import { jsx as v, jsxs as T, Fragment as De } from "react/jsx-runtime";
import * as g from "react";
import ne, { createContext as jt, useContext as ho, useCallback as Me, useState as Pe, useRef as Ie, useEffect as Ce, useMemo as Ho, createElement as dx, forwardRef as pt, cloneElement as Gp, useLayoutEffect as Kp, useReducer as gx, Component as hx, useImperativeHandle as mx } from "react";
import * as mo from "react-dom";
import rs from "react-dom";
import { D as Kd, p as px, s as fx, a as bx } from "./communicationBanner-Dk53U4Iq.js";
import { g as Cit, h as Eit } from "./communicationBanner-Dk53U4Iq.js";
const _x = (e, t, a, o) => {
  const n = [a, {
    code: t,
    ...o || {}
  }];
  if (e?.services?.logger?.forward)
    return e.services.logger.forward(n, "warn", "react-i18next::", !0);
  Za(n[0]) && (n[0] = `react-i18next:: ${n[0]}`), e?.services?.logger?.warn ? e.services.logger.warn(...n) : console?.warn && console.warn(...n);
}, Jd = {}, Yl = (e, t, a, o) => {
  Za(a) && Jd[a] || (Za(a) && (Jd[a] = /* @__PURE__ */ new Date()), _x(e, t, a, o));
}, Jp = (e, t) => () => {
  if (e.isInitialized)
    t();
  else {
    const a = () => {
      setTimeout(() => {
        e.off("initialized", a);
      }, 0), t();
    };
    e.on("initialized", a);
  }
}, Xl = (e, t, a) => {
  e.loadNamespaces(t, Jp(e, a));
}, Zd = (e, t, a, o) => {
  if (Za(a) && (a = [a]), e.options.preload && e.options.preload.indexOf(t) > -1) return Xl(e, a, o);
  a.forEach((n) => {
    e.options.ns.indexOf(n) < 0 && e.options.ns.push(n);
  }), e.loadLanguages(t, Jp(e, o));
}, vx = (e, t, a = {}) => !t.languages || !t.languages.length ? (Yl(t, "NO_LANGUAGES", "i18n.languages were undefined or empty", {
  languages: t.languages
}), !0) : t.hasLoadedNamespace(e, {
  lng: a.lng,
  precheck: (o, n) => {
    if (a.bindI18n && a.bindI18n.indexOf("languageChanging") > -1 && o.services.backendConnector.backend && o.isLanguageChangingTo && !n(o.isLanguageChangingTo, e)) return !1;
  }
}), Za = (e) => typeof e == "string", yx = (e) => typeof e == "object" && e !== null, wx = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34|nbsp|#160|copy|#169|reg|#174|hellip|#8230|#x2F|#47);/g, kx = {
  "&amp;": "&",
  "&#38;": "&",
  "&lt;": "<",
  "&#60;": "<",
  "&gt;": ">",
  "&#62;": ">",
  "&apos;": "'",
  "&#39;": "'",
  "&quot;": '"',
  "&#34;": '"',
  "&nbsp;": " ",
  "&#160;": " ",
  "&copy;": "©",
  "&#169;": "©",
  "&reg;": "®",
  "&#174;": "®",
  "&hellip;": "…",
  "&#8230;": "…",
  "&#x2F;": "/",
  "&#47;": "/"
}, xx = (e) => kx[e], $x = (e) => e.replace(wx, xx);
let Sx = {
  bindI18n: "languageChanged",
  bindI18nStore: "",
  transEmptyNodeValue: "",
  transSupportBasicHtmlNodes: !0,
  transWrapTextNodes: "",
  transKeepBasicHtmlNodesFor: ["br", "strong", "i", "p"],
  useSuspense: !0,
  unescape: $x
};
const Cx = () => Sx;
let Ex;
const zx = () => Ex, Zp = jt();
class jx {
  constructor() {
    this.usedNamespaces = {};
  }
  addUsedNamespaces(t) {
    t.forEach((a) => {
      this.usedNamespaces[a] || (this.usedNamespaces[a] = !0);
    });
  }
  getUsedNamespaces() {
    return Object.keys(this.usedNamespaces);
  }
}
const Ax = (e, t) => {
  const a = Ie();
  return Ce(() => {
    a.current = e;
  }, [e, t]), a.current;
}, Yp = (e, t, a, o) => e.getFixedT(t, a, o), Ox = (e, t, a, o) => Me(Yp(e, t, a, o), [e, t, a, o]), po = (e, t = {}) => {
  const {
    i18n: a
  } = t, {
    i18n: o,
    defaultNS: n
  } = ho(Zp) || {}, r = a || o || zx();
  if (r && !r.reportNamespaces && (r.reportNamespaces = new jx()), !r) {
    Yl(r, "NO_I18NEXT_INSTANCE", "useTranslation: You will need to pass in an i18next instance by using initReactI18next");
    const k = (S, $) => Za($) ? $ : yx($) && Za($.defaultValue) ? $.defaultValue : Array.isArray(S) ? S[S.length - 1] : S, x = [k, {}, !1];
    return x.t = k, x.i18n = {}, x.ready = !1, x;
  }
  r.options.react?.wait && Yl(r, "DEPRECATED_OPTION", "useTranslation: It seems you are still using the old wait option, you may migrate to the new useSuspense behaviour.");
  const i = {
    ...Cx(),
    ...r.options.react,
    ...t
  }, {
    useSuspense: s,
    keyPrefix: l
  } = i;
  let c = e || n || r.options?.defaultNS;
  c = Za(c) ? [c] : c || ["translation"], r.reportNamespaces.addUsedNamespaces?.(c);
  const u = (r.isInitialized || r.initializedStoreOnce) && c.every((k) => vx(k, r, i)), d = Ox(r, t.lng || null, i.nsMode === "fallback" ? c : c[0], l), h = () => d, p = () => Yp(r, t.lng || null, i.nsMode === "fallback" ? c : c[0], l), [f, m] = Pe(h);
  let b = c.join();
  t.lng && (b = `${t.lng}${b}`);
  const w = Ax(b), _ = Ie(!0);
  Ce(() => {
    const {
      bindI18n: k,
      bindI18nStore: x
    } = i;
    _.current = !0, !u && !s && (t.lng ? Zd(r, t.lng, c, () => {
      _.current && m(p);
    }) : Xl(r, c, () => {
      _.current && m(p);
    })), u && w && w !== b && _.current && m(p);
    const S = () => {
      _.current && m(p);
    };
    return k && r?.on(k, S), x && r?.store.on(x, S), () => {
      _.current = !1, r && k && k?.split(" ").forEach(($) => r.off($, S)), x && r && x.split(" ").forEach(($) => r.store.off($, S));
    };
  }, [r, b]), Ce(() => {
    _.current && u && m(h);
  }, [r, l, u]);
  const y = [f, r, u];
  if (y.t = f, y.i18n = r, y.ready = u, u || !u && !s) return y;
  throw new Promise((k) => {
    t.lng ? Zd(r, t.lng, c, () => k()) : Xl(r, c, () => k());
  });
};
function Px({
  i18n: e,
  defaultNS: t,
  children: a
}) {
  const o = Ho(() => ({
    i18n: e,
    defaultNS: t
  }), [e, t]);
  return dx(Zp.Provider, {
    value: o
  }, a);
}
function Xp(e) {
  var t, a, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (a = Xp(e[t])) && (o && (o += " "), o += a);
  } else for (a in e) e[a] && (o && (o += " "), o += a);
  return o;
}
function Oe() {
  for (var e, t, a = 0, o = "", n = arguments.length; a < n; a++) (e = arguments[a]) && (t = Xp(e)) && (o && (o += " "), o += t);
  return o;
}
const Dx = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], Nx = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, Rx = Dx.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: Nx[e]
})), Ix = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, Tx = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function Mx(e = 0) {
  const t = [];
  for (let a = 0; a < e; a++)
    t[a] = `path${a + 1}`;
  return t.map((a) => /* @__PURE__ */ v("span", { className: a }, a));
}
const Se = pt(
  ({ name: e, size: t = "medium", color: a = "base", className: o = "", ...n }, r) => {
    const i = Rx.find((l) => l.name === e), s = Oe("icon", `ds-${i?.class}`, Tx[t], Ix[a], o);
    return /* @__PURE__ */ v("i", { className: s, ...n, ref: r, children: Mx(i?.paths) });
  }
);
Se.displayName = "Icon";
const Lx = "_loader_1ksyv_29", Wx = "_circle_1ksyv_41", wo = {
  loader: Lx,
  "is-small": "_is-small_1ksyv_29",
  "is-medium": "_is-medium_1ksyv_33",
  "is-large": "_is-large_1ksyv_37",
  circle: Wx,
  "moving-element": "_moving-element_1ksyv_44",
  "on-dark": "_on-dark_1ksyv_47",
  "is-secondary": "_is-secondary_1ksyv_53",
  "dialog-overlay-show": "_dialog-overlay-show_1ksyv_1",
  "dialog-content-show": "_dialog-content-show_1ksyv_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ksyv_1"
}, Bx = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
}, Fx = {
  primary: "is-primary",
  secondary: "is-secondary"
};
function Vx({ onDark: e, size: t = "medium", color: a = "primary", className: o }) {
  return /* @__PURE__ */ T(
    "svg",
    {
      className: Oe(
        wo.loader,
        wo[Bx[t]],
        wo[Fx[a]],
        e && wo["on-dark"],
        o
      ),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      children: [
        /* @__PURE__ */ v("rect", { width: "100", height: "100", fill: "none", className: "bk" }),
        /* @__PURE__ */ v("circle", { className: wo.circle, cx: "50", cy: "50", r: "40", fill: "none", strokeWidth: "10", strokeLinecap: "round" }),
        /* @__PURE__ */ T(
          "circle",
          {
            className: wo["moving-element"],
            cx: "50",
            cy: "50",
            r: "40",
            fill: "none",
            strokeWidth: "6",
            strokeLinecap: "round",
            children: [
              /* @__PURE__ */ v("animate", { attributeName: "stroke-dashoffset", dur: "2s", repeatCount: "indefinite", from: "502", to: "0" }),
              /* @__PURE__ */ v(
                "animate",
                {
                  attributeName: "stroke-dasharray",
                  dur: "2s",
                  repeatCount: "indefinite",
                  values: "150.6 100.4;1 250;150.6 100.4"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const Ux = "_button_z1os6_29", qx = "_disabled_z1os6_43", Hx = "_loader_z1os6_263", sa = {
  button: Ux,
  disabled: qx,
  "is-primary": "_is-primary_z1os6_51",
  "is-contrasted": "_is-contrasted_z1os6_65",
  "is-secondary": "_is-secondary_z1os6_74",
  "is-tertiary": "_is-tertiary_z1os6_97",
  "is-eco-green": "_is-eco-green_z1os6_120",
  "is-ghost": "_is-ghost_z1os6_134",
  "is-destructive": "_is-destructive_z1os6_157",
  "is-hollow": "_is-hollow_z1os6_171",
  "is-destructive-ghost": "_is-destructive-ghost_z1os6_189",
  "is-facebook": "_is-facebook_z1os6_203",
  "is-apple": "_is-apple_z1os6_217",
  "is-google": "_is-google_z1os6_231",
  "is-regular": "_is-regular_z1os6_245",
  "is-medium": "_is-medium_z1os6_248",
  "is-small": "_is-small_z1os6_251",
  "is-full-width": "_is-full-width_z1os6_254",
  "is-loading": "_is-loading_z1os6_257",
  loader: Hx,
  "dialog-overlay-show": "_dialog-overlay-show_z1os6_1",
  "dialog-content-show": "_dialog-content-show_z1os6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_z1os6_1"
}, nu = pt(
  ({
    text: e,
    color: t = "primary",
    size: a = "medium",
    isFullWidth: o = !1,
    icon: n,
    iconPosition: r = "left",
    isLoading: i = !1,
    iconSize: s = "medium",
    isContrasted: l = !1,
    disabled: c = !1,
    className: u,
    children: d,
    ...h
  }, p) => {
    const f = Oe(
      sa.button,
      sa[Gx[t]],
      sa[Kx[a]],
      o && sa["is-full-width"],
      c && sa.disabled,
      r === "right" && sa["has-icon-right"],
      l && sa["is-contrasted"],
      i && sa["is-loading"],
      u
    ), m = /* @__PURE__ */ T(De, { children: [
      i && /* @__PURE__ */ v(Vx, { className: sa.loader, onDark: !0, size: "small" }),
      n && r === "left" && /* @__PURE__ */ v(Se, { color: "inherit", size: s, name: n }),
      d ?? e,
      n && r === "right" && /* @__PURE__ */ v(Se, { color: "inherit", size: s, name: n })
    ] });
    if (Jx(h))
      return /* @__PURE__ */ v(
        "a",
        {
          ...h,
          href: c ? void 0 : h.href,
          className: f,
          target: h.target,
          ref: p,
          children: m
        }
      );
    if (Zx(h))
      return /* @__PURE__ */ v(
        "button",
        {
          disabled: i || c,
          ...h,
          className: f,
          ref: p,
          children: m
        }
      );
  }
);
nu.displayName = "Button";
const Gx = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  hollow: "is-hollow",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google"
}, Kx = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
};
function Jx(e) {
  return "href" in e && typeof e.href == "string";
}
function Zx(e) {
  return !("href" in e);
}
const Yd = {
  MOBILE: 640,
  TABLET: 768
}, Yx = "_text_1tduc_29", xa = {
  text: Yx,
  "is-small": "_is-small_1tduc_34",
  "is-uppercase": "_is-uppercase_1tduc_38",
  "is-ellipsis": "_is-ellipsis_1tduc_41",
  "is-center": "_is-center_1tduc_47",
  "color-primary": "_color-primary_1tduc_50",
  "color-secondary": "_color-secondary_1tduc_53",
  "color-tertiary": "_color-tertiary_1tduc_56",
  "color-eco-green": "_color-eco-green_1tduc_59",
  "color-success": "_color-success_1tduc_62",
  "color-error": "_color-error_1tduc_65",
  "color-inverted": "_color-inverted_1tduc_68",
  "color-warning": "_color-warning_1tduc_71",
  "color-highlight": "_color-highlight_1tduc_74",
  "color-inherit": "_color-inherit_1tduc_77",
  "is-bold": "_is-bold_1tduc_80",
  "size-xs": "_size-xs_1tduc_83",
  "size-sm": "_size-sm_1tduc_86",
  "size-base": "_size-base_1tduc_89",
  "size-lg": "_size-lg_1tduc_92",
  "size-xl": "_size-xl_1tduc_95",
  "dialog-overlay-show": "_dialog-overlay-show_1tduc_1",
  "dialog-content-show": "_dialog-content-show_1tduc_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1tduc_1"
};
function Je({
  children: e,
  dangerouslySetInnerHTML: t,
  isSmall: a,
  isUppercase: o,
  ellipsis: n,
  isSpan: r,
  className: i = "",
  color: s = "primary",
  isBold: l,
  size: c,
  title: u,
  center: d,
  ...h
}) {
  const p = Oe(
    xa.text,
    a && xa["is-small"],
    n && xa["is-ellipsis"],
    s && xa[`color-${s}`],
    l && xa["is-bold"],
    o && xa["is-uppercase"],
    c && xa[`size-${c}`],
    d && xa["is-center"],
    i
  ), f = r ? "span" : "div";
  return t ? /* @__PURE__ */ v(f, { className: p, dangerouslySetInnerHTML: t, ...h, title: u }) : /* @__PURE__ */ v(f, { className: p, ...h, children: e });
}
const hr = {
  "flex-children": "_flex-children_7pjb4_29",
  "justify-self-start": "_justify-self-start_7pjb4_29",
  "justify-self-end": "_justify-self-end_7pjb4_32",
  "justify-self-center": "_justify-self-center_7pjb4_35",
  "align-self-start": "_align-self-start_7pjb4_38",
  "align-self-end": "_align-self-end_7pjb4_41",
  "align-self-center": "_align-self-center_7pjb4_44",
  "is-full-width": "_is-full-width_7pjb4_47",
  "dialog-overlay-show": "_dialog-overlay-show_7pjb4_1",
  "dialog-content-show": "_dialog-content-show_7pjb4_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_7pjb4_1"
}, Xx = ({ alignSelf: e, justifySelf: t, children: a, isFullWidth: o, ...n }) => {
  const r = Oe(
    hr["flex-children"],
    e && hr[`align-self-${e}`],
    t && hr[`justify-self-${t}`],
    o && hr["is-full-width"]
  );
  return /* @__PURE__ */ v("div", { className: r, ...n, children: a });
}, Qx = "_flex_1y1zn_29", e1 = "_wrap_1y1zn_67", t1 = "_nowrap_1y1zn_70", a1 = "_shrink_1y1zn_88", _t = {
  flex: Qx,
  "flex-row": "_flex-row_1y1zn_34",
  "flex-column": "_flex-column_1y1zn_37",
  "justify-start": "_justify-start_1y1zn_40",
  "justify-end": "_justify-end_1y1zn_43",
  "justify-center": "_justify-center_1y1zn_46",
  "justify-space-between": "_justify-space-between_1y1zn_49",
  "justify-space-around": "_justify-space-around_1y1zn_52",
  "align-start": "_align-start_1y1zn_55",
  "align-end": "_align-end_1y1zn_58",
  "align-center": "_align-center_1y1zn_61",
  "align-stretch": "_align-stretch_1y1zn_64",
  wrap: e1,
  nowrap: t1,
  "wrap-reverse": "_wrap-reverse_1y1zn_73",
  "is-full-width": "_is-full-width_1y1zn_79",
  "is-full-height": "_is-full-height_1y1zn_82",
  "flex-grow": "_flex-grow_1y1zn_85",
  shrink: a1,
  "hide-on-mobile": "_hide-on-mobile_1y1zn_91",
  "is-scrollable": "_is-scrollable_1y1zn_99",
  "gap-0": "_gap-0_1y1zn_105",
  "gap-1": "_gap-1_1y1zn_108",
  "gap-2": "_gap-2_1y1zn_111",
  "gap-3": "_gap-3_1y1zn_114",
  "gap-4": "_gap-4_1y1zn_117",
  "gap-5": "_gap-5_1y1zn_120",
  "gap-6": "_gap-6_1y1zn_123",
  "gap-7": "_gap-7_1y1zn_126",
  "gap-8": "_gap-8_1y1zn_129",
  "gap-9": "_gap-9_1y1zn_132",
  "gap-10": "_gap-10_1y1zn_135",
  "gap-11": "_gap-11_1y1zn_138",
  "gap-12": "_gap-12_1y1zn_141",
  "gap-14": "_gap-14_1y1zn_144",
  "gap-16": "_gap-16_1y1zn_147",
  "gap-18": "_gap-18_1y1zn_150",
  "gap-20": "_gap-20_1y1zn_153",
  "gap-24": "_gap-24_1y1zn_156",
  "gap-28": "_gap-28_1y1zn_159",
  "gap-32": "_gap-32_1y1zn_162",
  "gap-36": "_gap-36_1y1zn_165",
  "gap-40": "_gap-40_1y1zn_168",
  "gap-44": "_gap-44_1y1zn_171",
  "gap-48": "_gap-48_1y1zn_174",
  "gap-52": "_gap-52_1y1zn_177",
  "gap-56": "_gap-56_1y1zn_180",
  "gap-60": "_gap-60_1y1zn_183",
  "gap-64": "_gap-64_1y1zn_186",
  "gap-72": "_gap-72_1y1zn_189",
  "gap-80": "_gap-80_1y1zn_192",
  "gap-96": "_gap-96_1y1zn_195",
  "no-margin": "_no-margin_1y1zn_198",
  "dialog-overlay-show": "_dialog-overlay-show_1y1zn_1",
  "dialog-content-show": "_dialog-content-show_1y1zn_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1y1zn_1"
};
function ue({
  children: e,
  direction: t = "row",
  justifyContent: a = "start",
  alignItems: o = "start",
  flexWrap: n = "wrap",
  className: r = "",
  isFullWidth: i = !1,
  isFullHeight: s = !1,
  gap: l,
  style: c,
  noMargin: u = !1,
  flexGrow: d = !1,
  hideOnMobile: h = !1,
  shrink: p = !1,
  isScrollable: f = !1,
  ...m
}) {
  const b = Oe(
    _t.flex,
    _t[`flex-${t}`],
    _t[`justify-${a}`],
    _t[`align-${o}`],
    _t[n],
    i && _t["is-full-width"],
    s && _t["is-full-height"],
    l && _t[`gap-${l}`],
    u && _t["no-margin"],
    d && _t["flex-grow"],
    h && _t["hide-on-mobile"],
    p && _t.shrink,
    f && _t["is-scrollable"],
    r
  );
  return /* @__PURE__ */ v("div", { className: b, ...m, style: c, children: e });
}
ue.FlexChildren = Xx;
function pe(e, t, { checkForDefaultPrevented: a = !0 } = {}) {
  return function(o) {
    if (e?.(o), a === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
var ma = globalThis?.document ? g.useLayoutEffect : () => {
}, o1 = g[" useInsertionEffect ".trim().toString()] || ma;
function Jn({
  prop: e,
  defaultProp: t,
  onChange: a = () => {
  },
  caller: o
}) {
  const [n, r, i] = n1({
    defaultProp: t,
    onChange: a
  }), s = e !== void 0, l = s ? e : n;
  {
    const u = g.useRef(e !== void 0);
    g.useEffect(() => {
      const d = u.current;
      d !== s && console.warn(
        `${o} is changing from ${d ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = s;
    }, [s, o]);
  }
  const c = g.useCallback(
    (u) => {
      if (s) {
        const d = r1(u) ? u(e) : u;
        d !== e && i.current?.(d);
      } else
        r(u);
    },
    [s, e, r, i]
  );
  return [l, c];
}
function n1({
  defaultProp: e,
  onChange: t
}) {
  const [a, o] = g.useState(e), n = g.useRef(a), r = g.useRef(t);
  return o1(() => {
    r.current = t;
  }, [t]), g.useEffect(() => {
    n.current !== a && (r.current?.(a), n.current = a);
  }, [a, n]), [a, o, r];
}
function r1(e) {
  return typeof e == "function";
}
function Xd(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function ru(...e) {
  return (t) => {
    let a = !1;
    const o = e.map((n) => {
      const r = Xd(n, t);
      return !a && typeof r == "function" && (a = !0), r;
    });
    if (a)
      return () => {
        for (let n = 0; n < o.length; n++) {
          const r = o[n];
          typeof r == "function" ? r() : Xd(e[n], null);
        }
      };
  };
}
function We(...e) {
  return g.useCallback(ru(...e), e);
}
function i1(e, t) {
  const a = g.createContext(t), o = (r) => {
    const { children: i, ...s } = r, l = g.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ v(a.Provider, { value: l, children: i });
  };
  o.displayName = e + "Provider";
  function n(r) {
    const i = g.useContext(a);
    if (i) return i;
    if (t !== void 0) return t;
    throw new Error(`\`${r}\` must be used within \`${e}\``);
  }
  return [o, n];
}
function fo(e, t = []) {
  let a = [];
  function o(r, i) {
    const s = g.createContext(i), l = a.length;
    a = [...a, i];
    const c = (d) => {
      const { scope: h, children: p, ...f } = d, m = h?.[e]?.[l] || s, b = g.useMemo(() => f, Object.values(f));
      return /* @__PURE__ */ v(m.Provider, { value: b, children: p });
    };
    c.displayName = r + "Provider";
    function u(d, h) {
      const p = h?.[e]?.[l] || s, f = g.useContext(p);
      if (f) return f;
      if (i !== void 0) return i;
      throw new Error(`\`${d}\` must be used within \`${r}\``);
    }
    return [c, u];
  }
  const n = () => {
    const r = a.map((i) => g.createContext(i));
    return function(i) {
      const s = i?.[e] || r;
      return g.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: s } }),
        [i, s]
      );
    };
  };
  return n.scopeName = e, [o, s1(n, ...t)];
}
function s1(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const a = () => {
    const o = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(n) {
      const r = o.reduce((i, { useScope: s, scopeName: l }) => {
        const c = s(n)[`__scope${l}`];
        return { ...i, ...c };
      }, {});
      return g.useMemo(() => ({ [`__scope${t.scopeName}`]: r }), [r]);
    };
  };
  return a.scopeName = t.scopeName, a;
}
// @__NO_SIDE_EFFECTS__
function fi(e) {
  const t = /* @__PURE__ */ l1(e), a = g.forwardRef((o, n) => {
    const { children: r, ...i } = o, s = g.Children.toArray(r), l = s.find(u1);
    if (l) {
      const c = l.props.children, u = s.map((d) => d === l ? g.Children.count(c) > 1 ? g.Children.only(null) : g.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ v(t, { ...i, ref: n, children: g.isValidElement(c) ? g.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ v(t, { ...i, ref: n, children: r });
  });
  return a.displayName = `${e}.Slot`, a;
}
// @__NO_SIDE_EFFECTS__
function l1(e) {
  const t = g.forwardRef((a, o) => {
    const { children: n, ...r } = a;
    if (g.isValidElement(n)) {
      const i = g1(n), s = d1(r, n.props);
      return n.type !== g.Fragment && (s.ref = o ? ru(o, i) : i), g.cloneElement(n, s);
    }
    return g.Children.count(n) > 1 ? g.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var c1 = Symbol("radix.slottable");
function u1(e) {
  return g.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === c1;
}
function d1(e, t) {
  const a = { ...t };
  for (const o in t) {
    const n = e[o], r = t[o];
    /^on[A-Z]/.test(o) ? n && r ? a[o] = (...i) => {
      const s = r(...i);
      return n(...i), s;
    } : n && (a[o] = n) : o === "style" ? a[o] = { ...n, ...r } : o === "className" && (a[o] = [n, r].filter(Boolean).join(" "));
  }
  return { ...e, ...a };
}
function g1(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning;
  return a ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning, a ? e.props.ref : e.props.ref || e.ref);
}
var h1 = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], _e = h1.reduce((e, t) => {
  const a = /* @__PURE__ */ fi(`Primitive.${t}`), o = g.forwardRef((n, r) => {
    const { asChild: i, ...s } = n, l = i ? a : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ v(l, { ...s, ref: r });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {});
function Ql(e, t) {
  e && mo.flushSync(() => e.dispatchEvent(t));
}
var m1 = g.createContext(void 0);
function is(e) {
  const t = g.useContext(m1);
  return e || t || "ltr";
}
function iu(e) {
  const t = e + "CollectionProvider", [a, o] = fo(t), [n, r] = a(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (m) => {
    const { scope: b, children: w } = m, _ = ne.useRef(null), y = ne.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ v(n, { scope: b, itemMap: y, collectionRef: _, children: w });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", l = /* @__PURE__ */ fi(s), c = ne.forwardRef(
    (m, b) => {
      const { scope: w, children: _ } = m, y = r(s, w), k = We(b, y.collectionRef);
      return /* @__PURE__ */ v(l, { ref: k, children: _ });
    }
  );
  c.displayName = s;
  const u = e + "CollectionItemSlot", d = "data-radix-collection-item", h = /* @__PURE__ */ fi(u), p = ne.forwardRef(
    (m, b) => {
      const { scope: w, children: _, ...y } = m, k = ne.useRef(null), x = We(b, k), S = r(u, w);
      return ne.useEffect(() => (S.itemMap.set(k, { ref: k, ...y }), () => void S.itemMap.delete(k))), /* @__PURE__ */ v(h, { [d]: "", ref: x, children: _ });
    }
  );
  p.displayName = u;
  function f(m) {
    const b = r(e + "CollectionConsumer", m);
    return ne.useCallback(() => {
      const w = b.collectionRef.current;
      if (!w) return [];
      const _ = Array.from(w.querySelectorAll(`[${d}]`));
      return Array.from(b.itemMap.values()).sort(
        (y, k) => _.indexOf(y.ref.current) - _.indexOf(k.ref.current)
      );
    }, [b.collectionRef, b.itemMap]);
  }
  return [
    { Provider: i, Slot: c, ItemSlot: p },
    f,
    o
  ];
}
var p1 = g[" useId ".trim().toString()] || (() => {
}), f1 = 0;
function Ya(e) {
  const [t, a] = g.useState(p1());
  return ma(() => {
    a((o) => o ?? String(f1++));
  }, [e]), t ? `radix-${t}` : "";
}
function b1(e, t) {
  return g.useReducer((a, o) => t[a][o] ?? a, e);
}
var $t = (e) => {
  const { present: t, children: a } = e, o = _1(t), n = typeof a == "function" ? a({ present: o.isPresent }) : g.Children.only(a), r = We(o.ref, v1(n));
  return typeof a == "function" || o.isPresent ? g.cloneElement(n, { ref: r }) : null;
};
$t.displayName = "Presence";
function _1(e) {
  const [t, a] = g.useState(), o = g.useRef(null), n = g.useRef(e), r = g.useRef("none"), i = e ? "mounted" : "unmounted", [s, l] = b1(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return g.useEffect(() => {
    const c = mr(o.current);
    r.current = s === "mounted" ? c : "none";
  }, [s]), ma(() => {
    const c = o.current, u = n.current;
    if (u !== e) {
      const d = r.current, h = mr(c);
      e ? l("MOUNT") : h === "none" || c?.display === "none" ? l("UNMOUNT") : l(u && d !== h ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [e, l]), ma(() => {
    if (t) {
      let c;
      const u = t.ownerDocument.defaultView ?? window, d = (p) => {
        const f = mr(o.current).includes(CSS.escape(p.animationName));
        if (p.target === t && f && (l("ANIMATION_END"), !n.current)) {
          const m = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = m);
          });
        }
      }, h = (p) => {
        p.target === t && (r.current = mr(o.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(c), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: g.useCallback((c) => {
      o.current = c ? getComputedStyle(c) : null, a(c);
    }, [])
  };
}
function mr(e) {
  return e?.animationName || "none";
}
function v1(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning;
  return a ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning, a ? e.props.ref : e.props.ref || e.ref);
}
function qe(e) {
  const t = g.useRef(e);
  return g.useEffect(() => {
    t.current = e;
  }), g.useMemo(() => (...a) => t.current?.(...a), []);
}
var Ys = "rovingFocusGroup.onEntryFocus", y1 = { bubbles: !1, cancelable: !0 }, Zn = "RovingFocusGroup", [ec, Qp, w1] = iu(Zn), [k1, ef] = fo(
  Zn,
  [w1]
), [x1, $1] = k1(Zn), tf = g.forwardRef(
  (e, t) => /* @__PURE__ */ v(ec.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ v(ec.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ v(S1, { ...e, ref: t }) }) })
);
tf.displayName = Zn;
var S1 = g.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: a,
    orientation: o,
    loop: n = !1,
    dir: r,
    currentTabStopId: i,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = e, h = g.useRef(null), p = We(t, h), f = is(r), [m, b] = Jn({
    prop: i,
    defaultProp: s ?? null,
    onChange: l,
    caller: Zn
  }), [w, _] = g.useState(!1), y = qe(c), k = Qp(a), x = g.useRef(!1), [S, $] = g.useState(0);
  return g.useEffect(() => {
    const E = h.current;
    if (E)
      return E.addEventListener(Ys, y), () => E.removeEventListener(Ys, y);
  }, [y]), /* @__PURE__ */ v(
    x1,
    {
      scope: a,
      orientation: o,
      dir: f,
      loop: n,
      currentTabStopId: m,
      onItemFocus: g.useCallback(
        (E) => b(E),
        [b]
      ),
      onItemShiftTab: g.useCallback(() => _(!0), []),
      onFocusableItemAdd: g.useCallback(
        () => $((E) => E + 1),
        []
      ),
      onFocusableItemRemove: g.useCallback(
        () => $((E) => E - 1),
        []
      ),
      children: /* @__PURE__ */ v(
        _e.div,
        {
          tabIndex: w || S === 0 ? -1 : 0,
          "data-orientation": o,
          ...d,
          ref: p,
          style: { outline: "none", ...e.style },
          onMouseDown: pe(e.onMouseDown, () => {
            x.current = !0;
          }),
          onFocus: pe(e.onFocus, (E) => {
            const C = !x.current;
            if (E.target === E.currentTarget && C && !w) {
              const z = new CustomEvent(Ys, y1);
              if (E.currentTarget.dispatchEvent(z), !z.defaultPrevented) {
                const R = k().filter((U) => U.focusable), H = R.find((U) => U.active), M = R.find((U) => U.id === m), j = [H, M, ...R].filter(
                  Boolean
                ).map((U) => U.ref.current);
                nf(j, u);
              }
            }
            x.current = !1;
          }),
          onBlur: pe(e.onBlur, () => _(!1))
        }
      )
    }
  );
}), af = "RovingFocusGroupItem", of = g.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: a,
      focusable: o = !0,
      active: n = !1,
      tabStopId: r,
      children: i,
      ...s
    } = e, l = Ya(), c = r || l, u = $1(af, a), d = u.currentTabStopId === c, h = Qp(a), { onFocusableItemAdd: p, onFocusableItemRemove: f, currentTabStopId: m } = u;
    return g.useEffect(() => {
      if (o)
        return p(), () => f();
    }, [o, p, f]), /* @__PURE__ */ v(
      ec.ItemSlot,
      {
        scope: a,
        id: c,
        focusable: o,
        active: n,
        children: /* @__PURE__ */ v(
          _e.span,
          {
            tabIndex: d ? 0 : -1,
            "data-orientation": u.orientation,
            ...s,
            ref: t,
            onMouseDown: pe(e.onMouseDown, (b) => {
              o ? u.onItemFocus(c) : b.preventDefault();
            }),
            onFocus: pe(e.onFocus, () => u.onItemFocus(c)),
            onKeyDown: pe(e.onKeyDown, (b) => {
              if (b.key === "Tab" && b.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (b.target !== b.currentTarget) return;
              const w = z1(b, u.orientation, u.dir);
              if (w !== void 0) {
                if (b.metaKey || b.ctrlKey || b.altKey || b.shiftKey) return;
                b.preventDefault();
                let _ = h().filter((y) => y.focusable).map((y) => y.ref.current);
                if (w === "last") _.reverse();
                else if (w === "prev" || w === "next") {
                  w === "prev" && _.reverse();
                  const y = _.indexOf(b.currentTarget);
                  _ = u.loop ? j1(_, y + 1) : _.slice(y + 1);
                }
                setTimeout(() => nf(_));
              }
            }),
            children: typeof i == "function" ? i({ isCurrentTabStop: d, hasTabStop: m != null }) : i
          }
        )
      }
    );
  }
);
of.displayName = af;
var C1 = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function E1(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function z1(e, t, a) {
  const o = E1(e.key, a);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return C1[o];
}
function nf(e, t = !1) {
  const a = document.activeElement;
  for (const o of e)
    if (o === a || (o.focus({ preventScroll: t }), document.activeElement !== a)) return;
}
function j1(e, t) {
  return e.map((a, o) => e[(t + o) % e.length]);
}
var A1 = tf, O1 = of;
function P1(e) {
  const t = g.useRef({ value: e, previous: e });
  return g.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
function D1(e) {
  const [t, a] = Pe(!1), o = Me(() => a(!0), []), n = Me(() => a(!1), []), r = Me(() => a((i) => !i), []);
  return { value: t, setValue: a, setTrue: o, setFalse: n, toggle: r };
}
function N1() {
  const [e, t] = Pe({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return Ce(() => {
    function a() {
      t({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", a), a(), () => window.removeEventListener("resize", a);
  }, []), e;
}
function R1() {
  const { width: e } = N1();
  let t = "desktop";
  return e && e <= Yd.MOBILE ? t = "mobile" : e && e <= Yd.TABLET && (t = "tablet"), {
    currentWidth: e,
    currentDevice: t,
    isMobile: t === "mobile",
    isTablet: t === "tablet",
    isDesktop: t === "desktop",
    isReady: typeof window < "u"
  };
}
function I1(e, t = globalThis?.document) {
  const a = qe(e);
  g.useEffect(() => {
    const o = (n) => {
      n.key === "Escape" && a(n);
    };
    return t.addEventListener("keydown", o, { capture: !0 }), () => t.removeEventListener("keydown", o, { capture: !0 });
  }, [a, t]);
}
var T1 = "DismissableLayer", tc = "dismissableLayer.update", M1 = "dismissableLayer.pointerDownOutside", L1 = "dismissableLayer.focusOutside", Qd, rf = g.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), su = g.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: a = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: n,
      onFocusOutside: r,
      onInteractOutside: i,
      onDismiss: s,
      ...l
    } = e, c = g.useContext(rf), [u, d] = g.useState(null), h = u?.ownerDocument ?? globalThis?.document, [, p] = g.useState({}), f = We(t, ($) => d($)), m = Array.from(c.layers), [b] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), w = m.indexOf(b), _ = u ? m.indexOf(u) : -1, y = c.layersWithOutsidePointerEventsDisabled.size > 0, k = _ >= w, x = F1(($) => {
      const E = $.target, C = [...c.branches].some((z) => z.contains(E));
      !k || C || (n?.($), i?.($), $.defaultPrevented || s?.());
    }, h), S = V1(($) => {
      const E = $.target;
      [...c.branches].some((C) => C.contains(E)) || (r?.($), i?.($), $.defaultPrevented || s?.());
    }, h);
    return I1(($) => {
      _ === c.layers.size - 1 && (o?.($), !$.defaultPrevented && s && ($.preventDefault(), s()));
    }, h), g.useEffect(() => {
      if (u)
        return a && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (Qd = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), eg(), () => {
          a && c.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = Qd);
        };
    }, [u, h, a, c]), g.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), eg());
    }, [u, c]), g.useEffect(() => {
      const $ = () => p({});
      return document.addEventListener(tc, $), () => document.removeEventListener(tc, $);
    }, []), /* @__PURE__ */ v(
      _e.div,
      {
        ...l,
        ref: f,
        style: {
          pointerEvents: y ? k ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: pe(e.onFocusCapture, S.onFocusCapture),
        onBlurCapture: pe(e.onBlurCapture, S.onBlurCapture),
        onPointerDownCapture: pe(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
su.displayName = T1;
var W1 = "DismissableLayerBranch", B1 = g.forwardRef((e, t) => {
  const a = g.useContext(rf), o = g.useRef(null), n = We(t, o);
  return g.useEffect(() => {
    const r = o.current;
    if (r)
      return a.branches.add(r), () => {
        a.branches.delete(r);
      };
  }, [a.branches]), /* @__PURE__ */ v(_e.div, { ...e, ref: n });
});
B1.displayName = W1;
function F1(e, t = globalThis?.document) {
  const a = qe(e), o = g.useRef(!1), n = g.useRef(() => {
  });
  return g.useEffect(() => {
    const r = (s) => {
      if (s.target && !o.current) {
        let l = function() {
          sf(
            M1,
            a,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", n.current), n.current = l, t.addEventListener("click", n.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", n.current);
      o.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", r);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", r), t.removeEventListener("click", n.current);
    };
  }, [t, a]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function V1(e, t = globalThis?.document) {
  const a = qe(e), o = g.useRef(!1);
  return g.useEffect(() => {
    const n = (r) => {
      r.target && !o.current && sf(L1, a, { originalEvent: r }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", n), () => t.removeEventListener("focusin", n);
  }, [t, a]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function eg() {
  const e = new CustomEvent(tc);
  document.dispatchEvent(e);
}
function sf(e, t, a, { discrete: o }) {
  const n = a.originalEvent.target, r = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: a });
  t && n.addEventListener(e, t, { once: !0 }), o ? Ql(n, r) : n.dispatchEvent(r);
}
var U1 = "Portal", lf = g.forwardRef((e, t) => {
  const { container: a, ...o } = e, [n, r] = g.useState(!1);
  ma(() => r(!0), []);
  const i = a || n && globalThis?.document?.body;
  return i ? rs.createPortal(/* @__PURE__ */ v(_e.div, { ...o, ref: t }), i) : null;
});
lf.displayName = U1;
var Ht = function() {
  return Ht = Object.assign || function(e) {
    for (var t, a = 1, o = arguments.length; a < o; a++) {
      t = arguments[a];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Ht.apply(this, arguments);
};
function cf(e, t) {
  var a = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (a[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, o = Object.getOwnPropertySymbols(e); n < o.length; n++)
      t.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (a[o[n]] = e[o[n]]);
  return a;
}
function q1(e, t, a) {
  for (var o = 0, n = t.length, r; o < n; o++)
    (r || !(o in t)) && (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}
var Xs = "focusScope.autoFocusOnMount", Qs = "focusScope.autoFocusOnUnmount", tg = { bubbles: !1, cancelable: !0 }, H1 = "FocusScope", uf = g.forwardRef((e, t) => {
  const {
    loop: a = !1,
    trapped: o = !1,
    onMountAutoFocus: n,
    onUnmountAutoFocus: r,
    ...i
  } = e, [s, l] = g.useState(null), c = qe(n), u = qe(r), d = g.useRef(null), h = We(t, (m) => l(m)), p = g.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  g.useEffect(() => {
    if (o) {
      let m = function(y) {
        if (p.paused || !s) return;
        const k = y.target;
        s.contains(k) ? d.current = k : Ca(d.current, { select: !0 });
      }, b = function(y) {
        if (p.paused || !s) return;
        const k = y.relatedTarget;
        k !== null && (s.contains(k) || Ca(d.current, { select: !0 }));
      }, w = function(y) {
        if (document.activeElement === document.body)
          for (const k of y)
            k.removedNodes.length > 0 && Ca(s);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", b);
      const _ = new MutationObserver(w);
      return s && _.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", b), _.disconnect();
      };
    }
  }, [o, s, p.paused]), g.useEffect(() => {
    if (s) {
      og.add(p);
      const m = document.activeElement;
      if (!s.contains(m)) {
        const b = new CustomEvent(Xs, tg);
        s.addEventListener(Xs, c), s.dispatchEvent(b), b.defaultPrevented || (G1(X1(df(s)), { select: !0 }), document.activeElement === m && Ca(s));
      }
      return () => {
        s.removeEventListener(Xs, c), setTimeout(() => {
          const b = new CustomEvent(Qs, tg);
          s.addEventListener(Qs, u), s.dispatchEvent(b), b.defaultPrevented || Ca(m ?? document.body, { select: !0 }), s.removeEventListener(Qs, u), og.remove(p);
        }, 0);
      };
    }
  }, [s, c, u, p]);
  const f = g.useCallback(
    (m) => {
      if (!a && !o || p.paused) return;
      const b = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, w = document.activeElement;
      if (b && w) {
        const _ = m.currentTarget, [y, k] = K1(_);
        y && k ? !m.shiftKey && w === k ? (m.preventDefault(), a && Ca(y, { select: !0 })) : m.shiftKey && w === y && (m.preventDefault(), a && Ca(k, { select: !0 })) : w === _ && m.preventDefault();
      }
    },
    [a, o, p.paused]
  );
  return /* @__PURE__ */ v(_e.div, { tabIndex: -1, ...i, ref: h, onKeyDown: f });
});
uf.displayName = H1;
function G1(e, { select: t = !1 } = {}) {
  const a = document.activeElement;
  for (const o of e)
    if (Ca(o, { select: t }), document.activeElement !== a) return;
}
function K1(e) {
  const t = df(e), a = ag(t, e), o = ag(t.reverse(), e);
  return [a, o];
}
function df(e) {
  const t = [], a = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const n = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || n ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; a.nextNode(); ) t.push(a.currentNode);
  return t;
}
function ag(e, t) {
  for (const a of e)
    if (!J1(a, { upTo: t })) return a;
}
function J1(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function Z1(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Ca(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const a = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== a && Z1(e) && t && e.select();
  }
}
var og = Y1();
function Y1() {
  let e = [];
  return {
    add(t) {
      const a = e[0];
      t !== a && a?.pause(), e = ng(e, t), e.unshift(t);
    },
    remove(t) {
      e = ng(e, t), e[0]?.resume();
    }
  };
}
function ng(e, t) {
  const a = [...e], o = a.indexOf(t);
  return o !== -1 && a.splice(o, 1), a;
}
function X1(e) {
  return e.filter((t) => t.tagName !== "A");
}
var el = 0;
function Q1() {
  g.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? rg()), document.body.insertAdjacentElement("beforeend", e[1] ?? rg()), el++, () => {
      el === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), el--;
    };
  }, []);
}
function rg() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var Jr = "right-scroll-bar-position", Zr = "width-before-scroll-bar", e$ = "with-scroll-bars-hidden", t$ = "--removed-body-scroll-bar-size";
function tl(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function a$(e, t) {
  var a = Pe(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return a.value;
        },
        set current(o) {
          var n = a.value;
          n !== o && (a.value = o, a.callback(o, n));
        }
      }
    };
  })[0];
  return a.callback = t, a.facade;
}
var o$ = typeof window < "u" ? g.useLayoutEffect : g.useEffect, ig = /* @__PURE__ */ new WeakMap();
function n$(e, t) {
  var a = a$(null, function(o) {
    return e.forEach(function(n) {
      return tl(n, o);
    });
  });
  return o$(function() {
    var o = ig.get(a);
    if (o) {
      var n = new Set(o), r = new Set(e), i = a.current;
      n.forEach(function(s) {
        r.has(s) || tl(s, null);
      }), r.forEach(function(s) {
        n.has(s) || tl(s, i);
      });
    }
    ig.set(a, e);
  }, [e]), a;
}
function r$(e) {
  return e;
}
function i$(e, t) {
  t === void 0 && (t = r$);
  var a = [], o = !1, n = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return a.length ? a[a.length - 1] : e;
    },
    useMedium: function(r) {
      var i = t(r, o);
      return a.push(i), function() {
        a = a.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(r) {
      for (o = !0; a.length; ) {
        var i = a;
        a = [], i.forEach(r);
      }
      a = {
        push: function(s) {
          return r(s);
        },
        filter: function() {
          return a;
        }
      };
    },
    assignMedium: function(r) {
      o = !0;
      var i = [];
      if (a.length) {
        var s = a;
        a = [], s.forEach(r), i = a;
      }
      var l = function() {
        var u = i;
        i = [], u.forEach(r);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), a = {
        push: function(u) {
          i.push(u), c();
        },
        filter: function(u) {
          return i = i.filter(u), a;
        }
      };
    }
  };
  return n;
}
function s$(e) {
  e === void 0 && (e = {});
  var t = i$(null);
  return t.options = Ht({ async: !0, ssr: !1 }, e), t;
}
var gf = function(e) {
  var t = e.sideCar, a = cf(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return g.createElement(o, Ht({}, a));
};
gf.isSideCarExport = !0;
function l$(e, t) {
  return e.useMedium(t), gf;
}
var hf = s$(), al = function() {
}, ss = g.forwardRef(function(e, t) {
  var a = g.useRef(null), o = g.useState({
    onScrollCapture: al,
    onWheelCapture: al,
    onTouchMoveCapture: al
  }), n = o[0], r = o[1], i = e.forwardProps, s = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, h = e.sideCar, p = e.noIsolation, f = e.inert, m = e.allowPinchZoom, b = e.as, w = b === void 0 ? "div" : b, _ = e.gapMode, y = cf(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), k = h, x = n$([a, t]), S = Ht(Ht({}, y), n);
  return g.createElement(
    g.Fragment,
    null,
    u && g.createElement(k, { sideCar: hf, removeScrollBar: c, shards: d, noIsolation: p, inert: f, setCallbacks: r, allowPinchZoom: !!m, lockRef: a, gapMode: _ }),
    i ? g.cloneElement(g.Children.only(s), Ht(Ht({}, S), { ref: x })) : g.createElement(w, Ht({}, S, { className: l, ref: x }), s)
  );
});
ss.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
ss.classNames = {
  fullWidth: Zr,
  zeroRight: Jr
};
var c$ = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function u$() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = c$();
  return t && e.setAttribute("nonce", t), e;
}
function d$(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function g$(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var h$ = function() {
  var e = 0, t = null;
  return {
    add: function(a) {
      e == 0 && (t = u$()) && (d$(t, a), g$(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, m$ = function() {
  var e = h$();
  return function(t, a) {
    g.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && a]);
  };
}, mf = function() {
  var e = m$(), t = function(a) {
    var o = a.styles, n = a.dynamic;
    return e(o, n), null;
  };
  return t;
}, p$ = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, ol = function(e) {
  return parseInt(e || "", 10) || 0;
}, f$ = function(e) {
  var t = window.getComputedStyle(document.body), a = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], n = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [ol(a), ol(o), ol(n)];
}, b$ = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return p$;
  var t = f$(e), a = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - a + t[2] - t[0])
  };
}, _$ = mf(), Wo = "data-scroll-locked", v$ = function(e, t, a, o) {
  var n = e.left, r = e.top, i = e.right, s = e.gap;
  return a === void 0 && (a = "margin"), `
  .`.concat(e$, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(s, "px ").concat(o, `;
  }
  body[`).concat(Wo, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    a === "margin" && `
    padding-left: `.concat(n, `px;
    padding-top: `).concat(r, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(o, `;
    `),
    a === "padding" && "padding-right: ".concat(s, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(Jr, ` {
    right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(Zr, ` {
    margin-right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(Jr, " .").concat(Jr, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(Zr, " .").concat(Zr, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(Wo, `] {
    `).concat(t$, ": ").concat(s, `px;
  }
`);
}, sg = function() {
  var e = parseInt(document.body.getAttribute(Wo) || "0", 10);
  return isFinite(e) ? e : 0;
}, y$ = function() {
  g.useEffect(function() {
    return document.body.setAttribute(Wo, (sg() + 1).toString()), function() {
      var e = sg() - 1;
      e <= 0 ? document.body.removeAttribute(Wo) : document.body.setAttribute(Wo, e.toString());
    };
  }, []);
}, w$ = function(e) {
  var t = e.noRelative, a = e.noImportant, o = e.gapMode, n = o === void 0 ? "margin" : o;
  y$();
  var r = g.useMemo(function() {
    return b$(n);
  }, [n]);
  return g.createElement(_$, { styles: v$(r, !t, n, a ? "" : "!important") });
}, ac = !1;
if (typeof window < "u")
  try {
    var pr = Object.defineProperty({}, "passive", {
      get: function() {
        return ac = !0, !0;
      }
    });
    window.addEventListener("test", pr, pr), window.removeEventListener("test", pr, pr);
  } catch {
    ac = !1;
  }
var ko = ac ? { passive: !1 } : !1, k$ = function(e) {
  return e.tagName === "TEXTAREA";
}, pf = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var a = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    a[t] !== "hidden" && // contains scroll inside self
    !(a.overflowY === a.overflowX && !k$(e) && a[t] === "visible")
  );
}, x$ = function(e) {
  return pf(e, "overflowY");
}, $$ = function(e) {
  return pf(e, "overflowX");
}, lg = function(e, t) {
  var a = t.ownerDocument, o = t;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var n = ff(e, o);
    if (n) {
      var r = bf(e, o), i = r[1], s = r[2];
      if (i > s)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== a.body);
  return !1;
}, S$ = function(e) {
  var t = e.scrollTop, a = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    a,
    o
  ];
}, C$ = function(e) {
  var t = e.scrollLeft, a = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    a,
    o
  ];
}, ff = function(e, t) {
  return e === "v" ? x$(t) : $$(t);
}, bf = function(e, t) {
  return e === "v" ? S$(t) : C$(t);
}, E$ = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, z$ = function(e, t, a, o, n) {
  var r = E$(e, window.getComputedStyle(t).direction), i = r * o, s = a.target, l = t.contains(s), c = !1, u = i > 0, d = 0, h = 0;
  do {
    var p = bf(e, s), f = p[0], m = p[1], b = p[2], w = m - b - r * f;
    (f || w) && ff(e, s) && (d += w, h += f), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (u && Math.abs(d) < 1 || !u && Math.abs(h) < 1) && (c = !0), c;
}, fr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, cg = function(e) {
  return [e.deltaX, e.deltaY];
}, ug = function(e) {
  return e && "current" in e ? e.current : e;
}, j$ = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, A$ = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, O$ = 0, xo = [];
function P$(e) {
  var t = g.useRef([]), a = g.useRef([0, 0]), o = g.useRef(), n = g.useState(O$++)[0], r = g.useState(mf)[0], i = g.useRef(e);
  g.useEffect(function() {
    i.current = e;
  }, [e]), g.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(n));
      var m = q1([e.lockRef.current], (e.shards || []).map(ug)).filter(Boolean);
      return m.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(n));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(n)), m.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(n));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = g.useCallback(function(m, b) {
    if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey)
      return !i.current.allowPinchZoom;
    var w = fr(m), _ = a.current, y = "deltaX" in m ? m.deltaX : _[0] - w[0], k = "deltaY" in m ? m.deltaY : _[1] - w[1], x, S = m.target, $ = Math.abs(y) > Math.abs(k) ? "h" : "v";
    if ("touches" in m && $ === "h" && S.type === "range")
      return !1;
    var E = lg($, S);
    if (!E)
      return !0;
    if (E ? x = $ : (x = $ === "v" ? "h" : "v", E = lg($, S)), !E)
      return !1;
    if (!o.current && "changedTouches" in m && (y || k) && (o.current = x), !x)
      return !0;
    var C = o.current || x;
    return z$(C, b, m, C === "h" ? y : k);
  }, []), l = g.useCallback(function(m) {
    var b = m;
    if (!(!xo.length || xo[xo.length - 1] !== r)) {
      var w = "deltaY" in b ? cg(b) : fr(b), _ = t.current.filter(function(x) {
        return x.name === b.type && (x.target === b.target || b.target === x.shadowParent) && j$(x.delta, w);
      })[0];
      if (_ && _.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!_) {
        var y = (i.current.shards || []).map(ug).filter(Boolean).filter(function(x) {
          return x.contains(b.target);
        }), k = y.length > 0 ? s(b, y[0]) : !i.current.noIsolation;
        k && b.cancelable && b.preventDefault();
      }
    }
  }, []), c = g.useCallback(function(m, b, w, _) {
    var y = { name: m, delta: b, target: w, should: _, shadowParent: D$(w) };
    t.current.push(y), setTimeout(function() {
      t.current = t.current.filter(function(k) {
        return k !== y;
      });
    }, 1);
  }, []), u = g.useCallback(function(m) {
    a.current = fr(m), o.current = void 0;
  }, []), d = g.useCallback(function(m) {
    c(m.type, cg(m), m.target, s(m, e.lockRef.current));
  }, []), h = g.useCallback(function(m) {
    c(m.type, fr(m), m.target, s(m, e.lockRef.current));
  }, []);
  g.useEffect(function() {
    return xo.push(r), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, ko), document.addEventListener("touchmove", l, ko), document.addEventListener("touchstart", u, ko), function() {
      xo = xo.filter(function(m) {
        return m !== r;
      }), document.removeEventListener("wheel", l, ko), document.removeEventListener("touchmove", l, ko), document.removeEventListener("touchstart", u, ko);
    };
  }, []);
  var p = e.removeScrollBar, f = e.inert;
  return g.createElement(
    g.Fragment,
    null,
    f ? g.createElement(r, { styles: A$(n) }) : null,
    p ? g.createElement(w$, { gapMode: e.gapMode }) : null
  );
}
function D$(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const N$ = l$(hf, P$);
var _f = g.forwardRef(function(e, t) {
  return g.createElement(ss, Ht({}, e, { ref: t, sideCar: N$ }));
});
_f.classNames = ss.classNames;
var R$ = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, $o = /* @__PURE__ */ new WeakMap(), br = /* @__PURE__ */ new WeakMap(), _r = {}, nl = 0, vf = function(e) {
  return e && (e.host || vf(e.parentNode));
}, I$ = function(e, t) {
  return t.map(function(a) {
    if (e.contains(a))
      return a;
    var o = vf(a);
    return o && e.contains(o) ? o : (console.error("aria-hidden", a, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(a) {
    return !!a;
  });
}, T$ = function(e, t, a, o) {
  var n = I$(t, Array.isArray(e) ? e : [e]);
  _r[a] || (_r[a] = /* @__PURE__ */ new WeakMap());
  var r = _r[a], i = [], s = /* @__PURE__ */ new Set(), l = new Set(n), c = function(d) {
    !d || s.has(d) || (s.add(d), c(d.parentNode));
  };
  n.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(h) {
      if (s.has(h))
        u(h);
      else
        try {
          var p = h.getAttribute(o), f = p !== null && p !== "false", m = ($o.get(h) || 0) + 1, b = (r.get(h) || 0) + 1;
          $o.set(h, m), r.set(h, b), i.push(h), m === 1 && f && br.set(h, !0), b === 1 && h.setAttribute(a, "true"), f || h.setAttribute(o, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", h, w);
        }
    });
  };
  return u(t), s.clear(), nl++, function() {
    i.forEach(function(d) {
      var h = $o.get(d) - 1, p = r.get(d) - 1;
      $o.set(d, h), r.set(d, p), h || (br.has(d) || d.removeAttribute(o), br.delete(d)), p || d.removeAttribute(a);
    }), nl--, nl || ($o = /* @__PURE__ */ new WeakMap(), $o = /* @__PURE__ */ new WeakMap(), br = /* @__PURE__ */ new WeakMap(), _r = {});
  };
}, M$ = function(e, t, a) {
  a === void 0 && (a = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), n = R$(e);
  return n ? (o.push.apply(o, Array.from(n.querySelectorAll("[aria-live]"))), T$(o, n, a, "aria-hidden")) : function() {
    return null;
  };
}, ls = "Dialog", [yf, art] = fo(ls), [L$, Lt] = yf(ls), wf = (e) => {
  const {
    __scopeDialog: t,
    children: a,
    open: o,
    defaultOpen: n,
    onOpenChange: r,
    modal: i = !0
  } = e, s = g.useRef(null), l = g.useRef(null), [c, u] = Jn({
    prop: o,
    defaultProp: n ?? !1,
    onChange: r,
    caller: ls
  });
  return /* @__PURE__ */ v(
    L$,
    {
      scope: t,
      triggerRef: s,
      contentRef: l,
      contentId: Ya(),
      titleId: Ya(),
      descriptionId: Ya(),
      open: c,
      onOpenChange: u,
      onOpenToggle: g.useCallback(() => u((d) => !d), [u]),
      modal: i,
      children: a
    }
  );
};
wf.displayName = ls;
var kf = "DialogTrigger", W$ = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = Lt(kf, a), r = We(t, n.triggerRef);
    return /* @__PURE__ */ v(
      _e.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": n.open,
        "aria-controls": n.contentId,
        "data-state": uu(n.open),
        ...o,
        ref: r,
        onClick: pe(e.onClick, n.onOpenToggle)
      }
    );
  }
);
W$.displayName = kf;
var lu = "DialogPortal", [B$, xf] = yf(lu, {
  forceMount: void 0
}), $f = (e) => {
  const { __scopeDialog: t, forceMount: a, children: o, container: n } = e, r = Lt(lu, t);
  return /* @__PURE__ */ v(B$, { scope: t, forceMount: a, children: g.Children.map(o, (i) => /* @__PURE__ */ v($t, { present: a || r.open, children: /* @__PURE__ */ v(lf, { asChild: !0, container: n, children: i }) })) });
};
$f.displayName = lu;
var bi = "DialogOverlay", Sf = g.forwardRef(
  (e, t) => {
    const a = xf(bi, e.__scopeDialog), { forceMount: o = a.forceMount, ...n } = e, r = Lt(bi, e.__scopeDialog);
    return r.modal ? /* @__PURE__ */ v($t, { present: o || r.open, children: /* @__PURE__ */ v(V$, { ...n, ref: t }) }) : null;
  }
);
Sf.displayName = bi;
var F$ = /* @__PURE__ */ fi("DialogOverlay.RemoveScroll"), V$ = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = Lt(bi, a);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ v(_f, { as: F$, allowPinchZoom: !0, shards: [n.contentRef], children: /* @__PURE__ */ v(
        _e.div,
        {
          "data-state": uu(n.open),
          ...o,
          ref: t,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }
), eo = "DialogContent", Cf = g.forwardRef(
  (e, t) => {
    const a = xf(eo, e.__scopeDialog), { forceMount: o = a.forceMount, ...n } = e, r = Lt(eo, e.__scopeDialog);
    return /* @__PURE__ */ v($t, { present: o || r.open, children: r.modal ? /* @__PURE__ */ v(U$, { ...n, ref: t }) : /* @__PURE__ */ v(q$, { ...n, ref: t }) });
  }
);
Cf.displayName = eo;
var U$ = g.forwardRef(
  (e, t) => {
    const a = Lt(eo, e.__scopeDialog), o = g.useRef(null), n = We(t, a.contentRef, o);
    return g.useEffect(() => {
      const r = o.current;
      if (r) return M$(r);
    }, []), /* @__PURE__ */ v(
      Ef,
      {
        ...e,
        ref: n,
        trapFocus: a.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: pe(e.onCloseAutoFocus, (r) => {
          r.preventDefault(), a.triggerRef.current?.focus();
        }),
        onPointerDownOutside: pe(e.onPointerDownOutside, (r) => {
          const i = r.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || s) && r.preventDefault();
        }),
        onFocusOutside: pe(
          e.onFocusOutside,
          (r) => r.preventDefault()
        )
      }
    );
  }
), q$ = g.forwardRef(
  (e, t) => {
    const a = Lt(eo, e.__scopeDialog), o = g.useRef(!1), n = g.useRef(!1);
    return /* @__PURE__ */ v(
      Ef,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (r) => {
          e.onCloseAutoFocus?.(r), r.defaultPrevented || (o.current || a.triggerRef.current?.focus(), r.preventDefault()), o.current = !1, n.current = !1;
        },
        onInteractOutside: (r) => {
          e.onInteractOutside?.(r), r.defaultPrevented || (o.current = !0, r.detail.originalEvent.type === "pointerdown" && (n.current = !0));
          const i = r.target;
          a.triggerRef.current?.contains(i) && r.preventDefault(), r.detail.originalEvent.type === "focusin" && n.current && r.preventDefault();
        }
      }
    );
  }
), Ef = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, trapFocus: o, onOpenAutoFocus: n, onCloseAutoFocus: r, ...i } = e, s = Lt(eo, a), l = g.useRef(null), c = We(t, l);
    return Q1(), /* @__PURE__ */ T(De, { children: [
      /* @__PURE__ */ v(
        uf,
        {
          asChild: !0,
          loop: !0,
          trapped: o,
          onMountAutoFocus: n,
          onUnmountAutoFocus: r,
          children: /* @__PURE__ */ v(
            su,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": uu(s.open),
              ...i,
              ref: c,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ T(De, { children: [
        /* @__PURE__ */ v(K$, { titleId: s.titleId }),
        /* @__PURE__ */ v(Z$, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), cu = "DialogTitle", H$ = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = Lt(cu, a);
    return /* @__PURE__ */ v(_e.h2, { id: n.titleId, ...o, ref: t });
  }
);
H$.displayName = cu;
var zf = "DialogDescription", G$ = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = Lt(zf, a);
    return /* @__PURE__ */ v(_e.p, { id: n.descriptionId, ...o, ref: t });
  }
);
G$.displayName = zf;
var jf = "DialogClose", Af = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = Lt(jf, a);
    return /* @__PURE__ */ v(
      _e.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: pe(e.onClick, () => n.onOpenChange(!1))
      }
    );
  }
);
Af.displayName = jf;
function uu(e) {
  return e ? "open" : "closed";
}
var Of = "DialogTitleWarning", [ort, Pf] = i1(Of, {
  contentName: eo,
  titleName: cu,
  docsSlug: "dialog"
}), K$ = ({ titleId: e }) => {
  const t = Pf(Of), a = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return g.useEffect(() => {
    e && (document.getElementById(e) || console.error(a));
  }, [a, e]), null;
}, J$ = "DialogDescriptionWarning", Z$ = ({ contentRef: e, descriptionId: t }) => {
  const a = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Pf(J$).contentName}}.`;
  return g.useEffect(() => {
    const o = e.current?.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(a));
  }, [a, e, t]), null;
}, Y$ = wf, X$ = $f, Q$ = Sf, eS = Cf, tS = Af;
function aS(e, [t, a]) {
  return Math.min(a, Math.max(t, e));
}
function oS(e, t) {
  return g.useReducer((a, o) => t[a][o] ?? a, e);
}
var du = "ScrollArea", [Df, nrt] = fo(du), [nS, At] = Df(du), Nf = g.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: a,
      type: o = "hover",
      dir: n,
      scrollHideDelay: r = 600,
      ...i
    } = e, [s, l] = g.useState(null), [c, u] = g.useState(null), [d, h] = g.useState(null), [p, f] = g.useState(null), [m, b] = g.useState(null), [w, _] = g.useState(0), [y, k] = g.useState(0), [x, S] = g.useState(!1), [$, E] = g.useState(!1), C = We(t, (R) => l(R)), z = is(n);
    return /* @__PURE__ */ v(
      nS,
      {
        scope: a,
        type: o,
        dir: z,
        scrollHideDelay: r,
        scrollArea: s,
        viewport: c,
        onViewportChange: u,
        content: d,
        onContentChange: h,
        scrollbarX: p,
        onScrollbarXChange: f,
        scrollbarXEnabled: x,
        onScrollbarXEnabledChange: S,
        scrollbarY: m,
        onScrollbarYChange: b,
        scrollbarYEnabled: $,
        onScrollbarYEnabledChange: E,
        onCornerWidthChange: _,
        onCornerHeightChange: k,
        children: /* @__PURE__ */ v(
          _e.div,
          {
            dir: z,
            ...i,
            ref: C,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": w + "px",
              "--radix-scroll-area-corner-height": y + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
Nf.displayName = du;
var Rf = "ScrollAreaViewport", If = g.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: a, children: o, nonce: n, ...r } = e, i = At(Rf, a), s = g.useRef(null), l = We(t, s, i.onViewportChange);
    return /* @__PURE__ */ T(De, { children: [
      /* @__PURE__ */ v(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: n
        }
      ),
      /* @__PURE__ */ v(
        _e.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...r,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: i.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: i.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ v("div", { ref: i.onContentChange, style: { minWidth: "100%", display: "table" }, children: o })
        }
      )
    ] });
  }
);
If.displayName = Rf;
var Qt = "ScrollAreaScrollbar", rS = g.forwardRef(
  (e, t) => {
    const { forceMount: a, ...o } = e, n = At(Qt, e.__scopeScrollArea), { onScrollbarXEnabledChange: r, onScrollbarYEnabledChange: i } = n, s = e.orientation === "horizontal";
    return g.useEffect(() => (s ? r(!0) : i(!0), () => {
      s ? r(!1) : i(!1);
    }), [s, r, i]), n.type === "hover" ? /* @__PURE__ */ v(iS, { ...o, ref: t, forceMount: a }) : n.type === "scroll" ? /* @__PURE__ */ v(sS, { ...o, ref: t, forceMount: a }) : n.type === "auto" ? /* @__PURE__ */ v(Tf, { ...o, ref: t, forceMount: a }) : n.type === "always" ? /* @__PURE__ */ v(gu, { ...o, ref: t }) : null;
  }
);
rS.displayName = Qt;
var iS = g.forwardRef((e, t) => {
  const { forceMount: a, ...o } = e, n = At(Qt, e.__scopeScrollArea), [r, i] = g.useState(!1);
  return g.useEffect(() => {
    const s = n.scrollArea;
    let l = 0;
    if (s) {
      const c = () => {
        window.clearTimeout(l), i(!0);
      }, u = () => {
        l = window.setTimeout(() => i(!1), n.scrollHideDelay);
      };
      return s.addEventListener("pointerenter", c), s.addEventListener("pointerleave", u), () => {
        window.clearTimeout(l), s.removeEventListener("pointerenter", c), s.removeEventListener("pointerleave", u);
      };
    }
  }, [n.scrollArea, n.scrollHideDelay]), /* @__PURE__ */ v($t, { present: a || r, children: /* @__PURE__ */ v(
    Tf,
    {
      "data-state": r ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), sS = g.forwardRef((e, t) => {
  const { forceMount: a, ...o } = e, n = At(Qt, e.__scopeScrollArea), r = e.orientation === "horizontal", i = us(() => l("SCROLL_END"), 100), [s, l] = oS("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return g.useEffect(() => {
    if (s === "idle") {
      const c = window.setTimeout(() => l("HIDE"), n.scrollHideDelay);
      return () => window.clearTimeout(c);
    }
  }, [s, n.scrollHideDelay, l]), g.useEffect(() => {
    const c = n.viewport, u = r ? "scrollLeft" : "scrollTop";
    if (c) {
      let d = c[u];
      const h = () => {
        const p = c[u];
        d !== p && (l("SCROLL"), i()), d = p;
      };
      return c.addEventListener("scroll", h), () => c.removeEventListener("scroll", h);
    }
  }, [n.viewport, r, l, i]), /* @__PURE__ */ v($t, { present: a || s !== "hidden", children: /* @__PURE__ */ v(
    gu,
    {
      "data-state": s === "hidden" ? "hidden" : "visible",
      ...o,
      ref: t,
      onPointerEnter: pe(e.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: pe(e.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), Tf = g.forwardRef((e, t) => {
  const a = At(Qt, e.__scopeScrollArea), { forceMount: o, ...n } = e, [r, i] = g.useState(!1), s = e.orientation === "horizontal", l = us(() => {
    if (a.viewport) {
      const c = a.viewport.offsetWidth < a.viewport.scrollWidth, u = a.viewport.offsetHeight < a.viewport.scrollHeight;
      i(s ? c : u);
    }
  }, 10);
  return Go(a.viewport, l), Go(a.content, l), /* @__PURE__ */ v($t, { present: o || r, children: /* @__PURE__ */ v(
    gu,
    {
      "data-state": r ? "visible" : "hidden",
      ...n,
      ref: t
    }
  ) });
}), gu = g.forwardRef((e, t) => {
  const { orientation: a = "vertical", ...o } = e, n = At(Qt, e.__scopeScrollArea), r = g.useRef(null), i = g.useRef(0), [s, l] = g.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), c = Wf(s.viewport, s.content), u = {
    ...o,
    sizes: s,
    onSizesChange: l,
    hasThumb: c > 0 && c < 1,
    onThumbChange: (h) => r.current = h,
    onThumbPointerUp: () => i.current = 0,
    onThumbPointerDown: (h) => i.current = h
  };
  function d(h, p) {
    return pS(h, i.current, s, p);
  }
  return a === "horizontal" ? /* @__PURE__ */ v(
    lS,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (n.viewport && r.current) {
          const h = n.viewport.scrollLeft, p = dg(h, s, n.dir);
          r.current.style.transform = `translate3d(${p}px, 0, 0)`;
        }
      },
      onWheelScroll: (h) => {
        n.viewport && (n.viewport.scrollLeft = h);
      },
      onDragScroll: (h) => {
        n.viewport && (n.viewport.scrollLeft = d(h, n.dir));
      }
    }
  ) : a === "vertical" ? /* @__PURE__ */ v(
    cS,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (n.viewport && r.current) {
          const h = n.viewport.scrollTop, p = dg(h, s);
          r.current.style.transform = `translate3d(0, ${p}px, 0)`;
        }
      },
      onWheelScroll: (h) => {
        n.viewport && (n.viewport.scrollTop = h);
      },
      onDragScroll: (h) => {
        n.viewport && (n.viewport.scrollTop = d(h));
      }
    }
  ) : null;
}), lS = g.forwardRef((e, t) => {
  const { sizes: a, onSizesChange: o, ...n } = e, r = At(Qt, e.__scopeScrollArea), [i, s] = g.useState(), l = g.useRef(null), c = We(t, l, r.onScrollbarXChange);
  return g.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ v(
    Lf,
    {
      "data-orientation": "horizontal",
      ...n,
      ref: c,
      sizes: a,
      style: {
        bottom: 0,
        left: r.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: r.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": cs(a) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.x),
      onDragScroll: (u) => e.onDragScroll(u.x),
      onWheelScroll: (u, d) => {
        if (r.viewport) {
          const h = r.viewport.scrollLeft + u.deltaX;
          e.onWheelScroll(h), Ff(h, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && r.viewport && i && o({
          content: r.viewport.scrollWidth,
          viewport: r.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: vi(i.paddingLeft),
            paddingEnd: vi(i.paddingRight)
          }
        });
      }
    }
  );
}), cS = g.forwardRef((e, t) => {
  const { sizes: a, onSizesChange: o, ...n } = e, r = At(Qt, e.__scopeScrollArea), [i, s] = g.useState(), l = g.useRef(null), c = We(t, l, r.onScrollbarYChange);
  return g.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ v(
    Lf,
    {
      "data-orientation": "vertical",
      ...n,
      ref: c,
      sizes: a,
      style: {
        top: 0,
        right: r.dir === "ltr" ? 0 : void 0,
        left: r.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": cs(a) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.y),
      onDragScroll: (u) => e.onDragScroll(u.y),
      onWheelScroll: (u, d) => {
        if (r.viewport) {
          const h = r.viewport.scrollTop + u.deltaY;
          e.onWheelScroll(h), Ff(h, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && r.viewport && i && o({
          content: r.viewport.scrollHeight,
          viewport: r.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: vi(i.paddingTop),
            paddingEnd: vi(i.paddingBottom)
          }
        });
      }
    }
  );
}), [uS, Mf] = Df(Qt), Lf = g.forwardRef((e, t) => {
  const {
    __scopeScrollArea: a,
    sizes: o,
    hasThumb: n,
    onThumbChange: r,
    onThumbPointerUp: i,
    onThumbPointerDown: s,
    onThumbPositionChange: l,
    onDragScroll: c,
    onWheelScroll: u,
    onResize: d,
    ...h
  } = e, p = At(Qt, a), [f, m] = g.useState(null), b = We(t, (C) => m(C)), w = g.useRef(null), _ = g.useRef(""), y = p.viewport, k = o.content - o.viewport, x = qe(u), S = qe(l), $ = us(d, 10);
  function E(C) {
    if (w.current) {
      const z = C.clientX - w.current.left, R = C.clientY - w.current.top;
      c({ x: z, y: R });
    }
  }
  return g.useEffect(() => {
    const C = (z) => {
      const R = z.target;
      f?.contains(R) && x(z, k);
    };
    return document.addEventListener("wheel", C, { passive: !1 }), () => document.removeEventListener("wheel", C, { passive: !1 });
  }, [y, f, k, x]), g.useEffect(S, [o, S]), Go(f, $), Go(p.content, $), /* @__PURE__ */ v(
    uS,
    {
      scope: a,
      scrollbar: f,
      hasThumb: n,
      onThumbChange: qe(r),
      onThumbPointerUp: qe(i),
      onThumbPositionChange: S,
      onThumbPointerDown: qe(s),
      children: /* @__PURE__ */ v(
        _e.div,
        {
          ...h,
          ref: b,
          style: { position: "absolute", ...h.style },
          onPointerDown: pe(e.onPointerDown, (C) => {
            C.button === 0 && (C.target.setPointerCapture(C.pointerId), w.current = f.getBoundingClientRect(), _.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", p.viewport && (p.viewport.style.scrollBehavior = "auto"), E(C));
          }),
          onPointerMove: pe(e.onPointerMove, E),
          onPointerUp: pe(e.onPointerUp, (C) => {
            const z = C.target;
            z.hasPointerCapture(C.pointerId) && z.releasePointerCapture(C.pointerId), document.body.style.webkitUserSelect = _.current, p.viewport && (p.viewport.style.scrollBehavior = ""), w.current = null;
          })
        }
      )
    }
  );
}), _i = "ScrollAreaThumb", dS = g.forwardRef(
  (e, t) => {
    const { forceMount: a, ...o } = e, n = Mf(_i, e.__scopeScrollArea);
    return /* @__PURE__ */ v($t, { present: a || n.hasThumb, children: /* @__PURE__ */ v(gS, { ref: t, ...o }) });
  }
), gS = g.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: a, style: o, ...n } = e, r = At(_i, a), i = Mf(_i, a), { onThumbPositionChange: s } = i, l = We(
      t,
      (d) => i.onThumbChange(d)
    ), c = g.useRef(void 0), u = us(() => {
      c.current && (c.current(), c.current = void 0);
    }, 100);
    return g.useEffect(() => {
      const d = r.viewport;
      if (d) {
        const h = () => {
          if (u(), !c.current) {
            const p = fS(d, s);
            c.current = p, s();
          }
        };
        return s(), d.addEventListener("scroll", h), () => d.removeEventListener("scroll", h);
      }
    }, [r.viewport, u, s]), /* @__PURE__ */ v(
      _e.div,
      {
        "data-state": i.hasThumb ? "visible" : "hidden",
        ...n,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...o
        },
        onPointerDownCapture: pe(e.onPointerDownCapture, (d) => {
          const h = d.target.getBoundingClientRect(), p = d.clientX - h.left, f = d.clientY - h.top;
          i.onThumbPointerDown({ x: p, y: f });
        }),
        onPointerUp: pe(e.onPointerUp, i.onThumbPointerUp)
      }
    );
  }
);
dS.displayName = _i;
var hu = "ScrollAreaCorner", hS = g.forwardRef(
  (e, t) => {
    const a = At(hu, e.__scopeScrollArea), o = !!(a.scrollbarX && a.scrollbarY);
    return a.type !== "scroll" && o ? /* @__PURE__ */ v(mS, { ...e, ref: t }) : null;
  }
);
hS.displayName = hu;
var mS = g.forwardRef((e, t) => {
  const { __scopeScrollArea: a, ...o } = e, n = At(hu, a), [r, i] = g.useState(0), [s, l] = g.useState(0), c = !!(r && s);
  return Go(n.scrollbarX, () => {
    const u = n.scrollbarX?.offsetHeight || 0;
    n.onCornerHeightChange(u), l(u);
  }), Go(n.scrollbarY, () => {
    const u = n.scrollbarY?.offsetWidth || 0;
    n.onCornerWidthChange(u), i(u);
  }), c ? /* @__PURE__ */ v(
    _e.div,
    {
      ...o,
      ref: t,
      style: {
        width: r,
        height: s,
        position: "absolute",
        right: n.dir === "ltr" ? 0 : void 0,
        left: n.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function vi(e) {
  return e ? parseInt(e, 10) : 0;
}
function Wf(e, t) {
  const a = e / t;
  return isNaN(a) ? 0 : a;
}
function cs(e) {
  const t = Wf(e.viewport, e.content), a = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, o = (e.scrollbar.size - a) * t;
  return Math.max(o, 18);
}
function pS(e, t, a, o = "ltr") {
  const n = cs(a), r = n / 2, i = t || r, s = n - i, l = a.scrollbar.paddingStart + i, c = a.scrollbar.size - a.scrollbar.paddingEnd - s, u = a.content - a.viewport, d = o === "ltr" ? [0, u] : [u * -1, 0];
  return Bf([l, c], d)(e);
}
function dg(e, t, a = "ltr") {
  const o = cs(t), n = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, r = t.scrollbar.size - n, i = t.content - t.viewport, s = r - o, l = a === "ltr" ? [0, i] : [i * -1, 0], c = aS(e, l);
  return Bf([0, i], [0, s])(c);
}
function Bf(e, t) {
  return (a) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (a - e[0]);
  };
}
function Ff(e, t) {
  return e > 0 && e < t;
}
var fS = (e, t = () => {
}) => {
  let a = { left: e.scrollLeft, top: e.scrollTop }, o = 0;
  return function n() {
    const r = { left: e.scrollLeft, top: e.scrollTop }, i = a.left !== r.left, s = a.top !== r.top;
    (i || s) && t(), a = r, o = window.requestAnimationFrame(n);
  }(), () => window.cancelAnimationFrame(o);
};
function us(e, t) {
  const a = qe(e), o = g.useRef(0);
  return g.useEffect(() => () => window.clearTimeout(o.current), []), g.useCallback(() => {
    window.clearTimeout(o.current), o.current = window.setTimeout(a, t);
  }, [a, t]);
}
function Go(e, t) {
  const a = qe(t);
  ma(() => {
    let o = 0;
    if (e) {
      const n = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(a);
      });
      return n.observe(e), () => {
        window.cancelAnimationFrame(o), n.unobserve(e);
      };
    }
  }, [e, a]);
}
var bS = Nf, _S = If, vS = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), yS = "VisuallyHidden", Vf = g.forwardRef(
  (e, t) => /* @__PURE__ */ v(
    _e.span,
    {
      ...e,
      ref: t,
      style: { ...vS, ...e.style }
    }
  )
);
Vf.displayName = yS;
var wS = Vf;
const kS = "_divider_dlgq8_29", xS = "_dashed_dlgq8_61", hn = {
  divider: kS,
  "small-space": "_small-space_dlgq8_35",
  "medium-space": "_medium-space_dlgq8_38",
  "no-space": "_no-space_dlgq8_41",
  "with-text": "_with-text_dlgq8_44",
  dashed: xS,
  "divider-text": "_divider-text_dlgq8_70",
  "dialog-overlay-show": "_dialog-overlay-show_dlgq8_1",
  "dialog-content-show": "_dialog-content-show_dlgq8_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_dlgq8_1"
};
function $S({ className: e, text: t, dashed: a, space: o = "medium", ...n }) {
  const r = Oe(
    hn.divider,
    hn[`${o}-space`],
    t && hn["with-text"],
    a && hn.dashed,
    e
  );
  return /* @__PURE__ */ v("div", { className: r, role: "separator", "aria-label": t || "divider", ...n, children: t && /* @__PURE__ */ v("span", { className: hn["divider-text"], children: t }) });
}
function oc(e) {
  return e.replace(/\s/g, "-");
}
function Uf(e, t) {
  return oc(`${t}-${e}`);
}
function SS(e) {
  const [t, a] = Pe([]);
  return Ce(() => {
    const o = [];
    let n = 0;
    for (const r of e) {
      const i = document.getElementById(Uf(r.title, n));
      i && (o.push(i.clientWidth), n++);
    }
    a(o);
  }, [e]), t;
}
function CS(e) {
  return Ho(() => e.map((t, a) => ({
    ...t,
    value: Uf(t.title, a)
  })), [e]);
}
function ES(e = 0) {
  const [t, a] = Pe(e);
  return {
    activeTabIndex: t,
    setActiveTabIndex: a
  };
}
var ds = "Tabs", [zS, rrt] = fo(ds, [
  ef
]), qf = ef(), [jS, mu] = zS(ds), Hf = g.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: a,
      value: o,
      onValueChange: n,
      defaultValue: r,
      orientation: i = "horizontal",
      dir: s,
      activationMode: l = "automatic",
      ...c
    } = e, u = is(s), [d, h] = Jn({
      prop: o,
      onChange: n,
      defaultProp: r ?? "",
      caller: ds
    });
    return /* @__PURE__ */ v(
      jS,
      {
        scope: a,
        baseId: Ya(),
        value: d,
        onValueChange: h,
        orientation: i,
        dir: u,
        activationMode: l,
        children: /* @__PURE__ */ v(
          _e.div,
          {
            dir: u,
            "data-orientation": i,
            ...c,
            ref: t
          }
        )
      }
    );
  }
);
Hf.displayName = ds;
var Gf = "TabsList", Kf = g.forwardRef(
  (e, t) => {
    const { __scopeTabs: a, loop: o = !0, ...n } = e, r = mu(Gf, a), i = qf(a);
    return /* @__PURE__ */ v(
      A1,
      {
        asChild: !0,
        ...i,
        orientation: r.orientation,
        dir: r.dir,
        loop: o,
        children: /* @__PURE__ */ v(
          _e.div,
          {
            role: "tablist",
            "aria-orientation": r.orientation,
            ...n,
            ref: t
          }
        )
      }
    );
  }
);
Kf.displayName = Gf;
var Jf = "TabsTrigger", Zf = g.forwardRef(
  (e, t) => {
    const { __scopeTabs: a, value: o, disabled: n = !1, ...r } = e, i = mu(Jf, a), s = qf(a), l = Qf(i.baseId, o), c = eb(i.baseId, o), u = o === i.value;
    return /* @__PURE__ */ v(
      O1,
      {
        asChild: !0,
        ...s,
        focusable: !n,
        active: u,
        children: /* @__PURE__ */ v(
          _e.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": c,
            "data-state": u ? "active" : "inactive",
            "data-disabled": n ? "" : void 0,
            disabled: n,
            id: l,
            ...r,
            ref: t,
            onMouseDown: pe(e.onMouseDown, (d) => {
              !n && d.button === 0 && d.ctrlKey === !1 ? i.onValueChange(o) : d.preventDefault();
            }),
            onKeyDown: pe(e.onKeyDown, (d) => {
              [" ", "Enter"].includes(d.key) && i.onValueChange(o);
            }),
            onFocus: pe(e.onFocus, () => {
              const d = i.activationMode !== "manual";
              !u && !n && d && i.onValueChange(o);
            })
          }
        )
      }
    );
  }
);
Zf.displayName = Jf;
var Yf = "TabsContent", Xf = g.forwardRef(
  (e, t) => {
    const { __scopeTabs: a, value: o, forceMount: n, children: r, ...i } = e, s = mu(Yf, a), l = Qf(s.baseId, o), c = eb(s.baseId, o), u = o === s.value, d = g.useRef(u);
    return g.useEffect(() => {
      const h = requestAnimationFrame(() => d.current = !1);
      return () => cancelAnimationFrame(h);
    }, []), /* @__PURE__ */ v($t, { present: n || u, children: ({ present: h }) => /* @__PURE__ */ v(
      _e.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !h,
        id: c,
        tabIndex: 0,
        ...i,
        ref: t,
        style: {
          ...e.style,
          animationDuration: d.current ? "0s" : void 0
        },
        children: h && r
      }
    ) });
  }
);
Xf.displayName = Yf;
function Qf(e, t) {
  return `${e}-trigger-${t}`;
}
function eb(e, t) {
  return `${e}-content-${t}`;
}
var AS = Hf, OS = Kf, PS = Zf, DS = Xf;
const NS = "_tabs_11da8_29", Vt = {
  tabs: NS,
  "is-full-width": "_is-full-width_11da8_32",
  "tabs-content": "_tabs-content_11da8_35",
  "tabs-list": "_tabs-list_11da8_38",
  "is-small": "_is-small_11da8_41",
  "tabs-trigger-list": "_tabs-trigger-list_11da8_44",
  "tabs-trigger": "_tabs-trigger_11da8_44",
  "is-medium": "_is-medium_11da8_67",
  "tabs-underline": "_tabs-underline_11da8_77",
  "tabs-divider": "_tabs-divider_11da8_86",
  "dialog-overlay-show": "_dialog-overlay-show_11da8_1",
  "dialog-content-show": "_dialog-content-show_11da8_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_11da8_1"
};
function RS({
  tabs: e,
  isFullWidth: t,
  size: a = "medium",
  className: o = "",
  tabIndex: n = 0,
  onTabChange: r,
  ...i
}) {
  const { activeTabIndex: s, setActiveTabIndex: l } = ES(n), c = CS(e), u = SS(e), d = Oe(Vt.tabs, t && Vt["is-full-width"], o), h = Oe(Vt["tabs-trigger"], a && Vt[`is-${a}`]);
  return /* @__PURE__ */ T(
    AS,
    {
      onValueChange: (p) => {
        const f = c.findIndex((m) => oc(m.value) === p);
        l(f), r?.(f);
      },
      className: d,
      defaultValue: c[s]?.value,
      orientation: "horizontal",
      ...i,
      children: [
        /* @__PURE__ */ v(bS, { children: /* @__PURE__ */ v(_S, { children: /* @__PURE__ */ T(OS, { className: Oe(Vt["tabs-list"], a === "small" && Vt["is-small"]), children: [
          /* @__PURE__ */ T("div", { className: Vt["tabs-trigger-list"], children: [
            c.map((p) => {
              const f = p.value;
              return /* @__PURE__ */ v(
                PS,
                {
                  id: f,
                  "aria-controls": f,
                  "aria-labelledby": f,
                  className: h,
                  value: f,
                  children: p.title
                },
                f
              );
            }),
            /* @__PURE__ */ v(
              "span",
              {
                className: Vt["tabs-underline"],
                style: {
                  width: u[s],
                  transform: `translateX(${u.slice(0, s).reduce((p, f) => p + f, 0) + s * 16}px)`
                }
              }
            )
          ] }),
          /* @__PURE__ */ v("div", { className: Vt["tabs-divider"] })
        ] }) }) }),
        c.map((p) => {
          const f = oc(p.value);
          return /* @__PURE__ */ v(DS, { className: Vt["tabs-content"], "aria-labelledby": f, value: f, children: p.content }, f);
        })
      ]
    }
  );
}
const IS = "_drawer_1xu3v_29", rl = {
  "drawer-overlay": "_drawer-overlay_1xu3v_29",
  drawer: IS,
  "drawer-close": "_drawer-close_1xu3v_60"
};
function TS({ children: e, isOpen: t, onClose: a, className: o }) {
  const n = Oe(rl.drawer, o);
  return /* @__PURE__ */ v(Y$, { defaultOpen: t, open: t, children: /* @__PURE__ */ T(X$, { children: [
    /* @__PURE__ */ v(Q$, { className: rl["drawer-overlay"], onClick: a }),
    /* @__PURE__ */ T(eS, { className: n, children: [
      e,
      /* @__PURE__ */ v(tS, { asChild: !0, children: /* @__PURE__ */ v("button", { onClick: a, className: rl["drawer-close"], "aria-label": "Close", children: /* @__PURE__ */ v(Se, { name: "remove", size: "large" }) }) })
    ] })
  ] }) });
}
var pu = "Progress", fu = 100, [MS, irt] = fo(pu), [LS, WS] = MS(pu), tb = g.forwardRef(
  (e, t) => {
    const {
      __scopeProgress: a,
      value: o = null,
      max: n,
      getValueLabel: r = BS,
      ...i
    } = e;
    (n || n === 0) && !gg(n) && console.error(FS(`${n}`, "Progress"));
    const s = gg(n) ? n : fu;
    o !== null && !hg(o, s) && console.error(VS(`${o}`, "Progress"));
    const l = hg(o, s) ? o : null, c = yi(l) ? r(l, s) : void 0;
    return /* @__PURE__ */ v(LS, { scope: a, value: l, max: s, children: /* @__PURE__ */ v(
      _e.div,
      {
        "aria-valuemax": s,
        "aria-valuemin": 0,
        "aria-valuenow": yi(l) ? l : void 0,
        "aria-valuetext": c,
        role: "progressbar",
        "data-state": nb(l, s),
        "data-value": l ?? void 0,
        "data-max": s,
        ...i,
        ref: t
      }
    ) });
  }
);
tb.displayName = pu;
var ab = "ProgressIndicator", ob = g.forwardRef(
  (e, t) => {
    const { __scopeProgress: a, ...o } = e, n = WS(ab, a);
    return /* @__PURE__ */ v(
      _e.div,
      {
        "data-state": nb(n.value, n.max),
        "data-value": n.value ?? void 0,
        "data-max": n.max,
        ...o,
        ref: t
      }
    );
  }
);
ob.displayName = ab;
function BS(e, t) {
  return `${Math.round(e / t * 100)}%`;
}
function nb(e, t) {
  return e == null ? "indeterminate" : e === t ? "complete" : "loading";
}
function yi(e) {
  return typeof e == "number";
}
function gg(e) {
  return yi(e) && !isNaN(e) && e > 0;
}
function hg(e, t) {
  return yi(e) && !isNaN(e) && e <= t && e >= 0;
}
function FS(e, t) {
  return `Invalid prop \`max\` of value \`${e}\` supplied to \`${t}\`. Only numbers greater than 0 are valid max values. Defaulting to \`${fu}\`.`;
}
function VS(e, t) {
  return `Invalid prop \`value\` of value \`${e}\` supplied to \`${t}\`. The \`value\` prop must be:
  - a positive number
  - less than the value passed to \`max\` (or ${fu} if no \`max\` prop is set)
  - \`null\` or \`undefined\` if the progress is indeterminate.

Defaulting to \`null\`.`;
}
var US = tb, qS = ob;
const HS = "_small_ghhu4_36", GS = "_indicator_ghhu4_40", KS = "_primary_ghhu4_49", JS = "_secondary_ghhu4_55", ZS = "_tertiary_ghhu4_61", YS = "_success_ghhu4_67", XS = "_error_ghhu4_79", mn = {
  "progress-bar": "_progress-bar_ghhu4_29",
  small: HS,
  indicator: GS,
  "full-width": "_full-width_ghhu4_46",
  primary: KS,
  secondary: JS,
  tertiary: ZS,
  success: YS,
  "eco-green": "_eco-green_ghhu4_73",
  error: XS,
  "dialog-overlay-show": "_dialog-overlay-show_ghhu4_1",
  "dialog-content-show": "_dialog-content-show_ghhu4_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_ghhu4_1"
}, mg = ({ value: e = 0, color: t = "primary", size: a, isFullWidth: o, ariaLabel: n }) => {
  const [r, i] = Pe(0), s = Oe(
    mn["progress-bar"],
    a && mn[a],
    t && mn[t],
    o && mn["full-width"]
  );
  return Ce(() => {
    const l = setTimeout(() => i(e), 500);
    return () => clearTimeout(l);
  }, [e]), /* @__PURE__ */ v(US, { className: s, "aria-label": n, children: /* @__PURE__ */ v(qS, { className: mn.indicator, style: { transform: `translateX(-${100 - r}%)` } }) });
}, pg = {
  "is-hidden-desktop": "_is-hidden-desktop_1m12x_29",
  "is-hidden-mobile": "_is-hidden-mobile_1m12x_40",
  "unset-ul": "_unset-ul_1m12x_54",
  "dialog-overlay-show": "_dialog-overlay-show_1m12x_1",
  "dialog-content-show": "_dialog-content-show_1m12x_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1m12x_1"
}, Ko = ({ children: e, hideOn: t, className: a }) => {
  const o = Oe(t && pg[`is-hidden-${t}`], a);
  return /* @__PURE__ */ v("li", { className: o, children: /* @__PURE__ */ v("ul", { className: pg["unset-ul"], children: e }) });
}, QS = "_badge_zy4sa_29", e0 = "_root_zy4sa_58", pn = {
  badge: QS,
  "is-small": "_is-small_zy4sa_42",
  "has-child": "_has-child_zy4sa_48",
  "on-icon": "_on-icon_zy4sa_53",
  root: e0
};
function bu({ value: e, isSmall: t = !1, onIcon: a = !1, children: o, className: n, ...r }) {
  const i = Oe(
    pn.badge,
    t && pn["is-small"],
    a && pn["on-icon"],
    !!o && pn["has-child"],
    n
  );
  return o ? /* @__PURE__ */ T("span", { className: pn.root, ...r, children: [
    /* @__PURE__ */ v("span", { className: i, children: !t && e }),
    o
  ] }) : /* @__PURE__ */ v("span", { className: i, ...r, children: !t && e });
}
var bo = "NavigationMenu", [_u, rb, t0] = iu(bo), [nc, a0, o0] = iu(bo), [vu, srt] = fo(
  bo,
  [t0, o0]
), [n0, Ot] = vu(bo), [r0, i0] = vu(bo), ib = g.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: a,
      value: o,
      onValueChange: n,
      defaultValue: r,
      delayDuration: i = 200,
      skipDelayDuration: s = 300,
      orientation: l = "horizontal",
      dir: c,
      ...u
    } = e, [d, h] = g.useState(null), p = We(t, (C) => h(C)), f = is(c), m = g.useRef(0), b = g.useRef(0), w = g.useRef(0), [_, y] = g.useState(!0), [k, x] = Jn({
      prop: o,
      onChange: (C) => {
        const z = C !== "", R = s > 0;
        z ? (window.clearTimeout(w.current), R && y(!1)) : (window.clearTimeout(w.current), w.current = window.setTimeout(
          () => y(!0),
          s
        )), n?.(C);
      },
      defaultProp: r ?? "",
      caller: bo
    }), S = g.useCallback(() => {
      window.clearTimeout(b.current), b.current = window.setTimeout(() => x(""), 150);
    }, [x]), $ = g.useCallback(
      (C) => {
        window.clearTimeout(b.current), x(C);
      },
      [x]
    ), E = g.useCallback(
      (C) => {
        k === C ? window.clearTimeout(b.current) : m.current = window.setTimeout(() => {
          window.clearTimeout(b.current), x(C);
        }, i);
      },
      [k, x, i]
    );
    return g.useEffect(() => () => {
      window.clearTimeout(m.current), window.clearTimeout(b.current), window.clearTimeout(w.current);
    }, []), /* @__PURE__ */ v(
      sb,
      {
        scope: a,
        isRootMenu: !0,
        value: k,
        dir: f,
        orientation: l,
        rootNavigationMenu: d,
        onTriggerEnter: (C) => {
          window.clearTimeout(m.current), _ ? E(C) : $(C);
        },
        onTriggerLeave: () => {
          window.clearTimeout(m.current), S();
        },
        onContentEnter: () => window.clearTimeout(b.current),
        onContentLeave: S,
        onItemSelect: (C) => {
          x((z) => z === C ? "" : C);
        },
        onItemDismiss: () => x(""),
        children: /* @__PURE__ */ v(
          _e.nav,
          {
            "aria-label": "Main",
            "data-orientation": l,
            dir: f,
            ...u,
            ref: p
          }
        )
      }
    );
  }
);
ib.displayName = bo;
var rc = "NavigationMenuSub", s0 = g.forwardRef(
  (e, t) => {
    const {
      __scopeNavigationMenu: a,
      value: o,
      onValueChange: n,
      defaultValue: r,
      orientation: i = "horizontal",
      ...s
    } = e, l = Ot(rc, a), [c, u] = Jn({
      prop: o,
      onChange: n,
      defaultProp: r ?? "",
      caller: rc
    });
    return /* @__PURE__ */ v(
      sb,
      {
        scope: a,
        isRootMenu: !1,
        value: c,
        dir: l.dir,
        orientation: i,
        rootNavigationMenu: l.rootNavigationMenu,
        onTriggerEnter: (d) => u(d),
        onItemSelect: (d) => u(d),
        onItemDismiss: () => u(""),
        children: /* @__PURE__ */ v(_e.div, { "data-orientation": i, ...s, ref: t })
      }
    );
  }
);
s0.displayName = rc;
var sb = (e) => {
  const {
    scope: t,
    isRootMenu: a,
    rootNavigationMenu: o,
    dir: n,
    orientation: r,
    children: i,
    value: s,
    onItemSelect: l,
    onItemDismiss: c,
    onTriggerEnter: u,
    onTriggerLeave: d,
    onContentEnter: h,
    onContentLeave: p
  } = e, [f, m] = g.useState(null), [b, w] = g.useState(/* @__PURE__ */ new Map()), [_, y] = g.useState(null);
  return /* @__PURE__ */ v(
    n0,
    {
      scope: t,
      isRootMenu: a,
      rootNavigationMenu: o,
      value: s,
      previousValue: P1(s),
      baseId: Ya(),
      dir: n,
      orientation: r,
      viewport: f,
      onViewportChange: m,
      indicatorTrack: _,
      onIndicatorTrackChange: y,
      onTriggerEnter: qe(u),
      onTriggerLeave: qe(d),
      onContentEnter: qe(h),
      onContentLeave: qe(p),
      onItemSelect: qe(l),
      onItemDismiss: qe(c),
      onViewportContentChange: g.useCallback((k, x) => {
        w((S) => (S.set(k, x), new Map(S)));
      }, []),
      onViewportContentRemove: g.useCallback((k) => {
        w((x) => x.has(k) ? (x.delete(k), new Map(x)) : x);
      }, []),
      children: /* @__PURE__ */ v(_u.Provider, { scope: t, children: /* @__PURE__ */ v(r0, { scope: t, items: b, children: i }) })
    }
  );
}, lb = "NavigationMenuList", cb = g.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: a, ...o } = e, n = Ot(lb, a), r = /* @__PURE__ */ v(_e.ul, { "data-orientation": n.orientation, ...o, ref: t });
    return /* @__PURE__ */ v(_e.div, { style: { position: "relative" }, ref: n.onIndicatorTrackChange, children: /* @__PURE__ */ v(_u.Slot, { scope: a, children: n.isRootMenu ? /* @__PURE__ */ v(bb, { asChild: !0, children: r }) : r }) });
  }
);
cb.displayName = lb;
var ub = "NavigationMenuItem", [l0, db] = vu(ub), gb = g.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: a, value: o, ...n } = e, r = Ya(), i = o || r || "LEGACY_REACT_AUTO_VALUE", s = g.useRef(null), l = g.useRef(null), c = g.useRef(null), u = g.useRef(() => {
    }), d = g.useRef(!1), h = g.useCallback((f = "start") => {
      if (s.current) {
        u.current();
        const m = sc(s.current);
        m.length && ku(f === "start" ? m : m.reverse());
      }
    }, []), p = g.useCallback(() => {
      if (s.current) {
        const f = sc(s.current);
        f.length && (u.current = b0(f));
      }
    }, []);
    return /* @__PURE__ */ v(
      l0,
      {
        scope: a,
        value: i,
        triggerRef: l,
        contentRef: s,
        focusProxyRef: c,
        wasEscapeCloseRef: d,
        onEntryKeyDown: h,
        onFocusProxyEnter: h,
        onRootContentClose: p,
        onContentFocusOutside: p,
        children: /* @__PURE__ */ v(_e.li, { ...n, ref: t })
      }
    );
  }
);
gb.displayName = ub;
var ic = "NavigationMenuTrigger", hb = g.forwardRef((e, t) => {
  const { __scopeNavigationMenu: a, disabled: o, ...n } = e, r = Ot(ic, e.__scopeNavigationMenu), i = db(ic, e.__scopeNavigationMenu), s = g.useRef(null), l = We(s, i.triggerRef, t), c = vb(r.baseId, i.value), u = yb(r.baseId, i.value), d = g.useRef(!1), h = g.useRef(!1), p = i.value === r.value;
  return /* @__PURE__ */ T(De, { children: [
    /* @__PURE__ */ v(_u.ItemSlot, { scope: a, value: i.value, children: /* @__PURE__ */ v(_b, { asChild: !0, children: /* @__PURE__ */ v(
      _e.button,
      {
        id: c,
        disabled: o,
        "data-disabled": o ? "" : void 0,
        "data-state": xu(p),
        "aria-expanded": p,
        "aria-controls": u,
        ...n,
        ref: l,
        onPointerEnter: pe(e.onPointerEnter, () => {
          h.current = !1, i.wasEscapeCloseRef.current = !1;
        }),
        onPointerMove: pe(
          e.onPointerMove,
          wi(() => {
            o || h.current || i.wasEscapeCloseRef.current || d.current || (r.onTriggerEnter(i.value), d.current = !0);
          })
        ),
        onPointerLeave: pe(
          e.onPointerLeave,
          wi(() => {
            o || (r.onTriggerLeave(), d.current = !1);
          })
        ),
        onClick: pe(e.onClick, () => {
          r.onItemSelect(i.value), h.current = p;
        }),
        onKeyDown: pe(e.onKeyDown, (f) => {
          const m = { horizontal: "ArrowDown", vertical: r.dir === "rtl" ? "ArrowLeft" : "ArrowRight" }[r.orientation];
          p && f.key === m && (i.onEntryKeyDown(), f.preventDefault());
        })
      }
    ) }) }),
    p && /* @__PURE__ */ T(De, { children: [
      /* @__PURE__ */ v(
        wS,
        {
          "aria-hidden": !0,
          tabIndex: 0,
          ref: i.focusProxyRef,
          onFocus: (f) => {
            const m = i.contentRef.current, b = f.relatedTarget, w = b === s.current, _ = m?.contains(b);
            (w || !_) && i.onFocusProxyEnter(w ? "start" : "end");
          }
        }
      ),
      r.viewport && /* @__PURE__ */ v("span", { "aria-owns": u })
    ] })
  ] });
});
hb.displayName = ic;
var c0 = "NavigationMenuLink", fg = "navigationMenu.linkSelect", mb = g.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: a, active: o, onSelect: n, ...r } = e;
    return /* @__PURE__ */ v(_b, { asChild: !0, children: /* @__PURE__ */ v(
      _e.a,
      {
        "data-active": o ? "" : void 0,
        "aria-current": o ? "page" : void 0,
        ...r,
        ref: t,
        onClick: pe(
          e.onClick,
          (i) => {
            const s = i.target, l = new CustomEvent(fg, {
              bubbles: !0,
              cancelable: !0
            });
            if (s.addEventListener(fg, (c) => n?.(c), { once: !0 }), Ql(s, l), !l.defaultPrevented && !i.metaKey) {
              const c = new CustomEvent(Yr, {
                bubbles: !0,
                cancelable: !0
              });
              Ql(s, c);
            }
          },
          { checkForDefaultPrevented: !1 }
        )
      }
    ) });
  }
);
mb.displayName = c0;
var yu = "NavigationMenuIndicator", u0 = g.forwardRef((e, t) => {
  const { forceMount: a, ...o } = e, n = Ot(yu, e.__scopeNavigationMenu), r = !!n.value;
  return n.indicatorTrack ? rs.createPortal(
    /* @__PURE__ */ v($t, { present: a || r, children: /* @__PURE__ */ v(d0, { ...o, ref: t }) }),
    n.indicatorTrack
  ) : null;
});
u0.displayName = yu;
var d0 = g.forwardRef((e, t) => {
  const { __scopeNavigationMenu: a, ...o } = e, n = Ot(yu, a), r = rb(a), [i, s] = g.useState(
    null
  ), [l, c] = g.useState(null), u = n.orientation === "horizontal", d = !!n.value;
  g.useEffect(() => {
    const p = r().find((f) => f.value === n.value)?.ref.current;
    p && s(p);
  }, [r, n.value]);
  const h = () => {
    i && c({
      size: u ? i.offsetWidth : i.offsetHeight,
      offset: u ? i.offsetLeft : i.offsetTop
    });
  };
  return lc(i, h), lc(n.indicatorTrack, h), l ? /* @__PURE__ */ v(
    _e.div,
    {
      "aria-hidden": !0,
      "data-state": d ? "visible" : "hidden",
      "data-orientation": n.orientation,
      ...o,
      ref: t,
      style: {
        position: "absolute",
        ...u ? {
          left: 0,
          width: l.size + "px",
          transform: `translateX(${l.offset}px)`
        } : {
          top: 0,
          height: l.size + "px",
          transform: `translateY(${l.offset}px)`
        },
        ...o.style
      }
    }
  ) : null;
}), Jo = "NavigationMenuContent", pb = g.forwardRef((e, t) => {
  const { forceMount: a, ...o } = e, n = Ot(Jo, e.__scopeNavigationMenu), r = db(Jo, e.__scopeNavigationMenu), i = We(r.contentRef, t), s = r.value === n.value, l = {
    value: r.value,
    triggerRef: r.triggerRef,
    focusProxyRef: r.focusProxyRef,
    wasEscapeCloseRef: r.wasEscapeCloseRef,
    onContentFocusOutside: r.onContentFocusOutside,
    onRootContentClose: r.onRootContentClose,
    ...o
  };
  return n.viewport ? /* @__PURE__ */ v(g0, { forceMount: a, ...l, ref: i }) : /* @__PURE__ */ v($t, { present: a || s, children: /* @__PURE__ */ v(
    fb,
    {
      "data-state": xu(s),
      ...l,
      ref: i,
      onPointerEnter: pe(e.onPointerEnter, n.onContentEnter),
      onPointerLeave: pe(
        e.onPointerLeave,
        wi(n.onContentLeave)
      ),
      style: {
        // Prevent interaction when animating out
        pointerEvents: !s && n.isRootMenu ? "none" : void 0,
        ...l.style
      }
    }
  ) });
});
pb.displayName = Jo;
var g0 = g.forwardRef((e, t) => {
  const a = Ot(Jo, e.__scopeNavigationMenu), { onViewportContentChange: o, onViewportContentRemove: n } = a;
  return ma(() => {
    o(e.value, {
      ref: t,
      ...e
    });
  }, [e, t, o]), ma(() => () => n(e.value), [e.value, n]), null;
}), Yr = "navigationMenu.rootContentDismiss", fb = g.forwardRef((e, t) => {
  const {
    __scopeNavigationMenu: a,
    value: o,
    triggerRef: n,
    focusProxyRef: r,
    wasEscapeCloseRef: i,
    onRootContentClose: s,
    onContentFocusOutside: l,
    ...c
  } = e, u = Ot(Jo, a), d = g.useRef(null), h = We(d, t), p = vb(u.baseId, o), f = yb(u.baseId, o), m = rb(a), b = g.useRef(null), { onItemDismiss: w } = u;
  g.useEffect(() => {
    const y = d.current;
    if (u.isRootMenu && y) {
      const k = () => {
        w(), s(), y.contains(document.activeElement) && n.current?.focus();
      };
      return y.addEventListener(Yr, k), () => y.removeEventListener(Yr, k);
    }
  }, [u.isRootMenu, e.value, n, w, s]);
  const _ = g.useMemo(() => {
    const y = m().map((C) => C.value);
    u.dir === "rtl" && y.reverse();
    const k = y.indexOf(u.value), x = y.indexOf(u.previousValue), S = o === u.value, $ = x === y.indexOf(o);
    if (!S && !$) return b.current;
    const E = (() => {
      if (k !== x) {
        if (S && x !== -1) return k > x ? "from-end" : "from-start";
        if ($ && k !== -1) return k > x ? "to-start" : "to-end";
      }
      return null;
    })();
    return b.current = E, E;
  }, [u.previousValue, u.value, u.dir, m, o]);
  return /* @__PURE__ */ v(bb, { asChild: !0, children: /* @__PURE__ */ v(
    su,
    {
      id: f,
      "aria-labelledby": p,
      "data-motion": _,
      "data-orientation": u.orientation,
      ...c,
      ref: h,
      disableOutsidePointerEvents: !1,
      onDismiss: () => {
        const y = new Event(Yr, {
          bubbles: !0,
          cancelable: !0
        });
        d.current?.dispatchEvent(y);
      },
      onFocusOutside: pe(e.onFocusOutside, (y) => {
        l();
        const k = y.target;
        u.rootNavigationMenu?.contains(k) && y.preventDefault();
      }),
      onPointerDownOutside: pe(e.onPointerDownOutside, (y) => {
        const k = y.target, x = m().some(($) => $.ref.current?.contains(k)), S = u.isRootMenu && u.viewport?.contains(k);
        (x || S || !u.isRootMenu) && y.preventDefault();
      }),
      onKeyDown: pe(e.onKeyDown, (y) => {
        const k = y.altKey || y.ctrlKey || y.metaKey;
        if (y.key === "Tab" && !k) {
          const x = sc(y.currentTarget), S = document.activeElement, $ = x.findIndex((C) => C === S), E = y.shiftKey ? x.slice(0, $).reverse() : x.slice($ + 1, x.length);
          ku(E) ? y.preventDefault() : r.current?.focus();
        }
      }),
      onEscapeKeyDown: pe(e.onEscapeKeyDown, (y) => {
        i.current = !0;
      })
    }
  ) });
}), wu = "NavigationMenuViewport", h0 = g.forwardRef((e, t) => {
  const { forceMount: a, ...o } = e, n = !!Ot(wu, e.__scopeNavigationMenu).value;
  return /* @__PURE__ */ v($t, { present: a || n, children: /* @__PURE__ */ v(m0, { ...o, ref: t }) });
});
h0.displayName = wu;
var m0 = g.forwardRef((e, t) => {
  const { __scopeNavigationMenu: a, children: o, ...n } = e, r = Ot(wu, a), i = We(t, r.onViewportChange), s = i0(
    Jo,
    e.__scopeNavigationMenu
  ), [l, c] = g.useState(null), [u, d] = g.useState(null), h = l ? l?.width + "px" : void 0, p = l ? l?.height + "px" : void 0, f = !!r.value, m = f ? r.value : r.previousValue;
  return lc(u, () => {
    u && c({ width: u.offsetWidth, height: u.offsetHeight });
  }), /* @__PURE__ */ v(
    _e.div,
    {
      "data-state": xu(f),
      "data-orientation": r.orientation,
      ...n,
      ref: i,
      style: {
        // Prevent interaction when animating out
        pointerEvents: !f && r.isRootMenu ? "none" : void 0,
        "--radix-navigation-menu-viewport-width": h,
        "--radix-navigation-menu-viewport-height": p,
        ...n.style
      },
      onPointerEnter: pe(e.onPointerEnter, r.onContentEnter),
      onPointerLeave: pe(e.onPointerLeave, wi(r.onContentLeave)),
      children: Array.from(s.items).map(([b, { ref: w, forceMount: _, ...y }]) => {
        const k = m === b;
        return /* @__PURE__ */ v($t, { present: _ || k, children: /* @__PURE__ */ v(
          fb,
          {
            ...y,
            ref: ru(w, (x) => {
              k && x && d(x);
            })
          }
        ) }, b);
      })
    }
  );
}), p0 = "FocusGroup", bb = g.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: a, ...o } = e, n = Ot(p0, a);
    return /* @__PURE__ */ v(nc.Provider, { scope: a, children: /* @__PURE__ */ v(nc.Slot, { scope: a, children: /* @__PURE__ */ v(_e.div, { dir: n.dir, ...o, ref: t }) }) });
  }
), bg = ["ArrowRight", "ArrowLeft", "ArrowUp", "ArrowDown"], f0 = "FocusGroupItem", _b = g.forwardRef(
  (e, t) => {
    const { __scopeNavigationMenu: a, ...o } = e, n = a0(a), r = Ot(f0, a);
    return /* @__PURE__ */ v(nc.ItemSlot, { scope: a, children: /* @__PURE__ */ v(
      _e.button,
      {
        ...o,
        ref: t,
        onKeyDown: pe(e.onKeyDown, (i) => {
          if (["Home", "End", ...bg].includes(i.key)) {
            let s = n().map((l) => l.ref.current);
            if ([r.dir === "rtl" ? "ArrowRight" : "ArrowLeft", "ArrowUp", "End"].includes(i.key) && s.reverse(), bg.includes(i.key)) {
              const l = s.indexOf(i.currentTarget);
              s = s.slice(l + 1);
            }
            setTimeout(() => ku(s)), i.preventDefault();
          }
        })
      }
    ) });
  }
);
function sc(e) {
  const t = [], a = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const n = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || n ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; a.nextNode(); ) t.push(a.currentNode);
  return t;
}
function ku(e) {
  const t = document.activeElement;
  return e.some((a) => a === t ? !0 : (a.focus(), document.activeElement !== t));
}
function b0(e) {
  return e.forEach((t) => {
    t.dataset.tabindex = t.getAttribute("tabindex") || "", t.setAttribute("tabindex", "-1");
  }), () => {
    e.forEach((t) => {
      const a = t.dataset.tabindex;
      t.setAttribute("tabindex", a);
    });
  };
}
function lc(e, t) {
  const a = qe(t);
  ma(() => {
    let o = 0;
    if (e) {
      const n = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(a);
      });
      return n.observe(e), () => {
        window.cancelAnimationFrame(o), n.unobserve(e);
      };
    }
  }, [e, a]);
}
function xu(e) {
  return e ? "open" : "closed";
}
function vb(e, t) {
  return `${e}-trigger-${t}`;
}
function yb(e, t) {
  return `${e}-content-${t}`;
}
function wi(e) {
  return (t) => t.pointerType === "mouse" ? e(t) : void 0;
}
var _0 = ib, v0 = cb, ki = gb, y0 = hb, w0 = mb, k0 = pb;
const x0 = "_arrow_1367h_117", $0 = "_navbar_1367h_29", $e = {
  "navbar-item": "_navbar-item_1367h_29",
  "navbar-item-background-hover": "_navbar-item-background-hover_1367h_33",
  "navbar-drawer": "_navbar-drawer_1367h_37",
  "first-on-mobile": "_first-on-mobile_1367h_52",
  "second-on-mobile": "_second-on-mobile_1367h_61",
  "navbar-end": "_navbar-end_1367h_70",
  "navbar-item-wrapper": "_navbar-item-wrapper_1367h_89",
  "navbar-item-flex-grow": "_navbar-item-flex-grow_1367h_105",
  "navbar-item-button": "_navbar-item-button_1367h_108",
  arrow: x0,
  "navbar-has-dropdown": "_navbar-has-dropdown_1367h_130",
  "navbar-dropdown": "_navbar-dropdown_1367h_156",
  "is-size-small": "_is-size-small_1367h_161",
  "is-size-medium": "_is-size-medium_1367h_164",
  "navbar-item-no-padding-top-bottom": "_navbar-item-no-padding-top-bottom_1367h_191",
  "navbar-item-is-right": "_navbar-item-is-right_1367h_195",
  "navbar-item-is-center": "_navbar-item-is-center_1367h_200",
  "navbar-item-no-padding": "_navbar-item-no-padding_1367h_191",
  "is-right": "_is-right_1367h_207",
  "is-left": "_is-left_1367h_211",
  navbar: $0,
  "is-fixed-top": "_is-fixed-top_1367h_228",
  "navbar-burger": "_navbar-burger_1367h_241",
  "navbar-menu": "_navbar-menu_1367h_282",
  "burger-close": "_burger-close_1367h_296",
  "navbar-start": "_navbar-start_1367h_316",
  "unset-li": "_unset-li_1367h_350",
  "margin-auto-top": "_margin-auto-top_1367h_357",
  "navbar-item-larger-padding-bottom": "_navbar-item-larger-padding-bottom_1367h_366",
  "dialog-overlay-show": "_dialog-overlay-show_1367h_1",
  "dialog-content-show": "_dialog-content-show_1367h_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1367h_1"
}, wb = ({ children: e, isFixedTop: t }) => /* @__PURE__ */ v(_0, { children: /* @__PURE__ */ v(v0, { className: Oe($e.navbar, t && $e["is-fixed-top"]), children: e }) }), kb = ({ children: e, notificationValue: t }) => {
  const { value: a, toggle: o } = D1(), { isMobile: n, isTablet: r } = R1();
  return /* @__PURE__ */ T(De, { children: [
    (n || r) && /* @__PURE__ */ T(De, { children: [
      /* @__PURE__ */ v(de, { children: t ? /* @__PURE__ */ v(bu, { value: t, isSmall: !0, children: /* @__PURE__ */ T("button", { onClick: o, className: $e["navbar-burger"], "aria-label": "menu-button", children: [
        /* @__PURE__ */ v("span", { "aria-hidden": "true" }),
        /* @__PURE__ */ v("span", { "aria-hidden": "true" }),
        /* @__PURE__ */ v("span", { "aria-hidden": "true" })
      ] }) }) : /* @__PURE__ */ T("button", { onClick: o, className: $e["navbar-burger"], "aria-label": "menu-button", children: [
        /* @__PURE__ */ v("span", { "aria-hidden": "true" }),
        /* @__PURE__ */ v("span", { "aria-hidden": "true" }),
        /* @__PURE__ */ v("span", { "aria-hidden": "true" })
      ] }) }),
      /* @__PURE__ */ v(TS, { isOpen: a, onClose: o, className: Oe($e["navbar-drawer"]), children: e })
    ] }),
    /* @__PURE__ */ v("li", { className: Oe($e["navbar-menu"]), children: /* @__PURE__ */ T("ul", { children: [
      /* @__PURE__ */ v("li", { children: /* @__PURE__ */ v("button", { className: $e["burger-close"], onClick: o, "aria-label": "burger-close", children: /* @__PURE__ */ v(Se, { name: "remove", size: "large" }) }) }),
      e
    ] }) })
  ] });
}, de = ({
  children: e,
  href: t,
  hideOn: a,
  isFirstOnMobile: o,
  isSecondOnMobile: n,
  noPaddingRight: r,
  largerPaddingBottom: i,
  noTopBottomPadding: s,
  onClick: l,
  marginAutoTop: c,
  isButton: u,
  backgroundOnHover: d = !0,
  isFlexGrow: h = !1
}) => {
  const p = Oe(
    c && $e["margin-auto-top"],
    o && $e["first-on-mobile"],
    n && $e["second-on-mobile"],
    r && $e["navbar-item-no-padding"],
    u && $e["navbar-item-button"],
    s && $e["navbar-item-no-padding-top-bottom"],
    i && $e["navbar-item-larger-padding-bottom"],
    d && $e["navbar-item-background-hover"],
    h && $e["navbar-item-flex-grow"]
  ), f = t ? /* @__PURE__ */ v(ki, { onClick: l, className: Oe($e["navbar-item-wrapper"], p), children: /* @__PURE__ */ v(w0, { className: Oe($e["navbar-item"], p), href: t, children: e }) }) : /* @__PURE__ */ v(ki, { onClick: l, className: Oe($e["navbar-item"], p), children: e });
  return a ? /* @__PURE__ */ v(Ko, { hideOn: a, className: Oe($e["navbar-item-wrapper"], p), children: f }) : f;
}, xb = ({ children: e, position: t }) => {
  const a = Oe(t && $e[`navbar-${t}`]);
  return /* @__PURE__ */ v("li", { className: a, children: /* @__PURE__ */ v("ul", { className: a, children: e }) });
}, $u = ({ children: e, hideOn: t }) => {
  const a = Oe($e["navbar-has-dropdown"], $e["navbar-item-wrapper"]);
  return t ? /* @__PURE__ */ v(Ko, { hideOn: t, className: $e["navbar-item-wrapper"], children: /* @__PURE__ */ v(ki, { className: a, children: e }) }) : /* @__PURE__ */ v(ki, { className: a, children: e });
}, Su = ({ children: e }) => /* @__PURE__ */ v(y0, { className: $e["navbar-item"], children: /* @__PURE__ */ T(ue, { gap: "2", alignItems: "center", isFullWidth: !0, justifyContent: "space-between", children: [
  e,
  /* @__PURE__ */ v(Se, { name: "up-arrow", size: "small", className: $e.arrow })
] }) }), Cu = ({ children: e, size: t, align: a = "right" }) => {
  const o = Oe(
    $e["navbar-dropdown"],
    $e[`is-${a}`],
    $e["navbar-item"],
    t && $e[`is-size-${t}`]
  );
  return /* @__PURE__ */ v(k0, { className: o, children: /* @__PURE__ */ v("ul", { children: e }) });
}, _g = {
  "unset-list": "_unset-list_50wvn_29",
  "navbar-brand": "_navbar-brand_50wvn_38"
}, $b = ({ children: e }) => /* @__PURE__ */ v("li", { className: _g["unset-list"], children: /* @__PURE__ */ v("ul", { className: _g["navbar-brand"], children: e }) }), il = {
  "unset-list": "_unset-list_g6gr1_29",
  "navbar-divider": "_navbar-divider_g6gr1_35"
}, To = ({ hideOn: e }) => {
  const t = Oe(il["navbar-divider"]);
  return e ? /* @__PURE__ */ v(Ko, { hideOn: e, children: /* @__PURE__ */ v("li", { className: il["unset-list"], children: /* @__PURE__ */ v("hr", { className: t }) }) }) : /* @__PURE__ */ v("li", { className: il["unset-list"], children: /* @__PURE__ */ v("hr", { className: t }) });
}, S0 = {
  "dropdown-divider": "_dropdown-divider_6mcrd_29"
}, Et = () => /* @__PURE__ */ v("hr", { className: Oe(S0["dropdown-divider"]) }), C0 = "_avatar_1ikzc_29", vg = {
  avatar: C0,
  "is-xsmall": "_is-xsmall_1ikzc_32",
  "is-small": "_is-small_1ikzc_36",
  "is-medium": "_is-medium_1ikzc_40",
  "is-large": "_is-large_1ikzc_44",
  "dialog-overlay-show": "_dialog-overlay-show_1ikzc_1",
  "dialog-content-show": "_dialog-content-show_1ikzc_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ikzc_1"
};
function Sb({ url: e, alt: t, size: a = "medium", className: o, ...n }) {
  const r = Oe(vg.avatar, a && vg[`is-${a}`], o);
  return /* @__PURE__ */ v("img", { className: r, src: e, alt: t, ...n });
}
const yg = {
  "communication-banner": "_communication-banner_2kn0i_1"
};
function E0({ text: e, url: t }) {
  return /* @__PURE__ */ v("a", { href: t, children: /* @__PURE__ */ T("div", { className: yg["communication-banner"], children: [
    /* @__PURE__ */ v("p", { children: e }),
    /* @__PURE__ */ v(Se, { size: "2xl", name: "angle-right", className: yg.icon })
  ] }) });
}
function Cb(e) {
  var t, a, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (a = Cb(e[t])) && (o && (o += " "), o += a);
  } else for (a in e) e[a] && (o && (o += " "), o += a);
  return o;
}
function z0() {
  for (var e, t, a = 0, o = "", n = arguments.length; a < n; a++) (e = arguments[a]) && (t = Cb(e)) && (o && (o += " "), o += t);
  return o;
}
const j0 = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], A0 = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, O0 = j0.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: A0[e]
})), P0 = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, D0 = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function N0(e = 0) {
  const t = [];
  for (let a = 0; a < e; a++)
    t[a] = `path${a + 1}`;
  return t.map((a) => /* @__PURE__ */ v("span", { className: a }, a));
}
const R0 = pt(
  ({ name: e, size: t = "medium", color: a = "base", className: o = "", ...n }, r) => {
    const i = O0.find((l) => l.name === e), s = z0("icon", `ds-${i?.class}`, D0[t], P0[a], o);
    return /* @__PURE__ */ v("i", { className: s, ...n, ref: r, children: N0(i?.paths) });
  }
);
R0.displayName = "Icon";
const I0 = ["en", "fr", "it"], Eb = jt({
  locale: "en"
});
function zb({ children: e, ...t }) {
  return /* @__PURE__ */ v(Eb.Provider, { value: t, children: e });
}
const T0 = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_+.~#?&/=]*)$/;
function M0(e) {
  return I0.includes(e) && !0;
}
function L0(e, t) {
  const a = T0.test(t);
  let o;
  return M0(e) || a ? o = `${t}` : o = `/${e}${t}`, { url: o };
}
function je(e) {
  const { locale: t } = ho(Eb);
  return L0(t, e);
}
let wg = class extends Error {
  code;
  errorData;
  constructor(t, a, o) {
    super(t), this.name = "HeError", this.code = a, this.errorData = o;
  }
};
function jb(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: W0 } = Object.prototype, { getPrototypeOf: Eu } = Object, { iterator: gs, toStringTag: Ab } = Symbol, hs = /* @__PURE__ */ ((e) => (t) => {
  const a = W0.call(t);
  return e[a] || (e[a] = a.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Wt = (e) => (e = e.toLowerCase(), (t) => hs(t) === e), ms = (e) => (t) => typeof t === e, { isArray: on } = Array, Zo = ms("undefined");
function Yn(e) {
  return e !== null && !Zo(e) && e.constructor !== null && !Zo(e.constructor) && dt(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Ob = Wt("ArrayBuffer");
function B0(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Ob(e.buffer), t;
}
const F0 = ms("string"), dt = ms("function"), Pb = ms("number"), Xn = (e) => e !== null && typeof e == "object", V0 = (e) => e === !0 || e === !1, Xr = (e) => {
  if (hs(e) !== "object")
    return !1;
  const t = Eu(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Ab in e) && !(gs in e);
}, U0 = (e) => {
  if (!Xn(e) || Yn(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, q0 = Wt("Date"), H0 = Wt("File"), G0 = Wt("Blob"), K0 = Wt("FileList"), J0 = (e) => Xn(e) && dt(e.pipe), Z0 = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || dt(e.append) && ((t = hs(e)) === "formdata" || // detect form-data instance
  t === "object" && dt(e.toString) && e.toString() === "[object FormData]"));
}, Y0 = Wt("URLSearchParams"), [X0, Q0, eC, tC] = ["ReadableStream", "Request", "Response", "Headers"].map(Wt), aC = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function Qn(e, t, { allOwnKeys: a = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let o, n;
  if (typeof e != "object" && (e = [e]), on(e))
    for (o = 0, n = e.length; o < n; o++)
      t.call(null, e[o], o, e);
  else {
    if (Yn(e))
      return;
    const r = a ? Object.getOwnPropertyNames(e) : Object.keys(e), i = r.length;
    let s;
    for (o = 0; o < i; o++)
      s = r[o], t.call(null, e[s], s, e);
  }
}
function Db(e, t) {
  if (Yn(e))
    return null;
  t = t.toLowerCase();
  const a = Object.keys(e);
  let o = a.length, n;
  for (; o-- > 0; )
    if (n = a[o], t === n.toLowerCase())
      return n;
  return null;
}
const Ha = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Nb = (e) => !Zo(e) && e !== Ha;
function cc() {
  const { caseless: e, skipUndefined: t } = Nb(this) && this || {}, a = {}, o = (n, r) => {
    const i = e && Db(a, r) || r;
    Xr(a[i]) && Xr(n) ? a[i] = cc(a[i], n) : Xr(n) ? a[i] = cc({}, n) : on(n) ? a[i] = n.slice() : (!t || !Zo(n)) && (a[i] = n);
  };
  for (let n = 0, r = arguments.length; n < r; n++)
    arguments[n] && Qn(arguments[n], o);
  return a;
}
const oC = (e, t, a, { allOwnKeys: o } = {}) => (Qn(t, (n, r) => {
  a && dt(n) ? e[r] = jb(n, a) : e[r] = n;
}, { allOwnKeys: o }), e), nC = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), rC = (e, t, a, o) => {
  e.prototype = Object.create(t.prototype, o), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), a && Object.assign(e.prototype, a);
}, iC = (e, t, a, o) => {
  let n, r, i;
  const s = {};
  if (t = t || {}, e == null) return t;
  do {
    for (n = Object.getOwnPropertyNames(e), r = n.length; r-- > 0; )
      i = n[r], (!o || o(i, e, t)) && !s[i] && (t[i] = e[i], s[i] = !0);
    e = a !== !1 && Eu(e);
  } while (e && (!a || a(e, t)) && e !== Object.prototype);
  return t;
}, sC = (e, t, a) => {
  e = String(e), (a === void 0 || a > e.length) && (a = e.length), a -= t.length;
  const o = e.indexOf(t, a);
  return o !== -1 && o === a;
}, lC = (e) => {
  if (!e) return null;
  if (on(e)) return e;
  let t = e.length;
  if (!Pb(t)) return null;
  const a = new Array(t);
  for (; t-- > 0; )
    a[t] = e[t];
  return a;
}, cC = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && Eu(Uint8Array)), uC = (e, t) => {
  const a = (e && e[gs]).call(e);
  let o;
  for (; (o = a.next()) && !o.done; ) {
    const n = o.value;
    t.call(e, n[0], n[1]);
  }
}, dC = (e, t) => {
  let a;
  const o = [];
  for (; (a = e.exec(t)) !== null; )
    o.push(a);
  return o;
}, gC = Wt("HTMLFormElement"), hC = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, a, o) {
    return a.toUpperCase() + o;
  }
), kg = (({ hasOwnProperty: e }) => (t, a) => e.call(t, a))(Object.prototype), mC = Wt("RegExp"), Rb = (e, t) => {
  const a = Object.getOwnPropertyDescriptors(e), o = {};
  Qn(a, (n, r) => {
    let i;
    (i = t(n, r, e)) !== !1 && (o[r] = i || n);
  }), Object.defineProperties(e, o);
}, pC = (e) => {
  Rb(e, (t, a) => {
    if (dt(e) && ["arguments", "caller", "callee"].indexOf(a) !== -1)
      return !1;
    const o = e[a];
    if (dt(o)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + a + "'");
      });
    }
  });
}, fC = (e, t) => {
  const a = {}, o = (n) => {
    n.forEach((r) => {
      a[r] = !0;
    });
  };
  return on(e) ? o(e) : o(String(e).split(t)), a;
}, bC = () => {
}, _C = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function vC(e) {
  return !!(e && dt(e.append) && e[Ab] === "FormData" && e[gs]);
}
const yC = (e) => {
  const t = new Array(10), a = (o, n) => {
    if (Xn(o)) {
      if (t.indexOf(o) >= 0)
        return;
      if (Yn(o))
        return o;
      if (!("toJSON" in o)) {
        t[n] = o;
        const r = on(o) ? [] : {};
        return Qn(o, (i, s) => {
          const l = a(i, n + 1);
          !Zo(l) && (r[s] = l);
        }), t[n] = void 0, r;
      }
    }
    return o;
  };
  return a(e, 0);
}, wC = Wt("AsyncFunction"), kC = (e) => e && (Xn(e) || dt(e)) && dt(e.then) && dt(e.catch), Ib = ((e, t) => e ? setImmediate : t ? ((a, o) => (Ha.addEventListener("message", ({ source: n, data: r }) => {
  n === Ha && r === a && o.length && o.shift()();
}, !1), (n) => {
  o.push(n), Ha.postMessage(a, "*");
}))(`axios@${Math.random()}`, []) : (a) => setTimeout(a))(
  typeof setImmediate == "function",
  dt(Ha.postMessage)
), xC = typeof queueMicrotask < "u" ? queueMicrotask.bind(Ha) : typeof process < "u" && process.nextTick || Ib, $C = (e) => e != null && dt(e[gs]), P = {
  isArray: on,
  isArrayBuffer: Ob,
  isBuffer: Yn,
  isFormData: Z0,
  isArrayBufferView: B0,
  isString: F0,
  isNumber: Pb,
  isBoolean: V0,
  isObject: Xn,
  isPlainObject: Xr,
  isEmptyObject: U0,
  isReadableStream: X0,
  isRequest: Q0,
  isResponse: eC,
  isHeaders: tC,
  isUndefined: Zo,
  isDate: q0,
  isFile: H0,
  isBlob: G0,
  isRegExp: mC,
  isFunction: dt,
  isStream: J0,
  isURLSearchParams: Y0,
  isTypedArray: cC,
  isFileList: K0,
  forEach: Qn,
  merge: cc,
  extend: oC,
  trim: aC,
  stripBOM: nC,
  inherits: rC,
  toFlatObject: iC,
  kindOf: hs,
  kindOfTest: Wt,
  endsWith: sC,
  toArray: lC,
  forEachEntry: uC,
  matchAll: dC,
  isHTMLForm: gC,
  hasOwnProperty: kg,
  hasOwnProp: kg,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: Rb,
  freezeMethods: pC,
  toObjectSet: fC,
  toCamelCase: hC,
  noop: bC,
  toFiniteNumber: _C,
  findKey: Db,
  global: Ha,
  isContextDefined: Nb,
  isSpecCompliantForm: vC,
  toJSONObject: yC,
  isAsyncFn: wC,
  isThenable: kC,
  setImmediate: Ib,
  asap: xC,
  isIterable: $C
};
function ge(e, t, a, o, n) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), a && (this.config = a), o && (this.request = o), n && (this.response = n, this.status = n.status ? n.status : null);
}
P.inherits(ge, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: P.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const Tb = ge.prototype, Mb = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  Mb[e] = { value: e };
});
Object.defineProperties(ge, Mb);
Object.defineProperty(Tb, "isAxiosError", { value: !0 });
ge.from = (e, t, a, o, n, r) => {
  const i = Object.create(Tb);
  P.toFlatObject(e, i, function(c) {
    return c !== Error.prototype;
  }, (c) => c !== "isAxiosError");
  const s = e && e.message ? e.message : "Error", l = t == null && e ? e.code : t;
  return ge.call(i, s, l, a, o, n), e && i.cause == null && Object.defineProperty(i, "cause", { value: e, configurable: !0 }), i.name = e && e.name || "Error", r && Object.assign(i, r), i;
};
const SC = null;
function uc(e) {
  return P.isPlainObject(e) || P.isArray(e);
}
function Lb(e) {
  return P.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function xg(e, t, a) {
  return e ? e.concat(t).map(function(o, n) {
    return o = Lb(o), !a && n ? "[" + o + "]" : o;
  }).join(a ? "." : "") : t;
}
function CC(e) {
  return P.isArray(e) && !e.some(uc);
}
const EC = P.toFlatObject(P, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function ps(e, t, a) {
  if (!P.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), a = P.toFlatObject(a, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(p, f) {
    return !P.isUndefined(f[p]);
  });
  const o = a.metaTokens, n = a.visitor || c, r = a.dots, i = a.indexes, s = (a.Blob || typeof Blob < "u" && Blob) && P.isSpecCompliantForm(t);
  if (!P.isFunction(n))
    throw new TypeError("visitor must be a function");
  function l(p) {
    if (p === null) return "";
    if (P.isDate(p))
      return p.toISOString();
    if (P.isBoolean(p))
      return p.toString();
    if (!s && P.isBlob(p))
      throw new ge("Blob is not supported. Use a Buffer instead.");
    return P.isArrayBuffer(p) || P.isTypedArray(p) ? s && typeof Blob == "function" ? new Blob([p]) : Buffer.from(p) : p;
  }
  function c(p, f, m) {
    let b = p;
    if (p && !m && typeof p == "object") {
      if (P.endsWith(f, "{}"))
        f = o ? f : f.slice(0, -2), p = JSON.stringify(p);
      else if (P.isArray(p) && CC(p) || (P.isFileList(p) || P.endsWith(f, "[]")) && (b = P.toArray(p)))
        return f = Lb(f), b.forEach(function(w, _) {
          !(P.isUndefined(w) || w === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? xg([f], _, r) : i === null ? f : f + "[]",
            l(w)
          );
        }), !1;
    }
    return uc(p) ? !0 : (t.append(xg(m, f, r), l(p)), !1);
  }
  const u = [], d = Object.assign(EC, {
    defaultVisitor: c,
    convertValue: l,
    isVisitable: uc
  });
  function h(p, f) {
    if (!P.isUndefined(p)) {
      if (u.indexOf(p) !== -1)
        throw Error("Circular reference detected in " + f.join("."));
      u.push(p), P.forEach(p, function(m, b) {
        (!(P.isUndefined(m) || m === null) && n.call(
          t,
          m,
          P.isString(b) ? b.trim() : b,
          f,
          d
        )) === !0 && h(m, f ? f.concat(b) : [b]);
      }), u.pop();
    }
  }
  if (!P.isObject(e))
    throw new TypeError("data must be an object");
  return h(e), t;
}
function $g(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(a) {
    return t[a];
  });
}
function zu(e, t) {
  this._pairs = [], e && ps(e, this, t);
}
const Wb = zu.prototype;
Wb.append = function(e, t) {
  this._pairs.push([e, t]);
};
Wb.toString = function(e) {
  const t = e ? function(a) {
    return e.call(this, a, $g);
  } : $g;
  return this._pairs.map(function(a) {
    return t(a[0]) + "=" + t(a[1]);
  }, "").join("&");
};
function zC(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function Bb(e, t, a) {
  if (!t)
    return e;
  const o = a && a.encode || zC;
  P.isFunction(a) && (a = {
    serialize: a
  });
  const n = a && a.serialize;
  let r;
  if (n ? r = n(t, a) : r = P.isURLSearchParams(t) ? t.toString() : new zu(t, a).toString(o), r) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + r;
  }
  return e;
}
let Sg = class {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, a, o) {
    return this.handlers.push({
      fulfilled: t,
      rejected: a,
      synchronous: o ? o.synchronous : !1,
      runWhen: o ? o.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    P.forEach(this.handlers, function(a) {
      a !== null && t(a);
    });
  }
};
const Fb = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, jC = typeof URLSearchParams < "u" ? URLSearchParams : zu, AC = typeof FormData < "u" ? FormData : null, OC = typeof Blob < "u" ? Blob : null, PC = {
  isBrowser: !0,
  classes: {
    URLSearchParams: jC,
    FormData: AC,
    Blob: OC
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, ju = typeof window < "u" && typeof document < "u", dc = typeof navigator == "object" && navigator || void 0, DC = ju && (!dc || ["ReactNative", "NativeScript", "NS"].indexOf(dc.product) < 0), NC = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", RC = ju && window.location.href || "http://localhost", IC = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: ju,
  hasStandardBrowserEnv: DC,
  hasStandardBrowserWebWorkerEnv: NC,
  navigator: dc,
  origin: RC
}, Symbol.toStringTag, { value: "Module" })), tt = {
  ...IC,
  ...PC
};
function TC(e, t) {
  return ps(e, new tt.classes.URLSearchParams(), {
    visitor: function(a, o, n, r) {
      return tt.isNode && P.isBuffer(a) ? (this.append(o, a.toString("base64")), !1) : r.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function MC(e) {
  return P.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function LC(e) {
  const t = {}, a = Object.keys(e);
  let o;
  const n = a.length;
  let r;
  for (o = 0; o < n; o++)
    r = a[o], t[r] = e[r];
  return t;
}
function Vb(e) {
  function t(a, o, n, r) {
    let i = a[r++];
    if (i === "__proto__") return !0;
    const s = Number.isFinite(+i), l = r >= a.length;
    return i = !i && P.isArray(n) ? n.length : i, l ? (P.hasOwnProp(n, i) ? n[i] = [n[i], o] : n[i] = o, !s) : ((!n[i] || !P.isObject(n[i])) && (n[i] = []), t(a, o, n[i], r) && P.isArray(n[i]) && (n[i] = LC(n[i])), !s);
  }
  if (P.isFormData(e) && P.isFunction(e.entries)) {
    const a = {};
    return P.forEachEntry(e, (o, n) => {
      t(MC(o), n, a, 0);
    }), a;
  }
  return null;
}
function WC(e, t, a) {
  if (P.isString(e))
    try {
      return (t || JSON.parse)(e), P.trim(e);
    } catch (o) {
      if (o.name !== "SyntaxError")
        throw o;
    }
  return (a || JSON.stringify)(e);
}
const er = {
  transitional: Fb,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const a = t.getContentType() || "", o = a.indexOf("application/json") > -1, n = P.isObject(e);
    if (n && P.isHTMLForm(e) && (e = new FormData(e)), P.isFormData(e))
      return o ? JSON.stringify(Vb(e)) : e;
    if (P.isArrayBuffer(e) || P.isBuffer(e) || P.isStream(e) || P.isFile(e) || P.isBlob(e) || P.isReadableStream(e))
      return e;
    if (P.isArrayBufferView(e))
      return e.buffer;
    if (P.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let r;
    if (n) {
      if (a.indexOf("application/x-www-form-urlencoded") > -1)
        return TC(e, this.formSerializer).toString();
      if ((r = P.isFileList(e)) || a.indexOf("multipart/form-data") > -1) {
        const i = this.env && this.env.FormData;
        return ps(
          r ? { "files[]": e } : e,
          i && new i(),
          this.formSerializer
        );
      }
    }
    return n || o ? (t.setContentType("application/json", !1), WC(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || er.transitional, a = t && t.forcedJSONParsing, o = this.responseType === "json";
    if (P.isResponse(e) || P.isReadableStream(e))
      return e;
    if (e && P.isString(e) && (a && !this.responseType || o)) {
      const n = !(t && t.silentJSONParsing) && o;
      try {
        return JSON.parse(e, this.parseReviver);
      } catch (r) {
        if (n)
          throw r.name === "SyntaxError" ? ge.from(r, ge.ERR_BAD_RESPONSE, this, null, this.response) : r;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: tt.classes.FormData,
    Blob: tt.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
P.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  er.headers[e] = {};
});
const BC = P.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), FC = (e) => {
  const t = {};
  let a, o, n;
  return e && e.split(`
`).forEach(function(r) {
    n = r.indexOf(":"), a = r.substring(0, n).trim().toLowerCase(), o = r.substring(n + 1).trim(), !(!a || t[a] && BC[a]) && (a === "set-cookie" ? t[a] ? t[a].push(o) : t[a] = [o] : t[a] = t[a] ? t[a] + ", " + o : o);
  }), t;
}, Cg = Symbol("internals");
function fn(e) {
  return e && String(e).trim().toLowerCase();
}
function Qr(e) {
  return e === !1 || e == null ? e : P.isArray(e) ? e.map(Qr) : String(e);
}
function VC(e) {
  const t = /* @__PURE__ */ Object.create(null), a = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let o;
  for (; o = a.exec(e); )
    t[o[1]] = o[2];
  return t;
}
const UC = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function sl(e, t, a, o, n) {
  if (P.isFunction(o))
    return o.call(this, t, a);
  if (n && (t = a), !!P.isString(t)) {
    if (P.isString(o))
      return t.indexOf(o) !== -1;
    if (P.isRegExp(o))
      return o.test(t);
  }
}
function qC(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, a, o) => a.toUpperCase() + o);
}
function HC(e, t) {
  const a = P.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((o) => {
    Object.defineProperty(e, o + a, {
      value: function(n, r, i) {
        return this[o].call(this, t, n, r, i);
      },
      configurable: !0
    });
  });
}
let gt = class {
  constructor(t) {
    t && this.set(t);
  }
  set(t, a, o) {
    const n = this;
    function r(s, l, c) {
      const u = fn(l);
      if (!u)
        throw new Error("header name must be a non-empty string");
      const d = P.findKey(n, u);
      (!d || n[d] === void 0 || c === !0 || c === void 0 && n[d] !== !1) && (n[d || l] = Qr(s));
    }
    const i = (s, l) => P.forEach(s, (c, u) => r(c, u, l));
    if (P.isPlainObject(t) || t instanceof this.constructor)
      i(t, a);
    else if (P.isString(t) && (t = t.trim()) && !UC(t))
      i(FC(t), a);
    else if (P.isObject(t) && P.isIterable(t)) {
      let s = {}, l, c;
      for (const u of t) {
        if (!P.isArray(u))
          throw TypeError("Object iterator must return a key-value pair");
        s[c = u[0]] = (l = s[c]) ? P.isArray(l) ? [...l, u[1]] : [l, u[1]] : u[1];
      }
      i(s, a);
    } else
      t != null && r(a, t, o);
    return this;
  }
  get(t, a) {
    if (t = fn(t), t) {
      const o = P.findKey(this, t);
      if (o) {
        const n = this[o];
        if (!a)
          return n;
        if (a === !0)
          return VC(n);
        if (P.isFunction(a))
          return a.call(this, n, o);
        if (P.isRegExp(a))
          return a.exec(n);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(t, a) {
    if (t = fn(t), t) {
      const o = P.findKey(this, t);
      return !!(o && this[o] !== void 0 && (!a || sl(this, this[o], o, a)));
    }
    return !1;
  }
  delete(t, a) {
    const o = this;
    let n = !1;
    function r(i) {
      if (i = fn(i), i) {
        const s = P.findKey(o, i);
        s && (!a || sl(o, o[s], s, a)) && (delete o[s], n = !0);
      }
    }
    return P.isArray(t) ? t.forEach(r) : r(t), n;
  }
  clear(t) {
    const a = Object.keys(this);
    let o = a.length, n = !1;
    for (; o--; ) {
      const r = a[o];
      (!t || sl(this, this[r], r, t, !0)) && (delete this[r], n = !0);
    }
    return n;
  }
  normalize(t) {
    const a = this, o = {};
    return P.forEach(this, (n, r) => {
      const i = P.findKey(o, r);
      if (i) {
        a[i] = Qr(n), delete a[r];
        return;
      }
      const s = t ? qC(r) : String(r).trim();
      s !== r && delete a[r], a[s] = Qr(n), o[s] = !0;
    }), this;
  }
  concat(...t) {
    return this.constructor.concat(this, ...t);
  }
  toJSON(t) {
    const a = /* @__PURE__ */ Object.create(null);
    return P.forEach(this, (o, n) => {
      o != null && o !== !1 && (a[n] = t && P.isArray(o) ? o.join(", ") : o);
    }), a;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([t, a]) => t + ": " + a).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(t) {
    return t instanceof this ? t : new this(t);
  }
  static concat(t, ...a) {
    const o = new this(t);
    return a.forEach((n) => o.set(n)), o;
  }
  static accessor(t) {
    const a = (this[Cg] = this[Cg] = {
      accessors: {}
    }).accessors, o = this.prototype;
    function n(r) {
      const i = fn(r);
      a[i] || (HC(o, r), a[i] = !0);
    }
    return P.isArray(t) ? t.forEach(n) : n(t), this;
  }
};
gt.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
P.reduceDescriptors(gt.prototype, ({ value: e }, t) => {
  let a = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(o) {
      this[a] = o;
    }
  };
});
P.freezeMethods(gt);
function ll(e, t) {
  const a = this || er, o = t || a, n = gt.from(o.headers);
  let r = o.data;
  return P.forEach(e, function(i) {
    r = i.call(a, r, n.normalize(), t ? t.status : void 0);
  }), n.normalize(), r;
}
function Ub(e) {
  return !!(e && e.__CANCEL__);
}
function nn(e, t, a) {
  ge.call(this, e ?? "canceled", ge.ERR_CANCELED, t, a), this.name = "CanceledError";
}
P.inherits(nn, ge, {
  __CANCEL__: !0
});
function qb(e, t, a) {
  const o = a.config.validateStatus;
  !a.status || !o || o(a.status) ? e(a) : t(new ge(
    "Request failed with status code " + a.status,
    [ge.ERR_BAD_REQUEST, ge.ERR_BAD_RESPONSE][Math.floor(a.status / 100) - 4],
    a.config,
    a.request,
    a
  ));
}
function GC(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function KC(e, t) {
  e = e || 10;
  const a = new Array(e), o = new Array(e);
  let n = 0, r = 0, i;
  return t = t !== void 0 ? t : 1e3, function(s) {
    const l = Date.now(), c = o[r];
    i || (i = l), a[n] = s, o[n] = l;
    let u = r, d = 0;
    for (; u !== n; )
      d += a[u++], u = u % e;
    if (n = (n + 1) % e, n === r && (r = (r + 1) % e), l - i < t)
      return;
    const h = c && l - c;
    return h ? Math.round(d * 1e3 / h) : void 0;
  };
}
function JC(e, t) {
  let a = 0, o = 1e3 / t, n, r;
  const i = (s, l = Date.now()) => {
    a = l, n = null, r && (clearTimeout(r), r = null), e(...s);
  };
  return [(...s) => {
    const l = Date.now(), c = l - a;
    c >= o ? i(s, l) : (n = s, r || (r = setTimeout(() => {
      r = null, i(n);
    }, o - c)));
  }, () => n && i(n)];
}
const xi = (e, t, a = 3) => {
  let o = 0;
  const n = KC(50, 250);
  return JC((r) => {
    const i = r.loaded, s = r.lengthComputable ? r.total : void 0, l = i - o, c = n(l), u = i <= s;
    o = i;
    const d = {
      loaded: i,
      total: s,
      progress: s ? i / s : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && s && u ? (s - i) / c : void 0,
      event: r,
      lengthComputable: s != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, a);
}, Eg = (e, t) => {
  const a = e != null;
  return [(o) => t[0]({
    lengthComputable: a,
    total: e,
    loaded: o
  }), t[1]];
}, zg = (e) => (...t) => P.asap(() => e(...t)), ZC = tt.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (a) => (a = new URL(a, tt.origin), e.protocol === a.protocol && e.host === a.host && (t || e.port === a.port)))(
  new URL(tt.origin),
  tt.navigator && /(msie|trident)/i.test(tt.navigator.userAgent)
) : () => !0, YC = tt.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, a, o, n, r) {
      const i = [e + "=" + encodeURIComponent(t)];
      P.isNumber(a) && i.push("expires=" + new Date(a).toGMTString()), P.isString(o) && i.push("path=" + o), P.isString(n) && i.push("domain=" + n), r === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function XC(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function QC(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function Hb(e, t, a) {
  let o = !XC(t);
  return e && (o || a == !1) ? QC(e, t) : t;
}
const jg = (e) => e instanceof gt ? { ...e } : e;
function to(e, t) {
  t = t || {};
  const a = {};
  function o(c, u, d, h) {
    return P.isPlainObject(c) && P.isPlainObject(u) ? P.merge.call({ caseless: h }, c, u) : P.isPlainObject(u) ? P.merge({}, u) : P.isArray(u) ? u.slice() : u;
  }
  function n(c, u, d, h) {
    if (P.isUndefined(u)) {
      if (!P.isUndefined(c))
        return o(void 0, c, d, h);
    } else return o(c, u, d, h);
  }
  function r(c, u) {
    if (!P.isUndefined(u))
      return o(void 0, u);
  }
  function i(c, u) {
    if (P.isUndefined(u)) {
      if (!P.isUndefined(c))
        return o(void 0, c);
    } else return o(void 0, u);
  }
  function s(c, u, d) {
    if (d in t)
      return o(c, u);
    if (d in e)
      return o(void 0, c);
  }
  const l = {
    url: r,
    method: r,
    data: r,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: s,
    headers: (c, u, d) => n(jg(c), jg(u), d, !0)
  };
  return P.forEach(Object.keys({ ...e, ...t }), function(c) {
    const u = l[c] || n, d = u(e[c], t[c], c);
    P.isUndefined(d) && u !== s || (a[c] = d);
  }), a;
}
const Gb = (e) => {
  const t = to({}, e);
  let { data: a, withXSRFToken: o, xsrfHeaderName: n, xsrfCookieName: r, headers: i, auth: s } = t;
  if (t.headers = i = gt.from(i), t.url = Bb(Hb(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), s && i.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  ), P.isFormData(a)) {
    if (tt.hasStandardBrowserEnv || tt.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if (P.isFunction(a.getHeaders)) {
      const l = a.getHeaders(), c = ["content-type", "content-length"];
      Object.entries(l).forEach(([u, d]) => {
        c.includes(u.toLowerCase()) && i.set(u, d);
      });
    }
  }
  if (tt.hasStandardBrowserEnv && (o && P.isFunction(o) && (o = o(t)), o || o !== !1 && ZC(t.url))) {
    const l = n && r && YC.read(r);
    l && i.set(n, l);
  }
  return t;
}, eE = typeof XMLHttpRequest < "u", tE = eE && function(e) {
  return new Promise(function(t, a) {
    const o = Gb(e);
    let n = o.data;
    const r = gt.from(o.headers).normalize();
    let { responseType: i, onUploadProgress: s, onDownloadProgress: l } = o, c, u, d, h, p;
    function f() {
      h && h(), p && p(), o.cancelToken && o.cancelToken.unsubscribe(c), o.signal && o.signal.removeEventListener("abort", c);
    }
    let m = new XMLHttpRequest();
    m.open(o.method.toUpperCase(), o.url, !0), m.timeout = o.timeout;
    function b() {
      if (!m)
        return;
      const _ = gt.from(
        "getAllResponseHeaders" in m && m.getAllResponseHeaders()
      ), y = {
        data: !i || i === "text" || i === "json" ? m.responseText : m.response,
        status: m.status,
        statusText: m.statusText,
        headers: _,
        config: e,
        request: m
      };
      qb(function(k) {
        t(k), f();
      }, function(k) {
        a(k), f();
      }, y), m = null;
    }
    "onloadend" in m ? m.onloadend = b : m.onreadystatechange = function() {
      !m || m.readyState !== 4 || m.status === 0 && !(m.responseURL && m.responseURL.indexOf("file:") === 0) || setTimeout(b);
    }, m.onabort = function() {
      m && (a(new ge("Request aborted", ge.ECONNABORTED, e, m)), m = null);
    }, m.onerror = function(_) {
      const y = _ && _.message ? _.message : "Network Error", k = new ge(y, ge.ERR_NETWORK, e, m);
      k.event = _ || null, a(k), m = null;
    }, m.ontimeout = function() {
      let _ = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const y = o.transitional || Fb;
      o.timeoutErrorMessage && (_ = o.timeoutErrorMessage), a(new ge(
        _,
        y.clarifyTimeoutError ? ge.ETIMEDOUT : ge.ECONNABORTED,
        e,
        m
      )), m = null;
    }, n === void 0 && r.setContentType(null), "setRequestHeader" in m && P.forEach(r.toJSON(), function(_, y) {
      m.setRequestHeader(y, _);
    }), P.isUndefined(o.withCredentials) || (m.withCredentials = !!o.withCredentials), i && i !== "json" && (m.responseType = o.responseType), l && ([d, p] = xi(l, !0), m.addEventListener("progress", d)), s && m.upload && ([u, h] = xi(s), m.upload.addEventListener("progress", u), m.upload.addEventListener("loadend", h)), (o.cancelToken || o.signal) && (c = (_) => {
      m && (a(!_ || _.type ? new nn(null, e, m) : _), m.abort(), m = null);
    }, o.cancelToken && o.cancelToken.subscribe(c), o.signal && (o.signal.aborted ? c() : o.signal.addEventListener("abort", c)));
    const w = GC(o.url);
    if (w && tt.protocols.indexOf(w) === -1) {
      a(new ge("Unsupported protocol " + w + ":", ge.ERR_BAD_REQUEST, e));
      return;
    }
    m.send(n || null);
  });
}, aE = (e, t) => {
  const { length: a } = e = e ? e.filter(Boolean) : [];
  if (t || a) {
    let o = new AbortController(), n;
    const r = function(c) {
      if (!n) {
        n = !0, s();
        const u = c instanceof Error ? c : this.reason;
        o.abort(u instanceof ge ? u : new nn(u instanceof Error ? u.message : u));
      }
    };
    let i = t && setTimeout(() => {
      i = null, r(new ge(`timeout ${t} of ms exceeded`, ge.ETIMEDOUT));
    }, t);
    const s = () => {
      e && (i && clearTimeout(i), i = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(r) : c.removeEventListener("abort", r);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", r));
    const { signal: l } = o;
    return l.unsubscribe = () => P.asap(s), l;
  }
}, oE = function* (e, t) {
  let a = e.byteLength;
  if (a < t) {
    yield e;
    return;
  }
  let o = 0, n;
  for (; o < a; )
    n = o + t, yield e.slice(o, n), o = n;
}, nE = async function* (e, t) {
  for await (const a of rE(e))
    yield* oE(a, t);
}, rE = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: a, value: o } = await t.read();
      if (a)
        break;
      yield o;
    }
  } finally {
    await t.cancel();
  }
}, Ag = (e, t, a, o) => {
  const n = nE(e, t);
  let r = 0, i, s = (l) => {
    i || (i = !0, o && o(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: c, value: u } = await n.next();
        if (c) {
          s(), l.close();
          return;
        }
        let d = u.byteLength;
        if (a) {
          let h = r += d;
          a(h);
        }
        l.enqueue(new Uint8Array(u));
      } catch (c) {
        throw s(c), c;
      }
    },
    cancel(l) {
      return s(l), n.return();
    }
  }, {
    highWaterMark: 2
  });
}, Og = 64 * 1024, { isFunction: vr } = P, iE = (({ Request: e, Response: t }) => ({
  Request: e,
  Response: t
}))(P.global), {
  ReadableStream: Pg,
  TextEncoder: Dg
} = P.global, Ng = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, sE = (e) => {
  e = P.merge.call({
    skipUndefined: !0
  }, iE, e);
  const { fetch: t, Request: a, Response: o } = e, n = t ? vr(t) : typeof fetch == "function", r = vr(a), i = vr(o);
  if (!n)
    return !1;
  const s = n && vr(Pg), l = n && (typeof Dg == "function" ? /* @__PURE__ */ ((f) => (m) => f.encode(m))(new Dg()) : async (f) => new Uint8Array(await new a(f).arrayBuffer())), c = r && s && Ng(() => {
    let f = !1;
    const m = new a(tt.origin, {
      body: new Pg(),
      method: "POST",
      get duplex() {
        return f = !0, "half";
      }
    }).headers.has("Content-Type");
    return f && !m;
  }), u = i && s && Ng(() => P.isReadableStream(new o("").body)), d = {
    stream: u && ((f) => f.body)
  };
  n && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((f) => {
    !d[f] && (d[f] = (m, b) => {
      let w = m && m[f];
      if (w)
        return w.call(m);
      throw new ge(`Response type '${f}' is not supported`, ge.ERR_NOT_SUPPORT, b);
    });
  });
  const h = async (f) => {
    if (f == null)
      return 0;
    if (P.isBlob(f))
      return f.size;
    if (P.isSpecCompliantForm(f))
      return (await new a(tt.origin, {
        method: "POST",
        body: f
      }).arrayBuffer()).byteLength;
    if (P.isArrayBufferView(f) || P.isArrayBuffer(f))
      return f.byteLength;
    if (P.isURLSearchParams(f) && (f = f + ""), P.isString(f))
      return (await l(f)).byteLength;
  }, p = async (f, m) => P.toFiniteNumber(f.getContentLength()) ?? h(m);
  return async (f) => {
    let {
      url: m,
      method: b,
      data: w,
      signal: _,
      cancelToken: y,
      timeout: k,
      onDownloadProgress: x,
      onUploadProgress: S,
      responseType: $,
      headers: E,
      withCredentials: C = "same-origin",
      fetchOptions: z
    } = Gb(f), R = t || fetch;
    $ = $ ? ($ + "").toLowerCase() : "text";
    let H = aE([_, y && y.toAbortSignal()], k), M = null;
    const j = H && H.unsubscribe && (() => {
      H.unsubscribe();
    });
    let U;
    try {
      if (S && c && b !== "get" && b !== "head" && (U = await p(E, w)) !== 0) {
        let A = new a(m, {
          method: "POST",
          body: w,
          duplex: "half"
        }), N;
        if (P.isFormData(w) && (N = A.headers.get("content-type")) && E.setContentType(N), A.body) {
          const [B, W] = Eg(
            U,
            xi(zg(S))
          );
          w = Ag(A.body, Og, B, W);
        }
      }
      P.isString(C) || (C = C ? "include" : "omit");
      const I = r && "credentials" in a.prototype, K = {
        ...z,
        signal: H,
        method: b.toUpperCase(),
        headers: E.normalize().toJSON(),
        body: w,
        duplex: "half",
        credentials: I ? C : void 0
      };
      M = r && new a(m, K);
      let q = await (r ? R(M, z) : R(m, K));
      const te = u && ($ === "stream" || $ === "response");
      if (u && (x || te && j)) {
        const A = {};
        ["status", "statusText", "headers"].forEach((Z) => {
          A[Z] = q[Z];
        });
        const N = P.toFiniteNumber(q.headers.get("content-length")), [B, W] = x && Eg(
          N,
          xi(zg(x), !0)
        ) || [];
        q = new o(
          Ag(q.body, Og, B, () => {
            W && W(), j && j();
          }),
          A
        );
      }
      $ = $ || "text";
      let O = await d[P.findKey(d, $) || "text"](q, f);
      return !te && j && j(), await new Promise((A, N) => {
        qb(A, N, {
          data: O,
          headers: gt.from(q.headers),
          status: q.status,
          statusText: q.statusText,
          config: f,
          request: M
        });
      });
    } catch (I) {
      throw j && j(), I && I.name === "TypeError" && /Load failed|fetch/i.test(I.message) ? Object.assign(
        new ge("Network Error", ge.ERR_NETWORK, f, M),
        {
          cause: I.cause || I
        }
      ) : ge.from(I, I && I.code, f, M);
    }
  };
}, lE = /* @__PURE__ */ new Map(), Kb = (e) => {
  let t = e ? e.env : {};
  const { fetch: a, Request: o, Response: n } = t, r = [
    o,
    n,
    a
  ];
  let i = r.length, s = i, l, c, u = lE;
  for (; s--; )
    l = r[s], c = u.get(l), c === void 0 && u.set(l, c = s ? /* @__PURE__ */ new Map() : sE(t)), u = c;
  return c;
};
Kb();
const gc = {
  http: SC,
  xhr: tE,
  fetch: {
    get: Kb
  }
};
P.forEach(gc, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Rg = (e) => `- ${e}`, cE = (e) => P.isFunction(e) || e === null || e === !1, Jb = {
  getAdapter: (e, t) => {
    e = P.isArray(e) ? e : [e];
    const { length: a } = e;
    let o, n;
    const r = {};
    for (let i = 0; i < a; i++) {
      o = e[i];
      let s;
      if (n = o, !cE(o) && (n = gc[(s = String(o)).toLowerCase()], n === void 0))
        throw new ge(`Unknown adapter '${s}'`);
      if (n && (P.isFunction(n) || (n = n.get(t))))
        break;
      r[s || "#" + i] = n;
    }
    if (!n) {
      const i = Object.entries(r).map(
        ([l, c]) => `adapter ${l} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let s = a ? i.length > 1 ? `since :
` + i.map(Rg).join(`
`) : " " + Rg(i[0]) : "as no adapter specified";
      throw new ge(
        "There is no suitable adapter to dispatch the request " + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: gc
};
function cl(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new nn(null, e);
}
function Ig(e) {
  return cl(e), e.headers = gt.from(e.headers), e.data = ll.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), Jb.getAdapter(e.adapter || er.adapter, e)(e).then(function(t) {
    return cl(e), t.data = ll.call(
      e,
      e.transformResponse,
      t
    ), t.headers = gt.from(t.headers), t;
  }, function(t) {
    return Ub(t) || (cl(e), t && t.response && (t.response.data = ll.call(
      e,
      e.transformResponse,
      t.response
    ), t.response.headers = gt.from(t.response.headers))), Promise.reject(t);
  });
}
const Zb = "1.12.2", fs = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  fs[e] = function(a) {
    return typeof a === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Tg = {};
fs.transitional = function(e, t, a) {
  function o(n, r) {
    return "[Axios v" + Zb + "] Transitional option '" + n + "'" + r + (a ? ". " + a : "");
  }
  return (n, r, i) => {
    if (e === !1)
      throw new ge(
        o(r, " has been removed" + (t ? " in " + t : "")),
        ge.ERR_DEPRECATED
      );
    return t && !Tg[r] && (Tg[r] = !0, console.warn(
      o(
        r,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(n, r, i) : !0;
  };
};
fs.spelling = function(e) {
  return (t, a) => (console.warn(`${a} is likely a misspelling of ${e}`), !0);
};
function uE(e, t, a) {
  if (typeof e != "object")
    throw new ge("options must be an object", ge.ERR_BAD_OPTION_VALUE);
  const o = Object.keys(e);
  let n = o.length;
  for (; n-- > 0; ) {
    const r = o[n], i = t[r];
    if (i) {
      const s = e[r], l = s === void 0 || i(s, r, e);
      if (l !== !0)
        throw new ge("option " + r + " must be " + l, ge.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (a !== !0)
      throw new ge("Unknown option " + r, ge.ERR_BAD_OPTION);
  }
}
const ei = {
  assertOptions: uE,
  validators: fs
}, Ut = ei.validators;
let Xa = class {
  constructor(t) {
    this.defaults = t || {}, this.interceptors = {
      request: new Sg(),
      response: new Sg()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(t, a) {
    try {
      return await this._request(t, a);
    } catch (o) {
      if (o instanceof Error) {
        let n = {};
        Error.captureStackTrace ? Error.captureStackTrace(n) : n = new Error();
        const r = n.stack ? n.stack.replace(/^.+\n/, "") : "";
        try {
          o.stack ? r && !String(o.stack).endsWith(r.replace(/^.+\n.+\n/, "")) && (o.stack += `
` + r) : o.stack = r;
        } catch {
        }
      }
      throw o;
    }
  }
  _request(t, a) {
    typeof t == "string" ? (a = a || {}, a.url = t) : a = t || {}, a = to(this.defaults, a);
    const { transitional: o, paramsSerializer: n, headers: r } = a;
    o !== void 0 && ei.assertOptions(o, {
      silentJSONParsing: Ut.transitional(Ut.boolean),
      forcedJSONParsing: Ut.transitional(Ut.boolean),
      clarifyTimeoutError: Ut.transitional(Ut.boolean)
    }, !1), n != null && (P.isFunction(n) ? a.paramsSerializer = {
      serialize: n
    } : ei.assertOptions(n, {
      encode: Ut.function,
      serialize: Ut.function
    }, !0)), a.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? a.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : a.allowAbsoluteUrls = !0), ei.assertOptions(a, {
      baseUrl: Ut.spelling("baseURL"),
      withXsrfToken: Ut.spelling("withXSRFToken")
    }, !0), a.method = (a.method || this.defaults.method || "get").toLowerCase();
    let i = r && P.merge(
      r.common,
      r[a.method]
    );
    r && P.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (f) => {
        delete r[f];
      }
    ), a.headers = gt.concat(i, r);
    const s = [];
    let l = !0;
    this.interceptors.request.forEach(function(f) {
      typeof f.runWhen == "function" && f.runWhen(a) === !1 || (l = l && f.synchronous, s.unshift(f.fulfilled, f.rejected));
    });
    const c = [];
    this.interceptors.response.forEach(function(f) {
      c.push(f.fulfilled, f.rejected);
    });
    let u, d = 0, h;
    if (!l) {
      const f = [Ig.bind(this), void 0];
      for (f.unshift(...s), f.push(...c), h = f.length, u = Promise.resolve(a); d < h; )
        u = u.then(f[d++], f[d++]);
      return u;
    }
    h = s.length;
    let p = a;
    for (; d < h; ) {
      const f = s[d++], m = s[d++];
      try {
        p = f(p);
      } catch (b) {
        m.call(this, b);
        break;
      }
    }
    try {
      u = Ig.call(this, p);
    } catch (f) {
      return Promise.reject(f);
    }
    for (d = 0, h = c.length; d < h; )
      u = u.then(c[d++], c[d++]);
    return u;
  }
  getUri(t) {
    t = to(this.defaults, t);
    const a = Hb(t.baseURL, t.url, t.allowAbsoluteUrls);
    return Bb(a, t.params, t.paramsSerializer);
  }
};
P.forEach(["delete", "get", "head", "options"], function(e) {
  Xa.prototype[e] = function(t, a) {
    return this.request(to(a || {}, {
      method: e,
      url: t,
      data: (a || {}).data
    }));
  };
});
P.forEach(["post", "put", "patch"], function(e) {
  function t(a) {
    return function(o, n, r) {
      return this.request(to(r || {}, {
        method: e,
        headers: a ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: n
      }));
    };
  }
  Xa.prototype[e] = t(), Xa.prototype[e + "Form"] = t(!0);
});
let dE = class Yb {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let a;
    this.promise = new Promise(function(n) {
      a = n;
    });
    const o = this;
    this.promise.then((n) => {
      if (!o._listeners) return;
      let r = o._listeners.length;
      for (; r-- > 0; )
        o._listeners[r](n);
      o._listeners = null;
    }), this.promise.then = (n) => {
      let r;
      const i = new Promise((s) => {
        o.subscribe(s), r = s;
      }).then(n);
      return i.cancel = function() {
        o.unsubscribe(r);
      }, i;
    }, t(function(n, r, i) {
      o.reason || (o.reason = new nn(n, r, i), a(o.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const a = this._listeners.indexOf(t);
    a !== -1 && this._listeners.splice(a, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), a = (o) => {
      t.abort(o);
    };
    return this.subscribe(a), t.signal.unsubscribe = () => this.unsubscribe(a), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new Yb(function(a) {
        t = a;
      }),
      cancel: t
    };
  }
};
function gE(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function hE(e) {
  return P.isObject(e) && e.isAxiosError === !0;
}
const hc = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(hc).forEach(([e, t]) => {
  hc[t] = e;
});
function Xb(e) {
  const t = new Xa(e), a = jb(Xa.prototype.request, t);
  return P.extend(a, Xa.prototype, t, { allOwnKeys: !0 }), P.extend(a, t, null, { allOwnKeys: !0 }), a.create = function(o) {
    return Xb(to(e, o));
  }, a;
}
const Be = Xb(er);
Be.Axios = Xa;
Be.CanceledError = nn;
Be.CancelToken = dE;
Be.isCancel = Ub;
Be.VERSION = Zb;
Be.toFormData = ps;
Be.AxiosError = ge;
Be.Cancel = Be.CanceledError;
Be.all = function(e) {
  return Promise.all(e);
};
Be.spread = gE;
Be.isAxiosError = hE;
Be.mergeConfig = to;
Be.AxiosHeaders = gt;
Be.formToJSON = (e) => Vb(P.isHTMLForm(e) ? new FormData(e) : e);
Be.getAdapter = Jb.getAdapter;
Be.HttpStatusCode = hc;
Be.default = Be;
const {
  Axios: grt,
  AxiosError: mE,
  CanceledError: hrt,
  isCancel: mrt,
  CancelToken: prt,
  VERSION: frt,
  all: brt,
  Cancel: _rt,
  isAxiosError: vrt,
  spread: yrt,
  toFormData: wrt,
  AxiosHeaders: krt,
  HttpStatusCode: xrt,
  formToJSON: $rt,
  getAdapter: Srt,
  mergeConfig: Crt
} = Be, pE = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_,+.~#?&/=]*)$/;
let Qb = class {
  baseUrl;
  headers;
  constructor(t, a = {}) {
    this.baseUrl = t, this.headers = a?.headers || {};
  }
  async fetch(t, a = "GET", o = {}) {
    if (!this.baseUrl)
      throw new Error("No base URL set");
    const n = pE.test(t) ? t : `${this.baseUrl}${t}`;
    n.includes(this.baseUrl) && (o.withCredentials = !0);
    try {
      return (await Be(n, {
        ...o,
        method: a,
        data: o.data,
        headers: { ...this.headers, ...o.headers },
        withCredentials: o.withCredentials
      })).data;
    } catch (r) {
      throw r instanceof mE ? new wg(`${r.code} - ${r.status} - ${n}`, r.status, r.response?.data) : new wg("An error occured while fetching");
    }
  }
  getBaseUrl() {
    return this.baseUrl;
  }
  setBaseUrl(t) {
    this.baseUrl = t;
  }
  async get(t, a = {}) {
    return this.fetch(t, "GET", a);
  }
  async post(t, a = {}) {
    return this.fetch(t, "POST", {
      ...a,
      headers: {
        "Content-Type": "application/json",
        ...a.headers
      }
    });
  }
  async put(t, a = {}) {
    return this.fetch(t, "PUT", {
      ...a,
      headers: {
        "Content-Type": "application/json",
        ...a.headers
      }
    });
  }
  async delete(t, a = {}) {
    return this.fetch(t, "DELETE", a);
  }
  async patch(t, a = {}) {
    return this.fetch(t, "PATCH", {
      ...a,
      headers: {
        "Content-Type": "application/json",
        ...a.headers
      }
    });
  }
};
new Qb("", {});
function fE(e, t = {}) {
  if (!e) {
    console.warn("setSearchFetchConfig: URL is empty or undefined");
    return;
  }
  new Qb(e, t);
}
const bE = "ISSuiu5R48VFKdltBfogTgBSdaH68izqpiQ9C0WkBXS2Jg1lQSp02Hy5vVPCTgfT", _E = "https://api.jawg.io", vE = "dependency,neighbourhood,locality,borough,localadmin,county,macrocounty,region,macroregion,country,postalcode", yr = {
  "access-token": bE,
  layers: vE,
  sources: "wof",
  size: 10
};
async function yE(e, t, a) {
  const o = `${_E}/places/v1/autocomplete`;
  if (!o)
    throw new Error("JAWG_URL is not defined");
  const n = yr.size;
  let r = `${o}?text=${e}&access-token=${yr["access-token"]}&layers=${yr.layers}&sources=${yr.sources}&size=${n}`;
  t && (r += `&lang=${t}`);
  const i = await fetch(r, {
    headers: {
      "Accept-Language": t || "fr"
    }
  });
  if (!i.ok)
    throw new Error(`JAWG API error: ${i.status}`);
  return i.json();
}
function e_(e) {
  var t, a, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (a = e_(e[t])) && (o && (o += " "), o += a);
  } else for (a in e) e[a] && (o && (o += " "), o += a);
  return o;
}
function ao() {
  for (var e, t, a = 0, o = "", n = arguments.length; a < n; a++) (e = arguments[a]) && (t = e_(e)) && (o && (o += " "), o += t);
  return o;
}
const wE = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], kE = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, xE = wE.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: kE[e]
})), $E = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, SE = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function CE(e = 0) {
  const t = [];
  for (let a = 0; a < e; a++)
    t[a] = `path${a + 1}`;
  return t.map((a) => /* @__PURE__ */ v("span", { className: a }, a));
}
const In = pt(
  ({ name: e, size: t = "medium", color: a = "base", className: o = "", ...n }, r) => {
    const i = xE.find((l) => l.name === e), s = ao("icon", `ds-${i?.class}`, SE[t], $E[a], o);
    return /* @__PURE__ */ v("i", { className: s, ...n, ref: r, children: CE(i?.paths) });
  }
);
In.displayName = "Icon";
const EE = "_disabled_1rzsq_47", wr = {
  "icon-button": "_icon-button_1rzsq_29",
  "size-small": "_size-small_1rzsq_38",
  "size-medium": "_size-medium_1rzsq_41",
  "size-large": "_size-large_1rzsq_44",
  disabled: EE,
  "is-borderless": "_is-borderless_1rzsq_51",
  "dialog-overlay-show": "_dialog-overlay-show_1rzsq_1",
  "dialog-content-show": "_dialog-content-show_1rzsq_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1rzsq_1"
}, zE = pt(
  ({ icon: e, size: t, isBorderless: a, onClick: o, className: n, ...r }, i) => /* @__PURE__ */ v(
    "button",
    {
      ref: i,
      className: ao(
        wr["icon-button"],
        r.disabled && wr.disabled,
        t && wr[`size-${t}`],
        a && wr["is-borderless"],
        n
      ),
      onClick: o,
      ...r,
      children: /* @__PURE__ */ v(In, { name: e, size: t })
    }
  )
);
zE.displayName = "IconButton";
const jE = "_loader_1ksyv_29", AE = "_circle_1ksyv_41", So = {
  loader: jE,
  "is-small": "_is-small_1ksyv_29",
  "is-medium": "_is-medium_1ksyv_33",
  "is-large": "_is-large_1ksyv_37",
  circle: AE,
  "moving-element": "_moving-element_1ksyv_44",
  "on-dark": "_on-dark_1ksyv_47",
  "is-secondary": "_is-secondary_1ksyv_53",
  "dialog-overlay-show": "_dialog-overlay-show_1ksyv_1",
  "dialog-content-show": "_dialog-content-show_1ksyv_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ksyv_1"
}, OE = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
}, PE = {
  primary: "is-primary",
  secondary: "is-secondary"
};
function DE({ onDark: e, size: t = "medium", color: a = "primary", className: o }) {
  return /* @__PURE__ */ T(
    "svg",
    {
      className: ao(
        So.loader,
        So[OE[t]],
        So[PE[a]],
        e && So["on-dark"],
        o
      ),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      children: [
        /* @__PURE__ */ v("rect", { width: "100", height: "100", fill: "none", className: "bk" }),
        /* @__PURE__ */ v("circle", { className: So.circle, cx: "50", cy: "50", r: "40", fill: "none", strokeWidth: "10", strokeLinecap: "round" }),
        /* @__PURE__ */ T(
          "circle",
          {
            className: So["moving-element"],
            cx: "50",
            cy: "50",
            r: "40",
            fill: "none",
            strokeWidth: "6",
            strokeLinecap: "round",
            children: [
              /* @__PURE__ */ v("animate", { attributeName: "stroke-dashoffset", dur: "2s", repeatCount: "indefinite", from: "502", to: "0" }),
              /* @__PURE__ */ v(
                "animate",
                {
                  attributeName: "stroke-dasharray",
                  dur: "2s",
                  repeatCount: "indefinite",
                  values: "150.6 100.4;1 250;150.6 100.4"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const NE = "_button_z1os6_29", RE = "_disabled_z1os6_43", IE = "_loader_z1os6_263", la = {
  button: NE,
  disabled: RE,
  "is-primary": "_is-primary_z1os6_51",
  "is-contrasted": "_is-contrasted_z1os6_65",
  "is-secondary": "_is-secondary_z1os6_74",
  "is-tertiary": "_is-tertiary_z1os6_97",
  "is-eco-green": "_is-eco-green_z1os6_120",
  "is-ghost": "_is-ghost_z1os6_134",
  "is-destructive": "_is-destructive_z1os6_157",
  "is-hollow": "_is-hollow_z1os6_171",
  "is-destructive-ghost": "_is-destructive-ghost_z1os6_189",
  "is-facebook": "_is-facebook_z1os6_203",
  "is-apple": "_is-apple_z1os6_217",
  "is-google": "_is-google_z1os6_231",
  "is-regular": "_is-regular_z1os6_245",
  "is-medium": "_is-medium_z1os6_248",
  "is-small": "_is-small_z1os6_251",
  "is-full-width": "_is-full-width_z1os6_254",
  "is-loading": "_is-loading_z1os6_257",
  loader: IE,
  "dialog-overlay-show": "_dialog-overlay-show_z1os6_1",
  "dialog-content-show": "_dialog-content-show_z1os6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_z1os6_1"
}, TE = pt(
  ({
    text: e,
    color: t = "primary",
    size: a = "medium",
    isFullWidth: o = !1,
    icon: n,
    iconPosition: r = "left",
    isLoading: i = !1,
    iconSize: s = "medium",
    isContrasted: l = !1,
    disabled: c = !1,
    className: u,
    children: d,
    ...h
  }, p) => {
    const f = ao(
      la.button,
      la[ME[t]],
      la[LE[a]],
      o && la["is-full-width"],
      c && la.disabled,
      r === "right" && la["has-icon-right"],
      l && la["is-contrasted"],
      i && la["is-loading"],
      u
    ), m = /* @__PURE__ */ T(De, { children: [
      i && /* @__PURE__ */ v(DE, { className: la.loader, onDark: !0, size: "small" }),
      n && r === "left" && /* @__PURE__ */ v(In, { color: "inherit", size: s, name: n }),
      d ?? e,
      n && r === "right" && /* @__PURE__ */ v(In, { color: "inherit", size: s, name: n })
    ] });
    if (WE(h))
      return /* @__PURE__ */ v(
        "a",
        {
          ...h,
          href: c ? void 0 : h.href,
          className: f,
          target: h.target,
          ref: p,
          children: m
        }
      );
    if (BE(h))
      return /* @__PURE__ */ v(
        "button",
        {
          disabled: i || c,
          ...h,
          className: f,
          ref: p,
          children: m
        }
      );
  }
);
TE.displayName = "Button";
const ME = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  hollow: "is-hollow",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google"
}, LE = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
};
function WE(e) {
  return "href" in e && typeof e.href == "string";
}
function BE(e) {
  return !("href" in e);
}
const FE = (e, t) => {
  let a;
  return () => {
    clearTimeout(a), a = setTimeout(e, t);
  };
}, mc = {
  xs: { items: 1, peek: 15 },
  sm: { items: 2, peek: 20 },
  md: { items: 3, peek: 25 },
  lg: { items: 4, peek: 15 },
  xl: { items: 5, peek: 10 }
}, VE = [
  { size: 1280, key: "xl" },
  { size: 1024, key: "lg" },
  { size: 768, key: "md" },
  { size: 640, key: "sm" }
];
function UE(e, t) {
  const a = Ie(null), [o, n] = Pe("100%"), [r, i] = Pe(0), [s, l] = Pe(0), [c, u] = Pe(0), d = Ho(
    () => ({
      ...mc,
      ...t.itemsPerBreakpoint
    }),
    [t.itemsPerBreakpoint]
  ), h = () => {
    a.current && (l(a.current.scrollWidth), u(a.current.clientWidth));
  }, p = Ho(
    () => ({
      shouldDisplayNext: r + c < s,
      shouldDisplayPrev: r > 0
    }),
    [r, c, s]
  );
  Ce(() => {
    const w = a.current;
    if (!w) return;
    const _ = () => {
      const x = w.clientWidth ?? 0;
      let S = d.xs;
      for (const { size: M, key: j } of VE)
        if (window.matchMedia(`(min-width: ${M}px)`).matches) {
          S = d[j] ?? mc[j];
          break;
        }
      const $ = getComputedStyle(w), E = parseInt($.gap) || 0;
      let C = 0;
      if (t.paddingElementWrapper && w.children.length) {
        const M = w.children[w.children.length - 1], j = getComputedStyle(M);
        C = parseInt(j.paddingRight);
      }
      const z = x - E * (S.items + (S.peek === 0 ? -1 : 0)) - C, R = S.items + (S.peek === 0 ? 0 : S.peek / 100), H = z / R;
      n(`${H}px`), h();
    };
    _(), h();
    const y = () => i(w.scrollLeft), k = FE(() => {
      _(), h();
    }, 500);
    return w.addEventListener("scroll", y), window.addEventListener("resize", k), () => {
      w.removeEventListener("scroll", y), window.removeEventListener("resize", k);
    };
  }, [d, t.paddingElementWrapper, e]), Ce(h, [e]), Ce(() => {
    t.onNavigationStateChange?.(p);
  }, [p, t]);
  const f = () => {
    a.current && a.current.scrollTo({
      left: Math.max(0, r - a.current.offsetWidth),
      behavior: "smooth"
    });
  }, m = () => {
    a.current && a.current.scrollTo({
      left: Math.min(s - c, r + a.current.offsetWidth),
      behavior: "smooth"
    });
  }, b = (w) => {
    if (!a.current) return parseInt(o);
    const _ = ne.Children.count(e), y = {
      first: w === 0,
      last: w === _ - 1
    }, k = () => {
      if (!t.paddingElementWrapper) return 0;
      const x = a.current?.children[w];
      if (!x) return 0;
      const S = getComputedStyle(x);
      return y.first ? parseInt(S.paddingLeft || "0") : y.last ? parseInt(S.paddingRight || "0") : 0;
    };
    return parseInt(o) + k();
  };
  return {
    carouselRef: a,
    shouldDisplayPrev: p.shouldDisplayPrev,
    shouldDisplayNext: p.shouldDisplayNext,
    scrollPrev: f,
    scrollNext: m,
    itemWidth: o,
    getItemWidth: b
  };
}
const qE = "_carousel_u43l3_29", kr = {
  carousel: qE,
  "carousel-content": "_carousel-content_u43l3_33",
  "gap-0": "_gap-0_u43l3_47",
  "gap-1": "_gap-1_u43l3_50",
  "gap-2": "_gap-2_u43l3_53",
  "gap-3": "_gap-3_u43l3_56",
  "gap-4": "_gap-4_u43l3_59",
  "gap-5": "_gap-5_u43l3_62",
  "gap-6": "_gap-6_u43l3_65",
  "gap-7": "_gap-7_u43l3_68",
  "gap-8": "_gap-8_u43l3_71",
  "gap-9": "_gap-9_u43l3_74",
  "gap-10": "_gap-10_u43l3_77",
  "gap-11": "_gap-11_u43l3_80",
  "gap-12": "_gap-12_u43l3_83",
  "gap-14": "_gap-14_u43l3_86",
  "gap-16": "_gap-16_u43l3_89",
  "gap-18": "_gap-18_u43l3_92",
  "gap-20": "_gap-20_u43l3_95",
  "gap-24": "_gap-24_u43l3_98",
  "gap-28": "_gap-28_u43l3_101",
  "gap-32": "_gap-32_u43l3_104",
  "gap-36": "_gap-36_u43l3_107",
  "gap-40": "_gap-40_u43l3_110",
  "gap-44": "_gap-44_u43l3_113",
  "gap-48": "_gap-48_u43l3_116",
  "gap-52": "_gap-52_u43l3_119",
  "gap-56": "_gap-56_u43l3_122",
  "gap-60": "_gap-60_u43l3_125",
  "gap-64": "_gap-64_u43l3_128",
  "gap-72": "_gap-72_u43l3_131",
  "gap-80": "_gap-80_u43l3_134",
  "gap-96": "_gap-96_u43l3_137",
  "padding-element-wrapper": "_padding-element-wrapper_u43l3_140",
  "dialog-overlay-show": "_dialog-overlay-show_u43l3_1",
  "dialog-content-show": "_dialog-content-show_u43l3_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_u43l3_1"
}, HE = ({
  children: e,
  className: t = "",
  paddingElementWrapper: a = !1,
  gap: o = "8",
  itemsPerBreakpoint: n = mc,
  onNavigationStateChange: r,
  ...i
}, s) => {
  const { carouselRef: l, shouldDisplayPrev: c, shouldDisplayNext: u, scrollPrev: d, scrollNext: h, getItemWidth: p } = UE(
    e,
    {
      itemsPerBreakpoint: n,
      paddingElementWrapper: a,
      onNavigationStateChange: r
    }
  ), f = ne.Children.map(e, (b, w) => ne.isValidElement(b) ? ne.cloneElement(b, {
    style: {
      ...b.props.style,
      width: `${p(w)}px`,
      flexShrink: 0
    }
  }) : b);
  ne.useImperativeHandle(s, () => ({
    scrollNext: h,
    scrollPrev: d,
    shouldDisplayNext: u,
    shouldDisplayPrev: c,
    carouselElement: l.current
  }));
  const m = ao(kr.carousel, t);
  return /* @__PURE__ */ v("div", { className: m, ...i, children: /* @__PURE__ */ v(
    "ul",
    {
      ref: l,
      className: ao(
        kr["carousel-content"],
        a && kr["padding-element-wrapper"],
        o && kr[`gap-${o}`]
      ),
      children: f
    }
  ) });
};
ne.forwardRef(HE);
function be(e, t, { checkForDefaultPrevented: a = !0 } = {}) {
  return function(o) {
    if (e?.(o), a === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
var Da = globalThis?.document ? g.useLayoutEffect : () => {
}, GE = g[" useInsertionEffect ".trim().toString()] || Da;
function bs({
  prop: e,
  defaultProp: t,
  onChange: a = () => {
  },
  caller: o
}) {
  const [n, r, i] = KE({
    defaultProp: t,
    onChange: a
  }), s = e !== void 0, l = s ? e : n;
  {
    const u = g.useRef(e !== void 0);
    g.useEffect(() => {
      const d = u.current;
      d !== s && console.warn(
        `${o} is changing from ${d ? "controlled" : "uncontrolled"} to ${s ? "controlled" : "uncontrolled"}. Components should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled value for the lifetime of the component.`
      ), u.current = s;
    }, [s, o]);
  }
  const c = g.useCallback(
    (u) => {
      if (s) {
        const d = JE(u) ? u(e) : u;
        d !== e && i.current?.(d);
      } else
        r(u);
    },
    [s, e, r, i]
  );
  return [l, c];
}
function KE({
  defaultProp: e,
  onChange: t
}) {
  const [a, o] = g.useState(e), n = g.useRef(a), r = g.useRef(t);
  return GE(() => {
    r.current = t;
  }, [t]), g.useEffect(() => {
    n.current !== a && (r.current?.(a), n.current = a);
  }, [a, n]), [a, o, r];
}
function JE(e) {
  return typeof e == "function";
}
function Mg(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function t_(...e) {
  return (t) => {
    let a = !1;
    const o = e.map((n) => {
      const r = Mg(n, t);
      return !a && typeof r == "function" && (a = !0), r;
    });
    if (a)
      return () => {
        for (let n = 0; n < o.length; n++) {
          const r = o[n];
          typeof r == "function" ? r() : Mg(e[n], null);
        }
      };
  };
}
function He(...e) {
  return g.useCallback(t_(...e), e);
}
function ZE(e, t) {
  const a = g.createContext(t), o = (r) => {
    const { children: i, ...s } = r, l = g.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ v(a.Provider, { value: l, children: i });
  };
  o.displayName = e + "Provider";
  function n(r) {
    const i = g.useContext(a);
    if (i) return i;
    if (t !== void 0) return t;
    throw new Error(`\`${r}\` must be used within \`${e}\``);
  }
  return [o, n];
}
function _o(e, t = []) {
  let a = [];
  function o(r, i) {
    const s = g.createContext(i), l = a.length;
    a = [...a, i];
    const c = (d) => {
      const { scope: h, children: p, ...f } = d, m = h?.[e]?.[l] || s, b = g.useMemo(() => f, Object.values(f));
      return /* @__PURE__ */ v(m.Provider, { value: b, children: p });
    };
    c.displayName = r + "Provider";
    function u(d, h) {
      const p = h?.[e]?.[l] || s, f = g.useContext(p);
      if (f) return f;
      if (i !== void 0) return i;
      throw new Error(`\`${d}\` must be used within \`${r}\``);
    }
    return [c, u];
  }
  const n = () => {
    const r = a.map((i) => g.createContext(i));
    return function(i) {
      const s = i?.[e] || r;
      return g.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: s } }),
        [i, s]
      );
    };
  };
  return n.scopeName = e, [o, YE(n, ...t)];
}
function YE(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const a = () => {
    const o = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(n) {
      const r = o.reduce((i, { useScope: s, scopeName: l }) => {
        const c = s(n)[`__scope${l}`];
        return { ...i, ...c };
      }, {});
      return g.useMemo(() => ({ [`__scope${t.scopeName}`]: r }), [r]);
    };
  };
  return a.scopeName = t.scopeName, a;
}
// @__NO_SIDE_EFFECTS__
function $i(e) {
  const t = /* @__PURE__ */ XE(e), a = g.forwardRef((o, n) => {
    const { children: r, ...i } = o, s = g.Children.toArray(r), l = s.find(ez);
    if (l) {
      const c = l.props.children, u = s.map((d) => d === l ? g.Children.count(c) > 1 ? g.Children.only(null) : g.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ v(t, { ...i, ref: n, children: g.isValidElement(c) ? g.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ v(t, { ...i, ref: n, children: r });
  });
  return a.displayName = `${e}.Slot`, a;
}
// @__NO_SIDE_EFFECTS__
function XE(e) {
  const t = g.forwardRef((a, o) => {
    const { children: n, ...r } = a;
    if (g.isValidElement(n)) {
      const i = az(n), s = tz(r, n.props);
      return n.type !== g.Fragment && (s.ref = o ? t_(o, i) : i), g.cloneElement(n, s);
    }
    return g.Children.count(n) > 1 ? g.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var QE = Symbol("radix.slottable");
function ez(e) {
  return g.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === QE;
}
function tz(e, t) {
  const a = { ...t };
  for (const o in t) {
    const n = e[o], r = t[o];
    /^on[A-Z]/.test(o) ? n && r ? a[o] = (...i) => {
      const s = r(...i);
      return n(...i), s;
    } : n && (a[o] = n) : o === "style" ? a[o] = { ...n, ...r } : o === "className" && (a[o] = [n, r].filter(Boolean).join(" "));
  }
  return { ...e, ...a };
}
function az(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning;
  return a ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning, a ? e.props.ref : e.props.ref || e.ref);
}
var oz = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], Ae = oz.reduce((e, t) => {
  const a = /* @__PURE__ */ $i(`Primitive.${t}`), o = g.forwardRef((n, r) => {
    const { asChild: i, ...s } = n, l = i ? a : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ v(l, { ...s, ref: r });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {});
function a_(e, t) {
  e && mo.flushSync(() => e.dispatchEvent(t));
}
var nz = g.createContext(void 0);
function Au(e) {
  const t = g.useContext(nz);
  return e || t || "ltr";
}
function o_(e) {
  const t = e + "CollectionProvider", [a, o] = _o(t), [n, r] = a(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (m) => {
    const { scope: b, children: w } = m, _ = ne.useRef(null), y = ne.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ v(n, { scope: b, itemMap: y, collectionRef: _, children: w });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", l = /* @__PURE__ */ $i(s), c = ne.forwardRef(
    (m, b) => {
      const { scope: w, children: _ } = m, y = r(s, w), k = He(b, y.collectionRef);
      return /* @__PURE__ */ v(l, { ref: k, children: _ });
    }
  );
  c.displayName = s;
  const u = e + "CollectionItemSlot", d = "data-radix-collection-item", h = /* @__PURE__ */ $i(u), p = ne.forwardRef(
    (m, b) => {
      const { scope: w, children: _, ...y } = m, k = ne.useRef(null), x = He(b, k), S = r(u, w);
      return ne.useEffect(() => (S.itemMap.set(k, { ref: k, ...y }), () => void S.itemMap.delete(k))), /* @__PURE__ */ v(h, { [d]: "", ref: x, children: _ });
    }
  );
  p.displayName = u;
  function f(m) {
    const b = r(e + "CollectionConsumer", m);
    return ne.useCallback(() => {
      const w = b.collectionRef.current;
      if (!w) return [];
      const _ = Array.from(w.querySelectorAll(`[${d}]`));
      return Array.from(b.itemMap.values()).sort(
        (y, k) => _.indexOf(y.ref.current) - _.indexOf(k.ref.current)
      );
    }, [b.collectionRef, b.itemMap]);
  }
  return [
    { Provider: i, Slot: c, ItemSlot: p },
    f,
    o
  ];
}
var rz = g[" useId ".trim().toString()] || (() => {
}), iz = 0;
function n_(e) {
  const [t, a] = g.useState(rz());
  return Da(() => {
    a((o) => o ?? String(iz++));
  }, [e]), t ? `radix-${t}` : "";
}
function sz(e, t) {
  return g.useReducer((a, o) => t[a][o] ?? a, e);
}
var _a = (e) => {
  const { present: t, children: a } = e, o = lz(t), n = typeof a == "function" ? a({ present: o.isPresent }) : g.Children.only(a), r = He(o.ref, cz(n));
  return typeof a == "function" || o.isPresent ? g.cloneElement(n, { ref: r }) : null;
};
_a.displayName = "Presence";
function lz(e) {
  const [t, a] = g.useState(), o = g.useRef(null), n = g.useRef(e), r = g.useRef("none"), i = e ? "mounted" : "unmounted", [s, l] = sz(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return g.useEffect(() => {
    const c = xr(o.current);
    r.current = s === "mounted" ? c : "none";
  }, [s]), Da(() => {
    const c = o.current, u = n.current;
    if (u !== e) {
      const d = r.current, h = xr(c);
      e ? l("MOUNT") : h === "none" || c?.display === "none" ? l("UNMOUNT") : l(u && d !== h ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [e, l]), Da(() => {
    if (t) {
      let c;
      const u = t.ownerDocument.defaultView ?? window, d = (p) => {
        const f = xr(o.current).includes(CSS.escape(p.animationName));
        if (p.target === t && f && (l("ANIMATION_END"), !n.current)) {
          const m = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = m);
          });
        }
      }, h = (p) => {
        p.target === t && (r.current = xr(o.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(c), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: g.useCallback((c) => {
      o.current = c ? getComputedStyle(c) : null, a(c);
    }, [])
  };
}
function xr(e) {
  return e?.animationName || "none";
}
function cz(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning;
  return a ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning, a ? e.props.ref : e.props.ref || e.ref);
}
function Qe(e) {
  const t = g.useRef(e);
  return g.useEffect(() => {
    t.current = e;
  }), g.useMemo(() => (...a) => t.current?.(...a), []);
}
var ul = "rovingFocusGroup.onEntryFocus", uz = { bubbles: !1, cancelable: !0 }, tr = "RovingFocusGroup", [pc, r_, dz] = o_(tr), [gz, i_] = _o(
  tr,
  [dz]
), [hz, mz] = gz(tr), s_ = g.forwardRef(
  (e, t) => /* @__PURE__ */ v(pc.Provider, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ v(pc.Slot, { scope: e.__scopeRovingFocusGroup, children: /* @__PURE__ */ v(pz, { ...e, ref: t }) }) })
);
s_.displayName = tr;
var pz = g.forwardRef((e, t) => {
  const {
    __scopeRovingFocusGroup: a,
    orientation: o,
    loop: n = !1,
    dir: r,
    currentTabStopId: i,
    defaultCurrentTabStopId: s,
    onCurrentTabStopIdChange: l,
    onEntryFocus: c,
    preventScrollOnEntryFocus: u = !1,
    ...d
  } = e, h = g.useRef(null), p = He(t, h), f = Au(r), [m, b] = bs({
    prop: i,
    defaultProp: s ?? null,
    onChange: l,
    caller: tr
  }), [w, _] = g.useState(!1), y = Qe(c), k = r_(a), x = g.useRef(!1), [S, $] = g.useState(0);
  return g.useEffect(() => {
    const E = h.current;
    if (E)
      return E.addEventListener(ul, y), () => E.removeEventListener(ul, y);
  }, [y]), /* @__PURE__ */ v(
    hz,
    {
      scope: a,
      orientation: o,
      dir: f,
      loop: n,
      currentTabStopId: m,
      onItemFocus: g.useCallback(
        (E) => b(E),
        [b]
      ),
      onItemShiftTab: g.useCallback(() => _(!0), []),
      onFocusableItemAdd: g.useCallback(
        () => $((E) => E + 1),
        []
      ),
      onFocusableItemRemove: g.useCallback(
        () => $((E) => E - 1),
        []
      ),
      children: /* @__PURE__ */ v(
        Ae.div,
        {
          tabIndex: w || S === 0 ? -1 : 0,
          "data-orientation": o,
          ...d,
          ref: p,
          style: { outline: "none", ...e.style },
          onMouseDown: be(e.onMouseDown, () => {
            x.current = !0;
          }),
          onFocus: be(e.onFocus, (E) => {
            const C = !x.current;
            if (E.target === E.currentTarget && C && !w) {
              const z = new CustomEvent(ul, uz);
              if (E.currentTarget.dispatchEvent(z), !z.defaultPrevented) {
                const R = k().filter((U) => U.focusable), H = R.find((U) => U.active), M = R.find((U) => U.id === m), j = [H, M, ...R].filter(
                  Boolean
                ).map((U) => U.ref.current);
                u_(j, u);
              }
            }
            x.current = !1;
          }),
          onBlur: be(e.onBlur, () => _(!1))
        }
      )
    }
  );
}), l_ = "RovingFocusGroupItem", c_ = g.forwardRef(
  (e, t) => {
    const {
      __scopeRovingFocusGroup: a,
      focusable: o = !0,
      active: n = !1,
      tabStopId: r,
      children: i,
      ...s
    } = e, l = n_(), c = r || l, u = mz(l_, a), d = u.currentTabStopId === c, h = r_(a), { onFocusableItemAdd: p, onFocusableItemRemove: f, currentTabStopId: m } = u;
    return g.useEffect(() => {
      if (o)
        return p(), () => f();
    }, [o, p, f]), /* @__PURE__ */ v(
      pc.ItemSlot,
      {
        scope: a,
        id: c,
        focusable: o,
        active: n,
        children: /* @__PURE__ */ v(
          Ae.span,
          {
            tabIndex: d ? 0 : -1,
            "data-orientation": u.orientation,
            ...s,
            ref: t,
            onMouseDown: be(e.onMouseDown, (b) => {
              o ? u.onItemFocus(c) : b.preventDefault();
            }),
            onFocus: be(e.onFocus, () => u.onItemFocus(c)),
            onKeyDown: be(e.onKeyDown, (b) => {
              if (b.key === "Tab" && b.shiftKey) {
                u.onItemShiftTab();
                return;
              }
              if (b.target !== b.currentTarget) return;
              const w = _z(b, u.orientation, u.dir);
              if (w !== void 0) {
                if (b.metaKey || b.ctrlKey || b.altKey || b.shiftKey) return;
                b.preventDefault();
                let _ = h().filter((y) => y.focusable).map((y) => y.ref.current);
                if (w === "last") _.reverse();
                else if (w === "prev" || w === "next") {
                  w === "prev" && _.reverse();
                  const y = _.indexOf(b.currentTarget);
                  _ = u.loop ? vz(_, y + 1) : _.slice(y + 1);
                }
                setTimeout(() => u_(_));
              }
            }),
            children: typeof i == "function" ? i({ isCurrentTabStop: d, hasTabStop: m != null }) : i
          }
        )
      }
    );
  }
);
c_.displayName = l_;
var fz = {
  ArrowLeft: "prev",
  ArrowUp: "prev",
  ArrowRight: "next",
  ArrowDown: "next",
  PageUp: "first",
  Home: "first",
  PageDown: "last",
  End: "last"
};
function bz(e, t) {
  return t !== "rtl" ? e : e === "ArrowLeft" ? "ArrowRight" : e === "ArrowRight" ? "ArrowLeft" : e;
}
function _z(e, t, a) {
  const o = bz(e.key, a);
  if (!(t === "vertical" && ["ArrowLeft", "ArrowRight"].includes(o)) && !(t === "horizontal" && ["ArrowUp", "ArrowDown"].includes(o)))
    return fz[o];
}
function u_(e, t = !1) {
  const a = document.activeElement;
  for (const o of e)
    if (o === a || (o.focus({ preventScroll: t }), document.activeElement !== a)) return;
}
function vz(e, t) {
  return e.map((a, o) => e[(t + o) % e.length]);
}
var yz = s_, wz = c_;
function kz(e) {
  const [t, a] = g.useState(void 0);
  return Da(() => {
    if (e) {
      a({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((n) => {
        if (!Array.isArray(n) || !n.length)
          return;
        const r = n[0];
        let i, s;
        if ("borderBoxSize" in r) {
          const l = r.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          i = c.inlineSize, s = c.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        a({ width: i, height: s });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      a(void 0);
  }, [e]), t;
}
function xz(e) {
  const t = g.useRef({ value: e, previous: e });
  return g.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
const $z = typeof document < "u" ? ne.useLayoutEffect : () => {
};
var dl;
dl = ne.useInsertionEffect;
const Si = {
  prefix: String(Math.round(Math.random() * 1e10)),
  current: 0
}, d_ = /* @__PURE__ */ ne.createContext(Si), Sz = /* @__PURE__ */ ne.createContext(!1);
let Cz = !!(typeof window < "u" && window.document && window.document.createElement), gl = /* @__PURE__ */ new WeakMap();
function Ez(e = !1) {
  let t = ho(d_), a = Ie(null);
  if (a.current === null && !e) {
    var o, n;
    let r = (n = ne.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED) === null || n === void 0 || (o = n.ReactCurrentOwner) === null || o === void 0 ? void 0 : o.current;
    if (r) {
      let i = gl.get(r);
      i == null ? gl.set(r, {
        id: t.current,
        state: r.memoizedState
      }) : r.memoizedState !== i.state && (t.current = i.id, gl.delete(r));
    }
    a.current = ++t.current;
  }
  return a.current;
}
function zz(e) {
  let t = ho(d_);
  t === Si && !Cz && process.env.NODE_ENV !== "production" && console.warn("When server rendering, you must wrap your application in an <SSRProvider> to ensure consistent ids are generated between the client and server.");
  let a = Ez(!!e), o = t === Si && process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${t.prefix}`;
  return e || `${o}-${a}`;
}
function jz(e) {
  let t = ne.useId(), [a] = Pe(Dz()), o = a || process.env.NODE_ENV === "test" ? "react-aria" : `react-aria${Si.prefix}`;
  return e || `${o}-${t}`;
}
ne.useId;
function Az() {
  return !1;
}
function Oz() {
  return !0;
}
function Pz(e) {
  return () => {
  };
}
function Dz() {
  return typeof ne.useSyncExternalStore == "function" ? ne.useSyncExternalStore(Pz, Az, Oz) : ho(Sz);
}
let Nz = /* @__PURE__ */ new Map();
typeof FinalizationRegistry < "u" && new FinalizationRegistry((e) => {
  Nz.delete(e);
});
const Rz = /* @__PURE__ */ new Set([
  "Arab",
  "Syrc",
  "Samr",
  "Mand",
  "Thaa",
  "Mend",
  "Nkoo",
  "Adlm",
  "Rohg",
  "Hebr"
]), Iz = /* @__PURE__ */ new Set([
  "ae",
  "ar",
  "arc",
  "bcc",
  "bqi",
  "ckb",
  "dv",
  "fa",
  "glk",
  "he",
  "ku",
  "mzn",
  "nqo",
  "pnb",
  "ps",
  "sd",
  "ug",
  "ur",
  "yi"
]);
function Tz(e) {
  if (Intl.Locale) {
    let a = new Intl.Locale(e).maximize(), o = typeof a.getTextInfo == "function" ? a.getTextInfo() : a.textInfo;
    if (o) return o.direction === "rtl";
    if (a.script) return Rz.has(a.script);
  }
  let t = e.split("-")[0];
  return Iz.has(t);
}
const Mz = Symbol.for("react-aria.i18n.locale");
function Lz() {
  let e = typeof window < "u" && window[Mz] || typeof navigator < "u" && (navigator.language || navigator.userLanguage) || "en-US";
  try {
    Intl.DateTimeFormat.supportedLocalesOf([
      e
    ]);
  } catch {
    e = "en-US";
  }
  return {
    locale: e,
    direction: Tz(e) ? "rtl" : "ltr"
  };
}
Lz();
const _s = (e) => {
  var t;
  return (t = e?.ownerDocument) !== null && t !== void 0 ? t : document;
}, fc = (e) => _s(e).defaultView || window;
function vs(e) {
  var t;
  if (typeof window > "u" || window.navigator == null) return !1;
  let a = (t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.brands;
  return Array.isArray(a) && a.some((o) => e.test(o.brand)) || e.test(window.navigator.userAgent);
}
function Ou(e) {
  var t;
  return typeof window < "u" && window.navigator != null ? e.test(((t = window.navigator.userAgentData) === null || t === void 0 ? void 0 : t.platform) || window.navigator.platform) : !1;
}
function va(e) {
  if (process.env.NODE_ENV === "test") return e;
  let t = null;
  return () => (t == null && (t = e()), t);
}
const Pu = va(function() {
  return Ou(/^Mac/i);
}), Wz = va(function() {
  return Ou(/^iPhone/i);
}), Bz = va(function() {
  return Ou(/^iPad/i) || // iPadOS 13 lies and says it's a Mac, but we can distinguish by detecting touch support.
  Pu() && navigator.maxTouchPoints > 1;
}), Fz = va(function() {
  return Wz() || Bz();
});
va(function() {
  return Pu() || Fz();
});
va(function() {
  return vs(/AppleWebKit/i) && !Vz();
});
const Vz = va(function() {
  return vs(/Chrome/i);
}), Uz = va(function() {
  return vs(/Android/i);
});
va(function() {
  return vs(/Firefox/i);
});
let bn = /* @__PURE__ */ new Map(), Lg = /* @__PURE__ */ new Set();
function Wg() {
  if (typeof window > "u") return;
  function e(o) {
    return "propertyName" in o;
  }
  let t = (o) => {
    if (!e(o) || !o.target) return;
    let n = bn.get(o.target);
    n || (n = /* @__PURE__ */ new Set(), bn.set(o.target, n), o.target.addEventListener("transitioncancel", a, {
      once: !0
    })), n.add(o.propertyName);
  }, a = (o) => {
    if (!e(o) || !o.target) return;
    let n = bn.get(o.target);
    if (n && (n.delete(o.propertyName), n.size === 0 && (o.target.removeEventListener("transitioncancel", a), bn.delete(o.target)), bn.size === 0)) {
      for (let r of Lg) r();
      Lg.clear();
    }
  };
  document.body.addEventListener("transitionrun", t), document.body.addEventListener("transitionend", a);
}
typeof document < "u" && (document.readyState !== "loading" ? Wg() : document.addEventListener("DOMContentLoaded", Wg));
function qz(e) {
  return e.pointerType === "" && e.isTrusted ? !0 : Uz() && e.pointerType ? e.type === "click" && e.buttons === 1 : e.detail === 0 && !e.pointerType;
}
let Hz = !1;
const Gz = ne.createContext({
  register: () => {
  }
});
Gz.displayName = "PressResponderContext";
let Kz = /* @__PURE__ */ new Set(), En = /* @__PURE__ */ new Map(), oo = !1, bc = !1;
function Du(e, t) {
  for (let a of Kz) a(e, t);
}
function Jz(e) {
  return !(e.metaKey || !Pu() && e.altKey || e.ctrlKey || e.key === "Control" || e.key === "Shift" || e.key === "Meta");
}
function Ci(e) {
  oo = !0, Jz(e) && Du("keyboard", e);
}
function zt(e) {
  (e.type === "mousedown" || e.type === "pointerdown") && (oo = !0, Du("pointer", e));
}
function g_(e) {
  qz(e) && (oo = !0);
}
function h_(e) {
  e.target === window || e.target === document || Hz || !e.isTrusted || (!oo && !bc && Du("virtual", e), oo = !1, bc = !1);
}
function m_() {
  oo = !1, bc = !0;
}
function Bg(e) {
  if (typeof window > "u" || typeof document > "u" || En.get(fc(e))) return;
  const t = fc(e), a = _s(e);
  let o = t.HTMLElement.prototype.focus;
  t.HTMLElement.prototype.focus = function() {
    oo = !0, o.apply(this, arguments);
  }, a.addEventListener("keydown", Ci, !0), a.addEventListener("keyup", Ci, !0), a.addEventListener("click", g_, !0), t.addEventListener("focus", h_, !0), t.addEventListener("blur", m_, !1), typeof PointerEvent < "u" ? (a.addEventListener("pointerdown", zt, !0), a.addEventListener("pointermove", zt, !0), a.addEventListener("pointerup", zt, !0)) : process.env.NODE_ENV === "test" && (a.addEventListener("mousedown", zt, !0), a.addEventListener("mousemove", zt, !0), a.addEventListener("mouseup", zt, !0)), t.addEventListener("beforeunload", () => {
    p_(e);
  }, {
    once: !0
  }), En.set(t, {
    focus: o
  });
}
const p_ = (e, t) => {
  const a = fc(e), o = _s(e);
  t && o.removeEventListener("DOMContentLoaded", t), En.has(a) && (a.HTMLElement.prototype.focus = En.get(a).focus, o.removeEventListener("keydown", Ci, !0), o.removeEventListener("keyup", Ci, !0), o.removeEventListener("click", g_, !0), a.removeEventListener("focus", h_, !0), a.removeEventListener("blur", m_, !1), typeof PointerEvent < "u" ? (o.removeEventListener("pointerdown", zt, !0), o.removeEventListener("pointermove", zt, !0), o.removeEventListener("pointerup", zt, !0)) : process.env.NODE_ENV === "test" && (o.removeEventListener("mousedown", zt, !0), o.removeEventListener("mousemove", zt, !0), o.removeEventListener("mouseup", zt, !0)), En.delete(a));
};
function Zz(e) {
  const t = _s(e);
  let a;
  return t.readyState !== "loading" ? Bg(e) : (a = () => {
    Bg(e);
  }, t.addEventListener("DOMContentLoaded", a)), () => p_(e, a);
}
typeof document < "u" && Zz();
jt(null);
function Yz(e, t = globalThis?.document) {
  const a = Qe(e);
  g.useEffect(() => {
    const o = (n) => {
      n.key === "Escape" && a(n);
    };
    return t.addEventListener("keydown", o, { capture: !0 }), () => t.removeEventListener("keydown", o, { capture: !0 });
  }, [a, t]);
}
var Xz = "DismissableLayer", _c = "dismissableLayer.update", Qz = "dismissableLayer.pointerDownOutside", ej = "dismissableLayer.focusOutside", Fg, f_ = g.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), Nu = g.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: a = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: n,
      onFocusOutside: r,
      onInteractOutside: i,
      onDismiss: s,
      ...l
    } = e, c = g.useContext(f_), [u, d] = g.useState(null), h = u?.ownerDocument ?? globalThis?.document, [, p] = g.useState({}), f = He(t, ($) => d($)), m = Array.from(c.layers), [b] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), w = m.indexOf(b), _ = u ? m.indexOf(u) : -1, y = c.layersWithOutsidePointerEventsDisabled.size > 0, k = _ >= w, x = aj(($) => {
      const E = $.target, C = [...c.branches].some((z) => z.contains(E));
      !k || C || (n?.($), i?.($), $.defaultPrevented || s?.());
    }, h), S = oj(($) => {
      const E = $.target;
      [...c.branches].some((C) => C.contains(E)) || (r?.($), i?.($), $.defaultPrevented || s?.());
    }, h);
    return Yz(($) => {
      _ === c.layers.size - 1 && (o?.($), !$.defaultPrevented && s && ($.preventDefault(), s()));
    }, h), g.useEffect(() => {
      if (u)
        return a && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (Fg = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), Vg(), () => {
          a && c.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = Fg);
        };
    }, [u, h, a, c]), g.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), Vg());
    }, [u, c]), g.useEffect(() => {
      const $ = () => p({});
      return document.addEventListener(_c, $), () => document.removeEventListener(_c, $);
    }, []), /* @__PURE__ */ v(
      Ae.div,
      {
        ...l,
        ref: f,
        style: {
          pointerEvents: y ? k ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: be(e.onFocusCapture, S.onFocusCapture),
        onBlurCapture: be(e.onBlurCapture, S.onBlurCapture),
        onPointerDownCapture: be(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
Nu.displayName = Xz;
var tj = "DismissableLayerBranch", b_ = g.forwardRef((e, t) => {
  const a = g.useContext(f_), o = g.useRef(null), n = He(t, o);
  return g.useEffect(() => {
    const r = o.current;
    if (r)
      return a.branches.add(r), () => {
        a.branches.delete(r);
      };
  }, [a.branches]), /* @__PURE__ */ v(Ae.div, { ...e, ref: n });
});
b_.displayName = tj;
function aj(e, t = globalThis?.document) {
  const a = Qe(e), o = g.useRef(!1), n = g.useRef(() => {
  });
  return g.useEffect(() => {
    const r = (s) => {
      if (s.target && !o.current) {
        let l = function() {
          __(
            Qz,
            a,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", n.current), n.current = l, t.addEventListener("click", n.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", n.current);
      o.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", r);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", r), t.removeEventListener("click", n.current);
    };
  }, [t, a]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function oj(e, t = globalThis?.document) {
  const a = Qe(e), o = g.useRef(!1);
  return g.useEffect(() => {
    const n = (r) => {
      r.target && !o.current && __(ej, a, { originalEvent: r }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", n), () => t.removeEventListener("focusin", n);
  }, [t, a]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function Vg() {
  const e = new CustomEvent(_c);
  document.dispatchEvent(e);
}
function __(e, t, a, { discrete: o }) {
  const n = a.originalEvent.target, r = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: a });
  t && n.addEventListener(e, t, { once: !0 }), o ? a_(n, r) : n.dispatchEvent(r);
}
var nj = Nu, rj = b_, ij = "Portal", v_ = g.forwardRef((e, t) => {
  const { container: a, ...o } = e, [n, r] = g.useState(!1);
  Da(() => r(!0), []);
  const i = a || n && globalThis?.document?.body;
  return i ? rs.createPortal(/* @__PURE__ */ v(Ae.div, { ...o, ref: t }), i) : null;
});
v_.displayName = ij;
var ct = function() {
  return ct = Object.assign || function(e) {
    for (var t, a = 1, o = arguments.length; a < o; a++) {
      t = arguments[a];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, ct.apply(this, arguments);
};
function y_(e, t) {
  var a = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (a[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, o = Object.getOwnPropertySymbols(e); n < o.length; n++)
      t.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (a[o[n]] = e[o[n]]);
  return a;
}
function sj(e, t, a) {
  for (var o = 0, n = t.length, r; o < n; o++)
    (r || !(o in t)) && (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}
var hl = "focusScope.autoFocusOnMount", ml = "focusScope.autoFocusOnUnmount", Ug = { bubbles: !1, cancelable: !0 }, lj = "FocusScope", w_ = g.forwardRef((e, t) => {
  const {
    loop: a = !1,
    trapped: o = !1,
    onMountAutoFocus: n,
    onUnmountAutoFocus: r,
    ...i
  } = e, [s, l] = g.useState(null), c = Qe(n), u = Qe(r), d = g.useRef(null), h = He(t, (m) => l(m)), p = g.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  g.useEffect(() => {
    if (o) {
      let m = function(y) {
        if (p.paused || !s) return;
        const k = y.target;
        s.contains(k) ? d.current = k : Ea(d.current, { select: !0 });
      }, b = function(y) {
        if (p.paused || !s) return;
        const k = y.relatedTarget;
        k !== null && (s.contains(k) || Ea(d.current, { select: !0 }));
      }, w = function(y) {
        if (document.activeElement === document.body)
          for (const k of y)
            k.removedNodes.length > 0 && Ea(s);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", b);
      const _ = new MutationObserver(w);
      return s && _.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", b), _.disconnect();
      };
    }
  }, [o, s, p.paused]), g.useEffect(() => {
    if (s) {
      Hg.add(p);
      const m = document.activeElement;
      if (!s.contains(m)) {
        const b = new CustomEvent(hl, Ug);
        s.addEventListener(hl, c), s.dispatchEvent(b), b.defaultPrevented || (cj(mj(k_(s)), { select: !0 }), document.activeElement === m && Ea(s));
      }
      return () => {
        s.removeEventListener(hl, c), setTimeout(() => {
          const b = new CustomEvent(ml, Ug);
          s.addEventListener(ml, u), s.dispatchEvent(b), b.defaultPrevented || Ea(m ?? document.body, { select: !0 }), s.removeEventListener(ml, u), Hg.remove(p);
        }, 0);
      };
    }
  }, [s, c, u, p]);
  const f = g.useCallback(
    (m) => {
      if (!a && !o || p.paused) return;
      const b = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, w = document.activeElement;
      if (b && w) {
        const _ = m.currentTarget, [y, k] = uj(_);
        y && k ? !m.shiftKey && w === k ? (m.preventDefault(), a && Ea(y, { select: !0 })) : m.shiftKey && w === y && (m.preventDefault(), a && Ea(k, { select: !0 })) : w === _ && m.preventDefault();
      }
    },
    [a, o, p.paused]
  );
  return /* @__PURE__ */ v(Ae.div, { tabIndex: -1, ...i, ref: h, onKeyDown: f });
});
w_.displayName = lj;
function cj(e, { select: t = !1 } = {}) {
  const a = document.activeElement;
  for (const o of e)
    if (Ea(o, { select: t }), document.activeElement !== a) return;
}
function uj(e) {
  const t = k_(e), a = qg(t, e), o = qg(t.reverse(), e);
  return [a, o];
}
function k_(e) {
  const t = [], a = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const n = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || n ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; a.nextNode(); ) t.push(a.currentNode);
  return t;
}
function qg(e, t) {
  for (const a of e)
    if (!dj(a, { upTo: t })) return a;
}
function dj(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function gj(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Ea(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const a = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== a && gj(e) && t && e.select();
  }
}
var Hg = hj();
function hj() {
  let e = [];
  return {
    add(t) {
      const a = e[0];
      t !== a && a?.pause(), e = Gg(e, t), e.unshift(t);
    },
    remove(t) {
      e = Gg(e, t), e[0]?.resume();
    }
  };
}
function Gg(e, t) {
  const a = [...e], o = a.indexOf(t);
  return o !== -1 && a.splice(o, 1), a;
}
function mj(e) {
  return e.filter((t) => t.tagName !== "A");
}
var pl = 0;
function pj() {
  g.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? Kg()), document.body.insertAdjacentElement("beforeend", e[1] ?? Kg()), pl++, () => {
      pl === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), pl--;
    };
  }, []);
}
function Kg() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var ti = "right-scroll-bar-position", ai = "width-before-scroll-bar", fj = "with-scroll-bars-hidden", bj = "--removed-body-scroll-bar-size";
function fl(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function _j(e, t) {
  var a = Pe(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return a.value;
        },
        set current(o) {
          var n = a.value;
          n !== o && (a.value = o, a.callback(o, n));
        }
      }
    };
  })[0];
  return a.callback = t, a.facade;
}
var vj = typeof window < "u" ? g.useLayoutEffect : g.useEffect, Jg = /* @__PURE__ */ new WeakMap();
function yj(e, t) {
  var a = _j(null, function(o) {
    return e.forEach(function(n) {
      return fl(n, o);
    });
  });
  return vj(function() {
    var o = Jg.get(a);
    if (o) {
      var n = new Set(o), r = new Set(e), i = a.current;
      n.forEach(function(s) {
        r.has(s) || fl(s, null);
      }), r.forEach(function(s) {
        n.has(s) || fl(s, i);
      });
    }
    Jg.set(a, e);
  }, [e]), a;
}
function wj(e) {
  return e;
}
function kj(e, t) {
  t === void 0 && (t = wj);
  var a = [], o = !1, n = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return a.length ? a[a.length - 1] : e;
    },
    useMedium: function(r) {
      var i = t(r, o);
      return a.push(i), function() {
        a = a.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(r) {
      for (o = !0; a.length; ) {
        var i = a;
        a = [], i.forEach(r);
      }
      a = {
        push: function(s) {
          return r(s);
        },
        filter: function() {
          return a;
        }
      };
    },
    assignMedium: function(r) {
      o = !0;
      var i = [];
      if (a.length) {
        var s = a;
        a = [], s.forEach(r), i = a;
      }
      var l = function() {
        var u = i;
        i = [], u.forEach(r);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), a = {
        push: function(u) {
          i.push(u), c();
        },
        filter: function(u) {
          return i = i.filter(u), a;
        }
      };
    }
  };
  return n;
}
function xj(e) {
  e === void 0 && (e = {});
  var t = kj(null);
  return t.options = ct({ async: !0, ssr: !1 }, e), t;
}
var x_ = function(e) {
  var t = e.sideCar, a = y_(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return g.createElement(o, ct({}, a));
};
x_.isSideCarExport = !0;
function $j(e, t) {
  return e.useMedium(t), x_;
}
var $_ = xj(), bl = function() {
}, ys = g.forwardRef(function(e, t) {
  var a = g.useRef(null), o = g.useState({
    onScrollCapture: bl,
    onWheelCapture: bl,
    onTouchMoveCapture: bl
  }), n = o[0], r = o[1], i = e.forwardProps, s = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, h = e.sideCar, p = e.noIsolation, f = e.inert, m = e.allowPinchZoom, b = e.as, w = b === void 0 ? "div" : b, _ = e.gapMode, y = y_(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), k = h, x = yj([a, t]), S = ct(ct({}, y), n);
  return g.createElement(
    g.Fragment,
    null,
    u && g.createElement(k, { sideCar: $_, removeScrollBar: c, shards: d, noIsolation: p, inert: f, setCallbacks: r, allowPinchZoom: !!m, lockRef: a, gapMode: _ }),
    i ? g.cloneElement(g.Children.only(s), ct(ct({}, S), { ref: x })) : g.createElement(w, ct({}, S, { className: l, ref: x }), s)
  );
});
ys.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
ys.classNames = {
  fullWidth: ai,
  zeroRight: ti
};
var Sj = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function Cj() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = Sj();
  return t && e.setAttribute("nonce", t), e;
}
function Ej(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function zj(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var jj = function() {
  var e = 0, t = null;
  return {
    add: function(a) {
      e == 0 && (t = Cj()) && (Ej(t, a), zj(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, Aj = function() {
  var e = jj();
  return function(t, a) {
    g.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && a]);
  };
}, S_ = function() {
  var e = Aj(), t = function(a) {
    var o = a.styles, n = a.dynamic;
    return e(o, n), null;
  };
  return t;
}, Oj = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, _l = function(e) {
  return parseInt(e || "", 10) || 0;
}, Pj = function(e) {
  var t = window.getComputedStyle(document.body), a = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], n = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [_l(a), _l(o), _l(n)];
}, Dj = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return Oj;
  var t = Pj(e), a = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - a + t[2] - t[0])
  };
}, Nj = S_(), Bo = "data-scroll-locked", Rj = function(e, t, a, o) {
  var n = e.left, r = e.top, i = e.right, s = e.gap;
  return a === void 0 && (a = "margin"), `
  .`.concat(fj, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(s, "px ").concat(o, `;
  }
  body[`).concat(Bo, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    a === "margin" && `
    padding-left: `.concat(n, `px;
    padding-top: `).concat(r, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(o, `;
    `),
    a === "padding" && "padding-right: ".concat(s, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(ti, ` {
    right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(ai, ` {
    margin-right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(ti, " .").concat(ti, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(ai, " .").concat(ai, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(Bo, `] {
    `).concat(bj, ": ").concat(s, `px;
  }
`);
}, Zg = function() {
  var e = parseInt(document.body.getAttribute(Bo) || "0", 10);
  return isFinite(e) ? e : 0;
}, Ij = function() {
  g.useEffect(function() {
    return document.body.setAttribute(Bo, (Zg() + 1).toString()), function() {
      var e = Zg() - 1;
      e <= 0 ? document.body.removeAttribute(Bo) : document.body.setAttribute(Bo, e.toString());
    };
  }, []);
}, Tj = function(e) {
  var t = e.noRelative, a = e.noImportant, o = e.gapMode, n = o === void 0 ? "margin" : o;
  Ij();
  var r = g.useMemo(function() {
    return Dj(n);
  }, [n]);
  return g.createElement(Nj, { styles: Rj(r, !t, n, a ? "" : "!important") });
}, vc = !1;
if (typeof window < "u")
  try {
    var $r = Object.defineProperty({}, "passive", {
      get: function() {
        return vc = !0, !0;
      }
    });
    window.addEventListener("test", $r, $r), window.removeEventListener("test", $r, $r);
  } catch {
    vc = !1;
  }
var Co = vc ? { passive: !1 } : !1, Mj = function(e) {
  return e.tagName === "TEXTAREA";
}, C_ = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var a = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    a[t] !== "hidden" && // contains scroll inside self
    !(a.overflowY === a.overflowX && !Mj(e) && a[t] === "visible")
  );
}, Lj = function(e) {
  return C_(e, "overflowY");
}, Wj = function(e) {
  return C_(e, "overflowX");
}, Yg = function(e, t) {
  var a = t.ownerDocument, o = t;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var n = E_(e, o);
    if (n) {
      var r = z_(e, o), i = r[1], s = r[2];
      if (i > s)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== a.body);
  return !1;
}, Bj = function(e) {
  var t = e.scrollTop, a = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    a,
    o
  ];
}, Fj = function(e) {
  var t = e.scrollLeft, a = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    a,
    o
  ];
}, E_ = function(e, t) {
  return e === "v" ? Lj(t) : Wj(t);
}, z_ = function(e, t) {
  return e === "v" ? Bj(t) : Fj(t);
}, Vj = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, Uj = function(e, t, a, o, n) {
  var r = Vj(e, window.getComputedStyle(t).direction), i = r * o, s = a.target, l = t.contains(s), c = !1, u = i > 0, d = 0, h = 0;
  do {
    var p = z_(e, s), f = p[0], m = p[1], b = p[2], w = m - b - r * f;
    (f || w) && E_(e, s) && (d += w, h += f), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (u && Math.abs(d) < 1 || !u && Math.abs(h) < 1) && (c = !0), c;
}, Sr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, Xg = function(e) {
  return [e.deltaX, e.deltaY];
}, Qg = function(e) {
  return e && "current" in e ? e.current : e;
}, qj = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, Hj = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, Gj = 0, Eo = [];
function Kj(e) {
  var t = g.useRef([]), a = g.useRef([0, 0]), o = g.useRef(), n = g.useState(Gj++)[0], r = g.useState(S_)[0], i = g.useRef(e);
  g.useEffect(function() {
    i.current = e;
  }, [e]), g.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(n));
      var m = sj([e.lockRef.current], (e.shards || []).map(Qg)).filter(Boolean);
      return m.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(n));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(n)), m.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(n));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = g.useCallback(function(m, b) {
    if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey)
      return !i.current.allowPinchZoom;
    var w = Sr(m), _ = a.current, y = "deltaX" in m ? m.deltaX : _[0] - w[0], k = "deltaY" in m ? m.deltaY : _[1] - w[1], x, S = m.target, $ = Math.abs(y) > Math.abs(k) ? "h" : "v";
    if ("touches" in m && $ === "h" && S.type === "range")
      return !1;
    var E = Yg($, S);
    if (!E)
      return !0;
    if (E ? x = $ : (x = $ === "v" ? "h" : "v", E = Yg($, S)), !E)
      return !1;
    if (!o.current && "changedTouches" in m && (y || k) && (o.current = x), !x)
      return !0;
    var C = o.current || x;
    return Uj(C, b, m, C === "h" ? y : k);
  }, []), l = g.useCallback(function(m) {
    var b = m;
    if (!(!Eo.length || Eo[Eo.length - 1] !== r)) {
      var w = "deltaY" in b ? Xg(b) : Sr(b), _ = t.current.filter(function(x) {
        return x.name === b.type && (x.target === b.target || b.target === x.shadowParent) && qj(x.delta, w);
      })[0];
      if (_ && _.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!_) {
        var y = (i.current.shards || []).map(Qg).filter(Boolean).filter(function(x) {
          return x.contains(b.target);
        }), k = y.length > 0 ? s(b, y[0]) : !i.current.noIsolation;
        k && b.cancelable && b.preventDefault();
      }
    }
  }, []), c = g.useCallback(function(m, b, w, _) {
    var y = { name: m, delta: b, target: w, should: _, shadowParent: Jj(w) };
    t.current.push(y), setTimeout(function() {
      t.current = t.current.filter(function(k) {
        return k !== y;
      });
    }, 1);
  }, []), u = g.useCallback(function(m) {
    a.current = Sr(m), o.current = void 0;
  }, []), d = g.useCallback(function(m) {
    c(m.type, Xg(m), m.target, s(m, e.lockRef.current));
  }, []), h = g.useCallback(function(m) {
    c(m.type, Sr(m), m.target, s(m, e.lockRef.current));
  }, []);
  g.useEffect(function() {
    return Eo.push(r), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, Co), document.addEventListener("touchmove", l, Co), document.addEventListener("touchstart", u, Co), function() {
      Eo = Eo.filter(function(m) {
        return m !== r;
      }), document.removeEventListener("wheel", l, Co), document.removeEventListener("touchmove", l, Co), document.removeEventListener("touchstart", u, Co);
    };
  }, []);
  var p = e.removeScrollBar, f = e.inert;
  return g.createElement(
    g.Fragment,
    null,
    f ? g.createElement(r, { styles: Hj(n) }) : null,
    p ? g.createElement(Tj, { gapMode: e.gapMode }) : null
  );
}
function Jj(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const Zj = $j($_, Kj);
var j_ = g.forwardRef(function(e, t) {
  return g.createElement(ys, ct({}, e, { ref: t, sideCar: Zj }));
});
j_.classNames = ys.classNames;
var Yj = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, zo = /* @__PURE__ */ new WeakMap(), Cr = /* @__PURE__ */ new WeakMap(), Er = {}, vl = 0, A_ = function(e) {
  return e && (e.host || A_(e.parentNode));
}, Xj = function(e, t) {
  return t.map(function(a) {
    if (e.contains(a))
      return a;
    var o = A_(a);
    return o && e.contains(o) ? o : (console.error("aria-hidden", a, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(a) {
    return !!a;
  });
}, Qj = function(e, t, a, o) {
  var n = Xj(t, Array.isArray(e) ? e : [e]);
  Er[a] || (Er[a] = /* @__PURE__ */ new WeakMap());
  var r = Er[a], i = [], s = /* @__PURE__ */ new Set(), l = new Set(n), c = function(d) {
    !d || s.has(d) || (s.add(d), c(d.parentNode));
  };
  n.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(h) {
      if (s.has(h))
        u(h);
      else
        try {
          var p = h.getAttribute(o), f = p !== null && p !== "false", m = (zo.get(h) || 0) + 1, b = (r.get(h) || 0) + 1;
          zo.set(h, m), r.set(h, b), i.push(h), m === 1 && f && Cr.set(h, !0), b === 1 && h.setAttribute(a, "true"), f || h.setAttribute(o, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", h, w);
        }
    });
  };
  return u(t), s.clear(), vl++, function() {
    i.forEach(function(d) {
      var h = zo.get(d) - 1, p = r.get(d) - 1;
      zo.set(d, h), r.set(d, p), h || (Cr.has(d) || d.removeAttribute(o), Cr.delete(d)), p || d.removeAttribute(a);
    }), vl--, vl || (zo = /* @__PURE__ */ new WeakMap(), zo = /* @__PURE__ */ new WeakMap(), Cr = /* @__PURE__ */ new WeakMap(), Er = {});
  };
}, eA = function(e, t, a) {
  a === void 0 && (a = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), n = Yj(e);
  return n ? (o.push.apply(o, Array.from(n.querySelectorAll("[aria-live]"))), Qj(o, n, a, "aria-hidden")) : function() {
    return null;
  };
}, O_ = "Dialog", [P_, zrt] = _o(O_), [jrt, ea] = P_(O_), D_ = "DialogTrigger", tA = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = ea(D_, a), r = He(t, n.triggerRef);
    return /* @__PURE__ */ v(
      Ae.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": n.open,
        "aria-controls": n.contentId,
        "data-state": Iu(n.open),
        ...o,
        ref: r,
        onClick: be(e.onClick, n.onOpenToggle)
      }
    );
  }
);
tA.displayName = D_;
var aA = "DialogPortal", [Art, N_] = P_(aA, {
  forceMount: void 0
}), Ei = "DialogOverlay", oA = g.forwardRef(
  (e, t) => {
    const a = N_(Ei, e.__scopeDialog), { forceMount: o = a.forceMount, ...n } = e, r = ea(Ei, e.__scopeDialog);
    return r.modal ? /* @__PURE__ */ v(_a, { present: o || r.open, children: /* @__PURE__ */ v(rA, { ...n, ref: t }) }) : null;
  }
);
oA.displayName = Ei;
var nA = /* @__PURE__ */ $i("DialogOverlay.RemoveScroll"), rA = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = ea(Ei, a);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ v(j_, { as: nA, allowPinchZoom: !0, shards: [n.contentRef], children: /* @__PURE__ */ v(
        Ae.div,
        {
          "data-state": Iu(n.open),
          ...o,
          ref: t,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }
), no = "DialogContent", iA = g.forwardRef(
  (e, t) => {
    const a = N_(no, e.__scopeDialog), { forceMount: o = a.forceMount, ...n } = e, r = ea(no, e.__scopeDialog);
    return /* @__PURE__ */ v(_a, { present: o || r.open, children: r.modal ? /* @__PURE__ */ v(sA, { ...n, ref: t }) : /* @__PURE__ */ v(lA, { ...n, ref: t }) });
  }
);
iA.displayName = no;
var sA = g.forwardRef(
  (e, t) => {
    const a = ea(no, e.__scopeDialog), o = g.useRef(null), n = He(t, a.contentRef, o);
    return g.useEffect(() => {
      const r = o.current;
      if (r) return eA(r);
    }, []), /* @__PURE__ */ v(
      R_,
      {
        ...e,
        ref: n,
        trapFocus: a.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: be(e.onCloseAutoFocus, (r) => {
          r.preventDefault(), a.triggerRef.current?.focus();
        }),
        onPointerDownOutside: be(e.onPointerDownOutside, (r) => {
          const i = r.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || s) && r.preventDefault();
        }),
        onFocusOutside: be(
          e.onFocusOutside,
          (r) => r.preventDefault()
        )
      }
    );
  }
), lA = g.forwardRef(
  (e, t) => {
    const a = ea(no, e.__scopeDialog), o = g.useRef(!1), n = g.useRef(!1);
    return /* @__PURE__ */ v(
      R_,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (r) => {
          e.onCloseAutoFocus?.(r), r.defaultPrevented || (o.current || a.triggerRef.current?.focus(), r.preventDefault()), o.current = !1, n.current = !1;
        },
        onInteractOutside: (r) => {
          e.onInteractOutside?.(r), r.defaultPrevented || (o.current = !0, r.detail.originalEvent.type === "pointerdown" && (n.current = !0));
          const i = r.target;
          a.triggerRef.current?.contains(i) && r.preventDefault(), r.detail.originalEvent.type === "focusin" && n.current && r.preventDefault();
        }
      }
    );
  }
), R_ = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, trapFocus: o, onOpenAutoFocus: n, onCloseAutoFocus: r, ...i } = e, s = ea(no, a), l = g.useRef(null), c = He(t, l);
    return pj(), /* @__PURE__ */ T(De, { children: [
      /* @__PURE__ */ v(
        w_,
        {
          asChild: !0,
          loop: !0,
          trapped: o,
          onMountAutoFocus: n,
          onUnmountAutoFocus: r,
          children: /* @__PURE__ */ v(
            Nu,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": Iu(s.open),
              ...i,
              ref: c,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ T(De, { children: [
        /* @__PURE__ */ v(gA, { titleId: s.titleId }),
        /* @__PURE__ */ v(mA, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), Ru = "DialogTitle", cA = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = ea(Ru, a);
    return /* @__PURE__ */ v(Ae.h2, { id: n.titleId, ...o, ref: t });
  }
);
cA.displayName = Ru;
var I_ = "DialogDescription", uA = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = ea(I_, a);
    return /* @__PURE__ */ v(Ae.p, { id: n.descriptionId, ...o, ref: t });
  }
);
uA.displayName = I_;
var T_ = "DialogClose", dA = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = ea(T_, a);
    return /* @__PURE__ */ v(
      Ae.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: be(e.onClick, () => n.onOpenChange(!1))
      }
    );
  }
);
dA.displayName = T_;
function Iu(e) {
  return e ? "open" : "closed";
}
var M_ = "DialogTitleWarning", [Ort, L_] = ZE(M_, {
  contentName: no,
  titleName: Ru,
  docsSlug: "dialog"
}), gA = ({ titleId: e }) => {
  const t = L_(M_), a = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return g.useEffect(() => {
    e && (document.getElementById(e) || console.error(a));
  }, [a, e]), null;
}, hA = "DialogDescriptionWarning", mA = ({ contentRef: e, descriptionId: t }) => {
  const a = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${L_(hA).contentName}}.`;
  return g.useEffect(() => {
    const o = e.current?.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(a));
  }, [a, e, t]), null;
};
function pA(e) {
  return e && e.__esModule && Object.prototype.hasOwnProperty.call(e, "default") ? e.default : e;
}
function da(e, t) {
  if (e == null) return {};
  var a = {};
  for (var o in e) if ({}.hasOwnProperty.call(e, o)) {
    if (t.indexOf(o) !== -1) continue;
    a[o] = e[o];
  }
  return a;
}
function me() {
  return me = Object.assign ? Object.assign.bind() : function(e) {
    for (var t = 1; t < arguments.length; t++) {
      var a = arguments[t];
      for (var o in a) ({}).hasOwnProperty.call(a, o) && (e[o] = a[o]);
    }
    return e;
  }, me.apply(null, arguments);
}
function yc(e, t) {
  return yc = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(a, o) {
    return a.__proto__ = o, a;
  }, yc(e, t);
}
function fA(e, t) {
  e.prototype = Object.create(t.prototype), e.prototype.constructor = e, yc(e, t);
}
var zr = { exports: {} }, yl = { exports: {} }, ke = {};
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var eh;
function bA() {
  if (eh) return ke;
  eh = 1;
  var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, a = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, r = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, f = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
  function y(x) {
    if (typeof x == "object" && x !== null) {
      var S = x.$$typeof;
      switch (S) {
        case t:
          switch (x = x.type, x) {
            case l:
            case c:
            case o:
            case r:
            case n:
            case d:
              return x;
            default:
              switch (x = x && x.$$typeof, x) {
                case s:
                case u:
                case f:
                case p:
                case i:
                  return x;
                default:
                  return S;
              }
          }
        case a:
          return S;
      }
    }
  }
  function k(x) {
    return y(x) === c;
  }
  return ke.AsyncMode = l, ke.ConcurrentMode = c, ke.ContextConsumer = s, ke.ContextProvider = i, ke.Element = t, ke.ForwardRef = u, ke.Fragment = o, ke.Lazy = f, ke.Memo = p, ke.Portal = a, ke.Profiler = r, ke.StrictMode = n, ke.Suspense = d, ke.isAsyncMode = function(x) {
    return k(x) || y(x) === l;
  }, ke.isConcurrentMode = k, ke.isContextConsumer = function(x) {
    return y(x) === s;
  }, ke.isContextProvider = function(x) {
    return y(x) === i;
  }, ke.isElement = function(x) {
    return typeof x == "object" && x !== null && x.$$typeof === t;
  }, ke.isForwardRef = function(x) {
    return y(x) === u;
  }, ke.isFragment = function(x) {
    return y(x) === o;
  }, ke.isLazy = function(x) {
    return y(x) === f;
  }, ke.isMemo = function(x) {
    return y(x) === p;
  }, ke.isPortal = function(x) {
    return y(x) === a;
  }, ke.isProfiler = function(x) {
    return y(x) === r;
  }, ke.isStrictMode = function(x) {
    return y(x) === n;
  }, ke.isSuspense = function(x) {
    return y(x) === d;
  }, ke.isValidElementType = function(x) {
    return typeof x == "string" || typeof x == "function" || x === o || x === c || x === r || x === n || x === d || x === h || typeof x == "object" && x !== null && (x.$$typeof === f || x.$$typeof === p || x.$$typeof === i || x.$$typeof === s || x.$$typeof === u || x.$$typeof === b || x.$$typeof === w || x.$$typeof === _ || x.$$typeof === m);
  }, ke.typeOf = y, ke;
}
var Ee = {};
/** @license React v16.13.1
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var th;
function _A() {
  return th || (th = 1, process.env.NODE_ENV !== "production" && function() {
    var e = typeof Symbol == "function" && Symbol.for, t = e ? Symbol.for("react.element") : 60103, a = e ? Symbol.for("react.portal") : 60106, o = e ? Symbol.for("react.fragment") : 60107, n = e ? Symbol.for("react.strict_mode") : 60108, r = e ? Symbol.for("react.profiler") : 60114, i = e ? Symbol.for("react.provider") : 60109, s = e ? Symbol.for("react.context") : 60110, l = e ? Symbol.for("react.async_mode") : 60111, c = e ? Symbol.for("react.concurrent_mode") : 60111, u = e ? Symbol.for("react.forward_ref") : 60112, d = e ? Symbol.for("react.suspense") : 60113, h = e ? Symbol.for("react.suspense_list") : 60120, p = e ? Symbol.for("react.memo") : 60115, f = e ? Symbol.for("react.lazy") : 60116, m = e ? Symbol.for("react.block") : 60121, b = e ? Symbol.for("react.fundamental") : 60117, w = e ? Symbol.for("react.responder") : 60118, _ = e ? Symbol.for("react.scope") : 60119;
    function y(V) {
      return typeof V == "string" || typeof V == "function" || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
      V === o || V === c || V === r || V === n || V === d || V === h || typeof V == "object" && V !== null && (V.$$typeof === f || V.$$typeof === p || V.$$typeof === i || V.$$typeof === s || V.$$typeof === u || V.$$typeof === b || V.$$typeof === w || V.$$typeof === _ || V.$$typeof === m);
    }
    function k(V) {
      if (typeof V == "object" && V !== null) {
        var fe = V.$$typeof;
        switch (fe) {
          case t:
            var X = V.type;
            switch (X) {
              case l:
              case c:
              case o:
              case r:
              case n:
              case d:
                return X;
              default:
                var Ye = X && X.$$typeof;
                switch (Ye) {
                  case s:
                  case u:
                  case f:
                  case p:
                  case i:
                    return Ye;
                  default:
                    return fe;
                }
            }
          case a:
            return fe;
        }
      }
    }
    var x = l, S = c, $ = s, E = i, C = t, z = u, R = o, H = f, M = p, j = a, U = r, I = n, K = d, q = !1;
    function te(V) {
      return q || (q = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 17+. Update your code to use ReactIs.isConcurrentMode() instead. It has the exact same API.")), O(V) || k(V) === l;
    }
    function O(V) {
      return k(V) === c;
    }
    function A(V) {
      return k(V) === s;
    }
    function N(V) {
      return k(V) === i;
    }
    function B(V) {
      return typeof V == "object" && V !== null && V.$$typeof === t;
    }
    function W(V) {
      return k(V) === u;
    }
    function Z(V) {
      return k(V) === o;
    }
    function ee(V) {
      return k(V) === f;
    }
    function L(V) {
      return k(V) === p;
    }
    function Y(V) {
      return k(V) === a;
    }
    function Q(V) {
      return k(V) === r;
    }
    function J(V) {
      return k(V) === n;
    }
    function ae(V) {
      return k(V) === d;
    }
    Ee.AsyncMode = x, Ee.ConcurrentMode = S, Ee.ContextConsumer = $, Ee.ContextProvider = E, Ee.Element = C, Ee.ForwardRef = z, Ee.Fragment = R, Ee.Lazy = H, Ee.Memo = M, Ee.Portal = j, Ee.Profiler = U, Ee.StrictMode = I, Ee.Suspense = K, Ee.isAsyncMode = te, Ee.isConcurrentMode = O, Ee.isContextConsumer = A, Ee.isContextProvider = N, Ee.isElement = B, Ee.isForwardRef = W, Ee.isFragment = Z, Ee.isLazy = ee, Ee.isMemo = L, Ee.isPortal = Y, Ee.isProfiler = Q, Ee.isStrictMode = J, Ee.isSuspense = ae, Ee.isValidElementType = y, Ee.typeOf = k;
  }()), Ee;
}
var ah;
function W_() {
  return ah || (ah = 1, process.env.NODE_ENV === "production" ? yl.exports = bA() : yl.exports = _A()), yl.exports;
}
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
var wl, oh;
function vA() {
  if (oh) return wl;
  oh = 1;
  var e = Object.getOwnPropertySymbols, t = Object.prototype.hasOwnProperty, a = Object.prototype.propertyIsEnumerable;
  function o(r) {
    if (r == null)
      throw new TypeError("Object.assign cannot be called with null or undefined");
    return Object(r);
  }
  function n() {
    try {
      if (!Object.assign)
        return !1;
      var r = new String("abc");
      if (r[5] = "de", Object.getOwnPropertyNames(r)[0] === "5")
        return !1;
      for (var i = {}, s = 0; s < 10; s++)
        i["_" + String.fromCharCode(s)] = s;
      var l = Object.getOwnPropertyNames(i).map(function(u) {
        return i[u];
      });
      if (l.join("") !== "0123456789")
        return !1;
      var c = {};
      return "abcdefghijklmnopqrst".split("").forEach(function(u) {
        c[u] = u;
      }), Object.keys(Object.assign({}, c)).join("") === "abcdefghijklmnopqrst";
    } catch {
      return !1;
    }
  }
  return wl = n() ? Object.assign : function(r, i) {
    for (var s, l = o(r), c, u = 1; u < arguments.length; u++) {
      s = Object(arguments[u]);
      for (var d in s)
        t.call(s, d) && (l[d] = s[d]);
      if (e) {
        c = e(s);
        for (var h = 0; h < c.length; h++)
          a.call(s, c[h]) && (l[c[h]] = s[c[h]]);
      }
    }
    return l;
  }, wl;
}
var kl, nh;
function Tu() {
  if (nh) return kl;
  nh = 1;
  var e = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
  return kl = e, kl;
}
var rh, ih;
function B_() {
  return ih || (ih = 1, rh = Function.call.bind(Object.prototype.hasOwnProperty)), rh;
}
var xl, sh;
function yA() {
  if (sh) return xl;
  sh = 1;
  var e = function() {
  };
  if (process.env.NODE_ENV !== "production") {
    var t = /* @__PURE__ */ Tu(), a = {}, o = /* @__PURE__ */ B_();
    e = function(r) {
      var i = "Warning: " + r;
      typeof console < "u" && console.error(i);
      try {
        throw new Error(i);
      } catch {
      }
    };
  }
  function n(r, i, s, l, c) {
    if (process.env.NODE_ENV !== "production") {
      for (var u in r)
        if (o(r, u)) {
          var d;
          try {
            if (typeof r[u] != "function") {
              var h = Error(
                (l || "React class") + ": " + s + " type `" + u + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof r[u] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`."
              );
              throw h.name = "Invariant Violation", h;
            }
            d = r[u](i, u, l, s, null, t);
          } catch (f) {
            d = f;
          }
          if (d && !(d instanceof Error) && e(
            (l || "React class") + ": type specification of " + s + " `" + u + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof d + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."
          ), d instanceof Error && !(d.message in a)) {
            a[d.message] = !0;
            var p = c ? c() : "";
            e(
              "Failed " + s + " type: " + d.message + (p ?? "")
            );
          }
        }
    }
  }
  return n.resetWarningCache = function() {
    process.env.NODE_ENV !== "production" && (a = {});
  }, xl = n, xl;
}
var $l, lh;
function wA() {
  if (lh) return $l;
  lh = 1;
  var e = W_(), t = vA(), a = /* @__PURE__ */ Tu(), o = /* @__PURE__ */ B_(), n = /* @__PURE__ */ yA(), r = function() {
  };
  process.env.NODE_ENV !== "production" && (r = function(s) {
    var l = "Warning: " + s;
    typeof console < "u" && console.error(l);
    try {
      throw new Error(l);
    } catch {
    }
  });
  function i() {
    return null;
  }
  return $l = function(s, l) {
    var c = typeof Symbol == "function" && Symbol.iterator, u = "@@iterator";
    function d(O) {
      var A = O && (c && O[c] || O[u]);
      if (typeof A == "function")
        return A;
    }
    var h = "<<anonymous>>", p = {
      array: w("array"),
      bigint: w("bigint"),
      bool: w("boolean"),
      func: w("function"),
      number: w("number"),
      object: w("object"),
      string: w("string"),
      symbol: w("symbol"),
      any: _(),
      arrayOf: y,
      element: k(),
      elementType: x(),
      instanceOf: S,
      node: z(),
      objectOf: E,
      oneOf: $,
      oneOfType: C,
      shape: H,
      exact: M
    };
    function f(O, A) {
      return O === A ? O !== 0 || 1 / O === 1 / A : O !== O && A !== A;
    }
    function m(O, A) {
      this.message = O, this.data = A && typeof A == "object" ? A : {}, this.stack = "";
    }
    m.prototype = Error.prototype;
    function b(O) {
      if (process.env.NODE_ENV !== "production")
        var A = {}, N = 0;
      function B(Z, ee, L, Y, Q, J, ae) {
        if (Y = Y || h, J = J || L, ae !== a) {
          if (l) {
            var V = new Error(
              "Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types"
            );
            throw V.name = "Invariant Violation", V;
          } else if (process.env.NODE_ENV !== "production" && typeof console < "u") {
            var fe = Y + ":" + L;
            !A[fe] && // Avoid spamming the console because they are often not actionable except for lib authors
            N < 3 && (r(
              "You are manually calling a React.PropTypes validation function for the `" + J + "` prop on `" + Y + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."
            ), A[fe] = !0, N++);
          }
        }
        return ee[L] == null ? Z ? ee[L] === null ? new m("The " + Q + " `" + J + "` is marked as required " + ("in `" + Y + "`, but its value is `null`.")) : new m("The " + Q + " `" + J + "` is marked as required in " + ("`" + Y + "`, but its value is `undefined`.")) : null : O(ee, L, Y, Q, J);
      }
      var W = B.bind(null, !1);
      return W.isRequired = B.bind(null, !0), W;
    }
    function w(O) {
      function A(N, B, W, Z, ee, L) {
        var Y = N[B], Q = I(Y);
        if (Q !== O) {
          var J = K(Y);
          return new m(
            "Invalid " + Z + " `" + ee + "` of type " + ("`" + J + "` supplied to `" + W + "`, expected ") + ("`" + O + "`."),
            { expectedType: O }
          );
        }
        return null;
      }
      return b(A);
    }
    function _() {
      return b(i);
    }
    function y(O) {
      function A(N, B, W, Z, ee) {
        if (typeof O != "function")
          return new m("Property `" + ee + "` of component `" + W + "` has invalid PropType notation inside arrayOf.");
        var L = N[B];
        if (!Array.isArray(L)) {
          var Y = I(L);
          return new m("Invalid " + Z + " `" + ee + "` of type " + ("`" + Y + "` supplied to `" + W + "`, expected an array."));
        }
        for (var Q = 0; Q < L.length; Q++) {
          var J = O(L, Q, W, Z, ee + "[" + Q + "]", a);
          if (J instanceof Error)
            return J;
        }
        return null;
      }
      return b(A);
    }
    function k() {
      function O(A, N, B, W, Z) {
        var ee = A[N];
        if (!s(ee)) {
          var L = I(ee);
          return new m("Invalid " + W + " `" + Z + "` of type " + ("`" + L + "` supplied to `" + B + "`, expected a single ReactElement."));
        }
        return null;
      }
      return b(O);
    }
    function x() {
      function O(A, N, B, W, Z) {
        var ee = A[N];
        if (!e.isValidElementType(ee)) {
          var L = I(ee);
          return new m("Invalid " + W + " `" + Z + "` of type " + ("`" + L + "` supplied to `" + B + "`, expected a single ReactElement type."));
        }
        return null;
      }
      return b(O);
    }
    function S(O) {
      function A(N, B, W, Z, ee) {
        if (!(N[B] instanceof O)) {
          var L = O.name || h, Y = te(N[B]);
          return new m("Invalid " + Z + " `" + ee + "` of type " + ("`" + Y + "` supplied to `" + W + "`, expected ") + ("instance of `" + L + "`."));
        }
        return null;
      }
      return b(A);
    }
    function $(O) {
      if (!Array.isArray(O))
        return process.env.NODE_ENV !== "production" && (arguments.length > 1 ? r(
          "Invalid arguments supplied to oneOf, expected an array, got " + arguments.length + " arguments. A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z])."
        ) : r("Invalid argument supplied to oneOf, expected an array.")), i;
      function A(N, B, W, Z, ee) {
        for (var L = N[B], Y = 0; Y < O.length; Y++)
          if (f(L, O[Y]))
            return null;
        var Q = JSON.stringify(O, function(J, ae) {
          var V = K(ae);
          return V === "symbol" ? String(ae) : ae;
        });
        return new m("Invalid " + Z + " `" + ee + "` of value `" + String(L) + "` " + ("supplied to `" + W + "`, expected one of " + Q + "."));
      }
      return b(A);
    }
    function E(O) {
      function A(N, B, W, Z, ee) {
        if (typeof O != "function")
          return new m("Property `" + ee + "` of component `" + W + "` has invalid PropType notation inside objectOf.");
        var L = N[B], Y = I(L);
        if (Y !== "object")
          return new m("Invalid " + Z + " `" + ee + "` of type " + ("`" + Y + "` supplied to `" + W + "`, expected an object."));
        for (var Q in L)
          if (o(L, Q)) {
            var J = O(L, Q, W, Z, ee + "." + Q, a);
            if (J instanceof Error)
              return J;
          }
        return null;
      }
      return b(A);
    }
    function C(O) {
      if (!Array.isArray(O))
        return process.env.NODE_ENV !== "production" && r("Invalid argument supplied to oneOfType, expected an instance of array."), i;
      for (var A = 0; A < O.length; A++) {
        var N = O[A];
        if (typeof N != "function")
          return r(
            "Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + q(N) + " at index " + A + "."
          ), i;
      }
      function B(W, Z, ee, L, Y) {
        for (var Q = [], J = 0; J < O.length; J++) {
          var ae = O[J], V = ae(W, Z, ee, L, Y, a);
          if (V == null)
            return null;
          V.data && o(V.data, "expectedType") && Q.push(V.data.expectedType);
        }
        var fe = Q.length > 0 ? ", expected one of type [" + Q.join(", ") + "]" : "";
        return new m("Invalid " + L + " `" + Y + "` supplied to " + ("`" + ee + "`" + fe + "."));
      }
      return b(B);
    }
    function z() {
      function O(A, N, B, W, Z) {
        return j(A[N]) ? null : new m("Invalid " + W + " `" + Z + "` supplied to " + ("`" + B + "`, expected a ReactNode."));
      }
      return b(O);
    }
    function R(O, A, N, B, W) {
      return new m(
        (O || "React class") + ": " + A + " type `" + N + "." + B + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + W + "`."
      );
    }
    function H(O) {
      function A(N, B, W, Z, ee) {
        var L = N[B], Y = I(L);
        if (Y !== "object")
          return new m("Invalid " + Z + " `" + ee + "` of type `" + Y + "` " + ("supplied to `" + W + "`, expected `object`."));
        for (var Q in O) {
          var J = O[Q];
          if (typeof J != "function")
            return R(W, Z, ee, Q, K(J));
          var ae = J(L, Q, W, Z, ee + "." + Q, a);
          if (ae)
            return ae;
        }
        return null;
      }
      return b(A);
    }
    function M(O) {
      function A(N, B, W, Z, ee) {
        var L = N[B], Y = I(L);
        if (Y !== "object")
          return new m("Invalid " + Z + " `" + ee + "` of type `" + Y + "` " + ("supplied to `" + W + "`, expected `object`."));
        var Q = t({}, N[B], O);
        for (var J in Q) {
          var ae = O[J];
          if (o(O, J) && typeof ae != "function")
            return R(W, Z, ee, J, K(ae));
          if (!ae)
            return new m(
              "Invalid " + Z + " `" + ee + "` key `" + J + "` supplied to `" + W + "`.\nBad object: " + JSON.stringify(N[B], null, "  ") + `
Valid keys: ` + JSON.stringify(Object.keys(O), null, "  ")
            );
          var V = ae(L, J, W, Z, ee + "." + J, a);
          if (V)
            return V;
        }
        return null;
      }
      return b(A);
    }
    function j(O) {
      switch (typeof O) {
        case "number":
        case "string":
        case "undefined":
          return !0;
        case "boolean":
          return !O;
        case "object":
          if (Array.isArray(O))
            return O.every(j);
          if (O === null || s(O))
            return !0;
          var A = d(O);
          if (A) {
            var N = A.call(O), B;
            if (A !== O.entries) {
              for (; !(B = N.next()).done; )
                if (!j(B.value))
                  return !1;
            } else
              for (; !(B = N.next()).done; ) {
                var W = B.value;
                if (W && !j(W[1]))
                  return !1;
              }
          } else
            return !1;
          return !0;
        default:
          return !1;
      }
    }
    function U(O, A) {
      return O === "symbol" ? !0 : A ? A["@@toStringTag"] === "Symbol" || typeof Symbol == "function" && A instanceof Symbol : !1;
    }
    function I(O) {
      var A = typeof O;
      return Array.isArray(O) ? "array" : O instanceof RegExp ? "object" : U(A, O) ? "symbol" : A;
    }
    function K(O) {
      if (typeof O > "u" || O === null)
        return "" + O;
      var A = I(O);
      if (A === "object") {
        if (O instanceof Date)
          return "date";
        if (O instanceof RegExp)
          return "regexp";
      }
      return A;
    }
    function q(O) {
      var A = K(O);
      switch (A) {
        case "array":
        case "object":
          return "an " + A;
        case "boolean":
        case "date":
        case "regexp":
          return "a " + A;
        default:
          return A;
      }
    }
    function te(O) {
      return !O.constructor || !O.constructor.name ? h : O.constructor.name;
    }
    return p.checkPropTypes = n, p.resetWarningCache = n.resetWarningCache, p.PropTypes = p, p;
  }, $l;
}
var Sl, ch;
function kA() {
  if (ch) return Sl;
  ch = 1;
  var e = /* @__PURE__ */ Tu();
  function t() {
  }
  function a() {
  }
  return a.resetWarningCache = t, Sl = function() {
    function o(i, s, l, c, u, d) {
      if (d !== e) {
        var h = new Error(
          "Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types"
        );
        throw h.name = "Invariant Violation", h;
      }
    }
    o.isRequired = o;
    function n() {
      return o;
    }
    var r = {
      array: o,
      bigint: o,
      bool: o,
      func: o,
      number: o,
      object: o,
      string: o,
      symbol: o,
      any: o,
      arrayOf: n,
      element: o,
      elementType: o,
      instanceOf: n,
      node: o,
      objectOf: n,
      oneOf: n,
      oneOfType: n,
      shape: n,
      exact: n,
      checkPropTypes: a,
      resetWarningCache: t
    };
    return r.PropTypes = r, r;
  }, Sl;
}
var uh;
function xA() {
  if (uh) return zr.exports;
  if (uh = 1, process.env.NODE_ENV !== "production") {
    var e = W_(), t = !0;
    zr.exports = /* @__PURE__ */ wA()(e.isElement, t);
  } else
    zr.exports = /* @__PURE__ */ kA()();
  return zr.exports;
}
var $A = /* @__PURE__ */ xA();
const G = /* @__PURE__ */ pA($A);
var Cl = { exports: {} }, xe = {};
/**
 * @license React
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var dh;
function SA() {
  if (dh) return xe;
  dh = 1;
  var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), n = Symbol.for("react.profiler"), r = Symbol.for("react.provider"), i = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), f;
  f = Symbol.for("react.module.reference");
  function m(b) {
    if (typeof b == "object" && b !== null) {
      var w = b.$$typeof;
      switch (w) {
        case e:
          switch (b = b.type, b) {
            case a:
            case n:
            case o:
            case c:
            case u:
              return b;
            default:
              switch (b = b && b.$$typeof, b) {
                case s:
                case i:
                case l:
                case h:
                case d:
                case r:
                  return b;
                default:
                  return w;
              }
          }
        case t:
          return w;
      }
    }
  }
  return xe.ContextConsumer = i, xe.ContextProvider = r, xe.Element = e, xe.ForwardRef = l, xe.Fragment = a, xe.Lazy = h, xe.Memo = d, xe.Portal = t, xe.Profiler = n, xe.StrictMode = o, xe.Suspense = c, xe.SuspenseList = u, xe.isAsyncMode = function() {
    return !1;
  }, xe.isConcurrentMode = function() {
    return !1;
  }, xe.isContextConsumer = function(b) {
    return m(b) === i;
  }, xe.isContextProvider = function(b) {
    return m(b) === r;
  }, xe.isElement = function(b) {
    return typeof b == "object" && b !== null && b.$$typeof === e;
  }, xe.isForwardRef = function(b) {
    return m(b) === l;
  }, xe.isFragment = function(b) {
    return m(b) === a;
  }, xe.isLazy = function(b) {
    return m(b) === h;
  }, xe.isMemo = function(b) {
    return m(b) === d;
  }, xe.isPortal = function(b) {
    return m(b) === t;
  }, xe.isProfiler = function(b) {
    return m(b) === n;
  }, xe.isStrictMode = function(b) {
    return m(b) === o;
  }, xe.isSuspense = function(b) {
    return m(b) === c;
  }, xe.isSuspenseList = function(b) {
    return m(b) === u;
  }, xe.isValidElementType = function(b) {
    return typeof b == "string" || typeof b == "function" || b === a || b === n || b === o || b === c || b === u || b === p || typeof b == "object" && b !== null && (b.$$typeof === h || b.$$typeof === d || b.$$typeof === r || b.$$typeof === i || b.$$typeof === l || b.$$typeof === f || b.getModuleId !== void 0);
  }, xe.typeOf = m, xe;
}
var ze = {};
/**
 * @license React
 * react-is.development.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var gh;
function CA() {
  return gh || (gh = 1, process.env.NODE_ENV !== "production" && function() {
    var e = Symbol.for("react.element"), t = Symbol.for("react.portal"), a = Symbol.for("react.fragment"), o = Symbol.for("react.strict_mode"), n = Symbol.for("react.profiler"), r = Symbol.for("react.provider"), i = Symbol.for("react.context"), s = Symbol.for("react.server_context"), l = Symbol.for("react.forward_ref"), c = Symbol.for("react.suspense"), u = Symbol.for("react.suspense_list"), d = Symbol.for("react.memo"), h = Symbol.for("react.lazy"), p = Symbol.for("react.offscreen"), f = !1, m = !1, b = !1, w = !1, _ = !1, y;
    y = Symbol.for("react.module.reference");
    function k(X) {
      return !!(typeof X == "string" || typeof X == "function" || X === a || X === n || _ || X === o || X === c || X === u || w || X === p || f || m || b || typeof X == "object" && X !== null && (X.$$typeof === h || X.$$typeof === d || X.$$typeof === r || X.$$typeof === i || X.$$typeof === l || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      X.$$typeof === y || X.getModuleId !== void 0));
    }
    function x(X) {
      if (typeof X == "object" && X !== null) {
        var Ye = X.$$typeof;
        switch (Ye) {
          case e:
            var Ve = X.type;
            switch (Ve) {
              case a:
              case n:
              case o:
              case c:
              case u:
                return Ve;
              default:
                var Ft = Ve && Ve.$$typeof;
                switch (Ft) {
                  case s:
                  case i:
                  case l:
                  case h:
                  case d:
                  case r:
                    return Ft;
                  default:
                    return Ye;
                }
            }
          case t:
            return Ye;
        }
      }
    }
    var S = i, $ = r, E = e, C = l, z = a, R = h, H = d, M = t, j = n, U = o, I = c, K = u, q = !1, te = !1;
    function O(X) {
      return q || (q = !0, console.warn("The ReactIs.isAsyncMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function A(X) {
      return te || (te = !0, console.warn("The ReactIs.isConcurrentMode() alias has been deprecated, and will be removed in React 18+.")), !1;
    }
    function N(X) {
      return x(X) === i;
    }
    function B(X) {
      return x(X) === r;
    }
    function W(X) {
      return typeof X == "object" && X !== null && X.$$typeof === e;
    }
    function Z(X) {
      return x(X) === l;
    }
    function ee(X) {
      return x(X) === a;
    }
    function L(X) {
      return x(X) === h;
    }
    function Y(X) {
      return x(X) === d;
    }
    function Q(X) {
      return x(X) === t;
    }
    function J(X) {
      return x(X) === n;
    }
    function ae(X) {
      return x(X) === o;
    }
    function V(X) {
      return x(X) === c;
    }
    function fe(X) {
      return x(X) === u;
    }
    ze.ContextConsumer = S, ze.ContextProvider = $, ze.Element = E, ze.ForwardRef = C, ze.Fragment = z, ze.Lazy = R, ze.Memo = H, ze.Portal = M, ze.Profiler = j, ze.StrictMode = U, ze.Suspense = I, ze.SuspenseList = K, ze.isAsyncMode = O, ze.isConcurrentMode = A, ze.isContextConsumer = N, ze.isContextProvider = B, ze.isElement = W, ze.isForwardRef = Z, ze.isFragment = ee, ze.isLazy = L, ze.isMemo = Y, ze.isPortal = Q, ze.isProfiler = J, ze.isStrictMode = ae, ze.isSuspense = V, ze.isSuspenseList = fe, ze.isValidElementType = k, ze.typeOf = x;
  }()), ze;
}
var hh;
function EA() {
  return hh || (hh = 1, process.env.NODE_ENV === "production" ? Cl.exports = SA() : Cl.exports = CA()), Cl.exports;
}
var mh = EA();
const ph = (e) => typeof e == "object" && e != null && e.nodeType === 1, fh = (e, t) => (!t || e !== "hidden") && e !== "visible" && e !== "clip", jr = (e, t) => {
  if (e.clientHeight < e.scrollHeight || e.clientWidth < e.scrollWidth) {
    const a = getComputedStyle(e, null);
    return fh(a.overflowY, t) || fh(a.overflowX, t) || ((o) => {
      const n = ((r) => {
        if (!r.ownerDocument || !r.ownerDocument.defaultView) return null;
        try {
          return r.ownerDocument.defaultView.frameElement;
        } catch {
          return null;
        }
      })(o);
      return !!n && (n.clientHeight < o.scrollHeight || n.clientWidth < o.scrollWidth);
    })(e);
  }
  return !1;
}, Ar = (e, t, a, o, n, r, i, s) => r < e && i > t || r > e && i < t ? 0 : r <= e && s <= a || i >= t && s >= a ? r - e - o : i > t && s < a || r < e && s > a ? i - t + n : 0, zA = (e) => e.parentElement ?? (e.getRootNode().host || null), jA = (e, t) => {
  var a, o, n, r;
  if (typeof document > "u") return [];
  const { inline: i, boundary: s, skipOverflowHiddenElements: l } = t, c = typeof s == "function" ? s : (M) => M !== s;
  if (!ph(e)) throw new TypeError("Invalid target");
  const u = document.scrollingElement || document.documentElement, d = [];
  let h = e;
  for (; ph(h) && c(h); ) {
    if (h = zA(h), h === u) {
      d.push(h);
      break;
    }
    h != null && h === document.body && jr(h) && !jr(document.documentElement) || h != null && jr(h, l) && d.push(h);
  }
  const p = (o = (a = window.visualViewport) == null ? void 0 : a.width) != null ? o : innerWidth, f = (r = (n = window.visualViewport) == null ? void 0 : n.height) != null ? r : innerHeight, { scrollX: m, scrollY: b } = window, { height: w, width: _, top: y, right: k, bottom: x, left: S } = e.getBoundingClientRect(), { top: $, right: E, left: C } = ((M) => {
    const j = window.getComputedStyle(M);
    return { top: parseFloat(j.scrollMarginTop) || 0, right: parseFloat(j.scrollMarginRight) || 0, bottom: parseFloat(j.scrollMarginBottom) || 0, left: parseFloat(j.scrollMarginLeft) || 0 };
  })(e);
  let z = y - $, R = i === "center" ? S + _ / 2 - C + E : i === "end" ? k + E : S - C;
  const H = [];
  for (let M = 0; M < d.length; M++) {
    const j = d[M], { height: U, width: I, top: K, right: q, bottom: te, left: O } = j.getBoundingClientRect();
    if (y >= 0 && S >= 0 && x <= f && k <= p && (j === u && !jr(j) || y >= K && x <= te && S >= O && k <= q)) return H;
    const A = getComputedStyle(j), N = parseInt(A.borderLeftWidth, 10), B = parseInt(A.borderTopWidth, 10), W = parseInt(A.borderRightWidth, 10), Z = parseInt(A.borderBottomWidth, 10);
    let ee = 0, L = 0;
    const Y = "offsetWidth" in j ? j.offsetWidth - j.clientWidth - N - W : 0, Q = "offsetHeight" in j ? j.offsetHeight - j.clientHeight - B - Z : 0, J = "offsetWidth" in j ? j.offsetWidth === 0 ? 0 : I / j.offsetWidth : 0, ae = "offsetHeight" in j ? j.offsetHeight === 0 ? 0 : U / j.offsetHeight : 0;
    if (u === j) ee = Ar(b, b + f, f, B, Z, b + z, b + z + w, w), L = i === "start" ? R : i === "center" ? R - p / 2 : i === "end" ? R - p : Ar(m, m + p, p, N, W, m + R, m + R + _, _), ee = Math.max(0, ee + b), L = Math.max(0, L + m);
    else {
      ee = Ar(K, te, U, B, Z + Q, z, z + w, w), L = i === "start" ? R - O - N : i === "center" ? R - (O + I / 2) + Y / 2 : i === "end" ? R - q + W + Y : Ar(O, q, I, N, W + Y, R, R + _, _);
      const { scrollLeft: V, scrollTop: fe } = j;
      ee = ae === 0 ? 0 : Math.max(0, Math.min(fe + ee / ae, j.scrollHeight - U / ae + Q)), L = J === 0 ? 0 : Math.max(0, Math.min(V + L / J, j.scrollWidth - I / J + Y)), z += fe - ee, R += V - L;
    }
    H.push({ el: j, top: ee, left: L });
  }
  return H;
};
var AA = 0;
function bh(e) {
  return typeof e == "function" ? e : wt;
}
function wt() {
}
function F_(e, t) {
  if (e) {
    var a = jA(e, {
      boundary: t
    });
    a.forEach(function(o) {
      var n = o.el, r = o.top, i = o.left;
      n.scrollTop = r, n.scrollLeft = i;
    });
  }
}
function _h(e, t, a) {
  var o = e === t || t instanceof a.Node && e.contains && e.contains(t);
  return o;
}
function Mu(e, t) {
  var a;
  function o() {
    a && clearTimeout(a);
  }
  function n() {
    for (var r = arguments.length, i = new Array(r), s = 0; s < r; s++)
      i[s] = arguments[s];
    o(), a = setTimeout(function() {
      a = null, e.apply(void 0, i);
    }, t);
  }
  return n.cancel = o, n;
}
function Ke() {
  for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
    t[a] = arguments[a];
  return function(o) {
    for (var n = arguments.length, r = new Array(n > 1 ? n - 1 : 0), i = 1; i < n; i++)
      r[i - 1] = arguments[i];
    return t.some(function(s) {
      return s && s.apply(void 0, [o].concat(r)), o.preventDownshiftDefault || o.hasOwnProperty("nativeEvent") && o.nativeEvent.preventDownshiftDefault;
    });
  };
}
function Mo() {
  for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
    t[a] = arguments[a];
  return function(o) {
    t.forEach(function(n) {
      typeof n == "function" ? n(o) : n && (n.current = o);
    });
  };
}
function V_() {
  return String(AA++);
}
function OA(e) {
  var t = e.isOpen, a = e.resultCount, o = e.previousResultCount;
  return t ? a ? a !== o ? a + " result" + (a === 1 ? " is" : "s are") + " available, use up and down arrow keys to navigate. Press Enter key to select." : "" : "No results are available." : "";
}
function vh(e, t) {
  return e = Array.isArray(e) ? (
    /* istanbul ignore next (preact) */
    e[0]
  ) : e, !e && t ? t : e;
}
function U_(e) {
  return typeof e.type == "string";
}
function q_(e) {
  return e.props;
}
function PA(e, t) {
  console.error('The property "' + t + '" is required in "' + e + '"');
}
var DA = ["highlightedIndex", "inputValue", "isOpen", "selectedItem", "type"];
function Or(e) {
  e === void 0 && (e = {});
  var t = {};
  return DA.forEach(function(a) {
    e.hasOwnProperty(a) && (t[a] = e[a]);
  }), t;
}
function zi(e, t) {
  return !e || !t ? e : Object.keys(e).reduce(function(a, o) {
    return a[o] = ji(t, o) ? t[o] : e[o], a;
  }, {});
}
function ji(e, t) {
  return e[t] !== void 0;
}
function wc(e) {
  var t = e.key, a = e.keyCode;
  return a >= 37 && a <= 40 && t.indexOf("Arrow") !== 0 ? "Arrow" + t : t;
}
function NA(e) {
  return Object.prototype.toString.call(e) === "[object Object]";
}
function Ga(e, t, a, o, n) {
  var r = a.length;
  if (r === 0)
    return -1;
  var i = r - 1;
  (typeof e != "number" || e < 0 || e > i) && (e = t > 0 ? -1 : i + 1);
  var s = e + t;
  s < 0 ? s = i : s > i && (s = 0);
  var l = Yo(s, t < 0, a, o, n);
  return l === -1 ? e >= r ? -1 : e : l;
}
function Yo(e, t, a, o, n) {
  n === void 0 && (n = !1);
  var r = a.length;
  if (t) {
    for (var i = e; i >= 0; i--)
      if (!o(a[i], i))
        return i;
  } else
    for (var s = e; s < r; s++)
      if (!o(a[s], s))
        return s;
  return n ? Yo(t ? r - 1 : 0, t, a, o) : -1;
}
function Ai(e, t, a, o) {
  return o === void 0 && (o = !0), a && t.some(function(n) {
    return n && (_h(n, e, a) || o && _h(n, a.document.activeElement, a));
  });
}
var Lu = wt;
process.env.NODE_ENV !== "production" && (Lu = function(e, t, a) {
  var o = "This prop should not switch from controlled to uncontrolled (or vice versa). Decide between using a controlled or uncontrolled Downshift element for the lifetime of the component. More info: https://github.com/downshift-js/downshift#control-props";
  Object.keys(e).forEach(function(n) {
    t[n] !== void 0 && a[n] === void 0 ? console.error('downshift: A component has changed the controlled prop "' + n + '" to be uncontrolled. ' + o) : t[n] === void 0 && a[n] !== void 0 && console.error('downshift: A component has changed the uncontrolled prop "' + n + '" to be controlled. ' + o);
  });
});
var RA = Mu(function(e) {
  H_(e).textContent = "";
}, 500);
function H_(e) {
  var t = e.getElementById("a11y-status-message");
  return t || (t = e.createElement("div"), t.setAttribute("id", "a11y-status-message"), t.setAttribute("role", "status"), t.setAttribute("aria-live", "polite"), t.setAttribute("aria-relevant", "additions text"), Object.assign(t.style, {
    border: "0",
    clip: "rect(0 0 0 0)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: "0",
    position: "absolute",
    width: "1px"
  }), e.body.appendChild(t), t);
}
function G_(e, t) {
  if (!(!e || !t)) {
    var a = H_(t);
    a.textContent = e, RA(t);
  }
}
function IA(e) {
  var t = e?.getElementById("a11y-status-message");
  t && t.remove();
}
var K_ = process.env.NODE_ENV !== "production" ? "__autocomplete_unknown__" : 0, J_ = process.env.NODE_ENV !== "production" ? "__autocomplete_mouseup__" : 1, Z_ = process.env.NODE_ENV !== "production" ? "__autocomplete_item_mouseenter__" : 2, oi = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_up__" : 3, ni = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_arrow_down__" : 4, Y_ = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_escape__" : 5, X_ = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_enter__" : 6, Q_ = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_home__" : 7, ev = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_end__" : 8, tv = process.env.NODE_ENV !== "production" ? "__autocomplete_click_item__" : 9, av = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_input__" : 10, ov = process.env.NODE_ENV !== "production" ? "__autocomplete_change_input__" : 11, nv = process.env.NODE_ENV !== "production" ? "__autocomplete_keydown_space_button__" : 12, kc = process.env.NODE_ENV !== "production" ? "__autocomplete_click_button__" : 13, rv = process.env.NODE_ENV !== "production" ? "__autocomplete_blur_button__" : 14, iv = process.env.NODE_ENV !== "production" ? "__autocomplete_controlled_prop_updated_selected_item__" : 15, sv = process.env.NODE_ENV !== "production" ? "__autocomplete_touchend__" : 16, TA = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  blurButton: rv,
  blurInput: av,
  changeInput: ov,
  clickButton: kc,
  clickItem: tv,
  controlledPropUpdatedSelectedItem: iv,
  itemMouseEnter: Z_,
  keyDownArrowDown: ni,
  keyDownArrowUp: oi,
  keyDownEnd: ev,
  keyDownEnter: X_,
  keyDownEscape: Y_,
  keyDownHome: Q_,
  keyDownSpaceButton: nv,
  mouseUp: J_,
  touchEnd: sv,
  unknown: K_
}), MA = ["refKey", "ref"], LA = ["onClick", "onPress", "onKeyDown", "onKeyUp", "onBlur"], WA = ["onKeyDown", "onBlur", "onChange", "onInput", "onChangeText"], BA = ["refKey", "ref"], FA = ["onMouseMove", "onMouseDown", "onClick", "onPress", "index", "item"], VA = /* @__PURE__ */ function() {
  var e = /* @__PURE__ */ function(t) {
    function a(n) {
      var r;
      r = t.call(this, n) || this, r.id = r.props.id || "downshift-" + V_(), r.menuId = r.props.menuId || r.id + "-menu", r.labelId = r.props.labelId || r.id + "-label", r.inputId = r.props.inputId || r.id + "-input", r.getItemId = r.props.getItemId || function(_) {
        return r.id + "-item-" + _;
      }, r.items = [], r.itemCount = null, r.previousResultCount = 0, r.timeoutIds = [], r.internalSetTimeout = function(_, y) {
        var k = setTimeout(function() {
          r.timeoutIds = r.timeoutIds.filter(function(x) {
            return x !== k;
          }), _();
        }, y);
        r.timeoutIds.push(k);
      }, r.setItemCount = function(_) {
        r.itemCount = _;
      }, r.unsetItemCount = function() {
        r.itemCount = null;
      }, r.isItemDisabled = function(_, y) {
        var k = r.getItemNodeFromIndex(y);
        return k && k.hasAttribute("disabled");
      }, r.setHighlightedIndex = function(_, y) {
        _ === void 0 && (_ = r.props.defaultHighlightedIndex), y === void 0 && (y = {}), y = Or(y), r.internalSetState(me({
          highlightedIndex: _
        }, y));
      }, r.clearSelection = function(_) {
        r.internalSetState({
          selectedItem: null,
          inputValue: "",
          highlightedIndex: r.props.defaultHighlightedIndex,
          isOpen: r.props.defaultIsOpen
        }, _);
      }, r.selectItem = function(_, y, k) {
        y = Or(y), r.internalSetState(me({
          isOpen: r.props.defaultIsOpen,
          highlightedIndex: r.props.defaultHighlightedIndex,
          selectedItem: _,
          inputValue: r.props.itemToString(_)
        }, y), k);
      }, r.selectItemAtIndex = function(_, y, k) {
        var x = r.items[_];
        x != null && r.selectItem(x, y, k);
      }, r.selectHighlightedItem = function(_, y) {
        return r.selectItemAtIndex(r.getState().highlightedIndex, _, y);
      }, r.internalSetState = function(_, y) {
        var k, x, S = {}, $ = typeof _ == "function";
        return !$ && _.hasOwnProperty("inputValue") && r.props.onInputValueChange(_.inputValue, me({}, r.getStateAndHelpers(), _)), r.setState(function(E) {
          var C;
          E = r.getState(E);
          var z = $ ? _(E) : _;
          z = r.props.stateReducer(E, z), k = z.hasOwnProperty("selectedItem");
          var R = {};
          return k && z.selectedItem !== E.selectedItem && (x = z.selectedItem), (C = z).type || (C.type = K_), Object.keys(z).forEach(function(H) {
            E[H] !== z[H] && (S[H] = z[H]), H !== "type" && (z[H], ji(r.props, H) || (R[H] = z[H]));
          }), $ && z.hasOwnProperty("inputValue") && r.props.onInputValueChange(z.inputValue, me({}, r.getStateAndHelpers(), z)), R;
        }, function() {
          bh(y)();
          var E = Object.keys(S).length > 1;
          E && r.props.onStateChange(S, r.getStateAndHelpers()), k && r.props.onSelect(_.selectedItem, r.getStateAndHelpers()), x !== void 0 && r.props.onChange(x, r.getStateAndHelpers()), r.props.onUserAction(S, r.getStateAndHelpers());
        });
      }, r.rootRef = function(_) {
        return r._rootNode = _;
      }, r.getRootProps = function(_, y) {
        var k, x = _ === void 0 ? {} : _, S = x.refKey, $ = S === void 0 ? "ref" : S, E = x.ref, C = da(x, MA), z = y === void 0 ? {} : y, R = z.suppressRefError, H = R === void 0 ? !1 : R;
        r.getRootProps.called = !0, r.getRootProps.refKey = $, r.getRootProps.suppressRefError = H;
        var M = r.getState(), j = M.isOpen;
        return me((k = {}, k[$] = Mo(E, r.rootRef), k.role = "combobox", k["aria-expanded"] = j, k["aria-haspopup"] = "listbox", k["aria-owns"] = j ? r.menuId : void 0, k["aria-labelledby"] = r.labelId, k), C);
      }, r.keyDownHandlers = {
        ArrowDown: function(_) {
          var y = this;
          if (_.preventDefault(), this.getState().isOpen) {
            var k = _.shiftKey ? 5 : 1;
            this.moveHighlightedIndex(k, {
              type: ni
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: ni
            }, function() {
              var x = y.getItemCount();
              if (x > 0) {
                var S = y.getState(), $ = S.highlightedIndex, E = Ga($, 1, {
                  length: x
                }, y.isItemDisabled, !0);
                y.setHighlightedIndex(E, {
                  type: ni
                });
              }
            });
        },
        ArrowUp: function(_) {
          var y = this;
          if (_.preventDefault(), this.getState().isOpen) {
            var k = _.shiftKey ? -5 : -1;
            this.moveHighlightedIndex(k, {
              type: oi
            });
          } else
            this.internalSetState({
              isOpen: !0,
              type: oi
            }, function() {
              var x = y.getItemCount();
              if (x > 0) {
                var S = y.getState(), $ = S.highlightedIndex, E = Ga($, -1, {
                  length: x
                }, y.isItemDisabled, !0);
                y.setHighlightedIndex(E, {
                  type: oi
                });
              }
            });
        },
        Enter: function(_) {
          if (_.which !== 229) {
            var y = this.getState(), k = y.isOpen, x = y.highlightedIndex;
            if (k && x != null) {
              _.preventDefault();
              var S = this.items[x], $ = this.getItemNodeFromIndex(x);
              if (S == null || $ && $.hasAttribute("disabled"))
                return;
              this.selectHighlightedItem({
                type: X_
              });
            }
          }
        },
        Escape: function(_) {
          _.preventDefault(), this.reset(me({
            type: Y_
          }, !this.state.isOpen && {
            selectedItem: null,
            inputValue: ""
          }));
        }
      }, r.buttonKeyDownHandlers = me({}, r.keyDownHandlers, {
        " ": function(_) {
          _.preventDefault(), this.toggleMenu({
            type: nv
          });
        }
      }), r.inputKeyDownHandlers = me({}, r.keyDownHandlers, {
        Home: function(_) {
          var y = this.getState(), k = y.isOpen;
          if (k) {
            _.preventDefault();
            var x = this.getItemCount();
            if (!(x <= 0 || !k)) {
              var S = Yo(0, !1, {
                length: x
              }, this.isItemDisabled);
              this.setHighlightedIndex(S, {
                type: Q_
              });
            }
          }
        },
        End: function(_) {
          var y = this.getState(), k = y.isOpen;
          if (k) {
            _.preventDefault();
            var x = this.getItemCount();
            if (!(x <= 0 || !k)) {
              var S = Yo(x - 1, !0, {
                length: x
              }, this.isItemDisabled);
              this.setHighlightedIndex(S, {
                type: ev
              });
            }
          }
        }
      }), r.getToggleButtonProps = function(_) {
        var y = _ === void 0 ? {} : _, k = y.onClick;
        y.onPress;
        var x = y.onKeyDown, S = y.onKeyUp, $ = y.onBlur, E = da(y, LA), C = r.getState(), z = C.isOpen, R = {
          onClick: Ke(k, r.buttonHandleClick),
          onKeyDown: Ke(x, r.buttonHandleKeyDown),
          onKeyUp: Ke(S, r.buttonHandleKeyUp),
          onBlur: Ke($, r.buttonHandleBlur)
        }, H = E.disabled ? {} : R;
        return me({
          type: "button",
          role: "button",
          "aria-label": z ? "close menu" : "open menu",
          "aria-haspopup": !0,
          "data-toggle": !0
        }, H, E);
      }, r.buttonHandleKeyUp = function(_) {
        _.preventDefault();
      }, r.buttonHandleKeyDown = function(_) {
        var y = wc(_);
        r.buttonKeyDownHandlers[y] && r.buttonKeyDownHandlers[y].call(r, _);
      }, r.buttonHandleClick = function(_) {
        if (_.preventDefault(), r.props.environment) {
          var y = r.props.environment.document, k = y.body, x = y.activeElement;
          k && k === x && _.target.focus();
        }
        process.env.NODE_ENV === "test" ? r.toggleMenu({
          type: kc
        }) : r.internalSetTimeout(function() {
          return r.toggleMenu({
            type: kc
          });
        });
      }, r.buttonHandleBlur = function(_) {
        var y = _.target;
        r.internalSetTimeout(function() {
          if (!(r.isMouseDown || !r.props.environment)) {
            var k = r.props.environment.document.activeElement;
            (k == null || k.id !== r.inputId) && k !== y && r.reset({
              type: rv
            });
          }
        });
      }, r.getLabelProps = function(_) {
        return me({
          htmlFor: r.inputId,
          id: r.labelId
        }, _);
      }, r.getInputProps = function(_) {
        var y = _ === void 0 ? {} : _, k = y.onKeyDown, x = y.onBlur, S = y.onChange, $ = y.onInput;
        y.onChangeText;
        var E = da(y, WA), C, z = {};
        C = "onChange";
        var R = r.getState(), H = R.inputValue, M = R.isOpen, j = R.highlightedIndex;
        if (!E.disabled) {
          var U;
          z = (U = {}, U[C] = Ke(S, $, r.inputHandleChange), U.onKeyDown = Ke(k, r.inputHandleKeyDown), U.onBlur = Ke(x, r.inputHandleBlur), U);
        }
        return me({
          "aria-autocomplete": "list",
          "aria-activedescendant": M && typeof j == "number" && j >= 0 ? r.getItemId(j) : void 0,
          "aria-controls": M ? r.menuId : void 0,
          "aria-labelledby": E && E["aria-label"] ? void 0 : r.labelId,
          // https://developer.mozilla.org/en-US/docs/Web/Security/Securing_your_site/Turning_off_form_autocompletion
          // revert back since autocomplete="nope" is ignored on latest Chrome and Opera
          autoComplete: "off",
          value: H,
          id: r.inputId
        }, z, E);
      }, r.inputHandleKeyDown = function(_) {
        var y = wc(_);
        y && r.inputKeyDownHandlers[y] && r.inputKeyDownHandlers[y].call(r, _);
      }, r.inputHandleChange = function(_) {
        r.internalSetState({
          type: ov,
          isOpen: !0,
          inputValue: _.target.value,
          highlightedIndex: r.props.defaultHighlightedIndex
        });
      }, r.inputHandleBlur = function() {
        r.internalSetTimeout(function() {
          var _;
          if (!(r.isMouseDown || !r.props.environment)) {
            var y = r.props.environment.document.activeElement, k = (y == null || (_ = y.dataset) == null ? void 0 : _.toggle) && r._rootNode && r._rootNode.contains(y);
            k || r.reset({
              type: av
            });
          }
        });
      }, r.menuRef = function(_) {
        r._menuNode = _;
      }, r.getMenuProps = function(_, y) {
        var k, x = _ === void 0 ? {} : _, S = x.refKey, $ = S === void 0 ? "ref" : S, E = x.ref, C = da(x, BA), z = y === void 0 ? {} : y, R = z.suppressRefError, H = R === void 0 ? !1 : R;
        return r.getMenuProps.called = !0, r.getMenuProps.refKey = $, r.getMenuProps.suppressRefError = H, me((k = {}, k[$] = Mo(E, r.menuRef), k.role = "listbox", k["aria-labelledby"] = C && C["aria-label"] ? void 0 : r.labelId, k.id = r.menuId, k), C);
      }, r.getItemProps = function(_) {
        var y, k = _ === void 0 ? {} : _, x = k.onMouseMove, S = k.onMouseDown, $ = k.onClick;
        k.onPress;
        var E = k.index, C = k.item, z = C === void 0 ? process.env.NODE_ENV === "production" ? (
          /* istanbul ignore next */
          void 0
        ) : PA("getItemProps", "item") : C, R = da(k, FA);
        E === void 0 ? (r.items.push(z), E = r.items.indexOf(z)) : r.items[E] = z;
        var H = "onClick", M = $, j = (y = {
          // onMouseMove is used over onMouseEnter here. onMouseMove
          // is only triggered on actual mouse movement while onMouseEnter
          // can fire on DOM changes, interrupting keyboard navigation
          onMouseMove: Ke(x, function() {
            E !== r.getState().highlightedIndex && (r.setHighlightedIndex(E, {
              type: Z_
            }), r.avoidScrolling = !0, r.internalSetTimeout(function() {
              return r.avoidScrolling = !1;
            }, 250));
          }),
          onMouseDown: Ke(S, function(I) {
            I.preventDefault();
          })
        }, y[H] = Ke(M, function() {
          r.selectItemAtIndex(E, {
            type: tv
          });
        }), y), U = R.disabled ? {
          onMouseDown: j.onMouseDown
        } : j;
        return me({
          id: r.getItemId(E),
          role: "option",
          "aria-selected": r.getState().highlightedIndex === E
        }, U, R);
      }, r.clearItems = function() {
        r.items = [];
      }, r.reset = function(_, y) {
        _ === void 0 && (_ = {}), _ = Or(_), r.internalSetState(function(k) {
          var x = k.selectedItem;
          return me({
            isOpen: r.props.defaultIsOpen,
            highlightedIndex: r.props.defaultHighlightedIndex,
            inputValue: r.props.itemToString(x)
          }, _);
        }, y);
      }, r.toggleMenu = function(_, y) {
        _ === void 0 && (_ = {}), _ = Or(_), r.internalSetState(function(k) {
          var x = k.isOpen;
          return me({
            isOpen: !x
          }, x && {
            highlightedIndex: r.props.defaultHighlightedIndex
          }, _);
        }, function() {
          var k = r.getState(), x = k.isOpen, S = k.highlightedIndex;
          x && r.getItemCount() > 0 && typeof S == "number" && r.setHighlightedIndex(S, _), bh(y)();
        });
      }, r.openMenu = function(_) {
        r.internalSetState({
          isOpen: !0
        }, _);
      }, r.closeMenu = function(_) {
        r.internalSetState({
          isOpen: !1
        }, _);
      }, r.updateStatus = Mu(function() {
        var _;
        if ((_ = r.props) != null && (_ = _.environment) != null && _.document) {
          var y = r.getState(), k = r.items[y.highlightedIndex], x = r.getItemCount(), S = r.props.getA11yStatusMessage(me({
            itemToString: r.props.itemToString,
            previousResultCount: r.previousResultCount,
            resultCount: x,
            highlightedItem: k
          }, y));
          r.previousResultCount = x, G_(S, r.props.environment.document);
        }
      }, 200);
      var i = r.props, s = i.defaultHighlightedIndex, l = i.initialHighlightedIndex, c = l === void 0 ? s : l, u = i.defaultIsOpen, d = i.initialIsOpen, h = d === void 0 ? u : d, p = i.initialInputValue, f = p === void 0 ? "" : p, m = i.initialSelectedItem, b = m === void 0 ? null : m, w = r.getState({
        highlightedIndex: c,
        isOpen: h,
        inputValue: f,
        selectedItem: b
      });
      return w.selectedItem != null && r.props.initialInputValue === void 0 && (w.inputValue = r.props.itemToString(w.selectedItem)), r.state = w, r;
    }
    fA(a, t);
    var o = a.prototype;
    return o.internalClearTimeouts = function() {
      this.timeoutIds.forEach(function(n) {
        clearTimeout(n);
      }), this.timeoutIds = [];
    }, o.getState = function(n) {
      return n === void 0 && (n = this.state), zi(n, this.props);
    }, o.getItemCount = function() {
      var n = this.items.length;
      return this.itemCount != null ? n = this.itemCount : this.props.itemCount !== void 0 && (n = this.props.itemCount), n;
    }, o.getItemNodeFromIndex = function(n) {
      return this.props.environment ? this.props.environment.document.getElementById(this.getItemId(n)) : null;
    }, o.scrollHighlightedItemIntoView = function() {
      {
        var n = this.getItemNodeFromIndex(this.getState().highlightedIndex);
        this.props.scrollIntoView(n, this._menuNode);
      }
    }, o.moveHighlightedIndex = function(n, r) {
      var i = this.getItemCount(), s = this.getState(), l = s.highlightedIndex;
      if (i > 0) {
        var c = Ga(l, n, {
          length: i
        }, this.isItemDisabled, !0);
        this.setHighlightedIndex(c, r);
      }
    }, o.getStateAndHelpers = function() {
      var n = this.getState(), r = n.highlightedIndex, i = n.inputValue, s = n.selectedItem, l = n.isOpen, c = this.props.itemToString, u = this.id, d = this.getRootProps, h = this.getToggleButtonProps, p = this.getLabelProps, f = this.getMenuProps, m = this.getInputProps, b = this.getItemProps, w = this.openMenu, _ = this.closeMenu, y = this.toggleMenu, k = this.selectItem, x = this.selectItemAtIndex, S = this.selectHighlightedItem, $ = this.setHighlightedIndex, E = this.clearSelection, C = this.clearItems, z = this.reset, R = this.setItemCount, H = this.unsetItemCount, M = this.internalSetState;
      return {
        // prop getters
        getRootProps: d,
        getToggleButtonProps: h,
        getLabelProps: p,
        getMenuProps: f,
        getInputProps: m,
        getItemProps: b,
        // actions
        reset: z,
        openMenu: w,
        closeMenu: _,
        toggleMenu: y,
        selectItem: k,
        selectItemAtIndex: x,
        selectHighlightedItem: S,
        setHighlightedIndex: $,
        clearSelection: E,
        clearItems: C,
        setItemCount: R,
        unsetItemCount: H,
        setState: M,
        // props
        itemToString: c,
        // derived
        id: u,
        // state
        highlightedIndex: r,
        inputValue: i,
        isOpen: l,
        selectedItem: s
      };
    }, o.componentDidMount = function() {
      var n = this;
      if (process.env.NODE_ENV !== "production" && this.getMenuProps.called && !this.getMenuProps.suppressRefError && yh(this._menuNode, this.getMenuProps), !this.props.environment)
        this.cleanup = function() {
          n.internalClearTimeouts();
        };
      else {
        var r = function() {
          n.isMouseDown = !0;
        }, i = function(d) {
          n.isMouseDown = !1;
          var h = Ai(d.target, [n._rootNode, n._menuNode], n.props.environment);
          !h && n.getState().isOpen && n.reset({
            type: J_
          }, function() {
            return n.props.onOuterClick(n.getStateAndHelpers());
          });
        }, s = function() {
          n.isTouchMove = !1;
        }, l = function() {
          n.isTouchMove = !0;
        }, c = function(d) {
          var h = Ai(d.target, [n._rootNode, n._menuNode], n.props.environment, !1);
          !n.isTouchMove && !h && n.getState().isOpen && n.reset({
            type: sv
          }, function() {
            return n.props.onOuterClick(n.getStateAndHelpers());
          });
        }, u = this.props.environment;
        u.addEventListener("mousedown", r), u.addEventListener("mouseup", i), u.addEventListener("touchstart", s), u.addEventListener("touchmove", l), u.addEventListener("touchend", c), this.cleanup = function() {
          n.internalClearTimeouts(), n.updateStatus.cancel(), u.removeEventListener("mousedown", r), u.removeEventListener("mouseup", i), u.removeEventListener("touchstart", s), u.removeEventListener("touchmove", l), u.removeEventListener("touchend", c);
        };
      }
    }, o.shouldScroll = function(n, r) {
      var i = this.props.highlightedIndex === void 0 ? this.getState() : this.props, s = i.highlightedIndex, l = r.highlightedIndex === void 0 ? n : r, c = l.highlightedIndex, u = s && this.getState().isOpen && !n.isOpen, d = s !== c;
      return u || d;
    }, o.componentDidUpdate = function(n, r) {
      process.env.NODE_ENV !== "production" && (Lu(this.state, n, this.props), this.getMenuProps.called && !this.getMenuProps.suppressRefError && yh(this._menuNode, this.getMenuProps)), ji(this.props, "selectedItem") && this.props.selectedItemChanged(n.selectedItem, this.props.selectedItem) && this.internalSetState({
        type: iv,
        inputValue: this.props.itemToString(this.props.selectedItem)
      }), !this.avoidScrolling && this.shouldScroll(r, n) && this.scrollHighlightedItemIntoView(), this.updateStatus();
    }, o.componentWillUnmount = function() {
      this.cleanup();
    }, o.render = function() {
      var n = vh(this.props.children, wt);
      this.clearItems(), this.getRootProps.called = !1, this.getRootProps.refKey = void 0, this.getRootProps.suppressRefError = void 0, this.getMenuProps.called = !1, this.getMenuProps.refKey = void 0, this.getMenuProps.suppressRefError = void 0, this.getLabelProps.called = !1, this.getInputProps.called = !1;
      var r = vh(n(this.getStateAndHelpers()));
      if (!r)
        return null;
      if (this.getRootProps.called || this.props.suppressRefError)
        return process.env.NODE_ENV !== "production" && !this.getRootProps.suppressRefError && !this.props.suppressRefError && UA(r, this.getRootProps), r;
      if (U_(r))
        return /* @__PURE__ */ Gp(r, this.getRootProps(q_(r)));
      if (process.env.NODE_ENV !== "production")
        throw new Error("downshift: If you return a non-DOM element, you must apply the getRootProps function");
    }, a;
  }(hx);
  return e.defaultProps = {
    defaultHighlightedIndex: null,
    defaultIsOpen: !1,
    getA11yStatusMessage: OA,
    itemToString: function(t) {
      return t == null ? "" : (process.env.NODE_ENV !== "production" && NA(t) && !t.hasOwnProperty("toString") && console.warn("downshift: An object was passed to the default implementation of `itemToString`. You should probably provide your own `itemToString` implementation. Please refer to the `itemToString` API documentation.", "The object that was passed:", t), String(t));
    },
    onStateChange: wt,
    onInputValueChange: wt,
    onUserAction: wt,
    onChange: wt,
    onSelect: wt,
    onOuterClick: wt,
    selectedItemChanged: function(t, a) {
      return t !== a;
    },
    environment: (
      /* istanbul ignore next (ssr) */
      typeof window > "u" ? void 0 : window
    ),
    stateReducer: function(t, a) {
      return a;
    },
    suppressRefError: !1,
    scrollIntoView: F_
  }, e.stateChangeTypes = TA, e;
}();
process.env.NODE_ENV !== "production" && (VA.propTypes = {
  children: G.func,
  defaultHighlightedIndex: G.number,
  defaultIsOpen: G.bool,
  initialHighlightedIndex: G.number,
  initialSelectedItem: G.any,
  initialInputValue: G.string,
  initialIsOpen: G.bool,
  getA11yStatusMessage: G.func,
  itemToString: G.func,
  onChange: G.func,
  onSelect: G.func,
  onStateChange: G.func,
  onInputValueChange: G.func,
  onUserAction: G.func,
  onOuterClick: G.func,
  selectedItemChanged: G.func,
  stateReducer: G.func,
  itemCount: G.number,
  id: G.string,
  environment: G.shape({
    addEventListener: G.func.isRequired,
    removeEventListener: G.func.isRequired,
    document: G.shape({
      createElement: G.func.isRequired,
      getElementById: G.func.isRequired,
      activeElement: G.any.isRequired,
      body: G.any.isRequired
    }).isRequired,
    Node: G.func.isRequired
  }),
  suppressRefError: G.bool,
  scrollIntoView: G.func,
  // things we keep in state for uncontrolled components
  // but can accept as props for controlled components
  /* eslint-disable react/no-unused-prop-types */
  selectedItem: G.any,
  isOpen: G.bool,
  inputValue: G.string,
  highlightedIndex: G.number,
  labelId: G.string,
  inputId: G.string,
  menuId: G.string,
  getItemId: G.func
  /* eslint-enable react/no-unused-prop-types */
});
function yh(e, t) {
  var a = t.refKey;
  e || console.error('downshift: The ref prop "' + a + '" from getMenuProps was not applied correctly on your menu element.');
}
function UA(e, t) {
  var a = t.refKey, o = a !== "ref", n = !U_(e);
  n && !o && !mh.isForwardRef(e) ? console.error("downshift: You returned a non-DOM element. You must specify a refKey in getRootProps") : !n && o && console.error('downshift: You returned a DOM element. You should not specify a refKey in getRootProps. You specified "' + a + '"'), !mh.isForwardRef(e) && !q_(e)[a] && console.error('downshift: You must apply the ref prop "' + a + '" from getRootProps onto your root element.');
}
var lv = {
  highlightedIndex: -1,
  isOpen: !1,
  selectedItem: null,
  inputValue: ""
};
function qA(e, t, a) {
  var o = e.props, n = e.type, r = {};
  Object.keys(t).forEach(function(i) {
    HA(i, e, t, a), a[i] !== t[i] && (r[i] = a[i]);
  }), o.onStateChange && Object.keys(r).length && o.onStateChange(me({
    type: n
  }, r));
}
function HA(e, t, a, o) {
  var n = t.props, r = t.type, i = "on" + Wu(e) + "Change";
  n[i] && o[e] !== void 0 && o[e] !== a[e] && n[i](me({
    type: r
  }, o));
}
function GA(e, t) {
  return t.changes;
}
var wh = Mu(function(e, t) {
  G_(e, t);
}, 200), KA = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u" ? Kp : Ce, JA = "useId" in ne ? function(e) {
  var t = e.id, a = e.labelId, o = e.menuId, n = e.getItemId, r = e.toggleButtonId, i = e.inputId, s = "downshift-" + ne.useId();
  t || (t = s);
  var l = Ie({
    labelId: a || t + "-label",
    menuId: o || t + "-menu",
    getItemId: n || function(c) {
      return t + "-item-" + c;
    },
    toggleButtonId: r || t + "-toggle-button",
    inputId: i || t + "-input"
  });
  return l.current;
} : function(e) {
  var t = e.id, a = t === void 0 ? "downshift-" + V_() : t, o = e.labelId, n = e.menuId, r = e.getItemId, i = e.toggleButtonId, s = e.inputId, l = Ie({
    labelId: o || a + "-label",
    menuId: n || a + "-menu",
    getItemId: r || function(c) {
      return a + "-item-" + c;
    },
    toggleButtonId: i || a + "-toggle-button",
    inputId: s || a + "-input"
  });
  return l.current;
};
function ZA(e, t, a, o) {
  var n, r;
  if (e === void 0) {
    if (t === void 0)
      throw new Error(o);
    n = a[t], r = t;
  } else
    r = t === void 0 ? a.indexOf(e) : t, n = e;
  return [n, r];
}
function Wu(e) {
  return "" + e.slice(0, 1).toUpperCase() + e.slice(1);
}
function cv(e) {
  var t = Ie(e);
  return t.current = e, t;
}
function YA(e, t, a, o) {
  var n = Ie(), r = Ie(), i = Me(function(p, f) {
    r.current = f, p = zi(p, f.props);
    var m = e(p, f), b = f.props.stateReducer(p, me({}, f, {
      changes: m
    }));
    return b;
  }, [e]), s = gx(i, t, a), l = s[0], c = s[1], u = cv(t), d = Me(function(p) {
    return c(me({
      props: u.current
    }, p));
  }, [u]), h = r.current;
  return Ce(function() {
    var p = zi(n.current, h?.props), f = h && n.current && !o(p, l);
    f && qA(h, p, l), n.current = l;
  }, [l, h, o]), [l, d];
}
var zn = {
  itemToString: function(e) {
    return e ? String(e) : "";
  },
  itemToKey: function(e) {
    return e;
  },
  stateReducer: GA,
  scrollIntoView: F_,
  environment: (
    /* istanbul ignore next (ssr) */
    typeof window > "u" ? void 0 : window
  )
};
function Pa(e, t, a) {
  a === void 0 && (a = lv);
  var o = e["default" + Wu(t)];
  return o !== void 0 ? o : a[t];
}
function jn(e, t, a) {
  a === void 0 && (a = lv);
  var o = e[t];
  if (o !== void 0)
    return o;
  var n = e["initial" + Wu(t)];
  return n !== void 0 ? n : Pa(e, t, a);
}
function XA(e) {
  var t = jn(e, "selectedItem"), a = jn(e, "isOpen"), o = oO(e), n = jn(e, "inputValue");
  return {
    highlightedIndex: o < 0 && t && a ? e.items.findIndex(function(r) {
      return e.itemToKey(r) === e.itemToKey(t);
    }) : o,
    isOpen: a,
    selectedItem: t,
    inputValue: n
  };
}
function An(e, t, a) {
  var o = e.items, n = e.initialHighlightedIndex, r = e.defaultHighlightedIndex, i = e.isItemDisabled, s = e.itemToKey, l = t.selectedItem, c = t.highlightedIndex;
  return o.length === 0 ? -1 : n !== void 0 && c === n && !i(o[n], n) ? n : r !== void 0 && !i(o[r], r) ? r : l ? o.findIndex(function(u) {
    return s(l) === s(u);
  }) : a < 0 && !i(o[o.length - 1], o.length - 1) ? o.length - 1 : a > 0 && !i(o[0], 0) ? 0 : -1;
}
function QA(e, t, a) {
  var o = Ie({
    isMouseDown: !1,
    isTouchMove: !1,
    isTouchEnd: !1
  });
  return Ce(function() {
    if (!e)
      return wt;
    var n = a.map(function(u) {
      return u.current;
    });
    function r() {
      o.current.isTouchEnd = !1, o.current.isMouseDown = !0;
    }
    function i(u) {
      o.current.isMouseDown = !1, Ai(u.target, n, e) || t();
    }
    function s() {
      o.current.isTouchEnd = !1, o.current.isTouchMove = !1;
    }
    function l() {
      o.current.isTouchMove = !0;
    }
    function c(u) {
      o.current.isTouchEnd = !0, !o.current.isTouchMove && !Ai(u.target, n, e, !1) && t();
    }
    return e.addEventListener("mousedown", r), e.addEventListener("mouseup", i), e.addEventListener("touchstart", s), e.addEventListener("touchmove", l), e.addEventListener("touchend", c), function() {
      e.removeEventListener("mousedown", r), e.removeEventListener("mouseup", i), e.removeEventListener("touchstart", s), e.removeEventListener("touchmove", l), e.removeEventListener("touchend", c);
    };
  }, [a, e, t]), o.current;
}
var uv = function() {
  return wt;
};
process.env.NODE_ENV !== "production" && (uv = function() {
  for (var e = arguments.length, t = new Array(e), a = 0; a < e; a++)
    t[a] = arguments[a];
  var o = Ie(t.reduce(function(r, i) {
    return r[i] = {}, r;
  }, {}));
  Ce(function() {
    Object.keys(o.current).forEach(function(r) {
      var i = o.current[r];
      if (!Object.keys(i).length) {
        console.error("downshift: You forgot to call the " + r + " getter function on your component / element.");
        return;
      }
      var s = i.suppressRefError, l = i.refKey, c = i.elementRef;
      s || c != null && c.current || console.error('downshift: The ref prop "' + l + '" from ' + r + " was not applied correctly on your element.");
    });
  }, []);
  var n = Me(function(r, i, s, l) {
    o.current[r] = {
      suppressRefError: i,
      refKey: s,
      elementRef: l
    };
  }, []);
  return n;
});
function eO(e, t, a, o) {
  o === void 0 && (o = {});
  var n = o.document, r = ws();
  Ce(function() {
    if (!(!e || r || !n)) {
      var i = e(t);
      wh(i, n);
    }
  }, a), Ce(function() {
    return function() {
      wh.cancel(), IA(n);
    };
  }, [n]);
}
function tO(e) {
  var t = e.highlightedIndex, a = e.isOpen, o = e.itemRefs, n = e.getItemNodeFromIndex, r = e.menuElement, i = e.scrollIntoView, s = Ie(!0);
  return KA(function() {
    t < 0 || !a || !Object.keys(o.current).length || (s.current === !1 ? s.current = !0 : i(n(t), r));
  }, [t]), s;
}
var dv = wt;
process.env.NODE_ENV !== "production" && (dv = function(e) {
  var t = e.props, a = e.state, o = Ie(t), n = ws();
  Ce(function() {
    n || (Lu(a, o.current, t), o.current = t);
  }, [a, t, n]);
});
function kh(e, t, a) {
  var o;
  a === void 0 && (a = !0);
  var n = ((o = e.items) == null ? void 0 : o.length) && t >= 0;
  return me({
    isOpen: !1,
    highlightedIndex: -1
  }, n && me({
    selectedItem: e.items[t],
    isOpen: Pa(e, "isOpen"),
    highlightedIndex: Pa(e, "highlightedIndex")
  }, a && {
    inputValue: e.itemToString(e.items[t])
  }));
}
function aO(e, t) {
  return e.isOpen === t.isOpen && e.inputValue === t.inputValue && e.highlightedIndex === t.highlightedIndex && e.selectedItem === t.selectedItem;
}
function ws() {
  var e = ne.useRef(!0);
  return ne.useEffect(function() {
    return e.current = !1, function() {
      e.current = !0;
    };
  }, []), e.current;
}
function xc(e) {
  var t = Pa(e, "highlightedIndex");
  return t > -1 && e.isItemDisabled(e.items[t], t) ? -1 : t;
}
function oO(e) {
  var t = jn(e, "highlightedIndex");
  return t > -1 && e.isItemDisabled(e.items[t], t) ? -1 : t;
}
var ri = {
  environment: G.shape({
    addEventListener: G.func.isRequired,
    removeEventListener: G.func.isRequired,
    document: G.shape({
      createElement: G.func.isRequired,
      getElementById: G.func.isRequired,
      activeElement: G.any.isRequired,
      body: G.any.isRequired
    }).isRequired,
    Node: G.func.isRequired
  }),
  itemToString: G.func,
  itemToKey: G.func,
  stateReducer: G.func
}, gv = me({}, ri, {
  getA11yStatusMessage: G.func,
  highlightedIndex: G.number,
  defaultHighlightedIndex: G.number,
  initialHighlightedIndex: G.number,
  isOpen: G.bool,
  defaultIsOpen: G.bool,
  initialIsOpen: G.bool,
  selectedItem: G.any,
  initialSelectedItem: G.any,
  defaultSelectedItem: G.any,
  id: G.string,
  labelId: G.string,
  menuId: G.string,
  getItemId: G.func,
  toggleButtonId: G.string,
  onSelectedItemChange: G.func,
  onHighlightedIndexChange: G.func,
  onStateChange: G.func,
  onIsOpenChange: G.func,
  scrollIntoView: G.func
});
function nO(e, t, a) {
  var o = t.type, n = t.props, r;
  switch (o) {
    case a.ItemMouseMove:
      r = {
        highlightedIndex: t.disabled ? -1 : t.index
      };
      break;
    case a.MenuMouseLeave:
      r = {
        highlightedIndex: -1
      };
      break;
    case a.ToggleButtonClick:
    case a.FunctionToggleMenu:
      r = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : An(n, e, 0)
      };
      break;
    case a.FunctionOpenMenu:
      r = {
        isOpen: !0,
        highlightedIndex: An(n, e, 0)
      };
      break;
    case a.FunctionCloseMenu:
      r = {
        isOpen: !1
      };
      break;
    case a.FunctionSetHighlightedIndex:
      r = {
        highlightedIndex: n.isItemDisabled(n.items[t.highlightedIndex], t.highlightedIndex) ? -1 : t.highlightedIndex
      };
      break;
    case a.FunctionSetInputValue:
      r = {
        inputValue: t.inputValue
      };
      break;
    case a.FunctionReset:
      r = {
        highlightedIndex: xc(n),
        isOpen: Pa(n, "isOpen"),
        selectedItem: Pa(n, "selectedItem"),
        inputValue: Pa(n, "inputValue")
      };
      break;
    default:
      throw new Error("Reducer called without proper action type.");
  }
  return me({}, e, r);
}
ct(ct({}, gv), { items: G.array.isRequired, isItemDisabled: G.func });
ct(ct({}, zn), { isItemDisabled: function() {
  return !1;
} });
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
var Bu = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_down__" : 0, Fu = process.env.NODE_ENV !== "production" ? "__input_keydown_arrow_up__" : 1, Vu = process.env.NODE_ENV !== "production" ? "__input_keydown_escape__" : 2, Uu = process.env.NODE_ENV !== "production" ? "__input_keydown_home__" : 3, qu = process.env.NODE_ENV !== "production" ? "__input_keydown_end__" : 4, Hu = process.env.NODE_ENV !== "production" ? "__input_keydown_page_up__" : 5, Gu = process.env.NODE_ENV !== "production" ? "__input_keydown_page_down__" : 6, Ku = process.env.NODE_ENV !== "production" ? "__input_keydown_enter__" : 7, Ju = process.env.NODE_ENV !== "production" ? "__input_change__" : 8, Oi = process.env.NODE_ENV !== "production" ? "__input_blur__" : 9, Zu = process.env.NODE_ENV !== "production" ? "__input_click__" : 10, hv = process.env.NODE_ENV !== "production" ? "__menu_mouse_leave__" : 11, mv = process.env.NODE_ENV !== "production" ? "__item_mouse_move__" : 12, Yu = process.env.NODE_ENV !== "production" ? "__item_click__" : 13, pv = process.env.NODE_ENV !== "production" ? "__togglebutton_click__" : 14, fv = process.env.NODE_ENV !== "production" ? "__function_toggle_menu__" : 15, bv = process.env.NODE_ENV !== "production" ? "__function_open_menu__" : 16, _v = process.env.NODE_ENV !== "production" ? "__function_close_menu__" : 17, vv = process.env.NODE_ENV !== "production" ? "__function_set_highlighted_index__" : 18, Xu = process.env.NODE_ENV !== "production" ? "__function_select_item__" : 19, yv = process.env.NODE_ENV !== "production" ? "__function_set_input_value__" : 20, wv = process.env.NODE_ENV !== "production" ? "__function_reset__" : 21, Qu = process.env.NODE_ENV !== "production" ? "__controlled_prop_updated_selected_item__" : 22, kv = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  ControlledPropUpdatedSelectedItem: Qu,
  FunctionCloseMenu: _v,
  FunctionOpenMenu: bv,
  FunctionReset: wv,
  FunctionSelectItem: Xu,
  FunctionSetHighlightedIndex: vv,
  FunctionSetInputValue: yv,
  FunctionToggleMenu: fv,
  InputBlur: Oi,
  InputChange: Ju,
  InputClick: Zu,
  InputKeyDownArrowDown: Bu,
  InputKeyDownArrowUp: Fu,
  InputKeyDownEnd: qu,
  InputKeyDownEnter: Ku,
  InputKeyDownEscape: Vu,
  InputKeyDownHome: Uu,
  InputKeyDownPageDown: Gu,
  InputKeyDownPageUp: Hu,
  ItemClick: Yu,
  ItemMouseMove: mv,
  MenuMouseLeave: hv,
  ToggleButtonClick: pv
});
function rO(e) {
  var t = XA(e), a = t.selectedItem, o = t.inputValue;
  return o === "" && a && e.defaultInputValue === void 0 && e.initialInputValue === void 0 && e.inputValue === void 0 && (o = e.itemToString(a)), me({}, t, {
    inputValue: o
  });
}
var iO = me({}, gv, {
  items: G.array.isRequired,
  isItemDisabled: G.func,
  inputValue: G.string,
  defaultInputValue: G.string,
  initialInputValue: G.string,
  inputId: G.string,
  onInputValueChange: G.func
});
function sO(e, t, a, o) {
  var n = Ie(), r = YA(e, t, a, o), i = r[0], s = r[1], l = ws();
  return Ce(function() {
    if (ji(t, "selectedItem")) {
      if (!l) {
        var c = t.itemToKey(t.selectedItem) !== t.itemToKey(n.current);
        c && s({
          type: Qu,
          inputValue: t.itemToString(t.selectedItem)
        });
      }
      n.current = i.selectedItem === n.current ? t.selectedItem : i.selectedItem;
    }
  }, [i.selectedItem, t.selectedItem]), [zi(i, t), s];
}
var xv = wt;
process.env.NODE_ENV !== "production" && (xv = function(e, t) {
  G.checkPropTypes(iO, e, "prop", t.name);
});
var lO = me({}, zn, {
  isItemDisabled: function() {
    return !1;
  }
});
function cO(e, t) {
  var a, o = t.type, n = t.props, r = t.altKey, i;
  switch (o) {
    case Yu:
      i = {
        isOpen: Pa(n, "isOpen"),
        highlightedIndex: xc(n),
        selectedItem: n.items[t.index],
        inputValue: n.itemToString(n.items[t.index])
      };
      break;
    case Bu:
      e.isOpen ? i = {
        highlightedIndex: Ga(e.highlightedIndex, 1, n.items, n.isItemDisabled, !0)
      } : i = {
        highlightedIndex: r && e.selectedItem == null ? -1 : An(n, e, 1),
        isOpen: n.items.length >= 0
      };
      break;
    case Fu:
      e.isOpen ? r ? i = kh(n, e.highlightedIndex) : i = {
        highlightedIndex: Ga(e.highlightedIndex, -1, n.items, n.isItemDisabled, !0)
      } : i = {
        highlightedIndex: An(n, e, -1),
        isOpen: n.items.length >= 0
      };
      break;
    case Ku:
      i = kh(n, e.highlightedIndex);
      break;
    case Vu:
      i = me({
        isOpen: !1,
        highlightedIndex: -1
      }, !e.isOpen && {
        selectedItem: null,
        inputValue: ""
      });
      break;
    case Hu:
      i = {
        highlightedIndex: Ga(e.highlightedIndex, -10, n.items, n.isItemDisabled, !0)
      };
      break;
    case Gu:
      i = {
        highlightedIndex: Ga(e.highlightedIndex, 10, n.items, n.isItemDisabled, !0)
      };
      break;
    case Uu:
      i = {
        highlightedIndex: Yo(0, !1, n.items, n.isItemDisabled)
      };
      break;
    case qu:
      i = {
        highlightedIndex: Yo(n.items.length - 1, !0, n.items, n.isItemDisabled)
      };
      break;
    case Oi:
      i = me({
        isOpen: !1,
        highlightedIndex: -1
      }, e.highlightedIndex >= 0 && ((a = n.items) == null ? void 0 : a.length) && t.selectItem && {
        selectedItem: n.items[e.highlightedIndex],
        inputValue: n.itemToString(n.items[e.highlightedIndex])
      });
      break;
    case Ju:
      i = {
        isOpen: !0,
        highlightedIndex: xc(n),
        inputValue: t.inputValue
      };
      break;
    case Zu:
      i = {
        isOpen: !e.isOpen,
        highlightedIndex: e.isOpen ? -1 : An(n, e, 0)
      };
      break;
    case Xu:
      i = {
        selectedItem: t.selectedItem,
        inputValue: n.itemToString(t.selectedItem)
      };
      break;
    case Qu:
      i = {
        inputValue: t.inputValue
      };
      break;
    default:
      return nO(e, t, kv);
  }
  return me({}, e, i);
}
var uO = ["onMouseLeave", "refKey", "ref"], dO = ["item", "index", "refKey", "ref", "onMouseMove", "onMouseDown", "onClick", "onPress", "disabled"], gO = ["onClick", "onPress", "refKey", "ref"], hO = ["onKeyDown", "onChange", "onInput", "onBlur", "onChangeText", "onClick", "refKey", "ref"];
ed.stateChangeTypes = kv;
function ed(e) {
  e === void 0 && (e = {}), xv(e, ed);
  var t = me({}, lO, e), a = t.items, o = t.scrollIntoView, n = t.environment, r = t.getA11yStatusMessage, i = sO(cO, t, rO, aO), s = i[0], l = i[1], c = s.isOpen, u = s.highlightedIndex, d = s.selectedItem, h = s.inputValue, p = Ie(null), f = Ie({}), m = Ie(null), b = Ie(null), w = ws(), _ = JA(t), y = Ie(), k = cv({
    state: s,
    props: t
  }), x = Me(function(N) {
    return f.current[_.getItemId(N)];
  }, [_]);
  eO(r, s, [c, u, d, h], n);
  var S = tO({
    menuElement: p.current,
    highlightedIndex: u,
    isOpen: c,
    itemRefs: f,
    scrollIntoView: o,
    getItemNodeFromIndex: x
  });
  dv({
    props: t,
    state: s
  }), Ce(function() {
    var N = jn(t, "isOpen");
    N && m.current && m.current.focus();
  }, []), Ce(function() {
    w || (y.current = a.length);
  });
  var $ = QA(n, Me(function() {
    k.current.state.isOpen && l({
      type: Oi,
      selectItem: !1
    });
  }, [l, k]), Ho(function() {
    return [p, b, m];
  }, [p.current, b.current, m.current])), E = uv("getInputProps", "getMenuProps");
  Ce(function() {
    c || (f.current = {});
  }, [c]), Ce(function() {
    var N;
    !c || !(n != null && n.document) || !(m != null && (N = m.current) != null && N.focus) || n.document.activeElement !== m.current && m.current.focus();
  }, [c, n]);
  var C = Ho(function() {
    return {
      ArrowDown: function(N) {
        N.preventDefault(), l({
          type: Bu,
          altKey: N.altKey
        });
      },
      ArrowUp: function(N) {
        N.preventDefault(), l({
          type: Fu,
          altKey: N.altKey
        });
      },
      Home: function(N) {
        k.current.state.isOpen && (N.preventDefault(), l({
          type: Uu
        }));
      },
      End: function(N) {
        k.current.state.isOpen && (N.preventDefault(), l({
          type: qu
        }));
      },
      Escape: function(N) {
        var B = k.current.state;
        (B.isOpen || B.inputValue || B.selectedItem || B.highlightedIndex > -1) && (N.preventDefault(), l({
          type: Vu
        }));
      },
      Enter: function(N) {
        var B = k.current.state;
        !B.isOpen || N.which === 229 || (N.preventDefault(), l({
          type: Ku
        }));
      },
      PageUp: function(N) {
        k.current.state.isOpen && (N.preventDefault(), l({
          type: Hu
        }));
      },
      PageDown: function(N) {
        k.current.state.isOpen && (N.preventDefault(), l({
          type: Gu
        }));
      }
    };
  }, [l, k]), z = Me(function(N) {
    return me({
      id: _.labelId,
      htmlFor: _.inputId
    }, N);
  }, [_]), R = Me(function(N, B) {
    var W, Z = N === void 0 ? {} : N, ee = Z.onMouseLeave, L = Z.refKey, Y = L === void 0 ? "ref" : L, Q = Z.ref, J = da(Z, uO), ae = B === void 0 ? {} : B, V = ae.suppressRefError, fe = V === void 0 ? !1 : V;
    return E("getMenuProps", fe, Y, p), me((W = {}, W[Y] = Mo(Q, function(X) {
      p.current = X;
    }), W.id = _.menuId, W.role = "listbox", W["aria-labelledby"] = J && J["aria-label"] ? void 0 : "" + _.labelId, W.onMouseLeave = Ke(ee, function() {
      l({
        type: hv
      });
    }), W), J);
  }, [l, E, _]), H = Me(function(N) {
    var B, W, Z = N === void 0 ? {} : N, ee = Z.item, L = Z.index, Y = Z.refKey, Q = Y === void 0 ? "ref" : Y, J = Z.ref, ae = Z.onMouseMove, V = Z.onMouseDown, fe = Z.onClick;
    Z.onPress;
    var X = Z.disabled, Ye = da(Z, dO);
    X !== void 0 && console.warn('Passing "disabled" as an argument to getItemProps is not supported anymore. Please use the isItemDisabled prop from useCombobox.');
    var Ve = k.current, Ft = Ve.props, ft = Ve.state, Ba = ZA(ee, L, Ft.items, "Pass either item or index to getItemProps!"), Fa = Ba[0], St = Ba[1], ia = Ft.isItemDisabled(Fa, St), ka = "onClick", Va = fe, we = function() {
      $.isTouchEnd || St === ft.highlightedIndex || (S.current = !1, l({
        type: mv,
        index: St,
        disabled: ia
      }));
    }, bt = function() {
      l({
        type: Yu,
        index: St
      });
    }, oe = function(Ua) {
      return Ua.preventDefault();
    };
    return me((B = {}, B[Q] = Mo(J, function(Ua) {
      Ua && (f.current[_.getItemId(St)] = Ua);
    }), B["aria-disabled"] = ia, B["aria-selected"] = St === ft.highlightedIndex, B.id = _.getItemId(St), B.role = "option", B), !ia && (W = {}, W[ka] = Ke(Va, bt), W), {
      onMouseMove: Ke(ae, we),
      onMouseDown: Ke(V, oe)
    }, Ye);
  }, [l, _, k, $, S]), M = Me(function(N) {
    var B, W = N === void 0 ? {} : N, Z = W.onClick;
    W.onPress;
    var ee = W.refKey, L = ee === void 0 ? "ref" : ee, Y = W.ref, Q = da(W, gO), J = k.current.state, ae = function() {
      l({
        type: pv
      });
    };
    return me((B = {}, B[L] = Mo(Y, function(V) {
      b.current = V;
    }), B["aria-controls"] = _.menuId, B["aria-expanded"] = J.isOpen, B.id = _.toggleButtonId, B.tabIndex = -1, B), !Q.disabled && me({}, {
      onClick: Ke(Z, ae)
    }), Q);
  }, [l, k, _]), j = Me(function(N, B) {
    var W, Z = N === void 0 ? {} : N, ee = Z.onKeyDown, L = Z.onChange, Y = Z.onInput, Q = Z.onBlur;
    Z.onChangeText;
    var J = Z.onClick, ae = Z.refKey, V = ae === void 0 ? "ref" : ae, fe = Z.ref, X = da(Z, hO), Ye = B === void 0 ? {} : B, Ve = Ye.suppressRefError, Ft = Ve === void 0 ? !1 : Ve;
    E("getInputProps", Ft, V, m);
    var ft = k.current.state, Ba = function(bt) {
      var oe = wc(bt);
      oe && C[oe] && C[oe](bt);
    }, Fa = function(bt) {
      l({
        type: Ju,
        inputValue: bt.target.value
      });
    }, St = function(bt) {
      if (n != null && n.document && ft.isOpen && !$.isMouseDown) {
        var oe = bt.relatedTarget === null && n.document.activeElement !== n.document.body;
        l({
          type: Oi,
          selectItem: !oe
        });
      }
    }, ia = function() {
      l({
        type: Zu
      });
    }, ka = "onChange", Va = {};
    if (!X.disabled) {
      var we;
      Va = (we = {}, we[ka] = Ke(L, Y, Fa), we.onKeyDown = Ke(ee, Ba), we.onBlur = Ke(Q, St), we.onClick = Ke(J, ia), we);
    }
    return me((W = {}, W[V] = Mo(fe, function(bt) {
      m.current = bt;
    }), W["aria-activedescendant"] = ft.isOpen && ft.highlightedIndex > -1 ? _.getItemId(ft.highlightedIndex) : "", W["aria-autocomplete"] = "list", W["aria-controls"] = _.menuId, W["aria-expanded"] = ft.isOpen, W["aria-labelledby"] = X && X["aria-label"] ? void 0 : _.labelId, W.autoComplete = "off", W.id = _.inputId, W.role = "combobox", W.value = ft.inputValue, W), Va, X);
  }, [l, _, n, C, k, $, E]), U = Me(function() {
    l({
      type: fv
    });
  }, [l]), I = Me(function() {
    l({
      type: _v
    });
  }, [l]), K = Me(function() {
    l({
      type: bv
    });
  }, [l]), q = Me(function(N) {
    l({
      type: vv,
      highlightedIndex: N
    });
  }, [l]), te = Me(function(N) {
    l({
      type: Xu,
      selectedItem: N
    });
  }, [l]), O = Me(function(N) {
    l({
      type: yv,
      inputValue: N
    });
  }, [l]), A = Me(function() {
    l({
      type: wv
    });
  }, [l]);
  return {
    // prop getters.
    getItemProps: H,
    getLabelProps: z,
    getMenuProps: R,
    getInputProps: j,
    getToggleButtonProps: M,
    // actions.
    toggleMenu: U,
    openMenu: K,
    closeMenu: I,
    setHighlightedIndex: q,
    setInputValue: O,
    selectItem: te,
    reset: A,
    // state.
    highlightedIndex: u,
    isOpen: c,
    selectedItem: d,
    inputValue: h
  };
}
ri.stateReducer, ri.itemToKey, ri.environment, G.array, G.array, G.array, G.func, G.number, G.number, G.number, G.func, G.func, G.string, G.string;
zn.itemToKey, zn.stateReducer, zn.environment;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
process.env.NODE_ENV;
const mO = "_autocomplete_olk74_29", pO = "_suggestion_olk74_87", fO = "_highlight_olk74_107", $a = {
  autocomplete: mO,
  "autocomplete-container": "_autocomplete-container_olk74_38",
  "input-button-container": "_input-button-container_olk74_43",
  "autocomplete-input": "_autocomplete-input_olk74_49",
  "autocomplete-button": "_autocomplete-button_olk74_63",
  "suggestions-container": "_suggestions-container_olk74_87",
  suggestion: pO,
  highlight: fO
};
function bO({
  id: e,
  placeholder: t,
  value: a,
  onChange: o,
  suggestions: n = [],
  buttonText: r,
  onSubmit: i,
  hideButtonText: s,
  className: l,
  ...c
}) {
  const { isOpen: u, getLabelProps: d, getMenuProps: h, getInputProps: p, highlightedIndex: f, getItemProps: m, selectedItem: b } = ed({
    id: e,
    onInputValueChange({ inputValue: y }) {
      o && o(y ?? "");
    },
    items: n,
    itemToString(y) {
      return y?.value ?? "";
    }
  }), w = ao($a.autocomplete, l);
  function _(y) {
    y.preventDefault(), i && i(y, b ?? void 0);
  }
  return /* @__PURE__ */ T("div", { className: w, ...c, children: [
    /* @__PURE__ */ v("form", { className: $a["autocomplete-container"], onSubmit: _, children: /* @__PURE__ */ T("div", { className: $a["input-button-container"], children: [
      /* @__PURE__ */ v("label", { ...d(), hidden: !0, children: t }),
      /* @__PURE__ */ v(
        "input",
        {
          className: $a["autocomplete-input"],
          type: "text",
          placeholder: t,
          value: a,
          ...p()
        }
      ),
      /* @__PURE__ */ T("button", { "aria-label": r, className: $a["autocomplete-button"], children: [
        /* @__PURE__ */ v(In, { name: "search" }),
        !s && r
      ] })
    ] }) }),
    /* @__PURE__ */ v("ul", { className: $a["suggestions-container"], ...h(), "data-test": u, "aria-busy": !u, children: u && n.map((y, k) => /* @__PURE__ */ v(
      "li",
      {
        className: `${$a.suggestion} ${f === k ? $a.highlight : ""}`,
        ...m({ item: y, index: k }),
        children: y.value
      },
      y.id
    )) })
  ] });
}
function _O(e, [t, a]) {
  return Math.min(a, Math.max(t, e));
}
var ks = "Switch", [vO, Prt] = _o(ks), [yO, wO] = vO(ks), kO = g.forwardRef(
  (e, t) => {
    const {
      __scopeSwitch: a,
      name: o,
      checked: n,
      defaultChecked: r,
      required: i,
      disabled: s,
      value: l = "on",
      onCheckedChange: c,
      form: u,
      ...d
    } = e, [h, p] = g.useState(null), f = He(t, (y) => p(y)), m = g.useRef(!1), b = h ? u || !!h.closest("form") : !0, [w, _] = bs({
      prop: n,
      defaultProp: r ?? !1,
      onChange: c,
      caller: ks
    });
    return /* @__PURE__ */ T(yO, { scope: a, checked: w, disabled: s, children: [
      /* @__PURE__ */ v(
        Ae.button,
        {
          type: "button",
          role: "switch",
          "aria-checked": w,
          "aria-required": i,
          "data-state": Cv(w),
          "data-disabled": s ? "" : void 0,
          disabled: s,
          value: l,
          ...d,
          ref: f,
          onClick: be(e.onClick, (y) => {
            _((k) => !k), b && (m.current = y.isPropagationStopped(), m.current || y.stopPropagation());
          })
        }
      ),
      b && /* @__PURE__ */ v(
        Sv,
        {
          control: h,
          bubbles: !m.current,
          name: o,
          value: l,
          checked: w,
          required: i,
          disabled: s,
          form: u,
          style: { transform: "translateX(-100%)" }
        }
      )
    ] });
  }
);
kO.displayName = ks;
var $v = "SwitchThumb", xO = g.forwardRef(
  (e, t) => {
    const { __scopeSwitch: a, ...o } = e, n = wO($v, a);
    return /* @__PURE__ */ v(
      Ae.span,
      {
        "data-state": Cv(n.checked),
        "data-disabled": n.disabled ? "" : void 0,
        ...o,
        ref: t
      }
    );
  }
);
xO.displayName = $v;
var $O = "SwitchBubbleInput", Sv = g.forwardRef(
  ({
    __scopeSwitch: e,
    control: t,
    checked: a,
    bubbles: o = !0,
    ...n
  }, r) => {
    const i = g.useRef(null), s = He(i, r), l = xz(a), c = kz(t);
    return g.useEffect(() => {
      const u = i.current;
      if (!u) return;
      const d = window.HTMLInputElement.prototype, h = Object.getOwnPropertyDescriptor(
        d,
        "checked"
      ).set;
      if (l !== a && h) {
        const p = new Event("click", { bubbles: o });
        h.call(u, a), u.dispatchEvent(p);
      }
    }, [l, a, o]), /* @__PURE__ */ v(
      "input",
      {
        type: "checkbox",
        "aria-hidden": !0,
        defaultChecked: a,
        ...n,
        tabIndex: -1,
        ref: s,
        style: {
          ...n.style,
          ...c,
          position: "absolute",
          pointerEvents: "none",
          opacity: 0,
          margin: 0
        }
      }
    );
  }
);
Sv.displayName = $O;
function Cv(e) {
  return e ? "checked" : "unchecked";
}
function SO(e, t) {
  return g.useReducer((a, o) => t[a][o] ?? a, e);
}
var td = "ScrollArea", [Ev, Drt] = _o(td), [CO, Pt] = Ev(td), EO = g.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: a,
      type: o = "hover",
      dir: n,
      scrollHideDelay: r = 600,
      ...i
    } = e, [s, l] = g.useState(null), [c, u] = g.useState(null), [d, h] = g.useState(null), [p, f] = g.useState(null), [m, b] = g.useState(null), [w, _] = g.useState(0), [y, k] = g.useState(0), [x, S] = g.useState(!1), [$, E] = g.useState(!1), C = He(t, (R) => l(R)), z = Au(n);
    return /* @__PURE__ */ v(
      CO,
      {
        scope: a,
        type: o,
        dir: z,
        scrollHideDelay: r,
        scrollArea: s,
        viewport: c,
        onViewportChange: u,
        content: d,
        onContentChange: h,
        scrollbarX: p,
        onScrollbarXChange: f,
        scrollbarXEnabled: x,
        onScrollbarXEnabledChange: S,
        scrollbarY: m,
        onScrollbarYChange: b,
        scrollbarYEnabled: $,
        onScrollbarYEnabledChange: E,
        onCornerWidthChange: _,
        onCornerHeightChange: k,
        children: /* @__PURE__ */ v(
          Ae.div,
          {
            dir: z,
            ...i,
            ref: C,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": w + "px",
              "--radix-scroll-area-corner-height": y + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
EO.displayName = td;
var zv = "ScrollAreaViewport", zO = g.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: a, children: o, nonce: n, ...r } = e, i = Pt(zv, a), s = g.useRef(null), l = He(t, s, i.onViewportChange);
    return /* @__PURE__ */ T(De, { children: [
      /* @__PURE__ */ v(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: n
        }
      ),
      /* @__PURE__ */ v(
        Ae.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...r,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: i.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: i.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ v("div", { ref: i.onContentChange, style: { minWidth: "100%", display: "table" }, children: o })
        }
      )
    ] });
  }
);
zO.displayName = zv;
var ta = "ScrollAreaScrollbar", jO = g.forwardRef(
  (e, t) => {
    const { forceMount: a, ...o } = e, n = Pt(ta, e.__scopeScrollArea), { onScrollbarXEnabledChange: r, onScrollbarYEnabledChange: i } = n, s = e.orientation === "horizontal";
    return g.useEffect(() => (s ? r(!0) : i(!0), () => {
      s ? r(!1) : i(!1);
    }), [s, r, i]), n.type === "hover" ? /* @__PURE__ */ v(AO, { ...o, ref: t, forceMount: a }) : n.type === "scroll" ? /* @__PURE__ */ v(OO, { ...o, ref: t, forceMount: a }) : n.type === "auto" ? /* @__PURE__ */ v(jv, { ...o, ref: t, forceMount: a }) : n.type === "always" ? /* @__PURE__ */ v(ad, { ...o, ref: t }) : null;
  }
);
jO.displayName = ta;
var AO = g.forwardRef((e, t) => {
  const { forceMount: a, ...o } = e, n = Pt(ta, e.__scopeScrollArea), [r, i] = g.useState(!1);
  return g.useEffect(() => {
    const s = n.scrollArea;
    let l = 0;
    if (s) {
      const c = () => {
        window.clearTimeout(l), i(!0);
      }, u = () => {
        l = window.setTimeout(() => i(!1), n.scrollHideDelay);
      };
      return s.addEventListener("pointerenter", c), s.addEventListener("pointerleave", u), () => {
        window.clearTimeout(l), s.removeEventListener("pointerenter", c), s.removeEventListener("pointerleave", u);
      };
    }
  }, [n.scrollArea, n.scrollHideDelay]), /* @__PURE__ */ v(_a, { present: a || r, children: /* @__PURE__ */ v(
    jv,
    {
      "data-state": r ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), OO = g.forwardRef((e, t) => {
  const { forceMount: a, ...o } = e, n = Pt(ta, e.__scopeScrollArea), r = e.orientation === "horizontal", i = $s(() => l("SCROLL_END"), 100), [s, l] = SO("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return g.useEffect(() => {
    if (s === "idle") {
      const c = window.setTimeout(() => l("HIDE"), n.scrollHideDelay);
      return () => window.clearTimeout(c);
    }
  }, [s, n.scrollHideDelay, l]), g.useEffect(() => {
    const c = n.viewport, u = r ? "scrollLeft" : "scrollTop";
    if (c) {
      let d = c[u];
      const h = () => {
        const p = c[u];
        d !== p && (l("SCROLL"), i()), d = p;
      };
      return c.addEventListener("scroll", h), () => c.removeEventListener("scroll", h);
    }
  }, [n.viewport, r, l, i]), /* @__PURE__ */ v(_a, { present: a || s !== "hidden", children: /* @__PURE__ */ v(
    ad,
    {
      "data-state": s === "hidden" ? "hidden" : "visible",
      ...o,
      ref: t,
      onPointerEnter: be(e.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: be(e.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), jv = g.forwardRef((e, t) => {
  const a = Pt(ta, e.__scopeScrollArea), { forceMount: o, ...n } = e, [r, i] = g.useState(!1), s = e.orientation === "horizontal", l = $s(() => {
    if (a.viewport) {
      const c = a.viewport.offsetWidth < a.viewport.scrollWidth, u = a.viewport.offsetHeight < a.viewport.scrollHeight;
      i(s ? c : u);
    }
  }, 10);
  return Xo(a.viewport, l), Xo(a.content, l), /* @__PURE__ */ v(_a, { present: o || r, children: /* @__PURE__ */ v(
    ad,
    {
      "data-state": r ? "visible" : "hidden",
      ...n,
      ref: t
    }
  ) });
}), ad = g.forwardRef((e, t) => {
  const { orientation: a = "vertical", ...o } = e, n = Pt(ta, e.__scopeScrollArea), r = g.useRef(null), i = g.useRef(0), [s, l] = g.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), c = Pv(s.viewport, s.content), u = {
    ...o,
    sizes: s,
    onSizesChange: l,
    hasThumb: c > 0 && c < 1,
    onThumbChange: (h) => r.current = h,
    onThumbPointerUp: () => i.current = 0,
    onThumbPointerDown: (h) => i.current = h
  };
  function d(h, p) {
    return LO(h, i.current, s, p);
  }
  return a === "horizontal" ? /* @__PURE__ */ v(
    PO,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (n.viewport && r.current) {
          const h = n.viewport.scrollLeft, p = xh(h, s, n.dir);
          r.current.style.transform = `translate3d(${p}px, 0, 0)`;
        }
      },
      onWheelScroll: (h) => {
        n.viewport && (n.viewport.scrollLeft = h);
      },
      onDragScroll: (h) => {
        n.viewport && (n.viewport.scrollLeft = d(h, n.dir));
      }
    }
  ) : a === "vertical" ? /* @__PURE__ */ v(
    DO,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (n.viewport && r.current) {
          const h = n.viewport.scrollTop, p = xh(h, s);
          r.current.style.transform = `translate3d(0, ${p}px, 0)`;
        }
      },
      onWheelScroll: (h) => {
        n.viewport && (n.viewport.scrollTop = h);
      },
      onDragScroll: (h) => {
        n.viewport && (n.viewport.scrollTop = d(h));
      }
    }
  ) : null;
}), PO = g.forwardRef((e, t) => {
  const { sizes: a, onSizesChange: o, ...n } = e, r = Pt(ta, e.__scopeScrollArea), [i, s] = g.useState(), l = g.useRef(null), c = He(t, l, r.onScrollbarXChange);
  return g.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ v(
    Ov,
    {
      "data-orientation": "horizontal",
      ...n,
      ref: c,
      sizes: a,
      style: {
        bottom: 0,
        left: r.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: r.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": xs(a) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.x),
      onDragScroll: (u) => e.onDragScroll(u.x),
      onWheelScroll: (u, d) => {
        if (r.viewport) {
          const h = r.viewport.scrollLeft + u.deltaX;
          e.onWheelScroll(h), Nv(h, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && r.viewport && i && o({
          content: r.viewport.scrollWidth,
          viewport: r.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: Di(i.paddingLeft),
            paddingEnd: Di(i.paddingRight)
          }
        });
      }
    }
  );
}), DO = g.forwardRef((e, t) => {
  const { sizes: a, onSizesChange: o, ...n } = e, r = Pt(ta, e.__scopeScrollArea), [i, s] = g.useState(), l = g.useRef(null), c = He(t, l, r.onScrollbarYChange);
  return g.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ v(
    Ov,
    {
      "data-orientation": "vertical",
      ...n,
      ref: c,
      sizes: a,
      style: {
        top: 0,
        right: r.dir === "ltr" ? 0 : void 0,
        left: r.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": xs(a) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.y),
      onDragScroll: (u) => e.onDragScroll(u.y),
      onWheelScroll: (u, d) => {
        if (r.viewport) {
          const h = r.viewport.scrollTop + u.deltaY;
          e.onWheelScroll(h), Nv(h, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && r.viewport && i && o({
          content: r.viewport.scrollHeight,
          viewport: r.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: Di(i.paddingTop),
            paddingEnd: Di(i.paddingBottom)
          }
        });
      }
    }
  );
}), [NO, Av] = Ev(ta), Ov = g.forwardRef((e, t) => {
  const {
    __scopeScrollArea: a,
    sizes: o,
    hasThumb: n,
    onThumbChange: r,
    onThumbPointerUp: i,
    onThumbPointerDown: s,
    onThumbPositionChange: l,
    onDragScroll: c,
    onWheelScroll: u,
    onResize: d,
    ...h
  } = e, p = Pt(ta, a), [f, m] = g.useState(null), b = He(t, (C) => m(C)), w = g.useRef(null), _ = g.useRef(""), y = p.viewport, k = o.content - o.viewport, x = Qe(u), S = Qe(l), $ = $s(d, 10);
  function E(C) {
    if (w.current) {
      const z = C.clientX - w.current.left, R = C.clientY - w.current.top;
      c({ x: z, y: R });
    }
  }
  return g.useEffect(() => {
    const C = (z) => {
      const R = z.target;
      f?.contains(R) && x(z, k);
    };
    return document.addEventListener("wheel", C, { passive: !1 }), () => document.removeEventListener("wheel", C, { passive: !1 });
  }, [y, f, k, x]), g.useEffect(S, [o, S]), Xo(f, $), Xo(p.content, $), /* @__PURE__ */ v(
    NO,
    {
      scope: a,
      scrollbar: f,
      hasThumb: n,
      onThumbChange: Qe(r),
      onThumbPointerUp: Qe(i),
      onThumbPositionChange: S,
      onThumbPointerDown: Qe(s),
      children: /* @__PURE__ */ v(
        Ae.div,
        {
          ...h,
          ref: b,
          style: { position: "absolute", ...h.style },
          onPointerDown: be(e.onPointerDown, (C) => {
            C.button === 0 && (C.target.setPointerCapture(C.pointerId), w.current = f.getBoundingClientRect(), _.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", p.viewport && (p.viewport.style.scrollBehavior = "auto"), E(C));
          }),
          onPointerMove: be(e.onPointerMove, E),
          onPointerUp: be(e.onPointerUp, (C) => {
            const z = C.target;
            z.hasPointerCapture(C.pointerId) && z.releasePointerCapture(C.pointerId), document.body.style.webkitUserSelect = _.current, p.viewport && (p.viewport.style.scrollBehavior = ""), w.current = null;
          })
        }
      )
    }
  );
}), Pi = "ScrollAreaThumb", RO = g.forwardRef(
  (e, t) => {
    const { forceMount: a, ...o } = e, n = Av(Pi, e.__scopeScrollArea);
    return /* @__PURE__ */ v(_a, { present: a || n.hasThumb, children: /* @__PURE__ */ v(IO, { ref: t, ...o }) });
  }
), IO = g.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: a, style: o, ...n } = e, r = Pt(Pi, a), i = Av(Pi, a), { onThumbPositionChange: s } = i, l = He(
      t,
      (d) => i.onThumbChange(d)
    ), c = g.useRef(void 0), u = $s(() => {
      c.current && (c.current(), c.current = void 0);
    }, 100);
    return g.useEffect(() => {
      const d = r.viewport;
      if (d) {
        const h = () => {
          if (u(), !c.current) {
            const p = WO(d, s);
            c.current = p, s();
          }
        };
        return s(), d.addEventListener("scroll", h), () => d.removeEventListener("scroll", h);
      }
    }, [r.viewport, u, s]), /* @__PURE__ */ v(
      Ae.div,
      {
        "data-state": i.hasThumb ? "visible" : "hidden",
        ...n,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...o
        },
        onPointerDownCapture: be(e.onPointerDownCapture, (d) => {
          const h = d.target.getBoundingClientRect(), p = d.clientX - h.left, f = d.clientY - h.top;
          i.onThumbPointerDown({ x: p, y: f });
        }),
        onPointerUp: be(e.onPointerUp, i.onThumbPointerUp)
      }
    );
  }
);
RO.displayName = Pi;
var od = "ScrollAreaCorner", TO = g.forwardRef(
  (e, t) => {
    const a = Pt(od, e.__scopeScrollArea), o = !!(a.scrollbarX && a.scrollbarY);
    return a.type !== "scroll" && o ? /* @__PURE__ */ v(MO, { ...e, ref: t }) : null;
  }
);
TO.displayName = od;
var MO = g.forwardRef((e, t) => {
  const { __scopeScrollArea: a, ...o } = e, n = Pt(od, a), [r, i] = g.useState(0), [s, l] = g.useState(0), c = !!(r && s);
  return Xo(n.scrollbarX, () => {
    const u = n.scrollbarX?.offsetHeight || 0;
    n.onCornerHeightChange(u), l(u);
  }), Xo(n.scrollbarY, () => {
    const u = n.scrollbarY?.offsetWidth || 0;
    n.onCornerWidthChange(u), i(u);
  }), c ? /* @__PURE__ */ v(
    Ae.div,
    {
      ...o,
      ref: t,
      style: {
        width: r,
        height: s,
        position: "absolute",
        right: n.dir === "ltr" ? 0 : void 0,
        left: n.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function Di(e) {
  return e ? parseInt(e, 10) : 0;
}
function Pv(e, t) {
  const a = e / t;
  return isNaN(a) ? 0 : a;
}
function xs(e) {
  const t = Pv(e.viewport, e.content), a = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, o = (e.scrollbar.size - a) * t;
  return Math.max(o, 18);
}
function LO(e, t, a, o = "ltr") {
  const n = xs(a), r = n / 2, i = t || r, s = n - i, l = a.scrollbar.paddingStart + i, c = a.scrollbar.size - a.scrollbar.paddingEnd - s, u = a.content - a.viewport, d = o === "ltr" ? [0, u] : [u * -1, 0];
  return Dv([l, c], d)(e);
}
function xh(e, t, a = "ltr") {
  const o = xs(t), n = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, r = t.scrollbar.size - n, i = t.content - t.viewport, s = r - o, l = a === "ltr" ? [0, i] : [i * -1, 0], c = _O(e, l);
  return Dv([0, i], [0, s])(c);
}
function Dv(e, t) {
  return (a) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (a - e[0]);
  };
}
function Nv(e, t) {
  return e > 0 && e < t;
}
var WO = (e, t = () => {
}) => {
  let a = { left: e.scrollLeft, top: e.scrollTop }, o = 0;
  return function n() {
    const r = { left: e.scrollLeft, top: e.scrollTop }, i = a.left !== r.left, s = a.top !== r.top;
    (i || s) && t(), a = r, o = window.requestAnimationFrame(n);
  }(), () => window.cancelAnimationFrame(o);
};
function $s(e, t) {
  const a = Qe(e), o = g.useRef(0);
  return g.useEffect(() => () => window.clearTimeout(o.current), []), g.useCallback(() => {
    window.clearTimeout(o.current), o.current = window.setTimeout(a, t);
  }, [a, t]);
}
function Xo(e, t) {
  const a = Qe(t);
  Da(() => {
    let o = 0;
    if (e) {
      const n = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(a);
      });
      return n.observe(e), () => {
        window.cancelAnimationFrame(o), n.unobserve(e);
      };
    }
  }, [e, a]);
}
var BO = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), FO = "VisuallyHidden", nd = g.forwardRef(
  (e, t) => /* @__PURE__ */ v(
    Ae.span,
    {
      ...e,
      ref: t,
      style: { ...BO, ...e.style }
    }
  )
);
nd.displayName = FO;
var Ss = "Tabs", [VO, Nrt] = _o(Ss, [
  i_
]), Rv = i_(), [UO, rd] = VO(Ss), qO = g.forwardRef(
  (e, t) => {
    const {
      __scopeTabs: a,
      value: o,
      onValueChange: n,
      defaultValue: r,
      orientation: i = "horizontal",
      dir: s,
      activationMode: l = "automatic",
      ...c
    } = e, u = Au(s), [d, h] = bs({
      prop: o,
      onChange: n,
      defaultProp: r ?? "",
      caller: Ss
    });
    return /* @__PURE__ */ v(
      UO,
      {
        scope: a,
        baseId: n_(),
        value: d,
        onValueChange: h,
        orientation: i,
        dir: u,
        activationMode: l,
        children: /* @__PURE__ */ v(
          Ae.div,
          {
            dir: u,
            "data-orientation": i,
            ...c,
            ref: t
          }
        )
      }
    );
  }
);
qO.displayName = Ss;
var Iv = "TabsList", HO = g.forwardRef(
  (e, t) => {
    const { __scopeTabs: a, loop: o = !0, ...n } = e, r = rd(Iv, a), i = Rv(a);
    return /* @__PURE__ */ v(
      yz,
      {
        asChild: !0,
        ...i,
        orientation: r.orientation,
        dir: r.dir,
        loop: o,
        children: /* @__PURE__ */ v(
          Ae.div,
          {
            role: "tablist",
            "aria-orientation": r.orientation,
            ...n,
            ref: t
          }
        )
      }
    );
  }
);
HO.displayName = Iv;
var Tv = "TabsTrigger", GO = g.forwardRef(
  (e, t) => {
    const { __scopeTabs: a, value: o, disabled: n = !1, ...r } = e, i = rd(Tv, a), s = Rv(a), l = Lv(i.baseId, o), c = Wv(i.baseId, o), u = o === i.value;
    return /* @__PURE__ */ v(
      wz,
      {
        asChild: !0,
        ...s,
        focusable: !n,
        active: u,
        children: /* @__PURE__ */ v(
          Ae.button,
          {
            type: "button",
            role: "tab",
            "aria-selected": u,
            "aria-controls": c,
            "data-state": u ? "active" : "inactive",
            "data-disabled": n ? "" : void 0,
            disabled: n,
            id: l,
            ...r,
            ref: t,
            onMouseDown: be(e.onMouseDown, (d) => {
              !n && d.button === 0 && d.ctrlKey === !1 ? i.onValueChange(o) : d.preventDefault();
            }),
            onKeyDown: be(e.onKeyDown, (d) => {
              [" ", "Enter"].includes(d.key) && i.onValueChange(o);
            }),
            onFocus: be(e.onFocus, () => {
              const d = i.activationMode !== "manual";
              !u && !n && d && i.onValueChange(o);
            })
          }
        )
      }
    );
  }
);
GO.displayName = Tv;
var Mv = "TabsContent", KO = g.forwardRef(
  (e, t) => {
    const { __scopeTabs: a, value: o, forceMount: n, children: r, ...i } = e, s = rd(Mv, a), l = Lv(s.baseId, o), c = Wv(s.baseId, o), u = o === s.value, d = g.useRef(u);
    return g.useEffect(() => {
      const h = requestAnimationFrame(() => d.current = !1);
      return () => cancelAnimationFrame(h);
    }, []), /* @__PURE__ */ v(_a, { present: n || u, children: ({ present: h }) => /* @__PURE__ */ v(
      Ae.div,
      {
        "data-state": u ? "active" : "inactive",
        "data-orientation": s.orientation,
        role: "tabpanel",
        "aria-labelledby": l,
        hidden: !h,
        id: c,
        tabIndex: 0,
        ...i,
        ref: t,
        style: {
          ...e.style,
          animationDuration: d.current ? "0s" : void 0
        },
        children: h && r
      }
    ) });
  }
);
KO.displayName = Mv;
function Lv(e, t) {
  return `${e}-trigger-${t}`;
}
function Wv(e, t) {
  return `${e}-content-${t}`;
}
var JO = "ToastProvider", [Bv, ZO, YO] = o_("Toast"), [Fv, Rrt] = _o("Toast", [YO]), [Irt, Cs] = Fv(JO), Vv = "ToastViewport", XO = ["F8"], $c = "toast.viewportPause", Sc = "toast.viewportResume", QO = g.forwardRef(
  (e, t) => {
    const {
      __scopeToast: a,
      hotkey: o = XO,
      label: n = "Notifications ({hotkey})",
      ...r
    } = e, i = Cs(Vv, a), s = ZO(a), l = g.useRef(null), c = g.useRef(null), u = g.useRef(null), d = g.useRef(null), h = He(t, d, i.onViewportChange), p = o.join("+").replace(/Key/g, "").replace(/Digit/g, ""), f = i.toastCount > 0;
    g.useEffect(() => {
      const b = (w) => {
        o.length !== 0 && o.every((_) => w[_] || w.code === _) && d.current?.focus();
      };
      return document.addEventListener("keydown", b), () => document.removeEventListener("keydown", b);
    }, [o]), g.useEffect(() => {
      const b = l.current, w = d.current;
      if (f && b && w) {
        const _ = () => {
          if (!i.isClosePausedRef.current) {
            const S = new CustomEvent($c);
            w.dispatchEvent(S), i.isClosePausedRef.current = !0;
          }
        }, y = () => {
          if (i.isClosePausedRef.current) {
            const S = new CustomEvent(Sc);
            w.dispatchEvent(S), i.isClosePausedRef.current = !1;
          }
        }, k = (S) => {
          !b.contains(S.relatedTarget) && y();
        }, x = () => {
          b.contains(document.activeElement) || y();
        };
        return b.addEventListener("focusin", _), b.addEventListener("focusout", k), b.addEventListener("pointermove", _), b.addEventListener("pointerleave", x), window.addEventListener("blur", _), window.addEventListener("focus", y), () => {
          b.removeEventListener("focusin", _), b.removeEventListener("focusout", k), b.removeEventListener("pointermove", _), b.removeEventListener("pointerleave", x), window.removeEventListener("blur", _), window.removeEventListener("focus", y);
        };
      }
    }, [f, i.isClosePausedRef]);
    const m = g.useCallback(
      ({ tabbingDirection: b }) => {
        const w = s().map((_) => {
          const y = _.ref.current, k = [y, ...fP(y)];
          return b === "forwards" ? k : k.reverse();
        });
        return (b === "forwards" ? w.reverse() : w).flat();
      },
      [s]
    );
    return g.useEffect(() => {
      const b = d.current;
      if (b) {
        const w = (_) => {
          const y = _.altKey || _.ctrlKey || _.metaKey;
          if (_.key === "Tab" && !y) {
            const k = document.activeElement, x = _.shiftKey;
            if (_.target === b && x) {
              c.current?.focus();
              return;
            }
            const S = m({ tabbingDirection: x ? "backwards" : "forwards" }), $ = S.findIndex((E) => E === k);
            El(S.slice($ + 1)) ? _.preventDefault() : x ? c.current?.focus() : u.current?.focus();
          }
        };
        return b.addEventListener("keydown", w), () => b.removeEventListener("keydown", w);
      }
    }, [s, m]), /* @__PURE__ */ T(
      rj,
      {
        ref: l,
        role: "region",
        "aria-label": n.replace("{hotkey}", p),
        tabIndex: -1,
        style: { pointerEvents: f ? void 0 : "none" },
        children: [
          f && /* @__PURE__ */ v(
            Cc,
            {
              ref: c,
              onFocusFromOutsideViewport: () => {
                const b = m({
                  tabbingDirection: "forwards"
                });
                El(b);
              }
            }
          ),
          /* @__PURE__ */ v(Bv.Slot, { scope: a, children: /* @__PURE__ */ v(Ae.ol, { tabIndex: -1, ...r, ref: h }) }),
          f && /* @__PURE__ */ v(
            Cc,
            {
              ref: u,
              onFocusFromOutsideViewport: () => {
                const b = m({
                  tabbingDirection: "backwards"
                });
                El(b);
              }
            }
          )
        ]
      }
    );
  }
);
QO.displayName = Vv;
var Uv = "ToastFocusProxy", Cc = g.forwardRef(
  (e, t) => {
    const { __scopeToast: a, onFocusFromOutsideViewport: o, ...n } = e, r = Cs(Uv, a);
    return /* @__PURE__ */ v(
      nd,
      {
        tabIndex: 0,
        ...n,
        ref: t,
        style: { position: "fixed" },
        onFocus: (i) => {
          const s = i.relatedTarget;
          !r.viewport?.contains(s) && o();
        }
      }
    );
  }
);
Cc.displayName = Uv;
var ar = "Toast", eP = "toast.swipeStart", tP = "toast.swipeMove", aP = "toast.swipeCancel", oP = "toast.swipeEnd", nP = g.forwardRef(
  (e, t) => {
    const { forceMount: a, open: o, defaultOpen: n, onOpenChange: r, ...i } = e, [s, l] = bs({
      prop: o,
      defaultProp: n ?? !0,
      onChange: r,
      caller: ar
    });
    return /* @__PURE__ */ v(_a, { present: a || s, children: /* @__PURE__ */ v(
      sP,
      {
        open: s,
        ...i,
        ref: t,
        onClose: () => l(!1),
        onPause: Qe(e.onPause),
        onResume: Qe(e.onResume),
        onSwipeStart: be(e.onSwipeStart, (c) => {
          c.currentTarget.setAttribute("data-swipe", "start");
        }),
        onSwipeMove: be(e.onSwipeMove, (c) => {
          const { x: u, y: d } = c.detail.delta;
          c.currentTarget.setAttribute("data-swipe", "move"), c.currentTarget.style.setProperty("--radix-toast-swipe-move-x", `${u}px`), c.currentTarget.style.setProperty("--radix-toast-swipe-move-y", `${d}px`);
        }),
        onSwipeCancel: be(e.onSwipeCancel, (c) => {
          c.currentTarget.setAttribute("data-swipe", "cancel"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), c.currentTarget.style.removeProperty("--radix-toast-swipe-end-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-end-y");
        }),
        onSwipeEnd: be(e.onSwipeEnd, (c) => {
          const { x: u, y: d } = c.detail.delta;
          c.currentTarget.setAttribute("data-swipe", "end"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-x"), c.currentTarget.style.removeProperty("--radix-toast-swipe-move-y"), c.currentTarget.style.setProperty("--radix-toast-swipe-end-x", `${u}px`), c.currentTarget.style.setProperty("--radix-toast-swipe-end-y", `${d}px`), l(!1);
        })
      }
    ) });
  }
);
nP.displayName = ar;
var [rP, iP] = Fv(ar, {
  onClose() {
  }
}), sP = g.forwardRef(
  (e, t) => {
    const {
      __scopeToast: a,
      type: o = "foreground",
      duration: n,
      open: r,
      onClose: i,
      onEscapeKeyDown: s,
      onPause: l,
      onResume: c,
      onSwipeStart: u,
      onSwipeMove: d,
      onSwipeCancel: h,
      onSwipeEnd: p,
      ...f
    } = e, m = Cs(ar, a), [b, w] = g.useState(null), _ = He(t, (j) => w(j)), y = g.useRef(null), k = g.useRef(null), x = n || m.duration, S = g.useRef(0), $ = g.useRef(x), E = g.useRef(0), { onToastAdd: C, onToastRemove: z } = m, R = Qe(() => {
      b?.contains(document.activeElement) && m.viewport?.focus(), i();
    }), H = g.useCallback(
      (j) => {
        !j || j === 1 / 0 || (window.clearTimeout(E.current), S.current = (/* @__PURE__ */ new Date()).getTime(), E.current = window.setTimeout(R, j));
      },
      [R]
    );
    g.useEffect(() => {
      const j = m.viewport;
      if (j) {
        const U = () => {
          H($.current), c?.();
        }, I = () => {
          const K = (/* @__PURE__ */ new Date()).getTime() - S.current;
          $.current = $.current - K, window.clearTimeout(E.current), l?.();
        };
        return j.addEventListener($c, I), j.addEventListener(Sc, U), () => {
          j.removeEventListener($c, I), j.removeEventListener(Sc, U);
        };
      }
    }, [m.viewport, x, l, c, H]), g.useEffect(() => {
      r && !m.isClosePausedRef.current && H(x);
    }, [r, x, m.isClosePausedRef, H]), g.useEffect(() => (C(), () => z()), [C, z]);
    const M = g.useMemo(() => b ? Jv(b) : null, [b]);
    return m.viewport ? /* @__PURE__ */ T(De, { children: [
      M && /* @__PURE__ */ v(
        lP,
        {
          __scopeToast: a,
          role: "status",
          "aria-live": o === "foreground" ? "assertive" : "polite",
          children: M
        }
      ),
      /* @__PURE__ */ v(rP, { scope: a, onClose: R, children: mo.createPortal(
        /* @__PURE__ */ v(Bv.ItemSlot, { scope: a, children: /* @__PURE__ */ v(
          nj,
          {
            asChild: !0,
            onEscapeKeyDown: be(s, () => {
              m.isFocusedToastEscapeKeyDownRef.current || R(), m.isFocusedToastEscapeKeyDownRef.current = !1;
            }),
            children: /* @__PURE__ */ v(
              Ae.li,
              {
                tabIndex: 0,
                "data-state": r ? "open" : "closed",
                "data-swipe-direction": m.swipeDirection,
                ...f,
                ref: _,
                style: { userSelect: "none", touchAction: "none", ...e.style },
                onKeyDown: be(e.onKeyDown, (j) => {
                  j.key === "Escape" && (s?.(j.nativeEvent), j.nativeEvent.defaultPrevented || (m.isFocusedToastEscapeKeyDownRef.current = !0, R()));
                }),
                onPointerDown: be(e.onPointerDown, (j) => {
                  j.button === 0 && (y.current = { x: j.clientX, y: j.clientY });
                }),
                onPointerMove: be(e.onPointerMove, (j) => {
                  if (!y.current) return;
                  const U = j.clientX - y.current.x, I = j.clientY - y.current.y, K = !!k.current, q = ["left", "right"].includes(m.swipeDirection), te = ["left", "up"].includes(m.swipeDirection) ? Math.min : Math.max, O = q ? te(0, U) : 0, A = q ? 0 : te(0, I), N = j.pointerType === "touch" ? 10 : 2, B = { x: O, y: A }, W = { originalEvent: j, delta: B };
                  K ? (k.current = B, Pr(tP, d, W, {
                    discrete: !1
                  })) : $h(B, m.swipeDirection, N) ? (k.current = B, Pr(eP, u, W, {
                    discrete: !1
                  }), j.target.setPointerCapture(j.pointerId)) : (Math.abs(U) > N || Math.abs(I) > N) && (y.current = null);
                }),
                onPointerUp: be(e.onPointerUp, (j) => {
                  const U = k.current, I = j.target;
                  if (I.hasPointerCapture(j.pointerId) && I.releasePointerCapture(j.pointerId), k.current = null, y.current = null, U) {
                    const K = j.currentTarget, q = { originalEvent: j, delta: U };
                    $h(U, m.swipeDirection, m.swipeThreshold) ? Pr(oP, p, q, {
                      discrete: !0
                    }) : Pr(
                      aP,
                      h,
                      q,
                      {
                        discrete: !0
                      }
                    ), K.addEventListener("click", (te) => te.preventDefault(), {
                      once: !0
                    });
                  }
                })
              }
            )
          }
        ) }),
        m.viewport
      ) })
    ] }) : null;
  }
), lP = (e) => {
  const { __scopeToast: t, children: a, ...o } = e, n = Cs(ar, t), [r, i] = g.useState(!1), [s, l] = g.useState(!1);
  return mP(() => i(!0)), g.useEffect(() => {
    const c = window.setTimeout(() => l(!0), 1e3);
    return () => window.clearTimeout(c);
  }, []), s ? null : /* @__PURE__ */ v(v_, { asChild: !0, children: /* @__PURE__ */ v(nd, { ...o, children: r && /* @__PURE__ */ T(De, { children: [
    n.label,
    " ",
    a
  ] }) }) });
}, cP = "ToastTitle", uP = g.forwardRef(
  (e, t) => {
    const { __scopeToast: a, ...o } = e;
    return /* @__PURE__ */ v(Ae.div, { ...o, ref: t });
  }
);
uP.displayName = cP;
var dP = "ToastDescription", gP = g.forwardRef(
  (e, t) => {
    const { __scopeToast: a, ...o } = e;
    return /* @__PURE__ */ v(Ae.div, { ...o, ref: t });
  }
);
gP.displayName = dP;
var qv = "ToastAction", hP = g.forwardRef(
  (e, t) => {
    const { altText: a, ...o } = e;
    return a.trim() ? /* @__PURE__ */ v(Kv, { altText: a, asChild: !0, children: /* @__PURE__ */ v(Gv, { ...o, ref: t }) }) : (console.error(
      `Invalid prop \`altText\` supplied to \`${qv}\`. Expected non-empty \`string\`.`
    ), null);
  }
);
hP.displayName = qv;
var Hv = "ToastClose", Gv = g.forwardRef(
  (e, t) => {
    const { __scopeToast: a, ...o } = e, n = iP(Hv, a);
    return /* @__PURE__ */ v(Kv, { asChild: !0, children: /* @__PURE__ */ v(
      Ae.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: be(e.onClick, n.onClose)
      }
    ) });
  }
);
Gv.displayName = Hv;
var Kv = g.forwardRef((e, t) => {
  const { __scopeToast: a, altText: o, ...n } = e;
  return /* @__PURE__ */ v(
    Ae.div,
    {
      "data-radix-toast-announce-exclude": "",
      "data-radix-toast-announce-alt": o || void 0,
      ...n,
      ref: t
    }
  );
});
function Jv(e) {
  const t = [];
  return Array.from(e.childNodes).forEach((a) => {
    if (a.nodeType === a.TEXT_NODE && a.textContent && t.push(a.textContent), pP(a)) {
      const o = a.ariaHidden || a.hidden || a.style.display === "none", n = a.dataset.radixToastAnnounceExclude === "";
      if (!o)
        if (n) {
          const r = a.dataset.radixToastAnnounceAlt;
          r && t.push(r);
        } else
          t.push(...Jv(a));
    }
  }), t;
}
function Pr(e, t, a, { discrete: o }) {
  const n = a.originalEvent.currentTarget, r = new CustomEvent(e, { bubbles: !0, cancelable: !0, detail: a });
  t && n.addEventListener(e, t, { once: !0 }), o ? a_(n, r) : n.dispatchEvent(r);
}
var $h = (e, t, a = 0) => {
  const o = Math.abs(e.x), n = Math.abs(e.y), r = o > n;
  return t === "left" || t === "right" ? r && o > a : !r && n > a;
};
function mP(e = () => {
}) {
  const t = Qe(e);
  Da(() => {
    let a = 0, o = 0;
    return a = window.requestAnimationFrame(() => o = window.requestAnimationFrame(t)), () => {
      window.cancelAnimationFrame(a), window.cancelAnimationFrame(o);
    };
  }, [t]);
}
function pP(e) {
  return e.nodeType === e.ELEMENT_NODE;
}
function fP(e) {
  const t = [], a = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const n = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || n ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; a.nextNode(); ) t.push(a.currentNode);
  return t;
}
function El(e) {
  const t = document.activeElement;
  return e.some((a) => a === t ? !0 : (a.focus(), document.activeElement !== t));
}
function bP(e, t = 500) {
  const [a, o] = Pe(e);
  return Ce(() => {
    const n = setTimeout(() => o(e), t);
    return () => {
      clearTimeout(n);
    };
  }, [e, t]), a;
}
const _P = jt(void 0);
function vP({ children: e, config: t }) {
  const { apiUrl: a } = t;
  fE(a);
  const o = {
    apiUrl: "",
    locale: "fr"
  }, [n, r] = Pe({
    ...o,
    ...t
  }), i = {
    config: n,
    setConfig: r
  };
  return /* @__PURE__ */ v(_P.Provider, { value: i, children: e });
}
jt(void 0);
function et(e, t) {
  if (e === !1 || e === null || typeof e > "u")
    throw new Error(t);
}
function pa(e, t) {
  if (!e) {
    typeof console < "u" && console.warn(t);
    try {
      throw new Error(t);
    } catch {
    }
  }
}
function Ec({
  pathname: e = "/",
  search: t = "",
  hash: a = ""
}) {
  return t && t !== "?" && (e += t.charAt(0) === "?" ? t : "?" + t), a && a !== "#" && (e += a.charAt(0) === "#" ? a : "#" + a), e;
}
function id(e) {
  let t = {};
  if (e) {
    let a = e.indexOf("#");
    a >= 0 && (t.hash = e.substring(a), e = e.substring(0, a));
    let o = e.indexOf("?");
    o >= 0 && (t.search = e.substring(o), e = e.substring(0, o)), e && (t.pathname = e);
  }
  return t;
}
function Zv(e, t, a = "/") {
  return yP(e, t, a, !1);
}
function yP(e, t, a, o) {
  let n = typeof t == "string" ? id(t) : t, r = Na(n.pathname || "/", a);
  if (r == null)
    return null;
  let i = Yv(e);
  wP(i);
  let s = null;
  for (let l = 0; s == null && l < i.length; ++l) {
    let c = PP(r);
    s = AP(
      i[l],
      c,
      o
    );
  }
  return s;
}
function Yv(e, t = [], a = [], o = "", n = !1) {
  let r = (i, s, l = n, c) => {
    let u = {
      relativePath: c === void 0 ? i.path || "" : c,
      caseSensitive: i.caseSensitive === !0,
      childrenIndex: s,
      route: i
    };
    if (u.relativePath.startsWith("/")) {
      if (!u.relativePath.startsWith(o) && l)
        return;
      et(
        u.relativePath.startsWith(o),
        `Absolute route path "${u.relativePath}" nested under path "${o}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`
      ), u.relativePath = u.relativePath.slice(o.length);
    }
    let d = ga([o, u.relativePath]), h = a.concat(u);
    i.children && i.children.length > 0 && (et(
      // Our types know better, but runtime JS may not!
      // @ts-expect-error
      i.index !== !0,
      `Index routes must not have child routes. Please remove all child routes from route path "${d}".`
    ), Yv(
      i.children,
      t,
      h,
      d,
      l
    )), !(i.path == null && !i.index) && t.push({
      path: d,
      score: zP(d, i.index),
      routesMeta: h
    });
  };
  return e.forEach((i, s) => {
    if (i.path === "" || !i.path?.includes("?"))
      r(i, s);
    else
      for (let l of Xv(i.path))
        r(i, s, !0, l);
  }), t;
}
function Xv(e) {
  let t = e.split("/");
  if (t.length === 0) return [];
  let [a, ...o] = t, n = a.endsWith("?"), r = a.replace(/\?$/, "");
  if (o.length === 0)
    return n ? [r, ""] : [r];
  let i = Xv(o.join("/")), s = [];
  return s.push(
    ...i.map(
      (l) => l === "" ? r : [r, l].join("/")
    )
  ), n && s.push(...i), s.map(
    (l) => e.startsWith("/") && l === "" ? "/" : l
  );
}
function wP(e) {
  e.sort(
    (t, a) => t.score !== a.score ? a.score - t.score : jP(
      t.routesMeta.map((o) => o.childrenIndex),
      a.routesMeta.map((o) => o.childrenIndex)
    )
  );
}
var kP = /^:[\w-]+$/, xP = 3, $P = 2, SP = 1, CP = 10, EP = -2, Sh = (e) => e === "*";
function zP(e, t) {
  let a = e.split("/"), o = a.length;
  return a.some(Sh) && (o += EP), t && (o += $P), a.filter((n) => !Sh(n)).reduce(
    (n, r) => n + (kP.test(r) ? xP : r === "" ? SP : CP),
    o
  );
}
function jP(e, t) {
  return e.length === t.length && e.slice(0, -1).every((a, o) => a === t[o]) ? (
    // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    e[e.length - 1] - t[t.length - 1]
  ) : (
    // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0
  );
}
function AP(e, t, a = !1) {
  let { routesMeta: o } = e, n = {}, r = "/", i = [];
  for (let s = 0; s < o.length; ++s) {
    let l = o[s], c = s === o.length - 1, u = r === "/" ? t : t.slice(r.length) || "/", d = Ni(
      { path: l.relativePath, caseSensitive: l.caseSensitive, end: c },
      u
    ), h = l.route;
    if (!d && c && a && !o[o.length - 1].route.index && (d = Ni(
      {
        path: l.relativePath,
        caseSensitive: l.caseSensitive,
        end: !1
      },
      u
    )), !d)
      return null;
    Object.assign(n, d.params), i.push({
      // TODO: Can this as be avoided?
      params: n,
      pathname: ga([r, d.pathname]),
      pathnameBase: IP(
        ga([r, d.pathnameBase])
      ),
      route: h
    }), d.pathnameBase !== "/" && (r = ga([r, d.pathnameBase]));
  }
  return i;
}
function Ni(e, t) {
  typeof e == "string" && (e = { path: e, caseSensitive: !1, end: !0 });
  let [a, o] = OP(
    e.path,
    e.caseSensitive,
    e.end
  ), n = t.match(a);
  if (!n) return null;
  let r = n[0], i = r.replace(/(.)\/+$/, "$1"), s = n.slice(1);
  return {
    params: o.reduce(
      (l, { paramName: c, isOptional: u }, d) => {
        if (c === "*") {
          let p = s[d] || "";
          i = r.slice(0, r.length - p.length).replace(/(.)\/+$/, "$1");
        }
        const h = s[d];
        return u && !h ? l[c] = void 0 : l[c] = (h || "").replace(/%2F/g, "/"), l;
      },
      {}
    ),
    pathname: r,
    pathnameBase: i,
    pattern: e
  };
}
function OP(e, t = !1, a = !0) {
  pa(
    e === "*" || !e.endsWith("*") || e.endsWith("/*"),
    `Route path "${e}" will be treated as if it were "${e.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${e.replace(/\*$/, "/*")}".`
  );
  let o = [], n = "^" + e.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(
    /\/:([\w-]+)(\?)?/g,
    (r, i, s) => (o.push({ paramName: i, isOptional: s != null }), s ? "/?([^\\/]+)?" : "/([^\\/]+)")
  ).replace(/\/([\w-]+)\?(\/|$)/g, "(/$1)?$2");
  return e.endsWith("*") ? (o.push({ paramName: "*" }), n += e === "*" || e === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$") : a ? n += "\\/*$" : e !== "" && e !== "/" && (n += "(?:(?=\\/|$))"), [new RegExp(n, t ? void 0 : "i"), o];
}
function PP(e) {
  try {
    return e.split("/").map((t) => decodeURIComponent(t).replace(/\//g, "%2F")).join("/");
  } catch (t) {
    return pa(
      !1,
      `The URL path "${e}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${t}).`
    ), e;
  }
}
function Na(e, t) {
  if (t === "/") return e;
  if (!e.toLowerCase().startsWith(t.toLowerCase()))
    return null;
  let a = t.endsWith("/") ? t.length - 1 : t.length, o = e.charAt(a);
  return o && o !== "/" ? null : e.slice(a) || "/";
}
function DP(e, t = "/") {
  let {
    pathname: a,
    search: o = "",
    hash: n = ""
  } = typeof e == "string" ? id(e) : e;
  return {
    pathname: a ? a.startsWith("/") ? a : NP(a, t) : t,
    search: TP(o),
    hash: MP(n)
  };
}
function NP(e, t) {
  let a = t.replace(/\/+$/, "").split("/");
  return e.split("/").forEach((o) => {
    o === ".." ? a.length > 1 && a.pop() : o !== "." && a.push(o);
  }), a.length > 1 ? a.join("/") : "/";
}
function zl(e, t, a, o) {
  return `Cannot include a '${e}' character in a manually specified \`to.${t}\` field [${JSON.stringify(
    o
  )}].  Please separate it out to the \`to.${a}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function RP(e) {
  return e.filter(
    (t, a) => a === 0 || t.route.path && t.route.path.length > 0
  );
}
function Qv(e) {
  let t = RP(e);
  return t.map(
    (a, o) => o === t.length - 1 ? a.pathname : a.pathnameBase
  );
}
function ey(e, t, a, o = !1) {
  let n;
  typeof e == "string" ? n = id(e) : (n = { ...e }, et(
    !n.pathname || !n.pathname.includes("?"),
    zl("?", "pathname", "search", n)
  ), et(
    !n.pathname || !n.pathname.includes("#"),
    zl("#", "pathname", "hash", n)
  ), et(
    !n.search || !n.search.includes("#"),
    zl("#", "search", "hash", n)
  ));
  let r = e === "" || n.pathname === "", i = r ? "/" : n.pathname, s;
  if (i == null)
    s = a;
  else {
    let d = t.length - 1;
    if (!o && i.startsWith("..")) {
      let h = i.split("/");
      for (; h[0] === ".."; )
        h.shift(), d -= 1;
      n.pathname = h.join("/");
    }
    s = d >= 0 ? t[d] : "/";
  }
  let l = DP(n, s), c = i && i !== "/" && i.endsWith("/"), u = (r || i === ".") && a.endsWith("/");
  return !l.pathname.endsWith("/") && (c || u) && (l.pathname += "/"), l;
}
var ga = (e) => e.join("/").replace(/\/\/+/g, "/"), IP = (e) => e.replace(/\/+$/, "").replace(/^\/*/, "/"), TP = (e) => !e || e === "?" ? "" : e.startsWith("?") ? e : "?" + e, MP = (e) => !e || e === "#" ? "" : e.startsWith("#") ? e : "#" + e;
function LP(e) {
  return e != null && typeof e.status == "number" && typeof e.statusText == "string" && typeof e.internal == "boolean" && "data" in e;
}
var ty = [
  "POST",
  "PUT",
  "PATCH",
  "DELETE"
];
new Set(
  ty
);
var WP = [
  "GET",
  ...ty
];
new Set(WP);
var rn = g.createContext(null);
rn.displayName = "DataRouter";
var Es = g.createContext(null);
Es.displayName = "DataRouterState";
g.createContext(!1);
var ay = g.createContext({
  isTransitioning: !1
});
ay.displayName = "ViewTransition";
var BP = g.createContext(
  /* @__PURE__ */ new Map()
);
BP.displayName = "Fetchers";
var FP = g.createContext(null);
FP.displayName = "Await";
var ya = g.createContext(
  null
);
ya.displayName = "Navigation";
var zs = g.createContext(
  null
);
zs.displayName = "Location";
var wa = g.createContext({
  outlet: null,
  matches: [],
  isDataRoute: !1
});
wa.displayName = "Route";
var sd = g.createContext(null);
sd.displayName = "RouteError";
function VP(e, { relative: t } = {}) {
  et(
    js(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useHref() may be used only in the context of a <Router> component."
  );
  let { basename: a, navigator: o } = g.useContext(ya), { hash: n, pathname: r, search: i } = or(e, { relative: t }), s = r;
  return a !== "/" && (s = r === "/" ? a : ga([a, r])), o.createHref({ pathname: s, search: i, hash: n });
}
function js() {
  return g.useContext(zs) != null;
}
function vo() {
  return et(
    js(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useLocation() may be used only in the context of a <Router> component."
  ), g.useContext(zs).location;
}
var oy = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
function ny(e) {
  g.useContext(ya).static || g.useLayoutEffect(e);
}
function UP() {
  let { isDataRoute: e } = g.useContext(wa);
  return e ? oD() : qP();
}
function qP() {
  et(
    js(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useNavigate() may be used only in the context of a <Router> component."
  );
  let e = g.useContext(rn), { basename: t, navigator: a } = g.useContext(ya), { matches: o } = g.useContext(wa), { pathname: n } = vo(), r = JSON.stringify(Qv(o)), i = g.useRef(!1);
  return ny(() => {
    i.current = !0;
  }), g.useCallback(
    (s, l = {}) => {
      if (pa(i.current, oy), !i.current) return;
      if (typeof s == "number") {
        a.go(s);
        return;
      }
      let c = ey(
        s,
        JSON.parse(r),
        n,
        l.relative === "path"
      );
      e == null && t !== "/" && (c.pathname = c.pathname === "/" ? t : ga([t, c.pathname])), (l.replace ? a.replace : a.push)(
        c,
        l.state,
        l
      );
    },
    [
      t,
      a,
      r,
      n,
      e
    ]
  );
}
g.createContext(null);
function or(e, { relative: t } = {}) {
  let { matches: a } = g.useContext(wa), { pathname: o } = vo(), n = JSON.stringify(Qv(a));
  return g.useMemo(
    () => ey(
      e,
      JSON.parse(n),
      o,
      t === "path"
    ),
    [e, n, o, t]
  );
}
function HP(e, t, a, o, n) {
  et(
    js(),
    // TODO: This error is probably because they somehow have 2 versions of the
    // router loaded. We can help them understand how to avoid that.
    "useRoutes() may be used only in the context of a <Router> component."
  );
  let { navigator: r } = g.useContext(ya), { matches: i } = g.useContext(wa), s = i[i.length - 1], l = s ? s.params : {}, c = s ? s.pathname : "/", u = s ? s.pathnameBase : "/", d = s && s.route;
  {
    let _ = d && d.path || "";
    ry(
      c,
      !d || _.endsWith("*") || _.endsWith("*?"),
      `You rendered descendant <Routes> (or called \`useRoutes()\`) at "${c}" (under <Route path="${_}">) but the parent route path has no trailing "*". This means if you navigate deeper, the parent won't match anymore and therefore the child routes will never render.

Please change the parent <Route path="${_}"> to <Route path="${_ === "/" ? "*" : `${_}/*`}">.`
    );
  }
  let h = vo(), p;
  p = h;
  let f = p.pathname || "/", m = f;
  if (u !== "/") {
    let _ = u.replace(/^\//, "").split("/");
    m = "/" + f.replace(/^\//, "").split("/").slice(_.length).join("/");
  }
  let b = Zv(e, { pathname: m });
  pa(
    d || b != null,
    `No routes matched location "${p.pathname}${p.search}${p.hash}" `
  ), pa(
    b == null || b[b.length - 1].route.element !== void 0 || b[b.length - 1].route.Component !== void 0 || b[b.length - 1].route.lazy !== void 0,
    `Matched leaf route at location "${p.pathname}${p.search}${p.hash}" does not have an element or Component. This means it will render an <Outlet /> with a null value by default resulting in an "empty" page.`
  );
  let w = YP(
    b && b.map(
      (_) => Object.assign({}, _, {
        params: Object.assign({}, l, _.params),
        pathname: ga([
          u,
          // Re-encode pathnames that were decoded inside matchRoutes.
          // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
          // `new URL()` internally and we need to prevent it from treating
          // them as separators
          r.encodeLocation ? r.encodeLocation(
            _.pathname.replace(/\?/g, "%3F").replace(/#/g, "%23")
          ).pathname : _.pathname
        ]),
        pathnameBase: _.pathnameBase === "/" ? u : ga([
          u,
          // Re-encode pathnames that were decoded inside matchRoutes
          // Pre-encode `?` and `#` ahead of `encodeLocation` because it uses
          // `new URL()` internally and we need to prevent it from treating
          // them as separators
          r.encodeLocation ? r.encodeLocation(
            _.pathnameBase.replace(/\?/g, "%3F").replace(/#/g, "%23")
          ).pathname : _.pathnameBase
        ])
      })
    ),
    i,
    a,
    o,
    n
  );
  return t && w ? /* @__PURE__ */ g.createElement(
    zs.Provider,
    {
      value: {
        location: {
          pathname: "/",
          search: "",
          hash: "",
          state: null,
          key: "default",
          ...p
        },
        navigationType: "POP"
        /* Pop */
      }
    },
    w
  ) : w;
}
function GP() {
  let e = aD(), t = LP(e) ? `${e.status} ${e.statusText}` : e instanceof Error ? e.message : JSON.stringify(e), a = e instanceof Error ? e.stack : null, o = "rgba(200,200,200, 0.5)", n = { padding: "0.5rem", backgroundColor: o }, r = { padding: "2px 4px", backgroundColor: o }, i = null;
  return console.error(
    "Error handled by React Router default ErrorBoundary:",
    e
  ), i = /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement("p", null, "💿 Hey developer 👋"), /* @__PURE__ */ g.createElement("p", null, "You can provide a way better UX than this when your app throws errors by providing your own ", /* @__PURE__ */ g.createElement("code", { style: r }, "ErrorBoundary"), " or", " ", /* @__PURE__ */ g.createElement("code", { style: r }, "errorElement"), " prop on your route.")), /* @__PURE__ */ g.createElement(g.Fragment, null, /* @__PURE__ */ g.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ g.createElement("h3", { style: { fontStyle: "italic" } }, t), a ? /* @__PURE__ */ g.createElement("pre", { style: n }, a) : null, i);
}
var KP = /* @__PURE__ */ g.createElement(GP, null), JP = class extends g.Component {
  constructor(t) {
    super(t), this.state = {
      location: t.location,
      revalidation: t.revalidation,
      error: t.error
    };
  }
  static getDerivedStateFromError(t) {
    return { error: t };
  }
  static getDerivedStateFromProps(t, a) {
    return a.location !== t.location || a.revalidation !== "idle" && t.revalidation === "idle" ? {
      error: t.error,
      location: t.location,
      revalidation: t.revalidation
    } : {
      error: t.error !== void 0 ? t.error : a.error,
      location: a.location,
      revalidation: t.revalidation || a.revalidation
    };
  }
  componentDidCatch(t, a) {
    this.props.unstable_onError ? this.props.unstable_onError(t, a) : console.error(
      "React Router caught the following error during render",
      t
    );
  }
  render() {
    return this.state.error !== void 0 ? /* @__PURE__ */ g.createElement(wa.Provider, { value: this.props.routeContext }, /* @__PURE__ */ g.createElement(
      sd.Provider,
      {
        value: this.state.error,
        children: this.props.component
      }
    )) : this.props.children;
  }
};
function ZP({ routeContext: e, match: t, children: a }) {
  let o = g.useContext(rn);
  return o && o.static && o.staticContext && (t.route.errorElement || t.route.ErrorBoundary) && (o.staticContext._deepestRenderedBoundaryId = t.route.id), /* @__PURE__ */ g.createElement(wa.Provider, { value: e }, a);
}
function YP(e, t = [], a = null, o = null, n = null) {
  if (e == null) {
    if (!a)
      return null;
    if (a.errors)
      e = a.matches;
    else if (t.length === 0 && !a.initialized && a.matches.length > 0)
      e = a.matches;
    else
      return null;
  }
  let r = e, i = a?.errors;
  if (i != null) {
    let c = r.findIndex(
      (u) => u.route.id && i?.[u.route.id] !== void 0
    );
    et(
      c >= 0,
      `Could not find a matching route for errors on route IDs: ${Object.keys(
        i
      ).join(",")}`
    ), r = r.slice(
      0,
      Math.min(r.length, c + 1)
    );
  }
  let s = !1, l = -1;
  if (a)
    for (let c = 0; c < r.length; c++) {
      let u = r[c];
      if ((u.route.HydrateFallback || u.route.hydrateFallbackElement) && (l = c), u.route.id) {
        let { loaderData: d, errors: h } = a, p = u.route.loader && !d.hasOwnProperty(u.route.id) && (!h || h[u.route.id] === void 0);
        if (u.route.lazy || p) {
          s = !0, l >= 0 ? r = r.slice(0, l + 1) : r = [r[0]];
          break;
        }
      }
    }
  return r.reduceRight(
    (c, u, d) => {
      let h, p = !1, f = null, m = null;
      a && (h = i && u.route.id ? i[u.route.id] : void 0, f = u.route.errorElement || KP, s && (l < 0 && d === 0 ? (ry(
        "route-fallback",
        !1,
        "No `HydrateFallback` element provided to render during initial hydration"
      ), p = !0, m = null) : l === d && (p = !0, m = u.route.hydrateFallbackElement || null)));
      let b = t.concat(r.slice(0, d + 1)), w = () => {
        let _;
        return h ? _ = f : p ? _ = m : u.route.Component ? _ = /* @__PURE__ */ g.createElement(u.route.Component, null) : u.route.element ? _ = u.route.element : _ = c, /* @__PURE__ */ g.createElement(
          ZP,
          {
            match: u,
            routeContext: {
              outlet: c,
              matches: b,
              isDataRoute: a != null
            },
            children: _
          }
        );
      };
      return a && (u.route.ErrorBoundary || u.route.errorElement || d === 0) ? /* @__PURE__ */ g.createElement(
        JP,
        {
          location: a.location,
          revalidation: a.revalidation,
          component: f,
          error: h,
          children: w(),
          routeContext: { outlet: null, matches: b, isDataRoute: !0 },
          unstable_onError: o
        }
      ) : w();
    },
    null
  );
}
function ld(e) {
  return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function XP(e) {
  let t = g.useContext(rn);
  return et(t, ld(e)), t;
}
function QP(e) {
  let t = g.useContext(Es);
  return et(t, ld(e)), t;
}
function eD(e) {
  let t = g.useContext(wa);
  return et(t, ld(e)), t;
}
function cd(e) {
  let t = eD(e), a = t.matches[t.matches.length - 1];
  return et(
    a.route.id,
    `${e} can only be used on routes that contain a unique "id"`
  ), a.route.id;
}
function tD() {
  return cd(
    "useRouteId"
    /* UseRouteId */
  );
}
function aD() {
  let e = g.useContext(sd), t = QP(
    "useRouteError"
    /* UseRouteError */
  ), a = cd(
    "useRouteError"
    /* UseRouteError */
  );
  return e !== void 0 ? e : t.errors?.[a];
}
function oD() {
  let { router: e } = XP(
    "useNavigate"
    /* UseNavigateStable */
  ), t = cd(
    "useNavigate"
    /* UseNavigateStable */
  ), a = g.useRef(!1);
  return ny(() => {
    a.current = !0;
  }), g.useCallback(
    async (o, n = {}) => {
      pa(a.current, oy), a.current && (typeof o == "number" ? e.navigate(o) : await e.navigate(o, { fromRouteId: t, ...n }));
    },
    [e, t]
  );
}
var Ch = {};
function ry(e, t, a) {
  !t && !Ch[e] && (Ch[e] = !0, pa(!1, a));
}
g.memo(nD);
function nD({
  routes: e,
  future: t,
  state: a,
  unstable_onError: o
}) {
  return HP(e, void 0, a, o, t);
}
var ii = "get", si = "application/x-www-form-urlencoded";
function As(e) {
  return e != null && typeof e.tagName == "string";
}
function rD(e) {
  return As(e) && e.tagName.toLowerCase() === "button";
}
function iD(e) {
  return As(e) && e.tagName.toLowerCase() === "form";
}
function sD(e) {
  return As(e) && e.tagName.toLowerCase() === "input";
}
function lD(e) {
  return !!(e.metaKey || e.altKey || e.ctrlKey || e.shiftKey);
}
function cD(e, t) {
  return e.button === 0 && // Ignore everything but left clicks
  (!t || t === "_self") && // Let browser handle "target=_blank" etc.
  !lD(e);
}
var Dr = null;
function uD() {
  if (Dr === null)
    try {
      new FormData(
        document.createElement("form"),
        // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0
      ), Dr = !1;
    } catch {
      Dr = !0;
    }
  return Dr;
}
var dD = /* @__PURE__ */ new Set([
  "application/x-www-form-urlencoded",
  "multipart/form-data",
  "text/plain"
]);
function jl(e) {
  return e != null && !dD.has(e) ? (pa(
    !1,
    `"${e}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${si}"`
  ), null) : e;
}
function gD(e, t) {
  let a, o, n, r, i;
  if (iD(e)) {
    let s = e.getAttribute("action");
    o = s ? Na(s, t) : null, a = e.getAttribute("method") || ii, n = jl(e.getAttribute("enctype")) || si, r = new FormData(e);
  } else if (rD(e) || sD(e) && (e.type === "submit" || e.type === "image")) {
    let s = e.form;
    if (s == null)
      throw new Error(
        'Cannot submit a <button> or <input type="submit"> without a <form>'
      );
    let l = e.getAttribute("formaction") || s.getAttribute("action");
    if (o = l ? Na(l, t) : null, a = e.getAttribute("formmethod") || s.getAttribute("method") || ii, n = jl(e.getAttribute("formenctype")) || jl(s.getAttribute("enctype")) || si, r = new FormData(s, e), !uD()) {
      let { name: c, type: u, value: d } = e;
      if (u === "image") {
        let h = c ? `${c}.` : "";
        r.append(`${h}x`, "0"), r.append(`${h}y`, "0");
      } else c && r.append(c, d);
    }
  } else {
    if (As(e))
      throw new Error(
        'Cannot submit element that is not <form>, <button>, or <input type="submit|image">'
      );
    a = ii, o = null, n = si, i = e;
  }
  return r && n === "text/plain" && (i = r, r = void 0), { action: o, method: a.toLowerCase(), encType: n, formData: r, body: i };
}
Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function ud(e, t) {
  if (e === !1 || e === null || typeof e > "u")
    throw new Error(t);
}
function hD(e, t, a) {
  let o = typeof e == "string" ? new URL(
    e,
    // This can be called during the SSR flow via PrefetchPageLinksImpl so
    // don't assume window is available
    typeof window > "u" ? "server://singlefetch/" : window.location.origin
  ) : e;
  return o.pathname === "/" ? o.pathname = `_root.${a}` : t && Na(o.pathname, t) === "/" ? o.pathname = `${t.replace(/\/$/, "")}/_root.${a}` : o.pathname = `${o.pathname.replace(/\/$/, "")}.${a}`, o;
}
async function mD(e, t) {
  if (e.id in t)
    return t[e.id];
  try {
    let a = await import(
      /* @vite-ignore */
      /* webpackIgnore: true */
      e.module
    );
    return t[e.id] = a, a;
  } catch (a) {
    return console.error(
      `Error loading route module \`${e.module}\`, reloading page...`
    ), console.error(a), window.__reactRouterContext && window.__reactRouterContext.isSpaMode, window.location.reload(), new Promise(() => {
    });
  }
}
function pD(e) {
  return e == null ? !1 : e.href == null ? e.rel === "preload" && typeof e.imageSrcSet == "string" && typeof e.imageSizes == "string" : typeof e.rel == "string" && typeof e.href == "string";
}
async function fD(e, t, a) {
  let o = await Promise.all(
    e.map(async (n) => {
      let r = t.routes[n.route.id];
      if (r) {
        let i = await mD(r, a);
        return i.links ? i.links() : [];
      }
      return [];
    })
  );
  return yD(
    o.flat(1).filter(pD).filter((n) => n.rel === "stylesheet" || n.rel === "preload").map(
      (n) => n.rel === "stylesheet" ? { ...n, rel: "prefetch", as: "style" } : { ...n, rel: "prefetch" }
    )
  );
}
function Eh(e, t, a, o, n, r) {
  let i = (l, c) => a[c] ? l.route.id !== a[c].route.id : !0, s = (l, c) => (
    // param change, /users/123 -> /users/456
    a[c].pathname !== l.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    a[c].route.path?.endsWith("*") && a[c].params["*"] !== l.params["*"]
  );
  return r === "assets" ? t.filter(
    (l, c) => i(l, c) || s(l, c)
  ) : r === "data" ? t.filter((l, c) => {
    let u = o.routes[l.route.id];
    if (!u || !u.hasLoader)
      return !1;
    if (i(l, c) || s(l, c))
      return !0;
    if (l.route.shouldRevalidate) {
      let d = l.route.shouldRevalidate({
        currentUrl: new URL(
          n.pathname + n.search + n.hash,
          window.origin
        ),
        currentParams: a[0]?.params || {},
        nextUrl: new URL(e, window.origin),
        nextParams: l.params,
        defaultShouldRevalidate: !0
      });
      if (typeof d == "boolean")
        return d;
    }
    return !0;
  }) : [];
}
function bD(e, t, { includeHydrateFallback: a } = {}) {
  return _D(
    e.map((o) => {
      let n = t.routes[o.route.id];
      if (!n) return [];
      let r = [n.module];
      return n.clientActionModule && (r = r.concat(n.clientActionModule)), n.clientLoaderModule && (r = r.concat(n.clientLoaderModule)), a && n.hydrateFallbackModule && (r = r.concat(n.hydrateFallbackModule)), n.imports && (r = r.concat(n.imports)), r;
    }).flat(1)
  );
}
function _D(e) {
  return [...new Set(e)];
}
function vD(e) {
  let t = {}, a = Object.keys(e).sort();
  for (let o of a)
    t[o] = e[o];
  return t;
}
function yD(e, t) {
  let a = /* @__PURE__ */ new Set();
  return new Set(t), e.reduce((o, n) => {
    let r = JSON.stringify(vD(n));
    return a.has(r) || (a.add(r), o.push({ key: r, link: n })), o;
  }, []);
}
function iy() {
  let e = g.useContext(rn);
  return ud(
    e,
    "You must render this element inside a <DataRouterContext.Provider> element"
  ), e;
}
function wD() {
  let e = g.useContext(Es);
  return ud(
    e,
    "You must render this element inside a <DataRouterStateContext.Provider> element"
  ), e;
}
var dd = g.createContext(void 0);
dd.displayName = "FrameworkContext";
function sy() {
  let e = g.useContext(dd);
  return ud(
    e,
    "You must render this element inside a <HydratedRouter> element"
  ), e;
}
function kD(e, t) {
  let a = g.useContext(dd), [o, n] = g.useState(!1), [r, i] = g.useState(!1), { onFocus: s, onBlur: l, onMouseEnter: c, onMouseLeave: u, onTouchStart: d } = t, h = g.useRef(null);
  g.useEffect(() => {
    if (e === "render" && i(!0), e === "viewport") {
      let m = (w) => {
        w.forEach((_) => {
          i(_.isIntersecting);
        });
      }, b = new IntersectionObserver(m, { threshold: 0.5 });
      return h.current && b.observe(h.current), () => {
        b.disconnect();
      };
    }
  }, [e]), g.useEffect(() => {
    if (o) {
      let m = setTimeout(() => {
        i(!0);
      }, 100);
      return () => {
        clearTimeout(m);
      };
    }
  }, [o]);
  let p = () => {
    n(!0);
  }, f = () => {
    n(!1), i(!1);
  };
  return a ? e !== "intent" ? [r, h, {}] : [
    r,
    h,
    {
      onFocus: _n(s, p),
      onBlur: _n(l, f),
      onMouseEnter: _n(c, p),
      onMouseLeave: _n(u, f),
      onTouchStart: _n(d, p)
    }
  ] : [!1, h, {}];
}
function _n(e, t) {
  return (a) => {
    e && e(a), a.defaultPrevented || t(a);
  };
}
function xD({ page: e, ...t }) {
  let { router: a } = iy(), o = g.useMemo(
    () => Zv(a.routes, e, a.basename),
    [a.routes, e, a.basename]
  );
  return o ? /* @__PURE__ */ g.createElement(SD, { page: e, matches: o, ...t }) : null;
}
function $D(e) {
  let { manifest: t, routeModules: a } = sy(), [o, n] = g.useState([]);
  return g.useEffect(() => {
    let r = !1;
    return fD(e, t, a).then(
      (i) => {
        r || n(i);
      }
    ), () => {
      r = !0;
    };
  }, [e, t, a]), o;
}
function SD({
  page: e,
  matches: t,
  ...a
}) {
  let o = vo(), { manifest: n, routeModules: r } = sy(), { basename: i } = iy(), { loaderData: s, matches: l } = wD(), c = g.useMemo(
    () => Eh(
      e,
      t,
      l,
      n,
      o,
      "data"
    ),
    [e, t, l, n, o]
  ), u = g.useMemo(
    () => Eh(
      e,
      t,
      l,
      n,
      o,
      "assets"
    ),
    [e, t, l, n, o]
  ), d = g.useMemo(() => {
    if (e === o.pathname + o.search + o.hash)
      return [];
    let f = /* @__PURE__ */ new Set(), m = !1;
    if (t.forEach((w) => {
      let _ = n.routes[w.route.id];
      !_ || !_.hasLoader || (!c.some((y) => y.route.id === w.route.id) && w.route.id in s && r[w.route.id]?.shouldRevalidate || _.hasClientLoader ? m = !0 : f.add(w.route.id));
    }), f.size === 0)
      return [];
    let b = hD(e, i, "data");
    return m && f.size > 0 && b.searchParams.set(
      "_routes",
      t.filter((w) => f.has(w.route.id)).map((w) => w.route.id).join(",")
    ), [b.pathname + b.search];
  }, [
    i,
    s,
    o,
    n,
    c,
    t,
    e,
    r
  ]), h = g.useMemo(
    () => bD(u, n),
    [u, n]
  ), p = $D(u);
  return /* @__PURE__ */ g.createElement(g.Fragment, null, d.map((f) => /* @__PURE__ */ g.createElement("link", { key: f, rel: "prefetch", as: "fetch", href: f, ...a })), h.map((f) => /* @__PURE__ */ g.createElement("link", { key: f, rel: "modulepreload", href: f, ...a })), p.map(({ key: f, link: m }) => (
    // these don't spread `linkProps` because they are full link descriptors
    // already with their own props
    /* @__PURE__ */ g.createElement("link", { key: f, nonce: a.nonce, ...m })
  )));
}
function CD(...e) {
  return (t) => {
    e.forEach((a) => {
      typeof a == "function" ? a(t) : a != null && (a.current = t);
    });
  };
}
var ly = typeof window < "u" && typeof window.document < "u" && typeof window.document.createElement < "u";
try {
  ly && (window.__reactRouterVersion = // @ts-expect-error
  "7.9.3");
} catch {
}
var cy = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i, uy = g.forwardRef(
  function({
    onClick: e,
    discover: t = "render",
    prefetch: a = "none",
    relative: o,
    reloadDocument: n,
    replace: r,
    state: i,
    target: s,
    to: l,
    preventScrollReset: c,
    viewTransition: u,
    ...d
  }, h) {
    let { basename: p } = g.useContext(ya), f = typeof l == "string" && cy.test(l), m, b = !1;
    if (typeof l == "string" && f && (m = l, ly))
      try {
        let E = new URL(window.location.href), C = l.startsWith("//") ? new URL(E.protocol + l) : new URL(l), z = Na(C.pathname, p);
        C.origin === E.origin && z != null ? l = z + C.search + C.hash : b = !0;
      } catch {
        pa(
          !1,
          `<Link to="${l}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`
        );
      }
    let w = VP(l, { relative: o }), [_, y, k] = kD(
      a,
      d
    ), x = AD(l, {
      replace: r,
      state: i,
      target: s,
      preventScrollReset: c,
      relative: o,
      viewTransition: u
    });
    function S(E) {
      e && e(E), E.defaultPrevented || x(E);
    }
    let $ = (
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      /* @__PURE__ */ g.createElement(
        "a",
        {
          ...d,
          ...k,
          href: m || w,
          onClick: b || n ? e : S,
          ref: CD(h, y),
          target: s,
          "data-discover": !f && t === "render" ? "true" : void 0
        }
      )
    );
    return _ && !f ? /* @__PURE__ */ g.createElement(g.Fragment, null, $, /* @__PURE__ */ g.createElement(xD, { page: w })) : $;
  }
);
uy.displayName = "Link";
var ED = g.forwardRef(
  function({
    "aria-current": e = "page",
    caseSensitive: t = !1,
    className: a = "",
    end: o = !1,
    style: n,
    to: r,
    viewTransition: i,
    children: s,
    ...l
  }, c) {
    let u = or(r, { relative: l.relative }), d = vo(), h = g.useContext(Es), { navigator: p, basename: f } = g.useContext(ya), m = h != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    RD(u) && i === !0, b = p.encodeLocation ? p.encodeLocation(u).pathname : u.pathname, w = d.pathname, _ = h && h.navigation && h.navigation.location ? h.navigation.location.pathname : null;
    t || (w = w.toLowerCase(), _ = _ ? _.toLowerCase() : null, b = b.toLowerCase()), _ && f && (_ = Na(_, f) || _);
    const y = b !== "/" && b.endsWith("/") ? b.length - 1 : b.length;
    let k = w === b || !o && w.startsWith(b) && w.charAt(y) === "/", x = _ != null && (_ === b || !o && _.startsWith(b) && _.charAt(b.length) === "/"), S = {
      isActive: k,
      isPending: x,
      isTransitioning: m
    }, $ = k ? e : void 0, E;
    typeof a == "function" ? E = a(S) : E = [
      a,
      k ? "active" : null,
      x ? "pending" : null,
      m ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let C = typeof n == "function" ? n(S) : n;
    return /* @__PURE__ */ g.createElement(
      uy,
      {
        ...l,
        "aria-current": $,
        className: E,
        ref: c,
        style: C,
        to: r,
        viewTransition: i
      },
      typeof s == "function" ? s(S) : s
    );
  }
);
ED.displayName = "NavLink";
var zD = g.forwardRef(
  ({
    discover: e = "render",
    fetcherKey: t,
    navigate: a,
    reloadDocument: o,
    replace: n,
    state: r,
    method: i = ii,
    action: s,
    onSubmit: l,
    relative: c,
    preventScrollReset: u,
    viewTransition: d,
    ...h
  }, p) => {
    let f = DD(), m = ND(s, { relative: c }), b = i.toLowerCase() === "get" ? "get" : "post", w = typeof s == "string" && cy.test(s), _ = (y) => {
      if (l && l(y), y.defaultPrevented) return;
      y.preventDefault();
      let k = y.nativeEvent.submitter, x = k?.getAttribute("formmethod") || i;
      f(k || y.currentTarget, {
        fetcherKey: t,
        method: x,
        navigate: a,
        replace: n,
        state: r,
        relative: c,
        preventScrollReset: u,
        viewTransition: d
      });
    };
    return /* @__PURE__ */ g.createElement(
      "form",
      {
        ref: p,
        method: b,
        action: m,
        onSubmit: o ? l : _,
        ...h,
        "data-discover": !w && e === "render" ? "true" : void 0
      }
    );
  }
);
zD.displayName = "Form";
function jD(e) {
  return `${e} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function dy(e) {
  let t = g.useContext(rn);
  return et(t, jD(e)), t;
}
function AD(e, {
  target: t,
  replace: a,
  state: o,
  preventScrollReset: n,
  relative: r,
  viewTransition: i
} = {}) {
  let s = UP(), l = vo(), c = or(e, { relative: r });
  return g.useCallback(
    (u) => {
      if (cD(u, t)) {
        u.preventDefault();
        let d = a !== void 0 ? a : Ec(l) === Ec(c);
        s(e, {
          replace: d,
          state: o,
          preventScrollReset: n,
          relative: r,
          viewTransition: i
        });
      }
    },
    [
      l,
      s,
      c,
      a,
      o,
      t,
      e,
      n,
      r,
      i
    ]
  );
}
var OD = 0, PD = () => `__${String(++OD)}__`;
function DD() {
  let { router: e } = dy(
    "useSubmit"
    /* UseSubmit */
  ), { basename: t } = g.useContext(ya), a = tD();
  return g.useCallback(
    async (o, n = {}) => {
      let { action: r, method: i, encType: s, formData: l, body: c } = gD(
        o,
        t
      );
      if (n.navigate === !1) {
        let u = n.fetcherKey || PD();
        await e.fetch(u, a, n.action || r, {
          preventScrollReset: n.preventScrollReset,
          formData: l,
          body: c,
          formMethod: n.method || i,
          formEncType: n.encType || s,
          flushSync: n.flushSync
        });
      } else
        await e.navigate(n.action || r, {
          preventScrollReset: n.preventScrollReset,
          formData: l,
          body: c,
          formMethod: n.method || i,
          formEncType: n.encType || s,
          replace: n.replace,
          state: n.state,
          fromRouteId: a,
          flushSync: n.flushSync,
          viewTransition: n.viewTransition
        });
    },
    [e, t, a]
  );
}
function ND(e, { relative: t } = {}) {
  let { basename: a } = g.useContext(ya), o = g.useContext(wa);
  et(o, "useFormAction must be used inside a RouteContext");
  let [n] = o.matches.slice(-1), r = { ...or(e || ".", { relative: t }) }, i = vo();
  if (e == null) {
    r.search = i.search;
    let s = new URLSearchParams(r.search), l = s.getAll("index");
    if (l.some((c) => c === "")) {
      s.delete("index"), l.filter((u) => u).forEach((u) => s.append("index", u));
      let c = s.toString();
      r.search = c ? `?${c}` : "";
    }
  }
  return (!e || e === ".") && n.route.index && (r.search = r.search ? r.search.replace(/^\?/, "?index&") : "?index"), a !== "/" && (r.pathname = r.pathname === "/" ? a : ga([a, r.pathname])), Ec(r);
}
function RD(e, { relative: t } = {}) {
  let a = g.useContext(ay);
  et(
    a != null,
    "`useViewTransitionState` must be used within `react-router-dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?"
  );
  let { basename: o } = dy(
    "useViewTransitionState"
    /* useViewTransitionState */
  ), n = or(e, { relative: t });
  if (!a.isTransitioning)
    return !1;
  let r = Na(a.currentLocation.pathname, o) || a.currentLocation.pathname, i = Na(a.nextLocation.pathname, o) || a.nextLocation.pathname;
  return Ni(n.pathname, i) != null || Ni(n.pathname, r) != null;
}
function gy(e) {
  var t, a, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (a = gy(e[t])) && (o && (o += " "), o += a);
  } else for (a in e) e[a] && (o && (o += " "), o += a);
  return o;
}
function ID() {
  for (var e, t, a = 0, o = "", n = arguments.length; a < n; a++) (e = arguments[a]) && (t = gy(e)) && (o && (o += " "), o += t);
  return o;
}
const TD = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], MD = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, LD = TD.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: MD[e]
})), WD = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, BD = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function FD(e = 0) {
  const t = [];
  for (let a = 0; a < e; a++)
    t[a] = `path${a + 1}`;
  return t.map((a) => /* @__PURE__ */ v("span", { className: a }, a));
}
const VD = pt(
  ({ name: e, size: t = "medium", color: a = "base", className: o = "", ...n }, r) => {
    const i = LD.find((l) => l.name === e), s = ID("icon", `ds-${i?.class}`, BD[t], WD[a], o);
    return /* @__PURE__ */ v("i", { className: s, ...n, ref: r, children: FD(i?.paths) });
  }
);
VD.displayName = "Icon";
jt({
  locale: "en"
});
function UD(e, t) {
  const [a, o] = Pe(e), n = bP(a, 500), [r, i] = Pe([]);
  Ce(() => {
    n.length > 3 && yE(n, t).then((l) => {
      const c = l?.features.map((u) => ({ value: u.properties.label, id: u.properties.gid }));
      i(c);
    });
  }, [n, t]);
  const s = n.length > 2 ? r ?? [] : [];
  return { value: a, setValue: o, suggestedDestinations: s };
}
function qD() {
  return Me((e, t) => {
    let a;
    t ? a = `${t.value}?location_id=${t.id}&provider=Jawg` : a = "everywhere", window !== void 0 && (window.location.href = `/search-v2/${a}`);
  }, []);
}
function HD({
  placeholder: e,
  buttonText: t,
  id: a,
  className: o,
  locale: n,
  ...r
}) {
  const { setValue: i, suggestedDestinations: s } = UD("", n), l = qD();
  return /* @__PURE__ */ v(
    bO,
    {
      className: o,
      id: a || "search-bar",
      placeholder: e || "Search destinations",
      suggestions: s,
      onChange: i,
      onSubmit: l,
      buttonText: t || "Search",
      ...r
    }
  );
}
function GD({
  config: e,
  placeholder: t = "Search destinations",
  buttonText: a = "Search",
  id: o,
  className: n,
  ...r
}) {
  return /* @__PURE__ */ v(vP, { config: e, children: /* @__PURE__ */ v(
    HD,
    {
      placeholder: t,
      buttonText: a,
      id: o,
      className: n,
      locale: e.locale,
      ...r
    }
  ) });
}
jt();
const se = (e) => typeof e == "string", vn = () => {
  let e, t;
  const a = new Promise((o, n) => {
    e = o, t = n;
  });
  return a.resolve = e, a.reject = t, a;
}, zh = (e) => e == null ? "" : "" + e, KD = (e, t, a) => {
  e.forEach((o) => {
    t[o] && (a[o] = t[o]);
  });
}, JD = /###/g, jh = (e) => e && e.indexOf("###") > -1 ? e.replace(JD, ".") : e, Ah = (e) => !e || se(e), On = (e, t, a) => {
  const o = se(t) ? t.split(".") : t;
  let n = 0;
  for (; n < o.length - 1; ) {
    if (Ah(e)) return {};
    const r = jh(o[n]);
    !e[r] && a && (e[r] = new a()), Object.prototype.hasOwnProperty.call(e, r) ? e = e[r] : e = {}, ++n;
  }
  return Ah(e) ? {} : {
    obj: e,
    k: jh(o[n])
  };
}, Oh = (e, t, a) => {
  const {
    obj: o,
    k: n
  } = On(e, t, Object);
  if (o !== void 0 || t.length === 1) {
    o[n] = a;
    return;
  }
  let r = t[t.length - 1], i = t.slice(0, t.length - 1), s = On(e, i, Object);
  for (; s.obj === void 0 && i.length; )
    r = `${i[i.length - 1]}.${r}`, i = i.slice(0, i.length - 1), s = On(e, i, Object), s?.obj && typeof s.obj[`${s.k}.${r}`] < "u" && (s.obj = void 0);
  s.obj[`${s.k}.${r}`] = a;
}, ZD = (e, t, a, o) => {
  const {
    obj: n,
    k: r
  } = On(e, t, Object);
  n[r] = n[r] || [], n[r].push(a);
}, Ri = (e, t) => {
  const {
    obj: a,
    k: o
  } = On(e, t);
  if (a && Object.prototype.hasOwnProperty.call(a, o))
    return a[o];
}, YD = (e, t, a) => {
  const o = Ri(e, a);
  return o !== void 0 ? o : Ri(t, a);
}, hy = (e, t, a) => {
  for (const o in t)
    o !== "__proto__" && o !== "constructor" && (o in e ? se(e[o]) || e[o] instanceof String || se(t[o]) || t[o] instanceof String ? a && (e[o] = t[o]) : hy(e[o], t[o], a) : e[o] = t[o]);
  return e;
}, jo = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var XD = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const QD = (e) => se(e) ? e.replace(/[&<>"'\/]/g, (t) => XD[t]) : e;
let eN = class {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const a = this.regExpMap.get(t);
    if (a !== void 0)
      return a;
    const o = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, o), this.regExpQueue.push(t), o;
  }
};
const tN = [" ", ",", "?", "!", ";"], aN = new eN(20), oN = (e, t, a) => {
  t = t || "", a = a || "";
  const o = tN.filter((i) => t.indexOf(i) < 0 && a.indexOf(i) < 0);
  if (o.length === 0) return !0;
  const n = aN.getRegExp(`(${o.map((i) => i === "?" ? "\\?" : i).join("|")})`);
  let r = !n.test(e);
  if (!r) {
    const i = e.indexOf(a);
    i > 0 && !n.test(e.substring(0, i)) && (r = !0);
  }
  return r;
}, zc = (e, t, a = ".") => {
  if (!e) return;
  if (e[t])
    return Object.prototype.hasOwnProperty.call(e, t) ? e[t] : void 0;
  const o = t.split(a);
  let n = e;
  for (let r = 0; r < o.length; ) {
    if (!n || typeof n != "object")
      return;
    let i, s = "";
    for (let l = r; l < o.length; ++l)
      if (l !== r && (s += a), s += o[l], i = n[s], i !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof i) > -1 && l < o.length - 1)
          continue;
        r += l - r + 1;
        break;
      }
    n = i;
  }
  return n;
}, Tn = (e) => e?.replace("_", "-"), nN = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console?.[e]?.apply?.(console, t);
  }
};
class Ii {
  constructor(t, a = {}) {
    this.init(t, a);
  }
  init(t, a = {}) {
    this.prefix = a.prefix || "i18next:", this.logger = t || nN, this.options = a, this.debug = a.debug;
  }
  log(...t) {
    return this.forward(t, "log", "", !0);
  }
  warn(...t) {
    return this.forward(t, "warn", "", !0);
  }
  error(...t) {
    return this.forward(t, "error", "");
  }
  deprecate(...t) {
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, a, o, n) {
    return n && !this.debug ? null : (se(t[0]) && (t[0] = `${o}${this.prefix} ${t[0]}`), this.logger[a](t));
  }
  create(t) {
    return new Ii(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new Ii(this.logger, t);
  }
}
var Kt = new Ii();
let Os = class {
  constructor() {
    this.observers = {};
  }
  on(t, a) {
    return t.split(" ").forEach((o) => {
      this.observers[o] || (this.observers[o] = /* @__PURE__ */ new Map());
      const n = this.observers[o].get(a) || 0;
      this.observers[o].set(a, n + 1);
    }), this;
  }
  off(t, a) {
    if (this.observers[t]) {
      if (!a) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(a);
    }
  }
  emit(t, ...a) {
    this.observers[t] && Array.from(this.observers[t].entries()).forEach(([o, n]) => {
      for (let r = 0; r < n; r++)
        o(...a);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([o, n]) => {
      for (let r = 0; r < n; r++)
        o.apply(o, [t, ...a]);
    });
  }
};
class Ph extends Os {
  constructor(t, a = {
    ns: ["translation"],
    defaultNS: "translation"
  }) {
    super(), this.data = t || {}, this.options = a, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const a = this.options.ns.indexOf(t);
    a > -1 && this.options.ns.splice(a, 1);
  }
  getResource(t, a, o, n = {}) {
    const r = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, i = n.ignoreJSONStructure !== void 0 ? n.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    t.indexOf(".") > -1 ? s = t.split(".") : (s = [t, a], o && (Array.isArray(o) ? s.push(...o) : se(o) && r ? s.push(...o.split(r)) : s.push(o)));
    const l = Ri(this.data, s);
    return !l && !a && !o && t.indexOf(".") > -1 && (t = s[0], a = s[1], o = s.slice(2).join(".")), l || !i || !se(o) ? l : zc(this.data?.[t]?.[a], o, r);
  }
  addResource(t, a, o, n, r = {
    silent: !1
  }) {
    const i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
    let s = [t, a];
    o && (s = s.concat(i ? o.split(i) : o)), t.indexOf(".") > -1 && (s = t.split("."), n = a, a = s[1]), this.addNamespaces(a), Oh(this.data, s, n), r.silent || this.emit("added", t, a, o, n);
  }
  addResources(t, a, o, n = {
    silent: !1
  }) {
    for (const r in o)
      (se(o[r]) || Array.isArray(o[r])) && this.addResource(t, a, r, o[r], {
        silent: !0
      });
    n.silent || this.emit("added", t, a, o);
  }
  addResourceBundle(t, a, o, n, r, i = {
    silent: !1,
    skipCopy: !1
  }) {
    let s = [t, a];
    t.indexOf(".") > -1 && (s = t.split("."), n = o, o = a, a = s[1]), this.addNamespaces(a);
    let l = Ri(this.data, s) || {};
    i.skipCopy || (o = JSON.parse(JSON.stringify(o))), n ? hy(l, o, r) : l = {
      ...l,
      ...o
    }, Oh(this.data, s, l), i.silent || this.emit("added", t, a, o);
  }
  removeResourceBundle(t, a) {
    this.hasResourceBundle(t, a) && delete this.data[t][a], this.removeNamespaces(a), this.emit("removed", t, a);
  }
  hasResourceBundle(t, a) {
    return this.getResource(t, a) !== void 0;
  }
  getResourceBundle(t, a) {
    return a || (a = this.options.defaultNS), this.getResource(t, a);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const a = this.getDataByLanguage(t);
    return !!(a && Object.keys(a) || []).find((o) => a[o] && Object.keys(a[o]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var my = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, a, o, n) {
    return e.forEach((r) => {
      t = this.processors[r]?.process(t, a, o, n) ?? t;
    }), t;
  }
};
const py = Symbol("i18next/PATH_KEY");
function rN() {
  const e = [], t = /* @__PURE__ */ Object.create(null);
  let a;
  return t.get = (o, n) => (a?.revoke?.(), n === py ? e : (e.push(n), a = Proxy.revocable(o, t), a.proxy)), Proxy.revocable(/* @__PURE__ */ Object.create(null), t).proxy;
}
function jc(e, t) {
  const {
    [py]: a
  } = e(rN());
  return a.join(t?.keySeparator ?? ".");
}
const Dh = {}, Nh = (e) => !se(e) && typeof e != "boolean" && typeof e != "number";
class Ti extends Os {
  constructor(t, a = {}) {
    super(), KD(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = a, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Kt.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t, a = {
    interpolation: {}
  }) {
    const o = {
      ...a
    };
    return t == null ? !1 : this.resolve(t, o)?.res !== void 0;
  }
  extractFromKey(t, a) {
    let o = a.nsSeparator !== void 0 ? a.nsSeparator : this.options.nsSeparator;
    o === void 0 && (o = ":");
    const n = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator;
    let r = a.ns || this.options.defaultNS || [];
    const i = o && t.indexOf(o) > -1, s = !this.options.userDefinedKeySeparator && !a.keySeparator && !this.options.userDefinedNsSeparator && !a.nsSeparator && !oN(t, o, n);
    if (i && !s) {
      const l = t.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: t,
          namespaces: se(r) ? [r] : r
        };
      const c = t.split(o);
      (o !== n || o === n && this.options.ns.indexOf(c[0]) > -1) && (r = c.shift()), t = c.join(n);
    }
    return {
      key: t,
      namespaces: se(r) ? [r] : r
    };
  }
  translate(t, a, o) {
    let n = typeof a == "object" ? {
      ...a
    } : a;
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
      ...n
    }), n || (n = {}), t == null) return "";
    typeof t == "function" && (t = jc(t, {
      ...this.options,
      ...n
    })), Array.isArray(t) || (t = [String(t)]);
    const r = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: s,
      namespaces: l
    } = this.extractFromKey(t[t.length - 1], n), c = l[l.length - 1];
    let u = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    u === void 0 && (u = ":");
    const d = n.lng || this.language, h = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (d?.toLowerCase() === "cimode")
      return h ? r ? {
        res: `${c}${u}${s}`,
        usedKey: s,
        exactUsedKey: s,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(n)
      } : `${c}${u}${s}` : r ? {
        res: s,
        usedKey: s,
        exactUsedKey: s,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(n)
      } : s;
    const p = this.resolve(t, n);
    let f = p?.res;
    const m = p?.usedKey || s, b = p?.exactUsedKey || s, w = ["[object Number]", "[object Function]", "[object RegExp]"], _ = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, y = !this.i18nFormat || this.i18nFormat.handleAsObject, k = n.count !== void 0 && !se(n.count), x = Ti.hasDefaultValue(n), S = k ? this.pluralResolver.getSuffix(d, n.count, n) : "", $ = n.ordinal && k ? this.pluralResolver.getSuffix(d, n.count, {
      ordinal: !1
    }) : "", E = k && !n.ordinal && n.count === 0, C = E && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${S}`] || n[`defaultValue${$}`] || n.defaultValue;
    let z = f;
    y && !f && x && (z = C);
    const R = Nh(z), H = Object.prototype.toString.apply(z);
    if (y && z && R && w.indexOf(H) < 0 && !(se(_) && Array.isArray(z))) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const M = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(m, z, {
          ...n,
          ns: l
        }) : `key '${s} (${this.language})' returned an object instead of string.`;
        return r ? (p.res = M, p.usedParams = this.getUsedParamsDetails(n), p) : M;
      }
      if (i) {
        const M = Array.isArray(z), j = M ? [] : {}, U = M ? b : m;
        for (const I in z)
          if (Object.prototype.hasOwnProperty.call(z, I)) {
            const K = `${U}${i}${I}`;
            x && !f ? j[I] = this.translate(K, {
              ...n,
              defaultValue: Nh(C) ? C[I] : void 0,
              joinArrays: !1,
              ns: l
            }) : j[I] = this.translate(K, {
              ...n,
              joinArrays: !1,
              ns: l
            }), j[I] === K && (j[I] = z[I]);
          }
        f = j;
      }
    } else if (y && se(_) && Array.isArray(f))
      f = f.join(_), f && (f = this.extendTranslation(f, t, n, o));
    else {
      let M = !1, j = !1;
      !this.isValidLookup(f) && x && (M = !0, f = C), this.isValidLookup(f) || (j = !0, f = s);
      const U = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && j ? void 0 : f, I = x && C !== f && this.options.updateMissing;
      if (j || M || I) {
        if (this.logger.log(I ? "updateKey" : "missingKey", d, c, s, I ? C : f), i) {
          const O = this.resolve(s, {
            ...n,
            keySeparator: !1
          });
          O && O.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let K = [];
        const q = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && q && q[0])
          for (let O = 0; O < q.length; O++)
            K.push(q[O]);
        else this.options.saveMissingTo === "all" ? K = this.languageUtils.toResolveHierarchy(n.lng || this.language) : K.push(n.lng || this.language);
        const te = (O, A, N) => {
          const B = x && N !== f ? N : U;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(O, c, A, B, I, n) : this.backendConnector?.saveMissing && this.backendConnector.saveMissing(O, c, A, B, I, n), this.emit("missingKey", O, c, A, f);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && k ? K.forEach((O) => {
          const A = this.pluralResolver.getSuffixes(O, n);
          E && n[`defaultValue${this.options.pluralSeparator}zero`] && A.indexOf(`${this.options.pluralSeparator}zero`) < 0 && A.push(`${this.options.pluralSeparator}zero`), A.forEach((N) => {
            te([O], s + N, n[`defaultValue${N}`] || C);
          });
        }) : te(K, s, C));
      }
      f = this.extendTranslation(f, t, n, p, o), j && f === s && this.options.appendNamespaceToMissingKey && (f = `${c}${u}${s}`), (j || M) && this.options.parseMissingKeyHandler && (f = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${c}${u}${s}` : s, M ? f : void 0, n));
    }
    return r ? (p.res = f, p.usedParams = this.getUsedParamsDetails(n), p) : f;
  }
  extendTranslation(t, a, o, n, r) {
    if (this.i18nFormat?.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...o
      }, o.lng || this.language || n.usedLng, n.usedNS, n.usedKey, {
        resolved: n
      });
    else if (!o.skipInterpolation) {
      o.interpolation && this.interpolator.init({
        ...o,
        interpolation: {
          ...this.options.interpolation,
          ...o.interpolation
        }
      });
      const l = se(t) && (o?.interpolation?.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let c;
      if (l) {
        const d = t.match(this.interpolator.nestingRegexp);
        c = d && d.length;
      }
      let u = o.replace && !se(o.replace) ? o.replace : o;
      if (this.options.interpolation.defaultVariables && (u = {
        ...this.options.interpolation.defaultVariables,
        ...u
      }), t = this.interpolator.interpolate(t, u, o.lng || this.language || n.usedLng, o), l) {
        const d = t.match(this.interpolator.nestingRegexp), h = d && d.length;
        c < h && (o.nest = !1);
      }
      !o.lng && n && n.res && (o.lng = this.language || n.usedLng), o.nest !== !1 && (t = this.interpolator.nest(t, (...d) => r?.[0] === d[0] && !o.context ? (this.logger.warn(`It seems you are nesting recursively key: ${d[0]} in key: ${a[0]}`), null) : this.translate(...d, a), o)), o.interpolation && this.interpolator.reset();
    }
    const i = o.postProcess || this.options.postProcess, s = se(i) ? [i] : i;
    return t != null && s?.length && o.applyPostProcessor !== !1 && (t = my.handle(s, t, a, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...n,
        usedParams: this.getUsedParamsDetails(o)
      },
      ...o
    } : o, this)), t;
  }
  resolve(t, a = {}) {
    let o, n, r, i, s;
    return se(t) && (t = [t]), t.forEach((l) => {
      if (this.isValidLookup(o)) return;
      const c = this.extractFromKey(l, a), u = c.key;
      n = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const h = a.count !== void 0 && !se(a.count), p = h && !a.ordinal && a.count === 0, f = a.context !== void 0 && (se(a.context) || typeof a.context == "number") && a.context !== "", m = a.lngs ? a.lngs : this.languageUtils.toResolveHierarchy(a.lng || this.language, a.fallbackLng);
      d.forEach((b) => {
        this.isValidLookup(o) || (s = b, !Dh[`${m[0]}-${b}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(s) && (Dh[`${m[0]}-${b}`] = !0, this.logger.warn(`key "${n}" for languages "${m.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), m.forEach((w) => {
          if (this.isValidLookup(o)) return;
          i = w;
          const _ = [u];
          if (this.i18nFormat?.addLookupKeys)
            this.i18nFormat.addLookupKeys(_, u, w, b, a);
          else {
            let k;
            h && (k = this.pluralResolver.getSuffix(w, a.count, a));
            const x = `${this.options.pluralSeparator}zero`, S = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (h && (a.ordinal && k.indexOf(S) === 0 && _.push(u + k.replace(S, this.options.pluralSeparator)), _.push(u + k), p && _.push(u + x)), f) {
              const $ = `${u}${this.options.contextSeparator || "_"}${a.context}`;
              _.push($), h && (a.ordinal && k.indexOf(S) === 0 && _.push($ + k.replace(S, this.options.pluralSeparator)), _.push($ + k), p && _.push($ + x));
            }
          }
          let y;
          for (; y = _.pop(); )
            this.isValidLookup(o) || (r = y, o = this.getResource(w, b, y, a));
        }));
      });
    }), {
      res: o,
      usedKey: n,
      exactUsedKey: r,
      usedLng: i,
      usedNS: s
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, a, o, n = {}) {
    return this.i18nFormat?.getResource ? this.i18nFormat.getResource(t, a, o, n) : this.resourceStore.getResource(t, a, o, n);
  }
  getUsedParamsDetails(t = {}) {
    const a = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], o = t.replace && !se(t.replace);
    let n = o ? t.replace : t;
    if (o && typeof t.count < "u" && (n.count = t.count), this.options.interpolation.defaultVariables && (n = {
      ...this.options.interpolation.defaultVariables,
      ...n
    }), !o) {
      n = {
        ...n
      };
      for (const r of a)
        delete n[r];
    }
    return n;
  }
  static hasDefaultValue(t) {
    const a = "defaultValue";
    for (const o in t)
      if (Object.prototype.hasOwnProperty.call(t, o) && a === o.substring(0, a.length) && t[o] !== void 0)
        return !0;
    return !1;
  }
}
class Rh {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Kt.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = Tn(t), !t || t.indexOf("-") < 0) return null;
    const a = t.split("-");
    return a.length === 2 || (a.pop(), a[a.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(a.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = Tn(t), !t || t.indexOf("-") < 0) return t;
    const a = t.split("-");
    return this.formatLanguageCode(a[0]);
  }
  formatLanguageCode(t) {
    if (se(t) && t.indexOf("-") > -1) {
      let a;
      try {
        a = Intl.getCanonicalLocales(t)[0];
      } catch {
      }
      return a && this.options.lowerCaseLng && (a = a.toLowerCase()), a || (this.options.lowerCaseLng ? t.toLowerCase() : t);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t) return null;
    let a;
    return t.forEach((o) => {
      if (a) return;
      const n = this.formatLanguageCode(o);
      (!this.options.supportedLngs || this.isSupportedCode(n)) && (a = n);
    }), !a && this.options.supportedLngs && t.forEach((o) => {
      if (a) return;
      const n = this.getScriptPartFromCode(o);
      if (this.isSupportedCode(n)) return a = n;
      const r = this.getLanguagePartFromCode(o);
      if (this.isSupportedCode(r)) return a = r;
      a = this.options.supportedLngs.find((i) => {
        if (i === r || !(i.indexOf("-") < 0 && r.indexOf("-") < 0) && (i.indexOf("-") > 0 && r.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === r || i.indexOf(r) === 0 && r.length > 1))
          return i;
      });
    }), a || (a = this.getFallbackCodes(this.options.fallbackLng)[0]), a;
  }
  getFallbackCodes(t, a) {
    if (!t) return [];
    if (typeof t == "function" && (t = t(a)), se(t) && (t = [t]), Array.isArray(t)) return t;
    if (!a) return t.default || [];
    let o = t[a];
    return o || (o = t[this.getScriptPartFromCode(a)]), o || (o = t[this.formatLanguageCode(a)]), o || (o = t[this.getLanguagePartFromCode(a)]), o || (o = t.default), o || [];
  }
  toResolveHierarchy(t, a) {
    const o = this.getFallbackCodes((a === !1 ? [] : a) || this.options.fallbackLng || [], t), n = [], r = (i) => {
      i && (this.isSupportedCode(i) ? n.push(i) : this.logger.warn(`rejecting language code not found in supportedLngs: ${i}`));
    };
    return se(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && r(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && r(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && r(this.getLanguagePartFromCode(t))) : se(t) && r(this.formatLanguageCode(t)), o.forEach((i) => {
      n.indexOf(i) < 0 && r(this.formatLanguageCode(i));
    }), n;
  }
}
const Ih = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Th = {
  select: (e) => e === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
let iN = class {
  constructor(t, a = {}) {
    this.languageUtils = t, this.options = a, this.logger = Kt.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(t, a) {
    this.rules[t] = a;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t, a = {}) {
    const o = Tn(t === "dev" ? "en" : t), n = a.ordinal ? "ordinal" : "cardinal", r = JSON.stringify({
      cleanedCode: o,
      type: n
    });
    if (r in this.pluralRulesCache)
      return this.pluralRulesCache[r];
    let i;
    try {
      i = new Intl.PluralRules(o, {
        type: n
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), Th;
      if (!t.match(/-|_/)) return Th;
      const s = this.languageUtils.getLanguagePartFromCode(t);
      i = this.getRule(s, a);
    }
    return this.pluralRulesCache[r] = i, i;
  }
  needsPlural(t, a = {}) {
    let o = this.getRule(t, a);
    return o || (o = this.getRule("dev", a)), o?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(t, a, o = {}) {
    return this.getSuffixes(t, o).map((n) => `${a}${n}`);
  }
  getSuffixes(t, a = {}) {
    let o = this.getRule(t, a);
    return o || (o = this.getRule("dev", a)), o ? o.resolvedOptions().pluralCategories.sort((n, r) => Ih[n] - Ih[r]).map((n) => `${this.options.prepend}${a.ordinal ? `ordinal${this.options.prepend}` : ""}${n}`) : [];
  }
  getSuffix(t, a, o = {}) {
    const n = this.getRule(t, o);
    return n ? `${this.options.prepend}${o.ordinal ? `ordinal${this.options.prepend}` : ""}${n.select(a)}` : (this.logger.warn(`no plural rule found for: ${t}`), this.getSuffix("dev", a, o));
  }
};
const Mh = (e, t, a, o = ".", n = !0) => {
  let r = YD(e, t, a);
  return !r && n && se(a) && (r = zc(e, a, o), r === void 0 && (r = zc(t, a, o))), r;
}, Al = (e) => e.replace(/\$/g, "$$$$");
let sN = class {
  constructor(t = {}) {
    this.logger = Kt.create("interpolator"), this.options = t, this.format = t?.interpolation?.format || ((a) => a), this.init(t);
  }
  init(t = {}) {
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: a,
      escapeValue: o,
      useRawValueToEscape: n,
      prefix: r,
      prefixEscaped: i,
      suffix: s,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: h,
      nestingPrefixEscaped: p,
      nestingSuffix: f,
      nestingSuffixEscaped: m,
      nestingOptionsSeparator: b,
      maxReplaces: w,
      alwaysFormat: _
    } = t.interpolation;
    this.escape = a !== void 0 ? a : QD, this.escapeValue = o !== void 0 ? o : !0, this.useRawValueToEscape = n !== void 0 ? n : !1, this.prefix = r ? jo(r) : i || "{{", this.suffix = s ? jo(s) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = h ? jo(h) : p || jo("$t("), this.nestingSuffix = f ? jo(f) : m || jo(")"), this.nestingOptionsSeparator = b || ",", this.maxReplaces = w || 1e3, this.alwaysFormat = _ !== void 0 ? _ : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (a, o) => a?.source === o ? (a.lastIndex = 0, a) : new RegExp(o, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
  }
  interpolate(t, a, o, n) {
    let r, i, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (h) => {
      if (h.indexOf(this.formatSeparator) < 0) {
        const b = Mh(a, l, h, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(b, void 0, o, {
          ...n,
          ...a,
          interpolationkey: h
        }) : b;
      }
      const p = h.split(this.formatSeparator), f = p.shift().trim(), m = p.join(this.formatSeparator).trim();
      return this.format(Mh(a, l, f, this.options.keySeparator, this.options.ignoreJSONStructure), m, o, {
        ...n,
        ...a,
        interpolationkey: f
      });
    };
    this.resetRegExp();
    const u = n?.missingInterpolationHandler || this.options.missingInterpolationHandler, d = n?.interpolation?.skipOnVariables !== void 0 ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (h) => Al(h)
    }, {
      regex: this.regexp,
      safeValue: (h) => this.escapeValue ? Al(this.escape(h)) : Al(h)
    }].forEach((h) => {
      for (s = 0; r = h.regex.exec(t); ) {
        const p = r[1].trim();
        if (i = c(p), i === void 0)
          if (typeof u == "function") {
            const m = u(t, r, n);
            i = se(m) ? m : "";
          } else if (n && Object.prototype.hasOwnProperty.call(n, p))
            i = "";
          else if (d) {
            i = r[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${p} for interpolating ${t}`), i = "";
        else !se(i) && !this.useRawValueToEscape && (i = zh(i));
        const f = h.safeValue(i);
        if (t = t.replace(r[0], f), d ? (h.regex.lastIndex += i.length, h.regex.lastIndex -= r[0].length) : h.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, a, o = {}) {
    let n, r, i;
    const s = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0) return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let h = `{${d[1]}`;
      l = d[0], h = this.interpolate(h, i);
      const p = h.match(/'/g), f = h.match(/"/g);
      ((p?.length ?? 0) % 2 === 0 && !f || f.length % 2 !== 0) && (h = h.replace(/'/g, '"'));
      try {
        i = JSON.parse(h), c && (i = {
          ...c,
          ...i
        });
      } catch (m) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, m), `${l}${u}${h}`;
      }
      return i.defaultValue && i.defaultValue.indexOf(this.prefix) > -1 && delete i.defaultValue, l;
    };
    for (; n = this.nestingRegexp.exec(t); ) {
      let l = [];
      i = {
        ...o
      }, i = i.replace && !se(i.replace) ? i.replace : i, i.applyPostProcessor = !1, delete i.defaultValue;
      const c = /{.*}/.test(n[1]) ? n[1].lastIndexOf("}") + 1 : n[1].indexOf(this.formatSeparator);
      if (c !== -1 && (l = n[1].slice(c).split(this.formatSeparator).map((u) => u.trim()).filter(Boolean), n[1] = n[1].slice(0, c)), r = a(s.call(this, n[1].trim(), i), i), r && n[0] === t && !se(r)) return r;
      se(r) || (r = zh(r)), r || (this.logger.warn(`missed to resolve ${n[1]} for nesting ${t}`), r = ""), l.length && (r = l.reduce((u, d) => this.format(u, d, o.lng, {
        ...o,
        interpolationkey: n[1].trim()
      }), r.trim())), t = t.replace(n[0], r), this.regexp.lastIndex = 0;
    }
    return t;
  }
};
const lN = (e) => {
  let t = e.toLowerCase().trim();
  const a = {};
  if (e.indexOf("(") > -1) {
    const o = e.split("(");
    t = o[0].toLowerCase().trim();
    const n = o[1].substring(0, o[1].length - 1);
    t === "currency" && n.indexOf(":") < 0 ? a.currency || (a.currency = n.trim()) : t === "relativetime" && n.indexOf(":") < 0 ? a.range || (a.range = n.trim()) : n.split(";").forEach((r) => {
      if (r) {
        const [i, ...s] = r.split(":"), l = s.join(":").trim().replace(/^'+|'+$/g, ""), c = i.trim();
        a[c] || (a[c] = l), l === "false" && (a[c] = !1), l === "true" && (a[c] = !0), isNaN(l) || (a[c] = parseInt(l, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: a
  };
}, Lh = (e) => {
  const t = {};
  return (a, o, n) => {
    let r = n;
    n && n.interpolationkey && n.formatParams && n.formatParams[n.interpolationkey] && n[n.interpolationkey] && (r = {
      ...r,
      [n.interpolationkey]: void 0
    });
    const i = o + JSON.stringify(r);
    let s = t[i];
    return s || (s = e(Tn(o), n), t[i] = s), s(a);
  };
}, cN = (e) => (t, a, o) => e(Tn(a), o)(t);
let uN = class {
  constructor(t = {}) {
    this.logger = Kt.create("formatter"), this.options = t, this.init(t);
  }
  init(t, a = {
    interpolation: {}
  }) {
    this.formatSeparator = a.interpolation.formatSeparator || ",";
    const o = a.cacheInBuiltFormats ? Lh : cN;
    this.formats = {
      number: o((n, r) => {
        const i = new Intl.NumberFormat(n, {
          ...r
        });
        return (s) => i.format(s);
      }),
      currency: o((n, r) => {
        const i = new Intl.NumberFormat(n, {
          ...r,
          style: "currency"
        });
        return (s) => i.format(s);
      }),
      datetime: o((n, r) => {
        const i = new Intl.DateTimeFormat(n, {
          ...r
        });
        return (s) => i.format(s);
      }),
      relativetime: o((n, r) => {
        const i = new Intl.RelativeTimeFormat(n, {
          ...r
        });
        return (s) => i.format(s, r.range || "day");
      }),
      list: o((n, r) => {
        const i = new Intl.ListFormat(n, {
          ...r
        });
        return (s) => i.format(s);
      })
    };
  }
  add(t, a) {
    this.formats[t.toLowerCase().trim()] = a;
  }
  addCached(t, a) {
    this.formats[t.toLowerCase().trim()] = Lh(a);
  }
  format(t, a, o, n = {}) {
    const r = a.split(this.formatSeparator);
    if (r.length > 1 && r[0].indexOf("(") > 1 && r[0].indexOf(")") < 0 && r.find((i) => i.indexOf(")") > -1)) {
      const i = r.findIndex((s) => s.indexOf(")") > -1);
      r[0] = [r[0], ...r.splice(1, i)].join(this.formatSeparator);
    }
    return r.reduce((i, s) => {
      const {
        formatName: l,
        formatOptions: c
      } = lN(s);
      if (this.formats[l]) {
        let u = i;
        try {
          const d = n?.formatParams?.[n.interpolationkey] || {}, h = d.locale || d.lng || n.locale || n.lng || o;
          u = this.formats[l](i, h, {
            ...c,
            ...n,
            ...d
          });
        } catch (d) {
          this.logger.warn(d);
        }
        return u;
      } else
        this.logger.warn(`there was no format function for ${l}`);
      return i;
    }, t);
  }
};
const dN = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
let gN = class extends Os {
  constructor(t, a, o, n = {}) {
    super(), this.backend = t, this.store = a, this.services = o, this.languageUtils = o.languageUtils, this.options = n, this.logger = Kt.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = n.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = n.maxRetries >= 0 ? n.maxRetries : 5, this.retryTimeout = n.retryTimeout >= 1 ? n.retryTimeout : 350, this.state = {}, this.queue = [], this.backend?.init?.(o, n.backend, n);
  }
  queueLoad(t, a, o, n) {
    const r = {}, i = {}, s = {}, l = {};
    return t.forEach((c) => {
      let u = !0;
      a.forEach((d) => {
        const h = `${c}|${d}`;
        !o.reload && this.store.hasResourceBundle(c, d) ? this.state[h] = 2 : this.state[h] < 0 || (this.state[h] === 1 ? i[h] === void 0 && (i[h] = !0) : (this.state[h] = 1, u = !1, i[h] === void 0 && (i[h] = !0), r[h] === void 0 && (r[h] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (s[c] = !0);
    }), (Object.keys(r).length || Object.keys(i).length) && this.queue.push({
      pending: i,
      pendingCount: Object.keys(i).length,
      loaded: {},
      errors: [],
      callback: n
    }), {
      toLoad: Object.keys(r),
      pending: Object.keys(i),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(t, a, o) {
    const n = t.split("|"), r = n[0], i = n[1];
    a && this.emit("failedLoading", r, i, a), !a && o && this.store.addResourceBundle(r, i, o, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = a ? -1 : 2, a && o && (this.state[t] = 0);
    const s = {};
    this.queue.forEach((l) => {
      ZD(l.loaded, [r], i), dN(l, t), a && l.errors.push(a), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        s[c] || (s[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          s[c][d] === void 0 && (s[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(t, a, o, n = 0, r = this.retryTimeout, i) {
    if (!t.length) return i(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: a,
        fcName: o,
        tried: n,
        wait: r,
        callback: i
      });
      return;
    }
    this.readingCalls++;
    const s = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && n < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, a, o, n + 1, r * 2, i);
        }, r);
        return;
      }
      i(c, u);
    }, l = this.backend[o].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(t, a);
        c && typeof c.then == "function" ? c.then((u) => s(null, u)).catch(s) : s(null, c);
      } catch (c) {
        s(c);
      }
      return;
    }
    return l(t, a, s);
  }
  prepareLoading(t, a, o = {}, n) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), n && n();
    se(t) && (t = this.languageUtils.toResolveHierarchy(t)), se(a) && (a = [a]);
    const r = this.queueLoad(t, a, o, n);
    if (!r.toLoad.length)
      return r.pending.length || n(), null;
    r.toLoad.forEach((i) => {
      this.loadOne(i);
    });
  }
  load(t, a, o) {
    this.prepareLoading(t, a, {}, o);
  }
  reload(t, a, o) {
    this.prepareLoading(t, a, {
      reload: !0
    }, o);
  }
  loadOne(t, a = "") {
    const o = t.split("|"), n = o[0], r = o[1];
    this.read(n, r, "read", void 0, void 0, (i, s) => {
      i && this.logger.warn(`${a}loading namespace ${r} for language ${n} failed`, i), !i && s && this.logger.log(`${a}loaded namespace ${r} for language ${n}`, s), this.loaded(t, i, s);
    });
  }
  saveMissing(t, a, o, n, r, i = {}, s = () => {
  }) {
    if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(a)) {
      this.logger.warn(`did not save key "${o}" as the namespace "${a}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(o == null || o === "")) {
      if (this.backend?.create) {
        const l = {
          ...i,
          isUpdate: r
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(t, a, o, n, l) : u = c(t, a, o, n), u && typeof u.then == "function" ? u.then((d) => s(null, d)).catch(s) : s(null, u);
          } catch (u) {
            s(u);
          }
        else
          c(t, a, o, n, s, l);
      }
      !t || !t[0] || this.store.addResource(t[0], a, o, n);
    }
  }
};
const Wh = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), se(e[1]) && (t.defaultValue = e[1]), se(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const a = e[3] || e[2];
      Object.keys(a).forEach((o) => {
        t[o] = a[o];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  },
  cacheInBuiltFormats: !0
}), Bh = (e) => (se(e.ns) && (e.ns = [e.ns]), se(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), se(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs?.indexOf?.("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), typeof e.initImmediate == "boolean" && (e.initAsync = e.initImmediate), e), Nr = () => {
}, hN = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((t) => {
    typeof e[t] == "function" && (e[t] = e[t].bind(e));
  });
};
class Mn extends Os {
  constructor(t = {}, a) {
    if (super(), this.options = Bh(t), this.services = {}, this.logger = Kt, this.modules = {
      external: []
    }, hN(this), a && !this.isInitialized && !t.isClone) {
      if (!this.options.initAsync)
        return this.init(t, a), this;
      setTimeout(() => {
        this.init(t, a);
      }, 0);
    }
  }
  init(t = {}, a) {
    this.isInitializing = !0, typeof t == "function" && (a = t, t = {}), t.defaultNS == null && t.ns && (se(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const o = Wh();
    this.options = {
      ...o,
      ...this.options,
      ...Bh(t)
    }, this.options.interpolation = {
      ...o.interpolation,
      ...this.options.interpolation
    }, t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const n = (s) => s ? typeof s == "function" ? new s() : s : null;
    if (!this.options.isClone) {
      this.modules.logger ? Kt.init(n(this.modules.logger), this.options) : Kt.init(null, this.options);
      let s;
      this.modules.formatter ? s = this.modules.formatter : s = uN;
      const l = new Rh(this.options);
      this.store = new Ph(this.options.resources, this.options);
      const c = this.services;
      c.logger = Kt, c.resourceStore = this.store, c.languageUtils = l, c.pluralResolver = new iN(l, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), this.options.interpolation.format && this.options.interpolation.format !== o.interpolation.format && this.logger.deprecate("init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting"), s && (!this.options.interpolation.format || this.options.interpolation.format === o.interpolation.format) && (c.formatter = n(s), c.formatter.init && c.formatter.init(c, this.options), this.options.interpolation.format = c.formatter.format.bind(c.formatter)), c.interpolator = new sN(this.options), c.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, c.backendConnector = new gN(n(this.modules.backend), c.resourceStore, c, this.options), c.backendConnector.on("*", (u, ...d) => {
        this.emit(u, ...d);
      }), this.modules.languageDetector && (c.languageDetector = n(this.modules.languageDetector), c.languageDetector.init && c.languageDetector.init(c, this.options.detection, this.options)), this.modules.i18nFormat && (c.i18nFormat = n(this.modules.i18nFormat), c.i18nFormat.init && c.i18nFormat.init(this)), this.translator = new Ti(this.services, this.options), this.translator.on("*", (u, ...d) => {
        this.emit(u, ...d);
      }), this.modules.external.forEach((u) => {
        u.init && u.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, a || (a = Nr), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const s = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      s.length > 0 && s[0] !== "dev" && (this.options.lng = s[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((s) => {
      this[s] = (...l) => this.store[s](...l);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((s) => {
      this[s] = (...l) => (this.store[s](...l), this);
    });
    const r = vn(), i = () => {
      const s = (l, c) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), r.resolve(c), a(l, c);
      };
      if (this.languages && !this.isInitialized) return s(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, s);
    };
    return this.options.resources || !this.options.initAsync ? i() : setTimeout(i, 0), r;
  }
  loadResources(t, a = Nr) {
    let o = a;
    const n = se(t) ? t : this.language;
    if (typeof t == "function" && (o = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (n?.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return o();
      const r = [], i = (s) => {
        !s || s === "cimode" || this.services.languageUtils.toResolveHierarchy(s).forEach((l) => {
          l !== "cimode" && r.indexOf(l) < 0 && r.push(l);
        });
      };
      n ? i(n) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((s) => i(s)), this.options.preload?.forEach?.((s) => i(s)), this.services.backendConnector.load(r, this.options.ns, (s) => {
        !s && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), o(s);
      });
    } else
      o(null);
  }
  reloadResources(t, a, o) {
    const n = vn();
    return typeof t == "function" && (o = t, t = void 0), typeof a == "function" && (o = a, a = void 0), t || (t = this.languages), a || (a = this.options.ns), o || (o = Nr), this.services.backendConnector.reload(t, a, (r) => {
      n.resolve(), o(r);
    }), n;
  }
  use(t) {
    if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && my.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1)) {
      for (let a = 0; a < this.languages.length; a++) {
        const o = this.languages[a];
        if (!(["cimode", "dev"].indexOf(o) > -1) && this.store.hasLanguageSomeTranslations(o)) {
          this.resolvedLanguage = o;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(t) < 0 && this.store.hasLanguageSomeTranslations(t) && (this.resolvedLanguage = t, this.languages.unshift(t));
    }
  }
  changeLanguage(t, a) {
    this.isLanguageChangingTo = t;
    const o = vn();
    this.emit("languageChanging", t);
    const n = (s) => {
      this.language = s, this.languages = this.services.languageUtils.toResolveHierarchy(s), this.resolvedLanguage = void 0, this.setResolvedLanguage(s);
    }, r = (s, l) => {
      l ? this.isLanguageChangingTo === t && (n(l), this.translator.changeLanguage(l), this.isLanguageChangingTo = void 0, this.emit("languageChanged", l), this.logger.log("languageChanged", l)) : this.isLanguageChangingTo = void 0, o.resolve((...c) => this.t(...c)), a && a(s, (...c) => this.t(...c));
    }, i = (s) => {
      !t && !s && this.services.languageDetector && (s = []);
      const l = se(s) ? s : s && s[0], c = this.store.hasLanguageSomeTranslations(l) ? l : this.services.languageUtils.getBestMatchFromCodes(se(s) ? [s] : s);
      c && (this.language || n(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector?.cacheUserLanguage?.(c)), this.loadResources(c, (u) => {
        r(u, c);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? i(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(i) : this.services.languageDetector.detect(i) : i(t), o;
  }
  getFixedT(t, a, o) {
    const n = (r, i, ...s) => {
      let l;
      typeof i != "object" ? l = this.options.overloadTranslationOptionHandler([r, i].concat(s)) : l = {
        ...i
      }, l.lng = l.lng || n.lng, l.lngs = l.lngs || n.lngs, l.ns = l.ns || n.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || o || n.keyPrefix);
      const c = this.options.keySeparator || ".";
      let u;
      return l.keyPrefix && Array.isArray(r) ? u = r.map((d) => (typeof d == "function" && (d = jc(d, {
        ...this.options,
        ...i
      })), `${l.keyPrefix}${c}${d}`)) : (typeof r == "function" && (r = jc(r, {
        ...this.options,
        ...i
      })), u = l.keyPrefix ? `${l.keyPrefix}${c}${r}` : r), this.t(u, l);
    };
    return se(t) ? n.lng = t : n.lngs = t, n.ns = a, n.keyPrefix = o, n;
  }
  t(...t) {
    return this.translator?.translate(...t);
  }
  exists(...t) {
    return this.translator?.exists(...t);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t, a = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const o = a.lng || this.resolvedLanguage || this.languages[0], n = this.options ? this.options.fallbackLng : !1, r = this.languages[this.languages.length - 1];
    if (o.toLowerCase() === "cimode") return !0;
    const i = (s, l) => {
      const c = this.services.backendConnector.state[`${s}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (a.precheck) {
      const s = a.precheck(this, i);
      if (s !== void 0) return s;
    }
    return !!(this.hasResourceBundle(o, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || i(o, t) && (!n || i(r, t)));
  }
  loadNamespaces(t, a) {
    const o = vn();
    return this.options.ns ? (se(t) && (t = [t]), t.forEach((n) => {
      this.options.ns.indexOf(n) < 0 && this.options.ns.push(n);
    }), this.loadResources((n) => {
      o.resolve(), a && a(n);
    }), o) : (a && a(), Promise.resolve());
  }
  loadLanguages(t, a) {
    const o = vn();
    se(t) && (t = [t]);
    const n = this.options.preload || [], r = t.filter((i) => n.indexOf(i) < 0 && this.services.languageUtils.isSupportedCode(i));
    return r.length ? (this.options.preload = n.concat(r), this.loadResources((i) => {
      o.resolve(), a && a(i);
    }), o) : (a && a(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language)), !t) return "rtl";
    try {
      const n = new Intl.Locale(t);
      if (n && n.getTextInfo) {
        const r = n.getTextInfo();
        if (r && r.direction) return r.direction;
      }
    } catch {
    }
    const a = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], o = this.services?.languageUtils || new Rh(Wh());
    return t.toLowerCase().indexOf("-latn") > 1 ? "ltr" : a.indexOf(o.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(t = {}, a) {
    return new Mn(t, a);
  }
  cloneInstance(t = {}, a = Nr) {
    const o = t.forkResourceStore;
    o && delete t.forkResourceStore;
    const n = {
      ...this.options,
      ...t,
      isClone: !0
    }, r = new Mn(n);
    if ((t.debug !== void 0 || t.prefix !== void 0) && (r.logger = r.logger.clone(t)), ["store", "services", "language"].forEach((i) => {
      r[i] = this[i];
    }), r.services = {
      ...this.services
    }, r.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, o) {
      const i = Object.keys(this.store.data).reduce((s, l) => (s[l] = {
        ...this.store.data[l]
      }, s[l] = Object.keys(s[l]).reduce((c, u) => (c[u] = {
        ...s[l][u]
      }, c), s[l]), s), {});
      r.store = new Ph(i, n), r.services.resourceStore = r.store;
    }
    return r.translator = new Ti(r.services, n), r.translator.on("*", (i, ...s) => {
      r.emit(i, ...s);
    }), r.init(n, a), r.translator.options = n, r.translator.backendConnector.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, r;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const rt = Mn.createInstance();
rt.createInstance = Mn.createInstance;
const mN = rt.createInstance;
rt.dir;
rt.init;
rt.loadResources;
rt.reloadResources;
rt.use;
rt.changeLanguage;
rt.getFixedT;
rt.t;
rt.exists;
rt.setDefaultNamespace;
rt.hasLoadedNamespace;
rt.loadNamespaces;
rt.loadLanguages;
const pN = "Studio", fN = "{{count}} soveværelse", bN = "{{count}} soveværelser", _N = "", vN = "{{count}} seng", yN = "{{count}} senge", wN = "Voksne", kN = "Babyer", xN = "Din kalender er blevet opdateret.", $N = "En måned", SN = "Præcise datoer", CN = "Uge", EN = "", zN = "", jN = "", AN = "", ON = "To uger", PN = "Annuller", DN = "Børn", NN = "Datoer", RN = "Slet", IN = "Beskrivelse", TN = "Destination", MN = "Sådan!", LN = "Rediger", WN = "Enhver form for udveksling", BN = "Badekar", FN = "Grill", VN = "Cykel", UN = "Bil", qN = "Kat", HN = "By", GN = "På landet", KN = "Opvaskemaskine", JN = "Hund", ZN = "Tørretumbler", YN = "Elevator", XN = "Favoritboliger", QN = "Pejs/brændeovn", eR = "Lejlighed", tR = "Privat have", aR = "under {{max}} GP", oR = "fra {{min}} GP", nR = "Mellem {{min}} og {{max}} GP", rR = "Privat fitnessrum", iR = "Hus", sR = "En Ø", lR = "Isoleret", cR = "Jacuzzi", uR = "Søer", dR = "Collection-hjem", gR = "Bjerge", hR = "{{count}} badeværelser", mR = "Andre dyr", pR = "Klaver", fR = "Legeplads", bR = "Primære bolig", _R = "Gensifig udveksling", vR = "Omvendt søgning", yR = "Flod", wR = "Kystnær", kR = "Feriebolig", xR = "TV", $R = "Landsby", SR = "Wi-Fi", CR = "Filtre", ER = "Faste datoer", zR = "En måned i {{date}}", jR = "En weekend i {{date}}", AR = "En uge i {{date}}", OR = "To uger i {{date}}", PR = "Fleksible datoer", DR = "Gæster", NR = "boliger", RR = "Sidste minut", IR = "Lokation", TR = "Rediger", MR = "Navn", LR = "Næste", WR = "", BR = "", FR = "{{count}} voksne", VR = "", UR = "", qR = "{{count}} babyer", HR = "", GR = "", KR = "{{count}} børn", JR = "", ZR = "{{count}} gæst", YR = "{{count}} gæster", XR = "Telefonnummerets format er ikke gyldigt.", QR = "Modtag e-mailnotifikationer", eI = "Gem", tI = "Ingen lokationer fundet", aI = "Flere beskeder", oI = "Rejseliste", nI = "", rI = "valgfrit", iI = {
  "autocomplete.button": "Søg",
  "autocomplete.placeholder": "Hvor skal du hen ?",
  bedroomsNumbers_zero: pN,
  bedroomsNumbers_one: fN,
  bedroomsNumbers_other: bN,
  beds_zero: _N,
  beds_one: vN,
  beds_other: yN,
  "button.free-signup": "Tilmeld dig gratis",
  "button.validate": "Bekræft",
  "common.try-again": "Prøv igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Må ikke overstige {{limit}} tegn",
  "error.reload": "Opdater siden",
  "error.return-homepage": "Tilbage til startsiden",
  "error.subtitle": "Denne side kan desværre ikke nås..",
  "error.title": "Der opstod en fejl på siden",
  "errors.unable_to_submit.subtitle": '"Din formular kunne desværre ikke \\nindsendes lige nu. Prøv igen \\nsenere."',
  "errors.unable_to_submit.title": "Ups, vi løb ind i et problem",
  "global.back": "Tilbage",
  "global.cancel": "Annuller",
  "global.collection.browsehomes": "Se boliger",
  "global.collection.contactus": "Kontakt os",
  "global.confirm": "Bekræft",
  "global.continue": "Fortsæt",
  "global.getStarted": "Kom godt i gang",
  "global.login": "Log ind",
  "global.select": "Vælg",
  global_adults: wN,
  global_babies: kN,
  global_calendarUpdated_toast: xN,
  global_calendar_aMonth: $N,
  global_calendar_exactDates: SN,
  global_calendar_oneWeek: CN,
  global_calendar_oneWeekend: EN,
  global_calendar_plusMinusDay_zero: zN,
  global_calendar_plusMinusDay_one: jN,
  global_calendar_plusMinusDay_other: AN,
  global_calendar_twoWeeks: ON,
  global_cancel: PN,
  global_children: DN,
  global_dates: NN,
  global_delete: RN,
  global_description: IN,
  global_destination: TN,
  global_done: MN,
  global_edit: LN,
  "global_filter_a-c": "Klimaanlæg",
  global_filter_available: WN,
  "global_filter_baby-bed": "Babysenge",
  "global_filter_baby-gear": "Babyudstyr",
  "global_filter_balcony-terrace": "Altan/terrasse",
  global_filter_bathtub: BN,
  global_filter_bbq: FN,
  global_filter_bicycle: VN,
  global_filter_car: UN,
  global_filter_cat: qN,
  "global_filter_children-welcome": "Børn velkomne",
  global_filter_cities: HN,
  "global_filter_cleaning-person": "Rengøringsperson",
  global_filter_countryside: GN,
  "global_filter_dedicated-workspace": "Arbejdsområde",
  "global_filter_disabled-access": "Handicapvenlig bolig",
  global_filter_dishwasher: KN,
  global_filter_dog: JN,
  global_filter_dryer: ZN,
  "global_filter_eco-level": "Kun bæredygtige boliger",
  "global_filter_electric-car-plug": "Stik til elbil",
  global_filter_elevator: YN,
  global_filter_favorite: XN,
  global_filter_fireplace: QN,
  global_filter_flat: eR,
  global_filter_garden: tR,
  "global_filter_guest-wanted": "GuestPoints bytte",
  global_filter_guestPointsMax: aR,
  global_filter_guestPointsMin: oR,
  global_filter_guestPointsMinMax: nR,
  global_filter_gym: rR,
  "global_filter_heating-system": "Varmeanlæg",
  "global_filter_high-speed-connexion": "Hurtigt internet",
  global_filter_home: iR,
  "global_filter_home-verified": "Godkendte boliger",
  global_filter_island: sR,
  global_filter_isolated: lR,
  global_filter_jacuzzi: cR,
  "global_filter_kids-toys": "Legetøj til børn",
  global_filter_lakes: uR,
  global_filter_luxury: dR,
  global_filter_mountains: gR,
  "global_filter_no-bed-up": "Ingen midlertidige senge",
  global_filter_numOfBathrooms: hR,
  global_filter_other: mR,
  "global_filter_parking-space": "Privat parkeringsplads",
  "global_filter_pets-welcome": "Kæledyr er velkomne",
  global_filter_piano: pR,
  global_filter_playground: fR,
  global_filter_primary: bR,
  "global_filter_public-transit-access": "Adgang til offentlig transport",
  global_filter_reciprocal: _R,
  "global_filter_response-rate-above-threshold": "Svarprocent ≥ Gennemsnitlig",
  global_filter_reverse: vR,
  global_filter_river: yR,
  global_filter_seaside: wR,
  global_filter_secondary: kR,
  "global_filter_secured-pool": "Sikret pool",
  "global_filter_smokers-welcome": "Rygere er velkomne",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: xR,
  global_filter_villages: $R,
  "global_filter_washing-machine": "Vaskemaskine",
  "global_filter_whole-unit": "Hele enheden",
  global_filter_wifi: SR,
  global_filters: CR,
  global_fixDates: ER,
  global_flexDates_aMonth: zR,
  global_flexDates_aWeekend: jR,
  global_flexDates_oneWeek: AR,
  global_flexDates_twoWeek: OR,
  global_flexibleDates: PR,
  global_guests: DR,
  global_homes: NR,
  global_lastMinute: RR,
  global_location: IR,
  global_modify: TR,
  global_name: MR,
  global_next: LR,
  global_numberOfAdults_zero: WR,
  global_numberOfAdults_one: BR,
  global_numberOfAdults_other: FR,
  global_numberOfBabies_zero: VR,
  global_numberOfBabies_one: UR,
  global_numberOfBabies_other: qR,
  global_numberOfChildren_zero: HR,
  global_numberOfChildren_one: GR,
  global_numberOfChildren_other: KR,
  global_numberOfGuests_zero: JR,
  global_numberOfGuests_one: ZR,
  global_numberOfGuests_other: YR,
  global_phoneNumber_notValid: XR,
  global_receiveEmailAlerts: QR,
  global_save: eI,
  global_searchBar_noLocationFound: tI,
  global_seeMore_link: aI,
  global_travelWishlist: oI,
  "modal.error-occured.content": "Vi beklager ulejligheden, men prøv \\nvenligst igen.",
  "modal.error-occured.title": "Åh nej, der er opstået en fejl!",
  no_result: nI,
  optional: rI,
  "privacy-policy": "Privatpolitik"
}, sI = "https://www.homeexchange.com/blog/", lI = "/p/general-terms-of-use", cI = "https://www.homeexchange.com/da/p/community-da", uI = "https://homeexchangehelp.zendesk.com/hc/en-us", dI = "", gI = "https://www.homeexchange.com/da/p/service-homeexchange-da", hI = "https://www.homeexchange.com/da/p/guestpoints-da", mI = "https://www.homeexchange.com/da/p/press-da", pI = "https://www.homeexchange.com/p/fortalt-af-medlemmerne", fI = "", bI = "", _I = "https://www.homeexchange.com/da/p/hvor-velkomsten-virkelig-begynder", vI = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/da/p/about-us-da",
  blog: sI,
  cgu: lI,
  community: cI,
  "contact-us": "https://www.homeexchange.com/da/kontakt-os-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: uI,
  forum: dI,
  guarantees: gI,
  guestpoints: hI,
  "happiness-team": "https://www.homeexchange.com/da/p/happiness-team-da",
  "how-it-works": "https://www.homeexchange.com/da/p/hvordan-virker-det",
  "join-us": "https://www.homeexchange.com/da/p/join-us-da",
  "legal-notice": "/p/juridiske-vilkaar",
  "mobile-app": "https://www.homeexchange.com/da/p/mobil-app",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: mI,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/da/p/subscription-homeexchange-da",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: pI,
  travelWishlist_faq_links: fI,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: bI,
  values: _I
}, yI = "Fornavn", wI = "Efternavn", kI = "Tilføj til din rejseliste", xI = "En opdateret rejseliste giver dig mulighed for at modtage flere anmodninger om gensidige boligbytninger.", $I = "Er du sikker på, at du vil slette {{fullAddress}}?", SI = "Dette er de filtre, du har valgt. Hvis du har skiftet mening, kan du slette nogle af dem nedenfor. Men hvis du gerne vil tilføje flere, skal du starte en ny søgning (selvom dette snart ændrer sig... vi giver dig besked)!", CI = "Dette kan være et land, by eller en hel region. Hvis du vælger en bred lokation, er dine resultater muligvis mindre nøjagtige.", EI = "Indtast et land, by eller region", zI = "Se ledige boliger", jI = "Når boliger med tilgængelighed matcher dine rejseplaner.", AI = "Tilføj til din rejseliste", OI = "{{fullAddress}} er blevet slettet fra din rejseliste.", PI = "Vælg dine ideelle rejsedatoer (fleksible eller faste).", DI = "Tilføj detaljer, der hjælper andre, som bruger den omvendte søgefunktion, med at se, hvorfor du er interesseret i deres lokation.", NI = "Angiv, hvor mange personer der rejser sammen med dig under denne tur.", RI = "Hovsa! {{fullAddress}} kunne ikke gemmes til din rejseliste af en uventet årsag.", II = "Fortæl os, hvornår og hvorhen du ønsker at rejse for at modtage bytteanmodninger og notifikationer, så snart passende boliger bliver tilgængelige. Vi gemmer dine søgninger i din rejseliste!", TI = "Er der andre rejseeventyr, du vil gå i gang med at planlægge?", MI = "<updateDates>Opdater dine datoer</updateDates> for at fortsætte med at modtage relevante e-mailnotifikationer eller <delete>slet denne destination</delete> fra din rejseliste, hvis du ikke længere overvejer den.", LI = "Disse datoer er i fortiden", WI = "{{fullAddress}} er blevet tilføjet til din rejseliste!", BI = "{{fullAddress}} er blevet opdateret.", FI = "Din søgning er gemt, og din kalender er blevet opdateret!", VI = "Din søgning er blevet gemt. Du finder den i din rejseliste.", UI = "Lær mere om rejselister", qI = {
  firstname: yI,
  lastname: wI,
  modal_travelWishlist_addNew_title: kI,
  modal_travelWishlist_delete_body: xI,
  modal_travelWishlist_delete_title: $I,
  modal_travelWishlist_filtersApplied_helper: SI,
  modal_travelWishlist_location_helper: CI,
  modal_travelWishlist_searchBar_placeholder: EI,
  page_travelWishlist_card_cta: zI,
  page_travelWishlist_card_emailAlerts_helper: jI,
  page_travelWishlist_cta: AI,
  page_travelWishlist_deleted_toast: OI,
  page_travelWishlist_edit_dates_helper: PI,
  page_travelWishlist_edit_description_helper: DI,
  page_travelWishlist_edit_guests_helper: NI,
  page_travelWishlist_error_toast: RI,
  page_travelWishlist_none_body: II,
  page_travelWishlist_none_subheader: TI,
  page_travelWishlist_pastDates_desc: MI,
  page_travelWishlist_pastDates_title: LI,
  page_travelWishlist_saved_toast: WI,
  page_travelWishlist_updated_toast: BI,
  search_travelWishlist_calendarUpdated_toast: FI,
  search_travelWishlist_saved_toast: VI,
  travelWishlist_faq: UI
}, HI = "Studio", GI = "{{count}} schlafzimmer", KI = "{{count}} schlafzimmer", JI = "", ZI = "{{count}} Bett", YI = "{{count}} Betten", XI = "Erwachsene", QI = "Babys", eT = "Ihr Kalender wurde aktualisiert.", tT = "Ein Monat", aT = "Genaue Daten", oT = "Eine Woche", nT = "Ein Wochenende", rT = "", iT = "± {{count}} Tag", sT = "± {{count}} Tage", lT = "Zwei Wochen", cT = "Abbrechen", uT = "Kinder", dT = "Daten", gT = "Löschen", hT = "Beschreibung", mT = "Reiseziel", pT = "Fertig!", fT = "Bearbeiten", bT = "Jede Tauschanfrage", _T = "Badewanne", vT = "Grill", yT = "Fahrrad", wT = "Auto", kT = "Katze", xT = "Stadt", $T = "Auf dem Land", ST = "Geschirrspüler", CT = "Hund", ET = "Trockner", zT = "Aufzug", jT = "Lieblingshäuser", AT = "Kamin", OT = "Apartment", PT = "Privater Garten", DT = "weniger als {{max}} GP", NT = "von {{min}} GP", RT = "Zwischen {{min}} und {{max}} GP", IT = "Privater Fitnessraum", TT = "Haus", MT = "Insel", LT = "Abgelegen", WT = "Whirlpool", BT = "See", FT = "Häuser der Collection", VT = "Berge", UT = "{{count}} Badezimmer", qT = "Andere Tiere", HT = "Klavier", GT = "Spielplatz", KT = "Hauptwohnung", JT = "Gegenseitiger Austausch", ZT = "Umgekehrte Suche", YT = "Fluss", XT = "An der Küste", QT = "Zweitwohnung", eM = "Fernseher", tM = "Dorf", aM = "WLAN", oM = "Filter", nM = "Feste Daten", rM = "Eine Woche im {{date}}", iM = "Ein Wochenende im {{date}}", sM = "Eine Woche im {{date}}", lM = "Zwei Wochen im {{date}}", cM = "Flexible Daten", uM = "Gäste", dM = "Unterkünfte", gM = "Last Minute", hM = "Ort", mM = "Ändern", pM = "Name", fM = "Weiter", bM = "", _M = "{{count}} Erwachsener", vM = "{{count}} Erwachsene", yM = "", wM = "{{count}} Baby", kM = "{{count}} Babys", xM = "", $M = "{{count}} Kind", SM = "{{count}} Kinder", CM = "", EM = "{{count}} Gast", zM = "{{count}} Gäste", jM = "Das Format der Telefonnummer ist ungültig.", AM = "Benachrichtigungen per E-Mail erhalten", OM = "Speichern", PM = "Kein Reiseziel gefunden", DM = "Mehr anzeigen", NM = "Reiseprojekte", RM = "", IM = "optional", TM = {
  "autocomplete.button": "Suchen",
  "autocomplete.placeholder": "Wo gehst du hin ?",
  bedroomsNumbers_zero: HI,
  bedroomsNumbers_one: GI,
  bedroomsNumbers_other: KI,
  beds_zero: JI,
  beds_one: ZI,
  beds_other: YI,
  "button.free-signup": "Kostenlos anmelden",
  "button.validate": "Bestätigen",
  "common.try-again": "Erneut versuchen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Darf {{limit}} Zeichen nicht überschreiten",
  "error.reload": "Aktualisieren Sie diese Seite",
  "error.return-homepage": "Zurück zur Startseite",
  "error.subtitle": "Leider ist diese Seite nicht erreichbar.",
  "error.title": "Es ist ein Fehler auf der Seite aufgetreten.",
  "errors.unable_to_submit.subtitle": "Leider konnte Ihr Formular im Moment nicht abgeschickt werden. Bitte versuchen Sie es später noch einmal.",
  "errors.unable_to_submit.title": "Hoppla, wir haben ein Problem",
  "global.back": "Zurück",
  "global.cancel": "Abbrechen",
  "global.collection.browsehomes": "Unterkünfte durchstöbern",
  "global.collection.contactus": "Kontaktieren Sie uns",
  "global.confirm": "Bestätigen",
  "global.continue": "Weiter",
  "global.getStarted": "Los geht's",
  "global.login": "Anmelden",
  "global.select": "Auswählen",
  global_adults: XI,
  global_babies: QI,
  global_calendarUpdated_toast: eT,
  global_calendar_aMonth: tT,
  global_calendar_exactDates: aT,
  global_calendar_oneWeek: oT,
  global_calendar_oneWeekend: nT,
  global_calendar_plusMinusDay_zero: rT,
  global_calendar_plusMinusDay_one: iT,
  global_calendar_plusMinusDay_other: sT,
  global_calendar_twoWeeks: lT,
  global_cancel: cT,
  global_children: uT,
  global_dates: dT,
  global_delete: gT,
  global_description: hT,
  global_destination: mT,
  global_done: pT,
  global_edit: fT,
  "global_filter_a-c": "Klimaanlage",
  global_filter_available: bT,
  "global_filter_baby-bed": "Babybetten",
  "global_filter_baby-gear": "Babyausstattung",
  "global_filter_balcony-terrace": "Balkon / Terrasse",
  global_filter_bathtub: _T,
  global_filter_bbq: vT,
  global_filter_bicycle: yT,
  global_filter_car: wT,
  global_filter_cat: kT,
  "global_filter_children-welcome": "Kinder willkommen",
  global_filter_cities: xT,
  "global_filter_cleaning-person": "Reinigungskraft",
  global_filter_countryside: $T,
  "global_filter_dedicated-workspace": "Spezieller Arbeitsbereich",
  "global_filter_disabled-access": "Barrierefreie Unterkunft",
  global_filter_dishwasher: ST,
  global_filter_dog: CT,
  global_filter_dryer: ET,
  "global_filter_eco-level": "Nur nachhaltige Häuser",
  "global_filter_electric-car-plug": "Steckdose für Elektroautos",
  global_filter_elevator: zT,
  global_filter_favorite: jT,
  global_filter_fireplace: AT,
  global_filter_flat: OT,
  global_filter_garden: PT,
  "global_filter_guest-wanted": "Austausch gegen GuestPoints",
  global_filter_guestPointsMax: DT,
  global_filter_guestPointsMin: NT,
  global_filter_guestPointsMinMax: RT,
  global_filter_gym: IT,
  "global_filter_heating-system": "Heizung",
  "global_filter_high-speed-connexion": "Hochgeschwindigkeitsverbindung",
  global_filter_home: TT,
  "global_filter_home-verified": "Verifizierte Unterkünfte",
  global_filter_island: MT,
  global_filter_isolated: LT,
  global_filter_jacuzzi: WT,
  "global_filter_kids-toys": "Kinderspielzeug",
  global_filter_lakes: BT,
  global_filter_luxury: FT,
  global_filter_mountains: VT,
  "global_filter_no-bed-up": "Keine Zustellbetten",
  global_filter_numOfBathrooms: UT,
  global_filter_other: qT,
  "global_filter_parking-space": "Privater Parkplatz",
  "global_filter_pets-welcome": "Haustiere willkommen",
  global_filter_piano: HT,
  global_filter_playground: GT,
  global_filter_primary: KT,
  "global_filter_public-transit-access": "Zugang zu öffentlichen Verkehrsmitteln",
  global_filter_reciprocal: JT,
  "global_filter_response-rate-above-threshold": "Antwortrate ≥ Mittel",
  global_filter_reverse: ZT,
  global_filter_river: YT,
  global_filter_seaside: XT,
  global_filter_secondary: QT,
  "global_filter_secured-pool": "Gesicherter Pool",
  "global_filter_smokers-welcome": "Rauchen erlaubt",
  "global_filter_swimming-pool": "Swimmingpool",
  global_filter_tv: eM,
  global_filter_villages: tM,
  "global_filter_washing-machine": "Waschmaschine",
  "global_filter_whole-unit": "Die ganze Wohnung",
  global_filter_wifi: aM,
  global_filters: oM,
  global_fixDates: nM,
  global_flexDates_aMonth: rM,
  global_flexDates_aWeekend: iM,
  global_flexDates_oneWeek: sM,
  global_flexDates_twoWeek: lM,
  global_flexibleDates: cM,
  global_guests: uM,
  global_homes: dM,
  global_lastMinute: gM,
  global_location: hM,
  global_modify: mM,
  global_name: pM,
  global_next: fM,
  global_numberOfAdults_zero: bM,
  global_numberOfAdults_one: _M,
  global_numberOfAdults_other: vM,
  global_numberOfBabies_zero: yM,
  global_numberOfBabies_one: wM,
  global_numberOfBabies_other: kM,
  global_numberOfChildren_zero: xM,
  global_numberOfChildren_one: $M,
  global_numberOfChildren_other: SM,
  global_numberOfGuests_zero: CM,
  global_numberOfGuests_one: EM,
  global_numberOfGuests_other: zM,
  global_phoneNumber_notValid: jM,
  global_receiveEmailAlerts: AM,
  global_save: OM,
  global_searchBar_noLocationFound: PM,
  global_seeMore_link: DM,
  global_travelWishlist: NM,
  "modal.error-occured.content": "Wir entschuldigen uns für die Unannehmlichkeiten, bitte versuchen Sie es noch einmal.",
  "modal.error-occured.title": "Oh nein, es ist ein Fehler aufgetreten!",
  no_result: RM,
  optional: IM,
  "privacy-policy": "Datenschutz"
}, MM = "https://www.homeexchange.com/de/blog/", LM = "/de/p/homeexchangenutzungsbedingungen", WM = "https://www.homeexchange.com/de/p/our-community-de", BM = "https://homeexchangehelp.zendesk.com/hc/de", FM = "", VM = "https://www.homeexchange.com/de/p/service-homeexchange-de", UM = "https://www.homeexchange.com/de/p/guestpoints-de", qM = "https://www.homeexchange.com/de/p/press-de", HM = "https://www.homeexchange.com/p/worte-homeexchanger", GM = "https://help.homeexchange.com/hc/de/articles/360000623717-Bevorzugte-Tausch-Destinationen", KM = "", JM = "https://www.homeexchange.com/de/p/wo-die-begrubung-wirklich-beginnt", ZM = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/de/p/about-us-de",
  blog: MM,
  cgu: LM,
  community: WM,
  "contact-us": "https://www.homeexchange.com/de/kontakt-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeDE/",
  faq: BM,
  forum: FM,
  guarantees: VM,
  guestpoints: UM,
  "happiness-team": "https://www.homeexchange.com/de/p/happiness-team-de",
  "how-it-works": "https://www.homeexchange.com/de/p/so-funktioniert-es-de",
  "join-us": "https://www.homeexchange.com/de/p/join-us-de",
  "legal-notice": "/p/impressum",
  "mobile-app": "https://www.homeexchange.com/de/p/homeexchange-mobile-app",
  "our-team": "https://www.homeexchange.com/de/p/unser-team",
  press: qM,
  "privacy-policy": "/p/homeexchange-datenschutz",
  "subscription-cost": "https://www.homeexchange.com/de/p/subscription-homeexchange-de",
  "term-of-use": "/p/homeexchangenutzungsbedingungen",
  testimonials: HM,
  travelWishlist_faq_links: GM,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: KM,
  values: JM
}, YM = "Vorname", XM = "Nachname", QM = "Zu den Reiseprojekten hinzufügen", eL = "Aktualisierte Reiseprojekte ermöglichen es Ihnen, mehr gegenseitige Tauschanfragen zu erhalten.", tL = "Sind Sie sicher, dass Sie {{fullAddress}} löschen möchten?", aL = "Dies sind die Filter, die Sie ausgewählt haben. Wenn Sie Ihre Meinung geändert haben, können Sie einige von ihnen löschen. Wenn Sie jedoch weitere Filter hinzufügen möchten, müssen Sie eine neue Suche starten (dies wird sich jedoch bald ändern... bleiben Sie dran)!", oL = "Dies kann ein Land, eine Stadt oder eine ganze Region sein. Wenn Sie einen großen Bereich auswählen, sind Ihre Ergebnisse möglicherweise weniger genau.", nL = "Geben Sie ein Land, eine Stadt oder eine Region ein", rL = "Verfügbare Häuser anzeigen", iL = "Falls Unterkünfte mit Verfügbarkeit mit Ihren Reiseplänen übereinstimmen.", sL = "Zu den Reiseprojekten hinzufügen", lL = "{{fullAddress}} wurde aus Ihren Reiseprojekten gelöscht.", cL = "Wählen Sie Ihre idealen Reisedaten (flexibel oder fest).", uL = "Fügen Sie Details hinzu, damit andere, die die Umgekehrte Suche verwenden, erkennen können, warum Sie an ihrem Standort interessiert sind.", dL = "Geben Sie an, wie viele Personen Sie auf dieser Reise begleiten werden.", gL = "Hoppla! {{fullAddress}} konnte aus einem unerwarteten Grund nicht in Ihren Reiseprojekten gespeichert werden.", hL = "Teilen Sie uns mit, wann und wohin Sie reisen möchten, um Tauschanfragen und Benachrichtigungen zu erhalten, sobald passende Häuser verfügbar sind. Wir speichern Ihre Suchanfragen in Ihren Reiseprojekten!", mL = "Gibt es Reisen, die Sie planen möchten?", pL = "<updateDates>Aktualisieren Sie Ihre Daten</updateDates>, um weiterhin relevante E-Mail-Benachrichtigungen zu erhalten oder <delete>löschen Sie dieses Reiseziel</delete> aus Ihren Reiseprojekten, wenn Sie es nicht mehr in Betracht ziehen.", fL = "Diese Daten liegen in der Vergangenheit", bL = "{{fullAddress}} wurde zu Ihren Reiseprojekten hinzugefügt!", _L = "{{fullAddress}} wurde erfolgreich aktualisiert.", vL = "Ihre Suche wurde gespeichert und Ihr Kalender aktualisiert!", yL = "Ihre Suche wurde gespeichert. Finden Sie sie in Ihren Reiseprojekten.", wL = "Erfahren Sie mehr über Reiseprojekte", kL = {
  firstname: YM,
  lastname: XM,
  modal_travelWishlist_addNew_title: QM,
  modal_travelWishlist_delete_body: eL,
  modal_travelWishlist_delete_title: tL,
  modal_travelWishlist_filtersApplied_helper: aL,
  modal_travelWishlist_location_helper: oL,
  modal_travelWishlist_searchBar_placeholder: nL,
  page_travelWishlist_card_cta: rL,
  page_travelWishlist_card_emailAlerts_helper: iL,
  page_travelWishlist_cta: sL,
  page_travelWishlist_deleted_toast: lL,
  page_travelWishlist_edit_dates_helper: cL,
  page_travelWishlist_edit_description_helper: uL,
  page_travelWishlist_edit_guests_helper: dL,
  page_travelWishlist_error_toast: gL,
  page_travelWishlist_none_body: hL,
  page_travelWishlist_none_subheader: mL,
  page_travelWishlist_pastDates_desc: pL,
  page_travelWishlist_pastDates_title: fL,
  page_travelWishlist_saved_toast: bL,
  page_travelWishlist_updated_toast: _L,
  search_travelWishlist_calendarUpdated_toast: vL,
  search_travelWishlist_saved_toast: yL,
  travelWishlist_faq: wL
}, xL = "Studio", $L = "{{count}} bedroom", SL = "{{count}} bedrooms", CL = "", EL = "{{count}} bed", zL = "{{count}} beds", jL = "Adults", AL = "Babies", OL = "Your calendar has been updated.", PL = "A month", DL = "Exact dates", NL = "One week", RL = "One weekend", IL = "", TL = "± {{count}} day", ML = "± {{count}} days", LL = "Two weeks", WL = "Cancel", BL = "Children", FL = "Dates", VL = "Delete", UL = "Description", qL = "Destination", HL = "Done!", GL = "Edit", KL = "Any type of exchange", JL = "Bathtub", ZL = "BBQ", YL = "Bicycle", XL = "Car", QL = "Cat", eW = "City", tW = "Countryside", aW = "Dishwasher", oW = "Dog", nW = "Dryer", rW = "Elevator", iW = "Favorite homes", sW = "Fireplace", lW = "Apartment", cW = "Private backyard", uW = "less than {{max}} GP", dW = "from {{min}} GP", gW = "Between {{min}} and {{max}} GP", hW = "Private gym", mW = "House", pW = "Island", fW = "Isolated", bW = "Jacuzzi", _W = "Lake", vW = "Collection homes", yW = "Mountain", wW = "{{count}} bathrooms", kW = "Other animals", xW = "Piano", $W = "Kid's playground", SW = "Primary", CW = "Reciprocal exchange", EW = "Reverse search", zW = "River", jW = "Coastal", AW = "Secondary", OW = "TV", PW = "Village", DW = "WiFi", NW = "Filters", RW = "Fixed dates", IW = "A month in {{date}}", TW = "A Week-end in {{date}}", MW = "One week in {{date}}", LW = "Two weeks in {{date}}", WW = "Flexible dates", BW = "Guests", FW = "homes", VW = "Last minute", UW = "Location", qW = "Modify", HW = "Name", GW = "Next", KW = "", JW = "{{count}} adult", ZW = "{{count}} adults", YW = "", XW = "{{count}} baby", QW = "{{count}} babies", e2 = "", t2 = "{{count}} child", a2 = "{{count}} children", o2 = "{{count}} guest", n2 = "{{count}} guest", r2 = "{{count}} guests", i2 = "The phone number format is not valid", s2 = "Receive email alerts", l2 = "Save", c2 = "No locations found", u2 = "See more", d2 = "Travel wishlist", g2 = "No result", h2 = "optional", m2 = {
  "autocomplete.button": "Search",
  "autocomplete.placeholder": "Where are you going ?",
  bedroomsNumbers_zero: xL,
  bedroomsNumbers_one: $L,
  bedroomsNumbers_other: SL,
  beds_zero: CL,
  beds_one: EL,
  beds_other: zL,
  "button.free-signup": "Sign up for free",
  "button.validate": "Validate",
  "common.try-again": "Try again",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Must not exceed {{limit}} characters",
  "error.reload": "Refresh this page",
  "error.return-homepage": "Return to home page",
  "error.subtitle": "Unfortunately this page can't be reached.",
  "error.title": "An error occurred on the page",
  "errors.unable_to_submit.subtitle": "Unfortunately your form couldn't be submitted right now. Please try again later.",
  "errors.unable_to_submit.title": "Oops, we've hit a problem",
  "global.back": "Back",
  "global.cancel": "Cancel",
  "global.collection.browsehomes": "Browse Homes",
  "global.collection.contactus": "Contact us",
  "global.confirm": "Confirm",
  "global.continue": "Continue",
  "global.getStarted": "Get started",
  "global.login": "Log in",
  "global.select": "Select",
  global_adults: jL,
  global_babies: AL,
  global_calendarUpdated_toast: OL,
  global_calendar_aMonth: PL,
  global_calendar_exactDates: DL,
  global_calendar_oneWeek: NL,
  global_calendar_oneWeekend: RL,
  global_calendar_plusMinusDay_zero: IL,
  global_calendar_plusMinusDay_one: TL,
  global_calendar_plusMinusDay_other: ML,
  global_calendar_twoWeeks: LL,
  global_cancel: WL,
  global_children: BL,
  global_dates: FL,
  global_delete: VL,
  global_description: UL,
  global_destination: qL,
  global_done: HL,
  global_edit: GL,
  "global_filter_a-c": "A/C",
  global_filter_available: KL,
  "global_filter_baby-bed": "Baby cribs",
  "global_filter_baby-gear": "Baby gear",
  "global_filter_balcony-terrace": "Balcony/Terrace",
  global_filter_bathtub: JL,
  global_filter_bbq: ZL,
  global_filter_bicycle: YL,
  global_filter_car: XL,
  global_filter_cat: QL,
  "global_filter_children-welcome": "Children welcome",
  global_filter_cities: eW,
  "global_filter_cleaning-person": "Cleaning person",
  global_filter_countryside: tW,
  "global_filter_dedicated-workspace": "Dedicated workspace",
  "global_filter_disabled-access": "Accessible home",
  global_filter_dishwasher: aW,
  global_filter_dog: oW,
  global_filter_dryer: nW,
  "global_filter_eco-level": "Only sustainable homes",
  "global_filter_electric-car-plug": "Electric car plug",
  global_filter_elevator: rW,
  global_filter_favorite: iW,
  global_filter_fireplace: sW,
  global_filter_flat: lW,
  global_filter_garden: cW,
  "global_filter_guest-wanted": "GuestPoints exchange",
  global_filter_guestPointsMax: uW,
  global_filter_guestPointsMin: dW,
  global_filter_guestPointsMinMax: gW,
  global_filter_gym: hW,
  "global_filter_heating-system": "Heating system",
  "global_filter_high-speed-connexion": "High speed connection",
  global_filter_home: mW,
  "global_filter_home-verified": "Verified homes",
  global_filter_island: pW,
  global_filter_isolated: fW,
  global_filter_jacuzzi: bW,
  "global_filter_kids-toys": "Kids toys",
  global_filter_lakes: _W,
  global_filter_luxury: vW,
  global_filter_mountains: yW,
  "global_filter_no-bed-up": "No temporary beds",
  global_filter_numOfBathrooms: wW,
  global_filter_other: kW,
  "global_filter_parking-space": "Private parking space",
  "global_filter_pets-welcome": "Pets welcome",
  global_filter_piano: xW,
  global_filter_playground: $W,
  global_filter_primary: SW,
  "global_filter_public-transit-access": "Public transport access",
  global_filter_reciprocal: CW,
  "global_filter_response-rate-above-threshold": "Response rate ≥ Average",
  global_filter_reverse: EW,
  global_filter_river: zW,
  global_filter_seaside: jW,
  global_filter_secondary: AW,
  "global_filter_secured-pool": "Secured pool",
  "global_filter_smokers-welcome": "Smokers welcome",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: OW,
  global_filter_villages: PW,
  "global_filter_washing-machine": "Washing machine",
  "global_filter_whole-unit": "Entire home",
  global_filter_wifi: DW,
  global_filters: NW,
  global_fixDates: RW,
  global_flexDates_aMonth: IW,
  global_flexDates_aWeekend: TW,
  global_flexDates_oneWeek: MW,
  global_flexDates_twoWeek: LW,
  global_flexibleDates: WW,
  global_guests: BW,
  global_homes: FW,
  global_lastMinute: VW,
  global_location: UW,
  global_modify: qW,
  global_name: HW,
  global_next: GW,
  global_numberOfAdults_zero: KW,
  global_numberOfAdults_one: JW,
  global_numberOfAdults_other: ZW,
  global_numberOfBabies_zero: YW,
  global_numberOfBabies_one: XW,
  global_numberOfBabies_other: QW,
  global_numberOfChildren_zero: e2,
  global_numberOfChildren_one: t2,
  global_numberOfChildren_other: a2,
  global_numberOfGuests_zero: o2,
  global_numberOfGuests_one: n2,
  global_numberOfGuests_other: r2,
  global_phoneNumber_notValid: i2,
  global_receiveEmailAlerts: s2,
  global_save: l2,
  global_searchBar_noLocationFound: c2,
  global_seeMore_link: u2,
  global_travelWishlist: d2,
  "modal.error-occured.content": "We're so sorry for the inconvenience, but please do try again.",
  "modal.error-occured.title": "Oh no, an error has occurred!",
  no_result: g2,
  optional: h2,
  "privacy-policy": "Privacy Policy"
}, p2 = "https://www.homeexchange.com/blog/", f2 = "/p/general-terms-of-use", b2 = "https://www.homeexchange.com/p/community", _2 = "https://homeexchangehelp.zendesk.com/hc/en-us", v2 = "https://forum.homeexchange.com/c/english/20", y2 = "https://www.homeexchange.com/p/service-homeexchange-en", w2 = "https://www.homeexchange.com/p/guestpoints-en", k2 = "https://www.homeexchange.com/p/press", x2 = "https://www.homeexchange.com/p/words-of-homeexchanges", $2 = "https://help.homeexchange.com/hc/en-us/articles/360000623717-What-are-My-Preferred-Destinations-and-how-do-I-use-them", S2 = "https://www.homeexchange.com/p/where-the-welcome-really-begins", C2 = "https://www.homeexchange.com/p/where-the-welcome-really-begins", E2 = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/p/about-us",
  blog: p2,
  cgu: f2,
  community: b2,
  "contact-us": "https://www.homeexchange.com/contact-us-homeexchange",
  "cookie-policy": "/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: _2,
  forum: v2,
  guarantees: y2,
  guestpoints: w2,
  "happiness-team": "https://www.homeexchange.com/p/happiness-team",
  "how-it-works": "https://www.homeexchange.com/p/how-it-works-en",
  "join-us": "https://www.homeexchange.com/p/join-us",
  "legal-notice": "/p/legal-notice",
  "mobile-app": "https://www.homeexchange.com/p/mobile-apps",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: k2,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/p/subscription-homeexchange",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: x2,
  travelWishlist_faq_links: $2,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: S2,
  values: C2
}, z2 = "First name", j2 = "Last name", A2 = "Add to your travel wishlist", O2 = "An updated travel wishlist will enable you to receive more reciprocal exchange requests.", P2 = "Are you sure you want to delete {{fullAddress}}?", D2 = "These are the filters you've selected. If you've changed your mind, you can delete some of them below. But if you'd like to add additional ones, you'll need to start a new search (though this will change soon... stay tuned)!", N2 = "This could be a country, city or a whole region. If you pick a broad location, your results might be less accurate.", R2 = "Type a country, city, or region", I2 = "View available homes", T2 = "When homes with availability match your travel plans.", M2 = "Add to your travel wishlist", L2 = "{{fullAddress}} has been deleted from your travel wishlist.", W2 = "Select your ideal travel dates (flexible or fixed).", B2 = "Add details to help others using the reverse search feature see why you’re interested in their location.", F2 = "Specify how many people will be traveling with you for this trip.", V2 = "Oops! {{fullAddress}} couldn't be saved to your travel wishlist for an unexpected reason.", U2 = "Let us know when and where you'd like to travel to receive exchange requests and alerts as soon as suitable homes become available. We'll save your searches to your travel wishlist!", q2 = "Any travel adventures you'd like to start planning?", H2 = "<updateDates>Update your dates</updateDates> to keep receiving relevant email alerts or <delete>delete this destination</delete> from your travel wishlist if you're no longer considering it.", G2 = "These dates are in the past", K2 = "{{fullAddress}} has been added to your travel wishlist!", J2 = "{{fullAddress}} has been successfully updated.", Z2 = "Your search has been saved, and your calendar has been updated!", Y2 = "Your search has been saved. Find it in your travel wishlist.", X2 = "Learn more about travel wishlists", Q2 = {
  firstname: z2,
  lastname: j2,
  modal_travelWishlist_addNew_title: A2,
  modal_travelWishlist_delete_body: O2,
  modal_travelWishlist_delete_title: P2,
  modal_travelWishlist_filtersApplied_helper: D2,
  modal_travelWishlist_location_helper: N2,
  modal_travelWishlist_searchBar_placeholder: R2,
  page_travelWishlist_card_cta: I2,
  page_travelWishlist_card_emailAlerts_helper: T2,
  page_travelWishlist_cta: M2,
  page_travelWishlist_deleted_toast: L2,
  page_travelWishlist_edit_dates_helper: W2,
  page_travelWishlist_edit_description_helper: B2,
  page_travelWishlist_edit_guests_helper: F2,
  page_travelWishlist_error_toast: V2,
  page_travelWishlist_none_body: U2,
  page_travelWishlist_none_subheader: q2,
  page_travelWishlist_pastDates_desc: H2,
  page_travelWishlist_pastDates_title: G2,
  page_travelWishlist_saved_toast: K2,
  page_travelWishlist_updated_toast: J2,
  search_travelWishlist_calendarUpdated_toast: Z2,
  search_travelWishlist_saved_toast: Y2,
  travelWishlist_faq: X2
}, eB = "Estudio", tB = "{{count}} dormitorio", aB = "{{count}} dormitorios", oB = "", nB = "{{count}} cama", rB = "{{count}} camas", iB = "", sB = "", lB = "Tu calendario ha sido actualizado.", cB = "Un mes", uB = "Fechas exactas", dB = "Una semana", gB = "Un fin de semana", hB = "", mB = "± {{count}} día", pB = "± {{count}} días", fB = "Dos semanas", bB = "Cancelar", _B = "", vB = "Fechas", yB = "Eliminar", wB = "Descripción", kB = "Destino", xB = "¡Listo!", $B = "Editar", SB = "Cualquier tipo de intercambio", CB = "Bañera", EB = "Barbacoa", zB = "Bicicleta", jB = "Coche", AB = "Gato", OB = "Ciudad", PB = "Campo", DB = "Lavavajillas", NB = "Perro", RB = "Secadora", IB = "Ascensor", TB = "Casas favoritas", MB = "Chimenea", LB = "Piso", WB = "Patio privado", BB = "", FB = "", VB = "", UB = "", qB = "Casa", HB = "Isla", GB = "Aislado", KB = "Jacuzzi", JB = "Lagos", ZB = "Casas Collection", YB = "", XB = "{{count}} baños", QB = "Otros animales", eF = "Piano", tF = "Columpios", aF = "Principal", oF = "Intercambio recíproco", nF = "Búsqueda inversa", rF = "Río", iF = "En la costa", sF = "Secundaria", lF = "TV", cF = "Pueblo", uF = "WiFi", dF = "Filtros", gF = "Fechas fijas", hF = "Un mes en {{date}}", mF = "Un fin de semana en {{date}}", pF = "Una semana en {{date}}", fF = "Dos semanas en {{date}}", bF = "Fechas flexibles", _F = "Invitados", vF = "casas", yF = "Último minuto", wF = "Ubicación", kF = "Modificar", xF = "Nombre", $F = "Siguiente", SF = "", CF = "{{count}} adulto", EF = "{{count}} adultos", zF = "", jF = "{{count}} bebé", AF = "bebé", OF = "", PF = "{{count}} niño/a", DF = "{{count}} niños", NF = "", RF = "{{count}} invitado/a", IF = "{{count}} invitados", TF = "El formato del número de teléfono no es válido.", MF = "Recibir notificaciones por correo electrónico", LF = "Guardar", WF = "No encontramos este lugar", BF = "Ver más", FF = "Proyectos de viaje", VF = "", UF = "opcional", qF = {
  "autocomplete.button": "Buscar",
  "autocomplete.placeholder": "¿Adónde vas?",
  bedroomsNumbers_zero: eB,
  bedroomsNumbers_one: tB,
  bedroomsNumbers_other: aB,
  beds_zero: oB,
  beds_one: nB,
  beds_other: rB,
  "button.free-signup": "Regístrate gratis",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "No puedes superar los {{limit}} caracteres",
  "error.reload": "Actualizar esta página",
  "error.return-homepage": "Volver a la página de inicio",
  "error.subtitle": "Lo sentimos, pero no se puede acceder a esta página.",
  "error.title": "Se ha producido un error en la página",
  "errors.unable_to_submit.subtitle": "Lo sentimos, se ha producido un error al enviar el formulario. Por favor, vuelve a intentarlo más tarde.",
  "errors.unable_to_submit.title": "¡Vaya! Algo ha fallado.",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Continuar",
  "global.getStarted": "",
  "global.login": "Iniciar sesión",
  "global.select": "Selecciona",
  global_adults: iB,
  global_babies: sB,
  global_calendarUpdated_toast: lB,
  global_calendar_aMonth: cB,
  global_calendar_exactDates: uB,
  global_calendar_oneWeek: dB,
  global_calendar_oneWeekend: gB,
  global_calendar_plusMinusDay_zero: hB,
  global_calendar_plusMinusDay_one: mB,
  global_calendar_plusMinusDay_other: pB,
  global_calendar_twoWeeks: fB,
  global_cancel: bB,
  global_children: _B,
  global_dates: vB,
  global_delete: yB,
  global_description: wB,
  global_destination: kB,
  global_done: xB,
  global_edit: $B,
  "global_filter_a-c": "Aire acondicionado",
  global_filter_available: SB,
  "global_filter_baby-bed": "",
  "global_filter_baby-gear": "Equipamiento para bebés",
  "global_filter_balcony-terrace": "Balcón/Terraza",
  global_filter_bathtub: CB,
  global_filter_bbq: EB,
  global_filter_bicycle: zB,
  global_filter_car: jB,
  global_filter_cat: AB,
  "global_filter_children-welcome": "Niños bienvenidos",
  global_filter_cities: OB,
  "global_filter_cleaning-person": "Señor/a de la limpieza",
  global_filter_countryside: PB,
  "global_filter_dedicated-workspace": "Escritorio para trabajar",
  "global_filter_disabled-access": "Casas accesibles",
  global_filter_dishwasher: DB,
  global_filter_dog: NB,
  global_filter_dryer: RB,
  "global_filter_eco-level": "Solo viviendas sostenibles",
  "global_filter_electric-car-plug": "Enchufe para coches eléctricos",
  global_filter_elevator: IB,
  global_filter_favorite: TB,
  global_filter_fireplace: MB,
  global_filter_flat: LB,
  global_filter_garden: WB,
  "global_filter_guest-wanted": "Intercambio con GuestPoints",
  global_filter_guestPointsMax: BB,
  global_filter_guestPointsMin: FB,
  global_filter_guestPointsMinMax: VB,
  global_filter_gym: UB,
  "global_filter_heating-system": "Calefacción",
  "global_filter_high-speed-connexion": "Conexión de alta velocidad",
  global_filter_home: qB,
  "global_filter_home-verified": "Casas verificadas",
  global_filter_island: HB,
  global_filter_isolated: GB,
  global_filter_jacuzzi: KB,
  "global_filter_kids-toys": "",
  global_filter_lakes: JB,
  global_filter_luxury: ZB,
  global_filter_mountains: YB,
  "global_filter_no-bed-up": "Sin camas provisionales",
  global_filter_numOfBathrooms: XB,
  global_filter_other: QB,
  "global_filter_parking-space": "",
  "global_filter_pets-welcome": "Mascotas bienvenidas",
  global_filter_piano: eF,
  global_filter_playground: tF,
  global_filter_primary: aF,
  "global_filter_public-transit-access": "",
  global_filter_reciprocal: oF,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: nF,
  global_filter_river: rF,
  global_filter_seaside: iF,
  global_filter_secondary: sF,
  "global_filter_secured-pool": "Piscina segura",
  "global_filter_smokers-welcome": "Fumadores bienvenidos",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: lF,
  global_filter_villages: cF,
  "global_filter_washing-machine": "Lavadora",
  "global_filter_whole-unit": "",
  global_filter_wifi: uF,
  global_filters: dF,
  global_fixDates: gF,
  global_flexDates_aMonth: hF,
  global_flexDates_aWeekend: mF,
  global_flexDates_oneWeek: pF,
  global_flexDates_twoWeek: fF,
  global_flexibleDates: bF,
  global_guests: _F,
  global_homes: vF,
  global_lastMinute: yF,
  global_location: wF,
  global_modify: kF,
  global_name: xF,
  global_next: $F,
  global_numberOfAdults_zero: SF,
  global_numberOfAdults_one: CF,
  global_numberOfAdults_other: EF,
  global_numberOfBabies_zero: zF,
  global_numberOfBabies_one: jF,
  global_numberOfBabies_other: AF,
  global_numberOfChildren_zero: OF,
  global_numberOfChildren_one: PF,
  global_numberOfChildren_other: DF,
  global_numberOfGuests_zero: NF,
  global_numberOfGuests_one: RF,
  global_numberOfGuests_other: IF,
  global_phoneNumber_notValid: TF,
  global_receiveEmailAlerts: MF,
  global_save: LF,
  global_searchBar_noLocationFound: WF,
  global_seeMore_link: BF,
  global_travelWishlist: FF,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: VF,
  optional: UF,
  "privacy-policy": "Política de Privacidad"
}, HF = "https://www.homeexchange.com/es/blog/", GF = "/es/p/homeexchange-condiciones-de-uso", KF = "https://www.homeexchange.com/es/p/nuestra-comunidad-es", JF = "https://homeexchangehelp.zendesk.com/hc/es", ZF = "https://forum.homeexchange.com/c/espanol/22", YF = "https://www.homeexchange.com/es/p/service-homeexchange-es", XF = "https://www.homeexchange.com/es/p/los-guestpoints", QF = "https://www.homeexchange.com/es/p/prensa", eV = "https://www.homeexchange.com/p/palabra-de-homeexchanger", tV = "", aV = "https://www.homeexchange.com/es/p/principios-intercambio-casa", oV = "https://www.homeexchange.com/es/p/principios-intercambio-casa", nV = {
  "about-calendar": "https://help.homeexchange.com/hc/es/articles/360007584998-Todo-lo-que-necesitas-saber-sobre-el-calendario",
  "about-us": "https://www.homeexchange.com/es/p/about-us-es",
  blog: HF,
  cgu: GF,
  community: KF,
  "contact-us": "https://www.homeexchange.com/es/contacto-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeES/",
  faq: JF,
  forum: ZF,
  guarantees: YF,
  guestpoints: XF,
  "happiness-team": "https://www.homeexchange.com/es/p/happiness-team-es",
  "how-it-works": "https://www.homeexchange.com/es/p/como-funciona-es",
  "join-us": "https://www.homeexchange.com/es/p/join-us-es",
  "legal-notice": "/p/menciones-legales",
  "mobile-app": "https://www.homeexchange.com/es/p/aplicacion-movil",
  "our-team": "https://www.homeexchange.com/es/p/nuestro-equipo",
  press: QF,
  "privacy-policy": "/p/homeexchange-politica-privacidad",
  "subscription-cost": "https://www.homeexchange.com/es/p/subscription-homeexchange-es",
  "term-of-use": "/p/homeexchange-condiciones-de-uso",
  testimonials: eV,
  travelWishlist_faq_links: tV,
  "twitter-page": "https://twitter.com/HomeExchangeES",
  value: aV,
  values: oV
}, rV = "", iV = "", sV = "Crear nuevo proyecto de viaje", lV = "Tener tus proyectos de viaje actualizados te permitirá recibir más solicitudes de intercambio recíproco.", cV = "¿Seguro que quieres eliminar {{fullAddress}}?", uV = "Estos son los filtros que has seleccionado. Si has cambiado de opinión, puedes eliminar algunos de ellos a continuación. Pero si quieres añadir otros, tendrás que iniciar una nueva búsqueda (aunque esto cambiará pronto... ¡tendrás noticias!)", dV = "Puede ser un país, una ciudad o una región entera. Si eliges una ubicación general, los resultados pueden ser menos precisos.", gV = "Introduce un país, ciudad o región", hV = "Ver casas disponibles", mV = "Cuando haya casas disponibles que coincidan con tus proyectos de viaje.", pV = "Crear nuevo proyecto de viaje", fV = "{{fullAddress}} se ha eliminado de tus proyectos de viaje.", bV = "Selecciona tus fechas ideales de viaje (flexibles o fijas).", _V = "Añade detalles para ayudar a otras personas que utilicen la función de búsqueda inversa a entender por qué te interesa su región.", vV = "Especifica cuántas personas viajarán contigo.", yV = "¡Vaya! {{fullAddress}} no se ha guardado en tus proyectos de viaje por un motivo desconocido.", wV = "Indícanos cuándo y dónde te gustaría viajar para recibir solicitudes de intercambio y notificaciones cuando haya casas disponibles. Guardaremos tus búsquedas en tus proyectos de viaje.", kV = "¿Te apetece empezar a planear alguna aventura?", xV = "<updateDates>Actualiza la fecha</updateDates> para seguir recibiendo notificaciones por correo electrónico o <delete>elimina este destino</delete>  de tus proyectos de viaje si ya no lo tienes en mente.", $V = "Esta fecha ya ha pasado", SV = "{{fullAddress}} se ha añadido a tus proyectos de viaje", CV = "{{fullAddress}} se ha actualizado correctamente.", EV = "¡Tu búsqueda se ha guardado y tu calendario se ha actualizado!", zV = "Tu búsqueda se ha guardado. Podrás verla en tus proyectos de viaje.", jV = "Saber más sobre los proyectos de viaje", AV = {
  firstname: rV,
  lastname: iV,
  modal_travelWishlist_addNew_title: sV,
  modal_travelWishlist_delete_body: lV,
  modal_travelWishlist_delete_title: cV,
  modal_travelWishlist_filtersApplied_helper: uV,
  modal_travelWishlist_location_helper: dV,
  modal_travelWishlist_searchBar_placeholder: gV,
  page_travelWishlist_card_cta: hV,
  page_travelWishlist_card_emailAlerts_helper: mV,
  page_travelWishlist_cta: pV,
  page_travelWishlist_deleted_toast: fV,
  page_travelWishlist_edit_dates_helper: bV,
  page_travelWishlist_edit_description_helper: _V,
  page_travelWishlist_edit_guests_helper: vV,
  page_travelWishlist_error_toast: yV,
  page_travelWishlist_none_body: wV,
  page_travelWishlist_none_subheader: kV,
  page_travelWishlist_pastDates_desc: xV,
  page_travelWishlist_pastDates_title: $V,
  page_travelWishlist_saved_toast: SV,
  page_travelWishlist_updated_toast: CV,
  search_travelWishlist_calendarUpdated_toast: EV,
  search_travelWishlist_saved_toast: zV,
  travelWishlist_faq: jV
}, OV = "Studio", PV = "{{count}} chambre", DV = "{{count}} chambres", NV = "", RV = "{{count}} lit", IV = "{{count}} lits", TV = "Adultes", MV = "Bébés", LV = "Votre calendrier a été mis à jour.", WV = "Un mois", BV = "Dates exactes", FV = "Une semaine", VV = "Un week-end", UV = "Vide", qV = "± {{count}} jour", HV = "± {{count}} jours", GV = "Deux semaines", KV = "Annuler", JV = "Enfants", ZV = "Dates", YV = "Supprimer", XV = "Description", QV = "Destination", e3 = "C'est prêt !", t3 = "Modifier", a3 = "Tout type d'échange", o3 = "Baignoire", n3 = "Barbecue", r3 = "Vélo", i3 = "Voiture", s3 = "Chat", l3 = "Ville", c3 = "Campagne", u3 = "Lave-vaisselle", d3 = "Chien", g3 = "Sèche linge", h3 = "Ascenseur", m3 = "Maisons favorites", p3 = "Cheminée", f3 = "Appartement", b3 = "Jardin privé", _3 = "moins de {{max}} GP", v3 = "à partir de {{min}} GP", y3 = "Entre {{min}} et {{max}} GP", w3 = "Salle de sport privée", k3 = "Maison", x3 = "Île", $3 = "Isolé", S3 = "Jacuzzi", C3 = "Lac", E3 = "Maisons Collection", z3 = "Montagne", j3 = "{{count}} salles de bain", A3 = "Autre", O3 = "Piano", P3 = "Aire de jeux", D3 = "Principale", N3 = "Échange réciproque", R3 = "Recherche inversée", I3 = "Rivière", T3 = "Bord de mer", M3 = "Secondaire", L3 = "TV", W3 = "Village", B3 = "WiFi", F3 = "Filtres", V3 = "Dates fixes", U3 = "Un mois en {{date}}", q3 = "Un week-end en {{date}}", H3 = "Une semaine en {{date}}", G3 = "Deux semaines en {{date}}", K3 = "Dates flexibles", J3 = "Personnes", Z3 = "maisons", Y3 = "Dernière minute", X3 = "Lieu", Q3 = "Modifier", e4 = "Titre", t4 = "Suivant", a4 = "Vide", o4 = "{{count}} adulte", n4 = "{{count}} adultes", r4 = "Vide", i4 = "{{count}} bébé", s4 = "{{count}} bébés", l4 = "Vide", c4 = "{{count}} enfant", u4 = "{{count}} enfants", d4 = "{{count}} personne", g4 = "{{count}} personne", h4 = "{{count}} personnes", m4 = "Le format du numéro de téléphone est invalide.", p4 = "Recevoir des alertes par email", f4 = "Enregistrer", b4 = "Aucun lieu trouvé", _4 = "Voir plus", v4 = "Projets de voyage", y4 = "", w4 = "facultatif", k4 = {
  "autocomplete.button": "Rechercher",
  "autocomplete.placeholder": "Où allez-vous ?",
  bedroomsNumbers_zero: OV,
  bedroomsNumbers_one: PV,
  bedroomsNumbers_other: DV,
  beds_zero: NV,
  beds_one: RV,
  beds_other: IV,
  "button.free-signup": "Inscrivez-vous gratuitement",
  "button.validate": "Valider",
  "common.try-again": "Compris !",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne doit pas dépasser {{limit}} caractères",
  "error.reload": "Actualiser la page",
  "error.return-homepage": "Retour à la page d'accueil",
  "error.subtitle": "Malheureusement, il y a un problème avec cette page.",
  "error.title": "Une erreur s'est produite sur la page",
  "errors.unable_to_submit.subtitle": "Malheureusement, votre réponse n'a pas pu être enregistrée. Merci de réessayer plus tard !",
  "errors.unable_to_submit.title": "Oups, on dirait bien qu'il y a un problème !",
  "global.back": "Retour",
  "global.cancel": "Annuler",
  "global.collection.browsehomes": "Découvrir les maisons",
  "global.collection.contactus": "Nous contacter",
  "global.confirm": "Confirmer",
  "global.continue": "Continuer",
  "global.getStarted": "Commencer",
  "global.login": "Se connecter",
  "global.select": "Sélectionner",
  global_adults: TV,
  global_babies: MV,
  global_calendarUpdated_toast: LV,
  global_calendar_aMonth: WV,
  global_calendar_exactDates: BV,
  global_calendar_oneWeek: FV,
  global_calendar_oneWeekend: VV,
  global_calendar_plusMinusDay_zero: UV,
  global_calendar_plusMinusDay_one: qV,
  global_calendar_plusMinusDay_other: HV,
  global_calendar_twoWeeks: GV,
  global_cancel: KV,
  global_children: JV,
  global_dates: ZV,
  global_delete: YV,
  global_description: XV,
  global_destination: QV,
  global_done: e3,
  global_edit: t3,
  "global_filter_a-c": "Air conditionné",
  global_filter_available: a3,
  "global_filter_baby-bed": "Lits bébé",
  "global_filter_baby-gear": "Équipements bébé",
  "global_filter_balcony-terrace": "Balcon / Terrasse",
  global_filter_bathtub: o3,
  global_filter_bbq: n3,
  global_filter_bicycle: r3,
  global_filter_car: i3,
  global_filter_cat: s3,
  "global_filter_children-welcome": "Les enfants sont les bienvenus",
  global_filter_cities: l3,
  "global_filter_cleaning-person": "Service de ménage",
  global_filter_countryside: c3,
  "global_filter_dedicated-workspace": "Espace de travail dédié",
  "global_filter_disabled-access": "Logement adapté",
  global_filter_dishwasher: u3,
  global_filter_dog: d3,
  global_filter_dryer: g3,
  "global_filter_eco-level": "Uniquement des maisons durables",
  "global_filter_electric-car-plug": "Prise pour voiture électrique",
  global_filter_elevator: h3,
  global_filter_favorite: m3,
  global_filter_fireplace: p3,
  global_filter_flat: f3,
  global_filter_garden: b3,
  "global_filter_guest-wanted": "Échange contre GuestPoints",
  global_filter_guestPointsMax: _3,
  global_filter_guestPointsMin: v3,
  global_filter_guestPointsMinMax: y3,
  global_filter_gym: w3,
  "global_filter_heating-system": "Chauffage",
  "global_filter_high-speed-connexion": "Connexion haut débit",
  global_filter_home: k3,
  "global_filter_home-verified": "Logements vérifiés",
  global_filter_island: x3,
  global_filter_isolated: $3,
  global_filter_jacuzzi: S3,
  "global_filter_kids-toys": "Jouets pour enfants",
  global_filter_lakes: C3,
  global_filter_luxury: E3,
  global_filter_mountains: z3,
  "global_filter_no-bed-up": "Pas de lit d'appoint",
  global_filter_numOfBathrooms: j3,
  global_filter_other: A3,
  "global_filter_parking-space": "Place de parking privé",
  "global_filter_pets-welcome": "Les animaux sont les bienvenus",
  global_filter_piano: O3,
  global_filter_playground: P3,
  global_filter_primary: D3,
  "global_filter_public-transit-access": "Accès aux transports publics",
  global_filter_reciprocal: N3,
  "global_filter_response-rate-above-threshold": "Réactivité ≥ Moyenne",
  global_filter_reverse: R3,
  global_filter_river: I3,
  global_filter_seaside: T3,
  global_filter_secondary: M3,
  "global_filter_secured-pool": "Piscine sécurisée",
  "global_filter_smokers-welcome": "Fumeurs bienvenus",
  "global_filter_swimming-pool": "Piscine",
  global_filter_tv: L3,
  global_filter_villages: W3,
  "global_filter_washing-machine": "Lave linge",
  "global_filter_whole-unit": "L'intégralité du logement",
  global_filter_wifi: B3,
  global_filters: F3,
  global_fixDates: V3,
  global_flexDates_aMonth: U3,
  global_flexDates_aWeekend: q3,
  global_flexDates_oneWeek: H3,
  global_flexDates_twoWeek: G3,
  global_flexibleDates: K3,
  global_guests: J3,
  global_homes: Z3,
  global_lastMinute: Y3,
  global_location: X3,
  global_modify: Q3,
  global_name: e4,
  global_next: t4,
  global_numberOfAdults_zero: a4,
  global_numberOfAdults_one: o4,
  global_numberOfAdults_other: n4,
  global_numberOfBabies_zero: r4,
  global_numberOfBabies_one: i4,
  global_numberOfBabies_other: s4,
  global_numberOfChildren_zero: l4,
  global_numberOfChildren_one: c4,
  global_numberOfChildren_other: u4,
  global_numberOfGuests_zero: d4,
  global_numberOfGuests_one: g4,
  global_numberOfGuests_other: h4,
  global_phoneNumber_notValid: m4,
  global_receiveEmailAlerts: p4,
  global_save: f4,
  global_searchBar_noLocationFound: b4,
  global_seeMore_link: _4,
  global_travelWishlist: v4,
  "modal.error-occured.content": "Toutes nos excuses : quelque chose ne s'est pas passé comme prévu, il va falloir que vous retentiez votre chance !",
  "modal.error-occured.title": "Une erreur s'est produite",
  no_result: y4,
  optional: w4,
  "privacy-policy": "Charte de vie privée"
}, x4 = "https://www.homeexchange.fr/blog/", $4 = "/p/conditions-generale-d-utilisation", S4 = "https://www.homeexchange.fr/p/communaute", C4 = "https://homeexchangehelp.zendesk.com/hc/fr", E4 = "https://forum.homeexchange.com/c/francais/21", z4 = "https://www.homeexchange.fr/p/service-homeexchange-fr", j4 = "https://www.homeexchange.fr/p/comment-fonctionnent-les-gp", A4 = "https://www.homeexchange.fr/p/presse", O4 = "https://www.homeexchange.com/p/paroles-homeexchangers", P4 = "https://help.homeexchange.com/hc/fr/articles/360000623717-Que-sont-Mes-destinations-pr%C3%A9f%C3%A9r%C3%A9es-et-comment-les-utiliser", D4 = "https://www.homeexchange.fr/p/les-fondamentaux ", N4 = "https://www.homeexchange.fr/p/les-fondamentaux", R4 = {
  "about-calendar": "https://help.homeexchange.com/hc/fr/articles/360007584998-Tout-ce-que-vous-devez-savoir-sur-le-calendrier",
  "about-us": "https://www.homeexchange.fr/p/qui-sommes-nous",
  blog: x4,
  cgu: $4,
  community: S4,
  "contact-us": "https://www.homeexchange.fr/contactez-nous-homeexchange",
  "cookie-policy": "/p/nos-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeFR/",
  faq: C4,
  forum: E4,
  guarantees: z4,
  guestpoints: j4,
  "happiness-team": "https://www.homeexchange.fr/p/happiness-team-fr",
  "how-it-works": "https://www.homeexchange.fr/p/comment-ca-marche-fr",
  "join-us": "https://www.homeexchange.fr/p/recrutement",
  "legal-notice": "/p/mentions-legales",
  "mobile-app": "https://www.homeexchange.fr/p/applications-mobile",
  "our-team": "https://www.homeexchange.fr/p/notre-equipe",
  press: A4,
  "privacy-policy": "/p/charte-vie-privee",
  "subscription-cost": "https://www.homeexchange.fr/p/subscription-homeexchange-fr",
  "term-of-use": "/p/conditions-generale-d-utilisation",
  testimonials: O4,
  travelWishlist_faq_links: P4,
  "twitter-page": "https://twitter.com/HomeExchangeFR",
  value: D4,
  values: N4
}, I4 = "Prénom", T4 = "Nom", M4 = "Ajouter un projet de voyage", L4 = "Garder vos projets de voyage à jour vous permet de recevoir davantage de demandes d'échange réciproques.", W4 = "Voulez-vous vraiment supprimer {{fullAddress}} ?", B4 = "Ce sont les filtres que vous avez sélectionnés lors de votre recherche enregistrée : vous pouvez en supprimer mais si vous souhaitez en ajouter, vous devrez lancer une nouvelle recherche (mais plus pour très longtemps... on vous tiendra au courant !).", F4 = "Vous pouvez indiquer un pays, une région ou une ville. Si vous visez large, les résultats seront peut-être moins précis.", V4 = "Entrez un pays, une ville ou une région", U4 = "Voir les maisons disponibles", q4 = "Lorsque des logements correspondant à vos critères ont de nouvelles disponibilités", H4 = "Ajouter un projet de voyage", G4 = "Nous avons bien supprimé {{fullAddress}} de vos projets de voyage.", K4 = "Indiquez vos dates de voyage estimées (qu'elles soient flexibles ou fixes).", J4 = "Ajoutez des détails pour aider les membres utilisant la recherche inversée à savoir ce qui vous intéresse dans leur région.", Z4 = "Indiquez combien de personnes voyageront avec vous cette fois-ci.", Y4 = "Oups ! Pour une raison inattendue, nous n'avons pas pu ajouter {{fullAddress}} à vos projets de voyage.", X4 = "Indiquez où et quand vous aimeriez partir pour recevoir des demandes d'échange adaptées ainsi que des alertes dès que des logements correspondent à vos critères. Chaque recherche sera enregistrée dans vos projets de voyage.", Q4 = "Des envies de voyage en tête ?", eU = "<updateDates>Mettez à jour vos dates</updateDates> pour continuer à recevoir des alertes email pertinentes ou <delete>supprimez cette destination</delete> de vos projets de voyage si elle n'est plus d'actualité.", tU = "Ces dates sont passées", aU = "Nous avons bien ajouté {{fullAddress}} à vos projets de voyage.", oU = "Nous avons bien mis à jour les informations pour {{fullAddress}}", nU = "Votre recherche a bien été enregistrée et votre calendrier a été mis à jour.", rU = "Votre recherche a bien été enregistrée. Retrouvez-la dans vos projets de voyage.", iU = "En savoir plus sur les projets de voyage", sU = {
  firstname: I4,
  lastname: T4,
  modal_travelWishlist_addNew_title: M4,
  modal_travelWishlist_delete_body: L4,
  modal_travelWishlist_delete_title: W4,
  modal_travelWishlist_filtersApplied_helper: B4,
  modal_travelWishlist_location_helper: F4,
  modal_travelWishlist_searchBar_placeholder: V4,
  page_travelWishlist_card_cta: U4,
  page_travelWishlist_card_emailAlerts_helper: q4,
  page_travelWishlist_cta: H4,
  page_travelWishlist_deleted_toast: G4,
  page_travelWishlist_edit_dates_helper: K4,
  page_travelWishlist_edit_description_helper: J4,
  page_travelWishlist_edit_guests_helper: Z4,
  page_travelWishlist_error_toast: Y4,
  page_travelWishlist_none_body: X4,
  page_travelWishlist_none_subheader: Q4,
  page_travelWishlist_pastDates_desc: eU,
  page_travelWishlist_pastDates_title: tU,
  page_travelWishlist_saved_toast: aU,
  page_travelWishlist_updated_toast: oU,
  search_travelWishlist_calendarUpdated_toast: nU,
  search_travelWishlist_saved_toast: rU,
  travelWishlist_faq: iU
}, lU = "Studio", cU = "{{count}} soba", uU = "{{count}} sobe", dU = "{{count}} sobe", gU = "", hU = "{{count}} krevet", mU = "{{count}} kreveti", pU = "{{count}} kreveti", fU = "Odrasle osobe", bU = "Bebe", _U = "Vaš je kalendar ažuriran.", vU = "Mjesec", yU = "Točni datumi", wU = "Jedan tjedan", kU = "Jedan vikend", xU = "dana", $U = "dan", SU = "dana", CU = "± {{count}} dan", EU = "Dva tjedna", zU = "Odustani", jU = "Djeca", AU = "Datumi", OU = "Izbrišite", PU = "Opis", DU = "Odredište", NU = "Gotovo!", RU = "Uredite", IU = "Sve vrste zamjene", TU = "Kada", MU = "Roštilj", LU = "Bicikl", WU = "Automobil", BU = "Mačka", FU = "Grad", VU = "Ruralno", UU = "Perilica suđa", qU = "Pas", HU = "Sušilica", GU = "Dizalo", KU = "Favoriti", JU = "Kamin", ZU = "Stan", YU = "Privatno dvorište", XU = "manje od {{max}} GP", QU = "od {{min}} GP", eq = "Između {{min}} i {{max}} GP", tq = "Privatna teretana", aq = "Kuća", oq = "Otok", nq = "Izoliran", rq = "Jacuzzi", iq = "Jezera", sq = "Domove iz Collectiona", lq = "Planine", cq = "broj kupanica: %{count}", uq = "Ostale životinje", dq = "Glasovir", gq = "Dječje igralište", hq = "Moj dom", mq = "Recipročna zamjena", pq = "Obrnuta pretraga", fq = "Rijeka", bq = "Na obali", _q = "Drugi", vq = "TV", yq = "Selo", wq = "WiFi", kq = "Filtri", xq = "Fiksni datumi", $q = "{{date}}: jedan mjesec", Sq = "{{date}}: jedan vikend", Cq = "{{date}}: jedan tjedan", Eq = "{{date}}: dva tjedna", zq = "Fleksibilni datumi", jq = "Gosti", Aq = "domova", Oq = "U zadnji tren", Pq = "Lokacija", Dq = "Uredi", Nq = "", Rq = "Dalje", Iq = "odraslih osoba", Tq = "odrasla osoba", Mq = "odrasle osobe", Lq = "odraslih osoba", Wq = "beba", Bq = "beba", Fq = "bebe", Vq = "beba", Uq = "djece", qq = "dijete", Hq = "djeteta", Gq = "djece", Kq = "gostiju", Jq = "gost", Zq = "gosta", Yq = "gostiju", Xq = "Format telefonskog broja nije valjan.", Qq = "Primajte obavijesti e-poštom", eH = "Spremi", tH = "Nema pronađenih lokacija", aH = "Saznajte više", oH = "Planovi putovanja", nH = "", rH = "nije obavezno", iH = {
  "autocomplete.button": "Pretražite",
  "autocomplete.placeholder": "Gdje ideš ?",
  bedroomsNumbers_zero: lU,
  bedroomsNumbers_one: cU,
  bedroomsNumbers_few: uU,
  bedroomsNumbers_other: dU,
  beds_zero: gU,
  beds_one: hU,
  beds_few: mU,
  beds_other: pU,
  "button.free-signup": "Prijavite se besplatno",
  "button.validate": "Potvrdite",
  "common.try-again": "Pokušajte ponovno",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne smije biti dulje od {{limit}} znakova",
  "error.reload": "Osvježite stranicu",
  "error.return-homepage": "Vratite se na početnu stranicu",
  "error.subtitle": "Nažalost ne može se pristupiti ovoj stranici.",
  "error.title": "Došlo je do greške na stranici.",
  "errors.unable_to_submit.subtitle": "Nažalost, Vaš obrazac trenutačno ne može biti predan. Molimo da kasnije pokušate ponovno.",
  "errors.unable_to_submit.title": "Ups, imamo problem",
  "global.back": "Natrag",
  "global.cancel": "Odustani",
  "global.collection.browsehomes": "Pretražujte domove",
  "global.collection.contactus": "Kontaktirajte nas",
  "global.confirm": "Potvrdi",
  "global.continue": "Nastavite",
  "global.getStarted": "Započnite",
  "global.login": "Prijava",
  "global.select": "Odaberi",
  global_adults: fU,
  global_babies: bU,
  global_calendarUpdated_toast: _U,
  global_calendar_aMonth: vU,
  global_calendar_exactDates: yU,
  global_calendar_oneWeek: wU,
  global_calendar_oneWeekend: kU,
  global_calendar_plusMinusDay_zero: xU,
  global_calendar_plusMinusDay_one: $U,
  global_calendar_plusMinusDay_few: SU,
  global_calendar_plusMinusDay_other: CU,
  global_calendar_twoWeeks: EU,
  global_cancel: zU,
  global_children: jU,
  global_dates: AU,
  global_delete: OU,
  global_description: PU,
  global_destination: DU,
  global_done: NU,
  global_edit: RU,
  "global_filter_a-c": "Klima uređaj",
  global_filter_available: IU,
  "global_filter_baby-bed": "Kreveti za bebe",
  "global_filter_baby-gear": "Oprema za bebe",
  "global_filter_balcony-terrace": "Balkon/terasa",
  global_filter_bathtub: TU,
  global_filter_bbq: MU,
  global_filter_bicycle: LU,
  global_filter_car: WU,
  global_filter_cat: BU,
  "global_filter_children-welcome": "Djeca su dobrodošla",
  global_filter_cities: FU,
  "global_filter_cleaning-person": "Čistačica",
  global_filter_countryside: VU,
  "global_filter_dedicated-workspace": "Zaseban radni prostor",
  "global_filter_disabled-access": "Pristupačan dom",
  global_filter_dishwasher: UU,
  global_filter_dog: qU,
  global_filter_dryer: HU,
  "global_filter_eco-level": "Samo održivi domovi",
  "global_filter_electric-car-plug": "Utikač za električni automobil",
  global_filter_elevator: GU,
  global_filter_favorite: KU,
  global_filter_fireplace: JU,
  global_filter_flat: ZU,
  global_filter_garden: YU,
  "global_filter_guest-wanted": "Zamjena sa GuestPoints bodovima",
  global_filter_guestPointsMax: XU,
  global_filter_guestPointsMin: QU,
  global_filter_guestPointsMinMax: eq,
  global_filter_gym: tq,
  "global_filter_heating-system": "Sustav grijanja",
  "global_filter_high-speed-connexion": "Velika brzina veze",
  global_filter_home: aq,
  "global_filter_home-verified": "Provjereni domovi ",
  global_filter_island: oq,
  global_filter_isolated: nq,
  global_filter_jacuzzi: rq,
  "global_filter_kids-toys": "Dječje igračke",
  global_filter_lakes: iq,
  global_filter_luxury: sq,
  global_filter_mountains: lq,
  "global_filter_no-bed-up": "Nema privremenih kreveta",
  global_filter_numOfBathrooms: cq,
  global_filter_other: uq,
  "global_filter_parking-space": "Privatno parkirno mjesto",
  "global_filter_pets-welcome": "Kućni ljubimci su dobrodošli",
  global_filter_piano: dq,
  global_filter_playground: gq,
  global_filter_primary: hq,
  "global_filter_public-transit-access": "Pristup javnim prijevozom",
  global_filter_reciprocal: mq,
  "global_filter_response-rate-above-threshold": "Stopa odgovora ≥ Prosječno",
  global_filter_reverse: pq,
  global_filter_river: fq,
  global_filter_seaside: bq,
  global_filter_secondary: _q,
  "global_filter_secured-pool": "Osiguran bazen",
  "global_filter_smokers-welcome": "Dozvoljeno pušenje",
  "global_filter_swimming-pool": "Bazen",
  global_filter_tv: vq,
  global_filter_villages: yq,
  "global_filter_washing-machine": "Perilica rublja",
  "global_filter_whole-unit": "Cijela jedinica",
  global_filter_wifi: wq,
  global_filters: kq,
  global_fixDates: xq,
  global_flexDates_aMonth: $q,
  global_flexDates_aWeekend: Sq,
  global_flexDates_oneWeek: Cq,
  global_flexDates_twoWeek: Eq,
  global_flexibleDates: zq,
  global_guests: jq,
  global_homes: Aq,
  global_lastMinute: Oq,
  global_location: Pq,
  global_modify: Dq,
  global_name: Nq,
  global_next: Rq,
  global_numberOfAdults_zero: Iq,
  global_numberOfAdults_one: Tq,
  global_numberOfAdults_few: Mq,
  global_numberOfAdults_other: Lq,
  global_numberOfBabies_zero: Wq,
  global_numberOfBabies_one: Bq,
  global_numberOfBabies_few: Fq,
  global_numberOfBabies_other: Vq,
  global_numberOfChildren_zero: Uq,
  global_numberOfChildren_one: qq,
  global_numberOfChildren_few: Hq,
  global_numberOfChildren_other: Gq,
  global_numberOfGuests_zero: Kq,
  global_numberOfGuests_one: Jq,
  global_numberOfGuests_few: Zq,
  global_numberOfGuests_other: Yq,
  global_phoneNumber_notValid: Xq,
  global_receiveEmailAlerts: Qq,
  global_save: eH,
  global_searchBar_noLocationFound: tH,
  global_seeMore_link: aH,
  global_travelWishlist: oH,
  "modal.error-occured.content": "Žao nam je zbog neugodnosti, ali pokušajte ponovno.",
  "modal.error-occured.title": "Došlo je do pogreške.",
  no_result: nH,
  optional: rH,
  "privacy-policy": "Pravila o privatnosti"
}, sH = "https://www.homeexchange.com/blog/", lH = "/p/general-terms-of-use", cH = "https://www.homeexchange.com/hr/p/zajednica", uH = "https://homeexchangehelp.zendesk.com/hc/en-us", dH = "", gH = "https://www.homeexchange.com/hr/p/service-homeexchange-hr", hH = "https://www.homeexchange.com/hr/p/guestpoints-hr", mH = "https://www.homeexchange.com/hr/p/press-hr", pH = "https://www.homeexchange.com/p/rijeci-homeexchange", fH = "", bH = "https://www.homeexchange.com/hr/p/gdje-dobrodoslica-stvarno-pocinje", _H = "https://www.homeexchange.com/hr/p/gdje-dobrodoslica-stvarno-pocinje", vH = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/hr/p/about-us-hr",
  blog: sH,
  cgu: lH,
  community: cH,
  "contact-us": "https://www.homeexchange.com/hr/kontaktirajte-nas-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: uH,
  forum: dH,
  guarantees: gH,
  guestpoints: hH,
  "happiness-team": "https://www.homeexchange.com/hr/p/happiness-team-hr",
  "how-it-works": "https://www.homeexchange.com/hr/p/kako-to-funkcionira-hr",
  "join-us": "https://www.homeexchange.com/hr/p/join-us-hr",
  "legal-notice": "/p/pravna-napomena",
  "mobile-app": "https://www.homeexchange.com/hr/p/mobilna-aplikacija",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: mH,
  "privacy-policy": "/p/privacy-policy-hr",
  "subscription-cost": "https://www.homeexchange.com/hr/p/subscription-homeexchange-hr",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: pH,
  travelWishlist_faq_links: fH,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: bH,
  values: _H
}, yH = "Ime", wH = "Prezime", kH = "Dodajte u svoje planove putovanja", xH = "Ažurirani planovi putovanja će Vam omogućiti da dobivate više zahtjeva za recipročne zamjene.", $H = "Jeste li sigurni da želite obrisati lokaciju {{fullAddress}}?", SH = "Ovo su filtri koji ste odabrali. Ako ste se predomislili, možete obrisati neke od njih. Ali ako želite dodati neke druge, morate započeti novo pretraživanje (iako će se ovo uskoro promijeniti... pratite obavijesti)!", CH = "Ovo može biti neka zemlja, grad ili cijela regija. Ako odaberete jako široku lokaciju, Vaši bi rezultati mogli biti manje točni.", EH = "Upišite zemlju, grad ili regiju", zH = "Pogledajte dostupne domove", jH = "Kada domovi s dostupnošću odgovaraju Vašim planovima putovanja.", AH = "Izradite novi plan putovanja", OH = "Lokacija {{fullAddress}} je obrisana iz Vaših planova putovanja.", PH = "Odaberite svoje idealne datume putovanja (fleksibilne ili fiksne).", DH = "Dodajte detalje kako biste pomogli drugima koji koriste značajku obrnutog pretraživanja da vide zašto Vas zanima njihova lokacija.", NH = "Navedite koliko će ljudi putovati s Vama na ovom putovanju.", RH = "Ups! Lokacija {{fullAddress}} nije mogla biti spremljena u Vaše planove putovanja zbog neočekivanog razloga.", IH = "Recite nam kada i kamo biste željeli otputovati kako biste dobivali zahtjeve za zamjene i obavijesti čim odgovarajući domovi postanu dostupni. Spremit ćemo Vaše pretraživanje u Vaše planove putovanja!", TH = "Postoje li neke pustolovine za putovanja koje biste voljeli početi planirati?", MH = "<updateDates>Ažurirajte svoje datume</updateDates> kako biste i dalje dobivali odgovarajuće obavijesti preko e-poruka ili <delete>obrišite ovo odredište</delete> iz svojih planova putovanja ako više ne razmišljate o njemu.", LH = "Ovi datumi su u prošlosti", WH = "Lokacija {{fullAddress}} je dodana u Vaše planove putovanja!", BH = "{{fullAddress}} je uspješno ažurirana.", FH = "Vaše je pretraživanje spremljeno i Vaš je kalendar ažuriran!", VH = "Vaše je pretraživanje spremljeno. Pronađite ga u svojim planovima putovanja.", UH = "Saznajte više o planovima putovanja", qH = {
  firstname: yH,
  lastname: wH,
  modal_travelWishlist_addNew_title: kH,
  modal_travelWishlist_delete_body: xH,
  modal_travelWishlist_delete_title: $H,
  modal_travelWishlist_filtersApplied_helper: SH,
  modal_travelWishlist_location_helper: CH,
  modal_travelWishlist_searchBar_placeholder: EH,
  page_travelWishlist_card_cta: zH,
  page_travelWishlist_card_emailAlerts_helper: jH,
  page_travelWishlist_cta: AH,
  page_travelWishlist_deleted_toast: OH,
  page_travelWishlist_edit_dates_helper: PH,
  page_travelWishlist_edit_description_helper: DH,
  page_travelWishlist_edit_guests_helper: NH,
  page_travelWishlist_error_toast: RH,
  page_travelWishlist_none_body: IH,
  page_travelWishlist_none_subheader: TH,
  page_travelWishlist_pastDates_desc: MH,
  page_travelWishlist_pastDates_title: LH,
  page_travelWishlist_saved_toast: WH,
  page_travelWishlist_updated_toast: BH,
  search_travelWishlist_calendarUpdated_toast: FH,
  search_travelWishlist_saved_toast: VH,
  travelWishlist_faq: UH
}, HH = "Monolocale", GH = "{{count}} camera da letto", KH = "{{count}} camere da letto", JH = "", ZH = "{{count}} letto", YH = "{{count}} letti", XH = "Adulti", QH = "Neonati", e6 = "Il tuo calendario è stato aggiornato.", t6 = "Un mese", a6 = "Date esatte", o6 = "Una settimana", n6 = "", r6 = "", i6 = "", s6 = "", l6 = "Due settimane", c6 = "Annulla", u6 = "Bambini", d6 = "Date", g6 = "Elimina", h6 = "Descrizione", m6 = "Destinazione", p6 = "Fatto!", f6 = "Modifica", b6 = "Qualsiasi tipo di scambio", _6 = "Vasca da bagno", v6 = "Barbecue", y6 = "Bicicletta", w6 = "Automobile", k6 = "Gatto", x6 = "Città", $6 = "Campagna", S6 = "Lavastoviglie", C6 = "Cane", E6 = "Asciugatrice", z6 = "Ascensore", j6 = "Case preferite", A6 = "Camino", O6 = "Appartamento", P6 = "Cortile privato", D6 = "Meno di {{max}} GP", N6 = "da {{min}} GP", R6 = "Tra {{min}} e {{max}} GP", I6 = "Palestra privata", T6 = "Casa", M6 = "Isola o penisola", L6 = "Isolata", W6 = "Idromassaggio", B6 = "Lago", F6 = "Case Collection", V6 = "Montagna", U6 = "{{count}} bagni", q6 = "Altri animali", H6 = "Pianoforte", G6 = "Zona giochi per bambini", K6 = "Prima", J6 = "Scambio reciproco", Z6 = "Ricerca inversa", Y6 = "Fiume", X6 = "Sulla costa", Q6 = "Seconda", eG = "TV", tG = "Paese", aG = "WiFi", oG = "Filtri", nG = "Date esatte", rG = "Un mese in {{date}}", iG = "Un fine settimana in {{date}}", sG = "Una settimana in {{date}}", lG = "Due settimane in {{date}}", cG = "Date flessibili", uG = "Ospiti", dG = "case", gG = "Ultimo minuto", hG = "Posizione", mG = "Modifica", pG = "Nome", fG = "Avanti", bG = "Zero", _G = "Uno", vG = "Altro", yG = "Zero", wG = "Uno", kG = "Altro", xG = "Zero", $G = "Uno", SG = "Altro", CG = "Zero", EG = "Uno", zG = "Altro", jG = "Il formato del numero di telefono non è valido.", AG = "Ricevi avvisi via email", OG = "Salva", PG = "Nessuna posizione trovata", DG = "Vedere di più", NG = "Progetti di viaggio", RG = "", IG = "facoltativo", TG = {
  "autocomplete.button": "Ricerca",
  "autocomplete.placeholder": "Dove stai andando?",
  bedroomsNumbers_zero: HH,
  bedroomsNumbers_one: GH,
  bedroomsNumbers_other: KH,
  beds_zero: JH,
  beds_one: ZH,
  beds_other: YH,
  "button.free-signup": "Iscriviti gratis",
  "button.validate": "Convalida",
  "common.try-again": "Prova ancora",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Non deve superare i {{limit}} caratteri",
  "error.reload": "Aggiorna la pagina",
  "error.return-homepage": "Ritorna alla home page",
  "error.subtitle": "Si è verificato un errore e non è stato possibile caricare questa pagina.",
  "error.title": "Si è verificato un errore nella pagina",
  "errors.unable_to_submit.subtitle": "Errore durante l'invio del modulo. Per favore riprova più tardi.",
  "errors.unable_to_submit.title": "Errore: è impossibile inviare",
  "global.back": "Indietro",
  "global.cancel": "Annulla",
  "global.collection.browsehomes": "Sfoglia le case",
  "global.collection.contactus": "Contattaci",
  "global.confirm": "Conferma",
  "global.continue": "Continua",
  "global.getStarted": "Cominciare",
  "global.login": "Accedi",
  "global.select": "Seleziona",
  global_adults: XH,
  global_babies: QH,
  global_calendarUpdated_toast: e6,
  global_calendar_aMonth: t6,
  global_calendar_exactDates: a6,
  global_calendar_oneWeek: o6,
  global_calendar_oneWeekend: n6,
  global_calendar_plusMinusDay_zero: r6,
  global_calendar_plusMinusDay_one: i6,
  global_calendar_plusMinusDay_other: s6,
  global_calendar_twoWeeks: l6,
  global_cancel: c6,
  global_children: u6,
  global_dates: d6,
  global_delete: g6,
  global_description: h6,
  global_destination: m6,
  global_done: p6,
  global_edit: f6,
  "global_filter_a-c": "Aria condizionata",
  global_filter_available: b6,
  "global_filter_baby-bed": "Lettini per bambini",
  "global_filter_baby-gear": "Attrezzature per neonato",
  "global_filter_balcony-terrace": "Balcone/Terrazza",
  global_filter_bathtub: _6,
  global_filter_bbq: v6,
  global_filter_bicycle: y6,
  global_filter_car: w6,
  global_filter_cat: k6,
  "global_filter_children-welcome": "Bambini benvenuti",
  global_filter_cities: x6,
  "global_filter_cleaning-person": "Donna delle pulizie",
  global_filter_countryside: $6,
  "global_filter_dedicated-workspace": "Spazio di lavoro dedicato",
  "global_filter_disabled-access": "Casa accessibile alle sedie a rotelle",
  global_filter_dishwasher: S6,
  global_filter_dog: C6,
  global_filter_dryer: E6,
  "global_filter_eco-level": "Solo case sostenibili",
  "global_filter_electric-car-plug": "Presa per auto elettrica",
  global_filter_elevator: z6,
  global_filter_favorite: j6,
  global_filter_fireplace: A6,
  global_filter_flat: O6,
  global_filter_garden: P6,
  "global_filter_guest-wanted": "Scambio con GuestPoints",
  global_filter_guestPointsMax: D6,
  global_filter_guestPointsMin: N6,
  global_filter_guestPointsMinMax: R6,
  global_filter_gym: I6,
  "global_filter_heating-system": "Sistema di riscaldamento",
  "global_filter_high-speed-connexion": "Connessione ad alta velocità",
  global_filter_home: T6,
  "global_filter_home-verified": "Case verificate",
  global_filter_island: M6,
  global_filter_isolated: L6,
  global_filter_jacuzzi: W6,
  "global_filter_kids-toys": "Giocattoli per bambini",
  global_filter_lakes: B6,
  global_filter_luxury: F6,
  global_filter_mountains: V6,
  "global_filter_no-bed-up": "Nessun letto temporaneo",
  global_filter_numOfBathrooms: U6,
  global_filter_other: q6,
  "global_filter_parking-space": "Posto auto privato",
  "global_filter_pets-welcome": "Animali domestici ammessi",
  global_filter_piano: H6,
  global_filter_playground: G6,
  global_filter_primary: K6,
  "global_filter_public-transit-access": "Accesso ai trasporti pubblici",
  global_filter_reciprocal: J6,
  "global_filter_response-rate-above-threshold": "Tasso di risposta ≥ Nella media",
  global_filter_reverse: Z6,
  global_filter_river: Y6,
  global_filter_seaside: X6,
  global_filter_secondary: Q6,
  "global_filter_secured-pool": "Piscina protetta",
  "global_filter_smokers-welcome": "I fumatori sono i benvenuti",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: eG,
  global_filter_villages: tG,
  "global_filter_washing-machine": "Lavatrice",
  "global_filter_whole-unit": "L'intera unità",
  global_filter_wifi: aG,
  global_filters: oG,
  global_fixDates: nG,
  global_flexDates_aMonth: rG,
  global_flexDates_aWeekend: iG,
  global_flexDates_oneWeek: sG,
  global_flexDates_twoWeek: lG,
  global_flexibleDates: cG,
  global_guests: uG,
  global_homes: dG,
  global_lastMinute: gG,
  global_location: hG,
  global_modify: mG,
  global_name: pG,
  global_next: fG,
  global_numberOfAdults_zero: bG,
  global_numberOfAdults_one: _G,
  global_numberOfAdults_other: vG,
  global_numberOfBabies_zero: yG,
  global_numberOfBabies_one: wG,
  global_numberOfBabies_other: kG,
  global_numberOfChildren_zero: xG,
  global_numberOfChildren_one: $G,
  global_numberOfChildren_other: SG,
  global_numberOfGuests_zero: CG,
  global_numberOfGuests_one: EG,
  global_numberOfGuests_other: zG,
  global_phoneNumber_notValid: jG,
  global_receiveEmailAlerts: AG,
  global_save: OG,
  global_searchBar_noLocationFound: PG,
  global_seeMore_link: DG,
  global_travelWishlist: NG,
  "modal.error-occured.content": "Ci spiace davvero per l'inconveniente, ti chiediamo di riprovare.",
  "modal.error-occured.title": "Oh no, si è verificato un errore!",
  no_result: RG,
  optional: IG,
  "privacy-policy": "Informativa sulla privacy"
}, MG = "https://www.homeexchange.it/blog/", LG = "/p/homeexchange-condizioni-di-uso", WG = "https://www.homeexchange.it/p/comunita", BG = "https://homeexchangehelp.zendesk.com/hc/it", FG = "", VG = "https://www.homeexchange.it/p/service-homeexchange-it", UG = "https://www.homeexchange.it/p/guestpoints-it", qG = "https://www.homeexchange.it/p/stampa", HG = "https://www.homeexchange.com/p/racconti-homeexchangers", GG = "https://help.homeexchange.com/hc/it/articles/360000623717-Cosa-sono-le-mie-destinazioni-preferite-e-a-cosa-servono", KG = "", JG = "https://www.homeexchange.it/p/la-dove-accoglienza-inizia-davvero", ZG = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.it/p/about-us-it",
  blog: MG,
  cgu: LG,
  community: WG,
  "contact-us": "https://www.homeexchange.it/contattaci-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeIT/",
  faq: BG,
  forum: FG,
  guarantees: VG,
  guestpoints: UG,
  "happiness-team": "https://www.homeexchange.it/p/happiness-team-it",
  "how-it-works": "https://www.homeexchange.it/p/come-funziona-it",
  "join-us": "https://www.homeexchange.it/p/join-us-it",
  "legal-notice": "/p/avviso-legale",
  "mobile-app": "https://www.homeexchange.it/p/app-mobile",
  "our-team": "https://www.homeexchange.it/p/nostro-team",
  press: qG,
  "privacy-policy": "/p/homeexchange-informativa-privacy",
  "subscription-cost": "https://www.homeexchange.it/p/subscription-homeexchange-it",
  "term-of-use": "/p/homeexchange-condizioni-di-uso",
  testimonials: HG,
  travelWishlist_faq_links: GG,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: KG,
  values: JG
}, YG = "Nome", XG = "Cognome", QG = "Aggiungi ai progetti di viaggio", eK = "Una lista dei tuoi progetti di viaggio aggiornata ti consentirà di ricevere più richieste di scambio reciproco.", tK = "Vuoi davvero eliminare {{fullAddress}}?", aK = "Hai selezionato questi filtri. Se hai cambiato idea, puoi eliminarne alcuni qui sotto. Se invece desideri aggiungerne altri, dovrai avviare una nuova ricerca (ma presto non sarà più così... non perderti gli aggiornamenti)!", oK = "Potrebbe trattarsi di un paese, una città o un'intera regione. Se scegli una zona ampia, i risultati potrebbero essere meno accurati.", nK = "Digita un paese, una città o una regione", rK = "Vedi le case disponibili", iK = "Quando le case disponibili corrispondono ai tuoi progetti di viaggio.", sK = "Aggiungi ai progetti di viaggio", lK = "{{fullAddress}} è stato eliminato dai tuoi progetti di viaggio.", cK = "Seleziona le date di viaggio ideali (flessibili o fisse).", uK = "Aggiungi dei dettagli per aiutare gli altri utenti che utilizzano la funzione di ricerca inversa a capire perché ti interessa la loro zona.", dK = "Specifica quante persone viaggeranno con te.", gK = "Ops! {{fullAddress}} non è stato salvato nella lista dei tuoi progetti di viaggio per un motivo imprevisto.", hK = "Facci sapere quando e dove vorresti viaggiare per ricevere richieste di scambio e avvisi non appena saranno disponibili delle case adatte. Salveremo le tue ricerche nella lista dei tuoi progetti di viaggio!", mK = "Ci sono nuove avventure che vorresti iniziare a pianificare?", pK = "<updateDates>Aggiorna le tue date</updateDates> per continuare a ricevere gli avvisi pertinenti via mail oppure <delete>elimina questa destinazione</delete> dalla lista dei tuoi progetti di viaggio se hai cambiato idea.", fK = "Queste date sono già passate", bK = "{{fullAddress}} è stato aggiunto alla lista dei tuoi progetti di viaggio!", _K = "{{fullAddress}} è stato aggiornato correttamente.", vK = "La tua ricerca è stata salvata e il tuo calendario è aggiornato!", yK = "La tua ricerca è stata salvata. La trovi nella lista dei tuoi progetti di viaggio.", wK = "Scopri di più sulle liste per i progetti di viaggio", kK = {
  firstname: YG,
  lastname: XG,
  modal_travelWishlist_addNew_title: QG,
  modal_travelWishlist_delete_body: eK,
  modal_travelWishlist_delete_title: tK,
  modal_travelWishlist_filtersApplied_helper: aK,
  modal_travelWishlist_location_helper: oK,
  modal_travelWishlist_searchBar_placeholder: nK,
  page_travelWishlist_card_cta: rK,
  page_travelWishlist_card_emailAlerts_helper: iK,
  page_travelWishlist_cta: sK,
  page_travelWishlist_deleted_toast: lK,
  page_travelWishlist_edit_dates_helper: cK,
  page_travelWishlist_edit_description_helper: uK,
  page_travelWishlist_edit_guests_helper: dK,
  page_travelWishlist_error_toast: gK,
  page_travelWishlist_none_body: hK,
  page_travelWishlist_none_subheader: mK,
  page_travelWishlist_pastDates_desc: pK,
  page_travelWishlist_pastDates_title: fK,
  page_travelWishlist_saved_toast: bK,
  page_travelWishlist_updated_toast: _K,
  search_travelWishlist_calendarUpdated_toast: vK,
  search_travelWishlist_saved_toast: yK,
  travelWishlist_faq: wK
}, xK = "Studio", $K = "{{count}} soverom", SK = "{{count}} soverom", CK = "", EK = "{{count}} seng", zK = "{{count}} senger", jK = "Voksne", AK = "Babyer", OK = "", PK = "En måned", DK = "Nøyaktige datoer", NK = "Uke", RK = "", IK = "", TK = "", MK = "", LK = "To uker", WK = "", BK = "Barn", FK = "Datoer", VK = "", UK = "Beskrivelse", qK = "Reisemål", HK = "", GK = "", KK = "alle typer boligbytter", JK = "Badekar", ZK = "Grill", YK = "Sykkel", XK = "Bil", QK = "Katt", e5 = "By", t5 = "Landlig", a5 = "Oppvaskmaskin", o5 = "Hund", n5 = "Tørketrommel", r5 = "Heis", i5 = "Favoritthjem", s5 = "Peis", l5 = "Leilighet", c5 = "", u5 = "mindre enn {{max}} GP", d5 = "fra {{min}} GP", g5 = "Mellom {{min}} og {{max}} GP", h5 = "Privat treningsrom", m5 = "Hus", p5 = "Øy", f5 = "Isolert", b5 = "Jacuzzi", _5 = "Innsjøer", v5 = "Collection-hjem", y5 = "Fjell", w5 = "", k5 = "Andre dyr", x5 = "Piano", $5 = "", S5 = "Primær", C5 = "Gjensidig boligbytte", E5 = "Omvendt søk", z5 = "Elv", j5 = "", A5 = "Sekundær", O5 = "TV", P5 = "Landsbygd", D5 = "WiFi", N5 = "Filtrer", R5 = "Nøyaktige datoer", I5 = "", T5 = "", M5 = "", L5 = "", W5 = "Fleksible datoer", B5 = "Gjester", F5 = "", V5 = "Siste øyeblikk", U5 = "Beliggenhet", q5 = "", H5 = "", G5 = "", K5 = "", J5 = "", Z5 = "", Y5 = "", X5 = "", Q5 = "", e9 = "", t9 = "", a9 = "", o9 = "", n9 = "", r9 = "", i9 = "", s9 = "", l9 = "Lagre", c9 = "", u9 = "Se mer", d9 = "Reiseplaner", g9 = "", h9 = "", m9 = {
  "autocomplete.button": "Søk",
  "autocomplete.placeholder": "Hvor skal du ?",
  bedroomsNumbers_zero: xK,
  bedroomsNumbers_one: $K,
  bedroomsNumbers_other: SK,
  beds_zero: CK,
  beds_one: EK,
  beds_other: zK,
  "button.free-signup": "Registrer deg gratis",
  "button.validate": "Bekreft",
  "common.try-again": "",
  "contact-tech-email": "contact@homeexchange.com",
  "error.characters_max_limit": "Kan ikke overstige {{limit}} tegn",
  "error.reload": "Oppdater siden",
  "error.return-homepage": "Gå tilbake til startsiden",
  "error.subtitle": "Denne siden kan dessverre ikke nås.",
  "error.title": "En feil har oppstått på siden",
  "errors.unable_to_submit.subtitle": "Skjemaet ditt kunne dessverre ikke sendes inn akkurat nå. Vennligst prøv igjen senere.",
  "errors.unable_to_submit.title": "Oops, det har oppstått et problem",
  "global.back": "Tilbake",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Fortsett",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_adults: jK,
  global_babies: AK,
  global_calendarUpdated_toast: OK,
  global_calendar_aMonth: PK,
  global_calendar_exactDates: DK,
  global_calendar_oneWeek: NK,
  global_calendar_oneWeekend: RK,
  global_calendar_plusMinusDay_zero: IK,
  global_calendar_plusMinusDay_one: TK,
  global_calendar_plusMinusDay_other: MK,
  global_calendar_twoWeeks: LK,
  global_cancel: WK,
  global_children: BK,
  global_dates: FK,
  global_delete: VK,
  global_description: UK,
  global_destination: qK,
  global_done: HK,
  global_edit: GK,
  "global_filter_a-c": "Klimaanlegg",
  global_filter_available: KK,
  "global_filter_baby-bed": "Sprinkelsenger",
  "global_filter_baby-gear": "Babyutstyr",
  "global_filter_balcony-terrace": "",
  global_filter_bathtub: JK,
  global_filter_bbq: ZK,
  global_filter_bicycle: YK,
  global_filter_car: XK,
  global_filter_cat: QK,
  "global_filter_children-welcome": "Barn velkommen",
  global_filter_cities: e5,
  "global_filter_cleaning-person": "Rengjøringsperson",
  global_filter_countryside: t5,
  "global_filter_dedicated-workspace": "",
  "global_filter_disabled-access": "Tilgjengelig for funksjonshemmede",
  global_filter_dishwasher: a5,
  global_filter_dog: o5,
  global_filter_dryer: n5,
  "global_filter_eco-level": "Bare bærekraftige hjem",
  "global_filter_electric-car-plug": "Elektrisk bilplugg",
  global_filter_elevator: r5,
  global_filter_favorite: i5,
  global_filter_fireplace: s5,
  global_filter_flat: l5,
  global_filter_garden: c5,
  "global_filter_guest-wanted": "Boligbytte med GuestPoints",
  global_filter_guestPointsMax: u5,
  global_filter_guestPointsMin: d5,
  global_filter_guestPointsMinMax: g5,
  global_filter_gym: h5,
  "global_filter_heating-system": "Oppvarming",
  "global_filter_high-speed-connexion": "Høyhastighets tilkobling",
  global_filter_home: m5,
  "global_filter_home-verified": "Verifiserte hjem",
  global_filter_island: p5,
  global_filter_isolated: f5,
  global_filter_jacuzzi: b5,
  "global_filter_kids-toys": "Barneleker",
  global_filter_lakes: _5,
  global_filter_luxury: v5,
  global_filter_mountains: y5,
  "global_filter_no-bed-up": "",
  global_filter_numOfBathrooms: w5,
  global_filter_other: k5,
  "global_filter_parking-space": "Privat parkering",
  "global_filter_pets-welcome": "Kjæledyr velkommen",
  global_filter_piano: x5,
  global_filter_playground: $5,
  global_filter_primary: S5,
  "global_filter_public-transit-access": "Tilgang til offentlig transport",
  global_filter_reciprocal: C5,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: E5,
  global_filter_river: z5,
  global_filter_seaside: j5,
  global_filter_secondary: A5,
  "global_filter_secured-pool": "Sikret badebasseng",
  "global_filter_smokers-welcome": "Røykere velkommen",
  "global_filter_swimming-pool": "Svømmebasseng",
  global_filter_tv: O5,
  global_filter_villages: P5,
  "global_filter_washing-machine": "Vaskemaskin",
  "global_filter_whole-unit": "Hele boligen",
  global_filter_wifi: D5,
  global_filters: N5,
  global_fixDates: R5,
  global_flexDates_aMonth: I5,
  global_flexDates_aWeekend: T5,
  global_flexDates_oneWeek: M5,
  global_flexDates_twoWeek: L5,
  global_flexibleDates: W5,
  global_guests: B5,
  global_homes: F5,
  global_lastMinute: V5,
  global_location: U5,
  global_modify: q5,
  global_name: H5,
  global_next: G5,
  global_numberOfAdults_zero: K5,
  global_numberOfAdults_one: J5,
  global_numberOfAdults_other: Z5,
  global_numberOfBabies_zero: Y5,
  global_numberOfBabies_one: X5,
  global_numberOfBabies_other: Q5,
  global_numberOfChildren_zero: e9,
  global_numberOfChildren_one: t9,
  global_numberOfChildren_other: a9,
  global_numberOfGuests_zero: o9,
  global_numberOfGuests_one: n9,
  global_numberOfGuests_other: r9,
  global_phoneNumber_notValid: i9,
  global_receiveEmailAlerts: s9,
  global_save: l9,
  global_searchBar_noLocationFound: c9,
  global_seeMore_link: u9,
  global_travelWishlist: d9,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: g9,
  optional: h9,
  "privacy-policy": "Personvernpolicy"
}, p9 = "https://www.homeexchange.com/blog/", f9 = "/p/general-terms-of-use", b9 = "https://www.homeexchange.com/nb/p/nettverk", _9 = "https://homeexchangehelp.zendesk.com/hc/pt", v9 = "", y9 = "https://www.homeexchange.com/nb/p/service-homeexchange-no", w9 = "https://www.homeexchange.com/nb/p/guestpoints-no", k9 = "https://www.homeexchange.com/nb/p/press-no", x9 = "https://www.homeexchange.com/p/ifolge-homeexchangers", $9 = "", S9 = "", C9 = "https://www.homeexchange.com/nb/p/der-velkomsten-virkelig-starter", E9 = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/nb/p/about-us-no",
  blog: p9,
  cgu: f9,
  community: b9,
  "contact-us": "https://www.homeexchange.com/nb/p/kontact-oss-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: _9,
  forum: v9,
  guarantees: y9,
  guestpoints: w9,
  "happiness-team": "https://www.homeexchange.com/nb/p/happiness-team-no",
  "how-it-works": "https://www.homeexchange.com/nb/p/hvordan-fungerer-det-no",
  "join-us": "https://www.homeexchange.com/nb/p/join-us-no",
  "legal-notice": "/p/legal-notice-no",
  "mobile-app": "https://www.homeexchange.com/nb/p/mobile-app",
  "our-team": "https://www.homeexchange.com/nb/p/teamet-vart",
  press: k9,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/nb/p/subscription-homeexchange-no",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: x9,
  travelWishlist_faq_links: $9,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: S9,
  values: C9
}, z9 = "Fornavn", j9 = "Etternavn", A9 = "", O9 = "", P9 = "", D9 = "", N9 = "", R9 = "", I9 = "Se tilgjengelige hjem", T9 = "", M9 = "", L9 = "", W9 = "", B9 = "", F9 = "", V9 = "", U9 = "", q9 = "", H9 = "", G9 = "", K9 = "", J9 = "", Z9 = "", Y9 = "", X9 = "", Q9 = {
  firstname: z9,
  lastname: j9,
  modal_travelWishlist_addNew_title: A9,
  modal_travelWishlist_delete_body: O9,
  modal_travelWishlist_delete_title: P9,
  modal_travelWishlist_filtersApplied_helper: D9,
  modal_travelWishlist_location_helper: N9,
  modal_travelWishlist_searchBar_placeholder: R9,
  page_travelWishlist_card_cta: I9,
  page_travelWishlist_card_emailAlerts_helper: T9,
  page_travelWishlist_cta: M9,
  page_travelWishlist_deleted_toast: L9,
  page_travelWishlist_edit_dates_helper: W9,
  page_travelWishlist_edit_description_helper: B9,
  page_travelWishlist_edit_guests_helper: F9,
  page_travelWishlist_error_toast: V9,
  page_travelWishlist_none_body: U9,
  page_travelWishlist_none_subheader: q9,
  page_travelWishlist_pastDates_desc: H9,
  page_travelWishlist_pastDates_title: G9,
  page_travelWishlist_saved_toast: K9,
  page_travelWishlist_updated_toast: J9,
  search_travelWishlist_calendarUpdated_toast: Z9,
  search_travelWishlist_saved_toast: Y9,
  travelWishlist_faq: X9
}, e8 = "Studio", t8 = "{{count}} slaapkamer", a8 = "{{count}} slaapkamers", o8 = "", n8 = "{{count}} bed", r8 = "{{count}} bedden", i8 = "Volwassenen", s8 = "Baby's", l8 = "Je kalender is bijgewerkt.", c8 = "Een maand", u8 = "Exacte data", d8 = "Een week", g8 = "Een weekend", h8 = "", m8 = "± {{count}} dag", p8 = "± {{count}} dagen", f8 = "Twee weken", b8 = "Annuleren", _8 = "Kinderen", v8 = "Data", y8 = "Verwijderen", w8 = "Beschrijving", k8 = "Bestemming", x8 = "Klaar!", $8 = "Bewerken", S8 = "Elk type ruil", C8 = "Bad", E8 = "BBQ", z8 = "Fiets", j8 = "Auto", A8 = "Kat", O8 = "De stad", P8 = "Het platteland", D8 = "Vaatwasmachine", N8 = "Hond", R8 = "Droger", I8 = "Lift", T8 = "Favoriete huizen", M8 = "Open haard", L8 = "Appartement", W8 = "Privétuin", B8 = "Minder dan {{max}} GP", F8 = "vanaf {{min}} GP", V8 = "Tussen {{min}} en {{max}} GP", U8 = "Privésportzaal", q8 = "Huis", H8 = "Een eiland", G8 = "Geïsoleerd", K8 = "Jacuzzi", J8 = "Een meer", Z8 = "Collection-huizen", Y8 = "De bergen", X8 = "{{count}} badkamers", Q8 = "Andere dieren", e7 = "", t7 = "Speeltuin", a7 = "Eerste", o7 = "Wederzijdse huizenruil", n7 = "Omgekeerd zoeken", r7 = "Rivier", i7 = "Kust", s7 = "Vakantiehuis", l7 = "TV", c7 = "Dorp", u7 = "WiFi", d7 = "Filters", g7 = "Vaste data", h7 = "Een maand in {{date}}", m7 = "Een weekend in {{date}}", p7 = "Een week in {{date}}", f7 = "Twee weken in {{date}}", b7 = "Flexibele data", _7 = "Gasten", v7 = "huizen", y7 = "Last minute", w7 = "Locatie", k7 = "Wijzigen", x7 = "Naam", $7 = "Volgende", S7 = "", C7 = "{{count}} volwassene", E7 = "{{count}} volwassenen", z7 = "", j7 = "{{count}} baby", A7 = "{{count}} baby's", O7 = "", P7 = "{{count}} kind", D7 = "{{count}} kinderen", N7 = "", R7 = "{{count}} gast", I7 = "{{count}} gasten", T7 = "De indeling van het telefoonnummer is niet geldig.", M7 = "E-mailmeldingen ontvangen", L7 = "Opslaan", W7 = "Geen locaties gevonden", B7 = "Bekijk meer", F7 = "Reisplannen", V7 = "Geen resultaat", U7 = "optioneel", q7 = {
  "autocomplete.button": "Zoeken",
  "autocomplete.placeholder": "Waar ga je naar toe ?",
  bedroomsNumbers_zero: e8,
  bedroomsNumbers_one: t8,
  bedroomsNumbers_other: a8,
  beds_zero: o8,
  beds_one: n8,
  beds_other: r8,
  "button.free-signup": "Meld je gratis aan",
  "button.validate": "Bevestigen",
  "common.try-again": "Opnieuw proberen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Mag de {{limit}} karakters niet overschrijden",
  "error.reload": "Deze pagina vernieuwen ",
  "error.return-homepage": "Terug naar de startpagina",
  "error.subtitle": "Helaas kon deze pagina niet gevonden worden.",
  "error.title": "Er is een fout opgetreden op de pagina",
  "errors.unable_to_submit.subtitle": "Helaas kon het formulier niet verzonden worden. Probeer het later nog eens.",
  "errors.unable_to_submit.title": "Oeps... het is niet gelukt om het formulier te verzenden.",
  "global.back": "Terug",
  "global.cancel": "Annuleren",
  "global.collection.browsehomes": "Blader door huizen",
  "global.collection.contactus": "Neem contact met ons op",
  "global.confirm": "Bevestigen",
  "global.continue": "Doorgaan",
  "global.getStarted": "Ga van start",
  "global.login": "Inloggen",
  "global.select": "Selecteren",
  global_adults: i8,
  global_babies: s8,
  global_calendarUpdated_toast: l8,
  global_calendar_aMonth: c8,
  global_calendar_exactDates: u8,
  global_calendar_oneWeek: d8,
  global_calendar_oneWeekend: g8,
  global_calendar_plusMinusDay_zero: h8,
  global_calendar_plusMinusDay_one: m8,
  global_calendar_plusMinusDay_other: p8,
  global_calendar_twoWeeks: f8,
  global_cancel: b8,
  global_children: _8,
  global_dates: v8,
  global_delete: y8,
  global_description: w8,
  global_destination: k8,
  global_done: x8,
  global_edit: $8,
  "global_filter_a-c": "Airco",
  global_filter_available: S8,
  "global_filter_baby-bed": "Babybedden",
  "global_filter_baby-gear": "Baby spullen",
  "global_filter_balcony-terrace": "",
  global_filter_bathtub: C8,
  global_filter_bbq: E8,
  global_filter_bicycle: z8,
  global_filter_car: j8,
  global_filter_cat: A8,
  "global_filter_children-welcome": "Kinderen welkom",
  global_filter_cities: O8,
  "global_filter_cleaning-person": "Schoonmaakster",
  global_filter_countryside: P8,
  "global_filter_dedicated-workspace": "Toegewijde werkruimte",
  "global_filter_disabled-access": "Toegankelijke woning",
  global_filter_dishwasher: D8,
  global_filter_dog: N8,
  global_filter_dryer: R8,
  "global_filter_eco-level": "Alleen duurzame woningen",
  "global_filter_electric-car-plug": "Elektrische auto stekker",
  global_filter_elevator: I8,
  global_filter_favorite: T8,
  global_filter_fireplace: M8,
  global_filter_flat: L8,
  global_filter_garden: W8,
  "global_filter_guest-wanted": "Ruil tegen GuestPoints",
  global_filter_guestPointsMax: B8,
  global_filter_guestPointsMin: F8,
  global_filter_guestPointsMinMax: V8,
  global_filter_gym: U8,
  "global_filter_heating-system": "Verwarming",
  "global_filter_high-speed-connexion": "Snelle verbinding",
  global_filter_home: q8,
  "global_filter_home-verified": "Geverifieerde huizen",
  global_filter_island: H8,
  global_filter_isolated: G8,
  global_filter_jacuzzi: K8,
  "global_filter_kids-toys": "Kinderen speelgoed",
  global_filter_lakes: J8,
  global_filter_luxury: Z8,
  global_filter_mountains: Y8,
  "global_filter_no-bed-up": "Geen tijdelijke bedden",
  global_filter_numOfBathrooms: X8,
  global_filter_other: Q8,
  "global_filter_parking-space": "Privé parkeerplaats",
  "global_filter_pets-welcome": "Huisdieren toegestaan ",
  global_filter_piano: e7,
  global_filter_playground: t7,
  global_filter_primary: a7,
  "global_filter_public-transit-access": "Toegang tot het openbaar vervoer",
  global_filter_reciprocal: o7,
  "global_filter_response-rate-above-threshold": "Responspercentage ≥ Gemiddeld",
  global_filter_reverse: n7,
  global_filter_river: r7,
  global_filter_seaside: i7,
  global_filter_secondary: s7,
  "global_filter_secured-pool": "Beveiligd zwembad",
  "global_filter_smokers-welcome": "Roken toegestaan ",
  "global_filter_swimming-pool": "Zwembad",
  global_filter_tv: l7,
  global_filter_villages: c7,
  "global_filter_washing-machine": "Wasmachine",
  "global_filter_whole-unit": "De hele woning",
  global_filter_wifi: u7,
  global_filters: d7,
  global_fixDates: g7,
  global_flexDates_aMonth: h7,
  global_flexDates_aWeekend: m7,
  global_flexDates_oneWeek: p7,
  global_flexDates_twoWeek: f7,
  global_flexibleDates: b7,
  global_guests: _7,
  global_homes: v7,
  global_lastMinute: y7,
  global_location: w7,
  global_modify: k7,
  global_name: x7,
  global_next: $7,
  global_numberOfAdults_zero: S7,
  global_numberOfAdults_one: C7,
  global_numberOfAdults_other: E7,
  global_numberOfBabies_zero: z7,
  global_numberOfBabies_one: j7,
  global_numberOfBabies_other: A7,
  global_numberOfChildren_zero: O7,
  global_numberOfChildren_one: P7,
  global_numberOfChildren_other: D7,
  global_numberOfGuests_zero: N7,
  global_numberOfGuests_one: R7,
  global_numberOfGuests_other: I7,
  global_phoneNumber_notValid: T7,
  global_receiveEmailAlerts: M7,
  global_save: L7,
  global_searchBar_noLocationFound: W7,
  global_seeMore_link: B7,
  global_travelWishlist: F7,
  "modal.error-occured.content": "Onze excuses voor het ongemak, probeer het alsjeblieft opnieuw.",
  "modal.error-occured.title": "Oh nee, er is een fout opgetreden!",
  no_result: V7,
  optional: U7,
  "privacy-policy": "Privacy"
}, H7 = "https://www.homeexchange.com/nl/blog/", G7 = "/nl/p/homeexchangegebruiksvoorwaarden", K7 = "https://www.homeexchange.com/nl/p/gemeenschap", J7 = "https://homeexchangehelp.zendesk.com/hc/en-us", Z7 = "https://forum.homeexchange.com/c/english/20", Y7 = "https://www.homeexchange.com/nl/p/service-homeexchange-nl", X7 = "https://www.homeexchange.com/nl/p/guestpoints-nl", Q7 = "https://www.homeexchange.com/nl/p/pers", eJ = "https://www.homeexchange.com/p/wordsonhomeexchange", tJ = "https://help.homeexchange.com/hc/nl/articles/360000623717-Wat-zijn-Mijn-voorkeursbestemmingen-en-hoe-gebruik-ik-ze", aJ = "https://www.homeexchange.com/nl/p/where-the-welcome-really-begins", oJ = "https://www.guesttoguest.com/nl/p/waar-het-welkom-echt-begint", nJ = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/nl/p/about-us-nl",
  blog: H7,
  cgu: G7,
  community: K7,
  "contact-us": "https://www.homeexchange.com/nl/contact-op-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: J7,
  forum: Z7,
  guarantees: Y7,
  guestpoints: X7,
  "happiness-team": "https://www.homeexchange.com/nl/p/happiness-team-nl",
  "how-it-works": "https://www.homeexchange.com/nl/p/hoe-werkt-het-nl",
  "join-us": "https://www.homeexchange.com/nl/p/join-us-nl",
  "legal-notice": "/p/wettelijke-vermeldingen",
  "mobile-app": "https://www.homeexchange.com/nl/p/mobiele-app",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: Q7,
  "privacy-policy": "/p/homeexchange-privacy",
  "subscription-cost": "https://www.homeexchange.com/nl/p/subscription-homeexchange-nl",
  "term-of-use": "/p/homeexchangegebruiksvoorwaarden",
  testimonials: eJ,
  travelWishlist_faq_links: tJ,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: aJ,
  values: oJ
}, rJ = "Voornaam", iJ = "Achternaam", sJ = "Een nieuw reisplan toevoegen", lJ = "Met bijgewerkte reisplannen kun je meer wederzijdse uitwisselingsverzoeken ontvangen.", cJ = "Weet je zeker dat je {{fullAddress}} wilt verwijderen?", uJ = "Dit zijn de filters die je hebt geselecteerd. Als je van gedachten bent veranderd, kun je er hieronder een paar verwijderen. Maar als je extra filters wilt toevoegen, moet je een nieuwe zoekopdracht starten (dit zal binnenkort veranderen...hou het in de gaten)!", dJ = "Dit kan een land, stad of een hele regio zijn. Als je een brede locatie kiest, zijn je resultaten mogelijk minder nauwkeurig.", gJ = "Typ een land, stad of regio", hJ = "Bekijk beschikbare huizen", mJ = "Als er beschikbare huizen zijn die overeenkomen met je reisplannen.", pJ = "Een nieuw reisplan toevoegen", fJ = "{{fullAddress}} is verwijderd uit je reisplannen.", bJ = "Selecteer je ideale reisdata (flexibel of vast).", _J = "Voeg details toe zodat anderen die de omgekeerde zoekfunctie gebruiken kunnen zien waarom je geïnteresseerd bent in hun locatie.", vJ = "Geef aan hoeveel mensen met je meereizen voor deze reis.", yJ = "Oeps! {{fullAddress}} kon om een onverwachte reden niet worden opgeslagen in je reisplannen.", wJ = "Laat ons weten wanneer en waar je naartoe wilt reizen en ontvang uitwisselingsverzoeken en meldingen zodra er geschikte huizen beschikbaar zijn. We slaan je zoekopdrachten op in je reisplannen!", kJ = "Zijn er nog reisavonturen die je wilt plannen?", xJ = "<updateDates>Werk je data</updateDates> bij om relevante e-mailmeldingen te blijven ontvangen of <delete>verwijder deze bestemming</delete> uit je reisplannen als je het niet langer overweegt.", $J = "Deze data liggen in het verleden", SJ = "{{fullAddress}} is toegevoegd aan je reisplannen!", CJ = "{{fullAddress}} is succesvol bijgewerkt.", EJ = "Je zoekopdracht is opgeslagen en je kalender is bijgewerkt!", zJ = "Je zoekopdracht is opgeslagen. Je vindt hem in je reisplannen.", jJ = "Meer informatie over reisplannen", AJ = {
  firstname: rJ,
  lastname: iJ,
  modal_travelWishlist_addNew_title: sJ,
  modal_travelWishlist_delete_body: lJ,
  modal_travelWishlist_delete_title: cJ,
  modal_travelWishlist_filtersApplied_helper: uJ,
  modal_travelWishlist_location_helper: dJ,
  modal_travelWishlist_searchBar_placeholder: gJ,
  page_travelWishlist_card_cta: hJ,
  page_travelWishlist_card_emailAlerts_helper: mJ,
  page_travelWishlist_cta: pJ,
  page_travelWishlist_deleted_toast: fJ,
  page_travelWishlist_edit_dates_helper: bJ,
  page_travelWishlist_edit_description_helper: _J,
  page_travelWishlist_edit_guests_helper: vJ,
  page_travelWishlist_error_toast: yJ,
  page_travelWishlist_none_body: wJ,
  page_travelWishlist_none_subheader: kJ,
  page_travelWishlist_pastDates_desc: xJ,
  page_travelWishlist_pastDates_title: $J,
  page_travelWishlist_saved_toast: SJ,
  page_travelWishlist_updated_toast: CJ,
  search_travelWishlist_calendarUpdated_toast: EJ,
  search_travelWishlist_saved_toast: zJ,
  travelWishlist_faq: jJ
}, OJ = "Studio", PJ = "{{count}} quarto", DJ = "{{count}} quartos", NJ = "", RJ = "{{count}} cama", IJ = "{{count}} camas", TJ = "", MJ = "", LJ = "O seu calendário foi atualizado.", WJ = "Um mês", BJ = "Datas exatas", FJ = "Uma semana", VJ = "Um fim de semana", UJ = "", qJ = "± {{count}} dia", HJ = "± {{count]] dias", GJ = "Duas semanas", KJ = "Cancelar", JJ = "", ZJ = "Datas", YJ = "Eliminar", XJ = "Descrição", QJ = "Destino", eZ = "Feito!", tZ = "Editar", aZ = "Qualquer tipo de pedido de Troca", oZ = "Banheiro", nZ = "BBQ", rZ = "Bicicleta", iZ = "Carro", sZ = "Gato", lZ = "Cidade", cZ = "Campo", uZ = "Lavadora de louças", dZ = "Cão", gZ = "Secadora", hZ = "Elevador", mZ = "Casas favoritas", pZ = "Lareira", fZ = "Apartamento", bZ = "Quintal privado", _Z = "", vZ = "", yZ = "", wZ = "", kZ = "Casa", xZ = "Ilha", $Z = "Isolada", SZ = "Jacuzzi", CZ = "Lagos", EZ = "Casas Collection", zZ = "", jZ = "{{count}} casas de banho", AZ = "Outros animais", OZ = "Piano", PZ = "Parque infantil", DZ = "Principal", NZ = "Troca Reciproca", RZ = "Busca invertida", IZ = "Rio", TZ = "Litoral", MZ = "Secundária", LZ = "TV", WZ = "Aldeia", BZ = "WiFi", FZ = "Filtros", VZ = "Datas fixas", UZ = "Um mês em {{date}}", qZ = "Um fim de semana em {{date}}", HZ = "Uma semana em {{date}}", GZ = "Duas semanas em {{date}}", KZ = "Datas flexíveis", JZ = "Convidados", ZZ = "casas", YZ = "Última hora", XZ = "Localização", QZ = "Modificar", eY = "Nome", tY = "Seguinte", aY = "", oY = "{{count}} adulto", nY = "{{count}} adultos", rY = "", iY = "{{count}} bebé", sY = "{{count}} bebés", lY = "", cY = "{{count}} criança", uY = "{{count}} crianças", dY = "", gY = "{{count}} convidado", hY = "{{count}} convidados", mY = "O formato do número de telefone não é válido.", pY = "Receber alertas por e-mail", fY = "Guardar", bY = "Não foram encontradas localizações", _Y = "Ver mais", vY = "Ideias de viagens", yY = "", wY = "", kY = {
  "autocomplete.button": "Procurar",
  "autocomplete.placeholder": "Para onde vai ?",
  bedroomsNumbers_zero: OJ,
  bedroomsNumbers_one: PJ,
  bedroomsNumbers_other: DJ,
  beds_zero: NJ,
  beds_one: RJ,
  beds_other: IJ,
  "button.free-signup": "Filie-se gratuitamente",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "",
  "error.characters_max_limit": "Não deve ser superior a {{limit}} caracteres",
  "error.reload": "Atualizar esta página",
  "error.return-homepage": "Voltar à página inicial",
  "error.subtitle": "Infelizmente, não foi possível aceder a esta página.",
  "error.title": "Ocorreu um erro na página",
  "errors.unable_to_submit.subtitle": "Infelizmente, não foi possível submeter o formulário. Tente novamente mais tarde.",
  "errors.unable_to_submit.title": "Ups, ocorreu um problema!",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_adults: TJ,
  global_babies: MJ,
  global_calendarUpdated_toast: LJ,
  global_calendar_aMonth: WJ,
  global_calendar_exactDates: BJ,
  global_calendar_oneWeek: FJ,
  global_calendar_oneWeekend: VJ,
  global_calendar_plusMinusDay_zero: UJ,
  global_calendar_plusMinusDay_one: qJ,
  global_calendar_plusMinusDay_other: HJ,
  global_calendar_twoWeeks: GJ,
  global_cancel: KJ,
  global_children: JJ,
  global_dates: ZJ,
  global_delete: YJ,
  global_description: XJ,
  global_destination: QJ,
  global_done: eZ,
  global_edit: tZ,
  "global_filter_a-c": "A/C",
  global_filter_available: aZ,
  "global_filter_baby-bed": "",
  "global_filter_baby-gear": "Equipamento para bebês",
  "global_filter_balcony-terrace": "Varanda/Terraço",
  global_filter_bathtub: oZ,
  global_filter_bbq: nZ,
  global_filter_bicycle: rZ,
  global_filter_car: iZ,
  global_filter_cat: sZ,
  "global_filter_children-welcome": "Crianças bem vindas",
  global_filter_cities: lZ,
  "global_filter_cleaning-person": "Faxineiro",
  global_filter_countryside: cZ,
  "global_filter_dedicated-workspace": "Espaço de trabalho dedicado",
  "global_filter_disabled-access": "Casa acessível",
  global_filter_dishwasher: uZ,
  global_filter_dog: dZ,
  global_filter_dryer: gZ,
  "global_filter_eco-level": "Só casas sustentáveis",
  "global_filter_electric-car-plug": "Tomada para carro elétrico",
  global_filter_elevator: hZ,
  global_filter_favorite: mZ,
  global_filter_fireplace: pZ,
  global_filter_flat: fZ,
  global_filter_garden: bZ,
  "global_filter_guest-wanted": "Troca por GuestPoints",
  global_filter_guestPointsMax: _Z,
  global_filter_guestPointsMin: vZ,
  global_filter_guestPointsMinMax: yZ,
  global_filter_gym: wZ,
  "global_filter_heating-system": "Sistema de aquecimento",
  "global_filter_high-speed-connexion": "Wi-fi de alta velocidade",
  global_filter_home: kZ,
  "global_filter_home-verified": "Casas verificadas",
  global_filter_island: xZ,
  global_filter_isolated: $Z,
  global_filter_jacuzzi: SZ,
  "global_filter_kids-toys": "",
  global_filter_lakes: CZ,
  global_filter_luxury: EZ,
  global_filter_mountains: zZ,
  "global_filter_no-bed-up": "Sem camas temporárias",
  global_filter_numOfBathrooms: jZ,
  global_filter_other: AZ,
  "global_filter_parking-space": "",
  "global_filter_pets-welcome": "Animais de estimação bem-vindos",
  global_filter_piano: OZ,
  global_filter_playground: PZ,
  global_filter_primary: DZ,
  "global_filter_public-transit-access": "",
  global_filter_reciprocal: NZ,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: RZ,
  global_filter_river: IZ,
  global_filter_seaside: TZ,
  global_filter_secondary: MZ,
  "global_filter_secured-pool": "Piscina protegida",
  "global_filter_smokers-welcome": "Fumantes bem-vindos",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: LZ,
  global_filter_villages: WZ,
  "global_filter_washing-machine": "Máquina de lavar",
  "global_filter_whole-unit": "",
  global_filter_wifi: BZ,
  global_filters: FZ,
  global_fixDates: VZ,
  global_flexDates_aMonth: UZ,
  global_flexDates_aWeekend: qZ,
  global_flexDates_oneWeek: HZ,
  global_flexDates_twoWeek: GZ,
  global_flexibleDates: KZ,
  global_guests: JZ,
  global_homes: ZZ,
  global_lastMinute: YZ,
  global_location: XZ,
  global_modify: QZ,
  global_name: eY,
  global_next: tY,
  global_numberOfAdults_zero: aY,
  global_numberOfAdults_one: oY,
  global_numberOfAdults_other: nY,
  global_numberOfBabies_zero: rY,
  global_numberOfBabies_one: iY,
  global_numberOfBabies_other: sY,
  global_numberOfChildren_zero: lY,
  global_numberOfChildren_one: cY,
  global_numberOfChildren_other: uY,
  global_numberOfGuests_zero: dY,
  global_numberOfGuests_one: gY,
  global_numberOfGuests_other: hY,
  global_phoneNumber_notValid: mY,
  global_receiveEmailAlerts: pY,
  global_save: fY,
  global_searchBar_noLocationFound: bY,
  global_seeMore_link: _Y,
  global_travelWishlist: vY,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: yY,
  optional: wY,
  "privacy-policy": "Privacidade"
}, xY = "https://www.homeexchange.com/pt/blog/", $Y = "/p/general-terms-of-use", SY = "https://www.homeexchange.com/pt/p/a-nossa-comunidade-pt", CY = "https://homeexchangehelp.zendesk.com/hc/en-us", EY = "", zY = "https://www.homeexchange.com/pt/p/service-homeexchange-pt", jY = "https://www.homeexchange.com/pt/p/os-guestpoints", AY = "https://www.homeexchange.com/pt/p/press-pt", OY = "https://www.homeexchange.com/p/palavras-de-homeexchangers", PY = "", DY = "", NY = "https://www.homeexchange.com/pt/p/onde-as-boas-vindas-comecam", RY = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/pt/p/about-us-pt",
  blog: xY,
  cgu: $Y,
  community: SY,
  "contact-us": "https://www.homeexchange.com/pt/contactos-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: CY,
  forum: EY,
  guarantees: zY,
  guestpoints: jY,
  "happiness-team": "https://www.homeexchange.com/pt/p/happiness-team-pt",
  "how-it-works": "https://www.homeexchange.com/pt/p/como-funciona-homeexchange",
  "join-us": "https://www.homeexchange.com/pt/p/join-us-pt",
  "legal-notice": "/p/mencoes-legais",
  "mobile-app": "https://www.homeexchange.com/pt/p/app-homeexchange",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: AY,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/pt/p/subscription-homeexchange-pt",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: OY,
  travelWishlist_faq_links: PY,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: DY,
  values: NY
}, IY = "", TY = "", MY = "Criar nova ideia de viagem", LY = "As ideias de viagens atualizadas permitem-lhe receber mais pedidos de trocas recíprocas.", WY = "Tem a certeza de que pretende eliminar {{fullAddress}}?", BY = "Estes são os filtros que selecionou. Se tiver mudado de ideias, pode eliminar alguns deles abaixo. Contudo, se quiser adicionar outros filtros, terá de iniciar uma nova pesquisa (contudo, isto será alterado em breve... mantenha-se a par)!", FY = "Pode ser um país, cidade ou região. Se optar por uma localização mais ampla, os resultados podem ser menos precisos.", VY = "Escreva um país, cidade ou região", UY = "Ver casas disponíveis", qY = "Quando existirem casas com disponibilidade correspondentes aos seus planos de viagem.", HY = "Criar nova ideia de viagem", GY = "{{fullAddress}} foi eliminada das suas ideias de viagens.", KY = "Selecione as suas datas de viagem ideais (flexíveis ou fixas).", JY = "Adicione detalhes, para ajudar as pessoas que utilizam a funcionalidade de busca invertida a perceber porque tem interesse na respetiva região.", ZY = "Especifique quantas pessoas vão viajar consigo.", YY = "Ups! Não foi possível guardar {{fullAddress}} nas suas ideias de viagens devido a um motivo inesperado.", XY = "Diga-nos para onde e quando quer viajar para receber pedidos de troca e alertas quando se tornarem disponíveis casas correspondentes. Vamos guardar estas pesquisas nas suas ideias de viagens!", QY = "Existem aventuras de viagens que queira começar a planear?", eX = "<updateDates>Atualize as datas</updateDates> para continuar a receber alertas relevantes por e-mail ou <delete>elimine este destino</delete> das suas ideias de viagens se já não está a considerá-lo.", tX = "Estas datas já passaram", aX = "{{fullAddress}} foi adicionada às suas ideias de viagens!", oX = "{{fullAddress}} foi atualizada com sucesso.", nX = "A sua pesquisa foi guardada e o calendário foi atualizado!", rX = "A sua pesquisa foi guardada. Encontre-a nas suas ideias de viagens.", iX = "Saiba mais sobre as ideias de viagens", sX = {
  firstname: IY,
  lastname: TY,
  modal_travelWishlist_addNew_title: MY,
  modal_travelWishlist_delete_body: LY,
  modal_travelWishlist_delete_title: WY,
  modal_travelWishlist_filtersApplied_helper: BY,
  modal_travelWishlist_location_helper: FY,
  modal_travelWishlist_searchBar_placeholder: VY,
  page_travelWishlist_card_cta: UY,
  page_travelWishlist_card_emailAlerts_helper: qY,
  page_travelWishlist_cta: HY,
  page_travelWishlist_deleted_toast: GY,
  page_travelWishlist_edit_dates_helper: KY,
  page_travelWishlist_edit_description_helper: JY,
  page_travelWishlist_edit_guests_helper: ZY,
  page_travelWishlist_error_toast: YY,
  page_travelWishlist_none_body: XY,
  page_travelWishlist_none_subheader: QY,
  page_travelWishlist_pastDates_desc: eX,
  page_travelWishlist_pastDates_title: tX,
  page_travelWishlist_saved_toast: aX,
  page_travelWishlist_updated_toast: oX,
  search_travelWishlist_calendarUpdated_toast: nX,
  search_travelWishlist_saved_toast: rX,
  travelWishlist_faq: iX
}, lX = "Studio", cX = "{{count}} sovrum", uX = "{{count}} sovrum", dX = "", gX = "{{count}} säng", hX = "{{count}} sängar", mX = "Vuxna", pX = "Småbarn", fX = "Din kalender har uppdaterats.", bX = "En månad", _X = "Exakta datum", vX = "En vecka", yX = "En helg", wX = "", kX = "± {{count}} dag", xX = "± {{count}} dagar", $X = "Två veckor", SX = "Avbryt", CX = "Barn", EX = "Datum", zX = "Ta bort", jX = "Beskrivning", AX = "Resmål", OX = "Klart!", PX = "Ändra", DX = "Alla typer av hembyten", NX = "Badkar", RX = "Grill", IX = "Cykel", TX = "Bil", MX = "Katt", LX = "Stad", WX = "Landsbygd", BX = "Diskmaskin", FX = "Hund", VX = "Torktumlare", UX = "Hiss", qX = "Favorithem", HX = "Eldstad", GX = "Lägenhet", KX = "Privat trädgård", JX = "Mindre än {{max}} GP", ZX = "från {{min}} GP", YX = "Mellan {{min}} och {{max}} GuestPoints", XX = "Hemmagym", QX = "Hus", eQ = "Ö", tQ = "Isolerat", aQ = "Jacuzzi", oQ = "Sjö", nQ = "Collection-hem", rQ = "Berg", iQ = "{{count}} badrum", sQ = "Andra djur", lQ = "Piano", cQ = "Lekplats för barn", uQ = "Primärt", dQ = "Ömsesidigt hembyte", gQ = "Omvänd sökning", hQ = "Älv", mQ = "Kustnära", pQ = "Sekundärt", fQ = "TV", bQ = "By", _Q = "WiFi", vQ = "Filter", yQ = "Fasta datum", wQ = "En månad i {{date}}", kQ = "En helg i {{date}}", xQ = "En vecka i {{date}}", $Q = "Två veckor i {{date}}", SQ = "Flexibla datum", CQ = "Gäster", EQ = "hem", zQ = "Sista minuten", jQ = "Plats", AQ = "Ändra", OQ = "Namn", PQ = "Nästa", DQ = "", NQ = "{{count}} vuxen", RQ = "{{count}} vuxna", IQ = "", TQ = "{{count}} bebis", MQ = "{{count}} bebisar", LQ = "", WQ = "{{count}} barn", BQ = "{{count}} barn", FQ = "", VQ = "{{count}} gäst", UQ = "{{count}} gäster", qQ = "Telefonnumrets format är inte giltigt.", HQ = "Få e-postaviseringar", GQ = "Spara", KQ = "Inga resmål hittades", JQ = "Se mer", ZQ = "Reselista", YQ = "", XQ = "valfritt", QQ = {
  "autocomplete.button": "Sök",
  "autocomplete.placeholder": "Vart ska du ?",
  bedroomsNumbers_zero: lX,
  bedroomsNumbers_one: cX,
  bedroomsNumbers_other: uX,
  beds_zero: dX,
  beds_one: gX,
  beds_other: hX,
  "button.free-signup": "Registrera dig gratis",
  "button.validate": "Godkänn",
  "common.try-again": "Försök igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Får inte överskrida {{limit}} tecken",
  "error.reload": "Ladda om sidan",
  "error.return-homepage": "Gå tillbaka till startsidan",
  "error.subtitle": "Tyvärr kan inte den här sidan nås.",
  "error.title": "Ett fel uppstod på sidan",
  "errors.unable_to_submit.subtitle": "Tyvärr kunde inte ditt formulär skickas in just nu. Vänligen försök igen senare.",
  "errors.unable_to_submit.title": "Hoppsan, vi har stött på ett problem",
  "global.back": "Tillbaka",
  "global.cancel": "Avbryt",
  "global.collection.browsehomes": "Se fler hem",
  "global.collection.contactus": "Kontakta oss",
  "global.confirm": "Bekräfta",
  "global.continue": "Fortsätt",
  "global.getStarted": "Kom igång",
  "global.login": "Logga in",
  "global.select": "Välj",
  global_adults: mX,
  global_babies: pX,
  global_calendarUpdated_toast: fX,
  global_calendar_aMonth: bX,
  global_calendar_exactDates: _X,
  global_calendar_oneWeek: vX,
  global_calendar_oneWeekend: yX,
  global_calendar_plusMinusDay_zero: wX,
  global_calendar_plusMinusDay_one: kX,
  global_calendar_plusMinusDay_other: xX,
  global_calendar_twoWeeks: $X,
  global_cancel: SX,
  global_children: CX,
  global_dates: EX,
  global_delete: zX,
  global_description: jX,
  global_destination: AX,
  global_done: OX,
  global_edit: PX,
  "global_filter_a-c": "Luftkonditionering",
  global_filter_available: DX,
  "global_filter_baby-bed": "Bebissäng",
  "global_filter_baby-gear": "Barnutrustning",
  "global_filter_balcony-terrace": "Balkong/terrass",
  global_filter_bathtub: NX,
  global_filter_bbq: RX,
  global_filter_bicycle: IX,
  global_filter_car: TX,
  global_filter_cat: MX,
  "global_filter_children-welcome": "Barn är välkomna",
  global_filter_cities: LX,
  "global_filter_cleaning-person": "Städare",
  global_filter_countryside: WX,
  "global_filter_dedicated-workspace": "Kontor",
  "global_filter_disabled-access": "Tillgängligt hem",
  global_filter_dishwasher: BX,
  global_filter_dog: FX,
  global_filter_dryer: VX,
  "global_filter_eco-level": "Endast hållbara hem",
  "global_filter_electric-car-plug": "Elbilsladdare",
  global_filter_elevator: UX,
  global_filter_favorite: qX,
  global_filter_fireplace: HX,
  global_filter_flat: GX,
  global_filter_garden: KX,
  "global_filter_guest-wanted": "Hembyte för GuestPoints",
  global_filter_guestPointsMax: JX,
  global_filter_guestPointsMin: ZX,
  global_filter_guestPointsMinMax: YX,
  global_filter_gym: XX,
  "global_filter_heating-system": "Värmesystem",
  "global_filter_high-speed-connexion": "Bredband med hög hastighet",
  global_filter_home: QX,
  "global_filter_home-verified": "Verifierade hem",
  global_filter_island: eQ,
  global_filter_isolated: tQ,
  global_filter_jacuzzi: aQ,
  "global_filter_kids-toys": "Barnleksaker",
  global_filter_lakes: oQ,
  global_filter_luxury: nQ,
  global_filter_mountains: rQ,
  "global_filter_no-bed-up": "Inga tillfälliga sängar",
  global_filter_numOfBathrooms: iQ,
  global_filter_other: sQ,
  "global_filter_parking-space": "Privat parkeringsplats",
  "global_filter_pets-welcome": "Husdjur är välkomna",
  global_filter_piano: lQ,
  global_filter_playground: cQ,
  global_filter_primary: uQ,
  "global_filter_public-transit-access": "Tillgång till kollektivtrafik",
  global_filter_reciprocal: dQ,
  "global_filter_response-rate-above-threshold": "Svarsprocent ≥ Genomsnittlig",
  global_filter_reverse: gQ,
  global_filter_river: hQ,
  global_filter_seaside: mQ,
  global_filter_secondary: pQ,
  "global_filter_secured-pool": "Säker pool",
  "global_filter_smokers-welcome": "Rökning tillåtet",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: fQ,
  global_filter_villages: bQ,
  "global_filter_washing-machine": "Tvättmaskin",
  "global_filter_whole-unit": "Hela hemmet",
  global_filter_wifi: _Q,
  global_filters: vQ,
  global_fixDates: yQ,
  global_flexDates_aMonth: wQ,
  global_flexDates_aWeekend: kQ,
  global_flexDates_oneWeek: xQ,
  global_flexDates_twoWeek: $Q,
  global_flexibleDates: SQ,
  global_guests: CQ,
  global_homes: EQ,
  global_lastMinute: zQ,
  global_location: jQ,
  global_modify: AQ,
  global_name: OQ,
  global_next: PQ,
  global_numberOfAdults_zero: DQ,
  global_numberOfAdults_one: NQ,
  global_numberOfAdults_other: RQ,
  global_numberOfBabies_zero: IQ,
  global_numberOfBabies_one: TQ,
  global_numberOfBabies_other: MQ,
  global_numberOfChildren_zero: LQ,
  global_numberOfChildren_one: WQ,
  global_numberOfChildren_other: BQ,
  global_numberOfGuests_zero: FQ,
  global_numberOfGuests_one: VQ,
  global_numberOfGuests_other: UQ,
  global_phoneNumber_notValid: qQ,
  global_receiveEmailAlerts: HQ,
  global_save: GQ,
  global_searchBar_noLocationFound: KQ,
  global_seeMore_link: JQ,
  global_travelWishlist: ZQ,
  "modal.error-occured.content": "Vi ber om ursäkt för det, men försök gärna igen.",
  "modal.error-occured.title": "Hoppsan, ett fel uppstod!",
  no_result: YQ,
  optional: XQ,
  "privacy-policy": "Sekretesspolicy"
}, eee = "https://www.homeexchange.com/blog/", tee = "/p/general-terms-of-use", aee = "https://www.homeexchange.com/sv/p/natverket", oee = "https://homeexchangehelp.zendesk.com/hc/es", nee = "", ree = "https://www.homeexchange.com/sv/p/service-homeexchange-sv", iee = "https://www.homeexchange.com/sv/p/guestpoints-sv", see = "https://www.homeexchange.com/sv/p/press-sv", lee = "https://www.homeexchange.com/p/medlemmarna-har-ordet", cee = "", uee = "", dee = "https://www.homeexchange.com/sv/p/dar-valkomnandet-borjar", gee = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/sv/p/about-us-sv",
  blog: eee,
  cgu: tee,
  community: aee,
  "contact-us": "https://www.homeexchange.com/sv/kontakta-oss-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: oee,
  forum: nee,
  guarantees: ree,
  guestpoints: iee,
  "happiness-team": "https://www.homeexchange.com/sv/p/happiness-team-sv",
  "how-it-works": "https://www.homeexchange.com/sv/p/hur-fungerar-det-sv",
  "join-us": "https://www.homeexchange.com/sv/p/join-us-sv",
  "legal-notice": "/p/juridisk-information",
  "mobile-app": "https://www.homeexchange.com/sv/p/app-mobil",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: see,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/sv/p/subscription-homeexchange-sv",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: lee,
  travelWishlist_faq_links: cee,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: uee,
  values: dee
}, hee = "Förnamn", mee = "Efternamn", pee = "Skapa din reselista", fee = "En uppdaterad reselista gör att du kan få fler ömsesidiga hembytesförslag.", bee = "Är du säker på att du vill radera {{fullAddress}}?", _ee = "Det här är filtren du har valt. Om du har ändrat dig kan du ta bort några av dem nedan. Men om du vill lägga till fler måste du starta en ny sökning (detta kommer dock snart att ändras... håll utkik)!", vee = "Det kan vara ett land, en stad eller en hel region. Om du väljer en bred plats kan dina resultat bli mindre exakta.", yee = "Ange ett land, en stad eller en region", wee = "Visa tillgängliga hem", kee = "När hem med tillgänglighet matchar dina resplaner.", xee = "Skapa din reselista", $ee = "{{fullAddress}} har tagits bort från din reselista.", See = "Välj dina ideala resedatum (flexibla eller fasta).", Cee = "Lägg till detaljer för att hjälpa andra som använder funktionen för omvänd sökning att se varför du är intresserad av deras ställe.", Eee = "Ange hur många personer som följer med dig på den här resan.", zee = "Hoppsan! {{fullAddress}} kunde inte sparas i din reselista av en oväntad anledning.", jee = "Meddela oss när och vart du vill resa för att få hembytesförslag och aviseringar så snart passande hem blir tillgängliga. Vi sparar dina sökningar i din reselista!", Aee = "Har du några reseäventyr du vill börja planera?", Oee = "<updateDates>Uppdatera dina datum</updateDates> för att fortsätta få relevanta mejl eller <delete>ta bort det här resmålet</delete>från din reselista om du inte längre vill resa dit.", Pee = "Dessa datum har redan varit", Dee = "{{fullAddress}} har lagts till i din reselista!", Nee = "{{fullAddress}} har uppdaterats.", Ree = "Din sökning har sparats och din kalender har uppdaterats!", Iee = "Din sökning har sparats. Se den i din reselista.", Tee = "Läs mer om reselistor", Mee = {
  firstname: hee,
  lastname: mee,
  modal_travelWishlist_addNew_title: pee,
  modal_travelWishlist_delete_body: fee,
  modal_travelWishlist_delete_title: bee,
  modal_travelWishlist_filtersApplied_helper: _ee,
  modal_travelWishlist_location_helper: vee,
  modal_travelWishlist_searchBar_placeholder: yee,
  page_travelWishlist_card_cta: wee,
  page_travelWishlist_card_emailAlerts_helper: kee,
  page_travelWishlist_cta: xee,
  page_travelWishlist_deleted_toast: $ee,
  page_travelWishlist_edit_dates_helper: See,
  page_travelWishlist_edit_description_helper: Cee,
  page_travelWishlist_edit_guests_helper: Eee,
  page_travelWishlist_error_toast: zee,
  page_travelWishlist_none_body: jee,
  page_travelWishlist_none_subheader: Aee,
  page_travelWishlist_pastDates_desc: Oee,
  page_travelWishlist_pastDates_title: Pee,
  page_travelWishlist_saved_toast: Dee,
  page_travelWishlist_updated_toast: Nee,
  search_travelWishlist_calendarUpdated_toast: Ree,
  search_travelWishlist_saved_toast: Iee,
  travelWishlist_faq: Tee
}, Lee = "en", fy = mN({
  fallbackLng: Lee,
  debug: !1,
  interpolation: {
    escapeValue: !1
  },
  returnEmptyString: !1,
  postProcess: ["newlineHandler"],
  resources: {
    da: {
      common: iI,
      user: qI,
      links: vI
    },
    de: {
      common: TM,
      user: kL,
      links: ZM
    },
    en: {
      common: m2,
      user: Q2,
      links: E2
    },
    es: {
      common: qF,
      user: AV,
      links: nV
    },
    fr: {
      common: k4,
      user: sU,
      links: R4
    },
    hr: {
      common: iH,
      user: qH,
      links: vH
    },
    it: {
      common: TG,
      user: kK,
      links: ZG
    },
    nb: {
      common: m9,
      user: Q9,
      links: E9
    },
    nl: {
      common: q7,
      user: AJ,
      links: nJ
    },
    pt: {
      common: kY,
      user: sX,
      links: RY
    },
    sv: {
      common: QQ,
      user: Mee,
      links: gee
    }
  }
});
fy.use({
  name: "newlineHandler",
  type: "postProcessor",
  process: (e) => e.replace(/\\n/g, "")
});
fy.init();
function Wee() {
  const [e, t] = Pe({
    width: typeof window > "u" ? void 0 : window.innerWidth,
    height: typeof window > "u" ? void 0 : window.innerHeight
  });
  return Ce(() => {
    function a() {
      t({
        width: window.innerWidth,
        height: window.innerHeight
      });
    }
    return window.addEventListener("resize", a), a(), () => window.removeEventListener("resize", a);
  }, []), e;
}
function Bee() {
  const { width: e } = Wee();
  let t = "desktop";
  return e && e <= Kd.MOBILE ? t = "mobile" : e && e <= Kd.TABLET && (t = "tablet"), {
    currentWidth: e,
    currentDevice: t,
    isMobile: t === "mobile",
    isTablet: t === "tablet",
    isDesktop: t === "desktop",
    isReady: typeof window < "u"
  };
}
function Fee(e, t, a) {
  Ce(() => {
    if (window)
      return window.addEventListener(e, t, a), () => {
        window.removeEventListener(e, t, a);
      };
  }, [e, t, a]);
}
const Fh = (e) => {
  let t;
  const a = /* @__PURE__ */ new Set(), o = (c, u) => {
    const d = typeof c == "function" ? c(t) : c;
    if (!Object.is(d, t)) {
      const h = t;
      t = u ?? (typeof d != "object" || d === null) ? d : Object.assign({}, t, d), a.forEach((p) => p(t, h));
    }
  }, n = () => t, s = { setState: o, getState: n, getInitialState: () => l, subscribe: (c) => (a.add(c), () => a.delete(c)) }, l = t = e(o, n, s);
  return s;
}, by = (e) => e ? Fh(e) : Fh, Vee = (e) => e;
function _y(e, t = Vee) {
  const a = ne.useSyncExternalStore(
    e.subscribe,
    ne.useCallback(() => t(e.getState()), [e, t]),
    ne.useCallback(() => t(e.getInitialState()), [e, t])
  );
  return ne.useDebugValue(a), a;
}
function Uee(e) {
  const t = {
    conversations: void 0,
    userInfos: void 0,
    apiUrl: "",
    assetsUrl: ""
  };
  return by((a) => ({
    ...t,
    ...e,
    setNavigationBarData: (o) => a({
      conversations: o.conversations,
      userInfos: o.userInfos
    }),
    setConversations: (o) => a({ conversations: o }),
    setUserInfos: (o) => a({ userInfos: o }),
    setApiUrl: (o) => a({ apiUrl: o }),
    setAssetsUrl: (o) => a({ assetsUrl: o }),
    clear: () => a({
      conversations: void 0,
      userInfos: void 0
    })
  }));
}
const vy = jt(void 0);
function qee({ children: e, ...t }) {
  const a = Ie(null);
  return a.current || (a.current = Uee(t)), /* @__PURE__ */ v(vy.Provider, { value: a.current, children: e });
}
const Vh = (e) => Symbol.iterator in e, Uh = (e) => (
  // HACK: avoid checking entries type
  "entries" in e
), qh = (e, t) => {
  const a = e instanceof Map ? e : new Map(e.entries()), o = t instanceof Map ? t : new Map(t.entries());
  if (a.size !== o.size)
    return !1;
  for (const [n, r] of a)
    if (!o.has(n) || !Object.is(r, o.get(n)))
      return !1;
  return !0;
}, Hee = (e, t) => {
  const a = e[Symbol.iterator](), o = t[Symbol.iterator]();
  let n = a.next(), r = o.next();
  for (; !n.done && !r.done; ) {
    if (!Object.is(n.value, r.value))
      return !1;
    n = a.next(), r = o.next();
  }
  return !!n.done && !!r.done;
};
function Gee(e, t) {
  return Object.is(e, t) ? !0 : typeof e != "object" || e === null || typeof t != "object" || t === null || Object.getPrototypeOf(e) !== Object.getPrototypeOf(t) ? !1 : Vh(e) && Vh(t) ? Uh(e) && Uh(t) ? qh(e, t) : Hee(e, t) : qh(
    { entries: () => Object.entries(e) },
    { entries: () => Object.entries(t) }
  );
}
function yy(e) {
  const t = ne.useRef(void 0);
  return (a) => {
    const o = e(a);
    return Gee(t.current, o) ? t.current : t.current = o;
  };
}
function ro(e) {
  const t = ho(vy);
  if (!t) throw new Error("Missing NavigationContext.Provider in the tree");
  return _y(t, yy(e));
}
const wy = jt(void 0);
function Ps(e) {
  const t = ho(wy);
  if (!t) throw new Error("Missing UserContext.Provider in the tree");
  return _y(t, yy(e));
}
function Kee(e) {
  const t = {
    isSignedIn: !1
  };
  return by((a) => ({
    ...t,
    ...e,
    setIsSignedIn: (o) => a({ isSignedIn: o }),
    signout: () => a({ isSignedIn: !1 })
  }));
}
function Jee({ children: e, ...t }) {
  const a = Ie(null);
  return a.current || (a.current = Kee(t)), /* @__PURE__ */ v(wy.Provider, { value: a.current, children: e });
}
const le = (e) => typeof e == "string", yn = () => {
  let e, t;
  const a = new Promise((o, n) => {
    e = o, t = n;
  });
  return a.resolve = e, a.reject = t, a;
}, Hh = (e) => e == null ? "" : "" + e, Zee = (e, t, a) => {
  e.forEach((o) => {
    t[o] && (a[o] = t[o]);
  });
}, Yee = /###/g, Gh = (e) => e && e.indexOf("###") > -1 ? e.replace(Yee, ".") : e, Kh = (e) => !e || le(e), Pn = (e, t, a) => {
  const o = le(t) ? t.split(".") : t;
  let n = 0;
  for (; n < o.length - 1; ) {
    if (Kh(e)) return {};
    const r = Gh(o[n]);
    !e[r] && a && (e[r] = new a()), Object.prototype.hasOwnProperty.call(e, r) ? e = e[r] : e = {}, ++n;
  }
  return Kh(e) ? {} : {
    obj: e,
    k: Gh(o[n])
  };
}, Jh = (e, t, a) => {
  const {
    obj: o,
    k: n
  } = Pn(e, t, Object);
  if (o !== void 0 || t.length === 1) {
    o[n] = a;
    return;
  }
  let r = t[t.length - 1], i = t.slice(0, t.length - 1), s = Pn(e, i, Object);
  for (; s.obj === void 0 && i.length; )
    r = `${i[i.length - 1]}.${r}`, i = i.slice(0, i.length - 1), s = Pn(e, i, Object), s?.obj && typeof s.obj[`${s.k}.${r}`] < "u" && (s.obj = void 0);
  s.obj[`${s.k}.${r}`] = a;
}, Xee = (e, t, a, o) => {
  const {
    obj: n,
    k: r
  } = Pn(e, t, Object);
  n[r] = n[r] || [], n[r].push(a);
}, Mi = (e, t) => {
  const {
    obj: a,
    k: o
  } = Pn(e, t);
  if (a && Object.prototype.hasOwnProperty.call(a, o))
    return a[o];
}, Qee = (e, t, a) => {
  const o = Mi(e, a);
  return o !== void 0 ? o : Mi(t, a);
}, ky = (e, t, a) => {
  for (const o in t)
    o !== "__proto__" && o !== "constructor" && (o in e ? le(e[o]) || e[o] instanceof String || le(t[o]) || t[o] instanceof String ? a && (e[o] = t[o]) : ky(e[o], t[o], a) : e[o] = t[o]);
  return e;
}, Ao = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var ete = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const tte = (e) => le(e) ? e.replace(/[&<>"'\/]/g, (t) => ete[t]) : e;
class ate {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const a = this.regExpMap.get(t);
    if (a !== void 0)
      return a;
    const o = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, o), this.regExpQueue.push(t), o;
  }
}
const ote = [" ", ",", "?", "!", ";"], nte = new ate(20), rte = (e, t, a) => {
  t = t || "", a = a || "";
  const o = ote.filter((i) => t.indexOf(i) < 0 && a.indexOf(i) < 0);
  if (o.length === 0) return !0;
  const n = nte.getRegExp(`(${o.map((i) => i === "?" ? "\\?" : i).join("|")})`);
  let r = !n.test(e);
  if (!r) {
    const i = e.indexOf(a);
    i > 0 && !n.test(e.substring(0, i)) && (r = !0);
  }
  return r;
}, Ac = (e, t, a = ".") => {
  if (!e) return;
  if (e[t])
    return Object.prototype.hasOwnProperty.call(e, t) ? e[t] : void 0;
  const o = t.split(a);
  let n = e;
  for (let r = 0; r < o.length; ) {
    if (!n || typeof n != "object")
      return;
    let i, s = "";
    for (let l = r; l < o.length; ++l)
      if (l !== r && (s += a), s += o[l], i = n[s], i !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof i) > -1 && l < o.length - 1)
          continue;
        r += l - r + 1;
        break;
      }
    n = i;
  }
  return n;
}, Ln = (e) => e?.replace("_", "-"), ite = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console?.[e]?.apply?.(console, t);
  }
};
class Li {
  constructor(t, a = {}) {
    this.init(t, a);
  }
  init(t, a = {}) {
    this.prefix = a.prefix || "i18next:", this.logger = t || ite, this.options = a, this.debug = a.debug;
  }
  log(...t) {
    return this.forward(t, "log", "", !0);
  }
  warn(...t) {
    return this.forward(t, "warn", "", !0);
  }
  error(...t) {
    return this.forward(t, "error", "");
  }
  deprecate(...t) {
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, a, o, n) {
    return n && !this.debug ? null : (le(t[0]) && (t[0] = `${o}${this.prefix} ${t[0]}`), this.logger[a](t));
  }
  create(t) {
    return new Li(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new Li(this.logger, t);
  }
}
var Jt = new Li();
class Ds {
  constructor() {
    this.observers = {};
  }
  on(t, a) {
    return t.split(" ").forEach((o) => {
      this.observers[o] || (this.observers[o] = /* @__PURE__ */ new Map());
      const n = this.observers[o].get(a) || 0;
      this.observers[o].set(a, n + 1);
    }), this;
  }
  off(t, a) {
    if (this.observers[t]) {
      if (!a) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(a);
    }
  }
  emit(t, ...a) {
    this.observers[t] && Array.from(this.observers[t].entries()).forEach(([n, r]) => {
      for (let i = 0; i < r; i++)
        n(...a);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([n, r]) => {
      for (let i = 0; i < r; i++)
        n.apply(n, [t, ...a]);
    });
  }
}
class Zh extends Ds {
  constructor(t, a = {
    ns: ["translation"],
    defaultNS: "translation"
  }) {
    super(), this.data = t || {}, this.options = a, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const a = this.options.ns.indexOf(t);
    a > -1 && this.options.ns.splice(a, 1);
  }
  getResource(t, a, o, n = {}) {
    const r = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, i = n.ignoreJSONStructure !== void 0 ? n.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    t.indexOf(".") > -1 ? s = t.split(".") : (s = [t, a], o && (Array.isArray(o) ? s.push(...o) : le(o) && r ? s.push(...o.split(r)) : s.push(o)));
    const l = Mi(this.data, s);
    return !l && !a && !o && t.indexOf(".") > -1 && (t = s[0], a = s[1], o = s.slice(2).join(".")), l || !i || !le(o) ? l : Ac(this.data?.[t]?.[a], o, r);
  }
  addResource(t, a, o, n, r = {
    silent: !1
  }) {
    const i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
    let s = [t, a];
    o && (s = s.concat(i ? o.split(i) : o)), t.indexOf(".") > -1 && (s = t.split("."), n = a, a = s[1]), this.addNamespaces(a), Jh(this.data, s, n), r.silent || this.emit("added", t, a, o, n);
  }
  addResources(t, a, o, n = {
    silent: !1
  }) {
    for (const r in o)
      (le(o[r]) || Array.isArray(o[r])) && this.addResource(t, a, r, o[r], {
        silent: !0
      });
    n.silent || this.emit("added", t, a, o);
  }
  addResourceBundle(t, a, o, n, r, i = {
    silent: !1,
    skipCopy: !1
  }) {
    let s = [t, a];
    t.indexOf(".") > -1 && (s = t.split("."), n = o, o = a, a = s[1]), this.addNamespaces(a);
    let l = Mi(this.data, s) || {};
    i.skipCopy || (o = JSON.parse(JSON.stringify(o))), n ? ky(l, o, r) : l = {
      ...l,
      ...o
    }, Jh(this.data, s, l), i.silent || this.emit("added", t, a, o);
  }
  removeResourceBundle(t, a) {
    this.hasResourceBundle(t, a) && delete this.data[t][a], this.removeNamespaces(a), this.emit("removed", t, a);
  }
  hasResourceBundle(t, a) {
    return this.getResource(t, a) !== void 0;
  }
  getResourceBundle(t, a) {
    return a || (a = this.options.defaultNS), this.getResource(t, a);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const a = this.getDataByLanguage(t);
    return !!(a && Object.keys(a) || []).find((n) => a[n] && Object.keys(a[n]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var xy = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, a, o, n) {
    return e.forEach((r) => {
      t = this.processors[r]?.process(t, a, o, n) ?? t;
    }), t;
  }
};
const $y = Symbol("i18next/PATH_KEY");
function ste() {
  const e = [], t = /* @__PURE__ */ Object.create(null);
  let a;
  return t.get = (o, n) => (a?.revoke?.(), n === $y ? e : (e.push(n), a = Proxy.revocable(o, t), a.proxy)), Proxy.revocable(/* @__PURE__ */ Object.create(null), t).proxy;
}
function Oc(e, t) {
  const {
    [$y]: a
  } = e(ste());
  return a.join(t?.keySeparator ?? ".");
}
const Yh = {}, Xh = (e) => !le(e) && typeof e != "boolean" && typeof e != "number";
class Wi extends Ds {
  constructor(t, a = {}) {
    super(), Zee(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = a, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Jt.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t, a = {
    interpolation: {}
  }) {
    const o = {
      ...a
    };
    return t == null ? !1 : this.resolve(t, o)?.res !== void 0;
  }
  extractFromKey(t, a) {
    let o = a.nsSeparator !== void 0 ? a.nsSeparator : this.options.nsSeparator;
    o === void 0 && (o = ":");
    const n = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator;
    let r = a.ns || this.options.defaultNS || [];
    const i = o && t.indexOf(o) > -1, s = !this.options.userDefinedKeySeparator && !a.keySeparator && !this.options.userDefinedNsSeparator && !a.nsSeparator && !rte(t, o, n);
    if (i && !s) {
      const l = t.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: t,
          namespaces: le(r) ? [r] : r
        };
      const c = t.split(o);
      (o !== n || o === n && this.options.ns.indexOf(c[0]) > -1) && (r = c.shift()), t = c.join(n);
    }
    return {
      key: t,
      namespaces: le(r) ? [r] : r
    };
  }
  translate(t, a, o) {
    let n = typeof a == "object" ? {
      ...a
    } : a;
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
      ...n
    }), n || (n = {}), t == null) return "";
    typeof t == "function" && (t = Oc(t, {
      ...this.options,
      ...n
    })), Array.isArray(t) || (t = [String(t)]);
    const r = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: s,
      namespaces: l
    } = this.extractFromKey(t[t.length - 1], n), c = l[l.length - 1];
    let u = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    u === void 0 && (u = ":");
    const d = n.lng || this.language, h = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (d?.toLowerCase() === "cimode")
      return h ? r ? {
        res: `${c}${u}${s}`,
        usedKey: s,
        exactUsedKey: s,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(n)
      } : `${c}${u}${s}` : r ? {
        res: s,
        usedKey: s,
        exactUsedKey: s,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(n)
      } : s;
    const p = this.resolve(t, n);
    let f = p?.res;
    const m = p?.usedKey || s, b = p?.exactUsedKey || s, w = ["[object Number]", "[object Function]", "[object RegExp]"], _ = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, y = !this.i18nFormat || this.i18nFormat.handleAsObject, k = n.count !== void 0 && !le(n.count), x = Wi.hasDefaultValue(n), S = k ? this.pluralResolver.getSuffix(d, n.count, n) : "", $ = n.ordinal && k ? this.pluralResolver.getSuffix(d, n.count, {
      ordinal: !1
    }) : "", E = k && !n.ordinal && n.count === 0, C = E && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${S}`] || n[`defaultValue${$}`] || n.defaultValue;
    let z = f;
    y && !f && x && (z = C);
    const R = Xh(z), H = Object.prototype.toString.apply(z);
    if (y && z && R && w.indexOf(H) < 0 && !(le(_) && Array.isArray(z))) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const M = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(m, z, {
          ...n,
          ns: l
        }) : `key '${s} (${this.language})' returned an object instead of string.`;
        return r ? (p.res = M, p.usedParams = this.getUsedParamsDetails(n), p) : M;
      }
      if (i) {
        const M = Array.isArray(z), j = M ? [] : {}, U = M ? b : m;
        for (const I in z)
          if (Object.prototype.hasOwnProperty.call(z, I)) {
            const K = `${U}${i}${I}`;
            x && !f ? j[I] = this.translate(K, {
              ...n,
              defaultValue: Xh(C) ? C[I] : void 0,
              joinArrays: !1,
              ns: l
            }) : j[I] = this.translate(K, {
              ...n,
              joinArrays: !1,
              ns: l
            }), j[I] === K && (j[I] = z[I]);
          }
        f = j;
      }
    } else if (y && le(_) && Array.isArray(f))
      f = f.join(_), f && (f = this.extendTranslation(f, t, n, o));
    else {
      let M = !1, j = !1;
      !this.isValidLookup(f) && x && (M = !0, f = C), this.isValidLookup(f) || (j = !0, f = s);
      const I = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && j ? void 0 : f, K = x && C !== f && this.options.updateMissing;
      if (j || M || K) {
        if (this.logger.log(K ? "updateKey" : "missingKey", d, c, s, K ? C : f), i) {
          const A = this.resolve(s, {
            ...n,
            keySeparator: !1
          });
          A && A.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let q = [];
        const te = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && te && te[0])
          for (let A = 0; A < te.length; A++)
            q.push(te[A]);
        else this.options.saveMissingTo === "all" ? q = this.languageUtils.toResolveHierarchy(n.lng || this.language) : q.push(n.lng || this.language);
        const O = (A, N, B) => {
          const W = x && B !== f ? B : I;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(A, c, N, W, K, n) : this.backendConnector?.saveMissing && this.backendConnector.saveMissing(A, c, N, W, K, n), this.emit("missingKey", A, c, N, f);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && k ? q.forEach((A) => {
          const N = this.pluralResolver.getSuffixes(A, n);
          E && n[`defaultValue${this.options.pluralSeparator}zero`] && N.indexOf(`${this.options.pluralSeparator}zero`) < 0 && N.push(`${this.options.pluralSeparator}zero`), N.forEach((B) => {
            O([A], s + B, n[`defaultValue${B}`] || C);
          });
        }) : O(q, s, C));
      }
      f = this.extendTranslation(f, t, n, p, o), j && f === s && this.options.appendNamespaceToMissingKey && (f = `${c}${u}${s}`), (j || M) && this.options.parseMissingKeyHandler && (f = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${c}${u}${s}` : s, M ? f : void 0, n));
    }
    return r ? (p.res = f, p.usedParams = this.getUsedParamsDetails(n), p) : f;
  }
  extendTranslation(t, a, o, n, r) {
    if (this.i18nFormat?.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...o
      }, o.lng || this.language || n.usedLng, n.usedNS, n.usedKey, {
        resolved: n
      });
    else if (!o.skipInterpolation) {
      o.interpolation && this.interpolator.init({
        ...o,
        interpolation: {
          ...this.options.interpolation,
          ...o.interpolation
        }
      });
      const l = le(t) && (o?.interpolation?.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let c;
      if (l) {
        const d = t.match(this.interpolator.nestingRegexp);
        c = d && d.length;
      }
      let u = o.replace && !le(o.replace) ? o.replace : o;
      if (this.options.interpolation.defaultVariables && (u = {
        ...this.options.interpolation.defaultVariables,
        ...u
      }), t = this.interpolator.interpolate(t, u, o.lng || this.language || n.usedLng, o), l) {
        const d = t.match(this.interpolator.nestingRegexp), h = d && d.length;
        c < h && (o.nest = !1);
      }
      !o.lng && n && n.res && (o.lng = this.language || n.usedLng), o.nest !== !1 && (t = this.interpolator.nest(t, (...d) => r?.[0] === d[0] && !o.context ? (this.logger.warn(`It seems you are nesting recursively key: ${d[0]} in key: ${a[0]}`), null) : this.translate(...d, a), o)), o.interpolation && this.interpolator.reset();
    }
    const i = o.postProcess || this.options.postProcess, s = le(i) ? [i] : i;
    return t != null && s?.length && o.applyPostProcessor !== !1 && (t = xy.handle(s, t, a, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...n,
        usedParams: this.getUsedParamsDetails(o)
      },
      ...o
    } : o, this)), t;
  }
  resolve(t, a = {}) {
    let o, n, r, i, s;
    return le(t) && (t = [t]), t.forEach((l) => {
      if (this.isValidLookup(o)) return;
      const c = this.extractFromKey(l, a), u = c.key;
      n = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const h = a.count !== void 0 && !le(a.count), p = h && !a.ordinal && a.count === 0, f = a.context !== void 0 && (le(a.context) || typeof a.context == "number") && a.context !== "", m = a.lngs ? a.lngs : this.languageUtils.toResolveHierarchy(a.lng || this.language, a.fallbackLng);
      d.forEach((b) => {
        this.isValidLookup(o) || (s = b, !Yh[`${m[0]}-${b}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(s) && (Yh[`${m[0]}-${b}`] = !0, this.logger.warn(`key "${n}" for languages "${m.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), m.forEach((w) => {
          if (this.isValidLookup(o)) return;
          i = w;
          const _ = [u];
          if (this.i18nFormat?.addLookupKeys)
            this.i18nFormat.addLookupKeys(_, u, w, b, a);
          else {
            let k;
            h && (k = this.pluralResolver.getSuffix(w, a.count, a));
            const x = `${this.options.pluralSeparator}zero`, S = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (h && (a.ordinal && k.indexOf(S) === 0 && _.push(u + k.replace(S, this.options.pluralSeparator)), _.push(u + k), p && _.push(u + x)), f) {
              const $ = `${u}${this.options.contextSeparator || "_"}${a.context}`;
              _.push($), h && (a.ordinal && k.indexOf(S) === 0 && _.push($ + k.replace(S, this.options.pluralSeparator)), _.push($ + k), p && _.push($ + x));
            }
          }
          let y;
          for (; y = _.pop(); )
            this.isValidLookup(o) || (r = y, o = this.getResource(w, b, y, a));
        }));
      });
    }), {
      res: o,
      usedKey: n,
      exactUsedKey: r,
      usedLng: i,
      usedNS: s
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, a, o, n = {}) {
    return this.i18nFormat?.getResource ? this.i18nFormat.getResource(t, a, o, n) : this.resourceStore.getResource(t, a, o, n);
  }
  getUsedParamsDetails(t = {}) {
    const a = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], o = t.replace && !le(t.replace);
    let n = o ? t.replace : t;
    if (o && typeof t.count < "u" && (n.count = t.count), this.options.interpolation.defaultVariables && (n = {
      ...this.options.interpolation.defaultVariables,
      ...n
    }), !o) {
      n = {
        ...n
      };
      for (const r of a)
        delete n[r];
    }
    return n;
  }
  static hasDefaultValue(t) {
    const a = "defaultValue";
    for (const o in t)
      if (Object.prototype.hasOwnProperty.call(t, o) && a === o.substring(0, a.length) && t[o] !== void 0)
        return !0;
    return !1;
  }
}
class Qh {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Jt.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = Ln(t), !t || t.indexOf("-") < 0) return null;
    const a = t.split("-");
    return a.length === 2 || (a.pop(), a[a.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(a.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = Ln(t), !t || t.indexOf("-") < 0) return t;
    const a = t.split("-");
    return this.formatLanguageCode(a[0]);
  }
  formatLanguageCode(t) {
    if (le(t) && t.indexOf("-") > -1) {
      let a;
      try {
        a = Intl.getCanonicalLocales(t)[0];
      } catch {
      }
      return a && this.options.lowerCaseLng && (a = a.toLowerCase()), a || (this.options.lowerCaseLng ? t.toLowerCase() : t);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t) return null;
    let a;
    return t.forEach((o) => {
      if (a) return;
      const n = this.formatLanguageCode(o);
      (!this.options.supportedLngs || this.isSupportedCode(n)) && (a = n);
    }), !a && this.options.supportedLngs && t.forEach((o) => {
      if (a) return;
      const n = this.getScriptPartFromCode(o);
      if (this.isSupportedCode(n)) return a = n;
      const r = this.getLanguagePartFromCode(o);
      if (this.isSupportedCode(r)) return a = r;
      a = this.options.supportedLngs.find((i) => {
        if (i === r) return i;
        if (!(i.indexOf("-") < 0 && r.indexOf("-") < 0) && (i.indexOf("-") > 0 && r.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === r || i.indexOf(r) === 0 && r.length > 1))
          return i;
      });
    }), a || (a = this.getFallbackCodes(this.options.fallbackLng)[0]), a;
  }
  getFallbackCodes(t, a) {
    if (!t) return [];
    if (typeof t == "function" && (t = t(a)), le(t) && (t = [t]), Array.isArray(t)) return t;
    if (!a) return t.default || [];
    let o = t[a];
    return o || (o = t[this.getScriptPartFromCode(a)]), o || (o = t[this.formatLanguageCode(a)]), o || (o = t[this.getLanguagePartFromCode(a)]), o || (o = t.default), o || [];
  }
  toResolveHierarchy(t, a) {
    const o = this.getFallbackCodes((a === !1 ? [] : a) || this.options.fallbackLng || [], t), n = [], r = (i) => {
      i && (this.isSupportedCode(i) ? n.push(i) : this.logger.warn(`rejecting language code not found in supportedLngs: ${i}`));
    };
    return le(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && r(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && r(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && r(this.getLanguagePartFromCode(t))) : le(t) && r(this.formatLanguageCode(t)), o.forEach((i) => {
      n.indexOf(i) < 0 && r(this.formatLanguageCode(i));
    }), n;
  }
}
const em = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, tm = {
  select: (e) => e === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class lte {
  constructor(t, a = {}) {
    this.languageUtils = t, this.options = a, this.logger = Jt.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(t, a) {
    this.rules[t] = a;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t, a = {}) {
    const o = Ln(t === "dev" ? "en" : t), n = a.ordinal ? "ordinal" : "cardinal", r = JSON.stringify({
      cleanedCode: o,
      type: n
    });
    if (r in this.pluralRulesCache)
      return this.pluralRulesCache[r];
    let i;
    try {
      i = new Intl.PluralRules(o, {
        type: n
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), tm;
      if (!t.match(/-|_/)) return tm;
      const l = this.languageUtils.getLanguagePartFromCode(t);
      i = this.getRule(l, a);
    }
    return this.pluralRulesCache[r] = i, i;
  }
  needsPlural(t, a = {}) {
    let o = this.getRule(t, a);
    return o || (o = this.getRule("dev", a)), o?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(t, a, o = {}) {
    return this.getSuffixes(t, o).map((n) => `${a}${n}`);
  }
  getSuffixes(t, a = {}) {
    let o = this.getRule(t, a);
    return o || (o = this.getRule("dev", a)), o ? o.resolvedOptions().pluralCategories.sort((n, r) => em[n] - em[r]).map((n) => `${this.options.prepend}${a.ordinal ? `ordinal${this.options.prepend}` : ""}${n}`) : [];
  }
  getSuffix(t, a, o = {}) {
    const n = this.getRule(t, o);
    return n ? `${this.options.prepend}${o.ordinal ? `ordinal${this.options.prepend}` : ""}${n.select(a)}` : (this.logger.warn(`no plural rule found for: ${t}`), this.getSuffix("dev", a, o));
  }
}
const am = (e, t, a, o = ".", n = !0) => {
  let r = Qee(e, t, a);
  return !r && n && le(a) && (r = Ac(e, a, o), r === void 0 && (r = Ac(t, a, o))), r;
}, Ol = (e) => e.replace(/\$/g, "$$$$");
class cte {
  constructor(t = {}) {
    this.logger = Jt.create("interpolator"), this.options = t, this.format = t?.interpolation?.format || ((a) => a), this.init(t);
  }
  init(t = {}) {
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: a,
      escapeValue: o,
      useRawValueToEscape: n,
      prefix: r,
      prefixEscaped: i,
      suffix: s,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: h,
      nestingPrefixEscaped: p,
      nestingSuffix: f,
      nestingSuffixEscaped: m,
      nestingOptionsSeparator: b,
      maxReplaces: w,
      alwaysFormat: _
    } = t.interpolation;
    this.escape = a !== void 0 ? a : tte, this.escapeValue = o !== void 0 ? o : !0, this.useRawValueToEscape = n !== void 0 ? n : !1, this.prefix = r ? Ao(r) : i || "{{", this.suffix = s ? Ao(s) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = h ? Ao(h) : p || Ao("$t("), this.nestingSuffix = f ? Ao(f) : m || Ao(")"), this.nestingOptionsSeparator = b || ",", this.maxReplaces = w || 1e3, this.alwaysFormat = _ !== void 0 ? _ : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (a, o) => a?.source === o ? (a.lastIndex = 0, a) : new RegExp(o, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
  }
  interpolate(t, a, o, n) {
    let r, i, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (p) => {
      if (p.indexOf(this.formatSeparator) < 0) {
        const w = am(a, l, p, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(w, void 0, o, {
          ...n,
          ...a,
          interpolationkey: p
        }) : w;
      }
      const f = p.split(this.formatSeparator), m = f.shift().trim(), b = f.join(this.formatSeparator).trim();
      return this.format(am(a, l, m, this.options.keySeparator, this.options.ignoreJSONStructure), b, o, {
        ...n,
        ...a,
        interpolationkey: m
      });
    };
    this.resetRegExp();
    const u = n?.missingInterpolationHandler || this.options.missingInterpolationHandler, d = n?.interpolation?.skipOnVariables !== void 0 ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (p) => Ol(p)
    }, {
      regex: this.regexp,
      safeValue: (p) => this.escapeValue ? Ol(this.escape(p)) : Ol(p)
    }].forEach((p) => {
      for (s = 0; r = p.regex.exec(t); ) {
        const f = r[1].trim();
        if (i = c(f), i === void 0)
          if (typeof u == "function") {
            const b = u(t, r, n);
            i = le(b) ? b : "";
          } else if (n && Object.prototype.hasOwnProperty.call(n, f))
            i = "";
          else if (d) {
            i = r[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${f} for interpolating ${t}`), i = "";
        else !le(i) && !this.useRawValueToEscape && (i = Hh(i));
        const m = p.safeValue(i);
        if (t = t.replace(r[0], m), d ? (p.regex.lastIndex += i.length, p.regex.lastIndex -= r[0].length) : p.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, a, o = {}) {
    let n, r, i;
    const s = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0) return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let h = `{${d[1]}`;
      l = d[0], h = this.interpolate(h, i);
      const p = h.match(/'/g), f = h.match(/"/g);
      ((p?.length ?? 0) % 2 === 0 && !f || f.length % 2 !== 0) && (h = h.replace(/'/g, '"'));
      try {
        i = JSON.parse(h), c && (i = {
          ...c,
          ...i
        });
      } catch (m) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, m), `${l}${u}${h}`;
      }
      return i.defaultValue && i.defaultValue.indexOf(this.prefix) > -1 && delete i.defaultValue, l;
    };
    for (; n = this.nestingRegexp.exec(t); ) {
      let l = [];
      i = {
        ...o
      }, i = i.replace && !le(i.replace) ? i.replace : i, i.applyPostProcessor = !1, delete i.defaultValue;
      const c = /{.*}/.test(n[1]) ? n[1].lastIndexOf("}") + 1 : n[1].indexOf(this.formatSeparator);
      if (c !== -1 && (l = n[1].slice(c).split(this.formatSeparator).map((u) => u.trim()).filter(Boolean), n[1] = n[1].slice(0, c)), r = a(s.call(this, n[1].trim(), i), i), r && n[0] === t && !le(r)) return r;
      le(r) || (r = Hh(r)), r || (this.logger.warn(`missed to resolve ${n[1]} for nesting ${t}`), r = ""), l.length && (r = l.reduce((u, d) => this.format(u, d, o.lng, {
        ...o,
        interpolationkey: n[1].trim()
      }), r.trim())), t = t.replace(n[0], r), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const ute = (e) => {
  let t = e.toLowerCase().trim();
  const a = {};
  if (e.indexOf("(") > -1) {
    const o = e.split("(");
    t = o[0].toLowerCase().trim();
    const n = o[1].substring(0, o[1].length - 1);
    t === "currency" && n.indexOf(":") < 0 ? a.currency || (a.currency = n.trim()) : t === "relativetime" && n.indexOf(":") < 0 ? a.range || (a.range = n.trim()) : n.split(";").forEach((i) => {
      if (i) {
        const [s, ...l] = i.split(":"), c = l.join(":").trim().replace(/^'+|'+$/g, ""), u = s.trim();
        a[u] || (a[u] = c), c === "false" && (a[u] = !1), c === "true" && (a[u] = !0), isNaN(c) || (a[u] = parseInt(c, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: a
  };
}, om = (e) => {
  const t = {};
  return (a, o, n) => {
    let r = n;
    n && n.interpolationkey && n.formatParams && n.formatParams[n.interpolationkey] && n[n.interpolationkey] && (r = {
      ...r,
      [n.interpolationkey]: void 0
    });
    const i = o + JSON.stringify(r);
    let s = t[i];
    return s || (s = e(Ln(o), n), t[i] = s), s(a);
  };
}, dte = (e) => (t, a, o) => e(Ln(a), o)(t);
class gte {
  constructor(t = {}) {
    this.logger = Jt.create("formatter"), this.options = t, this.init(t);
  }
  init(t, a = {
    interpolation: {}
  }) {
    this.formatSeparator = a.interpolation.formatSeparator || ",";
    const o = a.cacheInBuiltFormats ? om : dte;
    this.formats = {
      number: o((n, r) => {
        const i = new Intl.NumberFormat(n, {
          ...r
        });
        return (s) => i.format(s);
      }),
      currency: o((n, r) => {
        const i = new Intl.NumberFormat(n, {
          ...r,
          style: "currency"
        });
        return (s) => i.format(s);
      }),
      datetime: o((n, r) => {
        const i = new Intl.DateTimeFormat(n, {
          ...r
        });
        return (s) => i.format(s);
      }),
      relativetime: o((n, r) => {
        const i = new Intl.RelativeTimeFormat(n, {
          ...r
        });
        return (s) => i.format(s, r.range || "day");
      }),
      list: o((n, r) => {
        const i = new Intl.ListFormat(n, {
          ...r
        });
        return (s) => i.format(s);
      })
    };
  }
  add(t, a) {
    this.formats[t.toLowerCase().trim()] = a;
  }
  addCached(t, a) {
    this.formats[t.toLowerCase().trim()] = om(a);
  }
  format(t, a, o, n = {}) {
    const r = a.split(this.formatSeparator);
    if (r.length > 1 && r[0].indexOf("(") > 1 && r[0].indexOf(")") < 0 && r.find((s) => s.indexOf(")") > -1)) {
      const s = r.findIndex((l) => l.indexOf(")") > -1);
      r[0] = [r[0], ...r.splice(1, s)].join(this.formatSeparator);
    }
    return r.reduce((s, l) => {
      const {
        formatName: c,
        formatOptions: u
      } = ute(l);
      if (this.formats[c]) {
        let d = s;
        try {
          const h = n?.formatParams?.[n.interpolationkey] || {}, p = h.locale || h.lng || n.locale || n.lng || o;
          d = this.formats[c](s, p, {
            ...u,
            ...n,
            ...h
          });
        } catch (h) {
          this.logger.warn(h);
        }
        return d;
      } else
        this.logger.warn(`there was no format function for ${c}`);
      return s;
    }, t);
  }
}
const hte = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class mte extends Ds {
  constructor(t, a, o, n = {}) {
    super(), this.backend = t, this.store = a, this.services = o, this.languageUtils = o.languageUtils, this.options = n, this.logger = Jt.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = n.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = n.maxRetries >= 0 ? n.maxRetries : 5, this.retryTimeout = n.retryTimeout >= 1 ? n.retryTimeout : 350, this.state = {}, this.queue = [], this.backend?.init?.(o, n.backend, n);
  }
  queueLoad(t, a, o, n) {
    const r = {}, i = {}, s = {}, l = {};
    return t.forEach((c) => {
      let u = !0;
      a.forEach((d) => {
        const h = `${c}|${d}`;
        !o.reload && this.store.hasResourceBundle(c, d) ? this.state[h] = 2 : this.state[h] < 0 || (this.state[h] === 1 ? i[h] === void 0 && (i[h] = !0) : (this.state[h] = 1, u = !1, i[h] === void 0 && (i[h] = !0), r[h] === void 0 && (r[h] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (s[c] = !0);
    }), (Object.keys(r).length || Object.keys(i).length) && this.queue.push({
      pending: i,
      pendingCount: Object.keys(i).length,
      loaded: {},
      errors: [],
      callback: n
    }), {
      toLoad: Object.keys(r),
      pending: Object.keys(i),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(t, a, o) {
    const n = t.split("|"), r = n[0], i = n[1];
    a && this.emit("failedLoading", r, i, a), !a && o && this.store.addResourceBundle(r, i, o, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = a ? -1 : 2, a && o && (this.state[t] = 0);
    const s = {};
    this.queue.forEach((l) => {
      Xee(l.loaded, [r], i), hte(l, t), a && l.errors.push(a), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        s[c] || (s[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          s[c][d] === void 0 && (s[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(t, a, o, n = 0, r = this.retryTimeout, i) {
    if (!t.length) return i(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: a,
        fcName: o,
        tried: n,
        wait: r,
        callback: i
      });
      return;
    }
    this.readingCalls++;
    const s = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && n < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, a, o, n + 1, r * 2, i);
        }, r);
        return;
      }
      i(c, u);
    }, l = this.backend[o].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(t, a);
        c && typeof c.then == "function" ? c.then((u) => s(null, u)).catch(s) : s(null, c);
      } catch (c) {
        s(c);
      }
      return;
    }
    return l(t, a, s);
  }
  prepareLoading(t, a, o = {}, n) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), n && n();
    le(t) && (t = this.languageUtils.toResolveHierarchy(t)), le(a) && (a = [a]);
    const r = this.queueLoad(t, a, o, n);
    if (!r.toLoad.length)
      return r.pending.length || n(), null;
    r.toLoad.forEach((i) => {
      this.loadOne(i);
    });
  }
  load(t, a, o) {
    this.prepareLoading(t, a, {}, o);
  }
  reload(t, a, o) {
    this.prepareLoading(t, a, {
      reload: !0
    }, o);
  }
  loadOne(t, a = "") {
    const o = t.split("|"), n = o[0], r = o[1];
    this.read(n, r, "read", void 0, void 0, (i, s) => {
      i && this.logger.warn(`${a}loading namespace ${r} for language ${n} failed`, i), !i && s && this.logger.log(`${a}loaded namespace ${r} for language ${n}`, s), this.loaded(t, i, s);
    });
  }
  saveMissing(t, a, o, n, r, i = {}, s = () => {
  }) {
    if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(a)) {
      this.logger.warn(`did not save key "${o}" as the namespace "${a}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(o == null || o === "")) {
      if (this.backend?.create) {
        const l = {
          ...i,
          isUpdate: r
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(t, a, o, n, l) : u = c(t, a, o, n), u && typeof u.then == "function" ? u.then((d) => s(null, d)).catch(s) : s(null, u);
          } catch (u) {
            s(u);
          }
        else
          c(t, a, o, n, s, l);
      }
      !t || !t[0] || this.store.addResource(t[0], a, o, n);
    }
  }
}
const nm = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), le(e[1]) && (t.defaultValue = e[1]), le(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const a = e[3] || e[2];
      Object.keys(a).forEach((o) => {
        t[o] = a[o];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  },
  cacheInBuiltFormats: !0
}), rm = (e) => (le(e.ns) && (e.ns = [e.ns]), le(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), le(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs?.indexOf?.("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), typeof e.initImmediate == "boolean" && (e.initAsync = e.initImmediate), e), Rr = () => {
}, pte = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((a) => {
    typeof e[a] == "function" && (e[a] = e[a].bind(e));
  });
};
class Wn extends Ds {
  constructor(t = {}, a) {
    if (super(), this.options = rm(t), this.services = {}, this.logger = Jt, this.modules = {
      external: []
    }, pte(this), a && !this.isInitialized && !t.isClone) {
      if (!this.options.initAsync)
        return this.init(t, a), this;
      setTimeout(() => {
        this.init(t, a);
      }, 0);
    }
  }
  init(t = {}, a) {
    this.isInitializing = !0, typeof t == "function" && (a = t, t = {}), t.defaultNS == null && t.ns && (le(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const o = nm();
    this.options = {
      ...o,
      ...this.options,
      ...rm(t)
    }, this.options.interpolation = {
      ...o.interpolation,
      ...this.options.interpolation
    }, t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const n = (c) => c ? typeof c == "function" ? new c() : c : null;
    if (!this.options.isClone) {
      this.modules.logger ? Jt.init(n(this.modules.logger), this.options) : Jt.init(null, this.options);
      let c;
      this.modules.formatter ? c = this.modules.formatter : c = gte;
      const u = new Qh(this.options);
      this.store = new Zh(this.options.resources, this.options);
      const d = this.services;
      d.logger = Jt, d.resourceStore = this.store, d.languageUtils = u, d.pluralResolver = new lte(u, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), this.options.interpolation.format && this.options.interpolation.format !== o.interpolation.format && this.logger.deprecate("init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting"), c && (!this.options.interpolation.format || this.options.interpolation.format === o.interpolation.format) && (d.formatter = n(c), d.formatter.init && d.formatter.init(d, this.options), this.options.interpolation.format = d.formatter.format.bind(d.formatter)), d.interpolator = new cte(this.options), d.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, d.backendConnector = new mte(n(this.modules.backend), d.resourceStore, d, this.options), d.backendConnector.on("*", (p, ...f) => {
        this.emit(p, ...f);
      }), this.modules.languageDetector && (d.languageDetector = n(this.modules.languageDetector), d.languageDetector.init && d.languageDetector.init(d, this.options.detection, this.options)), this.modules.i18nFormat && (d.i18nFormat = n(this.modules.i18nFormat), d.i18nFormat.init && d.i18nFormat.init(this)), this.translator = new Wi(this.services, this.options), this.translator.on("*", (p, ...f) => {
        this.emit(p, ...f);
      }), this.modules.external.forEach((p) => {
        p.init && p.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, a || (a = Rr), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const c = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      c.length > 0 && c[0] !== "dev" && (this.options.lng = c[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((c) => {
      this[c] = (...u) => this.store[c](...u);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((c) => {
      this[c] = (...u) => (this.store[c](...u), this);
    });
    const s = yn(), l = () => {
      const c = (u, d) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), s.resolve(d), a(u, d);
      };
      if (this.languages && !this.isInitialized) return c(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, c);
    };
    return this.options.resources || !this.options.initAsync ? l() : setTimeout(l, 0), s;
  }
  loadResources(t, a = Rr) {
    let o = a;
    const n = le(t) ? t : this.language;
    if (typeof t == "function" && (o = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (n?.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return o();
      const r = [], i = (s) => {
        if (!s || s === "cimode") return;
        this.services.languageUtils.toResolveHierarchy(s).forEach((c) => {
          c !== "cimode" && r.indexOf(c) < 0 && r.push(c);
        });
      };
      n ? i(n) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((l) => i(l)), this.options.preload?.forEach?.((s) => i(s)), this.services.backendConnector.load(r, this.options.ns, (s) => {
        !s && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), o(s);
      });
    } else
      o(null);
  }
  reloadResources(t, a, o) {
    const n = yn();
    return typeof t == "function" && (o = t, t = void 0), typeof a == "function" && (o = a, a = void 0), t || (t = this.languages), a || (a = this.options.ns), o || (o = Rr), this.services.backendConnector.reload(t, a, (r) => {
      n.resolve(), o(r);
    }), n;
  }
  use(t) {
    if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && xy.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1)) {
      for (let a = 0; a < this.languages.length; a++) {
        const o = this.languages[a];
        if (!(["cimode", "dev"].indexOf(o) > -1) && this.store.hasLanguageSomeTranslations(o)) {
          this.resolvedLanguage = o;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(t) < 0 && this.store.hasLanguageSomeTranslations(t) && (this.resolvedLanguage = t, this.languages.unshift(t));
    }
  }
  changeLanguage(t, a) {
    this.isLanguageChangingTo = t;
    const o = yn();
    this.emit("languageChanging", t);
    const n = (s) => {
      this.language = s, this.languages = this.services.languageUtils.toResolveHierarchy(s), this.resolvedLanguage = void 0, this.setResolvedLanguage(s);
    }, r = (s, l) => {
      l ? this.isLanguageChangingTo === t && (n(l), this.translator.changeLanguage(l), this.isLanguageChangingTo = void 0, this.emit("languageChanged", l), this.logger.log("languageChanged", l)) : this.isLanguageChangingTo = void 0, o.resolve((...c) => this.t(...c)), a && a(s, (...c) => this.t(...c));
    }, i = (s) => {
      !t && !s && this.services.languageDetector && (s = []);
      const l = le(s) ? s : s && s[0], c = this.store.hasLanguageSomeTranslations(l) ? l : this.services.languageUtils.getBestMatchFromCodes(le(s) ? [s] : s);
      c && (this.language || n(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector?.cacheUserLanguage?.(c)), this.loadResources(c, (u) => {
        r(u, c);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? i(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(i) : this.services.languageDetector.detect(i) : i(t), o;
  }
  getFixedT(t, a, o) {
    const n = (r, i, ...s) => {
      let l;
      typeof i != "object" ? l = this.options.overloadTranslationOptionHandler([r, i].concat(s)) : l = {
        ...i
      }, l.lng = l.lng || n.lng, l.lngs = l.lngs || n.lngs, l.ns = l.ns || n.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || o || n.keyPrefix);
      const c = this.options.keySeparator || ".";
      let u;
      return l.keyPrefix && Array.isArray(r) ? u = r.map((d) => (typeof d == "function" && (d = Oc(d, {
        ...this.options,
        ...i
      })), `${l.keyPrefix}${c}${d}`)) : (typeof r == "function" && (r = Oc(r, {
        ...this.options,
        ...i
      })), u = l.keyPrefix ? `${l.keyPrefix}${c}${r}` : r), this.t(u, l);
    };
    return le(t) ? n.lng = t : n.lngs = t, n.ns = a, n.keyPrefix = o, n;
  }
  t(...t) {
    return this.translator?.translate(...t);
  }
  exists(...t) {
    return this.translator?.exists(...t);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t, a = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const o = a.lng || this.resolvedLanguage || this.languages[0], n = this.options ? this.options.fallbackLng : !1, r = this.languages[this.languages.length - 1];
    if (o.toLowerCase() === "cimode") return !0;
    const i = (s, l) => {
      const c = this.services.backendConnector.state[`${s}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (a.precheck) {
      const s = a.precheck(this, i);
      if (s !== void 0) return s;
    }
    return !!(this.hasResourceBundle(o, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || i(o, t) && (!n || i(r, t)));
  }
  loadNamespaces(t, a) {
    const o = yn();
    return this.options.ns ? (le(t) && (t = [t]), t.forEach((n) => {
      this.options.ns.indexOf(n) < 0 && this.options.ns.push(n);
    }), this.loadResources((n) => {
      o.resolve(), a && a(n);
    }), o) : (a && a(), Promise.resolve());
  }
  loadLanguages(t, a) {
    const o = yn();
    le(t) && (t = [t]);
    const n = this.options.preload || [], r = t.filter((i) => n.indexOf(i) < 0 && this.services.languageUtils.isSupportedCode(i));
    return r.length ? (this.options.preload = n.concat(r), this.loadResources((i) => {
      o.resolve(), a && a(i);
    }), o) : (a && a(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language)), !t) return "rtl";
    try {
      const n = new Intl.Locale(t);
      if (n && n.getTextInfo) {
        const r = n.getTextInfo();
        if (r && r.direction) return r.direction;
      }
    } catch {
    }
    const a = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], o = this.services?.languageUtils || new Qh(nm());
    return t.toLowerCase().indexOf("-latn") > 1 ? "ltr" : a.indexOf(o.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(t = {}, a) {
    return new Wn(t, a);
  }
  cloneInstance(t = {}, a = Rr) {
    const o = t.forkResourceStore;
    o && delete t.forkResourceStore;
    const n = {
      ...this.options,
      ...t,
      isClone: !0
    }, r = new Wn(n);
    if ((t.debug !== void 0 || t.prefix !== void 0) && (r.logger = r.logger.clone(t)), ["store", "services", "language"].forEach((s) => {
      r[s] = this[s];
    }), r.services = {
      ...this.services
    }, r.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, o) {
      const s = Object.keys(this.store.data).reduce((l, c) => (l[c] = {
        ...this.store.data[c]
      }, l[c] = Object.keys(l[c]).reduce((u, d) => (u[d] = {
        ...l[c][d]
      }, u), l[c]), l), {});
      r.store = new Zh(s, n), r.services.resourceStore = r.store;
    }
    return r.translator = new Wi(r.services, n), r.translator.on("*", (s, ...l) => {
      r.emit(s, ...l);
    }), r.init(n, a), r.translator.options = n, r.translator.backendConnector.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, r;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const it = Wn.createInstance();
it.createInstance = Wn.createInstance;
const fte = it.createInstance;
it.dir;
it.init;
it.loadResources;
it.reloadResources;
it.use;
it.changeLanguage;
it.getFixedT;
it.t;
it.exists;
it.setDefaultNamespace;
it.hasLoadedNamespace;
it.loadNamespaces;
it.loadLanguages;
const bte = "Studio", _te = "{{count}} soveværelse", vte = "{{count}} soveværelser", yte = "", wte = "{{count}} seng", kte = "{{count}} senge", xte = "Voksne", $te = "Babyer", Ste = "Din kalender er blevet opdateret.", Cte = "En måned", Ete = "Præcise datoer", zte = "Uge", jte = "", Ate = "", Ote = "", Pte = "", Dte = "To uger", Nte = "Annuller", Rte = "Børn", Ite = "Datoer", Tte = "Slet", Mte = "Beskrivelse", Lte = "Destination", Wte = "Sådan!", Bte = "Rediger", Fte = "Enhver form for udveksling", Vte = "Badekar", Ute = "Grill", qte = "Cykel", Hte = "Bil", Gte = "Kat", Kte = "By", Jte = "På landet", Zte = "Opvaskemaskine", Yte = "Hund", Xte = "Tørretumbler", Qte = "Elevator", eae = "Favoritboliger", tae = "Pejs/brændeovn", aae = "Lejlighed", oae = "Privat have", nae = "under {{max}} GP", rae = "fra {{min}} GP", iae = "Mellem {{min}} og {{max}} GP", sae = "Privat fitnessrum", lae = "Hus", cae = "En Ø", uae = "Isoleret", dae = "Jacuzzi", gae = "Søer", hae = "Collection-hjem", mae = "Bjerge", pae = "{{count}} badeværelser", fae = "Andre dyr", bae = "Klaver", _ae = "Legeplads", vae = "Primære bolig", yae = "Gensifig udveksling", wae = "Omvendt søgning", kae = "Flod", xae = "Kystnær", $ae = "Feriebolig", Sae = "TV", Cae = "Landsby", Eae = "Wi-Fi", zae = "Filtre", jae = "Faste datoer", Aae = "En måned i {{date}}", Oae = "En weekend i {{date}}", Pae = "En uge i {{date}}", Dae = "To uger i {{date}}", Nae = "Fleksible datoer", Rae = "Gæster", Iae = "boliger", Tae = "Sidste minut", Mae = "Lokation", Lae = "Rediger", Wae = "Navn", Bae = "Næste", Fae = "", Vae = "", Uae = "{{count}} voksne", qae = "", Hae = "", Gae = "{{count}} babyer", Kae = "", Jae = "", Zae = "{{count}} børn", Yae = "", Xae = "{{count}} gæst", Qae = "{{count}} gæster", eoe = "Telefonnummerets format er ikke gyldigt.", toe = "Modtag e-mailnotifikationer", aoe = "Gem", ooe = "Ingen lokationer fundet", noe = "Flere beskeder", roe = "Rejseliste", ioe = "", soe = "valgfrit", loe = {
  "autocomplete.button": "Søg",
  "autocomplete.placeholder": "Hvor skal du hen ?",
  bedroomsNumbers_zero: bte,
  bedroomsNumbers_one: _te,
  bedroomsNumbers_other: vte,
  beds_zero: yte,
  beds_one: wte,
  beds_other: kte,
  "button.free-signup": "Tilmeld dig gratis",
  "button.validate": "Bekræft",
  "common.try-again": "Prøv igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Må ikke overstige {{limit}} tegn",
  "error.reload": "Opdater siden",
  "error.return-homepage": "Tilbage til startsiden",
  "error.subtitle": "Denne side kan desværre ikke nås..",
  "error.title": "Der opstod en fejl på siden",
  "errors.unable_to_submit.subtitle": '"Din formular kunne desværre ikke \\nindsendes lige nu. Prøv igen \\nsenere."',
  "errors.unable_to_submit.title": "Ups, vi løb ind i et problem",
  "global.back": "Tilbage",
  "global.cancel": "Annuller",
  "global.collection.browsehomes": "Se boliger",
  "global.collection.contactus": "Kontakt os",
  "global.confirm": "Bekræft",
  "global.continue": "Fortsæt",
  "global.getStarted": "Kom godt i gang",
  "global.login": "Log ind",
  "global.select": "Vælg",
  global_adults: xte,
  global_babies: $te,
  global_calendarUpdated_toast: Ste,
  global_calendar_aMonth: Cte,
  global_calendar_exactDates: Ete,
  global_calendar_oneWeek: zte,
  global_calendar_oneWeekend: jte,
  global_calendar_plusMinusDay_zero: Ate,
  global_calendar_plusMinusDay_one: Ote,
  global_calendar_plusMinusDay_other: Pte,
  global_calendar_twoWeeks: Dte,
  global_cancel: Nte,
  global_children: Rte,
  global_dates: Ite,
  global_delete: Tte,
  global_description: Mte,
  global_destination: Lte,
  global_done: Wte,
  global_edit: Bte,
  "global_filter_a-c": "Klimaanlæg",
  global_filter_available: Fte,
  "global_filter_baby-bed": "Babysenge",
  "global_filter_baby-gear": "Babyudstyr",
  "global_filter_balcony-terrace": "Altan/terrasse",
  global_filter_bathtub: Vte,
  global_filter_bbq: Ute,
  global_filter_bicycle: qte,
  global_filter_car: Hte,
  global_filter_cat: Gte,
  "global_filter_children-welcome": "Børn velkomne",
  global_filter_cities: Kte,
  "global_filter_cleaning-person": "Rengøringsperson",
  global_filter_countryside: Jte,
  "global_filter_dedicated-workspace": "Arbejdsområde",
  "global_filter_disabled-access": "Handicapvenlig bolig",
  global_filter_dishwasher: Zte,
  global_filter_dog: Yte,
  global_filter_dryer: Xte,
  "global_filter_eco-level": "Kun bæredygtige boliger",
  "global_filter_electric-car-plug": "Stik til elbil",
  global_filter_elevator: Qte,
  global_filter_favorite: eae,
  global_filter_fireplace: tae,
  global_filter_flat: aae,
  global_filter_garden: oae,
  "global_filter_guest-wanted": "GuestPoints bytte",
  global_filter_guestPointsMax: nae,
  global_filter_guestPointsMin: rae,
  global_filter_guestPointsMinMax: iae,
  global_filter_gym: sae,
  "global_filter_heating-system": "Varmeanlæg",
  "global_filter_high-speed-connexion": "Hurtigt internet",
  global_filter_home: lae,
  "global_filter_home-verified": "Godkendte boliger",
  global_filter_island: cae,
  global_filter_isolated: uae,
  global_filter_jacuzzi: dae,
  "global_filter_kids-toys": "Legetøj til børn",
  global_filter_lakes: gae,
  global_filter_luxury: hae,
  global_filter_mountains: mae,
  "global_filter_no-bed-up": "Ingen midlertidige senge",
  global_filter_numOfBathrooms: pae,
  global_filter_other: fae,
  "global_filter_parking-space": "Privat parkeringsplads",
  "global_filter_pets-welcome": "Kæledyr er velkomne",
  global_filter_piano: bae,
  global_filter_playground: _ae,
  global_filter_primary: vae,
  "global_filter_public-transit-access": "Adgang til offentlig transport",
  global_filter_reciprocal: yae,
  "global_filter_response-rate-above-threshold": "Svarprocent ≥ Gennemsnitlig",
  global_filter_reverse: wae,
  global_filter_river: kae,
  global_filter_seaside: xae,
  global_filter_secondary: $ae,
  "global_filter_secured-pool": "Sikret pool",
  "global_filter_smokers-welcome": "Rygere er velkomne",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: Sae,
  global_filter_villages: Cae,
  "global_filter_washing-machine": "Vaskemaskine",
  "global_filter_whole-unit": "Hele enheden",
  global_filter_wifi: Eae,
  global_filters: zae,
  global_fixDates: jae,
  global_flexDates_aMonth: Aae,
  global_flexDates_aWeekend: Oae,
  global_flexDates_oneWeek: Pae,
  global_flexDates_twoWeek: Dae,
  global_flexibleDates: Nae,
  global_guests: Rae,
  global_homes: Iae,
  global_lastMinute: Tae,
  global_location: Mae,
  global_modify: Lae,
  global_name: Wae,
  global_next: Bae,
  global_numberOfAdults_zero: Fae,
  global_numberOfAdults_one: Vae,
  global_numberOfAdults_other: Uae,
  global_numberOfBabies_zero: qae,
  global_numberOfBabies_one: Hae,
  global_numberOfBabies_other: Gae,
  global_numberOfChildren_zero: Kae,
  global_numberOfChildren_one: Jae,
  global_numberOfChildren_other: Zae,
  global_numberOfGuests_zero: Yae,
  global_numberOfGuests_one: Xae,
  global_numberOfGuests_other: Qae,
  global_phoneNumber_notValid: eoe,
  global_receiveEmailAlerts: toe,
  global_save: aoe,
  global_searchBar_noLocationFound: ooe,
  global_seeMore_link: noe,
  global_travelWishlist: roe,
  "modal.error-occured.content": "Vi beklager ulejligheden, men prøv \\nvenligst igen.",
  "modal.error-occured.title": "Åh nej, der er opstået en fejl!",
  no_result: ioe,
  optional: soe,
  "privacy-policy": "Privatpolitik"
}, coe = "Kontakt os", uoe = "FAQ", doe = "Garantier", goe = "GuestPoints", hoe = "Hjælp", moe = "Log out", poe = "Messages", foe = "Settings", boe = {
  "about-the-calendar": "Kalenderen",
  "add-home": "Add a home",
  contact: coe,
  faq: uoe,
  guarantees: doe,
  guestpoints: goe,
  help: hoe,
  "how-it-works": "Hvordan virker det?",
  "how-much-does-it-cost": "Hvor meget koster det?",
  logout: moe,
  messages: poe,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: foe,
  "sign-in": "Log ind",
  "sign-up": "Tilmeld dig",
  "sign-up-for-free": "Tilmeld dig gratis",
  "signin.modal.apple-button": "Log ind med Apple",
  "signin.modal.facebook-button": "Log ind med Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, _oe = "https://www.homeexchange.com/blog/", voe = "/p/general-terms-of-use", yoe = "https://www.homeexchange.com/da/p/community-da", woe = "https://homeexchangehelp.zendesk.com/hc/en-us", koe = "", xoe = "https://www.homeexchange.com/da/p/service-homeexchange-da", $oe = "https://www.homeexchange.com/da/p/guestpoints-da", Soe = "https://www.homeexchange.com/da/p/press-da", Coe = "https://www.homeexchange.com/p/fortalt-af-medlemmerne", Eoe = "", zoe = "", joe = "https://www.homeexchange.com/da/p/hvor-velkomsten-virkelig-begynder", Aoe = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/da/p/about-us-da",
  blog: _oe,
  cgu: voe,
  community: yoe,
  "contact-us": "https://www.homeexchange.com/da/kontakt-os-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: woe,
  forum: koe,
  guarantees: xoe,
  guestpoints: $oe,
  "happiness-team": "https://www.homeexchange.com/da/p/happiness-team-da",
  "how-it-works": "https://www.homeexchange.com/da/p/hvordan-virker-det",
  "join-us": "https://www.homeexchange.com/da/p/join-us-da",
  "legal-notice": "/p/juridiske-vilkaar",
  "mobile-app": "https://www.homeexchange.com/da/p/mobil-app",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: Soe,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/da/p/subscription-homeexchange-da",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: Coe,
  travelWishlist_faq_links: Eoe,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: zoe,
  values: joe
}, Ooe = "Studio", Poe = "{{count}} schlafzimmer", Doe = "{{count}} schlafzimmer", Noe = "", Roe = "{{count}} Bett", Ioe = "{{count}} Betten", Toe = "Erwachsene", Moe = "Babys", Loe = "Ihr Kalender wurde aktualisiert.", Woe = "Ein Monat", Boe = "Genaue Daten", Foe = "Eine Woche", Voe = "Ein Wochenende", Uoe = "", qoe = "± {{count}} Tag", Hoe = "± {{count}} Tage", Goe = "Zwei Wochen", Koe = "Abbrechen", Joe = "Kinder", Zoe = "Daten", Yoe = "Löschen", Xoe = "Beschreibung", Qoe = "Reiseziel", ene = "Fertig!", tne = "Bearbeiten", ane = "Jede Tauschanfrage", one = "Badewanne", nne = "Grill", rne = "Fahrrad", ine = "Auto", sne = "Katze", lne = "Stadt", cne = "Auf dem Land", une = "Geschirrspüler", dne = "Hund", gne = "Trockner", hne = "Aufzug", mne = "Lieblingshäuser", pne = "Kamin", fne = "Apartment", bne = "Privater Garten", _ne = "weniger als {{max}} GP", vne = "von {{min}} GP", yne = "Zwischen {{min}} und {{max}} GP", wne = "Privater Fitnessraum", kne = "Haus", xne = "Insel", $ne = "Abgelegen", Sne = "Whirlpool", Cne = "See", Ene = "Häuser der Collection", zne = "Berge", jne = "{{count}} Badezimmer", Ane = "Andere Tiere", One = "Klavier", Pne = "Spielplatz", Dne = "Hauptwohnung", Nne = "Gegenseitiger Austausch", Rne = "Umgekehrte Suche", Ine = "Fluss", Tne = "An der Küste", Mne = "Zweitwohnung", Lne = "Fernseher", Wne = "Dorf", Bne = "WLAN", Fne = "Filter", Vne = "Feste Daten", Une = "Eine Woche im {{date}}", qne = "Ein Wochenende im {{date}}", Hne = "Eine Woche im {{date}}", Gne = "Zwei Wochen im {{date}}", Kne = "Flexible Daten", Jne = "Gäste", Zne = "Unterkünfte", Yne = "Last Minute", Xne = "Ort", Qne = "Ändern", ere = "Name", tre = "Weiter", are = "", ore = "{{count}} Erwachsener", nre = "{{count}} Erwachsene", rre = "", ire = "{{count}} Baby", sre = "{{count}} Babys", lre = "", cre = "{{count}} Kind", ure = "{{count}} Kinder", dre = "", gre = "{{count}} Gast", hre = "{{count}} Gäste", mre = "Das Format der Telefonnummer ist ungültig.", pre = "Benachrichtigungen per E-Mail erhalten", fre = "Speichern", bre = "Kein Reiseziel gefunden", _re = "Mehr anzeigen", vre = "Reiseprojekte", yre = "", wre = "optional", kre = {
  "autocomplete.button": "Suchen",
  "autocomplete.placeholder": "Wo gehst du hin ?",
  bedroomsNumbers_zero: Ooe,
  bedroomsNumbers_one: Poe,
  bedroomsNumbers_other: Doe,
  beds_zero: Noe,
  beds_one: Roe,
  beds_other: Ioe,
  "button.free-signup": "Kostenlos anmelden",
  "button.validate": "Bestätigen",
  "common.try-again": "Erneut versuchen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Darf {{limit}} Zeichen nicht überschreiten",
  "error.reload": "Aktualisieren Sie diese Seite",
  "error.return-homepage": "Zurück zur Startseite",
  "error.subtitle": "Leider ist diese Seite nicht erreichbar.",
  "error.title": "Es ist ein Fehler auf der Seite aufgetreten.",
  "errors.unable_to_submit.subtitle": "Leider konnte Ihr Formular im Moment nicht abgeschickt werden. Bitte versuchen Sie es später noch einmal.",
  "errors.unable_to_submit.title": "Hoppla, wir haben ein Problem",
  "global.back": "Zurück",
  "global.cancel": "Abbrechen",
  "global.collection.browsehomes": "Unterkünfte durchstöbern",
  "global.collection.contactus": "Kontaktieren Sie uns",
  "global.confirm": "Bestätigen",
  "global.continue": "Weiter",
  "global.getStarted": "Los geht's",
  "global.login": "Anmelden",
  "global.select": "Auswählen",
  global_adults: Toe,
  global_babies: Moe,
  global_calendarUpdated_toast: Loe,
  global_calendar_aMonth: Woe,
  global_calendar_exactDates: Boe,
  global_calendar_oneWeek: Foe,
  global_calendar_oneWeekend: Voe,
  global_calendar_plusMinusDay_zero: Uoe,
  global_calendar_plusMinusDay_one: qoe,
  global_calendar_plusMinusDay_other: Hoe,
  global_calendar_twoWeeks: Goe,
  global_cancel: Koe,
  global_children: Joe,
  global_dates: Zoe,
  global_delete: Yoe,
  global_description: Xoe,
  global_destination: Qoe,
  global_done: ene,
  global_edit: tne,
  "global_filter_a-c": "Klimaanlage",
  global_filter_available: ane,
  "global_filter_baby-bed": "Babybetten",
  "global_filter_baby-gear": "Babyausstattung",
  "global_filter_balcony-terrace": "Balkon / Terrasse",
  global_filter_bathtub: one,
  global_filter_bbq: nne,
  global_filter_bicycle: rne,
  global_filter_car: ine,
  global_filter_cat: sne,
  "global_filter_children-welcome": "Kinder willkommen",
  global_filter_cities: lne,
  "global_filter_cleaning-person": "Reinigungskraft",
  global_filter_countryside: cne,
  "global_filter_dedicated-workspace": "Spezieller Arbeitsbereich",
  "global_filter_disabled-access": "Barrierefreie Unterkunft",
  global_filter_dishwasher: une,
  global_filter_dog: dne,
  global_filter_dryer: gne,
  "global_filter_eco-level": "Nur nachhaltige Häuser",
  "global_filter_electric-car-plug": "Steckdose für Elektroautos",
  global_filter_elevator: hne,
  global_filter_favorite: mne,
  global_filter_fireplace: pne,
  global_filter_flat: fne,
  global_filter_garden: bne,
  "global_filter_guest-wanted": "Austausch gegen GuestPoints",
  global_filter_guestPointsMax: _ne,
  global_filter_guestPointsMin: vne,
  global_filter_guestPointsMinMax: yne,
  global_filter_gym: wne,
  "global_filter_heating-system": "Heizung",
  "global_filter_high-speed-connexion": "Hochgeschwindigkeitsverbindung",
  global_filter_home: kne,
  "global_filter_home-verified": "Verifizierte Unterkünfte",
  global_filter_island: xne,
  global_filter_isolated: $ne,
  global_filter_jacuzzi: Sne,
  "global_filter_kids-toys": "Kinderspielzeug",
  global_filter_lakes: Cne,
  global_filter_luxury: Ene,
  global_filter_mountains: zne,
  "global_filter_no-bed-up": "Keine Zustellbetten",
  global_filter_numOfBathrooms: jne,
  global_filter_other: Ane,
  "global_filter_parking-space": "Privater Parkplatz",
  "global_filter_pets-welcome": "Haustiere willkommen",
  global_filter_piano: One,
  global_filter_playground: Pne,
  global_filter_primary: Dne,
  "global_filter_public-transit-access": "Zugang zu öffentlichen Verkehrsmitteln",
  global_filter_reciprocal: Nne,
  "global_filter_response-rate-above-threshold": "Antwortrate ≥ Mittel",
  global_filter_reverse: Rne,
  global_filter_river: Ine,
  global_filter_seaside: Tne,
  global_filter_secondary: Mne,
  "global_filter_secured-pool": "Gesicherter Pool",
  "global_filter_smokers-welcome": "Rauchen erlaubt",
  "global_filter_swimming-pool": "Swimmingpool",
  global_filter_tv: Lne,
  global_filter_villages: Wne,
  "global_filter_washing-machine": "Waschmaschine",
  "global_filter_whole-unit": "Die ganze Wohnung",
  global_filter_wifi: Bne,
  global_filters: Fne,
  global_fixDates: Vne,
  global_flexDates_aMonth: Une,
  global_flexDates_aWeekend: qne,
  global_flexDates_oneWeek: Hne,
  global_flexDates_twoWeek: Gne,
  global_flexibleDates: Kne,
  global_guests: Jne,
  global_homes: Zne,
  global_lastMinute: Yne,
  global_location: Xne,
  global_modify: Qne,
  global_name: ere,
  global_next: tre,
  global_numberOfAdults_zero: are,
  global_numberOfAdults_one: ore,
  global_numberOfAdults_other: nre,
  global_numberOfBabies_zero: rre,
  global_numberOfBabies_one: ire,
  global_numberOfBabies_other: sre,
  global_numberOfChildren_zero: lre,
  global_numberOfChildren_one: cre,
  global_numberOfChildren_other: ure,
  global_numberOfGuests_zero: dre,
  global_numberOfGuests_one: gre,
  global_numberOfGuests_other: hre,
  global_phoneNumber_notValid: mre,
  global_receiveEmailAlerts: pre,
  global_save: fre,
  global_searchBar_noLocationFound: bre,
  global_seeMore_link: _re,
  global_travelWishlist: vre,
  "modal.error-occured.content": "Wir entschuldigen uns für die Unannehmlichkeiten, bitte versuchen Sie es noch einmal.",
  "modal.error-occured.title": "Oh nein, es ist ein Fehler aufgetreten!",
  no_result: yre,
  optional: wre,
  "privacy-policy": "Datenschutz"
}, xre = "Kontaktieren Sie uns", $re = "FAQ", Sre = "Garantien", Cre = "GuestPoints", Ere = "Hilfe", zre = "Log out", jre = "Messages", Are = "Settings", Ore = {
  "about-the-calendar": "Kalender",
  "add-home": "Add a home",
  contact: xre,
  faq: $re,
  guarantees: Sre,
  guestpoints: Cre,
  help: Ere,
  "how-it-works": "Wie funktioniert es?",
  "how-much-does-it-cost": "Wieviel kostet es?",
  logout: zre,
  messages: jre,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: Are,
  "sign-in": "Einloggen",
  "sign-up": "Anmelden",
  "sign-up-for-free": "Kostenlos anmelden",
  "signin.modal.apple-button": "Melden Sie sich mit Apple an",
  "signin.modal.facebook-button": "Mit Facebook anmelden",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, Pre = "https://www.homeexchange.com/de/blog/", Dre = "/de/p/homeexchangenutzungsbedingungen", Nre = "https://www.homeexchange.com/de/p/our-community-de", Rre = "https://homeexchangehelp.zendesk.com/hc/de", Ire = "", Tre = "https://www.homeexchange.com/de/p/service-homeexchange-de", Mre = "https://www.homeexchange.com/de/p/guestpoints-de", Lre = "https://www.homeexchange.com/de/p/press-de", Wre = "https://www.homeexchange.com/p/worte-homeexchanger", Bre = "https://help.homeexchange.com/hc/de/articles/360000623717-Bevorzugte-Tausch-Destinationen", Fre = "", Vre = "https://www.homeexchange.com/de/p/wo-die-begrubung-wirklich-beginnt", Ure = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/de/p/about-us-de",
  blog: Pre,
  cgu: Dre,
  community: Nre,
  "contact-us": "https://www.homeexchange.com/de/kontakt-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeDE/",
  faq: Rre,
  forum: Ire,
  guarantees: Tre,
  guestpoints: Mre,
  "happiness-team": "https://www.homeexchange.com/de/p/happiness-team-de",
  "how-it-works": "https://www.homeexchange.com/de/p/so-funktioniert-es-de",
  "join-us": "https://www.homeexchange.com/de/p/join-us-de",
  "legal-notice": "/p/impressum",
  "mobile-app": "https://www.homeexchange.com/de/p/homeexchange-mobile-app",
  "our-team": "https://www.homeexchange.com/de/p/unser-team",
  press: Lre,
  "privacy-policy": "/p/homeexchange-datenschutz",
  "subscription-cost": "https://www.homeexchange.com/de/p/subscription-homeexchange-de",
  "term-of-use": "/p/homeexchangenutzungsbedingungen",
  testimonials: Wre,
  travelWishlist_faq_links: Bre,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: Fre,
  values: Vre
}, qre = "Studio", Hre = "{{count}} bedroom", Gre = "{{count}} bedrooms", Kre = "", Jre = "{{count}} bed", Zre = "{{count}} beds", Yre = "Adults", Xre = "Babies", Qre = "Your calendar has been updated.", eie = "A month", tie = "Exact dates", aie = "One week", oie = "One weekend", nie = "", rie = "± {{count}} day", iie = "± {{count}} days", sie = "Two weeks", lie = "Cancel", cie = "Children", uie = "Dates", die = "Delete", gie = "Description", hie = "Destination", mie = "Done!", pie = "Edit", fie = "Any type of exchange", bie = "Bathtub", _ie = "BBQ", vie = "Bicycle", yie = "Car", wie = "Cat", kie = "City", xie = "Countryside", $ie = "Dishwasher", Sie = "Dog", Cie = "Dryer", Eie = "Elevator", zie = "Favorite homes", jie = "Fireplace", Aie = "Apartment", Oie = "Private backyard", Pie = "less than {{max}} GP", Die = "from {{min}} GP", Nie = "Between {{min}} and {{max}} GP", Rie = "Private gym", Iie = "House", Tie = "Island", Mie = "Isolated", Lie = "Jacuzzi", Wie = "Lake", Bie = "Collection homes", Fie = "Mountain", Vie = "{{count}} bathrooms", Uie = "Other animals", qie = "Piano", Hie = "Kid's playground", Gie = "Primary", Kie = "Reciprocal exchange", Jie = "Reverse search", Zie = "River", Yie = "Coastal", Xie = "Secondary", Qie = "TV", ese = "Village", tse = "WiFi", ase = "Filters", ose = "Fixed dates", nse = "A month in {{date}}", rse = "A Week-end in {{date}}", ise = "One week in {{date}}", sse = "Two weeks in {{date}}", lse = "Flexible dates", cse = "Guests", use = "homes", dse = "Last minute", gse = "Location", hse = "Modify", mse = "Name", pse = "Next", fse = "", bse = "{{count}} adult", _se = "{{count}} adults", vse = "", yse = "{{count}} baby", wse = "{{count}} babies", kse = "", xse = "{{count}} child", $se = "{{count}} children", Sse = "{{count}} guest", Cse = "{{count}} guest", Ese = "{{count}} guests", zse = "The phone number format is not valid", jse = "Receive email alerts", Ase = "Save", Ose = "No locations found", Pse = "See more", Dse = "Travel wishlist", Nse = "No result", Rse = "optional", Ise = {
  "autocomplete.button": "Search",
  "autocomplete.placeholder": "Where are you going ?",
  bedroomsNumbers_zero: qre,
  bedroomsNumbers_one: Hre,
  bedroomsNumbers_other: Gre,
  beds_zero: Kre,
  beds_one: Jre,
  beds_other: Zre,
  "button.free-signup": "Sign up for free",
  "button.validate": "Validate",
  "common.try-again": "Try again",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Must not exceed {{limit}} characters",
  "error.reload": "Refresh this page",
  "error.return-homepage": "Return to home page",
  "error.subtitle": "Unfortunately this page can't be reached.",
  "error.title": "An error occurred on the page",
  "errors.unable_to_submit.subtitle": "Unfortunately your form couldn't be submitted right now. Please try again later.",
  "errors.unable_to_submit.title": "Oops, we've hit a problem",
  "global.back": "Back",
  "global.cancel": "Cancel",
  "global.collection.browsehomes": "Browse Homes",
  "global.collection.contactus": "Contact us",
  "global.confirm": "Confirm",
  "global.continue": "Continue",
  "global.getStarted": "Get started",
  "global.login": "Log in",
  "global.select": "Select",
  global_adults: Yre,
  global_babies: Xre,
  global_calendarUpdated_toast: Qre,
  global_calendar_aMonth: eie,
  global_calendar_exactDates: tie,
  global_calendar_oneWeek: aie,
  global_calendar_oneWeekend: oie,
  global_calendar_plusMinusDay_zero: nie,
  global_calendar_plusMinusDay_one: rie,
  global_calendar_plusMinusDay_other: iie,
  global_calendar_twoWeeks: sie,
  global_cancel: lie,
  global_children: cie,
  global_dates: uie,
  global_delete: die,
  global_description: gie,
  global_destination: hie,
  global_done: mie,
  global_edit: pie,
  "global_filter_a-c": "A/C",
  global_filter_available: fie,
  "global_filter_baby-bed": "Baby cribs",
  "global_filter_baby-gear": "Baby gear",
  "global_filter_balcony-terrace": "Balcony/Terrace",
  global_filter_bathtub: bie,
  global_filter_bbq: _ie,
  global_filter_bicycle: vie,
  global_filter_car: yie,
  global_filter_cat: wie,
  "global_filter_children-welcome": "Children welcome",
  global_filter_cities: kie,
  "global_filter_cleaning-person": "Cleaning person",
  global_filter_countryside: xie,
  "global_filter_dedicated-workspace": "Dedicated workspace",
  "global_filter_disabled-access": "Accessible home",
  global_filter_dishwasher: $ie,
  global_filter_dog: Sie,
  global_filter_dryer: Cie,
  "global_filter_eco-level": "Only sustainable homes",
  "global_filter_electric-car-plug": "Electric car plug",
  global_filter_elevator: Eie,
  global_filter_favorite: zie,
  global_filter_fireplace: jie,
  global_filter_flat: Aie,
  global_filter_garden: Oie,
  "global_filter_guest-wanted": "GuestPoints exchange",
  global_filter_guestPointsMax: Pie,
  global_filter_guestPointsMin: Die,
  global_filter_guestPointsMinMax: Nie,
  global_filter_gym: Rie,
  "global_filter_heating-system": "Heating system",
  "global_filter_high-speed-connexion": "High speed connection",
  global_filter_home: Iie,
  "global_filter_home-verified": "Verified homes",
  global_filter_island: Tie,
  global_filter_isolated: Mie,
  global_filter_jacuzzi: Lie,
  "global_filter_kids-toys": "Kids toys",
  global_filter_lakes: Wie,
  global_filter_luxury: Bie,
  global_filter_mountains: Fie,
  "global_filter_no-bed-up": "No temporary beds",
  global_filter_numOfBathrooms: Vie,
  global_filter_other: Uie,
  "global_filter_parking-space": "Private parking space",
  "global_filter_pets-welcome": "Pets welcome",
  global_filter_piano: qie,
  global_filter_playground: Hie,
  global_filter_primary: Gie,
  "global_filter_public-transit-access": "Public transport access",
  global_filter_reciprocal: Kie,
  "global_filter_response-rate-above-threshold": "Response rate ≥ Average",
  global_filter_reverse: Jie,
  global_filter_river: Zie,
  global_filter_seaside: Yie,
  global_filter_secondary: Xie,
  "global_filter_secured-pool": "Secured pool",
  "global_filter_smokers-welcome": "Smokers welcome",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: Qie,
  global_filter_villages: ese,
  "global_filter_washing-machine": "Washing machine",
  "global_filter_whole-unit": "Entire home",
  global_filter_wifi: tse,
  global_filters: ase,
  global_fixDates: ose,
  global_flexDates_aMonth: nse,
  global_flexDates_aWeekend: rse,
  global_flexDates_oneWeek: ise,
  global_flexDates_twoWeek: sse,
  global_flexibleDates: lse,
  global_guests: cse,
  global_homes: use,
  global_lastMinute: dse,
  global_location: gse,
  global_modify: hse,
  global_name: mse,
  global_next: pse,
  global_numberOfAdults_zero: fse,
  global_numberOfAdults_one: bse,
  global_numberOfAdults_other: _se,
  global_numberOfBabies_zero: vse,
  global_numberOfBabies_one: yse,
  global_numberOfBabies_other: wse,
  global_numberOfChildren_zero: kse,
  global_numberOfChildren_one: xse,
  global_numberOfChildren_other: $se,
  global_numberOfGuests_zero: Sse,
  global_numberOfGuests_one: Cse,
  global_numberOfGuests_other: Ese,
  global_phoneNumber_notValid: zse,
  global_receiveEmailAlerts: jse,
  global_save: Ase,
  global_searchBar_noLocationFound: Ose,
  global_seeMore_link: Pse,
  global_travelWishlist: Dse,
  "modal.error-occured.content": "We're so sorry for the inconvenience, but please do try again.",
  "modal.error-occured.title": "Oh no, an error has occurred!",
  no_result: Nse,
  optional: Rse,
  "privacy-policy": "Privacy Policy"
}, Tse = "Contact us", Mse = "FAQ", Lse = "Guarantees", Wse = "GuestPoints", Bse = "Help", Fse = "Log out", Vse = "Messages", Use = "Settings", qse = {
  "about-the-calendar": "Calendar",
  "add-home": "Add a home",
  contact: Tse,
  faq: Mse,
  guarantees: Lse,
  guestpoints: Wse,
  help: Bse,
  "how-it-works": "How does it work?",
  "how-much-does-it-cost": "How much does it cost?",
  logout: Fse,
  messages: Vse,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "Complete your home!",
  "notification.home.complete_home_first_time": "Complete your home and earn {{gp}} GuestPoints!",
  "notification.home.empty_calendar": "Add availability to your calendar for the coming year",
  "notification.home.new_calendar_type": "New calendar!",
  "notification.home.offline": "Publish your home!",
  "notification.membership.expired": "Membership expired",
  "notification.membership.lead": "Activate your membership and receive {{gp}} GuestPoints",
  "notification.user_profile.incomplete": "Complete your profile!",
  "notification.user_profile.motivate_incomplete": "Complete your profile and earn {{gp}} GuestPoints!",
  "refer-your-friends": "Refer your friends",
  settings: Use,
  "sign-in": "Sign in",
  "sign-up": "Sign up",
  "sign-up-for-free": "Sign up for free",
  "signin.modal.apple-button": "Sign in with Apple",
  "signin.modal.facebook-button": "Sign in with Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, Hse = "https://www.homeexchange.com/blog/", Gse = "/p/general-terms-of-use", Kse = "https://www.homeexchange.com/p/community", Jse = "https://homeexchangehelp.zendesk.com/hc/en-us", Zse = "https://forum.homeexchange.com/c/english/20", Yse = "https://www.homeexchange.com/p/service-homeexchange-en", Xse = "https://www.homeexchange.com/p/guestpoints-en", Qse = "https://www.homeexchange.com/p/press", ele = "https://www.homeexchange.com/p/words-of-homeexchanges", tle = "https://help.homeexchange.com/hc/en-us/articles/360000623717-What-are-My-Preferred-Destinations-and-how-do-I-use-them", ale = "https://www.homeexchange.com/p/where-the-welcome-really-begins", ole = "https://www.homeexchange.com/p/where-the-welcome-really-begins", nle = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/p/about-us",
  blog: Hse,
  cgu: Gse,
  community: Kse,
  "contact-us": "https://www.homeexchange.com/contact-us-homeexchange",
  "cookie-policy": "/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: Jse,
  forum: Zse,
  guarantees: Yse,
  guestpoints: Xse,
  "happiness-team": "https://www.homeexchange.com/p/happiness-team",
  "how-it-works": "https://www.homeexchange.com/p/how-it-works-en",
  "join-us": "https://www.homeexchange.com/p/join-us",
  "legal-notice": "/p/legal-notice",
  "mobile-app": "https://www.homeexchange.com/p/mobile-apps",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: Qse,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/p/subscription-homeexchange",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: ele,
  travelWishlist_faq_links: tle,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: ale,
  values: ole
}, rle = "Estudio", ile = "{{count}} dormitorio", sle = "{{count}} dormitorios", lle = "", cle = "{{count}} cama", ule = "{{count}} camas", dle = "", gle = "", hle = "Tu calendario ha sido actualizado.", mle = "Un mes", ple = "Fechas exactas", fle = "Una semana", ble = "Un fin de semana", _le = "", vle = "± {{count}} día", yle = "± {{count}} días", wle = "Dos semanas", kle = "Cancelar", xle = "", $le = "Fechas", Sle = "Eliminar", Cle = "Descripción", Ele = "Destino", zle = "¡Listo!", jle = "Editar", Ale = "Cualquier tipo de intercambio", Ole = "Bañera", Ple = "Barbacoa", Dle = "Bicicleta", Nle = "Coche", Rle = "Gato", Ile = "Ciudad", Tle = "Campo", Mle = "Lavavajillas", Lle = "Perro", Wle = "Secadora", Ble = "Ascensor", Fle = "Casas favoritas", Vle = "Chimenea", Ule = "Piso", qle = "Patio privado", Hle = "", Gle = "", Kle = "", Jle = "", Zle = "Casa", Yle = "Isla", Xle = "Aislado", Qle = "Jacuzzi", ece = "Lagos", tce = "Casas Collection", ace = "", oce = "{{count}} baños", nce = "Otros animales", rce = "Piano", ice = "Columpios", sce = "Principal", lce = "Intercambio recíproco", cce = "Búsqueda inversa", uce = "Río", dce = "En la costa", gce = "Secundaria", hce = "TV", mce = "Pueblo", pce = "WiFi", fce = "Filtros", bce = "Fechas fijas", _ce = "Un mes en {{date}}", vce = "Un fin de semana en {{date}}", yce = "Una semana en {{date}}", wce = "Dos semanas en {{date}}", kce = "Fechas flexibles", xce = "Invitados", $ce = "casas", Sce = "Último minuto", Cce = "Ubicación", Ece = "Modificar", zce = "Nombre", jce = "Siguiente", Ace = "", Oce = "{{count}} adulto", Pce = "{{count}} adultos", Dce = "", Nce = "{{count}} bebé", Rce = "bebé", Ice = "", Tce = "{{count}} niño/a", Mce = "{{count}} niños", Lce = "", Wce = "{{count}} invitado/a", Bce = "{{count}} invitados", Fce = "El formato del número de teléfono no es válido.", Vce = "Recibir notificaciones por correo electrónico", Uce = "Guardar", qce = "No encontramos este lugar", Hce = "Ver más", Gce = "Proyectos de viaje", Kce = "", Jce = "opcional", Zce = {
  "autocomplete.button": "Buscar",
  "autocomplete.placeholder": "¿Adónde vas?",
  bedroomsNumbers_zero: rle,
  bedroomsNumbers_one: ile,
  bedroomsNumbers_other: sle,
  beds_zero: lle,
  beds_one: cle,
  beds_other: ule,
  "button.free-signup": "Regístrate gratis",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "No puedes superar los {{limit}} caracteres",
  "error.reload": "Actualizar esta página",
  "error.return-homepage": "Volver a la página de inicio",
  "error.subtitle": "Lo sentimos, pero no se puede acceder a esta página.",
  "error.title": "Se ha producido un error en la página",
  "errors.unable_to_submit.subtitle": "Lo sentimos, se ha producido un error al enviar el formulario. Por favor, vuelve a intentarlo más tarde.",
  "errors.unable_to_submit.title": "¡Vaya! Algo ha fallado.",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Continuar",
  "global.getStarted": "",
  "global.login": "Iniciar sesión",
  "global.select": "Selecciona",
  global_adults: dle,
  global_babies: gle,
  global_calendarUpdated_toast: hle,
  global_calendar_aMonth: mle,
  global_calendar_exactDates: ple,
  global_calendar_oneWeek: fle,
  global_calendar_oneWeekend: ble,
  global_calendar_plusMinusDay_zero: _le,
  global_calendar_plusMinusDay_one: vle,
  global_calendar_plusMinusDay_other: yle,
  global_calendar_twoWeeks: wle,
  global_cancel: kle,
  global_children: xle,
  global_dates: $le,
  global_delete: Sle,
  global_description: Cle,
  global_destination: Ele,
  global_done: zle,
  global_edit: jle,
  "global_filter_a-c": "Aire acondicionado",
  global_filter_available: Ale,
  "global_filter_baby-bed": "",
  "global_filter_baby-gear": "Equipamiento para bebés",
  "global_filter_balcony-terrace": "Balcón/Terraza",
  global_filter_bathtub: Ole,
  global_filter_bbq: Ple,
  global_filter_bicycle: Dle,
  global_filter_car: Nle,
  global_filter_cat: Rle,
  "global_filter_children-welcome": "Niños bienvenidos",
  global_filter_cities: Ile,
  "global_filter_cleaning-person": "Señor/a de la limpieza",
  global_filter_countryside: Tle,
  "global_filter_dedicated-workspace": "Escritorio para trabajar",
  "global_filter_disabled-access": "Casas accesibles",
  global_filter_dishwasher: Mle,
  global_filter_dog: Lle,
  global_filter_dryer: Wle,
  "global_filter_eco-level": "Solo viviendas sostenibles",
  "global_filter_electric-car-plug": "Enchufe para coches eléctricos",
  global_filter_elevator: Ble,
  global_filter_favorite: Fle,
  global_filter_fireplace: Vle,
  global_filter_flat: Ule,
  global_filter_garden: qle,
  "global_filter_guest-wanted": "Intercambio con GuestPoints",
  global_filter_guestPointsMax: Hle,
  global_filter_guestPointsMin: Gle,
  global_filter_guestPointsMinMax: Kle,
  global_filter_gym: Jle,
  "global_filter_heating-system": "Calefacción",
  "global_filter_high-speed-connexion": "Conexión de alta velocidad",
  global_filter_home: Zle,
  "global_filter_home-verified": "Casas verificadas",
  global_filter_island: Yle,
  global_filter_isolated: Xle,
  global_filter_jacuzzi: Qle,
  "global_filter_kids-toys": "",
  global_filter_lakes: ece,
  global_filter_luxury: tce,
  global_filter_mountains: ace,
  "global_filter_no-bed-up": "Sin camas provisionales",
  global_filter_numOfBathrooms: oce,
  global_filter_other: nce,
  "global_filter_parking-space": "",
  "global_filter_pets-welcome": "Mascotas bienvenidas",
  global_filter_piano: rce,
  global_filter_playground: ice,
  global_filter_primary: sce,
  "global_filter_public-transit-access": "",
  global_filter_reciprocal: lce,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: cce,
  global_filter_river: uce,
  global_filter_seaside: dce,
  global_filter_secondary: gce,
  "global_filter_secured-pool": "Piscina segura",
  "global_filter_smokers-welcome": "Fumadores bienvenidos",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: hce,
  global_filter_villages: mce,
  "global_filter_washing-machine": "Lavadora",
  "global_filter_whole-unit": "",
  global_filter_wifi: pce,
  global_filters: fce,
  global_fixDates: bce,
  global_flexDates_aMonth: _ce,
  global_flexDates_aWeekend: vce,
  global_flexDates_oneWeek: yce,
  global_flexDates_twoWeek: wce,
  global_flexibleDates: kce,
  global_guests: xce,
  global_homes: $ce,
  global_lastMinute: Sce,
  global_location: Cce,
  global_modify: Ece,
  global_name: zce,
  global_next: jce,
  global_numberOfAdults_zero: Ace,
  global_numberOfAdults_one: Oce,
  global_numberOfAdults_other: Pce,
  global_numberOfBabies_zero: Dce,
  global_numberOfBabies_one: Nce,
  global_numberOfBabies_other: Rce,
  global_numberOfChildren_zero: Ice,
  global_numberOfChildren_one: Tce,
  global_numberOfChildren_other: Mce,
  global_numberOfGuests_zero: Lce,
  global_numberOfGuests_one: Wce,
  global_numberOfGuests_other: Bce,
  global_phoneNumber_notValid: Fce,
  global_receiveEmailAlerts: Vce,
  global_save: Uce,
  global_searchBar_noLocationFound: qce,
  global_seeMore_link: Hce,
  global_travelWishlist: Gce,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: Kce,
  optional: Jce,
  "privacy-policy": "Política de Privacidad"
}, Yce = "Contacte con nosotros", Xce = "Preguntas frecuentes", Qce = "Guarantías", eue = "GuestPoints", tue = "Ayuda", aue = "Log out", oue = "Messages", nue = "Settings", rue = {
  "about-the-calendar": "Calendario",
  "add-home": "Add a home",
  contact: Yce,
  faq: Xce,
  guarantees: Qce,
  guestpoints: eue,
  help: tue,
  "how-it-works": "¿Cómo funciona?",
  "how-much-does-it-cost": "¿Cuánto cuesta?",
  logout: aue,
  messages: oue,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: nue,
  "sign-in": "Inicia sesión",
  "sign-up": "Regístrate",
  "sign-up-for-free": "Regístrate gratis",
  "signin.modal.apple-button": "Inicia sesión con Apple",
  "signin.modal.facebook-button": "Inicia sesión con Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, iue = "https://www.homeexchange.com/es/blog/", sue = "/es/p/homeexchange-condiciones-de-uso", lue = "https://www.homeexchange.com/es/p/nuestra-comunidad-es", cue = "https://homeexchangehelp.zendesk.com/hc/es", uue = "https://forum.homeexchange.com/c/espanol/22", due = "https://www.homeexchange.com/es/p/service-homeexchange-es", gue = "https://www.homeexchange.com/es/p/los-guestpoints", hue = "https://www.homeexchange.com/es/p/prensa", mue = "https://www.homeexchange.com/p/palabra-de-homeexchanger", pue = "", fue = "https://www.homeexchange.com/es/p/principios-intercambio-casa", bue = "https://www.homeexchange.com/es/p/principios-intercambio-casa", _ue = {
  "about-calendar": "https://help.homeexchange.com/hc/es/articles/360007584998-Todo-lo-que-necesitas-saber-sobre-el-calendario",
  "about-us": "https://www.homeexchange.com/es/p/about-us-es",
  blog: iue,
  cgu: sue,
  community: lue,
  "contact-us": "https://www.homeexchange.com/es/contacto-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeES/",
  faq: cue,
  forum: uue,
  guarantees: due,
  guestpoints: gue,
  "happiness-team": "https://www.homeexchange.com/es/p/happiness-team-es",
  "how-it-works": "https://www.homeexchange.com/es/p/como-funciona-es",
  "join-us": "https://www.homeexchange.com/es/p/join-us-es",
  "legal-notice": "/p/menciones-legales",
  "mobile-app": "https://www.homeexchange.com/es/p/aplicacion-movil",
  "our-team": "https://www.homeexchange.com/es/p/nuestro-equipo",
  press: hue,
  "privacy-policy": "/p/homeexchange-politica-privacidad",
  "subscription-cost": "https://www.homeexchange.com/es/p/subscription-homeexchange-es",
  "term-of-use": "/p/homeexchange-condiciones-de-uso",
  testimonials: mue,
  travelWishlist_faq_links: pue,
  "twitter-page": "https://twitter.com/HomeExchangeES",
  value: fue,
  values: bue
}, vue = "Studio", yue = "{{count}} chambre", wue = "{{count}} chambres", kue = "", xue = "{{count}} lit", $ue = "{{count}} lits", Sue = "Adultes", Cue = "Bébés", Eue = "Votre calendrier a été mis à jour.", zue = "Un mois", jue = "Dates exactes", Aue = "Une semaine", Oue = "Un week-end", Pue = "Vide", Due = "± {{count}} jour", Nue = "± {{count}} jours", Rue = "Deux semaines", Iue = "Annuler", Tue = "Enfants", Mue = "Dates", Lue = "Supprimer", Wue = "Description", Bue = "Destination", Fue = "C'est prêt !", Vue = "Modifier", Uue = "Tout type d'échange", que = "Baignoire", Hue = "Barbecue", Gue = "Vélo", Kue = "Voiture", Jue = "Chat", Zue = "Ville", Yue = "Campagne", Xue = "Lave-vaisselle", Que = "Chien", ede = "Sèche linge", tde = "Ascenseur", ade = "Maisons favorites", ode = "Cheminée", nde = "Appartement", rde = "Jardin privé", ide = "moins de {{max}} GP", sde = "à partir de {{min}} GP", lde = "Entre {{min}} et {{max}} GP", cde = "Salle de sport privée", ude = "Maison", dde = "Île", gde = "Isolé", hde = "Jacuzzi", mde = "Lac", pde = "Maisons Collection", fde = "Montagne", bde = "{{count}} salles de bain", _de = "Autre", vde = "Piano", yde = "Aire de jeux", wde = "Principale", kde = "Échange réciproque", xde = "Recherche inversée", $de = "Rivière", Sde = "Bord de mer", Cde = "Secondaire", Ede = "TV", zde = "Village", jde = "WiFi", Ade = "Filtres", Ode = "Dates fixes", Pde = "Un mois en {{date}}", Dde = "Un week-end en {{date}}", Nde = "Une semaine en {{date}}", Rde = "Deux semaines en {{date}}", Ide = "Dates flexibles", Tde = "Personnes", Mde = "maisons", Lde = "Dernière minute", Wde = "Lieu", Bde = "Modifier", Fde = "Titre", Vde = "Suivant", Ude = "Vide", qde = "{{count}} adulte", Hde = "{{count}} adultes", Gde = "Vide", Kde = "{{count}} bébé", Jde = "{{count}} bébés", Zde = "Vide", Yde = "{{count}} enfant", Xde = "{{count}} enfants", Qde = "{{count}} personne", ege = "{{count}} personne", tge = "{{count}} personnes", age = "Le format du numéro de téléphone est invalide.", oge = "Recevoir des alertes par email", nge = "Enregistrer", rge = "Aucun lieu trouvé", ige = "Voir plus", sge = "Projets de voyage", lge = "", cge = "facultatif", uge = {
  "autocomplete.button": "Rechercher",
  "autocomplete.placeholder": "Où allez-vous ?",
  bedroomsNumbers_zero: vue,
  bedroomsNumbers_one: yue,
  bedroomsNumbers_other: wue,
  beds_zero: kue,
  beds_one: xue,
  beds_other: $ue,
  "button.free-signup": "Inscrivez-vous gratuitement",
  "button.validate": "Valider",
  "common.try-again": "Compris !",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne doit pas dépasser {{limit}} caractères",
  "error.reload": "Actualiser la page",
  "error.return-homepage": "Retour à la page d'accueil",
  "error.subtitle": "Malheureusement, il y a un problème avec cette page.",
  "error.title": "Une erreur s'est produite sur la page",
  "errors.unable_to_submit.subtitle": "Malheureusement, votre réponse n'a pas pu être enregistrée. Merci de réessayer plus tard !",
  "errors.unable_to_submit.title": "Oups, on dirait bien qu'il y a un problème !",
  "global.back": "Retour",
  "global.cancel": "Annuler",
  "global.collection.browsehomes": "Découvrir les maisons",
  "global.collection.contactus": "Nous contacter",
  "global.confirm": "Confirmer",
  "global.continue": "Continuer",
  "global.getStarted": "Commencer",
  "global.login": "Se connecter",
  "global.select": "Sélectionner",
  global_adults: Sue,
  global_babies: Cue,
  global_calendarUpdated_toast: Eue,
  global_calendar_aMonth: zue,
  global_calendar_exactDates: jue,
  global_calendar_oneWeek: Aue,
  global_calendar_oneWeekend: Oue,
  global_calendar_plusMinusDay_zero: Pue,
  global_calendar_plusMinusDay_one: Due,
  global_calendar_plusMinusDay_other: Nue,
  global_calendar_twoWeeks: Rue,
  global_cancel: Iue,
  global_children: Tue,
  global_dates: Mue,
  global_delete: Lue,
  global_description: Wue,
  global_destination: Bue,
  global_done: Fue,
  global_edit: Vue,
  "global_filter_a-c": "Air conditionné",
  global_filter_available: Uue,
  "global_filter_baby-bed": "Lits bébé",
  "global_filter_baby-gear": "Équipements bébé",
  "global_filter_balcony-terrace": "Balcon / Terrasse",
  global_filter_bathtub: que,
  global_filter_bbq: Hue,
  global_filter_bicycle: Gue,
  global_filter_car: Kue,
  global_filter_cat: Jue,
  "global_filter_children-welcome": "Les enfants sont les bienvenus",
  global_filter_cities: Zue,
  "global_filter_cleaning-person": "Service de ménage",
  global_filter_countryside: Yue,
  "global_filter_dedicated-workspace": "Espace de travail dédié",
  "global_filter_disabled-access": "Logement adapté",
  global_filter_dishwasher: Xue,
  global_filter_dog: Que,
  global_filter_dryer: ede,
  "global_filter_eco-level": "Uniquement des maisons durables",
  "global_filter_electric-car-plug": "Prise pour voiture électrique",
  global_filter_elevator: tde,
  global_filter_favorite: ade,
  global_filter_fireplace: ode,
  global_filter_flat: nde,
  global_filter_garden: rde,
  "global_filter_guest-wanted": "Échange contre GuestPoints",
  global_filter_guestPointsMax: ide,
  global_filter_guestPointsMin: sde,
  global_filter_guestPointsMinMax: lde,
  global_filter_gym: cde,
  "global_filter_heating-system": "Chauffage",
  "global_filter_high-speed-connexion": "Connexion haut débit",
  global_filter_home: ude,
  "global_filter_home-verified": "Logements vérifiés",
  global_filter_island: dde,
  global_filter_isolated: gde,
  global_filter_jacuzzi: hde,
  "global_filter_kids-toys": "Jouets pour enfants",
  global_filter_lakes: mde,
  global_filter_luxury: pde,
  global_filter_mountains: fde,
  "global_filter_no-bed-up": "Pas de lit d'appoint",
  global_filter_numOfBathrooms: bde,
  global_filter_other: _de,
  "global_filter_parking-space": "Place de parking privé",
  "global_filter_pets-welcome": "Les animaux sont les bienvenus",
  global_filter_piano: vde,
  global_filter_playground: yde,
  global_filter_primary: wde,
  "global_filter_public-transit-access": "Accès aux transports publics",
  global_filter_reciprocal: kde,
  "global_filter_response-rate-above-threshold": "Réactivité ≥ Moyenne",
  global_filter_reverse: xde,
  global_filter_river: $de,
  global_filter_seaside: Sde,
  global_filter_secondary: Cde,
  "global_filter_secured-pool": "Piscine sécurisée",
  "global_filter_smokers-welcome": "Fumeurs bienvenus",
  "global_filter_swimming-pool": "Piscine",
  global_filter_tv: Ede,
  global_filter_villages: zde,
  "global_filter_washing-machine": "Lave linge",
  "global_filter_whole-unit": "L'intégralité du logement",
  global_filter_wifi: jde,
  global_filters: Ade,
  global_fixDates: Ode,
  global_flexDates_aMonth: Pde,
  global_flexDates_aWeekend: Dde,
  global_flexDates_oneWeek: Nde,
  global_flexDates_twoWeek: Rde,
  global_flexibleDates: Ide,
  global_guests: Tde,
  global_homes: Mde,
  global_lastMinute: Lde,
  global_location: Wde,
  global_modify: Bde,
  global_name: Fde,
  global_next: Vde,
  global_numberOfAdults_zero: Ude,
  global_numberOfAdults_one: qde,
  global_numberOfAdults_other: Hde,
  global_numberOfBabies_zero: Gde,
  global_numberOfBabies_one: Kde,
  global_numberOfBabies_other: Jde,
  global_numberOfChildren_zero: Zde,
  global_numberOfChildren_one: Yde,
  global_numberOfChildren_other: Xde,
  global_numberOfGuests_zero: Qde,
  global_numberOfGuests_one: ege,
  global_numberOfGuests_other: tge,
  global_phoneNumber_notValid: age,
  global_receiveEmailAlerts: oge,
  global_save: nge,
  global_searchBar_noLocationFound: rge,
  global_seeMore_link: ige,
  global_travelWishlist: sge,
  "modal.error-occured.content": "Toutes nos excuses : quelque chose ne s'est pas passé comme prévu, il va falloir que vous retentiez votre chance !",
  "modal.error-occured.title": "Une erreur s'est produite",
  no_result: lge,
  optional: cge,
  "privacy-policy": "Charte de vie privée"
}, dge = "Contact", gge = "FAQ", hge = "Garanties", mge = "GuestPoints", pge = "Aide", fge = "Log out", bge = "Messages", _ge = "Settings", vge = {
  "about-the-calendar": "Calendrier",
  "add-home": "Add a home",
  contact: dge,
  faq: gge,
  guarantees: hge,
  guestpoints: mge,
  help: pge,
  "how-it-works": "Comment ça marche ?",
  "how-much-does-it-cost": "Combien ça coûte ?",
  logout: fge,
  messages: bge,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: _ge,
  "sign-in": "Se connecter",
  "sign-up": "S'inscrire",
  "sign-up-for-free": "Inscrivez-vous gratuitement",
  "signin.modal.apple-button": "Se connecter avec Apple",
  "signin.modal.facebook-button": "Se connecter avec Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, yge = "https://www.homeexchange.fr/blog/", wge = "/p/conditions-generale-d-utilisation", kge = "https://www.homeexchange.fr/p/communaute", xge = "https://homeexchangehelp.zendesk.com/hc/fr", $ge = "https://forum.homeexchange.com/c/francais/21", Sge = "https://www.homeexchange.fr/p/service-homeexchange-fr", Cge = "https://www.homeexchange.fr/p/comment-fonctionnent-les-gp", Ege = "https://www.homeexchange.fr/p/presse", zge = "https://www.homeexchange.com/p/paroles-homeexchangers", jge = "https://help.homeexchange.com/hc/fr/articles/360000623717-Que-sont-Mes-destinations-pr%C3%A9f%C3%A9r%C3%A9es-et-comment-les-utiliser", Age = "https://www.homeexchange.fr/p/les-fondamentaux ", Oge = "https://www.homeexchange.fr/p/les-fondamentaux", Pge = {
  "about-calendar": "https://help.homeexchange.com/hc/fr/articles/360007584998-Tout-ce-que-vous-devez-savoir-sur-le-calendrier",
  "about-us": "https://www.homeexchange.fr/p/qui-sommes-nous",
  blog: yge,
  cgu: wge,
  community: kge,
  "contact-us": "https://www.homeexchange.fr/contactez-nous-homeexchange",
  "cookie-policy": "/p/nos-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeFR/",
  faq: xge,
  forum: $ge,
  guarantees: Sge,
  guestpoints: Cge,
  "happiness-team": "https://www.homeexchange.fr/p/happiness-team-fr",
  "how-it-works": "https://www.homeexchange.fr/p/comment-ca-marche-fr",
  "join-us": "https://www.homeexchange.fr/p/recrutement",
  "legal-notice": "/p/mentions-legales",
  "mobile-app": "https://www.homeexchange.fr/p/applications-mobile",
  "our-team": "https://www.homeexchange.fr/p/notre-equipe",
  press: Ege,
  "privacy-policy": "/p/charte-vie-privee",
  "subscription-cost": "https://www.homeexchange.fr/p/subscription-homeexchange-fr",
  "term-of-use": "/p/conditions-generale-d-utilisation",
  testimonials: zge,
  travelWishlist_faq_links: jge,
  "twitter-page": "https://twitter.com/HomeExchangeFR",
  value: Age,
  values: Oge
}, Dge = "Studio", Nge = "{{count}} soba", Rge = "{{count}} sobe", Ige = "{{count}} sobe", Tge = "", Mge = "{{count}} krevet", Lge = "{{count}} kreveti", Wge = "{{count}} kreveti", Bge = "Odrasle osobe", Fge = "Bebe", Vge = "Vaš je kalendar ažuriran.", Uge = "Mjesec", qge = "Točni datumi", Hge = "Jedan tjedan", Gge = "Jedan vikend", Kge = "dana", Jge = "dan", Zge = "dana", Yge = "± {{count}} dan", Xge = "Dva tjedna", Qge = "Odustani", ehe = "Djeca", the = "Datumi", ahe = "Izbrišite", ohe = "Opis", nhe = "Odredište", rhe = "Gotovo!", ihe = "Uredite", she = "Sve vrste zamjene", lhe = "Kada", che = "Roštilj", uhe = "Bicikl", dhe = "Automobil", ghe = "Mačka", hhe = "Grad", mhe = "Ruralno", phe = "Perilica suđa", fhe = "Pas", bhe = "Sušilica", _he = "Dizalo", vhe = "Favoriti", yhe = "Kamin", whe = "Stan", khe = "Privatno dvorište", xhe = "manje od {{max}} GP", $he = "od {{min}} GP", She = "Između {{min}} i {{max}} GP", Che = "Privatna teretana", Ehe = "Kuća", zhe = "Otok", jhe = "Izoliran", Ahe = "Jacuzzi", Ohe = "Jezera", Phe = "Domove iz Collectiona", Dhe = "Planine", Nhe = "broj kupanica: %{count}", Rhe = "Ostale životinje", Ihe = "Glasovir", The = "Dječje igralište", Mhe = "Moj dom", Lhe = "Recipročna zamjena", Whe = "Obrnuta pretraga", Bhe = "Rijeka", Fhe = "Na obali", Vhe = "Drugi", Uhe = "TV", qhe = "Selo", Hhe = "WiFi", Ghe = "Filtri", Khe = "Fiksni datumi", Jhe = "{{date}}: jedan mjesec", Zhe = "{{date}}: jedan vikend", Yhe = "{{date}}: jedan tjedan", Xhe = "{{date}}: dva tjedna", Qhe = "Fleksibilni datumi", eme = "Gosti", tme = "domova", ame = "U zadnji tren", ome = "Lokacija", nme = "Uredi", rme = "", ime = "Dalje", sme = "odraslih osoba", lme = "odrasla osoba", cme = "odrasle osobe", ume = "odraslih osoba", dme = "beba", gme = "beba", hme = "bebe", mme = "beba", pme = "djece", fme = "dijete", bme = "djeteta", _me = "djece", vme = "gostiju", yme = "gost", wme = "gosta", kme = "gostiju", xme = "Format telefonskog broja nije valjan.", $me = "Primajte obavijesti e-poštom", Sme = "Spremi", Cme = "Nema pronađenih lokacija", Eme = "Saznajte više", zme = "Planovi putovanja", jme = "", Ame = "nije obavezno", Ome = {
  "autocomplete.button": "Pretražite",
  "autocomplete.placeholder": "Gdje ideš ?",
  bedroomsNumbers_zero: Dge,
  bedroomsNumbers_one: Nge,
  bedroomsNumbers_few: Rge,
  bedroomsNumbers_other: Ige,
  beds_zero: Tge,
  beds_one: Mge,
  beds_few: Lge,
  beds_other: Wge,
  "button.free-signup": "Prijavite se besplatno",
  "button.validate": "Potvrdite",
  "common.try-again": "Pokušajte ponovno",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne smije biti dulje od {{limit}} znakova",
  "error.reload": "Osvježite stranicu",
  "error.return-homepage": "Vratite se na početnu stranicu",
  "error.subtitle": "Nažalost ne može se pristupiti ovoj stranici.",
  "error.title": "Došlo je do greške na stranici.",
  "errors.unable_to_submit.subtitle": "Nažalost, Vaš obrazac trenutačno ne može biti predan. Molimo da kasnije pokušate ponovno.",
  "errors.unable_to_submit.title": "Ups, imamo problem",
  "global.back": "Natrag",
  "global.cancel": "Odustani",
  "global.collection.browsehomes": "Pretražujte domove",
  "global.collection.contactus": "Kontaktirajte nas",
  "global.confirm": "Potvrdi",
  "global.continue": "Nastavite",
  "global.getStarted": "Započnite",
  "global.login": "Prijava",
  "global.select": "Odaberi",
  global_adults: Bge,
  global_babies: Fge,
  global_calendarUpdated_toast: Vge,
  global_calendar_aMonth: Uge,
  global_calendar_exactDates: qge,
  global_calendar_oneWeek: Hge,
  global_calendar_oneWeekend: Gge,
  global_calendar_plusMinusDay_zero: Kge,
  global_calendar_plusMinusDay_one: Jge,
  global_calendar_plusMinusDay_few: Zge,
  global_calendar_plusMinusDay_other: Yge,
  global_calendar_twoWeeks: Xge,
  global_cancel: Qge,
  global_children: ehe,
  global_dates: the,
  global_delete: ahe,
  global_description: ohe,
  global_destination: nhe,
  global_done: rhe,
  global_edit: ihe,
  "global_filter_a-c": "Klima uređaj",
  global_filter_available: she,
  "global_filter_baby-bed": "Kreveti za bebe",
  "global_filter_baby-gear": "Oprema za bebe",
  "global_filter_balcony-terrace": "Balkon/terasa",
  global_filter_bathtub: lhe,
  global_filter_bbq: che,
  global_filter_bicycle: uhe,
  global_filter_car: dhe,
  global_filter_cat: ghe,
  "global_filter_children-welcome": "Djeca su dobrodošla",
  global_filter_cities: hhe,
  "global_filter_cleaning-person": "Čistačica",
  global_filter_countryside: mhe,
  "global_filter_dedicated-workspace": "Zaseban radni prostor",
  "global_filter_disabled-access": "Pristupačan dom",
  global_filter_dishwasher: phe,
  global_filter_dog: fhe,
  global_filter_dryer: bhe,
  "global_filter_eco-level": "Samo održivi domovi",
  "global_filter_electric-car-plug": "Utikač za električni automobil",
  global_filter_elevator: _he,
  global_filter_favorite: vhe,
  global_filter_fireplace: yhe,
  global_filter_flat: whe,
  global_filter_garden: khe,
  "global_filter_guest-wanted": "Zamjena sa GuestPoints bodovima",
  global_filter_guestPointsMax: xhe,
  global_filter_guestPointsMin: $he,
  global_filter_guestPointsMinMax: She,
  global_filter_gym: Che,
  "global_filter_heating-system": "Sustav grijanja",
  "global_filter_high-speed-connexion": "Velika brzina veze",
  global_filter_home: Ehe,
  "global_filter_home-verified": "Provjereni domovi ",
  global_filter_island: zhe,
  global_filter_isolated: jhe,
  global_filter_jacuzzi: Ahe,
  "global_filter_kids-toys": "Dječje igračke",
  global_filter_lakes: Ohe,
  global_filter_luxury: Phe,
  global_filter_mountains: Dhe,
  "global_filter_no-bed-up": "Nema privremenih kreveta",
  global_filter_numOfBathrooms: Nhe,
  global_filter_other: Rhe,
  "global_filter_parking-space": "Privatno parkirno mjesto",
  "global_filter_pets-welcome": "Kućni ljubimci su dobrodošli",
  global_filter_piano: Ihe,
  global_filter_playground: The,
  global_filter_primary: Mhe,
  "global_filter_public-transit-access": "Pristup javnim prijevozom",
  global_filter_reciprocal: Lhe,
  "global_filter_response-rate-above-threshold": "Stopa odgovora ≥ Prosječno",
  global_filter_reverse: Whe,
  global_filter_river: Bhe,
  global_filter_seaside: Fhe,
  global_filter_secondary: Vhe,
  "global_filter_secured-pool": "Osiguran bazen",
  "global_filter_smokers-welcome": "Dozvoljeno pušenje",
  "global_filter_swimming-pool": "Bazen",
  global_filter_tv: Uhe,
  global_filter_villages: qhe,
  "global_filter_washing-machine": "Perilica rublja",
  "global_filter_whole-unit": "Cijela jedinica",
  global_filter_wifi: Hhe,
  global_filters: Ghe,
  global_fixDates: Khe,
  global_flexDates_aMonth: Jhe,
  global_flexDates_aWeekend: Zhe,
  global_flexDates_oneWeek: Yhe,
  global_flexDates_twoWeek: Xhe,
  global_flexibleDates: Qhe,
  global_guests: eme,
  global_homes: tme,
  global_lastMinute: ame,
  global_location: ome,
  global_modify: nme,
  global_name: rme,
  global_next: ime,
  global_numberOfAdults_zero: sme,
  global_numberOfAdults_one: lme,
  global_numberOfAdults_few: cme,
  global_numberOfAdults_other: ume,
  global_numberOfBabies_zero: dme,
  global_numberOfBabies_one: gme,
  global_numberOfBabies_few: hme,
  global_numberOfBabies_other: mme,
  global_numberOfChildren_zero: pme,
  global_numberOfChildren_one: fme,
  global_numberOfChildren_few: bme,
  global_numberOfChildren_other: _me,
  global_numberOfGuests_zero: vme,
  global_numberOfGuests_one: yme,
  global_numberOfGuests_few: wme,
  global_numberOfGuests_other: kme,
  global_phoneNumber_notValid: xme,
  global_receiveEmailAlerts: $me,
  global_save: Sme,
  global_searchBar_noLocationFound: Cme,
  global_seeMore_link: Eme,
  global_travelWishlist: zme,
  "modal.error-occured.content": "Žao nam je zbog neugodnosti, ali pokušajte ponovno.",
  "modal.error-occured.title": "Došlo je do pogreške.",
  no_result: jme,
  optional: Ame,
  "privacy-policy": "Pravila o privatnosti"
}, Pme = "Kontaktirajte nas", Dme = "FAQ", Nme = "Garancije", Rme = "GuestPoints", Ime = "Pomoć", Tme = "Log out", Mme = "Messages", Lme = "Settings", Wme = {
  "about-the-calendar": "Kalendar",
  "add-home": "Add a home",
  contact: Pme,
  faq: Dme,
  guarantees: Nme,
  guestpoints: Rme,
  help: Ime,
  "how-it-works": "Kako funkcionira?",
  "how-much-does-it-cost": "Koliko košta?",
  logout: Tme,
  messages: Mme,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: Lme,
  "sign-in": "Prijavite se",
  "sign-up": "Registrirajte se",
  "sign-up-for-free": "Prijavite se besplatno",
  "signin.modal.apple-button": "Prijavite se s Apple ID-om",
  "signin.modal.facebook-button": "Prijavite se putem Facebooka",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, Bme = "https://www.homeexchange.com/blog/", Fme = "/p/general-terms-of-use", Vme = "https://www.homeexchange.com/hr/p/zajednica", Ume = "https://homeexchangehelp.zendesk.com/hc/en-us", qme = "", Hme = "https://www.homeexchange.com/hr/p/service-homeexchange-hr", Gme = "https://www.homeexchange.com/hr/p/guestpoints-hr", Kme = "https://www.homeexchange.com/hr/p/press-hr", Jme = "https://www.homeexchange.com/p/rijeci-homeexchange", Zme = "", Yme = "https://www.homeexchange.com/hr/p/gdje-dobrodoslica-stvarno-pocinje", Xme = "https://www.homeexchange.com/hr/p/gdje-dobrodoslica-stvarno-pocinje", Qme = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/hr/p/about-us-hr",
  blog: Bme,
  cgu: Fme,
  community: Vme,
  "contact-us": "https://www.homeexchange.com/hr/kontaktirajte-nas-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: Ume,
  forum: qme,
  guarantees: Hme,
  guestpoints: Gme,
  "happiness-team": "https://www.homeexchange.com/hr/p/happiness-team-hr",
  "how-it-works": "https://www.homeexchange.com/hr/p/kako-to-funkcionira-hr",
  "join-us": "https://www.homeexchange.com/hr/p/join-us-hr",
  "legal-notice": "/p/pravna-napomena",
  "mobile-app": "https://www.homeexchange.com/hr/p/mobilna-aplikacija",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: Kme,
  "privacy-policy": "/p/privacy-policy-hr",
  "subscription-cost": "https://www.homeexchange.com/hr/p/subscription-homeexchange-hr",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: Jme,
  travelWishlist_faq_links: Zme,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: Yme,
  values: Xme
}, epe = "Monolocale", tpe = "{{count}} camera da letto", ape = "{{count}} camere da letto", ope = "", npe = "{{count}} letto", rpe = "{{count}} letti", ipe = "Adulti", spe = "Neonati", lpe = "Il tuo calendario è stato aggiornato.", cpe = "Un mese", upe = "Date esatte", dpe = "Una settimana", gpe = "", hpe = "", mpe = "", ppe = "", fpe = "Due settimane", bpe = "Annulla", _pe = "Bambini", vpe = "Date", ype = "Elimina", wpe = "Descrizione", kpe = "Destinazione", xpe = "Fatto!", $pe = "Modifica", Spe = "Qualsiasi tipo di scambio", Cpe = "Vasca da bagno", Epe = "Barbecue", zpe = "Bicicletta", jpe = "Automobile", Ape = "Gatto", Ope = "Città", Ppe = "Campagna", Dpe = "Lavastoviglie", Npe = "Cane", Rpe = "Asciugatrice", Ipe = "Ascensore", Tpe = "Case preferite", Mpe = "Camino", Lpe = "Appartamento", Wpe = "Cortile privato", Bpe = "Meno di {{max}} GP", Fpe = "da {{min}} GP", Vpe = "Tra {{min}} e {{max}} GP", Upe = "Palestra privata", qpe = "Casa", Hpe = "Isola o penisola", Gpe = "Isolata", Kpe = "Idromassaggio", Jpe = "Lago", Zpe = "Case Collection", Ype = "Montagna", Xpe = "{{count}} bagni", Qpe = "Altri animali", efe = "Pianoforte", tfe = "Zona giochi per bambini", afe = "Prima", ofe = "Scambio reciproco", nfe = "Ricerca inversa", rfe = "Fiume", ife = "Sulla costa", sfe = "Seconda", lfe = "TV", cfe = "Paese", ufe = "WiFi", dfe = "Filtri", gfe = "Date esatte", hfe = "Un mese in {{date}}", mfe = "Un fine settimana in {{date}}", pfe = "Una settimana in {{date}}", ffe = "Due settimane in {{date}}", bfe = "Date flessibili", _fe = "Ospiti", vfe = "case", yfe = "Ultimo minuto", wfe = "Posizione", kfe = "Modifica", xfe = "Nome", $fe = "Avanti", Sfe = "Zero", Cfe = "Uno", Efe = "Altro", zfe = "Zero", jfe = "Uno", Afe = "Altro", Ofe = "Zero", Pfe = "Uno", Dfe = "Altro", Nfe = "Zero", Rfe = "Uno", Ife = "Altro", Tfe = "Il formato del numero di telefono non è valido.", Mfe = "Ricevi avvisi via email", Lfe = "Salva", Wfe = "Nessuna posizione trovata", Bfe = "Vedere di più", Ffe = "Progetti di viaggio", Vfe = "", Ufe = "facoltativo", qfe = {
  "autocomplete.button": "Ricerca",
  "autocomplete.placeholder": "Dove stai andando?",
  bedroomsNumbers_zero: epe,
  bedroomsNumbers_one: tpe,
  bedroomsNumbers_other: ape,
  beds_zero: ope,
  beds_one: npe,
  beds_other: rpe,
  "button.free-signup": "Iscriviti gratis",
  "button.validate": "Convalida",
  "common.try-again": "Prova ancora",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Non deve superare i {{limit}} caratteri",
  "error.reload": "Aggiorna la pagina",
  "error.return-homepage": "Ritorna alla home page",
  "error.subtitle": "Si è verificato un errore e non è stato possibile caricare questa pagina.",
  "error.title": "Si è verificato un errore nella pagina",
  "errors.unable_to_submit.subtitle": "Errore durante l'invio del modulo. Per favore riprova più tardi.",
  "errors.unable_to_submit.title": "Errore: è impossibile inviare",
  "global.back": "Indietro",
  "global.cancel": "Annulla",
  "global.collection.browsehomes": "Sfoglia le case",
  "global.collection.contactus": "Contattaci",
  "global.confirm": "Conferma",
  "global.continue": "Continua",
  "global.getStarted": "Cominciare",
  "global.login": "Accedi",
  "global.select": "Seleziona",
  global_adults: ipe,
  global_babies: spe,
  global_calendarUpdated_toast: lpe,
  global_calendar_aMonth: cpe,
  global_calendar_exactDates: upe,
  global_calendar_oneWeek: dpe,
  global_calendar_oneWeekend: gpe,
  global_calendar_plusMinusDay_zero: hpe,
  global_calendar_plusMinusDay_one: mpe,
  global_calendar_plusMinusDay_other: ppe,
  global_calendar_twoWeeks: fpe,
  global_cancel: bpe,
  global_children: _pe,
  global_dates: vpe,
  global_delete: ype,
  global_description: wpe,
  global_destination: kpe,
  global_done: xpe,
  global_edit: $pe,
  "global_filter_a-c": "Aria condizionata",
  global_filter_available: Spe,
  "global_filter_baby-bed": "Lettini per bambini",
  "global_filter_baby-gear": "Attrezzature per neonato",
  "global_filter_balcony-terrace": "Balcone/Terrazza",
  global_filter_bathtub: Cpe,
  global_filter_bbq: Epe,
  global_filter_bicycle: zpe,
  global_filter_car: jpe,
  global_filter_cat: Ape,
  "global_filter_children-welcome": "Bambini benvenuti",
  global_filter_cities: Ope,
  "global_filter_cleaning-person": "Donna delle pulizie",
  global_filter_countryside: Ppe,
  "global_filter_dedicated-workspace": "Spazio di lavoro dedicato",
  "global_filter_disabled-access": "Casa accessibile alle sedie a rotelle",
  global_filter_dishwasher: Dpe,
  global_filter_dog: Npe,
  global_filter_dryer: Rpe,
  "global_filter_eco-level": "Solo case sostenibili",
  "global_filter_electric-car-plug": "Presa per auto elettrica",
  global_filter_elevator: Ipe,
  global_filter_favorite: Tpe,
  global_filter_fireplace: Mpe,
  global_filter_flat: Lpe,
  global_filter_garden: Wpe,
  "global_filter_guest-wanted": "Scambio con GuestPoints",
  global_filter_guestPointsMax: Bpe,
  global_filter_guestPointsMin: Fpe,
  global_filter_guestPointsMinMax: Vpe,
  global_filter_gym: Upe,
  "global_filter_heating-system": "Sistema di riscaldamento",
  "global_filter_high-speed-connexion": "Connessione ad alta velocità",
  global_filter_home: qpe,
  "global_filter_home-verified": "Case verificate",
  global_filter_island: Hpe,
  global_filter_isolated: Gpe,
  global_filter_jacuzzi: Kpe,
  "global_filter_kids-toys": "Giocattoli per bambini",
  global_filter_lakes: Jpe,
  global_filter_luxury: Zpe,
  global_filter_mountains: Ype,
  "global_filter_no-bed-up": "Nessun letto temporaneo",
  global_filter_numOfBathrooms: Xpe,
  global_filter_other: Qpe,
  "global_filter_parking-space": "Posto auto privato",
  "global_filter_pets-welcome": "Animali domestici ammessi",
  global_filter_piano: efe,
  global_filter_playground: tfe,
  global_filter_primary: afe,
  "global_filter_public-transit-access": "Accesso ai trasporti pubblici",
  global_filter_reciprocal: ofe,
  "global_filter_response-rate-above-threshold": "Tasso di risposta ≥ Nella media",
  global_filter_reverse: nfe,
  global_filter_river: rfe,
  global_filter_seaside: ife,
  global_filter_secondary: sfe,
  "global_filter_secured-pool": "Piscina protetta",
  "global_filter_smokers-welcome": "I fumatori sono i benvenuti",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: lfe,
  global_filter_villages: cfe,
  "global_filter_washing-machine": "Lavatrice",
  "global_filter_whole-unit": "L'intera unità",
  global_filter_wifi: ufe,
  global_filters: dfe,
  global_fixDates: gfe,
  global_flexDates_aMonth: hfe,
  global_flexDates_aWeekend: mfe,
  global_flexDates_oneWeek: pfe,
  global_flexDates_twoWeek: ffe,
  global_flexibleDates: bfe,
  global_guests: _fe,
  global_homes: vfe,
  global_lastMinute: yfe,
  global_location: wfe,
  global_modify: kfe,
  global_name: xfe,
  global_next: $fe,
  global_numberOfAdults_zero: Sfe,
  global_numberOfAdults_one: Cfe,
  global_numberOfAdults_other: Efe,
  global_numberOfBabies_zero: zfe,
  global_numberOfBabies_one: jfe,
  global_numberOfBabies_other: Afe,
  global_numberOfChildren_zero: Ofe,
  global_numberOfChildren_one: Pfe,
  global_numberOfChildren_other: Dfe,
  global_numberOfGuests_zero: Nfe,
  global_numberOfGuests_one: Rfe,
  global_numberOfGuests_other: Ife,
  global_phoneNumber_notValid: Tfe,
  global_receiveEmailAlerts: Mfe,
  global_save: Lfe,
  global_searchBar_noLocationFound: Wfe,
  global_seeMore_link: Bfe,
  global_travelWishlist: Ffe,
  "modal.error-occured.content": "Ci spiace davvero per l'inconveniente, ti chiediamo di riprovare.",
  "modal.error-occured.title": "Oh no, si è verificato un errore!",
  no_result: Vfe,
  optional: Ufe,
  "privacy-policy": "Informativa sulla privacy"
}, Hfe = "Contatti", Gfe = "Domande frequenti", Kfe = "Garanzie", Jfe = "GuestPoints", Zfe = "Aiuto", Yfe = "Log out", Xfe = "Messages", Qfe = "Settings", ebe = {
  "about-the-calendar": "Calendario",
  "add-home": "Add a home",
  contact: Hfe,
  faq: Gfe,
  guarantees: Kfe,
  guestpoints: Jfe,
  help: Zfe,
  "how-it-works": "Come funziona?",
  "how-much-does-it-cost": "Quanto costa?",
  logout: Yfe,
  messages: Xfe,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: Qfe,
  "sign-in": "Accedi",
  "sign-up": "Registrati",
  "sign-up-for-free": "Iscriviti gratis",
  "signin.modal.apple-button": "Accedi con Apple",
  "signin.modal.facebook-button": "Accedi tramite Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, tbe = "https://www.homeexchange.it/blog/", abe = "/p/homeexchange-condizioni-di-uso", obe = "https://www.homeexchange.it/p/comunita", nbe = "https://homeexchangehelp.zendesk.com/hc/it", rbe = "", ibe = "https://www.homeexchange.it/p/service-homeexchange-it", sbe = "https://www.homeexchange.it/p/guestpoints-it", lbe = "https://www.homeexchange.it/p/stampa", cbe = "https://www.homeexchange.com/p/racconti-homeexchangers", ube = "https://help.homeexchange.com/hc/it/articles/360000623717-Cosa-sono-le-mie-destinazioni-preferite-e-a-cosa-servono", dbe = "", gbe = "https://www.homeexchange.it/p/la-dove-accoglienza-inizia-davvero", hbe = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.it/p/about-us-it",
  blog: tbe,
  cgu: abe,
  community: obe,
  "contact-us": "https://www.homeexchange.it/contattaci-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeIT/",
  faq: nbe,
  forum: rbe,
  guarantees: ibe,
  guestpoints: sbe,
  "happiness-team": "https://www.homeexchange.it/p/happiness-team-it",
  "how-it-works": "https://www.homeexchange.it/p/come-funziona-it",
  "join-us": "https://www.homeexchange.it/p/join-us-it",
  "legal-notice": "/p/avviso-legale",
  "mobile-app": "https://www.homeexchange.it/p/app-mobile",
  "our-team": "https://www.homeexchange.it/p/nostro-team",
  press: lbe,
  "privacy-policy": "/p/homeexchange-informativa-privacy",
  "subscription-cost": "https://www.homeexchange.it/p/subscription-homeexchange-it",
  "term-of-use": "/p/homeexchange-condizioni-di-uso",
  testimonials: cbe,
  travelWishlist_faq_links: ube,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: dbe,
  values: gbe
}, mbe = "Studio", pbe = "{{count}} soverom", fbe = "{{count}} soverom", bbe = "", _be = "{{count}} seng", vbe = "{{count}} senger", ybe = "Voksne", wbe = "Babyer", kbe = "", xbe = "En måned", $be = "Nøyaktige datoer", Sbe = "Uke", Cbe = "", Ebe = "", zbe = "", jbe = "", Abe = "To uker", Obe = "", Pbe = "Barn", Dbe = "Datoer", Nbe = "", Rbe = "Beskrivelse", Ibe = "Reisemål", Tbe = "", Mbe = "", Lbe = "alle typer boligbytter", Wbe = "Badekar", Bbe = "Grill", Fbe = "Sykkel", Vbe = "Bil", Ube = "Katt", qbe = "By", Hbe = "Landlig", Gbe = "Oppvaskmaskin", Kbe = "Hund", Jbe = "Tørketrommel", Zbe = "Heis", Ybe = "Favoritthjem", Xbe = "Peis", Qbe = "Leilighet", e_e = "", t_e = "mindre enn {{max}} GP", a_e = "fra {{min}} GP", o_e = "Mellom {{min}} og {{max}} GP", n_e = "Privat treningsrom", r_e = "Hus", i_e = "Øy", s_e = "Isolert", l_e = "Jacuzzi", c_e = "Innsjøer", u_e = "Collection-hjem", d_e = "Fjell", g_e = "", h_e = "Andre dyr", m_e = "Piano", p_e = "", f_e = "Primær", b_e = "Gjensidig boligbytte", __e = "Omvendt søk", v_e = "Elv", y_e = "", w_e = "Sekundær", k_e = "TV", x_e = "Landsbygd", $_e = "WiFi", S_e = "Filtrer", C_e = "Nøyaktige datoer", E_e = "", z_e = "", j_e = "", A_e = "", O_e = "Fleksible datoer", P_e = "Gjester", D_e = "", N_e = "Siste øyeblikk", R_e = "Beliggenhet", I_e = "", T_e = "", M_e = "", L_e = "", W_e = "", B_e = "", F_e = "", V_e = "", U_e = "", q_e = "", H_e = "", G_e = "", K_e = "", J_e = "", Z_e = "", Y_e = "", X_e = "", Q_e = "Lagre", eve = "", tve = "Se mer", ave = "Reiseplaner", ove = "", nve = "", rve = {
  "autocomplete.button": "Søk",
  "autocomplete.placeholder": "Hvor skal du ?",
  bedroomsNumbers_zero: mbe,
  bedroomsNumbers_one: pbe,
  bedroomsNumbers_other: fbe,
  beds_zero: bbe,
  beds_one: _be,
  beds_other: vbe,
  "button.free-signup": "Registrer deg gratis",
  "button.validate": "Bekreft",
  "common.try-again": "",
  "contact-tech-email": "contact@homeexchange.com",
  "error.characters_max_limit": "Kan ikke overstige {{limit}} tegn",
  "error.reload": "Oppdater siden",
  "error.return-homepage": "Gå tilbake til startsiden",
  "error.subtitle": "Denne siden kan dessverre ikke nås.",
  "error.title": "En feil har oppstått på siden",
  "errors.unable_to_submit.subtitle": "Skjemaet ditt kunne dessverre ikke sendes inn akkurat nå. Vennligst prøv igjen senere.",
  "errors.unable_to_submit.title": "Oops, det har oppstått et problem",
  "global.back": "Tilbake",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Fortsett",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_adults: ybe,
  global_babies: wbe,
  global_calendarUpdated_toast: kbe,
  global_calendar_aMonth: xbe,
  global_calendar_exactDates: $be,
  global_calendar_oneWeek: Sbe,
  global_calendar_oneWeekend: Cbe,
  global_calendar_plusMinusDay_zero: Ebe,
  global_calendar_plusMinusDay_one: zbe,
  global_calendar_plusMinusDay_other: jbe,
  global_calendar_twoWeeks: Abe,
  global_cancel: Obe,
  global_children: Pbe,
  global_dates: Dbe,
  global_delete: Nbe,
  global_description: Rbe,
  global_destination: Ibe,
  global_done: Tbe,
  global_edit: Mbe,
  "global_filter_a-c": "Klimaanlegg",
  global_filter_available: Lbe,
  "global_filter_baby-bed": "Sprinkelsenger",
  "global_filter_baby-gear": "Babyutstyr",
  "global_filter_balcony-terrace": "",
  global_filter_bathtub: Wbe,
  global_filter_bbq: Bbe,
  global_filter_bicycle: Fbe,
  global_filter_car: Vbe,
  global_filter_cat: Ube,
  "global_filter_children-welcome": "Barn velkommen",
  global_filter_cities: qbe,
  "global_filter_cleaning-person": "Rengjøringsperson",
  global_filter_countryside: Hbe,
  "global_filter_dedicated-workspace": "",
  "global_filter_disabled-access": "Tilgjengelig for funksjonshemmede",
  global_filter_dishwasher: Gbe,
  global_filter_dog: Kbe,
  global_filter_dryer: Jbe,
  "global_filter_eco-level": "Bare bærekraftige hjem",
  "global_filter_electric-car-plug": "Elektrisk bilplugg",
  global_filter_elevator: Zbe,
  global_filter_favorite: Ybe,
  global_filter_fireplace: Xbe,
  global_filter_flat: Qbe,
  global_filter_garden: e_e,
  "global_filter_guest-wanted": "Boligbytte med GuestPoints",
  global_filter_guestPointsMax: t_e,
  global_filter_guestPointsMin: a_e,
  global_filter_guestPointsMinMax: o_e,
  global_filter_gym: n_e,
  "global_filter_heating-system": "Oppvarming",
  "global_filter_high-speed-connexion": "Høyhastighets tilkobling",
  global_filter_home: r_e,
  "global_filter_home-verified": "Verifiserte hjem",
  global_filter_island: i_e,
  global_filter_isolated: s_e,
  global_filter_jacuzzi: l_e,
  "global_filter_kids-toys": "Barneleker",
  global_filter_lakes: c_e,
  global_filter_luxury: u_e,
  global_filter_mountains: d_e,
  "global_filter_no-bed-up": "",
  global_filter_numOfBathrooms: g_e,
  global_filter_other: h_e,
  "global_filter_parking-space": "Privat parkering",
  "global_filter_pets-welcome": "Kjæledyr velkommen",
  global_filter_piano: m_e,
  global_filter_playground: p_e,
  global_filter_primary: f_e,
  "global_filter_public-transit-access": "Tilgang til offentlig transport",
  global_filter_reciprocal: b_e,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: __e,
  global_filter_river: v_e,
  global_filter_seaside: y_e,
  global_filter_secondary: w_e,
  "global_filter_secured-pool": "Sikret badebasseng",
  "global_filter_smokers-welcome": "Røykere velkommen",
  "global_filter_swimming-pool": "Svømmebasseng",
  global_filter_tv: k_e,
  global_filter_villages: x_e,
  "global_filter_washing-machine": "Vaskemaskin",
  "global_filter_whole-unit": "Hele boligen",
  global_filter_wifi: $_e,
  global_filters: S_e,
  global_fixDates: C_e,
  global_flexDates_aMonth: E_e,
  global_flexDates_aWeekend: z_e,
  global_flexDates_oneWeek: j_e,
  global_flexDates_twoWeek: A_e,
  global_flexibleDates: O_e,
  global_guests: P_e,
  global_homes: D_e,
  global_lastMinute: N_e,
  global_location: R_e,
  global_modify: I_e,
  global_name: T_e,
  global_next: M_e,
  global_numberOfAdults_zero: L_e,
  global_numberOfAdults_one: W_e,
  global_numberOfAdults_other: B_e,
  global_numberOfBabies_zero: F_e,
  global_numberOfBabies_one: V_e,
  global_numberOfBabies_other: U_e,
  global_numberOfChildren_zero: q_e,
  global_numberOfChildren_one: H_e,
  global_numberOfChildren_other: G_e,
  global_numberOfGuests_zero: K_e,
  global_numberOfGuests_one: J_e,
  global_numberOfGuests_other: Z_e,
  global_phoneNumber_notValid: Y_e,
  global_receiveEmailAlerts: X_e,
  global_save: Q_e,
  global_searchBar_noLocationFound: eve,
  global_seeMore_link: tve,
  global_travelWishlist: ave,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: ove,
  optional: nve,
  "privacy-policy": "Personvernpolicy"
}, ive = "Kontakt oss", sve = "FAQ", lve = "Garantier", cve = "About the Guestpoints", uve = "Hjelp", dve = "Log out", gve = "Messages", hve = "Settings", mve = {
  "about-the-calendar": "About the calendar",
  "add-home": "Add a home",
  contact: ive,
  faq: sve,
  guarantees: lve,
  guestpoints: cve,
  help: uve,
  "how-it-works": "Hvordan virker det?",
  "how-much-does-it-cost": "Hvor mye koster det?",
  logout: dve,
  messages: gve,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: hve,
  "sign-in": "Logg inn",
  "sign-up": "Registrer deg",
  "sign-up-for-free": "Registrer deg gratis",
  "signin.modal.apple-button": "Logg inn med Apple",
  "signin.modal.facebook-button": "Logg inn med Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, pve = "https://www.homeexchange.com/blog/", fve = "/p/general-terms-of-use", bve = "https://www.homeexchange.com/nb/p/nettverk", _ve = "https://homeexchangehelp.zendesk.com/hc/pt", vve = "", yve = "https://www.homeexchange.com/nb/p/service-homeexchange-no", wve = "https://www.homeexchange.com/nb/p/guestpoints-no", kve = "https://www.homeexchange.com/nb/p/press-no", xve = "https://www.homeexchange.com/p/ifolge-homeexchangers", $ve = "", Sve = "", Cve = "https://www.homeexchange.com/nb/p/der-velkomsten-virkelig-starter", Eve = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/nb/p/about-us-no",
  blog: pve,
  cgu: fve,
  community: bve,
  "contact-us": "https://www.homeexchange.com/nb/p/kontact-oss-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: _ve,
  forum: vve,
  guarantees: yve,
  guestpoints: wve,
  "happiness-team": "https://www.homeexchange.com/nb/p/happiness-team-no",
  "how-it-works": "https://www.homeexchange.com/nb/p/hvordan-fungerer-det-no",
  "join-us": "https://www.homeexchange.com/nb/p/join-us-no",
  "legal-notice": "/p/legal-notice-no",
  "mobile-app": "https://www.homeexchange.com/nb/p/mobile-app",
  "our-team": "https://www.homeexchange.com/nb/p/teamet-vart",
  press: kve,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/nb/p/subscription-homeexchange-no",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: xve,
  travelWishlist_faq_links: $ve,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: Sve,
  values: Cve
}, zve = "Studio", jve = "{{count}} slaapkamer", Ave = "{{count}} slaapkamers", Ove = "", Pve = "{{count}} bed", Dve = "{{count}} bedden", Nve = "Volwassenen", Rve = "Baby's", Ive = "Je kalender is bijgewerkt.", Tve = "Een maand", Mve = "Exacte data", Lve = "Een week", Wve = "Een weekend", Bve = "", Fve = "± {{count}} dag", Vve = "± {{count}} dagen", Uve = "Twee weken", qve = "Annuleren", Hve = "Kinderen", Gve = "Data", Kve = "Verwijderen", Jve = "Beschrijving", Zve = "Bestemming", Yve = "Klaar!", Xve = "Bewerken", Qve = "Elk type ruil", eye = "Bad", tye = "BBQ", aye = "Fiets", oye = "Auto", nye = "Kat", rye = "De stad", iye = "Het platteland", sye = "Vaatwasmachine", lye = "Hond", cye = "Droger", uye = "Lift", dye = "Favoriete huizen", gye = "Open haard", hye = "Appartement", mye = "Privétuin", pye = "Minder dan {{max}} GP", fye = "vanaf {{min}} GP", bye = "Tussen {{min}} en {{max}} GP", _ye = "Privésportzaal", vye = "Huis", yye = "Een eiland", wye = "Geïsoleerd", kye = "Jacuzzi", xye = "Een meer", $ye = "Collection-huizen", Sye = "De bergen", Cye = "{{count}} badkamers", Eye = "Andere dieren", zye = "", jye = "Speeltuin", Aye = "Eerste", Oye = "Wederzijdse huizenruil", Pye = "Omgekeerd zoeken", Dye = "Rivier", Nye = "Kust", Rye = "Vakantiehuis", Iye = "TV", Tye = "Dorp", Mye = "WiFi", Lye = "Filters", Wye = "Vaste data", Bye = "Een maand in {{date}}", Fye = "Een weekend in {{date}}", Vye = "Een week in {{date}}", Uye = "Twee weken in {{date}}", qye = "Flexibele data", Hye = "Gasten", Gye = "huizen", Kye = "Last minute", Jye = "Locatie", Zye = "Wijzigen", Yye = "Naam", Xye = "Volgende", Qye = "", ewe = "{{count}} volwassene", twe = "{{count}} volwassenen", awe = "", owe = "{{count}} baby", nwe = "{{count}} baby's", rwe = "", iwe = "{{count}} kind", swe = "{{count}} kinderen", lwe = "", cwe = "{{count}} gast", uwe = "{{count}} gasten", dwe = "De indeling van het telefoonnummer is niet geldig.", gwe = "E-mailmeldingen ontvangen", hwe = "Opslaan", mwe = "Geen locaties gevonden", pwe = "Bekijk meer", fwe = "Reisplannen", bwe = "Geen resultaat", _we = "optioneel", vwe = {
  "autocomplete.button": "Zoeken",
  "autocomplete.placeholder": "Waar ga je naar toe ?",
  bedroomsNumbers_zero: zve,
  bedroomsNumbers_one: jve,
  bedroomsNumbers_other: Ave,
  beds_zero: Ove,
  beds_one: Pve,
  beds_other: Dve,
  "button.free-signup": "Meld je gratis aan",
  "button.validate": "Bevestigen",
  "common.try-again": "Opnieuw proberen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Mag de {{limit}} karakters niet overschrijden",
  "error.reload": "Deze pagina vernieuwen ",
  "error.return-homepage": "Terug naar de startpagina",
  "error.subtitle": "Helaas kon deze pagina niet gevonden worden.",
  "error.title": "Er is een fout opgetreden op de pagina",
  "errors.unable_to_submit.subtitle": "Helaas kon het formulier niet verzonden worden. Probeer het later nog eens.",
  "errors.unable_to_submit.title": "Oeps... het is niet gelukt om het formulier te verzenden.",
  "global.back": "Terug",
  "global.cancel": "Annuleren",
  "global.collection.browsehomes": "Blader door huizen",
  "global.collection.contactus": "Neem contact met ons op",
  "global.confirm": "Bevestigen",
  "global.continue": "Doorgaan",
  "global.getStarted": "Ga van start",
  "global.login": "Inloggen",
  "global.select": "Selecteren",
  global_adults: Nve,
  global_babies: Rve,
  global_calendarUpdated_toast: Ive,
  global_calendar_aMonth: Tve,
  global_calendar_exactDates: Mve,
  global_calendar_oneWeek: Lve,
  global_calendar_oneWeekend: Wve,
  global_calendar_plusMinusDay_zero: Bve,
  global_calendar_plusMinusDay_one: Fve,
  global_calendar_plusMinusDay_other: Vve,
  global_calendar_twoWeeks: Uve,
  global_cancel: qve,
  global_children: Hve,
  global_dates: Gve,
  global_delete: Kve,
  global_description: Jve,
  global_destination: Zve,
  global_done: Yve,
  global_edit: Xve,
  "global_filter_a-c": "Airco",
  global_filter_available: Qve,
  "global_filter_baby-bed": "Babybedden",
  "global_filter_baby-gear": "Baby spullen",
  "global_filter_balcony-terrace": "",
  global_filter_bathtub: eye,
  global_filter_bbq: tye,
  global_filter_bicycle: aye,
  global_filter_car: oye,
  global_filter_cat: nye,
  "global_filter_children-welcome": "Kinderen welkom",
  global_filter_cities: rye,
  "global_filter_cleaning-person": "Schoonmaakster",
  global_filter_countryside: iye,
  "global_filter_dedicated-workspace": "Toegewijde werkruimte",
  "global_filter_disabled-access": "Toegankelijke woning",
  global_filter_dishwasher: sye,
  global_filter_dog: lye,
  global_filter_dryer: cye,
  "global_filter_eco-level": "Alleen duurzame woningen",
  "global_filter_electric-car-plug": "Elektrische auto stekker",
  global_filter_elevator: uye,
  global_filter_favorite: dye,
  global_filter_fireplace: gye,
  global_filter_flat: hye,
  global_filter_garden: mye,
  "global_filter_guest-wanted": "Ruil tegen GuestPoints",
  global_filter_guestPointsMax: pye,
  global_filter_guestPointsMin: fye,
  global_filter_guestPointsMinMax: bye,
  global_filter_gym: _ye,
  "global_filter_heating-system": "Verwarming",
  "global_filter_high-speed-connexion": "Snelle verbinding",
  global_filter_home: vye,
  "global_filter_home-verified": "Geverifieerde huizen",
  global_filter_island: yye,
  global_filter_isolated: wye,
  global_filter_jacuzzi: kye,
  "global_filter_kids-toys": "Kinderen speelgoed",
  global_filter_lakes: xye,
  global_filter_luxury: $ye,
  global_filter_mountains: Sye,
  "global_filter_no-bed-up": "Geen tijdelijke bedden",
  global_filter_numOfBathrooms: Cye,
  global_filter_other: Eye,
  "global_filter_parking-space": "Privé parkeerplaats",
  "global_filter_pets-welcome": "Huisdieren toegestaan ",
  global_filter_piano: zye,
  global_filter_playground: jye,
  global_filter_primary: Aye,
  "global_filter_public-transit-access": "Toegang tot het openbaar vervoer",
  global_filter_reciprocal: Oye,
  "global_filter_response-rate-above-threshold": "Responspercentage ≥ Gemiddeld",
  global_filter_reverse: Pye,
  global_filter_river: Dye,
  global_filter_seaside: Nye,
  global_filter_secondary: Rye,
  "global_filter_secured-pool": "Beveiligd zwembad",
  "global_filter_smokers-welcome": "Roken toegestaan ",
  "global_filter_swimming-pool": "Zwembad",
  global_filter_tv: Iye,
  global_filter_villages: Tye,
  "global_filter_washing-machine": "Wasmachine",
  "global_filter_whole-unit": "De hele woning",
  global_filter_wifi: Mye,
  global_filters: Lye,
  global_fixDates: Wye,
  global_flexDates_aMonth: Bye,
  global_flexDates_aWeekend: Fye,
  global_flexDates_oneWeek: Vye,
  global_flexDates_twoWeek: Uye,
  global_flexibleDates: qye,
  global_guests: Hye,
  global_homes: Gye,
  global_lastMinute: Kye,
  global_location: Jye,
  global_modify: Zye,
  global_name: Yye,
  global_next: Xye,
  global_numberOfAdults_zero: Qye,
  global_numberOfAdults_one: ewe,
  global_numberOfAdults_other: twe,
  global_numberOfBabies_zero: awe,
  global_numberOfBabies_one: owe,
  global_numberOfBabies_other: nwe,
  global_numberOfChildren_zero: rwe,
  global_numberOfChildren_one: iwe,
  global_numberOfChildren_other: swe,
  global_numberOfGuests_zero: lwe,
  global_numberOfGuests_one: cwe,
  global_numberOfGuests_other: uwe,
  global_phoneNumber_notValid: dwe,
  global_receiveEmailAlerts: gwe,
  global_save: hwe,
  global_searchBar_noLocationFound: mwe,
  global_seeMore_link: pwe,
  global_travelWishlist: fwe,
  "modal.error-occured.content": "Onze excuses voor het ongemak, probeer het alsjeblieft opnieuw.",
  "modal.error-occured.title": "Oh nee, er is een fout opgetreden!",
  no_result: bwe,
  optional: _we,
  "privacy-policy": "Privacy"
}, ywe = "Neem contact met ons op", wwe = "FAQ", kwe = "Garanties", xwe = "GuestPoints", $we = "Help", Swe = "Log out", Cwe = "Messages", Ewe = "Settings", zwe = {
  "about-the-calendar": "Kalender",
  "add-home": "Add a home",
  contact: ywe,
  faq: wwe,
  guarantees: kwe,
  guestpoints: xwe,
  help: $we,
  "how-it-works": "Hoe werkt het?",
  "how-much-does-it-cost": "Hoeveel kost het?",
  logout: Swe,
  messages: Cwe,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "Voltooi de advertentie van je woning!",
  "notification.home.complete_home_first_time": "Voltooi de advertentie van je huis en ontvang {{gp}} GuestPoints!",
  "notification.home.empty_calendar": "Voeg beschikbaarheid toe aan je kalender voor het komende jaar",
  "notification.home.new_calendar_type": "Nieuwe kalender!",
  "notification.home.offline": "Publiceer je huis!",
  "notification.membership.expired": "Lidmaatschap verlopen",
  "notification.membership.lead": "Activeer je lidmaatschap en ontvang {{gp}} GuestPoints",
  "notification.user_profile.incomplete": "Voltooi je profiel",
  "notification.user_profile.motivate_incomplete": "Voltooi je profiel en ontvang {{gp}} GuestPoints",
  "refer-your-friends": "Refer your friends",
  settings: Ewe,
  "sign-in": "Inloggen",
  "sign-up": "Inschrijven",
  "sign-up-for-free": "Meld je gratis aan",
  "signin.modal.apple-button": "Inloggen met Apple",
  "signin.modal.facebook-button": "Meld je aan met Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, jwe = "https://www.homeexchange.com/nl/blog/", Awe = "/nl/p/homeexchangegebruiksvoorwaarden", Owe = "https://www.homeexchange.com/nl/p/gemeenschap", Pwe = "https://homeexchangehelp.zendesk.com/hc/en-us", Dwe = "https://forum.homeexchange.com/c/english/20", Nwe = "https://www.homeexchange.com/nl/p/service-homeexchange-nl", Rwe = "https://www.homeexchange.com/nl/p/guestpoints-nl", Iwe = "https://www.homeexchange.com/nl/p/pers", Twe = "https://www.homeexchange.com/p/wordsonhomeexchange", Mwe = "https://help.homeexchange.com/hc/nl/articles/360000623717-Wat-zijn-Mijn-voorkeursbestemmingen-en-hoe-gebruik-ik-ze", Lwe = "https://www.homeexchange.com/nl/p/where-the-welcome-really-begins", Wwe = "https://www.guesttoguest.com/nl/p/waar-het-welkom-echt-begint", Bwe = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/nl/p/about-us-nl",
  blog: jwe,
  cgu: Awe,
  community: Owe,
  "contact-us": "https://www.homeexchange.com/nl/contact-op-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: Pwe,
  forum: Dwe,
  guarantees: Nwe,
  guestpoints: Rwe,
  "happiness-team": "https://www.homeexchange.com/nl/p/happiness-team-nl",
  "how-it-works": "https://www.homeexchange.com/nl/p/hoe-werkt-het-nl",
  "join-us": "https://www.homeexchange.com/nl/p/join-us-nl",
  "legal-notice": "/p/wettelijke-vermeldingen",
  "mobile-app": "https://www.homeexchange.com/nl/p/mobiele-app",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: Iwe,
  "privacy-policy": "/p/homeexchange-privacy",
  "subscription-cost": "https://www.homeexchange.com/nl/p/subscription-homeexchange-nl",
  "term-of-use": "/p/homeexchangegebruiksvoorwaarden",
  testimonials: Twe,
  travelWishlist_faq_links: Mwe,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: Lwe,
  values: Wwe
}, Fwe = "Studio", Vwe = "{{count}} quarto", Uwe = "{{count}} quartos", qwe = "", Hwe = "{{count}} cama", Gwe = "{{count}} camas", Kwe = "", Jwe = "", Zwe = "O seu calendário foi atualizado.", Ywe = "Um mês", Xwe = "Datas exatas", Qwe = "Uma semana", eke = "Um fim de semana", tke = "", ake = "± {{count}} dia", oke = "± {{count]] dias", nke = "Duas semanas", rke = "Cancelar", ike = "", ske = "Datas", lke = "Eliminar", cke = "Descrição", uke = "Destino", dke = "Feito!", gke = "Editar", hke = "Qualquer tipo de pedido de Troca", mke = "Banheiro", pke = "BBQ", fke = "Bicicleta", bke = "Carro", _ke = "Gato", vke = "Cidade", yke = "Campo", wke = "Lavadora de louças", kke = "Cão", xke = "Secadora", $ke = "Elevador", Ske = "Casas favoritas", Cke = "Lareira", Eke = "Apartamento", zke = "Quintal privado", jke = "", Ake = "", Oke = "", Pke = "", Dke = "Casa", Nke = "Ilha", Rke = "Isolada", Ike = "Jacuzzi", Tke = "Lagos", Mke = "Casas Collection", Lke = "", Wke = "{{count}} casas de banho", Bke = "Outros animais", Fke = "Piano", Vke = "Parque infantil", Uke = "Principal", qke = "Troca Reciproca", Hke = "Busca invertida", Gke = "Rio", Kke = "Litoral", Jke = "Secundária", Zke = "TV", Yke = "Aldeia", Xke = "WiFi", Qke = "Filtros", exe = "Datas fixas", txe = "Um mês em {{date}}", axe = "Um fim de semana em {{date}}", oxe = "Uma semana em {{date}}", nxe = "Duas semanas em {{date}}", rxe = "Datas flexíveis", ixe = "Convidados", sxe = "casas", lxe = "Última hora", cxe = "Localização", uxe = "Modificar", dxe = "Nome", gxe = "Seguinte", hxe = "", mxe = "{{count}} adulto", pxe = "{{count}} adultos", fxe = "", bxe = "{{count}} bebé", _xe = "{{count}} bebés", vxe = "", yxe = "{{count}} criança", wxe = "{{count}} crianças", kxe = "", xxe = "{{count}} convidado", $xe = "{{count}} convidados", Sxe = "O formato do número de telefone não é válido.", Cxe = "Receber alertas por e-mail", Exe = "Guardar", zxe = "Não foram encontradas localizações", jxe = "Ver mais", Axe = "Ideias de viagens", Oxe = "", Pxe = "", Dxe = {
  "autocomplete.button": "Procurar",
  "autocomplete.placeholder": "Para onde vai ?",
  bedroomsNumbers_zero: Fwe,
  bedroomsNumbers_one: Vwe,
  bedroomsNumbers_other: Uwe,
  beds_zero: qwe,
  beds_one: Hwe,
  beds_other: Gwe,
  "button.free-signup": "Filie-se gratuitamente",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "",
  "error.characters_max_limit": "Não deve ser superior a {{limit}} caracteres",
  "error.reload": "Atualizar esta página",
  "error.return-homepage": "Voltar à página inicial",
  "error.subtitle": "Infelizmente, não foi possível aceder a esta página.",
  "error.title": "Ocorreu um erro na página",
  "errors.unable_to_submit.subtitle": "Infelizmente, não foi possível submeter o formulário. Tente novamente mais tarde.",
  "errors.unable_to_submit.title": "Ups, ocorreu um problema!",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_adults: Kwe,
  global_babies: Jwe,
  global_calendarUpdated_toast: Zwe,
  global_calendar_aMonth: Ywe,
  global_calendar_exactDates: Xwe,
  global_calendar_oneWeek: Qwe,
  global_calendar_oneWeekend: eke,
  global_calendar_plusMinusDay_zero: tke,
  global_calendar_plusMinusDay_one: ake,
  global_calendar_plusMinusDay_other: oke,
  global_calendar_twoWeeks: nke,
  global_cancel: rke,
  global_children: ike,
  global_dates: ske,
  global_delete: lke,
  global_description: cke,
  global_destination: uke,
  global_done: dke,
  global_edit: gke,
  "global_filter_a-c": "A/C",
  global_filter_available: hke,
  "global_filter_baby-bed": "",
  "global_filter_baby-gear": "Equipamento para bebês",
  "global_filter_balcony-terrace": "Varanda/Terraço",
  global_filter_bathtub: mke,
  global_filter_bbq: pke,
  global_filter_bicycle: fke,
  global_filter_car: bke,
  global_filter_cat: _ke,
  "global_filter_children-welcome": "Crianças bem vindas",
  global_filter_cities: vke,
  "global_filter_cleaning-person": "Faxineiro",
  global_filter_countryside: yke,
  "global_filter_dedicated-workspace": "Espaço de trabalho dedicado",
  "global_filter_disabled-access": "Casa acessível",
  global_filter_dishwasher: wke,
  global_filter_dog: kke,
  global_filter_dryer: xke,
  "global_filter_eco-level": "Só casas sustentáveis",
  "global_filter_electric-car-plug": "Tomada para carro elétrico",
  global_filter_elevator: $ke,
  global_filter_favorite: Ske,
  global_filter_fireplace: Cke,
  global_filter_flat: Eke,
  global_filter_garden: zke,
  "global_filter_guest-wanted": "Troca por GuestPoints",
  global_filter_guestPointsMax: jke,
  global_filter_guestPointsMin: Ake,
  global_filter_guestPointsMinMax: Oke,
  global_filter_gym: Pke,
  "global_filter_heating-system": "Sistema de aquecimento",
  "global_filter_high-speed-connexion": "Wi-fi de alta velocidade",
  global_filter_home: Dke,
  "global_filter_home-verified": "Casas verificadas",
  global_filter_island: Nke,
  global_filter_isolated: Rke,
  global_filter_jacuzzi: Ike,
  "global_filter_kids-toys": "",
  global_filter_lakes: Tke,
  global_filter_luxury: Mke,
  global_filter_mountains: Lke,
  "global_filter_no-bed-up": "Sem camas temporárias",
  global_filter_numOfBathrooms: Wke,
  global_filter_other: Bke,
  "global_filter_parking-space": "",
  "global_filter_pets-welcome": "Animais de estimação bem-vindos",
  global_filter_piano: Fke,
  global_filter_playground: Vke,
  global_filter_primary: Uke,
  "global_filter_public-transit-access": "",
  global_filter_reciprocal: qke,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: Hke,
  global_filter_river: Gke,
  global_filter_seaside: Kke,
  global_filter_secondary: Jke,
  "global_filter_secured-pool": "Piscina protegida",
  "global_filter_smokers-welcome": "Fumantes bem-vindos",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: Zke,
  global_filter_villages: Yke,
  "global_filter_washing-machine": "Máquina de lavar",
  "global_filter_whole-unit": "",
  global_filter_wifi: Xke,
  global_filters: Qke,
  global_fixDates: exe,
  global_flexDates_aMonth: txe,
  global_flexDates_aWeekend: axe,
  global_flexDates_oneWeek: oxe,
  global_flexDates_twoWeek: nxe,
  global_flexibleDates: rxe,
  global_guests: ixe,
  global_homes: sxe,
  global_lastMinute: lxe,
  global_location: cxe,
  global_modify: uxe,
  global_name: dxe,
  global_next: gxe,
  global_numberOfAdults_zero: hxe,
  global_numberOfAdults_one: mxe,
  global_numberOfAdults_other: pxe,
  global_numberOfBabies_zero: fxe,
  global_numberOfBabies_one: bxe,
  global_numberOfBabies_other: _xe,
  global_numberOfChildren_zero: vxe,
  global_numberOfChildren_one: yxe,
  global_numberOfChildren_other: wxe,
  global_numberOfGuests_zero: kxe,
  global_numberOfGuests_one: xxe,
  global_numberOfGuests_other: $xe,
  global_phoneNumber_notValid: Sxe,
  global_receiveEmailAlerts: Cxe,
  global_save: Exe,
  global_searchBar_noLocationFound: zxe,
  global_seeMore_link: jxe,
  global_travelWishlist: Axe,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: Oxe,
  optional: Pxe,
  "privacy-policy": "Privacidade"
}, Nxe = "Contacte-nos", Rxe = "Perguntas frequentes", Ixe = "Guarantias", Txe = "GuestPoints", Mxe = "Ajuda", Lxe = "Log out", Wxe = "Messages", Bxe = "Settings", Fxe = {
  "about-the-calendar": "Calendário",
  "add-home": "Add a home",
  contact: Nxe,
  faq: Rxe,
  guarantees: Ixe,
  guestpoints: Txe,
  help: Mxe,
  "how-it-works": "Como funciona?",
  "how-much-does-it-cost": "Quanto custa?",
  logout: Lxe,
  messages: Wxe,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: Bxe,
  "sign-in": "Iniciar sessão",
  "sign-up": "Inscreva-se",
  "sign-up-for-free": "Filie-se gratuitamente",
  "signin.modal.apple-button": "Iniciar sessão com a Apple",
  "signin.modal.facebook-button": "Iniciar sessão com o Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, Vxe = "https://www.homeexchange.com/pt/blog/", Uxe = "/p/general-terms-of-use", qxe = "https://www.homeexchange.com/pt/p/a-nossa-comunidade-pt", Hxe = "https://homeexchangehelp.zendesk.com/hc/en-us", Gxe = "", Kxe = "https://www.homeexchange.com/pt/p/service-homeexchange-pt", Jxe = "https://www.homeexchange.com/pt/p/os-guestpoints", Zxe = "https://www.homeexchange.com/pt/p/press-pt", Yxe = "https://www.homeexchange.com/p/palavras-de-homeexchangers", Xxe = "", Qxe = "", e1e = "https://www.homeexchange.com/pt/p/onde-as-boas-vindas-comecam", t1e = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/pt/p/about-us-pt",
  blog: Vxe,
  cgu: Uxe,
  community: qxe,
  "contact-us": "https://www.homeexchange.com/pt/contactos-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: Hxe,
  forum: Gxe,
  guarantees: Kxe,
  guestpoints: Jxe,
  "happiness-team": "https://www.homeexchange.com/pt/p/happiness-team-pt",
  "how-it-works": "https://www.homeexchange.com/pt/p/como-funciona-homeexchange",
  "join-us": "https://www.homeexchange.com/pt/p/join-us-pt",
  "legal-notice": "/p/mencoes-legais",
  "mobile-app": "https://www.homeexchange.com/pt/p/app-homeexchange",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: Zxe,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/pt/p/subscription-homeexchange-pt",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: Yxe,
  travelWishlist_faq_links: Xxe,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: Qxe,
  values: e1e
}, a1e = "Studio", o1e = "{{count}} sovrum", n1e = "{{count}} sovrum", r1e = "", i1e = "{{count}} säng", s1e = "{{count}} sängar", l1e = "Vuxna", c1e = "Småbarn", u1e = "Din kalender har uppdaterats.", d1e = "En månad", g1e = "Exakta datum", h1e = "En vecka", m1e = "En helg", p1e = "", f1e = "± {{count}} dag", b1e = "± {{count}} dagar", _1e = "Två veckor", v1e = "Avbryt", y1e = "Barn", w1e = "Datum", k1e = "Ta bort", x1e = "Beskrivning", $1e = "Resmål", S1e = "Klart!", C1e = "Ändra", E1e = "Alla typer av hembyten", z1e = "Badkar", j1e = "Grill", A1e = "Cykel", O1e = "Bil", P1e = "Katt", D1e = "Stad", N1e = "Landsbygd", R1e = "Diskmaskin", I1e = "Hund", T1e = "Torktumlare", M1e = "Hiss", L1e = "Favorithem", W1e = "Eldstad", B1e = "Lägenhet", F1e = "Privat trädgård", V1e = "Mindre än {{max}} GP", U1e = "från {{min}} GP", q1e = "Mellan {{min}} och {{max}} GuestPoints", H1e = "Hemmagym", G1e = "Hus", K1e = "Ö", J1e = "Isolerat", Z1e = "Jacuzzi", Y1e = "Sjö", X1e = "Collection-hem", Q1e = "Berg", e$e = "{{count}} badrum", t$e = "Andra djur", a$e = "Piano", o$e = "Lekplats för barn", n$e = "Primärt", r$e = "Ömsesidigt hembyte", i$e = "Omvänd sökning", s$e = "Älv", l$e = "Kustnära", c$e = "Sekundärt", u$e = "TV", d$e = "By", g$e = "WiFi", h$e = "Filter", m$e = "Fasta datum", p$e = "En månad i {{date}}", f$e = "En helg i {{date}}", b$e = "En vecka i {{date}}", _$e = "Två veckor i {{date}}", v$e = "Flexibla datum", y$e = "Gäster", w$e = "hem", k$e = "Sista minuten", x$e = "Plats", $$e = "Ändra", S$e = "Namn", C$e = "Nästa", E$e = "", z$e = "{{count}} vuxen", j$e = "{{count}} vuxna", A$e = "", O$e = "{{count}} bebis", P$e = "{{count}} bebisar", D$e = "", N$e = "{{count}} barn", R$e = "{{count}} barn", I$e = "", T$e = "{{count}} gäst", M$e = "{{count}} gäster", L$e = "Telefonnumrets format är inte giltigt.", W$e = "Få e-postaviseringar", B$e = "Spara", F$e = "Inga resmål hittades", V$e = "Se mer", U$e = "Reselista", q$e = "", H$e = "valfritt", G$e = {
  "autocomplete.button": "Sök",
  "autocomplete.placeholder": "Vart ska du ?",
  bedroomsNumbers_zero: a1e,
  bedroomsNumbers_one: o1e,
  bedroomsNumbers_other: n1e,
  beds_zero: r1e,
  beds_one: i1e,
  beds_other: s1e,
  "button.free-signup": "Registrera dig gratis",
  "button.validate": "Godkänn",
  "common.try-again": "Försök igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Får inte överskrida {{limit}} tecken",
  "error.reload": "Ladda om sidan",
  "error.return-homepage": "Gå tillbaka till startsidan",
  "error.subtitle": "Tyvärr kan inte den här sidan nås.",
  "error.title": "Ett fel uppstod på sidan",
  "errors.unable_to_submit.subtitle": "Tyvärr kunde inte ditt formulär skickas in just nu. Vänligen försök igen senare.",
  "errors.unable_to_submit.title": "Hoppsan, vi har stött på ett problem",
  "global.back": "Tillbaka",
  "global.cancel": "Avbryt",
  "global.collection.browsehomes": "Se fler hem",
  "global.collection.contactus": "Kontakta oss",
  "global.confirm": "Bekräfta",
  "global.continue": "Fortsätt",
  "global.getStarted": "Kom igång",
  "global.login": "Logga in",
  "global.select": "Välj",
  global_adults: l1e,
  global_babies: c1e,
  global_calendarUpdated_toast: u1e,
  global_calendar_aMonth: d1e,
  global_calendar_exactDates: g1e,
  global_calendar_oneWeek: h1e,
  global_calendar_oneWeekend: m1e,
  global_calendar_plusMinusDay_zero: p1e,
  global_calendar_plusMinusDay_one: f1e,
  global_calendar_plusMinusDay_other: b1e,
  global_calendar_twoWeeks: _1e,
  global_cancel: v1e,
  global_children: y1e,
  global_dates: w1e,
  global_delete: k1e,
  global_description: x1e,
  global_destination: $1e,
  global_done: S1e,
  global_edit: C1e,
  "global_filter_a-c": "Luftkonditionering",
  global_filter_available: E1e,
  "global_filter_baby-bed": "Bebissäng",
  "global_filter_baby-gear": "Barnutrustning",
  "global_filter_balcony-terrace": "Balkong/terrass",
  global_filter_bathtub: z1e,
  global_filter_bbq: j1e,
  global_filter_bicycle: A1e,
  global_filter_car: O1e,
  global_filter_cat: P1e,
  "global_filter_children-welcome": "Barn är välkomna",
  global_filter_cities: D1e,
  "global_filter_cleaning-person": "Städare",
  global_filter_countryside: N1e,
  "global_filter_dedicated-workspace": "Kontor",
  "global_filter_disabled-access": "Tillgängligt hem",
  global_filter_dishwasher: R1e,
  global_filter_dog: I1e,
  global_filter_dryer: T1e,
  "global_filter_eco-level": "Endast hållbara hem",
  "global_filter_electric-car-plug": "Elbilsladdare",
  global_filter_elevator: M1e,
  global_filter_favorite: L1e,
  global_filter_fireplace: W1e,
  global_filter_flat: B1e,
  global_filter_garden: F1e,
  "global_filter_guest-wanted": "Hembyte för GuestPoints",
  global_filter_guestPointsMax: V1e,
  global_filter_guestPointsMin: U1e,
  global_filter_guestPointsMinMax: q1e,
  global_filter_gym: H1e,
  "global_filter_heating-system": "Värmesystem",
  "global_filter_high-speed-connexion": "Bredband med hög hastighet",
  global_filter_home: G1e,
  "global_filter_home-verified": "Verifierade hem",
  global_filter_island: K1e,
  global_filter_isolated: J1e,
  global_filter_jacuzzi: Z1e,
  "global_filter_kids-toys": "Barnleksaker",
  global_filter_lakes: Y1e,
  global_filter_luxury: X1e,
  global_filter_mountains: Q1e,
  "global_filter_no-bed-up": "Inga tillfälliga sängar",
  global_filter_numOfBathrooms: e$e,
  global_filter_other: t$e,
  "global_filter_parking-space": "Privat parkeringsplats",
  "global_filter_pets-welcome": "Husdjur är välkomna",
  global_filter_piano: a$e,
  global_filter_playground: o$e,
  global_filter_primary: n$e,
  "global_filter_public-transit-access": "Tillgång till kollektivtrafik",
  global_filter_reciprocal: r$e,
  "global_filter_response-rate-above-threshold": "Svarsprocent ≥ Genomsnittlig",
  global_filter_reverse: i$e,
  global_filter_river: s$e,
  global_filter_seaside: l$e,
  global_filter_secondary: c$e,
  "global_filter_secured-pool": "Säker pool",
  "global_filter_smokers-welcome": "Rökning tillåtet",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: u$e,
  global_filter_villages: d$e,
  "global_filter_washing-machine": "Tvättmaskin",
  "global_filter_whole-unit": "Hela hemmet",
  global_filter_wifi: g$e,
  global_filters: h$e,
  global_fixDates: m$e,
  global_flexDates_aMonth: p$e,
  global_flexDates_aWeekend: f$e,
  global_flexDates_oneWeek: b$e,
  global_flexDates_twoWeek: _$e,
  global_flexibleDates: v$e,
  global_guests: y$e,
  global_homes: w$e,
  global_lastMinute: k$e,
  global_location: x$e,
  global_modify: $$e,
  global_name: S$e,
  global_next: C$e,
  global_numberOfAdults_zero: E$e,
  global_numberOfAdults_one: z$e,
  global_numberOfAdults_other: j$e,
  global_numberOfBabies_zero: A$e,
  global_numberOfBabies_one: O$e,
  global_numberOfBabies_other: P$e,
  global_numberOfChildren_zero: D$e,
  global_numberOfChildren_one: N$e,
  global_numberOfChildren_other: R$e,
  global_numberOfGuests_zero: I$e,
  global_numberOfGuests_one: T$e,
  global_numberOfGuests_other: M$e,
  global_phoneNumber_notValid: L$e,
  global_receiveEmailAlerts: W$e,
  global_save: B$e,
  global_searchBar_noLocationFound: F$e,
  global_seeMore_link: V$e,
  global_travelWishlist: U$e,
  "modal.error-occured.content": "Vi ber om ursäkt för det, men försök gärna igen.",
  "modal.error-occured.title": "Hoppsan, ett fel uppstod!",
  no_result: q$e,
  optional: H$e,
  "privacy-policy": "Sekretesspolicy"
}, K$e = "Kontakta oss", J$e = "FAQ", Z$e = "Garantier", Y$e = "GuestPoints", X$e = "Hjälp", Q$e = "Log out", eSe = "Messages", tSe = "Settings", aSe = {
  "about-the-calendar": "Kalender",
  "add-home": "Add a home",
  contact: K$e,
  faq: J$e,
  guarantees: Z$e,
  guestpoints: Y$e,
  help: X$e,
  "how-it-works": "Hur fungerar det?",
  "how-much-does-it-cost": "Hur mycket kostar det?",
  logout: Q$e,
  messages: eSe,
  "my-account": "My account",
  "my-exchanges": "My exchanges",
  "my-favorite-homes": "My favorite homes",
  "my-membership": "My membership",
  "my-preferred-destination": "My preferred destination",
  "my-profile": "My profile",
  "my-response-rate": "My response rate :",
  "no-messages": "You haven’t received any messages yet",
  "notification.home.complete_home": "",
  "notification.home.complete_home_first_time": "",
  "notification.home.empty_calendar": "",
  "notification.home.new_calendar_type": "",
  "notification.home.offline": "",
  "notification.membership.expired": "",
  "notification.membership.lead": "",
  "notification.user_profile.incomplete": "",
  "notification.user_profile.motivate_incomplete": "",
  "refer-your-friends": "Refer your friends",
  settings: tSe,
  "sign-in": "Logga in",
  "sign-up": "Registrera dig",
  "sign-up-for-free": "Registrera dig gratis",
  "signin.modal.apple-button": "Logga in med Apple",
  "signin.modal.facebook-button": "Logga in med Facebook",
  "they-love-my-home": "They love my home",
  "view-inbox": "View inbox"
}, oSe = "https://www.homeexchange.com/blog/", nSe = "/p/general-terms-of-use", rSe = "https://www.homeexchange.com/sv/p/natverket", iSe = "https://homeexchangehelp.zendesk.com/hc/es", sSe = "", lSe = "https://www.homeexchange.com/sv/p/service-homeexchange-sv", cSe = "https://www.homeexchange.com/sv/p/guestpoints-sv", uSe = "https://www.homeexchange.com/sv/p/press-sv", dSe = "https://www.homeexchange.com/p/medlemmarna-har-ordet", gSe = "", hSe = "", mSe = "https://www.homeexchange.com/sv/p/dar-valkomnandet-borjar", pSe = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/sv/p/about-us-sv",
  blog: oSe,
  cgu: nSe,
  community: rSe,
  "contact-us": "https://www.homeexchange.com/sv/kontakta-oss-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: iSe,
  forum: sSe,
  guarantees: lSe,
  guestpoints: cSe,
  "happiness-team": "https://www.homeexchange.com/sv/p/happiness-team-sv",
  "how-it-works": "https://www.homeexchange.com/sv/p/hur-fungerar-det-sv",
  "join-us": "https://www.homeexchange.com/sv/p/join-us-sv",
  "legal-notice": "/p/juridisk-information",
  "mobile-app": "https://www.homeexchange.com/sv/p/app-mobil",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: uSe,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/sv/p/subscription-homeexchange-sv",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: dSe,
  travelWishlist_faq_links: gSe,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: hSe,
  values: mSe
}, fSe = "en", Sy = fte({
  fallbackLng: fSe,
  debug: !1,
  interpolation: {
    escapeValue: !1
  },
  returnEmptyString: !1,
  resources: {
    da: {
      common: loe,
      links: Aoe,
      header: boe
    },
    de: {
      common: kre,
      links: Ure,
      header: Ore
    },
    en: {
      common: Ise,
      links: nle,
      header: qse
    },
    es: {
      common: Zce,
      links: _ue,
      header: rue
    },
    fr: {
      common: uge,
      links: Pge,
      header: vge
    },
    hr: {
      common: Ome,
      links: Qme,
      header: Wme
    },
    it: {
      common: qfe,
      links: hbe,
      header: ebe
    },
    nb: {
      common: rve,
      links: Eve,
      header: mve
    },
    nl: {
      common: vwe,
      links: Bwe,
      header: zwe
    },
    pt: {
      common: Dxe,
      links: t1e,
      header: Fxe
    },
    sv: {
      common: G$e,
      links: pSe,
      header: aSe
    }
  }
});
Sy.init();
const im = Sy;
var bSe = /(%?)(%([sdijo]))/g;
function _Se(e, t) {
  switch (t) {
    case "s":
      return e;
    case "d":
    case "i":
      return Number(e);
    case "j":
      return JSON.stringify(e);
    case "o": {
      if (typeof e == "string")
        return e;
      const a = JSON.stringify(e);
      return a === "{}" || a === "[]" || /^\[object .+?\]$/.test(a) ? e : a;
    }
  }
}
function gd(e, ...t) {
  if (t.length === 0)
    return e;
  let a = 0, o = e.replace(
    bSe,
    (n, r, i, s) => {
      const l = t[a], c = _Se(l, s);
      return r ? n : (a++, c);
    }
  );
  return a < t.length && (o += ` ${t.slice(a).join(" ")}`), o = o.replace(/%{2,2}/g, "%"), o;
}
var vSe = 2;
function ySe(e) {
  if (!e.stack)
    return;
  const t = e.stack.split(`
`);
  t.splice(1, vSe), e.stack = t.join(`
`);
}
var wSe = class extends Error {
  constructor(t, ...a) {
    super(t), this.message = t, this.name = "Invariant Violation", this.message = gd(t, ...a), ySe(this);
  }
}, hd = (e, t, ...a) => {
  if (!e)
    throw new wSe(t, ...a);
};
hd.as = (e, t, a, ...o) => {
  if (!t) {
    const n = o.length === 0 ? a : gd(a, ...o);
    let r;
    try {
      r = Reflect.construct(e, [
        n
      ]);
    } catch {
      r = e(n);
    }
    throw r;
  }
};
const kSe = "[MSW]";
function md(e, ...t) {
  const a = gd(e, ...t);
  return `${kSe} ${a}`;
}
function xSe(e, ...t) {
  console.warn(md(e, ...t));
}
function $Se(e, ...t) {
  console.error(md(e, ...t));
}
const Pc = {
  formatMessage: md,
  warn: xSe,
  error: $Se
};
function SSe() {
  hd(
    typeof URL < "u",
    Pc.formatMessage(
      `Global "URL" class is not defined. This likely means that you're running MSW in an environment that doesn't support all Node.js standard API (e.g. React Native). If that's the case, please use an appropriate polyfill for the "URL" class, like "react-native-url-polyfill".`
    )
  );
}
const CSe = /[/\\]msw[/\\]src[/\\](.+)/, ESe = /(node_modules)?[/\\]lib[/\\](core|browser|node|native|iife)[/\\]|^[^/\\]*$/;
function zSe(e) {
  const t = e.stack;
  if (!t)
    return;
  const a = t.split(`
`).slice(1).find((o) => !(CSe.test(o) || ESe.test(o)));
  return a ? a.replace(/\s*at [^()]*\(([^)]+)\)/, "$1").replace(/^@/, "") : void 0;
}
function jSe(e) {
  return e ? Reflect.has(e, Symbol.iterator) || Reflect.has(e, Symbol.asyncIterator) : !1;
}
class Bi {
  static cache = /* @__PURE__ */ new WeakMap();
  __kind;
  info;
  /**
   * Indicates whether this request handler has been used
   * (its resolver has successfully executed).
   */
  isUsed;
  resolver;
  resolverIterator;
  resolverIteratorResult;
  options;
  constructor(t) {
    this.resolver = t.resolver, this.options = t.options;
    const a = zSe(new Error());
    this.info = {
      ...t.info,
      callFrame: a
    }, this.isUsed = !1, this.__kind = "RequestHandler";
  }
  /**
   * Parse the intercepted request to extract additional information from it.
   * Parsed result is then exposed to other methods of this request handler.
   */
  async parse(t) {
    return {};
  }
  /**
   * Test if this handler matches the given request.
   *
   * This method is not used internally but is exposed
   * as a convenience method for consumers writing custom
   * handlers.
   */
  async test(t) {
    const a = await this.parse({
      request: t.request,
      resolutionContext: t.resolutionContext
    });
    return this.predicate({
      request: t.request,
      parsedResult: a,
      resolutionContext: t.resolutionContext
    });
  }
  extendResolverArgs(t) {
    return {};
  }
  // Clone the request instance before it's passed to the handler phases
  // and the response resolver so we can always read it for logging.
  // We only clone it once per request to avoid unnecessary overhead.
  cloneRequestOrGetFromCache(t) {
    const a = Bi.cache.get(t);
    if (typeof a < "u")
      return a;
    const o = t.clone();
    return Bi.cache.set(t, o), o;
  }
  /**
   * Execute this request handler and produce a mocked response
   * using the given resolver function.
   */
  async run(t) {
    if (this.isUsed && this.options?.once)
      return null;
    const a = this.cloneRequestOrGetFromCache(t.request), o = await this.parse({
      request: t.request,
      resolutionContext: t.resolutionContext
    });
    if (!await this.predicate({
      request: t.request,
      parsedResult: o,
      resolutionContext: t.resolutionContext
    }) || this.isUsed && this.options?.once)
      return null;
    this.isUsed = !0;
    const n = this.wrapResolver(this.resolver), r = this.extendResolverArgs({
      request: t.request,
      parsedResult: o
    }), i = await n({
      ...r,
      requestId: t.requestId,
      request: t.request
    }).catch((s) => {
      if (s instanceof Response)
        return s;
      throw s;
    });
    return this.createExecutionResult({
      // Pass the cloned request to the result so that logging
      // and other consumers could read its body once more.
      request: a,
      requestId: t.requestId,
      response: i,
      parsedResult: o
    });
  }
  wrapResolver(t) {
    return async (a) => {
      if (!this.resolverIterator) {
        const i = await t(a);
        if (!jSe(i))
          return i;
        this.resolverIterator = Symbol.iterator in i ? i[Symbol.iterator]() : i[Symbol.asyncIterator]();
      }
      this.isUsed = !1;
      const { done: o, value: n } = await this.resolverIterator.next(), r = await n;
      return r && (this.resolverIteratorResult = r.clone()), o ? (this.isUsed = !0, this.resolverIteratorResult?.clone()) : r;
    };
  }
  createExecutionResult(t) {
    return {
      handler: this,
      request: t.request,
      requestId: t.requestId,
      response: t.response,
      parsedResult: t.parsedResult
    };
  }
}
function ASe(e, t) {
  return e.toLowerCase() === t.toLowerCase();
}
function OSe(e) {
  return e < 300 ? "#69AB32" : e < 400 ? "#F0BB4B" : "#E95F5D";
}
function PSe(e) {
  const t = /* @__PURE__ */ new Date();
  return `${t.getHours().toString().padStart(2, "0")}:${t.getMinutes().toString().padStart(2, "0")}:${t.getSeconds().toString().padStart(2, "0")}`;
}
async function DSe(e) {
  const t = await e.clone().text();
  return {
    url: new URL(e.url),
    method: e.method,
    headers: Object.fromEntries(e.headers.entries()),
    body: t
  };
}
var NSe = Object.create, Cy = Object.defineProperty, RSe = Object.getOwnPropertyDescriptor, Ey = Object.getOwnPropertyNames, ISe = Object.getPrototypeOf, TSe = Object.prototype.hasOwnProperty, zy = (e, t) => function() {
  return t || (0, e[Ey(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, MSe = (e, t, a, o) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let n of Ey(t))
      !TSe.call(e, n) && n !== a && Cy(e, n, { get: () => t[n], enumerable: !(o = RSe(t, n)) || o.enumerable });
  return e;
}, LSe = (e, t, a) => (a = e != null ? NSe(ISe(e)) : {}, MSe(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  Cy(a, "default", { value: e, enumerable: !0 }),
  e
)), WSe = zy({
  "node_modules/statuses/codes.json"(e, t) {
    t.exports = {
      100: "Continue",
      101: "Switching Protocols",
      102: "Processing",
      103: "Early Hints",
      200: "OK",
      201: "Created",
      202: "Accepted",
      203: "Non-Authoritative Information",
      204: "No Content",
      205: "Reset Content",
      206: "Partial Content",
      207: "Multi-Status",
      208: "Already Reported",
      226: "IM Used",
      300: "Multiple Choices",
      301: "Moved Permanently",
      302: "Found",
      303: "See Other",
      304: "Not Modified",
      305: "Use Proxy",
      307: "Temporary Redirect",
      308: "Permanent Redirect",
      400: "Bad Request",
      401: "Unauthorized",
      402: "Payment Required",
      403: "Forbidden",
      404: "Not Found",
      405: "Method Not Allowed",
      406: "Not Acceptable",
      407: "Proxy Authentication Required",
      408: "Request Timeout",
      409: "Conflict",
      410: "Gone",
      411: "Length Required",
      412: "Precondition Failed",
      413: "Payload Too Large",
      414: "URI Too Long",
      415: "Unsupported Media Type",
      416: "Range Not Satisfiable",
      417: "Expectation Failed",
      418: "I'm a Teapot",
      421: "Misdirected Request",
      422: "Unprocessable Entity",
      423: "Locked",
      424: "Failed Dependency",
      425: "Too Early",
      426: "Upgrade Required",
      428: "Precondition Required",
      429: "Too Many Requests",
      431: "Request Header Fields Too Large",
      451: "Unavailable For Legal Reasons",
      500: "Internal Server Error",
      501: "Not Implemented",
      502: "Bad Gateway",
      503: "Service Unavailable",
      504: "Gateway Timeout",
      505: "HTTP Version Not Supported",
      506: "Variant Also Negotiates",
      507: "Insufficient Storage",
      508: "Loop Detected",
      509: "Bandwidth Limit Exceeded",
      510: "Not Extended",
      511: "Network Authentication Required"
    };
  }
}), BSe = zy({
  "node_modules/statuses/index.js"(e, t) {
    var a = WSe();
    t.exports = s, s.message = a, s.code = o(a), s.codes = n(a), s.redirect = {
      300: !0,
      301: !0,
      302: !0,
      303: !0,
      305: !0,
      307: !0,
      308: !0
    }, s.empty = {
      204: !0,
      205: !0,
      304: !0
    }, s.retry = {
      502: !0,
      503: !0,
      504: !0
    };
    function o(l) {
      var c = {};
      return Object.keys(l).forEach(function(u) {
        var d = l[u], h = Number(u);
        c[d.toLowerCase()] = h;
      }), c;
    }
    function n(l) {
      return Object.keys(l).map(function(c) {
        return Number(c);
      });
    }
    function r(l) {
      var c = l.toLowerCase();
      if (!Object.prototype.hasOwnProperty.call(s.code, c))
        throw new Error('invalid status message: "' + l + '"');
      return s.code[c];
    }
    function i(l) {
      if (!Object.prototype.hasOwnProperty.call(s.message, l))
        throw new Error("invalid status code: " + l);
      return s.message[l];
    }
    function s(l) {
      if (typeof l == "number")
        return i(l);
      if (typeof l != "string")
        throw new TypeError("code must be a number or string");
      var c = parseInt(l, 10);
      return isNaN(c) ? r(l) : i(c);
    }
  }
}), FSe = LSe(BSe()), jy = FSe.default;
/*! Bundled license information:

statuses/index.js:
  (*!
   * statuses
   * Copyright(c) 2014 Jonathan Ong
   * Copyright(c) 2016 Douglas Christopher Wilson
   * MIT Licensed
   *)
*/
const { message: VSe } = jy;
async function USe(e) {
  const t = e.clone(), a = await t.text(), o = t.status || 200, n = t.statusText || VSe[o] || "OK";
  return {
    status: o,
    statusText: n,
    headers: Object.fromEntries(t.headers.entries()),
    body: a
  };
}
function qSe(e) {
  for (var t = [], a = 0; a < e.length; ) {
    var o = e[a];
    if (o === "*" || o === "+" || o === "?") {
      t.push({ type: "MODIFIER", index: a, value: e[a++] });
      continue;
    }
    if (o === "\\") {
      t.push({ type: "ESCAPED_CHAR", index: a++, value: e[a++] });
      continue;
    }
    if (o === "{") {
      t.push({ type: "OPEN", index: a, value: e[a++] });
      continue;
    }
    if (o === "}") {
      t.push({ type: "CLOSE", index: a, value: e[a++] });
      continue;
    }
    if (o === ":") {
      for (var n = "", r = a + 1; r < e.length; ) {
        var i = e.charCodeAt(r);
        if (
          // `0-9`
          i >= 48 && i <= 57 || // `A-Z`
          i >= 65 && i <= 90 || // `a-z`
          i >= 97 && i <= 122 || // `_`
          i === 95
        ) {
          n += e[r++];
          continue;
        }
        break;
      }
      if (!n)
        throw new TypeError("Missing parameter name at ".concat(a));
      t.push({ type: "NAME", index: a, value: n }), a = r;
      continue;
    }
    if (o === "(") {
      var s = 1, l = "", r = a + 1;
      if (e[r] === "?")
        throw new TypeError('Pattern cannot start with "?" at '.concat(r));
      for (; r < e.length; ) {
        if (e[r] === "\\") {
          l += e[r++] + e[r++];
          continue;
        }
        if (e[r] === ")") {
          if (s--, s === 0) {
            r++;
            break;
          }
        } else if (e[r] === "(" && (s++, e[r + 1] !== "?"))
          throw new TypeError("Capturing groups are not allowed at ".concat(r));
        l += e[r++];
      }
      if (s)
        throw new TypeError("Unbalanced pattern at ".concat(a));
      if (!l)
        throw new TypeError("Missing pattern at ".concat(a));
      t.push({ type: "PATTERN", index: a, value: l }), a = r;
      continue;
    }
    t.push({ type: "CHAR", index: a, value: e[a++] });
  }
  return t.push({ type: "END", index: a, value: "" }), t;
}
function HSe(e, t) {
  t === void 0 && (t = {});
  for (var a = qSe(e), o = t.prefixes, n = o === void 0 ? "./" : o, r = t.delimiter, i = r === void 0 ? "/#?" : r, s = [], l = 0, c = 0, u = "", d = function(C) {
    if (c < a.length && a[c].type === C)
      return a[c++].value;
  }, h = function(C) {
    var z = d(C);
    if (z !== void 0)
      return z;
    var R = a[c], H = R.type, M = R.index;
    throw new TypeError("Unexpected ".concat(H, " at ").concat(M, ", expected ").concat(C));
  }, p = function() {
    for (var C = "", z; z = d("CHAR") || d("ESCAPED_CHAR"); )
      C += z;
    return C;
  }, f = function(C) {
    for (var z = 0, R = i; z < R.length; z++) {
      var H = R[z];
      if (C.indexOf(H) > -1)
        return !0;
    }
    return !1;
  }, m = function(C) {
    var z = s[s.length - 1], R = C || (z && typeof z == "string" ? z : "");
    if (z && !R)
      throw new TypeError('Must have text between two parameters, missing text after "'.concat(z.name, '"'));
    return !R || f(R) ? "[^".concat(Oa(i), "]+?") : "(?:(?!".concat(Oa(R), ")[^").concat(Oa(i), "])+?");
  }; c < a.length; ) {
    var b = d("CHAR"), w = d("NAME"), _ = d("PATTERN");
    if (w || _) {
      var y = b || "";
      n.indexOf(y) === -1 && (u += y, y = ""), u && (s.push(u), u = ""), s.push({
        name: w || l++,
        prefix: y,
        suffix: "",
        pattern: _ || m(y),
        modifier: d("MODIFIER") || ""
      });
      continue;
    }
    var k = b || d("ESCAPED_CHAR");
    if (k) {
      u += k;
      continue;
    }
    u && (s.push(u), u = "");
    var x = d("OPEN");
    if (x) {
      var y = p(), S = d("NAME") || "", $ = d("PATTERN") || "", E = p();
      h("CLOSE"), s.push({
        name: S || ($ ? l++ : ""),
        pattern: S && !$ ? m(y) : $,
        prefix: y,
        suffix: E,
        modifier: d("MODIFIER") || ""
      });
      continue;
    }
    h("END");
  }
  return s;
}
function GSe(e, t) {
  var a = [], o = Oy(e, a, t);
  return KSe(o, a, t);
}
function KSe(e, t, a) {
  a === void 0 && (a = {});
  var o = a.decode, n = o === void 0 ? function(r) {
    return r;
  } : o;
  return function(r) {
    var i = e.exec(r);
    if (!i)
      return !1;
    for (var s = i[0], l = i.index, c = /* @__PURE__ */ Object.create(null), u = function(h) {
      if (i[h] === void 0)
        return "continue";
      var p = t[h - 1];
      p.modifier === "*" || p.modifier === "+" ? c[p.name] = i[h].split(p.prefix + p.suffix).map(function(f) {
        return n(f, p);
      }) : c[p.name] = n(i[h], p);
    }, d = 1; d < i.length; d++)
      u(d);
    return { path: s, index: l, params: c };
  };
}
function Oa(e) {
  return e.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");
}
function Ay(e) {
  return e && e.sensitive ? "" : "i";
}
function JSe(e, t) {
  if (!t)
    return e;
  for (var a = /\((?:\?<(.*?)>)?(?!\?)/g, o = 0, n = a.exec(e.source); n; )
    t.push({
      // Use parenthesized substring match if available, index otherwise
      name: n[1] || o++,
      prefix: "",
      suffix: "",
      modifier: "",
      pattern: ""
    }), n = a.exec(e.source);
  return e;
}
function ZSe(e, t, a) {
  var o = e.map(function(n) {
    return Oy(n, t, a).source;
  });
  return new RegExp("(?:".concat(o.join("|"), ")"), Ay(a));
}
function YSe(e, t, a) {
  return XSe(HSe(e, a), t, a);
}
function XSe(e, t, a) {
  a === void 0 && (a = {});
  for (var o = a.strict, n = o === void 0 ? !1 : o, r = a.start, i = r === void 0 ? !0 : r, s = a.end, l = s === void 0 ? !0 : s, c = a.encode, u = c === void 0 ? function(z) {
    return z;
  } : c, d = a.delimiter, h = d === void 0 ? "/#?" : d, p = a.endsWith, f = p === void 0 ? "" : p, m = "[".concat(Oa(f), "]|$"), b = "[".concat(Oa(h), "]"), w = i ? "^" : "", _ = 0, y = e; _ < y.length; _++) {
    var k = y[_];
    if (typeof k == "string")
      w += Oa(u(k));
    else {
      var x = Oa(u(k.prefix)), S = Oa(u(k.suffix));
      if (k.pattern)
        if (t && t.push(k), x || S)
          if (k.modifier === "+" || k.modifier === "*") {
            var $ = k.modifier === "*" ? "?" : "";
            w += "(?:".concat(x, "((?:").concat(k.pattern, ")(?:").concat(S).concat(x, "(?:").concat(k.pattern, "))*)").concat(S, ")").concat($);
          } else
            w += "(?:".concat(x, "(").concat(k.pattern, ")").concat(S, ")").concat(k.modifier);
        else {
          if (k.modifier === "+" || k.modifier === "*")
            throw new TypeError('Can not repeat "'.concat(k.name, '" without a prefix and suffix'));
          w += "(".concat(k.pattern, ")").concat(k.modifier);
        }
      else
        w += "(?:".concat(x).concat(S, ")").concat(k.modifier);
    }
  }
  if (l)
    n || (w += "".concat(b, "?")), w += a.endsWith ? "(?=".concat(m, ")") : "$";
  else {
    var E = e[e.length - 1], C = typeof E == "string" ? b.indexOf(E[E.length - 1]) > -1 : E === void 0;
    n || (w += "(?:".concat(b, "(?=").concat(m, "))?")), C || (w += "(?=".concat(b, "|").concat(m, ")"));
  }
  return new RegExp(w, Ay(a));
}
function Oy(e, t, a) {
  return e instanceof RegExp ? JSe(e, t) : Array.isArray(e) ? ZSe(e, t, a) : YSe(e, t, a);
}
new TextEncoder();
function QSe(e) {
  try {
    return new URL(e), !0;
  } catch {
    return !1;
  }
}
function sm(e, t) {
  const a = Object.getOwnPropertySymbols(t).find((o) => o.description === e);
  if (a)
    return Reflect.get(t, a);
}
var Io = class extends Response {
  static isConfigurableStatusCode(e) {
    return e >= 200 && e <= 599;
  }
  static isRedirectResponse(e) {
    return Io.STATUS_CODES_WITH_REDIRECT.includes(e);
  }
  /**
   * Returns a boolean indicating whether the given response status
   * code represents a response that can have a body.
   */
  static isResponseWithBody(e) {
    return !Io.STATUS_CODES_WITHOUT_BODY.includes(e);
  }
  static setUrl(e, t) {
    if (!e || e === "about:" || !QSe(e))
      return;
    const a = sm("state", t);
    a ? a.urlList.push(new URL(e)) : Object.defineProperty(t, "url", {
      value: e,
      enumerable: !0,
      configurable: !0,
      writable: !1
    });
  }
  /**
   * Parses the given raw HTTP headers into a Fetch API `Headers` instance.
   */
  static parseRawHeaders(e) {
    const t = new Headers();
    for (let a = 0; a < e.length; a += 2)
      t.append(e[a], e[a + 1]);
    return t;
  }
  constructor(e, t = {}) {
    var a;
    const o = (a = t.status) != null ? a : 200, n = Io.isConfigurableStatusCode(o) ? o : 200, r = Io.isResponseWithBody(o) ? e : null;
    if (super(r, {
      status: n,
      statusText: t.statusText,
      headers: t.headers
    }), o !== n) {
      const i = sm("state", this);
      i ? i.status = o : Object.defineProperty(this, "status", {
        value: o,
        enumerable: !0,
        configurable: !0,
        writable: !1
      });
    }
    Io.setUrl(t.url, this);
  }
}, Py = Io;
Py.STATUS_CODES_WITHOUT_BODY = [101, 103, 204, 205, 304];
Py.STATUS_CODES_WITH_REDIRECT = [301, 302, 303, 307, 308];
function Dy() {
  if (typeof navigator < "u" && navigator.product === "ReactNative")
    return !0;
  if (typeof process < "u") {
    const e = process.type;
    return e === "renderer" || e === "worker" ? !1 : !!(process.versions && process.versions.node);
  }
  return !1;
}
var e0e = Object.defineProperty, t0e = (e, t) => {
  for (var a in t)
    e0e(e, a, { get: t[a], enumerable: !0 });
}, a0e = {};
t0e(a0e, {
  blue: () => n0e,
  gray: () => r0e,
  green: () => s0e,
  red: () => i0e,
  yellow: () => o0e
});
function o0e(e) {
  return `\x1B[33m${e}\x1B[0m`;
}
function n0e(e) {
  return `\x1B[34m${e}\x1B[0m`;
}
function r0e(e) {
  return `\x1B[90m${e}\x1B[0m`;
}
function i0e(e) {
  return `\x1B[31m${e}\x1B[0m`;
}
function s0e(e) {
  return `\x1B[32m${e}\x1B[0m`;
}
Dy();
function l0e(e, t = !0) {
  return [t && e.origin, e.pathname].filter(Boolean).join("");
}
const c0e = /[?|#].*$/g;
function u0e(e) {
  return new URL(`/${e}`, "http://localhost").searchParams;
}
function Ny(e) {
  return e.endsWith("?") ? e : e.replace(c0e, "");
}
function d0e(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function g0e(e, t) {
  if (d0e(e) || e.startsWith("*"))
    return e;
  const a = t || typeof location < "u" && location.href;
  return a ? (
    // Encode and decode the path to preserve escaped characters.
    decodeURI(new URL(encodeURI(e), a).href)
  ) : e;
}
function h0e(e, t) {
  if (e instanceof RegExp)
    return e;
  const a = g0e(e, t);
  return Ny(a);
}
function m0e(e) {
  return e.replace(
    /([:a-zA-Z_-]*)(\*{1,2})+/g,
    (t, a, o) => {
      const n = "(.*)";
      return a ? a.startsWith(":") ? `${a}${o}` : `${a}${n}` : n;
    }
  ).replace(/([^/])(:)(?=\d+)/, "$1\\$2").replace(/^([^/]+)(:)(?=\/\/)/, "$1\\$2");
}
function p0e(e, t, a) {
  const o = h0e(t, a), n = typeof o == "string" ? m0e(o) : o, r = l0e(e), i = GSe(n, { decode: decodeURIComponent })(r), s = i && i.params || {};
  return {
    matches: i !== !1,
    params: s
  };
}
function f0e(e) {
  if (typeof location > "u")
    return e.toString();
  const t = e instanceof URL ? e : new URL(e);
  return t.origin === location.origin ? t.pathname : t.origin + t.pathname;
}
var b0e = Object.create, Ry = Object.defineProperty, _0e = Object.getOwnPropertyDescriptor, Iy = Object.getOwnPropertyNames, v0e = Object.getPrototypeOf, y0e = Object.prototype.hasOwnProperty, w0e = (e, t) => function() {
  return t || (0, e[Iy(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, k0e = (e, t, a, o) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let n of Iy(t))
      !y0e.call(e, n) && n !== a && Ry(e, n, { get: () => t[n], enumerable: !(o = _0e(t, n)) || o.enumerable });
  return e;
}, x0e = (e, t, a) => (a = e != null ? b0e(v0e(e)) : {}, k0e(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  Ry(a, "default", { value: e, enumerable: !0 }),
  e
)), $0e = w0e({
  "node_modules/cookie/index.js"(e) {
    e.parse = s, e.serialize = u;
    var t = Object.prototype.toString, a = Object.prototype.hasOwnProperty, o = /^[!#$%&'*+\-.^_`|~0-9A-Za-z]+$/, n = /^("?)[\u0021\u0023-\u002B\u002D-\u003A\u003C-\u005B\u005D-\u007E]*\1$/, r = /^([.]?[a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)([.][a-z0-9]([a-z0-9-]{0,61}[a-z0-9])?)*$/i, i = /^[\u0020-\u003A\u003D-\u007E]*$/;
    function s(f, m) {
      if (typeof f != "string")
        throw new TypeError("argument str must be a string");
      var b = {}, w = f.length;
      if (w < 2) return b;
      var _ = m && m.decode || d, y = 0, k = 0, x = 0;
      do {
        if (k = f.indexOf("=", y), k === -1) break;
        if (x = f.indexOf(";", y), x === -1)
          x = w;
        else if (k > x) {
          y = f.lastIndexOf(";", k - 1) + 1;
          continue;
        }
        var S = l(f, y, k), $ = c(f, k, S), E = f.slice(S, $);
        if (!a.call(b, E)) {
          var C = l(f, k + 1, x), z = c(f, x, C);
          f.charCodeAt(C) === 34 && f.charCodeAt(z - 1) === 34 && (C++, z--);
          var R = f.slice(C, z);
          b[E] = p(R, _);
        }
        y = x + 1;
      } while (y < w);
      return b;
    }
    function l(f, m, b) {
      do {
        var w = f.charCodeAt(m);
        if (w !== 32 && w !== 9) return m;
      } while (++m < b);
      return b;
    }
    function c(f, m, b) {
      for (; m > b; ) {
        var w = f.charCodeAt(--m);
        if (w !== 32 && w !== 9) return m + 1;
      }
      return b;
    }
    function u(f, m, b) {
      var w = b && b.encode || encodeURIComponent;
      if (typeof w != "function")
        throw new TypeError("option encode is invalid");
      if (!o.test(f))
        throw new TypeError("argument name is invalid");
      var _ = w(m);
      if (!n.test(_))
        throw new TypeError("argument val is invalid");
      var y = f + "=" + _;
      if (!b) return y;
      if (b.maxAge != null) {
        var k = Math.floor(b.maxAge);
        if (!isFinite(k))
          throw new TypeError("option maxAge is invalid");
        y += "; Max-Age=" + k;
      }
      if (b.domain) {
        if (!r.test(b.domain))
          throw new TypeError("option domain is invalid");
        y += "; Domain=" + b.domain;
      }
      if (b.path) {
        if (!i.test(b.path))
          throw new TypeError("option path is invalid");
        y += "; Path=" + b.path;
      }
      if (b.expires) {
        var x = b.expires;
        if (!h(x) || isNaN(x.valueOf()))
          throw new TypeError("option expires is invalid");
        y += "; Expires=" + x.toUTCString();
      }
      if (b.httpOnly && (y += "; HttpOnly"), b.secure && (y += "; Secure"), b.partitioned && (y += "; Partitioned"), b.priority) {
        var S = typeof b.priority == "string" ? b.priority.toLowerCase() : b.priority;
        switch (S) {
          case "low":
            y += "; Priority=Low";
            break;
          case "medium":
            y += "; Priority=Medium";
            break;
          case "high":
            y += "; Priority=High";
            break;
          default:
            throw new TypeError("option priority is invalid");
        }
      }
      if (b.sameSite) {
        var $ = typeof b.sameSite == "string" ? b.sameSite.toLowerCase() : b.sameSite;
        switch ($) {
          case !0:
            y += "; SameSite=Strict";
            break;
          case "lax":
            y += "; SameSite=Lax";
            break;
          case "strict":
            y += "; SameSite=Strict";
            break;
          case "none":
            y += "; SameSite=None";
            break;
          default:
            throw new TypeError("option sameSite is invalid");
        }
      }
      return y;
    }
    function d(f) {
      return f.indexOf("%") !== -1 ? decodeURIComponent(f) : f;
    }
    function h(f) {
      return t.call(f) === "[object Date]";
    }
    function p(f, m) {
      try {
        return m(f);
      } catch {
        return f;
      }
    }
  }
}), S0e = x0e($0e()), Ty = S0e.default;
/*! Bundled license information:

cookie/index.js:
  (*!
   * cookie
   * Copyright(c) 2012-2014 Roman Shtylman
   * Copyright(c) 2015 Douglas Christopher Wilson
   * MIT Licensed
   *)
*/
function C0e(e, t) {
  return e.endsWith(t) ? e.length === t.length || e[e.length - t.length - 1] === "." : !1;
}
function E0e(e, t) {
  const a = e.length - t.length - 2, o = e.lastIndexOf(".", a);
  return o === -1 ? e : e.slice(o + 1);
}
function z0e(e, t, a) {
  if (a.validHosts !== null) {
    const n = a.validHosts;
    for (const r of n)
      if (
        /*@__INLINE__*/
        C0e(t, r)
      )
        return r;
  }
  let o = 0;
  if (t.startsWith("."))
    for (; o < t.length && t[o] === "."; )
      o += 1;
  return e.length === t.length - o ? null : (
    /*@__INLINE__*/
    E0e(t, e)
  );
}
function lm(e, t) {
  let a = 0, o = e.length, n = !1;
  if (!t) {
    if (e.startsWith("data:"))
      return null;
    for (; a < e.length && e.charCodeAt(a) <= 32; )
      a += 1;
    for (; o > a + 1 && e.charCodeAt(o - 1) <= 32; )
      o -= 1;
    if (e.charCodeAt(a) === 47 && e.charCodeAt(a + 1) === 47)
      a += 2;
    else {
      const c = e.indexOf(":/", a);
      if (c !== -1) {
        const u = c - a, d = e.charCodeAt(a), h = e.charCodeAt(a + 1), p = e.charCodeAt(a + 2), f = e.charCodeAt(a + 3), m = e.charCodeAt(a + 4);
        if (!(u === 5 && d === 104 && h === 116 && p === 116 && f === 112 && m === 115) && !(u === 4 && d === 104 && h === 116 && p === 116 && f === 112) && !(u === 3 && d === 119 && h === 115 && p === 115) && !(u === 2 && d === 119 && h === 115))
          for (let b = a; b < c; b += 1) {
            const w = e.charCodeAt(b) | 32;
            if (!(w >= 97 && w <= 122 || // [a, z]
            w >= 48 && w <= 57 || // [0, 9]
            w === 46 || // '.'
            w === 45 || // '-'
            w === 43))
              return null;
          }
        for (a = c + 2; e.charCodeAt(a) === 47; )
          a += 1;
      }
    }
    let i = -1, s = -1, l = -1;
    for (let c = a; c < o; c += 1) {
      const u = e.charCodeAt(c);
      if (u === 35 || // '#'
      u === 47 || // '/'
      u === 63) {
        o = c;
        break;
      } else u === 64 ? i = c : u === 93 ? s = c : u === 58 ? l = c : u >= 65 && u <= 90 && (n = !0);
    }
    if (i !== -1 && i > a && i < o && (a = i + 1), e.charCodeAt(a) === 91)
      return s !== -1 ? e.slice(a + 1, s).toLowerCase() : null;
    l !== -1 && l > a && l < o && (o = l);
  }
  for (; o > a + 1 && e.charCodeAt(o - 1) === 46; )
    o -= 1;
  const r = a !== 0 || o !== e.length ? e.slice(a, o) : e;
  return n ? r.toLowerCase() : r;
}
function j0e(e) {
  if (e.length < 7 || e.length > 15)
    return !1;
  let t = 0;
  for (let a = 0; a < e.length; a += 1) {
    const o = e.charCodeAt(a);
    if (o === 46)
      t += 1;
    else if (o < 48 || o > 57)
      return !1;
  }
  return t === 3 && e.charCodeAt(0) !== 46 && e.charCodeAt(e.length - 1) !== 46;
}
function A0e(e) {
  if (e.length < 3)
    return !1;
  let t = e.startsWith("[") ? 1 : 0, a = e.length;
  if (e[a - 1] === "]" && (a -= 1), a - t > 39)
    return !1;
  let o = !1;
  for (; t < a; t += 1) {
    const n = e.charCodeAt(t);
    if (n === 58)
      o = !0;
    else if (!(n >= 48 && n <= 57 || // 0-9
    n >= 97 && n <= 102 || // a-f
    n >= 65 && n <= 90))
      return !1;
  }
  return o;
}
function O0e(e) {
  return A0e(e) || j0e(e);
}
function cm(e) {
  return e >= 97 && e <= 122 || e >= 48 && e <= 57 || e > 127;
}
function um(e) {
  if (e.length > 255 || e.length === 0 || /*@__INLINE__*/
  !cm(e.charCodeAt(0)) && e.charCodeAt(0) !== 46 && // '.' (dot)
  e.charCodeAt(0) !== 95)
    return !1;
  let t = -1, a = -1;
  const o = e.length;
  for (let n = 0; n < o; n += 1) {
    const r = e.charCodeAt(n);
    if (r === 46) {
      if (
        // Check that previous label is < 63 bytes long (64 = 63 + '.')
        n - t > 64 || // Check that previous character was not already a '.'
        a === 46 || // Check that the previous label does not end with a '-' (dash)
        a === 45 || // Check that the previous label does not end with a '_' (underscore)
        a === 95
      )
        return !1;
      t = n;
    } else if (!/*@__INLINE__*/
    (cm(r) || r === 45 || r === 95))
      return !1;
    a = r;
  }
  return (
    // Check that last label is shorter than 63 chars
    o - t - 1 <= 63 && // Check that the last character is an allowed trailing label character.
    // Since we already checked that the char is a valid hostname character,
    // we only need to check that it's different from '-'.
    a !== 45
  );
}
function My({ allowIcannDomains: e = !0, allowPrivateDomains: t = !1, detectIp: a = !0, extractHostname: o = !0, mixedInputs: n = !0, validHosts: r = null, validateHostname: i = !0 }) {
  return {
    allowIcannDomains: e,
    allowPrivateDomains: t,
    detectIp: a,
    extractHostname: o,
    mixedInputs: n,
    validHosts: r,
    validateHostname: i
  };
}
const P0e = (
  /*@__INLINE__*/
  My({})
);
function D0e(e) {
  return e === void 0 ? P0e : (
    /*@__INLINE__*/
    My(e)
  );
}
function N0e() {
  return {
    domain: null,
    domainWithoutSuffix: null,
    hostname: null,
    isIcann: null,
    isIp: null,
    isPrivate: null,
    publicSuffix: null,
    subdomain: null
  };
}
function R0e(e) {
  e.domain = null, e.domainWithoutSuffix = null, e.hostname = null, e.isIcann = null, e.isIp = null, e.isPrivate = null, e.publicSuffix = null, e.subdomain = null;
}
function I0e(e, t, a, o, n) {
  const r = (
    /*@__INLINE__*/
    D0e(o)
  );
  return typeof e != "string" || (r.extractHostname ? r.mixedInputs ? n.hostname = lm(e, um(e)) : n.hostname = lm(e, !1) : n.hostname = e, r.detectIp && n.hostname !== null && (n.isIp = O0e(n.hostname), n.isIp)) ? n : r.validateHostname && r.extractHostname && n.hostname !== null && !um(n.hostname) ? (n.hostname = null, n) : (n.hostname === null || (a(n.hostname, r, n), n.publicSuffix === null) || (n.domain = z0e(n.publicSuffix, n.hostname, r)), n);
}
function T0e(e, t, a) {
  if (!t.allowPrivateDomains && e.length > 3) {
    const o = e.length - 1, n = e.charCodeAt(o), r = e.charCodeAt(o - 1), i = e.charCodeAt(o - 2), s = e.charCodeAt(o - 3);
    if (n === 109 && r === 111 && i === 99 && s === 46)
      return a.isIcann = !0, a.isPrivate = !1, a.publicSuffix = "com", !0;
    if (n === 103 && r === 114 && i === 111 && s === 46)
      return a.isIcann = !0, a.isPrivate = !1, a.publicSuffix = "org", !0;
    if (n === 117 && r === 100 && i === 101 && s === 46)
      return a.isIcann = !0, a.isPrivate = !1, a.publicSuffix = "edu", !0;
    if (n === 118 && r === 111 && i === 103 && s === 46)
      return a.isIcann = !0, a.isPrivate = !1, a.publicSuffix = "gov", !0;
    if (n === 116 && r === 101 && i === 110 && s === 46)
      return a.isIcann = !0, a.isPrivate = !1, a.publicSuffix = "net", !0;
    if (n === 101 && r === 100 && i === 46)
      return a.isIcann = !0, a.isPrivate = !1, a.publicSuffix = "de", !0;
  }
  return !1;
}
const M0e = /* @__PURE__ */ function() {
  const e = [1, {}], t = [0, { city: e }];
  return [0, { ck: [0, { www: e }], jp: [0, { kawasaki: t, kitakyushu: t, kobe: t, nagoya: t, sapporo: t, sendai: t, yokohama: t }] }];
}(), L0e = /* @__PURE__ */ function() {
  const e = [1, {}], t = [2, {}], a = [1, { com: e, edu: e, gov: e, net: e, org: e }], o = [1, { com: e, edu: e, gov: e, mil: e, net: e, org: e }], n = [0, { "*": t }], r = [2, { s: n }], i = [0, { relay: t }], s = [2, { id: t }], l = [1, { gov: e }], c = [2, { vps: t }], u = [0, { airflow: n, "transfer-webapp": t }], d = [0, { "transfer-webapp": t, "transfer-webapp-fips": t }], h = [0, { notebook: t, studio: t }], p = [0, { labeling: t, notebook: t, studio: t }], f = [0, { notebook: t }], m = [0, { labeling: t, notebook: t, "notebook-fips": t, studio: t }], b = [0, { notebook: t, "notebook-fips": t, studio: t, "studio-fips": t }], w = [0, { shop: t }], _ = [0, { "*": e }], y = [1, { co: t }], k = [0, { objects: t }], x = [2, { nodes: t }], S = [0, { my: t }], $ = [0, { s3: t, "s3-accesspoint": t, "s3-website": t }], E = [0, { s3: t, "s3-accesspoint": t }], C = [0, { direct: t }], z = [0, { "webview-assets": t }], R = [0, { vfs: t, "webview-assets": t }], H = [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: $, s3: t, "s3-accesspoint": t, "s3-object-lambda": t, "s3-website": t, "aws-cloud9": z, cloud9: R }], M = [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: E, s3: t, "s3-accesspoint": t, "s3-object-lambda": t, "s3-website": t, "aws-cloud9": z, cloud9: R }], j = [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: $, s3: t, "s3-accesspoint": t, "s3-object-lambda": t, "s3-website": t, "analytics-gateway": t, "aws-cloud9": z, cloud9: R }], U = [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: $, s3: t, "s3-accesspoint": t, "s3-object-lambda": t, "s3-website": t }], I = [0, { s3: t, "s3-accesspoint": t, "s3-accesspoint-fips": t, "s3-fips": t, "s3-website": t }], K = [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: I, s3: t, "s3-accesspoint": t, "s3-accesspoint-fips": t, "s3-fips": t, "s3-object-lambda": t, "s3-website": t, "aws-cloud9": z, cloud9: R }], q = [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: I, s3: t, "s3-accesspoint": t, "s3-accesspoint-fips": t, "s3-deprecated": t, "s3-fips": t, "s3-object-lambda": t, "s3-website": t, "analytics-gateway": t, "aws-cloud9": z, cloud9: R }], te = [0, { s3: t, "s3-accesspoint": t, "s3-accesspoint-fips": t, "s3-fips": t }], O = [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: te, s3: t, "s3-accesspoint": t, "s3-accesspoint-fips": t, "s3-fips": t, "s3-object-lambda": t, "s3-website": t }], A = [0, { auth: t }], N = [0, { auth: t, "auth-fips": t }], B = [0, { "auth-fips": t }], W = [0, { apps: t }], Z = [0, { paas: t }], ee = [2, { eu: t }], L = [0, { app: t }], Y = [0, { site: t }], Q = [1, { com: e, edu: e, net: e, org: e }], J = [0, { j: t }], ae = [0, { dyn: t }], V = [2, { web: t }], fe = [1, { co: e, com: e, edu: e, gov: e, net: e, org: e }], X = [0, { p: t }], Ye = [0, { user: t }], Ve = [0, { cdn: t }], Ft = [2, { raw: n }], ft = [0, { cust: t, reservd: t }], Ba = [0, { cust: t }], Fa = [0, { s3: t }], St = [1, { biz: e, com: e, edu: e, gov: e, info: e, net: e, org: e }], ia = [0, { ipfs: t }], ka = [1, { framer: t }], Va = [0, { forgot: t }], we = [1, { gs: e }], bt = [0, { nes: e }], oe = [1, { k12: e, cc: e, lib: e }], Ua = [1, { cc: e }], gr = [1, { cc: e, lib: e }];
  return [0, { ac: [1, { com: e, edu: e, gov: e, mil: e, net: e, org: e, drr: t, feedback: t, forms: t }], ad: e, ae: [1, { ac: e, co: e, gov: e, mil: e, net: e, org: e, sch: e }], aero: [1, { airline: e, airport: e, "accident-investigation": e, "accident-prevention": e, aerobatic: e, aeroclub: e, aerodrome: e, agents: e, "air-surveillance": e, "air-traffic-control": e, aircraft: e, airtraffic: e, ambulance: e, association: e, author: e, ballooning: e, broker: e, caa: e, cargo: e, catering: e, certification: e, championship: e, charter: e, civilaviation: e, club: e, conference: e, consultant: e, consulting: e, control: e, council: e, crew: e, design: e, dgca: e, educator: e, emergency: e, engine: e, engineer: e, entertainment: e, equipment: e, exchange: e, express: e, federation: e, flight: e, freight: e, fuel: e, gliding: e, government: e, groundhandling: e, group: e, hanggliding: e, homebuilt: e, insurance: e, journal: e, journalist: e, leasing: e, logistics: e, magazine: e, maintenance: e, marketplace: e, media: e, microlight: e, modelling: e, navigation: e, parachuting: e, paragliding: e, "passenger-association": e, pilot: e, press: e, production: e, recreation: e, repbody: e, res: e, research: e, rotorcraft: e, safety: e, scientist: e, services: e, show: e, skydiving: e, software: e, student: e, taxi: e, trader: e, trading: e, trainer: e, union: e, workinggroup: e, works: e }], af: a, ag: [1, { co: e, com: e, net: e, nom: e, org: e, obj: t }], ai: [1, { com: e, net: e, off: e, org: e, uwu: t, framer: t }], al: o, am: [1, { co: e, com: e, commune: e, net: e, org: e, radio: t }], ao: [1, { co: e, ed: e, edu: e, gov: e, gv: e, it: e, og: e, org: e, pb: e }], aq: e, ar: [1, { bet: e, com: e, coop: e, edu: e, gob: e, gov: e, int: e, mil: e, musica: e, mutual: e, net: e, org: e, seg: e, senasa: e, tur: e }], arpa: [1, { e164: e, home: e, "in-addr": e, ip6: e, iris: e, uri: e, urn: e }], as: l, asia: [1, { cloudns: t, daemon: t, dix: t }], at: [1, { 4: t, ac: [1, { sth: e }], co: e, gv: e, or: e, funkfeuer: [0, { wien: t }], futurecms: [0, { "*": t, ex: n, in: n }], futurehosting: t, futuremailing: t, ortsinfo: [0, { ex: n, kunden: n }], biz: t, info: t, "123webseite": t, priv: t, my: t, myspreadshop: t, "12hp": t, "2ix": t, "4lima": t, "lima-city": t }], au: [1, { asn: e, com: [1, { cloudlets: [0, { mel: t }], myspreadshop: t }], edu: [1, { act: e, catholic: e, nsw: e, nt: e, qld: e, sa: e, tas: e, vic: e, wa: e }], gov: [1, { qld: e, sa: e, tas: e, vic: e, wa: e }], id: e, net: e, org: e, conf: e, oz: e, act: e, nsw: e, nt: e, qld: e, sa: e, tas: e, vic: e, wa: e, hrsn: c }], aw: [1, { com: e }], ax: e, az: [1, { biz: e, co: e, com: e, edu: e, gov: e, info: e, int: e, mil: e, name: e, net: e, org: e, pp: e, pro: e }], ba: [1, { com: e, edu: e, gov: e, mil: e, net: e, org: e, brendly: w, rs: t }], bb: [1, { biz: e, co: e, com: e, edu: e, gov: e, info: e, net: e, org: e, store: e, tv: e }], bd: _, be: [1, { ac: e, cloudns: t, webhosting: t, interhostsolutions: [0, { cloud: t }], kuleuven: [0, { ezproxy: t }], "123website": t, myspreadshop: t, transurl: n }], bf: l, bg: [1, { 0: e, 1: e, 2: e, 3: e, 4: e, 5: e, 6: e, 7: e, 8: e, 9: e, a: e, b: e, c: e, d: e, e, f: e, g: e, h: e, i: e, j: e, k: e, l: e, m: e, n: e, o: e, p: e, q: e, r: e, s: e, t: e, u: e, v: e, w: e, x: e, y: e, z: e, barsy: t }], bh: a, bi: [1, { co: e, com: e, edu: e, or: e, org: e }], biz: [1, { activetrail: t, "cloud-ip": t, cloudns: t, jozi: t, dyndns: t, "for-better": t, "for-more": t, "for-some": t, "for-the": t, selfip: t, webhop: t, orx: t, mmafan: t, myftp: t, "no-ip": t, dscloud: t }], bj: [1, { africa: e, agro: e, architectes: e, assur: e, avocats: e, co: e, com: e, eco: e, econo: e, edu: e, info: e, loisirs: e, money: e, net: e, org: e, ote: e, restaurant: e, resto: e, tourism: e, univ: e }], bm: a, bn: [1, { com: e, edu: e, gov: e, net: e, org: e, co: t }], bo: [1, { com: e, edu: e, gob: e, int: e, mil: e, net: e, org: e, tv: e, web: e, academia: e, agro: e, arte: e, blog: e, bolivia: e, ciencia: e, cooperativa: e, democracia: e, deporte: e, ecologia: e, economia: e, empresa: e, indigena: e, industria: e, info: e, medicina: e, movimiento: e, musica: e, natural: e, nombre: e, noticias: e, patria: e, plurinacional: e, politica: e, profesional: e, pueblo: e, revista: e, salud: e, tecnologia: e, tksat: e, transporte: e, wiki: e }], br: [1, { "9guacu": e, abc: e, adm: e, adv: e, agr: e, aju: e, am: e, anani: e, aparecida: e, api: e, app: e, arq: e, art: e, ato: e, b: e, barueri: e, belem: e, bet: e, bhz: e, bib: e, bio: e, blog: e, bmd: e, boavista: e, bsb: e, campinagrande: e, campinas: e, caxias: e, cim: e, cng: e, cnt: e, com: [1, { simplesite: t }], contagem: e, coop: e, coz: e, cri: e, cuiaba: e, curitiba: e, def: e, des: e, det: e, dev: e, ecn: e, eco: e, edu: e, emp: e, enf: e, eng: e, esp: e, etc: e, eti: e, far: e, feira: e, flog: e, floripa: e, fm: e, fnd: e, fortal: e, fot: e, foz: e, fst: e, g12: e, geo: e, ggf: e, goiania: e, gov: [1, { ac: e, al: e, am: e, ap: e, ba: e, ce: e, df: e, es: e, go: e, ma: e, mg: e, ms: e, mt: e, pa: e, pb: e, pe: e, pi: e, pr: e, rj: e, rn: e, ro: e, rr: e, rs: e, sc: e, se: e, sp: e, to: e }], gru: e, ia: e, imb: e, ind: e, inf: e, jab: e, jampa: e, jdf: e, joinville: e, jor: e, jus: e, leg: [1, { ac: t, al: t, am: t, ap: t, ba: t, ce: t, df: t, es: t, go: t, ma: t, mg: t, ms: t, mt: t, pa: t, pb: t, pe: t, pi: t, pr: t, rj: t, rn: t, ro: t, rr: t, rs: t, sc: t, se: t, sp: t, to: t }], leilao: e, lel: e, log: e, londrina: e, macapa: e, maceio: e, manaus: e, maringa: e, mat: e, med: e, mil: e, morena: e, mp: e, mus: e, natal: e, net: e, niteroi: e, nom: _, not: e, ntr: e, odo: e, ong: e, org: e, osasco: e, palmas: e, poa: e, ppg: e, pro: e, psc: e, psi: e, pvh: e, qsl: e, radio: e, rec: e, recife: e, rep: e, ribeirao: e, rio: e, riobranco: e, riopreto: e, salvador: e, sampa: e, santamaria: e, santoandre: e, saobernardo: e, saogonca: e, seg: e, sjc: e, slg: e, slz: e, social: e, sorocaba: e, srv: e, taxi: e, tc: e, tec: e, teo: e, the: e, tmp: e, trd: e, tur: e, tv: e, udi: e, vet: e, vix: e, vlog: e, wiki: e, xyz: e, zlg: e, tche: t }], bs: [1, { com: e, edu: e, gov: e, net: e, org: e, we: t }], bt: a, bv: e, bw: [1, { ac: e, co: e, gov: e, net: e, org: e }], by: [1, { gov: e, mil: e, com: e, of: e, mediatech: t }], bz: [1, { co: e, com: e, edu: e, gov: e, net: e, org: e, za: t, mydns: t, gsj: t }], ca: [1, { ab: e, bc: e, mb: e, nb: e, nf: e, nl: e, ns: e, nt: e, nu: e, on: e, pe: e, qc: e, sk: e, yk: e, gc: e, barsy: t, awdev: n, co: t, "no-ip": t, onid: t, myspreadshop: t, box: t }], cat: e, cc: [1, { cleverapps: t, cloudns: t, ftpaccess: t, "game-server": t, myphotos: t, scrapping: t, twmail: t, csx: t, fantasyleague: t, spawn: [0, { instances: t }] }], cd: l, cf: e, cg: e, ch: [1, { square7: t, cloudns: t, cloudscale: [0, { cust: t, lpg: k, rma: k }], objectstorage: [0, { lpg: t, rma: t }], flow: [0, { ae: [0, { alp1: t }], appengine: t }], "linkyard-cloud": t, gotdns: t, dnsking: t, "123website": t, myspreadshop: t, firenet: [0, { "*": t, svc: n }], "12hp": t, "2ix": t, "4lima": t, "lima-city": t }], ci: [1, { ac: e, "xn--aroport-bya": e, aéroport: e, asso: e, co: e, com: e, ed: e, edu: e, go: e, gouv: e, int: e, net: e, or: e, org: e }], ck: _, cl: [1, { co: e, gob: e, gov: e, mil: e, cloudns: t }], cm: [1, { co: e, com: e, gov: e, net: e }], cn: [1, { ac: e, com: [1, { amazonaws: [0, { "cn-north-1": [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: $, s3: t, "s3-accesspoint": t, "s3-deprecated": t, "s3-object-lambda": t, "s3-website": t }], "cn-northwest-1": [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: E, s3: t, "s3-accesspoint": t, "s3-object-lambda": t, "s3-website": t }], compute: n, airflow: [0, { "cn-north-1": n, "cn-northwest-1": n }], eb: [0, { "cn-north-1": t, "cn-northwest-1": t }], elb: n }], amazonwebservices: [0, { on: [0, { "cn-north-1": u, "cn-northwest-1": u }] }], sagemaker: [0, { "cn-north-1": h, "cn-northwest-1": h }] }], edu: e, gov: e, mil: e, net: e, org: e, "xn--55qx5d": e, 公司: e, "xn--od0alg": e, 網絡: e, "xn--io0a7i": e, 网络: e, ah: e, bj: e, cq: e, fj: e, gd: e, gs: e, gx: e, gz: e, ha: e, hb: e, he: e, hi: e, hk: e, hl: e, hn: e, jl: e, js: e, jx: e, ln: e, mo: e, nm: e, nx: e, qh: e, sc: e, sd: e, sh: [1, { as: t }], sn: e, sx: e, tj: e, tw: e, xj: e, xz: e, yn: e, zj: e, "canva-apps": t, canvasite: S, myqnapcloud: t, quickconnect: C }], co: [1, { com: e, edu: e, gov: e, mil: e, net: e, nom: e, org: e, carrd: t, crd: t, otap: n, hidns: t, leadpages: t, lpages: t, mypi: t, xmit: n, firewalledreplit: s, repl: s, supabase: [2, { realtime: t, storage: t }] }], com: [1, { a2hosted: t, cpserver: t, adobeaemcloud: [2, { dev: n }], africa: t, airkitapps: t, "airkitapps-au": t, aivencloud: t, alibabacloudcs: t, kasserver: t, amazonaws: [0, { "af-south-1": H, "ap-east-1": M, "ap-northeast-1": j, "ap-northeast-2": j, "ap-northeast-3": H, "ap-south-1": j, "ap-south-2": U, "ap-southeast-1": j, "ap-southeast-2": j, "ap-southeast-3": U, "ap-southeast-4": U, "ap-southeast-5": [0, { "execute-api": t, dualstack: $, s3: t, "s3-accesspoint": t, "s3-deprecated": t, "s3-object-lambda": t, "s3-website": t }], "ca-central-1": K, "ca-west-1": [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: I, s3: t, "s3-accesspoint": t, "s3-accesspoint-fips": t, "s3-fips": t, "s3-object-lambda": t, "s3-website": t }], "eu-central-1": j, "eu-central-2": U, "eu-north-1": M, "eu-south-1": H, "eu-south-2": U, "eu-west-1": [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: $, s3: t, "s3-accesspoint": t, "s3-deprecated": t, "s3-object-lambda": t, "s3-website": t, "analytics-gateway": t, "aws-cloud9": z, cloud9: R }], "eu-west-2": M, "eu-west-3": H, "il-central-1": [0, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: $, s3: t, "s3-accesspoint": t, "s3-object-lambda": t, "s3-website": t, "aws-cloud9": z, cloud9: [0, { vfs: t }] }], "me-central-1": U, "me-south-1": M, "sa-east-1": H, "us-east-1": [2, { "execute-api": t, "emrappui-prod": t, "emrnotebooks-prod": t, "emrstudio-prod": t, dualstack: I, s3: t, "s3-accesspoint": t, "s3-accesspoint-fips": t, "s3-deprecated": t, "s3-fips": t, "s3-object-lambda": t, "s3-website": t, "analytics-gateway": t, "aws-cloud9": z, cloud9: R }], "us-east-2": q, "us-gov-east-1": O, "us-gov-west-1": O, "us-west-1": K, "us-west-2": q, compute: n, "compute-1": n, airflow: [0, { "af-south-1": n, "ap-east-1": n, "ap-northeast-1": n, "ap-northeast-2": n, "ap-northeast-3": n, "ap-south-1": n, "ap-south-2": n, "ap-southeast-1": n, "ap-southeast-2": n, "ap-southeast-3": n, "ap-southeast-4": n, "ap-southeast-5": n, "ca-central-1": n, "ca-west-1": n, "eu-central-1": n, "eu-central-2": n, "eu-north-1": n, "eu-south-1": n, "eu-south-2": n, "eu-west-1": n, "eu-west-2": n, "eu-west-3": n, "il-central-1": n, "me-central-1": n, "me-south-1": n, "sa-east-1": n, "us-east-1": n, "us-east-2": n, "us-west-1": n, "us-west-2": n }], s3: t, "s3-1": t, "s3-ap-east-1": t, "s3-ap-northeast-1": t, "s3-ap-northeast-2": t, "s3-ap-northeast-3": t, "s3-ap-south-1": t, "s3-ap-southeast-1": t, "s3-ap-southeast-2": t, "s3-ca-central-1": t, "s3-eu-central-1": t, "s3-eu-north-1": t, "s3-eu-west-1": t, "s3-eu-west-2": t, "s3-eu-west-3": t, "s3-external-1": t, "s3-fips-us-gov-east-1": t, "s3-fips-us-gov-west-1": t, "s3-global": [0, { accesspoint: [0, { mrap: t }] }], "s3-me-south-1": t, "s3-sa-east-1": t, "s3-us-east-2": t, "s3-us-gov-east-1": t, "s3-us-gov-west-1": t, "s3-us-west-1": t, "s3-us-west-2": t, "s3-website-ap-northeast-1": t, "s3-website-ap-southeast-1": t, "s3-website-ap-southeast-2": t, "s3-website-eu-west-1": t, "s3-website-sa-east-1": t, "s3-website-us-east-1": t, "s3-website-us-gov-west-1": t, "s3-website-us-west-1": t, "s3-website-us-west-2": t, elb: n }], amazoncognito: [0, { "af-south-1": A, "ap-east-1": A, "ap-northeast-1": A, "ap-northeast-2": A, "ap-northeast-3": A, "ap-south-1": A, "ap-south-2": A, "ap-southeast-1": A, "ap-southeast-2": A, "ap-southeast-3": A, "ap-southeast-4": A, "ap-southeast-5": A, "ap-southeast-7": A, "ca-central-1": A, "ca-west-1": A, "eu-central-1": A, "eu-central-2": A, "eu-north-1": A, "eu-south-1": A, "eu-south-2": A, "eu-west-1": A, "eu-west-2": A, "eu-west-3": A, "il-central-1": A, "me-central-1": A, "me-south-1": A, "mx-central-1": A, "sa-east-1": A, "us-east-1": N, "us-east-2": N, "us-gov-east-1": B, "us-gov-west-1": B, "us-west-1": N, "us-west-2": N }], amplifyapp: t, awsapprunner: n, awsapps: t, elasticbeanstalk: [2, { "af-south-1": t, "ap-east-1": t, "ap-northeast-1": t, "ap-northeast-2": t, "ap-northeast-3": t, "ap-south-1": t, "ap-southeast-1": t, "ap-southeast-2": t, "ap-southeast-3": t, "ca-central-1": t, "eu-central-1": t, "eu-north-1": t, "eu-south-1": t, "eu-west-1": t, "eu-west-2": t, "eu-west-3": t, "il-central-1": t, "me-south-1": t, "sa-east-1": t, "us-east-1": t, "us-east-2": t, "us-gov-east-1": t, "us-gov-west-1": t, "us-west-1": t, "us-west-2": t }], awsglobalaccelerator: t, siiites: t, appspacehosted: t, appspaceusercontent: t, "on-aptible": t, myasustor: t, "balena-devices": t, boutir: t, bplaced: t, cafjs: t, "canva-apps": t, "cdn77-storage": t, br: t, cn: t, de: t, eu: t, jpn: t, mex: t, ru: t, sa: t, uk: t, us: t, za: t, "clever-cloud": [0, { services: n }], dnsabr: t, "ip-ddns": t, jdevcloud: t, wpdevcloud: t, "cf-ipfs": t, "cloudflare-ipfs": t, trycloudflare: t, co: t, devinapps: n, builtwithdark: t, datadetect: [0, { demo: t, instance: t }], dattolocal: t, dattorelay: t, dattoweb: t, mydatto: t, digitaloceanspaces: n, discordsays: t, discordsez: t, drayddns: t, dreamhosters: t, durumis: t, blogdns: t, cechire: t, dnsalias: t, dnsdojo: t, doesntexist: t, dontexist: t, doomdns: t, "dyn-o-saur": t, dynalias: t, "dyndns-at-home": t, "dyndns-at-work": t, "dyndns-blog": t, "dyndns-free": t, "dyndns-home": t, "dyndns-ip": t, "dyndns-mail": t, "dyndns-office": t, "dyndns-pics": t, "dyndns-remote": t, "dyndns-server": t, "dyndns-web": t, "dyndns-wiki": t, "dyndns-work": t, "est-a-la-maison": t, "est-a-la-masion": t, "est-le-patron": t, "est-mon-blogueur": t, "from-ak": t, "from-al": t, "from-ar": t, "from-ca": t, "from-ct": t, "from-dc": t, "from-de": t, "from-fl": t, "from-ga": t, "from-hi": t, "from-ia": t, "from-id": t, "from-il": t, "from-in": t, "from-ks": t, "from-ky": t, "from-ma": t, "from-md": t, "from-mi": t, "from-mn": t, "from-mo": t, "from-ms": t, "from-mt": t, "from-nc": t, "from-nd": t, "from-ne": t, "from-nh": t, "from-nj": t, "from-nm": t, "from-nv": t, "from-oh": t, "from-ok": t, "from-or": t, "from-pa": t, "from-pr": t, "from-ri": t, "from-sc": t, "from-sd": t, "from-tn": t, "from-tx": t, "from-ut": t, "from-va": t, "from-vt": t, "from-wa": t, "from-wi": t, "from-wv": t, "from-wy": t, getmyip: t, gotdns: t, "hobby-site": t, homelinux: t, homeunix: t, iamallama: t, "is-a-anarchist": t, "is-a-blogger": t, "is-a-bookkeeper": t, "is-a-bulls-fan": t, "is-a-caterer": t, "is-a-chef": t, "is-a-conservative": t, "is-a-cpa": t, "is-a-cubicle-slave": t, "is-a-democrat": t, "is-a-designer": t, "is-a-doctor": t, "is-a-financialadvisor": t, "is-a-geek": t, "is-a-green": t, "is-a-guru": t, "is-a-hard-worker": t, "is-a-hunter": t, "is-a-landscaper": t, "is-a-lawyer": t, "is-a-liberal": t, "is-a-libertarian": t, "is-a-llama": t, "is-a-musician": t, "is-a-nascarfan": t, "is-a-nurse": t, "is-a-painter": t, "is-a-personaltrainer": t, "is-a-photographer": t, "is-a-player": t, "is-a-republican": t, "is-a-rockstar": t, "is-a-socialist": t, "is-a-student": t, "is-a-teacher": t, "is-a-techie": t, "is-a-therapist": t, "is-an-accountant": t, "is-an-actor": t, "is-an-actress": t, "is-an-anarchist": t, "is-an-artist": t, "is-an-engineer": t, "is-an-entertainer": t, "is-certified": t, "is-gone": t, "is-into-anime": t, "is-into-cars": t, "is-into-cartoons": t, "is-into-games": t, "is-leet": t, "is-not-certified": t, "is-slick": t, "is-uberleet": t, "is-with-theband": t, "isa-geek": t, "isa-hockeynut": t, issmarterthanyou: t, "likes-pie": t, likescandy: t, "neat-url": t, "saves-the-whales": t, selfip: t, "sells-for-less": t, "sells-for-u": t, servebbs: t, "simple-url": t, "space-to-rent": t, "teaches-yoga": t, writesthisblog: t, ddnsfree: t, ddnsgeek: t, giize: t, gleeze: t, kozow: t, loseyourip: t, ooguy: t, theworkpc: t, mytuleap: t, "tuleap-partners": t, encoreapi: t, evennode: [0, { "eu-1": t, "eu-2": t, "eu-3": t, "eu-4": t, "us-1": t, "us-2": t, "us-3": t, "us-4": t }], onfabrica: t, "fastly-edge": t, "fastly-terrarium": t, "fastvps-server": t, mydobiss: t, firebaseapp: t, fldrv: t, forgeblocks: t, framercanvas: t, "freebox-os": t, freeboxos: t, freemyip: t, aliases121: t, gentapps: t, gentlentapis: t, githubusercontent: t, "0emm": n, appspot: [2, { r: n }], blogspot: t, codespot: t, googleapis: t, googlecode: t, pagespeedmobilizer: t, withgoogle: t, withyoutube: t, grayjayleagues: t, hatenablog: t, hatenadiary: t, herokuapp: t, gr: t, smushcdn: t, wphostedmail: t, wpmucdn: t, pixolino: t, "apps-1and1": t, "live-website": t, "webspace-host": t, dopaas: t, "hosted-by-previder": Z, hosteur: [0, { "rag-cloud": t, "rag-cloud-ch": t }], "ik-server": [0, { jcloud: t, "jcloud-ver-jpc": t }], jelastic: [0, { demo: t }], massivegrid: Z, wafaicloud: [0, { jed: t, ryd: t }], webadorsite: t, joyent: [0, { cns: n }], "on-forge": t, "on-vapor": t, lpusercontent: t, linode: [0, { members: t, nodebalancer: n }], linodeobjects: n, linodeusercontent: [0, { ip: t }], localtonet: t, lovableproject: t, barsycenter: t, barsyonline: t, lutrausercontent: n, modelscape: t, mwcloudnonprod: t, polyspace: t, mazeplay: t, miniserver: t, atmeta: t, fbsbx: W, meteorapp: ee, routingthecloud: t, "same-app": t, "same-preview": t, mydbserver: t, hostedpi: t, "mythic-beasts": [0, { caracal: t, customer: t, fentiger: t, lynx: t, ocelot: t, oncilla: t, onza: t, sphinx: t, vs: t, x: t, yali: t }], nospamproxy: [0, { cloud: [2, { o365: t }] }], "4u": t, nfshost: t, "3utilities": t, blogsyte: t, ciscofreak: t, damnserver: t, ddnsking: t, ditchyourip: t, dnsiskinky: t, dynns: t, geekgalaxy: t, "health-carereform": t, homesecuritymac: t, homesecuritypc: t, myactivedirectory: t, mysecuritycamera: t, myvnc: t, "net-freaks": t, onthewifi: t, point2this: t, quicksytes: t, securitytactics: t, servebeer: t, servecounterstrike: t, serveexchange: t, serveftp: t, servegame: t, servehalflife: t, servehttp: t, servehumour: t, serveirc: t, servemp3: t, servep2p: t, servepics: t, servequake: t, servesarcasm: t, stufftoread: t, unusualperson: t, workisboring: t, myiphost: t, observableusercontent: [0, { static: t }], simplesite: t, oaiusercontent: n, orsites: t, operaunite: t, "customer-oci": [0, { "*": t, oci: n, ocp: n, ocs: n }], oraclecloudapps: n, oraclegovcloudapps: n, "authgear-staging": t, authgearapps: t, skygearapp: t, outsystemscloud: t, ownprovider: t, pgfog: t, pagexl: t, gotpantheon: t, paywhirl: n, upsunapp: t, "postman-echo": t, prgmr: [0, { xen: t }], "project-study": [0, { dev: t }], pythonanywhere: ee, qa2: t, "alpha-myqnapcloud": t, "dev-myqnapcloud": t, mycloudnas: t, mynascloud: t, myqnapcloud: t, qualifioapp: t, ladesk: t, qualyhqpartner: n, qualyhqportal: n, qbuser: t, quipelements: n, rackmaze: t, "readthedocs-hosted": t, rhcloud: t, onrender: t, render: L, "subsc-pay": t, "180r": t, dojin: t, sakuratan: t, sakuraweb: t, x0: t, code: [0, { builder: n, "dev-builder": n, "stg-builder": n }], salesforce: [0, { platform: [0, { "code-builder-stg": [0, { test: [0, { "001": n }] }] }] }], logoip: t, scrysec: t, "firewall-gateway": t, myshopblocks: t, myshopify: t, shopitsite: t, "1kapp": t, appchizi: t, applinzi: t, sinaapp: t, vipsinaapp: t, streamlitapp: t, "try-snowplow": t, "playstation-cloud": t, myspreadshop: t, "w-corp-staticblitz": t, "w-credentialless-staticblitz": t, "w-staticblitz": t, "stackhero-network": t, stdlib: [0, { api: t }], strapiapp: [2, { media: t }], "streak-link": t, streaklinks: t, streakusercontent: t, "temp-dns": t, dsmynas: t, familyds: t, mytabit: t, taveusercontent: t, "tb-hosting": Y, reservd: t, thingdustdata: t, "townnews-staging": t, typeform: [0, { pro: t }], hk: t, it: t, "deus-canvas": t, vultrobjects: n, wafflecell: t, hotelwithflight: t, "reserve-online": t, cprapid: t, pleskns: t, remotewd: t, wiardweb: [0, { pages: t }], wixsite: t, wixstudio: t, messwithdns: t, "woltlab-demo": t, wpenginepowered: [2, { js: t }], xnbay: [2, { u2: t, "u2-local": t }], yolasite: t }], coop: e, cr: [1, { ac: e, co: e, ed: e, fi: e, go: e, or: e, sa: e }], cu: [1, { com: e, edu: e, gob: e, inf: e, nat: e, net: e, org: e }], cv: [1, { com: e, edu: e, id: e, int: e, net: e, nome: e, org: e, publ: e }], cw: Q, cx: [1, { gov: e, cloudns: t, ath: t, info: t, assessments: t, calculators: t, funnels: t, paynow: t, quizzes: t, researched: t, tests: t }], cy: [1, { ac: e, biz: e, com: [1, { scaleforce: J }], ekloges: e, gov: e, ltd: e, mil: e, net: e, org: e, press: e, pro: e, tm: e }], cz: [1, { gov: e, contentproxy9: [0, { rsc: t }], realm: t, e4: t, co: t, metacentrum: [0, { cloud: n, custom: t }], muni: [0, { cloud: [0, { flt: t, usr: t }] }] }], de: [1, { bplaced: t, square7: t, com: t, cosidns: ae, dnsupdater: t, "dynamisches-dns": t, "internet-dns": t, "l-o-g-i-n": t, ddnss: [2, { dyn: t, dyndns: t }], "dyn-ip24": t, dyndns1: t, "home-webserver": [2, { dyn: t }], "myhome-server": t, dnshome: t, fuettertdasnetz: t, isteingeek: t, istmein: t, lebtimnetz: t, leitungsen: t, traeumtgerade: t, frusky: n, goip: t, "xn--gnstigbestellen-zvb": t, günstigbestellen: t, "xn--gnstigliefern-wob": t, günstigliefern: t, "hs-heilbronn": [0, { it: [0, { pages: t, "pages-research": t }] }], "dyn-berlin": t, "in-berlin": t, "in-brb": t, "in-butter": t, "in-dsl": t, "in-vpn": t, iservschule: t, "mein-iserv": t, schuldock: t, schulplattform: t, schulserver: t, "test-iserv": t, keymachine: t, co: t, "git-repos": t, "lcube-server": t, "svn-repos": t, barsy: t, webspaceconfig: t, "123webseite": t, rub: t, "ruhr-uni-bochum": [2, { noc: [0, { io: t }] }], logoip: t, "firewall-gateway": t, "my-gateway": t, "my-router": t, spdns: t, my: t, speedpartner: [0, { customer: t }], myspreadshop: t, "taifun-dns": t, "12hp": t, "2ix": t, "4lima": t, "lima-city": t, "dd-dns": t, "dray-dns": t, draydns: t, "dyn-vpn": t, dynvpn: t, "mein-vigor": t, "my-vigor": t, "my-wan": t, "syno-ds": t, "synology-diskstation": t, "synology-ds": t, "virtual-user": t, virtualuser: t, "community-pro": t, diskussionsbereich: t }], dj: e, dk: [1, { biz: t, co: t, firm: t, reg: t, store: t, "123hjemmeside": t, myspreadshop: t }], dm: fe, do: [1, { art: e, com: e, edu: e, gob: e, gov: e, mil: e, net: e, org: e, sld: e, web: e }], dz: [1, { art: e, asso: e, com: e, edu: e, gov: e, net: e, org: e, pol: e, soc: e, tm: e }], ec: [1, { abg: e, adm: e, agron: e, arqt: e, art: e, bar: e, chef: e, com: e, cont: e, cpa: e, cue: e, dent: e, dgn: e, disco: e, doc: e, edu: e, eng: e, esm: e, fin: e, fot: e, gal: e, gob: e, gov: e, gye: e, ibr: e, info: e, k12: e, lat: e, loj: e, med: e, mil: e, mktg: e, mon: e, net: e, ntr: e, odont: e, org: e, pro: e, prof: e, psic: e, psiq: e, pub: e, rio: e, rrpp: e, sal: e, tech: e, tul: e, tur: e, uio: e, vet: e, xxx: e, base: t, official: t }], edu: [1, { rit: [0, { "git-pages": t }] }], ee: [1, { aip: e, com: e, edu: e, fie: e, gov: e, lib: e, med: e, org: e, pri: e, riik: e }], eg: [1, { ac: e, com: e, edu: e, eun: e, gov: e, info: e, me: e, mil: e, name: e, net: e, org: e, sci: e, sport: e, tv: e }], er: _, es: [1, { com: e, edu: e, gob: e, nom: e, org: e, "123miweb": t, myspreadshop: t }], et: [1, { biz: e, com: e, edu: e, gov: e, info: e, name: e, net: e, org: e }], eu: [1, { airkitapps: t, cloudns: t, dogado: [0, { jelastic: t }], barsy: t, spdns: t, nxa: n, transurl: n, diskstation: t }], fi: [1, { aland: e, dy: t, "xn--hkkinen-5wa": t, häkkinen: t, iki: t, cloudplatform: [0, { fi: t }], datacenter: [0, { demo: t, paas: t }], kapsi: t, "123kotisivu": t, myspreadshop: t }], fj: [1, { ac: e, biz: e, com: e, gov: e, info: e, mil: e, name: e, net: e, org: e, pro: e }], fk: _, fm: [1, { com: e, edu: e, net: e, org: e, radio: t, user: n }], fo: e, fr: [1, { asso: e, com: e, gouv: e, nom: e, prd: e, tm: e, avoues: e, cci: e, greta: e, "huissier-justice": e, "en-root": t, "fbx-os": t, fbxos: t, "freebox-os": t, freeboxos: t, goupile: t, "123siteweb": t, "on-web": t, "chirurgiens-dentistes-en-france": t, dedibox: t, aeroport: t, avocat: t, chambagri: t, "chirurgiens-dentistes": t, "experts-comptables": t, medecin: t, notaires: t, pharmacien: t, port: t, veterinaire: t, myspreadshop: t, ynh: t }], ga: e, gb: e, gd: [1, { edu: e, gov: e }], ge: [1, { com: e, edu: e, gov: e, net: e, org: e, pvt: e, school: e }], gf: e, gg: [1, { co: e, net: e, org: e, botdash: t, kaas: t, stackit: t, panel: [2, { daemon: t }] }], gh: [1, { biz: e, com: e, edu: e, gov: e, mil: e, net: e, org: e }], gi: [1, { com: e, edu: e, gov: e, ltd: e, mod: e, org: e }], gl: [1, { co: e, com: e, edu: e, net: e, org: e }], gm: e, gn: [1, { ac: e, com: e, edu: e, gov: e, net: e, org: e }], gov: e, gp: [1, { asso: e, com: e, edu: e, mobi: e, net: e, org: e }], gq: e, gr: [1, { com: e, edu: e, gov: e, net: e, org: e, barsy: t, simplesite: t }], gs: e, gt: [1, { com: e, edu: e, gob: e, ind: e, mil: e, net: e, org: e }], gu: [1, { com: e, edu: e, gov: e, guam: e, info: e, net: e, org: e, web: e }], gw: [1, { nx: t }], gy: fe, hk: [1, { com: e, edu: e, gov: e, idv: e, net: e, org: e, "xn--ciqpn": e, 个人: e, "xn--gmqw5a": e, 個人: e, "xn--55qx5d": e, 公司: e, "xn--mxtq1m": e, 政府: e, "xn--lcvr32d": e, 敎育: e, "xn--wcvs22d": e, 教育: e, "xn--gmq050i": e, 箇人: e, "xn--uc0atv": e, 組織: e, "xn--uc0ay4a": e, 組织: e, "xn--od0alg": e, 網絡: e, "xn--zf0avx": e, 網络: e, "xn--mk0axi": e, 组織: e, "xn--tn0ag": e, 组织: e, "xn--od0aq3b": e, 网絡: e, "xn--io0a7i": e, 网络: e, inc: t, ltd: t }], hm: e, hn: [1, { com: e, edu: e, gob: e, mil: e, net: e, org: e }], hr: [1, { com: e, from: e, iz: e, name: e, brendly: w }], ht: [1, { adult: e, art: e, asso: e, com: e, coop: e, edu: e, firm: e, gouv: e, info: e, med: e, net: e, org: e, perso: e, pol: e, pro: e, rel: e, shop: e, rt: t }], hu: [1, { 2e3: e, agrar: e, bolt: e, casino: e, city: e, co: e, erotica: e, erotika: e, film: e, forum: e, games: e, hotel: e, info: e, ingatlan: e, jogasz: e, konyvelo: e, lakas: e, media: e, news: e, org: e, priv: e, reklam: e, sex: e, shop: e, sport: e, suli: e, szex: e, tm: e, tozsde: e, utazas: e, video: e }], id: [1, { ac: e, biz: e, co: e, desa: e, go: e, kop: e, mil: e, my: e, net: e, or: e, ponpes: e, sch: e, web: e, zone: t }], ie: [1, { gov: e, myspreadshop: t }], il: [1, { ac: e, co: [1, { ravpage: t, mytabit: t, tabitorder: t }], gov: e, idf: e, k12: e, muni: e, net: e, org: e }], "xn--4dbrk0ce": [1, { "xn--4dbgdty6c": e, "xn--5dbhl8d": e, "xn--8dbq2a": e, "xn--hebda8b": e }], ישראל: [1, { אקדמיה: e, ישוב: e, צהל: e, ממשל: e }], im: [1, { ac: e, co: [1, { ltd: e, plc: e }], com: e, net: e, org: e, tt: e, tv: e }], in: [1, { "5g": e, "6g": e, ac: e, ai: e, am: e, bihar: e, biz: e, business: e, ca: e, cn: e, co: e, com: e, coop: e, cs: e, delhi: e, dr: e, edu: e, er: e, firm: e, gen: e, gov: e, gujarat: e, ind: e, info: e, int: e, internet: e, io: e, me: e, mil: e, net: e, nic: e, org: e, pg: e, post: e, pro: e, res: e, travel: e, tv: e, uk: e, up: e, us: e, cloudns: t, barsy: t, web: t, supabase: t }], info: [1, { cloudns: t, "dynamic-dns": t, "barrel-of-knowledge": t, "barrell-of-knowledge": t, dyndns: t, "for-our": t, "groks-the": t, "groks-this": t, "here-for-more": t, knowsitall: t, selfip: t, webhop: t, barsy: t, mayfirst: t, mittwald: t, mittwaldserver: t, typo3server: t, dvrcam: t, ilovecollege: t, "no-ip": t, forumz: t, nsupdate: t, dnsupdate: t, "v-info": t }], int: [1, { eu: e }], io: [1, { 2038: t, co: e, com: e, edu: e, gov: e, mil: e, net: e, nom: e, org: e, "on-acorn": n, myaddr: t, apigee: t, "b-data": t, beagleboard: t, bitbucket: t, bluebite: t, boxfuse: t, brave: r, browsersafetymark: t, bubble: Ve, bubbleapps: t, bigv: [0, { uk0: t }], cleverapps: t, cloudbeesusercontent: t, dappnode: [0, { dyndns: t }], darklang: t, definima: t, dedyn: t, icp0: Ft, icp1: Ft, qzz: t, "fh-muenster": t, shw: t, forgerock: [0, { id: t }], github: t, gitlab: t, lolipop: t, "hasura-app": t, hostyhosting: t, hypernode: t, moonscale: n, beebyte: Z, beebyteapp: [0, { sekd1: t }], jele: t, webthings: t, loginline: t, barsy: t, azurecontainer: n, ngrok: [2, { ap: t, au: t, eu: t, in: t, jp: t, sa: t, us: t }], nodeart: [0, { stage: t }], pantheonsite: t, pstmn: [2, { mock: t }], protonet: t, qcx: [2, { sys: n }], qoto: t, vaporcloud: t, myrdbx: t, "rb-hosting": Y, "on-k3s": n, "on-rio": n, readthedocs: t, resindevice: t, resinstaging: [0, { devices: t }], hzc: t, sandcats: t, scrypted: [0, { client: t }], "mo-siemens": t, lair: W, stolos: n, musician: t, utwente: t, edugit: t, telebit: t, thingdust: [0, { dev: ft, disrec: ft, prod: Ba, testing: ft }], tickets: t, webflow: t, webflowtest: t, editorx: t, wixstudio: t, basicserver: t, virtualserver: t }], iq: o, ir: [1, { ac: e, co: e, gov: e, id: e, net: e, org: e, sch: e, "xn--mgba3a4f16a": e, ایران: e, "xn--mgba3a4fra": e, ايران: e, arvanedge: t, vistablog: t }], is: e, it: [1, { edu: e, gov: e, abr: e, abruzzo: e, "aosta-valley": e, aostavalley: e, bas: e, basilicata: e, cal: e, calabria: e, cam: e, campania: e, "emilia-romagna": e, emiliaromagna: e, emr: e, "friuli-v-giulia": e, "friuli-ve-giulia": e, "friuli-vegiulia": e, "friuli-venezia-giulia": e, "friuli-veneziagiulia": e, "friuli-vgiulia": e, "friuliv-giulia": e, "friulive-giulia": e, friulivegiulia: e, "friulivenezia-giulia": e, friuliveneziagiulia: e, friulivgiulia: e, fvg: e, laz: e, lazio: e, lig: e, liguria: e, lom: e, lombardia: e, lombardy: e, lucania: e, mar: e, marche: e, mol: e, molise: e, piedmont: e, piemonte: e, pmn: e, pug: e, puglia: e, sar: e, sardegna: e, sardinia: e, sic: e, sicilia: e, sicily: e, taa: e, tos: e, toscana: e, "trentin-sud-tirol": e, "xn--trentin-sd-tirol-rzb": e, "trentin-süd-tirol": e, "trentin-sudtirol": e, "xn--trentin-sdtirol-7vb": e, "trentin-südtirol": e, "trentin-sued-tirol": e, "trentin-suedtirol": e, trentino: e, "trentino-a-adige": e, "trentino-aadige": e, "trentino-alto-adige": e, "trentino-altoadige": e, "trentino-s-tirol": e, "trentino-stirol": e, "trentino-sud-tirol": e, "xn--trentino-sd-tirol-c3b": e, "trentino-süd-tirol": e, "trentino-sudtirol": e, "xn--trentino-sdtirol-szb": e, "trentino-südtirol": e, "trentino-sued-tirol": e, "trentino-suedtirol": e, "trentinoa-adige": e, trentinoaadige: e, "trentinoalto-adige": e, trentinoaltoadige: e, "trentinos-tirol": e, trentinostirol: e, "trentinosud-tirol": e, "xn--trentinosd-tirol-rzb": e, "trentinosüd-tirol": e, trentinosudtirol: e, "xn--trentinosdtirol-7vb": e, trentinosüdtirol: e, "trentinosued-tirol": e, trentinosuedtirol: e, "trentinsud-tirol": e, "xn--trentinsd-tirol-6vb": e, "trentinsüd-tirol": e, trentinsudtirol: e, "xn--trentinsdtirol-nsb": e, trentinsüdtirol: e, "trentinsued-tirol": e, trentinsuedtirol: e, tuscany: e, umb: e, umbria: e, "val-d-aosta": e, "val-daosta": e, "vald-aosta": e, valdaosta: e, "valle-aosta": e, "valle-d-aosta": e, "valle-daosta": e, valleaosta: e, "valled-aosta": e, valledaosta: e, "vallee-aoste": e, "xn--valle-aoste-ebb": e, "vallée-aoste": e, "vallee-d-aoste": e, "xn--valle-d-aoste-ehb": e, "vallée-d-aoste": e, valleeaoste: e, "xn--valleaoste-e7a": e, valléeaoste: e, valleedaoste: e, "xn--valledaoste-ebb": e, valléedaoste: e, vao: e, vda: e, ven: e, veneto: e, ag: e, agrigento: e, al: e, alessandria: e, "alto-adige": e, altoadige: e, an: e, ancona: e, "andria-barletta-trani": e, "andria-trani-barletta": e, andriabarlettatrani: e, andriatranibarletta: e, ao: e, aosta: e, aoste: e, ap: e, aq: e, aquila: e, ar: e, arezzo: e, "ascoli-piceno": e, ascolipiceno: e, asti: e, at: e, av: e, avellino: e, ba: e, balsan: e, "balsan-sudtirol": e, "xn--balsan-sdtirol-nsb": e, "balsan-südtirol": e, "balsan-suedtirol": e, bari: e, "barletta-trani-andria": e, barlettatraniandria: e, belluno: e, benevento: e, bergamo: e, bg: e, bi: e, biella: e, bl: e, bn: e, bo: e, bologna: e, bolzano: e, "bolzano-altoadige": e, bozen: e, "bozen-sudtirol": e, "xn--bozen-sdtirol-2ob": e, "bozen-südtirol": e, "bozen-suedtirol": e, br: e, brescia: e, brindisi: e, bs: e, bt: e, bulsan: e, "bulsan-sudtirol": e, "xn--bulsan-sdtirol-nsb": e, "bulsan-südtirol": e, "bulsan-suedtirol": e, bz: e, ca: e, cagliari: e, caltanissetta: e, "campidano-medio": e, campidanomedio: e, campobasso: e, "carbonia-iglesias": e, carboniaiglesias: e, "carrara-massa": e, carraramassa: e, caserta: e, catania: e, catanzaro: e, cb: e, ce: e, "cesena-forli": e, "xn--cesena-forl-mcb": e, "cesena-forlì": e, cesenaforli: e, "xn--cesenaforl-i8a": e, cesenaforlì: e, ch: e, chieti: e, ci: e, cl: e, cn: e, co: e, como: e, cosenza: e, cr: e, cremona: e, crotone: e, cs: e, ct: e, cuneo: e, cz: e, "dell-ogliastra": e, dellogliastra: e, en: e, enna: e, fc: e, fe: e, fermo: e, ferrara: e, fg: e, fi: e, firenze: e, florence: e, fm: e, foggia: e, "forli-cesena": e, "xn--forl-cesena-fcb": e, "forlì-cesena": e, forlicesena: e, "xn--forlcesena-c8a": e, forlìcesena: e, fr: e, frosinone: e, ge: e, genoa: e, genova: e, go: e, gorizia: e, gr: e, grosseto: e, "iglesias-carbonia": e, iglesiascarbonia: e, im: e, imperia: e, is: e, isernia: e, kr: e, "la-spezia": e, laquila: e, laspezia: e, latina: e, lc: e, le: e, lecce: e, lecco: e, li: e, livorno: e, lo: e, lodi: e, lt: e, lu: e, lucca: e, macerata: e, mantova: e, "massa-carrara": e, massacarrara: e, matera: e, mb: e, mc: e, me: e, "medio-campidano": e, mediocampidano: e, messina: e, mi: e, milan: e, milano: e, mn: e, mo: e, modena: e, monza: e, "monza-brianza": e, "monza-e-della-brianza": e, monzabrianza: e, monzaebrianza: e, monzaedellabrianza: e, ms: e, mt: e, na: e, naples: e, napoli: e, no: e, novara: e, nu: e, nuoro: e, og: e, ogliastra: e, "olbia-tempio": e, olbiatempio: e, or: e, oristano: e, ot: e, pa: e, padova: e, padua: e, palermo: e, parma: e, pavia: e, pc: e, pd: e, pe: e, perugia: e, "pesaro-urbino": e, pesarourbino: e, pescara: e, pg: e, pi: e, piacenza: e, pisa: e, pistoia: e, pn: e, po: e, pordenone: e, potenza: e, pr: e, prato: e, pt: e, pu: e, pv: e, pz: e, ra: e, ragusa: e, ravenna: e, rc: e, re: e, "reggio-calabria": e, "reggio-emilia": e, reggiocalabria: e, reggioemilia: e, rg: e, ri: e, rieti: e, rimini: e, rm: e, rn: e, ro: e, roma: e, rome: e, rovigo: e, sa: e, salerno: e, sassari: e, savona: e, si: e, siena: e, siracusa: e, so: e, sondrio: e, sp: e, sr: e, ss: e, "xn--sdtirol-n2a": e, südtirol: e, suedtirol: e, sv: e, ta: e, taranto: e, te: e, "tempio-olbia": e, tempioolbia: e, teramo: e, terni: e, tn: e, to: e, torino: e, tp: e, tr: e, "trani-andria-barletta": e, "trani-barletta-andria": e, traniandriabarletta: e, tranibarlettaandria: e, trapani: e, trento: e, treviso: e, trieste: e, ts: e, turin: e, tv: e, ud: e, udine: e, "urbino-pesaro": e, urbinopesaro: e, va: e, varese: e, vb: e, vc: e, ve: e, venezia: e, venice: e, verbania: e, vercelli: e, verona: e, vi: e, "vibo-valentia": e, vibovalentia: e, vicenza: e, viterbo: e, vr: e, vs: e, vt: e, vv: e, "12chars": t, ibxos: t, iliadboxos: t, neen: [0, { jc: t }], "123homepage": t, "16-b": t, "32-b": t, "64-b": t, myspreadshop: t, syncloud: t }], je: [1, { co: e, net: e, org: e, of: t }], jm: _, jo: [1, { agri: e, ai: e, com: e, edu: e, eng: e, fm: e, gov: e, mil: e, net: e, org: e, per: e, phd: e, sch: e, tv: e }], jobs: e, jp: [1, { ac: e, ad: e, co: e, ed: e, go: e, gr: e, lg: e, ne: [1, { aseinet: Ye, gehirn: t, ivory: t, "mail-box": t, mints: t, mokuren: t, opal: t, sakura: t, sumomo: t, topaz: t }], or: e, aichi: [1, { aisai: e, ama: e, anjo: e, asuke: e, chiryu: e, chita: e, fuso: e, gamagori: e, handa: e, hazu: e, hekinan: e, higashiura: e, ichinomiya: e, inazawa: e, inuyama: e, isshiki: e, iwakura: e, kanie: e, kariya: e, kasugai: e, kira: e, kiyosu: e, komaki: e, konan: e, kota: e, mihama: e, miyoshi: e, nishio: e, nisshin: e, obu: e, oguchi: e, oharu: e, okazaki: e, owariasahi: e, seto: e, shikatsu: e, shinshiro: e, shitara: e, tahara: e, takahama: e, tobishima: e, toei: e, togo: e, tokai: e, tokoname: e, toyoake: e, toyohashi: e, toyokawa: e, toyone: e, toyota: e, tsushima: e, yatomi: e }], akita: [1, { akita: e, daisen: e, fujisato: e, gojome: e, hachirogata: e, happou: e, higashinaruse: e, honjo: e, honjyo: e, ikawa: e, kamikoani: e, kamioka: e, katagami: e, kazuno: e, kitaakita: e, kosaka: e, kyowa: e, misato: e, mitane: e, moriyoshi: e, nikaho: e, noshiro: e, odate: e, oga: e, ogata: e, semboku: e, yokote: e, yurihonjo: e }], aomori: [1, { aomori: e, gonohe: e, hachinohe: e, hashikami: e, hiranai: e, hirosaki: e, itayanagi: e, kuroishi: e, misawa: e, mutsu: e, nakadomari: e, noheji: e, oirase: e, owani: e, rokunohe: e, sannohe: e, shichinohe: e, shingo: e, takko: e, towada: e, tsugaru: e, tsuruta: e }], chiba: [1, { abiko: e, asahi: e, chonan: e, chosei: e, choshi: e, chuo: e, funabashi: e, futtsu: e, hanamigawa: e, ichihara: e, ichikawa: e, ichinomiya: e, inzai: e, isumi: e, kamagaya: e, kamogawa: e, kashiwa: e, katori: e, katsuura: e, kimitsu: e, kisarazu: e, kozaki: e, kujukuri: e, kyonan: e, matsudo: e, midori: e, mihama: e, minamiboso: e, mobara: e, mutsuzawa: e, nagara: e, nagareyama: e, narashino: e, narita: e, noda: e, oamishirasato: e, omigawa: e, onjuku: e, otaki: e, sakae: e, sakura: e, shimofusa: e, shirako: e, shiroi: e, shisui: e, sodegaura: e, sosa: e, tako: e, tateyama: e, togane: e, tohnosho: e, tomisato: e, urayasu: e, yachimata: e, yachiyo: e, yokaichiba: e, yokoshibahikari: e, yotsukaido: e }], ehime: [1, { ainan: e, honai: e, ikata: e, imabari: e, iyo: e, kamijima: e, kihoku: e, kumakogen: e, masaki: e, matsuno: e, matsuyama: e, namikata: e, niihama: e, ozu: e, saijo: e, seiyo: e, shikokuchuo: e, tobe: e, toon: e, uchiko: e, uwajima: e, yawatahama: e }], fukui: [1, { echizen: e, eiheiji: e, fukui: e, ikeda: e, katsuyama: e, mihama: e, minamiechizen: e, obama: e, ohi: e, ono: e, sabae: e, sakai: e, takahama: e, tsuruga: e, wakasa: e }], fukuoka: [1, { ashiya: e, buzen: e, chikugo: e, chikuho: e, chikujo: e, chikushino: e, chikuzen: e, chuo: e, dazaifu: e, fukuchi: e, hakata: e, higashi: e, hirokawa: e, hisayama: e, iizuka: e, inatsuki: e, kaho: e, kasuga: e, kasuya: e, kawara: e, keisen: e, koga: e, kurate: e, kurogi: e, kurume: e, minami: e, miyako: e, miyama: e, miyawaka: e, mizumaki: e, munakata: e, nakagawa: e, nakama: e, nishi: e, nogata: e, ogori: e, okagaki: e, okawa: e, oki: e, omuta: e, onga: e, onojo: e, oto: e, saigawa: e, sasaguri: e, shingu: e, shinyoshitomi: e, shonai: e, soeda: e, sue: e, tachiarai: e, tagawa: e, takata: e, toho: e, toyotsu: e, tsuiki: e, ukiha: e, umi: e, usui: e, yamada: e, yame: e, yanagawa: e, yukuhashi: e }], fukushima: [1, { aizubange: e, aizumisato: e, aizuwakamatsu: e, asakawa: e, bandai: e, date: e, fukushima: e, furudono: e, futaba: e, hanawa: e, higashi: e, hirata: e, hirono: e, iitate: e, inawashiro: e, ishikawa: e, iwaki: e, izumizaki: e, kagamiishi: e, kaneyama: e, kawamata: e, kitakata: e, kitashiobara: e, koori: e, koriyama: e, kunimi: e, miharu: e, mishima: e, namie: e, nango: e, nishiaizu: e, nishigo: e, okuma: e, omotego: e, ono: e, otama: e, samegawa: e, shimogo: e, shirakawa: e, showa: e, soma: e, sukagawa: e, taishin: e, tamakawa: e, tanagura: e, tenei: e, yabuki: e, yamato: e, yamatsuri: e, yanaizu: e, yugawa: e }], gifu: [1, { anpachi: e, ena: e, gifu: e, ginan: e, godo: e, gujo: e, hashima: e, hichiso: e, hida: e, higashishirakawa: e, ibigawa: e, ikeda: e, kakamigahara: e, kani: e, kasahara: e, kasamatsu: e, kawaue: e, kitagata: e, mino: e, minokamo: e, mitake: e, mizunami: e, motosu: e, nakatsugawa: e, ogaki: e, sakahogi: e, seki: e, sekigahara: e, shirakawa: e, tajimi: e, takayama: e, tarui: e, toki: e, tomika: e, wanouchi: e, yamagata: e, yaotsu: e, yoro: e }], gunma: [1, { annaka: e, chiyoda: e, fujioka: e, higashiagatsuma: e, isesaki: e, itakura: e, kanna: e, kanra: e, katashina: e, kawaba: e, kiryu: e, kusatsu: e, maebashi: e, meiwa: e, midori: e, minakami: e, naganohara: e, nakanojo: e, nanmoku: e, numata: e, oizumi: e, ora: e, ota: e, shibukawa: e, shimonita: e, shinto: e, showa: e, takasaki: e, takayama: e, tamamura: e, tatebayashi: e, tomioka: e, tsukiyono: e, tsumagoi: e, ueno: e, yoshioka: e }], hiroshima: [1, { asaminami: e, daiwa: e, etajima: e, fuchu: e, fukuyama: e, hatsukaichi: e, higashihiroshima: e, hongo: e, jinsekikogen: e, kaita: e, kui: e, kumano: e, kure: e, mihara: e, miyoshi: e, naka: e, onomichi: e, osakikamijima: e, otake: e, saka: e, sera: e, seranishi: e, shinichi: e, shobara: e, takehara: e }], hokkaido: [1, { abashiri: e, abira: e, aibetsu: e, akabira: e, akkeshi: e, asahikawa: e, ashibetsu: e, ashoro: e, assabu: e, atsuma: e, bibai: e, biei: e, bifuka: e, bihoro: e, biratori: e, chippubetsu: e, chitose: e, date: e, ebetsu: e, embetsu: e, eniwa: e, erimo: e, esan: e, esashi: e, fukagawa: e, fukushima: e, furano: e, furubira: e, haboro: e, hakodate: e, hamatonbetsu: e, hidaka: e, higashikagura: e, higashikawa: e, hiroo: e, hokuryu: e, hokuto: e, honbetsu: e, horokanai: e, horonobe: e, ikeda: e, imakane: e, ishikari: e, iwamizawa: e, iwanai: e, kamifurano: e, kamikawa: e, kamishihoro: e, kamisunagawa: e, kamoenai: e, kayabe: e, kembuchi: e, kikonai: e, kimobetsu: e, kitahiroshima: e, kitami: e, kiyosato: e, koshimizu: e, kunneppu: e, kuriyama: e, kuromatsunai: e, kushiro: e, kutchan: e, kyowa: e, mashike: e, matsumae: e, mikasa: e, minamifurano: e, mombetsu: e, moseushi: e, mukawa: e, muroran: e, naie: e, nakagawa: e, nakasatsunai: e, nakatombetsu: e, nanae: e, nanporo: e, nayoro: e, nemuro: e, niikappu: e, niki: e, nishiokoppe: e, noboribetsu: e, numata: e, obihiro: e, obira: e, oketo: e, okoppe: e, otaru: e, otobe: e, otofuke: e, otoineppu: e, oumu: e, ozora: e, pippu: e, rankoshi: e, rebun: e, rikubetsu: e, rishiri: e, rishirifuji: e, saroma: e, sarufutsu: e, shakotan: e, shari: e, shibecha: e, shibetsu: e, shikabe: e, shikaoi: e, shimamaki: e, shimizu: e, shimokawa: e, shinshinotsu: e, shintoku: e, shiranuka: e, shiraoi: e, shiriuchi: e, sobetsu: e, sunagawa: e, taiki: e, takasu: e, takikawa: e, takinoue: e, teshikaga: e, tobetsu: e, tohma: e, tomakomai: e, tomari: e, toya: e, toyako: e, toyotomi: e, toyoura: e, tsubetsu: e, tsukigata: e, urakawa: e, urausu: e, uryu: e, utashinai: e, wakkanai: e, wassamu: e, yakumo: e, yoichi: e }], hyogo: [1, { aioi: e, akashi: e, ako: e, amagasaki: e, aogaki: e, asago: e, ashiya: e, awaji: e, fukusaki: e, goshiki: e, harima: e, himeji: e, ichikawa: e, inagawa: e, itami: e, kakogawa: e, kamigori: e, kamikawa: e, kasai: e, kasuga: e, kawanishi: e, miki: e, minamiawaji: e, nishinomiya: e, nishiwaki: e, ono: e, sanda: e, sannan: e, sasayama: e, sayo: e, shingu: e, shinonsen: e, shiso: e, sumoto: e, taishi: e, taka: e, takarazuka: e, takasago: e, takino: e, tamba: e, tatsuno: e, toyooka: e, yabu: e, yashiro: e, yoka: e, yokawa: e }], ibaraki: [1, { ami: e, asahi: e, bando: e, chikusei: e, daigo: e, fujishiro: e, hitachi: e, hitachinaka: e, hitachiomiya: e, hitachiota: e, ibaraki: e, ina: e, inashiki: e, itako: e, iwama: e, joso: e, kamisu: e, kasama: e, kashima: e, kasumigaura: e, koga: e, miho: e, mito: e, moriya: e, naka: e, namegata: e, oarai: e, ogawa: e, omitama: e, ryugasaki: e, sakai: e, sakuragawa: e, shimodate: e, shimotsuma: e, shirosato: e, sowa: e, suifu: e, takahagi: e, tamatsukuri: e, tokai: e, tomobe: e, tone: e, toride: e, tsuchiura: e, tsukuba: e, uchihara: e, ushiku: e, yachiyo: e, yamagata: e, yawara: e, yuki: e }], ishikawa: [1, { anamizu: e, hakui: e, hakusan: e, kaga: e, kahoku: e, kanazawa: e, kawakita: e, komatsu: e, nakanoto: e, nanao: e, nomi: e, nonoichi: e, noto: e, shika: e, suzu: e, tsubata: e, tsurugi: e, uchinada: e, wajima: e }], iwate: [1, { fudai: e, fujisawa: e, hanamaki: e, hiraizumi: e, hirono: e, ichinohe: e, ichinoseki: e, iwaizumi: e, iwate: e, joboji: e, kamaishi: e, kanegasaki: e, karumai: e, kawai: e, kitakami: e, kuji: e, kunohe: e, kuzumaki: e, miyako: e, mizusawa: e, morioka: e, ninohe: e, noda: e, ofunato: e, oshu: e, otsuchi: e, rikuzentakata: e, shiwa: e, shizukuishi: e, sumita: e, tanohata: e, tono: e, yahaba: e, yamada: e }], kagawa: [1, { ayagawa: e, higashikagawa: e, kanonji: e, kotohira: e, manno: e, marugame: e, mitoyo: e, naoshima: e, sanuki: e, tadotsu: e, takamatsu: e, tonosho: e, uchinomi: e, utazu: e, zentsuji: e }], kagoshima: [1, { akune: e, amami: e, hioki: e, isa: e, isen: e, izumi: e, kagoshima: e, kanoya: e, kawanabe: e, kinko: e, kouyama: e, makurazaki: e, matsumoto: e, minamitane: e, nakatane: e, nishinoomote: e, satsumasendai: e, soo: e, tarumizu: e, yusui: e }], kanagawa: [1, { aikawa: e, atsugi: e, ayase: e, chigasaki: e, ebina: e, fujisawa: e, hadano: e, hakone: e, hiratsuka: e, isehara: e, kaisei: e, kamakura: e, kiyokawa: e, matsuda: e, minamiashigara: e, miura: e, nakai: e, ninomiya: e, odawara: e, oi: e, oiso: e, sagamihara: e, samukawa: e, tsukui: e, yamakita: e, yamato: e, yokosuka: e, yugawara: e, zama: e, zushi: e }], kochi: [1, { aki: e, geisei: e, hidaka: e, higashitsuno: e, ino: e, kagami: e, kami: e, kitagawa: e, kochi: e, mihara: e, motoyama: e, muroto: e, nahari: e, nakamura: e, nankoku: e, nishitosa: e, niyodogawa: e, ochi: e, okawa: e, otoyo: e, otsuki: e, sakawa: e, sukumo: e, susaki: e, tosa: e, tosashimizu: e, toyo: e, tsuno: e, umaji: e, yasuda: e, yusuhara: e }], kumamoto: [1, { amakusa: e, arao: e, aso: e, choyo: e, gyokuto: e, kamiamakusa: e, kikuchi: e, kumamoto: e, mashiki: e, mifune: e, minamata: e, minamioguni: e, nagasu: e, nishihara: e, oguni: e, ozu: e, sumoto: e, takamori: e, uki: e, uto: e, yamaga: e, yamato: e, yatsushiro: e }], kyoto: [1, { ayabe: e, fukuchiyama: e, higashiyama: e, ide: e, ine: e, joyo: e, kameoka: e, kamo: e, kita: e, kizu: e, kumiyama: e, kyotamba: e, kyotanabe: e, kyotango: e, maizuru: e, minami: e, minamiyamashiro: e, miyazu: e, muko: e, nagaokakyo: e, nakagyo: e, nantan: e, oyamazaki: e, sakyo: e, seika: e, tanabe: e, uji: e, ujitawara: e, wazuka: e, yamashina: e, yawata: e }], mie: [1, { asahi: e, inabe: e, ise: e, kameyama: e, kawagoe: e, kiho: e, kisosaki: e, kiwa: e, komono: e, kumano: e, kuwana: e, matsusaka: e, meiwa: e, mihama: e, minamiise: e, misugi: e, miyama: e, nabari: e, shima: e, suzuka: e, tado: e, taiki: e, taki: e, tamaki: e, toba: e, tsu: e, udono: e, ureshino: e, watarai: e, yokkaichi: e }], miyagi: [1, { furukawa: e, higashimatsushima: e, ishinomaki: e, iwanuma: e, kakuda: e, kami: e, kawasaki: e, marumori: e, matsushima: e, minamisanriku: e, misato: e, murata: e, natori: e, ogawara: e, ohira: e, onagawa: e, osaki: e, rifu: e, semine: e, shibata: e, shichikashuku: e, shikama: e, shiogama: e, shiroishi: e, tagajo: e, taiwa: e, tome: e, tomiya: e, wakuya: e, watari: e, yamamoto: e, zao: e }], miyazaki: [1, { aya: e, ebino: e, gokase: e, hyuga: e, kadogawa: e, kawaminami: e, kijo: e, kitagawa: e, kitakata: e, kitaura: e, kobayashi: e, kunitomi: e, kushima: e, mimata: e, miyakonojo: e, miyazaki: e, morotsuka: e, nichinan: e, nishimera: e, nobeoka: e, saito: e, shiiba: e, shintomi: e, takaharu: e, takanabe: e, takazaki: e, tsuno: e }], nagano: [1, { achi: e, agematsu: e, anan: e, aoki: e, asahi: e, azumino: e, chikuhoku: e, chikuma: e, chino: e, fujimi: e, hakuba: e, hara: e, hiraya: e, iida: e, iijima: e, iiyama: e, iizuna: e, ikeda: e, ikusaka: e, ina: e, karuizawa: e, kawakami: e, kiso: e, kisofukushima: e, kitaaiki: e, komagane: e, komoro: e, matsukawa: e, matsumoto: e, miasa: e, minamiaiki: e, minamimaki: e, minamiminowa: e, minowa: e, miyada: e, miyota: e, mochizuki: e, nagano: e, nagawa: e, nagiso: e, nakagawa: e, nakano: e, nozawaonsen: e, obuse: e, ogawa: e, okaya: e, omachi: e, omi: e, ookuwa: e, ooshika: e, otaki: e, otari: e, sakae: e, sakaki: e, saku: e, sakuho: e, shimosuwa: e, shinanomachi: e, shiojiri: e, suwa: e, suzaka: e, takagi: e, takamori: e, takayama: e, tateshina: e, tatsuno: e, togakushi: e, togura: e, tomi: e, ueda: e, wada: e, yamagata: e, yamanouchi: e, yasaka: e, yasuoka: e }], nagasaki: [1, { chijiwa: e, futsu: e, goto: e, hasami: e, hirado: e, iki: e, isahaya: e, kawatana: e, kuchinotsu: e, matsuura: e, nagasaki: e, obama: e, omura: e, oseto: e, saikai: e, sasebo: e, seihi: e, shimabara: e, shinkamigoto: e, togitsu: e, tsushima: e, unzen: e }], nara: [1, { ando: e, gose: e, heguri: e, higashiyoshino: e, ikaruga: e, ikoma: e, kamikitayama: e, kanmaki: e, kashiba: e, kashihara: e, katsuragi: e, kawai: e, kawakami: e, kawanishi: e, koryo: e, kurotaki: e, mitsue: e, miyake: e, nara: e, nosegawa: e, oji: e, ouda: e, oyodo: e, sakurai: e, sango: e, shimoichi: e, shimokitayama: e, shinjo: e, soni: e, takatori: e, tawaramoto: e, tenkawa: e, tenri: e, uda: e, yamatokoriyama: e, yamatotakada: e, yamazoe: e, yoshino: e }], niigata: [1, { aga: e, agano: e, gosen: e, itoigawa: e, izumozaki: e, joetsu: e, kamo: e, kariwa: e, kashiwazaki: e, minamiuonuma: e, mitsuke: e, muika: e, murakami: e, myoko: e, nagaoka: e, niigata: e, ojiya: e, omi: e, sado: e, sanjo: e, seiro: e, seirou: e, sekikawa: e, shibata: e, tagami: e, tainai: e, tochio: e, tokamachi: e, tsubame: e, tsunan: e, uonuma: e, yahiko: e, yoita: e, yuzawa: e }], oita: [1, { beppu: e, bungoono: e, bungotakada: e, hasama: e, hiji: e, himeshima: e, hita: e, kamitsue: e, kokonoe: e, kuju: e, kunisaki: e, kusu: e, oita: e, saiki: e, taketa: e, tsukumi: e, usa: e, usuki: e, yufu: e }], okayama: [1, { akaiwa: e, asakuchi: e, bizen: e, hayashima: e, ibara: e, kagamino: e, kasaoka: e, kibichuo: e, kumenan: e, kurashiki: e, maniwa: e, misaki: e, nagi: e, niimi: e, nishiawakura: e, okayama: e, satosho: e, setouchi: e, shinjo: e, shoo: e, soja: e, takahashi: e, tamano: e, tsuyama: e, wake: e, yakage: e }], okinawa: [1, { aguni: e, ginowan: e, ginoza: e, gushikami: e, haebaru: e, higashi: e, hirara: e, iheya: e, ishigaki: e, ishikawa: e, itoman: e, izena: e, kadena: e, kin: e, kitadaito: e, kitanakagusuku: e, kumejima: e, kunigami: e, minamidaito: e, motobu: e, nago: e, naha: e, nakagusuku: e, nakijin: e, nanjo: e, nishihara: e, ogimi: e, okinawa: e, onna: e, shimoji: e, taketomi: e, tarama: e, tokashiki: e, tomigusuku: e, tonaki: e, urasoe: e, uruma: e, yaese: e, yomitan: e, yonabaru: e, yonaguni: e, zamami: e }], osaka: [1, { abeno: e, chihayaakasaka: e, chuo: e, daito: e, fujiidera: e, habikino: e, hannan: e, higashiosaka: e, higashisumiyoshi: e, higashiyodogawa: e, hirakata: e, ibaraki: e, ikeda: e, izumi: e, izumiotsu: e, izumisano: e, kadoma: e, kaizuka: e, kanan: e, kashiwara: e, katano: e, kawachinagano: e, kishiwada: e, kita: e, kumatori: e, matsubara: e, minato: e, minoh: e, misaki: e, moriguchi: e, neyagawa: e, nishi: e, nose: e, osakasayama: e, sakai: e, sayama: e, sennan: e, settsu: e, shijonawate: e, shimamoto: e, suita: e, tadaoka: e, taishi: e, tajiri: e, takaishi: e, takatsuki: e, tondabayashi: e, toyonaka: e, toyono: e, yao: e }], saga: [1, { ariake: e, arita: e, fukudomi: e, genkai: e, hamatama: e, hizen: e, imari: e, kamimine: e, kanzaki: e, karatsu: e, kashima: e, kitagata: e, kitahata: e, kiyama: e, kouhoku: e, kyuragi: e, nishiarita: e, ogi: e, omachi: e, ouchi: e, saga: e, shiroishi: e, taku: e, tara: e, tosu: e, yoshinogari: e }], saitama: [1, { arakawa: e, asaka: e, chichibu: e, fujimi: e, fujimino: e, fukaya: e, hanno: e, hanyu: e, hasuda: e, hatogaya: e, hatoyama: e, hidaka: e, higashichichibu: e, higashimatsuyama: e, honjo: e, ina: e, iruma: e, iwatsuki: e, kamiizumi: e, kamikawa: e, kamisato: e, kasukabe: e, kawagoe: e, kawaguchi: e, kawajima: e, kazo: e, kitamoto: e, koshigaya: e, kounosu: e, kuki: e, kumagaya: e, matsubushi: e, minano: e, misato: e, miyashiro: e, miyoshi: e, moroyama: e, nagatoro: e, namegawa: e, niiza: e, ogano: e, ogawa: e, ogose: e, okegawa: e, omiya: e, otaki: e, ranzan: e, ryokami: e, saitama: e, sakado: e, satte: e, sayama: e, shiki: e, shiraoka: e, soka: e, sugito: e, toda: e, tokigawa: e, tokorozawa: e, tsurugashima: e, urawa: e, warabi: e, yashio: e, yokoze: e, yono: e, yorii: e, yoshida: e, yoshikawa: e, yoshimi: e }], shiga: [1, { aisho: e, gamo: e, higashiomi: e, hikone: e, koka: e, konan: e, kosei: e, koto: e, kusatsu: e, maibara: e, moriyama: e, nagahama: e, nishiazai: e, notogawa: e, omihachiman: e, otsu: e, ritto: e, ryuoh: e, takashima: e, takatsuki: e, torahime: e, toyosato: e, yasu: e }], shimane: [1, { akagi: e, ama: e, gotsu: e, hamada: e, higashiizumo: e, hikawa: e, hikimi: e, izumo: e, kakinoki: e, masuda: e, matsue: e, misato: e, nishinoshima: e, ohda: e, okinoshima: e, okuizumo: e, shimane: e, tamayu: e, tsuwano: e, unnan: e, yakumo: e, yasugi: e, yatsuka: e }], shizuoka: [1, { arai: e, atami: e, fuji: e, fujieda: e, fujikawa: e, fujinomiya: e, fukuroi: e, gotemba: e, haibara: e, hamamatsu: e, higashiizu: e, ito: e, iwata: e, izu: e, izunokuni: e, kakegawa: e, kannami: e, kawanehon: e, kawazu: e, kikugawa: e, kosai: e, makinohara: e, matsuzaki: e, minamiizu: e, mishima: e, morimachi: e, nishiizu: e, numazu: e, omaezaki: e, shimada: e, shimizu: e, shimoda: e, shizuoka: e, susono: e, yaizu: e, yoshida: e }], tochigi: [1, { ashikaga: e, bato: e, haga: e, ichikai: e, iwafune: e, kaminokawa: e, kanuma: e, karasuyama: e, kuroiso: e, mashiko: e, mibu: e, moka: e, motegi: e, nasu: e, nasushiobara: e, nikko: e, nishikata: e, nogi: e, ohira: e, ohtawara: e, oyama: e, sakura: e, sano: e, shimotsuke: e, shioya: e, takanezawa: e, tochigi: e, tsuga: e, ujiie: e, utsunomiya: e, yaita: e }], tokushima: [1, { aizumi: e, anan: e, ichiba: e, itano: e, kainan: e, komatsushima: e, matsushige: e, mima: e, minami: e, miyoshi: e, mugi: e, nakagawa: e, naruto: e, sanagochi: e, shishikui: e, tokushima: e, wajiki: e }], tokyo: [1, { adachi: e, akiruno: e, akishima: e, aogashima: e, arakawa: e, bunkyo: e, chiyoda: e, chofu: e, chuo: e, edogawa: e, fuchu: e, fussa: e, hachijo: e, hachioji: e, hamura: e, higashikurume: e, higashimurayama: e, higashiyamato: e, hino: e, hinode: e, hinohara: e, inagi: e, itabashi: e, katsushika: e, kita: e, kiyose: e, kodaira: e, koganei: e, kokubunji: e, komae: e, koto: e, kouzushima: e, kunitachi: e, machida: e, meguro: e, minato: e, mitaka: e, mizuho: e, musashimurayama: e, musashino: e, nakano: e, nerima: e, ogasawara: e, okutama: e, ome: e, oshima: e, ota: e, setagaya: e, shibuya: e, shinagawa: e, shinjuku: e, suginami: e, sumida: e, tachikawa: e, taito: e, tama: e, toshima: e }], tottori: [1, { chizu: e, hino: e, kawahara: e, koge: e, kotoura: e, misasa: e, nanbu: e, nichinan: e, sakaiminato: e, tottori: e, wakasa: e, yazu: e, yonago: e }], toyama: [1, { asahi: e, fuchu: e, fukumitsu: e, funahashi: e, himi: e, imizu: e, inami: e, johana: e, kamiichi: e, kurobe: e, nakaniikawa: e, namerikawa: e, nanto: e, nyuzen: e, oyabe: e, taira: e, takaoka: e, tateyama: e, toga: e, tonami: e, toyama: e, unazuki: e, uozu: e, yamada: e }], wakayama: [1, { arida: e, aridagawa: e, gobo: e, hashimoto: e, hidaka: e, hirogawa: e, inami: e, iwade: e, kainan: e, kamitonda: e, katsuragi: e, kimino: e, kinokawa: e, kitayama: e, koya: e, koza: e, kozagawa: e, kudoyama: e, kushimoto: e, mihama: e, misato: e, nachikatsuura: e, shingu: e, shirahama: e, taiji: e, tanabe: e, wakayama: e, yuasa: e, yura: e }], yamagata: [1, { asahi: e, funagata: e, higashine: e, iide: e, kahoku: e, kaminoyama: e, kaneyama: e, kawanishi: e, mamurogawa: e, mikawa: e, murayama: e, nagai: e, nakayama: e, nanyo: e, nishikawa: e, obanazawa: e, oe: e, oguni: e, ohkura: e, oishida: e, sagae: e, sakata: e, sakegawa: e, shinjo: e, shirataka: e, shonai: e, takahata: e, tendo: e, tozawa: e, tsuruoka: e, yamagata: e, yamanobe: e, yonezawa: e, yuza: e }], yamaguchi: [1, { abu: e, hagi: e, hikari: e, hofu: e, iwakuni: e, kudamatsu: e, mitou: e, nagato: e, oshima: e, shimonoseki: e, shunan: e, tabuse: e, tokuyama: e, toyota: e, ube: e, yuu: e }], yamanashi: [1, { chuo: e, doshi: e, fuefuki: e, fujikawa: e, fujikawaguchiko: e, fujiyoshida: e, hayakawa: e, hokuto: e, ichikawamisato: e, kai: e, kofu: e, koshu: e, kosuge: e, "minami-alps": e, minobu: e, nakamichi: e, nanbu: e, narusawa: e, nirasaki: e, nishikatsura: e, oshino: e, otsuki: e, showa: e, tabayama: e, tsuru: e, uenohara: e, yamanakako: e, yamanashi: e }], "xn--ehqz56n": e, 三重: e, "xn--1lqs03n": e, 京都: e, "xn--qqqt11m": e, 佐賀: e, "xn--f6qx53a": e, 兵庫: e, "xn--djrs72d6uy": e, 北海道: e, "xn--mkru45i": e, 千葉: e, "xn--0trq7p7nn": e, 和歌山: e, "xn--5js045d": e, 埼玉: e, "xn--kbrq7o": e, 大分: e, "xn--pssu33l": e, 大阪: e, "xn--ntsq17g": e, 奈良: e, "xn--uisz3g": e, 宮城: e, "xn--6btw5a": e, 宮崎: e, "xn--1ctwo": e, 富山: e, "xn--6orx2r": e, 山口: e, "xn--rht61e": e, 山形: e, "xn--rht27z": e, 山梨: e, "xn--nit225k": e, 岐阜: e, "xn--rht3d": e, 岡山: e, "xn--djty4k": e, 岩手: e, "xn--klty5x": e, 島根: e, "xn--kltx9a": e, 広島: e, "xn--kltp7d": e, 徳島: e, "xn--c3s14m": e, 愛媛: e, "xn--vgu402c": e, 愛知: e, "xn--efvn9s": e, 新潟: e, "xn--1lqs71d": e, 東京: e, "xn--4pvxs": e, 栃木: e, "xn--uuwu58a": e, 沖縄: e, "xn--zbx025d": e, 滋賀: e, "xn--8pvr4u": e, 熊本: e, "xn--5rtp49c": e, 石川: e, "xn--ntso0iqx3a": e, 神奈川: e, "xn--elqq16h": e, 福井: e, "xn--4it168d": e, 福岡: e, "xn--klt787d": e, 福島: e, "xn--rny31h": e, 秋田: e, "xn--7t0a264c": e, 群馬: e, "xn--uist22h": e, 茨城: e, "xn--8ltr62k": e, 長崎: e, "xn--2m4a15e": e, 長野: e, "xn--32vp30h": e, 青森: e, "xn--4it797k": e, 静岡: e, "xn--5rtq34k": e, 香川: e, "xn--k7yn95e": e, 高知: e, "xn--tor131o": e, 鳥取: e, "xn--d5qv7z876c": e, 鹿児島: e, kawasaki: _, kitakyushu: _, kobe: _, nagoya: _, sapporo: _, sendai: _, yokohama: _, buyshop: t, fashionstore: t, handcrafted: t, kawaiishop: t, supersale: t, theshop: t, "0am": t, "0g0": t, "0j0": t, "0t0": t, mydns: t, pgw: t, wjg: t, usercontent: t, angry: t, babyblue: t, babymilk: t, backdrop: t, bambina: t, bitter: t, blush: t, boo: t, boy: t, boyfriend: t, but: t, candypop: t, capoo: t, catfood: t, cheap: t, chicappa: t, chillout: t, chips: t, chowder: t, chu: t, ciao: t, cocotte: t, coolblog: t, cranky: t, cutegirl: t, daa: t, deca: t, deci: t, digick: t, egoism: t, fakefur: t, fem: t, flier: t, floppy: t, fool: t, frenchkiss: t, girlfriend: t, girly: t, gloomy: t, gonna: t, greater: t, hacca: t, heavy: t, her: t, hiho: t, hippy: t, holy: t, hungry: t, icurus: t, itigo: t, jellybean: t, kikirara: t, kill: t, kilo: t, kuron: t, littlestar: t, lolipopmc: t, lolitapunk: t, lomo: t, lovepop: t, lovesick: t, main: t, mods: t, mond: t, mongolian: t, moo: t, namaste: t, nikita: t, nobushi: t, noor: t, oops: t, parallel: t, parasite: t, pecori: t, peewee: t, penne: t, pepper: t, perma: t, pigboat: t, pinoko: t, punyu: t, pupu: t, pussycat: t, pya: t, raindrop: t, readymade: t, sadist: t, schoolbus: t, secret: t, staba: t, stripper: t, sub: t, sunnyday: t, thick: t, tonkotsu: t, under: t, upper: t, velvet: t, verse: t, versus: t, vivian: t, watson: t, weblike: t, whitesnow: t, zombie: t, hateblo: t, hatenablog: t, hatenadiary: t, "2-d": t, bona: t, crap: t, daynight: t, eek: t, flop: t, halfmoon: t, jeez: t, matrix: t, mimoza: t, netgamers: t, nyanta: t, o0o0: t, rdy: t, rgr: t, rulez: t, sakurastorage: [0, { isk01: Fa, isk02: Fa }], saloon: t, sblo: t, skr: t, tank: t, "uh-oh": t, undo: t, webaccel: [0, { rs: t, user: t }], websozai: t, xii: t }], ke: [1, { ac: e, co: e, go: e, info: e, me: e, mobi: e, ne: e, or: e, sc: e }], kg: [1, { com: e, edu: e, gov: e, mil: e, net: e, org: e, us: t, xx: t }], kh: _, ki: St, km: [1, { ass: e, com: e, edu: e, gov: e, mil: e, nom: e, org: e, prd: e, tm: e, asso: e, coop: e, gouv: e, medecin: e, notaires: e, pharmaciens: e, presse: e, veterinaire: e }], kn: [1, { edu: e, gov: e, net: e, org: e }], kp: [1, { com: e, edu: e, gov: e, org: e, rep: e, tra: e }], kr: [1, { ac: e, ai: e, co: e, es: e, go: e, hs: e, io: e, it: e, kg: e, me: e, mil: e, ms: e, ne: e, or: e, pe: e, re: e, sc: e, busan: e, chungbuk: e, chungnam: e, daegu: e, daejeon: e, gangwon: e, gwangju: e, gyeongbuk: e, gyeonggi: e, gyeongnam: e, incheon: e, jeju: e, jeonbuk: e, jeonnam: e, seoul: e, ulsan: e, c01: t, "eliv-cdn": t, "eliv-dns": t, mmv: t, vki: t }], kw: [1, { com: e, edu: e, emb: e, gov: e, ind: e, net: e, org: e }], ky: Q, kz: [1, { com: e, edu: e, gov: e, mil: e, net: e, org: e, jcloud: t }], la: [1, { com: e, edu: e, gov: e, info: e, int: e, net: e, org: e, per: e, bnr: t }], lb: a, lc: [1, { co: e, com: e, edu: e, gov: e, net: e, org: e, oy: t }], li: e, lk: [1, { ac: e, assn: e, com: e, edu: e, gov: e, grp: e, hotel: e, int: e, ltd: e, net: e, ngo: e, org: e, sch: e, soc: e, web: e }], lr: a, ls: [1, { ac: e, biz: e, co: e, edu: e, gov: e, info: e, net: e, org: e, sc: e }], lt: l, lu: [1, { "123website": t }], lv: [1, { asn: e, com: e, conf: e, edu: e, gov: e, id: e, mil: e, net: e, org: e }], ly: [1, { com: e, edu: e, gov: e, id: e, med: e, net: e, org: e, plc: e, sch: e }], ma: [1, { ac: e, co: e, gov: e, net: e, org: e, press: e }], mc: [1, { asso: e, tm: e }], md: [1, { ir: t }], me: [1, { ac: e, co: e, edu: e, gov: e, its: e, net: e, org: e, priv: e, c66: t, craft: t, edgestack: t, filegear: t, "filegear-sg": t, lohmus: t, barsy: t, mcdir: t, brasilia: t, ddns: t, dnsfor: t, hopto: t, loginto: t, noip: t, webhop: t, soundcast: t, tcp4: t, vp4: t, diskstation: t, dscloud: t, i234: t, myds: t, synology: t, transip: Y, nohost: t }], mg: [1, { co: e, com: e, edu: e, gov: e, mil: e, nom: e, org: e, prd: e }], mh: e, mil: e, mk: [1, { com: e, edu: e, gov: e, inf: e, name: e, net: e, org: e }], ml: [1, { ac: e, art: e, asso: e, com: e, edu: e, gouv: e, gov: e, info: e, inst: e, net: e, org: e, pr: e, presse: e }], mm: _, mn: [1, { edu: e, gov: e, org: e, nyc: t }], mo: a, mobi: [1, { barsy: t, dscloud: t }], mp: [1, { ju: t }], mq: e, mr: l, ms: [1, { com: e, edu: e, gov: e, net: e, org: e, minisite: t }], mt: Q, mu: [1, { ac: e, co: e, com: e, gov: e, net: e, or: e, org: e }], museum: e, mv: [1, { aero: e, biz: e, com: e, coop: e, edu: e, gov: e, info: e, int: e, mil: e, museum: e, name: e, net: e, org: e, pro: e }], mw: [1, { ac: e, biz: e, co: e, com: e, coop: e, edu: e, gov: e, int: e, net: e, org: e }], mx: [1, { com: e, edu: e, gob: e, net: e, org: e }], my: [1, { biz: e, com: e, edu: e, gov: e, mil: e, name: e, net: e, org: e }], mz: [1, { ac: e, adv: e, co: e, edu: e, gov: e, mil: e, net: e, org: e }], na: [1, { alt: e, co: e, com: e, gov: e, net: e, org: e }], name: [1, { her: Va, his: Va }], nc: [1, { asso: e, nom: e }], ne: e, net: [1, { adobeaemcloud: t, "adobeio-static": t, adobeioruntime: t, akadns: t, akamai: t, "akamai-staging": t, akamaiedge: t, "akamaiedge-staging": t, akamaihd: t, "akamaihd-staging": t, akamaiorigin: t, "akamaiorigin-staging": t, akamaized: t, "akamaized-staging": t, edgekey: t, "edgekey-staging": t, edgesuite: t, "edgesuite-staging": t, alwaysdata: t, myamaze: t, cloudfront: t, appudo: t, "atlassian-dev": [0, { prod: Ve }], myfritz: t, onavstack: t, shopselect: t, blackbaudcdn: t, boomla: t, bplaced: t, square7: t, cdn77: [0, { r: t }], "cdn77-ssl": t, gb: t, hu: t, jp: t, se: t, uk: t, clickrising: t, "ddns-ip": t, "dns-cloud": t, "dns-dynamic": t, cloudaccess: t, cloudflare: [2, { cdn: t }], cloudflareanycast: Ve, cloudflarecn: Ve, cloudflareglobal: Ve, ctfcloud: t, "feste-ip": t, "knx-server": t, "static-access": t, cryptonomic: n, dattolocal: t, mydatto: t, debian: t, definima: t, deno: t, icp: n, "at-band-camp": t, blogdns: t, "broke-it": t, buyshouses: t, dnsalias: t, dnsdojo: t, "does-it": t, dontexist: t, dynalias: t, dynathome: t, endofinternet: t, "from-az": t, "from-co": t, "from-la": t, "from-ny": t, "gets-it": t, "ham-radio-op": t, homeftp: t, homeip: t, homelinux: t, homeunix: t, "in-the-band": t, "is-a-chef": t, "is-a-geek": t, "isa-geek": t, "kicks-ass": t, "office-on-the": t, podzone: t, "scrapper-site": t, selfip: t, "sells-it": t, servebbs: t, serveftp: t, thruhere: t, webhop: t, casacam: t, dynu: t, dynv6: t, twmail: t, ru: t, channelsdvr: [2, { u: t }], fastly: [0, { freetls: t, map: t, prod: [0, { a: t, global: t }], ssl: [0, { a: t, b: t, global: t }] }], fastlylb: [2, { map: t }], edgeapp: t, "keyword-on": t, "live-on": t, "server-on": t, "cdn-edges": t, heteml: t, cloudfunctions: t, "grafana-dev": t, iobb: t, moonscale: t, "in-dsl": t, "in-vpn": t, oninferno: t, botdash: t, "apps-1and1": t, ipifony: t, cloudjiffy: [2, { "fra1-de": t, "west1-us": t }], elastx: [0, { "jls-sto1": t, "jls-sto2": t, "jls-sto3": t }], massivegrid: [0, { paas: [0, { "fr-1": t, "lon-1": t, "lon-2": t, "ny-1": t, "ny-2": t, "sg-1": t }] }], saveincloud: [0, { jelastic: t, "nordeste-idc": t }], scaleforce: J, kinghost: t, uni5: t, krellian: t, ggff: t, localcert: t, localto: n, barsy: t, luyani: t, memset: t, "azure-api": t, "azure-mobile": t, azureedge: t, azurefd: t, azurestaticapps: [2, { 1: t, 2: t, 3: t, 4: t, 5: t, 6: t, 7: t, centralus: t, eastasia: t, eastus2: t, westeurope: t, westus2: t }], azurewebsites: t, cloudapp: t, trafficmanager: t, windows: [0, { core: [0, { blob: t }], servicebus: t }], mynetname: [0, { sn: t }], routingthecloud: t, bounceme: t, ddns: t, "eating-organic": t, mydissent: t, myeffect: t, mymediapc: t, mypsx: t, mysecuritycamera: t, nhlfan: t, "no-ip": t, pgafan: t, privatizehealthinsurance: t, redirectme: t, serveblog: t, serveminecraft: t, sytes: t, dnsup: t, hicam: t, "now-dns": t, ownip: t, vpndns: t, cloudycluster: t, ovh: [0, { hosting: n, webpaas: n }], rackmaze: t, myradweb: t, in: t, "subsc-pay": t, squares: t, schokokeks: t, "firewall-gateway": t, seidat: t, senseering: t, siteleaf: t, mafelo: t, myspreadshop: t, "vps-host": [2, { jelastic: [0, { atl: t, njs: t, ric: t }] }], srcf: [0, { soc: t, user: t }], supabase: t, dsmynas: t, familyds: t, ts: [2, { c: n }], torproject: [2, { pages: t }], vusercontent: t, "reserve-online": t, "community-pro": t, meinforum: t, yandexcloud: [2, { storage: t, website: t }], za: t, zabc: t }], nf: [1, { arts: e, com: e, firm: e, info: e, net: e, other: e, per: e, rec: e, store: e, web: e }], ng: [1, { com: e, edu: e, gov: e, i: e, mil: e, mobi: e, name: e, net: e, org: e, sch: e, biz: [2, { co: t, dl: t, go: t, lg: t, on: t }], col: t, firm: t, gen: t, ltd: t, ngo: t, plc: t }], ni: [1, { ac: e, biz: e, co: e, com: e, edu: e, gob: e, in: e, info: e, int: e, mil: e, net: e, nom: e, org: e, web: e }], nl: [1, { co: t, "hosting-cluster": t, gov: t, khplay: t, "123website": t, myspreadshop: t, transurl: n, cistron: t, demon: t }], no: [1, { fhs: e, folkebibl: e, fylkesbibl: e, idrett: e, museum: e, priv: e, vgs: e, dep: e, herad: e, kommune: e, mil: e, stat: e, aa: we, ah: we, bu: we, fm: we, hl: we, hm: we, "jan-mayen": we, mr: we, nl: we, nt: we, of: we, ol: we, oslo: we, rl: we, sf: we, st: we, svalbard: we, tm: we, tr: we, va: we, vf: we, akrehamn: e, "xn--krehamn-dxa": e, åkrehamn: e, algard: e, "xn--lgrd-poac": e, ålgård: e, arna: e, bronnoysund: e, "xn--brnnysund-m8ac": e, brønnøysund: e, brumunddal: e, bryne: e, drobak: e, "xn--drbak-wua": e, drøbak: e, egersund: e, fetsund: e, floro: e, "xn--flor-jra": e, florø: e, fredrikstad: e, hokksund: e, honefoss: e, "xn--hnefoss-q1a": e, hønefoss: e, jessheim: e, jorpeland: e, "xn--jrpeland-54a": e, jørpeland: e, kirkenes: e, kopervik: e, krokstadelva: e, langevag: e, "xn--langevg-jxa": e, langevåg: e, leirvik: e, mjondalen: e, "xn--mjndalen-64a": e, mjøndalen: e, "mo-i-rana": e, mosjoen: e, "xn--mosjen-eya": e, mosjøen: e, nesoddtangen: e, orkanger: e, osoyro: e, "xn--osyro-wua": e, osøyro: e, raholt: e, "xn--rholt-mra": e, råholt: e, sandnessjoen: e, "xn--sandnessjen-ogb": e, sandnessjøen: e, skedsmokorset: e, slattum: e, spjelkavik: e, stathelle: e, stavern: e, stjordalshalsen: e, "xn--stjrdalshalsen-sqb": e, stjørdalshalsen: e, tananger: e, tranby: e, vossevangen: e, aarborte: e, aejrie: e, afjord: e, "xn--fjord-lra": e, åfjord: e, agdenes: e, akershus: bt, aknoluokta: e, "xn--koluokta-7ya57h": e, ákŋoluokta: e, al: e, "xn--l-1fa": e, ål: e, alaheadju: e, "xn--laheadju-7ya": e, álaheadju: e, alesund: e, "xn--lesund-hua": e, ålesund: e, alstahaug: e, alta: e, "xn--lt-liac": e, áltá: e, alvdal: e, amli: e, "xn--mli-tla": e, åmli: e, amot: e, "xn--mot-tla": e, åmot: e, andasuolo: e, andebu: e, andoy: e, "xn--andy-ira": e, andøy: e, ardal: e, "xn--rdal-poa": e, årdal: e, aremark: e, arendal: e, "xn--s-1fa": e, ås: e, aseral: e, "xn--seral-lra": e, åseral: e, asker: e, askim: e, askoy: e, "xn--asky-ira": e, askøy: e, askvoll: e, asnes: e, "xn--snes-poa": e, åsnes: e, audnedaln: e, aukra: e, aure: e, aurland: e, "aurskog-holand": e, "xn--aurskog-hland-jnb": e, "aurskog-høland": e, austevoll: e, austrheim: e, averoy: e, "xn--avery-yua": e, averøy: e, badaddja: e, "xn--bdddj-mrabd": e, bådåddjå: e, "xn--brum-voa": e, bærum: e, bahcavuotna: e, "xn--bhcavuotna-s4a": e, báhcavuotna: e, bahccavuotna: e, "xn--bhccavuotna-k7a": e, báhccavuotna: e, baidar: e, "xn--bidr-5nac": e, báidár: e, bajddar: e, "xn--bjddar-pta": e, bájddar: e, balat: e, "xn--blt-elab": e, bálát: e, balestrand: e, ballangen: e, balsfjord: e, bamble: e, bardu: e, barum: e, batsfjord: e, "xn--btsfjord-9za": e, båtsfjord: e, bearalvahki: e, "xn--bearalvhki-y4a": e, bearalváhki: e, beardu: e, beiarn: e, berg: e, bergen: e, berlevag: e, "xn--berlevg-jxa": e, berlevåg: e, bievat: e, "xn--bievt-0qa": e, bievát: e, bindal: e, birkenes: e, bjarkoy: e, "xn--bjarky-fya": e, bjarkøy: e, bjerkreim: e, bjugn: e, bodo: e, "xn--bod-2na": e, bodø: e, bokn: e, bomlo: e, "xn--bmlo-gra": e, bømlo: e, bremanger: e, bronnoy: e, "xn--brnny-wuac": e, brønnøy: e, budejju: e, buskerud: bt, bygland: e, bykle: e, cahcesuolo: e, "xn--hcesuolo-7ya35b": e, čáhcesuolo: e, davvenjarga: e, "xn--davvenjrga-y4a": e, davvenjárga: e, davvesiida: e, deatnu: e, dielddanuorri: e, divtasvuodna: e, divttasvuotna: e, donna: e, "xn--dnna-gra": e, dønna: e, dovre: e, drammen: e, drangedal: e, dyroy: e, "xn--dyry-ira": e, dyrøy: e, eid: e, eidfjord: e, eidsberg: e, eidskog: e, eidsvoll: e, eigersund: e, elverum: e, enebakk: e, engerdal: e, etne: e, etnedal: e, evenassi: e, "xn--eveni-0qa01ga": e, evenášši: e, evenes: e, "evje-og-hornnes": e, farsund: e, fauske: e, fedje: e, fet: e, finnoy: e, "xn--finny-yua": e, finnøy: e, fitjar: e, fjaler: e, fjell: e, fla: e, "xn--fl-zia": e, flå: e, flakstad: e, flatanger: e, flekkefjord: e, flesberg: e, flora: e, folldal: e, forde: e, "xn--frde-gra": e, førde: e, forsand: e, fosnes: e, "xn--frna-woa": e, fræna: e, frana: e, frei: e, frogn: e, froland: e, frosta: e, froya: e, "xn--frya-hra": e, frøya: e, fuoisku: e, fuossko: e, fusa: e, fyresdal: e, gaivuotna: e, "xn--givuotna-8ya": e, gáivuotna: e, galsa: e, "xn--gls-elac": e, gálsá: e, gamvik: e, gangaviika: e, "xn--ggaviika-8ya47h": e, gáŋgaviika: e, gaular: e, gausdal: e, giehtavuoatna: e, gildeskal: e, "xn--gildeskl-g0a": e, gildeskål: e, giske: e, gjemnes: e, gjerdrum: e, gjerstad: e, gjesdal: e, gjovik: e, "xn--gjvik-wua": e, gjøvik: e, gloppen: e, gol: e, gran: e, grane: e, granvin: e, gratangen: e, grimstad: e, grong: e, grue: e, gulen: e, guovdageaidnu: e, ha: e, "xn--h-2fa": e, hå: e, habmer: e, "xn--hbmer-xqa": e, hábmer: e, hadsel: e, "xn--hgebostad-g3a": e, hægebostad: e, hagebostad: e, halden: e, halsa: e, hamar: e, hamaroy: e, hammarfeasta: e, "xn--hmmrfeasta-s4ac": e, hámmárfeasta: e, hammerfest: e, hapmir: e, "xn--hpmir-xqa": e, hápmir: e, haram: e, hareid: e, harstad: e, hasvik: e, hattfjelldal: e, haugesund: e, hedmark: [0, { os: e, valer: e, "xn--vler-qoa": e, våler: e }], hemne: e, hemnes: e, hemsedal: e, hitra: e, hjartdal: e, hjelmeland: e, hobol: e, "xn--hobl-ira": e, hobøl: e, hof: e, hol: e, hole: e, holmestrand: e, holtalen: e, "xn--holtlen-hxa": e, holtålen: e, hordaland: [0, { os: e }], hornindal: e, horten: e, hoyanger: e, "xn--hyanger-q1a": e, høyanger: e, hoylandet: e, "xn--hylandet-54a": e, høylandet: e, hurdal: e, hurum: e, hvaler: e, hyllestad: e, ibestad: e, inderoy: e, "xn--indery-fya": e, inderøy: e, iveland: e, ivgu: e, jevnaker: e, jolster: e, "xn--jlster-bya": e, jølster: e, jondal: e, kafjord: e, "xn--kfjord-iua": e, kåfjord: e, karasjohka: e, "xn--krjohka-hwab49j": e, kárášjohka: e, karasjok: e, karlsoy: e, karmoy: e, "xn--karmy-yua": e, karmøy: e, kautokeino: e, klabu: e, "xn--klbu-woa": e, klæbu: e, klepp: e, kongsberg: e, kongsvinger: e, kraanghke: e, "xn--kranghke-b0a": e, kråanghke: e, kragero: e, "xn--krager-gya": e, kragerø: e, kristiansand: e, kristiansund: e, krodsherad: e, "xn--krdsherad-m8a": e, krødsherad: e, "xn--kvfjord-nxa": e, kvæfjord: e, "xn--kvnangen-k0a": e, kvænangen: e, kvafjord: e, kvalsund: e, kvam: e, kvanangen: e, kvinesdal: e, kvinnherad: e, kviteseid: e, kvitsoy: e, "xn--kvitsy-fya": e, kvitsøy: e, laakesvuemie: e, "xn--lrdal-sra": e, lærdal: e, lahppi: e, "xn--lhppi-xqa": e, láhppi: e, lardal: e, larvik: e, lavagis: e, lavangen: e, leangaviika: e, "xn--leagaviika-52b": e, leaŋgaviika: e, lebesby: e, leikanger: e, leirfjord: e, leka: e, leksvik: e, lenvik: e, lerdal: e, lesja: e, levanger: e, lier: e, lierne: e, lillehammer: e, lillesand: e, lindas: e, "xn--linds-pra": e, lindås: e, lindesnes: e, loabat: e, "xn--loabt-0qa": e, loabát: e, lodingen: e, "xn--ldingen-q1a": e, lødingen: e, lom: e, loppa: e, lorenskog: e, "xn--lrenskog-54a": e, lørenskog: e, loten: e, "xn--lten-gra": e, løten: e, lund: e, lunner: e, luroy: e, "xn--lury-ira": e, lurøy: e, luster: e, lyngdal: e, lyngen: e, malatvuopmi: e, "xn--mlatvuopmi-s4a": e, málatvuopmi: e, malselv: e, "xn--mlselv-iua": e, målselv: e, malvik: e, mandal: e, marker: e, marnardal: e, masfjorden: e, masoy: e, "xn--msy-ula0h": e, måsøy: e, "matta-varjjat": e, "xn--mtta-vrjjat-k7af": e, "mátta-várjjat": e, meland: e, meldal: e, melhus: e, meloy: e, "xn--mely-ira": e, meløy: e, meraker: e, "xn--merker-kua": e, meråker: e, midsund: e, "midtre-gauldal": e, moareke: e, "xn--moreke-jua": e, moåreke: e, modalen: e, modum: e, molde: e, "more-og-romsdal": [0, { heroy: e, sande: e }], "xn--mre-og-romsdal-qqb": [0, { "xn--hery-ira": e, sande: e }], "møre-og-romsdal": [0, { herøy: e, sande: e }], moskenes: e, moss: e, mosvik: e, muosat: e, "xn--muost-0qa": e, muosát: e, naamesjevuemie: e, "xn--nmesjevuemie-tcba": e, nååmesjevuemie: e, "xn--nry-yla5g": e, nærøy: e, namdalseid: e, namsos: e, namsskogan: e, nannestad: e, naroy: e, narviika: e, narvik: e, naustdal: e, navuotna: e, "xn--nvuotna-hwa": e, návuotna: e, "nedre-eiker": e, nesna: e, nesodden: e, nesseby: e, nesset: e, nissedal: e, nittedal: e, "nord-aurdal": e, "nord-fron": e, "nord-odal": e, norddal: e, nordkapp: e, nordland: [0, { bo: e, "xn--b-5ga": e, bø: e, heroy: e, "xn--hery-ira": e, herøy: e }], "nordre-land": e, nordreisa: e, "nore-og-uvdal": e, notodden: e, notteroy: e, "xn--nttery-byae": e, nøtterøy: e, odda: e, oksnes: e, "xn--ksnes-uua": e, øksnes: e, omasvuotna: e, oppdal: e, oppegard: e, "xn--oppegrd-ixa": e, oppegård: e, orkdal: e, orland: e, "xn--rland-uua": e, ørland: e, orskog: e, "xn--rskog-uua": e, ørskog: e, orsta: e, "xn--rsta-fra": e, ørsta: e, osen: e, osteroy: e, "xn--ostery-fya": e, osterøy: e, ostfold: [0, { valer: e }], "xn--stfold-9xa": [0, { "xn--vler-qoa": e }], østfold: [0, { våler: e }], "ostre-toten": e, "xn--stre-toten-zcb": e, "østre-toten": e, overhalla: e, "ovre-eiker": e, "xn--vre-eiker-k8a": e, "øvre-eiker": e, oyer: e, "xn--yer-zna": e, øyer: e, oygarden: e, "xn--ygarden-p1a": e, øygarden: e, "oystre-slidre": e, "xn--ystre-slidre-ujb": e, "øystre-slidre": e, porsanger: e, porsangu: e, "xn--porsgu-sta26f": e, porsáŋgu: e, porsgrunn: e, rade: e, "xn--rde-ula": e, råde: e, radoy: e, "xn--rady-ira": e, radøy: e, "xn--rlingen-mxa": e, rælingen: e, rahkkeravju: e, "xn--rhkkervju-01af": e, ráhkkerávju: e, raisa: e, "xn--risa-5na": e, ráisa: e, rakkestad: e, ralingen: e, rana: e, randaberg: e, rauma: e, rendalen: e, rennebu: e, rennesoy: e, "xn--rennesy-v1a": e, rennesøy: e, rindal: e, ringebu: e, ringerike: e, ringsaker: e, risor: e, "xn--risr-ira": e, risør: e, rissa: e, roan: e, rodoy: e, "xn--rdy-0nab": e, rødøy: e, rollag: e, romsa: e, romskog: e, "xn--rmskog-bya": e, rømskog: e, roros: e, "xn--rros-gra": e, røros: e, rost: e, "xn--rst-0na": e, røst: e, royken: e, "xn--ryken-vua": e, røyken: e, royrvik: e, "xn--ryrvik-bya": e, røyrvik: e, ruovat: e, rygge: e, salangen: e, salat: e, "xn--slat-5na": e, sálat: e, "xn--slt-elab": e, sálát: e, saltdal: e, samnanger: e, sandefjord: e, sandnes: e, sandoy: e, "xn--sandy-yua": e, sandøy: e, sarpsborg: e, sauda: e, sauherad: e, sel: e, selbu: e, selje: e, seljord: e, siellak: e, sigdal: e, siljan: e, sirdal: e, skanit: e, "xn--sknit-yqa": e, skánit: e, skanland: e, "xn--sknland-fxa": e, skånland: e, skaun: e, skedsmo: e, ski: e, skien: e, skierva: e, "xn--skierv-uta": e, skiervá: e, skiptvet: e, skjak: e, "xn--skjk-soa": e, skjåk: e, skjervoy: e, "xn--skjervy-v1a": e, skjervøy: e, skodje: e, smola: e, "xn--smla-hra": e, smøla: e, snaase: e, "xn--snase-nra": e, snåase: e, snasa: e, "xn--snsa-roa": e, snåsa: e, snillfjord: e, snoasa: e, sogndal: e, sogne: e, "xn--sgne-gra": e, søgne: e, sokndal: e, sola: e, solund: e, somna: e, "xn--smna-gra": e, sømna: e, "sondre-land": e, "xn--sndre-land-0cb": e, "søndre-land": e, songdalen: e, "sor-aurdal": e, "xn--sr-aurdal-l8a": e, "sør-aurdal": e, "sor-fron": e, "xn--sr-fron-q1a": e, "sør-fron": e, "sor-odal": e, "xn--sr-odal-q1a": e, "sør-odal": e, "sor-varanger": e, "xn--sr-varanger-ggb": e, "sør-varanger": e, sorfold: e, "xn--srfold-bya": e, sørfold: e, sorreisa: e, "xn--srreisa-q1a": e, sørreisa: e, sortland: e, sorum: e, "xn--srum-gra": e, sørum: e, spydeberg: e, stange: e, stavanger: e, steigen: e, steinkjer: e, stjordal: e, "xn--stjrdal-s1a": e, stjørdal: e, stokke: e, "stor-elvdal": e, stord: e, stordal: e, storfjord: e, strand: e, stranda: e, stryn: e, sula: e, suldal: e, sund: e, sunndal: e, surnadal: e, sveio: e, svelvik: e, sykkylven: e, tana: e, telemark: [0, { bo: e, "xn--b-5ga": e, bø: e }], time: e, tingvoll: e, tinn: e, tjeldsund: e, tjome: e, "xn--tjme-hra": e, tjøme: e, tokke: e, tolga: e, tonsberg: e, "xn--tnsberg-q1a": e, tønsberg: e, torsken: e, "xn--trna-woa": e, træna: e, trana: e, tranoy: e, "xn--trany-yua": e, tranøy: e, troandin: e, trogstad: e, "xn--trgstad-r1a": e, trøgstad: e, tromsa: e, tromso: e, "xn--troms-zua": e, tromsø: e, trondheim: e, trysil: e, tvedestrand: e, tydal: e, tynset: e, tysfjord: e, tysnes: e, "xn--tysvr-vra": e, tysvær: e, tysvar: e, ullensaker: e, ullensvang: e, ulvik: e, unjarga: e, "xn--unjrga-rta": e, unjárga: e, utsira: e, vaapste: e, vadso: e, "xn--vads-jra": e, vadsø: e, "xn--vry-yla5g": e, værøy: e, vaga: e, "xn--vg-yiab": e, vågå: e, vagan: e, "xn--vgan-qoa": e, vågan: e, vagsoy: e, "xn--vgsy-qoa0j": e, vågsøy: e, vaksdal: e, valle: e, vang: e, vanylven: e, vardo: e, "xn--vard-jra": e, vardø: e, varggat: e, "xn--vrggt-xqad": e, várggát: e, varoy: e, vefsn: e, vega: e, vegarshei: e, "xn--vegrshei-c0a": e, vegårshei: e, vennesla: e, verdal: e, verran: e, vestby: e, vestfold: [0, { sande: e }], vestnes: e, "vestre-slidre": e, "vestre-toten": e, vestvagoy: e, "xn--vestvgy-ixa6o": e, vestvågøy: e, vevelstad: e, vik: e, vikna: e, vindafjord: e, voagat: e, volda: e, voss: e, co: t, "123hjemmeside": t, myspreadshop: t }], np: _, nr: St, nu: [1, { merseine: t, mine: t, shacknet: t, enterprisecloud: t }], nz: [1, { ac: e, co: e, cri: e, geek: e, gen: e, govt: e, health: e, iwi: e, kiwi: e, maori: e, "xn--mori-qsa": e, māori: e, mil: e, net: e, org: e, parliament: e, school: e, cloudns: t }], om: [1, { co: e, com: e, edu: e, gov: e, med: e, museum: e, net: e, org: e, pro: e }], onion: e, org: [1, { altervista: t, pimienta: t, poivron: t, potager: t, sweetpepper: t, cdn77: [0, { c: t, rsc: t }], "cdn77-secure": [0, { origin: [0, { ssl: t }] }], ae: t, cloudns: t, "ip-dynamic": t, ddnss: t, dpdns: t, duckdns: t, tunk: t, blogdns: t, blogsite: t, boldlygoingnowhere: t, dnsalias: t, dnsdojo: t, doesntexist: t, dontexist: t, doomdns: t, dvrdns: t, dynalias: t, dyndns: [2, { go: t, home: t }], endofinternet: t, endoftheinternet: t, "from-me": t, "game-host": t, gotdns: t, "hobby-site": t, homedns: t, homeftp: t, homelinux: t, homeunix: t, "is-a-bruinsfan": t, "is-a-candidate": t, "is-a-celticsfan": t, "is-a-chef": t, "is-a-geek": t, "is-a-knight": t, "is-a-linux-user": t, "is-a-patsfan": t, "is-a-soxfan": t, "is-found": t, "is-lost": t, "is-saved": t, "is-very-bad": t, "is-very-evil": t, "is-very-good": t, "is-very-nice": t, "is-very-sweet": t, "isa-geek": t, "kicks-ass": t, misconfused: t, podzone: t, readmyblog: t, selfip: t, sellsyourhome: t, servebbs: t, serveftp: t, servegame: t, "stuff-4-sale": t, webhop: t, accesscam: t, camdvr: t, freeddns: t, mywire: t, webredirect: t, twmail: t, eu: [2, { al: t, asso: t, at: t, au: t, be: t, bg: t, ca: t, cd: t, ch: t, cn: t, cy: t, cz: t, de: t, dk: t, edu: t, ee: t, es: t, fi: t, fr: t, gr: t, hr: t, hu: t, ie: t, il: t, in: t, int: t, is: t, it: t, jp: t, kr: t, lt: t, lu: t, lv: t, me: t, mk: t, mt: t, my: t, net: t, ng: t, nl: t, no: t, nz: t, pl: t, pt: t, ro: t, ru: t, se: t, si: t, sk: t, tr: t, uk: t, us: t }], fedorainfracloud: t, fedorapeople: t, fedoraproject: [0, { cloud: t, os: L, stg: [0, { os: L }] }], freedesktop: t, hatenadiary: t, hepforge: t, "in-dsl": t, "in-vpn": t, js: t, barsy: t, mayfirst: t, routingthecloud: t, bmoattachments: t, "cable-modem": t, collegefan: t, couchpotatofries: t, hopto: t, mlbfan: t, myftp: t, mysecuritycamera: t, nflfan: t, "no-ip": t, "read-books": t, ufcfan: t, zapto: t, dynserv: t, "now-dns": t, "is-local": t, httpbin: t, pubtls: t, jpn: t, "my-firewall": t, myfirewall: t, spdns: t, "small-web": t, dsmynas: t, familyds: t, teckids: Fa, tuxfamily: t, diskstation: t, hk: t, us: t, toolforge: t, wmcloud: [2, { beta: t }], wmflabs: t, za: t }], pa: [1, { abo: e, ac: e, com: e, edu: e, gob: e, ing: e, med: e, net: e, nom: e, org: e, sld: e }], pe: [1, { com: e, edu: e, gob: e, mil: e, net: e, nom: e, org: e }], pf: [1, { com: e, edu: e, org: e }], pg: _, ph: [1, { com: e, edu: e, gov: e, i: e, mil: e, net: e, ngo: e, org: e, cloudns: t }], pk: [1, { ac: e, biz: e, com: e, edu: e, fam: e, gkp: e, gob: e, gog: e, gok: e, gop: e, gos: e, gov: e, net: e, org: e, web: e }], pl: [1, { com: e, net: e, org: e, agro: e, aid: e, atm: e, auto: e, biz: e, edu: e, gmina: e, gsm: e, info: e, mail: e, media: e, miasta: e, mil: e, nieruchomosci: e, nom: e, pc: e, powiat: e, priv: e, realestate: e, rel: e, sex: e, shop: e, sklep: e, sos: e, szkola: e, targi: e, tm: e, tourism: e, travel: e, turystyka: e, gov: [1, { ap: e, griw: e, ic: e, is: e, kmpsp: e, konsulat: e, kppsp: e, kwp: e, kwpsp: e, mup: e, mw: e, oia: e, oirm: e, oke: e, oow: e, oschr: e, oum: e, pa: e, pinb: e, piw: e, po: e, pr: e, psp: e, psse: e, pup: e, rzgw: e, sa: e, sdn: e, sko: e, so: e, sr: e, starostwo: e, ug: e, ugim: e, um: e, umig: e, upow: e, uppo: e, us: e, uw: e, uzs: e, wif: e, wiih: e, winb: e, wios: e, witd: e, wiw: e, wkz: e, wsa: e, wskr: e, wsse: e, wuoz: e, wzmiuw: e, zp: e, zpisdn: e }], augustow: e, "babia-gora": e, bedzin: e, beskidy: e, bialowieza: e, bialystok: e, bielawa: e, bieszczady: e, boleslawiec: e, bydgoszcz: e, bytom: e, cieszyn: e, czeladz: e, czest: e, dlugoleka: e, elblag: e, elk: e, glogow: e, gniezno: e, gorlice: e, grajewo: e, ilawa: e, jaworzno: e, "jelenia-gora": e, jgora: e, kalisz: e, karpacz: e, kartuzy: e, kaszuby: e, katowice: e, "kazimierz-dolny": e, kepno: e, ketrzyn: e, klodzko: e, kobierzyce: e, kolobrzeg: e, konin: e, konskowola: e, kutno: e, lapy: e, lebork: e, legnica: e, lezajsk: e, limanowa: e, lomza: e, lowicz: e, lubin: e, lukow: e, malbork: e, malopolska: e, mazowsze: e, mazury: e, mielec: e, mielno: e, mragowo: e, naklo: e, nowaruda: e, nysa: e, olawa: e, olecko: e, olkusz: e, olsztyn: e, opoczno: e, opole: e, ostroda: e, ostroleka: e, ostrowiec: e, ostrowwlkp: e, pila: e, pisz: e, podhale: e, podlasie: e, polkowice: e, pomorskie: e, pomorze: e, prochowice: e, pruszkow: e, przeworsk: e, pulawy: e, radom: e, "rawa-maz": e, rybnik: e, rzeszow: e, sanok: e, sejny: e, skoczow: e, slask: e, slupsk: e, sosnowiec: e, "stalowa-wola": e, starachowice: e, stargard: e, suwalki: e, swidnica: e, swiebodzin: e, swinoujscie: e, szczecin: e, szczytno: e, tarnobrzeg: e, tgory: e, turek: e, tychy: e, ustka: e, walbrzych: e, warmia: e, warszawa: e, waw: e, wegrow: e, wielun: e, wlocl: e, wloclawek: e, wodzislaw: e, wolomin: e, wroclaw: e, zachpomor: e, zagan: e, zarow: e, zgora: e, zgorzelec: e, art: t, gliwice: t, krakow: t, poznan: t, wroc: t, zakopane: t, beep: t, "ecommerce-shop": t, cfolks: t, dfirma: t, dkonto: t, you2: t, shoparena: t, homesklep: t, sdscloud: t, unicloud: t, lodz: t, pabianice: t, plock: t, sieradz: t, skierniewice: t, zgierz: t, krasnik: t, leczna: t, lubartow: t, lublin: t, poniatowa: t, swidnik: t, co: t, torun: t, simplesite: t, myspreadshop: t, gda: t, gdansk: t, gdynia: t, med: t, sopot: t, bielsko: t }], pm: [1, { own: t, name: t }], pn: [1, { co: e, edu: e, gov: e, net: e, org: e }], post: e, pr: [1, { biz: e, com: e, edu: e, gov: e, info: e, isla: e, name: e, net: e, org: e, pro: e, ac: e, est: e, prof: e }], pro: [1, { aaa: e, aca: e, acct: e, avocat: e, bar: e, cpa: e, eng: e, jur: e, law: e, med: e, recht: e, "12chars": t, cloudns: t, barsy: t, ngrok: t }], ps: [1, { com: e, edu: e, gov: e, net: e, org: e, plo: e, sec: e }], pt: [1, { com: e, edu: e, gov: e, int: e, net: e, nome: e, org: e, publ: e, "123paginaweb": t }], pw: [1, { gov: e, cloudns: t, x443: t }], py: [1, { com: e, coop: e, edu: e, gov: e, mil: e, net: e, org: e }], qa: [1, { com: e, edu: e, gov: e, mil: e, name: e, net: e, org: e, sch: e }], re: [1, { asso: e, com: e, netlib: t, can: t }], ro: [1, { arts: e, com: e, firm: e, info: e, nom: e, nt: e, org: e, rec: e, store: e, tm: e, www: e, co: t, shop: t, barsy: t }], rs: [1, { ac: e, co: e, edu: e, gov: e, in: e, org: e, brendly: w, barsy: t, ox: t }], ru: [1, { ac: t, edu: t, gov: t, int: t, mil: t, eurodir: t, adygeya: t, bashkiria: t, bir: t, cbg: t, com: t, dagestan: t, grozny: t, kalmykia: t, kustanai: t, marine: t, mordovia: t, msk: t, mytis: t, nalchik: t, nov: t, pyatigorsk: t, spb: t, vladikavkaz: t, vladimir: t, na4u: t, mircloud: t, myjino: [2, { hosting: n, landing: n, spectrum: n, vps: n }], cldmail: [0, { hb: t }], mcdir: c, mcpre: t, net: t, org: t, pp: t, lk3: t, ras: t }], rw: [1, { ac: e, co: e, coop: e, gov: e, mil: e, net: e, org: e }], sa: [1, { com: e, edu: e, gov: e, med: e, net: e, org: e, pub: e, sch: e }], sb: a, sc: a, sd: [1, { com: e, edu: e, gov: e, info: e, med: e, net: e, org: e, tv: e }], se: [1, { a: e, ac: e, b: e, bd: e, brand: e, c: e, d: e, e, f: e, fh: e, fhsk: e, fhv: e, g: e, h: e, i: e, k: e, komforb: e, kommunalforbund: e, komvux: e, l: e, lanbib: e, m: e, n: e, naturbruksgymn: e, o: e, org: e, p: e, parti: e, pp: e, press: e, r: e, s: e, t: e, tm: e, u: e, w: e, x: e, y: e, z: e, com: t, iopsys: t, "123minsida": t, itcouldbewor: t, myspreadshop: t }], sg: [1, { com: e, edu: e, gov: e, net: e, org: e, enscaled: t }], sh: [1, { com: e, gov: e, mil: e, net: e, org: e, hashbang: t, botda: t, lovable: t, platform: [0, { ent: t, eu: t, us: t }], now: t }], si: [1, { f5: t, gitapp: t, gitpage: t }], sj: e, sk: e, sl: a, sm: e, sn: [1, { art: e, com: e, edu: e, gouv: e, org: e, perso: e, univ: e }], so: [1, { com: e, edu: e, gov: e, me: e, net: e, org: e, surveys: t }], sr: e, ss: [1, { biz: e, co: e, com: e, edu: e, gov: e, me: e, net: e, org: e, sch: e }], st: [1, { co: e, com: e, consulado: e, edu: e, embaixada: e, mil: e, net: e, org: e, principe: e, saotome: e, store: e, helioho: t, kirara: t, noho: t }], su: [1, { abkhazia: t, adygeya: t, aktyubinsk: t, arkhangelsk: t, armenia: t, ashgabad: t, azerbaijan: t, balashov: t, bashkiria: t, bryansk: t, bukhara: t, chimkent: t, dagestan: t, "east-kazakhstan": t, exnet: t, georgia: t, grozny: t, ivanovo: t, jambyl: t, kalmykia: t, kaluga: t, karacol: t, karaganda: t, karelia: t, khakassia: t, krasnodar: t, kurgan: t, kustanai: t, lenug: t, mangyshlak: t, mordovia: t, msk: t, murmansk: t, nalchik: t, navoi: t, "north-kazakhstan": t, nov: t, obninsk: t, penza: t, pokrovsk: t, sochi: t, spb: t, tashkent: t, termez: t, togliatti: t, troitsk: t, tselinograd: t, tula: t, tuva: t, vladikavkaz: t, vladimir: t, vologda: t }], sv: [1, { com: e, edu: e, gob: e, org: e, red: e }], sx: l, sy: o, sz: [1, { ac: e, co: e, org: e }], tc: e, td: e, tel: e, tf: [1, { sch: t }], tg: e, th: [1, { ac: e, co: e, go: e, in: e, mi: e, net: e, or: e, online: t, shop: t }], tj: [1, { ac: e, biz: e, co: e, com: e, edu: e, go: e, gov: e, int: e, mil: e, name: e, net: e, nic: e, org: e, test: e, web: e }], tk: e, tl: l, tm: [1, { co: e, com: e, edu: e, gov: e, mil: e, net: e, nom: e, org: e }], tn: [1, { com: e, ens: e, fin: e, gov: e, ind: e, info: e, intl: e, mincom: e, nat: e, net: e, org: e, perso: e, tourism: e, orangecloud: t }], to: [1, { 611: t, com: e, edu: e, gov: e, mil: e, net: e, org: e, oya: t, x0: t, quickconnect: C, vpnplus: t }], tr: [1, { av: e, bbs: e, bel: e, biz: e, com: e, dr: e, edu: e, gen: e, gov: e, info: e, k12: e, kep: e, mil: e, name: e, net: e, org: e, pol: e, tel: e, tsk: e, tv: e, web: e, nc: l }], tt: [1, { biz: e, co: e, com: e, edu: e, gov: e, info: e, mil: e, name: e, net: e, org: e, pro: e }], tv: [1, { "better-than": t, dyndns: t, "on-the-web": t, "worse-than": t, from: t, sakura: t }], tw: [1, { club: e, com: [1, { mymailer: t }], ebiz: e, edu: e, game: e, gov: e, idv: e, mil: e, net: e, org: e, url: t, mydns: t }], tz: [1, { ac: e, co: e, go: e, hotel: e, info: e, me: e, mil: e, mobi: e, ne: e, or: e, sc: e, tv: e }], ua: [1, { com: e, edu: e, gov: e, in: e, net: e, org: e, cherkassy: e, cherkasy: e, chernigov: e, chernihiv: e, chernivtsi: e, chernovtsy: e, ck: e, cn: e, cr: e, crimea: e, cv: e, dn: e, dnepropetrovsk: e, dnipropetrovsk: e, donetsk: e, dp: e, if: e, "ivano-frankivsk": e, kh: e, kharkiv: e, kharkov: e, kherson: e, khmelnitskiy: e, khmelnytskyi: e, kiev: e, kirovograd: e, km: e, kr: e, kropyvnytskyi: e, krym: e, ks: e, kv: e, kyiv: e, lg: e, lt: e, lugansk: e, luhansk: e, lutsk: e, lv: e, lviv: e, mk: e, mykolaiv: e, nikolaev: e, od: e, odesa: e, odessa: e, pl: e, poltava: e, rivne: e, rovno: e, rv: e, sb: e, sebastopol: e, sevastopol: e, sm: e, sumy: e, te: e, ternopil: e, uz: e, uzhgorod: e, uzhhorod: e, vinnica: e, vinnytsia: e, vn: e, volyn: e, yalta: e, zakarpattia: e, zaporizhzhe: e, zaporizhzhia: e, zhitomir: e, zhytomyr: e, zp: e, zt: e, cc: t, inf: t, ltd: t, cx: t, biz: t, co: t, pp: t, v: t }], ug: [1, { ac: e, co: e, com: e, edu: e, go: e, gov: e, mil: e, ne: e, or: e, org: e, sc: e, us: e }], uk: [1, { ac: e, co: [1, { bytemark: [0, { dh: t, vm: t }], layershift: J, barsy: t, barsyonline: t, retrosnub: Ba, "nh-serv": t, "no-ip": t, adimo: t, myspreadshop: t }], gov: [1, { api: t, campaign: t, service: t }], ltd: e, me: e, net: e, nhs: e, org: [1, { glug: t, lug: t, lugs: t, affinitylottery: t, raffleentry: t, weeklylottery: t }], plc: e, police: e, sch: _, conn: t, copro: t, hosp: t, "independent-commission": t, "independent-inquest": t, "independent-inquiry": t, "independent-panel": t, "independent-review": t, "public-inquiry": t, "royal-commission": t, pymnt: t, barsy: t, nimsite: t, oraclegovcloudapps: n }], us: [1, { dni: e, isa: e, nsn: e, ak: oe, al: oe, ar: oe, as: oe, az: oe, ca: oe, co: oe, ct: oe, dc: oe, de: Ua, fl: oe, ga: oe, gu: oe, hi: gr, ia: oe, id: oe, il: oe, in: oe, ks: oe, ky: oe, la: oe, ma: [1, { k12: [1, { chtr: e, paroch: e, pvt: e }], cc: e, lib: e }], md: oe, me: oe, mi: [1, { k12: e, cc: e, lib: e, "ann-arbor": e, cog: e, dst: e, eaton: e, gen: e, mus: e, tec: e, washtenaw: e }], mn: oe, mo: oe, ms: [1, { k12: e, cc: e }], mt: oe, nc: oe, nd: gr, ne: oe, nh: oe, nj: oe, nm: oe, nv: oe, ny: oe, oh: oe, ok: oe, or: oe, pa: oe, pr: oe, ri: gr, sc: oe, sd: gr, tn: oe, tx: oe, ut: oe, va: oe, vi: oe, vt: oe, wa: oe, wi: oe, wv: Ua, wy: oe, cloudns: t, "is-by": t, "land-4-sale": t, "stuff-4-sale": t, heliohost: t, enscaled: [0, { phx: t }], mircloud: t, ngo: t, golffan: t, noip: t, pointto: t, freeddns: t, srv: [2, { gh: t, gl: t }], platterp: t, servername: t }], uy: [1, { com: e, edu: e, gub: e, mil: e, net: e, org: e }], uz: [1, { co: e, com: e, net: e, org: e }], va: e, vc: [1, { com: e, edu: e, gov: e, mil: e, net: e, org: e, gv: [2, { d: t }], "0e": n, mydns: t }], ve: [1, { arts: e, bib: e, co: e, com: e, e12: e, edu: e, emprende: e, firm: e, gob: e, gov: e, info: e, int: e, mil: e, net: e, nom: e, org: e, rar: e, rec: e, store: e, tec: e, web: e }], vg: [1, { edu: e }], vi: [1, { co: e, com: e, k12: e, net: e, org: e }], vn: [1, { ac: e, ai: e, biz: e, com: e, edu: e, gov: e, health: e, id: e, info: e, int: e, io: e, name: e, net: e, org: e, pro: e, angiang: e, bacgiang: e, backan: e, baclieu: e, bacninh: e, "baria-vungtau": e, bentre: e, binhdinh: e, binhduong: e, binhphuoc: e, binhthuan: e, camau: e, cantho: e, caobang: e, daklak: e, daknong: e, danang: e, dienbien: e, dongnai: e, dongthap: e, gialai: e, hagiang: e, haiduong: e, haiphong: e, hanam: e, hanoi: e, hatinh: e, haugiang: e, hoabinh: e, hungyen: e, khanhhoa: e, kiengiang: e, kontum: e, laichau: e, lamdong: e, langson: e, laocai: e, longan: e, namdinh: e, nghean: e, ninhbinh: e, ninhthuan: e, phutho: e, phuyen: e, quangbinh: e, quangnam: e, quangngai: e, quangninh: e, quangtri: e, soctrang: e, sonla: e, tayninh: e, thaibinh: e, thainguyen: e, thanhhoa: e, thanhphohochiminh: e, thuathienhue: e, tiengiang: e, travinh: e, tuyenquang: e, vinhlong: e, vinhphuc: e, yenbai: e }], vu: Q, wf: [1, { biz: t, sch: t }], ws: [1, { com: e, edu: e, gov: e, net: e, org: e, advisor: n, cloud66: t, dyndns: t, mypets: t }], yt: [1, { org: t }], "xn--mgbaam7a8h": e, امارات: e, "xn--y9a3aq": e, հայ: e, "xn--54b7fta0cc": e, বাংলা: e, "xn--90ae": e, бг: e, "xn--mgbcpq6gpa1a": e, البحرين: e, "xn--90ais": e, бел: e, "xn--fiqs8s": e, 中国: e, "xn--fiqz9s": e, 中國: e, "xn--lgbbat1ad8j": e, الجزائر: e, "xn--wgbh1c": e, مصر: e, "xn--e1a4c": e, ею: e, "xn--qxa6a": e, ευ: e, "xn--mgbah1a3hjkrd": e, موريتانيا: e, "xn--node": e, გე: e, "xn--qxam": e, ελ: e, "xn--j6w193g": [1, { "xn--gmqw5a": e, "xn--55qx5d": e, "xn--mxtq1m": e, "xn--wcvs22d": e, "xn--uc0atv": e, "xn--od0alg": e }], 香港: [1, { 個人: e, 公司: e, 政府: e, 教育: e, 組織: e, 網絡: e }], "xn--2scrj9c": e, ಭಾರತ: e, "xn--3hcrj9c": e, ଭାରତ: e, "xn--45br5cyl": e, ভাৰত: e, "xn--h2breg3eve": e, भारतम्: e, "xn--h2brj9c8c": e, भारोत: e, "xn--mgbgu82a": e, ڀارت: e, "xn--rvc1e0am3e": e, ഭാരതം: e, "xn--h2brj9c": e, भारत: e, "xn--mgbbh1a": e, بارت: e, "xn--mgbbh1a71e": e, بھارت: e, "xn--fpcrj9c3d": e, భారత్: e, "xn--gecrj9c": e, ભારત: e, "xn--s9brj9c": e, ਭਾਰਤ: e, "xn--45brj9c": e, ভারত: e, "xn--xkc2dl3a5ee0h": e, இந்தியா: e, "xn--mgba3a4f16a": e, ایران: e, "xn--mgba3a4fra": e, ايران: e, "xn--mgbtx2b": e, عراق: e, "xn--mgbayh7gpa": e, الاردن: e, "xn--3e0b707e": e, 한국: e, "xn--80ao21a": e, қаз: e, "xn--q7ce6a": e, ລາວ: e, "xn--fzc2c9e2c": e, ලංකා: e, "xn--xkc2al3hye2a": e, இலங்கை: e, "xn--mgbc0a9azcg": e, المغرب: e, "xn--d1alf": e, мкд: e, "xn--l1acc": e, мон: e, "xn--mix891f": e, 澳門: e, "xn--mix082f": e, 澳门: e, "xn--mgbx4cd0ab": e, مليسيا: e, "xn--mgb9awbf": e, عمان: e, "xn--mgbai9azgqp6j": e, پاکستان: e, "xn--mgbai9a5eva00b": e, پاكستان: e, "xn--ygbi2ammx": e, فلسطين: e, "xn--90a3ac": [1, { "xn--80au": e, "xn--90azh": e, "xn--d1at": e, "xn--c1avg": e, "xn--o1ac": e, "xn--o1ach": e }], срб: [1, { ак: e, обр: e, од: e, орг: e, пр: e, упр: e }], "xn--p1ai": e, рф: e, "xn--wgbl6a": e, قطر: e, "xn--mgberp4a5d4ar": e, السعودية: e, "xn--mgberp4a5d4a87g": e, السعودیة: e, "xn--mgbqly7c0a67fbc": e, السعودیۃ: e, "xn--mgbqly7cvafr": e, السعوديه: e, "xn--mgbpl2fh": e, سودان: e, "xn--yfro4i67o": e, 新加坡: e, "xn--clchc0ea0b2g2a9gcd": e, சிங்கப்பூர்: e, "xn--ogbpf8fl": e, سورية: e, "xn--mgbtf8fl": e, سوريا: e, "xn--o3cw4h": [1, { "xn--o3cyx2a": e, "xn--12co0c3b4eva": e, "xn--m3ch0j3a": e, "xn--h3cuzk1di": e, "xn--12c1fe0br": e, "xn--12cfi8ixb8l": e }], ไทย: [1, { ทหาร: e, ธุรกิจ: e, เน็ต: e, รัฐบาล: e, ศึกษา: e, องค์กร: e }], "xn--pgbs0dh": e, تونس: e, "xn--kpry57d": e, 台灣: e, "xn--kprw13d": e, 台湾: e, "xn--nnx388a": e, 臺灣: e, "xn--j1amh": e, укр: e, "xn--mgb2ddes": e, اليمن: e, xxx: e, ye: o, za: [0, { ac: e, agric: e, alt: e, co: e, edu: e, gov: e, grondar: e, law: e, mil: e, net: e, ngo: e, nic: e, nis: e, nom: e, org: e, school: e, tm: e, web: e }], zm: [1, { ac: e, biz: e, co: e, com: e, edu: e, gov: e, info: e, mil: e, net: e, org: e, sch: e }], zw: [1, { ac: e, co: e, gov: e, mil: e, org: e }], aaa: e, aarp: e, abb: e, abbott: e, abbvie: e, abc: e, able: e, abogado: e, abudhabi: e, academy: [1, { official: t }], accenture: e, accountant: e, accountants: e, aco: e, actor: e, ads: e, adult: e, aeg: e, aetna: e, afl: e, africa: e, agakhan: e, agency: e, aig: e, airbus: e, airforce: e, airtel: e, akdn: e, alibaba: e, alipay: e, allfinanz: e, allstate: e, ally: e, alsace: e, alstom: e, amazon: e, americanexpress: e, americanfamily: e, amex: e, amfam: e, amica: e, amsterdam: e, analytics: e, android: e, anquan: e, anz: e, aol: e, apartments: e, app: [1, { adaptable: t, aiven: t, beget: n, brave: r, clerk: t, clerkstage: t, wnext: t, csb: [2, { preview: t }], convex: t, deta: t, ondigitalocean: t, easypanel: t, encr: [2, { frontend: t }], evervault: i, expo: [2, { staging: t }], edgecompute: t, "on-fleek": t, flutterflow: t, e2b: t, framer: t, github: t, hosted: n, run: [0, { "*": t, mtls: n }], web: t, hackclub: t, hasura: t, botdash: t, loginline: t, lovable: t, luyani: t, medusajs: t, messerli: t, netfy: t, netlify: t, ngrok: t, "ngrok-free": t, developer: n, noop: t, northflank: n, upsun: n, railway: [0, { up: t }], replit: s, nyat: t, snowflake: [0, { "*": t, privatelink: n }], streamlit: t, storipress: t, telebit: t, typedream: t, vercel: t, wal: t, bookonline: t, wdh: t, windsurf: t, zeabur: t, zerops: n }], apple: e, aquarelle: e, arab: e, aramco: e, archi: e, army: e, art: e, arte: e, asda: e, associates: e, athleta: e, attorney: e, auction: e, audi: e, audible: e, audio: e, auspost: e, author: e, auto: e, autos: e, aws: [1, { on: [0, { "af-south-1": u, "ap-east-1": u, "ap-northeast-1": u, "ap-northeast-2": u, "ap-northeast-3": u, "ap-south-1": u, "ap-south-2": u, "ap-southeast-1": u, "ap-southeast-2": u, "ap-southeast-3": u, "ap-southeast-4": u, "ap-southeast-5": u, "ca-central-1": u, "ca-west-1": u, "eu-central-1": u, "eu-central-2": u, "eu-north-1": u, "eu-south-1": u, "eu-south-2": u, "eu-west-1": u, "eu-west-2": u, "eu-west-3": u, "il-central-1": u, "me-central-1": u, "me-south-1": u, "sa-east-1": u, "us-east-1": u, "us-east-2": u, "us-west-1": u, "us-west-2": u, "us-gov-east-1": d, "us-gov-west-1": d }], sagemaker: [0, { "ap-northeast-1": p, "ap-northeast-2": p, "ap-south-1": p, "ap-southeast-1": p, "ap-southeast-2": p, "ca-central-1": m, "eu-central-1": p, "eu-west-1": p, "eu-west-2": p, "us-east-1": m, "us-east-2": m, "us-west-2": m, "af-south-1": h, "ap-east-1": h, "ap-northeast-3": h, "ap-south-2": f, "ap-southeast-3": h, "ap-southeast-4": f, "ca-west-1": [0, { notebook: t, "notebook-fips": t }], "eu-central-2": h, "eu-north-1": h, "eu-south-1": h, "eu-south-2": h, "eu-west-3": h, "il-central-1": h, "me-central-1": h, "me-south-1": h, "sa-east-1": h, "us-gov-east-1": b, "us-gov-west-1": b, "us-west-1": [0, { notebook: t, "notebook-fips": t, studio: t }], experiments: n }], repost: [0, { private: n }] }], axa: e, azure: e, baby: e, baidu: e, banamex: e, band: e, bank: e, bar: e, barcelona: e, barclaycard: e, barclays: e, barefoot: e, bargains: e, baseball: e, basketball: [1, { aus: t, nz: t }], bauhaus: e, bayern: e, bbc: e, bbt: e, bbva: e, bcg: e, bcn: e, beats: e, beauty: e, beer: e, berlin: e, best: e, bestbuy: e, bet: e, bharti: e, bible: e, bid: e, bike: e, bing: e, bingo: e, bio: e, black: e, blackfriday: e, blockbuster: e, blog: e, bloomberg: e, blue: e, bms: e, bmw: e, bnpparibas: e, boats: e, boehringer: e, bofa: e, bom: e, bond: e, boo: e, book: e, booking: e, bosch: e, bostik: e, boston: e, bot: e, boutique: e, box: e, bradesco: e, bridgestone: e, broadway: e, broker: e, brother: e, brussels: e, build: [1, { v0: t, windsurf: t }], builders: [1, { cloudsite: t }], business: y, buy: e, buzz: e, bzh: e, cab: e, cafe: e, cal: e, call: e, calvinklein: e, cam: e, camera: e, camp: [1, { emf: [0, { at: t }] }], canon: e, capetown: e, capital: e, capitalone: e, car: e, caravan: e, cards: e, care: e, career: e, careers: e, cars: e, casa: [1, { nabu: [0, { ui: t }] }], case: e, cash: e, casino: e, catering: e, catholic: e, cba: e, cbn: e, cbre: e, center: e, ceo: e, cern: e, cfa: e, cfd: e, chanel: e, channel: e, charity: e, chase: e, chat: e, cheap: e, chintai: e, christmas: e, chrome: e, church: e, cipriani: e, circle: e, cisco: e, citadel: e, citi: e, citic: e, city: e, claims: e, cleaning: e, click: e, clinic: e, clinique: e, clothing: e, cloud: [1, { convex: t, elementor: t, encoway: [0, { eu: t }], statics: n, ravendb: t, axarnet: [0, { "es-1": t }], diadem: t, jelastic: [0, { vip: t }], jele: t, "jenv-aruba": [0, { aruba: [0, { eur: [0, { it1: t }] }], it1: t }], keliweb: [2, { cs: t }], oxa: [2, { tn: t, uk: t }], primetel: [2, { uk: t }], reclaim: [0, { ca: t, uk: t, us: t }], trendhosting: [0, { ch: t, de: t }], jote: t, jotelulu: t, kuleuven: t, laravel: t, linkyard: t, magentosite: n, matlab: t, observablehq: t, perspecta: t, vapor: t, "on-rancher": n, scw: [0, { baremetal: [0, { "fr-par-1": t, "fr-par-2": t, "nl-ams-1": t }], "fr-par": [0, { cockpit: t, ddl: t, dtwh: t, fnc: [2, { functions: t }], ifr: t, k8s: x, kafk: t, mgdb: t, rdb: t, s3: t, "s3-website": t, scbl: t, whm: t }], instances: [0, { priv: t, pub: t }], k8s: t, "nl-ams": [0, { cockpit: t, ddl: t, dtwh: t, ifr: t, k8s: x, kafk: t, mgdb: t, rdb: t, s3: t, "s3-website": t, scbl: t, whm: t }], "pl-waw": [0, { cockpit: t, ddl: t, dtwh: t, ifr: t, k8s: x, kafk: t, mgdb: t, rdb: t, s3: t, "s3-website": t, scbl: t }], scalebook: t, smartlabeling: t }], servebolt: t, onstackit: [0, { runs: t }], trafficplex: t, "unison-services": t, urown: t, voorloper: t, zap: t }], club: [1, { cloudns: t, jele: t, barsy: t }], clubmed: e, coach: e, codes: [1, { owo: n }], coffee: e, college: e, cologne: e, commbank: e, community: [1, { nog: t, ravendb: t, myforum: t }], company: e, compare: e, computer: e, comsec: e, condos: e, construction: e, consulting: e, contact: e, contractors: e, cooking: e, cool: [1, { elementor: t, de: t }], corsica: e, country: e, coupon: e, coupons: e, courses: e, cpa: e, credit: e, creditcard: e, creditunion: e, cricket: e, crown: e, crs: e, cruise: e, cruises: e, cuisinella: e, cymru: e, cyou: e, dad: e, dance: e, data: e, date: e, dating: e, datsun: e, day: e, dclk: e, dds: e, deal: e, dealer: e, deals: e, degree: e, delivery: e, dell: e, deloitte: e, delta: e, democrat: e, dental: e, dentist: e, desi: e, design: [1, { graphic: t, bss: t }], dev: [1, { "12chars": t, myaddr: t, panel: t, lcl: n, lclstage: n, stg: n, stgstage: n, pages: t, r2: t, workers: t, deno: t, "deno-staging": t, deta: t, lp: [2, { api: t, objects: t }], evervault: i, fly: t, githubpreview: t, gateway: n, botdash: t, inbrowser: n, "is-a-good": t, "is-a": t, iserv: t, runcontainers: t, localcert: [0, { user: n }], loginline: t, barsy: t, mediatech: t, modx: t, ngrok: t, "ngrok-free": t, "is-a-fullstack": t, "is-cool": t, "is-not-a": t, localplayer: t, xmit: t, "platter-app": t, replit: [2, { archer: t, bones: t, canary: t, global: t, hacker: t, id: t, janeway: t, kim: t, kira: t, kirk: t, odo: t, paris: t, picard: t, pike: t, prerelease: t, reed: t, riker: t, sisko: t, spock: t, staging: t, sulu: t, tarpit: t, teams: t, tucker: t, wesley: t, worf: t }], crm: [0, { d: n, w: n, wa: n, wb: n, wc: n, wd: n, we: n, wf: n }], erp: V, vercel: t, webhare: n, hrsn: t }], dhl: e, diamonds: e, diet: e, digital: [1, { cloudapps: [2, { london: t }] }], direct: [1, { libp2p: t }], directory: e, discount: e, discover: e, dish: e, diy: e, dnp: e, docs: e, doctor: e, dog: e, domains: e, dot: e, download: e, drive: e, dtv: e, dubai: e, dunlop: e, dupont: e, durban: e, dvag: e, dvr: e, earth: e, eat: e, eco: e, edeka: e, education: y, email: [1, { crisp: [0, { on: t }], tawk: X, tawkto: X }], emerck: e, energy: e, engineer: e, engineering: e, enterprises: e, epson: e, equipment: e, ericsson: e, erni: e, esq: e, estate: [1, { compute: n }], eurovision: e, eus: [1, { party: Ye }], events: [1, { koobin: t, co: t }], exchange: e, expert: e, exposed: e, express: e, extraspace: e, fage: e, fail: e, fairwinds: e, faith: e, family: e, fan: e, fans: e, farm: [1, { storj: t }], farmers: e, fashion: e, fast: e, fedex: e, feedback: e, ferrari: e, ferrero: e, fidelity: e, fido: e, film: e, final: e, finance: e, financial: y, fire: e, firestone: e, firmdale: e, fish: e, fishing: e, fit: e, fitness: e, flickr: e, flights: e, flir: e, florist: e, flowers: e, fly: e, foo: e, food: e, football: e, ford: e, forex: e, forsale: e, forum: e, foundation: e, fox: e, free: e, fresenius: e, frl: e, frogans: e, frontier: e, ftr: e, fujitsu: e, fun: e, fund: e, furniture: e, futbol: e, fyi: e, gal: e, gallery: e, gallo: e, gallup: e, game: e, games: [1, { pley: t, sheezy: t }], gap: e, garden: e, gay: [1, { pages: t }], gbiz: e, gdn: [1, { cnpy: t }], gea: e, gent: e, genting: e, george: e, ggee: e, gift: e, gifts: e, gives: e, giving: e, glass: e, gle: e, global: [1, { appwrite: t }], globo: e, gmail: e, gmbh: e, gmo: e, gmx: e, godaddy: e, gold: e, goldpoint: e, golf: e, goo: e, goodyear: e, goog: [1, { cloud: t, translate: t, usercontent: n }], google: e, gop: e, got: e, grainger: e, graphics: e, gratis: e, green: e, gripe: e, grocery: e, group: [1, { discourse: t }], gucci: e, guge: e, guide: e, guitars: e, guru: e, hair: e, hamburg: e, hangout: e, haus: e, hbo: e, hdfc: e, hdfcbank: e, health: [1, { hra: t }], healthcare: e, help: e, helsinki: e, here: e, hermes: e, hiphop: e, hisamitsu: e, hitachi: e, hiv: e, hkt: e, hockey: e, holdings: e, holiday: e, homedepot: e, homegoods: e, homes: e, homesense: e, honda: e, horse: e, hospital: e, host: [1, { cloudaccess: t, freesite: t, easypanel: t, fastvps: t, myfast: t, tempurl: t, wpmudev: t, iserv: t, jele: t, mircloud: t, wp2: t, half: t }], hosting: [1, { opencraft: t }], hot: e, hotel: e, hotels: e, hotmail: e, house: e, how: e, hsbc: e, hughes: e, hyatt: e, hyundai: e, ibm: e, icbc: e, ice: e, icu: e, ieee: e, ifm: e, ikano: e, imamat: e, imdb: e, immo: e, immobilien: e, inc: e, industries: e, infiniti: e, ing: e, ink: e, institute: e, insurance: e, insure: e, international: e, intuit: e, investments: e, ipiranga: e, irish: e, ismaili: e, ist: e, istanbul: e, itau: e, itv: e, jaguar: e, java: e, jcb: e, jeep: e, jetzt: e, jewelry: e, jio: e, jll: e, jmp: e, jnj: e, joburg: e, jot: e, joy: e, jpmorgan: e, jprs: e, juegos: e, juniper: e, kaufen: e, kddi: e, kerryhotels: e, kerryproperties: e, kfh: e, kia: e, kids: e, kim: e, kindle: e, kitchen: e, kiwi: e, koeln: e, komatsu: e, kosher: e, kpmg: e, kpn: e, krd: [1, { co: t, edu: t }], kred: e, kuokgroup: e, kyoto: e, lacaixa: e, lamborghini: e, lamer: e, land: e, landrover: e, lanxess: e, lasalle: e, lat: e, latino: e, latrobe: e, law: e, lawyer: e, lds: e, lease: e, leclerc: e, lefrak: e, legal: e, lego: e, lexus: e, lgbt: e, lidl: e, life: e, lifeinsurance: e, lifestyle: e, lighting: e, like: e, lilly: e, limited: e, limo: e, lincoln: e, link: [1, { myfritz: t, cyon: t, dweb: n, inbrowser: n, nftstorage: ia, mypep: t, storacha: ia, w3s: ia }], live: [1, { aem: t, hlx: t, ewp: n }], living: e, llc: e, llp: e, loan: e, loans: e, locker: e, locus: e, lol: [1, { omg: t }], london: e, lotte: e, lotto: e, love: e, lpl: e, lplfinancial: e, ltd: e, ltda: e, lundbeck: e, luxe: e, luxury: e, madrid: e, maif: e, maison: e, makeup: e, man: e, management: e, mango: e, map: e, market: e, marketing: e, markets: e, marriott: e, marshalls: e, mattel: e, mba: e, mckinsey: e, med: e, media: ka, meet: e, melbourne: e, meme: e, memorial: e, men: e, menu: [1, { barsy: t, barsyonline: t }], merck: e, merckmsd: e, miami: e, microsoft: e, mini: e, mint: e, mit: e, mitsubishi: e, mlb: e, mls: e, mma: e, mobile: e, moda: e, moe: e, moi: e, mom: e, monash: e, money: e, monster: e, mormon: e, mortgage: e, moscow: e, moto: e, motorcycles: e, mov: e, movie: e, msd: e, mtn: e, mtr: e, music: e, nab: e, nagoya: e, navy: e, nba: e, nec: e, netbank: e, netflix: e, network: [1, { aem: t, alces: n, co: t, arvo: t, azimuth: t, tlon: t }], neustar: e, new: e, news: [1, { noticeable: t }], next: e, nextdirect: e, nexus: e, nfl: e, ngo: e, nhk: e, nico: e, nike: e, nikon: e, ninja: e, nissan: e, nissay: e, nokia: e, norton: e, now: e, nowruz: e, nowtv: e, nra: e, nrw: e, ntt: e, nyc: e, obi: e, observer: e, office: e, okinawa: e, olayan: e, olayangroup: e, ollo: e, omega: e, one: [1, { kin: n, service: t }], ong: [1, { obl: t }], onl: e, online: [1, { eero: t, "eero-stage": t, websitebuilder: t, barsy: t }], ooo: e, open: e, oracle: e, orange: [1, { tech: t }], organic: e, origins: e, osaka: e, otsuka: e, ott: e, ovh: [1, { nerdpol: t }], page: [1, { aem: t, hlx: t, translated: t, codeberg: t, heyflow: t, prvcy: t, rocky: t, pdns: t, plesk: t }], panasonic: e, paris: e, pars: e, partners: e, parts: e, party: e, pay: e, pccw: e, pet: e, pfizer: e, pharmacy: e, phd: e, philips: e, phone: e, photo: e, photography: e, photos: ka, physio: e, pics: e, pictet: e, pictures: [1, { 1337: t }], pid: e, pin: e, ping: e, pink: e, pioneer: e, pizza: [1, { ngrok: t }], place: y, play: e, playstation: e, plumbing: e, plus: e, pnc: e, pohl: e, poker: e, politie: e, porn: e, praxi: e, press: e, prime: e, prod: e, productions: e, prof: e, progressive: e, promo: e, properties: e, property: e, protection: e, pru: e, prudential: e, pub: [1, { id: n, kin: n, barsy: t }], pwc: e, qpon: e, quebec: e, quest: e, racing: e, radio: e, read: e, realestate: e, realtor: e, realty: e, recipes: e, red: e, redumbrella: e, rehab: e, reise: e, reisen: e, reit: e, reliance: e, ren: e, rent: e, rentals: e, repair: e, report: e, republican: e, rest: e, restaurant: e, review: e, reviews: [1, { aem: t }], rexroth: e, rich: e, richardli: e, ricoh: e, ril: e, rio: e, rip: [1, { clan: t }], rocks: [1, { myddns: t, stackit: t, "lima-city": t, webspace: t }], rodeo: e, rogers: e, room: e, rsvp: e, rugby: e, ruhr: e, run: [1, { appwrite: n, development: t, ravendb: t, liara: [2, { iran: t }], lovable: t, build: n, code: n, database: n, migration: n, onporter: t, repl: t, stackit: t, val: V, vercel: t, wix: t }], rwe: e, ryukyu: e, saarland: e, safe: e, safety: e, sakura: e, sale: e, salon: e, samsclub: e, samsung: e, sandvik: e, sandvikcoromant: e, sanofi: e, sap: e, sarl: e, sas: e, save: e, saxo: e, sbi: e, sbs: e, scb: e, schaeffler: e, schmidt: e, scholarships: e, school: e, schule: e, schwarz: e, science: e, scot: [1, { gov: [2, { service: t }] }], search: e, seat: e, secure: e, security: e, seek: e, select: e, sener: e, services: [1, { loginline: t }], seven: e, sew: e, sex: e, sexy: e, sfr: e, shangrila: e, sharp: e, shell: e, shia: e, shiksha: e, shoes: e, shop: [1, { base: t, hoplix: t, barsy: t, barsyonline: t, shopware: t }], shopping: e, shouji: e, show: e, silk: e, sina: e, singles: e, site: [1, { square: t, canva: S, cloudera: n, convex: t, cyon: t, caffeine: t, fastvps: t, figma: t, preview: t, heyflow: t, jele: t, jouwweb: t, loginline: t, barsy: t, notion: t, omniwe: t, opensocial: t, madethis: t, platformsh: n, tst: n, byen: t, srht: t, novecore: t, cpanel: t, wpsquared: t, sourcecraft: t }], ski: e, skin: e, sky: e, skype: e, sling: e, smart: e, smile: e, sncf: e, soccer: e, social: e, softbank: e, software: e, sohu: e, solar: e, solutions: e, song: e, sony: e, soy: e, spa: e, space: [1, { myfast: t, heiyu: t, hf: [2, { static: t }], "app-ionos": t, project: t, uber: t, xs4all: t }], sport: e, spot: e, srl: e, stada: e, staples: e, star: e, statebank: e, statefarm: e, stc: e, stcgroup: e, stockholm: e, storage: e, store: [1, { barsy: t, sellfy: t, shopware: t, storebase: t }], stream: e, studio: e, study: e, style: e, sucks: e, supplies: e, supply: e, support: [1, { barsy: t }], surf: e, surgery: e, suzuki: e, swatch: e, swiss: e, sydney: e, systems: [1, { knightpoint: t }], tab: e, taipei: e, talk: e, taobao: e, target: e, tatamotors: e, tatar: e, tattoo: e, tax: e, taxi: e, tci: e, tdk: e, team: [1, { discourse: t, jelastic: t }], tech: [1, { cleverapps: t }], technology: y, temasek: e, tennis: e, teva: e, thd: e, theater: e, theatre: e, tiaa: e, tickets: e, tienda: e, tips: e, tires: e, tirol: e, tjmaxx: e, tjx: e, tkmaxx: e, tmall: e, today: [1, { prequalifyme: t }], tokyo: e, tools: [1, { addr: ae, myaddr: t }], top: [1, { ntdll: t, wadl: n }], toray: e, toshiba: e, total: e, tours: e, town: e, toyota: e, toys: e, trade: e, trading: e, training: e, travel: e, travelers: e, travelersinsurance: e, trust: e, trv: e, tube: e, tui: e, tunes: e, tushu: e, tvs: e, ubank: e, ubs: e, unicom: e, university: e, uno: e, uol: e, ups: e, vacations: e, vana: e, vanguard: e, vegas: e, ventures: e, verisign: e, versicherung: e, vet: e, viajes: e, video: e, vig: e, viking: e, villas: e, vin: e, vip: [1, { hidns: t }], virgin: e, visa: e, vision: e, viva: e, vivo: e, vlaanderen: e, vodka: e, volvo: e, vote: e, voting: e, voto: e, voyage: e, wales: e, walmart: e, walter: e, wang: e, wanggou: e, watch: e, watches: e, weather: e, weatherchannel: e, webcam: e, weber: e, website: ka, wed: e, wedding: e, weibo: e, weir: e, whoswho: e, wien: e, wiki: ka, williamhill: e, win: e, windows: e, wine: e, winners: e, wme: e, wolterskluwer: e, woodside: e, work: e, works: e, world: e, wow: e, wtc: e, wtf: e, xbox: e, xerox: e, xihuan: e, xin: e, "xn--11b4c3d": e, कॉम: e, "xn--1ck2e1b": e, セール: e, "xn--1qqw23a": e, 佛山: e, "xn--30rr7y": e, 慈善: e, "xn--3bst00m": e, 集团: e, "xn--3ds443g": e, 在线: e, "xn--3pxu8k": e, 点看: e, "xn--42c2d9a": e, คอม: e, "xn--45q11c": e, 八卦: e, "xn--4gbrim": e, موقع: e, "xn--55qw42g": e, 公益: e, "xn--55qx5d": e, 公司: e, "xn--5su34j936bgsg": e, 香格里拉: e, "xn--5tzm5g": e, 网站: e, "xn--6frz82g": e, 移动: e, "xn--6qq986b3xl": e, 我爱你: e, "xn--80adxhks": e, москва: e, "xn--80aqecdr1a": e, католик: e, "xn--80asehdb": e, онлайн: e, "xn--80aswg": e, сайт: e, "xn--8y0a063a": e, 联通: e, "xn--9dbq2a": e, קום: e, "xn--9et52u": e, 时尚: e, "xn--9krt00a": e, 微博: e, "xn--b4w605ferd": e, 淡马锡: e, "xn--bck1b9a5dre4c": e, ファッション: e, "xn--c1avg": e, орг: e, "xn--c2br7g": e, नेट: e, "xn--cck2b3b": e, ストア: e, "xn--cckwcxetd": e, アマゾン: e, "xn--cg4bki": e, 삼성: e, "xn--czr694b": e, 商标: e, "xn--czrs0t": e, 商店: e, "xn--czru2d": e, 商城: e, "xn--d1acj3b": e, дети: e, "xn--eckvdtc9d": e, ポイント: e, "xn--efvy88h": e, 新闻: e, "xn--fct429k": e, 家電: e, "xn--fhbei": e, كوم: e, "xn--fiq228c5hs": e, 中文网: e, "xn--fiq64b": e, 中信: e, "xn--fjq720a": e, 娱乐: e, "xn--flw351e": e, 谷歌: e, "xn--fzys8d69uvgm": e, 電訊盈科: e, "xn--g2xx48c": e, 购物: e, "xn--gckr3f0f": e, クラウド: e, "xn--gk3at1e": e, 通販: e, "xn--hxt814e": e, 网店: e, "xn--i1b6b1a6a2e": e, संगठन: e, "xn--imr513n": e, 餐厅: e, "xn--io0a7i": e, 网络: e, "xn--j1aef": e, ком: e, "xn--jlq480n2rg": e, 亚马逊: e, "xn--jvr189m": e, 食品: e, "xn--kcrx77d1x4a": e, 飞利浦: e, "xn--kput3i": e, 手机: e, "xn--mgba3a3ejt": e, ارامكو: e, "xn--mgba7c0bbn0a": e, العليان: e, "xn--mgbab2bd": e, بازار: e, "xn--mgbca7dzdo": e, ابوظبي: e, "xn--mgbi4ecexp": e, كاثوليك: e, "xn--mgbt3dhd": e, همراه: e, "xn--mk1bu44c": e, 닷컴: e, "xn--mxtq1m": e, 政府: e, "xn--ngbc5azd": e, شبكة: e, "xn--ngbe9e0a": e, بيتك: e, "xn--ngbrx": e, عرب: e, "xn--nqv7f": e, 机构: e, "xn--nqv7fs00ema": e, 组织机构: e, "xn--nyqy26a": e, 健康: e, "xn--otu796d": e, 招聘: e, "xn--p1acf": [1, { "xn--90amc": t, "xn--j1aef": t, "xn--j1ael8b": t, "xn--h1ahn": t, "xn--j1adp": t, "xn--c1avg": t, "xn--80aaa0cvac": t, "xn--h1aliz": t, "xn--90a1af": t, "xn--41a": t }], рус: [1, { биз: t, ком: t, крым: t, мир: t, мск: t, орг: t, самара: t, сочи: t, спб: t, я: t }], "xn--pssy2u": e, 大拿: e, "xn--q9jyb4c": e, みんな: e, "xn--qcka1pmc": e, グーグル: e, "xn--rhqv96g": e, 世界: e, "xn--rovu88b": e, 書籍: e, "xn--ses554g": e, 网址: e, "xn--t60b56a": e, 닷넷: e, "xn--tckwe": e, コム: e, "xn--tiq49xqyj": e, 天主教: e, "xn--unup4y": e, 游戏: e, "xn--vermgensberater-ctb": e, vermögensberater: e, "xn--vermgensberatung-pwb": e, vermögensberatung: e, "xn--vhquv": e, 企业: e, "xn--vuq861b": e, 信息: e, "xn--w4r85el8fhu5dnra": e, 嘉里大酒店: e, "xn--w4rs40l": e, 嘉里: e, "xn--xhq521b": e, 广东: e, "xn--zfr164b": e, 政务: e, xyz: [1, { botdash: t, telebit: n }], yachts: e, yahoo: e, yamaxun: e, yandex: e, yodobashi: e, yoga: e, yokohama: e, you: e, youtube: e, yun: e, zappos: e, zara: e, zero: e, zip: e, zone: [1, { triton: n, stackit: t, lima: t }], zuerich: e }];
}();
function dm(e, t, a, o) {
  let n = null, r = t;
  for (; r !== void 0 && ((r[0] & o) !== 0 && (n = {
    index: a + 1,
    isIcann: r[0] === 1,
    isPrivate: r[0] === 2
  }), a !== -1); ) {
    const i = r[1];
    r = Object.prototype.hasOwnProperty.call(i, e[a]) ? i[e[a]] : i["*"], a -= 1;
  }
  return n;
}
function W0e(e, t, a) {
  var o;
  if (T0e(e, t, a))
    return;
  const n = e.split("."), r = (t.allowPrivateDomains ? 2 : 0) | (t.allowIcannDomains ? 1 : 0), i = dm(n, M0e, n.length - 1, r);
  if (i !== null) {
    a.isIcann = i.isIcann, a.isPrivate = i.isPrivate, a.publicSuffix = n.slice(i.index + 1).join(".");
    return;
  }
  const s = dm(n, L0e, n.length - 1, r);
  if (s !== null) {
    a.isIcann = s.isIcann, a.isPrivate = s.isPrivate, a.publicSuffix = n.slice(s.index).join(".");
    return;
  }
  a.isIcann = !1, a.isPrivate = !1, a.publicSuffix = (o = n[n.length - 1]) !== null && o !== void 0 ? o : null;
}
const gm = N0e();
function B0e(e, t = {}) {
  return R0e(gm), I0e(e, 3, W0e, t, gm).domain;
}
function Ly(e, t) {
  return !!(t === e || e.indexOf(t) === 0 && (t[t.length - 1] === "/" || e.startsWith(t) && e[t.length] === "/"));
}
var hm = ["local", "example", "invalid", "localhost", "test"], F0e = ["localhost", "invalid"], V0e = {
  allowSpecialUseDomain: !1,
  ignoreError: !1
};
function pd(e, t = {}) {
  t = { ...V0e, ...t };
  const a = e.split("."), o = a[a.length - 1], n = !!t.allowSpecialUseDomain, r = !!t.ignoreError;
  if (n && o !== void 0 && hm.includes(o)) {
    if (a.length > 1)
      return `${a[a.length - 2]}.${o}`;
    if (F0e.includes(o))
      return o;
  }
  if (!r && o !== void 0 && hm.includes(o))
    throw new Error(
      `Cookie has domain set to the public suffix "${o}" which is a special use domain. To allow this, configure your CookieJar with {allowSpecialUseDomain: true, rejectPublicSuffixes: false}.`
    );
  const i = B0e(e, {
    allowIcannDomains: !0,
    allowPrivateDomains: !0
  });
  if (i) return i;
}
function U0e(e, t) {
  const a = pd(e, {
    allowSpecialUseDomain: t
  });
  if (!a)
    return;
  if (a == e)
    return [e];
  e.slice(-1) == "." && (e = e.slice(0, -1));
  const o = e.slice(0, -(a.length + 1)).split(".").reverse();
  let n = a;
  const r = [n];
  for (; o.length; )
    n = `${o.shift()}.${n}`, r.push(n);
  return r;
}
var Wy = class {
  constructor() {
    this.synchronous = !1;
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  findCookie(t, a, o, n) {
    throw new Error("findCookie is not implemented");
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  findCookies(t, a, o = !1, n) {
    throw new Error("findCookies is not implemented");
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  putCookie(t, a) {
    throw new Error("putCookie is not implemented");
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  updateCookie(t, a, o) {
    throw new Error("updateCookie is not implemented");
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  removeCookie(t, a, o, n) {
    throw new Error("removeCookie is not implemented");
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  removeCookies(t, a, o) {
    throw new Error("removeCookies is not implemented");
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  removeAllCookies(t) {
    throw new Error("removeAllCookies is not implemented");
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  getAllCookies(t) {
    throw new Error(
      "getAllCookies is not implemented (therefore jar cannot be serialized)"
    );
  }
}, fd = (e) => Object.prototype.toString.call(e), q0e = (e, t) => typeof e.join != "function" ? fd(e) : (t.add(e), e.map(
  (a) => a == null || t.has(a) ? "" : By(a, t)
).join()), By = (e, t = /* @__PURE__ */ new WeakSet()) => typeof e != "object" || e === null ? String(e) : typeof e.toString == "function" ? Array.isArray(e) ? (
  // Arrays have a weird custom toString that we need to replicate
  q0e(e, t)
) : (
  // eslint-disable-next-line @typescript-eslint/no-base-to-string
  String(e)
) : fd(e), Dc = (e) => By(e);
function nt(e) {
  let t, a, o;
  const n = new Promise((r, i) => {
    a = r, o = i;
  });
  return typeof e == "function" ? t = (r, i) => {
    try {
      r ? e(r) : e(null, i);
    } catch (s) {
      o(s instanceof Error ? s : new Error());
    }
  } : t = (r, i) => {
    try {
      r ? o(r) : a(i);
    } catch (s) {
      o(s instanceof Error ? s : new Error());
    }
  }, {
    promise: n,
    callback: t,
    resolve: (r) => (t(null, r), n),
    reject: (r) => (t(r), n)
  };
}
function Dn(e, t) {
  return e in t;
}
var Fy = class extends Wy {
  /**
   * Create a new {@link MemoryCookieStore}.
   */
  constructor() {
    super(), this.synchronous = !0, this.idx = /* @__PURE__ */ Object.create(null);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  findCookie(t, a, o, n) {
    const r = nt(n);
    if (t == null || a == null || o == null)
      return r.resolve(void 0);
    const i = this.idx[t]?.[a]?.[o];
    return r.resolve(i);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  findCookies(t, a, o = !1, n) {
    typeof o == "function" && (n = o, o = !0);
    const r = [], i = nt(n);
    if (!t)
      return i.resolve([]);
    let s;
    a ? s = function(u) {
      for (const d in u)
        if (Ly(a, d)) {
          const h = u[d];
          for (const p in h) {
            const f = h[p];
            f && r.push(f);
          }
        }
    } : s = function(u) {
      for (const d in u) {
        const h = u[d];
        for (const p in h) {
          const f = h[p];
          f && r.push(f);
        }
      }
    };
    const l = U0e(t, o) || [t], c = this.idx;
    return l.forEach((u) => {
      const d = c[u];
      d && s(d);
    }), i.resolve(r);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  putCookie(t, a) {
    const o = nt(a), { domain: n, path: r, key: i } = t;
    if (n == null || r == null || i == null)
      return o.resolve(void 0);
    const s = this.idx[n] ?? /* @__PURE__ */ Object.create(null);
    this.idx[n] = s;
    const l = s[r] ?? /* @__PURE__ */ Object.create(null);
    return s[r] = l, l[i] = t, o.resolve(void 0);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  updateCookie(t, a, o) {
    if (o) this.putCookie(a, o);
    else return this.putCookie(a);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  removeCookie(t, a, o, n) {
    const r = nt(n);
    return delete this.idx[t]?.[a]?.[o], r.resolve(void 0);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  removeCookies(t, a, o) {
    const n = nt(o), r = this.idx[t];
    return r && (a ? delete r[a] : delete this.idx[t]), n.resolve(void 0);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  removeAllCookies(t) {
    const a = nt(t);
    return this.idx = /* @__PURE__ */ Object.create(null), a.resolve(void 0);
  }
  /**
   * @internal No doc because this is an overload that supports the implementation
   */
  getAllCookies(t) {
    const a = nt(t), o = [], n = this.idx;
    return Object.keys(n).forEach((r) => {
      const i = n[r] ?? {};
      Object.keys(i).forEach((s) => {
        const l = i[s] ?? {};
        Object.keys(l).forEach((c) => {
          const u = l[c];
          u != null && o.push(u);
        });
      });
    }), o.sort((r, i) => (r.creationIndex || 0) - (i.creationIndex || 0)), a.resolve(o);
  }
};
function Pl(e) {
  return Vy(e) && e !== "";
}
function bd(e) {
  return e === "" || e instanceof String && e.toString() === "";
}
function Vy(e) {
  return typeof e == "string" || e instanceof String;
}
function li(e) {
  return fd(e) === "[object Object]";
}
function wn(e, t, a) {
  if (e) return;
  const o = typeof t == "function" ? t : void 0;
  let n = typeof t == "function" ? a : t;
  li(n) || (n = "[object Object]");
  const r = new Uy(Dc(n));
  if (o) o(r);
  else throw r;
}
var Uy = class extends Error {
}, H0e = "6.0.0", Ka = {
  SILENT: "silent",
  STRICT: "strict",
  DISABLED: "unsafe-disabled"
};
Object.freeze(Ka);
var G0e = `
\\[?(?:
(?:[a-fA-F\\d]{1,4}:){7}(?:[a-fA-F\\d]{1,4}|:)|
(?:[a-fA-F\\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|:[a-fA-F\\d]{1,4}|:)|
(?:[a-fA-F\\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,2}|:)|
(?:[a-fA-F\\d]{1,4}:){4}(?:(?::[a-fA-F\\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,3}|:)|
(?:[a-fA-F\\d]{1,4}:){3}(?:(?::[a-fA-F\\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,4}|:)|
(?:[a-fA-F\\d]{1,4}:){2}(?:(?::[a-fA-F\\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,5}|:)|
(?:[a-fA-F\\d]{1,4}:){1}(?:(?::[a-fA-F\\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,6}|:)|
(?::(?:(?::[a-fA-F\\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)(?:\\.(?:25[0-5]|2[0-4]\\d|1\\d\\d|[1-9]\\d|\\d)){3}|(?::[a-fA-F\\d]{1,4}){1,7}|:))
)(?:%[0-9a-zA-Z]{1,})?\\]?
`.replace(/\s*\/\/.*$/gm, "").replace(/\n/g, "").trim(), _d = new RegExp(`^${G0e}$`), K0e = "(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])", J0e = new RegExp(`^${K0e}$`);
function mm(e) {
  return new URL(`http://${e}`).hostname;
}
function Fi(e) {
  if (e == null)
    return;
  let t = e.trim().replace(/^\./, "");
  return _d.test(t) ? (t.startsWith("[") || (t = "[" + t), t.endsWith("]") || (t = t + "]"), mm(t).slice(1, -1)) : /[^\u0001-\u007f]/.test(t) ? mm(t) : t.toLowerCase();
}
function Z0e(e) {
  return e.toUTCString();
}
var Y0e = /[\x09\x20-\x2F\x3B-\x40\x5B-\x60\x7B-\x7E]/, Ct = {
  jan: 0,
  feb: 1,
  mar: 2,
  apr: 3,
  may: 4,
  jun: 5,
  jul: 6,
  aug: 7,
  sep: 8,
  oct: 9,
  nov: 10,
  dec: 11
};
function Nc(e, t, a, o) {
  let n = 0;
  for (; n < e.length; ) {
    const r = e.charCodeAt(n);
    if (r <= 47 || r >= 58)
      break;
    n++;
  }
  if (!(n < t || n > a) && !(!o && n != e.length))
    return parseInt(e.slice(0, n), 10);
}
function X0e(e) {
  const t = e.split(":"), a = [0, 0, 0];
  if (t.length === 3) {
    for (let o = 0; o < 3; o++) {
      const n = o == 2, r = t[o];
      if (r === void 0)
        return;
      const i = Nc(r, 1, 2, n);
      if (i === void 0)
        return;
      a[o] = i;
    }
    return a;
  }
}
function Q0e(e) {
  switch (e = String(e).slice(0, 3).toLowerCase(), e) {
    case "jan":
      return Ct.jan;
    case "feb":
      return Ct.feb;
    case "mar":
      return Ct.mar;
    case "apr":
      return Ct.apr;
    case "may":
      return Ct.may;
    case "jun":
      return Ct.jun;
    case "jul":
      return Ct.jul;
    case "aug":
      return Ct.aug;
    case "sep":
      return Ct.sep;
    case "oct":
      return Ct.oct;
    case "nov":
      return Ct.nov;
    case "dec":
      return Ct.dec;
    default:
      return;
  }
}
function Rc(e) {
  if (!e)
    return;
  const t = e.split(Y0e);
  let a, o, n, r, i, s;
  for (let l = 0; l < t.length; l++) {
    const c = (t[l] ?? "").trim();
    if (c.length) {
      if (n === void 0) {
        const u = X0e(c);
        if (u) {
          a = u[0], o = u[1], n = u[2];
          continue;
        }
      }
      if (r === void 0) {
        const u = Nc(c, 1, 2, !0);
        if (u !== void 0) {
          r = u;
          continue;
        }
      }
      if (i === void 0) {
        const u = Q0e(c);
        if (u !== void 0) {
          i = u;
          continue;
        }
      }
      if (s === void 0) {
        const u = Nc(c, 2, 4, !0);
        u !== void 0 && (s = u, s >= 70 && s <= 99 ? s += 1900 : s >= 0 && s <= 69 && (s += 2e3));
      }
    }
  }
  if (!(r === void 0 || i === void 0 || s === void 0 || a === void 0 || o === void 0 || n === void 0 || r < 1 || r > 31 || s < 1601 || a > 23 || o > 59 || n > 59))
    return new Date(Date.UTC(s, i, r, a, o, n));
}
var eCe = /^[\x21\x23-\x2B\x2D-\x3A\x3C-\x5B\x5D-\x7E]+$/, tCe = /[\x20-\x3A\x3C-\x7E]+/, pm = /[\x00-\x1F]/, fm = [`
`, "\r", "\0"];
function aCe(e) {
  if (bd(e)) return e;
  for (let t = 0; t < fm.length; t++) {
    const a = fm[t], o = a ? e.indexOf(a) : -1;
    o !== -1 && (e = e.slice(0, o));
  }
  return e;
}
function oCe(e, t) {
  e = aCe(e);
  let a = e.indexOf("=");
  if (t)
    a === 0 && (e = e.substring(1), a = e.indexOf("="));
  else if (a <= 0)
    return;
  let o, n;
  if (a <= 0 ? (o = "", n = e.trim()) : (o = e.slice(0, a).trim(), n = e.slice(a + 1).trim()), pm.test(o) || pm.test(n))
    return;
  const r = new yt();
  return r.key = o, r.value = n, r;
}
function nCe(e, t) {
  if (bd(e) || !Vy(e))
    return;
  e = e.trim();
  const a = e.indexOf(";"), o = a === -1 ? e : e.slice(0, a), n = oCe(o, t?.loose ?? !1);
  if (!n)
    return;
  if (a === -1)
    return n;
  const r = e.slice(a + 1).trim();
  if (r.length === 0)
    return n;
  const i = r.split(";");
  for (; i.length; ) {
    const s = (i.shift() ?? "").trim();
    if (s.length === 0)
      continue;
    const l = s.indexOf("=");
    let c, u;
    switch (l === -1 ? (c = s, u = null) : (c = s.slice(0, l), u = s.slice(l + 1)), c = c.trim().toLowerCase(), u && (u = u.trim()), c) {
      case "expires":
        if (u) {
          const d = Rc(u);
          d && (n.expires = d);
        }
        break;
      case "max-age":
        if (u && /^-?[0-9]+$/.test(u)) {
          const d = parseInt(u, 10);
          n.setMaxAge(d);
        }
        break;
      case "domain":
        if (u) {
          const d = u.trim().replace(/^\./, "");
          d && (n.domain = d.toLowerCase());
        }
        break;
      case "path":
        n.path = u && u[0] === "/" ? u : null;
        break;
      case "secure":
        n.secure = !0;
        break;
      case "httponly":
        n.httpOnly = !0;
        break;
      case "samesite":
        switch (u ? u.toLowerCase() : "") {
          case "strict":
            n.sameSite = "strict";
            break;
          case "lax":
            n.sameSite = "lax";
            break;
          case "none":
            n.sameSite = "none";
            break;
          default:
            n.sameSite = void 0;
            break;
        }
        break;
      default:
        n.extensions = n.extensions || [], n.extensions.push(s);
        break;
    }
  }
  return n;
}
function bm(e) {
  if (!e || bd(e))
    return;
  let t;
  if (typeof e == "string")
    try {
      t = JSON.parse(e);
    } catch {
      return;
    }
  else
    t = e;
  const a = new yt();
  return yt.serializableProperties.forEach((o) => {
    if (t && typeof t == "object" && Dn(o, t)) {
      const n = t[o];
      if (n === void 0 || Dn(o, Xe) && n === Xe[o])
        return;
      switch (o) {
        case "key":
        case "value":
        case "sameSite":
          typeof n == "string" && (a[o] = n);
          break;
        case "expires":
        case "creation":
        case "lastAccessed":
          typeof n == "number" || typeof n == "string" || n instanceof Date ? a[o] = t[o] == "Infinity" ? "Infinity" : new Date(n) : n === null && (a[o] = null);
          break;
        case "maxAge":
          (typeof n == "number" || n === "Infinity" || n === "-Infinity") && (a[o] = n);
          break;
        case "domain":
        case "path":
          (typeof n == "string" || n === null) && (a[o] = n);
          break;
        case "secure":
        case "httpOnly":
          typeof n == "boolean" && (a[o] = n);
          break;
        case "extensions":
          Array.isArray(n) && n.every((r) => typeof r == "string") && (a[o] = n);
          break;
        case "hostOnly":
        case "pathIsDefault":
          (typeof n == "boolean" || n === null) && (a[o] = n);
          break;
      }
    }
  }), a;
}
var Xe = {
  // the order in which the RFC has them:
  key: "",
  value: "",
  expires: "Infinity",
  maxAge: null,
  domain: null,
  path: null,
  secure: !1,
  httpOnly: !1,
  extensions: null,
  // set by the CookieJar:
  hostOnly: null,
  pathIsDefault: null,
  creation: null,
  lastAccessed: null,
  sameSite: void 0
}, nr = class za {
  /**
   * Create a new Cookie instance.
   * @public
   * @param options - The attributes to set on the cookie
   */
  constructor(t = {}) {
    this.key = t.key ?? Xe.key, this.value = t.value ?? Xe.value, this.expires = t.expires ?? Xe.expires, this.maxAge = t.maxAge ?? Xe.maxAge, this.domain = t.domain ?? Xe.domain, this.path = t.path ?? Xe.path, this.secure = t.secure ?? Xe.secure, this.httpOnly = t.httpOnly ?? Xe.httpOnly, this.extensions = t.extensions ?? Xe.extensions, this.creation = t.creation ?? Xe.creation, this.hostOnly = t.hostOnly ?? Xe.hostOnly, this.pathIsDefault = t.pathIsDefault ?? Xe.pathIsDefault, this.lastAccessed = t.lastAccessed ?? Xe.lastAccessed, this.sameSite = t.sameSite ?? Xe.sameSite, this.creation = t.creation ?? /* @__PURE__ */ new Date(), Object.defineProperty(this, "creationIndex", {
      configurable: !1,
      enumerable: !1,
      // important for assert.deepEqual checks
      writable: !0,
      value: ++za.cookiesCreated
    }), this.creationIndex = za.cookiesCreated;
  }
  [Symbol.for("nodejs.util.inspect.custom")]() {
    const t = Date.now(), a = this.hostOnly != null ? this.hostOnly.toString() : "?", o = this.creation && this.creation !== "Infinity" ? `${String(t - this.creation.getTime())}ms` : "?", n = this.lastAccessed && this.lastAccessed !== "Infinity" ? `${String(t - this.lastAccessed.getTime())}ms` : "?";
    return `Cookie="${this.toString()}; hostOnly=${a}; aAge=${n}; cAge=${o}"`;
  }
  /**
   * For convenience in using `JSON.stringify(cookie)`. Returns a plain-old Object that can be JSON-serialized.
   *
   * @remarks
   * - Any `Date` properties (such as {@link Cookie.expires}, {@link Cookie.creation}, and {@link Cookie.lastAccessed}) are exported in ISO format (`Date.toISOString()`).
   *
   *  - Custom Cookie properties are discarded. In tough-cookie 1.x, since there was no {@link Cookie.toJSON} method explicitly defined, all enumerable properties were captured.
   *      If you want a property to be serialized, add the property name to {@link Cookie.serializableProperties}.
   */
  toJSON() {
    const t = {};
    for (const a of za.serializableProperties) {
      const o = this[a];
      if (o !== Xe[a])
        switch (a) {
          case "key":
          case "value":
          case "sameSite":
            typeof o == "string" && (t[a] = o);
            break;
          case "expires":
          case "creation":
          case "lastAccessed":
            typeof o == "number" || typeof o == "string" || o instanceof Date ? t[a] = o == "Infinity" ? "Infinity" : new Date(o).toISOString() : o === null && (t[a] = null);
            break;
          case "maxAge":
            (typeof o == "number" || o === "Infinity" || o === "-Infinity") && (t[a] = o);
            break;
          case "domain":
          case "path":
            (typeof o == "string" || o === null) && (t[a] = o);
            break;
          case "secure":
          case "httpOnly":
            typeof o == "boolean" && (t[a] = o);
            break;
          case "extensions":
            Array.isArray(o) && (t[a] = o);
            break;
          case "hostOnly":
          case "pathIsDefault":
            (typeof o == "boolean" || o === null) && (t[a] = o);
            break;
        }
    }
    return t;
  }
  /**
   * Does a deep clone of this cookie, implemented exactly as `Cookie.fromJSON(cookie.toJSON())`.
   * @public
   */
  clone() {
    return bm(this.toJSON());
  }
  /**
   * Validates cookie attributes for semantic correctness. Useful for "lint" checking any `Set-Cookie` headers you generate.
   * For now, it returns a boolean, but eventually could return a reason string.
   *
   * @remarks
   * Works for a few things, but is by no means comprehensive.
   *
   * @beta
   */
  validate() {
    if (!this.value || !eCe.test(this.value) || this.expires != "Infinity" && !(this.expires instanceof Date) && !Rc(this.expires) || this.maxAge != null && this.maxAge !== "Infinity" && (this.maxAge === "-Infinity" || this.maxAge <= 0) || this.path != null && !tCe.test(this.path))
      return !1;
    const t = this.cdomain();
    return !(t && (t.match(/\.$/) || pd(t) == null));
  }
  /**
   * Sets the 'Expires' attribute on a cookie.
   *
   * @remarks
   * When given a `string` value it will be parsed with {@link parseDate}. If the value can't be parsed as a cookie date
   * then the 'Expires' attribute will be set to `"Infinity"`.
   *
   * @param exp - the new value for the 'Expires' attribute of the cookie.
   */
  setExpires(t) {
    t instanceof Date ? this.expires = t : this.expires = Rc(t) || "Infinity";
  }
  /**
   * Sets the 'Max-Age' attribute (in seconds) on a cookie.
   *
   * @remarks
   * Coerces `-Infinity` to `"-Infinity"` and `Infinity` to `"Infinity"` so it can be serialized to JSON.
   *
   * @param age - the new value for the 'Max-Age' attribute (in seconds).
   */
  setMaxAge(t) {
    t === 1 / 0 ? this.maxAge = "Infinity" : t === -1 / 0 ? this.maxAge = "-Infinity" : this.maxAge = t;
  }
  /**
   * Encodes to a `Cookie` header value (specifically, the {@link Cookie.key} and {@link Cookie.value} properties joined with "=").
   * @public
   */
  cookieString() {
    const t = this.value || "";
    return this.key ? `${this.key}=${t}` : t;
  }
  /**
   * Encodes to a `Set-Cookie header` value.
   * @public
   */
  toString() {
    let t = this.cookieString();
    return this.expires != "Infinity" && this.expires instanceof Date && (t += `; Expires=${Z0e(this.expires)}`), this.maxAge != null && this.maxAge != 1 / 0 && (t += `; Max-Age=${String(this.maxAge)}`), this.domain && !this.hostOnly && (t += `; Domain=${this.domain}`), this.path && (t += `; Path=${this.path}`), this.secure && (t += "; Secure"), this.httpOnly && (t += "; HttpOnly"), this.sameSite && this.sameSite !== "none" && (this.sameSite.toLowerCase() === za.sameSiteCanonical.lax.toLowerCase() ? t += `; SameSite=${za.sameSiteCanonical.lax}` : this.sameSite.toLowerCase() === za.sameSiteCanonical.strict.toLowerCase() ? t += `; SameSite=${za.sameSiteCanonical.strict}` : t += `; SameSite=${this.sameSite}`), this.extensions && this.extensions.forEach((a) => {
      t += `; ${a}`;
    }), t;
  }
  /**
   * Computes the TTL relative to now (milliseconds).
   *
   * @remarks
   * - `Infinity` is returned for cookies without an explicit expiry
   *
   * - `0` is returned if the cookie is expired.
   *
   * - Otherwise a time-to-live in milliseconds is returned.
   *
   * @param now - passing an explicit value is mostly used for testing purposes since this defaults to the `Date.now()`
   * @public
   */
  TTL(t = Date.now()) {
    if (this.maxAge != null && typeof this.maxAge == "number")
      return this.maxAge <= 0 ? 0 : this.maxAge * 1e3;
    const a = this.expires;
    return a === "Infinity" ? 1 / 0 : (a?.getTime() ?? t) - (t || Date.now());
  }
  /**
   * Computes the absolute unix-epoch milliseconds that this cookie expires.
   *
   * The "Max-Age" attribute takes precedence over "Expires" (as per the RFC). The {@link Cookie.lastAccessed} attribute
   * (or the `now` parameter if given) is used to offset the {@link Cookie.maxAge} attribute.
   *
   * If Expires ({@link Cookie.expires}) is set, that's returned.
   *
   * @param now - can be used to provide a time offset (instead of {@link Cookie.lastAccessed}) to use when calculating the "Max-Age" value
   */
  expiryTime(t) {
    if (this.maxAge != null) {
      const a = t || this.lastAccessed || /* @__PURE__ */ new Date(), o = typeof this.maxAge == "number" ? this.maxAge : -1 / 0, n = o <= 0 ? -1 / 0 : o * 1e3;
      return a === "Infinity" ? 1 / 0 : a.getTime() + n;
    }
    return this.expires == "Infinity" ? 1 / 0 : this.expires ? this.expires.getTime() : void 0;
  }
  /**
   * Similar to {@link Cookie.expiryTime}, computes the absolute unix-epoch milliseconds that this cookie expires and returns it as a Date.
   *
   * The "Max-Age" attribute takes precedence over "Expires" (as per the RFC). The {@link Cookie.lastAccessed} attribute
   * (or the `now` parameter if given) is used to offset the {@link Cookie.maxAge} attribute.
   *
   * If Expires ({@link Cookie.expires}) is set, that's returned.
   *
   * @param now - can be used to provide a time offset (instead of {@link Cookie.lastAccessed}) to use when calculating the "Max-Age" value
   */
  expiryDate(t) {
    const a = this.expiryTime(t);
    return a == 1 / 0 ? /* @__PURE__ */ new Date(2147483647e3) : a == -1 / 0 ? /* @__PURE__ */ new Date(0) : a == null ? void 0 : new Date(a);
  }
  /**
   * Indicates if the cookie has been persisted to a store or not.
   * @public
   */
  isPersistent() {
    return this.maxAge != null || this.expires != "Infinity";
  }
  /**
   * Calls {@link canonicalDomain} with the {@link Cookie.domain} property.
   * @public
   */
  canonicalizedDomain() {
    return Fi(this.domain);
  }
  /**
   * Alias for {@link Cookie.canonicalizedDomain}
   * @public
   */
  cdomain() {
    return Fi(this.domain);
  }
  /**
   * Parses a string into a Cookie object.
   *
   * @remarks
   * Note: when parsing a `Cookie` header it must be split by ';' before each Cookie string can be parsed.
   *
   * @example
   * ```
   * // parse a `Set-Cookie` header
   * const setCookieHeader = 'a=bcd; Expires=Tue, 18 Oct 2011 07:05:03 GMT'
   * const cookie = Cookie.parse(setCookieHeader)
   * cookie.key === 'a'
   * cookie.value === 'bcd'
   * cookie.expires === new Date(Date.parse('Tue, 18 Oct 2011 07:05:03 GMT'))
   * ```
   *
   * @example
   * ```
   * // parse a `Cookie` header
   * const cookieHeader = 'name=value; name2=value2; name3=value3'
   * const cookies = cookieHeader.split(';').map(Cookie.parse)
   * cookies[0].name === 'name'
   * cookies[0].value === 'value'
   * cookies[1].name === 'name2'
   * cookies[1].value === 'value2'
   * cookies[2].name === 'name3'
   * cookies[2].value === 'value3'
   * ```
   *
   * @param str - The `Set-Cookie` header or a Cookie string to parse.
   * @param options - Configures `strict` or `loose` mode for cookie parsing
   */
  static parse(t, a) {
    return nCe(t, a);
  }
  /**
   * Does the reverse of {@link Cookie.toJSON}.
   *
   * @remarks
   * Any Date properties (such as .expires, .creation, and .lastAccessed) are parsed via Date.parse, not tough-cookie's parseDate, since ISO timestamps are being handled at this layer.
   *
   * @example
   * ```
   * const json = JSON.stringify({
   *   key: 'alpha',
   *   value: 'beta',
   *   domain: 'example.com',
   *   path: '/foo',
   *   expires: '2038-01-19T03:14:07.000Z',
   * })
   * const cookie = Cookie.fromJSON(json)
   * cookie.key === 'alpha'
   * cookie.value === 'beta'
   * cookie.domain === 'example.com'
   * cookie.path === '/foo'
   * cookie.expires === new Date(Date.parse('2038-01-19T03:14:07.000Z'))
   * ```
   *
   * @param str - An unparsed JSON string or a value that has already been parsed as JSON
   */
  static fromJSON(t) {
    return bm(t);
  }
};
nr.cookiesCreated = 0;
nr.sameSiteLevel = {
  strict: 3,
  lax: 2,
  none: 1
};
nr.sameSiteCanonical = {
  strict: "Strict",
  lax: "Lax"
};
nr.serializableProperties = [
  "key",
  "value",
  "expires",
  "maxAge",
  "domain",
  "path",
  "secure",
  "httpOnly",
  "extensions",
  "hostOnly",
  "pathIsDefault",
  "creation",
  "lastAccessed",
  "sameSite"
];
var yt = nr, _m = 2147483647e3;
function vm(e, t) {
  let a;
  const o = e.path ? e.path.length : 0;
  if (a = (t.path ? t.path.length : 0) - o, a !== 0)
    return a;
  const n = e.creation && e.creation instanceof Date ? e.creation.getTime() : _m, r = t.creation && t.creation instanceof Date ? t.creation.getTime() : _m;
  return a = n - r, a !== 0 || (a = (e.creationIndex || 0) - (t.creationIndex || 0)), a;
}
function rCe(e) {
  if (!e || e.slice(0, 1) !== "/")
    return "/";
  if (e === "/")
    return e;
  const t = e.lastIndexOf("/");
  return t === 0 ? "/" : e.slice(0, t);
}
var iCe = /(?:^(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}$)|(?:^(?:(?:[a-f\d]{1,4}:){7}(?:[a-f\d]{1,4}|:)|(?:[a-f\d]{1,4}:){6}(?:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|:[a-f\d]{1,4}|:)|(?:[a-f\d]{1,4}:){5}(?::(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,2}|:)|(?:[a-f\d]{1,4}:){4}(?:(?::[a-f\d]{1,4}){0,1}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,3}|:)|(?:[a-f\d]{1,4}:){3}(?:(?::[a-f\d]{1,4}){0,2}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,4}|:)|(?:[a-f\d]{1,4}:){2}(?:(?::[a-f\d]{1,4}){0,3}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,5}|:)|(?:[a-f\d]{1,4}:){1}(?:(?::[a-f\d]{1,4}){0,4}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,6}|:)|(?::(?:(?::[a-f\d]{1,4}){0,5}:(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)(?:\.(?:25[0-5]|2[0-4]\d|1\d\d|[1-9]\d|\d)){3}|(?::[a-f\d]{1,4}){1,7}|:)))$)/;
function ym(e, t, a) {
  if (e == null || t == null)
    return;
  let o, n;
  if (o = e, n = t, o == null || n == null)
    return;
  if (o == n)
    return !0;
  const r = o.lastIndexOf(n);
  return r <= 0 || o.length !== n.length + r || o.substring(r - 1, r) !== "." ? !1 : !iCe.test(o);
}
function sCe(e) {
  const t = e.split(".");
  return t.length === 4 && t[0] !== void 0 && parseInt(t[0], 10) === 127;
}
function lCe(e) {
  return e === "::1";
}
function cCe(e) {
  return e.endsWith(".localhost");
}
function uCe(e) {
  const t = e.toLowerCase();
  return t === "localhost" || cCe(t);
}
function dCe(e) {
  return e.length >= 2 && e.startsWith("[") && e.endsWith("]") ? e.substring(1, e.length - 1) : e;
}
function gCe(e, t = !0) {
  let a;
  if (typeof e == "string")
    try {
      a = new URL(e);
    } catch {
      return !1;
    }
  else
    a = e;
  const o = a.protocol.replace(":", "").toLowerCase(), n = dCe(a.hostname).replace(/\.+$/, "");
  return o === "https" || o === "wss" ? !0 : t ? J0e.test(n) ? sCe(n) : _d.test(n) ? lCe(n) : uCe(n) : !1;
}
var hCe = {
  loose: !1,
  sameSiteContext: void 0,
  ignoreError: !1,
  http: !0
}, wm = {
  http: !0,
  expire: !0,
  allPaths: !1,
  sameSiteContext: void 0,
  sort: void 0
}, Dl = 'Invalid sameSiteContext option for getCookies(); expected one of "strict", "lax", or "none"';
function km(e) {
  if (e && typeof e == "object" && "hostname" in e && typeof e.hostname == "string" && "pathname" in e && typeof e.pathname == "string" && "protocol" in e && typeof e.protocol == "string")
    return {
      hostname: e.hostname,
      pathname: e.pathname,
      protocol: e.protocol
    };
  if (typeof e == "string")
    try {
      return new URL(decodeURI(e));
    } catch {
      return new URL(e);
    }
  else
    throw new Uy("`url` argument is not a string or URL.");
}
function xm(e) {
  const t = String(e).toLowerCase();
  if (t === "none" || t === "lax" || t === "strict")
    return t;
}
function mCe(e) {
  return !(typeof e.key == "string" && e.key.startsWith("__Secure-")) || e.secure;
}
function pCe(e) {
  return !(typeof e.key == "string" && e.key.startsWith("__Host-")) || !!(e.secure && e.hostOnly && e.path != null && e.path === "/");
}
function Ir(e) {
  const t = e.toLowerCase();
  switch (t) {
    case Ka.STRICT:
    case Ka.SILENT:
    case Ka.DISABLED:
      return t;
    default:
      return Ka.SILENT;
  }
}
var fCe = class $n {
  /**
   * Creates a new `CookieJar` instance.
   *
   * @remarks
   * - If a custom store is not passed to the constructor, an in-memory store ({@link MemoryCookieStore} will be created and used.
   * - If a boolean value is passed as the `options` parameter, this is equivalent to passing `{ rejectPublicSuffixes: <value> }`
   *
   * @param store - a custom {@link Store} implementation (defaults to {@link MemoryCookieStore})
   * @param options - configures how cookies are processed by the cookie jar
   */
  constructor(t, a) {
    typeof a == "boolean" && (a = { rejectPublicSuffixes: a }), this.rejectPublicSuffixes = a?.rejectPublicSuffixes ?? !0, this.enableLooseMode = a?.looseMode ?? !1, this.allowSpecialUseDomain = a?.allowSpecialUseDomain ?? !0, this.allowSecureOnLocal = a?.allowSecureOnLocal ?? !0, this.prefixSecurity = Ir(
      a?.prefixSecurity ?? "silent"
    ), this.store = t ?? new Fy();
  }
  callSync(t) {
    if (!this.store.synchronous)
      throw new Error(
        "CookieJar store is not synchronous; use async API instead."
      );
    let a = null, o;
    try {
      t.call(this, (n, r) => {
        a = n, o = r;
      });
    } catch (n) {
      a = n;
    }
    if (a) throw a;
    return o;
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  setCookie(t, a, o, n) {
    typeof o == "function" && (n = o, o = void 0);
    const r = nt(n), i = r.callback;
    let s;
    try {
      if (typeof a == "string" && wn(
        Pl(a),
        n,
        Dc(o)
      ), s = km(a), typeof a == "function")
        return r.reject(new Error("No URL was specified"));
      if (typeof o == "function" && (o = hCe), wn(typeof i == "function", i), !Pl(t) && !li(t) && t instanceof String && t.length == 0)
        return r.resolve(void 0);
    } catch (m) {
      return r.reject(m);
    }
    const l = Fi(s.hostname) ?? null, c = o?.loose || this.enableLooseMode;
    let u = null;
    if (o?.sameSiteContext && (u = xm(o.sameSiteContext), !u))
      return r.reject(new Error(Dl));
    if (typeof t == "string" || t instanceof String) {
      const m = yt.parse(t.toString(), { loose: c });
      if (!m) {
        const b = new Error("Cookie failed to parse");
        return o?.ignoreError ? r.resolve(void 0) : r.reject(b);
      }
      t = m;
    } else if (!(t instanceof yt)) {
      const m = new Error(
        "First argument to setCookie must be a Cookie object or string"
      );
      return o?.ignoreError ? r.resolve(void 0) : r.reject(m);
    }
    const d = o?.now || /* @__PURE__ */ new Date();
    if (this.rejectPublicSuffixes && t.domain)
      try {
        const m = t.cdomain();
        if ((typeof m == "string" ? pd(m, {
          allowSpecialUseDomain: this.allowSpecialUseDomain,
          ignoreError: o?.ignoreError
        }) : null) == null && !_d.test(t.domain)) {
          const b = new Error("Cookie has domain set to a public suffix");
          return o?.ignoreError ? r.resolve(void 0) : r.reject(b);
        }
      } catch (m) {
        return o?.ignoreError ? r.resolve(void 0) : (
          // eslint-disable-next-line @typescript-eslint/no-unsafe-argument
          r.reject(m)
        );
      }
    if (t.domain) {
      if (!ym(l ?? void 0, t.cdomain() ?? void 0)) {
        const m = new Error(
          `Cookie not in this host's domain. Cookie:${t.cdomain() ?? "null"} Request:${l ?? "null"}`
        );
        return o?.ignoreError ? r.resolve(void 0) : r.reject(m);
      }
      t.hostOnly == null && (t.hostOnly = !1);
    } else
      t.hostOnly = !0, t.domain = l;
    if ((!t.path || t.path[0] !== "/") && (t.path = rCe(s.pathname), t.pathIsDefault = !0), o?.http === !1 && t.httpOnly) {
      const m = new Error("Cookie is HttpOnly and this isn't an HTTP API");
      return o.ignoreError ? r.resolve(void 0) : r.reject(m);
    }
    if (t.sameSite !== "none" && t.sameSite !== void 0 && u && u === "none") {
      const m = new Error(
        "Cookie is SameSite but this is a cross-origin request"
      );
      return o?.ignoreError ? r.resolve(void 0) : r.reject(m);
    }
    const h = this.prefixSecurity === Ka.SILENT;
    if (this.prefixSecurity !== Ka.DISABLED) {
      let m = !1, b;
      if (mCe(t) ? pCe(t) || (m = !0, b = "Cookie has __Host prefix but either Secure or HostOnly attribute is not set or Path is not '/'") : (m = !0, b = "Cookie has __Secure prefix but Secure attribute is not set"), m)
        return o?.ignoreError || h ? r.resolve(void 0) : r.reject(new Error(b));
    }
    const p = this.store;
    p.updateCookie || (p.updateCookie = async function(m, b, w) {
      return this.putCookie(b).then(
        () => w?.(null),
        (_) => w?.(_)
      );
    });
    const f = function(m, b) {
      if (m) {
        i(m);
        return;
      }
      const w = function(_) {
        _ ? i(_) : typeof t == "string" ? i(null, void 0) : i(null, t);
      };
      if (b) {
        if (o && "http" in o && o.http === !1 && b.httpOnly) {
          m = new Error("old Cookie is HttpOnly and this isn't an HTTP API"), o.ignoreError ? i(null, void 0) : i(m);
          return;
        }
        t instanceof yt && (t.creation = b.creation, t.creationIndex = b.creationIndex, t.lastAccessed = d, p.updateCookie(b, t, w));
      } else
        t instanceof yt && (t.creation = t.lastAccessed = d, p.putCookie(t, w));
    };
    return p.findCookie(t.domain, t.path, t.key, f), r.promise;
  }
  /**
   * Synchronously attempt to set the {@link Cookie} in the {@link CookieJar}.
   *
   * <strong>Note:</strong> Only works if the configured {@link Store} is also synchronous.
   *
   * @remarks
   * - If successfully persisted, the {@link Cookie} will have updated
   *     {@link Cookie.creation}, {@link Cookie.lastAccessed} and {@link Cookie.hostOnly}
   *     properties.
   *
   * - As per the RFC, the {@link Cookie.hostOnly} flag is set if there was no `Domain={value}`
   *     attribute on the cookie string. The {@link Cookie.domain} property is set to the
   *     fully-qualified hostname of `currentUrl` in this case. Matching this cookie requires an
   *     exact hostname match (not a {@link domainMatch} as per usual)
   *
   * @param cookie - The cookie object or cookie string to store. A string value will be parsed into a cookie using {@link Cookie.parse}.
   * @param url - The domain to store the cookie with.
   * @param options - Configuration settings to use when storing the cookie.
   * @public
   */
  setCookieSync(t, a, o) {
    const n = o ? this.setCookie.bind(this, t, a, o) : this.setCookie.bind(this, t, a);
    return this.callSync(n);
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  getCookies(t, a, o) {
    typeof a == "function" ? (o = a, a = wm) : a === void 0 && (a = wm);
    const n = nt(o), r = n.callback;
    let i;
    try {
      typeof t == "string" && wn(Pl(t), r, t), i = km(t), wn(
        li(a),
        r,
        Dc(a)
      ), wn(typeof r == "function", r);
    } catch (w) {
      return n.reject(w);
    }
    const s = Fi(i.hostname), l = i.pathname || "/", c = gCe(
      t,
      this.allowSecureOnLocal
    );
    let u = 0;
    if (a.sameSiteContext) {
      const w = xm(a.sameSiteContext);
      if (w == null)
        return n.reject(new Error(Dl));
      if (u = yt.sameSiteLevel[w], !u)
        return n.reject(new Error(Dl));
    }
    const d = a.http ?? !0, h = Date.now(), p = a.expire ?? !0, f = a.allPaths ?? !1, m = this.store;
    function b(w) {
      if (w.hostOnly) {
        if (w.domain != s)
          return !1;
      } else if (!ym(s ?? void 0, w.domain ?? void 0))
        return !1;
      if (!f && typeof w.path == "string" && !Ly(l, w.path) || w.secure && !c || w.httpOnly && !d)
        return !1;
      if (u) {
        let y;
        if (w.sameSite === "lax" ? y = yt.sameSiteLevel.lax : w.sameSite === "strict" ? y = yt.sameSiteLevel.strict : y = yt.sameSiteLevel.none, y > u)
          return !1;
      }
      const _ = w.expiryTime();
      return p && _ != null && _ <= h ? (m.removeCookie(w.domain, w.path, w.key, () => {
      }), !1) : !0;
    }
    return m.findCookies(
      s,
      f ? null : l,
      this.allowSpecialUseDomain,
      (w, _) => {
        if (w) {
          r(w);
          return;
        }
        if (_ == null) {
          r(null, []);
          return;
        }
        _ = _.filter(b), "sort" in a && a.sort !== !1 && (_ = _.sort(vm));
        const y = /* @__PURE__ */ new Date();
        for (const k of _)
          k.lastAccessed = y;
        r(null, _);
      }
    ), n.promise;
  }
  /**
   * Synchronously retrieve the list of cookies that can be sent in a Cookie header for the
   * current URL.
   *
   * <strong>Note</strong>: Only works if the configured Store is also synchronous.
   *
   * @remarks
   * - The array of cookies returned will be sorted according to {@link cookieCompare}.
   *
   * - The {@link Cookie.lastAccessed} property will be updated on all returned cookies.
   *
   * @param url - The domain to store the cookie with.
   * @param options - Configuration settings to use when retrieving the cookies.
   */
  getCookiesSync(t, a) {
    return this.callSync(this.getCookies.bind(this, t, a)) ?? [];
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  getCookieString(t, a, o) {
    typeof a == "function" && (o = a, a = void 0);
    const n = nt(o), r = function(i, s) {
      i ? n.callback(i) : n.callback(
        null,
        s?.sort(vm).map((l) => l.cookieString()).join("; ")
      );
    };
    return this.getCookies(t, a, r), n.promise;
  }
  /**
   * Synchronous version of `.getCookieString()`. Accepts the same options as `.getCookies()` but returns a string suitable for a
   * `Cookie` header rather than an Array.
   *
   * <strong>Note</strong>: Only works if the configured Store is also synchronous.
   *
   * @param url - The domain to store the cookie with.
   * @param options - Configuration settings to use when retrieving the cookies.
   */
  getCookieStringSync(t, a) {
    return this.callSync(
      a ? this.getCookieString.bind(this, t, a) : this.getCookieString.bind(this, t)
    ) ?? "";
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  getSetCookieStrings(t, a, o) {
    typeof a == "function" && (o = a, a = void 0);
    const n = nt(
      o
    ), r = function(i, s) {
      i ? n.callback(i) : n.callback(
        null,
        s?.map((l) => l.toString())
      );
    };
    return this.getCookies(t, a, r), n.promise;
  }
  /**
   * Synchronous version of `.getSetCookieStrings()`. Returns an array of strings suitable for `Set-Cookie` headers.
   * Accepts the same options as `.getCookies()`.
   *
   * <strong>Note</strong>: Only works if the configured Store is also synchronous.
   *
   * @param url - The domain to store the cookie with.
   * @param options - Configuration settings to use when retrieving the cookies.
   */
  getSetCookieStringsSync(t, a = {}) {
    return this.callSync(this.getSetCookieStrings.bind(this, t, a)) ?? [];
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  serialize(t) {
    const a = nt(t);
    let o = this.store.constructor.name;
    li(o) && (o = null);
    const n = {
      // The version of tough-cookie that serialized this jar. Generally a good
      // practice since future versions can make data import decisions based on
      // known past behavior. When/if this matters, use `semver`.
      version: `tough-cookie@${H0e}`,
      // add the store type, to make humans happy:
      storeType: o,
      // CookieJar configuration:
      rejectPublicSuffixes: this.rejectPublicSuffixes,
      enableLooseMode: this.enableLooseMode,
      allowSpecialUseDomain: this.allowSpecialUseDomain,
      prefixSecurity: Ir(this.prefixSecurity),
      // this gets filled from getAllCookies:
      cookies: []
    };
    return typeof this.store.getAllCookies != "function" ? a.reject(
      new Error(
        "store does not support getAllCookies and cannot be serialized"
      )
    ) : (this.store.getAllCookies((r, i) => {
      if (r) {
        a.callback(r);
        return;
      }
      if (i == null) {
        a.callback(null, n);
        return;
      }
      n.cookies = i.map((s) => {
        const l = s.toJSON();
        return delete l.creationIndex, l;
      }), a.callback(null, n);
    }), a.promise);
  }
  /**
   * Serialize the CookieJar if the underlying store supports `.getAllCookies`.
   *
   * <strong>Note</strong>: Only works if the configured Store is also synchronous.
   */
  serializeSync() {
    return this.callSync((t) => {
      this.serialize(t);
    });
  }
  /**
   * Alias of {@link CookieJar.serializeSync}. Allows the cookie to be serialized
   * with `JSON.stringify(cookieJar)`.
   */
  toJSON() {
    return this.serializeSync();
  }
  /**
   * Use the class method CookieJar.deserialize instead of calling this directly
   * @internal
   */
  _importCookies(t, a) {
    let o;
    if (t && typeof t == "object" && Dn("cookies", t) && Array.isArray(t.cookies) && (o = t.cookies), !o) {
      a(new Error("serialized jar has no cookies array"), void 0);
      return;
    }
    o = o.slice();
    const n = (r) => {
      if (r) {
        a(r, void 0);
        return;
      }
      if (Array.isArray(o)) {
        if (!o.length) {
          a(r, this);
          return;
        }
        let i;
        try {
          i = yt.fromJSON(o.shift());
        } catch (s) {
          a(s instanceof Error ? s : new Error(), void 0);
          return;
        }
        if (i === void 0) {
          n(null);
          return;
        }
        this.store.putCookie(i, n);
      }
    };
    n(null);
  }
  /**
   * @internal
   */
  _importCookiesSync(t) {
    this.callSync(this._importCookies.bind(this, t));
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  clone(t, a) {
    typeof t == "function" && (a = t, t = void 0);
    const o = nt(a), n = o.callback;
    return this.serialize((r, i) => r ? o.reject(r) : $n.deserialize(i ?? "", t, n)), o.promise;
  }
  /**
   * @internal
   */
  _cloneSync(t) {
    const a = t && typeof t != "function" ? this.clone.bind(this, t) : this.clone.bind(this);
    return this.callSync((o) => {
      a(o);
    });
  }
  /**
   * Produces a deep clone of this CookieJar. Modifications to the original do
   * not affect the clone, and vice versa.
   *
   * <strong>Note</strong>: Only works if both the configured Store and destination
   * Store are synchronous.
   *
   * @remarks
   * - When no {@link Store} is provided, a new {@link MemoryCookieStore} will be used.
   *
   * - Transferring between store types is supported so long as the source
   *     implements `.getAllCookies()` and the destination implements `.putCookie()`.
   *
   * @param newStore - The target {@link Store} to clone cookies into.
   */
  cloneSync(t) {
    if (!t)
      return this._cloneSync();
    if (!t.synchronous)
      throw new Error(
        "CookieJar clone destination store is not synchronous; use async API instead."
      );
    return this._cloneSync(t);
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  removeAllCookies(t) {
    const a = nt(t), o = a.callback, n = this.store;
    return typeof n.removeAllCookies == "function" && n.removeAllCookies !== Wy.prototype.removeAllCookies ? (n.removeAllCookies(o), a.promise) : (n.getAllCookies((r, i) => {
      if (r) {
        o(r);
        return;
      }
      if (i || (i = []), i.length === 0) {
        o(null, void 0);
        return;
      }
      let s = 0;
      const l = [], c = function(u) {
        if (u && l.push(u), s++, s === i.length) {
          l[0] ? o(l[0]) : o(null, void 0);
          return;
        }
      };
      i.forEach((u) => {
        n.removeCookie(
          u.domain,
          u.path,
          u.key,
          c
        );
      });
    }), a.promise);
  }
  /**
   * Removes all cookies from the CookieJar.
   *
   * <strong>Note</strong>: Only works if the configured Store is also synchronous.
   *
   * @remarks
   * - This is a new backwards-compatible feature of tough-cookie version 2.5,
   *     so not all Stores will implement it efficiently. For Stores that do not
   *     implement `removeAllCookies`, the fallback is to call `removeCookie` after
   *     `getAllCookies`.
   *
   * - If `getAllCookies` fails or isn't implemented in the Store, an error is returned.
   *
   * - If one or more of the `removeCookie` calls fail, only the first error is returned.
   */
  removeAllCookiesSync() {
    this.callSync((t) => {
      this.removeAllCookies(t);
    });
  }
  /**
   * @internal No doc because this is the overload implementation
   */
  static deserialize(t, a, o) {
    typeof a == "function" && (o = a, a = void 0);
    const n = nt(o);
    let r;
    if (typeof t == "string")
      try {
        r = JSON.parse(t);
      } catch (u) {
        return n.reject(u instanceof Error ? u : new Error());
      }
    else
      r = t;
    const i = (u) => r && typeof r == "object" && Dn(u, r) ? r[u] : void 0, s = (u) => {
      const d = i(u);
      return typeof d == "boolean" ? d : void 0;
    }, l = (u) => {
      const d = i(u);
      return typeof d == "string" ? d : void 0;
    }, c = new $n(a, {
      rejectPublicSuffixes: s("rejectPublicSuffixes"),
      looseMode: s("enableLooseMode"),
      allowSpecialUseDomain: s("allowSpecialUseDomain"),
      prefixSecurity: Ir(
        l("prefixSecurity") ?? "silent"
      )
    });
    return c._importCookies(r, (u) => {
      if (u) {
        n.callback(u);
        return;
      }
      n.callback(null, c);
    }), n.promise;
  }
  /**
   * A new CookieJar is created and the serialized {@link Cookie} values are added to
   * the underlying store. Each {@link Cookie} is added via `store.putCookie(...)` in
   * the order in which they appear in the serialization.
   *
   * <strong>Note</strong>: Only works if the configured Store is also synchronous.
   *
   * @remarks
   * - When no {@link Store} is provided, a new {@link MemoryCookieStore} will be used.
   *
   * - As a convenience, if `strOrObj` is a string, it is passed through `JSON.parse` first.
   *
   * @param strOrObj - A JSON string or object representing the deserialized cookies.
   * @param store - The underlying store to persist the deserialized cookies into.
   */
  static deserializeSync(t, a) {
    const o = typeof t == "string" ? JSON.parse(t) : t, n = (l) => o && typeof o == "object" && Dn(l, o) ? o[l] : void 0, r = (l) => {
      const c = n(l);
      return typeof c == "boolean" ? c : void 0;
    }, i = (l) => {
      const c = n(l);
      return typeof c == "string" ? c : void 0;
    }, s = new $n(a, {
      rejectPublicSuffixes: r("rejectPublicSuffixes"),
      looseMode: r("enableLooseMode"),
      allowSpecialUseDomain: r("allowSpecialUseDomain"),
      prefixSecurity: Ir(
        i("prefixSecurity") ?? "silent"
      )
    });
    if (!s.store.synchronous)
      throw new Error(
        "CookieJar store is not synchronous; use async API instead."
      );
    return s._importCookiesSync(o), s;
  }
  /**
   * Alias of {@link CookieJar.deserializeSync}.
   *
   * @remarks
   * - When no {@link Store} is provided, a new {@link MemoryCookieStore} will be used.
   *
   * - As a convenience, if `strOrObj` is a string, it is passed through `JSON.parse` first.
   *
   * @param jsonString - A JSON string or object representing the deserialized cookies.
   * @param store - The underlying store to persist the deserialized cookies into.
   */
  static fromJSON(t, a) {
    return $n.deserializeSync(t, a);
  }
};
/*!
 * Copyright (c) 2015-2020, Salesforce.com, Inc.
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice,
 * this list of conditions and the following disclaimer.
 *
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 * this list of conditions and the following disclaimer in the documentation
 * and/or other materials provided with the distribution.
 *
 * 3. Neither the name of Salesforce.com nor the names of its contributors may
 * be used to endorse or promote products derived from this software without
 * specific prior written permission.
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS"
 * AND ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE
 * IMPLIED WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE
 * ARE DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT HOLDER OR CONTRIBUTORS BE
 * LIABLE FOR ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR
 * CONSEQUENTIAL DAMAGES (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF
 * SUBSTITUTE GOODS OR SERVICES; LOSS OF USE, DATA, OR PROFITS; OR BUSINESS
 * INTERRUPTION) HOWEVER CAUSED AND ON ANY THEORY OF LIABILITY, WHETHER IN
 * CONTRACT, STRICT LIABILITY, OR TORT (INCLUDING NEGLIGENCE OR OTHERWISE)
 * ARISING IN ANY WAY OUT OF THE USE OF THIS SOFTWARE, EVEN IF ADVISED OF THE
 * POSSIBILITY OF SUCH DAMAGE.
 */
function bCe(e) {
  try {
    return JSON.parse(e);
  } catch {
    return;
  }
}
let _Ce = class {
  #a = "__msw-cookie-store__";
  #t;
  #e;
  constructor() {
    Dy() || hd(
      typeof localStorage < "u",
      "Failed to create a CookieStore: `localStorage` is not available in this environment. This is likely an issue with your environment, which has been detected as browser (or browser-like) environment and must implement global browser APIs correctly."
    ), this.#e = new Fy(), this.#e.idx = this.getCookieStoreIndex(), this.#t = new fCe(this.#e);
  }
  getCookies(t) {
    return this.#t.getCookiesSync(t);
  }
  async setCookie(t, a) {
    await this.#t.setCookie(t, a), this.persist();
  }
  getCookieStoreIndex() {
    if (typeof localStorage > "u")
      return {};
    const t = localStorage.getItem(this.#a);
    if (t == null)
      return {};
    const a = bCe(t);
    if (a == null)
      return {};
    const o = {};
    for (const n of a) {
      const r = yt.fromJSON(n);
      r != null && r.domain != null && r.path != null && (o[r.domain] ||= {}, o[r.domain][r.path] ||= {}, o[r.domain][r.path][r.key] = r);
    }
    return o;
  }
  persist() {
    if (typeof localStorage > "u")
      return;
    const t = [], { idx: a } = this.#e;
    for (const o in a)
      for (const n in a[o])
        for (const r in a[o][n])
          t.push(a[o][n][r].toJSON());
    localStorage.setItem(this.#a, JSON.stringify(t));
  }
};
const vCe = new _Ce();
function qy(e) {
  const t = Ty.parse(e), a = {};
  for (const o in t)
    typeof t[o] < "u" && (a[o] = t[o]);
  return a;
}
function $m() {
  return qy(document.cookie);
}
function yCe(e) {
  if (typeof document > "u" || typeof location > "u")
    return {};
  switch (e.credentials) {
    case "same-origin": {
      const t = new URL(e.url);
      return location.origin === t.origin ? $m() : {};
    }
    case "include":
      return $m();
    default:
      return {};
  }
}
function wCe(e) {
  const t = e.headers.get("cookie"), a = t ? qy(t) : {}, o = yCe(e);
  for (const i in o)
    e.headers.append(
      "cookie",
      Ty.serialize(i, o[i])
    );
  const n = vCe.getCookies(e.url), r = Object.fromEntries(
    n.map((i) => [i.key, i.value])
  );
  for (const i of n)
    e.headers.append("cookie", i.toString());
  return {
    ...o,
    ...r,
    ...a
  };
}
var ja = /* @__PURE__ */ ((e) => (e.HEAD = "HEAD", e.GET = "GET", e.POST = "POST", e.PUT = "PUT", e.PATCH = "PATCH", e.OPTIONS = "OPTIONS", e.DELETE = "DELETE", e))(ja || {});
let kCe = class extends Bi {
  constructor(t, a, o, n) {
    const r = typeof a == "function" ? "[custom predicate]" : a;
    super({
      info: {
        header: `${t}${r ? ` ${r}` : ""}`,
        path: a,
        method: t
      },
      resolver: o,
      options: n
    }), this.checkRedundantQueryParameters();
  }
  checkRedundantQueryParameters() {
    const { method: t, path: a } = this.info;
    !a || a instanceof RegExp || typeof a == "function" || Ny(a) === a || (u0e(a).forEach((o, n) => {
    }), Pc.warn(
      `Found a redundant usage of query parameters in the request handler URL for "${t} ${a}". Please match against a path instead and access query parameters using "new URL(request.url).searchParams" instead. Learn more: https://mswjs.io/docs/http/intercepting-requests#querysearch-parameters`
    ));
  }
  async parse(t) {
    const a = new URL(t.request.url), o = wCe(t.request);
    if (typeof this.info.path == "function") {
      const n = await this.info.path({
        request: t.request,
        cookies: o
      });
      return {
        match: typeof n == "boolean" ? {
          matches: n,
          params: {}
        } : n,
        cookies: o
      };
    }
    return {
      match: this.info.path ? p0e(a, this.info.path, t.resolutionContext?.baseUrl) : { matches: !1, params: {} },
      cookies: o
    };
  }
  async predicate(t) {
    const a = this.matchMethod(t.request.method), o = t.parsedResult.match.matches;
    return a && o;
  }
  matchMethod(t) {
    return this.info.method instanceof RegExp ? this.info.method.test(t) : ASe(this.info.method, t);
  }
  extendResolverArgs(t) {
    return {
      params: t.parsedResult.match?.params || {},
      cookies: t.parsedResult.cookies
    };
  }
  async log(t) {
    const a = f0e(t.request.url), o = await DSe(t.request), n = await USe(t.response), r = OSe(n.status);
    console.groupCollapsed(
      Pc.formatMessage(
        `${PSe()} ${t.request.method} ${a} (%c${n.status} ${n.statusText}%c)`
      ),
      `color:${r}`,
      "color:inherit"
    ), console.log("Request", o), console.log("Handler:", this), console.log("Response", n), console.groupEnd();
  }
};
function qa(e) {
  return (t, a, o = {}) => new kCe(e, t, a, o);
}
qa(ja.HEAD), qa(ja.GET), qa(ja.POST), qa(ja.PUT), qa(ja.DELETE), qa(ja.PATCH), qa(ja.OPTIONS);
var xCe = Object.create, Hy = Object.defineProperty, $Ce = Object.getOwnPropertyDescriptor, Gy = Object.getOwnPropertyNames, SCe = Object.getPrototypeOf, CCe = Object.prototype.hasOwnProperty, ECe = (e, t) => function() {
  return t || (0, e[Gy(e)[0]])((t = { exports: {} }).exports, t), t.exports;
}, zCe = (e, t, a, o) => {
  if (t && typeof t == "object" || typeof t == "function")
    for (let n of Gy(t))
      !CCe.call(e, n) && n !== a && Hy(e, n, { get: () => t[n], enumerable: !(o = $Ce(t, n)) || o.enumerable });
  return e;
}, jCe = (e, t, a) => (a = e != null ? xCe(SCe(e)) : {}, zCe(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  !e || !e.__esModule ? Hy(a, "default", { value: e, enumerable: !0 }) : a,
  e
)), ACe = ECe({
  "node_modules/set-cookie-parser/lib/set-cookie.js"(e, t) {
    var a = {
      decodeValues: !0,
      map: !1,
      silent: !1
    };
    function o(l) {
      return typeof l == "string" && !!l.trim();
    }
    function n(l, c) {
      var u = l.split(";").filter(o), d = u.shift(), h = r(d), p = h.name, f = h.value;
      c = c ? Object.assign({}, a, c) : a;
      try {
        f = c.decodeValues ? decodeURIComponent(f) : f;
      } catch (b) {
        console.error(
          "set-cookie-parser encountered an error while decoding a cookie with value '" + f + "'. Set options.decodeValues to false to disable this feature.",
          b
        );
      }
      var m = {
        name: p,
        value: f
      };
      return u.forEach(function(b) {
        var w = b.split("="), _ = w.shift().trimLeft().toLowerCase(), y = w.join("=");
        _ === "expires" ? m.expires = new Date(y) : _ === "max-age" ? m.maxAge = parseInt(y, 10) : _ === "secure" ? m.secure = !0 : _ === "httponly" ? m.httpOnly = !0 : _ === "samesite" ? m.sameSite = y : m[_] = y;
      }), m;
    }
    function r(l) {
      var c = "", u = "", d = l.split("=");
      return d.length > 1 ? (c = d.shift(), u = d.join("=")) : u = l, { name: c, value: u };
    }
    function i(l, c) {
      if (c = c ? Object.assign({}, a, c) : a, !l)
        return c.map ? {} : [];
      if (l.headers)
        if (typeof l.headers.getSetCookie == "function")
          l = l.headers.getSetCookie();
        else if (l.headers["set-cookie"])
          l = l.headers["set-cookie"];
        else {
          var u = l.headers[Object.keys(l.headers).find(function(h) {
            return h.toLowerCase() === "set-cookie";
          })];
          !u && l.headers.cookie && !c.silent && console.warn(
            "Warning: set-cookie-parser appears to have been called on a request object. It is designed to parse Set-Cookie headers from responses, not Cookie headers from requests. Set the option {silent: true} to suppress this warning."
          ), l = u;
        }
      if (Array.isArray(l) || (l = [l]), c = c ? Object.assign({}, a, c) : a, c.map) {
        var d = {};
        return l.filter(o).reduce(function(h, p) {
          var f = n(p, c);
          return h[f.name] = f, h;
        }, d);
      } else
        return l.filter(o).map(function(h) {
          return n(h, c);
        });
    }
    function s(l) {
      if (Array.isArray(l))
        return l;
      if (typeof l != "string")
        return [];
      var c = [], u = 0, d, h, p, f, m;
      function b() {
        for (; u < l.length && /\s/.test(l.charAt(u)); )
          u += 1;
        return u < l.length;
      }
      function w() {
        return h = l.charAt(u), h !== "=" && h !== ";" && h !== ",";
      }
      for (; u < l.length; ) {
        for (d = u, m = !1; b(); )
          if (h = l.charAt(u), h === ",") {
            for (p = u, u += 1, b(), f = u; u < l.length && w(); )
              u += 1;
            u < l.length && l.charAt(u) === "=" ? (m = !0, u = f, c.push(l.substring(d, p)), d = u) : u = p + 1;
          } else
            u += 1;
        (!m || u >= l.length) && c.push(l.substring(d, l.length));
      }
      return c;
    }
    t.exports = i, t.exports.parse = i, t.exports.parseString = n, t.exports.splitCookiesString = s;
  }
});
jCe(ACe());
const { message: Jrt } = jy;
SSe();
async function OCe() {
  return _w.post("/legacy-auth/logout");
}
class Sm extends Error {
  code;
  errorData;
  constructor(t, a, o) {
    super(t), this.name = "HeError", this.code = a, this.errorData = o;
  }
}
function Ky(e, t) {
  return function() {
    return e.apply(t, arguments);
  };
}
const { toString: PCe } = Object.prototype, { getPrototypeOf: vd } = Object, { iterator: Ns, toStringTag: Jy } = Symbol, Rs = /* @__PURE__ */ ((e) => (t) => {
  const a = PCe.call(t);
  return e[a] || (e[a] = a.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), Bt = (e) => (e = e.toLowerCase(), (t) => Rs(t) === e), Is = (e) => (t) => typeof t === e, { isArray: sn } = Array, Qo = Is("undefined");
function rr(e) {
  return e !== null && !Qo(e) && e.constructor !== null && !Qo(e.constructor) && ht(e.constructor.isBuffer) && e.constructor.isBuffer(e);
}
const Zy = Bt("ArrayBuffer");
function DCe(e) {
  let t;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? t = ArrayBuffer.isView(e) : t = e && e.buffer && Zy(e.buffer), t;
}
const NCe = Is("string"), ht = Is("function"), Yy = Is("number"), ir = (e) => e !== null && typeof e == "object", RCe = (e) => e === !0 || e === !1, ci = (e) => {
  if (Rs(e) !== "object")
    return !1;
  const t = vd(e);
  return (t === null || t === Object.prototype || Object.getPrototypeOf(t) === null) && !(Jy in e) && !(Ns in e);
}, ICe = (e) => {
  if (!ir(e) || rr(e))
    return !1;
  try {
    return Object.keys(e).length === 0 && Object.getPrototypeOf(e) === Object.prototype;
  } catch {
    return !1;
  }
}, TCe = Bt("Date"), MCe = Bt("File"), LCe = Bt("Blob"), WCe = Bt("FileList"), BCe = (e) => ir(e) && ht(e.pipe), FCe = (e) => {
  let t;
  return e && (typeof FormData == "function" && e instanceof FormData || ht(e.append) && ((t = Rs(e)) === "formdata" || // detect form-data instance
  t === "object" && ht(e.toString) && e.toString() === "[object FormData]"));
}, VCe = Bt("URLSearchParams"), [UCe, qCe, HCe, GCe] = ["ReadableStream", "Request", "Response", "Headers"].map(Bt), KCe = (e) => e.trim ? e.trim() : e.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function sr(e, t, { allOwnKeys: a = !1 } = {}) {
  if (e === null || typeof e > "u")
    return;
  let o, n;
  if (typeof e != "object" && (e = [e]), sn(e))
    for (o = 0, n = e.length; o < n; o++)
      t.call(null, e[o], o, e);
  else {
    if (rr(e))
      return;
    const r = a ? Object.getOwnPropertyNames(e) : Object.keys(e), i = r.length;
    let s;
    for (o = 0; o < i; o++)
      s = r[o], t.call(null, e[s], s, e);
  }
}
function Xy(e, t) {
  if (rr(e))
    return null;
  t = t.toLowerCase();
  const a = Object.keys(e);
  let o = a.length, n;
  for (; o-- > 0; )
    if (n = a[o], t === n.toLowerCase())
      return n;
  return null;
}
const Ja = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : global, Qy = (e) => !Qo(e) && e !== Ja;
function Ic() {
  const { caseless: e, skipUndefined: t } = Qy(this) && this || {}, a = {}, o = (n, r) => {
    const i = e && Xy(a, r) || r;
    ci(a[i]) && ci(n) ? a[i] = Ic(a[i], n) : ci(n) ? a[i] = Ic({}, n) : sn(n) ? a[i] = n.slice() : (!t || !Qo(n)) && (a[i] = n);
  };
  for (let n = 0, r = arguments.length; n < r; n++)
    arguments[n] && sr(arguments[n], o);
  return a;
}
const JCe = (e, t, a, { allOwnKeys: o } = {}) => (sr(t, (n, r) => {
  a && ht(n) ? e[r] = Ky(n, a) : e[r] = n;
}, { allOwnKeys: o }), e), ZCe = (e) => (e.charCodeAt(0) === 65279 && (e = e.slice(1)), e), YCe = (e, t, a, o) => {
  e.prototype = Object.create(t.prototype, o), e.prototype.constructor = e, Object.defineProperty(e, "super", {
    value: t.prototype
  }), a && Object.assign(e.prototype, a);
}, XCe = (e, t, a, o) => {
  let n, r, i;
  const s = {};
  if (t = t || {}, e == null) return t;
  do {
    for (n = Object.getOwnPropertyNames(e), r = n.length; r-- > 0; )
      i = n[r], (!o || o(i, e, t)) && !s[i] && (t[i] = e[i], s[i] = !0);
    e = a !== !1 && vd(e);
  } while (e && (!a || a(e, t)) && e !== Object.prototype);
  return t;
}, QCe = (e, t, a) => {
  e = String(e), (a === void 0 || a > e.length) && (a = e.length), a -= t.length;
  const o = e.indexOf(t, a);
  return o !== -1 && o === a;
}, eEe = (e) => {
  if (!e) return null;
  if (sn(e)) return e;
  let t = e.length;
  if (!Yy(t)) return null;
  const a = new Array(t);
  for (; t-- > 0; )
    a[t] = e[t];
  return a;
}, tEe = /* @__PURE__ */ ((e) => (t) => e && t instanceof e)(typeof Uint8Array < "u" && vd(Uint8Array)), aEe = (e, t) => {
  const a = (e && e[Ns]).call(e);
  let o;
  for (; (o = a.next()) && !o.done; ) {
    const n = o.value;
    t.call(e, n[0], n[1]);
  }
}, oEe = (e, t) => {
  let a;
  const o = [];
  for (; (a = e.exec(t)) !== null; )
    o.push(a);
  return o;
}, nEe = Bt("HTMLFormElement"), rEe = (e) => e.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(t, a, o) {
    return a.toUpperCase() + o;
  }
), Cm = (({ hasOwnProperty: e }) => (t, a) => e.call(t, a))(Object.prototype), iEe = Bt("RegExp"), ew = (e, t) => {
  const a = Object.getOwnPropertyDescriptors(e), o = {};
  sr(a, (n, r) => {
    let i;
    (i = t(n, r, e)) !== !1 && (o[r] = i || n);
  }), Object.defineProperties(e, o);
}, sEe = (e) => {
  ew(e, (t, a) => {
    if (ht(e) && ["arguments", "caller", "callee"].indexOf(a) !== -1)
      return !1;
    const o = e[a];
    if (ht(o)) {
      if (t.enumerable = !1, "writable" in t) {
        t.writable = !1;
        return;
      }
      t.set || (t.set = () => {
        throw Error("Can not rewrite read-only method '" + a + "'");
      });
    }
  });
}, lEe = (e, t) => {
  const a = {}, o = (n) => {
    n.forEach((r) => {
      a[r] = !0;
    });
  };
  return sn(e) ? o(e) : o(String(e).split(t)), a;
}, cEe = () => {
}, uEe = (e, t) => e != null && Number.isFinite(e = +e) ? e : t;
function dEe(e) {
  return !!(e && ht(e.append) && e[Jy] === "FormData" && e[Ns]);
}
const gEe = (e) => {
  const t = new Array(10), a = (o, n) => {
    if (ir(o)) {
      if (t.indexOf(o) >= 0)
        return;
      if (rr(o))
        return o;
      if (!("toJSON" in o)) {
        t[n] = o;
        const r = sn(o) ? [] : {};
        return sr(o, (i, s) => {
          const l = a(i, n + 1);
          !Qo(l) && (r[s] = l);
        }), t[n] = void 0, r;
      }
    }
    return o;
  };
  return a(e, 0);
}, hEe = Bt("AsyncFunction"), mEe = (e) => e && (ir(e) || ht(e)) && ht(e.then) && ht(e.catch), tw = ((e, t) => e ? setImmediate : t ? ((a, o) => (Ja.addEventListener("message", ({ source: n, data: r }) => {
  n === Ja && r === a && o.length && o.shift()();
}, !1), (n) => {
  o.push(n), Ja.postMessage(a, "*");
}))(`axios@${Math.random()}`, []) : (a) => setTimeout(a))(
  typeof setImmediate == "function",
  ht(Ja.postMessage)
), pEe = typeof queueMicrotask < "u" ? queueMicrotask.bind(Ja) : typeof process < "u" && process.nextTick || tw, fEe = (e) => e != null && ht(e[Ns]), D = {
  isArray: sn,
  isArrayBuffer: Zy,
  isBuffer: rr,
  isFormData: FCe,
  isArrayBufferView: DCe,
  isString: NCe,
  isNumber: Yy,
  isBoolean: RCe,
  isObject: ir,
  isPlainObject: ci,
  isEmptyObject: ICe,
  isReadableStream: UCe,
  isRequest: qCe,
  isResponse: HCe,
  isHeaders: GCe,
  isUndefined: Qo,
  isDate: TCe,
  isFile: MCe,
  isBlob: LCe,
  isRegExp: iEe,
  isFunction: ht,
  isStream: BCe,
  isURLSearchParams: VCe,
  isTypedArray: tEe,
  isFileList: WCe,
  forEach: sr,
  merge: Ic,
  extend: JCe,
  trim: KCe,
  stripBOM: ZCe,
  inherits: YCe,
  toFlatObject: XCe,
  kindOf: Rs,
  kindOfTest: Bt,
  endsWith: QCe,
  toArray: eEe,
  forEachEntry: aEe,
  matchAll: oEe,
  isHTMLForm: nEe,
  hasOwnProperty: Cm,
  hasOwnProp: Cm,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: ew,
  freezeMethods: sEe,
  toObjectSet: lEe,
  toCamelCase: rEe,
  noop: cEe,
  toFiniteNumber: uEe,
  findKey: Xy,
  global: Ja,
  isContextDefined: Qy,
  isSpecCompliantForm: dEe,
  toJSONObject: gEe,
  isAsyncFn: hEe,
  isThenable: mEe,
  setImmediate: tw,
  asap: pEe,
  isIterable: fEe
};
function he(e, t, a, o, n) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = e, this.name = "AxiosError", t && (this.code = t), a && (this.config = a), o && (this.request = o), n && (this.response = n, this.status = n.status ? n.status : null);
}
D.inherits(he, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: D.toJSONObject(this.config),
      code: this.code,
      status: this.status
    };
  }
});
const aw = he.prototype, ow = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((e) => {
  ow[e] = { value: e };
});
Object.defineProperties(he, ow);
Object.defineProperty(aw, "isAxiosError", { value: !0 });
he.from = (e, t, a, o, n, r) => {
  const i = Object.create(aw);
  D.toFlatObject(e, i, function(c) {
    return c !== Error.prototype;
  }, (c) => c !== "isAxiosError");
  const s = e && e.message ? e.message : "Error", l = t == null && e ? e.code : t;
  return he.call(i, s, l, a, o, n), e && i.cause == null && Object.defineProperty(i, "cause", { value: e, configurable: !0 }), i.name = e && e.name || "Error", r && Object.assign(i, r), i;
};
const bEe = null;
function Tc(e) {
  return D.isPlainObject(e) || D.isArray(e);
}
function nw(e) {
  return D.endsWith(e, "[]") ? e.slice(0, -2) : e;
}
function Em(e, t, a) {
  return e ? e.concat(t).map(function(o, n) {
    return o = nw(o), !a && n ? "[" + o + "]" : o;
  }).join(a ? "." : "") : t;
}
function _Ee(e) {
  return D.isArray(e) && !e.some(Tc);
}
const vEe = D.toFlatObject(D, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Ts(e, t, a) {
  if (!D.isObject(e))
    throw new TypeError("target must be an object");
  t = t || new FormData(), a = D.toFlatObject(a, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(p, f) {
    return !D.isUndefined(f[p]);
  });
  const o = a.metaTokens, n = a.visitor || c, r = a.dots, i = a.indexes, s = (a.Blob || typeof Blob < "u" && Blob) && D.isSpecCompliantForm(t);
  if (!D.isFunction(n))
    throw new TypeError("visitor must be a function");
  function l(p) {
    if (p === null) return "";
    if (D.isDate(p))
      return p.toISOString();
    if (D.isBoolean(p))
      return p.toString();
    if (!s && D.isBlob(p))
      throw new he("Blob is not supported. Use a Buffer instead.");
    return D.isArrayBuffer(p) || D.isTypedArray(p) ? s && typeof Blob == "function" ? new Blob([p]) : Buffer.from(p) : p;
  }
  function c(p, f, m) {
    let b = p;
    if (p && !m && typeof p == "object") {
      if (D.endsWith(f, "{}"))
        f = o ? f : f.slice(0, -2), p = JSON.stringify(p);
      else if (D.isArray(p) && _Ee(p) || (D.isFileList(p) || D.endsWith(f, "[]")) && (b = D.toArray(p)))
        return f = nw(f), b.forEach(function(w, _) {
          !(D.isUndefined(w) || w === null) && t.append(
            // eslint-disable-next-line no-nested-ternary
            i === !0 ? Em([f], _, r) : i === null ? f : f + "[]",
            l(w)
          );
        }), !1;
    }
    return Tc(p) ? !0 : (t.append(Em(m, f, r), l(p)), !1);
  }
  const u = [], d = Object.assign(vEe, {
    defaultVisitor: c,
    convertValue: l,
    isVisitable: Tc
  });
  function h(p, f) {
    if (!D.isUndefined(p)) {
      if (u.indexOf(p) !== -1)
        throw Error("Circular reference detected in " + f.join("."));
      u.push(p), D.forEach(p, function(m, b) {
        (!(D.isUndefined(m) || m === null) && n.call(
          t,
          m,
          D.isString(b) ? b.trim() : b,
          f,
          d
        )) === !0 && h(m, f ? f.concat(b) : [b]);
      }), u.pop();
    }
  }
  if (!D.isObject(e))
    throw new TypeError("data must be an object");
  return h(e), t;
}
function zm(e) {
  const t = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(e).replace(/[!'()~]|%20|%00/g, function(a) {
    return t[a];
  });
}
function yd(e, t) {
  this._pairs = [], e && Ts(e, this, t);
}
const rw = yd.prototype;
rw.append = function(e, t) {
  this._pairs.push([e, t]);
};
rw.toString = function(e) {
  const t = e ? function(a) {
    return e.call(this, a, zm);
  } : zm;
  return this._pairs.map(function(a) {
    return t(a[0]) + "=" + t(a[1]);
  }, "").join("&");
};
function yEe(e) {
  return encodeURIComponent(e).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+");
}
function iw(e, t, a) {
  if (!t)
    return e;
  const o = a && a.encode || yEe;
  D.isFunction(a) && (a = {
    serialize: a
  });
  const n = a && a.serialize;
  let r;
  if (n ? r = n(t, a) : r = D.isURLSearchParams(t) ? t.toString() : new yd(t, a).toString(o), r) {
    const i = e.indexOf("#");
    i !== -1 && (e = e.slice(0, i)), e += (e.indexOf("?") === -1 ? "?" : "&") + r;
  }
  return e;
}
let jm = class {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(t, a, o) {
    return this.handlers.push({
      fulfilled: t,
      rejected: a,
      synchronous: o ? o.synchronous : !1,
      runWhen: o ? o.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(t) {
    this.handlers[t] && (this.handlers[t] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(t) {
    D.forEach(this.handlers, function(a) {
      a !== null && t(a);
    });
  }
};
const sw = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, wEe = typeof URLSearchParams < "u" ? URLSearchParams : yd, kEe = typeof FormData < "u" ? FormData : null, xEe = typeof Blob < "u" ? Blob : null, $Ee = {
  isBrowser: !0,
  classes: {
    URLSearchParams: wEe,
    FormData: kEe,
    Blob: xEe
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
}, wd = typeof window < "u" && typeof document < "u", Mc = typeof navigator == "object" && navigator || void 0, SEe = wd && (!Mc || ["ReactNative", "NativeScript", "NS"].indexOf(Mc.product) < 0), CEe = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", EEe = wd && window.location.href || "http://localhost", zEe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  hasBrowserEnv: wd,
  hasStandardBrowserEnv: SEe,
  hasStandardBrowserWebWorkerEnv: CEe,
  navigator: Mc,
  origin: EEe
}, Symbol.toStringTag, { value: "Module" })), at = {
  ...zEe,
  ...$Ee
};
function jEe(e, t) {
  return Ts(e, new at.classes.URLSearchParams(), {
    visitor: function(a, o, n, r) {
      return at.isNode && D.isBuffer(a) ? (this.append(o, a.toString("base64")), !1) : r.defaultVisitor.apply(this, arguments);
    },
    ...t
  });
}
function AEe(e) {
  return D.matchAll(/\w+|\[(\w*)]/g, e).map((t) => t[0] === "[]" ? "" : t[1] || t[0]);
}
function OEe(e) {
  const t = {}, a = Object.keys(e);
  let o;
  const n = a.length;
  let r;
  for (o = 0; o < n; o++)
    r = a[o], t[r] = e[r];
  return t;
}
function lw(e) {
  function t(a, o, n, r) {
    let i = a[r++];
    if (i === "__proto__") return !0;
    const s = Number.isFinite(+i), l = r >= a.length;
    return i = !i && D.isArray(n) ? n.length : i, l ? (D.hasOwnProp(n, i) ? n[i] = [n[i], o] : n[i] = o, !s) : ((!n[i] || !D.isObject(n[i])) && (n[i] = []), t(a, o, n[i], r) && D.isArray(n[i]) && (n[i] = OEe(n[i])), !s);
  }
  if (D.isFormData(e) && D.isFunction(e.entries)) {
    const a = {};
    return D.forEachEntry(e, (o, n) => {
      t(AEe(o), n, a, 0);
    }), a;
  }
  return null;
}
function PEe(e, t, a) {
  if (D.isString(e))
    try {
      return (t || JSON.parse)(e), D.trim(e);
    } catch (o) {
      if (o.name !== "SyntaxError")
        throw o;
    }
  return (a || JSON.stringify)(e);
}
const lr = {
  transitional: sw,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, t) {
    const a = t.getContentType() || "", o = a.indexOf("application/json") > -1, n = D.isObject(e);
    if (n && D.isHTMLForm(e) && (e = new FormData(e)), D.isFormData(e))
      return o ? JSON.stringify(lw(e)) : e;
    if (D.isArrayBuffer(e) || D.isBuffer(e) || D.isStream(e) || D.isFile(e) || D.isBlob(e) || D.isReadableStream(e))
      return e;
    if (D.isArrayBufferView(e))
      return e.buffer;
    if (D.isURLSearchParams(e))
      return t.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let r;
    if (n) {
      if (a.indexOf("application/x-www-form-urlencoded") > -1)
        return jEe(e, this.formSerializer).toString();
      if ((r = D.isFileList(e)) || a.indexOf("multipart/form-data") > -1) {
        const i = this.env && this.env.FormData;
        return Ts(
          r ? { "files[]": e } : e,
          i && new i(),
          this.formSerializer
        );
      }
    }
    return n || o ? (t.setContentType("application/json", !1), PEe(e)) : e;
  }],
  transformResponse: [function(e) {
    const t = this.transitional || lr.transitional, a = t && t.forcedJSONParsing, o = this.responseType === "json";
    if (D.isResponse(e) || D.isReadableStream(e))
      return e;
    if (e && D.isString(e) && (a && !this.responseType || o)) {
      const n = !(t && t.silentJSONParsing) && o;
      try {
        return JSON.parse(e, this.parseReviver);
      } catch (r) {
        if (n)
          throw r.name === "SyntaxError" ? he.from(r, he.ERR_BAD_RESPONSE, this, null, this.response) : r;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: at.classes.FormData,
    Blob: at.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
D.forEach(["delete", "get", "head", "post", "put", "patch"], (e) => {
  lr.headers[e] = {};
});
const DEe = D.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]), NEe = (e) => {
  const t = {};
  let a, o, n;
  return e && e.split(`
`).forEach(function(r) {
    n = r.indexOf(":"), a = r.substring(0, n).trim().toLowerCase(), o = r.substring(n + 1).trim(), !(!a || t[a] && DEe[a]) && (a === "set-cookie" ? t[a] ? t[a].push(o) : t[a] = [o] : t[a] = t[a] ? t[a] + ", " + o : o);
  }), t;
}, Am = Symbol("internals");
function kn(e) {
  return e && String(e).trim().toLowerCase();
}
function ui(e) {
  return e === !1 || e == null ? e : D.isArray(e) ? e.map(ui) : String(e);
}
function REe(e) {
  const t = /* @__PURE__ */ Object.create(null), a = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let o;
  for (; o = a.exec(e); )
    t[o[1]] = o[2];
  return t;
}
const IEe = (e) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(e.trim());
function Nl(e, t, a, o, n) {
  if (D.isFunction(o))
    return o.call(this, t, a);
  if (n && (t = a), !!D.isString(t)) {
    if (D.isString(o))
      return t.indexOf(o) !== -1;
    if (D.isRegExp(o))
      return o.test(t);
  }
}
function TEe(e) {
  return e.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (t, a, o) => a.toUpperCase() + o);
}
function MEe(e, t) {
  const a = D.toCamelCase(" " + t);
  ["get", "set", "has"].forEach((o) => {
    Object.defineProperty(e, o + a, {
      value: function(n, r, i) {
        return this[o].call(this, t, n, r, i);
      },
      configurable: !0
    });
  });
}
let mt = class {
  constructor(e) {
    e && this.set(e);
  }
  set(e, t, a) {
    const o = this;
    function n(i, s, l) {
      const c = kn(s);
      if (!c)
        throw new Error("header name must be a non-empty string");
      const u = D.findKey(o, c);
      (!u || o[u] === void 0 || l === !0 || l === void 0 && o[u] !== !1) && (o[u || s] = ui(i));
    }
    const r = (i, s) => D.forEach(i, (l, c) => n(l, c, s));
    if (D.isPlainObject(e) || e instanceof this.constructor)
      r(e, t);
    else if (D.isString(e) && (e = e.trim()) && !IEe(e))
      r(NEe(e), t);
    else if (D.isObject(e) && D.isIterable(e)) {
      let i = {}, s, l;
      for (const c of e) {
        if (!D.isArray(c))
          throw TypeError("Object iterator must return a key-value pair");
        i[l = c[0]] = (s = i[l]) ? D.isArray(s) ? [...s, c[1]] : [s, c[1]] : c[1];
      }
      r(i, t);
    } else
      e != null && n(t, e, a);
    return this;
  }
  get(e, t) {
    if (e = kn(e), e) {
      const a = D.findKey(this, e);
      if (a) {
        const o = this[a];
        if (!t)
          return o;
        if (t === !0)
          return REe(o);
        if (D.isFunction(t))
          return t.call(this, o, a);
        if (D.isRegExp(t))
          return t.exec(o);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, t) {
    if (e = kn(e), e) {
      const a = D.findKey(this, e);
      return !!(a && this[a] !== void 0 && (!t || Nl(this, this[a], a, t)));
    }
    return !1;
  }
  delete(e, t) {
    const a = this;
    let o = !1;
    function n(r) {
      if (r = kn(r), r) {
        const i = D.findKey(a, r);
        i && (!t || Nl(a, a[i], i, t)) && (delete a[i], o = !0);
      }
    }
    return D.isArray(e) ? e.forEach(n) : n(e), o;
  }
  clear(e) {
    const t = Object.keys(this);
    let a = t.length, o = !1;
    for (; a--; ) {
      const n = t[a];
      (!e || Nl(this, this[n], n, e, !0)) && (delete this[n], o = !0);
    }
    return o;
  }
  normalize(e) {
    const t = this, a = {};
    return D.forEach(this, (o, n) => {
      const r = D.findKey(a, n);
      if (r) {
        t[r] = ui(o), delete t[n];
        return;
      }
      const i = e ? TEe(n) : String(n).trim();
      i !== n && delete t[n], t[i] = ui(o), a[i] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const t = /* @__PURE__ */ Object.create(null);
    return D.forEach(this, (a, o) => {
      a != null && a !== !1 && (t[o] = e && D.isArray(a) ? a.join(", ") : a);
    }), t;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, t]) => e + ": " + t).join(`
`);
  }
  getSetCookie() {
    return this.get("set-cookie") || [];
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...t) {
    const a = new this(e);
    return t.forEach((o) => a.set(o)), a;
  }
  static accessor(e) {
    const t = (this[Am] = this[Am] = {
      accessors: {}
    }).accessors, a = this.prototype;
    function o(n) {
      const r = kn(n);
      t[r] || (MEe(a, n), t[r] = !0);
    }
    return D.isArray(e) ? e.forEach(o) : o(e), this;
  }
};
mt.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
D.reduceDescriptors(mt.prototype, ({ value: e }, t) => {
  let a = t[0].toUpperCase() + t.slice(1);
  return {
    get: () => e,
    set(o) {
      this[a] = o;
    }
  };
});
D.freezeMethods(mt);
function Rl(e, t) {
  const a = this || lr, o = t || a, n = mt.from(o.headers);
  let r = o.data;
  return D.forEach(e, function(i) {
    r = i.call(a, r, n.normalize(), t ? t.status : void 0);
  }), n.normalize(), r;
}
function cw(e) {
  return !!(e && e.__CANCEL__);
}
function ln(e, t, a) {
  he.call(this, e ?? "canceled", he.ERR_CANCELED, t, a), this.name = "CanceledError";
}
D.inherits(ln, he, {
  __CANCEL__: !0
});
function uw(e, t, a) {
  const o = a.config.validateStatus;
  !a.status || !o || o(a.status) ? e(a) : t(new he(
    "Request failed with status code " + a.status,
    [he.ERR_BAD_REQUEST, he.ERR_BAD_RESPONSE][Math.floor(a.status / 100) - 4],
    a.config,
    a.request,
    a
  ));
}
function LEe(e) {
  const t = /^([-+\w]{1,25})(:?\/\/|:)/.exec(e);
  return t && t[1] || "";
}
function WEe(e, t) {
  e = e || 10;
  const a = new Array(e), o = new Array(e);
  let n = 0, r = 0, i;
  return t = t !== void 0 ? t : 1e3, function(s) {
    const l = Date.now(), c = o[r];
    i || (i = l), a[n] = s, o[n] = l;
    let u = r, d = 0;
    for (; u !== n; )
      d += a[u++], u = u % e;
    if (n = (n + 1) % e, n === r && (r = (r + 1) % e), l - i < t)
      return;
    const h = c && l - c;
    return h ? Math.round(d * 1e3 / h) : void 0;
  };
}
function BEe(e, t) {
  let a = 0, o = 1e3 / t, n, r;
  const i = (s, l = Date.now()) => {
    a = l, n = null, r && (clearTimeout(r), r = null), e(...s);
  };
  return [(...s) => {
    const l = Date.now(), c = l - a;
    c >= o ? i(s, l) : (n = s, r || (r = setTimeout(() => {
      r = null, i(n);
    }, o - c)));
  }, () => n && i(n)];
}
const Vi = (e, t, a = 3) => {
  let o = 0;
  const n = WEe(50, 250);
  return BEe((r) => {
    const i = r.loaded, s = r.lengthComputable ? r.total : void 0, l = i - o, c = n(l), u = i <= s;
    o = i;
    const d = {
      loaded: i,
      total: s,
      progress: s ? i / s : void 0,
      bytes: l,
      rate: c || void 0,
      estimated: c && s && u ? (s - i) / c : void 0,
      event: r,
      lengthComputable: s != null,
      [t ? "download" : "upload"]: !0
    };
    e(d);
  }, a);
}, Om = (e, t) => {
  const a = e != null;
  return [(o) => t[0]({
    lengthComputable: a,
    total: e,
    loaded: o
  }), t[1]];
}, Pm = (e) => (...t) => D.asap(() => e(...t)), FEe = at.hasStandardBrowserEnv ? /* @__PURE__ */ ((e, t) => (a) => (a = new URL(a, at.origin), e.protocol === a.protocol && e.host === a.host && (t || e.port === a.port)))(
  new URL(at.origin),
  at.navigator && /(msie|trident)/i.test(at.navigator.userAgent)
) : () => !0, VEe = at.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(e, t, a, o, n, r) {
      const i = [e + "=" + encodeURIComponent(t)];
      D.isNumber(a) && i.push("expires=" + new Date(a).toGMTString()), D.isString(o) && i.push("path=" + o), D.isString(n) && i.push("domain=" + n), r === !0 && i.push("secure"), document.cookie = i.join("; ");
    },
    read(e) {
      const t = document.cookie.match(new RegExp("(^|;\\s*)(" + e + ")=([^;]*)"));
      return t ? decodeURIComponent(t[3]) : null;
    },
    remove(e) {
      this.write(e, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function UEe(e) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(e);
}
function qEe(e, t) {
  return t ? e.replace(/\/?\/$/, "") + "/" + t.replace(/^\/+/, "") : e;
}
function dw(e, t, a) {
  let o = !UEe(t);
  return e && (o || a == !1) ? qEe(e, t) : t;
}
const Dm = (e) => e instanceof mt ? { ...e } : e;
function io(e, t) {
  t = t || {};
  const a = {};
  function o(c, u, d, h) {
    return D.isPlainObject(c) && D.isPlainObject(u) ? D.merge.call({ caseless: h }, c, u) : D.isPlainObject(u) ? D.merge({}, u) : D.isArray(u) ? u.slice() : u;
  }
  function n(c, u, d, h) {
    if (D.isUndefined(u)) {
      if (!D.isUndefined(c))
        return o(void 0, c, d, h);
    } else return o(c, u, d, h);
  }
  function r(c, u) {
    if (!D.isUndefined(u))
      return o(void 0, u);
  }
  function i(c, u) {
    if (D.isUndefined(u)) {
      if (!D.isUndefined(c))
        return o(void 0, c);
    } else return o(void 0, u);
  }
  function s(c, u, d) {
    if (d in t)
      return o(c, u);
    if (d in e)
      return o(void 0, c);
  }
  const l = {
    url: r,
    method: r,
    data: r,
    baseURL: i,
    transformRequest: i,
    transformResponse: i,
    paramsSerializer: i,
    timeout: i,
    timeoutMessage: i,
    withCredentials: i,
    withXSRFToken: i,
    adapter: i,
    responseType: i,
    xsrfCookieName: i,
    xsrfHeaderName: i,
    onUploadProgress: i,
    onDownloadProgress: i,
    decompress: i,
    maxContentLength: i,
    maxBodyLength: i,
    beforeRedirect: i,
    transport: i,
    httpAgent: i,
    httpsAgent: i,
    cancelToken: i,
    socketPath: i,
    responseEncoding: i,
    validateStatus: s,
    headers: (c, u, d) => n(Dm(c), Dm(u), d, !0)
  };
  return D.forEach(Object.keys({ ...e, ...t }), function(c) {
    const u = l[c] || n, d = u(e[c], t[c], c);
    D.isUndefined(d) && u !== s || (a[c] = d);
  }), a;
}
const gw = (e) => {
  const t = io({}, e);
  let { data: a, withXSRFToken: o, xsrfHeaderName: n, xsrfCookieName: r, headers: i, auth: s } = t;
  if (t.headers = i = mt.from(i), t.url = iw(dw(t.baseURL, t.url, t.allowAbsoluteUrls), e.params, e.paramsSerializer), s && i.set(
    "Authorization",
    "Basic " + btoa((s.username || "") + ":" + (s.password ? unescape(encodeURIComponent(s.password)) : ""))
  ), D.isFormData(a)) {
    if (at.hasStandardBrowserEnv || at.hasStandardBrowserWebWorkerEnv)
      i.setContentType(void 0);
    else if (D.isFunction(a.getHeaders)) {
      const l = a.getHeaders(), c = ["content-type", "content-length"];
      Object.entries(l).forEach(([u, d]) => {
        c.includes(u.toLowerCase()) && i.set(u, d);
      });
    }
  }
  if (at.hasStandardBrowserEnv && (o && D.isFunction(o) && (o = o(t)), o || o !== !1 && FEe(t.url))) {
    const l = n && r && VEe.read(r);
    l && i.set(n, l);
  }
  return t;
}, HEe = typeof XMLHttpRequest < "u", GEe = HEe && function(e) {
  return new Promise(function(t, a) {
    const o = gw(e);
    let n = o.data;
    const r = mt.from(o.headers).normalize();
    let { responseType: i, onUploadProgress: s, onDownloadProgress: l } = o, c, u, d, h, p;
    function f() {
      h && h(), p && p(), o.cancelToken && o.cancelToken.unsubscribe(c), o.signal && o.signal.removeEventListener("abort", c);
    }
    let m = new XMLHttpRequest();
    m.open(o.method.toUpperCase(), o.url, !0), m.timeout = o.timeout;
    function b() {
      if (!m)
        return;
      const _ = mt.from(
        "getAllResponseHeaders" in m && m.getAllResponseHeaders()
      ), y = {
        data: !i || i === "text" || i === "json" ? m.responseText : m.response,
        status: m.status,
        statusText: m.statusText,
        headers: _,
        config: e,
        request: m
      };
      uw(function(k) {
        t(k), f();
      }, function(k) {
        a(k), f();
      }, y), m = null;
    }
    "onloadend" in m ? m.onloadend = b : m.onreadystatechange = function() {
      !m || m.readyState !== 4 || m.status === 0 && !(m.responseURL && m.responseURL.indexOf("file:") === 0) || setTimeout(b);
    }, m.onabort = function() {
      m && (a(new he("Request aborted", he.ECONNABORTED, e, m)), m = null);
    }, m.onerror = function(_) {
      const y = _ && _.message ? _.message : "Network Error", k = new he(y, he.ERR_NETWORK, e, m);
      k.event = _ || null, a(k), m = null;
    }, m.ontimeout = function() {
      let _ = o.timeout ? "timeout of " + o.timeout + "ms exceeded" : "timeout exceeded";
      const y = o.transitional || sw;
      o.timeoutErrorMessage && (_ = o.timeoutErrorMessage), a(new he(
        _,
        y.clarifyTimeoutError ? he.ETIMEDOUT : he.ECONNABORTED,
        e,
        m
      )), m = null;
    }, n === void 0 && r.setContentType(null), "setRequestHeader" in m && D.forEach(r.toJSON(), function(_, y) {
      m.setRequestHeader(y, _);
    }), D.isUndefined(o.withCredentials) || (m.withCredentials = !!o.withCredentials), i && i !== "json" && (m.responseType = o.responseType), l && ([d, p] = Vi(l, !0), m.addEventListener("progress", d)), s && m.upload && ([u, h] = Vi(s), m.upload.addEventListener("progress", u), m.upload.addEventListener("loadend", h)), (o.cancelToken || o.signal) && (c = (_) => {
      m && (a(!_ || _.type ? new ln(null, e, m) : _), m.abort(), m = null);
    }, o.cancelToken && o.cancelToken.subscribe(c), o.signal && (o.signal.aborted ? c() : o.signal.addEventListener("abort", c)));
    const w = LEe(o.url);
    if (w && at.protocols.indexOf(w) === -1) {
      a(new he("Unsupported protocol " + w + ":", he.ERR_BAD_REQUEST, e));
      return;
    }
    m.send(n || null);
  });
}, KEe = (e, t) => {
  const { length: a } = e = e ? e.filter(Boolean) : [];
  if (t || a) {
    let o = new AbortController(), n;
    const r = function(c) {
      if (!n) {
        n = !0, s();
        const u = c instanceof Error ? c : this.reason;
        o.abort(u instanceof he ? u : new ln(u instanceof Error ? u.message : u));
      }
    };
    let i = t && setTimeout(() => {
      i = null, r(new he(`timeout ${t} of ms exceeded`, he.ETIMEDOUT));
    }, t);
    const s = () => {
      e && (i && clearTimeout(i), i = null, e.forEach((c) => {
        c.unsubscribe ? c.unsubscribe(r) : c.removeEventListener("abort", r);
      }), e = null);
    };
    e.forEach((c) => c.addEventListener("abort", r));
    const { signal: l } = o;
    return l.unsubscribe = () => D.asap(s), l;
  }
}, JEe = function* (e, t) {
  let a = e.byteLength;
  if (a < t) {
    yield e;
    return;
  }
  let o = 0, n;
  for (; o < a; )
    n = o + t, yield e.slice(o, n), o = n;
}, ZEe = async function* (e, t) {
  for await (const a of YEe(e))
    yield* JEe(a, t);
}, YEe = async function* (e) {
  if (e[Symbol.asyncIterator]) {
    yield* e;
    return;
  }
  const t = e.getReader();
  try {
    for (; ; ) {
      const { done: a, value: o } = await t.read();
      if (a)
        break;
      yield o;
    }
  } finally {
    await t.cancel();
  }
}, Nm = (e, t, a, o) => {
  const n = ZEe(e, t);
  let r = 0, i, s = (l) => {
    i || (i = !0, o && o(l));
  };
  return new ReadableStream({
    async pull(l) {
      try {
        const { done: c, value: u } = await n.next();
        if (c) {
          s(), l.close();
          return;
        }
        let d = u.byteLength;
        if (a) {
          let h = r += d;
          a(h);
        }
        l.enqueue(new Uint8Array(u));
      } catch (c) {
        throw s(c), c;
      }
    },
    cancel(l) {
      return s(l), n.return();
    }
  }, {
    highWaterMark: 2
  });
}, Rm = 64 * 1024, { isFunction: Tr } = D, XEe = (({ Request: e, Response: t }) => ({
  Request: e,
  Response: t
}))(D.global), {
  ReadableStream: Im,
  TextEncoder: Tm
} = D.global, Mm = (e, ...t) => {
  try {
    return !!e(...t);
  } catch {
    return !1;
  }
}, QEe = (e) => {
  e = D.merge.call({
    skipUndefined: !0
  }, XEe, e);
  const { fetch: t, Request: a, Response: o } = e, n = t ? Tr(t) : typeof fetch == "function", r = Tr(a), i = Tr(o);
  if (!n)
    return !1;
  const s = n && Tr(Im), l = n && (typeof Tm == "function" ? /* @__PURE__ */ ((f) => (m) => f.encode(m))(new Tm()) : async (f) => new Uint8Array(await new a(f).arrayBuffer())), c = r && s && Mm(() => {
    let f = !1;
    const m = new a(at.origin, {
      body: new Im(),
      method: "POST",
      get duplex() {
        return f = !0, "half";
      }
    }).headers.has("Content-Type");
    return f && !m;
  }), u = i && s && Mm(() => D.isReadableStream(new o("").body)), d = {
    stream: u && ((f) => f.body)
  };
  n && ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((f) => {
    !d[f] && (d[f] = (m, b) => {
      let w = m && m[f];
      if (w)
        return w.call(m);
      throw new he(`Response type '${f}' is not supported`, he.ERR_NOT_SUPPORT, b);
    });
  });
  const h = async (f) => {
    if (f == null)
      return 0;
    if (D.isBlob(f))
      return f.size;
    if (D.isSpecCompliantForm(f))
      return (await new a(at.origin, {
        method: "POST",
        body: f
      }).arrayBuffer()).byteLength;
    if (D.isArrayBufferView(f) || D.isArrayBuffer(f))
      return f.byteLength;
    if (D.isURLSearchParams(f) && (f = f + ""), D.isString(f))
      return (await l(f)).byteLength;
  }, p = async (f, m) => D.toFiniteNumber(f.getContentLength()) ?? h(m);
  return async (f) => {
    let {
      url: m,
      method: b,
      data: w,
      signal: _,
      cancelToken: y,
      timeout: k,
      onDownloadProgress: x,
      onUploadProgress: S,
      responseType: $,
      headers: E,
      withCredentials: C = "same-origin",
      fetchOptions: z
    } = gw(f), R = t || fetch;
    $ = $ ? ($ + "").toLowerCase() : "text";
    let H = KEe([_, y && y.toAbortSignal()], k), M = null;
    const j = H && H.unsubscribe && (() => {
      H.unsubscribe();
    });
    let U;
    try {
      if (S && c && b !== "get" && b !== "head" && (U = await p(E, w)) !== 0) {
        let A = new a(m, {
          method: "POST",
          body: w,
          duplex: "half"
        }), N;
        if (D.isFormData(w) && (N = A.headers.get("content-type")) && E.setContentType(N), A.body) {
          const [B, W] = Om(
            U,
            Vi(Pm(S))
          );
          w = Nm(A.body, Rm, B, W);
        }
      }
      D.isString(C) || (C = C ? "include" : "omit");
      const I = r && "credentials" in a.prototype, K = {
        ...z,
        signal: H,
        method: b.toUpperCase(),
        headers: E.normalize().toJSON(),
        body: w,
        duplex: "half",
        credentials: I ? C : void 0
      };
      M = r && new a(m, K);
      let q = await (r ? R(M, z) : R(m, K));
      const te = u && ($ === "stream" || $ === "response");
      if (u && (x || te && j)) {
        const A = {};
        ["status", "statusText", "headers"].forEach((Z) => {
          A[Z] = q[Z];
        });
        const N = D.toFiniteNumber(q.headers.get("content-length")), [B, W] = x && Om(
          N,
          Vi(Pm(x), !0)
        ) || [];
        q = new o(
          Nm(q.body, Rm, B, () => {
            W && W(), j && j();
          }),
          A
        );
      }
      $ = $ || "text";
      let O = await d[D.findKey(d, $) || "text"](q, f);
      return !te && j && j(), await new Promise((A, N) => {
        uw(A, N, {
          data: O,
          headers: mt.from(q.headers),
          status: q.status,
          statusText: q.statusText,
          config: f,
          request: M
        });
      });
    } catch (I) {
      throw j && j(), I && I.name === "TypeError" && /Load failed|fetch/i.test(I.message) ? Object.assign(
        new he("Network Error", he.ERR_NETWORK, f, M),
        {
          cause: I.cause || I
        }
      ) : he.from(I, I && I.code, f, M);
    }
  };
}, eze = /* @__PURE__ */ new Map(), hw = (e) => {
  let t = e ? e.env : {};
  const { fetch: a, Request: o, Response: n } = t, r = [
    o,
    n,
    a
  ];
  let i = r.length, s = i, l, c, u = eze;
  for (; s--; )
    l = r[s], c = u.get(l), c === void 0 && u.set(l, c = s ? /* @__PURE__ */ new Map() : QEe(t)), u = c;
  return c;
};
hw();
const Lc = {
  http: bEe,
  xhr: GEe,
  fetch: {
    get: hw
  }
};
D.forEach(Lc, (e, t) => {
  if (e) {
    try {
      Object.defineProperty(e, "name", { value: t });
    } catch {
    }
    Object.defineProperty(e, "adapterName", { value: t });
  }
});
const Lm = (e) => `- ${e}`, tze = (e) => D.isFunction(e) || e === null || e === !1, mw = {
  getAdapter: (e, t) => {
    e = D.isArray(e) ? e : [e];
    const { length: a } = e;
    let o, n;
    const r = {};
    for (let i = 0; i < a; i++) {
      o = e[i];
      let s;
      if (n = o, !tze(o) && (n = Lc[(s = String(o)).toLowerCase()], n === void 0))
        throw new he(`Unknown adapter '${s}'`);
      if (n && (D.isFunction(n) || (n = n.get(t))))
        break;
      r[s || "#" + i] = n;
    }
    if (!n) {
      const i = Object.entries(r).map(
        ([l, c]) => `adapter ${l} ` + (c === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let s = a ? i.length > 1 ? `since :
` + i.map(Lm).join(`
`) : " " + Lm(i[0]) : "as no adapter specified";
      throw new he(
        "There is no suitable adapter to dispatch the request " + s,
        "ERR_NOT_SUPPORT"
      );
    }
    return n;
  },
  adapters: Lc
};
function Il(e) {
  if (e.cancelToken && e.cancelToken.throwIfRequested(), e.signal && e.signal.aborted)
    throw new ln(null, e);
}
function Wm(e) {
  return Il(e), e.headers = mt.from(e.headers), e.data = Rl.call(
    e,
    e.transformRequest
  ), ["post", "put", "patch"].indexOf(e.method) !== -1 && e.headers.setContentType("application/x-www-form-urlencoded", !1), mw.getAdapter(e.adapter || lr.adapter, e)(e).then(function(t) {
    return Il(e), t.data = Rl.call(
      e,
      e.transformResponse,
      t
    ), t.headers = mt.from(t.headers), t;
  }, function(t) {
    return cw(t) || (Il(e), t && t.response && (t.response.data = Rl.call(
      e,
      e.transformResponse,
      t.response
    ), t.response.headers = mt.from(t.response.headers))), Promise.reject(t);
  });
}
const pw = "1.12.2", Ms = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((e, t) => {
  Ms[e] = function(a) {
    return typeof a === e || "a" + (t < 1 ? "n " : " ") + e;
  };
});
const Bm = {};
Ms.transitional = function(e, t, a) {
  function o(n, r) {
    return "[Axios v" + pw + "] Transitional option '" + n + "'" + r + (a ? ". " + a : "");
  }
  return (n, r, i) => {
    if (e === !1)
      throw new he(
        o(r, " has been removed" + (t ? " in " + t : "")),
        he.ERR_DEPRECATED
      );
    return t && !Bm[r] && (Bm[r] = !0, console.warn(
      o(
        r,
        " has been deprecated since v" + t + " and will be removed in the near future"
      )
    )), e ? e(n, r, i) : !0;
  };
};
Ms.spelling = function(e) {
  return (t, a) => (console.warn(`${a} is likely a misspelling of ${e}`), !0);
};
function aze(e, t, a) {
  if (typeof e != "object")
    throw new he("options must be an object", he.ERR_BAD_OPTION_VALUE);
  const o = Object.keys(e);
  let n = o.length;
  for (; n-- > 0; ) {
    const r = o[n], i = t[r];
    if (i) {
      const s = e[r], l = s === void 0 || i(s, r, e);
      if (l !== !0)
        throw new he("option " + r + " must be " + l, he.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (a !== !0)
      throw new he("Unknown option " + r, he.ERR_BAD_OPTION);
  }
}
const di = {
  assertOptions: aze,
  validators: Ms
}, qt = di.validators;
let Qa = class {
  constructor(e) {
    this.defaults = e || {}, this.interceptors = {
      request: new jm(),
      response: new jm()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, t) {
    try {
      return await this._request(e, t);
    } catch (a) {
      if (a instanceof Error) {
        let o = {};
        Error.captureStackTrace ? Error.captureStackTrace(o) : o = new Error();
        const n = o.stack ? o.stack.replace(/^.+\n/, "") : "";
        try {
          a.stack ? n && !String(a.stack).endsWith(n.replace(/^.+\n.+\n/, "")) && (a.stack += `
` + n) : a.stack = n;
        } catch {
        }
      }
      throw a;
    }
  }
  _request(e, t) {
    typeof e == "string" ? (t = t || {}, t.url = e) : t = e || {}, t = io(this.defaults, t);
    const { transitional: a, paramsSerializer: o, headers: n } = t;
    a !== void 0 && di.assertOptions(a, {
      silentJSONParsing: qt.transitional(qt.boolean),
      forcedJSONParsing: qt.transitional(qt.boolean),
      clarifyTimeoutError: qt.transitional(qt.boolean)
    }, !1), o != null && (D.isFunction(o) ? t.paramsSerializer = {
      serialize: o
    } : di.assertOptions(o, {
      encode: qt.function,
      serialize: qt.function
    }, !0)), t.allowAbsoluteUrls !== void 0 || (this.defaults.allowAbsoluteUrls !== void 0 ? t.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls : t.allowAbsoluteUrls = !0), di.assertOptions(t, {
      baseUrl: qt.spelling("baseURL"),
      withXsrfToken: qt.spelling("withXSRFToken")
    }, !0), t.method = (t.method || this.defaults.method || "get").toLowerCase();
    let r = n && D.merge(
      n.common,
      n[t.method]
    );
    n && D.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (p) => {
        delete n[p];
      }
    ), t.headers = mt.concat(r, n);
    const i = [];
    let s = !0;
    this.interceptors.request.forEach(function(p) {
      typeof p.runWhen == "function" && p.runWhen(t) === !1 || (s = s && p.synchronous, i.unshift(p.fulfilled, p.rejected));
    });
    const l = [];
    this.interceptors.response.forEach(function(p) {
      l.push(p.fulfilled, p.rejected);
    });
    let c, u = 0, d;
    if (!s) {
      const p = [Wm.bind(this), void 0];
      for (p.unshift(...i), p.push(...l), d = p.length, c = Promise.resolve(t); u < d; )
        c = c.then(p[u++], p[u++]);
      return c;
    }
    d = i.length;
    let h = t;
    for (; u < d; ) {
      const p = i[u++], f = i[u++];
      try {
        h = p(h);
      } catch (m) {
        f.call(this, m);
        break;
      }
    }
    try {
      c = Wm.call(this, h);
    } catch (p) {
      return Promise.reject(p);
    }
    for (u = 0, d = l.length; u < d; )
      c = c.then(l[u++], l[u++]);
    return c;
  }
  getUri(e) {
    e = io(this.defaults, e);
    const t = dw(e.baseURL, e.url, e.allowAbsoluteUrls);
    return iw(t, e.params, e.paramsSerializer);
  }
};
D.forEach(["delete", "get", "head", "options"], function(e) {
  Qa.prototype[e] = function(t, a) {
    return this.request(io(a || {}, {
      method: e,
      url: t,
      data: (a || {}).data
    }));
  };
});
D.forEach(["post", "put", "patch"], function(e) {
  function t(a) {
    return function(o, n, r) {
      return this.request(io(r || {}, {
        method: e,
        headers: a ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: o,
        data: n
      }));
    };
  }
  Qa.prototype[e] = t(), Qa.prototype[e + "Form"] = t(!0);
});
let oze = class fw {
  constructor(t) {
    if (typeof t != "function")
      throw new TypeError("executor must be a function.");
    let a;
    this.promise = new Promise(function(n) {
      a = n;
    });
    const o = this;
    this.promise.then((n) => {
      if (!o._listeners) return;
      let r = o._listeners.length;
      for (; r-- > 0; )
        o._listeners[r](n);
      o._listeners = null;
    }), this.promise.then = (n) => {
      let r;
      const i = new Promise((s) => {
        o.subscribe(s), r = s;
      }).then(n);
      return i.cancel = function() {
        o.unsubscribe(r);
      }, i;
    }, t(function(n, r, i) {
      o.reason || (o.reason = new ln(n, r, i), a(o.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(t) {
    if (this.reason) {
      t(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(t) : this._listeners = [t];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(t) {
    if (!this._listeners)
      return;
    const a = this._listeners.indexOf(t);
    a !== -1 && this._listeners.splice(a, 1);
  }
  toAbortSignal() {
    const t = new AbortController(), a = (o) => {
      t.abort(o);
    };
    return this.subscribe(a), t.signal.unsubscribe = () => this.unsubscribe(a), t.signal;
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let t;
    return {
      token: new fw(function(a) {
        t = a;
      }),
      cancel: t
    };
  }
};
function nze(e) {
  return function(t) {
    return e.apply(null, t);
  };
}
function rze(e) {
  return D.isObject(e) && e.isAxiosError === !0;
}
const Wc = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(Wc).forEach(([e, t]) => {
  Wc[t] = e;
});
function bw(e) {
  const t = new Qa(e), a = Ky(Qa.prototype.request, t);
  return D.extend(a, Qa.prototype, t, { allOwnKeys: !0 }), D.extend(a, t, null, { allOwnKeys: !0 }), a.create = function(o) {
    return bw(io(e, o));
  }, a;
}
const Fe = bw(lr);
Fe.Axios = Qa;
Fe.CanceledError = ln;
Fe.CancelToken = oze;
Fe.isCancel = cw;
Fe.VERSION = pw;
Fe.toFormData = Ts;
Fe.AxiosError = he;
Fe.Cancel = Fe.CanceledError;
Fe.all = function(e) {
  return Promise.all(e);
};
Fe.spread = nze;
Fe.isAxiosError = rze;
Fe.mergeConfig = io;
Fe.AxiosHeaders = mt;
Fe.formToJSON = (e) => lw(D.isHTMLForm(e) ? new FormData(e) : e);
Fe.getAdapter = mw.getAdapter;
Fe.HttpStatusCode = Wc;
Fe.default = Fe;
const {
  Axios: Yrt,
  AxiosError: ize,
  CanceledError: Xrt,
  isCancel: Qrt,
  CancelToken: eit,
  VERSION: tit,
  all: ait,
  Cancel: oit,
  isAxiosError: nit,
  spread: rit,
  toFormData: iit,
  AxiosHeaders: sit,
  HttpStatusCode: lit,
  formToJSON: cit,
  getAdapter: uit,
  mergeConfig: dit
} = Fe, sze = /^https?:\/\/(?:www\.)?[-a-zA-Z0-9@:%._+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b(?:[-a-zA-Z0-9()@:%_,+.~#?&/=]*)$/;
class lze {
  baseUrl;
  headers;
  constructor(t, a = {}) {
    this.baseUrl = t, this.headers = a?.headers || {};
  }
  async fetch(t, a = "GET", o = {}) {
    if (!this.baseUrl)
      throw new Error("No base URL set");
    const n = sze.test(t) ? t : `${this.baseUrl}${t}`;
    n.includes(this.baseUrl) && (o.withCredentials = !0);
    try {
      return (await Fe(n, {
        ...o,
        method: a,
        data: o.data,
        headers: { ...this.headers, ...o.headers },
        withCredentials: o.withCredentials
      })).data;
    } catch (r) {
      throw r instanceof ize ? new Sm(`${r.code} - ${r.status} - ${n}`, r.status, r.response?.data) : new Sm("An error occured while fetching");
    }
  }
  getBaseUrl() {
    return this.baseUrl;
  }
  setBaseUrl(t) {
    this.baseUrl = t;
  }
  async get(t, a = {}) {
    return this.fetch(t, "GET", a);
  }
  async post(t, a = {}) {
    return this.fetch(t, "POST", {
      ...a,
      headers: {
        "Content-Type": "application/json",
        ...a.headers
      }
    });
  }
  async put(t, a = {}) {
    return this.fetch(t, "PUT", {
      ...a,
      headers: {
        "Content-Type": "application/json",
        ...a.headers
      }
    });
  }
  async delete(t, a = {}) {
    return this.fetch(t, "DELETE", a);
  }
  async patch(t, a = {}) {
    return this.fetch(t, "PATCH", {
      ...a,
      headers: {
        "Content-Type": "application/json",
        ...a.headers
      }
    });
  }
}
let _w;
function cze(e, t = {}) {
  _w = new lze(e, t);
}
jt();
function vw(e) {
  var t, a, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (a = vw(e[t])) && (o && (o += " "), o += a);
  } else for (a in e) e[a] && (o && (o += " "), o += a);
  return o;
}
function It() {
  for (var e, t, a = 0, o = "", n = arguments.length; a < n; a++) (e = arguments[a]) && (t = vw(e)) && (o && (o += " "), o += t);
  return o;
}
const uze = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], dze = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, gze = uze.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: dze[e]
})), hze = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, mze = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function pze(e = 0) {
  const t = [];
  for (let a = 0; a < e; a++)
    t[a] = `path${a + 1}`;
  return t.map((a) => /* @__PURE__ */ v("span", { className: a }, a));
}
const Bn = pt(
  ({ name: e, size: t = "medium", color: a = "base", className: o = "", ...n }, r) => {
    const i = gze.find((l) => l.name === e), s = It("icon", `ds-${i?.class}`, mze[t], hze[a], o);
    return /* @__PURE__ */ v("i", { className: s, ...n, ref: r, children: pze(i?.paths) });
  }
);
Bn.displayName = "Icon";
const fze = "_loader_1ksyv_29", bze = "_circle_1ksyv_41", Oo = {
  loader: fze,
  "is-small": "_is-small_1ksyv_29",
  "is-medium": "_is-medium_1ksyv_33",
  "is-large": "_is-large_1ksyv_37",
  circle: bze,
  "moving-element": "_moving-element_1ksyv_44",
  "on-dark": "_on-dark_1ksyv_47",
  "is-secondary": "_is-secondary_1ksyv_53",
  "dialog-overlay-show": "_dialog-overlay-show_1ksyv_1",
  "dialog-content-show": "_dialog-content-show_1ksyv_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ksyv_1"
}, _ze = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large"
}, vze = {
  primary: "is-primary",
  secondary: "is-secondary"
};
function yze({ onDark: e, size: t = "medium", color: a = "primary", className: o }) {
  return /* @__PURE__ */ T(
    "svg",
    {
      className: It(
        Oo.loader,
        Oo[_ze[t]],
        Oo[vze[a]],
        e && Oo["on-dark"],
        o
      ),
      xmlns: "http://www.w3.org/2000/svg",
      viewBox: "0 0 100 100",
      preserveAspectRatio: "xMidYMid",
      children: [
        /* @__PURE__ */ v("rect", { width: "100", height: "100", fill: "none", className: "bk" }),
        /* @__PURE__ */ v("circle", { className: Oo.circle, cx: "50", cy: "50", r: "40", fill: "none", strokeWidth: "10", strokeLinecap: "round" }),
        /* @__PURE__ */ T(
          "circle",
          {
            className: Oo["moving-element"],
            cx: "50",
            cy: "50",
            r: "40",
            fill: "none",
            strokeWidth: "6",
            strokeLinecap: "round",
            children: [
              /* @__PURE__ */ v("animate", { attributeName: "stroke-dashoffset", dur: "2s", repeatCount: "indefinite", from: "502", to: "0" }),
              /* @__PURE__ */ v(
                "animate",
                {
                  attributeName: "stroke-dasharray",
                  dur: "2s",
                  repeatCount: "indefinite",
                  values: "150.6 100.4;1 250;150.6 100.4"
                }
              )
            ]
          }
        )
      ]
    }
  );
}
const wze = "_button_z1os6_29", kze = "_disabled_z1os6_43", xze = "_loader_z1os6_263", ca = {
  button: wze,
  disabled: kze,
  "is-primary": "_is-primary_z1os6_51",
  "is-contrasted": "_is-contrasted_z1os6_65",
  "is-secondary": "_is-secondary_z1os6_74",
  "is-tertiary": "_is-tertiary_z1os6_97",
  "is-eco-green": "_is-eco-green_z1os6_120",
  "is-ghost": "_is-ghost_z1os6_134",
  "is-destructive": "_is-destructive_z1os6_157",
  "is-hollow": "_is-hollow_z1os6_171",
  "is-destructive-ghost": "_is-destructive-ghost_z1os6_189",
  "is-facebook": "_is-facebook_z1os6_203",
  "is-apple": "_is-apple_z1os6_217",
  "is-google": "_is-google_z1os6_231",
  "is-regular": "_is-regular_z1os6_245",
  "is-medium": "_is-medium_z1os6_248",
  "is-small": "_is-small_z1os6_251",
  "is-full-width": "_is-full-width_z1os6_254",
  "is-loading": "_is-loading_z1os6_257",
  loader: xze,
  "dialog-overlay-show": "_dialog-overlay-show_z1os6_1",
  "dialog-content-show": "_dialog-content-show_z1os6_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_z1os6_1"
}, $ze = pt(
  ({
    text: e,
    color: t = "primary",
    size: a = "medium",
    isFullWidth: o = !1,
    icon: n,
    iconPosition: r = "left",
    isLoading: i = !1,
    iconSize: s = "medium",
    isContrasted: l = !1,
    disabled: c = !1,
    className: u,
    children: d,
    ...h
  }, p) => {
    const f = It(
      ca.button,
      ca[Sze[t]],
      ca[Cze[a]],
      o && ca["is-full-width"],
      c && ca.disabled,
      r === "right" && ca["has-icon-right"],
      l && ca["is-contrasted"],
      i && ca["is-loading"],
      u
    ), m = /* @__PURE__ */ T(De, { children: [
      i && /* @__PURE__ */ v(yze, { className: ca.loader, onDark: !0, size: "small" }),
      n && r === "left" && /* @__PURE__ */ v(Bn, { color: "inherit", size: s, name: n }),
      d ?? e,
      n && r === "right" && /* @__PURE__ */ v(Bn, { color: "inherit", size: s, name: n })
    ] });
    if (Eze(h))
      return /* @__PURE__ */ v(
        "a",
        {
          ...h,
          href: c ? void 0 : h.href,
          className: f,
          target: h.target,
          ref: p,
          children: m
        }
      );
    if (zze(h))
      return /* @__PURE__ */ v(
        "button",
        {
          disabled: i || c,
          ...h,
          className: f,
          ref: p,
          children: m
        }
      );
  }
);
$ze.displayName = "Button";
const Sze = {
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  "eco-green": "is-eco-green",
  ghost: "is-ghost",
  "destructive-ghost": "is-destructive-ghost",
  destructive: "is-destructive",
  hollow: "is-hollow",
  facebook: "is-facebook",
  apple: "is-apple",
  google: "is-google"
}, Cze = {
  small: "is-small",
  medium: "is-medium",
  regular: "is-regular"
};
function Eze(e) {
  return "href" in e && typeof e.href == "string";
}
function zze(e) {
  return !("href" in e);
}
const jze = 0;
function Aze(e, t, a, o) {
  const [n, r] = Pe(!1), i = n ? e : t, [s, l] = Pe(i ? i.length : jze), [c, u] = Pe(!1);
  return {
    valueCounter: s,
    isOnBlur: c,
    handleBlur: () => {
      u(!0), o && o();
    },
    handleChange: (d) => {
      r(!0), l(d.target.value.length), a && a(d), u(!1);
    }
  };
}
const Fm = {
  warning: {
    name: "warning",
    color: "warning"
  },
  success: {
    name: "verification-check",
    color: "success"
  },
  error: {
    name: "notification",
    color: "error"
  }
}, Tl = {
  warning: "is-warning",
  success: "is-success",
  error: "is-error"
}, Oze = "_input_s9iwc_29", Pze = "_filled_s9iwc_48", Dze = "_error_s9iwc_154", Nze = "_counter_s9iwc_174", vt = {
  input: Oze,
  "group-label": "_group-label_s9iwc_29",
  filled: Pze,
  "is-error": "_is-error_s9iwc_51",
  "is-success": "_is-success_s9iwc_54",
  "is-warning": "_is-warning_s9iwc_57",
  "helper-text": "_helper-text_s9iwc_60",
  "is-disabled": "_is-disabled_s9iwc_86",
  "is-full-width": "_is-full-width_s9iwc_101",
  "container-counter-icon": "_container-counter-icon_s9iwc_148",
  error: Dze,
  "container-icon": "_container-icon_s9iwc_157",
  counter: Nze,
  "dialog-overlay-show": "_dialog-overlay-show_s9iwc_1",
  "dialog-content-show": "_dialog-content-show_s9iwc_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_s9iwc_1"
}, Rze = pt(
  ({
    className: e,
    type: t = "text",
    value: a,
    message: o,
    status: n,
    placeholder: r,
    onChange: i,
    onBlur: s,
    disabled: l,
    label: c,
    helperText: u,
    name: d,
    isFullWidth: h,
    defaultValue: p,
    id: f,
    optionalMessage: m,
    maxLength: b,
    ...w
  }, _) => {
    const {
      valueCounter: y,
      handleBlur: k,
      handleChange: x
    } = Aze(
      a?.toString(),
      p?.toString(),
      i,
      s ? () => s({}) : void 0
    ), S = It(
      vt.input,
      n && vt[Tl[n]],
      l && vt["is-disabled"],
      h && vt["is-full-width"],
      e
    );
    return /* @__PURE__ */ T("div", { className: S, children: [
      /* @__PURE__ */ T("div", { className: vt["group-label"], children: [
        /* @__PURE__ */ T("div", { children: [
          c && /* @__PURE__ */ v("label", { className: It(n && vt[n]), children: c }),
          m && /* @__PURE__ */ v("span", { children: m })
        ] }),
        u && /* @__PURE__ */ v("div", { className: vt["helper-text"], children: u })
      ] }),
      /* @__PURE__ */ v(
        "input",
        {
          id: f,
          ref: _,
          value: a,
          className: It(n && !l && vt[Tl[n]]),
          type: t,
          placeholder: r,
          onChange: x,
          onBlur: k,
          name: d,
          defaultValue: p,
          "aria-label": c,
          disabled: l,
          ...w
        }
      ),
      (o && n && !l || b) && /* @__PURE__ */ T("div", { className: vt["container-counter-icon"], children: [
        o && n && !l && /* @__PURE__ */ T("div", { className: vt["container-icon"], children: [
          /* @__PURE__ */ v(Bn, { name: Fm[n].name, size: "medium", color: Fm[n].color }),
          /* @__PURE__ */ v("span", { className: vt[Tl[n]], children: o })
        ] }),
        b && /* @__PURE__ */ T("div", { className: It(vt.counter, y > b && vt.error), children: [
          y,
          "/",
          b
        ] })
      ] })
    ] });
  }
);
Rze.displayName = "Input";
const Ize = "_container_1iybi_29", Tze = "_message_1iybi_33", Mze = "_error_1iybi_39", Lze = "_disabled_1iybi_49", ua = {
  container: Ize,
  message: Tze,
  error: Mze,
  "input-container": "_input-container_1iybi_43",
  disabled: Lze,
  "checkbox-input": "_checkbox-input_1iybi_52",
  "label-container": "_label-container_1iybi_99"
}, Wze = pt(
  ({ label: e, value: t, onChange: a, name: o, message: n, hasError: r, disabled: i, checked: s }, l) => {
    const c = It(ua["checkbox-input"], r && ua.error, i && ua.disabled);
    return /* @__PURE__ */ T("div", { className: ua.container, children: [
      /* @__PURE__ */ T("label", { className: It(ua["input-container"], i && ua.disabled), children: [
        /* @__PURE__ */ v(
          "input",
          {
            type: "checkbox",
            className: c,
            name: o,
            value: t,
            onChange: a,
            disabled: i,
            checked: s,
            ref: l
          }
        ),
        /* @__PURE__ */ v("div", { className: ua["label-container"], children: e })
      ] }),
      n && /* @__PURE__ */ v("span", { className: It(ua.message, r && ua.error), children: n })
    ] });
  }
);
Wze.displayName = "Checkbox";
function ve(e, t, { checkForDefaultPrevented: a = !0 } = {}) {
  return function(o) {
    if (e?.(o), a === !1 || !o.defaultPrevented)
      return t?.(o);
  };
}
var ot = globalThis?.document ? g.useLayoutEffect : () => {
};
function Vm(e, t) {
  if (typeof e == "function")
    return e(t);
  e != null && (e.current = t);
}
function yw(...e) {
  return (t) => {
    let a = !1;
    const o = e.map((n) => {
      const r = Vm(n, t);
      return !a && typeof r == "function" && (a = !0), r;
    });
    if (a)
      return () => {
        for (let n = 0; n < o.length; n++) {
          const r = o[n];
          typeof r == "function" ? r() : Vm(e[n], null);
        }
      };
  };
}
function Ne(...e) {
  return g.useCallback(yw(...e), e);
}
function Bze(e, t) {
  const a = g.createContext(t), o = (r) => {
    const { children: i, ...s } = r, l = g.useMemo(() => s, Object.values(s));
    return /* @__PURE__ */ v(a.Provider, { value: l, children: i });
  };
  o.displayName = e + "Provider";
  function n(r) {
    const i = g.useContext(a);
    if (i) return i;
    if (t !== void 0) return t;
    throw new Error(`\`${r}\` must be used within \`${e}\``);
  }
  return [o, n];
}
function cr(e, t = []) {
  let a = [];
  function o(r, i) {
    const s = g.createContext(i), l = a.length;
    a = [...a, i];
    const c = (d) => {
      const { scope: h, children: p, ...f } = d, m = h?.[e]?.[l] || s, b = g.useMemo(() => f, Object.values(f));
      return /* @__PURE__ */ v(m.Provider, { value: b, children: p });
    };
    c.displayName = r + "Provider";
    function u(d, h) {
      const p = h?.[e]?.[l] || s, f = g.useContext(p);
      if (f) return f;
      if (i !== void 0) return i;
      throw new Error(`\`${d}\` must be used within \`${r}\``);
    }
    return [c, u];
  }
  const n = () => {
    const r = a.map((i) => g.createContext(i));
    return function(i) {
      const s = i?.[e] || r;
      return g.useMemo(
        () => ({ [`__scope${e}`]: { ...i, [e]: s } }),
        [i, s]
      );
    };
  };
  return n.scopeName = e, [o, Fze(n, ...t)];
}
function Fze(...e) {
  const t = e[0];
  if (e.length === 1) return t;
  const a = () => {
    const o = e.map((n) => ({
      useScope: n(),
      scopeName: n.scopeName
    }));
    return function(n) {
      const r = o.reduce((i, { useScope: s, scopeName: l }) => {
        const c = s(n)[`__scope${l}`];
        return { ...i, ...c };
      }, {});
      return g.useMemo(() => ({ [`__scope${t.scopeName}`]: r }), [r]);
    };
  };
  return a.scopeName = t.scopeName, a;
}
// @__NO_SIDE_EFFECTS__
function Fn(e) {
  const t = /* @__PURE__ */ Vze(e), a = g.forwardRef((o, n) => {
    const { children: r, ...i } = o, s = g.Children.toArray(r), l = s.find(qze);
    if (l) {
      const c = l.props.children, u = s.map((d) => d === l ? g.Children.count(c) > 1 ? g.Children.only(null) : g.isValidElement(c) ? c.props.children : null : d);
      return /* @__PURE__ */ v(t, { ...i, ref: n, children: g.isValidElement(c) ? g.cloneElement(c, void 0, u) : null });
    }
    return /* @__PURE__ */ v(t, { ...i, ref: n, children: r });
  });
  return a.displayName = `${e}.Slot`, a;
}
// @__NO_SIDE_EFFECTS__
function Vze(e) {
  const t = g.forwardRef((a, o) => {
    const { children: n, ...r } = a;
    if (g.isValidElement(n)) {
      const i = Gze(n), s = Hze(r, n.props);
      return n.type !== g.Fragment && (s.ref = o ? yw(o, i) : i), g.cloneElement(n, s);
    }
    return g.Children.count(n) > 1 ? g.Children.only(null) : null;
  });
  return t.displayName = `${e}.SlotClone`, t;
}
var Uze = Symbol("radix.slottable");
function qze(e) {
  return g.isValidElement(e) && typeof e.type == "function" && "__radixId" in e.type && e.type.__radixId === Uze;
}
function Hze(e, t) {
  const a = { ...t };
  for (const o in t) {
    const n = e[o], r = t[o];
    /^on[A-Z]/.test(o) ? n && r ? a[o] = (...i) => {
      const s = r(...i);
      return n(...i), s;
    } : n && (a[o] = n) : o === "style" ? a[o] = { ...n, ...r } : o === "className" && (a[o] = [n, r].filter(Boolean).join(" "));
  }
  return { ...e, ...a };
}
function Gze(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning;
  return a ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning, a ? e.props.ref : e.props.ref || e.ref);
}
var Kze = [
  "a",
  "button",
  "div",
  "form",
  "h2",
  "h3",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "select",
  "span",
  "svg",
  "ul"
], ye = Kze.reduce((e, t) => {
  const a = /* @__PURE__ */ Fn(`Primitive.${t}`), o = g.forwardRef((n, r) => {
    const { asChild: i, ...s } = n, l = i ? a : t;
    return typeof window < "u" && (window[Symbol.for("radix-ui")] = !0), /* @__PURE__ */ v(l, { ...s, ref: r });
  });
  return o.displayName = `Primitive.${t}`, { ...e, [t]: o };
}, {});
function Jze(e, t) {
  e && mo.flushSync(() => e.dispatchEvent(t));
}
var Zze = g.createContext(void 0);
function Yze(e) {
  const t = g.useContext(Zze);
  return e || t || "ltr";
}
function Xze(e) {
  const t = e + "CollectionProvider", [a, o] = cr(t), [n, r] = a(
    t,
    { collectionRef: { current: null }, itemMap: /* @__PURE__ */ new Map() }
  ), i = (m) => {
    const { scope: b, children: w } = m, _ = ne.useRef(null), y = ne.useRef(/* @__PURE__ */ new Map()).current;
    return /* @__PURE__ */ v(n, { scope: b, itemMap: y, collectionRef: _, children: w });
  };
  i.displayName = t;
  const s = e + "CollectionSlot", l = /* @__PURE__ */ Fn(s), c = ne.forwardRef(
    (m, b) => {
      const { scope: w, children: _ } = m, y = r(s, w), k = Ne(b, y.collectionRef);
      return /* @__PURE__ */ v(l, { ref: k, children: _ });
    }
  );
  c.displayName = s;
  const u = e + "CollectionItemSlot", d = "data-radix-collection-item", h = /* @__PURE__ */ Fn(u), p = ne.forwardRef(
    (m, b) => {
      const { scope: w, children: _, ...y } = m, k = ne.useRef(null), x = Ne(b, k), S = r(u, w);
      return ne.useEffect(() => (S.itemMap.set(k, { ref: k, ...y }), () => void S.itemMap.delete(k))), /* @__PURE__ */ v(h, { [d]: "", ref: x, children: _ });
    }
  );
  p.displayName = u;
  function f(m) {
    const b = r(e + "CollectionConsumer", m);
    return ne.useCallback(() => {
      const w = b.collectionRef.current;
      if (!w) return [];
      const _ = Array.from(w.querySelectorAll(`[${d}]`));
      return Array.from(b.itemMap.values()).sort(
        (y, k) => _.indexOf(y.ref.current) - _.indexOf(k.ref.current)
      );
    }, [b.collectionRef, b.itemMap]);
  }
  return [
    { Provider: i, Slot: c, ItemSlot: p },
    f,
    o
  ];
}
var Qze = g[" useId ".trim().toString()] || (() => {
}), eje = 0;
function ww(e) {
  const [t, a] = g.useState(Qze());
  return ot(() => {
    a((o) => o ?? String(eje++));
  }, [e]), t ? `radix-${t}` : "";
}
function tje(e, t) {
  return g.useReducer((a, o) => t[a][o] ?? a, e);
}
var yo = (e) => {
  const { present: t, children: a } = e, o = aje(t), n = typeof a == "function" ? a({ present: o.isPresent }) : g.Children.only(a), r = Ne(o.ref, oje(n));
  return typeof a == "function" || o.isPresent ? g.cloneElement(n, { ref: r }) : null;
};
yo.displayName = "Presence";
function aje(e) {
  const [t, a] = g.useState(), o = g.useRef(null), n = g.useRef(e), r = g.useRef("none"), i = e ? "mounted" : "unmounted", [s, l] = tje(i, {
    mounted: {
      UNMOUNT: "unmounted",
      ANIMATION_OUT: "unmountSuspended"
    },
    unmountSuspended: {
      MOUNT: "mounted",
      ANIMATION_END: "unmounted"
    },
    unmounted: {
      MOUNT: "mounted"
    }
  });
  return g.useEffect(() => {
    const c = Mr(o.current);
    r.current = s === "mounted" ? c : "none";
  }, [s]), ot(() => {
    const c = o.current, u = n.current;
    if (u !== e) {
      const d = r.current, h = Mr(c);
      e ? l("MOUNT") : h === "none" || c?.display === "none" ? l("UNMOUNT") : l(u && d !== h ? "ANIMATION_OUT" : "UNMOUNT"), n.current = e;
    }
  }, [e, l]), ot(() => {
    if (t) {
      let c;
      const u = t.ownerDocument.defaultView ?? window, d = (p) => {
        const f = Mr(o.current).includes(CSS.escape(p.animationName));
        if (p.target === t && f && (l("ANIMATION_END"), !n.current)) {
          const m = t.style.animationFillMode;
          t.style.animationFillMode = "forwards", c = u.setTimeout(() => {
            t.style.animationFillMode === "forwards" && (t.style.animationFillMode = m);
          });
        }
      }, h = (p) => {
        p.target === t && (r.current = Mr(o.current));
      };
      return t.addEventListener("animationstart", h), t.addEventListener("animationcancel", d), t.addEventListener("animationend", d), () => {
        u.clearTimeout(c), t.removeEventListener("animationstart", h), t.removeEventListener("animationcancel", d), t.removeEventListener("animationend", d);
      };
    } else
      l("ANIMATION_END");
  }, [t, l]), {
    isPresent: ["mounted", "unmountSuspended"].includes(s),
    ref: g.useCallback((c) => {
      o.current = c ? getComputedStyle(c) : null, a(c);
    }, [])
  };
}
function Mr(e) {
  return e?.animationName || "none";
}
function oje(e) {
  let t = Object.getOwnPropertyDescriptor(e.props, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning;
  return a ? e.ref : (t = Object.getOwnPropertyDescriptor(e, "ref")?.get, a = t && "isReactWarning" in t && t.isReactWarning, a ? e.props.ref : e.props.ref || e.ref);
}
function ut(e) {
  const t = g.useRef(e);
  return g.useEffect(() => {
    t.current = e;
  }), g.useMemo(() => (...a) => t.current?.(...a), []);
}
function nje(e) {
  const [t, a] = g.useState(void 0);
  return ot(() => {
    if (e) {
      a({ width: e.offsetWidth, height: e.offsetHeight });
      const o = new ResizeObserver((n) => {
        if (!Array.isArray(n) || !n.length)
          return;
        const r = n[0];
        let i, s;
        if ("borderBoxSize" in r) {
          const l = r.borderBoxSize, c = Array.isArray(l) ? l[0] : l;
          i = c.inlineSize, s = c.blockSize;
        } else
          i = e.offsetWidth, s = e.offsetHeight;
        a({ width: i, height: s });
      });
      return o.observe(e, { box: "border-box" }), () => o.unobserve(e);
    } else
      a(void 0);
  }, [e]), t;
}
function rje(e) {
  const t = g.useRef({ value: e, previous: e });
  return g.useMemo(() => (t.current.value !== e && (t.current.previous = t.current.value, t.current.value = e), t.current.previous), [e]);
}
const ije = ({
  initialPhoneNumber: e = "",
  initialCountry: t = "",
  onChangePhoneNumber: a,
  onChangeCountry: o
}) => {
  const [n, r] = Pe(e), [i, s] = Pe(t);
  return {
    phoneNumber: n,
    country: i,
    handlePhoneNumberChange: (l) => {
      r(l), a?.(l);
    },
    handleCountryChange: (l) => {
      s(l), o?.(l);
    }
  };
}, sje = {
  ad: "Andorra",
  ae: "De Forenede Arabiske Emirater",
  af: "Afghanistan",
  ag: "Antigua og Barbuda",
  ai: "Anguilla",
  al: "Albanien",
  am: "Armenien",
  ao: "Angola",
  ar: "Argentina",
  as: "Amerikansk Samoa",
  at: "Østrig",
  au: "Australien",
  aw: "Aruba",
  ax: "Åland",
  az: "Aserbajdsjan",
  ba: "Bosnien-Hercegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgien",
  bf: "Burkina Faso",
  bg: "Bulgarien",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "De tidligere Nederlandske Antiller",
  br: "Brasilien",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Hviderusland",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocosøerne",
  cd: "Congo-Kinshasa",
  cf: "Den Centralafrikanske Republik",
  cg: "Congo-Brazzaville",
  ch: "Schweiz",
  ci: "Elfenbenskysten",
  ck: "Cookøerne",
  cl: "Chile",
  cm: "Cameroun",
  cn: "Kina",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Kap Verde",
  cw: "Curaçao",
  cx: "Juleøen",
  cy: "Cypern",
  cz: "Tjekkiet",
  de: "Tyskland",
  dj: "Djibouti",
  dk: "Danmark",
  dm: "Dominica",
  do: "Den Dominikanske Republik",
  dz: "Algeriet",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Egypten",
  eh: "Vestsahara",
  er: "Eritrea",
  es: "Spanien",
  et: "Etiopien",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falklandsøerne",
  fm: "Mikronesien",
  fo: "Færøerne",
  fr: "Frankrig",
  ga: "Gabon",
  gb: "Storbritannien",
  gd: "Grenada",
  ge: "Georgien",
  gf: "Fransk Guyana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Grønland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Ækvatorialguinea",
  gr: "Grækenland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "SAR Hongkong",
  hn: "Honduras",
  hr: "Kroatien",
  ht: "Haiti",
  hu: "Ungarn",
  id: "Indonesien",
  ie: "Irland",
  il: "Israel",
  im: "Isle of Man",
  in: "Indien",
  io: "Det Britiske Territorium i Det Indiske Ocean",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italien",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kirgisistan",
  kh: "Cambodja",
  ki: "Kiribati",
  km: "Comorerne",
  kn: "Saint Kitts og Nevis",
  kp: "Nordkorea",
  kr: "Sydkorea",
  kw: "Kuwait",
  ky: "Caymanøerne",
  kz: "Kasakhstan",
  la: "Laos",
  lb: "Libanon",
  lc: "Saint Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litauen",
  lu: "Luxembourg",
  lv: "Letland",
  ly: "Libyen",
  ma: "Marokko",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "Saint Martin",
  mg: "Madagaskar",
  mh: "Marshalløerne",
  mk: "Nordmakedonien",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongoliet",
  mo: "SAR Macao",
  mp: "Nordmarianerne",
  mq: "Martinique",
  mr: "Mauretanien",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldiverne",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "Ny Kaledonien",
  ne: "Niger",
  nf: "Norfolk Island",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Holland",
  no: "Norge",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Fransk Polynesien",
  pg: "Papua Ny Guinea",
  ph: "Filippinerne",
  pk: "Pakistan",
  pl: "Polen",
  pm: "Saint Pierre og Miquelon",
  pr: "Puerto Rico",
  ps: "De palæstinensiske områder",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Rumænien",
  rs: "Serbien",
  ru: "Rusland",
  rw: "Rwanda",
  sa: "Saudi-Arabien",
  sb: "Salomonøerne",
  sc: "Seychellerne",
  sd: "Sudan",
  se: "Sverige",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenien",
  sj: "Svalbard og Jan Mayen",
  sk: "Slovakiet",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Surinam",
  ss: "Sydsudan",
  st: "São Tomé og Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syrien",
  sz: "Eswatini",
  tc: "Turks- og Caicosøerne",
  td: "Tchad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadsjikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunesien",
  to: "Tonga",
  tr: "Tyrkiet",
  tt: "Trinidad og Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "USA",
  uy: "Uruguay",
  uz: "Usbekistan",
  va: "Vatikanstaten",
  vc: "Saint Vincent og Grenadinerne",
  ve: "Venezuela",
  vg: "De Britiske Jomfruøer",
  vi: "De Amerikanske Jomfruøer",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis og Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "Sydafrika",
  zm: "Zambia",
  zw: "Zimbabwe"
}, lje = {
  selectedCountryAriaLabel: "Valgt land",
  noCountrySelected: "Intet land er valgt",
  countryListAriaLabel: "Liste over lande",
  searchPlaceholder: "Søg",
  zeroSearchResults: "Ingen resultater fundet",
  oneSearchResult: "1 resultat fundet",
  multipleSearchResults: "${count} resultater fundet",
  // additional countries (not supported by country-list library)
  ac: "Ascension",
  xk: "Kosovo"
}, cje = { ...sje, ...lje }, uje = {
  ad: "Andorra",
  ae: "Vereinigte Arabische Emirate",
  af: "Afghanistan",
  ag: "Antigua und Barbuda",
  ai: "Anguilla",
  al: "Albanien",
  am: "Armenien",
  ao: "Angola",
  ar: "Argentinien",
  as: "Amerikanisch-Samoa",
  at: "Österreich",
  au: "Australien",
  aw: "Aruba",
  ax: "Ålandinseln",
  az: "Aserbaidschan",
  ba: "Bosnien und Herzegowina",
  bb: "Barbados",
  bd: "Bangladesch",
  be: "Belgien",
  bf: "Burkina Faso",
  bg: "Bulgarien",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "St. Barthélemy",
  bm: "Bermuda",
  bn: "Brunei Darussalam",
  bo: "Bolivien",
  bq: "Bonaire, Sint Eustatius und Saba",
  br: "Brasilien",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botsuana",
  by: "Belarus",
  bz: "Belize",
  ca: "Kanada",
  cc: "Kokosinseln",
  cd: "Kongo-Kinshasa",
  cf: "Zentralafrikanische Republik",
  cg: "Kongo-Brazzaville",
  ch: "Schweiz",
  ci: "Côte d’Ivoire",
  ck: "Cookinseln",
  cl: "Chile",
  cm: "Kamerun",
  cn: "China",
  co: "Kolumbien",
  cr: "Costa Rica",
  cu: "Kuba",
  cv: "Cabo Verde",
  cw: "Curaçao",
  cx: "Weihnachtsinsel",
  cy: "Zypern",
  cz: "Tschechien",
  de: "Deutschland",
  dj: "Dschibuti",
  dk: "Dänemark",
  dm: "Dominica",
  do: "Dominikanische Republik",
  dz: "Algerien",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Ägypten",
  eh: "Westsahara",
  er: "Eritrea",
  es: "Spanien",
  et: "Äthiopien",
  fi: "Finnland",
  fj: "Fidschi",
  fk: "Falklandinseln",
  fm: "Mikronesien",
  fo: "Färöer",
  fr: "Frankreich",
  ga: "Gabun",
  gb: "Vereinigtes Königreich",
  gd: "Grenada",
  ge: "Georgien",
  gf: "Französisch-Guayana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Grönland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Äquatorialguinea",
  gr: "Griechenland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Sonderverwaltungsregion Hongkong",
  hn: "Honduras",
  hr: "Kroatien",
  ht: "Haiti",
  hu: "Ungarn",
  id: "Indonesien",
  ie: "Irland",
  il: "Israel",
  im: "Isle of Man",
  in: "Indien",
  io: "Britisches Territorium im Indischen Ozean",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italien",
  je: "Jersey",
  jm: "Jamaika",
  jo: "Jordanien",
  jp: "Japan",
  ke: "Kenia",
  kg: "Kirgisistan",
  kh: "Kambodscha",
  ki: "Kiribati",
  km: "Komoren",
  kn: "St. Kitts und Nevis",
  kp: "Nordkorea",
  kr: "Südkorea",
  kw: "Kuwait",
  ky: "Kaimaninseln",
  kz: "Kasachstan",
  la: "Laos",
  lb: "Libanon",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litauen",
  lu: "Luxemburg",
  lv: "Lettland",
  ly: "Libyen",
  ma: "Marokko",
  mc: "Monaco",
  md: "Republik Moldau",
  me: "Montenegro",
  mf: "St. Martin",
  mg: "Madagaskar",
  mh: "Marshallinseln",
  mk: "Nordmazedonien",
  ml: "Mali",
  mm: "Myanmar",
  mn: "Mongolei",
  mo: "Sonderverwaltungsregion Macau",
  mp: "Nördliche Marianen",
  mq: "Martinique",
  mr: "Mauretanien",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Malediven",
  mw: "Malawi",
  mx: "Mexiko",
  my: "Malaysia",
  mz: "Mosambik",
  na: "Namibia",
  nc: "Neukaledonien",
  ne: "Niger",
  nf: "Norfolkinsel",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Niederlande",
  no: "Norwegen",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Neuseeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Französisch-Polynesien",
  pg: "Papua-Neuguinea",
  ph: "Philippinen",
  pk: "Pakistan",
  pl: "Polen",
  pm: "St. Pierre und Miquelon",
  pr: "Puerto Rico",
  ps: "Palästinensische Autonomiegebiete",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Katar",
  re: "Réunion",
  ro: "Rumänien",
  rs: "Serbien",
  ru: "Russland",
  rw: "Ruanda",
  sa: "Saudi-Arabien",
  sb: "Salomonen",
  sc: "Seychellen",
  sd: "Sudan",
  se: "Schweden",
  sg: "Singapur",
  sh: "St. Helena",
  si: "Slowenien",
  sj: "Spitzbergen und Jan Mayen",
  sk: "Slowakei",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "Südsudan",
  st: "São Tomé und Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syrien",
  sz: "Eswatini",
  tc: "Turks- und Caicosinseln",
  td: "Tschad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadschikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunesien",
  to: "Tonga",
  tr: "Türkei",
  tt: "Trinidad und Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tansania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "Vereinigte Staaten",
  uy: "Uruguay",
  uz: "Usbekistan",
  va: "Vatikanstadt",
  vc: "St. Vincent und die Grenadinen",
  ve: "Venezuela",
  vg: "Britische Jungferninseln",
  vi: "Amerikanische Jungferninseln",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis und Futuna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Südafrika",
  zm: "Sambia",
  zw: "Simbabwe"
}, dje = {
  selectedCountryAriaLabel: "Ausgewähltes Land",
  noCountrySelected: "Kein Land ausgewählt",
  countryListAriaLabel: "Liste der Länder",
  searchPlaceholder: "Suchen",
  zeroSearchResults: "Keine Suchergebnisse",
  oneSearchResult: "1 Suchergebnis",
  multipleSearchResults: "${count} Suchergebnisse",
  // additional countries (not supported by country-list library)
  ac: "Ascension-Insel",
  xk: "Kosovo"
}, gje = { ...uje, ...dje }, hje = {
  ad: "Andorra",
  ae: "United Arab Emirates",
  af: "Afghanistan",
  ag: "Antigua & Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "American Samoa",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Åland Islands",
  az: "Azerbaijan",
  ba: "Bosnia & Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgium",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "St. Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caribbean Netherlands",
  br: "Brazil",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocos (Keeling) Islands",
  cd: "Congo - Kinshasa",
  cf: "Central African Republic",
  cg: "Congo - Brazzaville",
  ch: "Switzerland",
  ci: "Côte d’Ivoire",
  ck: "Cook Islands",
  cl: "Chile",
  cm: "Cameroon",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cape Verde",
  cw: "Curaçao",
  cx: "Christmas Island",
  cy: "Cyprus",
  cz: "Czechia",
  de: "Germany",
  dj: "Djibouti",
  dk: "Denmark",
  dm: "Dominica",
  do: "Dominican Republic",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egypt",
  eh: "Western Sahara",
  er: "Eritrea",
  es: "Spain",
  et: "Ethiopia",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falkland Islands",
  fm: "Micronesia",
  fo: "Faroe Islands",
  fr: "France",
  ga: "Gabon",
  gb: "United Kingdom",
  gd: "Grenada",
  ge: "Georgia",
  gf: "French Guiana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Greenland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Equatorial Guinea",
  gr: "Greece",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hong Kong SAR China",
  hn: "Honduras",
  hr: "Croatia",
  ht: "Haiti",
  hu: "Hungary",
  id: "Indonesia",
  ie: "Ireland",
  il: "Israel",
  im: "Isle of Man",
  in: "India",
  io: "British Indian Ocean Territory",
  iq: "Iraq",
  ir: "Iran",
  is: "Iceland",
  it: "Italy",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kyrgyzstan",
  kh: "Cambodia",
  ki: "Kiribati",
  km: "Comoros",
  kn: "St. Kitts & Nevis",
  kp: "North Korea",
  kr: "South Korea",
  kw: "Kuwait",
  ky: "Cayman Islands",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Lebanon",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Lithuania",
  lu: "Luxembourg",
  lv: "Latvia",
  ly: "Libya",
  ma: "Morocco",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "St. Martin",
  mg: "Madagascar",
  mh: "Marshall Islands",
  mk: "North Macedonia",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongolia",
  mo: "Macao SAR China",
  mp: "Northern Mariana Islands",
  mq: "Martinique",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "New Caledonia",
  ne: "Niger",
  nf: "Norfolk Island",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Netherlands",
  no: "Norway",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "French Polynesia",
  pg: "Papua New Guinea",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Poland",
  pm: "St. Pierre & Miquelon",
  pr: "Puerto Rico",
  ps: "Palestinian Territories",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russia",
  rw: "Rwanda",
  sa: "Saudi Arabia",
  sb: "Solomon Islands",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Sweden",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenia",
  sj: "Svalbard & Jan Mayen",
  sk: "Slovakia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "South Sudan",
  st: "São Tomé & Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syria",
  sz: "Eswatini",
  tc: "Turks & Caicos Islands",
  td: "Chad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tajikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Turkey",
  tt: "Trinidad & Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "United States",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Vatican City",
  vc: "St. Vincent & Grenadines",
  ve: "Venezuela",
  vg: "British Virgin Islands",
  vi: "U.S. Virgin Islands",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis & Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "South Africa",
  zm: "Zambia",
  zw: "Zimbabwe"
}, mje = {
  selectedCountryAriaLabel: "Change country, selected ${countryName} (${dialCode})",
  noCountrySelected: "Select country",
  countryListAriaLabel: "List of countries",
  searchPlaceholder: "Search",
  clearSearchAriaLabel: "Clear search",
  zeroSearchResults: "No results found",
  oneSearchResult: "1 result found",
  multipleSearchResults: "${count} results found",
  // additional countries (not supported by country-list library)
  ac: "Ascension Island",
  xk: "Kosovo"
}, pje = { ...hje, ...mje }, fje = {
  ad: "Andorra",
  ae: "Emiratos Árabes Unidos",
  af: "Afganistán",
  ag: "Antigua y Barbuda",
  ai: "Anguila",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "Samoa Americana",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Islas Åland",
  az: "Azerbaiyán",
  ba: "Bosnia y Herzegovina",
  bb: "Barbados",
  bd: "Bangladés",
  be: "Bélgica",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Baréin",
  bi: "Burundi",
  bj: "Benín",
  bl: "San Bartolomé",
  bm: "Bermudas",
  bn: "Brunéi",
  bo: "Bolivia",
  bq: "Caribe neerlandés",
  br: "Brasil",
  bs: "Bahamas",
  bt: "Bután",
  bw: "Botsuana",
  by: "Bielorrusia",
  bz: "Belice",
  ca: "Canadá",
  cc: "Islas Cocos",
  cd: "República Democrática del Congo",
  cf: "República Centroafricana",
  cg: "Congo",
  ch: "Suiza",
  ci: "Côte d’Ivoire",
  ck: "Islas Cook",
  cl: "Chile",
  cm: "Camerún",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cabo Verde",
  cw: "Curazao",
  cx: "Isla de Navidad",
  cy: "Chipre",
  cz: "Chequia",
  de: "Alemania",
  dj: "Yibuti",
  dk: "Dinamarca",
  dm: "Dominica",
  do: "República Dominicana",
  dz: "Argelia",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egipto",
  eh: "Sáhara Occidental",
  er: "Eritrea",
  es: "España",
  et: "Etiopía",
  fi: "Finlandia",
  fj: "Fiyi",
  fk: "Islas Malvinas",
  fm: "Micronesia",
  fo: "Islas Feroe",
  fr: "Francia",
  ga: "Gabón",
  gb: "Reino Unido",
  gd: "Granada",
  ge: "Georgia",
  gf: "Guayana Francesa",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Groenlandia",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadalupe",
  gq: "Guinea Ecuatorial",
  gr: "Grecia",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bisáu",
  gy: "Guyana",
  hk: "RAE de Hong Kong (China)",
  hn: "Honduras",
  hr: "Croacia",
  ht: "Haití",
  hu: "Hungría",
  id: "Indonesia",
  ie: "Irlanda",
  il: "Israel",
  im: "Isla de Man",
  in: "India",
  io: "Territorio Británico del Océano Índico",
  iq: "Irak",
  ir: "Irán",
  is: "Islandia",
  it: "Italia",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordania",
  jp: "Japón",
  ke: "Kenia",
  kg: "Kirguistán",
  kh: "Camboya",
  ki: "Kiribati",
  km: "Comoras",
  kn: "San Cristóbal y Nieves",
  kp: "Corea del Norte",
  kr: "Corea del Sur",
  kw: "Kuwait",
  ky: "Islas Caimán",
  kz: "Kazajistán",
  la: "Laos",
  lb: "Líbano",
  lc: "Santa Lucía",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesoto",
  lt: "Lituania",
  lu: "Luxemburgo",
  lv: "Letonia",
  ly: "Libia",
  ma: "Marruecos",
  mc: "Mónaco",
  md: "Moldavia",
  me: "Montenegro",
  mf: "San Martín",
  mg: "Madagascar",
  mh: "Islas Marshall",
  mk: "Macedonia del Norte",
  ml: "Mali",
  mm: "Myanmar (Birmania)",
  mn: "Mongolia",
  mo: "RAE de Macao (China)",
  mp: "Islas Marianas del Norte",
  mq: "Martinica",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauricio",
  mv: "Maldivas",
  mw: "Malaui",
  mx: "México",
  my: "Malasia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "Nueva Caledonia",
  ne: "Níger",
  nf: "Isla Norfolk",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Países Bajos",
  no: "Noruega",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nueva Zelanda",
  om: "Omán",
  pa: "Panamá",
  pe: "Perú",
  pf: "Polinesia Francesa",
  pg: "Papúa Nueva Guinea",
  ph: "Filipinas",
  pk: "Pakistán",
  pl: "Polonia",
  pm: "San Pedro y Miquelón",
  pr: "Puerto Rico",
  ps: "Territorios Palestinos",
  pt: "Portugal",
  pw: "Palaos",
  py: "Paraguay",
  qa: "Catar",
  re: "Reunión",
  ro: "Rumanía",
  rs: "Serbia",
  ru: "Rusia",
  rw: "Ruanda",
  sa: "Arabia Saudí",
  sb: "Islas Salomón",
  sc: "Seychelles",
  sd: "Sudán",
  se: "Suecia",
  sg: "Singapur",
  sh: "Santa Elena",
  si: "Eslovenia",
  sj: "Svalbard y Jan Mayen",
  sk: "Eslovaquia",
  sl: "Sierra Leona",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Surinam",
  ss: "Sudán del Sur",
  st: "Santo Tomé y Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Siria",
  sz: "Esuatini",
  tc: "Islas Turcas y Caicos",
  td: "Chad",
  tg: "Togo",
  th: "Tailandia",
  tj: "Tayikistán",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistán",
  tn: "Túnez",
  to: "Tonga",
  tr: "Turquía",
  tt: "Trinidad y Tobago",
  tv: "Tuvalu",
  tw: "Taiwán",
  tz: "Tanzania",
  ua: "Ucrania",
  ug: "Uganda",
  us: "Estados Unidos",
  uy: "Uruguay",
  uz: "Uzbekistán",
  va: "Ciudad del Vaticano",
  vc: "San Vicente y las Granadinas",
  ve: "Venezuela",
  vg: "Islas Vírgenes Británicas",
  vi: "Islas Vírgenes de EE. UU.",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis y Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "Sudáfrica",
  zm: "Zambia",
  zw: "Zimbabue"
}, bje = {
  selectedCountryAriaLabel: "País seleccionado",
  noCountrySelected: "Ningún país seleccionado",
  countryListAriaLabel: "Lista de países",
  searchPlaceholder: "Buscar",
  zeroSearchResults: "No se han encontrado resultados",
  oneSearchResult: "1 resultado encontrado",
  multipleSearchResults: "${count} resultados encontrados",
  // additional countries (not supported by country-list library)
  ac: "isla Ascencion",
  xk: "Kosovo"
}, _je = { ...fje, ...bje }, vje = {
  ad: "Andorre",
  ae: "Émirats arabes unis",
  af: "Afghanistan",
  ag: "Antigua-et-Barbuda",
  ai: "Anguilla",
  al: "Albanie",
  am: "Arménie",
  ao: "Angola",
  ar: "Argentine",
  as: "Samoa américaines",
  at: "Autriche",
  au: "Australie",
  aw: "Aruba",
  ax: "Îles Åland",
  az: "Azerbaïdjan",
  ba: "Bosnie-Herzégovine",
  bb: "Barbade",
  bd: "Bangladesh",
  be: "Belgique",
  bf: "Burkina Faso",
  bg: "Bulgarie",
  bh: "Bahreïn",
  bi: "Burundi",
  bj: "Bénin",
  bl: "Saint-Barthélemy",
  bm: "Bermudes",
  bn: "Brunéi Darussalam",
  bo: "Bolivie",
  bq: "Pays-Bas caribéens",
  br: "Brésil",
  bs: "Bahamas",
  bt: "Bhoutan",
  bw: "Botswana",
  by: "Biélorussie",
  bz: "Belize",
  ca: "Canada",
  cc: "Îles Cocos",
  cd: "Congo-Kinshasa",
  cf: "République centrafricaine",
  cg: "Congo-Brazzaville",
  ch: "Suisse",
  ci: "Côte d’Ivoire",
  ck: "Îles Cook",
  cl: "Chili",
  cm: "Cameroun",
  cn: "Chine",
  co: "Colombie",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cap-Vert",
  cw: "Curaçao",
  cx: "Île Christmas",
  cy: "Chypre",
  cz: "Tchéquie",
  de: "Allemagne",
  dj: "Djibouti",
  dk: "Danemark",
  dm: "Dominique",
  do: "République dominicaine",
  dz: "Algérie",
  ec: "Équateur",
  ee: "Estonie",
  eg: "Égypte",
  eh: "Sahara occidental",
  er: "Érythrée",
  es: "Espagne",
  et: "Éthiopie",
  fi: "Finlande",
  fj: "Fidji",
  fk: "Îles Malouines",
  fm: "États fédérés de Micronésie",
  fo: "Îles Féroé",
  fr: "France",
  ga: "Gabon",
  gb: "Royaume-Uni",
  gd: "Grenade",
  ge: "Géorgie",
  gf: "Guyane française",
  gg: "Guernesey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Groenland",
  gm: "Gambie",
  gn: "Guinée",
  gp: "Guadeloupe",
  gq: "Guinée équatoriale",
  gr: "Grèce",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinée-Bissau",
  gy: "Guyana",
  hk: "R.A.S. chinoise de Hong Kong",
  hn: "Honduras",
  hr: "Croatie",
  ht: "Haïti",
  hu: "Hongrie",
  id: "Indonésie",
  ie: "Irlande",
  il: "Israël",
  im: "Île de Man",
  in: "Inde",
  io: "Territoire britannique de l’océan Indien",
  iq: "Irak",
  ir: "Iran",
  is: "Islande",
  it: "Italie",
  je: "Jersey",
  jm: "Jamaïque",
  jo: "Jordanie",
  jp: "Japon",
  ke: "Kenya",
  kg: "Kirghizistan",
  kh: "Cambodge",
  ki: "Kiribati",
  km: "Comores",
  kn: "Saint-Christophe-et-Niévès",
  kp: "Corée du Nord",
  kr: "Corée du Sud",
  kw: "Koweït",
  ky: "Îles Caïmans",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Liban",
  lc: "Sainte-Lucie",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Libéria",
  ls: "Lesotho",
  lt: "Lituanie",
  lu: "Luxembourg",
  lv: "Lettonie",
  ly: "Libye",
  ma: "Maroc",
  mc: "Monaco",
  md: "Moldavie",
  me: "Monténégro",
  mf: "Saint-Martin",
  mg: "Madagascar",
  mh: "Îles Marshall",
  mk: "Macédoine du Nord",
  ml: "Mali",
  mm: "Myanmar (Birmanie)",
  mn: "Mongolie",
  mo: "R.A.S. chinoise de Macao",
  mp: "Îles Mariannes du Nord",
  mq: "Martinique",
  mr: "Mauritanie",
  ms: "Montserrat",
  mt: "Malte",
  mu: "Maurice",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexique",
  my: "Malaisie",
  mz: "Mozambique",
  na: "Namibie",
  nc: "Nouvelle-Calédonie",
  ne: "Niger",
  nf: "Île Norfolk",
  ng: "Nigéria",
  ni: "Nicaragua",
  nl: "Pays-Bas",
  no: "Norvège",
  np: "Népal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nouvelle-Zélande",
  om: "Oman",
  pa: "Panama",
  pe: "Pérou",
  pf: "Polynésie française",
  pg: "Papouasie-Nouvelle-Guinée",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Pologne",
  pm: "Saint-Pierre-et-Miquelon",
  pr: "Porto Rico",
  ps: "Territoires palestiniens",
  pt: "Portugal",
  pw: "Palaos",
  py: "Paraguay",
  qa: "Qatar",
  re: "La Réunion",
  ro: "Roumanie",
  rs: "Serbie",
  ru: "Russie",
  rw: "Rwanda",
  sa: "Arabie saoudite",
  sb: "Îles Salomon",
  sc: "Seychelles",
  sd: "Soudan",
  se: "Suède",
  sg: "Singapour",
  sh: "Sainte-Hélène",
  si: "Slovénie",
  sj: "Svalbard et Jan Mayen",
  sk: "Slovaquie",
  sl: "Sierra Leone",
  sm: "Saint-Marin",
  sn: "Sénégal",
  so: "Somalie",
  sr: "Suriname",
  ss: "Soudan du Sud",
  st: "Sao Tomé-et-Principe",
  sv: "Salvador",
  sx: "Saint-Martin (partie néerlandaise)",
  sy: "Syrie",
  sz: "Eswatini",
  tc: "Îles Turques-et-Caïques",
  td: "Tchad",
  tg: "Togo",
  th: "Thaïlande",
  tj: "Tadjikistan",
  tk: "Tokelau",
  tl: "Timor oriental",
  tm: "Turkménistan",
  tn: "Tunisie",
  to: "Tonga",
  tr: "Turquie",
  tt: "Trinité-et-Tobago",
  tv: "Tuvalu",
  tw: "Taïwan",
  tz: "Tanzanie",
  ua: "Ukraine",
  ug: "Ouganda",
  us: "États-Unis",
  uy: "Uruguay",
  uz: "Ouzbékistan",
  va: "État de la Cité du Vatican",
  vc: "Saint-Vincent-et-les-Grenadines",
  ve: "Venezuela",
  vg: "Îles Vierges britanniques",
  vi: "Îles Vierges des États-Unis",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis-et-Futuna",
  ws: "Samoa",
  ye: "Yémen",
  yt: "Mayotte",
  za: "Afrique du Sud",
  zm: "Zambie",
  zw: "Zimbabwe"
}, yje = {
  selectedCountryAriaLabel: "Pays sélectionné",
  noCountrySelected: "Aucun pays sélectionné",
  countryListAriaLabel: "Liste des pays",
  searchPlaceholder: "Recherche",
  zeroSearchResults: "Aucun résultat trouvé",
  oneSearchResult: "1 résultat trouvé",
  multipleSearchResults: "${count} résultats trouvés",
  // additional countries (not supported by country-list library)
  ac: "Île de l'Ascension",
  xk: "Kosovo"
}, wje = { ...vje, ...yje }, kje = {
  ad: "Andora",
  ae: "Ujedinjeni Arapski Emirati",
  af: "Afganistan",
  ag: "Antigva i Barbuda",
  ai: "Angvila",
  al: "Albanija",
  am: "Armenija",
  ao: "Angola",
  ar: "Argentina",
  as: "Američka Samoa",
  at: "Austrija",
  au: "Australija",
  aw: "Aruba",
  ax: "Ålandski otoci",
  az: "Azerbajdžan",
  ba: "Bosna i Hercegovina",
  bb: "Barbados",
  bd: "Bangladeš",
  be: "Belgija",
  bf: "Burkina Faso",
  bg: "Bugarska",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint Barthélemy",
  bm: "Bermudi",
  bn: "Brunej",
  bo: "Bolivija",
  bq: "Karipski otoci Nizozemske",
  br: "Brazil",
  bs: "Bahami",
  bt: "Butan",
  bw: "Bocvana",
  by: "Bjelorusija",
  bz: "Belize",
  ca: "Kanada",
  cc: "Kokosovi (Keelingovi) otoci",
  cd: "Kongo - Kinshasa",
  cf: "Srednjoafrička Republika",
  cg: "Kongo - Brazzaville",
  ch: "Švicarska",
  ci: "Obala Bjelokosti",
  ck: "Cookovi Otoci",
  cl: "Čile",
  cm: "Kamerun",
  cn: "Kina",
  co: "Kolumbija",
  cr: "Kostarika",
  cu: "Kuba",
  cv: "Zelenortska Republika",
  cw: "Curaçao",
  cx: "Božićni otok",
  cy: "Cipar",
  cz: "Češka",
  de: "Njemačka",
  dj: "Džibuti",
  dk: "Danska",
  dm: "Dominika",
  do: "Dominikanska Republika",
  dz: "Alžir",
  ec: "Ekvador",
  ee: "Estonija",
  eg: "Egipat",
  eh: "Zapadna Sahara",
  er: "Eritreja",
  es: "Španjolska",
  et: "Etiopija",
  fi: "Finska",
  fj: "Fidži",
  fk: "Falklandski otoci",
  fm: "Mikronezija",
  fo: "Farski otoci",
  fr: "Francuska",
  ga: "Gabon",
  gb: "Ujedinjeno Kraljevstvo",
  gd: "Grenada",
  ge: "Gruzija",
  gf: "Francuska Gijana",
  gg: "Guernsey",
  gh: "Gana",
  gi: "Gibraltar",
  gl: "Grenland",
  gm: "Gambija",
  gn: "Gvineja",
  gp: "Guadalupe",
  gq: "Ekvatorska Gvineja",
  gr: "Grčka",
  gt: "Gvatemala",
  gu: "Guam",
  gw: "Gvineja Bisau",
  gy: "Gvajana",
  hk: "PUP Hong Kong Kina",
  hn: "Honduras",
  hr: "Hrvatska",
  ht: "Haiti",
  hu: "Mađarska",
  id: "Indonezija",
  ie: "Irska",
  il: "Izrael",
  im: "Otok Man",
  in: "Indija",
  io: "Britanski Indijskooceanski teritorij",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italija",
  je: "Jersey",
  jm: "Jamajka",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenija",
  kg: "Kirgistan",
  kh: "Kambodža",
  ki: "Kiribati",
  km: "Komori",
  kn: "Sveti Kristofor i Nevis",
  kp: "Sjeverna Koreja",
  kr: "Južna Koreja",
  kw: "Kuvajt",
  ky: "Kajmanski otoci",
  kz: "Kazahstan",
  la: "Laos",
  lb: "Libanon",
  lc: "Sveta Lucija",
  li: "Lihtenštajn",
  lk: "Šri Lanka",
  lr: "Liberija",
  ls: "Lesoto",
  lt: "Litva",
  lu: "Luksemburg",
  lv: "Latvija",
  ly: "Libija",
  ma: "Maroko",
  mc: "Monako",
  md: "Moldavija",
  me: "Crna Gora",
  mf: "Saint Martin",
  mg: "Madagaskar",
  mh: "Maršalovi Otoci",
  mk: "Sjeverna Makedonija",
  ml: "Mali",
  mm: "Mjanmar (Burma)",
  mn: "Mongolija",
  mo: "PUP Makao Kina",
  mp: "Sjevernomarijanski otoci",
  mq: "Martinique",
  mr: "Mauretanija",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauricijus",
  mv: "Maldivi",
  mw: "Malavi",
  mx: "Meksiko",
  my: "Malezija",
  mz: "Mozambik",
  na: "Namibija",
  nc: "Nova Kaledonija",
  ne: "Niger",
  nf: "Otok Norfolk",
  ng: "Nigerija",
  ni: "Nikaragva",
  nl: "Nizozemska",
  no: "Norveška",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Novi Zeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Francuska Polinezija",
  pg: "Papua Nova Gvineja",
  ph: "Filipini",
  pk: "Pakistan",
  pl: "Poljska",
  pm: "Saint-Pierre-et-Miquelon",
  pr: "Portoriko",
  ps: "Palestinsko područje",
  pt: "Portugal",
  pw: "Palau",
  py: "Paragvaj",
  qa: "Katar",
  re: "Réunion",
  ro: "Rumunjska",
  rs: "Srbija",
  ru: "Rusija",
  rw: "Ruanda",
  sa: "Saudijska Arabija",
  sb: "Salomonski Otoci",
  sc: "Sejšeli",
  sd: "Sudan",
  se: "Švedska",
  sg: "Singapur",
  sh: "Sveta Helena",
  si: "Slovenija",
  sj: "Svalbard i Jan Mayen",
  sk: "Slovačka",
  sl: "Sijera Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalija",
  sr: "Surinam",
  ss: "Južni Sudan",
  st: "Sveti Toma i Princip",
  sv: "Salvador",
  sx: "Sint Maarten",
  sy: "Sirija",
  sz: "Esvatini",
  tc: "Otoci Turks i Caicos",
  td: "Čad",
  tg: "Togo",
  th: "Tajland",
  tj: "Tadžikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunis",
  to: "Tonga",
  tr: "Turska",
  tt: "Trinidad i Tobago",
  tv: "Tuvalu",
  tw: "Tajvan",
  tz: "Tanzanija",
  ua: "Ukrajina",
  ug: "Uganda",
  us: "Sjedinjene Američke Države",
  uy: "Urugvaj",
  uz: "Uzbekistan",
  va: "Vatikanski Grad",
  vc: "Sveti Vincent i Grenadini",
  ve: "Venezuela",
  vg: "Britanski Djevičanski otoci",
  vi: "Američki Djevičanski otoci",
  vn: "Vijetnam",
  vu: "Vanuatu",
  wf: "Wallis i Futuna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Južnoafrička Republika",
  zm: "Zambija",
  zw: "Zimbabve"
}, xje = {
  selectedCountryAriaLabel: "Odabrana zemlja",
  noCountrySelected: "Zemlja nije odabrana",
  countryListAriaLabel: "Lista zemalja",
  searchPlaceholder: "Pretraži",
  zeroSearchResults: "Nema pronađenih rezultata",
  oneSearchResult: "Pronađen 1 rezultat",
  multipleSearchResults: "${count} rezultata pronađeno",
  // additional countries (not supported by country-list library)
  ac: "Ascension",
  xk: "Kosovo"
}, $je = { ...kje, ...xje }, Sje = {
  ad: "Andorra",
  ae: "Emirati Arabi Uniti",
  af: "Afghanistan",
  ag: "Antigua e Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "Samoa americane",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Isole Åland",
  az: "Azerbaigian",
  ba: "Bosnia ed Erzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgio",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint-Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caraibi olandesi",
  br: "Brasile",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Bielorussia",
  bz: "Belize",
  ca: "Canada",
  cc: "Isole Cocos (Keeling)",
  cd: "Congo - Kinshasa",
  cf: "Repubblica Centrafricana",
  cg: "Congo-Brazzaville",
  ch: "Svizzera",
  ci: "Costa d’Avorio",
  ck: "Isole Cook",
  cl: "Cile",
  cm: "Camerun",
  cn: "Cina",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Capo Verde",
  cw: "Curaçao",
  cx: "Isola Christmas",
  cy: "Cipro",
  cz: "Cechia",
  de: "Germania",
  dj: "Gibuti",
  dk: "Danimarca",
  dm: "Dominica",
  do: "Repubblica Dominicana",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egitto",
  eh: "Sahara occidentale",
  er: "Eritrea",
  es: "Spagna",
  et: "Etiopia",
  fi: "Finlandia",
  fj: "Figi",
  fk: "Isole Falkland",
  fm: "Micronesia",
  fo: "Isole Fær Øer",
  fr: "Francia",
  ga: "Gabon",
  gb: "Regno Unito",
  gd: "Grenada",
  ge: "Georgia",
  gf: "Guyana francese",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibilterra",
  gl: "Groenlandia",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadalupa",
  gq: "Guinea Equatoriale",
  gr: "Grecia",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "RAS di Hong Kong",
  hn: "Honduras",
  hr: "Croazia",
  ht: "Haiti",
  hu: "Ungheria",
  id: "Indonesia",
  ie: "Irlanda",
  il: "Israele",
  im: "Isola di Man",
  in: "India",
  io: "Territorio britannico dell’Oceano Indiano",
  iq: "Iraq",
  ir: "Iran",
  is: "Islanda",
  it: "Italia",
  je: "Jersey",
  jm: "Giamaica",
  jo: "Giordania",
  jp: "Giappone",
  ke: "Kenya",
  kg: "Kirghizistan",
  kh: "Cambogia",
  ki: "Kiribati",
  km: "Comore",
  kn: "Saint Kitts e Nevis",
  kp: "Corea del Nord",
  kr: "Corea del Sud",
  kw: "Kuwait",
  ky: "Isole Cayman",
  kz: "Kazakistan",
  la: "Laos",
  lb: "Libano",
  lc: "Saint Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Lituania",
  lu: "Lussemburgo",
  lv: "Lettonia",
  ly: "Libia",
  ma: "Marocco",
  mc: "Monaco",
  md: "Moldavia",
  me: "Montenegro",
  mf: "Saint Martin",
  mg: "Madagascar",
  mh: "Isole Marshall",
  mk: "Macedonia del Nord",
  ml: "Mali",
  mm: "Myanmar (Birmania)",
  mn: "Mongolia",
  mo: "RAS di Macao",
  mp: "Isole Marianne settentrionali",
  mq: "Martinica",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldive",
  mw: "Malawi",
  mx: "Messico",
  my: "Malaysia",
  mz: "Mozambico",
  na: "Namibia",
  nc: "Nuova Caledonia",
  ne: "Niger",
  nf: "Isola Norfolk",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Paesi Bassi",
  no: "Norvegia",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nuova Zelanda",
  om: "Oman",
  pa: "Panamá",
  pe: "Perù",
  pf: "Polinesia francese",
  pg: "Papua Nuova Guinea",
  ph: "Filippine",
  pk: "Pakistan",
  pl: "Polonia",
  pm: "Saint-Pierre e Miquelon",
  pr: "Portorico",
  ps: "Territori palestinesi",
  pt: "Portogallo",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Riunione",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russia",
  rw: "Ruanda",
  sa: "Arabia Saudita",
  sb: "Isole Salomone",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Svezia",
  sg: "Singapore",
  sh: "Sant’Elena",
  si: "Slovenia",
  sj: "Svalbard e Jan Mayen",
  sk: "Slovacchia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "Sud Sudan",
  st: "São Tomé e Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Siria",
  sz: "Swaziland",
  tc: "Isole Turks e Caicos",
  td: "Ciad",
  tg: "Togo",
  th: "Thailandia",
  tj: "Tagikistan",
  tk: "Tokelau",
  tl: "Timor Est",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Turchia",
  tt: "Trinidad e Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ucraina",
  ug: "Uganda",
  us: "Stati Uniti",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Città del Vaticano",
  vc: "Saint Vincent e Grenadine",
  ve: "Venezuela",
  vg: "Isole Vergini Britanniche",
  vi: "Isole Vergini Americane",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis e Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "Sudafrica",
  zm: "Zambia",
  zw: "Zimbabwe"
}, Cje = {
  selectedCountryAriaLabel: "Paese selezionato",
  noCountrySelected: "Nessun paese selezionato",
  countryListAriaLabel: "Elenco dei paesi",
  searchPlaceholder: "Ricerca",
  zeroSearchResults: "Nessun risultato trovato",
  oneSearchResult: "1 risultato trovato",
  multipleSearchResults: "${count} risultati trovati",
  // additional countries (not supported by country-list library)
  ac: "Isola di Ascensione",
  xk: "Kosovo"
}, Eje = { ...Sje, ...Cje }, zje = {
  ad: "Andorra",
  ae: "Verenigde Arabische Emiraten",
  af: "Afghanistan",
  ag: "Antigua en Barbuda",
  ai: "Anguilla",
  al: "Albanië",
  am: "Armenië",
  ao: "Angola",
  ar: "Argentinië",
  as: "Amerikaans-Samoa",
  at: "Oostenrijk",
  au: "Australië",
  aw: "Aruba",
  ax: "Åland",
  az: "Azerbeidzjan",
  ba: "Bosnië en Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "België",
  bf: "Burkina Faso",
  bg: "Bulgarije",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint-Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caribisch Nederland",
  br: "Brazilië",
  bs: "Bahama’s",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocoseilanden",
  cd: "Congo-Kinshasa",
  cf: "Centraal-Afrikaanse Republiek",
  cg: "Congo-Brazzaville",
  ch: "Zwitserland",
  ci: "Ivoorkust",
  ck: "Cookeilanden",
  cl: "Chili",
  cm: "Kameroen",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Kaapverdië",
  cw: "Curaçao",
  cx: "Christmaseiland",
  cy: "Cyprus",
  cz: "Tsjechië",
  de: "Duitsland",
  dj: "Djibouti",
  dk: "Denemarken",
  dm: "Dominica",
  do: "Dominicaanse Republiek",
  dz: "Algerije",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Egypte",
  eh: "Westelijke Sahara",
  er: "Eritrea",
  es: "Spanje",
  et: "Ethiopië",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falklandeilanden",
  fm: "Micronesia",
  fo: "Faeröer",
  fr: "Frankrijk",
  ga: "Gabon",
  gb: "Verenigd Koninkrijk",
  gd: "Grenada",
  ge: "Georgië",
  gf: "Frans-Guyana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Groenland",
  gm: "Gambia",
  gn: "Guinee",
  gp: "Guadeloupe",
  gq: "Equatoriaal-Guinea",
  gr: "Griekenland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinee-Bissau",
  gy: "Guyana",
  hk: "Hongkong SAR van China",
  hn: "Honduras",
  hr: "Kroatië",
  ht: "Haïti",
  hu: "Hongarije",
  id: "Indonesië",
  ie: "Ierland",
  il: "Israël",
  im: "Isle of Man",
  in: "India",
  io: "Brits Indische Oceaanterritorium",
  iq: "Irak",
  ir: "Iran",
  is: "IJsland",
  it: "Italië",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordanië",
  jp: "Japan",
  ke: "Kenia",
  kg: "Kirgizië",
  kh: "Cambodja",
  ki: "Kiribati",
  km: "Comoren",
  kn: "Saint Kitts en Nevis",
  kp: "Noord-Korea",
  kr: "Zuid-Korea",
  kw: "Koeweit",
  ky: "Kaaimaneilanden",
  kz: "Kazachstan",
  la: "Laos",
  lb: "Libanon",
  lc: "Saint Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litouwen",
  lu: "Luxemburg",
  lv: "Letland",
  ly: "Libië",
  ma: "Marokko",
  mc: "Monaco",
  md: "Moldavië",
  me: "Montenegro",
  mf: "Saint-Martin",
  mg: "Madagaskar",
  mh: "Marshalleilanden",
  mk: "Noord-Macedonië",
  ml: "Mali",
  mm: "Myanmar (Birma)",
  mn: "Mongolië",
  mo: "Macau SAR van China",
  mp: "Noordelijke Marianen",
  mq: "Martinique",
  mr: "Mauritanië",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldiven",
  mw: "Malawi",
  mx: "Mexico",
  my: "Maleisië",
  mz: "Mozambique",
  na: "Namibië",
  nc: "Nieuw-Caledonië",
  ne: "Niger",
  nf: "Norfolk",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Nederland",
  no: "Noorwegen",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nieuw-Zeeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Frans-Polynesië",
  pg: "Papoea-Nieuw-Guinea",
  ph: "Filipijnen",
  pk: "Pakistan",
  pl: "Polen",
  pm: "Saint-Pierre en Miquelon",
  pr: "Puerto Rico",
  ps: "Palestijnse gebieden",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Roemenië",
  rs: "Servië",
  ru: "Rusland",
  rw: "Rwanda",
  sa: "Saoedi-Arabië",
  sb: "Salomonseilanden",
  sc: "Seychellen",
  sd: "Soedan",
  se: "Zweden",
  sg: "Singapore",
  sh: "Sint-Helena",
  si: "Slovenië",
  sj: "Spitsbergen en Jan Mayen",
  sk: "Slowakije",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalië",
  sr: "Suriname",
  ss: "Zuid-Soedan",
  st: "Sao Tomé en Principe",
  sv: "El Salvador",
  sx: "Sint-Maarten",
  sy: "Syrië",
  sz: "eSwatini",
  tc: "Turks- en Caicoseilanden",
  td: "Tsjaad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadzjikistan",
  tk: "Tokelau",
  tl: "Oost-Timor",
  tm: "Turkmenistan",
  tn: "Tunesië",
  to: "Tonga",
  tr: "Turkije",
  tt: "Trinidad en Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Oekraïne",
  ug: "Oeganda",
  us: "Verenigde Staten",
  uy: "Uruguay",
  uz: "Oezbekistan",
  va: "Vaticaanstad",
  vc: "Saint Vincent en de Grenadines",
  ve: "Venezuela",
  vg: "Britse Maagdeneilanden",
  vi: "Amerikaanse Maagdeneilanden",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis en Futuna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Zuid-Afrika",
  zm: "Zambia",
  zw: "Zimbabwe"
}, jje = {
  selectedCountryAriaLabel: "Geselecteerd land",
  noCountrySelected: "Geen land geselecteerd",
  countryListAriaLabel: "Lijst met landen",
  searchPlaceholder: "Zoekopdracht",
  zeroSearchResults: "Geen resultaten gevonden",
  oneSearchResult: "1 resultaat gevonden",
  multipleSearchResults: "${count} resultaten gevonden",
  // additional countries (not supported by country-list library)
  ac: "Ascension-eiland",
  xk: "Kosovo"
}, Um = { ...zje, ...jje }, Aje = {
  ad: "Andorra",
  ae: "Emirados Árabes Unidos",
  af: "Afeganistão",
  ag: "Antígua e Barbuda",
  ai: "Anguila",
  al: "Albânia",
  am: "Armênia",
  ao: "Angola",
  ar: "Argentina",
  as: "Samoa Americana",
  at: "Áustria",
  au: "Austrália",
  aw: "Aruba",
  ax: "Ilhas Aland",
  az: "Azerbaijão",
  ba: "Bósnia e Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Bélgica",
  bf: "Burquina Faso",
  bg: "Bulgária",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "São Bartolomeu",
  bm: "Bermudas",
  bn: "Brunei",
  bo: "Bolívia",
  bq: "Países Baixos Caribenhos",
  br: "Brasil",
  bs: "Bahamas",
  bt: "Butão",
  bw: "Botsuana",
  by: "Bielorrússia",
  bz: "Belize",
  ca: "Canadá",
  cc: "Ilhas Cocos (Keeling)",
  cd: "Congo - Kinshasa",
  cf: "República Centro-Africana",
  cg: "República do Congo",
  ch: "Suíça",
  ci: "Costa do Marfim",
  ck: "Ilhas Cook",
  cl: "Chile",
  cm: "Camarões",
  cn: "China",
  co: "Colômbia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cabo Verde",
  cw: "Curaçao",
  cx: "Ilha Christmas",
  cy: "Chipre",
  cz: "Tchéquia",
  de: "Alemanha",
  dj: "Djibuti",
  dk: "Dinamarca",
  dm: "Dominica",
  do: "República Dominicana",
  dz: "Argélia",
  ec: "Equador",
  ee: "Estônia",
  eg: "Egito",
  eh: "Saara Ocidental",
  er: "Eritreia",
  es: "Espanha",
  et: "Etiópia",
  fi: "Finlândia",
  fj: "Fiji",
  fk: "Ilhas Malvinas",
  fm: "Micronésia",
  fo: "Ilhas Faroe",
  fr: "França",
  ga: "Gabão",
  gb: "Reino Unido",
  gd: "Granada",
  ge: "Geórgia",
  gf: "Guiana Francesa",
  gg: "Guernsey",
  gh: "Gana",
  gi: "Gibraltar",
  gl: "Groenlândia",
  gm: "Gâmbia",
  gn: "Guiné",
  gp: "Guadalupe",
  gq: "Guiné Equatorial",
  gr: "Grécia",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guiné-Bissau",
  gy: "Guiana",
  hk: "Hong Kong, RAE da China",
  hn: "Honduras",
  hr: "Croácia",
  ht: "Haiti",
  hu: "Hungria",
  id: "Indonésia",
  ie: "Irlanda",
  il: "Israel",
  im: "Ilha de Man",
  in: "Índia",
  io: "Território Britânico do Oceano Índico",
  iq: "Iraque",
  ir: "Irã",
  is: "Islândia",
  it: "Itália",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordânia",
  jp: "Japão",
  ke: "Quênia",
  kg: "Quirguistão",
  kh: "Camboja",
  ki: "Quiribati",
  km: "Comores",
  kn: "São Cristóvão e Névis",
  kp: "Coreia do Norte",
  kr: "Coreia do Sul",
  kw: "Kuwait",
  ky: "Ilhas Cayman",
  kz: "Cazaquistão",
  la: "Laos",
  lb: "Líbano",
  lc: "Santa Lúcia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Libéria",
  ls: "Lesoto",
  lt: "Lituânia",
  lu: "Luxemburgo",
  lv: "Letônia",
  ly: "Líbia",
  ma: "Marrocos",
  mc: "Mônaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "São Martinho",
  mg: "Madagascar",
  mh: "Ilhas Marshall",
  mk: "Macedônia do Norte",
  ml: "Mali",
  mm: "Mianmar (Birmânia)",
  mn: "Mongólia",
  mo: "Macau, RAE da China",
  mp: "Ilhas Marianas do Norte",
  mq: "Martinica",
  mr: "Mauritânia",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Maurício",
  mv: "Maldivas",
  mw: "Malaui",
  mx: "México",
  my: "Malásia",
  mz: "Moçambique",
  na: "Namíbia",
  nc: "Nova Caledônia",
  ne: "Níger",
  nf: "Ilha Norfolk",
  ng: "Nigéria",
  ni: "Nicarágua",
  nl: "Países Baixos",
  no: "Noruega",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nova Zelândia",
  om: "Omã",
  pa: "Panamá",
  pe: "Peru",
  pf: "Polinésia Francesa",
  pg: "Papua-Nova Guiné",
  ph: "Filipinas",
  pk: "Paquistão",
  pl: "Polônia",
  pm: "São Pedro e Miquelão",
  pr: "Porto Rico",
  ps: "Territórios palestinos",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguai",
  qa: "Catar",
  re: "Reunião",
  ro: "Romênia",
  rs: "Sérvia",
  ru: "Rússia",
  rw: "Ruanda",
  sa: "Arábia Saudita",
  sb: "Ilhas Salomão",
  sc: "Seicheles",
  sd: "Sudão",
  se: "Suécia",
  sg: "Singapura",
  sh: "Santa Helena",
  si: "Eslovênia",
  sj: "Svalbard e Jan Mayen",
  sk: "Eslováquia",
  sl: "Serra Leoa",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somália",
  sr: "Suriname",
  ss: "Sudão do Sul",
  st: "São Tomé e Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Síria",
  sz: "Essuatíni",
  tc: "Ilhas Turcas e Caicos",
  td: "Chade",
  tg: "Togo",
  th: "Tailândia",
  tj: "Tadjiquistão",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turcomenistão",
  tn: "Tunísia",
  to: "Tonga",
  tr: "Turquia",
  tt: "Trinidad e Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzânia",
  ua: "Ucrânia",
  ug: "Uganda",
  us: "Estados Unidos",
  uy: "Uruguai",
  uz: "Uzbequistão",
  va: "Cidade do Vaticano",
  vc: "São Vicente e Granadinas",
  ve: "Venezuela",
  vg: "Ilhas Virgens Britânicas",
  vi: "Ilhas Virgens Americanas",
  vn: "Vietnã",
  vu: "Vanuatu",
  wf: "Wallis e Futuna",
  ws: "Samoa",
  ye: "Iêmen",
  yt: "Mayotte",
  za: "África do Sul",
  zm: "Zâmbia",
  zw: "Zimbábue"
}, Oje = {
  selectedCountryAriaLabel: "País selecionado",
  noCountrySelected: "Nenhum país selecionado",
  countryListAriaLabel: "Lista de países",
  searchPlaceholder: "Procurar",
  zeroSearchResults: "Nenhum resultado encontrado",
  oneSearchResult: "1 resultado encontrado",
  multipleSearchResults: "${count} resultados encontrados",
  // additional countries (not supported by country-list library)
  ac: "Ilha de Ascensão",
  xk: "Kosovo"
}, Pje = { ...Aje, ...Oje }, Dje = {
  ad: "Andorra",
  ae: "Förenade Arabemiraten",
  af: "Afghanistan",
  ag: "Antigua och Barbuda",
  ai: "Anguilla",
  al: "Albanien",
  am: "Armenien",
  ao: "Angola",
  ar: "Argentina",
  as: "Amerikanska Samoa",
  at: "Österrike",
  au: "Australien",
  aw: "Aruba",
  ax: "Åland",
  az: "Azerbajdzjan",
  ba: "Bosnien och Hercegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgien",
  bf: "Burkina Faso",
  bg: "Bulgarien",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "S:t Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Karibiska Nederländerna",
  br: "Brasilien",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Vitryssland",
  bz: "Belize",
  ca: "Kanada",
  cc: "Kokosöarna",
  cd: "Kongo-Kinshasa",
  cf: "Centralafrikanska republiken",
  cg: "Kongo-Brazzaville",
  ch: "Schweiz",
  ci: "Côte d’Ivoire",
  ck: "Cooköarna",
  cl: "Chile",
  cm: "Kamerun",
  cn: "Kina",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Kuba",
  cv: "Kap Verde",
  cw: "Curaçao",
  cx: "Julön",
  cy: "Cypern",
  cz: "Tjeckien",
  de: "Tyskland",
  dj: "Djibouti",
  dk: "Danmark",
  dm: "Dominica",
  do: "Dominikanska republiken",
  dz: "Algeriet",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Egypten",
  eh: "Västsahara",
  er: "Eritrea",
  es: "Spanien",
  et: "Etiopien",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falklandsöarna",
  fm: "Mikronesien",
  fo: "Färöarna",
  fr: "Frankrike",
  ga: "Gabon",
  gb: "Storbritannien",
  gd: "Grenada",
  ge: "Georgien",
  gf: "Franska Guyana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Grönland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Ekvatorialguinea",
  gr: "Grekland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hongkong",
  hn: "Honduras",
  hr: "Kroatien",
  ht: "Haiti",
  hu: "Ungern",
  id: "Indonesien",
  ie: "Irland",
  il: "Israel",
  im: "Isle of Man",
  in: "Indien",
  io: "Brittiska territoriet i Indiska oceanen",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italien",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordanien",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kirgizistan",
  kh: "Kambodja",
  ki: "Kiribati",
  km: "Komorerna",
  kn: "S:t Kitts och Nevis",
  kp: "Nordkorea",
  kr: "Sydkorea",
  kw: "Kuwait",
  ky: "Caymanöarna",
  kz: "Kazakstan",
  la: "Laos",
  lb: "Libanon",
  lc: "S:t Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litauen",
  lu: "Luxemburg",
  lv: "Lettland",
  ly: "Libyen",
  ma: "Marocko",
  mc: "Monaco",
  md: "Moldavien",
  me: "Montenegro",
  mf: "Saint-Martin",
  mg: "Madagaskar",
  mh: "Marshallöarna",
  mk: "Nordmakedonien",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongoliet",
  mo: "Macao",
  mp: "Nordmarianerna",
  mq: "Martinique",
  mr: "Mauretanien",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldiverna",
  mw: "Malawi",
  mx: "Mexiko",
  my: "Malaysia",
  mz: "Moçambique",
  na: "Namibia",
  nc: "Nya Kaledonien",
  ne: "Niger",
  nf: "Norfolkön",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Nederländerna",
  no: "Norge",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nya Zeeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Franska Polynesien",
  pg: "Papua Nya Guinea",
  ph: "Filippinerna",
  pk: "Pakistan",
  pl: "Polen",
  pm: "S:t Pierre och Miquelon",
  pr: "Puerto Rico",
  ps: "Palestinska territorierna",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Rumänien",
  rs: "Serbien",
  ru: "Ryssland",
  rw: "Rwanda",
  sa: "Saudiarabien",
  sb: "Salomonöarna",
  sc: "Seychellerna",
  sd: "Sudan",
  se: "Sverige",
  sg: "Singapore",
  sh: "S:t Helena",
  si: "Slovenien",
  sj: "Svalbard och Jan Mayen",
  sk: "Slovakien",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Surinam",
  ss: "Sydsudan",
  st: "São Tomé och Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syrien",
  sz: "Swaziland",
  tc: "Turks- och Caicosöarna",
  td: "Tchad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadzjikistan",
  tk: "Tokelau",
  tl: "Östtimor",
  tm: "Turkmenistan",
  tn: "Tunisien",
  to: "Tonga",
  tr: "Turkiet",
  tt: "Trinidad och Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraina",
  ug: "Uganda",
  us: "USA",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Vatikanstaten",
  vc: "S:t Vincent och Grenadinerna",
  ve: "Venezuela",
  vg: "Brittiska Jungfruöarna",
  vi: "Amerikanska Jungfruöarna",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis- och Futunaöarna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Sydafrika",
  zm: "Zambia",
  zw: "Zimbabwe"
}, Nje = {
  selectedCountryAriaLabel: "Valt land",
  noCountrySelected: "Inget land valt",
  countryListAriaLabel: "Lista över länder",
  searchPlaceholder: "Sök",
  zeroSearchResults: "Inga resultat hittades",
  oneSearchResult: "1 resultat hittades",
  multipleSearchResults: "${count} resultat hittades",
  // additional countries (not supported by country-list library)
  ac: "Ascension",
  xk: "Kosovo"
}, Rje = { ...Dje, ...Nje }, Ije = {
  en: pje,
  fr: wje,
  it: Eje,
  es: _je,
  de: gje,
  da: cje,
  hr: $je,
  nb: Um,
  nl: Um,
  pt: Pje,
  sv: Rje
}, qm = {
  error: "is-error"
}, Hm = {
  error: {
    name: "error-warning-fill",
    color: "error"
  }
};
var Tje = [
  [
    "af",
    // Afghanistan
    "93"
  ],
  [
    "ax",
    // Åland Islands
    "358",
    1
  ],
  [
    "al",
    // Albania
    "355"
  ],
  [
    "dz",
    // Algeria
    "213"
  ],
  [
    "as",
    // American Samoa
    "1",
    5,
    ["684"]
  ],
  [
    "ad",
    // Andorra
    "376"
  ],
  [
    "ao",
    // Angola
    "244"
  ],
  [
    "ai",
    // Anguilla
    "1",
    6,
    ["264"]
  ],
  [
    "ag",
    // Antigua and Barbuda
    "1",
    7,
    ["268"]
  ],
  [
    "ar",
    // Argentina
    "54"
  ],
  [
    "am",
    // Armenia
    "374"
  ],
  [
    "aw",
    // Aruba
    "297"
  ],
  [
    "ac",
    // Ascension Island
    "247"
  ],
  [
    "au",
    // Australia
    "61",
    0,
    null,
    "0"
  ],
  [
    "at",
    // Austria
    "43"
  ],
  [
    "az",
    // Azerbaijan
    "994"
  ],
  [
    "bs",
    // Bahamas
    "1",
    8,
    ["242"]
  ],
  [
    "bh",
    // Bahrain
    "973"
  ],
  [
    "bd",
    // Bangladesh
    "880"
  ],
  [
    "bb",
    // Barbados
    "1",
    9,
    ["246"]
  ],
  [
    "by",
    // Belarus
    "375"
  ],
  [
    "be",
    // Belgium
    "32"
  ],
  [
    "bz",
    // Belize
    "501"
  ],
  [
    "bj",
    // Benin
    "229"
  ],
  [
    "bm",
    // Bermuda
    "1",
    10,
    ["441"]
  ],
  [
    "bt",
    // Bhutan
    "975"
  ],
  [
    "bo",
    // Bolivia
    "591"
  ],
  [
    "ba",
    // Bosnia and Herzegovina
    "387"
  ],
  [
    "bw",
    // Botswana
    "267"
  ],
  [
    "br",
    // Brazil
    "55"
  ],
  [
    "io",
    // British Indian Ocean Territory
    "246"
  ],
  [
    "vg",
    // British Virgin Islands
    "1",
    11,
    ["284"]
  ],
  [
    "bn",
    // Brunei
    "673"
  ],
  [
    "bg",
    // Bulgaria
    "359"
  ],
  [
    "bf",
    // Burkina Faso
    "226"
  ],
  [
    "bi",
    // Burundi
    "257"
  ],
  [
    "kh",
    // Cambodia
    "855"
  ],
  [
    "cm",
    // Cameroon
    "237"
  ],
  [
    "ca",
    // Canada
    "1",
    1,
    ["204", "226", "236", "249", "250", "263", "289", "306", "343", "354", "365", "367", "368", "382", "387", "403", "416", "418", "428", "431", "437", "438", "450", "584", "468", "474", "506", "514", "519", "548", "579", "581", "584", "587", "604", "613", "639", "647", "672", "683", "705", "709", "742", "753", "778", "780", "782", "807", "819", "825", "867", "873", "879", "902", "905"]
  ],
  [
    "cv",
    // Cape Verde
    "238"
  ],
  [
    "bq",
    // Caribbean Netherlands
    "599",
    1,
    ["3", "4", "7"]
  ],
  [
    "ky",
    // Cayman Islands
    "1",
    12,
    ["345"]
  ],
  [
    "cf",
    // Central African Republic
    "236"
  ],
  [
    "td",
    // Chad
    "235"
  ],
  [
    "cl",
    // Chile
    "56"
  ],
  [
    "cn",
    // China
    "86"
  ],
  [
    "cx",
    // Christmas Island
    "61",
    2,
    ["89164"],
    "0"
  ],
  [
    "cc",
    // Cocos (Keeling) Islands
    "61",
    1,
    ["89162"],
    "0"
  ],
  [
    "co",
    // Colombia
    "57"
  ],
  [
    "km",
    // Comoros
    "269"
  ],
  [
    "cg",
    // Congo (Brazzaville)
    "242"
  ],
  [
    "cd",
    // Congo (Kinshasa)
    "243"
  ],
  [
    "ck",
    // Cook Islands
    "682"
  ],
  [
    "cr",
    // Costa Rica
    "506"
  ],
  [
    "ci",
    // Côte d'Ivoire
    "225"
  ],
  [
    "hr",
    // Croatia
    "385"
  ],
  [
    "cu",
    // Cuba
    "53"
  ],
  [
    "cw",
    // Curaçao
    "599",
    0
  ],
  [
    "cy",
    // Cyprus
    "357"
  ],
  [
    "cz",
    // Czech Republic
    "420"
  ],
  [
    "dk",
    // Denmark
    "45"
  ],
  [
    "dj",
    // Djibouti
    "253"
  ],
  [
    "dm",
    // Dominica
    "1",
    13,
    ["767"]
  ],
  [
    "do",
    // Dominican Republic
    "1",
    2,
    ["809", "829", "849"]
  ],
  [
    "ec",
    // Ecuador
    "593"
  ],
  [
    "eg",
    // Egypt
    "20"
  ],
  [
    "sv",
    // El Salvador
    "503"
  ],
  [
    "gq",
    // Equatorial Guinea
    "240"
  ],
  [
    "er",
    // Eritrea
    "291"
  ],
  [
    "ee",
    // Estonia
    "372"
  ],
  [
    "sz",
    // Eswatini
    "268"
  ],
  [
    "et",
    // Ethiopia
    "251"
  ],
  [
    "fk",
    // Falkland Islands (Malvinas)
    "500"
  ],
  [
    "fo",
    // Faroe Islands
    "298"
  ],
  [
    "fj",
    // Fiji
    "679"
  ],
  [
    "fi",
    // Finland
    "358",
    0
  ],
  [
    "fr",
    // France
    "33"
  ],
  [
    "gf",
    // French Guiana
    "594"
  ],
  [
    "pf",
    // French Polynesia
    "689"
  ],
  [
    "ga",
    // Gabon
    "241"
  ],
  [
    "gm",
    // Gambia
    "220"
  ],
  [
    "ge",
    // Georgia
    "995"
  ],
  [
    "de",
    // Germany
    "49"
  ],
  [
    "gh",
    // Ghana
    "233"
  ],
  [
    "gi",
    // Gibraltar
    "350"
  ],
  [
    "gr",
    // Greece
    "30"
  ],
  [
    "gl",
    // Greenland
    "299"
  ],
  [
    "gd",
    // Grenada
    "1",
    14,
    ["473"]
  ],
  [
    "gp",
    // Guadeloupe
    "590",
    0
  ],
  [
    "gu",
    // Guam
    "1",
    15,
    ["671"]
  ],
  [
    "gt",
    // Guatemala
    "502"
  ],
  [
    "gg",
    // Guernsey
    "44",
    1,
    ["1481", "7781", "7839", "7911"],
    "0"
  ],
  [
    "gn",
    // Guinea
    "224"
  ],
  [
    "gw",
    // Guinea-Bissau
    "245"
  ],
  [
    "gy",
    // Guyana
    "592"
  ],
  [
    "ht",
    // Haiti
    "509"
  ],
  [
    "hn",
    // Honduras
    "504"
  ],
  [
    "hk",
    // Hong Kong SAR China
    "852"
  ],
  [
    "hu",
    // Hungary
    "36"
  ],
  [
    "is",
    // Iceland
    "354"
  ],
  [
    "in",
    // India
    "91"
  ],
  [
    "id",
    // Indonesia
    "62"
  ],
  [
    "ir",
    // Iran
    "98"
  ],
  [
    "iq",
    // Iraq
    "964"
  ],
  [
    "ie",
    // Ireland
    "353"
  ],
  [
    "im",
    // Isle of Man
    "44",
    2,
    ["1624", "74576", "7524", "7924", "7624"],
    "0"
  ],
  [
    "il",
    // Israel
    "972"
  ],
  [
    "it",
    // Italy
    "39",
    0
  ],
  [
    "jm",
    // Jamaica
    "1",
    4,
    ["876", "658"]
  ],
  [
    "jp",
    // Japan
    "81"
  ],
  [
    "je",
    // Jersey
    "44",
    3,
    ["1534", "7509", "7700", "7797", "7829", "7937"],
    "0"
  ],
  [
    "jo",
    // Jordan
    "962"
  ],
  [
    "kz",
    // Kazakhstan
    "7",
    1,
    ["33", "7"],
    "8"
  ],
  [
    "ke",
    // Kenya
    "254"
  ],
  [
    "ki",
    // Kiribati
    "686"
  ],
  [
    "xk",
    // Kosovo
    "383"
  ],
  [
    "kw",
    // Kuwait
    "965"
  ],
  [
    "kg",
    // Kyrgyzstan
    "996"
  ],
  [
    "la",
    // Laos
    "856"
  ],
  [
    "lv",
    // Latvia
    "371"
  ],
  [
    "lb",
    // Lebanon
    "961"
  ],
  [
    "ls",
    // Lesotho
    "266"
  ],
  [
    "lr",
    // Liberia
    "231"
  ],
  [
    "ly",
    // Libya
    "218"
  ],
  [
    "li",
    // Liechtenstein
    "423"
  ],
  [
    "lt",
    // Lithuania
    "370"
  ],
  [
    "lu",
    // Luxembourg
    "352"
  ],
  [
    "mo",
    // Macao SAR China
    "853"
  ],
  [
    "mg",
    // Madagascar
    "261"
  ],
  [
    "mw",
    // Malawi
    "265"
  ],
  [
    "my",
    // Malaysia
    "60"
  ],
  [
    "mv",
    // Maldives
    "960"
  ],
  [
    "ml",
    // Mali
    "223"
  ],
  [
    "mt",
    // Malta
    "356"
  ],
  [
    "mh",
    // Marshall Islands
    "692"
  ],
  [
    "mq",
    // Martinique
    "596"
  ],
  [
    "mr",
    // Mauritania
    "222"
  ],
  [
    "mu",
    // Mauritius
    "230"
  ],
  [
    "yt",
    // Mayotte
    "262",
    1,
    ["269", "639"],
    "0"
  ],
  [
    "mx",
    // Mexico
    "52"
  ],
  [
    "fm",
    // Micronesia
    "691"
  ],
  [
    "md",
    // Moldova
    "373"
  ],
  [
    "mc",
    // Monaco
    "377"
  ],
  [
    "mn",
    // Mongolia
    "976"
  ],
  [
    "me",
    // Montenegro
    "382"
  ],
  [
    "ms",
    // Montserrat
    "1",
    16,
    ["664"]
  ],
  [
    "ma",
    // Morocco
    "212",
    0,
    null,
    "0"
  ],
  [
    "mz",
    // Mozambique
    "258"
  ],
  [
    "mm",
    // Myanmar (Burma)
    "95"
  ],
  [
    "na",
    // Namibia
    "264"
  ],
  [
    "nr",
    // Nauru
    "674"
  ],
  [
    "np",
    // Nepal
    "977"
  ],
  [
    "nl",
    // Netherlands
    "31"
  ],
  [
    "nc",
    // New Caledonia
    "687"
  ],
  [
    "nz",
    // New Zealand
    "64"
  ],
  [
    "ni",
    // Nicaragua
    "505"
  ],
  [
    "ne",
    // Niger
    "227"
  ],
  [
    "ng",
    // Nigeria
    "234"
  ],
  [
    "nu",
    // Niue
    "683"
  ],
  [
    "nf",
    // Norfolk Island
    "672"
  ],
  [
    "kp",
    // North Korea
    "850"
  ],
  [
    "mk",
    // North Macedonia
    "389"
  ],
  [
    "mp",
    // Northern Mariana Islands
    "1",
    17,
    ["670"]
  ],
  [
    "no",
    // Norway
    "47",
    0
  ],
  [
    "om",
    // Oman
    "968"
  ],
  [
    "pk",
    // Pakistan
    "92"
  ],
  [
    "pw",
    // Palau
    "680"
  ],
  [
    "ps",
    // Palestinian Territories
    "970"
  ],
  [
    "pa",
    // Panama
    "507"
  ],
  [
    "pg",
    // Papua New Guinea
    "675"
  ],
  [
    "py",
    // Paraguay
    "595"
  ],
  [
    "pe",
    // Peru
    "51"
  ],
  [
    "ph",
    // Philippines
    "63"
  ],
  [
    "pl",
    // Poland
    "48"
  ],
  [
    "pt",
    // Portugal
    "351"
  ],
  [
    "pr",
    // Puerto Rico
    "1",
    3,
    ["787", "939"]
  ],
  [
    "qa",
    // Qatar
    "974"
  ],
  [
    "re",
    // Réunion
    "262",
    0,
    null,
    "0"
  ],
  [
    "ro",
    // Romania
    "40"
  ],
  [
    "ru",
    // Russia
    "7",
    0,
    null,
    "8"
  ],
  [
    "rw",
    // Rwanda
    "250"
  ],
  [
    "ws",
    // Samoa
    "685"
  ],
  [
    "sm",
    // San Marino
    "378"
  ],
  [
    "st",
    // São Tomé & Príncipe
    "239"
  ],
  [
    "sa",
    // Saudi Arabia
    "966"
  ],
  [
    "sn",
    // Senegal
    "221"
  ],
  [
    "rs",
    // Serbia
    "381"
  ],
  [
    "sc",
    // Seychelles
    "248"
  ],
  [
    "sl",
    // Sierra Leone
    "232"
  ],
  [
    "sg",
    // Singapore
    "65"
  ],
  [
    "sx",
    // Sint Maarten
    "1",
    21,
    ["721"]
  ],
  [
    "sk",
    // Slovakia
    "421"
  ],
  [
    "si",
    // Slovenia
    "386"
  ],
  [
    "sb",
    // Solomon Islands
    "677"
  ],
  [
    "so",
    // Somalia
    "252"
  ],
  [
    "za",
    // South Africa
    "27"
  ],
  [
    "kr",
    // South Korea
    "82"
  ],
  [
    "ss",
    // South Sudan
    "211"
  ],
  [
    "es",
    // Spain
    "34"
  ],
  [
    "lk",
    // Sri Lanka
    "94"
  ],
  [
    "bl",
    // St. Barthélemy
    "590",
    1
  ],
  [
    "sh",
    // St. Helena
    "290"
  ],
  [
    "kn",
    // St. Kitts & Nevis
    "1",
    18,
    ["869"]
  ],
  [
    "lc",
    // St. Lucia
    "1",
    19,
    ["758"]
  ],
  [
    "mf",
    // St. Martin
    "590",
    2
  ],
  [
    "pm",
    // St. Pierre & Miquelon
    "508"
  ],
  [
    "vc",
    // St. Vincent & Grenadines
    "1",
    20,
    ["784"]
  ],
  [
    "sd",
    // Sudan
    "249"
  ],
  [
    "sr",
    // Suriname
    "597"
  ],
  [
    "sj",
    // Svalbard & Jan Mayen
    "47",
    1,
    ["79"]
  ],
  [
    "se",
    // Sweden
    "46"
  ],
  [
    "ch",
    // Switzerland
    "41"
  ],
  [
    "sy",
    // Syria
    "963"
  ],
  [
    "tw",
    // Taiwan
    "886"
  ],
  [
    "tj",
    // Tajikistan
    "992"
  ],
  [
    "tz",
    // Tanzania
    "255"
  ],
  [
    "th",
    // Thailand
    "66"
  ],
  [
    "tl",
    // Timor-Leste
    "670"
  ],
  [
    "tg",
    // Togo
    "228"
  ],
  [
    "tk",
    // Tokelau
    "690"
  ],
  [
    "to",
    // Tonga
    "676"
  ],
  [
    "tt",
    // Trinidad & Tobago
    "1",
    22,
    ["868"]
  ],
  [
    "tn",
    // Tunisia
    "216"
  ],
  [
    "tr",
    // Turkey
    "90"
  ],
  [
    "tm",
    // Turkmenistan
    "993"
  ],
  [
    "tc",
    // Turks & Caicos Islands
    "1",
    23,
    ["649"]
  ],
  [
    "tv",
    // Tuvalu
    "688"
  ],
  [
    "vi",
    // U.S. Virgin Islands
    "1",
    24,
    ["340"]
  ],
  [
    "ug",
    // Uganda
    "256"
  ],
  [
    "ua",
    // Ukraine
    "380"
  ],
  [
    "ae",
    // United Arab Emirates
    "971"
  ],
  [
    "gb",
    // United Kingdom
    "44",
    0,
    null,
    "0"
  ],
  [
    "us",
    // United States
    "1",
    0
  ],
  [
    "uy",
    // Uruguay
    "598"
  ],
  [
    "uz",
    // Uzbekistan
    "998"
  ],
  [
    "vu",
    // Vanuatu
    "678"
  ],
  [
    "va",
    // Vatican City
    "39",
    1,
    ["06698"]
  ],
  [
    "ve",
    // Venezuela
    "58"
  ],
  [
    "vn",
    // Vietnam
    "84"
  ],
  [
    "wf",
    // Wallis & Futuna
    "681"
  ],
  [
    "eh",
    // Western Sahara
    "212",
    1,
    ["5288", "5289"],
    "0"
  ],
  [
    "ye",
    // Yemen
    "967"
  ],
  [
    "zm",
    // Zambia
    "260"
  ],
  [
    "zw",
    // Zimbabwe
    "263"
  ]
], kw = [];
for (const e of Tje)
  kw.push({
    name: "",
    // populated in the plugin
    iso2: e[0],
    dialCode: e[1],
    priority: e[2] || 0,
    areaCodes: e[3] || null,
    nodeById: {},
    // populated by the plugin
    nationalPrefix: e[4] || null
  });
var Fo = kw, Mje = {
  ad: "Andorra",
  ae: "United Arab Emirates",
  af: "Afghanistan",
  ag: "Antigua & Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "American Samoa",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Åland Islands",
  az: "Azerbaijan",
  ba: "Bosnia & Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgium",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "St. Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caribbean Netherlands",
  br: "Brazil",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocos (Keeling) Islands",
  cd: "Congo - Kinshasa",
  cf: "Central African Republic",
  cg: "Congo - Brazzaville",
  ch: "Switzerland",
  ci: "Côte d’Ivoire",
  ck: "Cook Islands",
  cl: "Chile",
  cm: "Cameroon",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cape Verde",
  cw: "Curaçao",
  cx: "Christmas Island",
  cy: "Cyprus",
  cz: "Czechia",
  de: "Germany",
  dj: "Djibouti",
  dk: "Denmark",
  dm: "Dominica",
  do: "Dominican Republic",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egypt",
  eh: "Western Sahara",
  er: "Eritrea",
  es: "Spain",
  et: "Ethiopia",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falkland Islands",
  fm: "Micronesia",
  fo: "Faroe Islands",
  fr: "France",
  ga: "Gabon",
  gb: "United Kingdom",
  gd: "Grenada",
  ge: "Georgia",
  gf: "French Guiana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Greenland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Equatorial Guinea",
  gr: "Greece",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hong Kong SAR China",
  hn: "Honduras",
  hr: "Croatia",
  ht: "Haiti",
  hu: "Hungary",
  id: "Indonesia",
  ie: "Ireland",
  il: "Israel",
  im: "Isle of Man",
  in: "India",
  io: "British Indian Ocean Territory",
  iq: "Iraq",
  ir: "Iran",
  is: "Iceland",
  it: "Italy",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kyrgyzstan",
  kh: "Cambodia",
  ki: "Kiribati",
  km: "Comoros",
  kn: "St. Kitts & Nevis",
  kp: "North Korea",
  kr: "South Korea",
  kw: "Kuwait",
  ky: "Cayman Islands",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Lebanon",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Lithuania",
  lu: "Luxembourg",
  lv: "Latvia",
  ly: "Libya",
  ma: "Morocco",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "St. Martin",
  mg: "Madagascar",
  mh: "Marshall Islands",
  mk: "North Macedonia",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongolia",
  mo: "Macao SAR China",
  mp: "Northern Mariana Islands",
  mq: "Martinique",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "New Caledonia",
  ne: "Niger",
  nf: "Norfolk Island",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Netherlands",
  no: "Norway",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "French Polynesia",
  pg: "Papua New Guinea",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Poland",
  pm: "St. Pierre & Miquelon",
  pr: "Puerto Rico",
  ps: "Palestinian Territories",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russia",
  rw: "Rwanda",
  sa: "Saudi Arabia",
  sb: "Solomon Islands",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Sweden",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenia",
  sj: "Svalbard & Jan Mayen",
  sk: "Slovakia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "South Sudan",
  st: "São Tomé & Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syria",
  sz: "Eswatini",
  tc: "Turks & Caicos Islands",
  td: "Chad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tajikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Turkey",
  tt: "Trinidad & Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "United States",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Vatican City",
  vc: "St. Vincent & Grenadines",
  ve: "Venezuela",
  vg: "British Virgin Islands",
  vi: "U.S. Virgin Islands",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis & Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "South Africa",
  zm: "Zambia",
  zw: "Zimbabwe"
}, Lje = Mje, Wje = {
  selectedCountryAriaLabel: "Change country, selected ${countryName} (${dialCode})",
  noCountrySelected: "Select country",
  countryListAriaLabel: "List of countries",
  searchPlaceholder: "Search",
  clearSearchAriaLabel: "Clear search",
  zeroSearchResults: "No results found",
  oneSearchResult: "1 result found",
  multipleSearchResults: "${count} results found",
  // additional countries (not supported by country-list library)
  ac: "Ascension Island",
  xk: "Kosovo"
}, Bje = Wje, Fje = { ...Lje, ...Bje }, xw = Fje, Ml = (e) => typeof window < "u" && typeof window.matchMedia == "function" && window.matchMedia(e).matches, Vje = () => {
  if (typeof navigator < "u" && typeof window < "u") {
    const e = /Android.+Mobile|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent), t = Ml("(max-width: 500px)"), a = Ml("(max-height: 600px)"), o = Ml("(pointer: coarse)");
    return e || t || o && a;
  }
  return !1;
}, $w = {
  // Allow alphanumeric "phonewords" (e.g. +1 800 FLOWERS) as valid numbers
  allowPhonewords: !1,
  //* Whether or not to allow the dropdown.
  allowDropdown: !0,
  //* Add a placeholder in the input with an example number for the selected country.
  autoPlaceholder: "polite",
  //* Modify the parentClass.
  containerClass: "",
  //* The order of the countries in the dropdown. Defaults to alphabetical.
  countryOrder: null,
  //* Add a country search input at the top of the dropdown.
  countrySearch: !0,
  //* Modify the auto placeholder.
  customPlaceholder: null,
  //* Append menu to specified element.
  dropdownContainer: null,
  //* Don't display these countries.
  excludeCountries: [],
  //* Fix the dropdown width to the input width (rather than being as wide as the longest country name).
  fixDropdownWidth: !0,
  //* Format the number as the user types
  formatAsYouType: !0,
  //* Format the input value during initialisation and on setNumber.
  formatOnDisplay: !0,
  //* geoIp lookup function.
  geoIpLookup: null,
  //* Inject a hidden input with the name returned from this function, and on submit, populate it with the result of getNumber.
  hiddenInput: null,
  //* Internationalise the plugin text e.g. search input placeholder, country names.
  i18n: {},
  //* Initial country.
  initialCountry: "",
  //* A function to load the utils script.
  loadUtils: null,
  //* National vs international formatting for numbers e.g. placeholders and displaying existing numbers.
  nationalMode: !0,
  //* Display only these countries.
  onlyCountries: [],
  //* Number type to use for placeholders.
  placeholderNumberType: "MOBILE",
  //* Show flags - for both the selected country, and in the country dropdown
  showFlags: !0,
  //* Display the international dial code next to the selected flag.
  separateDialCode: !1,
  //* Only allow certain chars e.g. a plus followed by numeric digits, and cap at max valid length.
  strictMode: !1,
  //* Use full screen popup instead of dropdown for country list.
  useFullscreenPopup: Vje(),
  //* The number type to enforce during validation.
  validationNumberTypes: ["MOBILE"]
};
function Uje(e) {
  e.useFullscreenPopup && (e.fixDropdownWidth = !1), e.onlyCountries.length === 1 && (e.initialCountry = e.onlyCountries[0]), e.separateDialCode && (e.nationalMode = !1), e.allowDropdown && !e.showFlags && !e.separateDialCode && (e.nationalMode = !1), e.useFullscreenPopup && !e.dropdownContainer && (e.dropdownContainer = document.body), e.i18n = { ...xw, ...e.i18n };
}
var gi = (e) => e.replace(/\D/g, ""), Sw = (e = "") => e.normalize("NFD").replace(/[\u0300-\u036f]/g, "").toLowerCase(), Ue = (e, t, a) => {
  const o = document.createElement(e);
  return t && Object.entries(t).forEach(([n, r]) => o.setAttribute(n, r)), a && a.appendChild(o), o;
};
function qje(e) {
  const { onlyCountries: t, excludeCountries: a } = e;
  if (t.length) {
    const o = t.map((n) => n.toLowerCase());
    return Fo.filter((n) => o.includes(n.iso2));
  } else if (a.length) {
    const o = a.map((n) => n.toLowerCase());
    return Fo.filter((n) => !o.includes(n.iso2));
  }
  return Fo;
}
function Hje(e, t) {
  for (const a of e) {
    const o = a.iso2.toLowerCase();
    t.i18n[o] && (a.name = t.i18n[o]);
  }
}
function Gje(e, t) {
  const a = /* @__PURE__ */ new Set();
  let o = 0;
  const n = {}, r = (i, s, l) => {
    if (!i || !s)
      return;
    s.length > o && (o = s.length), n.hasOwnProperty(s) || (n[s] = []);
    const c = n[s];
    if (c.includes(i))
      return;
    const u = l !== void 0 ? l : c.length;
    c[u] = i;
  };
  for (const i of e)
    a.has(i.dialCode) || a.add(i.dialCode), r(i.iso2, i.dialCode, i.priority);
  (t.onlyCountries.length || t.excludeCountries.length) && a.forEach((i) => {
    n[i] = n[i].filter(Boolean);
  });
  for (const i of e)
    if (i.areaCodes) {
      const s = n[i.dialCode][0];
      for (const l of i.areaCodes) {
        for (let c = 1; c < l.length; c++) {
          const u = l.substring(0, c), d = i.dialCode + u;
          r(s, d), r(i.iso2, d);
        }
        r(i.iso2, i.dialCode + l);
      }
    }
  return { dialCodes: a, dialCodeMaxLen: o, dialCodeToIso2Map: n };
}
function Kje(e, t) {
  t.countryOrder && (t.countryOrder = t.countryOrder.map((a) => a.toLowerCase())), e.sort((a, o) => {
    const { countryOrder: n } = t;
    if (n) {
      const r = n.indexOf(a.iso2), i = n.indexOf(o.iso2), s = r > -1, l = i > -1;
      if (s || l)
        return s && l ? r - i : s ? -1 : 1;
    }
    return a.name.localeCompare(o.name);
  });
}
function Jje(e) {
  for (const t of e)
    t.normalisedName = Sw(t.name), t.initials = t.name.split(/[^a-zA-ZÀ-ÿа-яА-Я]/).map((a) => a[0]).join("").toLowerCase(), t.dialCodePlus = `+${t.dialCode}`;
}
function Zje(e, t, a, o) {
  let n = e;
  if (a && t) {
    t = `+${o.dialCode}`;
    const r = n[t.length] === " " || n[t.length] === "-" ? t.length + 1 : t.length;
    n = n.substring(r);
  }
  return n;
}
function Yje(e, t, a, o, n) {
  const r = a ? a.formatNumberAsYouType(e, o.iso2) : e, { dialCode: i } = o;
  return n && t.charAt(0) !== "+" && r.includes(`+${i}`) ? (r.split(`+${i}`)[1] || "").trim() : r;
}
function Xje(e, t, a, o) {
  if (a === 0 && !o)
    return 0;
  let n = 0;
  for (let r = 0; r < t.length; r++) {
    if (/[+0-9]/.test(t[r]) && n++, n === e && !o)
      return r + 1;
    if (o && n === e + 1)
      return r;
  }
  return t.length;
}
var Qje = [
  "800",
  "822",
  "833",
  "844",
  "855",
  "866",
  "877",
  "880",
  "881",
  "882",
  "883",
  "884",
  "885",
  "886",
  "887",
  "888",
  "889"
], Gm = (e) => {
  const t = gi(e);
  if (t.charAt(0) === "1") {
    const a = t.substring(1, 4);
    return Qje.includes(a);
  }
  return !1;
};
for (const e of Fo)
  e.name = xw[e.iso2];
var eAe = 0, tAe = new Set(Fo.map((e) => e.iso2)), Ll = (e) => tAe.has(e), Nn = (e, ...t) => {
  const { instances: a } = ie;
  Object.values(a).forEach((o) => o[e](...t));
}, aAe = class Bc {
  /**
   * Build a space-delimited class string from an object map of className -> truthy/falsey.
   * Only keys with truthy values are included.
   */
  static _buildClassNames(t) {
    return Object.keys(t).filter((a) => !!t[a]).join(" ");
  }
  constructor(t, a = {}) {
    this.id = eAe++, this.telInput = t, this.highlightedItem = null, this.options = Object.assign({}, $w, a), this.hadInitialPlaceholder = !!t.getAttribute("placeholder");
  }
  _detectEnvironmentAndLayout() {
    this.isAndroid = typeof navigator < "u" ? /Android/i.test(navigator.userAgent) : !1, this.isRTL = !!this.telInput.closest("[dir=rtl]"), this.telInput.dir = "ltr";
    const t = this.options.allowDropdown || this.options.separateDialCode;
    this.showSelectedCountryOnLeft = this.isRTL ? !t : t, this.options.separateDialCode && (this.isRTL ? this.originalPaddingRight = this.telInput.style.paddingRight : this.originalPaddingLeft = this.telInput.style.paddingLeft);
  }
  _createInitPromises() {
    const t = new Promise((o, n) => {
      this.resolveAutoCountryPromise = o, this.rejectAutoCountryPromise = n;
    }), a = new Promise((o, n) => {
      this.resolveUtilsScriptPromise = o, this.rejectUtilsScriptPromise = n;
    });
    this.promise = Promise.all([t, a]);
  }
  //* Can't be private as it's called from intlTelInput convenience wrapper.
  _init() {
    Uje(this.options), this._detectEnvironmentAndLayout(), this._createInitPromises(), this.selectedCountryData = {}, this._processCountryData(), this._generateMarkup(), this._setInitialState(), this._initListeners(), this._initRequests();
  }
  //********************
  //*  PRIVATE METHODS
  //********************
  //* Prepare all of the country data, including onlyCountries, excludeCountries, countryOrder options.
  _processCountryData() {
    this.countries = qje(this.options);
    const t = Gje(this.countries, this.options);
    this.dialCodes = t.dialCodes, this.dialCodeMaxLen = t.dialCodeMaxLen, this.dialCodeToIso2Map = t.dialCodeToIso2Map, Hje(this.countries, this.options), Kje(this.countries, this.options), this.countryByIso2 = new Map(this.countries.map((a) => [a.iso2, a])), Jje(this.countries);
  }
  //* Generate all of the markup for the plugin: the selected country overlay, and the dropdown.
  _generateMarkup() {
    this._prepareTelInput();
    const t = this._createWrapperAndInsert();
    this._maybeBuildCountryContainer(t), t.appendChild(this.telInput), this._maybeUpdateInputPaddingAndReveal(), this._maybeBuildHiddenInputs(t);
  }
  _prepareTelInput() {
    this.telInput.classList.add("iti__tel-input"), !this.telInput.hasAttribute("autocomplete") && !(this.telInput.form && this.telInput.form.hasAttribute("autocomplete")) && this.telInput.setAttribute("autocomplete", "off");
  }
  _createWrapperAndInsert() {
    const {
      allowDropdown: t,
      showFlags: a,
      containerClass: o,
      useFullscreenPopup: n
    } = this.options, r = Bc._buildClassNames({
      iti: !0,
      "iti--allow-dropdown": t,
      "iti--show-flags": a,
      "iti--inline-dropdown": !n,
      [o]: !!o
    }), i = Ue("div", { class: r });
    return this.telInput.parentNode?.insertBefore(i, this.telInput), i;
  }
  _maybeBuildCountryContainer(t) {
    const {
      allowDropdown: a,
      separateDialCode: o,
      showFlags: n
    } = this.options;
    if (a || n || o) {
      this.countryContainer = Ue(
        "div",
        // visibly hidden until we measure it's width to set the input padding correctly
        { class: "iti__country-container iti__v-hide" },
        t
      ), this.showSelectedCountryOnLeft ? this.countryContainer.style.left = "0px" : this.countryContainer.style.right = "0px", a ? (this.selectedCountry = Ue(
        "button",
        {
          type: "button",
          class: "iti__selected-country",
          "aria-expanded": "false",
          "aria-label": this.options.i18n.noCountrySelected,
          "aria-haspopup": "dialog",
          "aria-controls": `iti-${this.id}__dropdown-content`
        },
        this.countryContainer
      ), this.telInput.disabled && this.selectedCountry.setAttribute("disabled", "true")) : this.selectedCountry = Ue(
        "div",
        { class: "iti__selected-country" },
        this.countryContainer
      );
      const r = Ue(
        "div",
        { class: "iti__selected-country-primary" },
        this.selectedCountry
      );
      this.selectedCountryInner = Ue(
        "div",
        { class: "iti__flag" },
        r
      ), a && (this.dropdownArrow = Ue(
        "div",
        { class: "iti__arrow", "aria-hidden": "true" },
        r
      )), o && (this.selectedDialCode = Ue(
        "div",
        { class: "iti__selected-dial-code", dir: "ltr" },
        this.selectedCountry
      )), a && this._buildDropdownContent();
    }
  }
  _buildDropdownContent() {
    const {
      fixDropdownWidth: t,
      useFullscreenPopup: a,
      countrySearch: o,
      i18n: n,
      dropdownContainer: r,
      containerClass: i
    } = this.options, s = t ? "" : "iti--flexible-dropdown-width";
    if (this.dropdownContent = Ue("div", {
      id: `iti-${this.id}__dropdown-content`,
      class: `iti__dropdown-content iti__hide ${s}`,
      role: "dialog",
      "aria-modal": "true"
    }), o && this._buildSearchUI(), this.countryList = Ue(
      "ul",
      {
        class: "iti__country-list",
        id: `iti-${this.id}__country-listbox`,
        role: "listbox",
        "aria-label": n.countryListAriaLabel
      },
      this.dropdownContent
    ), this._appendListItems(), o && this._updateSearchResultsA11yText(), r) {
      const l = Bc._buildClassNames({
        iti: !0,
        "iti--container": !0,
        "iti--fullscreen-popup": a,
        "iti--inline-dropdown": !a,
        [i]: !!i
      });
      this.dropdown = Ue("div", { class: l }), this.dropdown.appendChild(this.dropdownContent);
    } else
      this.countryContainer.appendChild(this.dropdownContent);
  }
  _buildSearchUI() {
    const { i18n: t } = this.options, a = Ue(
      "div",
      { class: "iti__search-input-wrapper" },
      this.dropdownContent
    );
    this.searchIcon = Ue(
      "span",
      {
        class: "iti__search-icon",
        "aria-hidden": "true"
      },
      a
    ), this.searchIcon.innerHTML = `
      <svg class="iti__search-icon-svg" width="14" height="14" viewBox="0 0 24 24" focusable="false" aria-hidden="true">
        <circle cx="11" cy="11" r="7" />
        <line x1="21" y1="21" x2="16.65" y2="16.65" />
      </svg>`, this.searchInput = Ue(
      "input",
      {
        id: `iti-${this.id}__search-input`,
        // Chrome says inputs need either a name or an id
        type: "search",
        class: "iti__search-input",
        placeholder: t.searchPlaceholder,
        // role=combobox + aria-autocomplete=list + aria-activedescendant allows maintaining focus on the search input while allowing users to navigate search results with up/down keyboard keys
        role: "combobox",
        "aria-expanded": "true",
        "aria-label": t.searchPlaceholder,
        "aria-controls": `iti-${this.id}__country-listbox`,
        "aria-autocomplete": "list",
        autocomplete: "off"
      },
      a
    ), this.searchClearButton = Ue(
      "button",
      {
        type: "button",
        class: "iti__search-clear iti__hide",
        "aria-label": t.clearSearchAriaLabel,
        tabindex: "-1"
      },
      a
    );
    const o = `iti-${this.id}-clear-mask`;
    this.searchClearButton.innerHTML = `
      <svg class="iti__search-clear-svg" width="12" height="12" viewBox="0 0 16 16" aria-hidden="true" focusable="false">
        <mask id="${o}" maskUnits="userSpaceOnUse">
          <rect width="16" height="16" fill="white" />
          <path d="M5.2 5.2 L10.8 10.8 M10.8 5.2 L5.2 10.8" stroke="black" stroke-linecap="round" class="iti__search-clear-x" />
        </mask>
        <circle cx="8" cy="8" r="8" class="iti__search-clear-bg" mask="url(#${o})" />
      </svg>`, this.searchResultsA11yText = Ue(
      "span",
      { class: "iti__a11y-text" },
      this.dropdownContent
    ), this.searchNoResults = Ue(
      "div",
      {
        class: "iti__no-results iti__hide",
        "aria-hidden": "true"
        // all a11y messaging happens in this.searchResultsA11yText
      },
      this.dropdownContent
    ), this.searchNoResults.textContent = t.zeroSearchResults;
  }
  _maybeUpdateInputPaddingAndReveal() {
    this.countryContainer && (this._updateInputPadding(), this.countryContainer.classList.remove("iti__v-hide"));
  }
  _maybeBuildHiddenInputs(t) {
    const { hiddenInput: a } = this.options;
    if (a) {
      const o = this.telInput.getAttribute("name") || "", n = a(o);
      if (n.phone) {
        const r = this.telInput.form?.querySelector(`input[name="${n.phone}"]`);
        r ? this.hiddenInput = r : (this.hiddenInput = Ue("input", {
          type: "hidden",
          name: n.phone
        }), t.appendChild(this.hiddenInput));
      }
      if (n.country) {
        const r = this.telInput.form?.querySelector(`input[name="${n.country}"]`);
        r ? this.hiddenInputCountry = r : (this.hiddenInputCountry = Ue("input", {
          type: "hidden",
          name: n.country
        }), t.appendChild(this.hiddenInputCountry));
      }
    }
  }
  //* For each country: add a country list item <li> to the countryList <ul> container.
  _appendListItems() {
    for (let t = 0; t < this.countries.length; t++) {
      const a = this.countries[t], o = t === 0 ? "iti__highlight" : "", n = Ue(
        "li",
        {
          id: `iti-${this.id}__item-${a.iso2}`,
          class: `iti__country ${o}`,
          tabindex: "-1",
          role: "option",
          "data-dial-code": a.dialCode,
          "data-country-code": a.iso2,
          "aria-selected": "false"
        },
        this.countryList
      );
      a.nodeById[this.id] = n;
      let r = "";
      this.options.showFlags && (r += `<div class='iti__flag iti__${a.iso2}'></div>`), r += `<span class='iti__country-name'>${a.name}</span>`, r += `<span class='iti__dial-code' dir='ltr'>+${a.dialCode}</span>`, n.insertAdjacentHTML("beforeend", r);
    }
  }
  //* Set the initial state of the input value and the selected country by:
  //* 1. Extracting a dial code from the given number
  //* 2. Using explicit initialCountry
  _setInitialState(t = !1) {
    const a = this.telInput.getAttribute("value"), o = this.telInput.value, n = a && a.charAt(0) === "+" && (!o || o.charAt(0) !== "+") ? a : o, r = this._getDialCode(n), i = Gm(n), { initialCountry: s, geoIpLookup: l } = this.options, c = s === "auto" && l;
    if (r && !i)
      this._updateCountryFromNumber(n);
    else if (!c || t) {
      const u = s ? s.toLowerCase() : "";
      Ll(u) ? this._setCountry(u) : r && i ? this._setCountry("us") : this._setCountry("");
    }
    n && this._updateValFromNumber(n);
  }
  //* Initialise the main event listeners: input keyup, and click selected country.
  _initListeners() {
    this._initTelInputListeners(), this.options.allowDropdown && this._initDropdownListeners(), (this.hiddenInput || this.hiddenInputCountry) && this.telInput.form && this._initHiddenInputListener();
  }
  //* Update hidden input on form submit.
  _initHiddenInputListener() {
    this._handleHiddenInputSubmit = () => {
      this.hiddenInput && (this.hiddenInput.value = this.getNumber()), this.hiddenInputCountry && (this.hiddenInputCountry.value = this.getSelectedCountryData().iso2 || "");
    }, this.telInput.form?.addEventListener(
      "submit",
      this._handleHiddenInputSubmit
    );
  }
  //* initialise the dropdown listeners.
  _initDropdownListeners() {
    this._handleLabelClick = (a) => {
      this.dropdownContent.classList.contains("iti__hide") ? this.telInput.focus() : a.preventDefault();
    };
    const t = this.telInput.closest("label");
    t && t.addEventListener("click", this._handleLabelClick), this._handleClickSelectedCountry = () => {
      this.dropdownContent.classList.contains("iti__hide") && !this.telInput.disabled && !this.telInput.readOnly && this._openDropdown();
    }, this.selectedCountry.addEventListener("click", this._handleClickSelectedCountry), this._handleCountryContainerKeydown = (a) => {
      this.dropdownContent.classList.contains("iti__hide") && ["ArrowUp", "ArrowDown", " ", "Enter"].includes(a.key) && (a.preventDefault(), a.stopPropagation(), this._openDropdown()), a.key === "Tab" && this._closeDropdown();
    }, this.countryContainer.addEventListener(
      "keydown",
      this._handleCountryContainerKeydown
    );
  }
  //* Init many requests: utils script / geo ip lookup.
  _initRequests() {
    let { loadUtils: t, initialCountry: a, geoIpLookup: o } = this.options;
    t && !ie.utils ? (this._doAttachUtils = () => {
      ie.attachUtils(t)?.catch(() => {
      });
    }, ie.documentReady() ? this._doAttachUtils() : (this._handlePageLoad = () => {
      this._doAttachUtils();
    }, window.addEventListener("load", this._handlePageLoad))) : this.resolveUtilsScriptPromise(), a === "auto" && o && !this.selectedCountryData.iso2 ? this._loadAutoCountry() : this.resolveAutoCountryPromise();
  }
  //* Perform the geo ip lookup.
  _loadAutoCountry() {
    ie.autoCountry ? this.handleAutoCountry() : ie.startedLoadingAutoCountry || (ie.startedLoadingAutoCountry = !0, typeof this.options.geoIpLookup == "function" && this.options.geoIpLookup(
      (t = "") => {
        const a = t.toLowerCase();
        Ll(a) ? (ie.autoCountry = a, setTimeout(() => Nn("handleAutoCountry"))) : (this._setInitialState(!0), Nn("rejectAutoCountryPromise"));
      },
      () => {
        this._setInitialState(!0), Nn("rejectAutoCountryPromise");
      }
    ));
  }
  _openDropdownWithPlus() {
    this._openDropdown(), this.searchInput.value = "+", this._filterCountries("");
  }
  //* Initialize the tel input listeners.
  _initTelInputListeners() {
    this._bindInputListener(), this._maybeBindKeydownListener(), this._maybeBindPasteListener();
  }
  _bindInputListener() {
    const { strictMode: t, formatAsYouType: a, separateDialCode: o, allowDropdown: n, countrySearch: r } = this.options;
    let i = !1;
    new RegExp("\\p{L}", "u").test(this.telInput.value) && (i = !0), this._handleInputEvent = (s) => {
      if (this.isAndroid && s?.data === "+" && o && n && r) {
        const d = this.telInput.selectionStart || 0, h = this.telInput.value.substring(0, d - 1), p = this.telInput.value.substring(d);
        this.telInput.value = h + p, this._openDropdownWithPlus();
        return;
      }
      this._updateCountryFromNumber(this.telInput.value) && this._triggerCountryChange();
      const l = s?.data && /[^+0-9]/.test(s.data), c = s?.inputType === "insertFromPaste" && this.telInput.value;
      l || c && !t ? i = !0 : /[^+0-9]/.test(this.telInput.value) || (i = !1);
      const u = s?.detail && s.detail.isSetNumber;
      if (a && !i && !u) {
        const d = this.telInput.selectionStart || 0, h = this.telInput.value.substring(0, d).replace(/[^+0-9]/g, "").length, p = s?.inputType === "deleteContentForward", f = this._getFullNumber(), m = Yje(
          f,
          this.telInput.value,
          ie.utils,
          this.selectedCountryData,
          this.options.separateDialCode
        ), b = Xje(h, m, d, p);
        this.telInput.value = m, this.telInput.setSelectionRange(b, b);
      }
    }, this.telInput.addEventListener("input", this._handleInputEvent);
  }
  _maybeBindKeydownListener() {
    const { strictMode: t, separateDialCode: a, allowDropdown: o, countrySearch: n } = this.options;
    (t || a) && (this._handleKeydownEvent = (r) => {
      if (r.key && r.key.length === 1 && !r.altKey && !r.ctrlKey && !r.metaKey) {
        if (a && o && n && r.key === "+") {
          r.preventDefault(), this._openDropdownWithPlus();
          return;
        }
        if (t) {
          const i = this.telInput.value, s = i.charAt(0) !== "+" && this.telInput.selectionStart === 0 && r.key === "+", l = /^[0-9]$/.test(r.key), c = a ? l : s || l, u = i.slice(0, this.telInput.selectionStart) + r.key + i.slice(this.telInput.selectionEnd), d = this._getFullNumber(u), h = ie.utils.getCoreNumber(d, this.selectedCountryData.iso2), p = this.maxCoreNumberLength && h.length > this.maxCoreNumberLength, f = this._getNewCountryFromNumber(d) !== null;
          (!c || p && !f && !s) && r.preventDefault();
        }
      }
    }, this.telInput.addEventListener("keydown", this._handleKeydownEvent));
  }
  _maybeBindPasteListener() {
    this.options.strictMode && (this._handlePasteEvent = (t) => {
      t.preventDefault();
      const a = this.telInput, o = a.selectionStart, n = a.selectionEnd, r = a.value.slice(0, o), i = a.value.slice(n), s = this.selectedCountryData.iso2, l = t.clipboardData.getData("text"), c = o === 0 && n > 0, u = !a.value.startsWith("+") || c, d = l.replace(/[^0-9+]/g, ""), h = d.startsWith("+"), p = d.replace(/\+/g, ""), f = h && u ? `+${p}` : p;
      let m = r + f + i, b = ie.utils.getCoreNumber(m, s);
      for (; b.length === 0 && m.length > 0; )
        m = m.slice(0, -1), b = ie.utils.getCoreNumber(m, s);
      if (!b)
        return;
      if (this.maxCoreNumberLength && b.length > this.maxCoreNumberLength)
        if (a.selectionEnd === a.value.length) {
          const _ = b.length - this.maxCoreNumberLength;
          m = m.slice(0, m.length - _);
        } else
          return;
      a.value = m;
      const w = o + f.length;
      a.setSelectionRange(w, w), a.dispatchEvent(new InputEvent("input", { bubbles: !0 }));
    }, this.telInput.addEventListener("paste", this._handlePasteEvent));
  }
  //* Adhere to the input's maxlength attr.
  _cap(t) {
    const a = parseInt(this.telInput.getAttribute("maxlength") || "", 10);
    return a && t.length > a ? t.substring(0, a) : t;
  }
  //* Trigger a custom event on the input.
  _trigger(t, a = {}) {
    const o = new CustomEvent(t, {
      bubbles: !0,
      cancelable: !0,
      detail: a
    });
    this.telInput.dispatchEvent(o);
  }
  //* Open the dropdown.
  _openDropdown() {
    const { fixDropdownWidth: t, countrySearch: a } = this.options;
    if (t && (this.dropdownContent.style.width = `${this.telInput.offsetWidth}px`), this.dropdownContent.classList.remove("iti__hide"), this.selectedCountry.setAttribute("aria-expanded", "true"), this._setDropdownPosition(), a) {
      const o = this.countryList.firstElementChild;
      o && (this._highlightListItem(o, !1), this.countryList.scrollTop = 0), this.searchInput.focus();
    }
    this._bindDropdownListeners(), this.dropdownArrow.classList.add("iti__arrow--up"), this._trigger("open:countrydropdown");
  }
  //* Set the dropdown position
  _setDropdownPosition() {
    if (this.options.dropdownContainer && this.options.dropdownContainer.appendChild(this.dropdown), !this.options.useFullscreenPopup) {
      const t = this.telInput.getBoundingClientRect(), a = this.telInput.offsetHeight;
      this.options.dropdownContainer && (this.dropdown.style.top = `${t.top + a}px`, this.dropdown.style.left = `${t.left}px`, this._handleWindowScroll = () => this._closeDropdown(), window.addEventListener("scroll", this._handleWindowScroll));
    }
  }
  //* We only bind dropdown listeners when the dropdown is open.
  _bindDropdownListeners() {
    this._handleMouseoverCountryList = (o) => {
      const n = o.target?.closest(".iti__country");
      n && this._highlightListItem(n, !1);
    }, this.countryList.addEventListener(
      "mouseover",
      this._handleMouseoverCountryList
    ), this._handleClickCountryList = (o) => {
      const n = o.target?.closest(".iti__country");
      n && this._selectListItem(n);
    }, this.countryList.addEventListener("click", this._handleClickCountryList), this._handleClickOffToClose = (o) => {
      o.target.closest(`#iti-${this.id}__dropdown-content`) || this._closeDropdown();
    }, setTimeout(() => {
      document.documentElement.addEventListener(
        "click",
        this._handleClickOffToClose
      );
    }, 0);
    let t = "", a = null;
    if (this._handleKeydownOnDropdown = (o) => {
      ["ArrowUp", "ArrowDown", "Enter", "Escape"].includes(o.key) && (o.preventDefault(), o.stopPropagation(), o.key === "ArrowUp" || o.key === "ArrowDown" ? this._handleUpDownKey(o.key) : o.key === "Enter" ? this._handleEnterKey() : o.key === "Escape" && this._closeDropdown()), !this.options.countrySearch && /^[a-zA-ZÀ-ÿа-яА-Я ]$/.test(o.key) && (o.stopPropagation(), a && clearTimeout(a), t += o.key.toLowerCase(), this._searchForCountry(t), a = setTimeout(() => {
        t = "";
      }, 1e3));
    }, document.addEventListener("keydown", this._handleKeydownOnDropdown), this.options.countrySearch) {
      const o = () => {
        const r = this.searchInput.value.trim();
        this._filterCountries(r), this.searchInput.value ? this.searchClearButton.classList.remove("iti__hide") : this.searchClearButton.classList.add("iti__hide");
      };
      let n = null;
      this._handleSearchChange = () => {
        n && clearTimeout(n), n = setTimeout(() => {
          o(), n = null;
        }, 100);
      }, this.searchInput.addEventListener("input", this._handleSearchChange), this._handleSearchClear = () => {
        this.searchInput.value = "", this.searchInput.focus(), o();
      }, this.searchClearButton.addEventListener("click", this._handleSearchClear);
    }
  }
  //* Hidden search (countrySearch disabled): Find the first list item whose name starts with the query string.
  _searchForCountry(t) {
    for (const a of this.countries)
      if (a.name.substring(0, t.length).toLowerCase() === t) {
        const o = a.nodeById[this.id];
        this._highlightListItem(o, !1), this._scrollTo(o);
        break;
      }
  }
  //* Country search enabled: Filter the countries according to the search query.
  _filterCountries(t) {
    this.countryList.innerHTML = "";
    let a;
    t === "" ? a = this.countries : a = this._getMatchedCountries(t);
    let o = !0;
    for (const n of a) {
      const r = n.nodeById[this.id];
      r && (this.countryList.appendChild(r), o && (this._highlightListItem(r, !1), o = !1));
    }
    o ? (this._highlightListItem(null, !1), this.searchNoResults && this.searchNoResults.classList.remove("iti__hide")) : this.searchNoResults && this.searchNoResults.classList.add("iti__hide"), this.countryList.scrollTop = 0, this._updateSearchResultsA11yText();
  }
  _getMatchedCountries(t) {
    const a = Sw(t), o = [], n = [], r = [], i = [], s = [], l = [];
    for (const c of this.countries)
      c.iso2 === a ? o.push(c) : c.normalisedName.startsWith(a) ? n.push(c) : c.normalisedName.includes(a) ? r.push(c) : a === c.dialCode || a === c.dialCodePlus ? i.push(c) : c.dialCodePlus.includes(a) ? s.push(c) : c.initials.includes(a) && l.push(c);
    return [
      ...o.sort((c, u) => c.priority - u.priority),
      ...n.sort((c, u) => c.priority - u.priority),
      ...r.sort((c, u) => c.priority - u.priority),
      ...i.sort((c, u) => c.priority - u.priority),
      ...s.sort((c, u) => c.priority - u.priority),
      ...l.sort((c, u) => c.priority - u.priority)
    ];
  }
  //* Update search results text (for a11y).
  _updateSearchResultsA11yText() {
    const { i18n: t } = this.options, a = this.countryList.childElementCount;
    let o;
    a === 0 ? o = t.zeroSearchResults : t.searchResultsText ? o = t.searchResultsText(a) : a === 1 ? o = t.oneSearchResult : o = t.multipleSearchResults.replace("${count}", a.toString()), this.searchResultsA11yText.textContent = o;
  }
  //* Highlight the next/prev item in the list (and ensure it is visible).
  _handleUpDownKey(t) {
    let a = t === "ArrowUp" ? this.highlightedItem?.previousElementSibling : this.highlightedItem?.nextElementSibling;
    !a && this.countryList.childElementCount > 1 && (a = t === "ArrowUp" ? this.countryList.lastElementChild : this.countryList.firstElementChild), a && (this._scrollTo(a), this._highlightListItem(a, !1));
  }
  //* Select the currently highlighted item.
  _handleEnterKey() {
    this.highlightedItem && this._selectListItem(this.highlightedItem);
  }
  //* Update the input's value to the given val (format first if possible)
  //* NOTE: this is called from _setInitialState, handleUtils and setNumber.
  _updateValFromNumber(t) {
    let a = t;
    if (this.options.formatOnDisplay && ie.utils && this.selectedCountryData) {
      const o = this.options.nationalMode || a.charAt(0) !== "+" && !this.options.separateDialCode, { NATIONAL: n, INTERNATIONAL: r } = ie.utils.numberFormat, i = o ? n : r;
      a = ie.utils.formatNumber(
        a,
        this.selectedCountryData.iso2,
        i
      );
    }
    a = this._beforeSetNumber(a), this.telInput.value = a;
  }
  //* Check if need to select a new country based on the given number
  //* Note: called from _setInitialState, keyup handler, setNumber.
  _updateCountryFromNumber(t) {
    const a = this._getNewCountryFromNumber(t);
    return a !== null ? this._setCountry(a) : !1;
  }
  _ensureHasDialCode(t) {
    const { dialCode: a, nationalPrefix: o } = this.selectedCountryData;
    if (t.charAt(0) === "+" || !a)
      return t;
    const n = o && t.charAt(0) === o && !this.options.separateDialCode ? t.substring(1) : t;
    return `+${a}${n}`;
  }
  // Get the country ISO2 code from the given number
  // BUT ONLY IF ITS CHANGED FROM THE CURRENTLY SELECTED COUNTRY
  // NOTE: consider refactoring this to be more clear
  _getNewCountryFromNumber(t) {
    const a = t.indexOf("+");
    let o = a ? t.substring(a) : t;
    const n = this.selectedCountryData.iso2, r = this.selectedCountryData.dialCode;
    o = this._ensureHasDialCode(o);
    const i = this._getDialCode(o, !0), s = gi(o);
    if (i) {
      const l = gi(i), c = this.dialCodeToIso2Map[l];
      if (c.length === 1)
        return c[0] === n ? null : c[0];
      if (!n && this.defaultCountry && c.includes(this.defaultCountry))
        return this.defaultCountry;
      if (r === "1" && Gm(s))
        return null;
      const u = this.selectedCountryData.areaCodes && s.length > l.length;
      if (!(n && c.includes(n) && !u))
        return c[0];
    } else {
      if (o.charAt(0) === "+" && s.length)
        return "";
      if ((!o || o === "+") && !n)
        return this.defaultCountry;
    }
    return null;
  }
  //* Remove highlighting from other list items and highlight the given item.
  _highlightListItem(t, a) {
    const o = this.highlightedItem;
    if (o && (o.classList.remove("iti__highlight"), o.setAttribute("aria-selected", "false")), this.highlightedItem = t, this.highlightedItem && (this.highlightedItem.classList.add("iti__highlight"), this.highlightedItem.setAttribute("aria-selected", "true"), this.options.countrySearch)) {
      const n = this.highlightedItem.getAttribute("id") || "";
      this.searchInput.setAttribute("aria-activedescendant", n);
    }
    a && this.highlightedItem.focus();
  }
  //* Update the selected country, dial code (if separateDialCode), placeholder, title, and active list item.
  //* Note: called from _setInitialState, _updateCountryFromNumber, _selectListItem, setCountry.
  _setCountry(t) {
    const { separateDialCode: a, showFlags: o, i18n: n } = this.options, r = this.selectedCountryData.iso2 || "";
    if (this.selectedCountryData = t ? this.countryByIso2.get(t) : {}, this.selectedCountryData.iso2 && (this.defaultCountry = this.selectedCountryData.iso2), this.selectedCountry) {
      const i = t && o ? `iti__flag iti__${t}` : "iti__flag iti__globe";
      let s, l;
      if (t) {
        const { name: c, dialCode: u } = this.selectedCountryData;
        l = c, s = n.selectedCountryAriaLabel.replace("${countryName}", c).replace("${dialCode}", `+${u}`);
      } else
        l = n.noCountrySelected, s = n.noCountrySelected;
      this.selectedCountryInner.className = i, this.selectedCountry.setAttribute("title", l), this.selectedCountry.setAttribute("aria-label", s);
    }
    if (a) {
      const i = this.selectedCountryData.dialCode ? `+${this.selectedCountryData.dialCode}` : "";
      this.selectedDialCode.innerHTML = i, this._updateInputPadding();
    }
    return this._updatePlaceholder(), this._updateMaxLength(), r !== t;
  }
  //* Update the input padding to make space for the selected country/dial code.
  _updateInputPadding() {
    if (this.selectedCountry) {
      const t = this.options.separateDialCode ? 78 : 42, a = (this.selectedCountry.offsetWidth || this._getHiddenSelectedCountryWidth() || t) + 6;
      this.showSelectedCountryOnLeft ? this.telInput.style.paddingLeft = `${a}px` : this.telInput.style.paddingRight = `${a}px`;
    }
  }
  //* Update the maximum valid number length for the currently selected country.
  _updateMaxLength() {
    const { strictMode: t, placeholderNumberType: a, validationNumberTypes: o } = this.options, { iso2: n } = this.selectedCountryData;
    if (t && ie.utils)
      if (n) {
        const r = ie.utils.numberType[a];
        let i = ie.utils.getExampleNumber(
          n,
          !1,
          r,
          !0
        ), s = i;
        for (; ie.utils.isPossibleNumber(i, n, o); )
          s = i, i += "0";
        const l = ie.utils.getCoreNumber(s, n);
        this.maxCoreNumberLength = l.length, n === "by" && (this.maxCoreNumberLength = l.length + 1);
      } else
        this.maxCoreNumberLength = null;
  }
  //* When input is in a hidden container during init, we cannot calculate the selected country width.
  //* Fix: clone the markup, make it invisible, add it to the end of the DOM, and then measure it's width.
  //* To get the right styling to apply, all we need is a shallow clone of the container,
  //* and then to inject a deep clone of the selectedCountry element.
  _getHiddenSelectedCountryWidth() {
    if (this.telInput.parentNode) {
      let t;
      try {
        t = window.top.document.body;
      } catch {
        t = document.body;
      }
      const a = this.telInput.parentNode.cloneNode(!1);
      a.style.visibility = "hidden", t.appendChild(a);
      const o = this.countryContainer.cloneNode();
      a.appendChild(o);
      const n = this.selectedCountry.cloneNode(!0);
      o.appendChild(n);
      const r = n.offsetWidth;
      return t.removeChild(a), r;
    }
    return 0;
  }
  //* Update the input placeholder to an example number from the currently selected country.
  _updatePlaceholder() {
    const {
      autoPlaceholder: t,
      placeholderNumberType: a,
      nationalMode: o,
      customPlaceholder: n
    } = this.options, r = t === "aggressive" || !this.hadInitialPlaceholder && t === "polite";
    if (ie.utils && r) {
      const i = ie.utils.numberType[a];
      let s = this.selectedCountryData.iso2 ? ie.utils.getExampleNumber(
        this.selectedCountryData.iso2,
        o,
        i
      ) : "";
      s = this._beforeSetNumber(s), typeof n == "function" && (s = n(s, this.selectedCountryData)), this.telInput.setAttribute("placeholder", s);
    }
  }
  //* Called when the user selects a list item from the dropdown.
  _selectListItem(t) {
    const a = t.getAttribute("data-country-code"), o = this._setCountry(a);
    this._closeDropdown();
    const n = t.getAttribute("data-dial-code");
    this._updateDialCode(n), this.options.formatOnDisplay && this._updateValFromNumber(this.telInput.value), this.telInput.focus(), o && this._triggerCountryChange();
  }
  //* Close the dropdown and unbind any listeners.
  _closeDropdown() {
    this.dropdownContent.classList.add("iti__hide"), this.selectedCountry.setAttribute("aria-expanded", "false"), this.highlightedItem && this.highlightedItem.setAttribute("aria-selected", "false"), this.options.countrySearch && this.searchInput.removeAttribute("aria-activedescendant"), this.dropdownArrow.classList.remove("iti__arrow--up"), this.options.countrySearch && (this.searchInput.removeEventListener("input", this._handleSearchChange), this.searchClearButton.removeEventListener("click", this._handleSearchClear)), document.removeEventListener("keydown", this._handleKeydownOnDropdown), document.documentElement.removeEventListener(
      "click",
      this._handleClickOffToClose
    ), this.countryList.removeEventListener(
      "mouseover",
      this._handleMouseoverCountryList
    ), this.countryList.removeEventListener("click", this._handleClickCountryList), this.options.dropdownContainer && (this.options.useFullscreenPopup || window.removeEventListener("scroll", this._handleWindowScroll), this.dropdown.parentNode && this.dropdown.parentNode.removeChild(this.dropdown)), this._trigger("close:countrydropdown");
  }
  //* Check if an element is visible within it's container, else scroll until it is.
  _scrollTo(t) {
    const a = this.countryList, o = document.documentElement.scrollTop, n = a.offsetHeight, r = a.getBoundingClientRect().top + o, i = r + n, s = t.offsetHeight, l = t.getBoundingClientRect().top + o, c = l + s, u = l - r + a.scrollTop;
    if (l < r)
      a.scrollTop = u;
    else if (c > i) {
      const d = n - s;
      a.scrollTop = u - d;
    }
  }
  //* Replace any existing dial code with the new one
  //* Note: called from _selectListItem and setCountry
  _updateDialCode(t) {
    const a = this.telInput.value, o = `+${t}`;
    let n;
    if (a.charAt(0) === "+") {
      const r = this._getDialCode(a);
      r ? n = a.replace(r, o) : n = o, this.telInput.value = n;
    }
  }
  //* Try and extract a valid international dial code from a full telephone number.
  //* Note: returns the raw string inc plus character and any whitespace/dots etc.
  _getDialCode(t, a) {
    let o = "";
    if (t.charAt(0) === "+") {
      let n = "";
      for (let r = 0; r < t.length; r++) {
        const i = t.charAt(r);
        if (/[0-9]/.test(i)) {
          if (n += i, a)
            this.dialCodeToIso2Map[n] && (o = t.substring(0, r + 1));
          else if (this.dialCodes.has(n)) {
            o = t.substring(0, r + 1);
            break;
          }
          if (n.length === this.dialCodeMaxLen)
            break;
        }
      }
    }
    return o;
  }
  //* Get the input val, adding the dial code if separateDialCode is enabled.
  _getFullNumber(t) {
    const a = t || this.telInput.value.trim(), { dialCode: o } = this.selectedCountryData;
    let n;
    const r = gi(a);
    return this.options.separateDialCode && a.charAt(0) !== "+" && o && r ? n = `+${o}` : n = "", n + a;
  }
  //* Remove the dial code if separateDialCode is enabled also cap the length if the input has a maxlength attribute
  _beforeSetNumber(t) {
    const a = this._getDialCode(t), o = Zje(
      t,
      a,
      this.options.separateDialCode,
      this.selectedCountryData
    );
    return this._cap(o);
  }
  //* Trigger the 'countrychange' event.
  _triggerCountryChange() {
    this._trigger("countrychange");
  }
  //**************************
  //*  SECRET PUBLIC METHODS
  //**************************
  //* This is called when the geoip call returns.
  handleAutoCountry() {
    this.options.initialCountry === "auto" && ie.autoCountry && (this.defaultCountry = ie.autoCountry, this.selectedCountryData.iso2 || this.selectedCountryInner.classList.contains("iti__globe") || this.setCountry(this.defaultCountry), this.resolveAutoCountryPromise());
  }
  //* This is called when the utils request completes.
  handleUtils() {
    ie.utils && (this.telInput.value && this._updateValFromNumber(this.telInput.value), this.selectedCountryData.iso2 && (this._updatePlaceholder(), this._updateMaxLength())), this.resolveUtilsScriptPromise();
  }
  //********************
  //*  PUBLIC METHODS
  //********************
  //* Remove plugin.
  destroy() {
    this.telInput.iti = void 0;
    const { allowDropdown: t, separateDialCode: a } = this.options;
    if (t) {
      this._closeDropdown(), this.selectedCountry.removeEventListener(
        "click",
        this._handleClickSelectedCountry
      ), this.countryContainer.removeEventListener(
        "keydown",
        this._handleCountryContainerKeydown
      );
      const r = this.telInput.closest("label");
      r && r.removeEventListener("click", this._handleLabelClick);
    }
    const { form: o } = this.telInput;
    this._handleHiddenInputSubmit && o && o.removeEventListener("submit", this._handleHiddenInputSubmit), this.telInput.removeEventListener("input", this._handleInputEvent), this._handleKeydownEvent && this.telInput.removeEventListener("keydown", this._handleKeydownEvent), this._handlePasteEvent && this.telInput.removeEventListener("paste", this._handlePasteEvent), this._handlePageLoad && window.removeEventListener("load", this._handlePageLoad), this.telInput.removeAttribute("data-intl-tel-input-id"), a && (this.isRTL ? this.telInput.style.paddingRight = this.originalPaddingRight : this.telInput.style.paddingLeft = this.originalPaddingLeft);
    const n = this.telInput.parentNode;
    n?.parentNode?.insertBefore(this.telInput, n), n?.parentNode?.removeChild(n), delete ie.instances[this.id];
  }
  //* Get the extension from the current number.
  getExtension() {
    return ie.utils ? ie.utils.getExtension(
      this._getFullNumber(),
      this.selectedCountryData.iso2
    ) : "";
  }
  //* Format the number to the given format.
  getNumber(t) {
    if (ie.utils) {
      const { iso2: a } = this.selectedCountryData;
      return ie.utils.formatNumber(
        this._getFullNumber(),
        a,
        t
      );
    }
    return "";
  }
  //* Get the type of the entered number e.g. landline/mobile.
  getNumberType() {
    return ie.utils ? ie.utils.getNumberType(
      this._getFullNumber(),
      this.selectedCountryData.iso2
    ) : -99;
  }
  //* Get the country data for the currently selected country.
  getSelectedCountryData() {
    return this.selectedCountryData;
  }
  //* Get the validation error.
  getValidationError() {
    if (ie.utils) {
      const { iso2: t } = this.selectedCountryData;
      return ie.utils.getValidationError(this._getFullNumber(), t);
    }
    return -99;
  }
  //* Validate the input val (with precise=false)
  isValidNumber() {
    return this._validateNumber(!1);
  }
  //* Validate the input val (with precise=true)
  isValidNumberPrecise() {
    return this._validateNumber(!0);
  }
  _utilsIsPossibleNumber(t) {
    return ie.utils ? ie.utils.isPossibleNumber(t, this.selectedCountryData.iso2, this.options.validationNumberTypes) : null;
  }
  //* Shared internal validation logic to handle alpha character extension rules.
  _validateNumber(t) {
    if (!this.selectedCountryData.iso2)
      return !1;
    const a = (r) => t ? this._utilsIsValidNumber(r) : this._utilsIsPossibleNumber(r), o = this._getFullNumber(), n = o.search(new RegExp("\\p{L}", "u"));
    if (n > -1 && !this.options.allowPhonewords) {
      const r = o.substring(0, n), i = a(r), s = a(o);
      return i && s;
    }
    return a(o);
  }
  _utilsIsValidNumber(t) {
    return ie.utils ? ie.utils.isValidNumber(t, this.selectedCountryData.iso2, this.options.validationNumberTypes) : null;
  }
  //* Update the selected country, and update the input val accordingly.
  setCountry(t) {
    const a = t?.toLowerCase();
    if (!Ll(a))
      throw new Error(`Invalid country code: '${a}'`);
    const o = this.selectedCountryData.iso2;
    (t && a !== o || !t && o) && (this._setCountry(a), this._updateDialCode(this.selectedCountryData.dialCode), this.options.formatOnDisplay && this._updateValFromNumber(this.telInput.value), this._triggerCountryChange());
  }
  //* Set the input value and update the country.
  setNumber(t) {
    const a = this._updateCountryFromNumber(t);
    this._updateValFromNumber(t), a && this._triggerCountryChange(), this._trigger("input", { isSetNumber: !0 });
  }
  //* Set the placeholder number typ
  setPlaceholderNumberType(t) {
    this.options.placeholderNumberType = t, this._updatePlaceholder();
  }
  setDisabled(t) {
    this.telInput.disabled = t, t ? this.selectedCountry.setAttribute("disabled", "true") : this.selectedCountry.removeAttribute("disabled");
  }
}, oAe = (e) => {
  if (!ie.utils && !ie.startedLoadingUtilsScript) {
    let t;
    if (typeof e == "function")
      try {
        t = Promise.resolve(e());
      } catch (a) {
        return Promise.reject(a);
      }
    else
      return Promise.reject(new TypeError(`The argument passed to attachUtils must be a function that returns a promise for the utilities module, not ${typeof e}`));
    return ie.startedLoadingUtilsScript = !0, t.then((a) => {
      const o = a?.default;
      if (!o || typeof o != "object")
        throw new TypeError("The loader function passed to attachUtils did not resolve to a module object with utils as its default export.");
      return ie.utils = o, Nn("handleUtils"), !0;
    }).catch((a) => {
      throw Nn("rejectUtilsScriptPromise", a), a;
    });
  }
  return null;
}, ie = Object.assign(
  (e, t) => {
    const a = new aAe(e, t);
    return a._init(), e.setAttribute("data-intl-tel-input-id", a.id.toString()), ie.instances[a.id] = a, e.iti = a, a;
  },
  {
    defaults: $w,
    //* Using a static var like this allows us to mock it in the tests.
    documentReady: () => document.readyState === "complete",
    //* Get the country data object.
    getCountryData: () => Fo,
    //* A getter for the plugin instance.
    getInstance: (e) => {
      const t = e.getAttribute("data-intl-tel-input-id");
      return t ? ie.instances[t] : null;
    },
    //* A map from instance ID to instance object.
    instances: {},
    attachUtils: oAe,
    startedLoadingUtilsScript: !1,
    startedLoadingAutoCountry: !1,
    version: "25.10.10"
  }
), nAe = ie, rAe = pt(function({
  initialValue: e = "",
  onChangeNumber: t = () => {
  },
  onChangeCountry: a = () => {
  },
  onChangeValidity: o = () => {
  },
  onChangeErrorCode: n = () => {
  },
  usePreciseValidation: r = !1,
  initOptions: i = {},
  inputProps: s = {},
  disabled: l = void 0
}, c) {
  const u = Ie(null), d = Ie(null);
  mx(c, () => ({
    getInstance: () => d.current,
    getInput: () => u.current
  }));
  const h = Me(() => {
    const p = d.current?.getNumber() || "", f = d.current?.getSelectedCountryData().iso2 || "";
    if (t(p), a(f), d.current)
      if (r ? d.current.isValidNumberPrecise() : d.current.isValidNumber())
        o(!0), n(null);
      else {
        const m = d.current.getValidationError();
        o(!1), n(m);
      }
  }, [a, n, t, o, r]);
  return Ce(() => (u.current && (d.current = nAe(u.current, i)), () => {
    d.current?.destroy();
  }), []), Ce(() => {
    const p = u.current;
    return p && (p.addEventListener("countrychange", h), d.current.promise.then(h)), () => {
      p && p.removeEventListener("countrychange", h);
    };
  }, [h]), Ce(() => {
    d.current && l !== void 0 && d.current.setDisabled(l);
  }, [l]), /* @__PURE__ */ ne.createElement(
    "input",
    {
      type: "tel",
      ref: u,
      onInput: h,
      defaultValue: e,
      ...s
    }
  );
}), iAe = rAe;
const Sa = {
  "phone-number": "_phone-number_1ni27_30",
  "is-full-width": "_is-full-width_1ni27_41",
  "group-label": "_group-label_1ni27_44",
  "helper-text": "_helper-text_1ni27_53",
  "is-disabled": "_is-disabled_1ni27_58",
  "is-error": "_is-error_1ni27_73",
  "is-success": "_is-success_1ni27_144",
  "container-icon": "_container-icon_1ni27_166",
  "dialog-overlay-show": "_dialog-overlay-show_1ni27_1",
  "dialog-content-show": "_dialog-content-show_1ni27_1",
  "dialog-content-slide-up": "_dialog-content-slide-up_1ni27_1"
};
pt(
  ({
    label: e,
    helperText: t,
    initialPhoneNumber: a,
    onChangePhoneNumber: o,
    initialCountry: n,
    onChangeCountry: r,
    locale: i = "en",
    message: s,
    status: l,
    disabled: c,
    isFullWidth: u,
    inputProps: d,
    setErrorCode: h,
    setIsValidPhoneNumber: p
  }, f) => {
    const { phoneNumber: m, country: b, handlePhoneNumberChange: w, handleCountryChange: _ } = ije({
      initialPhoneNumber: a,
      initialCountry: n,
      onChangePhoneNumber: o,
      onChangeCountry: r
    }), y = It(
      Sa["phone-number"],
      c && Sa["is-disabled"],
      l && Sa[qm[l]],
      u && Sa["is-full-width"]
    );
    return /* @__PURE__ */ T("div", { className: y, children: [
      /* @__PURE__ */ T("div", { className: Sa["group-label"], children: [
        e && /* @__PURE__ */ v("label", { children: e }),
        t && /* @__PURE__ */ v("div", { className: Sa["helper-text"], children: t })
      ] }),
      /* @__PURE__ */ v(
        iAe,
        {
          initialValue: m,
          onChangeErrorCode: h,
          onChangeValidity: p,
          onChangeCountry: _,
          onChangeNumber: w,
          inputProps: {
            disabled: c,
            "aria-label": d?.["aria-label"] || e,
            ...d
          },
          ref: f,
          initOptions: {
            strictMode: !0,
            initialCountry: b,
            i18n: Ije[i],
            useFullscreenPopup: !1,
            // Manually load the utils to prevent issues on SSR pages
            loadUtils: () => import("./utils-CJDvlpOH-DLsHHipy-DtXQX1OX.js")
          }
        }
      ),
      s && l && !c && /* @__PURE__ */ T("div", { className: Sa["container-icon"], children: [
        /* @__PURE__ */ v(Bn, { name: Hm[l].name, size: "medium", color: Hm[l].color }),
        /* @__PURE__ */ v("span", { className: Sa[qm[l]], children: s })
      ] })
    ] });
  }
);
function sAe(e, t = globalThis?.document) {
  const a = ut(e);
  g.useEffect(() => {
    const o = (n) => {
      n.key === "Escape" && a(n);
    };
    return t.addEventListener("keydown", o, { capture: !0 }), () => t.removeEventListener("keydown", o, { capture: !0 });
  }, [a, t]);
}
var lAe = "DismissableLayer", Fc = "dismissableLayer.update", cAe = "dismissableLayer.pointerDownOutside", uAe = "dismissableLayer.focusOutside", Km, Cw = g.createContext({
  layers: /* @__PURE__ */ new Set(),
  layersWithOutsidePointerEventsDisabled: /* @__PURE__ */ new Set(),
  branches: /* @__PURE__ */ new Set()
}), kd = g.forwardRef(
  (e, t) => {
    const {
      disableOutsidePointerEvents: a = !1,
      onEscapeKeyDown: o,
      onPointerDownOutside: n,
      onFocusOutside: r,
      onInteractOutside: i,
      onDismiss: s,
      ...l
    } = e, c = g.useContext(Cw), [u, d] = g.useState(null), h = u?.ownerDocument ?? globalThis?.document, [, p] = g.useState({}), f = Ne(t, ($) => d($)), m = Array.from(c.layers), [b] = [...c.layersWithOutsidePointerEventsDisabled].slice(-1), w = m.indexOf(b), _ = u ? m.indexOf(u) : -1, y = c.layersWithOutsidePointerEventsDisabled.size > 0, k = _ >= w, x = hAe(($) => {
      const E = $.target, C = [...c.branches].some((z) => z.contains(E));
      !k || C || (n?.($), i?.($), $.defaultPrevented || s?.());
    }, h), S = mAe(($) => {
      const E = $.target;
      [...c.branches].some((C) => C.contains(E)) || (r?.($), i?.($), $.defaultPrevented || s?.());
    }, h);
    return sAe(($) => {
      _ === c.layers.size - 1 && (o?.($), !$.defaultPrevented && s && ($.preventDefault(), s()));
    }, h), g.useEffect(() => {
      if (u)
        return a && (c.layersWithOutsidePointerEventsDisabled.size === 0 && (Km = h.body.style.pointerEvents, h.body.style.pointerEvents = "none"), c.layersWithOutsidePointerEventsDisabled.add(u)), c.layers.add(u), Jm(), () => {
          a && c.layersWithOutsidePointerEventsDisabled.size === 1 && (h.body.style.pointerEvents = Km);
        };
    }, [u, h, a, c]), g.useEffect(() => () => {
      u && (c.layers.delete(u), c.layersWithOutsidePointerEventsDisabled.delete(u), Jm());
    }, [u, c]), g.useEffect(() => {
      const $ = () => p({});
      return document.addEventListener(Fc, $), () => document.removeEventListener(Fc, $);
    }, []), /* @__PURE__ */ v(
      ye.div,
      {
        ...l,
        ref: f,
        style: {
          pointerEvents: y ? k ? "auto" : "none" : void 0,
          ...e.style
        },
        onFocusCapture: ve(e.onFocusCapture, S.onFocusCapture),
        onBlurCapture: ve(e.onBlurCapture, S.onBlurCapture),
        onPointerDownCapture: ve(
          e.onPointerDownCapture,
          x.onPointerDownCapture
        )
      }
    );
  }
);
kd.displayName = lAe;
var dAe = "DismissableLayerBranch", gAe = g.forwardRef((e, t) => {
  const a = g.useContext(Cw), o = g.useRef(null), n = Ne(t, o);
  return g.useEffect(() => {
    const r = o.current;
    if (r)
      return a.branches.add(r), () => {
        a.branches.delete(r);
      };
  }, [a.branches]), /* @__PURE__ */ v(ye.div, { ...e, ref: n });
});
gAe.displayName = dAe;
function hAe(e, t = globalThis?.document) {
  const a = ut(e), o = g.useRef(!1), n = g.useRef(() => {
  });
  return g.useEffect(() => {
    const r = (s) => {
      if (s.target && !o.current) {
        let l = function() {
          Ew(
            cAe,
            a,
            c,
            { discrete: !0 }
          );
        };
        const c = { originalEvent: s };
        s.pointerType === "touch" ? (t.removeEventListener("click", n.current), n.current = l, t.addEventListener("click", n.current, { once: !0 })) : l();
      } else
        t.removeEventListener("click", n.current);
      o.current = !1;
    }, i = window.setTimeout(() => {
      t.addEventListener("pointerdown", r);
    }, 0);
    return () => {
      window.clearTimeout(i), t.removeEventListener("pointerdown", r), t.removeEventListener("click", n.current);
    };
  }, [t, a]), {
    // ensures we check React component tree (not just DOM tree)
    onPointerDownCapture: () => o.current = !0
  };
}
function mAe(e, t = globalThis?.document) {
  const a = ut(e), o = g.useRef(!1);
  return g.useEffect(() => {
    const n = (r) => {
      r.target && !o.current && Ew(uAe, a, { originalEvent: r }, {
        discrete: !1
      });
    };
    return t.addEventListener("focusin", n), () => t.removeEventListener("focusin", n);
  }, [t, a]), {
    onFocusCapture: () => o.current = !0,
    onBlurCapture: () => o.current = !1
  };
}
function Jm() {
  const e = new CustomEvent(Fc);
  document.dispatchEvent(e);
}
function Ew(e, t, a, { discrete: o }) {
  const n = a.originalEvent.target, r = new CustomEvent(e, { bubbles: !1, cancelable: !0, detail: a });
  t && n.addEventListener(e, t, { once: !0 }), o ? Jze(n, r) : n.dispatchEvent(r);
}
var pAe = "Portal", fAe = g.forwardRef((e, t) => {
  const { container: a, ...o } = e, [n, r] = g.useState(!1);
  ot(() => r(!0), []);
  const i = a || n && globalThis?.document?.body;
  return i ? rs.createPortal(/* @__PURE__ */ v(ye.div, { ...o, ref: t }), i) : null;
});
fAe.displayName = pAe;
var Gt = function() {
  return Gt = Object.assign || function(e) {
    for (var t, a = 1, o = arguments.length; a < o; a++) {
      t = arguments[a];
      for (var n in t) Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
    }
    return e;
  }, Gt.apply(this, arguments);
};
function zw(e, t) {
  var a = {};
  for (var o in e) Object.prototype.hasOwnProperty.call(e, o) && t.indexOf(o) < 0 && (a[o] = e[o]);
  if (e != null && typeof Object.getOwnPropertySymbols == "function")
    for (var n = 0, o = Object.getOwnPropertySymbols(e); n < o.length; n++)
      t.indexOf(o[n]) < 0 && Object.prototype.propertyIsEnumerable.call(e, o[n]) && (a[o[n]] = e[o[n]]);
  return a;
}
function bAe(e, t, a) {
  for (var o = 0, n = t.length, r; o < n; o++)
    (r || !(o in t)) && (r || (r = Array.prototype.slice.call(t, 0, o)), r[o] = t[o]);
  return e.concat(r || Array.prototype.slice.call(t));
}
var Wl = "focusScope.autoFocusOnMount", Bl = "focusScope.autoFocusOnUnmount", Zm = { bubbles: !1, cancelable: !0 }, _Ae = "FocusScope", xd = g.forwardRef((e, t) => {
  const {
    loop: a = !1,
    trapped: o = !1,
    onMountAutoFocus: n,
    onUnmountAutoFocus: r,
    ...i
  } = e, [s, l] = g.useState(null), c = ut(n), u = ut(r), d = g.useRef(null), h = Ne(t, (m) => l(m)), p = g.useRef({
    paused: !1,
    pause() {
      this.paused = !0;
    },
    resume() {
      this.paused = !1;
    }
  }).current;
  g.useEffect(() => {
    if (o) {
      let m = function(y) {
        if (p.paused || !s) return;
        const k = y.target;
        s.contains(k) ? d.current = k : Aa(d.current, { select: !0 });
      }, b = function(y) {
        if (p.paused || !s) return;
        const k = y.relatedTarget;
        k !== null && (s.contains(k) || Aa(d.current, { select: !0 }));
      }, w = function(y) {
        if (document.activeElement === document.body)
          for (const k of y)
            k.removedNodes.length > 0 && Aa(s);
      };
      document.addEventListener("focusin", m), document.addEventListener("focusout", b);
      const _ = new MutationObserver(w);
      return s && _.observe(s, { childList: !0, subtree: !0 }), () => {
        document.removeEventListener("focusin", m), document.removeEventListener("focusout", b), _.disconnect();
      };
    }
  }, [o, s, p.paused]), g.useEffect(() => {
    if (s) {
      Xm.add(p);
      const m = document.activeElement;
      if (!s.contains(m)) {
        const b = new CustomEvent(Wl, Zm);
        s.addEventListener(Wl, c), s.dispatchEvent(b), b.defaultPrevented || (vAe($Ae(jw(s)), { select: !0 }), document.activeElement === m && Aa(s));
      }
      return () => {
        s.removeEventListener(Wl, c), setTimeout(() => {
          const b = new CustomEvent(Bl, Zm);
          s.addEventListener(Bl, u), s.dispatchEvent(b), b.defaultPrevented || Aa(m ?? document.body, { select: !0 }), s.removeEventListener(Bl, u), Xm.remove(p);
        }, 0);
      };
    }
  }, [s, c, u, p]);
  const f = g.useCallback(
    (m) => {
      if (!a && !o || p.paused) return;
      const b = m.key === "Tab" && !m.altKey && !m.ctrlKey && !m.metaKey, w = document.activeElement;
      if (b && w) {
        const _ = m.currentTarget, [y, k] = yAe(_);
        y && k ? !m.shiftKey && w === k ? (m.preventDefault(), a && Aa(y, { select: !0 })) : m.shiftKey && w === y && (m.preventDefault(), a && Aa(k, { select: !0 })) : w === _ && m.preventDefault();
      }
    },
    [a, o, p.paused]
  );
  return /* @__PURE__ */ v(ye.div, { tabIndex: -1, ...i, ref: h, onKeyDown: f });
});
xd.displayName = _Ae;
function vAe(e, { select: t = !1 } = {}) {
  const a = document.activeElement;
  for (const o of e)
    if (Aa(o, { select: t }), document.activeElement !== a) return;
}
function yAe(e) {
  const t = jw(e), a = Ym(t, e), o = Ym(t.reverse(), e);
  return [a, o];
}
function jw(e) {
  const t = [], a = document.createTreeWalker(e, NodeFilter.SHOW_ELEMENT, {
    acceptNode: (o) => {
      const n = o.tagName === "INPUT" && o.type === "hidden";
      return o.disabled || o.hidden || n ? NodeFilter.FILTER_SKIP : o.tabIndex >= 0 ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_SKIP;
    }
  });
  for (; a.nextNode(); ) t.push(a.currentNode);
  return t;
}
function Ym(e, t) {
  for (const a of e)
    if (!wAe(a, { upTo: t })) return a;
}
function wAe(e, { upTo: t }) {
  if (getComputedStyle(e).visibility === "hidden") return !0;
  for (; e; ) {
    if (t !== void 0 && e === t) return !1;
    if (getComputedStyle(e).display === "none") return !0;
    e = e.parentElement;
  }
  return !1;
}
function kAe(e) {
  return e instanceof HTMLInputElement && "select" in e;
}
function Aa(e, { select: t = !1 } = {}) {
  if (e && e.focus) {
    const a = document.activeElement;
    e.focus({ preventScroll: !0 }), e !== a && kAe(e) && t && e.select();
  }
}
var Xm = xAe();
function xAe() {
  let e = [];
  return {
    add(t) {
      const a = e[0];
      t !== a && a?.pause(), e = Qm(e, t), e.unshift(t);
    },
    remove(t) {
      e = Qm(e, t), e[0]?.resume();
    }
  };
}
function Qm(e, t) {
  const a = [...e], o = a.indexOf(t);
  return o !== -1 && a.splice(o, 1), a;
}
function $Ae(e) {
  return e.filter((t) => t.tagName !== "A");
}
var Fl = 0;
function Aw() {
  g.useEffect(() => {
    const e = document.querySelectorAll("[data-radix-focus-guard]");
    return document.body.insertAdjacentElement("afterbegin", e[0] ?? ep()), document.body.insertAdjacentElement("beforeend", e[1] ?? ep()), Fl++, () => {
      Fl === 1 && document.querySelectorAll("[data-radix-focus-guard]").forEach((t) => t.remove()), Fl--;
    };
  }, []);
}
function ep() {
  const e = document.createElement("span");
  return e.setAttribute("data-radix-focus-guard", ""), e.tabIndex = 0, e.style.outline = "none", e.style.opacity = "0", e.style.position = "fixed", e.style.pointerEvents = "none", e;
}
var hi = "right-scroll-bar-position", mi = "width-before-scroll-bar", SAe = "with-scroll-bars-hidden", CAe = "--removed-body-scroll-bar-size";
function Vl(e, t) {
  return typeof e == "function" ? e(t) : e && (e.current = t), e;
}
function EAe(e, t) {
  var a = Pe(function() {
    return {
      // value
      value: e,
      // last callback
      callback: t,
      // "memoized" public interface
      facade: {
        get current() {
          return a.value;
        },
        set current(o) {
          var n = a.value;
          n !== o && (a.value = o, a.callback(o, n));
        }
      }
    };
  })[0];
  return a.callback = t, a.facade;
}
var zAe = typeof window < "u" ? g.useLayoutEffect : g.useEffect, tp = /* @__PURE__ */ new WeakMap();
function jAe(e, t) {
  var a = EAe(null, function(o) {
    return e.forEach(function(n) {
      return Vl(n, o);
    });
  });
  return zAe(function() {
    var o = tp.get(a);
    if (o) {
      var n = new Set(o), r = new Set(e), i = a.current;
      n.forEach(function(s) {
        r.has(s) || Vl(s, null);
      }), r.forEach(function(s) {
        n.has(s) || Vl(s, i);
      });
    }
    tp.set(a, e);
  }, [e]), a;
}
function AAe(e) {
  return e;
}
function OAe(e, t) {
  t === void 0 && (t = AAe);
  var a = [], o = !1, n = {
    read: function() {
      if (o)
        throw new Error("Sidecar: could not `read` from an `assigned` medium. `read` could be used only with `useMedium`.");
      return a.length ? a[a.length - 1] : e;
    },
    useMedium: function(r) {
      var i = t(r, o);
      return a.push(i), function() {
        a = a.filter(function(s) {
          return s !== i;
        });
      };
    },
    assignSyncMedium: function(r) {
      for (o = !0; a.length; ) {
        var i = a;
        a = [], i.forEach(r);
      }
      a = {
        push: function(s) {
          return r(s);
        },
        filter: function() {
          return a;
        }
      };
    },
    assignMedium: function(r) {
      o = !0;
      var i = [];
      if (a.length) {
        var s = a;
        a = [], s.forEach(r), i = a;
      }
      var l = function() {
        var u = i;
        i = [], u.forEach(r);
      }, c = function() {
        return Promise.resolve().then(l);
      };
      c(), a = {
        push: function(u) {
          i.push(u), c();
        },
        filter: function(u) {
          return i = i.filter(u), a;
        }
      };
    }
  };
  return n;
}
function PAe(e) {
  e === void 0 && (e = {});
  var t = OAe(null);
  return t.options = Gt({ async: !0, ssr: !1 }, e), t;
}
var Ow = function(e) {
  var t = e.sideCar, a = zw(e, ["sideCar"]);
  if (!t)
    throw new Error("Sidecar: please provide `sideCar` property to import the right car");
  var o = t.read();
  if (!o)
    throw new Error("Sidecar medium not found");
  return g.createElement(o, Gt({}, a));
};
Ow.isSideCarExport = !0;
function DAe(e, t) {
  return e.useMedium(t), Ow;
}
var Pw = PAe(), Ul = function() {
}, Ls = g.forwardRef(function(e, t) {
  var a = g.useRef(null), o = g.useState({
    onScrollCapture: Ul,
    onWheelCapture: Ul,
    onTouchMoveCapture: Ul
  }), n = o[0], r = o[1], i = e.forwardProps, s = e.children, l = e.className, c = e.removeScrollBar, u = e.enabled, d = e.shards, h = e.sideCar, p = e.noIsolation, f = e.inert, m = e.allowPinchZoom, b = e.as, w = b === void 0 ? "div" : b, _ = e.gapMode, y = zw(e, ["forwardProps", "children", "className", "removeScrollBar", "enabled", "shards", "sideCar", "noIsolation", "inert", "allowPinchZoom", "as", "gapMode"]), k = h, x = jAe([a, t]), S = Gt(Gt({}, y), n);
  return g.createElement(
    g.Fragment,
    null,
    u && g.createElement(k, { sideCar: Pw, removeScrollBar: c, shards: d, noIsolation: p, inert: f, setCallbacks: r, allowPinchZoom: !!m, lockRef: a, gapMode: _ }),
    i ? g.cloneElement(g.Children.only(s), Gt(Gt({}, S), { ref: x })) : g.createElement(w, Gt({}, S, { className: l, ref: x }), s)
  );
});
Ls.defaultProps = {
  enabled: !0,
  removeScrollBar: !0,
  inert: !1
};
Ls.classNames = {
  fullWidth: mi,
  zeroRight: hi
};
var NAe = function() {
  if (typeof __webpack_nonce__ < "u")
    return __webpack_nonce__;
};
function RAe() {
  if (!document)
    return null;
  var e = document.createElement("style");
  e.type = "text/css";
  var t = NAe();
  return t && e.setAttribute("nonce", t), e;
}
function IAe(e, t) {
  e.styleSheet ? e.styleSheet.cssText = t : e.appendChild(document.createTextNode(t));
}
function TAe(e) {
  var t = document.head || document.getElementsByTagName("head")[0];
  t.appendChild(e);
}
var MAe = function() {
  var e = 0, t = null;
  return {
    add: function(a) {
      e == 0 && (t = RAe()) && (IAe(t, a), TAe(t)), e++;
    },
    remove: function() {
      e--, !e && t && (t.parentNode && t.parentNode.removeChild(t), t = null);
    }
  };
}, LAe = function() {
  var e = MAe();
  return function(t, a) {
    g.useEffect(function() {
      return e.add(t), function() {
        e.remove();
      };
    }, [t && a]);
  };
}, Dw = function() {
  var e = LAe(), t = function(a) {
    var o = a.styles, n = a.dynamic;
    return e(o, n), null;
  };
  return t;
}, WAe = {
  left: 0,
  top: 0,
  right: 0,
  gap: 0
}, ql = function(e) {
  return parseInt(e || "", 10) || 0;
}, BAe = function(e) {
  var t = window.getComputedStyle(document.body), a = t[e === "padding" ? "paddingLeft" : "marginLeft"], o = t[e === "padding" ? "paddingTop" : "marginTop"], n = t[e === "padding" ? "paddingRight" : "marginRight"];
  return [ql(a), ql(o), ql(n)];
}, FAe = function(e) {
  if (e === void 0 && (e = "margin"), typeof window > "u")
    return WAe;
  var t = BAe(e), a = document.documentElement.clientWidth, o = window.innerWidth;
  return {
    left: t[0],
    top: t[1],
    right: t[2],
    gap: Math.max(0, o - a + t[2] - t[0])
  };
}, VAe = Dw(), Vo = "data-scroll-locked", UAe = function(e, t, a, o) {
  var n = e.left, r = e.top, i = e.right, s = e.gap;
  return a === void 0 && (a = "margin"), `
  .`.concat(SAe, ` {
   overflow: hidden `).concat(o, `;
   padding-right: `).concat(s, "px ").concat(o, `;
  }
  body[`).concat(Vo, `] {
    overflow: hidden `).concat(o, `;
    overscroll-behavior: contain;
    `).concat([
    t && "position: relative ".concat(o, ";"),
    a === "margin" && `
    padding-left: `.concat(n, `px;
    padding-top: `).concat(r, `px;
    padding-right: `).concat(i, `px;
    margin-left:0;
    margin-top:0;
    margin-right: `).concat(s, "px ").concat(o, `;
    `),
    a === "padding" && "padding-right: ".concat(s, "px ").concat(o, ";")
  ].filter(Boolean).join(""), `
  }
  
  .`).concat(hi, ` {
    right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(mi, ` {
    margin-right: `).concat(s, "px ").concat(o, `;
  }
  
  .`).concat(hi, " .").concat(hi, ` {
    right: 0 `).concat(o, `;
  }
  
  .`).concat(mi, " .").concat(mi, ` {
    margin-right: 0 `).concat(o, `;
  }
  
  body[`).concat(Vo, `] {
    `).concat(CAe, ": ").concat(s, `px;
  }
`);
}, ap = function() {
  var e = parseInt(document.body.getAttribute(Vo) || "0", 10);
  return isFinite(e) ? e : 0;
}, qAe = function() {
  g.useEffect(function() {
    return document.body.setAttribute(Vo, (ap() + 1).toString()), function() {
      var e = ap() - 1;
      e <= 0 ? document.body.removeAttribute(Vo) : document.body.setAttribute(Vo, e.toString());
    };
  }, []);
}, HAe = function(e) {
  var t = e.noRelative, a = e.noImportant, o = e.gapMode, n = o === void 0 ? "margin" : o;
  qAe();
  var r = g.useMemo(function() {
    return FAe(n);
  }, [n]);
  return g.createElement(VAe, { styles: UAe(r, !t, n, a ? "" : "!important") });
}, Vc = !1;
if (typeof window < "u")
  try {
    var Lr = Object.defineProperty({}, "passive", {
      get: function() {
        return Vc = !0, !0;
      }
    });
    window.addEventListener("test", Lr, Lr), window.removeEventListener("test", Lr, Lr);
  } catch {
    Vc = !1;
  }
var Po = Vc ? { passive: !1 } : !1, GAe = function(e) {
  return e.tagName === "TEXTAREA";
}, Nw = function(e, t) {
  if (!(e instanceof Element))
    return !1;
  var a = window.getComputedStyle(e);
  return (
    // not-not-scrollable
    a[t] !== "hidden" && // contains scroll inside self
    !(a.overflowY === a.overflowX && !GAe(e) && a[t] === "visible")
  );
}, KAe = function(e) {
  return Nw(e, "overflowY");
}, JAe = function(e) {
  return Nw(e, "overflowX");
}, op = function(e, t) {
  var a = t.ownerDocument, o = t;
  do {
    typeof ShadowRoot < "u" && o instanceof ShadowRoot && (o = o.host);
    var n = Rw(e, o);
    if (n) {
      var r = Iw(e, o), i = r[1], s = r[2];
      if (i > s)
        return !0;
    }
    o = o.parentNode;
  } while (o && o !== a.body);
  return !1;
}, ZAe = function(e) {
  var t = e.scrollTop, a = e.scrollHeight, o = e.clientHeight;
  return [
    t,
    a,
    o
  ];
}, YAe = function(e) {
  var t = e.scrollLeft, a = e.scrollWidth, o = e.clientWidth;
  return [
    t,
    a,
    o
  ];
}, Rw = function(e, t) {
  return e === "v" ? KAe(t) : JAe(t);
}, Iw = function(e, t) {
  return e === "v" ? ZAe(t) : YAe(t);
}, XAe = function(e, t) {
  return e === "h" && t === "rtl" ? -1 : 1;
}, QAe = function(e, t, a, o, n) {
  var r = XAe(e, window.getComputedStyle(t).direction), i = r * o, s = a.target, l = t.contains(s), c = !1, u = i > 0, d = 0, h = 0;
  do {
    var p = Iw(e, s), f = p[0], m = p[1], b = p[2], w = m - b - r * f;
    (f || w) && Rw(e, s) && (d += w, h += f), s instanceof ShadowRoot ? s = s.host : s = s.parentNode;
  } while (
    // portaled content
    !l && s !== document.body || // self content
    l && (t.contains(s) || t === s)
  );
  return (u && Math.abs(d) < 1 || !u && Math.abs(h) < 1) && (c = !0), c;
}, Wr = function(e) {
  return "changedTouches" in e ? [e.changedTouches[0].clientX, e.changedTouches[0].clientY] : [0, 0];
}, np = function(e) {
  return [e.deltaX, e.deltaY];
}, rp = function(e) {
  return e && "current" in e ? e.current : e;
}, eOe = function(e, t) {
  return e[0] === t[0] && e[1] === t[1];
}, tOe = function(e) {
  return `
  .block-interactivity-`.concat(e, ` {pointer-events: none;}
  .allow-interactivity-`).concat(e, ` {pointer-events: all;}
`);
}, aOe = 0, Do = [];
function oOe(e) {
  var t = g.useRef([]), a = g.useRef([0, 0]), o = g.useRef(), n = g.useState(aOe++)[0], r = g.useState(Dw)[0], i = g.useRef(e);
  g.useEffect(function() {
    i.current = e;
  }, [e]), g.useEffect(function() {
    if (e.inert) {
      document.body.classList.add("block-interactivity-".concat(n));
      var m = bAe([e.lockRef.current], (e.shards || []).map(rp)).filter(Boolean);
      return m.forEach(function(b) {
        return b.classList.add("allow-interactivity-".concat(n));
      }), function() {
        document.body.classList.remove("block-interactivity-".concat(n)), m.forEach(function(b) {
          return b.classList.remove("allow-interactivity-".concat(n));
        });
      };
    }
  }, [e.inert, e.lockRef.current, e.shards]);
  var s = g.useCallback(function(m, b) {
    if ("touches" in m && m.touches.length === 2 || m.type === "wheel" && m.ctrlKey)
      return !i.current.allowPinchZoom;
    var w = Wr(m), _ = a.current, y = "deltaX" in m ? m.deltaX : _[0] - w[0], k = "deltaY" in m ? m.deltaY : _[1] - w[1], x, S = m.target, $ = Math.abs(y) > Math.abs(k) ? "h" : "v";
    if ("touches" in m && $ === "h" && S.type === "range")
      return !1;
    var E = op($, S);
    if (!E)
      return !0;
    if (E ? x = $ : (x = $ === "v" ? "h" : "v", E = op($, S)), !E)
      return !1;
    if (!o.current && "changedTouches" in m && (y || k) && (o.current = x), !x)
      return !0;
    var C = o.current || x;
    return QAe(C, b, m, C === "h" ? y : k);
  }, []), l = g.useCallback(function(m) {
    var b = m;
    if (!(!Do.length || Do[Do.length - 1] !== r)) {
      var w = "deltaY" in b ? np(b) : Wr(b), _ = t.current.filter(function(x) {
        return x.name === b.type && (x.target === b.target || b.target === x.shadowParent) && eOe(x.delta, w);
      })[0];
      if (_ && _.should) {
        b.cancelable && b.preventDefault();
        return;
      }
      if (!_) {
        var y = (i.current.shards || []).map(rp).filter(Boolean).filter(function(x) {
          return x.contains(b.target);
        }), k = y.length > 0 ? s(b, y[0]) : !i.current.noIsolation;
        k && b.cancelable && b.preventDefault();
      }
    }
  }, []), c = g.useCallback(function(m, b, w, _) {
    var y = { name: m, delta: b, target: w, should: _, shadowParent: nOe(w) };
    t.current.push(y), setTimeout(function() {
      t.current = t.current.filter(function(k) {
        return k !== y;
      });
    }, 1);
  }, []), u = g.useCallback(function(m) {
    a.current = Wr(m), o.current = void 0;
  }, []), d = g.useCallback(function(m) {
    c(m.type, np(m), m.target, s(m, e.lockRef.current));
  }, []), h = g.useCallback(function(m) {
    c(m.type, Wr(m), m.target, s(m, e.lockRef.current));
  }, []);
  g.useEffect(function() {
    return Do.push(r), e.setCallbacks({
      onScrollCapture: d,
      onWheelCapture: d,
      onTouchMoveCapture: h
    }), document.addEventListener("wheel", l, Po), document.addEventListener("touchmove", l, Po), document.addEventListener("touchstart", u, Po), function() {
      Do = Do.filter(function(m) {
        return m !== r;
      }), document.removeEventListener("wheel", l, Po), document.removeEventListener("touchmove", l, Po), document.removeEventListener("touchstart", u, Po);
    };
  }, []);
  var p = e.removeScrollBar, f = e.inert;
  return g.createElement(
    g.Fragment,
    null,
    f ? g.createElement(r, { styles: tOe(n) }) : null,
    p ? g.createElement(HAe, { gapMode: e.gapMode }) : null
  );
}
function nOe(e) {
  for (var t = null; e !== null; )
    e instanceof ShadowRoot && (t = e.host, e = e.host), e = e.parentNode;
  return t;
}
const rOe = DAe(Pw, oOe);
var $d = g.forwardRef(function(e, t) {
  return g.createElement(Ls, Gt({}, e, { ref: t, sideCar: rOe }));
});
$d.classNames = Ls.classNames;
var iOe = function(e) {
  if (typeof document > "u")
    return null;
  var t = Array.isArray(e) ? e[0] : e;
  return t.ownerDocument.body;
}, No = /* @__PURE__ */ new WeakMap(), Br = /* @__PURE__ */ new WeakMap(), Fr = {}, Hl = 0, Tw = function(e) {
  return e && (e.host || Tw(e.parentNode));
}, sOe = function(e, t) {
  return t.map(function(a) {
    if (e.contains(a))
      return a;
    var o = Tw(a);
    return o && e.contains(o) ? o : (console.error("aria-hidden", a, "in not contained inside", e, ". Doing nothing"), null);
  }).filter(function(a) {
    return !!a;
  });
}, lOe = function(e, t, a, o) {
  var n = sOe(t, Array.isArray(e) ? e : [e]);
  Fr[a] || (Fr[a] = /* @__PURE__ */ new WeakMap());
  var r = Fr[a], i = [], s = /* @__PURE__ */ new Set(), l = new Set(n), c = function(d) {
    !d || s.has(d) || (s.add(d), c(d.parentNode));
  };
  n.forEach(c);
  var u = function(d) {
    !d || l.has(d) || Array.prototype.forEach.call(d.children, function(h) {
      if (s.has(h))
        u(h);
      else
        try {
          var p = h.getAttribute(o), f = p !== null && p !== "false", m = (No.get(h) || 0) + 1, b = (r.get(h) || 0) + 1;
          No.set(h, m), r.set(h, b), i.push(h), m === 1 && f && Br.set(h, !0), b === 1 && h.setAttribute(a, "true"), f || h.setAttribute(o, "true");
        } catch (w) {
          console.error("aria-hidden: cannot operate on ", h, w);
        }
    });
  };
  return u(t), s.clear(), Hl++, function() {
    i.forEach(function(d) {
      var h = No.get(d) - 1, p = r.get(d) - 1;
      No.set(d, h), r.set(d, p), h || (Br.has(d) || d.removeAttribute(o), Br.delete(d)), p || d.removeAttribute(a);
    }), Hl--, Hl || (No = /* @__PURE__ */ new WeakMap(), No = /* @__PURE__ */ new WeakMap(), Br = /* @__PURE__ */ new WeakMap(), Fr = {});
  };
}, Mw = function(e, t, a) {
  a === void 0 && (a = "data-aria-hidden");
  var o = Array.from(Array.isArray(e) ? e : [e]), n = iOe(e);
  return n ? (o.push.apply(o, Array.from(n.querySelectorAll("[aria-live]"))), lOe(o, n, a, "aria-hidden")) : function() {
    return null;
  };
}, Lw = "Dialog", [Ww, git] = cr(Lw), [hit, aa] = Ww(Lw), Bw = "DialogTrigger", cOe = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = aa(Bw, a), r = Ne(t, n.triggerRef);
    return /* @__PURE__ */ v(
      ye.button,
      {
        type: "button",
        "aria-haspopup": "dialog",
        "aria-expanded": n.open,
        "aria-controls": n.contentId,
        "data-state": Cd(n.open),
        ...o,
        ref: r,
        onClick: ve(e.onClick, n.onOpenToggle)
      }
    );
  }
);
cOe.displayName = Bw;
var uOe = "DialogPortal", [mit, Fw] = Ww(uOe, {
  forceMount: void 0
}), Ui = "DialogOverlay", dOe = g.forwardRef(
  (e, t) => {
    const a = Fw(Ui, e.__scopeDialog), { forceMount: o = a.forceMount, ...n } = e, r = aa(Ui, e.__scopeDialog);
    return r.modal ? /* @__PURE__ */ v(yo, { present: o || r.open, children: /* @__PURE__ */ v(hOe, { ...n, ref: t }) }) : null;
  }
);
dOe.displayName = Ui;
var gOe = /* @__PURE__ */ Fn("DialogOverlay.RemoveScroll"), hOe = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = aa(Ui, a);
    return (
      // Make sure `Content` is scrollable even when it doesn't live inside `RemoveScroll`
      // ie. when `Overlay` and `Content` are siblings
      /* @__PURE__ */ v($d, { as: gOe, allowPinchZoom: !0, shards: [n.contentRef], children: /* @__PURE__ */ v(
        ye.div,
        {
          "data-state": Cd(n.open),
          ...o,
          ref: t,
          style: { pointerEvents: "auto", ...o.style }
        }
      ) })
    );
  }
), so = "DialogContent", mOe = g.forwardRef(
  (e, t) => {
    const a = Fw(so, e.__scopeDialog), { forceMount: o = a.forceMount, ...n } = e, r = aa(so, e.__scopeDialog);
    return /* @__PURE__ */ v(yo, { present: o || r.open, children: r.modal ? /* @__PURE__ */ v(pOe, { ...n, ref: t }) : /* @__PURE__ */ v(fOe, { ...n, ref: t }) });
  }
);
mOe.displayName = so;
var pOe = g.forwardRef(
  (e, t) => {
    const a = aa(so, e.__scopeDialog), o = g.useRef(null), n = Ne(t, a.contentRef, o);
    return g.useEffect(() => {
      const r = o.current;
      if (r) return Mw(r);
    }, []), /* @__PURE__ */ v(
      Vw,
      {
        ...e,
        ref: n,
        trapFocus: a.open,
        disableOutsidePointerEvents: !0,
        onCloseAutoFocus: ve(e.onCloseAutoFocus, (r) => {
          r.preventDefault(), a.triggerRef.current?.focus();
        }),
        onPointerDownOutside: ve(e.onPointerDownOutside, (r) => {
          const i = r.detail.originalEvent, s = i.button === 0 && i.ctrlKey === !0;
          (i.button === 2 || s) && r.preventDefault();
        }),
        onFocusOutside: ve(
          e.onFocusOutside,
          (r) => r.preventDefault()
        )
      }
    );
  }
), fOe = g.forwardRef(
  (e, t) => {
    const a = aa(so, e.__scopeDialog), o = g.useRef(!1), n = g.useRef(!1);
    return /* @__PURE__ */ v(
      Vw,
      {
        ...e,
        ref: t,
        trapFocus: !1,
        disableOutsidePointerEvents: !1,
        onCloseAutoFocus: (r) => {
          e.onCloseAutoFocus?.(r), r.defaultPrevented || (o.current || a.triggerRef.current?.focus(), r.preventDefault()), o.current = !1, n.current = !1;
        },
        onInteractOutside: (r) => {
          e.onInteractOutside?.(r), r.defaultPrevented || (o.current = !0, r.detail.originalEvent.type === "pointerdown" && (n.current = !0));
          const i = r.target;
          a.triggerRef.current?.contains(i) && r.preventDefault(), r.detail.originalEvent.type === "focusin" && n.current && r.preventDefault();
        }
      }
    );
  }
), Vw = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, trapFocus: o, onOpenAutoFocus: n, onCloseAutoFocus: r, ...i } = e, s = aa(so, a), l = g.useRef(null), c = Ne(t, l);
    return Aw(), /* @__PURE__ */ T(De, { children: [
      /* @__PURE__ */ v(
        xd,
        {
          asChild: !0,
          loop: !0,
          trapped: o,
          onMountAutoFocus: n,
          onUnmountAutoFocus: r,
          children: /* @__PURE__ */ v(
            kd,
            {
              role: "dialog",
              id: s.contentId,
              "aria-describedby": s.descriptionId,
              "aria-labelledby": s.titleId,
              "data-state": Cd(s.open),
              ...i,
              ref: c,
              onDismiss: () => s.onOpenChange(!1)
            }
          )
        }
      ),
      /* @__PURE__ */ T(De, { children: [
        /* @__PURE__ */ v(yOe, { titleId: s.titleId }),
        /* @__PURE__ */ v(kOe, { contentRef: l, descriptionId: s.descriptionId })
      ] })
    ] });
  }
), Sd = "DialogTitle", bOe = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = aa(Sd, a);
    return /* @__PURE__ */ v(ye.h2, { id: n.titleId, ...o, ref: t });
  }
);
bOe.displayName = Sd;
var Uw = "DialogDescription", _Oe = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = aa(Uw, a);
    return /* @__PURE__ */ v(ye.p, { id: n.descriptionId, ...o, ref: t });
  }
);
_Oe.displayName = Uw;
var qw = "DialogClose", vOe = g.forwardRef(
  (e, t) => {
    const { __scopeDialog: a, ...o } = e, n = aa(qw, a);
    return /* @__PURE__ */ v(
      ye.button,
      {
        type: "button",
        ...o,
        ref: t,
        onClick: ve(e.onClick, () => n.onOpenChange(!1))
      }
    );
  }
);
vOe.displayName = qw;
function Cd(e) {
  return e ? "open" : "closed";
}
var Hw = "DialogTitleWarning", [pit, Gw] = Bze(Hw, {
  contentName: so,
  titleName: Sd,
  docsSlug: "dialog"
}), yOe = ({ titleId: e }) => {
  const t = Gw(Hw), a = `\`${t.contentName}\` requires a \`${t.titleName}\` for the component to be accessible for screen reader users.

If you want to hide the \`${t.titleName}\`, you can wrap it with our VisuallyHidden component.

For more information, see https://radix-ui.com/primitives/docs/components/${t.docsSlug}`;
  return g.useEffect(() => {
    e && (document.getElementById(e) || console.error(a));
  }, [a, e]), null;
}, wOe = "DialogDescriptionWarning", kOe = ({ contentRef: e, descriptionId: t }) => {
  const a = `Warning: Missing \`Description\` or \`aria-describedby={undefined}\` for {${Gw(wOe).contentName}}.`;
  return g.useEffect(() => {
    const o = e.current?.getAttribute("aria-describedby");
    t && o && (document.getElementById(t) || console.warn(a));
  }, [a, e, t]), null;
};
function Uc(e, [t, a]) {
  return Math.min(a, Math.max(t, e));
}
function xOe(e, t) {
  return g.useReducer((a, o) => t[a][o] ?? a, e);
}
var Ed = "ScrollArea", [Kw, fit] = cr(Ed), [$Oe, Dt] = Kw(Ed), SOe = g.forwardRef(
  (e, t) => {
    const {
      __scopeScrollArea: a,
      type: o = "hover",
      dir: n,
      scrollHideDelay: r = 600,
      ...i
    } = e, [s, l] = g.useState(null), [c, u] = g.useState(null), [d, h] = g.useState(null), [p, f] = g.useState(null), [m, b] = g.useState(null), [w, _] = g.useState(0), [y, k] = g.useState(0), [x, S] = g.useState(!1), [$, E] = g.useState(!1), C = Ne(t, (R) => l(R)), z = Yze(n);
    return /* @__PURE__ */ v(
      $Oe,
      {
        scope: a,
        type: o,
        dir: z,
        scrollHideDelay: r,
        scrollArea: s,
        viewport: c,
        onViewportChange: u,
        content: d,
        onContentChange: h,
        scrollbarX: p,
        onScrollbarXChange: f,
        scrollbarXEnabled: x,
        onScrollbarXEnabledChange: S,
        scrollbarY: m,
        onScrollbarYChange: b,
        scrollbarYEnabled: $,
        onScrollbarYEnabledChange: E,
        onCornerWidthChange: _,
        onCornerHeightChange: k,
        children: /* @__PURE__ */ v(
          ye.div,
          {
            dir: z,
            ...i,
            ref: C,
            style: {
              position: "relative",
              // Pass corner sizes as CSS vars to reduce re-renders of context consumers
              "--radix-scroll-area-corner-width": w + "px",
              "--radix-scroll-area-corner-height": y + "px",
              ...e.style
            }
          }
        )
      }
    );
  }
);
SOe.displayName = Ed;
var Jw = "ScrollAreaViewport", COe = g.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: a, children: o, nonce: n, ...r } = e, i = Dt(Jw, a), s = g.useRef(null), l = Ne(t, s, i.onViewportChange);
    return /* @__PURE__ */ T(De, { children: [
      /* @__PURE__ */ v(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-scroll-area-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-scroll-area-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: n
        }
      ),
      /* @__PURE__ */ v(
        ye.div,
        {
          "data-radix-scroll-area-viewport": "",
          ...r,
          ref: l,
          style: {
            /**
             * We don't support `visible` because the intention is to have at least one scrollbar
             * if this component is used and `visible` will behave like `auto` in that case
             * https://developer.mozilla.org/en-US/docs/Web/CSS/overflow#description
             *
             * We don't handle `auto` because the intention is for the native implementation
             * to be hidden if using this component. We just want to ensure the node is scrollable
             * so could have used either `scroll` or `auto` here. We picked `scroll` to prevent
             * the browser from having to work out whether to render native scrollbars or not,
             * we tell it to with the intention of hiding them in CSS.
             */
            overflowX: i.scrollbarXEnabled ? "scroll" : "hidden",
            overflowY: i.scrollbarYEnabled ? "scroll" : "hidden",
            ...e.style
          },
          children: /* @__PURE__ */ v("div", { ref: i.onContentChange, style: { minWidth: "100%", display: "table" }, children: o })
        }
      )
    ] });
  }
);
COe.displayName = Jw;
var oa = "ScrollAreaScrollbar", EOe = g.forwardRef(
  (e, t) => {
    const { forceMount: a, ...o } = e, n = Dt(oa, e.__scopeScrollArea), { onScrollbarXEnabledChange: r, onScrollbarYEnabledChange: i } = n, s = e.orientation === "horizontal";
    return g.useEffect(() => (s ? r(!0) : i(!0), () => {
      s ? r(!1) : i(!1);
    }), [s, r, i]), n.type === "hover" ? /* @__PURE__ */ v(zOe, { ...o, ref: t, forceMount: a }) : n.type === "scroll" ? /* @__PURE__ */ v(jOe, { ...o, ref: t, forceMount: a }) : n.type === "auto" ? /* @__PURE__ */ v(Zw, { ...o, ref: t, forceMount: a }) : n.type === "always" ? /* @__PURE__ */ v(zd, { ...o, ref: t }) : null;
  }
);
EOe.displayName = oa;
var zOe = g.forwardRef((e, t) => {
  const { forceMount: a, ...o } = e, n = Dt(oa, e.__scopeScrollArea), [r, i] = g.useState(!1);
  return g.useEffect(() => {
    const s = n.scrollArea;
    let l = 0;
    if (s) {
      const c = () => {
        window.clearTimeout(l), i(!0);
      }, u = () => {
        l = window.setTimeout(() => i(!1), n.scrollHideDelay);
      };
      return s.addEventListener("pointerenter", c), s.addEventListener("pointerleave", u), () => {
        window.clearTimeout(l), s.removeEventListener("pointerenter", c), s.removeEventListener("pointerleave", u);
      };
    }
  }, [n.scrollArea, n.scrollHideDelay]), /* @__PURE__ */ v(yo, { present: a || r, children: /* @__PURE__ */ v(
    Zw,
    {
      "data-state": r ? "visible" : "hidden",
      ...o,
      ref: t
    }
  ) });
}), jOe = g.forwardRef((e, t) => {
  const { forceMount: a, ...o } = e, n = Dt(oa, e.__scopeScrollArea), r = e.orientation === "horizontal", i = Bs(() => l("SCROLL_END"), 100), [s, l] = xOe("hidden", {
    hidden: {
      SCROLL: "scrolling"
    },
    scrolling: {
      SCROLL_END: "idle",
      POINTER_ENTER: "interacting"
    },
    interacting: {
      SCROLL: "interacting",
      POINTER_LEAVE: "idle"
    },
    idle: {
      HIDE: "hidden",
      SCROLL: "scrolling",
      POINTER_ENTER: "interacting"
    }
  });
  return g.useEffect(() => {
    if (s === "idle") {
      const c = window.setTimeout(() => l("HIDE"), n.scrollHideDelay);
      return () => window.clearTimeout(c);
    }
  }, [s, n.scrollHideDelay, l]), g.useEffect(() => {
    const c = n.viewport, u = r ? "scrollLeft" : "scrollTop";
    if (c) {
      let d = c[u];
      const h = () => {
        const p = c[u];
        d !== p && (l("SCROLL"), i()), d = p;
      };
      return c.addEventListener("scroll", h), () => c.removeEventListener("scroll", h);
    }
  }, [n.viewport, r, l, i]), /* @__PURE__ */ v(yo, { present: a || s !== "hidden", children: /* @__PURE__ */ v(
    zd,
    {
      "data-state": s === "hidden" ? "hidden" : "visible",
      ...o,
      ref: t,
      onPointerEnter: ve(e.onPointerEnter, () => l("POINTER_ENTER")),
      onPointerLeave: ve(e.onPointerLeave, () => l("POINTER_LEAVE"))
    }
  ) });
}), Zw = g.forwardRef((e, t) => {
  const a = Dt(oa, e.__scopeScrollArea), { forceMount: o, ...n } = e, [r, i] = g.useState(!1), s = e.orientation === "horizontal", l = Bs(() => {
    if (a.viewport) {
      const c = a.viewport.offsetWidth < a.viewport.scrollWidth, u = a.viewport.offsetHeight < a.viewport.scrollHeight;
      i(s ? c : u);
    }
  }, 10);
  return en(a.viewport, l), en(a.content, l), /* @__PURE__ */ v(yo, { present: o || r, children: /* @__PURE__ */ v(
    zd,
    {
      "data-state": r ? "visible" : "hidden",
      ...n,
      ref: t
    }
  ) });
}), zd = g.forwardRef((e, t) => {
  const { orientation: a = "vertical", ...o } = e, n = Dt(oa, e.__scopeScrollArea), r = g.useRef(null), i = g.useRef(0), [s, l] = g.useState({
    content: 0,
    viewport: 0,
    scrollbar: { size: 0, paddingStart: 0, paddingEnd: 0 }
  }), c = Qw(s.viewport, s.content), u = {
    ...o,
    sizes: s,
    onSizesChange: l,
    hasThumb: c > 0 && c < 1,
    onThumbChange: (h) => r.current = h,
    onThumbPointerUp: () => i.current = 0,
    onThumbPointerDown: (h) => i.current = h
  };
  function d(h, p) {
    return TOe(h, i.current, s, p);
  }
  return a === "horizontal" ? /* @__PURE__ */ v(
    AOe,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (n.viewport && r.current) {
          const h = n.viewport.scrollLeft, p = ip(h, s, n.dir);
          r.current.style.transform = `translate3d(${p}px, 0, 0)`;
        }
      },
      onWheelScroll: (h) => {
        n.viewport && (n.viewport.scrollLeft = h);
      },
      onDragScroll: (h) => {
        n.viewport && (n.viewport.scrollLeft = d(h, n.dir));
      }
    }
  ) : a === "vertical" ? /* @__PURE__ */ v(
    OOe,
    {
      ...u,
      ref: t,
      onThumbPositionChange: () => {
        if (n.viewport && r.current) {
          const h = n.viewport.scrollTop, p = ip(h, s);
          r.current.style.transform = `translate3d(0, ${p}px, 0)`;
        }
      },
      onWheelScroll: (h) => {
        n.viewport && (n.viewport.scrollTop = h);
      },
      onDragScroll: (h) => {
        n.viewport && (n.viewport.scrollTop = d(h));
      }
    }
  ) : null;
}), AOe = g.forwardRef((e, t) => {
  const { sizes: a, onSizesChange: o, ...n } = e, r = Dt(oa, e.__scopeScrollArea), [i, s] = g.useState(), l = g.useRef(null), c = Ne(t, l, r.onScrollbarXChange);
  return g.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ v(
    Xw,
    {
      "data-orientation": "horizontal",
      ...n,
      ref: c,
      sizes: a,
      style: {
        bottom: 0,
        left: r.dir === "rtl" ? "var(--radix-scroll-area-corner-width)" : 0,
        right: r.dir === "ltr" ? "var(--radix-scroll-area-corner-width)" : 0,
        "--radix-scroll-area-thumb-width": Ws(a) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.x),
      onDragScroll: (u) => e.onDragScroll(u.x),
      onWheelScroll: (u, d) => {
        if (r.viewport) {
          const h = r.viewport.scrollLeft + u.deltaX;
          e.onWheelScroll(h), tk(h, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && r.viewport && i && o({
          content: r.viewport.scrollWidth,
          viewport: r.viewport.offsetWidth,
          scrollbar: {
            size: l.current.clientWidth,
            paddingStart: Hi(i.paddingLeft),
            paddingEnd: Hi(i.paddingRight)
          }
        });
      }
    }
  );
}), OOe = g.forwardRef((e, t) => {
  const { sizes: a, onSizesChange: o, ...n } = e, r = Dt(oa, e.__scopeScrollArea), [i, s] = g.useState(), l = g.useRef(null), c = Ne(t, l, r.onScrollbarYChange);
  return g.useEffect(() => {
    l.current && s(getComputedStyle(l.current));
  }, [l]), /* @__PURE__ */ v(
    Xw,
    {
      "data-orientation": "vertical",
      ...n,
      ref: c,
      sizes: a,
      style: {
        top: 0,
        right: r.dir === "ltr" ? 0 : void 0,
        left: r.dir === "rtl" ? 0 : void 0,
        bottom: "var(--radix-scroll-area-corner-height)",
        "--radix-scroll-area-thumb-height": Ws(a) + "px",
        ...e.style
      },
      onThumbPointerDown: (u) => e.onThumbPointerDown(u.y),
      onDragScroll: (u) => e.onDragScroll(u.y),
      onWheelScroll: (u, d) => {
        if (r.viewport) {
          const h = r.viewport.scrollTop + u.deltaY;
          e.onWheelScroll(h), tk(h, d) && u.preventDefault();
        }
      },
      onResize: () => {
        l.current && r.viewport && i && o({
          content: r.viewport.scrollHeight,
          viewport: r.viewport.offsetHeight,
          scrollbar: {
            size: l.current.clientHeight,
            paddingStart: Hi(i.paddingTop),
            paddingEnd: Hi(i.paddingBottom)
          }
        });
      }
    }
  );
}), [POe, Yw] = Kw(oa), Xw = g.forwardRef((e, t) => {
  const {
    __scopeScrollArea: a,
    sizes: o,
    hasThumb: n,
    onThumbChange: r,
    onThumbPointerUp: i,
    onThumbPointerDown: s,
    onThumbPositionChange: l,
    onDragScroll: c,
    onWheelScroll: u,
    onResize: d,
    ...h
  } = e, p = Dt(oa, a), [f, m] = g.useState(null), b = Ne(t, (C) => m(C)), w = g.useRef(null), _ = g.useRef(""), y = p.viewport, k = o.content - o.viewport, x = ut(u), S = ut(l), $ = Bs(d, 10);
  function E(C) {
    if (w.current) {
      const z = C.clientX - w.current.left, R = C.clientY - w.current.top;
      c({ x: z, y: R });
    }
  }
  return g.useEffect(() => {
    const C = (z) => {
      const R = z.target;
      f?.contains(R) && x(z, k);
    };
    return document.addEventListener("wheel", C, { passive: !1 }), () => document.removeEventListener("wheel", C, { passive: !1 });
  }, [y, f, k, x]), g.useEffect(S, [o, S]), en(f, $), en(p.content, $), /* @__PURE__ */ v(
    POe,
    {
      scope: a,
      scrollbar: f,
      hasThumb: n,
      onThumbChange: ut(r),
      onThumbPointerUp: ut(i),
      onThumbPositionChange: S,
      onThumbPointerDown: ut(s),
      children: /* @__PURE__ */ v(
        ye.div,
        {
          ...h,
          ref: b,
          style: { position: "absolute", ...h.style },
          onPointerDown: ve(e.onPointerDown, (C) => {
            C.button === 0 && (C.target.setPointerCapture(C.pointerId), w.current = f.getBoundingClientRect(), _.current = document.body.style.webkitUserSelect, document.body.style.webkitUserSelect = "none", p.viewport && (p.viewport.style.scrollBehavior = "auto"), E(C));
          }),
          onPointerMove: ve(e.onPointerMove, E),
          onPointerUp: ve(e.onPointerUp, (C) => {
            const z = C.target;
            z.hasPointerCapture(C.pointerId) && z.releasePointerCapture(C.pointerId), document.body.style.webkitUserSelect = _.current, p.viewport && (p.viewport.style.scrollBehavior = ""), w.current = null;
          })
        }
      )
    }
  );
}), qi = "ScrollAreaThumb", DOe = g.forwardRef(
  (e, t) => {
    const { forceMount: a, ...o } = e, n = Yw(qi, e.__scopeScrollArea);
    return /* @__PURE__ */ v(yo, { present: a || n.hasThumb, children: /* @__PURE__ */ v(NOe, { ref: t, ...o }) });
  }
), NOe = g.forwardRef(
  (e, t) => {
    const { __scopeScrollArea: a, style: o, ...n } = e, r = Dt(qi, a), i = Yw(qi, a), { onThumbPositionChange: s } = i, l = Ne(
      t,
      (d) => i.onThumbChange(d)
    ), c = g.useRef(void 0), u = Bs(() => {
      c.current && (c.current(), c.current = void 0);
    }, 100);
    return g.useEffect(() => {
      const d = r.viewport;
      if (d) {
        const h = () => {
          if (u(), !c.current) {
            const p = MOe(d, s);
            c.current = p, s();
          }
        };
        return s(), d.addEventListener("scroll", h), () => d.removeEventListener("scroll", h);
      }
    }, [r.viewport, u, s]), /* @__PURE__ */ v(
      ye.div,
      {
        "data-state": i.hasThumb ? "visible" : "hidden",
        ...n,
        ref: l,
        style: {
          width: "var(--radix-scroll-area-thumb-width)",
          height: "var(--radix-scroll-area-thumb-height)",
          ...o
        },
        onPointerDownCapture: ve(e.onPointerDownCapture, (d) => {
          const h = d.target.getBoundingClientRect(), p = d.clientX - h.left, f = d.clientY - h.top;
          i.onThumbPointerDown({ x: p, y: f });
        }),
        onPointerUp: ve(e.onPointerUp, i.onThumbPointerUp)
      }
    );
  }
);
DOe.displayName = qi;
var jd = "ScrollAreaCorner", ROe = g.forwardRef(
  (e, t) => {
    const a = Dt(jd, e.__scopeScrollArea), o = !!(a.scrollbarX && a.scrollbarY);
    return a.type !== "scroll" && o ? /* @__PURE__ */ v(IOe, { ...e, ref: t }) : null;
  }
);
ROe.displayName = jd;
var IOe = g.forwardRef((e, t) => {
  const { __scopeScrollArea: a, ...o } = e, n = Dt(jd, a), [r, i] = g.useState(0), [s, l] = g.useState(0), c = !!(r && s);
  return en(n.scrollbarX, () => {
    const u = n.scrollbarX?.offsetHeight || 0;
    n.onCornerHeightChange(u), l(u);
  }), en(n.scrollbarY, () => {
    const u = n.scrollbarY?.offsetWidth || 0;
    n.onCornerWidthChange(u), i(u);
  }), c ? /* @__PURE__ */ v(
    ye.div,
    {
      ...o,
      ref: t,
      style: {
        width: r,
        height: s,
        position: "absolute",
        right: n.dir === "ltr" ? 0 : void 0,
        left: n.dir === "rtl" ? 0 : void 0,
        bottom: 0,
        ...e.style
      }
    }
  ) : null;
});
function Hi(e) {
  return e ? parseInt(e, 10) : 0;
}
function Qw(e, t) {
  const a = e / t;
  return isNaN(a) ? 0 : a;
}
function Ws(e) {
  const t = Qw(e.viewport, e.content), a = e.scrollbar.paddingStart + e.scrollbar.paddingEnd, o = (e.scrollbar.size - a) * t;
  return Math.max(o, 18);
}
function TOe(e, t, a, o = "ltr") {
  const n = Ws(a), r = n / 2, i = t || r, s = n - i, l = a.scrollbar.paddingStart + i, c = a.scrollbar.size - a.scrollbar.paddingEnd - s, u = a.content - a.viewport, d = o === "ltr" ? [0, u] : [u * -1, 0];
  return ek([l, c], d)(e);
}
function ip(e, t, a = "ltr") {
  const o = Ws(t), n = t.scrollbar.paddingStart + t.scrollbar.paddingEnd, r = t.scrollbar.size - n, i = t.content - t.viewport, s = r - o, l = a === "ltr" ? [0, i] : [i * -1, 0], c = Uc(e, l);
  return ek([0, i], [0, s])(c);
}
function ek(e, t) {
  return (a) => {
    if (e[0] === e[1] || t[0] === t[1]) return t[0];
    const o = (t[1] - t[0]) / (e[1] - e[0]);
    return t[0] + o * (a - e[0]);
  };
}
function tk(e, t) {
  return e > 0 && e < t;
}
var MOe = (e, t = () => {
}) => {
  let a = { left: e.scrollLeft, top: e.scrollTop }, o = 0;
  return function n() {
    const r = { left: e.scrollLeft, top: e.scrollTop }, i = a.left !== r.left, s = a.top !== r.top;
    (i || s) && t(), a = r, o = window.requestAnimationFrame(n);
  }(), () => window.cancelAnimationFrame(o);
};
function Bs(e, t) {
  const a = ut(e), o = g.useRef(0);
  return g.useEffect(() => () => window.clearTimeout(o.current), []), g.useCallback(() => {
    window.clearTimeout(o.current), o.current = window.setTimeout(a, t);
  }, [a, t]);
}
function en(e, t) {
  const a = ut(t);
  ot(() => {
    let o = 0;
    if (e) {
      const n = new ResizeObserver(() => {
        cancelAnimationFrame(o), o = window.requestAnimationFrame(a);
      });
      return n.observe(e), () => {
        window.cancelAnimationFrame(o), n.unobserve(e);
      };
    }
  }, [e, a]);
}
const LOe = ["top", "right", "bottom", "left"], Ra = Math.min, kt = Math.max, Gi = Math.round, Vr = Math.floor, Yt = (e) => ({
  x: e,
  y: e
}), WOe = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
}, BOe = {
  start: "end",
  end: "start"
};
function qc(e, t, a) {
  return kt(e, Ra(t, a));
}
function fa(e, t) {
  return typeof e == "function" ? e(t) : e;
}
function ba(e) {
  return e.split("-")[0];
}
function cn(e) {
  return e.split("-")[1];
}
function Ad(e) {
  return e === "x" ? "y" : "x";
}
function Od(e) {
  return e === "y" ? "height" : "width";
}
function ha(e) {
  return ["top", "bottom"].includes(ba(e)) ? "y" : "x";
}
function Pd(e) {
  return Ad(ha(e));
}
function FOe(e, t, a) {
  a === void 0 && (a = !1);
  const o = cn(e), n = Pd(e), r = Od(n);
  let i = n === "x" ? o === (a ? "end" : "start") ? "right" : "left" : o === "start" ? "bottom" : "top";
  return t.reference[r] > t.floating[r] && (i = Ki(i)), [i, Ki(i)];
}
function VOe(e) {
  const t = Ki(e);
  return [Hc(e), t, Hc(t)];
}
function Hc(e) {
  return e.replace(/start|end/g, (t) => BOe[t]);
}
function UOe(e, t, a) {
  const o = ["left", "right"], n = ["right", "left"], r = ["top", "bottom"], i = ["bottom", "top"];
  switch (e) {
    case "top":
    case "bottom":
      return a ? t ? n : o : t ? o : n;
    case "left":
    case "right":
      return t ? r : i;
    default:
      return [];
  }
}
function qOe(e, t, a, o) {
  const n = cn(e);
  let r = UOe(ba(e), a === "start", o);
  return n && (r = r.map((i) => i + "-" + n), t && (r = r.concat(r.map(Hc)))), r;
}
function Ki(e) {
  return e.replace(/left|right|bottom|top/g, (t) => WOe[t]);
}
function HOe(e) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...e
  };
}
function ak(e) {
  return typeof e != "number" ? HOe(e) : {
    top: e,
    right: e,
    bottom: e,
    left: e
  };
}
function Ji(e) {
  const {
    x: t,
    y: a,
    width: o,
    height: n
  } = e;
  return {
    width: o,
    height: n,
    top: a,
    left: t,
    right: t + o,
    bottom: a + n,
    x: t,
    y: a
  };
}
function sp(e, t, a) {
  let {
    reference: o,
    floating: n
  } = e;
  const r = ha(t), i = Pd(t), s = Od(i), l = ba(t), c = r === "y", u = o.x + o.width / 2 - n.width / 2, d = o.y + o.height / 2 - n.height / 2, h = o[s] / 2 - n[s] / 2;
  let p;
  switch (l) {
    case "top":
      p = {
        x: u,
        y: o.y - n.height
      };
      break;
    case "bottom":
      p = {
        x: u,
        y: o.y + o.height
      };
      break;
    case "right":
      p = {
        x: o.x + o.width,
        y: d
      };
      break;
    case "left":
      p = {
        x: o.x - n.width,
        y: d
      };
      break;
    default:
      p = {
        x: o.x,
        y: o.y
      };
  }
  switch (cn(t)) {
    case "start":
      p[i] -= h * (a && c ? -1 : 1);
      break;
    case "end":
      p[i] += h * (a && c ? -1 : 1);
      break;
  }
  return p;
}
const GOe = async (e, t, a) => {
  const {
    placement: o = "bottom",
    strategy: n = "absolute",
    middleware: r = [],
    platform: i
  } = a, s = r.filter(Boolean), l = await (i.isRTL == null ? void 0 : i.isRTL(t));
  let c = await i.getElementRects({
    reference: e,
    floating: t,
    strategy: n
  }), {
    x: u,
    y: d
  } = sp(c, o, l), h = o, p = {}, f = 0;
  for (let m = 0; m < s.length; m++) {
    const {
      name: b,
      fn: w
    } = s[m], {
      x: _,
      y,
      data: k,
      reset: x
    } = await w({
      x: u,
      y: d,
      initialPlacement: o,
      placement: h,
      strategy: n,
      middlewareData: p,
      rects: c,
      platform: i,
      elements: {
        reference: e,
        floating: t
      }
    });
    u = _ ?? u, d = y ?? d, p = {
      ...p,
      [b]: {
        ...p[b],
        ...k
      }
    }, x && f <= 50 && (f++, typeof x == "object" && (x.placement && (h = x.placement), x.rects && (c = x.rects === !0 ? await i.getElementRects({
      reference: e,
      floating: t,
      strategy: n
    }) : x.rects), {
      x: u,
      y: d
    } = sp(c, h, l)), m = -1);
  }
  return {
    x: u,
    y: d,
    placement: h,
    strategy: n,
    middlewareData: p
  };
};
async function Vn(e, t) {
  var a;
  t === void 0 && (t = {});
  const {
    x: o,
    y: n,
    platform: r,
    rects: i,
    elements: s,
    strategy: l
  } = e, {
    boundary: c = "clippingAncestors",
    rootBoundary: u = "viewport",
    elementContext: d = "floating",
    altBoundary: h = !1,
    padding: p = 0
  } = fa(t, e), f = ak(p), m = s[h ? d === "floating" ? "reference" : "floating" : d], b = Ji(await r.getClippingRect({
    element: (a = await (r.isElement == null ? void 0 : r.isElement(m))) == null || a ? m : m.contextElement || await (r.getDocumentElement == null ? void 0 : r.getDocumentElement(s.floating)),
    boundary: c,
    rootBoundary: u,
    strategy: l
  })), w = d === "floating" ? {
    x: o,
    y: n,
    width: i.floating.width,
    height: i.floating.height
  } : i.reference, _ = await (r.getOffsetParent == null ? void 0 : r.getOffsetParent(s.floating)), y = await (r.isElement == null ? void 0 : r.isElement(_)) ? await (r.getScale == null ? void 0 : r.getScale(_)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  }, k = Ji(r.convertOffsetParentRelativeRectToViewportRelativeRect ? await r.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: s,
    rect: w,
    offsetParent: _,
    strategy: l
  }) : w);
  return {
    top: (b.top - k.top + f.top) / y.y,
    bottom: (k.bottom - b.bottom + f.bottom) / y.y,
    left: (b.left - k.left + f.left) / y.x,
    right: (k.right - b.right + f.right) / y.x
  };
}
const KOe = (e) => ({
  name: "arrow",
  options: e,
  async fn(t) {
    const {
      x: a,
      y: o,
      placement: n,
      rects: r,
      platform: i,
      elements: s,
      middlewareData: l
    } = t, {
      element: c,
      padding: u = 0
    } = fa(e, t) || {};
    if (c == null)
      return {};
    const d = ak(u), h = {
      x: a,
      y: o
    }, p = Pd(n), f = Od(p), m = await i.getDimensions(c), b = p === "y", w = b ? "top" : "left", _ = b ? "bottom" : "right", y = b ? "clientHeight" : "clientWidth", k = r.reference[f] + r.reference[p] - h[p] - r.floating[f], x = h[p] - r.reference[p], S = await (i.getOffsetParent == null ? void 0 : i.getOffsetParent(c));
    let $ = S ? S[y] : 0;
    (!$ || !await (i.isElement == null ? void 0 : i.isElement(S))) && ($ = s.floating[y] || r.floating[f]);
    const E = k / 2 - x / 2, C = $ / 2 - m[f] / 2 - 1, z = Ra(d[w], C), R = Ra(d[_], C), H = z, M = $ - m[f] - R, j = $ / 2 - m[f] / 2 + E, U = qc(H, j, M), I = !l.arrow && cn(n) != null && j !== U && r.reference[f] / 2 - (j < H ? z : R) - m[f] / 2 < 0, K = I ? j < H ? j - H : j - M : 0;
    return {
      [p]: h[p] + K,
      data: {
        [p]: U,
        centerOffset: j - U - K,
        ...I && {
          alignmentOffset: K
        }
      },
      reset: I
    };
  }
}), JOe = function(e) {
  return e === void 0 && (e = {}), {
    name: "flip",
    options: e,
    async fn(t) {
      var a, o;
      const {
        placement: n,
        middlewareData: r,
        rects: i,
        initialPlacement: s,
        platform: l,
        elements: c
      } = t, {
        mainAxis: u = !0,
        crossAxis: d = !0,
        fallbackPlacements: h,
        fallbackStrategy: p = "bestFit",
        fallbackAxisSideDirection: f = "none",
        flipAlignment: m = !0,
        ...b
      } = fa(e, t);
      if ((a = r.arrow) != null && a.alignmentOffset)
        return {};
      const w = ba(n), _ = ha(s), y = ba(s) === s, k = await (l.isRTL == null ? void 0 : l.isRTL(c.floating)), x = h || (y || !m ? [Ki(s)] : VOe(s)), S = f !== "none";
      !h && S && x.push(...qOe(s, m, f, k));
      const $ = [s, ...x], E = await Vn(t, b), C = [];
      let z = ((o = r.flip) == null ? void 0 : o.overflows) || [];
      if (u && C.push(E[w]), d) {
        const U = FOe(n, i, k);
        C.push(E[U[0]], E[U[1]]);
      }
      if (z = [...z, {
        placement: n,
        overflows: C
      }], !C.every((U) => U <= 0)) {
        var R, H;
        const U = (((R = r.flip) == null ? void 0 : R.index) || 0) + 1, I = $[U];
        if (I) {
          var M;
          const q = d === "alignment" ? _ !== ha(I) : !1, te = ((M = z[0]) == null ? void 0 : M.overflows[0]) > 0;
          if (!q || te)
            return {
              data: {
                index: U,
                overflows: z
              },
              reset: {
                placement: I
              }
            };
        }
        let K = (H = z.filter((q) => q.overflows[0] <= 0).sort((q, te) => q.overflows[1] - te.overflows[1])[0]) == null ? void 0 : H.placement;
        if (!K)
          switch (p) {
            case "bestFit": {
              var j;
              const q = (j = z.filter((te) => {
                if (S) {
                  const O = ha(te.placement);
                  return O === _ || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  O === "y";
                }
                return !0;
              }).map((te) => [te.placement, te.overflows.filter((O) => O > 0).reduce((O, A) => O + A, 0)]).sort((te, O) => te[1] - O[1])[0]) == null ? void 0 : j[0];
              q && (K = q);
              break;
            }
            case "initialPlacement":
              K = s;
              break;
          }
        if (n !== K)
          return {
            reset: {
              placement: K
            }
          };
      }
      return {};
    }
  };
};
function lp(e, t) {
  return {
    top: e.top - t.height,
    right: e.right - t.width,
    bottom: e.bottom - t.height,
    left: e.left - t.width
  };
}
function cp(e) {
  return LOe.some((t) => e[t] >= 0);
}
const ZOe = function(e) {
  return e === void 0 && (e = {}), {
    name: "hide",
    options: e,
    async fn(t) {
      const {
        rects: a
      } = t, {
        strategy: o = "referenceHidden",
        ...n
      } = fa(e, t);
      switch (o) {
        case "referenceHidden": {
          const r = await Vn(t, {
            ...n,
            elementContext: "reference"
          }), i = lp(r, a.reference);
          return {
            data: {
              referenceHiddenOffsets: i,
              referenceHidden: cp(i)
            }
          };
        }
        case "escaped": {
          const r = await Vn(t, {
            ...n,
            altBoundary: !0
          }), i = lp(r, a.floating);
          return {
            data: {
              escapedOffsets: i,
              escaped: cp(i)
            }
          };
        }
        default:
          return {};
      }
    }
  };
};
async function YOe(e, t) {
  const {
    placement: a,
    platform: o,
    elements: n
  } = e, r = await (o.isRTL == null ? void 0 : o.isRTL(n.floating)), i = ba(a), s = cn(a), l = ha(a) === "y", c = ["left", "top"].includes(i) ? -1 : 1, u = r && l ? -1 : 1, d = fa(t, e);
  let {
    mainAxis: h,
    crossAxis: p,
    alignmentAxis: f
  } = typeof d == "number" ? {
    mainAxis: d,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: d.mainAxis || 0,
    crossAxis: d.crossAxis || 0,
    alignmentAxis: d.alignmentAxis
  };
  return s && typeof f == "number" && (p = s === "end" ? f * -1 : f), l ? {
    x: p * u,
    y: h * c
  } : {
    x: h * c,
    y: p * u
  };
}
const XOe = function(e) {
  return e === void 0 && (e = 0), {
    name: "offset",
    options: e,
    async fn(t) {
      var a, o;
      const {
        x: n,
        y: r,
        placement: i,
        middlewareData: s
      } = t, l = await YOe(t, e);
      return i === ((a = s.offset) == null ? void 0 : a.placement) && (o = s.arrow) != null && o.alignmentOffset ? {} : {
        x: n + l.x,
        y: r + l.y,
        data: {
          ...l,
          placement: i
        }
      };
    }
  };
}, QOe = function(e) {
  return e === void 0 && (e = {}), {
    name: "shift",
    options: e,
    async fn(t) {
      const {
        x: a,
        y: o,
        placement: n
      } = t, {
        mainAxis: r = !0,
        crossAxis: i = !1,
        limiter: s = {
          fn: (b) => {
            let {
              x: w,
              y: _
            } = b;
            return {
              x: w,
              y: _
            };
          }
        },
        ...l
      } = fa(e, t), c = {
        x: a,
        y: o
      }, u = await Vn(t, l), d = ha(ba(n)), h = Ad(d);
      let p = c[h], f = c[d];
      if (r) {
        const b = h === "y" ? "top" : "left", w = h === "y" ? "bottom" : "right", _ = p + u[b], y = p - u[w];
        p = qc(_, p, y);
      }
      if (i) {
        const b = d === "y" ? "top" : "left", w = d === "y" ? "bottom" : "right", _ = f + u[b], y = f - u[w];
        f = qc(_, f, y);
      }
      const m = s.fn({
        ...t,
        [h]: p,
        [d]: f
      });
      return {
        ...m,
        data: {
          x: m.x - a,
          y: m.y - o,
          enabled: {
            [h]: r,
            [d]: i
          }
        }
      };
    }
  };
}, ePe = function(e) {
  return e === void 0 && (e = {}), {
    options: e,
    fn(t) {
      const {
        x: a,
        y: o,
        placement: n,
        rects: r,
        middlewareData: i
      } = t, {
        offset: s = 0,
        mainAxis: l = !0,
        crossAxis: c = !0
      } = fa(e, t), u = {
        x: a,
        y: o
      }, d = ha(n), h = Ad(d);
      let p = u[h], f = u[d];
      const m = fa(s, t), b = typeof m == "number" ? {
        mainAxis: m,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...m
      };
      if (l) {
        const y = h === "y" ? "height" : "width", k = r.reference[h] - r.floating[y] + b.mainAxis, x = r.reference[h] + r.reference[y] - b.mainAxis;
        p < k ? p = k : p > x && (p = x);
      }
      if (c) {
        var w, _;
        const y = h === "y" ? "width" : "height", k = ["top", "left"].includes(ba(n)), x = r.reference[d] - r.floating[y] + (k && ((w = i.offset) == null ? void 0 : w[d]) || 0) + (k ? 0 : b.crossAxis), S = r.reference[d] + r.reference[y] + (k ? 0 : ((_ = i.offset) == null ? void 0 : _[d]) || 0) - (k ? b.crossAxis : 0);
        f < x ? f = x : f > S && (f = S);
      }
      return {
        [h]: p,
        [d]: f
      };
    }
  };
}, tPe = function(e) {
  return e === void 0 && (e = {}), {
    name: "size",
    options: e,
    async fn(t) {
      var a, o;
      const {
        placement: n,
        rects: r,
        platform: i,
        elements: s
      } = t, {
        apply: l = () => {
        },
        ...c
      } = fa(e, t), u = await Vn(t, c), d = ba(n), h = cn(n), p = ha(n) === "y", {
        width: f,
        height: m
      } = r.floating;
      let b, w;
      d === "top" || d === "bottom" ? (b = d, w = h === (await (i.isRTL == null ? void 0 : i.isRTL(s.floating)) ? "start" : "end") ? "left" : "right") : (w = d, b = h === "end" ? "top" : "bottom");
      const _ = m - u.top - u.bottom, y = f - u.left - u.right, k = Ra(m - u[b], _), x = Ra(f - u[w], y), S = !t.middlewareData.shift;
      let $ = k, E = x;
      if ((a = t.middlewareData.shift) != null && a.enabled.x && (E = y), (o = t.middlewareData.shift) != null && o.enabled.y && ($ = _), S && !h) {
        const z = kt(u.left, 0), R = kt(u.right, 0), H = kt(u.top, 0), M = kt(u.bottom, 0);
        p ? E = f - 2 * (z !== 0 || R !== 0 ? z + R : kt(u.left, u.right)) : $ = m - 2 * (H !== 0 || M !== 0 ? H + M : kt(u.top, u.bottom));
      }
      await l({
        ...t,
        availableWidth: E,
        availableHeight: $
      });
      const C = await i.getDimensions(s.floating);
      return f !== C.width || m !== C.height ? {
        reset: {
          rects: !0
        }
      } : {};
    }
  };
};
function Fs() {
  return typeof window < "u";
}
function un(e) {
  return ok(e) ? (e.nodeName || "").toLowerCase() : "#document";
}
function xt(e) {
  var t;
  return (e == null || (t = e.ownerDocument) == null ? void 0 : t.defaultView) || window;
}
function na(e) {
  var t;
  return (t = (ok(e) ? e.ownerDocument : e.document) || window.document) == null ? void 0 : t.documentElement;
}
function ok(e) {
  return Fs() ? e instanceof Node || e instanceof xt(e).Node : !1;
}
function Tt(e) {
  return Fs() ? e instanceof Element || e instanceof xt(e).Element : !1;
}
function Xt(e) {
  return Fs() ? e instanceof HTMLElement || e instanceof xt(e).HTMLElement : !1;
}
function up(e) {
  return !Fs() || typeof ShadowRoot > "u" ? !1 : e instanceof ShadowRoot || e instanceof xt(e).ShadowRoot;
}
function ur(e) {
  const {
    overflow: t,
    overflowX: a,
    overflowY: o,
    display: n
  } = Mt(e);
  return /auto|scroll|overlay|hidden|clip/.test(t + o + a) && !["inline", "contents"].includes(n);
}
function aPe(e) {
  return ["table", "td", "th"].includes(un(e));
}
function Vs(e) {
  return [":popover-open", ":modal"].some((t) => {
    try {
      return e.matches(t);
    } catch {
      return !1;
    }
  });
}
function Dd(e) {
  const t = Nd(), a = Tt(e) ? Mt(e) : e;
  return ["transform", "translate", "scale", "rotate", "perspective"].some((o) => a[o] ? a[o] !== "none" : !1) || (a.containerType ? a.containerType !== "normal" : !1) || !t && (a.backdropFilter ? a.backdropFilter !== "none" : !1) || !t && (a.filter ? a.filter !== "none" : !1) || ["transform", "translate", "scale", "rotate", "perspective", "filter"].some((o) => (a.willChange || "").includes(o)) || ["paint", "layout", "strict", "content"].some((o) => (a.contain || "").includes(o));
}
function oPe(e) {
  let t = Ia(e);
  for (; Xt(t) && !tn(t); ) {
    if (Dd(t))
      return t;
    if (Vs(t))
      return null;
    t = Ia(t);
  }
  return null;
}
function Nd() {
  return typeof CSS > "u" || !CSS.supports ? !1 : CSS.supports("-webkit-backdrop-filter", "none");
}
function tn(e) {
  return ["html", "body", "#document"].includes(un(e));
}
function Mt(e) {
  return xt(e).getComputedStyle(e);
}
function Us(e) {
  return Tt(e) ? {
    scrollLeft: e.scrollLeft,
    scrollTop: e.scrollTop
  } : {
    scrollLeft: e.scrollX,
    scrollTop: e.scrollY
  };
}
function Ia(e) {
  if (un(e) === "html")
    return e;
  const t = (
    // Step into the shadow DOM of the parent of a slotted node.
    e.assignedSlot || // DOM Element detected.
    e.parentNode || // ShadowRoot detected.
    up(e) && e.host || // Fallback.
    na(e)
  );
  return up(t) ? t.host : t;
}
function nk(e) {
  const t = Ia(e);
  return tn(t) ? e.ownerDocument ? e.ownerDocument.body : e.body : Xt(t) && ur(t) ? t : nk(t);
}
function Un(e, t, a) {
  var o;
  t === void 0 && (t = []), a === void 0 && (a = !0);
  const n = nk(e), r = n === ((o = e.ownerDocument) == null ? void 0 : o.body), i = xt(n);
  if (r) {
    const s = Gc(i);
    return t.concat(i, i.visualViewport || [], ur(n) ? n : [], s && a ? Un(s) : []);
  }
  return t.concat(n, Un(n, [], a));
}
function Gc(e) {
  return e.parent && Object.getPrototypeOf(e.parent) ? e.frameElement : null;
}
function rk(e) {
  const t = Mt(e);
  let a = parseFloat(t.width) || 0, o = parseFloat(t.height) || 0;
  const n = Xt(e), r = n ? e.offsetWidth : a, i = n ? e.offsetHeight : o, s = Gi(a) !== r || Gi(o) !== i;
  return s && (a = r, o = i), {
    width: a,
    height: o,
    $: s
  };
}
function Rd(e) {
  return Tt(e) ? e : e.contextElement;
}
function Uo(e) {
  const t = Rd(e);
  if (!Xt(t))
    return Yt(1);
  const a = t.getBoundingClientRect(), {
    width: o,
    height: n,
    $: r
  } = rk(t);
  let i = (r ? Gi(a.width) : a.width) / o, s = (r ? Gi(a.height) : a.height) / n;
  return (!i || !Number.isFinite(i)) && (i = 1), (!s || !Number.isFinite(s)) && (s = 1), {
    x: i,
    y: s
  };
}
const nPe = /* @__PURE__ */ Yt(0);
function ik(e) {
  const t = xt(e);
  return !Nd() || !t.visualViewport ? nPe : {
    x: t.visualViewport.offsetLeft,
    y: t.visualViewport.offsetTop
  };
}
function rPe(e, t, a) {
  return t === void 0 && (t = !1), !a || t && a !== xt(e) ? !1 : t;
}
function lo(e, t, a, o) {
  t === void 0 && (t = !1), a === void 0 && (a = !1);
  const n = e.getBoundingClientRect(), r = Rd(e);
  let i = Yt(1);
  t && (o ? Tt(o) && (i = Uo(o)) : i = Uo(e));
  const s = rPe(r, a, o) ? ik(r) : Yt(0);
  let l = (n.left + s.x) / i.x, c = (n.top + s.y) / i.y, u = n.width / i.x, d = n.height / i.y;
  if (r) {
    const h = xt(r), p = o && Tt(o) ? xt(o) : o;
    let f = h, m = Gc(f);
    for (; m && o && p !== f; ) {
      const b = Uo(m), w = m.getBoundingClientRect(), _ = Mt(m), y = w.left + (m.clientLeft + parseFloat(_.paddingLeft)) * b.x, k = w.top + (m.clientTop + parseFloat(_.paddingTop)) * b.y;
      l *= b.x, c *= b.y, u *= b.x, d *= b.y, l += y, c += k, f = xt(m), m = Gc(f);
    }
  }
  return Ji({
    width: u,
    height: d,
    x: l,
    y: c
  });
}
function Id(e, t) {
  const a = Us(e).scrollLeft;
  return t ? t.left + a : lo(na(e)).left + a;
}
function sk(e, t, a) {
  a === void 0 && (a = !1);
  const o = e.getBoundingClientRect(), n = o.left + t.scrollLeft - (a ? 0 : (
    // RTL <body> scrollbar.
    Id(e, o)
  )), r = o.top + t.scrollTop;
  return {
    x: n,
    y: r
  };
}
function iPe(e) {
  let {
    elements: t,
    rect: a,
    offsetParent: o,
    strategy: n
  } = e;
  const r = n === "fixed", i = na(o), s = t ? Vs(t.floating) : !1;
  if (o === i || s && r)
    return a;
  let l = {
    scrollLeft: 0,
    scrollTop: 0
  }, c = Yt(1);
  const u = Yt(0), d = Xt(o);
  if ((d || !d && !r) && ((un(o) !== "body" || ur(i)) && (l = Us(o)), Xt(o))) {
    const p = lo(o);
    c = Uo(o), u.x = p.x + o.clientLeft, u.y = p.y + o.clientTop;
  }
  const h = i && !d && !r ? sk(i, l, !0) : Yt(0);
  return {
    width: a.width * c.x,
    height: a.height * c.y,
    x: a.x * c.x - l.scrollLeft * c.x + u.x + h.x,
    y: a.y * c.y - l.scrollTop * c.y + u.y + h.y
  };
}
function sPe(e) {
  return Array.from(e.getClientRects());
}
function lPe(e) {
  const t = na(e), a = Us(e), o = e.ownerDocument.body, n = kt(t.scrollWidth, t.clientWidth, o.scrollWidth, o.clientWidth), r = kt(t.scrollHeight, t.clientHeight, o.scrollHeight, o.clientHeight);
  let i = -a.scrollLeft + Id(e);
  const s = -a.scrollTop;
  return Mt(o).direction === "rtl" && (i += kt(t.clientWidth, o.clientWidth) - n), {
    width: n,
    height: r,
    x: i,
    y: s
  };
}
function cPe(e, t) {
  const a = xt(e), o = na(e), n = a.visualViewport;
  let r = o.clientWidth, i = o.clientHeight, s = 0, l = 0;
  if (n) {
    r = n.width, i = n.height;
    const c = Nd();
    (!c || c && t === "fixed") && (s = n.offsetLeft, l = n.offsetTop);
  }
  return {
    width: r,
    height: i,
    x: s,
    y: l
  };
}
function uPe(e, t) {
  const a = lo(e, !0, t === "fixed"), o = a.top + e.clientTop, n = a.left + e.clientLeft, r = Xt(e) ? Uo(e) : Yt(1), i = e.clientWidth * r.x, s = e.clientHeight * r.y, l = n * r.x, c = o * r.y;
  return {
    width: i,
    height: s,
    x: l,
    y: c
  };
}
function dp(e, t, a) {
  let o;
  if (t === "viewport")
    o = cPe(e, a);
  else if (t === "document")
    o = lPe(na(e));
  else if (Tt(t))
    o = uPe(t, a);
  else {
    const n = ik(e);
    o = {
      x: t.x - n.x,
      y: t.y - n.y,
      width: t.width,
      height: t.height
    };
  }
  return Ji(o);
}
function lk(e, t) {
  const a = Ia(e);
  return a === t || !Tt(a) || tn(a) ? !1 : Mt(a).position === "fixed" || lk(a, t);
}
function dPe(e, t) {
  const a = t.get(e);
  if (a)
    return a;
  let o = Un(e, [], !1).filter((s) => Tt(s) && un(s) !== "body"), n = null;
  const r = Mt(e).position === "fixed";
  let i = r ? Ia(e) : e;
  for (; Tt(i) && !tn(i); ) {
    const s = Mt(i), l = Dd(i);
    !l && s.position === "fixed" && (n = null), (r ? !l && !n : !l && s.position === "static" && n && ["absolute", "fixed"].includes(n.position) || ur(i) && !l && lk(e, i)) ? o = o.filter((c) => c !== i) : n = s, i = Ia(i);
  }
  return t.set(e, o), o;
}
function gPe(e) {
  let {
    element: t,
    boundary: a,
    rootBoundary: o,
    strategy: n
  } = e;
  const r = [...a === "clippingAncestors" ? Vs(t) ? [] : dPe(t, this._c) : [].concat(a), o], i = r[0], s = r.reduce((l, c) => {
    const u = dp(t, c, n);
    return l.top = kt(u.top, l.top), l.right = Ra(u.right, l.right), l.bottom = Ra(u.bottom, l.bottom), l.left = kt(u.left, l.left), l;
  }, dp(t, i, n));
  return {
    width: s.right - s.left,
    height: s.bottom - s.top,
    x: s.left,
    y: s.top
  };
}
function hPe(e) {
  const {
    width: t,
    height: a
  } = rk(e);
  return {
    width: t,
    height: a
  };
}
function mPe(e, t, a) {
  const o = Xt(t), n = na(t), r = a === "fixed", i = lo(e, !0, r, t);
  let s = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const l = Yt(0);
  function c() {
    l.x = Id(n);
  }
  if (o || !o && !r)
    if ((un(t) !== "body" || ur(n)) && (s = Us(t)), o) {
      const p = lo(t, !0, r, t);
      l.x = p.x + t.clientLeft, l.y = p.y + t.clientTop;
    } else n && c();
  r && !o && n && c();
  const u = n && !o && !r ? sk(n, s) : Yt(0), d = i.left + s.scrollLeft - l.x - u.x, h = i.top + s.scrollTop - l.y - u.y;
  return {
    x: d,
    y: h,
    width: i.width,
    height: i.height
  };
}
function Gl(e) {
  return Mt(e).position === "static";
}
function gp(e, t) {
  if (!Xt(e) || Mt(e).position === "fixed")
    return null;
  if (t)
    return t(e);
  let a = e.offsetParent;
  return na(e) === a && (a = a.ownerDocument.body), a;
}
function ck(e, t) {
  const a = xt(e);
  if (Vs(e))
    return a;
  if (!Xt(e)) {
    let n = Ia(e);
    for (; n && !tn(n); ) {
      if (Tt(n) && !Gl(n))
        return n;
      n = Ia(n);
    }
    return a;
  }
  let o = gp(e, t);
  for (; o && aPe(o) && Gl(o); )
    o = gp(o, t);
  return o && tn(o) && Gl(o) && !Dd(o) ? a : o || oPe(e) || a;
}
const pPe = async function(e) {
  const t = this.getOffsetParent || ck, a = this.getDimensions, o = await a(e.floating);
  return {
    reference: mPe(e.reference, await t(e.floating), e.strategy),
    floating: {
      x: 0,
      y: 0,
      width: o.width,
      height: o.height
    }
  };
};
function fPe(e) {
  return Mt(e).direction === "rtl";
}
const bPe = {
  convertOffsetParentRelativeRectToViewportRelativeRect: iPe,
  getDocumentElement: na,
  getClippingRect: gPe,
  getOffsetParent: ck,
  getElementRects: pPe,
  getClientRects: sPe,
  getDimensions: hPe,
  getScale: Uo,
  isElement: Tt,
  isRTL: fPe
};
function uk(e, t) {
  return e.x === t.x && e.y === t.y && e.width === t.width && e.height === t.height;
}
function _Pe(e, t) {
  let a = null, o;
  const n = na(e);
  function r() {
    var s;
    clearTimeout(o), (s = a) == null || s.disconnect(), a = null;
  }
  function i(s, l) {
    s === void 0 && (s = !1), l === void 0 && (l = 1), r();
    const c = e.getBoundingClientRect(), {
      left: u,
      top: d,
      width: h,
      height: p
    } = c;
    if (s || t(), !h || !p)
      return;
    const f = Vr(d), m = Vr(n.clientWidth - (u + h)), b = Vr(n.clientHeight - (d + p)), w = Vr(u), _ = {
      rootMargin: -f + "px " + -m + "px " + -b + "px " + -w + "px",
      threshold: kt(0, Ra(1, l)) || 1
    };
    let y = !0;
    function k(x) {
      const S = x[0].intersectionRatio;
      if (S !== l) {
        if (!y)
          return i();
        S ? i(!1, S) : o = setTimeout(() => {
          i(!1, 1e-7);
        }, 1e3);
      }
      S === 1 && !uk(c, e.getBoundingClientRect()) && i(), y = !1;
    }
    try {
      a = new IntersectionObserver(k, {
        ..._,
        // Handle <iframe>s
        root: n.ownerDocument
      });
    } catch {
      a = new IntersectionObserver(k, _);
    }
    a.observe(e);
  }
  return i(!0), r;
}
function vPe(e, t, a, o) {
  o === void 0 && (o = {});
  const {
    ancestorScroll: n = !0,
    ancestorResize: r = !0,
    elementResize: i = typeof ResizeObserver == "function",
    layoutShift: s = typeof IntersectionObserver == "function",
    animationFrame: l = !1
  } = o, c = Rd(e), u = n || r ? [...c ? Un(c) : [], ...Un(t)] : [];
  u.forEach((w) => {
    n && w.addEventListener("scroll", a, {
      passive: !0
    }), r && w.addEventListener("resize", a);
  });
  const d = c && s ? _Pe(c, a) : null;
  let h = -1, p = null;
  i && (p = new ResizeObserver((w) => {
    let [_] = w;
    _ && _.target === c && p && (p.unobserve(t), cancelAnimationFrame(h), h = requestAnimationFrame(() => {
      var y;
      (y = p) == null || y.observe(t);
    })), a();
  }), c && !l && p.observe(c), p.observe(t));
  let f, m = l ? lo(e) : null;
  l && b();
  function b() {
    const w = lo(e);
    m && !uk(m, w) && a(), m = w, f = requestAnimationFrame(b);
  }
  return a(), () => {
    var w;
    u.forEach((_) => {
      n && _.removeEventListener("scroll", a), r && _.removeEventListener("resize", a);
    }), d?.(), (w = p) == null || w.disconnect(), p = null, l && cancelAnimationFrame(f);
  };
}
const yPe = XOe, wPe = QOe, kPe = JOe, xPe = tPe, $Pe = ZOe, hp = KOe, SPe = ePe, CPe = (e, t, a) => {
  const o = /* @__PURE__ */ new Map(), n = {
    platform: bPe,
    ...a
  }, r = {
    ...n.platform,
    _c: o
  };
  return GOe(e, t, {
    ...n,
    platform: r
  });
};
var pi = typeof document < "u" ? Kp : Ce;
function Zi(e, t) {
  if (e === t)
    return !0;
  if (typeof e != typeof t)
    return !1;
  if (typeof e == "function" && e.toString() === t.toString())
    return !0;
  let a, o, n;
  if (e && t && typeof e == "object") {
    if (Array.isArray(e)) {
      if (a = e.length, a !== t.length) return !1;
      for (o = a; o-- !== 0; )
        if (!Zi(e[o], t[o]))
          return !1;
      return !0;
    }
    if (n = Object.keys(e), a = n.length, a !== Object.keys(t).length)
      return !1;
    for (o = a; o-- !== 0; )
      if (!{}.hasOwnProperty.call(t, n[o]))
        return !1;
    for (o = a; o-- !== 0; ) {
      const r = n[o];
      if (!(r === "_owner" && e.$$typeof) && !Zi(e[r], t[r]))
        return !1;
    }
    return !0;
  }
  return e !== e && t !== t;
}
function dk(e) {
  return typeof window > "u" ? 1 : (e.ownerDocument.defaultView || window).devicePixelRatio || 1;
}
function mp(e, t) {
  const a = dk(e);
  return Math.round(t * a) / a;
}
function Kl(e) {
  const t = g.useRef(e);
  return pi(() => {
    t.current = e;
  }), t;
}
function EPe(e) {
  e === void 0 && (e = {});
  const {
    placement: t = "bottom",
    strategy: a = "absolute",
    middleware: o = [],
    platform: n,
    elements: {
      reference: r,
      floating: i
    } = {},
    transform: s = !0,
    whileElementsMounted: l,
    open: c
  } = e, [u, d] = g.useState({
    x: 0,
    y: 0,
    strategy: a,
    placement: t,
    middlewareData: {},
    isPositioned: !1
  }), [h, p] = g.useState(o);
  Zi(h, o) || p(o);
  const [f, m] = g.useState(null), [b, w] = g.useState(null), _ = g.useCallback((q) => {
    q !== S.current && (S.current = q, m(q));
  }, []), y = g.useCallback((q) => {
    q !== $.current && ($.current = q, w(q));
  }, []), k = r || f, x = i || b, S = g.useRef(null), $ = g.useRef(null), E = g.useRef(u), C = l != null, z = Kl(l), R = Kl(n), H = Kl(c), M = g.useCallback(() => {
    if (!S.current || !$.current)
      return;
    const q = {
      placement: t,
      strategy: a,
      middleware: h
    };
    R.current && (q.platform = R.current), CPe(S.current, $.current, q).then((te) => {
      const O = {
        ...te,
        // The floating element's position may be recomputed while it's closed
        // but still mounted (such as when transitioning out). To ensure
        // `isPositioned` will be `false` initially on the next open, avoid
        // setting it to `true` when `open === false` (must be specified).
        isPositioned: H.current !== !1
      };
      j.current && !Zi(E.current, O) && (E.current = O, mo.flushSync(() => {
        d(O);
      }));
    });
  }, [h, t, a, R, H]);
  pi(() => {
    c === !1 && E.current.isPositioned && (E.current.isPositioned = !1, d((q) => ({
      ...q,
      isPositioned: !1
    })));
  }, [c]);
  const j = g.useRef(!1);
  pi(() => (j.current = !0, () => {
    j.current = !1;
  }), []), pi(() => {
    if (k && (S.current = k), x && ($.current = x), k && x) {
      if (z.current)
        return z.current(k, x, M);
      M();
    }
  }, [k, x, M, z, C]);
  const U = g.useMemo(() => ({
    reference: S,
    floating: $,
    setReference: _,
    setFloating: y
  }), [_, y]), I = g.useMemo(() => ({
    reference: k,
    floating: x
  }), [k, x]), K = g.useMemo(() => {
    const q = {
      position: a,
      left: 0,
      top: 0
    };
    if (!I.floating)
      return q;
    const te = mp(I.floating, u.x), O = mp(I.floating, u.y);
    return s ? {
      ...q,
      transform: "translate(" + te + "px, " + O + "px)",
      ...dk(I.floating) >= 1.5 && {
        willChange: "transform"
      }
    } : {
      position: a,
      left: te,
      top: O
    };
  }, [a, s, I.floating, u.x, u.y]);
  return g.useMemo(() => ({
    ...u,
    update: M,
    refs: U,
    elements: I,
    floatingStyles: K
  }), [u, M, U, I, K]);
}
const zPe = (e) => {
  function t(a) {
    return {}.hasOwnProperty.call(a, "current");
  }
  return {
    name: "arrow",
    options: e,
    fn(a) {
      const {
        element: o,
        padding: n
      } = typeof e == "function" ? e(a) : e;
      return o && t(o) ? o.current != null ? hp({
        element: o.current,
        padding: n
      }).fn(a) : {} : o ? hp({
        element: o,
        padding: n
      }).fn(a) : {};
    }
  };
}, jPe = (e, t) => ({
  ...yPe(e),
  options: [e, t]
}), APe = (e, t) => ({
  ...wPe(e),
  options: [e, t]
}), OPe = (e, t) => ({
  ...SPe(e),
  options: [e, t]
}), PPe = (e, t) => ({
  ...kPe(e),
  options: [e, t]
}), DPe = (e, t) => ({
  ...xPe(e),
  options: [e, t]
}), NPe = (e, t) => ({
  ...$Pe(e),
  options: [e, t]
}), RPe = (e, t) => ({
  ...zPe(e),
  options: [e, t]
});
var IPe = "Arrow", gk = g.forwardRef((e, t) => {
  const { children: a, width: o = 10, height: n = 5, ...r } = e;
  return /* @__PURE__ */ v(
    ye.svg,
    {
      ...r,
      ref: t,
      width: o,
      height: n,
      viewBox: "0 0 30 10",
      preserveAspectRatio: "none",
      children: e.asChild ? a : /* @__PURE__ */ v("polygon", { points: "0,0 30,0 15,10" })
    }
  );
});
gk.displayName = IPe;
var TPe = gk, hk = "Popper", [mk, pk] = cr(hk), [bit, fk] = mk(hk), bk = "PopperAnchor", _k = g.forwardRef(
  (e, t) => {
    const { __scopePopper: a, virtualRef: o, ...n } = e, r = fk(bk, a), i = g.useRef(null), s = Ne(t, i), l = g.useRef(null);
    return g.useEffect(() => {
      const c = l.current;
      l.current = o?.current || i.current, c !== l.current && r.onAnchorChange(l.current);
    }), o ? null : /* @__PURE__ */ v(ye.div, { ...n, ref: s });
  }
);
_k.displayName = bk;
var Td = "PopperContent", [MPe, LPe] = mk(Td), vk = g.forwardRef(
  (e, t) => {
    const {
      __scopePopper: a,
      side: o = "bottom",
      sideOffset: n = 0,
      align: r = "center",
      alignOffset: i = 0,
      arrowPadding: s = 0,
      avoidCollisions: l = !0,
      collisionBoundary: c = [],
      collisionPadding: u = 0,
      sticky: d = "partial",
      hideWhenDetached: h = !1,
      updatePositionStrategy: p = "optimized",
      onPlaced: f,
      ...m
    } = e, b = fk(Td, a), [w, _] = g.useState(null), y = Ne(t, (L) => _(L)), [k, x] = g.useState(null), S = nje(k), $ = S?.width ?? 0, E = S?.height ?? 0, C = o + (r !== "center" ? "-" + r : ""), z = typeof u == "number" ? u : { top: 0, right: 0, bottom: 0, left: 0, ...u }, R = Array.isArray(c) ? c : [c], H = R.length > 0, M = {
      padding: z,
      boundary: R.filter(BPe),
      // with `strategy: 'fixed'`, this is the only way to get it to respect boundaries
      altBoundary: H
    }, { refs: j, floatingStyles: U, placement: I, isPositioned: K, middlewareData: q } = EPe({
      // default to `fixed` strategy so users don't have to pick and we also avoid focus scroll issues
      strategy: "fixed",
      placement: C,
      whileElementsMounted: (...L) => vPe(...L, {
        animationFrame: p === "always"
      }),
      elements: {
        reference: b.anchor
      },
      middleware: [
        jPe({ mainAxis: n + E, alignmentAxis: i }),
        l && APe({
          mainAxis: !0,
          crossAxis: !1,
          limiter: d === "partial" ? OPe() : void 0,
          ...M
        }),
        l && PPe({ ...M }),
        DPe({
          ...M,
          apply: ({ elements: L, rects: Y, availableWidth: Q, availableHeight: J }) => {
            const { width: ae, height: V } = Y.reference, fe = L.floating.style;
            fe.setProperty("--radix-popper-available-width", `${Q}px`), fe.setProperty("--radix-popper-available-height", `${J}px`), fe.setProperty("--radix-popper-anchor-width", `${ae}px`), fe.setProperty("--radix-popper-anchor-height", `${V}px`);
          }
        }),
        k && RPe({ element: k, padding: s }),
        FPe({ arrowWidth: $, arrowHeight: E }),
        h && NPe({ strategy: "referenceHidden", ...M })
      ]
    }), [te, O] = kk(I), A = ut(f);
    ot(() => {
      K && A?.();
    }, [K, A]);
    const N = q.arrow?.x, B = q.arrow?.y, W = q.arrow?.centerOffset !== 0, [Z, ee] = g.useState();
    return ot(() => {
      w && ee(window.getComputedStyle(w).zIndex);
    }, [w]), /* @__PURE__ */ v(
      "div",
      {
        ref: j.setFloating,
        "data-radix-popper-content-wrapper": "",
        style: {
          ...U,
          transform: K ? U.transform : "translate(0, -200%)",
          // keep off the page when measuring
          minWidth: "max-content",
          zIndex: Z,
          "--radix-popper-transform-origin": [
            q.transformOrigin?.x,
            q.transformOrigin?.y
          ].join(" "),
          // hide the content if using the hide middleware and should be hidden
          // set visibility to hidden and disable pointer events so the UI behaves
          // as if the PopperContent isn't there at all
          ...q.hide?.referenceHidden && {
            visibility: "hidden",
            pointerEvents: "none"
          }
        },
        dir: e.dir,
        children: /* @__PURE__ */ v(
          MPe,
          {
            scope: a,
            placedSide: te,
            onArrowChange: x,
            arrowX: N,
            arrowY: B,
            shouldHideArrow: W,
            children: /* @__PURE__ */ v(
              ye.div,
              {
                "data-side": te,
                "data-align": O,
                ...m,
                ref: y,
                style: {
                  ...m.style,
                  // if the PopperContent hasn't been placed yet (not all measurements done)
                  // we prevent animations so that users's animation don't kick in too early referring wrong sides
                  animation: K ? void 0 : "none"
                }
              }
            )
          }
        )
      }
    );
  }
);
vk.displayName = Td;
var yk = "PopperArrow", WPe = {
  top: "bottom",
  right: "left",
  bottom: "top",
  left: "right"
}, wk = g.forwardRef(function(e, t) {
  const { __scopePopper: a, ...o } = e, n = LPe(yk, a), r = WPe[n.placedSide];
  return (
    // we have to use an extra wrapper because `ResizeObserver` (used by `useSize`)
    // doesn't report size as we'd expect on SVG elements.
    // it reports their bounding box which is effectively the largest path inside the SVG.
    /* @__PURE__ */ v(
      "span",
      {
        ref: n.onArrowChange,
        style: {
          position: "absolute",
          left: n.arrowX,
          top: n.arrowY,
          [r]: 0,
          transformOrigin: {
            top: "",
            right: "0 0",
            bottom: "center 0",
            left: "100% 0"
          }[n.placedSide],
          transform: {
            top: "translateY(100%)",
            right: "translateY(50%) rotate(90deg) translateX(-50%)",
            bottom: "rotate(180deg)",
            left: "translateY(50%) rotate(-90deg) translateX(50%)"
          }[n.placedSide],
          visibility: n.shouldHideArrow ? "hidden" : void 0
        },
        children: /* @__PURE__ */ v(
          TPe,
          {
            ...o,
            ref: t,
            style: {
              ...o.style,
              // ensures the element can be measured correctly (mostly for if SVG)
              display: "block"
            }
          }
        )
      }
    )
  );
});
wk.displayName = yk;
function BPe(e) {
  return e !== null;
}
var FPe = (e) => ({
  name: "transformOrigin",
  options: e,
  fn(t) {
    const { placement: a, rects: o, middlewareData: n } = t, r = n.arrow?.centerOffset !== 0, i = r ? 0 : e.arrowWidth, s = r ? 0 : e.arrowHeight, [l, c] = kk(a), u = { start: "0%", center: "50%", end: "100%" }[c], d = (n.arrow?.x ?? 0) + i / 2, h = (n.arrow?.y ?? 0) + s / 2;
    let p = "", f = "";
    return l === "bottom" ? (p = r ? u : `${d}px`, f = `${-s}px`) : l === "top" ? (p = r ? u : `${d}px`, f = `${o.floating.height + s}px`) : l === "right" ? (p = `${-s}px`, f = r ? u : `${h}px`) : l === "left" && (p = `${o.floating.width + s}px`, f = r ? u : `${h}px`), { data: { x: p, y: f } };
  }
});
function kk(e) {
  const [t, a = "center"] = e.split("-");
  return [t, a];
}
var VPe = _k, UPe = vk, qPe = wk, xk = Object.freeze({
  // See: https://github.com/twbs/bootstrap/blob/main/scss/mixins/_visually-hidden.scss
  position: "absolute",
  border: 0,
  width: 1,
  height: 1,
  padding: 0,
  margin: -1,
  overflow: "hidden",
  clip: "rect(0, 0, 0, 0)",
  whiteSpace: "nowrap",
  wordWrap: "normal"
}), HPe = "VisuallyHidden", GPe = g.forwardRef(
  (e, t) => /* @__PURE__ */ v(
    ye.span,
    {
      ...e,
      ref: t,
      style: { ...xk, ...e.style }
    }
  )
);
GPe.displayName = HPe;
var KPe = [" ", "Enter", "ArrowUp", "ArrowDown"], JPe = [" ", "Enter"], qs = "Select", [Md, Hs, ZPe] = Xze(qs), [dn, _it] = cr(qs, [
  ZPe,
  pk
]), Ld = pk(), [vit, Ta] = dn(qs), [yit, YPe] = dn(qs), $k = "SelectTrigger", XPe = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, disabled: o = !1, ...n } = e, r = Ld(a), i = Ta($k, a), s = i.disabled || o, l = Ne(t, i.onTriggerChange), c = Hs(a), u = g.useRef("touch"), [d, h, p] = Rk((m) => {
      const b = c().filter((y) => !y.disabled), w = b.find((y) => y.value === i.value), _ = Ik(b, m, w);
      _ !== void 0 && i.onValueChange(_.value);
    }), f = (m) => {
      s || (i.onOpenChange(!0), p()), m && (i.triggerPointerDownPosRef.current = {
        x: Math.round(m.pageX),
        y: Math.round(m.pageY)
      });
    };
    return /* @__PURE__ */ v(VPe, { asChild: !0, ...r, children: /* @__PURE__ */ v(
      ye.button,
      {
        type: "button",
        role: "combobox",
        "aria-controls": i.contentId,
        "aria-expanded": i.open,
        "aria-required": i.required,
        "aria-autocomplete": "none",
        dir: i.dir,
        "data-state": i.open ? "open" : "closed",
        disabled: s,
        "data-disabled": s ? "" : void 0,
        "data-placeholder": Nk(i.value) ? "" : void 0,
        ...n,
        ref: l,
        onClick: ve(n.onClick, (m) => {
          m.currentTarget.focus(), u.current !== "mouse" && f(m);
        }),
        onPointerDown: ve(n.onPointerDown, (m) => {
          u.current = m.pointerType;
          const b = m.target;
          b.hasPointerCapture(m.pointerId) && b.releasePointerCapture(m.pointerId), m.button === 0 && m.ctrlKey === !1 && m.pointerType === "mouse" && (f(m), m.preventDefault());
        }),
        onKeyDown: ve(n.onKeyDown, (m) => {
          const b = d.current !== "";
          !(m.ctrlKey || m.altKey || m.metaKey) && m.key.length === 1 && h(m.key), !(b && m.key === " ") && KPe.includes(m.key) && (f(), m.preventDefault());
        })
      }
    ) });
  }
);
XPe.displayName = $k;
var Sk = "SelectValue", QPe = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, className: o, style: n, children: r, placeholder: i = "", ...s } = e, l = Ta(Sk, a), { onValueNodeHasChildrenChange: c } = l, u = r !== void 0, d = Ne(t, l.onValueNodeChange);
    return ot(() => {
      c(u);
    }, [c, u]), /* @__PURE__ */ v(
      ye.span,
      {
        ...s,
        ref: d,
        style: { pointerEvents: "none" },
        children: Nk(l.value) ? /* @__PURE__ */ v(De, { children: i }) : r
      }
    );
  }
);
QPe.displayName = Sk;
var eDe = "SelectIcon", tDe = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, children: o, ...n } = e;
    return /* @__PURE__ */ v(ye.span, { "aria-hidden": !0, ...n, ref: t, children: o || "▼" });
  }
);
tDe.displayName = eDe;
var co = "SelectContent", aDe = g.forwardRef(
  (e, t) => {
    const a = Ta(co, e.__scopeSelect), [o, n] = g.useState();
    if (ot(() => {
      n(new DocumentFragment());
    }, []), !a.open) {
      const r = o;
      return r ? mo.createPortal(
        /* @__PURE__ */ v(Ck, { scope: e.__scopeSelect, children: /* @__PURE__ */ v(Md.Slot, { scope: e.__scopeSelect, children: /* @__PURE__ */ v("div", { children: e.children }) }) }),
        r
      ) : null;
    }
    return /* @__PURE__ */ v(Ek, { ...e, ref: t });
  }
);
aDe.displayName = co;
var Rt = 10, [Ck, Ma] = dn(co), oDe = "SelectContentImpl", nDe = /* @__PURE__ */ Fn("SelectContent.RemoveScroll"), Ek = g.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: a,
      position: o = "item-aligned",
      onCloseAutoFocus: n,
      onEscapeKeyDown: r,
      onPointerDownOutside: i,
      //
      // PopperContent props
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: h,
      collisionPadding: p,
      sticky: f,
      hideWhenDetached: m,
      avoidCollisions: b,
      //
      ...w
    } = e, _ = Ta(co, a), [y, k] = g.useState(null), [x, S] = g.useState(null), $ = Ne(t, (L) => k(L)), [E, C] = g.useState(null), [z, R] = g.useState(
      null
    ), H = Hs(a), [M, j] = g.useState(!1), U = g.useRef(!1);
    g.useEffect(() => {
      if (y) return Mw(y);
    }, [y]), Aw();
    const I = g.useCallback(
      (L) => {
        const [Y, ...Q] = H().map((V) => V.ref.current), [J] = Q.slice(-1), ae = document.activeElement;
        for (const V of L)
          if (V === ae || (V?.scrollIntoView({ block: "nearest" }), V === Y && x && (x.scrollTop = 0), V === J && x && (x.scrollTop = x.scrollHeight), V?.focus(), document.activeElement !== ae)) return;
      },
      [H, x]
    ), K = g.useCallback(
      () => I([E, y]),
      [I, E, y]
    );
    g.useEffect(() => {
      M && K();
    }, [M, K]);
    const { onOpenChange: q, triggerPointerDownPosRef: te } = _;
    g.useEffect(() => {
      if (y) {
        let L = { x: 0, y: 0 };
        const Y = (J) => {
          L = {
            x: Math.abs(Math.round(J.pageX) - (te.current?.x ?? 0)),
            y: Math.abs(Math.round(J.pageY) - (te.current?.y ?? 0))
          };
        }, Q = (J) => {
          L.x <= 10 && L.y <= 10 ? J.preventDefault() : y.contains(J.target) || q(!1), document.removeEventListener("pointermove", Y), te.current = null;
        };
        return te.current !== null && (document.addEventListener("pointermove", Y), document.addEventListener("pointerup", Q, { capture: !0, once: !0 })), () => {
          document.removeEventListener("pointermove", Y), document.removeEventListener("pointerup", Q, { capture: !0 });
        };
      }
    }, [y, q, te]), g.useEffect(() => {
      const L = () => q(!1);
      return window.addEventListener("blur", L), window.addEventListener("resize", L), () => {
        window.removeEventListener("blur", L), window.removeEventListener("resize", L);
      };
    }, [q]);
    const [O, A] = Rk((L) => {
      const Y = H().filter((ae) => !ae.disabled), Q = Y.find((ae) => ae.ref.current === document.activeElement), J = Ik(Y, L, Q);
      J && setTimeout(() => J.ref.current.focus());
    }), N = g.useCallback(
      (L, Y, Q) => {
        const J = !U.current && !Q;
        (_.value !== void 0 && _.value === Y || J) && (C(L), J && (U.current = !0));
      },
      [_.value]
    ), B = g.useCallback(() => y?.focus(), [y]), W = g.useCallback(
      (L, Y, Q) => {
        const J = !U.current && !Q;
        (_.value !== void 0 && _.value === Y || J) && R(L);
      },
      [_.value]
    ), Z = o === "popper" ? Kc : zk, ee = Z === Kc ? {
      side: s,
      sideOffset: l,
      align: c,
      alignOffset: u,
      arrowPadding: d,
      collisionBoundary: h,
      collisionPadding: p,
      sticky: f,
      hideWhenDetached: m,
      avoidCollisions: b
    } : {};
    return /* @__PURE__ */ v(
      Ck,
      {
        scope: a,
        content: y,
        viewport: x,
        onViewportChange: S,
        itemRefCallback: N,
        selectedItem: E,
        onItemLeave: B,
        itemTextRefCallback: W,
        focusSelectedItem: K,
        selectedItemText: z,
        position: o,
        isPositioned: M,
        searchRef: O,
        children: /* @__PURE__ */ v($d, { as: nDe, allowPinchZoom: !0, children: /* @__PURE__ */ v(
          xd,
          {
            asChild: !0,
            trapped: _.open,
            onMountAutoFocus: (L) => {
              L.preventDefault();
            },
            onUnmountAutoFocus: ve(n, (L) => {
              _.trigger?.focus({ preventScroll: !0 }), L.preventDefault();
            }),
            children: /* @__PURE__ */ v(
              kd,
              {
                asChild: !0,
                disableOutsidePointerEvents: !0,
                onEscapeKeyDown: r,
                onPointerDownOutside: i,
                onFocusOutside: (L) => L.preventDefault(),
                onDismiss: () => _.onOpenChange(!1),
                children: /* @__PURE__ */ v(
                  Z,
                  {
                    role: "listbox",
                    id: _.contentId,
                    "data-state": _.open ? "open" : "closed",
                    dir: _.dir,
                    onContextMenu: (L) => L.preventDefault(),
                    ...w,
                    ...ee,
                    onPlaced: () => j(!0),
                    ref: $,
                    style: {
                      // flex layout so we can place the scroll buttons properly
                      display: "flex",
                      flexDirection: "column",
                      // reset the outline by default as the content MAY get focused
                      outline: "none",
                      ...w.style
                    },
                    onKeyDown: ve(w.onKeyDown, (L) => {
                      const Y = L.ctrlKey || L.altKey || L.metaKey;
                      if (L.key === "Tab" && L.preventDefault(), !Y && L.key.length === 1 && A(L.key), ["ArrowUp", "ArrowDown", "Home", "End"].includes(L.key)) {
                        let Q = H().filter((J) => !J.disabled).map((J) => J.ref.current);
                        if (["ArrowUp", "End"].includes(L.key) && (Q = Q.slice().reverse()), ["ArrowUp", "ArrowDown"].includes(L.key)) {
                          const J = L.target, ae = Q.indexOf(J);
                          Q = Q.slice(ae + 1);
                        }
                        setTimeout(() => I(Q)), L.preventDefault();
                      }
                    })
                  }
                )
              }
            )
          }
        ) })
      }
    );
  }
);
Ek.displayName = oDe;
var rDe = "SelectItemAlignedPosition", zk = g.forwardRef((e, t) => {
  const { __scopeSelect: a, onPlaced: o, ...n } = e, r = Ta(co, a), i = Ma(co, a), [s, l] = g.useState(null), [c, u] = g.useState(null), d = Ne(t, ($) => u($)), h = Hs(a), p = g.useRef(!1), f = g.useRef(!0), { viewport: m, selectedItem: b, selectedItemText: w, focusSelectedItem: _ } = i, y = g.useCallback(() => {
    if (r.trigger && r.valueNode && s && c && m && b && w) {
      const $ = r.trigger.getBoundingClientRect(), E = c.getBoundingClientRect(), C = r.valueNode.getBoundingClientRect(), z = w.getBoundingClientRect();
      if (r.dir !== "rtl") {
        const J = z.left - E.left, ae = C.left - J, V = $.left - ae, fe = $.width + V, X = Math.max(fe, E.width), Ye = window.innerWidth - Rt, Ve = Uc(ae, [
          Rt,
          // Prevents the content from going off the starting edge of the
          // viewport. It may still go off the ending edge, but this can be
          // controlled by the user since they may want to manage overflow in a
          // specific way.
          // https://github.com/radix-ui/primitives/issues/2049
          Math.max(Rt, Ye - X)
        ]);
        s.style.minWidth = fe + "px", s.style.left = Ve + "px";
      } else {
        const J = E.right - z.right, ae = window.innerWidth - C.right - J, V = window.innerWidth - $.right - ae, fe = $.width + V, X = Math.max(fe, E.width), Ye = window.innerWidth - Rt, Ve = Uc(ae, [
          Rt,
          Math.max(Rt, Ye - X)
        ]);
        s.style.minWidth = fe + "px", s.style.right = Ve + "px";
      }
      const R = h(), H = window.innerHeight - Rt * 2, M = m.scrollHeight, j = window.getComputedStyle(c), U = parseInt(j.borderTopWidth, 10), I = parseInt(j.paddingTop, 10), K = parseInt(j.borderBottomWidth, 10), q = parseInt(j.paddingBottom, 10), te = U + I + M + q + K, O = Math.min(b.offsetHeight * 5, te), A = window.getComputedStyle(m), N = parseInt(A.paddingTop, 10), B = parseInt(A.paddingBottom, 10), W = $.top + $.height / 2 - Rt, Z = H - W, ee = b.offsetHeight / 2, L = b.offsetTop + ee, Y = U + I + L, Q = te - Y;
      if (Y <= W) {
        const J = R.length > 0 && b === R[R.length - 1].ref.current;
        s.style.bottom = "0px";
        const ae = c.clientHeight - m.offsetTop - m.offsetHeight, V = Math.max(
          Z,
          ee + // viewport might have padding bottom, include it to avoid a scrollable viewport
          (J ? B : 0) + ae + K
        ), fe = Y + V;
        s.style.height = fe + "px";
      } else {
        const J = R.length > 0 && b === R[0].ref.current;
        s.style.top = "0px";
        const ae = Math.max(
          W,
          U + m.offsetTop + // viewport might have padding top, include it to avoid a scrollable viewport
          (J ? N : 0) + ee
        ) + Q;
        s.style.height = ae + "px", m.scrollTop = Y - W + m.offsetTop;
      }
      s.style.margin = `${Rt}px 0`, s.style.minHeight = O + "px", s.style.maxHeight = H + "px", o?.(), requestAnimationFrame(() => p.current = !0);
    }
  }, [
    h,
    r.trigger,
    r.valueNode,
    s,
    c,
    m,
    b,
    w,
    r.dir,
    o
  ]);
  ot(() => y(), [y]);
  const [k, x] = g.useState();
  ot(() => {
    c && x(window.getComputedStyle(c).zIndex);
  }, [c]);
  const S = g.useCallback(
    ($) => {
      $ && f.current === !0 && (y(), _?.(), f.current = !1);
    },
    [y, _]
  );
  return /* @__PURE__ */ v(
    sDe,
    {
      scope: a,
      contentWrapper: s,
      shouldExpandOnScrollRef: p,
      onScrollButtonChange: S,
      children: /* @__PURE__ */ v(
        "div",
        {
          ref: l,
          style: {
            display: "flex",
            flexDirection: "column",
            position: "fixed",
            zIndex: k
          },
          children: /* @__PURE__ */ v(
            ye.div,
            {
              ...n,
              ref: d,
              style: {
                // When we get the height of the content, it includes borders. If we were to set
                // the height without having `boxSizing: 'border-box'` it would be too big.
                boxSizing: "border-box",
                // We need to ensure the content doesn't get taller than the wrapper
                maxHeight: "100%",
                ...n.style
              }
            }
          )
        }
      )
    }
  );
});
zk.displayName = rDe;
var iDe = "SelectPopperPosition", Kc = g.forwardRef((e, t) => {
  const {
    __scopeSelect: a,
    align: o = "start",
    collisionPadding: n = Rt,
    ...r
  } = e, i = Ld(a);
  return /* @__PURE__ */ v(
    UPe,
    {
      ...i,
      ...r,
      ref: t,
      align: o,
      collisionPadding: n,
      style: {
        // Ensure border-box for floating-ui calculations
        boxSizing: "border-box",
        ...r.style,
        "--radix-select-content-transform-origin": "var(--radix-popper-transform-origin)",
        "--radix-select-content-available-width": "var(--radix-popper-available-width)",
        "--radix-select-content-available-height": "var(--radix-popper-available-height)",
        "--radix-select-trigger-width": "var(--radix-popper-anchor-width)",
        "--radix-select-trigger-height": "var(--radix-popper-anchor-height)"
      }
    }
  );
});
Kc.displayName = iDe;
var [sDe, Wd] = dn(co, {}), Jc = "SelectViewport", lDe = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, nonce: o, ...n } = e, r = Ma(Jc, a), i = Wd(Jc, a), s = Ne(t, r.onViewportChange), l = g.useRef(0);
    return /* @__PURE__ */ T(De, { children: [
      /* @__PURE__ */ v(
        "style",
        {
          dangerouslySetInnerHTML: {
            __html: "[data-radix-select-viewport]{scrollbar-width:none;-ms-overflow-style:none;-webkit-overflow-scrolling:touch;}[data-radix-select-viewport]::-webkit-scrollbar{display:none}"
          },
          nonce: o
        }
      ),
      /* @__PURE__ */ v(Md.Slot, { scope: a, children: /* @__PURE__ */ v(
        ye.div,
        {
          "data-radix-select-viewport": "",
          role: "presentation",
          ...n,
          ref: s,
          style: {
            // we use position: 'relative' here on the `viewport` so that when we call
            // `selectedItem.offsetTop` in calculations, the offset is relative to the viewport
            // (independent of the scrollUpButton).
            position: "relative",
            flex: 1,
            // Viewport should only be scrollable in the vertical direction.
            // This won't work in vertical writing modes, so we'll need to
            // revisit this if/when that is supported
            // https://developer.chrome.com/blog/vertical-form-controls
            overflow: "hidden auto",
            ...n.style
          },
          onScroll: ve(n.onScroll, (c) => {
            const u = c.currentTarget, { contentWrapper: d, shouldExpandOnScrollRef: h } = i;
            if (h?.current && d) {
              const p = Math.abs(l.current - u.scrollTop);
              if (p > 0) {
                const f = window.innerHeight - Rt * 2, m = parseFloat(d.style.minHeight), b = parseFloat(d.style.height), w = Math.max(m, b);
                if (w < f) {
                  const _ = w + p, y = Math.min(f, _), k = _ - y;
                  d.style.height = y + "px", d.style.bottom === "0px" && (u.scrollTop = k > 0 ? k : 0, d.style.justifyContent = "flex-end");
                }
              }
            }
            l.current = u.scrollTop;
          })
        }
      ) })
    ] });
  }
);
lDe.displayName = Jc;
var jk = "SelectGroup", [cDe, uDe] = dn(jk), dDe = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, ...o } = e, n = ww();
    return /* @__PURE__ */ v(cDe, { scope: a, id: n, children: /* @__PURE__ */ v(ye.div, { role: "group", "aria-labelledby": n, ...o, ref: t }) });
  }
);
dDe.displayName = jk;
var Ak = "SelectLabel", gDe = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, ...o } = e, n = uDe(Ak, a);
    return /* @__PURE__ */ v(ye.div, { id: n.id, ...o, ref: t });
  }
);
gDe.displayName = Ak;
var Yi = "SelectItem", [hDe, Ok] = dn(Yi), mDe = g.forwardRef(
  (e, t) => {
    const {
      __scopeSelect: a,
      value: o,
      disabled: n = !1,
      textValue: r,
      ...i
    } = e, s = Ta(Yi, a), l = Ma(Yi, a), c = s.value === o, [u, d] = g.useState(r ?? ""), [h, p] = g.useState(!1), f = Ne(
      t,
      (_) => l.itemRefCallback?.(_, o, n)
    ), m = ww(), b = g.useRef("touch"), w = () => {
      n || (s.onValueChange(o), s.onOpenChange(!1));
    };
    if (o === "")
      throw new Error(
        "A <Select.Item /> must have a value prop that is not an empty string. This is because the Select value can be set to an empty string to clear the selection and show the placeholder."
      );
    return /* @__PURE__ */ v(
      hDe,
      {
        scope: a,
        value: o,
        disabled: n,
        textId: m,
        isSelected: c,
        onItemTextChange: g.useCallback((_) => {
          d((y) => y || (_?.textContent ?? "").trim());
        }, []),
        children: /* @__PURE__ */ v(
          Md.ItemSlot,
          {
            scope: a,
            value: o,
            disabled: n,
            textValue: u,
            children: /* @__PURE__ */ v(
              ye.div,
              {
                role: "option",
                "aria-labelledby": m,
                "data-highlighted": h ? "" : void 0,
                "aria-selected": c && h,
                "data-state": c ? "checked" : "unchecked",
                "aria-disabled": n || void 0,
                "data-disabled": n ? "" : void 0,
                tabIndex: n ? void 0 : -1,
                ...i,
                ref: f,
                onFocus: ve(i.onFocus, () => p(!0)),
                onBlur: ve(i.onBlur, () => p(!1)),
                onClick: ve(i.onClick, () => {
                  b.current !== "mouse" && w();
                }),
                onPointerUp: ve(i.onPointerUp, () => {
                  b.current === "mouse" && w();
                }),
                onPointerDown: ve(i.onPointerDown, (_) => {
                  b.current = _.pointerType;
                }),
                onPointerMove: ve(i.onPointerMove, (_) => {
                  b.current = _.pointerType, n ? l.onItemLeave?.() : b.current === "mouse" && _.currentTarget.focus({ preventScroll: !0 });
                }),
                onPointerLeave: ve(i.onPointerLeave, (_) => {
                  _.currentTarget === document.activeElement && l.onItemLeave?.();
                }),
                onKeyDown: ve(i.onKeyDown, (_) => {
                  l.searchRef?.current !== "" && _.key === " " || (JPe.includes(_.key) && w(), _.key === " " && _.preventDefault());
                })
              }
            )
          }
        )
      }
    );
  }
);
mDe.displayName = Yi;
var Sn = "SelectItemText", pDe = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, className: o, style: n, ...r } = e, i = Ta(Sn, a), s = Ma(Sn, a), l = Ok(Sn, a), c = YPe(Sn, a), [u, d] = g.useState(null), h = Ne(
      t,
      (w) => d(w),
      l.onItemTextChange,
      (w) => s.itemTextRefCallback?.(w, l.value, l.disabled)
    ), p = u?.textContent, f = g.useMemo(
      () => /* @__PURE__ */ v("option", { value: l.value, disabled: l.disabled, children: p }, l.value),
      [l.disabled, l.value, p]
    ), { onNativeOptionAdd: m, onNativeOptionRemove: b } = c;
    return ot(() => (m(f), () => b(f)), [m, b, f]), /* @__PURE__ */ T(De, { children: [
      /* @__PURE__ */ v(ye.span, { id: l.textId, ...r, ref: h }),
      l.isSelected && i.valueNode && !i.valueNodeHasChildren ? mo.createPortal(r.children, i.valueNode) : null
    ] });
  }
);
pDe.displayName = Sn;
var Pk = "SelectItemIndicator", fDe = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, ...o } = e;
    return Ok(Pk, a).isSelected ? /* @__PURE__ */ v(ye.span, { "aria-hidden": !0, ...o, ref: t }) : null;
  }
);
fDe.displayName = Pk;
var Zc = "SelectScrollUpButton", bDe = g.forwardRef((e, t) => {
  const a = Ma(Zc, e.__scopeSelect), o = Wd(Zc, e.__scopeSelect), [n, r] = g.useState(!1), i = Ne(t, o.onScrollButtonChange);
  return ot(() => {
    if (a.viewport && a.isPositioned) {
      let s = function() {
        const c = l.scrollTop > 0;
        r(c);
      };
      const l = a.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [a.viewport, a.isPositioned]), n ? /* @__PURE__ */ v(
    Dk,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = a;
        s && l && (s.scrollTop = s.scrollTop - l.offsetHeight);
      }
    }
  ) : null;
});
bDe.displayName = Zc;
var Yc = "SelectScrollDownButton", _De = g.forwardRef((e, t) => {
  const a = Ma(Yc, e.__scopeSelect), o = Wd(Yc, e.__scopeSelect), [n, r] = g.useState(!1), i = Ne(t, o.onScrollButtonChange);
  return ot(() => {
    if (a.viewport && a.isPositioned) {
      let s = function() {
        const c = l.scrollHeight - l.clientHeight, u = Math.ceil(l.scrollTop) < c;
        r(u);
      };
      const l = a.viewport;
      return s(), l.addEventListener("scroll", s), () => l.removeEventListener("scroll", s);
    }
  }, [a.viewport, a.isPositioned]), n ? /* @__PURE__ */ v(
    Dk,
    {
      ...e,
      ref: i,
      onAutoScroll: () => {
        const { viewport: s, selectedItem: l } = a;
        s && l && (s.scrollTop = s.scrollTop + l.offsetHeight);
      }
    }
  ) : null;
});
_De.displayName = Yc;
var Dk = g.forwardRef((e, t) => {
  const { __scopeSelect: a, onAutoScroll: o, ...n } = e, r = Ma("SelectScrollButton", a), i = g.useRef(null), s = Hs(a), l = g.useCallback(() => {
    i.current !== null && (window.clearInterval(i.current), i.current = null);
  }, []);
  return g.useEffect(() => () => l(), [l]), ot(() => {
    s().find((c) => c.ref.current === document.activeElement)?.ref.current?.scrollIntoView({ block: "nearest" });
  }, [s]), /* @__PURE__ */ v(
    ye.div,
    {
      "aria-hidden": !0,
      ...n,
      ref: t,
      style: { flexShrink: 0, ...n.style },
      onPointerDown: ve(n.onPointerDown, () => {
        i.current === null && (i.current = window.setInterval(o, 50));
      }),
      onPointerMove: ve(n.onPointerMove, () => {
        r.onItemLeave?.(), i.current === null && (i.current = window.setInterval(o, 50));
      }),
      onPointerLeave: ve(n.onPointerLeave, () => {
        l();
      })
    }
  );
}), vDe = "SelectSeparator", yDe = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, ...o } = e;
    return /* @__PURE__ */ v(ye.div, { "aria-hidden": !0, ...o, ref: t });
  }
);
yDe.displayName = vDe;
var Xc = "SelectArrow", wDe = g.forwardRef(
  (e, t) => {
    const { __scopeSelect: a, ...o } = e, n = Ld(a), r = Ta(Xc, a), i = Ma(Xc, a);
    return r.open && i.position === "popper" ? /* @__PURE__ */ v(qPe, { ...n, ...o, ref: t }) : null;
  }
);
wDe.displayName = Xc;
var kDe = "SelectBubbleInput", xDe = g.forwardRef(
  ({ __scopeSelect: e, value: t, ...a }, o) => {
    const n = g.useRef(null), r = Ne(o, n), i = rje(t);
    return g.useEffect(() => {
      const s = n.current;
      if (!s) return;
      const l = window.HTMLSelectElement.prototype, c = Object.getOwnPropertyDescriptor(
        l,
        "value"
      ).set;
      if (i !== t && c) {
        const u = new Event("change", { bubbles: !0 });
        c.call(s, t), s.dispatchEvent(u);
      }
    }, [i, t]), /* @__PURE__ */ v(
      ye.select,
      {
        ...a,
        style: { ...xk, ...a.style },
        ref: r,
        defaultValue: t
      }
    );
  }
);
xDe.displayName = kDe;
function Nk(e) {
  return e === "" || e === void 0;
}
function Rk(e) {
  const t = ut(e), a = g.useRef(""), o = g.useRef(0), n = g.useCallback(
    (i) => {
      const s = a.current + i;
      t(s), function l(c) {
        a.current = c, window.clearTimeout(o.current), c !== "" && (o.current = window.setTimeout(() => l(""), 1e3));
      }(s);
    },
    [t]
  ), r = g.useCallback(() => {
    a.current = "", window.clearTimeout(o.current);
  }, []);
  return g.useEffect(() => () => window.clearTimeout(o.current), []), [a, n, r];
}
function Ik(e, t, a) {
  const o = t.length > 1 && Array.from(t).every((s) => s === t[0]) ? t[0] : t, n = a ? e.indexOf(a) : -1;
  let r = $De(e, Math.max(n, 0));
  o.length === 1 && (r = r.filter((s) => s !== a));
  const i = r.find(
    (s) => s.textValue.toLowerCase().startsWith(o.toLowerCase())
  );
  return i !== a ? i : void 0;
}
function $De(e, t) {
  return e.map((a, o) => e[(t + o) % e.length]);
}
const SDe = jt(void 0), pp = (e) => {
  let t;
  const a = /* @__PURE__ */ new Set(), o = (s, l) => {
    const c = typeof s == "function" ? s(t) : s;
    if (!Object.is(c, t)) {
      const u = t;
      t = l ?? (typeof c != "object" || c === null) ? c : Object.assign({}, t, c), a.forEach((d) => d(t, u));
    }
  }, n = () => t, r = { setState: o, getState: n, getInitialState: () => i, subscribe: (s) => (a.add(s), () => a.delete(s)) }, i = t = e(o, n, r);
  return r;
}, CDe = (e) => e ? pp(e) : pp;
function EDe(e) {
  const t = {
    config: {
      apiUrl: "",
      assetsUrl: "",
      clients: {
        regular: "",
        collection: ""
      }
    }
  };
  return CDe((a) => ({
    ...t,
    ...e,
    setConfig: (o) => a({ config: o })
  }));
}
function zDe({ children: e, ...t }) {
  const a = Ie(null);
  return a.current || (a.current = EDe(t)), /* @__PURE__ */ v(SDe.Provider, { value: a.current, children: e });
}
const ce = (e) => typeof e == "string", xn = () => {
  let e, t;
  const a = new Promise((o, n) => {
    e = o, t = n;
  });
  return a.resolve = e, a.reject = t, a;
}, fp = (e) => e == null ? "" : "" + e, jDe = (e, t, a) => {
  e.forEach((o) => {
    t[o] && (a[o] = t[o]);
  });
}, ADe = /###/g, bp = (e) => e && e.indexOf("###") > -1 ? e.replace(ADe, ".") : e, _p = (e) => !e || ce(e), Rn = (e, t, a) => {
  const o = ce(t) ? t.split(".") : t;
  let n = 0;
  for (; n < o.length - 1; ) {
    if (_p(e)) return {};
    const r = bp(o[n]);
    !e[r] && a && (e[r] = new a()), Object.prototype.hasOwnProperty.call(e, r) ? e = e[r] : e = {}, ++n;
  }
  return _p(e) ? {} : {
    obj: e,
    k: bp(o[n])
  };
}, vp = (e, t, a) => {
  const {
    obj: o,
    k: n
  } = Rn(e, t, Object);
  if (o !== void 0 || t.length === 1) {
    o[n] = a;
    return;
  }
  let r = t[t.length - 1], i = t.slice(0, t.length - 1), s = Rn(e, i, Object);
  for (; s.obj === void 0 && i.length; )
    r = `${i[i.length - 1]}.${r}`, i = i.slice(0, i.length - 1), s = Rn(e, i, Object), s?.obj && typeof s.obj[`${s.k}.${r}`] < "u" && (s.obj = void 0);
  s.obj[`${s.k}.${r}`] = a;
}, ODe = (e, t, a, o) => {
  const {
    obj: n,
    k: r
  } = Rn(e, t, Object);
  n[r] = n[r] || [], n[r].push(a);
}, Xi = (e, t) => {
  const {
    obj: a,
    k: o
  } = Rn(e, t);
  if (a && Object.prototype.hasOwnProperty.call(a, o))
    return a[o];
}, PDe = (e, t, a) => {
  const o = Xi(e, a);
  return o !== void 0 ? o : Xi(t, a);
}, Tk = (e, t, a) => {
  for (const o in t)
    o !== "__proto__" && o !== "constructor" && (o in e ? ce(e[o]) || e[o] instanceof String || ce(t[o]) || t[o] instanceof String ? a && (e[o] = t[o]) : Tk(e[o], t[o], a) : e[o] = t[o]);
  return e;
}, Ro = (e) => e.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, "\\$&");
var DDe = {
  "&": "&amp;",
  "<": "&lt;",
  ">": "&gt;",
  '"': "&quot;",
  "'": "&#39;",
  "/": "&#x2F;"
};
const NDe = (e) => ce(e) ? e.replace(/[&<>"'\/]/g, (t) => DDe[t]) : e;
class RDe {
  constructor(t) {
    this.capacity = t, this.regExpMap = /* @__PURE__ */ new Map(), this.regExpQueue = [];
  }
  getRegExp(t) {
    const a = this.regExpMap.get(t);
    if (a !== void 0)
      return a;
    const o = new RegExp(t);
    return this.regExpQueue.length === this.capacity && this.regExpMap.delete(this.regExpQueue.shift()), this.regExpMap.set(t, o), this.regExpQueue.push(t), o;
  }
}
const IDe = [" ", ",", "?", "!", ";"], TDe = new RDe(20), MDe = (e, t, a) => {
  t = t || "", a = a || "";
  const o = IDe.filter((i) => t.indexOf(i) < 0 && a.indexOf(i) < 0);
  if (o.length === 0) return !0;
  const n = TDe.getRegExp(`(${o.map((i) => i === "?" ? "\\?" : i).join("|")})`);
  let r = !n.test(e);
  if (!r) {
    const i = e.indexOf(a);
    i > 0 && !n.test(e.substring(0, i)) && (r = !0);
  }
  return r;
}, Qc = (e, t, a = ".") => {
  if (!e) return;
  if (e[t])
    return Object.prototype.hasOwnProperty.call(e, t) ? e[t] : void 0;
  const o = t.split(a);
  let n = e;
  for (let r = 0; r < o.length; ) {
    if (!n || typeof n != "object")
      return;
    let i, s = "";
    for (let l = r; l < o.length; ++l)
      if (l !== r && (s += a), s += o[l], i = n[s], i !== void 0) {
        if (["string", "number", "boolean"].indexOf(typeof i) > -1 && l < o.length - 1)
          continue;
        r += l - r + 1;
        break;
      }
    n = i;
  }
  return n;
}, qn = (e) => e?.replace("_", "-"), LDe = {
  type: "logger",
  log(e) {
    this.output("log", e);
  },
  warn(e) {
    this.output("warn", e);
  },
  error(e) {
    this.output("error", e);
  },
  output(e, t) {
    console?.[e]?.apply?.(console, t);
  }
};
class Qi {
  constructor(t, a = {}) {
    this.init(t, a);
  }
  init(t, a = {}) {
    this.prefix = a.prefix || "i18next:", this.logger = t || LDe, this.options = a, this.debug = a.debug;
  }
  log(...t) {
    return this.forward(t, "log", "", !0);
  }
  warn(...t) {
    return this.forward(t, "warn", "", !0);
  }
  error(...t) {
    return this.forward(t, "error", "");
  }
  deprecate(...t) {
    return this.forward(t, "warn", "WARNING DEPRECATED: ", !0);
  }
  forward(t, a, o, n) {
    return n && !this.debug ? null : (ce(t[0]) && (t[0] = `${o}${this.prefix} ${t[0]}`), this.logger[a](t));
  }
  create(t) {
    return new Qi(this.logger, {
      prefix: `${this.prefix}:${t}:`,
      ...this.options
    });
  }
  clone(t) {
    return t = t || this.options, t.prefix = t.prefix || this.prefix, new Qi(this.logger, t);
  }
}
var Zt = new Qi();
class Gs {
  constructor() {
    this.observers = {};
  }
  on(t, a) {
    return t.split(" ").forEach((o) => {
      this.observers[o] || (this.observers[o] = /* @__PURE__ */ new Map());
      const n = this.observers[o].get(a) || 0;
      this.observers[o].set(a, n + 1);
    }), this;
  }
  off(t, a) {
    if (this.observers[t]) {
      if (!a) {
        delete this.observers[t];
        return;
      }
      this.observers[t].delete(a);
    }
  }
  emit(t, ...a) {
    this.observers[t] && Array.from(this.observers[t].entries()).forEach(([o, n]) => {
      for (let r = 0; r < n; r++)
        o(...a);
    }), this.observers["*"] && Array.from(this.observers["*"].entries()).forEach(([o, n]) => {
      for (let r = 0; r < n; r++)
        o.apply(o, [t, ...a]);
    });
  }
}
class yp extends Gs {
  constructor(t, a = {
    ns: ["translation"],
    defaultNS: "translation"
  }) {
    super(), this.data = t || {}, this.options = a, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.options.ignoreJSONStructure === void 0 && (this.options.ignoreJSONStructure = !0);
  }
  addNamespaces(t) {
    this.options.ns.indexOf(t) < 0 && this.options.ns.push(t);
  }
  removeNamespaces(t) {
    const a = this.options.ns.indexOf(t);
    a > -1 && this.options.ns.splice(a, 1);
  }
  getResource(t, a, o, n = {}) {
    const r = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, i = n.ignoreJSONStructure !== void 0 ? n.ignoreJSONStructure : this.options.ignoreJSONStructure;
    let s;
    t.indexOf(".") > -1 ? s = t.split(".") : (s = [t, a], o && (Array.isArray(o) ? s.push(...o) : ce(o) && r ? s.push(...o.split(r)) : s.push(o)));
    const l = Xi(this.data, s);
    return !l && !a && !o && t.indexOf(".") > -1 && (t = s[0], a = s[1], o = s.slice(2).join(".")), l || !i || !ce(o) ? l : Qc(this.data?.[t]?.[a], o, r);
  }
  addResource(t, a, o, n, r = {
    silent: !1
  }) {
    const i = r.keySeparator !== void 0 ? r.keySeparator : this.options.keySeparator;
    let s = [t, a];
    o && (s = s.concat(i ? o.split(i) : o)), t.indexOf(".") > -1 && (s = t.split("."), n = a, a = s[1]), this.addNamespaces(a), vp(this.data, s, n), r.silent || this.emit("added", t, a, o, n);
  }
  addResources(t, a, o, n = {
    silent: !1
  }) {
    for (const r in o)
      (ce(o[r]) || Array.isArray(o[r])) && this.addResource(t, a, r, o[r], {
        silent: !0
      });
    n.silent || this.emit("added", t, a, o);
  }
  addResourceBundle(t, a, o, n, r, i = {
    silent: !1,
    skipCopy: !1
  }) {
    let s = [t, a];
    t.indexOf(".") > -1 && (s = t.split("."), n = o, o = a, a = s[1]), this.addNamespaces(a);
    let l = Xi(this.data, s) || {};
    i.skipCopy || (o = JSON.parse(JSON.stringify(o))), n ? Tk(l, o, r) : l = {
      ...l,
      ...o
    }, vp(this.data, s, l), i.silent || this.emit("added", t, a, o);
  }
  removeResourceBundle(t, a) {
    this.hasResourceBundle(t, a) && delete this.data[t][a], this.removeNamespaces(a), this.emit("removed", t, a);
  }
  hasResourceBundle(t, a) {
    return this.getResource(t, a) !== void 0;
  }
  getResourceBundle(t, a) {
    return a || (a = this.options.defaultNS), this.getResource(t, a);
  }
  getDataByLanguage(t) {
    return this.data[t];
  }
  hasLanguageSomeTranslations(t) {
    const a = this.getDataByLanguage(t);
    return !!(a && Object.keys(a) || []).find((o) => a[o] && Object.keys(a[o]).length > 0);
  }
  toJSON() {
    return this.data;
  }
}
var Mk = {
  processors: {},
  addPostProcessor(e) {
    this.processors[e.name] = e;
  },
  handle(e, t, a, o, n) {
    return e.forEach((r) => {
      t = this.processors[r]?.process(t, a, o, n) ?? t;
    }), t;
  }
};
const Lk = Symbol("i18next/PATH_KEY");
function WDe() {
  const e = [], t = /* @__PURE__ */ Object.create(null);
  let a;
  return t.get = (o, n) => (a?.revoke?.(), n === Lk ? e : (e.push(n), a = Proxy.revocable(o, t), a.proxy)), Proxy.revocable(/* @__PURE__ */ Object.create(null), t).proxy;
}
function eu(e, t) {
  const {
    [Lk]: a
  } = e(WDe());
  return a.join(t?.keySeparator ?? ".");
}
const wp = {}, kp = (e) => !ce(e) && typeof e != "boolean" && typeof e != "number";
class es extends Gs {
  constructor(t, a = {}) {
    super(), jDe(["resourceStore", "languageUtils", "pluralResolver", "interpolator", "backendConnector", "i18nFormat", "utils"], t, this), this.options = a, this.options.keySeparator === void 0 && (this.options.keySeparator = "."), this.logger = Zt.create("translator");
  }
  changeLanguage(t) {
    t && (this.language = t);
  }
  exists(t, a = {
    interpolation: {}
  }) {
    const o = {
      ...a
    };
    return t == null ? !1 : this.resolve(t, o)?.res !== void 0;
  }
  extractFromKey(t, a) {
    let o = a.nsSeparator !== void 0 ? a.nsSeparator : this.options.nsSeparator;
    o === void 0 && (o = ":");
    const n = a.keySeparator !== void 0 ? a.keySeparator : this.options.keySeparator;
    let r = a.ns || this.options.defaultNS || [];
    const i = o && t.indexOf(o) > -1, s = !this.options.userDefinedKeySeparator && !a.keySeparator && !this.options.userDefinedNsSeparator && !a.nsSeparator && !MDe(t, o, n);
    if (i && !s) {
      const l = t.match(this.interpolator.nestingRegexp);
      if (l && l.length > 0)
        return {
          key: t,
          namespaces: ce(r) ? [r] : r
        };
      const c = t.split(o);
      (o !== n || o === n && this.options.ns.indexOf(c[0]) > -1) && (r = c.shift()), t = c.join(n);
    }
    return {
      key: t,
      namespaces: ce(r) ? [r] : r
    };
  }
  translate(t, a, o) {
    let n = typeof a == "object" ? {
      ...a
    } : a;
    if (typeof n != "object" && this.options.overloadTranslationOptionHandler && (n = this.options.overloadTranslationOptionHandler(arguments)), typeof n == "object" && (n = {
      ...n
    }), n || (n = {}), t == null) return "";
    typeof t == "function" && (t = eu(t, {
      ...this.options,
      ...n
    })), Array.isArray(t) || (t = [String(t)]);
    const r = n.returnDetails !== void 0 ? n.returnDetails : this.options.returnDetails, i = n.keySeparator !== void 0 ? n.keySeparator : this.options.keySeparator, {
      key: s,
      namespaces: l
    } = this.extractFromKey(t[t.length - 1], n), c = l[l.length - 1];
    let u = n.nsSeparator !== void 0 ? n.nsSeparator : this.options.nsSeparator;
    u === void 0 && (u = ":");
    const d = n.lng || this.language, h = n.appendNamespaceToCIMode || this.options.appendNamespaceToCIMode;
    if (d?.toLowerCase() === "cimode")
      return h ? r ? {
        res: `${c}${u}${s}`,
        usedKey: s,
        exactUsedKey: s,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(n)
      } : `${c}${u}${s}` : r ? {
        res: s,
        usedKey: s,
        exactUsedKey: s,
        usedLng: d,
        usedNS: c,
        usedParams: this.getUsedParamsDetails(n)
      } : s;
    const p = this.resolve(t, n);
    let f = p?.res;
    const m = p?.usedKey || s, b = p?.exactUsedKey || s, w = ["[object Number]", "[object Function]", "[object RegExp]"], _ = n.joinArrays !== void 0 ? n.joinArrays : this.options.joinArrays, y = !this.i18nFormat || this.i18nFormat.handleAsObject, k = n.count !== void 0 && !ce(n.count), x = es.hasDefaultValue(n), S = k ? this.pluralResolver.getSuffix(d, n.count, n) : "", $ = n.ordinal && k ? this.pluralResolver.getSuffix(d, n.count, {
      ordinal: !1
    }) : "", E = k && !n.ordinal && n.count === 0, C = E && n[`defaultValue${this.options.pluralSeparator}zero`] || n[`defaultValue${S}`] || n[`defaultValue${$}`] || n.defaultValue;
    let z = f;
    y && !f && x && (z = C);
    const R = kp(z), H = Object.prototype.toString.apply(z);
    if (y && z && R && w.indexOf(H) < 0 && !(ce(_) && Array.isArray(z))) {
      if (!n.returnObjects && !this.options.returnObjects) {
        this.options.returnedObjectHandler || this.logger.warn("accessing an object - but returnObjects options is not enabled!");
        const M = this.options.returnedObjectHandler ? this.options.returnedObjectHandler(m, z, {
          ...n,
          ns: l
        }) : `key '${s} (${this.language})' returned an object instead of string.`;
        return r ? (p.res = M, p.usedParams = this.getUsedParamsDetails(n), p) : M;
      }
      if (i) {
        const M = Array.isArray(z), j = M ? [] : {}, U = M ? b : m;
        for (const I in z)
          if (Object.prototype.hasOwnProperty.call(z, I)) {
            const K = `${U}${i}${I}`;
            x && !f ? j[I] = this.translate(K, {
              ...n,
              defaultValue: kp(C) ? C[I] : void 0,
              joinArrays: !1,
              ns: l
            }) : j[I] = this.translate(K, {
              ...n,
              joinArrays: !1,
              ns: l
            }), j[I] === K && (j[I] = z[I]);
          }
        f = j;
      }
    } else if (y && ce(_) && Array.isArray(f))
      f = f.join(_), f && (f = this.extendTranslation(f, t, n, o));
    else {
      let M = !1, j = !1;
      !this.isValidLookup(f) && x && (M = !0, f = C), this.isValidLookup(f) || (j = !0, f = s);
      const U = (n.missingKeyNoValueFallbackToKey || this.options.missingKeyNoValueFallbackToKey) && j ? void 0 : f, I = x && C !== f && this.options.updateMissing;
      if (j || M || I) {
        if (this.logger.log(I ? "updateKey" : "missingKey", d, c, s, I ? C : f), i) {
          const O = this.resolve(s, {
            ...n,
            keySeparator: !1
          });
          O && O.res && this.logger.warn("Seems the loaded translations were in flat JSON format instead of nested. Either set keySeparator: false on init or make sure your translations are published in nested format.");
        }
        let K = [];
        const q = this.languageUtils.getFallbackCodes(this.options.fallbackLng, n.lng || this.language);
        if (this.options.saveMissingTo === "fallback" && q && q[0])
          for (let O = 0; O < q.length; O++)
            K.push(q[O]);
        else this.options.saveMissingTo === "all" ? K = this.languageUtils.toResolveHierarchy(n.lng || this.language) : K.push(n.lng || this.language);
        const te = (O, A, N) => {
          const B = x && N !== f ? N : U;
          this.options.missingKeyHandler ? this.options.missingKeyHandler(O, c, A, B, I, n) : this.backendConnector?.saveMissing && this.backendConnector.saveMissing(O, c, A, B, I, n), this.emit("missingKey", O, c, A, f);
        };
        this.options.saveMissing && (this.options.saveMissingPlurals && k ? K.forEach((O) => {
          const A = this.pluralResolver.getSuffixes(O, n);
          E && n[`defaultValue${this.options.pluralSeparator}zero`] && A.indexOf(`${this.options.pluralSeparator}zero`) < 0 && A.push(`${this.options.pluralSeparator}zero`), A.forEach((N) => {
            te([O], s + N, n[`defaultValue${N}`] || C);
          });
        }) : te(K, s, C));
      }
      f = this.extendTranslation(f, t, n, p, o), j && f === s && this.options.appendNamespaceToMissingKey && (f = `${c}${u}${s}`), (j || M) && this.options.parseMissingKeyHandler && (f = this.options.parseMissingKeyHandler(this.options.appendNamespaceToMissingKey ? `${c}${u}${s}` : s, M ? f : void 0, n));
    }
    return r ? (p.res = f, p.usedParams = this.getUsedParamsDetails(n), p) : f;
  }
  extendTranslation(t, a, o, n, r) {
    if (this.i18nFormat?.parse)
      t = this.i18nFormat.parse(t, {
        ...this.options.interpolation.defaultVariables,
        ...o
      }, o.lng || this.language || n.usedLng, n.usedNS, n.usedKey, {
        resolved: n
      });
    else if (!o.skipInterpolation) {
      o.interpolation && this.interpolator.init({
        ...o,
        interpolation: {
          ...this.options.interpolation,
          ...o.interpolation
        }
      });
      const l = ce(t) && (o?.interpolation?.skipOnVariables !== void 0 ? o.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables);
      let c;
      if (l) {
        const d = t.match(this.interpolator.nestingRegexp);
        c = d && d.length;
      }
      let u = o.replace && !ce(o.replace) ? o.replace : o;
      if (this.options.interpolation.defaultVariables && (u = {
        ...this.options.interpolation.defaultVariables,
        ...u
      }), t = this.interpolator.interpolate(t, u, o.lng || this.language || n.usedLng, o), l) {
        const d = t.match(this.interpolator.nestingRegexp), h = d && d.length;
        c < h && (o.nest = !1);
      }
      !o.lng && n && n.res && (o.lng = this.language || n.usedLng), o.nest !== !1 && (t = this.interpolator.nest(t, (...d) => r?.[0] === d[0] && !o.context ? (this.logger.warn(`It seems you are nesting recursively key: ${d[0]} in key: ${a[0]}`), null) : this.translate(...d, a), o)), o.interpolation && this.interpolator.reset();
    }
    const i = o.postProcess || this.options.postProcess, s = ce(i) ? [i] : i;
    return t != null && s?.length && o.applyPostProcessor !== !1 && (t = Mk.handle(s, t, a, this.options && this.options.postProcessPassResolved ? {
      i18nResolved: {
        ...n,
        usedParams: this.getUsedParamsDetails(o)
      },
      ...o
    } : o, this)), t;
  }
  resolve(t, a = {}) {
    let o, n, r, i, s;
    return ce(t) && (t = [t]), t.forEach((l) => {
      if (this.isValidLookup(o)) return;
      const c = this.extractFromKey(l, a), u = c.key;
      n = u;
      let d = c.namespaces;
      this.options.fallbackNS && (d = d.concat(this.options.fallbackNS));
      const h = a.count !== void 0 && !ce(a.count), p = h && !a.ordinal && a.count === 0, f = a.context !== void 0 && (ce(a.context) || typeof a.context == "number") && a.context !== "", m = a.lngs ? a.lngs : this.languageUtils.toResolveHierarchy(a.lng || this.language, a.fallbackLng);
      d.forEach((b) => {
        this.isValidLookup(o) || (s = b, !wp[`${m[0]}-${b}`] && this.utils?.hasLoadedNamespace && !this.utils?.hasLoadedNamespace(s) && (wp[`${m[0]}-${b}`] = !0, this.logger.warn(`key "${n}" for languages "${m.join(", ")}" won't get resolved as namespace "${s}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!")), m.forEach((w) => {
          if (this.isValidLookup(o)) return;
          i = w;
          const _ = [u];
          if (this.i18nFormat?.addLookupKeys)
            this.i18nFormat.addLookupKeys(_, u, w, b, a);
          else {
            let k;
            h && (k = this.pluralResolver.getSuffix(w, a.count, a));
            const x = `${this.options.pluralSeparator}zero`, S = `${this.options.pluralSeparator}ordinal${this.options.pluralSeparator}`;
            if (h && (a.ordinal && k.indexOf(S) === 0 && _.push(u + k.replace(S, this.options.pluralSeparator)), _.push(u + k), p && _.push(u + x)), f) {
              const $ = `${u}${this.options.contextSeparator || "_"}${a.context}`;
              _.push($), h && (a.ordinal && k.indexOf(S) === 0 && _.push($ + k.replace(S, this.options.pluralSeparator)), _.push($ + k), p && _.push($ + x));
            }
          }
          let y;
          for (; y = _.pop(); )
            this.isValidLookup(o) || (r = y, o = this.getResource(w, b, y, a));
        }));
      });
    }), {
      res: o,
      usedKey: n,
      exactUsedKey: r,
      usedLng: i,
      usedNS: s
    };
  }
  isValidLookup(t) {
    return t !== void 0 && !(!this.options.returnNull && t === null) && !(!this.options.returnEmptyString && t === "");
  }
  getResource(t, a, o, n = {}) {
    return this.i18nFormat?.getResource ? this.i18nFormat.getResource(t, a, o, n) : this.resourceStore.getResource(t, a, o, n);
  }
  getUsedParamsDetails(t = {}) {
    const a = ["defaultValue", "ordinal", "context", "replace", "lng", "lngs", "fallbackLng", "ns", "keySeparator", "nsSeparator", "returnObjects", "returnDetails", "joinArrays", "postProcess", "interpolation"], o = t.replace && !ce(t.replace);
    let n = o ? t.replace : t;
    if (o && typeof t.count < "u" && (n.count = t.count), this.options.interpolation.defaultVariables && (n = {
      ...this.options.interpolation.defaultVariables,
      ...n
    }), !o) {
      n = {
        ...n
      };
      for (const r of a)
        delete n[r];
    }
    return n;
  }
  static hasDefaultValue(t) {
    const a = "defaultValue";
    for (const o in t)
      if (Object.prototype.hasOwnProperty.call(t, o) && a === o.substring(0, a.length) && t[o] !== void 0)
        return !0;
    return !1;
  }
}
class xp {
  constructor(t) {
    this.options = t, this.supportedLngs = this.options.supportedLngs || !1, this.logger = Zt.create("languageUtils");
  }
  getScriptPartFromCode(t) {
    if (t = qn(t), !t || t.indexOf("-") < 0) return null;
    const a = t.split("-");
    return a.length === 2 || (a.pop(), a[a.length - 1].toLowerCase() === "x") ? null : this.formatLanguageCode(a.join("-"));
  }
  getLanguagePartFromCode(t) {
    if (t = qn(t), !t || t.indexOf("-") < 0) return t;
    const a = t.split("-");
    return this.formatLanguageCode(a[0]);
  }
  formatLanguageCode(t) {
    if (ce(t) && t.indexOf("-") > -1) {
      let a;
      try {
        a = Intl.getCanonicalLocales(t)[0];
      } catch {
      }
      return a && this.options.lowerCaseLng && (a = a.toLowerCase()), a || (this.options.lowerCaseLng ? t.toLowerCase() : t);
    }
    return this.options.cleanCode || this.options.lowerCaseLng ? t.toLowerCase() : t;
  }
  isSupportedCode(t) {
    return (this.options.load === "languageOnly" || this.options.nonExplicitSupportedLngs) && (t = this.getLanguagePartFromCode(t)), !this.supportedLngs || !this.supportedLngs.length || this.supportedLngs.indexOf(t) > -1;
  }
  getBestMatchFromCodes(t) {
    if (!t) return null;
    let a;
    return t.forEach((o) => {
      if (a) return;
      const n = this.formatLanguageCode(o);
      (!this.options.supportedLngs || this.isSupportedCode(n)) && (a = n);
    }), !a && this.options.supportedLngs && t.forEach((o) => {
      if (a) return;
      const n = this.getScriptPartFromCode(o);
      if (this.isSupportedCode(n)) return a = n;
      const r = this.getLanguagePartFromCode(o);
      if (this.isSupportedCode(r)) return a = r;
      a = this.options.supportedLngs.find((i) => {
        if (i === r || !(i.indexOf("-") < 0 && r.indexOf("-") < 0) && (i.indexOf("-") > 0 && r.indexOf("-") < 0 && i.substring(0, i.indexOf("-")) === r || i.indexOf(r) === 0 && r.length > 1))
          return i;
      });
    }), a || (a = this.getFallbackCodes(this.options.fallbackLng)[0]), a;
  }
  getFallbackCodes(t, a) {
    if (!t) return [];
    if (typeof t == "function" && (t = t(a)), ce(t) && (t = [t]), Array.isArray(t)) return t;
    if (!a) return t.default || [];
    let o = t[a];
    return o || (o = t[this.getScriptPartFromCode(a)]), o || (o = t[this.formatLanguageCode(a)]), o || (o = t[this.getLanguagePartFromCode(a)]), o || (o = t.default), o || [];
  }
  toResolveHierarchy(t, a) {
    const o = this.getFallbackCodes((a === !1 ? [] : a) || this.options.fallbackLng || [], t), n = [], r = (i) => {
      i && (this.isSupportedCode(i) ? n.push(i) : this.logger.warn(`rejecting language code not found in supportedLngs: ${i}`));
    };
    return ce(t) && (t.indexOf("-") > -1 || t.indexOf("_") > -1) ? (this.options.load !== "languageOnly" && r(this.formatLanguageCode(t)), this.options.load !== "languageOnly" && this.options.load !== "currentOnly" && r(this.getScriptPartFromCode(t)), this.options.load !== "currentOnly" && r(this.getLanguagePartFromCode(t))) : ce(t) && r(this.formatLanguageCode(t)), o.forEach((i) => {
      n.indexOf(i) < 0 && r(this.formatLanguageCode(i));
    }), n;
  }
}
const $p = {
  zero: 0,
  one: 1,
  two: 2,
  few: 3,
  many: 4,
  other: 5
}, Sp = {
  select: (e) => e === 1 ? "one" : "other",
  resolvedOptions: () => ({
    pluralCategories: ["one", "other"]
  })
};
class BDe {
  constructor(t, a = {}) {
    this.languageUtils = t, this.options = a, this.logger = Zt.create("pluralResolver"), this.pluralRulesCache = {};
  }
  addRule(t, a) {
    this.rules[t] = a;
  }
  clearCache() {
    this.pluralRulesCache = {};
  }
  getRule(t, a = {}) {
    const o = qn(t === "dev" ? "en" : t), n = a.ordinal ? "ordinal" : "cardinal", r = JSON.stringify({
      cleanedCode: o,
      type: n
    });
    if (r in this.pluralRulesCache)
      return this.pluralRulesCache[r];
    let i;
    try {
      i = new Intl.PluralRules(o, {
        type: n
      });
    } catch {
      if (!Intl)
        return this.logger.error("No Intl support, please use an Intl polyfill!"), Sp;
      if (!t.match(/-|_/)) return Sp;
      const s = this.languageUtils.getLanguagePartFromCode(t);
      i = this.getRule(s, a);
    }
    return this.pluralRulesCache[r] = i, i;
  }
  needsPlural(t, a = {}) {
    let o = this.getRule(t, a);
    return o || (o = this.getRule("dev", a)), o?.resolvedOptions().pluralCategories.length > 1;
  }
  getPluralFormsOfKey(t, a, o = {}) {
    return this.getSuffixes(t, o).map((n) => `${a}${n}`);
  }
  getSuffixes(t, a = {}) {
    let o = this.getRule(t, a);
    return o || (o = this.getRule("dev", a)), o ? o.resolvedOptions().pluralCategories.sort((n, r) => $p[n] - $p[r]).map((n) => `${this.options.prepend}${a.ordinal ? `ordinal${this.options.prepend}` : ""}${n}`) : [];
  }
  getSuffix(t, a, o = {}) {
    const n = this.getRule(t, o);
    return n ? `${this.options.prepend}${o.ordinal ? `ordinal${this.options.prepend}` : ""}${n.select(a)}` : (this.logger.warn(`no plural rule found for: ${t}`), this.getSuffix("dev", a, o));
  }
}
const Cp = (e, t, a, o = ".", n = !0) => {
  let r = PDe(e, t, a);
  return !r && n && ce(a) && (r = Qc(e, a, o), r === void 0 && (r = Qc(t, a, o))), r;
}, Jl = (e) => e.replace(/\$/g, "$$$$");
class FDe {
  constructor(t = {}) {
    this.logger = Zt.create("interpolator"), this.options = t, this.format = t?.interpolation?.format || ((a) => a), this.init(t);
  }
  init(t = {}) {
    t.interpolation || (t.interpolation = {
      escapeValue: !0
    });
    const {
      escape: a,
      escapeValue: o,
      useRawValueToEscape: n,
      prefix: r,
      prefixEscaped: i,
      suffix: s,
      suffixEscaped: l,
      formatSeparator: c,
      unescapeSuffix: u,
      unescapePrefix: d,
      nestingPrefix: h,
      nestingPrefixEscaped: p,
      nestingSuffix: f,
      nestingSuffixEscaped: m,
      nestingOptionsSeparator: b,
      maxReplaces: w,
      alwaysFormat: _
    } = t.interpolation;
    this.escape = a !== void 0 ? a : NDe, this.escapeValue = o !== void 0 ? o : !0, this.useRawValueToEscape = n !== void 0 ? n : !1, this.prefix = r ? Ro(r) : i || "{{", this.suffix = s ? Ro(s) : l || "}}", this.formatSeparator = c || ",", this.unescapePrefix = u ? "" : d || "-", this.unescapeSuffix = this.unescapePrefix ? "" : u || "", this.nestingPrefix = h ? Ro(h) : p || Ro("$t("), this.nestingSuffix = f ? Ro(f) : m || Ro(")"), this.nestingOptionsSeparator = b || ",", this.maxReplaces = w || 1e3, this.alwaysFormat = _ !== void 0 ? _ : !1, this.resetRegExp();
  }
  reset() {
    this.options && this.init(this.options);
  }
  resetRegExp() {
    const t = (a, o) => a?.source === o ? (a.lastIndex = 0, a) : new RegExp(o, "g");
    this.regexp = t(this.regexp, `${this.prefix}(.+?)${this.suffix}`), this.regexpUnescape = t(this.regexpUnescape, `${this.prefix}${this.unescapePrefix}(.+?)${this.unescapeSuffix}${this.suffix}`), this.nestingRegexp = t(this.nestingRegexp, `${this.nestingPrefix}((?:[^()"']+|"[^"]*"|'[^']*'|\\((?:[^()]|"[^"]*"|'[^']*')*\\))*?)${this.nestingSuffix}`);
  }
  interpolate(t, a, o, n) {
    let r, i, s;
    const l = this.options && this.options.interpolation && this.options.interpolation.defaultVariables || {}, c = (h) => {
      if (h.indexOf(this.formatSeparator) < 0) {
        const b = Cp(a, l, h, this.options.keySeparator, this.options.ignoreJSONStructure);
        return this.alwaysFormat ? this.format(b, void 0, o, {
          ...n,
          ...a,
          interpolationkey: h
        }) : b;
      }
      const p = h.split(this.formatSeparator), f = p.shift().trim(), m = p.join(this.formatSeparator).trim();
      return this.format(Cp(a, l, f, this.options.keySeparator, this.options.ignoreJSONStructure), m, o, {
        ...n,
        ...a,
        interpolationkey: f
      });
    };
    this.resetRegExp();
    const u = n?.missingInterpolationHandler || this.options.missingInterpolationHandler, d = n?.interpolation?.skipOnVariables !== void 0 ? n.interpolation.skipOnVariables : this.options.interpolation.skipOnVariables;
    return [{
      regex: this.regexpUnescape,
      safeValue: (h) => Jl(h)
    }, {
      regex: this.regexp,
      safeValue: (h) => this.escapeValue ? Jl(this.escape(h)) : Jl(h)
    }].forEach((h) => {
      for (s = 0; r = h.regex.exec(t); ) {
        const p = r[1].trim();
        if (i = c(p), i === void 0)
          if (typeof u == "function") {
            const m = u(t, r, n);
            i = ce(m) ? m : "";
          } else if (n && Object.prototype.hasOwnProperty.call(n, p))
            i = "";
          else if (d) {
            i = r[0];
            continue;
          } else
            this.logger.warn(`missed to pass in variable ${p} for interpolating ${t}`), i = "";
        else !ce(i) && !this.useRawValueToEscape && (i = fp(i));
        const f = h.safeValue(i);
        if (t = t.replace(r[0], f), d ? (h.regex.lastIndex += i.length, h.regex.lastIndex -= r[0].length) : h.regex.lastIndex = 0, s++, s >= this.maxReplaces)
          break;
      }
    }), t;
  }
  nest(t, a, o = {}) {
    let n, r, i;
    const s = (l, c) => {
      const u = this.nestingOptionsSeparator;
      if (l.indexOf(u) < 0) return l;
      const d = l.split(new RegExp(`${u}[ ]*{`));
      let h = `{${d[1]}`;
      l = d[0], h = this.interpolate(h, i);
      const p = h.match(/'/g), f = h.match(/"/g);
      ((p?.length ?? 0) % 2 === 0 && !f || f.length % 2 !== 0) && (h = h.replace(/'/g, '"'));
      try {
        i = JSON.parse(h), c && (i = {
          ...c,
          ...i
        });
      } catch (m) {
        return this.logger.warn(`failed parsing options string in nesting for key ${l}`, m), `${l}${u}${h}`;
      }
      return i.defaultValue && i.defaultValue.indexOf(this.prefix) > -1 && delete i.defaultValue, l;
    };
    for (; n = this.nestingRegexp.exec(t); ) {
      let l = [];
      i = {
        ...o
      }, i = i.replace && !ce(i.replace) ? i.replace : i, i.applyPostProcessor = !1, delete i.defaultValue;
      const c = /{.*}/.test(n[1]) ? n[1].lastIndexOf("}") + 1 : n[1].indexOf(this.formatSeparator);
      if (c !== -1 && (l = n[1].slice(c).split(this.formatSeparator).map((u) => u.trim()).filter(Boolean), n[1] = n[1].slice(0, c)), r = a(s.call(this, n[1].trim(), i), i), r && n[0] === t && !ce(r)) return r;
      ce(r) || (r = fp(r)), r || (this.logger.warn(`missed to resolve ${n[1]} for nesting ${t}`), r = ""), l.length && (r = l.reduce((u, d) => this.format(u, d, o.lng, {
        ...o,
        interpolationkey: n[1].trim()
      }), r.trim())), t = t.replace(n[0], r), this.regexp.lastIndex = 0;
    }
    return t;
  }
}
const VDe = (e) => {
  let t = e.toLowerCase().trim();
  const a = {};
  if (e.indexOf("(") > -1) {
    const o = e.split("(");
    t = o[0].toLowerCase().trim();
    const n = o[1].substring(0, o[1].length - 1);
    t === "currency" && n.indexOf(":") < 0 ? a.currency || (a.currency = n.trim()) : t === "relativetime" && n.indexOf(":") < 0 ? a.range || (a.range = n.trim()) : n.split(";").forEach((r) => {
      if (r) {
        const [i, ...s] = r.split(":"), l = s.join(":").trim().replace(/^'+|'+$/g, ""), c = i.trim();
        a[c] || (a[c] = l), l === "false" && (a[c] = !1), l === "true" && (a[c] = !0), isNaN(l) || (a[c] = parseInt(l, 10));
      }
    });
  }
  return {
    formatName: t,
    formatOptions: a
  };
}, Ep = (e) => {
  const t = {};
  return (a, o, n) => {
    let r = n;
    n && n.interpolationkey && n.formatParams && n.formatParams[n.interpolationkey] && n[n.interpolationkey] && (r = {
      ...r,
      [n.interpolationkey]: void 0
    });
    const i = o + JSON.stringify(r);
    let s = t[i];
    return s || (s = e(qn(o), n), t[i] = s), s(a);
  };
}, UDe = (e) => (t, a, o) => e(qn(a), o)(t);
class qDe {
  constructor(t = {}) {
    this.logger = Zt.create("formatter"), this.options = t, this.init(t);
  }
  init(t, a = {
    interpolation: {}
  }) {
    this.formatSeparator = a.interpolation.formatSeparator || ",";
    const o = a.cacheInBuiltFormats ? Ep : UDe;
    this.formats = {
      number: o((n, r) => {
        const i = new Intl.NumberFormat(n, {
          ...r
        });
        return (s) => i.format(s);
      }),
      currency: o((n, r) => {
        const i = new Intl.NumberFormat(n, {
          ...r,
          style: "currency"
        });
        return (s) => i.format(s);
      }),
      datetime: o((n, r) => {
        const i = new Intl.DateTimeFormat(n, {
          ...r
        });
        return (s) => i.format(s);
      }),
      relativetime: o((n, r) => {
        const i = new Intl.RelativeTimeFormat(n, {
          ...r
        });
        return (s) => i.format(s, r.range || "day");
      }),
      list: o((n, r) => {
        const i = new Intl.ListFormat(n, {
          ...r
        });
        return (s) => i.format(s);
      })
    };
  }
  add(t, a) {
    this.formats[t.toLowerCase().trim()] = a;
  }
  addCached(t, a) {
    this.formats[t.toLowerCase().trim()] = Ep(a);
  }
  format(t, a, o, n = {}) {
    const r = a.split(this.formatSeparator);
    if (r.length > 1 && r[0].indexOf("(") > 1 && r[0].indexOf(")") < 0 && r.find((i) => i.indexOf(")") > -1)) {
      const i = r.findIndex((s) => s.indexOf(")") > -1);
      r[0] = [r[0], ...r.splice(1, i)].join(this.formatSeparator);
    }
    return r.reduce((i, s) => {
      const {
        formatName: l,
        formatOptions: c
      } = VDe(s);
      if (this.formats[l]) {
        let u = i;
        try {
          const d = n?.formatParams?.[n.interpolationkey] || {}, h = d.locale || d.lng || n.locale || n.lng || o;
          u = this.formats[l](i, h, {
            ...c,
            ...n,
            ...d
          });
        } catch (d) {
          this.logger.warn(d);
        }
        return u;
      } else
        this.logger.warn(`there was no format function for ${l}`);
      return i;
    }, t);
  }
}
const HDe = (e, t) => {
  e.pending[t] !== void 0 && (delete e.pending[t], e.pendingCount--);
};
class GDe extends Gs {
  constructor(t, a, o, n = {}) {
    super(), this.backend = t, this.store = a, this.services = o, this.languageUtils = o.languageUtils, this.options = n, this.logger = Zt.create("backendConnector"), this.waitingReads = [], this.maxParallelReads = n.maxParallelReads || 10, this.readingCalls = 0, this.maxRetries = n.maxRetries >= 0 ? n.maxRetries : 5, this.retryTimeout = n.retryTimeout >= 1 ? n.retryTimeout : 350, this.state = {}, this.queue = [], this.backend?.init?.(o, n.backend, n);
  }
  queueLoad(t, a, o, n) {
    const r = {}, i = {}, s = {}, l = {};
    return t.forEach((c) => {
      let u = !0;
      a.forEach((d) => {
        const h = `${c}|${d}`;
        !o.reload && this.store.hasResourceBundle(c, d) ? this.state[h] = 2 : this.state[h] < 0 || (this.state[h] === 1 ? i[h] === void 0 && (i[h] = !0) : (this.state[h] = 1, u = !1, i[h] === void 0 && (i[h] = !0), r[h] === void 0 && (r[h] = !0), l[d] === void 0 && (l[d] = !0)));
      }), u || (s[c] = !0);
    }), (Object.keys(r).length || Object.keys(i).length) && this.queue.push({
      pending: i,
      pendingCount: Object.keys(i).length,
      loaded: {},
      errors: [],
      callback: n
    }), {
      toLoad: Object.keys(r),
      pending: Object.keys(i),
      toLoadLanguages: Object.keys(s),
      toLoadNamespaces: Object.keys(l)
    };
  }
  loaded(t, a, o) {
    const n = t.split("|"), r = n[0], i = n[1];
    a && this.emit("failedLoading", r, i, a), !a && o && this.store.addResourceBundle(r, i, o, void 0, void 0, {
      skipCopy: !0
    }), this.state[t] = a ? -1 : 2, a && o && (this.state[t] = 0);
    const s = {};
    this.queue.forEach((l) => {
      ODe(l.loaded, [r], i), HDe(l, t), a && l.errors.push(a), l.pendingCount === 0 && !l.done && (Object.keys(l.loaded).forEach((c) => {
        s[c] || (s[c] = {});
        const u = l.loaded[c];
        u.length && u.forEach((d) => {
          s[c][d] === void 0 && (s[c][d] = !0);
        });
      }), l.done = !0, l.errors.length ? l.callback(l.errors) : l.callback());
    }), this.emit("loaded", s), this.queue = this.queue.filter((l) => !l.done);
  }
  read(t, a, o, n = 0, r = this.retryTimeout, i) {
    if (!t.length) return i(null, {});
    if (this.readingCalls >= this.maxParallelReads) {
      this.waitingReads.push({
        lng: t,
        ns: a,
        fcName: o,
        tried: n,
        wait: r,
        callback: i
      });
      return;
    }
    this.readingCalls++;
    const s = (c, u) => {
      if (this.readingCalls--, this.waitingReads.length > 0) {
        const d = this.waitingReads.shift();
        this.read(d.lng, d.ns, d.fcName, d.tried, d.wait, d.callback);
      }
      if (c && u && n < this.maxRetries) {
        setTimeout(() => {
          this.read.call(this, t, a, o, n + 1, r * 2, i);
        }, r);
        return;
      }
      i(c, u);
    }, l = this.backend[o].bind(this.backend);
    if (l.length === 2) {
      try {
        const c = l(t, a);
        c && typeof c.then == "function" ? c.then((u) => s(null, u)).catch(s) : s(null, c);
      } catch (c) {
        s(c);
      }
      return;
    }
    return l(t, a, s);
  }
  prepareLoading(t, a, o = {}, n) {
    if (!this.backend)
      return this.logger.warn("No backend was added via i18next.use. Will not load resources."), n && n();
    ce(t) && (t = this.languageUtils.toResolveHierarchy(t)), ce(a) && (a = [a]);
    const r = this.queueLoad(t, a, o, n);
    if (!r.toLoad.length)
      return r.pending.length || n(), null;
    r.toLoad.forEach((i) => {
      this.loadOne(i);
    });
  }
  load(t, a, o) {
    this.prepareLoading(t, a, {}, o);
  }
  reload(t, a, o) {
    this.prepareLoading(t, a, {
      reload: !0
    }, o);
  }
  loadOne(t, a = "") {
    const o = t.split("|"), n = o[0], r = o[1];
    this.read(n, r, "read", void 0, void 0, (i, s) => {
      i && this.logger.warn(`${a}loading namespace ${r} for language ${n} failed`, i), !i && s && this.logger.log(`${a}loaded namespace ${r} for language ${n}`, s), this.loaded(t, i, s);
    });
  }
  saveMissing(t, a, o, n, r, i = {}, s = () => {
  }) {
    if (this.services?.utils?.hasLoadedNamespace && !this.services?.utils?.hasLoadedNamespace(a)) {
      this.logger.warn(`did not save key "${o}" as the namespace "${a}" was not yet loaded`, "This means something IS WRONG in your setup. You access the t function before i18next.init / i18next.loadNamespace / i18next.changeLanguage was done. Wait for the callback or Promise to resolve before accessing it!!!");
      return;
    }
    if (!(o == null || o === "")) {
      if (this.backend?.create) {
        const l = {
          ...i,
          isUpdate: r
        }, c = this.backend.create.bind(this.backend);
        if (c.length < 6)
          try {
            let u;
            c.length === 5 ? u = c(t, a, o, n, l) : u = c(t, a, o, n), u && typeof u.then == "function" ? u.then((d) => s(null, d)).catch(s) : s(null, u);
          } catch (u) {
            s(u);
          }
        else
          c(t, a, o, n, s, l);
      }
      !t || !t[0] || this.store.addResource(t[0], a, o, n);
    }
  }
}
const zp = () => ({
  debug: !1,
  initAsync: !0,
  ns: ["translation"],
  defaultNS: ["translation"],
  fallbackLng: ["dev"],
  fallbackNS: !1,
  supportedLngs: !1,
  nonExplicitSupportedLngs: !1,
  load: "all",
  preload: !1,
  simplifyPluralSuffix: !0,
  keySeparator: ".",
  nsSeparator: ":",
  pluralSeparator: "_",
  contextSeparator: "_",
  partialBundledLanguages: !1,
  saveMissing: !1,
  updateMissing: !1,
  saveMissingTo: "fallback",
  saveMissingPlurals: !0,
  missingKeyHandler: !1,
  missingInterpolationHandler: !1,
  postProcess: !1,
  postProcessPassResolved: !1,
  returnNull: !1,
  returnEmptyString: !0,
  returnObjects: !1,
  joinArrays: !1,
  returnedObjectHandler: !1,
  parseMissingKeyHandler: !1,
  appendNamespaceToMissingKey: !1,
  appendNamespaceToCIMode: !1,
  overloadTranslationOptionHandler: (e) => {
    let t = {};
    if (typeof e[1] == "object" && (t = e[1]), ce(e[1]) && (t.defaultValue = e[1]), ce(e[2]) && (t.tDescription = e[2]), typeof e[2] == "object" || typeof e[3] == "object") {
      const a = e[3] || e[2];
      Object.keys(a).forEach((o) => {
        t[o] = a[o];
      });
    }
    return t;
  },
  interpolation: {
    escapeValue: !0,
    format: (e) => e,
    prefix: "{{",
    suffix: "}}",
    formatSeparator: ",",
    unescapePrefix: "-",
    nestingPrefix: "$t(",
    nestingSuffix: ")",
    nestingOptionsSeparator: ",",
    maxReplaces: 1e3,
    skipOnVariables: !0
  },
  cacheInBuiltFormats: !0
}), jp = (e) => (ce(e.ns) && (e.ns = [e.ns]), ce(e.fallbackLng) && (e.fallbackLng = [e.fallbackLng]), ce(e.fallbackNS) && (e.fallbackNS = [e.fallbackNS]), e.supportedLngs?.indexOf?.("cimode") < 0 && (e.supportedLngs = e.supportedLngs.concat(["cimode"])), typeof e.initImmediate == "boolean" && (e.initAsync = e.initImmediate), e), Ur = () => {
}, KDe = (e) => {
  Object.getOwnPropertyNames(Object.getPrototypeOf(e)).forEach((t) => {
    typeof e[t] == "function" && (e[t] = e[t].bind(e));
  });
};
class Hn extends Gs {
  constructor(t = {}, a) {
    if (super(), this.options = jp(t), this.services = {}, this.logger = Zt, this.modules = {
      external: []
    }, KDe(this), a && !this.isInitialized && !t.isClone) {
      if (!this.options.initAsync)
        return this.init(t, a), this;
      setTimeout(() => {
        this.init(t, a);
      }, 0);
    }
  }
  init(t = {}, a) {
    this.isInitializing = !0, typeof t == "function" && (a = t, t = {}), t.defaultNS == null && t.ns && (ce(t.ns) ? t.defaultNS = t.ns : t.ns.indexOf("translation") < 0 && (t.defaultNS = t.ns[0]));
    const o = zp();
    this.options = {
      ...o,
      ...this.options,
      ...jp(t)
    }, this.options.interpolation = {
      ...o.interpolation,
      ...this.options.interpolation
    }, t.keySeparator !== void 0 && (this.options.userDefinedKeySeparator = t.keySeparator), t.nsSeparator !== void 0 && (this.options.userDefinedNsSeparator = t.nsSeparator);
    const n = (s) => s ? typeof s == "function" ? new s() : s : null;
    if (!this.options.isClone) {
      this.modules.logger ? Zt.init(n(this.modules.logger), this.options) : Zt.init(null, this.options);
      let s;
      this.modules.formatter ? s = this.modules.formatter : s = qDe;
      const l = new xp(this.options);
      this.store = new yp(this.options.resources, this.options);
      const c = this.services;
      c.logger = Zt, c.resourceStore = this.store, c.languageUtils = l, c.pluralResolver = new BDe(l, {
        prepend: this.options.pluralSeparator,
        simplifyPluralSuffix: this.options.simplifyPluralSuffix
      }), this.options.interpolation.format && this.options.interpolation.format !== o.interpolation.format && this.logger.deprecate("init: you are still using the legacy format function, please use the new approach: https://www.i18next.com/translation-function/formatting"), s && (!this.options.interpolation.format || this.options.interpolation.format === o.interpolation.format) && (c.formatter = n(s), c.formatter.init && c.formatter.init(c, this.options), this.options.interpolation.format = c.formatter.format.bind(c.formatter)), c.interpolator = new FDe(this.options), c.utils = {
        hasLoadedNamespace: this.hasLoadedNamespace.bind(this)
      }, c.backendConnector = new GDe(n(this.modules.backend), c.resourceStore, c, this.options), c.backendConnector.on("*", (u, ...d) => {
        this.emit(u, ...d);
      }), this.modules.languageDetector && (c.languageDetector = n(this.modules.languageDetector), c.languageDetector.init && c.languageDetector.init(c, this.options.detection, this.options)), this.modules.i18nFormat && (c.i18nFormat = n(this.modules.i18nFormat), c.i18nFormat.init && c.i18nFormat.init(this)), this.translator = new es(this.services, this.options), this.translator.on("*", (u, ...d) => {
        this.emit(u, ...d);
      }), this.modules.external.forEach((u) => {
        u.init && u.init(this);
      });
    }
    if (this.format = this.options.interpolation.format, a || (a = Ur), this.options.fallbackLng && !this.services.languageDetector && !this.options.lng) {
      const s = this.services.languageUtils.getFallbackCodes(this.options.fallbackLng);
      s.length > 0 && s[0] !== "dev" && (this.options.lng = s[0]);
    }
    !this.services.languageDetector && !this.options.lng && this.logger.warn("init: no languageDetector is used and no lng is defined"), ["getResource", "hasResourceBundle", "getResourceBundle", "getDataByLanguage"].forEach((s) => {
      this[s] = (...l) => this.store[s](...l);
    }), ["addResource", "addResources", "addResourceBundle", "removeResourceBundle"].forEach((s) => {
      this[s] = (...l) => (this.store[s](...l), this);
    });
    const r = xn(), i = () => {
      const s = (l, c) => {
        this.isInitializing = !1, this.isInitialized && !this.initializedStoreOnce && this.logger.warn("init: i18next is already initialized. You should call init just once!"), this.isInitialized = !0, this.options.isClone || this.logger.log("initialized", this.options), this.emit("initialized", this.options), r.resolve(c), a(l, c);
      };
      if (this.languages && !this.isInitialized) return s(null, this.t.bind(this));
      this.changeLanguage(this.options.lng, s);
    };
    return this.options.resources || !this.options.initAsync ? i() : setTimeout(i, 0), r;
  }
  loadResources(t, a = Ur) {
    let o = a;
    const n = ce(t) ? t : this.language;
    if (typeof t == "function" && (o = t), !this.options.resources || this.options.partialBundledLanguages) {
      if (n?.toLowerCase() === "cimode" && (!this.options.preload || this.options.preload.length === 0)) return o();
      const r = [], i = (s) => {
        !s || s === "cimode" || this.services.languageUtils.toResolveHierarchy(s).forEach((l) => {
          l !== "cimode" && r.indexOf(l) < 0 && r.push(l);
        });
      };
      n ? i(n) : this.services.languageUtils.getFallbackCodes(this.options.fallbackLng).forEach((s) => i(s)), this.options.preload?.forEach?.((s) => i(s)), this.services.backendConnector.load(r, this.options.ns, (s) => {
        !s && !this.resolvedLanguage && this.language && this.setResolvedLanguage(this.language), o(s);
      });
    } else
      o(null);
  }
  reloadResources(t, a, o) {
    const n = xn();
    return typeof t == "function" && (o = t, t = void 0), typeof a == "function" && (o = a, a = void 0), t || (t = this.languages), a || (a = this.options.ns), o || (o = Ur), this.services.backendConnector.reload(t, a, (r) => {
      n.resolve(), o(r);
    }), n;
  }
  use(t) {
    if (!t) throw new Error("You are passing an undefined module! Please check the object you are passing to i18next.use()");
    if (!t.type) throw new Error("You are passing a wrong module! Please check the object you are passing to i18next.use()");
    return t.type === "backend" && (this.modules.backend = t), (t.type === "logger" || t.log && t.warn && t.error) && (this.modules.logger = t), t.type === "languageDetector" && (this.modules.languageDetector = t), t.type === "i18nFormat" && (this.modules.i18nFormat = t), t.type === "postProcessor" && Mk.addPostProcessor(t), t.type === "formatter" && (this.modules.formatter = t), t.type === "3rdParty" && this.modules.external.push(t), this;
  }
  setResolvedLanguage(t) {
    if (!(!t || !this.languages) && !(["cimode", "dev"].indexOf(t) > -1)) {
      for (let a = 0; a < this.languages.length; a++) {
        const o = this.languages[a];
        if (!(["cimode", "dev"].indexOf(o) > -1) && this.store.hasLanguageSomeTranslations(o)) {
          this.resolvedLanguage = o;
          break;
        }
      }
      !this.resolvedLanguage && this.languages.indexOf(t) < 0 && this.store.hasLanguageSomeTranslations(t) && (this.resolvedLanguage = t, this.languages.unshift(t));
    }
  }
  changeLanguage(t, a) {
    this.isLanguageChangingTo = t;
    const o = xn();
    this.emit("languageChanging", t);
    const n = (s) => {
      this.language = s, this.languages = this.services.languageUtils.toResolveHierarchy(s), this.resolvedLanguage = void 0, this.setResolvedLanguage(s);
    }, r = (s, l) => {
      l ? this.isLanguageChangingTo === t && (n(l), this.translator.changeLanguage(l), this.isLanguageChangingTo = void 0, this.emit("languageChanged", l), this.logger.log("languageChanged", l)) : this.isLanguageChangingTo = void 0, o.resolve((...c) => this.t(...c)), a && a(s, (...c) => this.t(...c));
    }, i = (s) => {
      !t && !s && this.services.languageDetector && (s = []);
      const l = ce(s) ? s : s && s[0], c = this.store.hasLanguageSomeTranslations(l) ? l : this.services.languageUtils.getBestMatchFromCodes(ce(s) ? [s] : s);
      c && (this.language || n(c), this.translator.language || this.translator.changeLanguage(c), this.services.languageDetector?.cacheUserLanguage?.(c)), this.loadResources(c, (u) => {
        r(u, c);
      });
    };
    return !t && this.services.languageDetector && !this.services.languageDetector.async ? i(this.services.languageDetector.detect()) : !t && this.services.languageDetector && this.services.languageDetector.async ? this.services.languageDetector.detect.length === 0 ? this.services.languageDetector.detect().then(i) : this.services.languageDetector.detect(i) : i(t), o;
  }
  getFixedT(t, a, o) {
    const n = (r, i, ...s) => {
      let l;
      typeof i != "object" ? l = this.options.overloadTranslationOptionHandler([r, i].concat(s)) : l = {
        ...i
      }, l.lng = l.lng || n.lng, l.lngs = l.lngs || n.lngs, l.ns = l.ns || n.ns, l.keyPrefix !== "" && (l.keyPrefix = l.keyPrefix || o || n.keyPrefix);
      const c = this.options.keySeparator || ".";
      let u;
      return l.keyPrefix && Array.isArray(r) ? u = r.map((d) => (typeof d == "function" && (d = eu(d, {
        ...this.options,
        ...i
      })), `${l.keyPrefix}${c}${d}`)) : (typeof r == "function" && (r = eu(r, {
        ...this.options,
        ...i
      })), u = l.keyPrefix ? `${l.keyPrefix}${c}${r}` : r), this.t(u, l);
    };
    return ce(t) ? n.lng = t : n.lngs = t, n.ns = a, n.keyPrefix = o, n;
  }
  t(...t) {
    return this.translator?.translate(...t);
  }
  exists(...t) {
    return this.translator?.exists(...t);
  }
  setDefaultNamespace(t) {
    this.options.defaultNS = t;
  }
  hasLoadedNamespace(t, a = {}) {
    if (!this.isInitialized)
      return this.logger.warn("hasLoadedNamespace: i18next was not initialized", this.languages), !1;
    if (!this.languages || !this.languages.length)
      return this.logger.warn("hasLoadedNamespace: i18n.languages were undefined or empty", this.languages), !1;
    const o = a.lng || this.resolvedLanguage || this.languages[0], n = this.options ? this.options.fallbackLng : !1, r = this.languages[this.languages.length - 1];
    if (o.toLowerCase() === "cimode") return !0;
    const i = (s, l) => {
      const c = this.services.backendConnector.state[`${s}|${l}`];
      return c === -1 || c === 0 || c === 2;
    };
    if (a.precheck) {
      const s = a.precheck(this, i);
      if (s !== void 0) return s;
    }
    return !!(this.hasResourceBundle(o, t) || !this.services.backendConnector.backend || this.options.resources && !this.options.partialBundledLanguages || i(o, t) && (!n || i(r, t)));
  }
  loadNamespaces(t, a) {
    const o = xn();
    return this.options.ns ? (ce(t) && (t = [t]), t.forEach((n) => {
      this.options.ns.indexOf(n) < 0 && this.options.ns.push(n);
    }), this.loadResources((n) => {
      o.resolve(), a && a(n);
    }), o) : (a && a(), Promise.resolve());
  }
  loadLanguages(t, a) {
    const o = xn();
    ce(t) && (t = [t]);
    const n = this.options.preload || [], r = t.filter((i) => n.indexOf(i) < 0 && this.services.languageUtils.isSupportedCode(i));
    return r.length ? (this.options.preload = n.concat(r), this.loadResources((i) => {
      o.resolve(), a && a(i);
    }), o) : (a && a(), Promise.resolve());
  }
  dir(t) {
    if (t || (t = this.resolvedLanguage || (this.languages?.length > 0 ? this.languages[0] : this.language)), !t) return "rtl";
    try {
      const n = new Intl.Locale(t);
      if (n && n.getTextInfo) {
        const r = n.getTextInfo();
        if (r && r.direction) return r.direction;
      }
    } catch {
    }
    const a = ["ar", "shu", "sqr", "ssh", "xaa", "yhd", "yud", "aao", "abh", "abv", "acm", "acq", "acw", "acx", "acy", "adf", "ads", "aeb", "aec", "afb", "ajp", "apc", "apd", "arb", "arq", "ars", "ary", "arz", "auz", "avl", "ayh", "ayl", "ayn", "ayp", "bbz", "pga", "he", "iw", "ps", "pbt", "pbu", "pst", "prp", "prd", "ug", "ur", "ydd", "yds", "yih", "ji", "yi", "hbo", "men", "xmn", "fa", "jpr", "peo", "pes", "prs", "dv", "sam", "ckb"], o = this.services?.languageUtils || new xp(zp());
    return t.toLowerCase().indexOf("-latn") > 1 ? "ltr" : a.indexOf(o.getLanguagePartFromCode(t)) > -1 || t.toLowerCase().indexOf("-arab") > 1 ? "rtl" : "ltr";
  }
  static createInstance(t = {}, a) {
    return new Hn(t, a);
  }
  cloneInstance(t = {}, a = Ur) {
    const o = t.forkResourceStore;
    o && delete t.forkResourceStore;
    const n = {
      ...this.options,
      ...t,
      isClone: !0
    }, r = new Hn(n);
    if ((t.debug !== void 0 || t.prefix !== void 0) && (r.logger = r.logger.clone(t)), ["store", "services", "language"].forEach((i) => {
      r[i] = this[i];
    }), r.services = {
      ...this.services
    }, r.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, o) {
      const i = Object.keys(this.store.data).reduce((s, l) => (s[l] = {
        ...this.store.data[l]
      }, s[l] = Object.keys(s[l]).reduce((c, u) => (c[u] = {
        ...s[l][u]
      }, c), s[l]), s), {});
      r.store = new yp(i, n), r.services.resourceStore = r.store;
    }
    return r.translator = new es(r.services, n), r.translator.on("*", (i, ...s) => {
      r.emit(i, ...s);
    }), r.init(n, a), r.translator.options = n, r.translator.backendConnector.services.utils = {
      hasLoadedNamespace: r.hasLoadedNamespace.bind(r)
    }, r;
  }
  toJSON() {
    return {
      options: this.options,
      store: this.store,
      language: this.language,
      languages: this.languages,
      resolvedLanguage: this.resolvedLanguage
    };
  }
}
const st = Hn.createInstance();
st.createInstance = Hn.createInstance;
const JDe = st.createInstance;
st.dir;
st.init;
st.loadResources;
st.reloadResources;
st.use;
st.changeLanguage;
st.getFixedT;
st.t;
st.exists;
st.setDefaultNamespace;
st.hasLoadedNamespace;
st.loadNamespaces;
st.loadLanguages;
const ZDe = {
  "modal.emailVerif.alreadyVerified.desc": "Din e-mail er klar! Log ind for at fortsætte.",
  "modal.emailVerif.alreadyVerified.title": "Din e-mailadresse er allerede blevet bekræftet",
  "modal.emailVerif.callout": "Vi har sendt en bekræftelsesmail til <b>{{email}}</b>.",
  "modal.emailVerif.desc": "Tjek din indbakke. Linket i denne e-mail udløber om 24 timer.",
  "modal.emailVerif.linkExpired.desc": "Log ind for at modtage et nyt bekræftelseslink i din indbakke.",
  "modal.emailVerif.linkExpired.title": "Dette link er udløbet",
  "modal.emailVerif.resend-email-link": "Send ny bekræftelsesmail",
  "modal.emailVerif.resend-email.rate-limit": "Du har nået grænsen for e-mailanmodninger. Prøv igen om 1 minut.",
  "modal.emailVerif.resend-link": "Send ny bekræftelsesmail.",
  "modal.emailVerif.title": "Bekræft din e-mailadresse",
  "modal.finishCreatingAccount.event": "Til en begivenhed",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Alle kender til HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Indtast dit fornavn",
  "modal.finishCreatingAccount.friends_family": "Gennem venner, familie eller bekendte",
  "modal.finishCreatingAccount.hearAboutHE": "Hvor har du hørt om HomeExchange?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Indtast dit efternavn",
  "modal.finishCreatingAccount.other": "Andet",
  "modal.finishCreatingAccount.phone_number": "Telefonnummer",
  "modal.finishCreatingAccount.phone_number.error": "Indtast dit telefonnummer",
  "modal.finishCreatingAccount.pleaseSpecify": "Angiv venligst",
  "modal.finishCreatingAccount.press": "I pressen",
  "modal.finishCreatingAccount.press_online": "Online",
  "modal.finishCreatingAccount.press_print": "Trykte medier",
  "modal.finishCreatingAccount.radio": "I radioen",
  "modal.finishCreatingAccount.referral": "Henvisningskode",
  "modal.finishCreatingAccount.referralCode.error": "Denne henvisningskode er ugyldig",
  "modal.finishCreatingAccount.search_engine": "På en søgemaskine",
  "modal.finishCreatingAccount.social_media": "Via sociale medier",
  "modal.finishCreatingAccount.social_network_other": "Andre sociale medier (angiv venligst)",
  "modal.finishCreatingAccount.title": "Færdiggør oprettelsen af din konto",
  "modal.finishCreatingAccount.tv": "I fjernsynet",
  "modal.finishCreatingAccount.tv_ad": "I en reklame",
  "modal.finishCreatingAccount.tv_show": "Under et tv-indslag/tv-program",
  "modal.genericError.desc": "Platformen kan være nede, eller der kan være en midlertidig fejl hos os, så prøv venligst igen.<br><br>Vi registrerer automatisk disse fejl, men hvis problemet fortsætter, er du velkommen til at kontakte os på:<br><a>tech@homeexchange.com</a>",
  "modal.genericError.title": "Hov! Der opstod en fejl",
  "modal.modifyEmail.callout.desc": "Når du har gemt din nye e-mail, bliver du logget ud og modtager en bekræftelsesmail på din nye adresse.",
  "modal.modifyEmail.callout.title": "Du bliver logget ud",
  "modal.modifyEmail.confirmEmail.title": "Bekræft ny e-mail",
  "modal.modifyEmail.cta": "Gem ny e-mail",
  "modal.modifyEmail.currentEmail.title": "Nuværende e-mail",
  "modal.modifyEmail.error.alreadyExists": "Denne e-mail eksisterer allerede",
  "modal.modifyEmail.error.dontMatch": "E-mailadresserne matcher ikke",
  "modal.modifyEmail.error.incorrectFormat": "Denne e-mailadresse er ikke gyldig",
  "modal.modifyEmail.error.unfilled": "Du bedes indtaste en e-mailadresse",
  "modal.modifyEmail.newEmail.title": "Ny e-mail",
  "modal.modifyEmail.title": "Ændr din e-mail",
  "modal.noEmailRecieved.desc": "<b>Har du ikke modtaget en e-mail?</b>Tjek din spammappe, og at du har stavet din e-mail korrekt, inden du anmoder om en ny bekræftelsesmail.",
  "modal.noEmailRecieved.error": "Der opstod en fejl. Prøv igen senere.",
  "modal.verifyEmail.emailResent.toast": "Vi har sendt dig en ny bekræftelsesmail til <b>{{email}}</b>.",
  "signin-modal.apple.button": "Log ind med Apple",
  "signin-modal.button": "Log ind",
  "signin-modal.email.button": "Log ind",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Log ind med Facebook",
  "signin-modal.no-account": "Nyt medlem?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Skift kodeord",
  "signup-modal.accept-cgu": "Ved at oprette en profil accepterer jeg de",
  "signup-modal.apple.button": "Log ind med Apple",
  "signup-modal.button": "Tilmeld dig",
  "signup-modal.cgu.link": "Generelle brugervilkår",
  "signup-modal.description": "Rejs på en ny måde med HomeExchange: Bliv budt velkommen over hele verden og spar penge!",
  "signup-modal.email.button": "Tilmeld dig med din e-mailadresse",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Tilmeld dig med Facebook",
  "signup-modal.have-an-account": "Har du allerede en profil?"
}, YDe = "Studio", XDe = "{{count}} soveværelse", QDe = "{{count}} soveværelser", eNe = "", tNe = "{{count}} seng", aNe = "{{count}} senge", oNe = "Voksne", nNe = "Babyer", rNe = "Din kalender er blevet opdateret.", iNe = "En måned", sNe = "Præcise datoer", lNe = "Uge", cNe = "", uNe = "", dNe = "", gNe = "", hNe = "To uger", mNe = "Annuller", pNe = "Børn", fNe = "Datoer", bNe = "Slet", _Ne = "Beskrivelse", vNe = "Destination", yNe = "Sådan!", wNe = "Rediger", kNe = "Enhver form for udveksling", xNe = "Badekar", $Ne = "Grill", SNe = "Cykel", CNe = "Bil", ENe = "Kat", zNe = "By", jNe = "På landet", ANe = "Opvaskemaskine", ONe = "Hund", PNe = "Tørretumbler", DNe = "Elevator", NNe = "Favoritboliger", RNe = "Pejs/brændeovn", INe = "Lejlighed", TNe = "Privat have", MNe = "under {{max}} GP", LNe = "fra {{min}} GP", WNe = "Mellem {{min}} og {{max}} GP", BNe = "Privat fitnessrum", FNe = "Hus", VNe = "En Ø", UNe = "Isoleret", qNe = "Jacuzzi", HNe = "Søer", GNe = "Collection-hjem", KNe = "Bjerge", JNe = "{{count}} badeværelser", ZNe = "Andre dyr", YNe = "Klaver", XNe = "Legeplads", QNe = "Primære bolig", eRe = "Gensifig udveksling", tRe = "Omvendt søgning", aRe = "Flod", oRe = "Kystnær", nRe = "Feriebolig", rRe = "TV", iRe = "Landsby", sRe = "Wi-Fi", lRe = "Filtre", cRe = "Faste datoer", uRe = "En måned i {{date}}", dRe = "En weekend i {{date}}", gRe = "En uge i {{date}}", hRe = "To uger i {{date}}", mRe = "Fleksible datoer", pRe = "Gæster", fRe = "boliger", bRe = "Sidste minut", _Re = "Lokation", vRe = "Rediger", yRe = "Navn", wRe = "Næste", kRe = "", xRe = "", $Re = "{{count}} voksne", SRe = "", CRe = "", ERe = "{{count}} babyer", zRe = "", jRe = "", ARe = "{{count}} børn", ORe = "", PRe = "{{count}} gæst", DRe = "{{count}} gæster", NRe = "Telefonnummerets format er ikke gyldigt.", RRe = "Modtag e-mailnotifikationer", IRe = "Gem", TRe = "Ingen lokationer fundet", MRe = "Flere beskeder", LRe = "Rejseliste", WRe = "", BRe = "valgfrit", FRe = {
  "autocomplete.button": "Søg",
  "autocomplete.placeholder": "Hvor skal du hen ?",
  bedroomsNumbers_zero: YDe,
  bedroomsNumbers_one: XDe,
  bedroomsNumbers_other: QDe,
  beds_zero: eNe,
  beds_one: tNe,
  beds_other: aNe,
  "button.free-signup": "Tilmeld dig gratis",
  "button.validate": "Bekræft",
  "common.try-again": "Prøv igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Må ikke overstige {{limit}} tegn",
  "error.reload": "Opdater siden",
  "error.return-homepage": "Tilbage til startsiden",
  "error.subtitle": "Denne side kan desværre ikke nås..",
  "error.title": "Der opstod en fejl på siden",
  "errors.unable_to_submit.subtitle": '"Din formular kunne desværre ikke \\nindsendes lige nu. Prøv igen \\nsenere."',
  "errors.unable_to_submit.title": "Ups, vi løb ind i et problem",
  "global.back": "Tilbage",
  "global.cancel": "Annuller",
  "global.collection.browsehomes": "Se boliger",
  "global.collection.contactus": "Kontakt os",
  "global.confirm": "Bekræft",
  "global.continue": "Fortsæt",
  "global.getStarted": "Kom godt i gang",
  "global.login": "Log ind",
  "global.select": "Vælg",
  global_adults: oNe,
  global_babies: nNe,
  global_calendarUpdated_toast: rNe,
  global_calendar_aMonth: iNe,
  global_calendar_exactDates: sNe,
  global_calendar_oneWeek: lNe,
  global_calendar_oneWeekend: cNe,
  global_calendar_plusMinusDay_zero: uNe,
  global_calendar_plusMinusDay_one: dNe,
  global_calendar_plusMinusDay_other: gNe,
  global_calendar_twoWeeks: hNe,
  global_cancel: mNe,
  global_children: pNe,
  global_dates: fNe,
  global_delete: bNe,
  global_description: _Ne,
  global_destination: vNe,
  global_done: yNe,
  global_edit: wNe,
  "global_filter_a-c": "Klimaanlæg",
  global_filter_available: kNe,
  "global_filter_baby-bed": "Babysenge",
  "global_filter_baby-gear": "Babyudstyr",
  "global_filter_balcony-terrace": "Altan/terrasse",
  global_filter_bathtub: xNe,
  global_filter_bbq: $Ne,
  global_filter_bicycle: SNe,
  global_filter_car: CNe,
  global_filter_cat: ENe,
  "global_filter_children-welcome": "Børn velkomne",
  global_filter_cities: zNe,
  "global_filter_cleaning-person": "Rengøringsperson",
  global_filter_countryside: jNe,
  "global_filter_dedicated-workspace": "Arbejdsområde",
  "global_filter_disabled-access": "Handicapvenlig bolig",
  global_filter_dishwasher: ANe,
  global_filter_dog: ONe,
  global_filter_dryer: PNe,
  "global_filter_eco-level": "Kun bæredygtige boliger",
  "global_filter_electric-car-plug": "Stik til elbil",
  global_filter_elevator: DNe,
  global_filter_favorite: NNe,
  global_filter_fireplace: RNe,
  global_filter_flat: INe,
  global_filter_garden: TNe,
  "global_filter_guest-wanted": "GuestPoints bytte",
  global_filter_guestPointsMax: MNe,
  global_filter_guestPointsMin: LNe,
  global_filter_guestPointsMinMax: WNe,
  global_filter_gym: BNe,
  "global_filter_heating-system": "Varmeanlæg",
  "global_filter_high-speed-connexion": "Hurtigt internet",
  global_filter_home: FNe,
  "global_filter_home-verified": "Godkendte boliger",
  global_filter_island: VNe,
  global_filter_isolated: UNe,
  global_filter_jacuzzi: qNe,
  "global_filter_kids-toys": "Legetøj til børn",
  global_filter_lakes: HNe,
  global_filter_luxury: GNe,
  global_filter_mountains: KNe,
  "global_filter_no-bed-up": "Ingen midlertidige senge",
  global_filter_numOfBathrooms: JNe,
  global_filter_other: ZNe,
  "global_filter_parking-space": "Privat parkeringsplads",
  "global_filter_pets-welcome": "Kæledyr er velkomne",
  global_filter_piano: YNe,
  global_filter_playground: XNe,
  global_filter_primary: QNe,
  "global_filter_public-transit-access": "Adgang til offentlig transport",
  global_filter_reciprocal: eRe,
  "global_filter_response-rate-above-threshold": "Svarprocent ≥ Gennemsnitlig",
  global_filter_reverse: tRe,
  global_filter_river: aRe,
  global_filter_seaside: oRe,
  global_filter_secondary: nRe,
  "global_filter_secured-pool": "Sikret pool",
  "global_filter_smokers-welcome": "Rygere er velkomne",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: rRe,
  global_filter_villages: iRe,
  "global_filter_washing-machine": "Vaskemaskine",
  "global_filter_whole-unit": "Hele enheden",
  global_filter_wifi: sRe,
  global_filters: lRe,
  global_fixDates: cRe,
  global_flexDates_aMonth: uRe,
  global_flexDates_aWeekend: dRe,
  global_flexDates_oneWeek: gRe,
  global_flexDates_twoWeek: hRe,
  global_flexibleDates: mRe,
  global_guests: pRe,
  global_homes: fRe,
  global_lastMinute: bRe,
  global_location: _Re,
  global_modify: vRe,
  global_name: yRe,
  global_next: wRe,
  global_numberOfAdults_zero: kRe,
  global_numberOfAdults_one: xRe,
  global_numberOfAdults_other: $Re,
  global_numberOfBabies_zero: SRe,
  global_numberOfBabies_one: CRe,
  global_numberOfBabies_other: ERe,
  global_numberOfChildren_zero: zRe,
  global_numberOfChildren_one: jRe,
  global_numberOfChildren_other: ARe,
  global_numberOfGuests_zero: ORe,
  global_numberOfGuests_one: PRe,
  global_numberOfGuests_other: DRe,
  global_phoneNumber_notValid: NRe,
  global_receiveEmailAlerts: RRe,
  global_save: IRe,
  global_searchBar_noLocationFound: TRe,
  global_seeMore_link: MRe,
  global_travelWishlist: LRe,
  "modal.error-occured.content": "Vi beklager ulejligheden, men prøv \\nvenligst igen.",
  "modal.error-occured.title": "Åh nej, der er opstået en fejl!",
  no_result: WRe,
  optional: BRe,
  "privacy-policy": "Privatpolitik"
}, VRe = "https://www.homeexchange.com/blog/", URe = "/p/general-terms-of-use", qRe = "https://www.homeexchange.com/da/p/community-da", HRe = "https://homeexchangehelp.zendesk.com/hc/en-us", GRe = "", KRe = "https://www.homeexchange.com/da/p/service-homeexchange-da", JRe = "https://www.homeexchange.com/da/p/guestpoints-da", ZRe = "https://www.homeexchange.com/da/p/press-da", YRe = "https://www.homeexchange.com/p/fortalt-af-medlemmerne", XRe = "", QRe = "", eIe = "https://www.homeexchange.com/da/p/hvor-velkomsten-virkelig-begynder", tIe = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/da/p/about-us-da",
  blog: VRe,
  cgu: URe,
  community: qRe,
  "contact-us": "https://www.homeexchange.com/da/kontakt-os-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: HRe,
  forum: GRe,
  guarantees: KRe,
  guestpoints: JRe,
  "happiness-team": "https://www.homeexchange.com/da/p/happiness-team-da",
  "how-it-works": "https://www.homeexchange.com/da/p/hvordan-virker-det",
  "join-us": "https://www.homeexchange.com/da/p/join-us-da",
  "legal-notice": "/p/juridiske-vilkaar",
  "mobile-app": "https://www.homeexchange.com/da/p/mobil-app",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: ZRe,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/da/p/subscription-homeexchange-da",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: YRe,
  travelWishlist_faq_links: XRe,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: QRe,
  values: eIe
}, aIe = "Fornavn", oIe = "Efternavn", nIe = "Tilføj til din rejseliste", rIe = "En opdateret rejseliste giver dig mulighed for at modtage flere anmodninger om gensidige boligbytninger.", iIe = "Er du sikker på, at du vil slette {{fullAddress}}?", sIe = "Dette er de filtre, du har valgt. Hvis du har skiftet mening, kan du slette nogle af dem nedenfor. Men hvis du gerne vil tilføje flere, skal du starte en ny søgning (selvom dette snart ændrer sig... vi giver dig besked)!", lIe = "Dette kan være et land, by eller en hel region. Hvis du vælger en bred lokation, er dine resultater muligvis mindre nøjagtige.", cIe = "Indtast et land, by eller region", uIe = "Se ledige boliger", dIe = "Når boliger med tilgængelighed matcher dine rejseplaner.", gIe = "Tilføj til din rejseliste", hIe = "{{fullAddress}} er blevet slettet fra din rejseliste.", mIe = "Vælg dine ideelle rejsedatoer (fleksible eller faste).", pIe = "Tilføj detaljer, der hjælper andre, som bruger den omvendte søgefunktion, med at se, hvorfor du er interesseret i deres lokation.", fIe = "Angiv, hvor mange personer der rejser sammen med dig under denne tur.", bIe = "Hovsa! {{fullAddress}} kunne ikke gemmes til din rejseliste af en uventet årsag.", _Ie = "Fortæl os, hvornår og hvorhen du ønsker at rejse for at modtage bytteanmodninger og notifikationer, så snart passende boliger bliver tilgængelige. Vi gemmer dine søgninger i din rejseliste!", vIe = "Er der andre rejseeventyr, du vil gå i gang med at planlægge?", yIe = "<updateDates>Opdater dine datoer</updateDates> for at fortsætte med at modtage relevante e-mailnotifikationer eller <delete>slet denne destination</delete> fra din rejseliste, hvis du ikke længere overvejer den.", wIe = "Disse datoer er i fortiden", kIe = "{{fullAddress}} er blevet tilføjet til din rejseliste!", xIe = "{{fullAddress}} er blevet opdateret.", $Ie = "Din søgning er gemt, og din kalender er blevet opdateret!", SIe = "Din søgning er blevet gemt. Du finder den i din rejseliste.", CIe = "Lær mere om rejselister", EIe = {
  firstname: aIe,
  lastname: oIe,
  modal_travelWishlist_addNew_title: nIe,
  modal_travelWishlist_delete_body: rIe,
  modal_travelWishlist_delete_title: iIe,
  modal_travelWishlist_filtersApplied_helper: sIe,
  modal_travelWishlist_location_helper: lIe,
  modal_travelWishlist_searchBar_placeholder: cIe,
  page_travelWishlist_card_cta: uIe,
  page_travelWishlist_card_emailAlerts_helper: dIe,
  page_travelWishlist_cta: gIe,
  page_travelWishlist_deleted_toast: hIe,
  page_travelWishlist_edit_dates_helper: mIe,
  page_travelWishlist_edit_description_helper: pIe,
  page_travelWishlist_edit_guests_helper: fIe,
  page_travelWishlist_error_toast: bIe,
  page_travelWishlist_none_body: _Ie,
  page_travelWishlist_none_subheader: vIe,
  page_travelWishlist_pastDates_desc: yIe,
  page_travelWishlist_pastDates_title: wIe,
  page_travelWishlist_saved_toast: kIe,
  page_travelWishlist_updated_toast: xIe,
  search_travelWishlist_calendarUpdated_toast: $Ie,
  search_travelWishlist_saved_toast: SIe,
  travelWishlist_faq: CIe
}, zIe = {
  "modal.emailVerif.alreadyVerified.desc": "Ihre E-Mail ist fertig! Melden Sie sich an, um fortzufahren.",
  "modal.emailVerif.alreadyVerified.title": "Ihre E-Mail-Adresse wurde bereits verifiziert",
  "modal.emailVerif.callout": "Eine Bestätigungs-E-Mail wurde an <b>{{email}}</b> gesendet.",
  "modal.emailVerif.desc": "Überprüfen Sie Ihren Posteingang. Der Link in dieser E-Mail läuft in 24 Stunden ab.",
  "modal.emailVerif.linkExpired.desc": "Um einen neuen Verifizierungslink per E-Mail zu erhalten, melden Sie sich bitte an.",
  "modal.emailVerif.linkExpired.title": "Dieser Link ist abgelaufen",
  "modal.emailVerif.resend-email-link": "E-Mail zur Verifizierung erneut senden",
  "modal.emailVerif.resend-email.rate-limit": "Sie haben das Limit für E-Mail-Anfragen erreicht. Versuchen Sie es in 1 Minute erneut.",
  "modal.emailVerif.resend-link": "E-Mail zur Verifizierung erneut senden",
  "modal.emailVerif.title": "Verifizieren Sie Ihre E-Mail-Adresse",
  "modal.finishCreatingAccount.event": "Bei einer Veranstaltung",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Jeder kennt HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Geben Sie Ihren Vornamen ein",
  "modal.finishCreatingAccount.friends_family": "Durch Freunde, Familie oder Bekannte",
  "modal.finishCreatingAccount.hearAboutHE": "Wie haben Sie von HomeExchange erfahren?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Geben Sie Ihren Nachnamen ein",
  "modal.finishCreatingAccount.other": "Anderes",
  "modal.finishCreatingAccount.phone_number": "Telefonnummer",
  "modal.finishCreatingAccount.phone_number.error": "Bitte geben Sie ihre Telefonnummer ein",
  "modal.finishCreatingAccount.pleaseSpecify": "Angeben",
  "modal.finishCreatingAccount.press": "In der Presse",
  "modal.finishCreatingAccount.press_online": "Im Internet",
  "modal.finishCreatingAccount.press_print": "Gedruckte Ausgabe",
  "modal.finishCreatingAccount.radio": "Im Radio",
  "modal.finishCreatingAccount.referral": "Empfehlungscode",
  "modal.finishCreatingAccount.referralCode.error": "Dieser Empfehlungscode ist ungültig",
  "modal.finishCreatingAccount.search_engine": "Über eine Suchmaschine",
  "modal.finishCreatingAccount.social_media": "Über soziale Medien",
  "modal.finishCreatingAccount.social_network_other": "Anderes soziales Netzwerk (bitte angeben)",
  "modal.finishCreatingAccount.title": "Schließen Sie die Erstellung Ihres Kontos ab",
  "modal.finishCreatingAccount.tv": "Im Fernsehen",
  "modal.finishCreatingAccount.tv_ad": "In der Werbung",
  "modal.finishCreatingAccount.tv_show": "In einer Reportage / TV-Sendung",
  "modal.genericError.desc": "Die Plattform ist möglicherweise nicht erreichbar oder es liegt ein vorübergehender Fehler auf unserer Seite vor. Bitte versuchen Sie es noch einmal.<br><br>Wir erfassen diese Fehler automatisch, aber wenn das Problem weiterhin besteht, können Sie uns gerne unter <br><a>tech@homeexchange.com</a> kontaktieren.",
  "modal.genericError.title": "Hoppla! Da ist etwas schiefgelaufen",
  "modal.modifyEmail.callout.desc": "Nachdem Sie Ihre neue E-Mail-Adresse gespeichert haben, werden Sie abgemeldet und erhalten eine Bestätigungs-E-Mail an Ihre neue Adresse.",
  "modal.modifyEmail.callout.title": "Sie werden abgemeldet",
  "modal.modifyEmail.confirmEmail.title": "Neue E-Mail-Adresse bestätigen",
  "modal.modifyEmail.cta": "Neue E-Mail-Adresse speichern",
  "modal.modifyEmail.currentEmail.title": "Aktuelle E-Mail-Adresse",
  "modal.modifyEmail.error.alreadyExists": "Diese E-Mail existiert bereits",
  "modal.modifyEmail.error.dontMatch": "Die E-Mails stimmen nicht überein",
  "modal.modifyEmail.error.incorrectFormat": "Diese E-Mail-Adresse ist ungültig",
  "modal.modifyEmail.error.unfilled": "Bitte geben Sie eine E-Mail-Adresse ein",
  "modal.modifyEmail.newEmail.title": "Neue E-Mail-Adresse",
  "modal.modifyEmail.title": "Ihre E-Mail-Adresse ändern",
  "modal.noEmailRecieved.desc": "<b>Sie haben keine E-Mail erhalten?</b>Überprüfen Sie Ihren Spam-Ordner und die Schreibweise Ihrer E-Mail, bevor Sie eine weitere Bestätigungs-E-Mail anfordern.",
  "modal.noEmailRecieved.error": "Etwas ist schiefgelaufen. Bitte versuchen Sie es später noch einmal.",
  "modal.verifyEmail.emailResent.toast": "Wir haben Ihnen eine neue Bestätigungs-E-Mail an <b>{{email}}</b> geschickt.",
  "signin-modal.apple.button": "Mit Google verbinden",
  "signin-modal.button": "Einloggen",
  "signin-modal.email.button": "Einloggen",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Mit Facebook verbinden",
  "signin-modal.no-account": "Noch keinen Account?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Passwort zurücksetzen",
  "signup-modal.accept-cgu": "Mit der Erstellung des Kontos akzeptiere ich die",
  "signup-modal.apple.button": "Melden Sie sich mit Apple an",
  "signup-modal.button": "Anmelden",
  "signup-modal.cgu.link": "Allgemeine Nutzungsbedingungen",
  "signup-modal.description": "Entdecken Sie dank Wohnungs-und Haustausch eine neue Art des Reisens: Seien Sie auf der ganzen Welt willkommen und sparen Sie Geld!",
  "signup-modal.email.button": "Mit E-Mail-Adresse anmelden",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Mit Facebook anmelden",
  "signup-modal.have-an-account": "Sie haben bereits ein Konto?"
}, jIe = "Studio", AIe = "{{count}} schlafzimmer", OIe = "{{count}} schlafzimmer", PIe = "", DIe = "{{count}} Bett", NIe = "{{count}} Betten", RIe = "Erwachsene", IIe = "Babys", TIe = "Ihr Kalender wurde aktualisiert.", MIe = "Ein Monat", LIe = "Genaue Daten", WIe = "Eine Woche", BIe = "Ein Wochenende", FIe = "", VIe = "± {{count}} Tag", UIe = "± {{count}} Tage", qIe = "Zwei Wochen", HIe = "Abbrechen", GIe = "Kinder", KIe = "Daten", JIe = "Löschen", ZIe = "Beschreibung", YIe = "Reiseziel", XIe = "Fertig!", QIe = "Bearbeiten", eTe = "Jede Tauschanfrage", tTe = "Badewanne", aTe = "Grill", oTe = "Fahrrad", nTe = "Auto", rTe = "Katze", iTe = "Stadt", sTe = "Auf dem Land", lTe = "Geschirrspüler", cTe = "Hund", uTe = "Trockner", dTe = "Aufzug", gTe = "Lieblingshäuser", hTe = "Kamin", mTe = "Apartment", pTe = "Privater Garten", fTe = "weniger als {{max}} GP", bTe = "von {{min}} GP", _Te = "Zwischen {{min}} und {{max}} GP", vTe = "Privater Fitnessraum", yTe = "Haus", wTe = "Insel", kTe = "Abgelegen", xTe = "Whirlpool", $Te = "See", STe = "Häuser der Collection", CTe = "Berge", ETe = "{{count}} Badezimmer", zTe = "Andere Tiere", jTe = "Klavier", ATe = "Spielplatz", OTe = "Hauptwohnung", PTe = "Gegenseitiger Austausch", DTe = "Umgekehrte Suche", NTe = "Fluss", RTe = "An der Küste", ITe = "Zweitwohnung", TTe = "Fernseher", MTe = "Dorf", LTe = "WLAN", WTe = "Filter", BTe = "Feste Daten", FTe = "Eine Woche im {{date}}", VTe = "Ein Wochenende im {{date}}", UTe = "Eine Woche im {{date}}", qTe = "Zwei Wochen im {{date}}", HTe = "Flexible Daten", GTe = "Gäste", KTe = "Unterkünfte", JTe = "Last Minute", ZTe = "Ort", YTe = "Ändern", XTe = "Name", QTe = "Weiter", eMe = "", tMe = "{{count}} Erwachsener", aMe = "{{count}} Erwachsene", oMe = "", nMe = "{{count}} Baby", rMe = "{{count}} Babys", iMe = "", sMe = "{{count}} Kind", lMe = "{{count}} Kinder", cMe = "", uMe = "{{count}} Gast", dMe = "{{count}} Gäste", gMe = "Das Format der Telefonnummer ist ungültig.", hMe = "Benachrichtigungen per E-Mail erhalten", mMe = "Speichern", pMe = "Kein Reiseziel gefunden", fMe = "Mehr anzeigen", bMe = "Reiseprojekte", _Me = "", vMe = "optional", yMe = {
  "autocomplete.button": "Suchen",
  "autocomplete.placeholder": "Wo gehst du hin ?",
  bedroomsNumbers_zero: jIe,
  bedroomsNumbers_one: AIe,
  bedroomsNumbers_other: OIe,
  beds_zero: PIe,
  beds_one: DIe,
  beds_other: NIe,
  "button.free-signup": "Kostenlos anmelden",
  "button.validate": "Bestätigen",
  "common.try-again": "Erneut versuchen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Darf {{limit}} Zeichen nicht überschreiten",
  "error.reload": "Aktualisieren Sie diese Seite",
  "error.return-homepage": "Zurück zur Startseite",
  "error.subtitle": "Leider ist diese Seite nicht erreichbar.",
  "error.title": "Es ist ein Fehler auf der Seite aufgetreten.",
  "errors.unable_to_submit.subtitle": "Leider konnte Ihr Formular im Moment nicht abgeschickt werden. Bitte versuchen Sie es später noch einmal.",
  "errors.unable_to_submit.title": "Hoppla, wir haben ein Problem",
  "global.back": "Zurück",
  "global.cancel": "Abbrechen",
  "global.collection.browsehomes": "Unterkünfte durchstöbern",
  "global.collection.contactus": "Kontaktieren Sie uns",
  "global.confirm": "Bestätigen",
  "global.continue": "Weiter",
  "global.getStarted": "Los geht's",
  "global.login": "Anmelden",
  "global.select": "Auswählen",
  global_adults: RIe,
  global_babies: IIe,
  global_calendarUpdated_toast: TIe,
  global_calendar_aMonth: MIe,
  global_calendar_exactDates: LIe,
  global_calendar_oneWeek: WIe,
  global_calendar_oneWeekend: BIe,
  global_calendar_plusMinusDay_zero: FIe,
  global_calendar_plusMinusDay_one: VIe,
  global_calendar_plusMinusDay_other: UIe,
  global_calendar_twoWeeks: qIe,
  global_cancel: HIe,
  global_children: GIe,
  global_dates: KIe,
  global_delete: JIe,
  global_description: ZIe,
  global_destination: YIe,
  global_done: XIe,
  global_edit: QIe,
  "global_filter_a-c": "Klimaanlage",
  global_filter_available: eTe,
  "global_filter_baby-bed": "Babybetten",
  "global_filter_baby-gear": "Babyausstattung",
  "global_filter_balcony-terrace": "Balkon / Terrasse",
  global_filter_bathtub: tTe,
  global_filter_bbq: aTe,
  global_filter_bicycle: oTe,
  global_filter_car: nTe,
  global_filter_cat: rTe,
  "global_filter_children-welcome": "Kinder willkommen",
  global_filter_cities: iTe,
  "global_filter_cleaning-person": "Reinigungskraft",
  global_filter_countryside: sTe,
  "global_filter_dedicated-workspace": "Spezieller Arbeitsbereich",
  "global_filter_disabled-access": "Barrierefreie Unterkunft",
  global_filter_dishwasher: lTe,
  global_filter_dog: cTe,
  global_filter_dryer: uTe,
  "global_filter_eco-level": "Nur nachhaltige Häuser",
  "global_filter_electric-car-plug": "Steckdose für Elektroautos",
  global_filter_elevator: dTe,
  global_filter_favorite: gTe,
  global_filter_fireplace: hTe,
  global_filter_flat: mTe,
  global_filter_garden: pTe,
  "global_filter_guest-wanted": "Austausch gegen GuestPoints",
  global_filter_guestPointsMax: fTe,
  global_filter_guestPointsMin: bTe,
  global_filter_guestPointsMinMax: _Te,
  global_filter_gym: vTe,
  "global_filter_heating-system": "Heizung",
  "global_filter_high-speed-connexion": "Hochgeschwindigkeitsverbindung",
  global_filter_home: yTe,
  "global_filter_home-verified": "Verifizierte Unterkünfte",
  global_filter_island: wTe,
  global_filter_isolated: kTe,
  global_filter_jacuzzi: xTe,
  "global_filter_kids-toys": "Kinderspielzeug",
  global_filter_lakes: $Te,
  global_filter_luxury: STe,
  global_filter_mountains: CTe,
  "global_filter_no-bed-up": "Keine Zustellbetten",
  global_filter_numOfBathrooms: ETe,
  global_filter_other: zTe,
  "global_filter_parking-space": "Privater Parkplatz",
  "global_filter_pets-welcome": "Haustiere willkommen",
  global_filter_piano: jTe,
  global_filter_playground: ATe,
  global_filter_primary: OTe,
  "global_filter_public-transit-access": "Zugang zu öffentlichen Verkehrsmitteln",
  global_filter_reciprocal: PTe,
  "global_filter_response-rate-above-threshold": "Antwortrate ≥ Mittel",
  global_filter_reverse: DTe,
  global_filter_river: NTe,
  global_filter_seaside: RTe,
  global_filter_secondary: ITe,
  "global_filter_secured-pool": "Gesicherter Pool",
  "global_filter_smokers-welcome": "Rauchen erlaubt",
  "global_filter_swimming-pool": "Swimmingpool",
  global_filter_tv: TTe,
  global_filter_villages: MTe,
  "global_filter_washing-machine": "Waschmaschine",
  "global_filter_whole-unit": "Die ganze Wohnung",
  global_filter_wifi: LTe,
  global_filters: WTe,
  global_fixDates: BTe,
  global_flexDates_aMonth: FTe,
  global_flexDates_aWeekend: VTe,
  global_flexDates_oneWeek: UTe,
  global_flexDates_twoWeek: qTe,
  global_flexibleDates: HTe,
  global_guests: GTe,
  global_homes: KTe,
  global_lastMinute: JTe,
  global_location: ZTe,
  global_modify: YTe,
  global_name: XTe,
  global_next: QTe,
  global_numberOfAdults_zero: eMe,
  global_numberOfAdults_one: tMe,
  global_numberOfAdults_other: aMe,
  global_numberOfBabies_zero: oMe,
  global_numberOfBabies_one: nMe,
  global_numberOfBabies_other: rMe,
  global_numberOfChildren_zero: iMe,
  global_numberOfChildren_one: sMe,
  global_numberOfChildren_other: lMe,
  global_numberOfGuests_zero: cMe,
  global_numberOfGuests_one: uMe,
  global_numberOfGuests_other: dMe,
  global_phoneNumber_notValid: gMe,
  global_receiveEmailAlerts: hMe,
  global_save: mMe,
  global_searchBar_noLocationFound: pMe,
  global_seeMore_link: fMe,
  global_travelWishlist: bMe,
  "modal.error-occured.content": "Wir entschuldigen uns für die Unannehmlichkeiten, bitte versuchen Sie es noch einmal.",
  "modal.error-occured.title": "Oh nein, es ist ein Fehler aufgetreten!",
  no_result: _Me,
  optional: vMe,
  "privacy-policy": "Datenschutz"
}, wMe = "https://www.homeexchange.com/de/blog/", kMe = "/de/p/homeexchangenutzungsbedingungen", xMe = "https://www.homeexchange.com/de/p/our-community-de", $Me = "https://homeexchangehelp.zendesk.com/hc/de", SMe = "", CMe = "https://www.homeexchange.com/de/p/service-homeexchange-de", EMe = "https://www.homeexchange.com/de/p/guestpoints-de", zMe = "https://www.homeexchange.com/de/p/press-de", jMe = "https://www.homeexchange.com/p/worte-homeexchanger", AMe = "https://help.homeexchange.com/hc/de/articles/360000623717-Bevorzugte-Tausch-Destinationen", OMe = "", PMe = "https://www.homeexchange.com/de/p/wo-die-begrubung-wirklich-beginnt", DMe = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/de/p/about-us-de",
  blog: wMe,
  cgu: kMe,
  community: xMe,
  "contact-us": "https://www.homeexchange.com/de/kontakt-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeDE/",
  faq: $Me,
  forum: SMe,
  guarantees: CMe,
  guestpoints: EMe,
  "happiness-team": "https://www.homeexchange.com/de/p/happiness-team-de",
  "how-it-works": "https://www.homeexchange.com/de/p/so-funktioniert-es-de",
  "join-us": "https://www.homeexchange.com/de/p/join-us-de",
  "legal-notice": "/p/impressum",
  "mobile-app": "https://www.homeexchange.com/de/p/homeexchange-mobile-app",
  "our-team": "https://www.homeexchange.com/de/p/unser-team",
  press: zMe,
  "privacy-policy": "/p/homeexchange-datenschutz",
  "subscription-cost": "https://www.homeexchange.com/de/p/subscription-homeexchange-de",
  "term-of-use": "/p/homeexchangenutzungsbedingungen",
  testimonials: jMe,
  travelWishlist_faq_links: AMe,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: OMe,
  values: PMe
}, NMe = "Vorname", RMe = "Nachname", IMe = "Zu den Reiseprojekten hinzufügen", TMe = "Aktualisierte Reiseprojekte ermöglichen es Ihnen, mehr gegenseitige Tauschanfragen zu erhalten.", MMe = "Sind Sie sicher, dass Sie {{fullAddress}} löschen möchten?", LMe = "Dies sind die Filter, die Sie ausgewählt haben. Wenn Sie Ihre Meinung geändert haben, können Sie einige von ihnen löschen. Wenn Sie jedoch weitere Filter hinzufügen möchten, müssen Sie eine neue Suche starten (dies wird sich jedoch bald ändern... bleiben Sie dran)!", WMe = "Dies kann ein Land, eine Stadt oder eine ganze Region sein. Wenn Sie einen großen Bereich auswählen, sind Ihre Ergebnisse möglicherweise weniger genau.", BMe = "Geben Sie ein Land, eine Stadt oder eine Region ein", FMe = "Verfügbare Häuser anzeigen", VMe = "Falls Unterkünfte mit Verfügbarkeit mit Ihren Reiseplänen übereinstimmen.", UMe = "Zu den Reiseprojekten hinzufügen", qMe = "{{fullAddress}} wurde aus Ihren Reiseprojekten gelöscht.", HMe = "Wählen Sie Ihre idealen Reisedaten (flexibel oder fest).", GMe = "Fügen Sie Details hinzu, damit andere, die die Umgekehrte Suche verwenden, erkennen können, warum Sie an ihrem Standort interessiert sind.", KMe = "Geben Sie an, wie viele Personen Sie auf dieser Reise begleiten werden.", JMe = "Hoppla! {{fullAddress}} konnte aus einem unerwarteten Grund nicht in Ihren Reiseprojekten gespeichert werden.", ZMe = "Teilen Sie uns mit, wann und wohin Sie reisen möchten, um Tauschanfragen und Benachrichtigungen zu erhalten, sobald passende Häuser verfügbar sind. Wir speichern Ihre Suchanfragen in Ihren Reiseprojekten!", YMe = "Gibt es Reisen, die Sie planen möchten?", XMe = "<updateDates>Aktualisieren Sie Ihre Daten</updateDates>, um weiterhin relevante E-Mail-Benachrichtigungen zu erhalten oder <delete>löschen Sie dieses Reiseziel</delete> aus Ihren Reiseprojekten, wenn Sie es nicht mehr in Betracht ziehen.", QMe = "Diese Daten liegen in der Vergangenheit", eLe = "{{fullAddress}} wurde zu Ihren Reiseprojekten hinzugefügt!", tLe = "{{fullAddress}} wurde erfolgreich aktualisiert.", aLe = "Ihre Suche wurde gespeichert und Ihr Kalender aktualisiert!", oLe = "Ihre Suche wurde gespeichert. Finden Sie sie in Ihren Reiseprojekten.", nLe = "Erfahren Sie mehr über Reiseprojekte", rLe = {
  firstname: NMe,
  lastname: RMe,
  modal_travelWishlist_addNew_title: IMe,
  modal_travelWishlist_delete_body: TMe,
  modal_travelWishlist_delete_title: MMe,
  modal_travelWishlist_filtersApplied_helper: LMe,
  modal_travelWishlist_location_helper: WMe,
  modal_travelWishlist_searchBar_placeholder: BMe,
  page_travelWishlist_card_cta: FMe,
  page_travelWishlist_card_emailAlerts_helper: VMe,
  page_travelWishlist_cta: UMe,
  page_travelWishlist_deleted_toast: qMe,
  page_travelWishlist_edit_dates_helper: HMe,
  page_travelWishlist_edit_description_helper: GMe,
  page_travelWishlist_edit_guests_helper: KMe,
  page_travelWishlist_error_toast: JMe,
  page_travelWishlist_none_body: ZMe,
  page_travelWishlist_none_subheader: YMe,
  page_travelWishlist_pastDates_desc: XMe,
  page_travelWishlist_pastDates_title: QMe,
  page_travelWishlist_saved_toast: eLe,
  page_travelWishlist_updated_toast: tLe,
  search_travelWishlist_calendarUpdated_toast: aLe,
  search_travelWishlist_saved_toast: oLe,
  travelWishlist_faq: nLe
}, iLe = {
  "modal.emailVerif.alreadyVerified.desc": "Your email is ready! Log in to continue.",
  "modal.emailVerif.alreadyVerified.title": "Your email address has already been verified",
  "modal.emailVerif.callout": "A verification email has been sent to <b>{{email}}</b>.",
  "modal.emailVerif.desc": "Check your inbox. The link in this email will expire in 24-hours.",
  "modal.emailVerif.linkExpired.desc": "To receive a new verification link in your inbox, please log in.",
  "modal.emailVerif.linkExpired.title": "This link has expired",
  "modal.emailVerif.resend-email-link": "Resend verification email",
  "modal.emailVerif.resend-email.rate-limit": "You’ve reached the email request limit. Try again in 1 minute.",
  "modal.emailVerif.resend-link": "Resend verification email",
  "modal.emailVerif.title": "Verify your email address",
  "modal.finishCreatingAccount.event": "At an event",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Everyone knows HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Enter your first name",
  "modal.finishCreatingAccount.friends_family": "Through friends, family, or acquaintances",
  "modal.finishCreatingAccount.hearAboutHE": "How did you hear about HomeExchange?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Enter your last name",
  "modal.finishCreatingAccount.other": "Other ",
  "modal.finishCreatingAccount.phone_number": "Phone number",
  "modal.finishCreatingAccount.phone_number.error": "Please enter your phone number",
  "modal.finishCreatingAccount.pleaseSpecify": "Specify",
  "modal.finishCreatingAccount.press": "In the press",
  "modal.finishCreatingAccount.press_online": "Online",
  "modal.finishCreatingAccount.press_print": "Print",
  "modal.finishCreatingAccount.radio": "On the radio",
  "modal.finishCreatingAccount.referral": "Referral code",
  "modal.finishCreatingAccount.referralCode.error": "This referral code is invalid",
  "modal.finishCreatingAccount.search_engine": "On a search engine",
  "modal.finishCreatingAccount.social_media": "Via social media",
  "modal.finishCreatingAccount.social_network_other": "Other social network (please specify)",
  "modal.finishCreatingAccount.title": "Finish creating your account",
  "modal.finishCreatingAccount.tv": "On TV",
  "modal.finishCreatingAccount.tv_ad": "Through an advertisement",
  "modal.finishCreatingAccount.tv_show": "During a report / TV show",
  "modal.genericError.desc": "The platform might be down or there might be a temporary glitch on our side, so please try again.<br><br>We track these errors automatically, but if the problem persists feel free to contact us at:<br><a>tech@homeexchange.com</a>",
  "modal.genericError.title": "Oops! something went wrong",
  "modal.modifyEmail.callout.desc": "After saving your new email, you’ll be logged out and will receive a verification email at your new address.",
  "modal.modifyEmail.callout.title": "You are going to be logged out",
  "modal.modifyEmail.confirmEmail.title": "Confirm new email",
  "modal.modifyEmail.cta": "Save new email",
  "modal.modifyEmail.currentEmail.title": "Current email",
  "modal.modifyEmail.error.alreadyExists": "This email already exists",
  "modal.modifyEmail.error.dontMatch": "Emails don’t match",
  "modal.modifyEmail.error.incorrectFormat": "This email address is not valid",
  "modal.modifyEmail.error.unfilled": "Please enter an email address",
  "modal.modifyEmail.newEmail.title": "New email",
  "modal.modifyEmail.title": "Modify your email",
  "modal.noEmailRecieved.desc": "<b>Didn’t receive an email?</b>Check your spam folder and the spelling of your email before requesting another verification email.",
  "modal.noEmailRecieved.error": "Something went wrong, please try again later",
  "modal.verifyEmail.emailResent.toast": "We've sent you a new verification email to <b>{{email}}</b>.",
  "signin-modal.apple.button": "Connect with Apple",
  "signin-modal.button": "Sign in",
  "signin-modal.email.button": "Sign in",
  "signin-modal.error.content": "An error occured",
  "signin-modal.error.email_no_verified.content": "Email not verified",
  "signin-modal.error.email_no_verified.title": "Error",
  "signin-modal.error.title": "Error",
  "signin-modal.facebook.button": "Connect with Facebook",
  "signin-modal.no-account": "Don't have an account yet?",
  "signin-modal.reset-password": "Reset password",
  "signin-modal.title": "Sign in ",
  "signin.modal.reset-password": "Reset password",
  "signup-modal.accept-cgu": "By creating an account, I accept the",
  "signup-modal.apple.button": "Sign in with Apple",
  "signup-modal.button": "Sign up",
  "signup-modal.cgu.link": "General Terms of Use",
  "signup-modal.description": "Discover a new way of traveling with HomeExchange: Be welcomed all over the world and save money!",
  "signup-modal.email.button": "Sign up with your email address",
  "signup-modal.email.form.submit": "Sign up",
  "signup-modal.error.content": "An error occured",
  "signup-modal.error.title": "Error",
  "signup-modal.facebook.button": "Sign up with Facebook",
  "signup-modal.have-an-account": "Already have an account?"
}, sLe = "Studio", lLe = "{{count}} bedroom", cLe = "{{count}} bedrooms", uLe = "", dLe = "{{count}} bed", gLe = "{{count}} beds", hLe = "Adults", mLe = "Babies", pLe = "Your calendar has been updated.", fLe = "A month", bLe = "Exact dates", _Le = "One week", vLe = "One weekend", yLe = "", wLe = "± {{count}} day", kLe = "± {{count}} days", xLe = "Two weeks", $Le = "Cancel", SLe = "Children", CLe = "Dates", ELe = "Delete", zLe = "Description", jLe = "Destination", ALe = "Done!", OLe = "Edit", PLe = "Any type of exchange", DLe = "Bathtub", NLe = "BBQ", RLe = "Bicycle", ILe = "Car", TLe = "Cat", MLe = "City", LLe = "Countryside", WLe = "Dishwasher", BLe = "Dog", FLe = "Dryer", VLe = "Elevator", ULe = "Favorite homes", qLe = "Fireplace", HLe = "Apartment", GLe = "Private backyard", KLe = "less than {{max}} GP", JLe = "from {{min}} GP", ZLe = "Between {{min}} and {{max}} GP", YLe = "Private gym", XLe = "House", QLe = "Island", eWe = "Isolated", tWe = "Jacuzzi", aWe = "Lake", oWe = "Collection homes", nWe = "Mountain", rWe = "{{count}} bathrooms", iWe = "Other animals", sWe = "Piano", lWe = "Kid's playground", cWe = "Primary", uWe = "Reciprocal exchange", dWe = "Reverse search", gWe = "River", hWe = "Coastal", mWe = "Secondary", pWe = "TV", fWe = "Village", bWe = "WiFi", _We = "Filters", vWe = "Fixed dates", yWe = "A month in {{date}}", wWe = "A Week-end in {{date}}", kWe = "One week in {{date}}", xWe = "Two weeks in {{date}}", $We = "Flexible dates", SWe = "Guests", CWe = "homes", EWe = "Last minute", zWe = "Location", jWe = "Modify", AWe = "Name", OWe = "Next", PWe = "", DWe = "{{count}} adult", NWe = "{{count}} adults", RWe = "", IWe = "{{count}} baby", TWe = "{{count}} babies", MWe = "", LWe = "{{count}} child", WWe = "{{count}} children", BWe = "{{count}} guest", FWe = "{{count}} guest", VWe = "{{count}} guests", UWe = "The phone number format is not valid", qWe = "Receive email alerts", HWe = "Save", GWe = "No locations found", KWe = "See more", JWe = "Travel wishlist", ZWe = "No result", YWe = "optional", XWe = {
  "autocomplete.button": "Search",
  "autocomplete.placeholder": "Where are you going ?",
  bedroomsNumbers_zero: sLe,
  bedroomsNumbers_one: lLe,
  bedroomsNumbers_other: cLe,
  beds_zero: uLe,
  beds_one: dLe,
  beds_other: gLe,
  "button.free-signup": "Sign up for free",
  "button.validate": "Validate",
  "common.try-again": "Try again",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Must not exceed {{limit}} characters",
  "error.reload": "Refresh this page",
  "error.return-homepage": "Return to home page",
  "error.subtitle": "Unfortunately this page can't be reached.",
  "error.title": "An error occurred on the page",
  "errors.unable_to_submit.subtitle": "Unfortunately your form couldn't be submitted right now. Please try again later.",
  "errors.unable_to_submit.title": "Oops, we've hit a problem",
  "global.back": "Back",
  "global.cancel": "Cancel",
  "global.collection.browsehomes": "Browse Homes",
  "global.collection.contactus": "Contact us",
  "global.confirm": "Confirm",
  "global.continue": "Continue",
  "global.getStarted": "Get started",
  "global.login": "Log in",
  "global.select": "Select",
  global_adults: hLe,
  global_babies: mLe,
  global_calendarUpdated_toast: pLe,
  global_calendar_aMonth: fLe,
  global_calendar_exactDates: bLe,
  global_calendar_oneWeek: _Le,
  global_calendar_oneWeekend: vLe,
  global_calendar_plusMinusDay_zero: yLe,
  global_calendar_plusMinusDay_one: wLe,
  global_calendar_plusMinusDay_other: kLe,
  global_calendar_twoWeeks: xLe,
  global_cancel: $Le,
  global_children: SLe,
  global_dates: CLe,
  global_delete: ELe,
  global_description: zLe,
  global_destination: jLe,
  global_done: ALe,
  global_edit: OLe,
  "global_filter_a-c": "A/C",
  global_filter_available: PLe,
  "global_filter_baby-bed": "Baby cribs",
  "global_filter_baby-gear": "Baby gear",
  "global_filter_balcony-terrace": "Balcony/Terrace",
  global_filter_bathtub: DLe,
  global_filter_bbq: NLe,
  global_filter_bicycle: RLe,
  global_filter_car: ILe,
  global_filter_cat: TLe,
  "global_filter_children-welcome": "Children welcome",
  global_filter_cities: MLe,
  "global_filter_cleaning-person": "Cleaning person",
  global_filter_countryside: LLe,
  "global_filter_dedicated-workspace": "Dedicated workspace",
  "global_filter_disabled-access": "Accessible home",
  global_filter_dishwasher: WLe,
  global_filter_dog: BLe,
  global_filter_dryer: FLe,
  "global_filter_eco-level": "Only sustainable homes",
  "global_filter_electric-car-plug": "Electric car plug",
  global_filter_elevator: VLe,
  global_filter_favorite: ULe,
  global_filter_fireplace: qLe,
  global_filter_flat: HLe,
  global_filter_garden: GLe,
  "global_filter_guest-wanted": "GuestPoints exchange",
  global_filter_guestPointsMax: KLe,
  global_filter_guestPointsMin: JLe,
  global_filter_guestPointsMinMax: ZLe,
  global_filter_gym: YLe,
  "global_filter_heating-system": "Heating system",
  "global_filter_high-speed-connexion": "High speed connection",
  global_filter_home: XLe,
  "global_filter_home-verified": "Verified homes",
  global_filter_island: QLe,
  global_filter_isolated: eWe,
  global_filter_jacuzzi: tWe,
  "global_filter_kids-toys": "Kids toys",
  global_filter_lakes: aWe,
  global_filter_luxury: oWe,
  global_filter_mountains: nWe,
  "global_filter_no-bed-up": "No temporary beds",
  global_filter_numOfBathrooms: rWe,
  global_filter_other: iWe,
  "global_filter_parking-space": "Private parking space",
  "global_filter_pets-welcome": "Pets welcome",
  global_filter_piano: sWe,
  global_filter_playground: lWe,
  global_filter_primary: cWe,
  "global_filter_public-transit-access": "Public transport access",
  global_filter_reciprocal: uWe,
  "global_filter_response-rate-above-threshold": "Response rate ≥ Average",
  global_filter_reverse: dWe,
  global_filter_river: gWe,
  global_filter_seaside: hWe,
  global_filter_secondary: mWe,
  "global_filter_secured-pool": "Secured pool",
  "global_filter_smokers-welcome": "Smokers welcome",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: pWe,
  global_filter_villages: fWe,
  "global_filter_washing-machine": "Washing machine",
  "global_filter_whole-unit": "Entire home",
  global_filter_wifi: bWe,
  global_filters: _We,
  global_fixDates: vWe,
  global_flexDates_aMonth: yWe,
  global_flexDates_aWeekend: wWe,
  global_flexDates_oneWeek: kWe,
  global_flexDates_twoWeek: xWe,
  global_flexibleDates: $We,
  global_guests: SWe,
  global_homes: CWe,
  global_lastMinute: EWe,
  global_location: zWe,
  global_modify: jWe,
  global_name: AWe,
  global_next: OWe,
  global_numberOfAdults_zero: PWe,
  global_numberOfAdults_one: DWe,
  global_numberOfAdults_other: NWe,
  global_numberOfBabies_zero: RWe,
  global_numberOfBabies_one: IWe,
  global_numberOfBabies_other: TWe,
  global_numberOfChildren_zero: MWe,
  global_numberOfChildren_one: LWe,
  global_numberOfChildren_other: WWe,
  global_numberOfGuests_zero: BWe,
  global_numberOfGuests_one: FWe,
  global_numberOfGuests_other: VWe,
  global_phoneNumber_notValid: UWe,
  global_receiveEmailAlerts: qWe,
  global_save: HWe,
  global_searchBar_noLocationFound: GWe,
  global_seeMore_link: KWe,
  global_travelWishlist: JWe,
  "modal.error-occured.content": "We're so sorry for the inconvenience, but please do try again.",
  "modal.error-occured.title": "Oh no, an error has occurred!",
  no_result: ZWe,
  optional: YWe,
  "privacy-policy": "Privacy Policy"
}, QWe = "https://www.homeexchange.com/blog/", e2e = "/p/general-terms-of-use", t2e = "https://www.homeexchange.com/p/community", a2e = "https://homeexchangehelp.zendesk.com/hc/en-us", o2e = "https://forum.homeexchange.com/c/english/20", n2e = "https://www.homeexchange.com/p/service-homeexchange-en", r2e = "https://www.homeexchange.com/p/guestpoints-en", i2e = "https://www.homeexchange.com/p/press", s2e = "https://www.homeexchange.com/p/words-of-homeexchanges", l2e = "https://help.homeexchange.com/hc/en-us/articles/360000623717-What-are-My-Preferred-Destinations-and-how-do-I-use-them", c2e = "https://www.homeexchange.com/p/where-the-welcome-really-begins", u2e = "https://www.homeexchange.com/p/where-the-welcome-really-begins", d2e = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/p/about-us",
  blog: QWe,
  cgu: e2e,
  community: t2e,
  "contact-us": "https://www.homeexchange.com/contact-us-homeexchange",
  "cookie-policy": "/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: a2e,
  forum: o2e,
  guarantees: n2e,
  guestpoints: r2e,
  "happiness-team": "https://www.homeexchange.com/p/happiness-team",
  "how-it-works": "https://www.homeexchange.com/p/how-it-works-en",
  "join-us": "https://www.homeexchange.com/p/join-us",
  "legal-notice": "/p/legal-notice",
  "mobile-app": "https://www.homeexchange.com/p/mobile-apps",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: i2e,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/p/subscription-homeexchange",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: s2e,
  travelWishlist_faq_links: l2e,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: c2e,
  values: u2e
}, g2e = "First name", h2e = "Last name", m2e = "Add to your travel wishlist", p2e = "An updated travel wishlist will enable you to receive more reciprocal exchange requests.", f2e = "Are you sure you want to delete {{fullAddress}}?", b2e = "These are the filters you've selected. If you've changed your mind, you can delete some of them below. But if you'd like to add additional ones, you'll need to start a new search (though this will change soon... stay tuned)!", _2e = "This could be a country, city or a whole region. If you pick a broad location, your results might be less accurate.", v2e = "Type a country, city, or region", y2e = "View available homes", w2e = "When homes with availability match your travel plans.", k2e = "Add to your travel wishlist", x2e = "{{fullAddress}} has been deleted from your travel wishlist.", $2e = "Select your ideal travel dates (flexible or fixed).", S2e = "Add details to help others using the reverse search feature see why you’re interested in their location.", C2e = "Specify how many people will be traveling with you for this trip.", E2e = "Oops! {{fullAddress}} couldn't be saved to your travel wishlist for an unexpected reason.", z2e = "Let us know when and where you'd like to travel to receive exchange requests and alerts as soon as suitable homes become available. We'll save your searches to your travel wishlist!", j2e = "Any travel adventures you'd like to start planning?", A2e = "<updateDates>Update your dates</updateDates> to keep receiving relevant email alerts or <delete>delete this destination</delete> from your travel wishlist if you're no longer considering it.", O2e = "These dates are in the past", P2e = "{{fullAddress}} has been added to your travel wishlist!", D2e = "{{fullAddress}} has been successfully updated.", N2e = "Your search has been saved, and your calendar has been updated!", R2e = "Your search has been saved. Find it in your travel wishlist.", I2e = "Learn more about travel wishlists", T2e = {
  firstname: g2e,
  lastname: h2e,
  modal_travelWishlist_addNew_title: m2e,
  modal_travelWishlist_delete_body: p2e,
  modal_travelWishlist_delete_title: f2e,
  modal_travelWishlist_filtersApplied_helper: b2e,
  modal_travelWishlist_location_helper: _2e,
  modal_travelWishlist_searchBar_placeholder: v2e,
  page_travelWishlist_card_cta: y2e,
  page_travelWishlist_card_emailAlerts_helper: w2e,
  page_travelWishlist_cta: k2e,
  page_travelWishlist_deleted_toast: x2e,
  page_travelWishlist_edit_dates_helper: $2e,
  page_travelWishlist_edit_description_helper: S2e,
  page_travelWishlist_edit_guests_helper: C2e,
  page_travelWishlist_error_toast: E2e,
  page_travelWishlist_none_body: z2e,
  page_travelWishlist_none_subheader: j2e,
  page_travelWishlist_pastDates_desc: A2e,
  page_travelWishlist_pastDates_title: O2e,
  page_travelWishlist_saved_toast: P2e,
  page_travelWishlist_updated_toast: D2e,
  search_travelWishlist_calendarUpdated_toast: N2e,
  search_travelWishlist_saved_toast: R2e,
  travelWishlist_faq: I2e
}, M2e = {
  "modal.emailVerif.alreadyVerified.desc": "¡Tu correo electrónico está listo! Inicia sesión para continuar.",
  "modal.emailVerif.alreadyVerified.title": "Tu dirección de correo ya está verificada",
  "modal.emailVerif.callout": "Te hemos enviado un correo de verificación a <b>{{email}}</b>.",
  "modal.emailVerif.desc": "Comprueba tu bandeja de entrada. El enlace del correo electrónico caduca en 24 horas.",
  "modal.emailVerif.linkExpired.desc": "Inicia sesión para recibir un nuevo enlace de verificación en tu bandeja de entrada.",
  "modal.emailVerif.linkExpired.title": "Este enlace ha caducado",
  "modal.emailVerif.resend-email-link": "Reenviar correo de verificación",
  "modal.emailVerif.resend-email.rate-limit": "",
  "modal.emailVerif.resend-link": "Reenviar correo de verificación",
  "modal.emailVerif.title": "Verifica tu dirección de correo electrónico",
  "modal.finishCreatingAccount.event": "En un evento",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Todo el mundo conoce HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Introduce tu nombre.",
  "modal.finishCreatingAccount.friends_family": "Por amigos, familiares o conocidos",
  "modal.finishCreatingAccount.hearAboutHE": "¿Cómo has descubierto HomeExchange?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Introduce tus apellidos.",
  "modal.finishCreatingAccount.other": "Otros",
  "modal.finishCreatingAccount.phone_number": "Número de teléfono",
  "modal.finishCreatingAccount.phone_number.error": "Introduce tu número de teléfono",
  "modal.finishCreatingAccount.pleaseSpecify": "Especifica",
  "modal.finishCreatingAccount.press": "Por la prensa",
  "modal.finishCreatingAccount.press_online": "Online",
  "modal.finishCreatingAccount.press_print": "Medios impresos",
  "modal.finishCreatingAccount.radio": "Por la radio",
  "modal.finishCreatingAccount.referral": "Código de invitación",
  "modal.finishCreatingAccount.referralCode.error": "Este código de invitación no es válido.",
  "modal.finishCreatingAccount.search_engine": "En un motor de búsqueda",
  "modal.finishCreatingAccount.social_media": "Por las redes sociales",
  "modal.finishCreatingAccount.social_network_other": "Otra red social (especifica cuál)",
  "modal.finishCreatingAccount.title": "Termina de crear tu cuenta",
  "modal.finishCreatingAccount.tv": "En la televisión",
  "modal.finishCreatingAccount.tv_ad": "En un anuncio",
  "modal.finishCreatingAccount.tv_show": "En un reportaje/programa de televisión",
  "modal.genericError.desc": "Es posible que la plataforma esté fuera de servicio o que estemos experimentando un problema técnico temporal, así que vuelve a intentarlo.<br><br>Llevamos un seguimiento automático de estos errores, pero si el problema persiste, no dudes en ponerte en contacto con nosotros en:<br><a>tech@homeexchange.com</a>",
  "modal.genericError.title": "¡Vaya! Algo salió mal...",
  "modal.modifyEmail.callout.desc": "",
  "modal.modifyEmail.callout.title": "",
  "modal.modifyEmail.confirmEmail.title": "",
  "modal.modifyEmail.cta": "",
  "modal.modifyEmail.currentEmail.title": "Correo electrónico actual",
  "modal.modifyEmail.error.alreadyExists": "",
  "modal.modifyEmail.error.dontMatch": "",
  "modal.modifyEmail.error.incorrectFormat": "",
  "modal.modifyEmail.error.unfilled": "",
  "modal.modifyEmail.newEmail.title": "Nuevo correo electrónico",
  "modal.modifyEmail.title": "",
  "modal.noEmailRecieved.desc": "<b>¿No has recibido el correo electrónico?</b>Comprueba tu carpeta de spam y asegúrate de que tu dirección esté bien escrita antes de solicitar otro correo de verificación.",
  "modal.noEmailRecieved.error": "Algo salió mal, por favor inténtalo de nuevo más tarde.",
  "modal.verifyEmail.emailResent.toast": "Te hemos enviado un nuevo correo de verificación a <b>{{email}}</b>.",
  "signin-modal.apple.button": "Inicia sesión con Apple",
  "signin-modal.button": "Inicia sesión",
  "signin-modal.email.button": "Inicia sesión",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Inicia sesión con Facebook",
  "signin-modal.no-account": "¿Aún no tienes una cuenta?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Restablecer la contraseña",
  "signup-modal.accept-cgu": "Al crear una cuenta acepto las",
  "signup-modal.apple.button": "Inicia sesión con Apple",
  "signup-modal.button": "Regístrate",
  "signup-modal.cgu.link": "Condiciones Generales de Uso",
  "signup-modal.description": "Descubre otra forma de viajar con el intercambio de casas: ¡siéntete bienvenido/a en todo el mundo y ahorra en alojamiento!",
  "signup-modal.email.button": "Regístrate con tu correo electrónico",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Regístrate con Facebook",
  "signup-modal.have-an-account": "¿Ya tienes una cuenta?"
}, L2e = "Estudio", W2e = "{{count}} dormitorio", B2e = "{{count}} dormitorios", F2e = "", V2e = "{{count}} cama", U2e = "{{count}} camas", q2e = "", H2e = "", G2e = "Tu calendario ha sido actualizado.", K2e = "Un mes", J2e = "Fechas exactas", Z2e = "Una semana", Y2e = "Un fin de semana", X2e = "", Q2e = "± {{count}} día", eBe = "± {{count}} días", tBe = "Dos semanas", aBe = "Cancelar", oBe = "", nBe = "Fechas", rBe = "Eliminar", iBe = "Descripción", sBe = "Destino", lBe = "¡Listo!", cBe = "Editar", uBe = "Cualquier tipo de intercambio", dBe = "Bañera", gBe = "Barbacoa", hBe = "Bicicleta", mBe = "Coche", pBe = "Gato", fBe = "Ciudad", bBe = "Campo", _Be = "Lavavajillas", vBe = "Perro", yBe = "Secadora", wBe = "Ascensor", kBe = "Casas favoritas", xBe = "Chimenea", $Be = "Piso", SBe = "Patio privado", CBe = "", EBe = "", zBe = "", jBe = "", ABe = "Casa", OBe = "Isla", PBe = "Aislado", DBe = "Jacuzzi", NBe = "Lagos", RBe = "Casas Collection", IBe = "", TBe = "{{count}} baños", MBe = "Otros animales", LBe = "Piano", WBe = "Columpios", BBe = "Principal", FBe = "Intercambio recíproco", VBe = "Búsqueda inversa", UBe = "Río", qBe = "En la costa", HBe = "Secundaria", GBe = "TV", KBe = "Pueblo", JBe = "WiFi", ZBe = "Filtros", YBe = "Fechas fijas", XBe = "Un mes en {{date}}", QBe = "Un fin de semana en {{date}}", eFe = "Una semana en {{date}}", tFe = "Dos semanas en {{date}}", aFe = "Fechas flexibles", oFe = "Invitados", nFe = "casas", rFe = "Último minuto", iFe = "Ubicación", sFe = "Modificar", lFe = "Nombre", cFe = "Siguiente", uFe = "", dFe = "{{count}} adulto", gFe = "{{count}} adultos", hFe = "", mFe = "{{count}} bebé", pFe = "bebé", fFe = "", bFe = "{{count}} niño/a", _Fe = "{{count}} niños", vFe = "", yFe = "{{count}} invitado/a", wFe = "{{count}} invitados", kFe = "El formato del número de teléfono no es válido.", xFe = "Recibir notificaciones por correo electrónico", $Fe = "Guardar", SFe = "No encontramos este lugar", CFe = "Ver más", EFe = "Proyectos de viaje", zFe = "", jFe = "opcional", AFe = {
  "autocomplete.button": "Buscar",
  "autocomplete.placeholder": "¿Adónde vas?",
  bedroomsNumbers_zero: L2e,
  bedroomsNumbers_one: W2e,
  bedroomsNumbers_other: B2e,
  beds_zero: F2e,
  beds_one: V2e,
  beds_other: U2e,
  "button.free-signup": "Regístrate gratis",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "No puedes superar los {{limit}} caracteres",
  "error.reload": "Actualizar esta página",
  "error.return-homepage": "Volver a la página de inicio",
  "error.subtitle": "Lo sentimos, pero no se puede acceder a esta página.",
  "error.title": "Se ha producido un error en la página",
  "errors.unable_to_submit.subtitle": "Lo sentimos, se ha producido un error al enviar el formulario. Por favor, vuelve a intentarlo más tarde.",
  "errors.unable_to_submit.title": "¡Vaya! Algo ha fallado.",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Continuar",
  "global.getStarted": "",
  "global.login": "Iniciar sesión",
  "global.select": "Selecciona",
  global_adults: q2e,
  global_babies: H2e,
  global_calendarUpdated_toast: G2e,
  global_calendar_aMonth: K2e,
  global_calendar_exactDates: J2e,
  global_calendar_oneWeek: Z2e,
  global_calendar_oneWeekend: Y2e,
  global_calendar_plusMinusDay_zero: X2e,
  global_calendar_plusMinusDay_one: Q2e,
  global_calendar_plusMinusDay_other: eBe,
  global_calendar_twoWeeks: tBe,
  global_cancel: aBe,
  global_children: oBe,
  global_dates: nBe,
  global_delete: rBe,
  global_description: iBe,
  global_destination: sBe,
  global_done: lBe,
  global_edit: cBe,
  "global_filter_a-c": "Aire acondicionado",
  global_filter_available: uBe,
  "global_filter_baby-bed": "",
  "global_filter_baby-gear": "Equipamiento para bebés",
  "global_filter_balcony-terrace": "Balcón/Terraza",
  global_filter_bathtub: dBe,
  global_filter_bbq: gBe,
  global_filter_bicycle: hBe,
  global_filter_car: mBe,
  global_filter_cat: pBe,
  "global_filter_children-welcome": "Niños bienvenidos",
  global_filter_cities: fBe,
  "global_filter_cleaning-person": "Señor/a de la limpieza",
  global_filter_countryside: bBe,
  "global_filter_dedicated-workspace": "Escritorio para trabajar",
  "global_filter_disabled-access": "Casas accesibles",
  global_filter_dishwasher: _Be,
  global_filter_dog: vBe,
  global_filter_dryer: yBe,
  "global_filter_eco-level": "Solo viviendas sostenibles",
  "global_filter_electric-car-plug": "Enchufe para coches eléctricos",
  global_filter_elevator: wBe,
  global_filter_favorite: kBe,
  global_filter_fireplace: xBe,
  global_filter_flat: $Be,
  global_filter_garden: SBe,
  "global_filter_guest-wanted": "Intercambio con GuestPoints",
  global_filter_guestPointsMax: CBe,
  global_filter_guestPointsMin: EBe,
  global_filter_guestPointsMinMax: zBe,
  global_filter_gym: jBe,
  "global_filter_heating-system": "Calefacción",
  "global_filter_high-speed-connexion": "Conexión de alta velocidad",
  global_filter_home: ABe,
  "global_filter_home-verified": "Casas verificadas",
  global_filter_island: OBe,
  global_filter_isolated: PBe,
  global_filter_jacuzzi: DBe,
  "global_filter_kids-toys": "",
  global_filter_lakes: NBe,
  global_filter_luxury: RBe,
  global_filter_mountains: IBe,
  "global_filter_no-bed-up": "Sin camas provisionales",
  global_filter_numOfBathrooms: TBe,
  global_filter_other: MBe,
  "global_filter_parking-space": "",
  "global_filter_pets-welcome": "Mascotas bienvenidas",
  global_filter_piano: LBe,
  global_filter_playground: WBe,
  global_filter_primary: BBe,
  "global_filter_public-transit-access": "",
  global_filter_reciprocal: FBe,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: VBe,
  global_filter_river: UBe,
  global_filter_seaside: qBe,
  global_filter_secondary: HBe,
  "global_filter_secured-pool": "Piscina segura",
  "global_filter_smokers-welcome": "Fumadores bienvenidos",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: GBe,
  global_filter_villages: KBe,
  "global_filter_washing-machine": "Lavadora",
  "global_filter_whole-unit": "",
  global_filter_wifi: JBe,
  global_filters: ZBe,
  global_fixDates: YBe,
  global_flexDates_aMonth: XBe,
  global_flexDates_aWeekend: QBe,
  global_flexDates_oneWeek: eFe,
  global_flexDates_twoWeek: tFe,
  global_flexibleDates: aFe,
  global_guests: oFe,
  global_homes: nFe,
  global_lastMinute: rFe,
  global_location: iFe,
  global_modify: sFe,
  global_name: lFe,
  global_next: cFe,
  global_numberOfAdults_zero: uFe,
  global_numberOfAdults_one: dFe,
  global_numberOfAdults_other: gFe,
  global_numberOfBabies_zero: hFe,
  global_numberOfBabies_one: mFe,
  global_numberOfBabies_other: pFe,
  global_numberOfChildren_zero: fFe,
  global_numberOfChildren_one: bFe,
  global_numberOfChildren_other: _Fe,
  global_numberOfGuests_zero: vFe,
  global_numberOfGuests_one: yFe,
  global_numberOfGuests_other: wFe,
  global_phoneNumber_notValid: kFe,
  global_receiveEmailAlerts: xFe,
  global_save: $Fe,
  global_searchBar_noLocationFound: SFe,
  global_seeMore_link: CFe,
  global_travelWishlist: EFe,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: zFe,
  optional: jFe,
  "privacy-policy": "Política de Privacidad"
}, OFe = "https://www.homeexchange.com/es/blog/", PFe = "/es/p/homeexchange-condiciones-de-uso", DFe = "https://www.homeexchange.com/es/p/nuestra-comunidad-es", NFe = "https://homeexchangehelp.zendesk.com/hc/es", RFe = "https://forum.homeexchange.com/c/espanol/22", IFe = "https://www.homeexchange.com/es/p/service-homeexchange-es", TFe = "https://www.homeexchange.com/es/p/los-guestpoints", MFe = "https://www.homeexchange.com/es/p/prensa", LFe = "https://www.homeexchange.com/p/palabra-de-homeexchanger", WFe = "", BFe = "https://www.homeexchange.com/es/p/principios-intercambio-casa", FFe = "https://www.homeexchange.com/es/p/principios-intercambio-casa", VFe = {
  "about-calendar": "https://help.homeexchange.com/hc/es/articles/360007584998-Todo-lo-que-necesitas-saber-sobre-el-calendario",
  "about-us": "https://www.homeexchange.com/es/p/about-us-es",
  blog: OFe,
  cgu: PFe,
  community: DFe,
  "contact-us": "https://www.homeexchange.com/es/contacto-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeES/",
  faq: NFe,
  forum: RFe,
  guarantees: IFe,
  guestpoints: TFe,
  "happiness-team": "https://www.homeexchange.com/es/p/happiness-team-es",
  "how-it-works": "https://www.homeexchange.com/es/p/como-funciona-es",
  "join-us": "https://www.homeexchange.com/es/p/join-us-es",
  "legal-notice": "/p/menciones-legales",
  "mobile-app": "https://www.homeexchange.com/es/p/aplicacion-movil",
  "our-team": "https://www.homeexchange.com/es/p/nuestro-equipo",
  press: MFe,
  "privacy-policy": "/p/homeexchange-politica-privacidad",
  "subscription-cost": "https://www.homeexchange.com/es/p/subscription-homeexchange-es",
  "term-of-use": "/p/homeexchange-condiciones-de-uso",
  testimonials: LFe,
  travelWishlist_faq_links: WFe,
  "twitter-page": "https://twitter.com/HomeExchangeES",
  value: BFe,
  values: FFe
}, UFe = "", qFe = "", HFe = "Crear nuevo proyecto de viaje", GFe = "Tener tus proyectos de viaje actualizados te permitirá recibir más solicitudes de intercambio recíproco.", KFe = "¿Seguro que quieres eliminar {{fullAddress}}?", JFe = "Estos son los filtros que has seleccionado. Si has cambiado de opinión, puedes eliminar algunos de ellos a continuación. Pero si quieres añadir otros, tendrás que iniciar una nueva búsqueda (aunque esto cambiará pronto... ¡tendrás noticias!)", ZFe = "Puede ser un país, una ciudad o una región entera. Si eliges una ubicación general, los resultados pueden ser menos precisos.", YFe = "Introduce un país, ciudad o región", XFe = "Ver casas disponibles", QFe = "Cuando haya casas disponibles que coincidan con tus proyectos de viaje.", eVe = "Crear nuevo proyecto de viaje", tVe = "{{fullAddress}} se ha eliminado de tus proyectos de viaje.", aVe = "Selecciona tus fechas ideales de viaje (flexibles o fijas).", oVe = "Añade detalles para ayudar a otras personas que utilicen la función de búsqueda inversa a entender por qué te interesa su región.", nVe = "Especifica cuántas personas viajarán contigo.", rVe = "¡Vaya! {{fullAddress}} no se ha guardado en tus proyectos de viaje por un motivo desconocido.", iVe = "Indícanos cuándo y dónde te gustaría viajar para recibir solicitudes de intercambio y notificaciones cuando haya casas disponibles. Guardaremos tus búsquedas en tus proyectos de viaje.", sVe = "¿Te apetece empezar a planear alguna aventura?", lVe = "<updateDates>Actualiza la fecha</updateDates> para seguir recibiendo notificaciones por correo electrónico o <delete>elimina este destino</delete>  de tus proyectos de viaje si ya no lo tienes en mente.", cVe = "Esta fecha ya ha pasado", uVe = "{{fullAddress}} se ha añadido a tus proyectos de viaje", dVe = "{{fullAddress}} se ha actualizado correctamente.", gVe = "¡Tu búsqueda se ha guardado y tu calendario se ha actualizado!", hVe = "Tu búsqueda se ha guardado. Podrás verla en tus proyectos de viaje.", mVe = "Saber más sobre los proyectos de viaje", pVe = {
  firstname: UFe,
  lastname: qFe,
  modal_travelWishlist_addNew_title: HFe,
  modal_travelWishlist_delete_body: GFe,
  modal_travelWishlist_delete_title: KFe,
  modal_travelWishlist_filtersApplied_helper: JFe,
  modal_travelWishlist_location_helper: ZFe,
  modal_travelWishlist_searchBar_placeholder: YFe,
  page_travelWishlist_card_cta: XFe,
  page_travelWishlist_card_emailAlerts_helper: QFe,
  page_travelWishlist_cta: eVe,
  page_travelWishlist_deleted_toast: tVe,
  page_travelWishlist_edit_dates_helper: aVe,
  page_travelWishlist_edit_description_helper: oVe,
  page_travelWishlist_edit_guests_helper: nVe,
  page_travelWishlist_error_toast: rVe,
  page_travelWishlist_none_body: iVe,
  page_travelWishlist_none_subheader: sVe,
  page_travelWishlist_pastDates_desc: lVe,
  page_travelWishlist_pastDates_title: cVe,
  page_travelWishlist_saved_toast: uVe,
  page_travelWishlist_updated_toast: dVe,
  search_travelWishlist_calendarUpdated_toast: gVe,
  search_travelWishlist_saved_toast: hVe,
  travelWishlist_faq: mVe
}, fVe = {
  "modal.emailVerif.alreadyVerified.desc": "C'est tout bon ! Connectez-vous pour continuer.",
  "modal.emailVerif.alreadyVerified.title": "Votre adresse email a déjà été vérifiée",
  "modal.emailVerif.callout": "Un email de vérification a été envoyé à l'adresse <b>{{email}}</b>.",
  "modal.emailVerif.desc": "Consultez votre boîte de réception. Le lien inclus dans cet email expirera au bout de 24 heures.",
  "modal.emailVerif.linkExpired.desc": "Connectez-vous pour recevoir un nouveau lien de vérification dans votre boîte de réception.",
  "modal.emailVerif.linkExpired.title": "Ce lien a expiré",
  "modal.emailVerif.resend-email-link": "Renvoyer l'email de vérification",
  "modal.emailVerif.resend-email.rate-limit": "Vous avez atteint la limite de demandes d'envoi d'e-mails. Réessayez dans 1 minute.",
  "modal.emailVerif.resend-link": "Renvoyer l'email de vérification",
  "modal.emailVerif.title": "Confirmez votre adresse email",
  "modal.finishCreatingAccount.event": "Lors d'un événement",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Tout le monde connaît HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Merci de saisir votre prénom",
  "modal.finishCreatingAccount.friends_family": "Par l'intermédiaire de proches",
  "modal.finishCreatingAccount.hearAboutHE": "Comment avez-vous entendu parler de HomeExchange ?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Merci de saisir votre nom de famille",
  "modal.finishCreatingAccount.other": "Autre",
  "modal.finishCreatingAccount.phone_number": "Téléphone",
  "modal.finishCreatingAccount.phone_number.error": "Merci de renseigner votre numéro de téléphone",
  "modal.finishCreatingAccount.pleaseSpecify": "Précisez",
  "modal.finishCreatingAccount.press": "Dans la presse",
  "modal.finishCreatingAccount.press_online": "En ligne",
  "modal.finishCreatingAccount.press_print": "Écrite",
  "modal.finishCreatingAccount.radio": "À la radio",
  "modal.finishCreatingAccount.referral": "Code de parrainage",
  "modal.finishCreatingAccount.referralCode.error": "Ce code de parrainage n'est pas valide",
  "modal.finishCreatingAccount.search_engine": "Sur un moteur de recherche",
  "modal.finishCreatingAccount.social_media": "Sur les réseaux sociaux",
  "modal.finishCreatingAccount.social_network_other": "Autre réseau social (merci de préciser)",
  "modal.finishCreatingAccount.title": "Terminez la création de votre compte",
  "modal.finishCreatingAccount.tv": "À la télévision",
  "modal.finishCreatingAccount.tv_ad": "Dans une publicité",
  "modal.finishCreatingAccount.tv_show": "Dans un reportage/une émission TV",
  "modal.genericError.desc": "Notre plateforme pourrait être indisponible ou victime d'une panne temporaire, il va vous falloir réessayer.<br><br> Nous détectons ces erreurs automatiquement, mais n'hésitez pas à nous contacter à l'adresse suivante si le problème persiste :<br><a> tech@homeexchange.com</a>",
  "modal.genericError.title": "Oups ! Une erreur est survenue",
  "modal.modifyEmail.callout.desc": "Vous serez déconnecté·e après avoir sauvegardé votre nouvelle adresse email et recevrez un email de vérification à cette nouvelle adresse.",
  "modal.modifyEmail.callout.title": "Vous êtes sur le point d'être déconnecté·e",
  "modal.modifyEmail.confirmEmail.title": "Confirmez la nouvelle adresse email",
  "modal.modifyEmail.cta": "Sauvegarder la nouvelle adresse email",
  "modal.modifyEmail.currentEmail.title": "Adresse email actuelle",
  "modal.modifyEmail.error.alreadyExists": "Cette adresse email existe déjà",
  "modal.modifyEmail.error.dontMatch": "Les adresses email ne sont pas identiques",
  "modal.modifyEmail.error.incorrectFormat": "Cette adresse email n'est pas valide",
  "modal.modifyEmail.error.unfilled": "Merci de saisir une adresse email",
  "modal.modifyEmail.newEmail.title": "Nouvelle adresse email",
  "modal.modifyEmail.title": "Modifiez votre adresse email",
  "modal.noEmailRecieved.desc": "<b>Vous n'avez pas reçu d'email ?</b> Vérifiez vos spams et l'orthographe de votre adresse email avant de demander l'envoi d'un nouvel email de vérification.",
  "modal.noEmailRecieved.error": "Une erreur est survenue, réessayez plus tard",
  "modal.verifyEmail.emailResent.toast": "Nous vous avons envoyé un nouvel email de vérification à l'adresse <b>{{email}}</b>.",
  "signin-modal.apple.button": "Se connecter avec Google",
  "signin-modal.button": "Se connecter",
  "signin-modal.email.button": "Se connecter",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Se connecter avec Facebook",
  "signin-modal.no-account": "Pas encore de compte ?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Réinitialiser le mot de passe",
  "signup-modal.accept-cgu": "En créant un compte, j’accepte les",
  "signup-modal.apple.button": "Se connecter avec Apple",
  "signup-modal.button": "S'inscrire",
  "signup-modal.cgu.link": "Conditions Générales d’Utilisation",
  "signup-modal.description": "Découvrez une autre manière de voyager avec l’échange de maison : soyez accueilli(e) partout dans le monde et faites des économies !",
  "signup-modal.email.button": "S’inscrire avec votre adresse email",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "S’inscrire avec Facebook",
  "signup-modal.have-an-account": "Vous avez déjà un compte ?"
}, bVe = "Studio", _Ve = "{{count}} chambre", vVe = "{{count}} chambres", yVe = "", wVe = "{{count}} lit", kVe = "{{count}} lits", xVe = "Adultes", $Ve = "Bébés", SVe = "Votre calendrier a été mis à jour.", CVe = "Un mois", EVe = "Dates exactes", zVe = "Une semaine", jVe = "Un week-end", AVe = "Vide", OVe = "± {{count}} jour", PVe = "± {{count}} jours", DVe = "Deux semaines", NVe = "Annuler", RVe = "Enfants", IVe = "Dates", TVe = "Supprimer", MVe = "Description", LVe = "Destination", WVe = "C'est prêt !", BVe = "Modifier", FVe = "Tout type d'échange", VVe = "Baignoire", UVe = "Barbecue", qVe = "Vélo", HVe = "Voiture", GVe = "Chat", KVe = "Ville", JVe = "Campagne", ZVe = "Lave-vaisselle", YVe = "Chien", XVe = "Sèche linge", QVe = "Ascenseur", e3e = "Maisons favorites", t3e = "Cheminée", a3e = "Appartement", o3e = "Jardin privé", n3e = "moins de {{max}} GP", r3e = "à partir de {{min}} GP", i3e = "Entre {{min}} et {{max}} GP", s3e = "Salle de sport privée", l3e = "Maison", c3e = "Île", u3e = "Isolé", d3e = "Jacuzzi", g3e = "Lac", h3e = "Maisons Collection", m3e = "Montagne", p3e = "{{count}} salles de bain", f3e = "Autre", b3e = "Piano", _3e = "Aire de jeux", v3e = "Principale", y3e = "Échange réciproque", w3e = "Recherche inversée", k3e = "Rivière", x3e = "Bord de mer", $3e = "Secondaire", S3e = "TV", C3e = "Village", E3e = "WiFi", z3e = "Filtres", j3e = "Dates fixes", A3e = "Un mois en {{date}}", O3e = "Un week-end en {{date}}", P3e = "Une semaine en {{date}}", D3e = "Deux semaines en {{date}}", N3e = "Dates flexibles", R3e = "Personnes", I3e = "maisons", T3e = "Dernière minute", M3e = "Lieu", L3e = "Modifier", W3e = "Titre", B3e = "Suivant", F3e = "Vide", V3e = "{{count}} adulte", U3e = "{{count}} adultes", q3e = "Vide", H3e = "{{count}} bébé", G3e = "{{count}} bébés", K3e = "Vide", J3e = "{{count}} enfant", Z3e = "{{count}} enfants", Y3e = "{{count}} personne", X3e = "{{count}} personne", Q3e = "{{count}} personnes", e4e = "Le format du numéro de téléphone est invalide.", t4e = "Recevoir des alertes par email", a4e = "Enregistrer", o4e = "Aucun lieu trouvé", n4e = "Voir plus", r4e = "Projets de voyage", i4e = "", s4e = "facultatif", l4e = {
  "autocomplete.button": "Rechercher",
  "autocomplete.placeholder": "Où allez-vous ?",
  bedroomsNumbers_zero: bVe,
  bedroomsNumbers_one: _Ve,
  bedroomsNumbers_other: vVe,
  beds_zero: yVe,
  beds_one: wVe,
  beds_other: kVe,
  "button.free-signup": "Inscrivez-vous gratuitement",
  "button.validate": "Valider",
  "common.try-again": "Compris !",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne doit pas dépasser {{limit}} caractères",
  "error.reload": "Actualiser la page",
  "error.return-homepage": "Retour à la page d'accueil",
  "error.subtitle": "Malheureusement, il y a un problème avec cette page.",
  "error.title": "Une erreur s'est produite sur la page",
  "errors.unable_to_submit.subtitle": "Malheureusement, votre réponse n'a pas pu être enregistrée. Merci de réessayer plus tard !",
  "errors.unable_to_submit.title": "Oups, on dirait bien qu'il y a un problème !",
  "global.back": "Retour",
  "global.cancel": "Annuler",
  "global.collection.browsehomes": "Découvrir les maisons",
  "global.collection.contactus": "Nous contacter",
  "global.confirm": "Confirmer",
  "global.continue": "Continuer",
  "global.getStarted": "Commencer",
  "global.login": "Se connecter",
  "global.select": "Sélectionner",
  global_adults: xVe,
  global_babies: $Ve,
  global_calendarUpdated_toast: SVe,
  global_calendar_aMonth: CVe,
  global_calendar_exactDates: EVe,
  global_calendar_oneWeek: zVe,
  global_calendar_oneWeekend: jVe,
  global_calendar_plusMinusDay_zero: AVe,
  global_calendar_plusMinusDay_one: OVe,
  global_calendar_plusMinusDay_other: PVe,
  global_calendar_twoWeeks: DVe,
  global_cancel: NVe,
  global_children: RVe,
  global_dates: IVe,
  global_delete: TVe,
  global_description: MVe,
  global_destination: LVe,
  global_done: WVe,
  global_edit: BVe,
  "global_filter_a-c": "Air conditionné",
  global_filter_available: FVe,
  "global_filter_baby-bed": "Lits bébé",
  "global_filter_baby-gear": "Équipements bébé",
  "global_filter_balcony-terrace": "Balcon / Terrasse",
  global_filter_bathtub: VVe,
  global_filter_bbq: UVe,
  global_filter_bicycle: qVe,
  global_filter_car: HVe,
  global_filter_cat: GVe,
  "global_filter_children-welcome": "Les enfants sont les bienvenus",
  global_filter_cities: KVe,
  "global_filter_cleaning-person": "Service de ménage",
  global_filter_countryside: JVe,
  "global_filter_dedicated-workspace": "Espace de travail dédié",
  "global_filter_disabled-access": "Logement adapté",
  global_filter_dishwasher: ZVe,
  global_filter_dog: YVe,
  global_filter_dryer: XVe,
  "global_filter_eco-level": "Uniquement des maisons durables",
  "global_filter_electric-car-plug": "Prise pour voiture électrique",
  global_filter_elevator: QVe,
  global_filter_favorite: e3e,
  global_filter_fireplace: t3e,
  global_filter_flat: a3e,
  global_filter_garden: o3e,
  "global_filter_guest-wanted": "Échange contre GuestPoints",
  global_filter_guestPointsMax: n3e,
  global_filter_guestPointsMin: r3e,
  global_filter_guestPointsMinMax: i3e,
  global_filter_gym: s3e,
  "global_filter_heating-system": "Chauffage",
  "global_filter_high-speed-connexion": "Connexion haut débit",
  global_filter_home: l3e,
  "global_filter_home-verified": "Logements vérifiés",
  global_filter_island: c3e,
  global_filter_isolated: u3e,
  global_filter_jacuzzi: d3e,
  "global_filter_kids-toys": "Jouets pour enfants",
  global_filter_lakes: g3e,
  global_filter_luxury: h3e,
  global_filter_mountains: m3e,
  "global_filter_no-bed-up": "Pas de lit d'appoint",
  global_filter_numOfBathrooms: p3e,
  global_filter_other: f3e,
  "global_filter_parking-space": "Place de parking privé",
  "global_filter_pets-welcome": "Les animaux sont les bienvenus",
  global_filter_piano: b3e,
  global_filter_playground: _3e,
  global_filter_primary: v3e,
  "global_filter_public-transit-access": "Accès aux transports publics",
  global_filter_reciprocal: y3e,
  "global_filter_response-rate-above-threshold": "Réactivité ≥ Moyenne",
  global_filter_reverse: w3e,
  global_filter_river: k3e,
  global_filter_seaside: x3e,
  global_filter_secondary: $3e,
  "global_filter_secured-pool": "Piscine sécurisée",
  "global_filter_smokers-welcome": "Fumeurs bienvenus",
  "global_filter_swimming-pool": "Piscine",
  global_filter_tv: S3e,
  global_filter_villages: C3e,
  "global_filter_washing-machine": "Lave linge",
  "global_filter_whole-unit": "L'intégralité du logement",
  global_filter_wifi: E3e,
  global_filters: z3e,
  global_fixDates: j3e,
  global_flexDates_aMonth: A3e,
  global_flexDates_aWeekend: O3e,
  global_flexDates_oneWeek: P3e,
  global_flexDates_twoWeek: D3e,
  global_flexibleDates: N3e,
  global_guests: R3e,
  global_homes: I3e,
  global_lastMinute: T3e,
  global_location: M3e,
  global_modify: L3e,
  global_name: W3e,
  global_next: B3e,
  global_numberOfAdults_zero: F3e,
  global_numberOfAdults_one: V3e,
  global_numberOfAdults_other: U3e,
  global_numberOfBabies_zero: q3e,
  global_numberOfBabies_one: H3e,
  global_numberOfBabies_other: G3e,
  global_numberOfChildren_zero: K3e,
  global_numberOfChildren_one: J3e,
  global_numberOfChildren_other: Z3e,
  global_numberOfGuests_zero: Y3e,
  global_numberOfGuests_one: X3e,
  global_numberOfGuests_other: Q3e,
  global_phoneNumber_notValid: e4e,
  global_receiveEmailAlerts: t4e,
  global_save: a4e,
  global_searchBar_noLocationFound: o4e,
  global_seeMore_link: n4e,
  global_travelWishlist: r4e,
  "modal.error-occured.content": "Toutes nos excuses : quelque chose ne s'est pas passé comme prévu, il va falloir que vous retentiez votre chance !",
  "modal.error-occured.title": "Une erreur s'est produite",
  no_result: i4e,
  optional: s4e,
  "privacy-policy": "Charte de vie privée"
}, c4e = "https://www.homeexchange.fr/blog/", u4e = "/p/conditions-generale-d-utilisation", d4e = "https://www.homeexchange.fr/p/communaute", g4e = "https://homeexchangehelp.zendesk.com/hc/fr", h4e = "https://forum.homeexchange.com/c/francais/21", m4e = "https://www.homeexchange.fr/p/service-homeexchange-fr", p4e = "https://www.homeexchange.fr/p/comment-fonctionnent-les-gp", f4e = "https://www.homeexchange.fr/p/presse", b4e = "https://www.homeexchange.com/p/paroles-homeexchangers", _4e = "https://help.homeexchange.com/hc/fr/articles/360000623717-Que-sont-Mes-destinations-pr%C3%A9f%C3%A9r%C3%A9es-et-comment-les-utiliser", v4e = "https://www.homeexchange.fr/p/les-fondamentaux ", y4e = "https://www.homeexchange.fr/p/les-fondamentaux", w4e = {
  "about-calendar": "https://help.homeexchange.com/hc/fr/articles/360007584998-Tout-ce-que-vous-devez-savoir-sur-le-calendrier",
  "about-us": "https://www.homeexchange.fr/p/qui-sommes-nous",
  blog: c4e,
  cgu: u4e,
  community: d4e,
  "contact-us": "https://www.homeexchange.fr/contactez-nous-homeexchange",
  "cookie-policy": "/p/nos-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeFR/",
  faq: g4e,
  forum: h4e,
  guarantees: m4e,
  guestpoints: p4e,
  "happiness-team": "https://www.homeexchange.fr/p/happiness-team-fr",
  "how-it-works": "https://www.homeexchange.fr/p/comment-ca-marche-fr",
  "join-us": "https://www.homeexchange.fr/p/recrutement",
  "legal-notice": "/p/mentions-legales",
  "mobile-app": "https://www.homeexchange.fr/p/applications-mobile",
  "our-team": "https://www.homeexchange.fr/p/notre-equipe",
  press: f4e,
  "privacy-policy": "/p/charte-vie-privee",
  "subscription-cost": "https://www.homeexchange.fr/p/subscription-homeexchange-fr",
  "term-of-use": "/p/conditions-generale-d-utilisation",
  testimonials: b4e,
  travelWishlist_faq_links: _4e,
  "twitter-page": "https://twitter.com/HomeExchangeFR",
  value: v4e,
  values: y4e
}, k4e = "Prénom", x4e = "Nom", $4e = "Ajouter un projet de voyage", S4e = "Garder vos projets de voyage à jour vous permet de recevoir davantage de demandes d'échange réciproques.", C4e = "Voulez-vous vraiment supprimer {{fullAddress}} ?", E4e = "Ce sont les filtres que vous avez sélectionnés lors de votre recherche enregistrée : vous pouvez en supprimer mais si vous souhaitez en ajouter, vous devrez lancer une nouvelle recherche (mais plus pour très longtemps... on vous tiendra au courant !).", z4e = "Vous pouvez indiquer un pays, une région ou une ville. Si vous visez large, les résultats seront peut-être moins précis.", j4e = "Entrez un pays, une ville ou une région", A4e = "Voir les maisons disponibles", O4e = "Lorsque des logements correspondant à vos critères ont de nouvelles disponibilités", P4e = "Ajouter un projet de voyage", D4e = "Nous avons bien supprimé {{fullAddress}} de vos projets de voyage.", N4e = "Indiquez vos dates de voyage estimées (qu'elles soient flexibles ou fixes).", R4e = "Ajoutez des détails pour aider les membres utilisant la recherche inversée à savoir ce qui vous intéresse dans leur région.", I4e = "Indiquez combien de personnes voyageront avec vous cette fois-ci.", T4e = "Oups ! Pour une raison inattendue, nous n'avons pas pu ajouter {{fullAddress}} à vos projets de voyage.", M4e = "Indiquez où et quand vous aimeriez partir pour recevoir des demandes d'échange adaptées ainsi que des alertes dès que des logements correspondent à vos critères. Chaque recherche sera enregistrée dans vos projets de voyage.", L4e = "Des envies de voyage en tête ?", W4e = "<updateDates>Mettez à jour vos dates</updateDates> pour continuer à recevoir des alertes email pertinentes ou <delete>supprimez cette destination</delete> de vos projets de voyage si elle n'est plus d'actualité.", B4e = "Ces dates sont passées", F4e = "Nous avons bien ajouté {{fullAddress}} à vos projets de voyage.", V4e = "Nous avons bien mis à jour les informations pour {{fullAddress}}", U4e = "Votre recherche a bien été enregistrée et votre calendrier a été mis à jour.", q4e = "Votre recherche a bien été enregistrée. Retrouvez-la dans vos projets de voyage.", H4e = "En savoir plus sur les projets de voyage", G4e = {
  firstname: k4e,
  lastname: x4e,
  modal_travelWishlist_addNew_title: $4e,
  modal_travelWishlist_delete_body: S4e,
  modal_travelWishlist_delete_title: C4e,
  modal_travelWishlist_filtersApplied_helper: E4e,
  modal_travelWishlist_location_helper: z4e,
  modal_travelWishlist_searchBar_placeholder: j4e,
  page_travelWishlist_card_cta: A4e,
  page_travelWishlist_card_emailAlerts_helper: O4e,
  page_travelWishlist_cta: P4e,
  page_travelWishlist_deleted_toast: D4e,
  page_travelWishlist_edit_dates_helper: N4e,
  page_travelWishlist_edit_description_helper: R4e,
  page_travelWishlist_edit_guests_helper: I4e,
  page_travelWishlist_error_toast: T4e,
  page_travelWishlist_none_body: M4e,
  page_travelWishlist_none_subheader: L4e,
  page_travelWishlist_pastDates_desc: W4e,
  page_travelWishlist_pastDates_title: B4e,
  page_travelWishlist_saved_toast: F4e,
  page_travelWishlist_updated_toast: V4e,
  search_travelWishlist_calendarUpdated_toast: U4e,
  search_travelWishlist_saved_toast: q4e,
  travelWishlist_faq: H4e
}, K4e = {
  "modal.emailVerif.alreadyVerified.desc": "Vaša adresa e-pošte je spremna! Prijavite se kako biste nastavili.",
  "modal.emailVerif.alreadyVerified.title": "Ova adresa e-pošte je već potvrđena",
  "modal.emailVerif.callout": "E-poruka s potvrdom je poslana na <b>{{email}}</b>.",
  "modal.emailVerif.desc": "Provjerite svoju dolaznu poštu. Poveznica u ovoj poruci će isteći u roku od 24 sata.",
  "modal.emailVerif.linkExpired.desc": "Ako želite dobiti novu poveznicu s potvrdom, morate se prijaviti.",
  "modal.emailVerif.linkExpired.title": "Ova je poveznica istekla",
  "modal.emailVerif.resend-email-link": "Ponovno pošalji e-poruku s potvrdom",
  "modal.emailVerif.resend-email.rate-limit": "Dosegli ste ograničenje zahtjeva za e-poštu. Pokušajte ponovno za 1 minutu.",
  "modal.emailVerif.resend-link": "Ponovno pošalji e-poruku s potvrdom",
  "modal.emailVerif.title": "Potvrdite adresu e-pošte",
  "modal.finishCreatingAccount.event": "na nekom događaju",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "svi znaju za HomeExchange",
  "modal.finishCreatingAccount.facebook": "na Facebooku",
  "modal.finishCreatingAccount.firstName.error": "Upišite svoje ime",
  "modal.finishCreatingAccount.friends_family": "preko obitelji, prijatelja ili poznanika",
  "modal.finishCreatingAccount.hearAboutHE": "Kako ste čuli za HomeExchange?",
  "modal.finishCreatingAccount.instagram": "na Instagramu",
  "modal.finishCreatingAccount.lastName.error": "Upišite svoje prezime",
  "modal.finishCreatingAccount.other": "ostalo",
  "modal.finishCreatingAccount.phone_number": "Broj telefona",
  "modal.finishCreatingAccount.phone_number.error": "Molimo unesite svoj broj telefona",
  "modal.finishCreatingAccount.pleaseSpecify": "napišite konkretnije",
  "modal.finishCreatingAccount.press": "u novinama",
  "modal.finishCreatingAccount.press_online": "na internetu",
  "modal.finishCreatingAccount.press_print": "u tiskanim medijima",
  "modal.finishCreatingAccount.radio": "na radiju",
  "modal.finishCreatingAccount.referral": "Kod za preporuku",
  "modal.finishCreatingAccount.referralCode.error": "Ovaj kod za preporuku nije valjan",
  "modal.finishCreatingAccount.search_engine": "u tražilici",
  "modal.finishCreatingAccount.social_media": "na društvenim mrežama",
  "modal.finishCreatingAccount.social_network_other": "na drugoj društvenoj mreži (napišite kojoj)",
  "modal.finishCreatingAccount.title": "Dovršite izradu svojeg računa",
  "modal.finishCreatingAccount.tv": "na televiziji",
  "modal.finishCreatingAccount.tv_ad": "u reklami",
  "modal.finishCreatingAccount.tv_show": "u nekoj reportaži/TV emisiji",
  "modal.genericError.desc": "Platforma možda trenutačno nije dostupna ili možda imamo nekih problema, zbog čega Vas molimo da pokušate ponovno.<br><br>Automatski pratimo ove greške, ali ako i dalje budete nailazili na problem, slobodno nam se javite na:<br><a>tech@homeexchange.com</a>",
  "modal.genericError.title": "Ajoj! Nešto nije u redu",
  "modal.modifyEmail.callout.desc": "Nakon što spremite svoju novu adresu e-pošte, bit ćete odjavljeni i dobit ćete e-poruku s potvrdom na svoju novu adresu.",
  "modal.modifyEmail.callout.title": "Bit ćete odjavljeni",
  "modal.modifyEmail.confirmEmail.title": "Potvrdite novu adresu e-pošte",
  "modal.modifyEmail.cta": "Spremite novu adresu e-pošte",
  "modal.modifyEmail.currentEmail.title": "Trenutačna adresa e-pošte",
  "modal.modifyEmail.error.alreadyExists": "Ova adresa e-pošte već postoji",
  "modal.modifyEmail.error.dontMatch": "Adrese e-pošte se ne podudaraju",
  "modal.modifyEmail.error.incorrectFormat": "Ova adresa e-pošte nije valjana",
  "modal.modifyEmail.error.unfilled": "Unesite adresu e-pošte",
  "modal.modifyEmail.newEmail.title": "Nova adresa e-pošte",
  "modal.modifyEmail.title": "Uredite svoju adresu e-pošte",
  "modal.noEmailRecieved.desc": "<b>Niste primili e-poruku?</b>Provjerite svoj pretinac neželjene pošte i jeste li točno upisali svoju adresu e-pošte prije nego što zatražite još jednu e-poruku s potvrdom.",
  "modal.noEmailRecieved.error": "Nešto nije u redu, pokušajte ponovno kasnije",
  "modal.verifyEmail.emailResent.toast": "Poslali smo Vam novu e-poruku s potvrdom na <b>{{email}}</b>.",
  "signin-modal.apple.button": "Prijavite se s Apple ID-om",
  "signin-modal.button": "Prijavite se",
  "signin-modal.email.button": "Prijavite se",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Prijavite se putem Facebooka",
  "signin-modal.no-account": "Još nemate račun?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Resetirajte lozinku",
  "signup-modal.accept-cgu": "Izradom računa, prihvaćam",
  "signup-modal.apple.button": "Prijavite se s Apple ID-om",
  "signup-modal.button": "Registrirajte se",
  "signup-modal.cgu.link": "Opće Uvjete korištenja",
  "signup-modal.description": "Otkrijte novi način putovanja sa zamjenom domova: odsjedajte svugdje po svijetu i uštedite novac!",
  "signup-modal.email.button": "Registrirajte se sa Vašom email adresom",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Registrirajte se putem Facebooka",
  "signup-modal.have-an-account": "Već imate račun?"
}, J4e = "Studio", Z4e = "{{count}} soba", Y4e = "{{count}} sobe", X4e = "{{count}} sobe", Q4e = "", eUe = "{{count}} krevet", tUe = "{{count}} kreveti", aUe = "{{count}} kreveti", oUe = "Odrasle osobe", nUe = "Bebe", rUe = "Vaš je kalendar ažuriran.", iUe = "Mjesec", sUe = "Točni datumi", lUe = "Jedan tjedan", cUe = "Jedan vikend", uUe = "dana", dUe = "dan", gUe = "dana", hUe = "± {{count}} dan", mUe = "Dva tjedna", pUe = "Odustani", fUe = "Djeca", bUe = "Datumi", _Ue = "Izbrišite", vUe = "Opis", yUe = "Odredište", wUe = "Gotovo!", kUe = "Uredite", xUe = "Sve vrste zamjene", $Ue = "Kada", SUe = "Roštilj", CUe = "Bicikl", EUe = "Automobil", zUe = "Mačka", jUe = "Grad", AUe = "Ruralno", OUe = "Perilica suđa", PUe = "Pas", DUe = "Sušilica", NUe = "Dizalo", RUe = "Favoriti", IUe = "Kamin", TUe = "Stan", MUe = "Privatno dvorište", LUe = "manje od {{max}} GP", WUe = "od {{min}} GP", BUe = "Između {{min}} i {{max}} GP", FUe = "Privatna teretana", VUe = "Kuća", UUe = "Otok", qUe = "Izoliran", HUe = "Jacuzzi", GUe = "Jezera", KUe = "Domove iz Collectiona", JUe = "Planine", ZUe = "broj kupanica: %{count}", YUe = "Ostale životinje", XUe = "Glasovir", QUe = "Dječje igralište", eqe = "Moj dom", tqe = "Recipročna zamjena", aqe = "Obrnuta pretraga", oqe = "Rijeka", nqe = "Na obali", rqe = "Drugi", iqe = "TV", sqe = "Selo", lqe = "WiFi", cqe = "Filtri", uqe = "Fiksni datumi", dqe = "{{date}}: jedan mjesec", gqe = "{{date}}: jedan vikend", hqe = "{{date}}: jedan tjedan", mqe = "{{date}}: dva tjedna", pqe = "Fleksibilni datumi", fqe = "Gosti", bqe = "domova", _qe = "U zadnji tren", vqe = "Lokacija", yqe = "Uredi", wqe = "", kqe = "Dalje", xqe = "odraslih osoba", $qe = "odrasla osoba", Sqe = "odrasle osobe", Cqe = "odraslih osoba", Eqe = "beba", zqe = "beba", jqe = "bebe", Aqe = "beba", Oqe = "djece", Pqe = "dijete", Dqe = "djeteta", Nqe = "djece", Rqe = "gostiju", Iqe = "gost", Tqe = "gosta", Mqe = "gostiju", Lqe = "Format telefonskog broja nije valjan.", Wqe = "Primajte obavijesti e-poštom", Bqe = "Spremi", Fqe = "Nema pronađenih lokacija", Vqe = "Saznajte više", Uqe = "Planovi putovanja", qqe = "", Hqe = "nije obavezno", Gqe = {
  "autocomplete.button": "Pretražite",
  "autocomplete.placeholder": "Gdje ideš ?",
  bedroomsNumbers_zero: J4e,
  bedroomsNumbers_one: Z4e,
  bedroomsNumbers_few: Y4e,
  bedroomsNumbers_other: X4e,
  beds_zero: Q4e,
  beds_one: eUe,
  beds_few: tUe,
  beds_other: aUe,
  "button.free-signup": "Prijavite se besplatno",
  "button.validate": "Potvrdite",
  "common.try-again": "Pokušajte ponovno",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Ne smije biti dulje od {{limit}} znakova",
  "error.reload": "Osvježite stranicu",
  "error.return-homepage": "Vratite se na početnu stranicu",
  "error.subtitle": "Nažalost ne može se pristupiti ovoj stranici.",
  "error.title": "Došlo je do greške na stranici.",
  "errors.unable_to_submit.subtitle": "Nažalost, Vaš obrazac trenutačno ne može biti predan. Molimo da kasnije pokušate ponovno.",
  "errors.unable_to_submit.title": "Ups, imamo problem",
  "global.back": "Natrag",
  "global.cancel": "Odustani",
  "global.collection.browsehomes": "Pretražujte domove",
  "global.collection.contactus": "Kontaktirajte nas",
  "global.confirm": "Potvrdi",
  "global.continue": "Nastavite",
  "global.getStarted": "Započnite",
  "global.login": "Prijava",
  "global.select": "Odaberi",
  global_adults: oUe,
  global_babies: nUe,
  global_calendarUpdated_toast: rUe,
  global_calendar_aMonth: iUe,
  global_calendar_exactDates: sUe,
  global_calendar_oneWeek: lUe,
  global_calendar_oneWeekend: cUe,
  global_calendar_plusMinusDay_zero: uUe,
  global_calendar_plusMinusDay_one: dUe,
  global_calendar_plusMinusDay_few: gUe,
  global_calendar_plusMinusDay_other: hUe,
  global_calendar_twoWeeks: mUe,
  global_cancel: pUe,
  global_children: fUe,
  global_dates: bUe,
  global_delete: _Ue,
  global_description: vUe,
  global_destination: yUe,
  global_done: wUe,
  global_edit: kUe,
  "global_filter_a-c": "Klima uređaj",
  global_filter_available: xUe,
  "global_filter_baby-bed": "Kreveti za bebe",
  "global_filter_baby-gear": "Oprema za bebe",
  "global_filter_balcony-terrace": "Balkon/terasa",
  global_filter_bathtub: $Ue,
  global_filter_bbq: SUe,
  global_filter_bicycle: CUe,
  global_filter_car: EUe,
  global_filter_cat: zUe,
  "global_filter_children-welcome": "Djeca su dobrodošla",
  global_filter_cities: jUe,
  "global_filter_cleaning-person": "Čistačica",
  global_filter_countryside: AUe,
  "global_filter_dedicated-workspace": "Zaseban radni prostor",
  "global_filter_disabled-access": "Pristupačan dom",
  global_filter_dishwasher: OUe,
  global_filter_dog: PUe,
  global_filter_dryer: DUe,
  "global_filter_eco-level": "Samo održivi domovi",
  "global_filter_electric-car-plug": "Utikač za električni automobil",
  global_filter_elevator: NUe,
  global_filter_favorite: RUe,
  global_filter_fireplace: IUe,
  global_filter_flat: TUe,
  global_filter_garden: MUe,
  "global_filter_guest-wanted": "Zamjena sa GuestPoints bodovima",
  global_filter_guestPointsMax: LUe,
  global_filter_guestPointsMin: WUe,
  global_filter_guestPointsMinMax: BUe,
  global_filter_gym: FUe,
  "global_filter_heating-system": "Sustav grijanja",
  "global_filter_high-speed-connexion": "Velika brzina veze",
  global_filter_home: VUe,
  "global_filter_home-verified": "Provjereni domovi ",
  global_filter_island: UUe,
  global_filter_isolated: qUe,
  global_filter_jacuzzi: HUe,
  "global_filter_kids-toys": "Dječje igračke",
  global_filter_lakes: GUe,
  global_filter_luxury: KUe,
  global_filter_mountains: JUe,
  "global_filter_no-bed-up": "Nema privremenih kreveta",
  global_filter_numOfBathrooms: ZUe,
  global_filter_other: YUe,
  "global_filter_parking-space": "Privatno parkirno mjesto",
  "global_filter_pets-welcome": "Kućni ljubimci su dobrodošli",
  global_filter_piano: XUe,
  global_filter_playground: QUe,
  global_filter_primary: eqe,
  "global_filter_public-transit-access": "Pristup javnim prijevozom",
  global_filter_reciprocal: tqe,
  "global_filter_response-rate-above-threshold": "Stopa odgovora ≥ Prosječno",
  global_filter_reverse: aqe,
  global_filter_river: oqe,
  global_filter_seaside: nqe,
  global_filter_secondary: rqe,
  "global_filter_secured-pool": "Osiguran bazen",
  "global_filter_smokers-welcome": "Dozvoljeno pušenje",
  "global_filter_swimming-pool": "Bazen",
  global_filter_tv: iqe,
  global_filter_villages: sqe,
  "global_filter_washing-machine": "Perilica rublja",
  "global_filter_whole-unit": "Cijela jedinica",
  global_filter_wifi: lqe,
  global_filters: cqe,
  global_fixDates: uqe,
  global_flexDates_aMonth: dqe,
  global_flexDates_aWeekend: gqe,
  global_flexDates_oneWeek: hqe,
  global_flexDates_twoWeek: mqe,
  global_flexibleDates: pqe,
  global_guests: fqe,
  global_homes: bqe,
  global_lastMinute: _qe,
  global_location: vqe,
  global_modify: yqe,
  global_name: wqe,
  global_next: kqe,
  global_numberOfAdults_zero: xqe,
  global_numberOfAdults_one: $qe,
  global_numberOfAdults_few: Sqe,
  global_numberOfAdults_other: Cqe,
  global_numberOfBabies_zero: Eqe,
  global_numberOfBabies_one: zqe,
  global_numberOfBabies_few: jqe,
  global_numberOfBabies_other: Aqe,
  global_numberOfChildren_zero: Oqe,
  global_numberOfChildren_one: Pqe,
  global_numberOfChildren_few: Dqe,
  global_numberOfChildren_other: Nqe,
  global_numberOfGuests_zero: Rqe,
  global_numberOfGuests_one: Iqe,
  global_numberOfGuests_few: Tqe,
  global_numberOfGuests_other: Mqe,
  global_phoneNumber_notValid: Lqe,
  global_receiveEmailAlerts: Wqe,
  global_save: Bqe,
  global_searchBar_noLocationFound: Fqe,
  global_seeMore_link: Vqe,
  global_travelWishlist: Uqe,
  "modal.error-occured.content": "Žao nam je zbog neugodnosti, ali pokušajte ponovno.",
  "modal.error-occured.title": "Došlo je do pogreške.",
  no_result: qqe,
  optional: Hqe,
  "privacy-policy": "Pravila o privatnosti"
}, Kqe = "https://www.homeexchange.com/blog/", Jqe = "/p/general-terms-of-use", Zqe = "https://www.homeexchange.com/hr/p/zajednica", Yqe = "https://homeexchangehelp.zendesk.com/hc/en-us", Xqe = "", Qqe = "https://www.homeexchange.com/hr/p/service-homeexchange-hr", eHe = "https://www.homeexchange.com/hr/p/guestpoints-hr", tHe = "https://www.homeexchange.com/hr/p/press-hr", aHe = "https://www.homeexchange.com/p/rijeci-homeexchange", oHe = "", nHe = "https://www.homeexchange.com/hr/p/gdje-dobrodoslica-stvarno-pocinje", rHe = "https://www.homeexchange.com/hr/p/gdje-dobrodoslica-stvarno-pocinje", iHe = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/hr/p/about-us-hr",
  blog: Kqe,
  cgu: Jqe,
  community: Zqe,
  "contact-us": "https://www.homeexchange.com/hr/kontaktirajte-nas-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: Yqe,
  forum: Xqe,
  guarantees: Qqe,
  guestpoints: eHe,
  "happiness-team": "https://www.homeexchange.com/hr/p/happiness-team-hr",
  "how-it-works": "https://www.homeexchange.com/hr/p/kako-to-funkcionira-hr",
  "join-us": "https://www.homeexchange.com/hr/p/join-us-hr",
  "legal-notice": "/p/pravna-napomena",
  "mobile-app": "https://www.homeexchange.com/hr/p/mobilna-aplikacija",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: tHe,
  "privacy-policy": "/p/privacy-policy-hr",
  "subscription-cost": "https://www.homeexchange.com/hr/p/subscription-homeexchange-hr",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: aHe,
  travelWishlist_faq_links: oHe,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: nHe,
  values: rHe
}, sHe = "Ime", lHe = "Prezime", cHe = "Dodajte u svoje planove putovanja", uHe = "Ažurirani planovi putovanja će Vam omogućiti da dobivate više zahtjeva za recipročne zamjene.", dHe = "Jeste li sigurni da želite obrisati lokaciju {{fullAddress}}?", gHe = "Ovo su filtri koji ste odabrali. Ako ste se predomislili, možete obrisati neke od njih. Ali ako želite dodati neke druge, morate započeti novo pretraživanje (iako će se ovo uskoro promijeniti... pratite obavijesti)!", hHe = "Ovo može biti neka zemlja, grad ili cijela regija. Ako odaberete jako široku lokaciju, Vaši bi rezultati mogli biti manje točni.", mHe = "Upišite zemlju, grad ili regiju", pHe = "Pogledajte dostupne domove", fHe = "Kada domovi s dostupnošću odgovaraju Vašim planovima putovanja.", bHe = "Izradite novi plan putovanja", _He = "Lokacija {{fullAddress}} je obrisana iz Vaših planova putovanja.", vHe = "Odaberite svoje idealne datume putovanja (fleksibilne ili fiksne).", yHe = "Dodajte detalje kako biste pomogli drugima koji koriste značajku obrnutog pretraživanja da vide zašto Vas zanima njihova lokacija.", wHe = "Navedite koliko će ljudi putovati s Vama na ovom putovanju.", kHe = "Ups! Lokacija {{fullAddress}} nije mogla biti spremljena u Vaše planove putovanja zbog neočekivanog razloga.", xHe = "Recite nam kada i kamo biste željeli otputovati kako biste dobivali zahtjeve za zamjene i obavijesti čim odgovarajući domovi postanu dostupni. Spremit ćemo Vaše pretraživanje u Vaše planove putovanja!", $He = "Postoje li neke pustolovine za putovanja koje biste voljeli početi planirati?", SHe = "<updateDates>Ažurirajte svoje datume</updateDates> kako biste i dalje dobivali odgovarajuće obavijesti preko e-poruka ili <delete>obrišite ovo odredište</delete> iz svojih planova putovanja ako više ne razmišljate o njemu.", CHe = "Ovi datumi su u prošlosti", EHe = "Lokacija {{fullAddress}} je dodana u Vaše planove putovanja!", zHe = "{{fullAddress}} je uspješno ažurirana.", jHe = "Vaše je pretraživanje spremljeno i Vaš je kalendar ažuriran!", AHe = "Vaše je pretraživanje spremljeno. Pronađite ga u svojim planovima putovanja.", OHe = "Saznajte više o planovima putovanja", PHe = {
  firstname: sHe,
  lastname: lHe,
  modal_travelWishlist_addNew_title: cHe,
  modal_travelWishlist_delete_body: uHe,
  modal_travelWishlist_delete_title: dHe,
  modal_travelWishlist_filtersApplied_helper: gHe,
  modal_travelWishlist_location_helper: hHe,
  modal_travelWishlist_searchBar_placeholder: mHe,
  page_travelWishlist_card_cta: pHe,
  page_travelWishlist_card_emailAlerts_helper: fHe,
  page_travelWishlist_cta: bHe,
  page_travelWishlist_deleted_toast: _He,
  page_travelWishlist_edit_dates_helper: vHe,
  page_travelWishlist_edit_description_helper: yHe,
  page_travelWishlist_edit_guests_helper: wHe,
  page_travelWishlist_error_toast: kHe,
  page_travelWishlist_none_body: xHe,
  page_travelWishlist_none_subheader: $He,
  page_travelWishlist_pastDates_desc: SHe,
  page_travelWishlist_pastDates_title: CHe,
  page_travelWishlist_saved_toast: EHe,
  page_travelWishlist_updated_toast: zHe,
  search_travelWishlist_calendarUpdated_toast: jHe,
  search_travelWishlist_saved_toast: AHe,
  travelWishlist_faq: OHe
}, DHe = {
  "modal.emailVerif.alreadyVerified.desc": "La tua email è pronta! Accedi per continuare.",
  "modal.emailVerif.alreadyVerified.title": "Il tuo indirizzo email è già stato verificato",
  "modal.emailVerif.callout": "Abbiamo inviato un'email di verifica a <b>{{email}}</b>.",
  "modal.emailVerif.desc": "Controlla la tua casella di posta. Il link all'interno scade dopo 24 ore.",
  "modal.emailVerif.linkExpired.desc": "Per ricevere un nuovo link di verifica alla tua mail, fai l'accesso.",
  "modal.emailVerif.linkExpired.title": "Questo link è scaduto",
  "modal.emailVerif.resend-email-link": "Invia di nuovo l'email di verifica",
  "modal.emailVerif.resend-email.rate-limit": "È stato raggiunto il limite di richieste via e-mail. Riprovare tra 1 minuto.",
  "modal.emailVerif.resend-link": "Invia di nuovo l'email di verifica",
  "modal.emailVerif.title": "Verifica il tuo indirizzo email",
  "modal.finishCreatingAccount.event": "A un evento",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Tutti conoscono HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Inserisci il tuo nome",
  "modal.finishCreatingAccount.friends_family": "Tramite amici, parenti o conoscenti",
  "modal.finishCreatingAccount.hearAboutHE": "Come hai scoperto HomeExchange?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Inserisci il tuo cognome",
  "modal.finishCreatingAccount.other": "Altro",
  "modal.finishCreatingAccount.phone_number": "Numero di telefono",
  "modal.finishCreatingAccount.phone_number.error": "Inserisci il tuo numero di telefono",
  "modal.finishCreatingAccount.pleaseSpecify": "Specifica",
  "modal.finishCreatingAccount.press": "Sulla stampa",
  "modal.finishCreatingAccount.press_online": "Online",
  "modal.finishCreatingAccount.press_print": "Stampa",
  "modal.finishCreatingAccount.radio": "Alla radio",
  "modal.finishCreatingAccount.referral": "Codice invito",
  "modal.finishCreatingAccount.referralCode.error": "Questo codice invito non è valido",
  "modal.finishCreatingAccount.search_engine": "Su un motore di ricerca",
  "modal.finishCreatingAccount.social_media": "Nei social media",
  "modal.finishCreatingAccount.social_network_other": "Altro social network (specificare)",
  "modal.finishCreatingAccount.title": "Completa la creazione del tuo account",
  "modal.finishCreatingAccount.tv": "Alla TV",
  "modal.finishCreatingAccount.tv_ad": "In una pubblicità",
  "modal.finishCreatingAccount.tv_show": "In un reportage / programma televisivo",
  "modal.genericError.desc": "La piattaforma potrebbe essere inattiva o potrebbe esserci un problema temporaneo da parte nostra, quindi riprova. <br> <br>Monitoriamo questi errori automaticamente, ma se il problema persiste non esitare a contattarci all'indirizzo:<br><a>tech@homeexchange.com</a>",
  "modal.genericError.title": "Oops! Qualcosa è andato storto",
  "modal.modifyEmail.callout.desc": "Dopo aver salvato la tua nuova email, verrai disconnesso e riceverai un'email di verifica al tuo nuovo indirizzo.",
  "modal.modifyEmail.callout.title": "Verrai disconnesso",
  "modal.modifyEmail.confirmEmail.title": "Conferma la nuova email",
  "modal.modifyEmail.cta": "Salva la nuova email",
  "modal.modifyEmail.currentEmail.title": "Email attuale",
  "modal.modifyEmail.error.alreadyExists": "Esiste già un account con questo indirizzo email",
  "modal.modifyEmail.error.dontMatch": "Le email non corrispondono",
  "modal.modifyEmail.error.incorrectFormat": "L'indirizzo email non è valido",
  "modal.modifyEmail.error.unfilled": "Inserisci un indirizzo email",
  "modal.modifyEmail.newEmail.title": "Nuova email",
  "modal.modifyEmail.title": "Modifica la tua email",
  "modal.noEmailRecieved.desc": "<b>Non hai ricevuto l'email?</b>Controlla la cartella spam e l'ortografia della tua email prima di richiedere un'altra email di verifica.",
  "modal.noEmailRecieved.error": "Qualcosa è andato storto, per favore riprova più tardi",
  "modal.verifyEmail.emailResent.toast": "Ti abbiamo inviato una nuova email di verifica a <b>{{email}}</b>.",
  "signin-modal.apple.button": "Accedi tramite Google",
  "signin-modal.button": "Accedi",
  "signin-modal.email.button": "Accedi",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Accedi tramite Facebook",
  "signin-modal.no-account": "Non hai ancora un account?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Reimposta la password",
  "signup-modal.accept-cgu": "Creando un account, accetto le",
  "signup-modal.apple.button": "Accedi con Apple",
  "signup-modal.button": "Registrati",
  "signup-modal.cgu.link": "Condizioni Generali di Utilizzo",
  "signup-modal.description": "Scopri un nuovo modo di viaggiare con lo scambio casa: lasciati accogliere in tutto il mondo e risparmia!",
  "signup-modal.email.button": "Registrati con il tuo indirizzo email",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Registrati tramite Facebook",
  "signup-modal.have-an-account": "Hai già un account?"
}, NHe = "Monolocale", RHe = "{{count}} camera da letto", IHe = "{{count}} camere da letto", THe = "", MHe = "{{count}} letto", LHe = "{{count}} letti", WHe = "Adulti", BHe = "Neonati", FHe = "Il tuo calendario è stato aggiornato.", VHe = "Un mese", UHe = "Date esatte", qHe = "Una settimana", HHe = "", GHe = "", KHe = "", JHe = "", ZHe = "Due settimane", YHe = "Annulla", XHe = "Bambini", QHe = "Date", e6e = "Elimina", t6e = "Descrizione", a6e = "Destinazione", o6e = "Fatto!", n6e = "Modifica", r6e = "Qualsiasi tipo di scambio", i6e = "Vasca da bagno", s6e = "Barbecue", l6e = "Bicicletta", c6e = "Automobile", u6e = "Gatto", d6e = "Città", g6e = "Campagna", h6e = "Lavastoviglie", m6e = "Cane", p6e = "Asciugatrice", f6e = "Ascensore", b6e = "Case preferite", _6e = "Camino", v6e = "Appartamento", y6e = "Cortile privato", w6e = "Meno di {{max}} GP", k6e = "da {{min}} GP", x6e = "Tra {{min}} e {{max}} GP", $6e = "Palestra privata", S6e = "Casa", C6e = "Isola o penisola", E6e = "Isolata", z6e = "Idromassaggio", j6e = "Lago", A6e = "Case Collection", O6e = "Montagna", P6e = "{{count}} bagni", D6e = "Altri animali", N6e = "Pianoforte", R6e = "Zona giochi per bambini", I6e = "Prima", T6e = "Scambio reciproco", M6e = "Ricerca inversa", L6e = "Fiume", W6e = "Sulla costa", B6e = "Seconda", F6e = "TV", V6e = "Paese", U6e = "WiFi", q6e = "Filtri", H6e = "Date esatte", G6e = "Un mese in {{date}}", K6e = "Un fine settimana in {{date}}", J6e = "Una settimana in {{date}}", Z6e = "Due settimane in {{date}}", Y6e = "Date flessibili", X6e = "Ospiti", Q6e = "case", eGe = "Ultimo minuto", tGe = "Posizione", aGe = "Modifica", oGe = "Nome", nGe = "Avanti", rGe = "Zero", iGe = "Uno", sGe = "Altro", lGe = "Zero", cGe = "Uno", uGe = "Altro", dGe = "Zero", gGe = "Uno", hGe = "Altro", mGe = "Zero", pGe = "Uno", fGe = "Altro", bGe = "Il formato del numero di telefono non è valido.", _Ge = "Ricevi avvisi via email", vGe = "Salva", yGe = "Nessuna posizione trovata", wGe = "Vedere di più", kGe = "Progetti di viaggio", xGe = "", $Ge = "facoltativo", SGe = {
  "autocomplete.button": "Ricerca",
  "autocomplete.placeholder": "Dove stai andando?",
  bedroomsNumbers_zero: NHe,
  bedroomsNumbers_one: RHe,
  bedroomsNumbers_other: IHe,
  beds_zero: THe,
  beds_one: MHe,
  beds_other: LHe,
  "button.free-signup": "Iscriviti gratis",
  "button.validate": "Convalida",
  "common.try-again": "Prova ancora",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Non deve superare i {{limit}} caratteri",
  "error.reload": "Aggiorna la pagina",
  "error.return-homepage": "Ritorna alla home page",
  "error.subtitle": "Si è verificato un errore e non è stato possibile caricare questa pagina.",
  "error.title": "Si è verificato un errore nella pagina",
  "errors.unable_to_submit.subtitle": "Errore durante l'invio del modulo. Per favore riprova più tardi.",
  "errors.unable_to_submit.title": "Errore: è impossibile inviare",
  "global.back": "Indietro",
  "global.cancel": "Annulla",
  "global.collection.browsehomes": "Sfoglia le case",
  "global.collection.contactus": "Contattaci",
  "global.confirm": "Conferma",
  "global.continue": "Continua",
  "global.getStarted": "Cominciare",
  "global.login": "Accedi",
  "global.select": "Seleziona",
  global_adults: WHe,
  global_babies: BHe,
  global_calendarUpdated_toast: FHe,
  global_calendar_aMonth: VHe,
  global_calendar_exactDates: UHe,
  global_calendar_oneWeek: qHe,
  global_calendar_oneWeekend: HHe,
  global_calendar_plusMinusDay_zero: GHe,
  global_calendar_plusMinusDay_one: KHe,
  global_calendar_plusMinusDay_other: JHe,
  global_calendar_twoWeeks: ZHe,
  global_cancel: YHe,
  global_children: XHe,
  global_dates: QHe,
  global_delete: e6e,
  global_description: t6e,
  global_destination: a6e,
  global_done: o6e,
  global_edit: n6e,
  "global_filter_a-c": "Aria condizionata",
  global_filter_available: r6e,
  "global_filter_baby-bed": "Lettini per bambini",
  "global_filter_baby-gear": "Attrezzature per neonato",
  "global_filter_balcony-terrace": "Balcone/Terrazza",
  global_filter_bathtub: i6e,
  global_filter_bbq: s6e,
  global_filter_bicycle: l6e,
  global_filter_car: c6e,
  global_filter_cat: u6e,
  "global_filter_children-welcome": "Bambini benvenuti",
  global_filter_cities: d6e,
  "global_filter_cleaning-person": "Donna delle pulizie",
  global_filter_countryside: g6e,
  "global_filter_dedicated-workspace": "Spazio di lavoro dedicato",
  "global_filter_disabled-access": "Casa accessibile alle sedie a rotelle",
  global_filter_dishwasher: h6e,
  global_filter_dog: m6e,
  global_filter_dryer: p6e,
  "global_filter_eco-level": "Solo case sostenibili",
  "global_filter_electric-car-plug": "Presa per auto elettrica",
  global_filter_elevator: f6e,
  global_filter_favorite: b6e,
  global_filter_fireplace: _6e,
  global_filter_flat: v6e,
  global_filter_garden: y6e,
  "global_filter_guest-wanted": "Scambio con GuestPoints",
  global_filter_guestPointsMax: w6e,
  global_filter_guestPointsMin: k6e,
  global_filter_guestPointsMinMax: x6e,
  global_filter_gym: $6e,
  "global_filter_heating-system": "Sistema di riscaldamento",
  "global_filter_high-speed-connexion": "Connessione ad alta velocità",
  global_filter_home: S6e,
  "global_filter_home-verified": "Case verificate",
  global_filter_island: C6e,
  global_filter_isolated: E6e,
  global_filter_jacuzzi: z6e,
  "global_filter_kids-toys": "Giocattoli per bambini",
  global_filter_lakes: j6e,
  global_filter_luxury: A6e,
  global_filter_mountains: O6e,
  "global_filter_no-bed-up": "Nessun letto temporaneo",
  global_filter_numOfBathrooms: P6e,
  global_filter_other: D6e,
  "global_filter_parking-space": "Posto auto privato",
  "global_filter_pets-welcome": "Animali domestici ammessi",
  global_filter_piano: N6e,
  global_filter_playground: R6e,
  global_filter_primary: I6e,
  "global_filter_public-transit-access": "Accesso ai trasporti pubblici",
  global_filter_reciprocal: T6e,
  "global_filter_response-rate-above-threshold": "Tasso di risposta ≥ Nella media",
  global_filter_reverse: M6e,
  global_filter_river: L6e,
  global_filter_seaside: W6e,
  global_filter_secondary: B6e,
  "global_filter_secured-pool": "Piscina protetta",
  "global_filter_smokers-welcome": "I fumatori sono i benvenuti",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: F6e,
  global_filter_villages: V6e,
  "global_filter_washing-machine": "Lavatrice",
  "global_filter_whole-unit": "L'intera unità",
  global_filter_wifi: U6e,
  global_filters: q6e,
  global_fixDates: H6e,
  global_flexDates_aMonth: G6e,
  global_flexDates_aWeekend: K6e,
  global_flexDates_oneWeek: J6e,
  global_flexDates_twoWeek: Z6e,
  global_flexibleDates: Y6e,
  global_guests: X6e,
  global_homes: Q6e,
  global_lastMinute: eGe,
  global_location: tGe,
  global_modify: aGe,
  global_name: oGe,
  global_next: nGe,
  global_numberOfAdults_zero: rGe,
  global_numberOfAdults_one: iGe,
  global_numberOfAdults_other: sGe,
  global_numberOfBabies_zero: lGe,
  global_numberOfBabies_one: cGe,
  global_numberOfBabies_other: uGe,
  global_numberOfChildren_zero: dGe,
  global_numberOfChildren_one: gGe,
  global_numberOfChildren_other: hGe,
  global_numberOfGuests_zero: mGe,
  global_numberOfGuests_one: pGe,
  global_numberOfGuests_other: fGe,
  global_phoneNumber_notValid: bGe,
  global_receiveEmailAlerts: _Ge,
  global_save: vGe,
  global_searchBar_noLocationFound: yGe,
  global_seeMore_link: wGe,
  global_travelWishlist: kGe,
  "modal.error-occured.content": "Ci spiace davvero per l'inconveniente, ti chiediamo di riprovare.",
  "modal.error-occured.title": "Oh no, si è verificato un errore!",
  no_result: xGe,
  optional: $Ge,
  "privacy-policy": "Informativa sulla privacy"
}, CGe = "https://www.homeexchange.it/blog/", EGe = "/p/homeexchange-condizioni-di-uso", zGe = "https://www.homeexchange.it/p/comunita", jGe = "https://homeexchangehelp.zendesk.com/hc/it", AGe = "", OGe = "https://www.homeexchange.it/p/service-homeexchange-it", PGe = "https://www.homeexchange.it/p/guestpoints-it", DGe = "https://www.homeexchange.it/p/stampa", NGe = "https://www.homeexchange.com/p/racconti-homeexchangers", RGe = "https://help.homeexchange.com/hc/it/articles/360000623717-Cosa-sono-le-mie-destinazioni-preferite-e-a-cosa-servono", IGe = "", TGe = "https://www.homeexchange.it/p/la-dove-accoglienza-inizia-davvero", MGe = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.it/p/about-us-it",
  blog: CGe,
  cgu: EGe,
  community: zGe,
  "contact-us": "https://www.homeexchange.it/contattaci-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/HomeExchangeIT/",
  faq: jGe,
  forum: AGe,
  guarantees: OGe,
  guestpoints: PGe,
  "happiness-team": "https://www.homeexchange.it/p/happiness-team-it",
  "how-it-works": "https://www.homeexchange.it/p/come-funziona-it",
  "join-us": "https://www.homeexchange.it/p/join-us-it",
  "legal-notice": "/p/avviso-legale",
  "mobile-app": "https://www.homeexchange.it/p/app-mobile",
  "our-team": "https://www.homeexchange.it/p/nostro-team",
  press: DGe,
  "privacy-policy": "/p/homeexchange-informativa-privacy",
  "subscription-cost": "https://www.homeexchange.it/p/subscription-homeexchange-it",
  "term-of-use": "/p/homeexchange-condizioni-di-uso",
  testimonials: NGe,
  travelWishlist_faq_links: RGe,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: IGe,
  values: TGe
}, LGe = "Nome", WGe = "Cognome", BGe = "Aggiungi ai progetti di viaggio", FGe = "Una lista dei tuoi progetti di viaggio aggiornata ti consentirà di ricevere più richieste di scambio reciproco.", VGe = "Vuoi davvero eliminare {{fullAddress}}?", UGe = "Hai selezionato questi filtri. Se hai cambiato idea, puoi eliminarne alcuni qui sotto. Se invece desideri aggiungerne altri, dovrai avviare una nuova ricerca (ma presto non sarà più così... non perderti gli aggiornamenti)!", qGe = "Potrebbe trattarsi di un paese, una città o un'intera regione. Se scegli una zona ampia, i risultati potrebbero essere meno accurati.", HGe = "Digita un paese, una città o una regione", GGe = "Vedi le case disponibili", KGe = "Quando le case disponibili corrispondono ai tuoi progetti di viaggio.", JGe = "Aggiungi ai progetti di viaggio", ZGe = "{{fullAddress}} è stato eliminato dai tuoi progetti di viaggio.", YGe = "Seleziona le date di viaggio ideali (flessibili o fisse).", XGe = "Aggiungi dei dettagli per aiutare gli altri utenti che utilizzano la funzione di ricerca inversa a capire perché ti interessa la loro zona.", QGe = "Specifica quante persone viaggeranno con te.", eKe = "Ops! {{fullAddress}} non è stato salvato nella lista dei tuoi progetti di viaggio per un motivo imprevisto.", tKe = "Facci sapere quando e dove vorresti viaggiare per ricevere richieste di scambio e avvisi non appena saranno disponibili delle case adatte. Salveremo le tue ricerche nella lista dei tuoi progetti di viaggio!", aKe = "Ci sono nuove avventure che vorresti iniziare a pianificare?", oKe = "<updateDates>Aggiorna le tue date</updateDates> per continuare a ricevere gli avvisi pertinenti via mail oppure <delete>elimina questa destinazione</delete> dalla lista dei tuoi progetti di viaggio se hai cambiato idea.", nKe = "Queste date sono già passate", rKe = "{{fullAddress}} è stato aggiunto alla lista dei tuoi progetti di viaggio!", iKe = "{{fullAddress}} è stato aggiornato correttamente.", sKe = "La tua ricerca è stata salvata e il tuo calendario è aggiornato!", lKe = "La tua ricerca è stata salvata. La trovi nella lista dei tuoi progetti di viaggio.", cKe = "Scopri di più sulle liste per i progetti di viaggio", uKe = {
  firstname: LGe,
  lastname: WGe,
  modal_travelWishlist_addNew_title: BGe,
  modal_travelWishlist_delete_body: FGe,
  modal_travelWishlist_delete_title: VGe,
  modal_travelWishlist_filtersApplied_helper: UGe,
  modal_travelWishlist_location_helper: qGe,
  modal_travelWishlist_searchBar_placeholder: HGe,
  page_travelWishlist_card_cta: GGe,
  page_travelWishlist_card_emailAlerts_helper: KGe,
  page_travelWishlist_cta: JGe,
  page_travelWishlist_deleted_toast: ZGe,
  page_travelWishlist_edit_dates_helper: YGe,
  page_travelWishlist_edit_description_helper: XGe,
  page_travelWishlist_edit_guests_helper: QGe,
  page_travelWishlist_error_toast: eKe,
  page_travelWishlist_none_body: tKe,
  page_travelWishlist_none_subheader: aKe,
  page_travelWishlist_pastDates_desc: oKe,
  page_travelWishlist_pastDates_title: nKe,
  page_travelWishlist_saved_toast: rKe,
  page_travelWishlist_updated_toast: iKe,
  search_travelWishlist_calendarUpdated_toast: sKe,
  search_travelWishlist_saved_toast: lKe,
  travelWishlist_faq: cKe
}, dKe = {
  "modal.emailVerif.alreadyVerified.desc": "",
  "modal.emailVerif.alreadyVerified.title": "",
  "modal.emailVerif.callout": "En verifiserings-e-post har blitt sendt til <b>{{email}}</b>.",
  "modal.emailVerif.desc": "Sjekk innboksen din. Lenken i denne e-posten vil utløpe om 24 timer.",
  "modal.emailVerif.linkExpired.desc": "",
  "modal.emailVerif.linkExpired.title": "",
  "modal.emailVerif.resend-email-link": "Send bekreftelsesmeldingen på nytt",
  "modal.emailVerif.resend-email.rate-limit": "Du har nådd grensen for e-postforespørsler. Prøv igjen om 1 minutt.",
  "modal.emailVerif.resend-link": "Send bekreftelsesmeldingen på nytt",
  "modal.emailVerif.title": "Verifiser din e-postadresse",
  "modal.finishCreatingAccount.event": "",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "",
  "modal.finishCreatingAccount.facebook": "",
  "modal.finishCreatingAccount.firstName.error": "",
  "modal.finishCreatingAccount.friends_family": "",
  "modal.finishCreatingAccount.hearAboutHE": "",
  "modal.finishCreatingAccount.instagram": "",
  "modal.finishCreatingAccount.lastName.error": "",
  "modal.finishCreatingAccount.other": "",
  "modal.finishCreatingAccount.phone_number": "Telefonnummer",
  "modal.finishCreatingAccount.phone_number.error": "Skriv inn telefonnummeret",
  "modal.finishCreatingAccount.pleaseSpecify": "",
  "modal.finishCreatingAccount.press": "",
  "modal.finishCreatingAccount.press_online": "",
  "modal.finishCreatingAccount.press_print": "",
  "modal.finishCreatingAccount.radio": "",
  "modal.finishCreatingAccount.referral": "",
  "modal.finishCreatingAccount.referralCode.error": "",
  "modal.finishCreatingAccount.search_engine": "",
  "modal.finishCreatingAccount.social_media": "",
  "modal.finishCreatingAccount.social_network_other": "",
  "modal.finishCreatingAccount.title": "",
  "modal.finishCreatingAccount.tv": "",
  "modal.finishCreatingAccount.tv_ad": "",
  "modal.finishCreatingAccount.tv_show": "",
  "modal.genericError.desc": "",
  "modal.genericError.title": "",
  "modal.modifyEmail.callout.desc": "",
  "modal.modifyEmail.callout.title": "",
  "modal.modifyEmail.confirmEmail.title": "",
  "modal.modifyEmail.cta": "",
  "modal.modifyEmail.currentEmail.title": "",
  "modal.modifyEmail.error.alreadyExists": "",
  "modal.modifyEmail.error.dontMatch": "",
  "modal.modifyEmail.error.incorrectFormat": "",
  "modal.modifyEmail.error.unfilled": "",
  "modal.modifyEmail.newEmail.title": "",
  "modal.modifyEmail.title": "",
  "modal.noEmailRecieved.desc": "",
  "modal.noEmailRecieved.error": "",
  "modal.verifyEmail.emailResent.toast": "Vi har sendt deg en ny e-post for verifisering til <b>{{email}}</b>.",
  "signin-modal.apple.button": "Logg inn med Apple",
  "signin-modal.button": "Logg inn",
  "signin-modal.email.button": "Logg inn",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Logg inn med Facebook",
  "signin-modal.no-account": "Ingen konto ennå?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Tilbakestill passord",
  "signup-modal.accept-cgu": "Ved å opprette en konto, aksepterer jeg",
  "signup-modal.apple.button": "Logg inn med Apple",
  "signup-modal.button": "Registrer deg",
  "signup-modal.cgu.link": "Generelle vilkår for bruk",
  "signup-modal.description": "Oppdag en ny måte å reise på med HomeExchange: bli ønsket velkommen over hele verden og spar penger!",
  "signup-modal.email.button": "Registrer deg med e-postadresse",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Registrer deg med Facebook",
  "signup-modal.have-an-account": "Har du allerede en konto?"
}, gKe = "Studio", hKe = "{{count}} soverom", mKe = "{{count}} soverom", pKe = "", fKe = "{{count}} seng", bKe = "{{count}} senger", _Ke = "Voksne", vKe = "Babyer", yKe = "", wKe = "En måned", kKe = "Nøyaktige datoer", xKe = "Uke", $Ke = "", SKe = "", CKe = "", EKe = "", zKe = "To uker", jKe = "", AKe = "Barn", OKe = "Datoer", PKe = "", DKe = "Beskrivelse", NKe = "Reisemål", RKe = "", IKe = "", TKe = "alle typer boligbytter", MKe = "Badekar", LKe = "Grill", WKe = "Sykkel", BKe = "Bil", FKe = "Katt", VKe = "By", UKe = "Landlig", qKe = "Oppvaskmaskin", HKe = "Hund", GKe = "Tørketrommel", KKe = "Heis", JKe = "Favoritthjem", ZKe = "Peis", YKe = "Leilighet", XKe = "", QKe = "mindre enn {{max}} GP", e5e = "fra {{min}} GP", t5e = "Mellom {{min}} og {{max}} GP", a5e = "Privat treningsrom", o5e = "Hus", n5e = "Øy", r5e = "Isolert", i5e = "Jacuzzi", s5e = "Innsjøer", l5e = "Collection-hjem", c5e = "Fjell", u5e = "", d5e = "Andre dyr", g5e = "Piano", h5e = "", m5e = "Primær", p5e = "Gjensidig boligbytte", f5e = "Omvendt søk", b5e = "Elv", _5e = "", v5e = "Sekundær", y5e = "TV", w5e = "Landsbygd", k5e = "WiFi", x5e = "Filtrer", $5e = "Nøyaktige datoer", S5e = "", C5e = "", E5e = "", z5e = "", j5e = "Fleksible datoer", A5e = "Gjester", O5e = "", P5e = "Siste øyeblikk", D5e = "Beliggenhet", N5e = "", R5e = "", I5e = "", T5e = "", M5e = "", L5e = "", W5e = "", B5e = "", F5e = "", V5e = "", U5e = "", q5e = "", H5e = "", G5e = "", K5e = "", J5e = "", Z5e = "", Y5e = "Lagre", X5e = "", Q5e = "Se mer", e9e = "Reiseplaner", t9e = "", a9e = "", o9e = {
  "autocomplete.button": "Søk",
  "autocomplete.placeholder": "Hvor skal du ?",
  bedroomsNumbers_zero: gKe,
  bedroomsNumbers_one: hKe,
  bedroomsNumbers_other: mKe,
  beds_zero: pKe,
  beds_one: fKe,
  beds_other: bKe,
  "button.free-signup": "Registrer deg gratis",
  "button.validate": "Bekreft",
  "common.try-again": "",
  "contact-tech-email": "contact@homeexchange.com",
  "error.characters_max_limit": "Kan ikke overstige {{limit}} tegn",
  "error.reload": "Oppdater siden",
  "error.return-homepage": "Gå tilbake til startsiden",
  "error.subtitle": "Denne siden kan dessverre ikke nås.",
  "error.title": "En feil har oppstått på siden",
  "errors.unable_to_submit.subtitle": "Skjemaet ditt kunne dessverre ikke sendes inn akkurat nå. Vennligst prøv igjen senere.",
  "errors.unable_to_submit.title": "Oops, det har oppstått et problem",
  "global.back": "Tilbake",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "Fortsett",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_adults: _Ke,
  global_babies: vKe,
  global_calendarUpdated_toast: yKe,
  global_calendar_aMonth: wKe,
  global_calendar_exactDates: kKe,
  global_calendar_oneWeek: xKe,
  global_calendar_oneWeekend: $Ke,
  global_calendar_plusMinusDay_zero: SKe,
  global_calendar_plusMinusDay_one: CKe,
  global_calendar_plusMinusDay_other: EKe,
  global_calendar_twoWeeks: zKe,
  global_cancel: jKe,
  global_children: AKe,
  global_dates: OKe,
  global_delete: PKe,
  global_description: DKe,
  global_destination: NKe,
  global_done: RKe,
  global_edit: IKe,
  "global_filter_a-c": "Klimaanlegg",
  global_filter_available: TKe,
  "global_filter_baby-bed": "Sprinkelsenger",
  "global_filter_baby-gear": "Babyutstyr",
  "global_filter_balcony-terrace": "",
  global_filter_bathtub: MKe,
  global_filter_bbq: LKe,
  global_filter_bicycle: WKe,
  global_filter_car: BKe,
  global_filter_cat: FKe,
  "global_filter_children-welcome": "Barn velkommen",
  global_filter_cities: VKe,
  "global_filter_cleaning-person": "Rengjøringsperson",
  global_filter_countryside: UKe,
  "global_filter_dedicated-workspace": "",
  "global_filter_disabled-access": "Tilgjengelig for funksjonshemmede",
  global_filter_dishwasher: qKe,
  global_filter_dog: HKe,
  global_filter_dryer: GKe,
  "global_filter_eco-level": "Bare bærekraftige hjem",
  "global_filter_electric-car-plug": "Elektrisk bilplugg",
  global_filter_elevator: KKe,
  global_filter_favorite: JKe,
  global_filter_fireplace: ZKe,
  global_filter_flat: YKe,
  global_filter_garden: XKe,
  "global_filter_guest-wanted": "Boligbytte med GuestPoints",
  global_filter_guestPointsMax: QKe,
  global_filter_guestPointsMin: e5e,
  global_filter_guestPointsMinMax: t5e,
  global_filter_gym: a5e,
  "global_filter_heating-system": "Oppvarming",
  "global_filter_high-speed-connexion": "Høyhastighets tilkobling",
  global_filter_home: o5e,
  "global_filter_home-verified": "Verifiserte hjem",
  global_filter_island: n5e,
  global_filter_isolated: r5e,
  global_filter_jacuzzi: i5e,
  "global_filter_kids-toys": "Barneleker",
  global_filter_lakes: s5e,
  global_filter_luxury: l5e,
  global_filter_mountains: c5e,
  "global_filter_no-bed-up": "",
  global_filter_numOfBathrooms: u5e,
  global_filter_other: d5e,
  "global_filter_parking-space": "Privat parkering",
  "global_filter_pets-welcome": "Kjæledyr velkommen",
  global_filter_piano: g5e,
  global_filter_playground: h5e,
  global_filter_primary: m5e,
  "global_filter_public-transit-access": "Tilgang til offentlig transport",
  global_filter_reciprocal: p5e,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: f5e,
  global_filter_river: b5e,
  global_filter_seaside: _5e,
  global_filter_secondary: v5e,
  "global_filter_secured-pool": "Sikret badebasseng",
  "global_filter_smokers-welcome": "Røykere velkommen",
  "global_filter_swimming-pool": "Svømmebasseng",
  global_filter_tv: y5e,
  global_filter_villages: w5e,
  "global_filter_washing-machine": "Vaskemaskin",
  "global_filter_whole-unit": "Hele boligen",
  global_filter_wifi: k5e,
  global_filters: x5e,
  global_fixDates: $5e,
  global_flexDates_aMonth: S5e,
  global_flexDates_aWeekend: C5e,
  global_flexDates_oneWeek: E5e,
  global_flexDates_twoWeek: z5e,
  global_flexibleDates: j5e,
  global_guests: A5e,
  global_homes: O5e,
  global_lastMinute: P5e,
  global_location: D5e,
  global_modify: N5e,
  global_name: R5e,
  global_next: I5e,
  global_numberOfAdults_zero: T5e,
  global_numberOfAdults_one: M5e,
  global_numberOfAdults_other: L5e,
  global_numberOfBabies_zero: W5e,
  global_numberOfBabies_one: B5e,
  global_numberOfBabies_other: F5e,
  global_numberOfChildren_zero: V5e,
  global_numberOfChildren_one: U5e,
  global_numberOfChildren_other: q5e,
  global_numberOfGuests_zero: H5e,
  global_numberOfGuests_one: G5e,
  global_numberOfGuests_other: K5e,
  global_phoneNumber_notValid: J5e,
  global_receiveEmailAlerts: Z5e,
  global_save: Y5e,
  global_searchBar_noLocationFound: X5e,
  global_seeMore_link: Q5e,
  global_travelWishlist: e9e,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: t9e,
  optional: a9e,
  "privacy-policy": "Personvernpolicy"
}, n9e = "https://www.homeexchange.com/blog/", r9e = "/p/general-terms-of-use", i9e = "https://www.homeexchange.com/nb/p/nettverk", s9e = "https://homeexchangehelp.zendesk.com/hc/pt", l9e = "", c9e = "https://www.homeexchange.com/nb/p/service-homeexchange-no", u9e = "https://www.homeexchange.com/nb/p/guestpoints-no", d9e = "https://www.homeexchange.com/nb/p/press-no", g9e = "https://www.homeexchange.com/p/ifolge-homeexchangers", h9e = "", m9e = "", p9e = "https://www.homeexchange.com/nb/p/der-velkomsten-virkelig-starter", f9e = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/nb/p/about-us-no",
  blog: n9e,
  cgu: r9e,
  community: i9e,
  "contact-us": "https://www.homeexchange.com/nb/p/kontact-oss-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: s9e,
  forum: l9e,
  guarantees: c9e,
  guestpoints: u9e,
  "happiness-team": "https://www.homeexchange.com/nb/p/happiness-team-no",
  "how-it-works": "https://www.homeexchange.com/nb/p/hvordan-fungerer-det-no",
  "join-us": "https://www.homeexchange.com/nb/p/join-us-no",
  "legal-notice": "/p/legal-notice-no",
  "mobile-app": "https://www.homeexchange.com/nb/p/mobile-app",
  "our-team": "https://www.homeexchange.com/nb/p/teamet-vart",
  press: d9e,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/nb/p/subscription-homeexchange-no",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: g9e,
  travelWishlist_faq_links: h9e,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: m9e,
  values: p9e
}, b9e = "Fornavn", _9e = "Etternavn", v9e = "", y9e = "", w9e = "", k9e = "", x9e = "", $9e = "", S9e = "Se tilgjengelige hjem", C9e = "", E9e = "", z9e = "", j9e = "", A9e = "", O9e = "", P9e = "", D9e = "", N9e = "", R9e = "", I9e = "", T9e = "", M9e = "", L9e = "", W9e = "", B9e = "", F9e = {
  firstname: b9e,
  lastname: _9e,
  modal_travelWishlist_addNew_title: v9e,
  modal_travelWishlist_delete_body: y9e,
  modal_travelWishlist_delete_title: w9e,
  modal_travelWishlist_filtersApplied_helper: k9e,
  modal_travelWishlist_location_helper: x9e,
  modal_travelWishlist_searchBar_placeholder: $9e,
  page_travelWishlist_card_cta: S9e,
  page_travelWishlist_card_emailAlerts_helper: C9e,
  page_travelWishlist_cta: E9e,
  page_travelWishlist_deleted_toast: z9e,
  page_travelWishlist_edit_dates_helper: j9e,
  page_travelWishlist_edit_description_helper: A9e,
  page_travelWishlist_edit_guests_helper: O9e,
  page_travelWishlist_error_toast: P9e,
  page_travelWishlist_none_body: D9e,
  page_travelWishlist_none_subheader: N9e,
  page_travelWishlist_pastDates_desc: R9e,
  page_travelWishlist_pastDates_title: I9e,
  page_travelWishlist_saved_toast: T9e,
  page_travelWishlist_updated_toast: M9e,
  search_travelWishlist_calendarUpdated_toast: L9e,
  search_travelWishlist_saved_toast: W9e,
  travelWishlist_faq: B9e
}, V9e = {
  "modal.emailVerif.alreadyVerified.desc": "Je e-mailadres is klaar! Log in om verder te gaan.",
  "modal.emailVerif.alreadyVerified.title": "Je e-mailadres is al geverifieerd",
  "modal.emailVerif.callout": "Er is een verificatie-e-mail verzonden naar <b>{{email}}</b>.",
  "modal.emailVerif.desc": "Controleer je inbox. De link in deze e-mail verloopt binnen 24 uur.",
  "modal.emailVerif.linkExpired.desc": "Log in om een nieuwe verificatielink in je inbox te ontvangen.",
  "modal.emailVerif.linkExpired.title": "Deze link is verlopen",
  "modal.emailVerif.resend-email-link": "Verificatie-e-mail opnieuw verzenden",
  "modal.emailVerif.resend-email.rate-limit": "Je hebt de limiet voor e-mailverzoeken bereikt. Probeer het opnieuw over 1 minuut.",
  "modal.emailVerif.resend-link": "Verificatie-e-mail opnieuw verzenden",
  "modal.emailVerif.title": "Verifieer je e-mailadres",
  "modal.finishCreatingAccount.event": "Op een evenement",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Iedereen kent HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Voer je voornaam in",
  "modal.finishCreatingAccount.friends_family": "Via vrienden, familie of kennissen",
  "modal.finishCreatingAccount.hearAboutHE": "Hoe heb je over HomeExchange gehoord?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Voer je achternaam in",
  "modal.finishCreatingAccount.other": "Andere",
  "modal.finishCreatingAccount.phone_number": "Telefoonnummer",
  "modal.finishCreatingAccount.phone_number.error": "Voer je telefoonnummer in",
  "modal.finishCreatingAccount.pleaseSpecify": "Gelieve te specificeren",
  "modal.finishCreatingAccount.press": "In de pers",
  "modal.finishCreatingAccount.press_online": "Online",
  "modal.finishCreatingAccount.press_print": "Gedrukte pers",
  "modal.finishCreatingAccount.radio": "Op de radio",
  "modal.finishCreatingAccount.referral": "Doorverwijzingscode",
  "modal.finishCreatingAccount.referralCode.error": "Deze doorverwijzingscode is ongeldig",
  "modal.finishCreatingAccount.search_engine": "Op een zoekmachine",
  "modal.finishCreatingAccount.social_media": "Via sociale media",
  "modal.finishCreatingAccount.social_network_other": "Ander sociaal netwerk (specificeer)",
  "modal.finishCreatingAccount.title": "Voltooi het aanmaken van je account",
  "modal.finishCreatingAccount.tv": "Op tv",
  "modal.finishCreatingAccount.tv_ad": "Via een advertentie",
  "modal.finishCreatingAccount.tv_show": "Tijdens een reportage/tv-programma",
  "modal.genericError.desc": "Het platform is mogelijk niet beschikbaar of er kan een tijdelijke storing zijn aan onze kant, dus probeer het opnieuw.<br><br> We traceren deze fouten automatisch, maar als het probleem zich blijft voordoen, neem dan gerust contact met ons op:<br><a> tech@homeexchange.com</a>",
  "modal.genericError.title": "Oeps! Er is iets misgegaan",
  "modal.modifyEmail.callout.desc": "Nadat je je nieuwe e-mailadres hebt opgeslagen, word je uitgelogd en ontvang je een verificatie-e-mail op je nieuwe adres.",
  "modal.modifyEmail.callout.title": "Je wordt uitgelogd",
  "modal.modifyEmail.confirmEmail.title": "Bevestig nieuw e-mailadres",
  "modal.modifyEmail.cta": "Nieuw e-mailadres opslaan",
  "modal.modifyEmail.currentEmail.title": "Huidig e-mailadres",
  "modal.modifyEmail.error.alreadyExists": "Dit e-mailadres bestaat al",
  "modal.modifyEmail.error.dontMatch": "E-mailadressen komen niet overeen",
  "modal.modifyEmail.error.incorrectFormat": "Dit e-mailadres is ongeldig",
  "modal.modifyEmail.error.unfilled": "Voer een e-mailadres in",
  "modal.modifyEmail.newEmail.title": "Nieuw e-mailadres",
  "modal.modifyEmail.title": "Wijzig je e-mailadres",
  "modal.noEmailRecieved.desc": "<b>Geen e-mail ontvangen?</b>Controleer je spammap en de spelling van je e-mail voordat je een nieuwe verificatiemail aanvraagt.",
  "modal.noEmailRecieved.error": "Er is iets misgegaan, probeer het later opnieuw",
  "modal.verifyEmail.emailResent.toast": "We hebben je een nieuwe verificatiemail gestuurd naar <b>{{email}}</b>.",
  "signin-modal.apple.button": "Meld je aan zonder Google",
  "signin-modal.button": "Inloggen",
  "signin-modal.email.button": "Inloggen",
  "signin-modal.error.content": "Er is een fout opgetreden",
  "signin-modal.error.email_no_verified.content": "E-mailadres niet geverifieerd",
  "signin-modal.error.email_no_verified.title": "Fout",
  "signin-modal.error.title": "Fout",
  "signin-modal.facebook.button": "Meld je aan zonder Facebook",
  "signin-modal.no-account": "Heb je nog geen account?",
  "signin-modal.reset-password": "Wachtwoord opnieuw instellen",
  "signin-modal.title": "Inloggen",
  "signin.modal.reset-password": "Wachtwoord opnieuw instellen",
  "signup-modal.accept-cgu": "Door een account aan te maken, accepteer ik de",
  "signup-modal.apple.button": "Inloggen met Apple",
  "signup-modal.button": "Inschrijven",
  "signup-modal.cgu.link": "Wettelijke bepalingen",
  "signup-modal.description": "Ontdek een nieuwe manier van reizen met HomeExchange: word overal ter wereld verwelkomd en bespaar geld!",
  "signup-modal.email.button": "Meld je aan met je e-mail adres",
  "signup-modal.email.form.submit": "Registreren",
  "signup-modal.error.content": "Er is een fout opgetreden",
  "signup-modal.error.title": "Fout",
  "signup-modal.facebook.button": "Inloggen met Facebook",
  "signup-modal.have-an-account": "Heb je al een account?"
}, U9e = "Studio", q9e = "{{count}} slaapkamer", H9e = "{{count}} slaapkamers", G9e = "", K9e = "{{count}} bed", J9e = "{{count}} bedden", Z9e = "Volwassenen", Y9e = "Baby's", X9e = "Je kalender is bijgewerkt.", Q9e = "Een maand", e8e = "Exacte data", t8e = "Een week", a8e = "Een weekend", o8e = "", n8e = "± {{count}} dag", r8e = "± {{count}} dagen", i8e = "Twee weken", s8e = "Annuleren", l8e = "Kinderen", c8e = "Data", u8e = "Verwijderen", d8e = "Beschrijving", g8e = "Bestemming", h8e = "Klaar!", m8e = "Bewerken", p8e = "Elk type ruil", f8e = "Bad", b8e = "BBQ", _8e = "Fiets", v8e = "Auto", y8e = "Kat", w8e = "De stad", k8e = "Het platteland", x8e = "Vaatwasmachine", $8e = "Hond", S8e = "Droger", C8e = "Lift", E8e = "Favoriete huizen", z8e = "Open haard", j8e = "Appartement", A8e = "Privétuin", O8e = "Minder dan {{max}} GP", P8e = "vanaf {{min}} GP", D8e = "Tussen {{min}} en {{max}} GP", N8e = "Privésportzaal", R8e = "Huis", I8e = "Een eiland", T8e = "Geïsoleerd", M8e = "Jacuzzi", L8e = "Een meer", W8e = "Collection-huizen", B8e = "De bergen", F8e = "{{count}} badkamers", V8e = "Andere dieren", U8e = "", q8e = "Speeltuin", H8e = "Eerste", G8e = "Wederzijdse huizenruil", K8e = "Omgekeerd zoeken", J8e = "Rivier", Z8e = "Kust", Y8e = "Vakantiehuis", X8e = "TV", Q8e = "Dorp", e7e = "WiFi", t7e = "Filters", a7e = "Vaste data", o7e = "Een maand in {{date}}", n7e = "Een weekend in {{date}}", r7e = "Een week in {{date}}", i7e = "Twee weken in {{date}}", s7e = "Flexibele data", l7e = "Gasten", c7e = "huizen", u7e = "Last minute", d7e = "Locatie", g7e = "Wijzigen", h7e = "Naam", m7e = "Volgende", p7e = "", f7e = "{{count}} volwassene", b7e = "{{count}} volwassenen", _7e = "", v7e = "{{count}} baby", y7e = "{{count}} baby's", w7e = "", k7e = "{{count}} kind", x7e = "{{count}} kinderen", $7e = "", S7e = "{{count}} gast", C7e = "{{count}} gasten", E7e = "De indeling van het telefoonnummer is niet geldig.", z7e = "E-mailmeldingen ontvangen", j7e = "Opslaan", A7e = "Geen locaties gevonden", O7e = "Bekijk meer", P7e = "Reisplannen", D7e = "Geen resultaat", N7e = "optioneel", R7e = {
  "autocomplete.button": "Zoeken",
  "autocomplete.placeholder": "Waar ga je naar toe ?",
  bedroomsNumbers_zero: U9e,
  bedroomsNumbers_one: q9e,
  bedroomsNumbers_other: H9e,
  beds_zero: G9e,
  beds_one: K9e,
  beds_other: J9e,
  "button.free-signup": "Meld je gratis aan",
  "button.validate": "Bevestigen",
  "common.try-again": "Opnieuw proberen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Mag de {{limit}} karakters niet overschrijden",
  "error.reload": "Deze pagina vernieuwen ",
  "error.return-homepage": "Terug naar de startpagina",
  "error.subtitle": "Helaas kon deze pagina niet gevonden worden.",
  "error.title": "Er is een fout opgetreden op de pagina",
  "errors.unable_to_submit.subtitle": "Helaas kon het formulier niet verzonden worden. Probeer het later nog eens.",
  "errors.unable_to_submit.title": "Oeps... het is niet gelukt om het formulier te verzenden.",
  "global.back": "Terug",
  "global.cancel": "Annuleren",
  "global.collection.browsehomes": "Blader door huizen",
  "global.collection.contactus": "Neem contact met ons op",
  "global.confirm": "Bevestigen",
  "global.continue": "Doorgaan",
  "global.getStarted": "Ga van start",
  "global.login": "Inloggen",
  "global.select": "Selecteren",
  global_adults: Z9e,
  global_babies: Y9e,
  global_calendarUpdated_toast: X9e,
  global_calendar_aMonth: Q9e,
  global_calendar_exactDates: e8e,
  global_calendar_oneWeek: t8e,
  global_calendar_oneWeekend: a8e,
  global_calendar_plusMinusDay_zero: o8e,
  global_calendar_plusMinusDay_one: n8e,
  global_calendar_plusMinusDay_other: r8e,
  global_calendar_twoWeeks: i8e,
  global_cancel: s8e,
  global_children: l8e,
  global_dates: c8e,
  global_delete: u8e,
  global_description: d8e,
  global_destination: g8e,
  global_done: h8e,
  global_edit: m8e,
  "global_filter_a-c": "Airco",
  global_filter_available: p8e,
  "global_filter_baby-bed": "Babybedden",
  "global_filter_baby-gear": "Baby spullen",
  "global_filter_balcony-terrace": "",
  global_filter_bathtub: f8e,
  global_filter_bbq: b8e,
  global_filter_bicycle: _8e,
  global_filter_car: v8e,
  global_filter_cat: y8e,
  "global_filter_children-welcome": "Kinderen welkom",
  global_filter_cities: w8e,
  "global_filter_cleaning-person": "Schoonmaakster",
  global_filter_countryside: k8e,
  "global_filter_dedicated-workspace": "Toegewijde werkruimte",
  "global_filter_disabled-access": "Toegankelijke woning",
  global_filter_dishwasher: x8e,
  global_filter_dog: $8e,
  global_filter_dryer: S8e,
  "global_filter_eco-level": "Alleen duurzame woningen",
  "global_filter_electric-car-plug": "Elektrische auto stekker",
  global_filter_elevator: C8e,
  global_filter_favorite: E8e,
  global_filter_fireplace: z8e,
  global_filter_flat: j8e,
  global_filter_garden: A8e,
  "global_filter_guest-wanted": "Ruil tegen GuestPoints",
  global_filter_guestPointsMax: O8e,
  global_filter_guestPointsMin: P8e,
  global_filter_guestPointsMinMax: D8e,
  global_filter_gym: N8e,
  "global_filter_heating-system": "Verwarming",
  "global_filter_high-speed-connexion": "Snelle verbinding",
  global_filter_home: R8e,
  "global_filter_home-verified": "Geverifieerde huizen",
  global_filter_island: I8e,
  global_filter_isolated: T8e,
  global_filter_jacuzzi: M8e,
  "global_filter_kids-toys": "Kinderen speelgoed",
  global_filter_lakes: L8e,
  global_filter_luxury: W8e,
  global_filter_mountains: B8e,
  "global_filter_no-bed-up": "Geen tijdelijke bedden",
  global_filter_numOfBathrooms: F8e,
  global_filter_other: V8e,
  "global_filter_parking-space": "Privé parkeerplaats",
  "global_filter_pets-welcome": "Huisdieren toegestaan ",
  global_filter_piano: U8e,
  global_filter_playground: q8e,
  global_filter_primary: H8e,
  "global_filter_public-transit-access": "Toegang tot het openbaar vervoer",
  global_filter_reciprocal: G8e,
  "global_filter_response-rate-above-threshold": "Responspercentage ≥ Gemiddeld",
  global_filter_reverse: K8e,
  global_filter_river: J8e,
  global_filter_seaside: Z8e,
  global_filter_secondary: Y8e,
  "global_filter_secured-pool": "Beveiligd zwembad",
  "global_filter_smokers-welcome": "Roken toegestaan ",
  "global_filter_swimming-pool": "Zwembad",
  global_filter_tv: X8e,
  global_filter_villages: Q8e,
  "global_filter_washing-machine": "Wasmachine",
  "global_filter_whole-unit": "De hele woning",
  global_filter_wifi: e7e,
  global_filters: t7e,
  global_fixDates: a7e,
  global_flexDates_aMonth: o7e,
  global_flexDates_aWeekend: n7e,
  global_flexDates_oneWeek: r7e,
  global_flexDates_twoWeek: i7e,
  global_flexibleDates: s7e,
  global_guests: l7e,
  global_homes: c7e,
  global_lastMinute: u7e,
  global_location: d7e,
  global_modify: g7e,
  global_name: h7e,
  global_next: m7e,
  global_numberOfAdults_zero: p7e,
  global_numberOfAdults_one: f7e,
  global_numberOfAdults_other: b7e,
  global_numberOfBabies_zero: _7e,
  global_numberOfBabies_one: v7e,
  global_numberOfBabies_other: y7e,
  global_numberOfChildren_zero: w7e,
  global_numberOfChildren_one: k7e,
  global_numberOfChildren_other: x7e,
  global_numberOfGuests_zero: $7e,
  global_numberOfGuests_one: S7e,
  global_numberOfGuests_other: C7e,
  global_phoneNumber_notValid: E7e,
  global_receiveEmailAlerts: z7e,
  global_save: j7e,
  global_searchBar_noLocationFound: A7e,
  global_seeMore_link: O7e,
  global_travelWishlist: P7e,
  "modal.error-occured.content": "Onze excuses voor het ongemak, probeer het alsjeblieft opnieuw.",
  "modal.error-occured.title": "Oh nee, er is een fout opgetreden!",
  no_result: D7e,
  optional: N7e,
  "privacy-policy": "Privacy"
}, I7e = "https://www.homeexchange.com/nl/blog/", T7e = "/nl/p/homeexchangegebruiksvoorwaarden", M7e = "https://www.homeexchange.com/nl/p/gemeenschap", L7e = "https://homeexchangehelp.zendesk.com/hc/en-us", W7e = "https://forum.homeexchange.com/c/english/20", B7e = "https://www.homeexchange.com/nl/p/service-homeexchange-nl", F7e = "https://www.homeexchange.com/nl/p/guestpoints-nl", V7e = "https://www.homeexchange.com/nl/p/pers", U7e = "https://www.homeexchange.com/p/wordsonhomeexchange", q7e = "https://help.homeexchange.com/hc/nl/articles/360000623717-Wat-zijn-Mijn-voorkeursbestemmingen-en-hoe-gebruik-ik-ze", H7e = "https://www.homeexchange.com/nl/p/where-the-welcome-really-begins", G7e = "https://www.guesttoguest.com/nl/p/waar-het-welkom-echt-begint", K7e = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/nl/p/about-us-nl",
  blog: I7e,
  cgu: T7e,
  community: M7e,
  "contact-us": "https://www.homeexchange.com/nl/contact-op-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: L7e,
  forum: W7e,
  guarantees: B7e,
  guestpoints: F7e,
  "happiness-team": "https://www.homeexchange.com/nl/p/happiness-team-nl",
  "how-it-works": "https://www.homeexchange.com/nl/p/hoe-werkt-het-nl",
  "join-us": "https://www.homeexchange.com/nl/p/join-us-nl",
  "legal-notice": "/p/wettelijke-vermeldingen",
  "mobile-app": "https://www.homeexchange.com/nl/p/mobiele-app",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: V7e,
  "privacy-policy": "/p/homeexchange-privacy",
  "subscription-cost": "https://www.homeexchange.com/nl/p/subscription-homeexchange-nl",
  "term-of-use": "/p/homeexchangegebruiksvoorwaarden",
  testimonials: U7e,
  travelWishlist_faq_links: q7e,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: H7e,
  values: G7e
}, J7e = "Voornaam", Z7e = "Achternaam", Y7e = "Een nieuw reisplan toevoegen", X7e = "Met bijgewerkte reisplannen kun je meer wederzijdse uitwisselingsverzoeken ontvangen.", Q7e = "Weet je zeker dat je {{fullAddress}} wilt verwijderen?", eJe = "Dit zijn de filters die je hebt geselecteerd. Als je van gedachten bent veranderd, kun je er hieronder een paar verwijderen. Maar als je extra filters wilt toevoegen, moet je een nieuwe zoekopdracht starten (dit zal binnenkort veranderen...hou het in de gaten)!", tJe = "Dit kan een land, stad of een hele regio zijn. Als je een brede locatie kiest, zijn je resultaten mogelijk minder nauwkeurig.", aJe = "Typ een land, stad of regio", oJe = "Bekijk beschikbare huizen", nJe = "Als er beschikbare huizen zijn die overeenkomen met je reisplannen.", rJe = "Een nieuw reisplan toevoegen", iJe = "{{fullAddress}} is verwijderd uit je reisplannen.", sJe = "Selecteer je ideale reisdata (flexibel of vast).", lJe = "Voeg details toe zodat anderen die de omgekeerde zoekfunctie gebruiken kunnen zien waarom je geïnteresseerd bent in hun locatie.", cJe = "Geef aan hoeveel mensen met je meereizen voor deze reis.", uJe = "Oeps! {{fullAddress}} kon om een onverwachte reden niet worden opgeslagen in je reisplannen.", dJe = "Laat ons weten wanneer en waar je naartoe wilt reizen en ontvang uitwisselingsverzoeken en meldingen zodra er geschikte huizen beschikbaar zijn. We slaan je zoekopdrachten op in je reisplannen!", gJe = "Zijn er nog reisavonturen die je wilt plannen?", hJe = "<updateDates>Werk je data</updateDates> bij om relevante e-mailmeldingen te blijven ontvangen of <delete>verwijder deze bestemming</delete> uit je reisplannen als je het niet langer overweegt.", mJe = "Deze data liggen in het verleden", pJe = "{{fullAddress}} is toegevoegd aan je reisplannen!", fJe = "{{fullAddress}} is succesvol bijgewerkt.", bJe = "Je zoekopdracht is opgeslagen en je kalender is bijgewerkt!", _Je = "Je zoekopdracht is opgeslagen. Je vindt hem in je reisplannen.", vJe = "Meer informatie over reisplannen", yJe = {
  firstname: J7e,
  lastname: Z7e,
  modal_travelWishlist_addNew_title: Y7e,
  modal_travelWishlist_delete_body: X7e,
  modal_travelWishlist_delete_title: Q7e,
  modal_travelWishlist_filtersApplied_helper: eJe,
  modal_travelWishlist_location_helper: tJe,
  modal_travelWishlist_searchBar_placeholder: aJe,
  page_travelWishlist_card_cta: oJe,
  page_travelWishlist_card_emailAlerts_helper: nJe,
  page_travelWishlist_cta: rJe,
  page_travelWishlist_deleted_toast: iJe,
  page_travelWishlist_edit_dates_helper: sJe,
  page_travelWishlist_edit_description_helper: lJe,
  page_travelWishlist_edit_guests_helper: cJe,
  page_travelWishlist_error_toast: uJe,
  page_travelWishlist_none_body: dJe,
  page_travelWishlist_none_subheader: gJe,
  page_travelWishlist_pastDates_desc: hJe,
  page_travelWishlist_pastDates_title: mJe,
  page_travelWishlist_saved_toast: pJe,
  page_travelWishlist_updated_toast: fJe,
  search_travelWishlist_calendarUpdated_toast: bJe,
  search_travelWishlist_saved_toast: _Je,
  travelWishlist_faq: vJe
}, wJe = {
  "modal.emailVerif.alreadyVerified.desc": "",
  "modal.emailVerif.alreadyVerified.title": "",
  "modal.emailVerif.callout": "Foi enviado um e-mail de verificação para <b>{{email}}<br/>.",
  "modal.emailVerif.desc": "",
  "modal.emailVerif.linkExpired.desc": "",
  "modal.emailVerif.linkExpired.title": "",
  "modal.emailVerif.resend-email-link": "",
  "modal.emailVerif.resend-email.rate-limit": "",
  "modal.emailVerif.resend-link": "",
  "modal.emailVerif.title": "",
  "modal.finishCreatingAccount.event": "",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "",
  "modal.finishCreatingAccount.facebook": "",
  "modal.finishCreatingAccount.firstName.error": "",
  "modal.finishCreatingAccount.friends_family": "",
  "modal.finishCreatingAccount.hearAboutHE": "",
  "modal.finishCreatingAccount.instagram": "",
  "modal.finishCreatingAccount.lastName.error": "",
  "modal.finishCreatingAccount.other": "",
  "modal.finishCreatingAccount.phone_number": "",
  "modal.finishCreatingAccount.phone_number.error": "",
  "modal.finishCreatingAccount.pleaseSpecify": "",
  "modal.finishCreatingAccount.press": "",
  "modal.finishCreatingAccount.press_online": "",
  "modal.finishCreatingAccount.press_print": "",
  "modal.finishCreatingAccount.radio": "",
  "modal.finishCreatingAccount.referral": "",
  "modal.finishCreatingAccount.referralCode.error": "",
  "modal.finishCreatingAccount.search_engine": "",
  "modal.finishCreatingAccount.social_media": "",
  "modal.finishCreatingAccount.social_network_other": "",
  "modal.finishCreatingAccount.title": "",
  "modal.finishCreatingAccount.tv": "",
  "modal.finishCreatingAccount.tv_ad": "",
  "modal.finishCreatingAccount.tv_show": "",
  "modal.genericError.desc": "",
  "modal.genericError.title": "",
  "modal.modifyEmail.callout.desc": "",
  "modal.modifyEmail.callout.title": "",
  "modal.modifyEmail.confirmEmail.title": "",
  "modal.modifyEmail.cta": "",
  "modal.modifyEmail.currentEmail.title": "E-mail atual",
  "modal.modifyEmail.error.alreadyExists": "",
  "modal.modifyEmail.error.dontMatch": "",
  "modal.modifyEmail.error.incorrectFormat": "",
  "modal.modifyEmail.error.unfilled": "",
  "modal.modifyEmail.newEmail.title": "",
  "modal.modifyEmail.title": "",
  "modal.noEmailRecieved.desc": "",
  "modal.noEmailRecieved.error": "",
  "modal.verifyEmail.emailResent.toast": "Enviámos-lhe um novo e-mail de verificação para <b>{{email}}<br/>.",
  "signin-modal.apple.button": "Iniciar sessão com a Apple",
  "signin-modal.button": "Iniciar sessão",
  "signin-modal.email.button": "Iniciar sessão",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Iniciar sessão com o Facebook",
  "signin-modal.no-account": "Ainda não tem conta?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Redefinir palavra-passe",
  "signup-modal.accept-cgu": "Ao criar uma conta, eu aceito os",
  "signup-modal.apple.button": "Iniciar sessão com a Apple",
  "signup-modal.button": "Inscreva-se",
  "signup-modal.cgu.link": "Termos Gerais de Utilização",
  "signup-modal.description": "Descubra uma nova forma de viajar com a HomeExchange: sinta-se bem-vindo/a em todo o mundo e poupe dinheiro!",
  "signup-modal.email.button": "Inscreva-se com o seu endereço de e-mail",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Inscreva-se com o Facebook",
  "signup-modal.have-an-account": "Já possui uma conta?"
}, kJe = "Studio", xJe = "{{count}} quarto", $Je = "{{count}} quartos", SJe = "", CJe = "{{count}} cama", EJe = "{{count}} camas", zJe = "", jJe = "", AJe = "O seu calendário foi atualizado.", OJe = "Um mês", PJe = "Datas exatas", DJe = "Uma semana", NJe = "Um fim de semana", RJe = "", IJe = "± {{count}} dia", TJe = "± {{count]] dias", MJe = "Duas semanas", LJe = "Cancelar", WJe = "", BJe = "Datas", FJe = "Eliminar", VJe = "Descrição", UJe = "Destino", qJe = "Feito!", HJe = "Editar", GJe = "Qualquer tipo de pedido de Troca", KJe = "Banheiro", JJe = "BBQ", ZJe = "Bicicleta", YJe = "Carro", XJe = "Gato", QJe = "Cidade", eZe = "Campo", tZe = "Lavadora de louças", aZe = "Cão", oZe = "Secadora", nZe = "Elevador", rZe = "Casas favoritas", iZe = "Lareira", sZe = "Apartamento", lZe = "Quintal privado", cZe = "", uZe = "", dZe = "", gZe = "", hZe = "Casa", mZe = "Ilha", pZe = "Isolada", fZe = "Jacuzzi", bZe = "Lagos", _Ze = "Casas Collection", vZe = "", yZe = "{{count}} casas de banho", wZe = "Outros animais", kZe = "Piano", xZe = "Parque infantil", $Ze = "Principal", SZe = "Troca Reciproca", CZe = "Busca invertida", EZe = "Rio", zZe = "Litoral", jZe = "Secundária", AZe = "TV", OZe = "Aldeia", PZe = "WiFi", DZe = "Filtros", NZe = "Datas fixas", RZe = "Um mês em {{date}}", IZe = "Um fim de semana em {{date}}", TZe = "Uma semana em {{date}}", MZe = "Duas semanas em {{date}}", LZe = "Datas flexíveis", WZe = "Convidados", BZe = "casas", FZe = "Última hora", VZe = "Localização", UZe = "Modificar", qZe = "Nome", HZe = "Seguinte", GZe = "", KZe = "{{count}} adulto", JZe = "{{count}} adultos", ZZe = "", YZe = "{{count}} bebé", XZe = "{{count}} bebés", QZe = "", eYe = "{{count}} criança", tYe = "{{count}} crianças", aYe = "", oYe = "{{count}} convidado", nYe = "{{count}} convidados", rYe = "O formato do número de telefone não é válido.", iYe = "Receber alertas por e-mail", sYe = "Guardar", lYe = "Não foram encontradas localizações", cYe = "Ver mais", uYe = "Ideias de viagens", dYe = "", gYe = "", hYe = {
  "autocomplete.button": "Procurar",
  "autocomplete.placeholder": "Para onde vai ?",
  bedroomsNumbers_zero: kJe,
  bedroomsNumbers_one: xJe,
  bedroomsNumbers_other: $Je,
  beds_zero: SJe,
  beds_one: CJe,
  beds_other: EJe,
  "button.free-signup": "Filie-se gratuitamente",
  "button.validate": "Validar",
  "common.try-again": "",
  "contact-tech-email": "",
  "error.characters_max_limit": "Não deve ser superior a {{limit}} caracteres",
  "error.reload": "Atualizar esta página",
  "error.return-homepage": "Voltar à página inicial",
  "error.subtitle": "Infelizmente, não foi possível aceder a esta página.",
  "error.title": "Ocorreu um erro na página",
  "errors.unable_to_submit.subtitle": "Infelizmente, não foi possível submeter o formulário. Tente novamente mais tarde.",
  "errors.unable_to_submit.title": "Ups, ocorreu um problema!",
  "global.back": "",
  "global.cancel": "",
  "global.collection.browsehomes": "",
  "global.collection.contactus": "",
  "global.confirm": "",
  "global.continue": "",
  "global.getStarted": "",
  "global.login": "",
  "global.select": "",
  global_adults: zJe,
  global_babies: jJe,
  global_calendarUpdated_toast: AJe,
  global_calendar_aMonth: OJe,
  global_calendar_exactDates: PJe,
  global_calendar_oneWeek: DJe,
  global_calendar_oneWeekend: NJe,
  global_calendar_plusMinusDay_zero: RJe,
  global_calendar_plusMinusDay_one: IJe,
  global_calendar_plusMinusDay_other: TJe,
  global_calendar_twoWeeks: MJe,
  global_cancel: LJe,
  global_children: WJe,
  global_dates: BJe,
  global_delete: FJe,
  global_description: VJe,
  global_destination: UJe,
  global_done: qJe,
  global_edit: HJe,
  "global_filter_a-c": "A/C",
  global_filter_available: GJe,
  "global_filter_baby-bed": "",
  "global_filter_baby-gear": "Equipamento para bebês",
  "global_filter_balcony-terrace": "Varanda/Terraço",
  global_filter_bathtub: KJe,
  global_filter_bbq: JJe,
  global_filter_bicycle: ZJe,
  global_filter_car: YJe,
  global_filter_cat: XJe,
  "global_filter_children-welcome": "Crianças bem vindas",
  global_filter_cities: QJe,
  "global_filter_cleaning-person": "Faxineiro",
  global_filter_countryside: eZe,
  "global_filter_dedicated-workspace": "Espaço de trabalho dedicado",
  "global_filter_disabled-access": "Casa acessível",
  global_filter_dishwasher: tZe,
  global_filter_dog: aZe,
  global_filter_dryer: oZe,
  "global_filter_eco-level": "Só casas sustentáveis",
  "global_filter_electric-car-plug": "Tomada para carro elétrico",
  global_filter_elevator: nZe,
  global_filter_favorite: rZe,
  global_filter_fireplace: iZe,
  global_filter_flat: sZe,
  global_filter_garden: lZe,
  "global_filter_guest-wanted": "Troca por GuestPoints",
  global_filter_guestPointsMax: cZe,
  global_filter_guestPointsMin: uZe,
  global_filter_guestPointsMinMax: dZe,
  global_filter_gym: gZe,
  "global_filter_heating-system": "Sistema de aquecimento",
  "global_filter_high-speed-connexion": "Wi-fi de alta velocidade",
  global_filter_home: hZe,
  "global_filter_home-verified": "Casas verificadas",
  global_filter_island: mZe,
  global_filter_isolated: pZe,
  global_filter_jacuzzi: fZe,
  "global_filter_kids-toys": "",
  global_filter_lakes: bZe,
  global_filter_luxury: _Ze,
  global_filter_mountains: vZe,
  "global_filter_no-bed-up": "Sem camas temporárias",
  global_filter_numOfBathrooms: yZe,
  global_filter_other: wZe,
  "global_filter_parking-space": "",
  "global_filter_pets-welcome": "Animais de estimação bem-vindos",
  global_filter_piano: kZe,
  global_filter_playground: xZe,
  global_filter_primary: $Ze,
  "global_filter_public-transit-access": "",
  global_filter_reciprocal: SZe,
  "global_filter_response-rate-above-threshold": "",
  global_filter_reverse: CZe,
  global_filter_river: EZe,
  global_filter_seaside: zZe,
  global_filter_secondary: jZe,
  "global_filter_secured-pool": "Piscina protegida",
  "global_filter_smokers-welcome": "Fumantes bem-vindos",
  "global_filter_swimming-pool": "Piscina",
  global_filter_tv: AZe,
  global_filter_villages: OZe,
  "global_filter_washing-machine": "Máquina de lavar",
  "global_filter_whole-unit": "",
  global_filter_wifi: PZe,
  global_filters: DZe,
  global_fixDates: NZe,
  global_flexDates_aMonth: RZe,
  global_flexDates_aWeekend: IZe,
  global_flexDates_oneWeek: TZe,
  global_flexDates_twoWeek: MZe,
  global_flexibleDates: LZe,
  global_guests: WZe,
  global_homes: BZe,
  global_lastMinute: FZe,
  global_location: VZe,
  global_modify: UZe,
  global_name: qZe,
  global_next: HZe,
  global_numberOfAdults_zero: GZe,
  global_numberOfAdults_one: KZe,
  global_numberOfAdults_other: JZe,
  global_numberOfBabies_zero: ZZe,
  global_numberOfBabies_one: YZe,
  global_numberOfBabies_other: XZe,
  global_numberOfChildren_zero: QZe,
  global_numberOfChildren_one: eYe,
  global_numberOfChildren_other: tYe,
  global_numberOfGuests_zero: aYe,
  global_numberOfGuests_one: oYe,
  global_numberOfGuests_other: nYe,
  global_phoneNumber_notValid: rYe,
  global_receiveEmailAlerts: iYe,
  global_save: sYe,
  global_searchBar_noLocationFound: lYe,
  global_seeMore_link: cYe,
  global_travelWishlist: uYe,
  "modal.error-occured.content": "",
  "modal.error-occured.title": "",
  no_result: dYe,
  optional: gYe,
  "privacy-policy": "Privacidade"
}, mYe = "https://www.homeexchange.com/pt/blog/", pYe = "/p/general-terms-of-use", fYe = "https://www.homeexchange.com/pt/p/a-nossa-comunidade-pt", bYe = "https://homeexchangehelp.zendesk.com/hc/en-us", _Ye = "", vYe = "https://www.homeexchange.com/pt/p/service-homeexchange-pt", yYe = "https://www.homeexchange.com/pt/p/os-guestpoints", wYe = "https://www.homeexchange.com/pt/p/press-pt", kYe = "https://www.homeexchange.com/p/palavras-de-homeexchangers", xYe = "", $Ye = "", SYe = "https://www.homeexchange.com/pt/p/onde-as-boas-vindas-comecam", CYe = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/pt/p/about-us-pt",
  blog: mYe,
  cgu: pYe,
  community: fYe,
  "contact-us": "https://www.homeexchange.com/pt/contactos-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: bYe,
  forum: _Ye,
  guarantees: vYe,
  guestpoints: yYe,
  "happiness-team": "https://www.homeexchange.com/pt/p/happiness-team-pt",
  "how-it-works": "https://www.homeexchange.com/pt/p/como-funciona-homeexchange",
  "join-us": "https://www.homeexchange.com/pt/p/join-us-pt",
  "legal-notice": "/p/mencoes-legais",
  "mobile-app": "https://www.homeexchange.com/pt/p/app-homeexchange",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: wYe,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/pt/p/subscription-homeexchange-pt",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: kYe,
  travelWishlist_faq_links: xYe,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: $Ye,
  values: SYe
}, EYe = "", zYe = "", jYe = "Criar nova ideia de viagem", AYe = "As ideias de viagens atualizadas permitem-lhe receber mais pedidos de trocas recíprocas.", OYe = "Tem a certeza de que pretende eliminar {{fullAddress}}?", PYe = "Estes são os filtros que selecionou. Se tiver mudado de ideias, pode eliminar alguns deles abaixo. Contudo, se quiser adicionar outros filtros, terá de iniciar uma nova pesquisa (contudo, isto será alterado em breve... mantenha-se a par)!", DYe = "Pode ser um país, cidade ou região. Se optar por uma localização mais ampla, os resultados podem ser menos precisos.", NYe = "Escreva um país, cidade ou região", RYe = "Ver casas disponíveis", IYe = "Quando existirem casas com disponibilidade correspondentes aos seus planos de viagem.", TYe = "Criar nova ideia de viagem", MYe = "{{fullAddress}} foi eliminada das suas ideias de viagens.", LYe = "Selecione as suas datas de viagem ideais (flexíveis ou fixas).", WYe = "Adicione detalhes, para ajudar as pessoas que utilizam a funcionalidade de busca invertida a perceber porque tem interesse na respetiva região.", BYe = "Especifique quantas pessoas vão viajar consigo.", FYe = "Ups! Não foi possível guardar {{fullAddress}} nas suas ideias de viagens devido a um motivo inesperado.", VYe = "Diga-nos para onde e quando quer viajar para receber pedidos de troca e alertas quando se tornarem disponíveis casas correspondentes. Vamos guardar estas pesquisas nas suas ideias de viagens!", UYe = "Existem aventuras de viagens que queira começar a planear?", qYe = "<updateDates>Atualize as datas</updateDates> para continuar a receber alertas relevantes por e-mail ou <delete>elimine este destino</delete> das suas ideias de viagens se já não está a considerá-lo.", HYe = "Estas datas já passaram", GYe = "{{fullAddress}} foi adicionada às suas ideias de viagens!", KYe = "{{fullAddress}} foi atualizada com sucesso.", JYe = "A sua pesquisa foi guardada e o calendário foi atualizado!", ZYe = "A sua pesquisa foi guardada. Encontre-a nas suas ideias de viagens.", YYe = "Saiba mais sobre as ideias de viagens", XYe = {
  firstname: EYe,
  lastname: zYe,
  modal_travelWishlist_addNew_title: jYe,
  modal_travelWishlist_delete_body: AYe,
  modal_travelWishlist_delete_title: OYe,
  modal_travelWishlist_filtersApplied_helper: PYe,
  modal_travelWishlist_location_helper: DYe,
  modal_travelWishlist_searchBar_placeholder: NYe,
  page_travelWishlist_card_cta: RYe,
  page_travelWishlist_card_emailAlerts_helper: IYe,
  page_travelWishlist_cta: TYe,
  page_travelWishlist_deleted_toast: MYe,
  page_travelWishlist_edit_dates_helper: LYe,
  page_travelWishlist_edit_description_helper: WYe,
  page_travelWishlist_edit_guests_helper: BYe,
  page_travelWishlist_error_toast: FYe,
  page_travelWishlist_none_body: VYe,
  page_travelWishlist_none_subheader: UYe,
  page_travelWishlist_pastDates_desc: qYe,
  page_travelWishlist_pastDates_title: HYe,
  page_travelWishlist_saved_toast: GYe,
  page_travelWishlist_updated_toast: KYe,
  search_travelWishlist_calendarUpdated_toast: JYe,
  search_travelWishlist_saved_toast: ZYe,
  travelWishlist_faq: YYe
}, QYe = {
  "modal.emailVerif.alreadyVerified.desc": "Din e-post är redo! Logga in för att fortsätta.",
  "modal.emailVerif.alreadyVerified.title": "Din e-postadress har redan verifierats",
  "modal.emailVerif.callout": "Ett verifieringsmail har skickats till <b>{{email}}</b>.",
  "modal.emailVerif.desc": "Kontrollera din inkorg. Länken i det här mailet löper ut om 24 timmar.",
  "modal.emailVerif.linkExpired.desc": "Logga in för att få en ny verifieringslänk till din e-post.",
  "modal.emailVerif.linkExpired.title": "Den här länken har löpt ut",
  "modal.emailVerif.resend-email-link": "Skicka nytt bekräftelsemail",
  "modal.emailVerif.resend-email.rate-limit": "Du har nått gränsen för e-postförfrågningar. Försök igen om 1 minut.",
  "modal.emailVerif.resend-link": "Skicka verifieringsmailet igen",
  "modal.emailVerif.title": "Verifiera din e-postadress",
  "modal.finishCreatingAccount.event": "På ett evenemang",
  "modal.finishCreatingAccount.everyone_knows_homeexchange": "Alla känner till HomeExchange",
  "modal.finishCreatingAccount.facebook": "Facebook",
  "modal.finishCreatingAccount.firstName.error": "Ange ditt förnamn",
  "modal.finishCreatingAccount.friends_family": "Genom vänner, familj eller bekanta",
  "modal.finishCreatingAccount.hearAboutHE": "Hur hörde du talas om HomeExchange?",
  "modal.finishCreatingAccount.instagram": "Instagram",
  "modal.finishCreatingAccount.lastName.error": "Ange ditt efternamn",
  "modal.finishCreatingAccount.other": "Annat",
  "modal.finishCreatingAccount.phone_number": "Telefonnummer",
  "modal.finishCreatingAccount.phone_number.error": "Ange ditt telefonnummer",
  "modal.finishCreatingAccount.pleaseSpecify": "Specificera",
  "modal.finishCreatingAccount.press": "Genom nyhetskanaler",
  "modal.finishCreatingAccount.press_online": "Online",
  "modal.finishCreatingAccount.press_print": "Tryckt media",
  "modal.finishCreatingAccount.radio": "På radion",
  "modal.finishCreatingAccount.referral": "Referenskod",
  "modal.finishCreatingAccount.referralCode.error": "Den här referenskoden är ogiltig",
  "modal.finishCreatingAccount.search_engine": "Från en sökmotor",
  "modal.finishCreatingAccount.social_media": "Via sociala medier",
  "modal.finishCreatingAccount.social_network_other": "Andra sociala medier (vänligen specificera)",
  "modal.finishCreatingAccount.title": "Slutför kontoskapandet",
  "modal.finishCreatingAccount.tv": "På tv",
  "modal.finishCreatingAccount.tv_ad": "Genom en annons",
  "modal.finishCreatingAccount.tv_show": "Under ett reportage/tv-program",
  "modal.genericError.desc": "Plattformen kan vara nere eller så kan det vara ett tillfälligt fel hos oss, vänligen försök igen.<br><br>Vi spårar de här felen automatiskt, men om problemet kvarstår, kontakta oss gärna på:<br><a>tech@homeexchange.com</a>",
  "modal.genericError.title": "Hoppsan! Något gick fel",
  "modal.modifyEmail.callout.desc": "Efter att du har sparat din nya e-post kommer du att loggas ut och får ett verifieringsmail till din nya e-postadress.",
  "modal.modifyEmail.callout.title": "Du kommer att loggas ut",
  "modal.modifyEmail.confirmEmail.title": "Bekräfta ny e-postadress",
  "modal.modifyEmail.cta": "Spara ny e-postadress",
  "modal.modifyEmail.currentEmail.title": "Nuvarande e-postadress",
  "modal.modifyEmail.error.alreadyExists": "Den här e-posten existerar redan",
  "modal.modifyEmail.error.dontMatch": "E-postadresserna matchar inte",
  "modal.modifyEmail.error.incorrectFormat": "Den här e-postadressen är inte giltig",
  "modal.modifyEmail.error.unfilled": "Ange en e-postadress",
  "modal.modifyEmail.newEmail.title": "Ny e-postadress",
  "modal.modifyEmail.title": "Ändra din e-postadress",
  "modal.noEmailRecieved.desc": "<b>Fick du inget e-postmeddelande?</b> Kontrollera din skräppost och stavningen av din e-post innan du begär ett nytt verifieringsmail.",
  "modal.noEmailRecieved.error": "Något gick fel, försök igen senare",
  "modal.verifyEmail.emailResent.toast": "Vi har skickat ett nytt verifieringsmail till dig till <b>{{email}}</b>.",
  "signin-modal.apple.button": "Logga in med Apple",
  "signin-modal.button": "Logga in",
  "signin-modal.email.button": "Logga in",
  "signin-modal.error.content": "",
  "signin-modal.error.email_no_verified.content": "",
  "signin-modal.error.email_no_verified.title": "",
  "signin-modal.error.title": "",
  "signin-modal.facebook.button": "Logga in med Facebook",
  "signin-modal.no-account": "Har du inget konto ännu?",
  "signin-modal.reset-password": "",
  "signin-modal.title": "",
  "signin.modal.reset-password": "Återställ lösenord",
  "signup-modal.accept-cgu": "Genom att skapa ett konto godkänner jag",
  "signup-modal.apple.button": "Logga in med Apple",
  "signup-modal.button": "Registrera dig",
  "signup-modal.cgu.link": "de allmänna villkoren",
  "signup-modal.description": "Upptäck ett nytt sätt att resa med HomeExchange: bli välkomnad över hela världen och spara pengar!",
  "signup-modal.email.button": "Registrera dig med din e-postadress",
  "signup-modal.email.form.submit": "",
  "signup-modal.error.content": "",
  "signup-modal.error.title": "",
  "signup-modal.facebook.button": "Registrera dig med Facebook",
  "signup-modal.have-an-account": "Har du redan ett konto?"
}, eXe = "Studio", tXe = "{{count}} sovrum", aXe = "{{count}} sovrum", oXe = "", nXe = "{{count}} säng", rXe = "{{count}} sängar", iXe = "Vuxna", sXe = "Småbarn", lXe = "Din kalender har uppdaterats.", cXe = "En månad", uXe = "Exakta datum", dXe = "En vecka", gXe = "En helg", hXe = "", mXe = "± {{count}} dag", pXe = "± {{count}} dagar", fXe = "Två veckor", bXe = "Avbryt", _Xe = "Barn", vXe = "Datum", yXe = "Ta bort", wXe = "Beskrivning", kXe = "Resmål", xXe = "Klart!", $Xe = "Ändra", SXe = "Alla typer av hembyten", CXe = "Badkar", EXe = "Grill", zXe = "Cykel", jXe = "Bil", AXe = "Katt", OXe = "Stad", PXe = "Landsbygd", DXe = "Diskmaskin", NXe = "Hund", RXe = "Torktumlare", IXe = "Hiss", TXe = "Favorithem", MXe = "Eldstad", LXe = "Lägenhet", WXe = "Privat trädgård", BXe = "Mindre än {{max}} GP", FXe = "från {{min}} GP", VXe = "Mellan {{min}} och {{max}} GuestPoints", UXe = "Hemmagym", qXe = "Hus", HXe = "Ö", GXe = "Isolerat", KXe = "Jacuzzi", JXe = "Sjö", ZXe = "Collection-hem", YXe = "Berg", XXe = "{{count}} badrum", QXe = "Andra djur", eQe = "Piano", tQe = "Lekplats för barn", aQe = "Primärt", oQe = "Ömsesidigt hembyte", nQe = "Omvänd sökning", rQe = "Älv", iQe = "Kustnära", sQe = "Sekundärt", lQe = "TV", cQe = "By", uQe = "WiFi", dQe = "Filter", gQe = "Fasta datum", hQe = "En månad i {{date}}", mQe = "En helg i {{date}}", pQe = "En vecka i {{date}}", fQe = "Två veckor i {{date}}", bQe = "Flexibla datum", _Qe = "Gäster", vQe = "hem", yQe = "Sista minuten", wQe = "Plats", kQe = "Ändra", xQe = "Namn", $Qe = "Nästa", SQe = "", CQe = "{{count}} vuxen", EQe = "{{count}} vuxna", zQe = "", jQe = "{{count}} bebis", AQe = "{{count}} bebisar", OQe = "", PQe = "{{count}} barn", DQe = "{{count}} barn", NQe = "", RQe = "{{count}} gäst", IQe = "{{count}} gäster", TQe = "Telefonnumrets format är inte giltigt.", MQe = "Få e-postaviseringar", LQe = "Spara", WQe = "Inga resmål hittades", BQe = "Se mer", FQe = "Reselista", VQe = "", UQe = "valfritt", qQe = {
  "autocomplete.button": "Sök",
  "autocomplete.placeholder": "Vart ska du ?",
  bedroomsNumbers_zero: eXe,
  bedroomsNumbers_one: tXe,
  bedroomsNumbers_other: aXe,
  beds_zero: oXe,
  beds_one: nXe,
  beds_other: rXe,
  "button.free-signup": "Registrera dig gratis",
  "button.validate": "Godkänn",
  "common.try-again": "Försök igen",
  "contact-tech-email": "tech@homeexchange.com",
  "error.characters_max_limit": "Får inte överskrida {{limit}} tecken",
  "error.reload": "Ladda om sidan",
  "error.return-homepage": "Gå tillbaka till startsidan",
  "error.subtitle": "Tyvärr kan inte den här sidan nås.",
  "error.title": "Ett fel uppstod på sidan",
  "errors.unable_to_submit.subtitle": "Tyvärr kunde inte ditt formulär skickas in just nu. Vänligen försök igen senare.",
  "errors.unable_to_submit.title": "Hoppsan, vi har stött på ett problem",
  "global.back": "Tillbaka",
  "global.cancel": "Avbryt",
  "global.collection.browsehomes": "Se fler hem",
  "global.collection.contactus": "Kontakta oss",
  "global.confirm": "Bekräfta",
  "global.continue": "Fortsätt",
  "global.getStarted": "Kom igång",
  "global.login": "Logga in",
  "global.select": "Välj",
  global_adults: iXe,
  global_babies: sXe,
  global_calendarUpdated_toast: lXe,
  global_calendar_aMonth: cXe,
  global_calendar_exactDates: uXe,
  global_calendar_oneWeek: dXe,
  global_calendar_oneWeekend: gXe,
  global_calendar_plusMinusDay_zero: hXe,
  global_calendar_plusMinusDay_one: mXe,
  global_calendar_plusMinusDay_other: pXe,
  global_calendar_twoWeeks: fXe,
  global_cancel: bXe,
  global_children: _Xe,
  global_dates: vXe,
  global_delete: yXe,
  global_description: wXe,
  global_destination: kXe,
  global_done: xXe,
  global_edit: $Xe,
  "global_filter_a-c": "Luftkonditionering",
  global_filter_available: SXe,
  "global_filter_baby-bed": "Bebissäng",
  "global_filter_baby-gear": "Barnutrustning",
  "global_filter_balcony-terrace": "Balkong/terrass",
  global_filter_bathtub: CXe,
  global_filter_bbq: EXe,
  global_filter_bicycle: zXe,
  global_filter_car: jXe,
  global_filter_cat: AXe,
  "global_filter_children-welcome": "Barn är välkomna",
  global_filter_cities: OXe,
  "global_filter_cleaning-person": "Städare",
  global_filter_countryside: PXe,
  "global_filter_dedicated-workspace": "Kontor",
  "global_filter_disabled-access": "Tillgängligt hem",
  global_filter_dishwasher: DXe,
  global_filter_dog: NXe,
  global_filter_dryer: RXe,
  "global_filter_eco-level": "Endast hållbara hem",
  "global_filter_electric-car-plug": "Elbilsladdare",
  global_filter_elevator: IXe,
  global_filter_favorite: TXe,
  global_filter_fireplace: MXe,
  global_filter_flat: LXe,
  global_filter_garden: WXe,
  "global_filter_guest-wanted": "Hembyte för GuestPoints",
  global_filter_guestPointsMax: BXe,
  global_filter_guestPointsMin: FXe,
  global_filter_guestPointsMinMax: VXe,
  global_filter_gym: UXe,
  "global_filter_heating-system": "Värmesystem",
  "global_filter_high-speed-connexion": "Bredband med hög hastighet",
  global_filter_home: qXe,
  "global_filter_home-verified": "Verifierade hem",
  global_filter_island: HXe,
  global_filter_isolated: GXe,
  global_filter_jacuzzi: KXe,
  "global_filter_kids-toys": "Barnleksaker",
  global_filter_lakes: JXe,
  global_filter_luxury: ZXe,
  global_filter_mountains: YXe,
  "global_filter_no-bed-up": "Inga tillfälliga sängar",
  global_filter_numOfBathrooms: XXe,
  global_filter_other: QXe,
  "global_filter_parking-space": "Privat parkeringsplats",
  "global_filter_pets-welcome": "Husdjur är välkomna",
  global_filter_piano: eQe,
  global_filter_playground: tQe,
  global_filter_primary: aQe,
  "global_filter_public-transit-access": "Tillgång till kollektivtrafik",
  global_filter_reciprocal: oQe,
  "global_filter_response-rate-above-threshold": "Svarsprocent ≥ Genomsnittlig",
  global_filter_reverse: nQe,
  global_filter_river: rQe,
  global_filter_seaside: iQe,
  global_filter_secondary: sQe,
  "global_filter_secured-pool": "Säker pool",
  "global_filter_smokers-welcome": "Rökning tillåtet",
  "global_filter_swimming-pool": "Pool",
  global_filter_tv: lQe,
  global_filter_villages: cQe,
  "global_filter_washing-machine": "Tvättmaskin",
  "global_filter_whole-unit": "Hela hemmet",
  global_filter_wifi: uQe,
  global_filters: dQe,
  global_fixDates: gQe,
  global_flexDates_aMonth: hQe,
  global_flexDates_aWeekend: mQe,
  global_flexDates_oneWeek: pQe,
  global_flexDates_twoWeek: fQe,
  global_flexibleDates: bQe,
  global_guests: _Qe,
  global_homes: vQe,
  global_lastMinute: yQe,
  global_location: wQe,
  global_modify: kQe,
  global_name: xQe,
  global_next: $Qe,
  global_numberOfAdults_zero: SQe,
  global_numberOfAdults_one: CQe,
  global_numberOfAdults_other: EQe,
  global_numberOfBabies_zero: zQe,
  global_numberOfBabies_one: jQe,
  global_numberOfBabies_other: AQe,
  global_numberOfChildren_zero: OQe,
  global_numberOfChildren_one: PQe,
  global_numberOfChildren_other: DQe,
  global_numberOfGuests_zero: NQe,
  global_numberOfGuests_one: RQe,
  global_numberOfGuests_other: IQe,
  global_phoneNumber_notValid: TQe,
  global_receiveEmailAlerts: MQe,
  global_save: LQe,
  global_searchBar_noLocationFound: WQe,
  global_seeMore_link: BQe,
  global_travelWishlist: FQe,
  "modal.error-occured.content": "Vi ber om ursäkt för det, men försök gärna igen.",
  "modal.error-occured.title": "Hoppsan, ett fel uppstod!",
  no_result: VQe,
  optional: UQe,
  "privacy-policy": "Sekretesspolicy"
}, HQe = "https://www.homeexchange.com/blog/", GQe = "/p/general-terms-of-use", KQe = "https://www.homeexchange.com/sv/p/natverket", JQe = "https://homeexchangehelp.zendesk.com/hc/es", ZQe = "", YQe = "https://www.homeexchange.com/sv/p/service-homeexchange-sv", XQe = "https://www.homeexchange.com/sv/p/guestpoints-sv", QQe = "https://www.homeexchange.com/sv/p/press-sv", eet = "https://www.homeexchange.com/p/medlemmarna-har-ordet", tet = "", aet = "", oet = "https://www.homeexchange.com/sv/p/dar-valkomnandet-borjar", net = {
  "about-calendar": "https://help.homeexchange.com/hc/en-us/articles/360007584998-Everything-you-need-to-know-about-the-calendar",
  "about-us": "https://www.homeexchange.com/sv/p/about-us-sv",
  blog: HQe,
  cgu: GQe,
  community: KQe,
  "contact-us": "https://www.homeexchange.com/sv/kontakta-oss-homeexchange",
  "cookie-policy": "https://www.homeexchange.com/p/our-cookies",
  "facebook-page": "https://www.facebook.com/homeexchangecom/",
  faq: JQe,
  forum: ZQe,
  guarantees: YQe,
  guestpoints: XQe,
  "happiness-team": "https://www.homeexchange.com/sv/p/happiness-team-sv",
  "how-it-works": "https://www.homeexchange.com/sv/p/hur-fungerar-det-sv",
  "join-us": "https://www.homeexchange.com/sv/p/join-us-sv",
  "legal-notice": "/p/juridisk-information",
  "mobile-app": "https://www.homeexchange.com/sv/p/app-mobil",
  "our-team": "https://www.homeexchange.com/p/ourteam",
  press: QQe,
  "privacy-policy": "/p/homeexchange-privacy-policy",
  "subscription-cost": "https://www.homeexchange.com/sv/p/subscription-homeexchange-sv",
  "term-of-use": "/p/general-terms-of-use",
  testimonials: eet,
  travelWishlist_faq_links: tet,
  "twitter-page": "https://twitter.com/HomeExchangecom",
  value: aet,
  values: oet
}, ret = "Förnamn", iet = "Efternamn", set = "Skapa din reselista", cet = "En uppdaterad reselista gör att du kan få fler ömsesidiga hembytesförslag.", uet = "Är du säker på att du vill radera {{fullAddress}}?", det = "Det här är filtren du har valt. Om du har ändrat dig kan du ta bort några av dem nedan. Men om du vill lägga till fler måste du starta en ny sökning (detta kommer dock snart att ändras... håll utkik)!", get = "Det kan vara ett land, en stad eller en hel region. Om du väljer en bred plats kan dina resultat bli mindre exakta.", het = "Ange ett land, en stad eller en region", met = "Visa tillgängliga hem", pet = "När hem med tillgänglighet matchar dina resplaner.", fet = "Skapa din reselista", bet = "{{fullAddress}} har tagits bort från din reselista.", _et = "Välj dina ideala resedatum (flexibla eller fasta).", vet = "Lägg till detaljer för att hjälpa andra som använder funktionen för omvänd sökning att se varför du är intresserad av deras ställe.", yet = "Ange hur många personer som följer med dig på den här resan.", wet = "Hoppsan! {{fullAddress}} kunde inte sparas i din reselista av en oväntad anledning.", ket = "Meddela oss när och vart du vill resa för att få hembytesförslag och aviseringar så snart passande hem blir tillgängliga. Vi sparar dina sökningar i din reselista!", xet = "Har du några reseäventyr du vill börja planera?", $et = "<updateDates>Uppdatera dina datum</updateDates> för att fortsätta få relevanta mejl eller <delete>ta bort det här resmålet</delete>från din reselista om du inte längre vill resa dit.", Cet = "Dessa datum har redan varit", Eet = "{{fullAddress}} har lagts till i din reselista!", zet = "{{fullAddress}} har uppdaterats.", jet = "Din sökning har sparats och din kalender har uppdaterats!", Aet = "Din sökning har sparats. Se den i din reselista.", Oet = "Läs mer om reselistor", Pet = {
  firstname: ret,
  lastname: iet,
  modal_travelWishlist_addNew_title: set,
  modal_travelWishlist_delete_body: cet,
  modal_travelWishlist_delete_title: uet,
  modal_travelWishlist_filtersApplied_helper: det,
  modal_travelWishlist_location_helper: get,
  modal_travelWishlist_searchBar_placeholder: het,
  page_travelWishlist_card_cta: met,
  page_travelWishlist_card_emailAlerts_helper: pet,
  page_travelWishlist_cta: fet,
  page_travelWishlist_deleted_toast: bet,
  page_travelWishlist_edit_dates_helper: _et,
  page_travelWishlist_edit_description_helper: vet,
  page_travelWishlist_edit_guests_helper: yet,
  page_travelWishlist_error_toast: wet,
  page_travelWishlist_none_body: ket,
  page_travelWishlist_none_subheader: xet,
  page_travelWishlist_pastDates_desc: $et,
  page_travelWishlist_pastDates_title: Cet,
  page_travelWishlist_saved_toast: Eet,
  page_travelWishlist_updated_toast: zet,
  search_travelWishlist_calendarUpdated_toast: jet,
  search_travelWishlist_saved_toast: Aet,
  travelWishlist_faq: Oet
}, Det = "en", Wk = JDe({
  fallbackLng: Det,
  debug: !1,
  interpolation: {
    escapeValue: !1
  },
  returnEmptyString: !1,
  resources: {
    da: {
      auth: ZDe,
      common: FRe,
      user: EIe,
      links: tIe
    },
    de: {
      auth: zIe,
      common: yMe,
      user: rLe,
      links: DMe
    },
    en: {
      auth: iLe,
      common: XWe,
      user: T2e,
      links: d2e
    },
    es: {
      auth: M2e,
      common: AFe,
      user: pVe,
      links: VFe
    },
    fr: {
      auth: fVe,
      common: l4e,
      user: G4e,
      links: w4e
    },
    hr: {
      auth: K4e,
      common: Gqe,
      user: PHe,
      links: iHe
    },
    it: {
      auth: DHe,
      common: SGe,
      user: uKe,
      links: MGe
    },
    nb: {
      auth: dKe,
      common: o9e,
      user: F9e,
      links: f9e
    },
    nl: {
      auth: V9e,
      common: R7e,
      user: yJe,
      links: K7e
    },
    pt: {
      auth: wJe,
      common: hYe,
      user: XYe,
      links: CYe
    },
    sv: {
      auth: QYe,
      common: qQe,
      user: Pet,
      links: net
    }
  }
});
Wk.init();
const Cn = Wk, Net = ne.createContext(null);
Net.displayName = "HookFormContext";
typeof window < "u" ? ne.useLayoutEffect : ne.useEffect;
function F(e, t, a) {
  function o(s, l) {
    var c;
    Object.defineProperty(s, "_zod", {
      value: s._zod ?? {},
      enumerable: !1
    }), (c = s._zod).traits ?? (c.traits = /* @__PURE__ */ new Set()), s._zod.traits.add(e), t(s, l);
    for (const u in i.prototype)
      u in s || Object.defineProperty(s, u, { value: i.prototype[u].bind(s) });
    s._zod.constr = i, s._zod.def = l;
  }
  const n = a?.Parent ?? Object;
  class r extends n {
  }
  Object.defineProperty(r, "name", { value: e });
  function i(s) {
    var l;
    const c = a?.Parent ? new r() : this;
    o(c, s), (l = c._zod).deferred ?? (l.deferred = []);
    for (const u of c._zod.deferred)
      u();
    return c;
  }
  return Object.defineProperty(i, "init", { value: o }), Object.defineProperty(i, Symbol.hasInstance, {
    value: (s) => a?.Parent && s instanceof a.Parent ? !0 : s?._zod?.traits?.has(e)
  }), Object.defineProperty(i, "name", { value: e }), i;
}
class qo extends Error {
  constructor() {
    super("Encountered Promise during synchronous parse. Use .parseAsync() instead.");
  }
}
class Bk extends Error {
  constructor(t) {
    super(`Encountered unidirectional transform during encode: ${t}`), this.name = "ZodEncodeError";
  }
}
const Fk = {};
function uo(e) {
  return Fk;
}
function Ret(e) {
  const t = Object.values(e).filter((a) => typeof a == "number");
  return Object.entries(e).filter(([a, o]) => t.indexOf(+a) === -1).map(([a, o]) => o);
}
function tu(e, t) {
  return typeof t == "bigint" ? t.toString() : t;
}
function Bd(e) {
  return {
    get value() {
      {
        const t = e();
        return Object.defineProperty(this, "value", { value: t }), t;
      }
    }
  };
}
function Fd(e) {
  return e == null;
}
function Vd(e) {
  const t = e.startsWith("^") ? 1 : 0, a = e.endsWith("$") ? e.length - 1 : e.length;
  return e.slice(t, a);
}
const Ap = Symbol("evaluating");
function Re(e, t, a) {
  let o;
  Object.defineProperty(e, t, {
    get() {
      if (o !== Ap)
        return o === void 0 && (o = Ap, o = a()), o;
    },
    set(n) {
      Object.defineProperty(e, t, {
        value: n
        // configurable: true,
      });
    },
    configurable: !0
  });
}
function Iet(e) {
  return Object.create(Object.getPrototypeOf(e), Object.getOwnPropertyDescriptors(e));
}
function La(e, t, a) {
  Object.defineProperty(e, t, {
    value: a,
    writable: !0,
    enumerable: !0,
    configurable: !0
  });
}
function gn(...e) {
  const t = {};
  for (const a of e) {
    const o = Object.getOwnPropertyDescriptors(a);
    Object.assign(t, o);
  }
  return Object.defineProperties({}, t);
}
function Op(e) {
  return JSON.stringify(e);
}
const Vk = "captureStackTrace" in Error ? Error.captureStackTrace : (...e) => {
};
function ts(e) {
  return typeof e == "object" && e !== null && !Array.isArray(e);
}
const Tet = Bd(() => {
  if (typeof navigator < "u" && navigator?.userAgent?.includes("Cloudflare"))
    return !1;
  try {
    const e = Function;
    return new e(""), !0;
  } catch {
    return !1;
  }
});
function Gn(e) {
  if (ts(e) === !1)
    return !1;
  const t = e.constructor;
  if (t === void 0)
    return !0;
  const a = t.prototype;
  return !(ts(a) === !1 || Object.prototype.hasOwnProperty.call(a, "isPrototypeOf") === !1);
}
function Uk(e) {
  return Gn(e) ? { ...e } : Array.isArray(e) ? [...e] : e;
}
const Met = /* @__PURE__ */ new Set(["string", "number", "symbol"]);
function an(e) {
  return e.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
}
function Wa(e, t, a) {
  const o = new e._zod.constr(t ?? e._zod.def);
  return (!t || a?.parent) && (o._zod.parent = e), o;
}
function re(e) {
  const t = e;
  if (!t)
    return {};
  if (typeof t == "string")
    return { error: () => t };
  if (t?.message !== void 0) {
    if (t?.error !== void 0)
      throw new Error("Cannot specify both `message` and `error` params");
    t.error = t.message;
  }
  return delete t.message, typeof t.error == "string" ? { ...t, error: () => t.error } : t;
}
function Let(e) {
  return Object.keys(e).filter((t) => e[t]._zod.optin === "optional" && e[t]._zod.optout === "optional");
}
function Wet(e, t) {
  const a = e._zod.def, o = gn(e._zod.def, {
    get shape() {
      const n = {};
      for (const r in t) {
        if (!(r in a.shape))
          throw new Error(`Unrecognized key: "${r}"`);
        t[r] && (n[r] = a.shape[r]);
      }
      return La(this, "shape", n), n;
    },
    checks: []
  });
  return Wa(e, o);
}
function Bet(e, t) {
  const a = e._zod.def, o = gn(e._zod.def, {
    get shape() {
      const n = { ...e._zod.def.shape };
      for (const r in t) {
        if (!(r in a.shape))
          throw new Error(`Unrecognized key: "${r}"`);
        t[r] && delete n[r];
      }
      return La(this, "shape", n), n;
    },
    checks: []
  });
  return Wa(e, o);
}
function Fet(e, t) {
  if (!Gn(t))
    throw new Error("Invalid input to extend: expected a plain object");
  const a = e._zod.def.checks;
  if (a && a.length > 0)
    throw new Error("Object schemas containing refinements cannot be extended. Use `.safeExtend()` instead.");
  const o = gn(e._zod.def, {
    get shape() {
      const n = { ...e._zod.def.shape, ...t };
      return La(this, "shape", n), n;
    },
    checks: []
  });
  return Wa(e, o);
}
function Vet(e, t) {
  if (!Gn(t))
    throw new Error("Invalid input to safeExtend: expected a plain object");
  const a = {
    ...e._zod.def,
    get shape() {
      const o = { ...e._zod.def.shape, ...t };
      return La(this, "shape", o), o;
    },
    checks: e._zod.def.checks
  };
  return Wa(e, a);
}
function Uet(e, t) {
  const a = gn(e._zod.def, {
    get shape() {
      const o = { ...e._zod.def.shape, ...t._zod.def.shape };
      return La(this, "shape", o), o;
    },
    get catchall() {
      return t._zod.def.catchall;
    },
    checks: []
    // delete existing checks
  });
  return Wa(e, a);
}
function qet(e, t, a) {
  const o = gn(t._zod.def, {
    get shape() {
      const n = t._zod.def.shape, r = { ...n };
      if (a)
        for (const i in a) {
          if (!(i in n))
            throw new Error(`Unrecognized key: "${i}"`);
          a[i] && (r[i] = e ? new e({
            type: "optional",
            innerType: n[i]
          }) : n[i]);
        }
      else
        for (const i in n)
          r[i] = e ? new e({
            type: "optional",
            innerType: n[i]
          }) : n[i];
      return La(this, "shape", r), r;
    },
    checks: []
  });
  return Wa(t, o);
}
function Het(e, t, a) {
  const o = gn(t._zod.def, {
    get shape() {
      const n = t._zod.def.shape, r = { ...n };
      if (a)
        for (const i in a) {
          if (!(i in r))
            throw new Error(`Unrecognized key: "${i}"`);
          a[i] && (r[i] = new e({
            type: "nonoptional",
            innerType: n[i]
          }));
        }
      else
        for (const i in n)
          r[i] = new e({
            type: "nonoptional",
            innerType: n[i]
          });
      return La(this, "shape", r), r;
    },
    checks: []
  });
  return Wa(t, o);
}
function Lo(e, t = 0) {
  if (e.aborted === !0)
    return !0;
  for (let a = t; a < e.issues.length; a++)
    if (e.issues[a]?.continue !== !0)
      return !0;
  return !1;
}
function qk(e, t) {
  return t.map((a) => {
    var o;
    return (o = a).path ?? (o.path = []), a.path.unshift(e), a;
  });
}
function qr(e) {
  return typeof e == "string" ? e : e?.message;
}
function go(e, t, a) {
  const o = { ...e, path: e.path ?? [] };
  if (!e.message) {
    const n = qr(e.inst?._zod.def?.error?.(e)) ?? qr(t?.error?.(e)) ?? qr(a.customError?.(e)) ?? qr(a.localeError?.(e)) ?? "Invalid input";
    o.message = n;
  }
  return delete o.inst, delete o.continue, t?.reportInput || delete o.input, o;
}
function Ud(e) {
  return Array.isArray(e) ? "array" : typeof e == "string" ? "string" : "unknown";
}
function Kn(...e) {
  const [t, a, o] = e;
  return typeof t == "string" ? {
    message: t,
    code: "custom",
    input: a,
    inst: o
  } : { ...t };
}
const Hk = (e, t) => {
  e.name = "$ZodError", Object.defineProperty(e, "_zod", {
    value: e._zod,
    enumerable: !1
  }), Object.defineProperty(e, "issues", {
    value: t,
    enumerable: !1
  }), e.message = JSON.stringify(t, tu, 2), Object.defineProperty(e, "toString", {
    value: () => e.message,
    enumerable: !1
  });
}, Gk = F("$ZodError", Hk), Kk = F("$ZodError", Hk, { Parent: Error });
function Get(e, t = (a) => a.message) {
  const a = {}, o = [];
  for (const n of e.issues)
    n.path.length > 0 ? (a[n.path[0]] = a[n.path[0]] || [], a[n.path[0]].push(t(n))) : o.push(t(n));
  return { formErrors: o, fieldErrors: a };
}
function Ket(e, t) {
  const a = t || function(r) {
    return r.message;
  }, o = { _errors: [] }, n = (r) => {
    for (const i of r.issues)
      if (i.code === "invalid_union" && i.errors.length)
        i.errors.map((s) => n({ issues: s }));
      else if (i.code === "invalid_key")
        n({ issues: i.issues });
      else if (i.code === "invalid_element")
        n({ issues: i.issues });
      else if (i.path.length === 0)
        o._errors.push(a(i));
      else {
        let s = o, l = 0;
        for (; l < i.path.length; ) {
          const c = i.path[l];
          l === i.path.length - 1 ? (s[c] = s[c] || { _errors: [] }, s[c]._errors.push(a(i))) : s[c] = s[c] || { _errors: [] }, s = s[c], l++;
        }
      }
  };
  return n(e), o;
}
const qd = (e) => (t, a, o, n) => {
  const r = o ? Object.assign(o, { async: !1 }) : { async: !1 }, i = t._zod.run({ value: a, issues: [] }, r);
  if (i instanceof Promise)
    throw new qo();
  if (i.issues.length) {
    const s = new (n?.Err ?? e)(i.issues.map((l) => go(l, r, uo())));
    throw Vk(s, n?.callee), s;
  }
  return i.value;
}, Hd = (e) => async (t, a, o, n) => {
  const r = o ? Object.assign(o, { async: !0 }) : { async: !0 };
  let i = t._zod.run({ value: a, issues: [] }, r);
  if (i instanceof Promise && (i = await i), i.issues.length) {
    const s = new (n?.Err ?? e)(i.issues.map((l) => go(l, r, uo())));
    throw Vk(s, n?.callee), s;
  }
  return i.value;
}, Ks = (e) => (t, a, o) => {
  const n = o ? { ...o, async: !1 } : { async: !1 }, r = t._zod.run({ value: a, issues: [] }, n);
  if (r instanceof Promise)
    throw new qo();
  return r.issues.length ? {
    success: !1,
    error: new (e ?? Gk)(r.issues.map((i) => go(i, n, uo())))
  } : { success: !0, data: r.value };
}, Jet = /* @__PURE__ */ Ks(Kk), Js = (e) => async (t, a, o) => {
  const n = o ? Object.assign(o, { async: !0 }) : { async: !0 };
  let r = t._zod.run({ value: a, issues: [] }, n);
  return r instanceof Promise && (r = await r), r.issues.length ? {
    success: !1,
    error: new e(r.issues.map((i) => go(i, n, uo())))
  } : { success: !0, data: r.value };
}, Zet = /* @__PURE__ */ Js(Kk), Yet = (e) => (t, a, o) => {
  const n = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return qd(e)(t, a, n);
}, Xet = (e) => (t, a, o) => qd(e)(t, a, o), Qet = (e) => async (t, a, o) => {
  const n = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return Hd(e)(t, a, n);
}, ett = (e) => async (t, a, o) => Hd(e)(t, a, o), ttt = (e) => (t, a, o) => {
  const n = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return Ks(e)(t, a, n);
}, att = (e) => (t, a, o) => Ks(e)(t, a, o), ott = (e) => async (t, a, o) => {
  const n = o ? Object.assign(o, { direction: "backward" }) : { direction: "backward" };
  return Js(e)(t, a, n);
}, ntt = (e) => async (t, a, o) => Js(e)(t, a, o), rtt = /^[cC][^\s-]{8,}$/, itt = /^[0-9a-z]+$/, stt = /^[0-9A-HJKMNP-TV-Za-hjkmnp-tv-z]{26}$/, ltt = /^[0-9a-vA-V]{20}$/, ctt = /^[A-Za-z0-9]{27}$/, utt = /^[a-zA-Z0-9_-]{21}$/, dtt = /^P(?:(\d+W)|(?!.*W)(?=\d|T\d)(\d+Y)?(\d+M)?(\d+D)?(T(?=\d)(\d+H)?(\d+M)?(\d+([.,]\d+)?S)?)?)$/, gtt = /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12})$/, Pp = (e) => e ? new RegExp(`^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-${e}[0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12})$`) : /^([0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[1-8][0-9a-fA-F]{3}-[89abAB][0-9a-fA-F]{3}-[0-9a-fA-F]{12}|00000000-0000-0000-0000-000000000000|ffffffff-ffff-ffff-ffff-ffffffffffff)$/, htt = /^(?!\.)(?!.*\.\.)([A-Za-z0-9_'+\-\.]*)[A-Za-z0-9_+-]@([A-Za-z0-9][A-Za-z0-9\-]*\.)+[A-Za-z]{2,}$/, mtt = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
function ptt() {
  return new RegExp(mtt, "u");
}
const ftt = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, btt = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:))$/, _tt = /^((25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\/([0-9]|[1-2][0-9]|3[0-2])$/, vtt = /^(([0-9a-fA-F]{1,4}:){7}[0-9a-fA-F]{1,4}|::|([0-9a-fA-F]{1,4})?::([0-9a-fA-F]{1,4}:?){0,6})\/(12[0-8]|1[01][0-9]|[1-9]?[0-9])$/, ytt = /^$|^(?:[0-9a-zA-Z+/]{4})*(?:(?:[0-9a-zA-Z+/]{2}==)|(?:[0-9a-zA-Z+/]{3}=))?$/, Jk = /^[A-Za-z0-9_-]*$/, wtt = /^(?=.{1,253}\.?$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,61}[a-zA-Z0-9])?(?:\.[a-zA-Z0-9](?:[-0-9a-zA-Z]{0,61}[0-9a-zA-Z])?)*\.?$/, ktt = /^\+(?:[0-9]){6,14}[0-9]$/, Zk = "(?:(?:\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-(?:(?:0[13578]|1[02])-(?:0[1-9]|[12]\\d|3[01])|(?:0[469]|11)-(?:0[1-9]|[12]\\d|30)|(?:02)-(?:0[1-9]|1\\d|2[0-8])))", xtt = /* @__PURE__ */ new RegExp(`^${Zk}$`);
function Yk(e) {
  const t = "(?:[01]\\d|2[0-3]):[0-5]\\d";
  return typeof e.precision == "number" ? e.precision === -1 ? `${t}` : e.precision === 0 ? `${t}:[0-5]\\d` : `${t}:[0-5]\\d\\.\\d{${e.precision}}` : `${t}(?::[0-5]\\d(?:\\.\\d+)?)?`;
}
function $tt(e) {
  return new RegExp(`^${Yk(e)}$`);
}
function Stt(e) {
  const t = Yk({ precision: e.precision }), a = ["Z"];
  e.local && a.push(""), e.offset && a.push("([+-](?:[01]\\d|2[0-3]):[0-5]\\d)");
  const o = `${t}(?:${a.join("|")})`;
  return new RegExp(`^${Zk}T(?:${o})$`);
}
const Ctt = (e) => {
  const t = e ? `[\\s\\S]{${e?.minimum ?? 0},${e?.maximum ?? ""}}` : "[\\s\\S]*";
  return new RegExp(`^${t}$`);
}, Ett = /^[^A-Z]*$/, ztt = /^[^a-z]*$/, ra = /* @__PURE__ */ F("$ZodCheck", (e, t) => {
  var a;
  e._zod ?? (e._zod = {}), e._zod.def = t, (a = e._zod).onattach ?? (a.onattach = []);
}), jtt = /* @__PURE__ */ F("$ZodCheckMaxLength", (e, t) => {
  var a;
  ra.init(e, t), (a = e._zod.def).when ?? (a.when = (o) => {
    const n = o.value;
    return !Fd(n) && n.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const n = o._zod.bag.maximum ?? Number.POSITIVE_INFINITY;
    t.maximum < n && (o._zod.bag.maximum = t.maximum);
  }), e._zod.check = (o) => {
    const n = o.value;
    if (n.length <= t.maximum)
      return;
    const r = Ud(n);
    o.issues.push({
      origin: r,
      code: "too_big",
      maximum: t.maximum,
      inclusive: !0,
      input: n,
      inst: e,
      continue: !t.abort
    });
  };
}), Att = /* @__PURE__ */ F("$ZodCheckMinLength", (e, t) => {
  var a;
  ra.init(e, t), (a = e._zod.def).when ?? (a.when = (o) => {
    const n = o.value;
    return !Fd(n) && n.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const n = o._zod.bag.minimum ?? Number.NEGATIVE_INFINITY;
    t.minimum > n && (o._zod.bag.minimum = t.minimum);
  }), e._zod.check = (o) => {
    const n = o.value;
    if (n.length >= t.minimum)
      return;
    const r = Ud(n);
    o.issues.push({
      origin: r,
      code: "too_small",
      minimum: t.minimum,
      inclusive: !0,
      input: n,
      inst: e,
      continue: !t.abort
    });
  };
}), Ott = /* @__PURE__ */ F("$ZodCheckLengthEquals", (e, t) => {
  var a;
  ra.init(e, t), (a = e._zod.def).when ?? (a.when = (o) => {
    const n = o.value;
    return !Fd(n) && n.length !== void 0;
  }), e._zod.onattach.push((o) => {
    const n = o._zod.bag;
    n.minimum = t.length, n.maximum = t.length, n.length = t.length;
  }), e._zod.check = (o) => {
    const n = o.value, r = n.length;
    if (r === t.length)
      return;
    const i = Ud(n), s = r > t.length;
    o.issues.push({
      origin: i,
      ...s ? { code: "too_big", maximum: t.length } : { code: "too_small", minimum: t.length },
      inclusive: !0,
      exact: !0,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Zs = /* @__PURE__ */ F("$ZodCheckStringFormat", (e, t) => {
  var a, o;
  ra.init(e, t), e._zod.onattach.push((n) => {
    const r = n._zod.bag;
    r.format = t.format, t.pattern && (r.patterns ?? (r.patterns = /* @__PURE__ */ new Set()), r.patterns.add(t.pattern));
  }), t.pattern ? (a = e._zod).check ?? (a.check = (n) => {
    t.pattern.lastIndex = 0, !t.pattern.test(n.value) && n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: t.format,
      input: n.value,
      ...t.pattern ? { pattern: t.pattern.toString() } : {},
      inst: e,
      continue: !t.abort
    });
  }) : (o = e._zod).check ?? (o.check = () => {
  });
}), Ptt = /* @__PURE__ */ F("$ZodCheckRegex", (e, t) => {
  Zs.init(e, t), e._zod.check = (a) => {
    t.pattern.lastIndex = 0, !t.pattern.test(a.value) && a.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "regex",
      input: a.value,
      pattern: t.pattern.toString(),
      inst: e,
      continue: !t.abort
    });
  };
}), Dtt = /* @__PURE__ */ F("$ZodCheckLowerCase", (e, t) => {
  t.pattern ?? (t.pattern = Ett), Zs.init(e, t);
}), Ntt = /* @__PURE__ */ F("$ZodCheckUpperCase", (e, t) => {
  t.pattern ?? (t.pattern = ztt), Zs.init(e, t);
}), Rtt = /* @__PURE__ */ F("$ZodCheckIncludes", (e, t) => {
  ra.init(e, t);
  const a = an(t.includes), o = new RegExp(typeof t.position == "number" ? `^.{${t.position}}${a}` : a);
  t.pattern = o, e._zod.onattach.push((n) => {
    const r = n._zod.bag;
    r.patterns ?? (r.patterns = /* @__PURE__ */ new Set()), r.patterns.add(o);
  }), e._zod.check = (n) => {
    n.value.includes(t.includes, t.position) || n.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "includes",
      includes: t.includes,
      input: n.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Itt = /* @__PURE__ */ F("$ZodCheckStartsWith", (e, t) => {
  ra.init(e, t);
  const a = new RegExp(`^${an(t.prefix)}.*`);
  t.pattern ?? (t.pattern = a), e._zod.onattach.push((o) => {
    const n = o._zod.bag;
    n.patterns ?? (n.patterns = /* @__PURE__ */ new Set()), n.patterns.add(a);
  }), e._zod.check = (o) => {
    o.value.startsWith(t.prefix) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "starts_with",
      prefix: t.prefix,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Ttt = /* @__PURE__ */ F("$ZodCheckEndsWith", (e, t) => {
  ra.init(e, t);
  const a = new RegExp(`.*${an(t.suffix)}$`);
  t.pattern ?? (t.pattern = a), e._zod.onattach.push((o) => {
    const n = o._zod.bag;
    n.patterns ?? (n.patterns = /* @__PURE__ */ new Set()), n.patterns.add(a);
  }), e._zod.check = (o) => {
    o.value.endsWith(t.suffix) || o.issues.push({
      origin: "string",
      code: "invalid_format",
      format: "ends_with",
      suffix: t.suffix,
      input: o.value,
      inst: e,
      continue: !t.abort
    });
  };
}), Mtt = /* @__PURE__ */ F("$ZodCheckOverwrite", (e, t) => {
  ra.init(e, t), e._zod.check = (a) => {
    a.value = t.tx(a.value);
  };
});
class Ltt {
  constructor(t = []) {
    this.content = [], this.indent = 0, this && (this.args = t);
  }
  indented(t) {
    this.indent += 1, t(this), this.indent -= 1;
  }
  write(t) {
    if (typeof t == "function") {
      t(this, { execution: "sync" }), t(this, { execution: "async" });
      return;
    }
    const a = t.split(`
`).filter((r) => r), o = Math.min(...a.map((r) => r.length - r.trimStart().length)), n = a.map((r) => r.slice(o)).map((r) => " ".repeat(this.indent * 2) + r);
    for (const r of n)
      this.content.push(r);
  }
  compile() {
    const t = Function, a = this?.args, o = [...(this?.content ?? [""]).map((n) => `  ${n}`)];
    return new t(...a, o.join(`
`));
  }
}
const Wtt = {
  major: 4,
  minor: 1,
  patch: 9
}, Ge = /* @__PURE__ */ F("$ZodType", (e, t) => {
  var a;
  e ?? (e = {}), e._zod.def = t, e._zod.bag = e._zod.bag || {}, e._zod.version = Wtt;
  const o = [...e._zod.def.checks ?? []];
  e._zod.traits.has("$ZodCheck") && o.unshift(e);
  for (const n of o)
    for (const r of n._zod.onattach)
      r(e);
  if (o.length === 0)
    (a = e._zod).deferred ?? (a.deferred = []), e._zod.deferred?.push(() => {
      e._zod.run = e._zod.parse;
    });
  else {
    const n = (i, s, l) => {
      let c = Lo(i), u;
      for (const d of s) {
        if (d._zod.def.when) {
          if (!d._zod.def.when(i))
            continue;
        } else if (c)
          continue;
        const h = i.issues.length, p = d._zod.check(i);
        if (p instanceof Promise && l?.async === !1)
          throw new qo();
        if (u || p instanceof Promise)
          u = (u ?? Promise.resolve()).then(async () => {
            await p, i.issues.length !== h && (c || (c = Lo(i, h)));
          });
        else {
          if (i.issues.length === h)
            continue;
          c || (c = Lo(i, h));
        }
      }
      return u ? u.then(() => i) : i;
    }, r = (i, s, l) => {
      if (Lo(i))
        return i.aborted = !0, i;
      const c = n(s, o, l);
      if (c instanceof Promise) {
        if (l.async === !1)
          throw new qo();
        return c.then((u) => e._zod.parse(u, l));
      }
      return e._zod.parse(c, l);
    };
    e._zod.run = (i, s) => {
      if (s.skipChecks)
        return e._zod.parse(i, s);
      if (s.direction === "backward") {
        const c = e._zod.parse({ value: i.value, issues: [] }, { ...s, skipChecks: !0 });
        return c instanceof Promise ? c.then((u) => r(u, i, s)) : r(c, i, s);
      }
      const l = e._zod.parse(i, s);
      if (l instanceof Promise) {
        if (s.async === !1)
          throw new qo();
        return l.then((c) => n(c, o, s));
      }
      return n(l, o, s);
    };
  }
  e["~standard"] = {
    validate: (n) => {
      try {
        const r = Jet(e, n);
        return r.success ? { value: r.data } : { issues: r.error?.issues };
      } catch {
        return Zet(e, n).then((r) => r.success ? { value: r.data } : { issues: r.error?.issues });
      }
    },
    vendor: "zod",
    version: 1
  };
}), Gd = /* @__PURE__ */ F("$ZodString", (e, t) => {
  Ge.init(e, t), e._zod.pattern = [...e?._zod.bag?.patterns ?? []].pop() ?? Ctt(e._zod.bag), e._zod.parse = (a, o) => {
    if (t.coerce)
      try {
        a.value = String(a.value);
      } catch {
      }
    return typeof a.value == "string" || a.issues.push({
      expected: "string",
      code: "invalid_type",
      input: a.value,
      inst: e
    }), a;
  };
}), Te = /* @__PURE__ */ F("$ZodStringFormat", (e, t) => {
  Zs.init(e, t), Gd.init(e, t);
}), Btt = /* @__PURE__ */ F("$ZodGUID", (e, t) => {
  t.pattern ?? (t.pattern = gtt), Te.init(e, t);
}), Ftt = /* @__PURE__ */ F("$ZodUUID", (e, t) => {
  if (t.version) {
    const a = {
      v1: 1,
      v2: 2,
      v3: 3,
      v4: 4,
      v5: 5,
      v6: 6,
      v7: 7,
      v8: 8
    }[t.version];
    if (a === void 0)
      throw new Error(`Invalid UUID version: "${t.version}"`);
    t.pattern ?? (t.pattern = Pp(a));
  } else
    t.pattern ?? (t.pattern = Pp());
  Te.init(e, t);
}), Vtt = /* @__PURE__ */ F("$ZodEmail", (e, t) => {
  t.pattern ?? (t.pattern = htt), Te.init(e, t);
}), Utt = /* @__PURE__ */ F("$ZodURL", (e, t) => {
  Te.init(e, t), e._zod.check = (a) => {
    try {
      const o = a.value.trim(), n = new URL(o);
      t.hostname && (t.hostname.lastIndex = 0, t.hostname.test(n.hostname) || a.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid hostname",
        pattern: wtt.source,
        input: a.value,
        inst: e,
        continue: !t.abort
      })), t.protocol && (t.protocol.lastIndex = 0, t.protocol.test(n.protocol.endsWith(":") ? n.protocol.slice(0, -1) : n.protocol) || a.issues.push({
        code: "invalid_format",
        format: "url",
        note: "Invalid protocol",
        pattern: t.protocol.source,
        input: a.value,
        inst: e,
        continue: !t.abort
      })), t.normalize ? a.value = n.href : a.value = o;
      return;
    } catch {
      a.issues.push({
        code: "invalid_format",
        format: "url",
        input: a.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), qtt = /* @__PURE__ */ F("$ZodEmoji", (e, t) => {
  t.pattern ?? (t.pattern = ptt()), Te.init(e, t);
}), Htt = /* @__PURE__ */ F("$ZodNanoID", (e, t) => {
  t.pattern ?? (t.pattern = utt), Te.init(e, t);
}), Gtt = /* @__PURE__ */ F("$ZodCUID", (e, t) => {
  t.pattern ?? (t.pattern = rtt), Te.init(e, t);
}), Ktt = /* @__PURE__ */ F("$ZodCUID2", (e, t) => {
  t.pattern ?? (t.pattern = itt), Te.init(e, t);
}), Jtt = /* @__PURE__ */ F("$ZodULID", (e, t) => {
  t.pattern ?? (t.pattern = stt), Te.init(e, t);
}), Ztt = /* @__PURE__ */ F("$ZodXID", (e, t) => {
  t.pattern ?? (t.pattern = ltt), Te.init(e, t);
}), Ytt = /* @__PURE__ */ F("$ZodKSUID", (e, t) => {
  t.pattern ?? (t.pattern = ctt), Te.init(e, t);
}), Xtt = /* @__PURE__ */ F("$ZodISODateTime", (e, t) => {
  t.pattern ?? (t.pattern = Stt(t)), Te.init(e, t);
}), Qtt = /* @__PURE__ */ F("$ZodISODate", (e, t) => {
  t.pattern ?? (t.pattern = xtt), Te.init(e, t);
}), eat = /* @__PURE__ */ F("$ZodISOTime", (e, t) => {
  t.pattern ?? (t.pattern = $tt(t)), Te.init(e, t);
}), tat = /* @__PURE__ */ F("$ZodISODuration", (e, t) => {
  t.pattern ?? (t.pattern = dtt), Te.init(e, t);
}), aat = /* @__PURE__ */ F("$ZodIPv4", (e, t) => {
  t.pattern ?? (t.pattern = ftt), Te.init(e, t), e._zod.onattach.push((a) => {
    const o = a._zod.bag;
    o.format = "ipv4";
  });
}), oat = /* @__PURE__ */ F("$ZodIPv6", (e, t) => {
  t.pattern ?? (t.pattern = btt), Te.init(e, t), e._zod.onattach.push((a) => {
    const o = a._zod.bag;
    o.format = "ipv6";
  }), e._zod.check = (a) => {
    try {
      new URL(`http://[${a.value}]`);
    } catch {
      a.issues.push({
        code: "invalid_format",
        format: "ipv6",
        input: a.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
}), nat = /* @__PURE__ */ F("$ZodCIDRv4", (e, t) => {
  t.pattern ?? (t.pattern = _tt), Te.init(e, t);
}), rat = /* @__PURE__ */ F("$ZodCIDRv6", (e, t) => {
  t.pattern ?? (t.pattern = vtt), Te.init(e, t), e._zod.check = (a) => {
    const o = a.value.split("/");
    try {
      if (o.length !== 2)
        throw new Error();
      const [n, r] = o;
      if (!r)
        throw new Error();
      const i = Number(r);
      if (`${i}` !== r)
        throw new Error();
      if (i < 0 || i > 128)
        throw new Error();
      new URL(`http://[${n}]`);
    } catch {
      a.issues.push({
        code: "invalid_format",
        format: "cidrv6",
        input: a.value,
        inst: e,
        continue: !t.abort
      });
    }
  };
});
function Xk(e) {
  if (e === "")
    return !0;
  if (e.length % 4 !== 0)
    return !1;
  try {
    return atob(e), !0;
  } catch {
    return !1;
  }
}
const iat = /* @__PURE__ */ F("$ZodBase64", (e, t) => {
  t.pattern ?? (t.pattern = ytt), Te.init(e, t), e._zod.onattach.push((a) => {
    a._zod.bag.contentEncoding = "base64";
  }), e._zod.check = (a) => {
    Xk(a.value) || a.issues.push({
      code: "invalid_format",
      format: "base64",
      input: a.value,
      inst: e,
      continue: !t.abort
    });
  };
});
function sat(e) {
  if (!Jk.test(e))
    return !1;
  const t = e.replace(/[-_]/g, (o) => o === "-" ? "+" : "/"), a = t.padEnd(Math.ceil(t.length / 4) * 4, "=");
  return Xk(a);
}
const lat = /* @__PURE__ */ F("$ZodBase64URL", (e, t) => {
  t.pattern ?? (t.pattern = Jk), Te.init(e, t), e._zod.onattach.push((a) => {
    a._zod.bag.contentEncoding = "base64url";
  }), e._zod.check = (a) => {
    sat(a.value) || a.issues.push({
      code: "invalid_format",
      format: "base64url",
      input: a.value,
      inst: e,
      continue: !t.abort
    });
  };
}), cat = /* @__PURE__ */ F("$ZodE164", (e, t) => {
  t.pattern ?? (t.pattern = ktt), Te.init(e, t);
});
function uat(e, t = null) {
  try {
    const a = e.split(".");
    if (a.length !== 3)
      return !1;
    const [o] = a;
    if (!o)
      return !1;
    const n = JSON.parse(atob(o));
    return !("typ" in n && n?.typ !== "JWT" || !n.alg || t && (!("alg" in n) || n.alg !== t));
  } catch {
    return !1;
  }
}
const dat = /* @__PURE__ */ F("$ZodJWT", (e, t) => {
  Te.init(e, t), e._zod.check = (a) => {
    uat(a.value, t.alg) || a.issues.push({
      code: "invalid_format",
      format: "jwt",
      input: a.value,
      inst: e,
      continue: !t.abort
    });
  };
}), gat = /* @__PURE__ */ F("$ZodUnknown", (e, t) => {
  Ge.init(e, t), e._zod.parse = (a) => a;
}), hat = /* @__PURE__ */ F("$ZodNever", (e, t) => {
  Ge.init(e, t), e._zod.parse = (a, o) => (a.issues.push({
    expected: "never",
    code: "invalid_type",
    input: a.value,
    inst: e
  }), a);
});
function Dp(e, t, a) {
  e.issues.length && t.issues.push(...qk(a, e.issues)), t.value[a] = e.value;
}
const mat = /* @__PURE__ */ F("$ZodArray", (e, t) => {
  Ge.init(e, t), e._zod.parse = (a, o) => {
    const n = a.value;
    if (!Array.isArray(n))
      return a.issues.push({
        expected: "array",
        code: "invalid_type",
        input: n,
        inst: e
      }), a;
    a.value = Array(n.length);
    const r = [];
    for (let i = 0; i < n.length; i++) {
      const s = n[i], l = t.element._zod.run({
        value: s,
        issues: []
      }, o);
      l instanceof Promise ? r.push(l.then((c) => Dp(c, a, i))) : Dp(l, a, i);
    }
    return r.length ? Promise.all(r).then(() => a) : a;
  };
});
function as(e, t, a, o) {
  e.issues.length && t.issues.push(...qk(a, e.issues)), e.value === void 0 ? a in o && (t.value[a] = void 0) : t.value[a] = e.value;
}
function Qk(e) {
  const t = Object.keys(e.shape);
  for (const o of t)
    if (!e.shape?.[o]?._zod?.traits?.has("$ZodType"))
      throw new Error(`Invalid element at key "${o}": expected a Zod schema`);
  const a = Let(e.shape);
  return {
    ...e,
    keys: t,
    keySet: new Set(t),
    numKeys: t.length,
    optionalKeys: new Set(a)
  };
}
function ex(e, t, a, o, n, r) {
  const i = [], s = n.keySet, l = n.catchall._zod, c = l.def.type;
  for (const u of Object.keys(t)) {
    if (s.has(u))
      continue;
    if (c === "never") {
      i.push(u);
      continue;
    }
    const d = l.run({ value: t[u], issues: [] }, o);
    d instanceof Promise ? e.push(d.then((h) => as(h, a, u, t))) : as(d, a, u, t);
  }
  return i.length && a.issues.push({
    code: "unrecognized_keys",
    keys: i,
    input: t,
    inst: r
  }), e.length ? Promise.all(e).then(() => a) : a;
}
const pat = /* @__PURE__ */ F("$ZodObject", (e, t) => {
  Ge.init(e, t);
  const a = Bd(() => Qk(t));
  Re(e._zod, "propValues", () => {
    const i = t.shape, s = {};
    for (const l in i) {
      const c = i[l]._zod;
      if (c.values) {
        s[l] ?? (s[l] = /* @__PURE__ */ new Set());
        for (const u of c.values)
          s[l].add(u);
      }
    }
    return s;
  });
  const o = ts, n = t.catchall;
  let r;
  e._zod.parse = (i, s) => {
    r ?? (r = a.value);
    const l = i.value;
    if (!o(l))
      return i.issues.push({
        expected: "object",
        code: "invalid_type",
        input: l,
        inst: e
      }), i;
    i.value = {};
    const c = [], u = r.shape;
    for (const d of r.keys) {
      const h = u[d]._zod.run({ value: l[d], issues: [] }, s);
      h instanceof Promise ? c.push(h.then((p) => as(p, i, d, l))) : as(h, i, d, l);
    }
    return n ? ex(c, l, i, s, a.value, e) : c.length ? Promise.all(c).then(() => i) : i;
  };
}), fat = /* @__PURE__ */ F("$ZodObjectJIT", (e, t) => {
  pat.init(e, t);
  const a = e._zod.parse, o = Bd(() => Qk(t)), n = (d) => {
    const h = new Ltt(["shape", "payload", "ctx"]), p = o.value, f = (_) => {
      const y = Op(_);
      return `shape[${y}]._zod.run({ value: input[${y}], issues: [] }, ctx)`;
    };
    h.write("const input = payload.value;");
    const m = /* @__PURE__ */ Object.create(null);
    let b = 0;
    for (const _ of p.keys)
      m[_] = `key_${b++}`;
    h.write("const newResult = {};");
    for (const _ of p.keys) {
      const y = m[_], k = Op(_);
      h.write(`const ${y} = ${f(_)};`), h.write(`
        if (${y}.issues.length) {
          payload.issues = payload.issues.concat(${y}.issues.map(iss => ({
            ...iss,
            path: iss.path ? [${k}, ...iss.path] : [${k}]
          })));
        }
        
        
        if (${y}.value === undefined) {
          if (${k} in input) {
            newResult[${k}] = undefined;
          }
        } else {
          newResult[${k}] = ${y}.value;
        }
        
      `);
    }
    h.write("payload.value = newResult;"), h.write("return payload;");
    const w = h.compile();
    return (_, y) => w(d, _, y);
  };
  let r;
  const i = ts, s = !Fk.jitless, l = s && Tet.value, c = t.catchall;
  let u;
  e._zod.parse = (d, h) => {
    u ?? (u = o.value);
    const p = d.value;
    return i(p) ? s && l && h?.async === !1 && h.jitless !== !0 ? (r || (r = n(t.shape)), d = r(d, h), c ? ex([], p, d, h, u, e) : d) : a(d, h) : (d.issues.push({
      expected: "object",
      code: "invalid_type",
      input: p,
      inst: e
    }), d);
  };
});
function Np(e, t, a, o) {
  for (const r of e)
    if (r.issues.length === 0)
      return t.value = r.value, t;
  const n = e.filter((r) => !Lo(r));
  return n.length === 1 ? (t.value = n[0].value, n[0]) : (t.issues.push({
    code: "invalid_union",
    input: t.value,
    inst: a,
    errors: e.map((r) => r.issues.map((i) => go(i, o, uo())))
  }), t);
}
const bat = /* @__PURE__ */ F("$ZodUnion", (e, t) => {
  Ge.init(e, t), Re(e._zod, "optin", () => t.options.some((n) => n._zod.optin === "optional") ? "optional" : void 0), Re(e._zod, "optout", () => t.options.some((n) => n._zod.optout === "optional") ? "optional" : void 0), Re(e._zod, "values", () => {
    if (t.options.every((n) => n._zod.values))
      return new Set(t.options.flatMap((n) => Array.from(n._zod.values)));
  }), Re(e._zod, "pattern", () => {
    if (t.options.every((n) => n._zod.pattern)) {
      const n = t.options.map((r) => r._zod.pattern);
      return new RegExp(`^(${n.map((r) => Vd(r.source)).join("|")})$`);
    }
  });
  const a = t.options.length === 1, o = t.options[0]._zod.run;
  e._zod.parse = (n, r) => {
    if (a)
      return o(n, r);
    let i = !1;
    const s = [];
    for (const l of t.options) {
      const c = l._zod.run({
        value: n.value,
        issues: []
      }, r);
      if (c instanceof Promise)
        s.push(c), i = !0;
      else {
        if (c.issues.length === 0)
          return c;
        s.push(c);
      }
    }
    return i ? Promise.all(s).then((l) => Np(l, n, e, r)) : Np(s, n, e, r);
  };
}), _at = /* @__PURE__ */ F("$ZodIntersection", (e, t) => {
  Ge.init(e, t), e._zod.parse = (a, o) => {
    const n = a.value, r = t.left._zod.run({ value: n, issues: [] }, o), i = t.right._zod.run({ value: n, issues: [] }, o);
    return r instanceof Promise || i instanceof Promise ? Promise.all([r, i]).then(([s, l]) => Rp(a, s, l)) : Rp(a, r, i);
  };
});
function au(e, t) {
  if (e === t)
    return { valid: !0, data: e };
  if (e instanceof Date && t instanceof Date && +e == +t)
    return { valid: !0, data: e };
  if (Gn(e) && Gn(t)) {
    const a = Object.keys(t), o = Object.keys(e).filter((r) => a.indexOf(r) !== -1), n = { ...e, ...t };
    for (const r of o) {
      const i = au(e[r], t[r]);
      if (!i.valid)
        return {
          valid: !1,
          mergeErrorPath: [r, ...i.mergeErrorPath]
        };
      n[r] = i.data;
    }
    return { valid: !0, data: n };
  }
  if (Array.isArray(e) && Array.isArray(t)) {
    if (e.length !== t.length)
      return { valid: !1, mergeErrorPath: [] };
    const a = [];
    for (let o = 0; o < e.length; o++) {
      const n = e[o], r = t[o], i = au(n, r);
      if (!i.valid)
        return {
          valid: !1,
          mergeErrorPath: [o, ...i.mergeErrorPath]
        };
      a.push(i.data);
    }
    return { valid: !0, data: a };
  }
  return { valid: !1, mergeErrorPath: [] };
}
function Rp(e, t, a) {
  if (t.issues.length && e.issues.push(...t.issues), a.issues.length && e.issues.push(...a.issues), Lo(e))
    return e;
  const o = au(t.value, a.value);
  if (!o.valid)
    throw new Error(`Unmergable intersection. Error path: ${JSON.stringify(o.mergeErrorPath)}`);
  return e.value = o.data, e;
}
const vat = /* @__PURE__ */ F("$ZodEnum", (e, t) => {
  Ge.init(e, t);
  const a = Ret(t.entries), o = new Set(a);
  e._zod.values = o, e._zod.pattern = new RegExp(`^(${a.filter((n) => Met.has(typeof n)).map((n) => typeof n == "string" ? an(n) : n.toString()).join("|")})$`), e._zod.parse = (n, r) => {
    const i = n.value;
    return o.has(i) || n.issues.push({
      code: "invalid_value",
      values: a,
      input: i,
      inst: e
    }), n;
  };
}), yat = /* @__PURE__ */ F("$ZodLiteral", (e, t) => {
  if (Ge.init(e, t), t.values.length === 0)
    throw new Error("Cannot create literal schema with no valid values");
  e._zod.values = new Set(t.values), e._zod.pattern = new RegExp(`^(${t.values.map((a) => typeof a == "string" ? an(a) : a ? an(a.toString()) : String(a)).join("|")})$`), e._zod.parse = (a, o) => {
    const n = a.value;
    return e._zod.values.has(n) || a.issues.push({
      code: "invalid_value",
      values: t.values,
      input: n,
      inst: e
    }), a;
  };
}), wat = /* @__PURE__ */ F("$ZodTransform", (e, t) => {
  Ge.init(e, t), e._zod.parse = (a, o) => {
    if (o.direction === "backward")
      throw new Bk(e.constructor.name);
    const n = t.transform(a.value, a);
    if (o.async)
      return (n instanceof Promise ? n : Promise.resolve(n)).then((r) => (a.value = r, a));
    if (n instanceof Promise)
      throw new qo();
    return a.value = n, a;
  };
});
function Ip(e, t) {
  return e.issues.length && t === void 0 ? { issues: [], value: void 0 } : e;
}
const kat = /* @__PURE__ */ F("$ZodOptional", (e, t) => {
  Ge.init(e, t), e._zod.optin = "optional", e._zod.optout = "optional", Re(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, void 0]) : void 0), Re(e._zod, "pattern", () => {
    const a = t.innerType._zod.pattern;
    return a ? new RegExp(`^(${Vd(a.source)})?$`) : void 0;
  }), e._zod.parse = (a, o) => {
    if (t.innerType._zod.optin === "optional") {
      const n = t.innerType._zod.run(a, o);
      return n instanceof Promise ? n.then((r) => Ip(r, a.value)) : Ip(n, a.value);
    }
    return a.value === void 0 ? a : t.innerType._zod.run(a, o);
  };
}), xat = /* @__PURE__ */ F("$ZodNullable", (e, t) => {
  Ge.init(e, t), Re(e._zod, "optin", () => t.innerType._zod.optin), Re(e._zod, "optout", () => t.innerType._zod.optout), Re(e._zod, "pattern", () => {
    const a = t.innerType._zod.pattern;
    return a ? new RegExp(`^(${Vd(a.source)}|null)$`) : void 0;
  }), Re(e._zod, "values", () => t.innerType._zod.values ? /* @__PURE__ */ new Set([...t.innerType._zod.values, null]) : void 0), e._zod.parse = (a, o) => a.value === null ? a : t.innerType._zod.run(a, o);
}), $at = /* @__PURE__ */ F("$ZodDefault", (e, t) => {
  Ge.init(e, t), e._zod.optin = "optional", Re(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (a, o) => {
    if (o.direction === "backward")
      return t.innerType._zod.run(a, o);
    if (a.value === void 0)
      return a.value = t.defaultValue, a;
    const n = t.innerType._zod.run(a, o);
    return n instanceof Promise ? n.then((r) => Tp(r, t)) : Tp(n, t);
  };
});
function Tp(e, t) {
  return e.value === void 0 && (e.value = t.defaultValue), e;
}
const Sat = /* @__PURE__ */ F("$ZodPrefault", (e, t) => {
  Ge.init(e, t), e._zod.optin = "optional", Re(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (a, o) => (o.direction === "backward" || a.value === void 0 && (a.value = t.defaultValue), t.innerType._zod.run(a, o));
}), Cat = /* @__PURE__ */ F("$ZodNonOptional", (e, t) => {
  Ge.init(e, t), Re(e._zod, "values", () => {
    const a = t.innerType._zod.values;
    return a ? new Set([...a].filter((o) => o !== void 0)) : void 0;
  }), e._zod.parse = (a, o) => {
    const n = t.innerType._zod.run(a, o);
    return n instanceof Promise ? n.then((r) => Mp(r, e)) : Mp(n, e);
  };
});
function Mp(e, t) {
  return !e.issues.length && e.value === void 0 && e.issues.push({
    code: "invalid_type",
    expected: "nonoptional",
    input: e.value,
    inst: t
  }), e;
}
const Eat = /* @__PURE__ */ F("$ZodCatch", (e, t) => {
  Ge.init(e, t), Re(e._zod, "optin", () => t.innerType._zod.optin), Re(e._zod, "optout", () => t.innerType._zod.optout), Re(e._zod, "values", () => t.innerType._zod.values), e._zod.parse = (a, o) => {
    if (o.direction === "backward")
      return t.innerType._zod.run(a, o);
    const n = t.innerType._zod.run(a, o);
    return n instanceof Promise ? n.then((r) => (a.value = r.value, r.issues.length && (a.value = t.catchValue({
      ...a,
      error: {
        issues: r.issues.map((i) => go(i, o, uo()))
      },
      input: a.value
    }), a.issues = []), a)) : (a.value = n.value, n.issues.length && (a.value = t.catchValue({
      ...a,
      error: {
        issues: n.issues.map((r) => go(r, o, uo()))
      },
      input: a.value
    }), a.issues = []), a);
  };
}), zat = /* @__PURE__ */ F("$ZodPipe", (e, t) => {
  Ge.init(e, t), Re(e._zod, "values", () => t.in._zod.values), Re(e._zod, "optin", () => t.in._zod.optin), Re(e._zod, "optout", () => t.out._zod.optout), Re(e._zod, "propValues", () => t.in._zod.propValues), e._zod.parse = (a, o) => {
    if (o.direction === "backward") {
      const r = t.out._zod.run(a, o);
      return r instanceof Promise ? r.then((i) => Hr(i, t.in, o)) : Hr(r, t.in, o);
    }
    const n = t.in._zod.run(a, o);
    return n instanceof Promise ? n.then((r) => Hr(r, t.out, o)) : Hr(n, t.out, o);
  };
});
function Hr(e, t, a) {
  return e.issues.length ? (e.aborted = !0, e) : t._zod.run({ value: e.value, issues: e.issues }, a);
}
const jat = /* @__PURE__ */ F("$ZodReadonly", (e, t) => {
  Ge.init(e, t), Re(e._zod, "propValues", () => t.innerType._zod.propValues), Re(e._zod, "values", () => t.innerType._zod.values), Re(e._zod, "optin", () => t.innerType._zod.optin), Re(e._zod, "optout", () => t.innerType._zod.optout), e._zod.parse = (a, o) => {
    if (o.direction === "backward")
      return t.innerType._zod.run(a, o);
    const n = t.innerType._zod.run(a, o);
    return n instanceof Promise ? n.then(Lp) : Lp(n);
  };
});
function Lp(e) {
  return e.value = Object.freeze(e.value), e;
}
const Aat = /* @__PURE__ */ F("$ZodCustom", (e, t) => {
  ra.init(e, t), Ge.init(e, t), e._zod.parse = (a, o) => a, e._zod.check = (a) => {
    const o = a.value, n = t.fn(o);
    if (n instanceof Promise)
      return n.then((r) => Wp(r, a, o, e));
    Wp(n, a, o, e);
  };
});
function Wp(e, t, a, o) {
  if (!e) {
    const n = {
      code: "custom",
      input: a,
      inst: o,
      // incorporates params.error into issue reporting
      path: [...o._zod.def.path ?? []],
      // incorporates params.error into issue reporting
      continue: !o._zod.def.abort
      // params: inst._zod.def.params,
    };
    o._zod.def.params && (n.params = o._zod.def.params), t.issues.push(Kn(n));
  }
}
class Oat {
  constructor() {
    this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map();
  }
  add(t, ...a) {
    const o = a[0];
    if (this._map.set(t, o), o && typeof o == "object" && "id" in o) {
      if (this._idmap.has(o.id))
        throw new Error(`ID ${o.id} already exists in the registry`);
      this._idmap.set(o.id, t);
    }
    return this;
  }
  clear() {
    return this._map = /* @__PURE__ */ new WeakMap(), this._idmap = /* @__PURE__ */ new Map(), this;
  }
  remove(t) {
    const a = this._map.get(t);
    return a && typeof a == "object" && "id" in a && this._idmap.delete(a.id), this._map.delete(t), this;
  }
  get(t) {
    const a = t._zod.parent;
    if (a) {
      const o = { ...this.get(a) ?? {} };
      delete o.id;
      const n = { ...o, ...this._map.get(t) };
      return Object.keys(n).length ? n : void 0;
    }
    return this._map.get(t);
  }
  has(t) {
    return this._map.has(t);
  }
}
function Pat() {
  return new Oat();
}
const Gr = /* @__PURE__ */ Pat();
function Dat(e, t) {
  return new e({
    type: "string",
    ...re(t)
  });
}
function tx(e, t) {
  return new e({
    type: "string",
    format: "email",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Bp(e, t) {
  return new e({
    type: "string",
    format: "guid",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Nat(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Rat(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v4",
    ...re(t)
  });
}
function Iat(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v6",
    ...re(t)
  });
}
function Tat(e, t) {
  return new e({
    type: "string",
    format: "uuid",
    check: "string_format",
    abort: !1,
    version: "v7",
    ...re(t)
  });
}
function Mat(e, t) {
  return new e({
    type: "string",
    format: "url",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Lat(e, t) {
  return new e({
    type: "string",
    format: "emoji",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Wat(e, t) {
  return new e({
    type: "string",
    format: "nanoid",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Bat(e, t) {
  return new e({
    type: "string",
    format: "cuid",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Fat(e, t) {
  return new e({
    type: "string",
    format: "cuid2",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Vat(e, t) {
  return new e({
    type: "string",
    format: "ulid",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Uat(e, t) {
  return new e({
    type: "string",
    format: "xid",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function qat(e, t) {
  return new e({
    type: "string",
    format: "ksuid",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Hat(e, t) {
  return new e({
    type: "string",
    format: "ipv4",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Gat(e, t) {
  return new e({
    type: "string",
    format: "ipv6",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Kat(e, t) {
  return new e({
    type: "string",
    format: "cidrv4",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Jat(e, t) {
  return new e({
    type: "string",
    format: "cidrv6",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Zat(e, t) {
  return new e({
    type: "string",
    format: "base64",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Yat(e, t) {
  return new e({
    type: "string",
    format: "base64url",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Xat(e, t) {
  return new e({
    type: "string",
    format: "e164",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function Qat(e, t) {
  return new e({
    type: "string",
    format: "jwt",
    check: "string_format",
    abort: !1,
    ...re(t)
  });
}
function eot(e, t) {
  return new e({
    type: "string",
    format: "datetime",
    check: "string_format",
    offset: !1,
    local: !1,
    precision: null,
    ...re(t)
  });
}
function tot(e, t) {
  return new e({
    type: "string",
    format: "date",
    check: "string_format",
    ...re(t)
  });
}
function aot(e, t) {
  return new e({
    type: "string",
    format: "time",
    check: "string_format",
    precision: null,
    ...re(t)
  });
}
function oot(e, t) {
  return new e({
    type: "string",
    format: "duration",
    check: "string_format",
    ...re(t)
  });
}
function not(e) {
  return new e({
    type: "unknown"
  });
}
function rot(e, t) {
  return new e({
    type: "never",
    ...re(t)
  });
}
function ax(e, t) {
  return new jtt({
    check: "max_length",
    ...re(t),
    maximum: e
  });
}
function os(e, t) {
  return new Att({
    check: "min_length",
    ...re(t),
    minimum: e
  });
}
function ox(e, t) {
  return new Ott({
    check: "length_equals",
    ...re(t),
    length: e
  });
}
function iot(e, t) {
  return new Ptt({
    check: "string_format",
    format: "regex",
    ...re(t),
    pattern: e
  });
}
function sot(e) {
  return new Dtt({
    check: "string_format",
    format: "lowercase",
    ...re(e)
  });
}
function lot(e) {
  return new Ntt({
    check: "string_format",
    format: "uppercase",
    ...re(e)
  });
}
function cot(e, t) {
  return new Rtt({
    check: "string_format",
    format: "includes",
    ...re(t),
    includes: e
  });
}
function uot(e, t) {
  return new Itt({
    check: "string_format",
    format: "starts_with",
    ...re(t),
    prefix: e
  });
}
function dot(e, t) {
  return new Ttt({
    check: "string_format",
    format: "ends_with",
    ...re(t),
    suffix: e
  });
}
function dr(e) {
  return new Mtt({
    check: "overwrite",
    tx: e
  });
}
function got(e) {
  return dr((t) => t.normalize(e));
}
function hot() {
  return dr((e) => e.trim());
}
function mot() {
  return dr((e) => e.toLowerCase());
}
function pot() {
  return dr((e) => e.toUpperCase());
}
function fot(e, t, a) {
  return new e({
    type: "array",
    element: t,
    // get element() {
    //   return element;
    // },
    ...re(a)
  });
}
function bot(e, t, a) {
  return new e({
    type: "custom",
    check: "custom",
    fn: t,
    ...re(a)
  });
}
function _ot(e) {
  const t = vot((a) => (a.addIssue = (o) => {
    if (typeof o == "string")
      a.issues.push(Kn(o, a.value, t._zod.def));
    else {
      const n = o;
      n.fatal && (n.continue = !1), n.code ?? (n.code = "custom"), n.input ?? (n.input = a.value), n.inst ?? (n.inst = t), n.continue ?? (n.continue = !t._zod.def.abort), a.issues.push(Kn(n));
    }
  }, e(a.value, a)));
  return t;
}
function vot(e, t) {
  const a = new ra({
    check: "custom",
    ...re(t)
  });
  return a._zod.check = e, a;
}
const yot = /* @__PURE__ */ F("ZodISODateTime", (e, t) => {
  Xtt.init(e, t), Le.init(e, t);
});
function wot(e) {
  return eot(yot, e);
}
const kot = /* @__PURE__ */ F("ZodISODate", (e, t) => {
  Qtt.init(e, t), Le.init(e, t);
});
function xot(e) {
  return tot(kot, e);
}
const $ot = /* @__PURE__ */ F("ZodISOTime", (e, t) => {
  eat.init(e, t), Le.init(e, t);
});
function Sot(e) {
  return aot($ot, e);
}
const Cot = /* @__PURE__ */ F("ZodISODuration", (e, t) => {
  tat.init(e, t), Le.init(e, t);
});
function Eot(e) {
  return oot(Cot, e);
}
const zot = (e, t) => {
  Gk.init(e, t), e.name = "ZodError", Object.defineProperties(e, {
    format: {
      value: (a) => Ket(e, a)
      // enumerable: false,
    },
    flatten: {
      value: (a) => Get(e, a)
      // enumerable: false,
    },
    addIssue: {
      value: (a) => {
        e.issues.push(a), e.message = JSON.stringify(e.issues, tu, 2);
      }
      // enumerable: false,
    },
    addIssues: {
      value: (a) => {
        e.issues.push(...a), e.message = JSON.stringify(e.issues, tu, 2);
      }
      // enumerable: false,
    },
    isEmpty: {
      get() {
        return e.issues.length === 0;
      }
      // enumerable: false,
    }
  });
}, Nt = F("ZodError", zot, {
  Parent: Error
}), jot = /* @__PURE__ */ qd(Nt), Aot = /* @__PURE__ */ Hd(Nt), Oot = /* @__PURE__ */ Ks(Nt), Pot = /* @__PURE__ */ Js(Nt), Dot = /* @__PURE__ */ Yet(Nt), Not = /* @__PURE__ */ Xet(Nt), Rot = /* @__PURE__ */ Qet(Nt), Iot = /* @__PURE__ */ ett(Nt), Tot = /* @__PURE__ */ ttt(Nt), Mot = /* @__PURE__ */ att(Nt), Lot = /* @__PURE__ */ ott(Nt), Wot = /* @__PURE__ */ ntt(Nt), Ze = /* @__PURE__ */ F("ZodType", (e, t) => (Ge.init(e, t), e.def = t, e.type = t.type, Object.defineProperty(e, "_def", { value: t }), e.check = (...a) => e.clone(
  {
    ...t,
    checks: [
      ...t.checks ?? [],
      ...a.map((o) => typeof o == "function" ? { _zod: { check: o, def: { check: "custom" }, onattach: [] } } : o)
    ]
  }
  // { parent: true }
), e.clone = (a, o) => Wa(e, a, o), e.brand = () => e, e.register = (a, o) => (a.add(e, o), e), e.parse = (a, o) => jot(e, a, o, { callee: e.parse }), e.safeParse = (a, o) => Oot(e, a, o), e.parseAsync = async (a, o) => Aot(e, a, o, { callee: e.parseAsync }), e.safeParseAsync = async (a, o) => Pot(e, a, o), e.spa = e.safeParseAsync, e.encode = (a, o) => Dot(e, a, o), e.decode = (a, o) => Not(e, a, o), e.encodeAsync = async (a, o) => Rot(e, a, o), e.decodeAsync = async (a, o) => Iot(e, a, o), e.safeEncode = (a, o) => Tot(e, a, o), e.safeDecode = (a, o) => Mot(e, a, o), e.safeEncodeAsync = async (a, o) => Lot(e, a, o), e.safeDecodeAsync = async (a, o) => Wot(e, a, o), e.refine = (a, o) => e.check(Pnt(a, o)), e.superRefine = (a) => e.check(Dnt(a)), e.overwrite = (a) => e.check(dr(a)), e.optional = () => Up(e), e.nullable = () => qp(e), e.nullish = () => Up(qp(e)), e.nonoptional = (a) => Snt(e, a), e.array = () => cnt(e), e.or = (a) => gnt([e, a]), e.and = (a) => mnt(e, a), e.transform = (a) => Hp(e, vnt(a)), e.default = (a) => knt(e, a), e.prefault = (a) => $nt(e, a), e.catch = (a) => Ent(e, a), e.pipe = (a) => Hp(e, a), e.readonly = () => Ant(e), e.describe = (a) => {
  const o = e.clone();
  return Gr.add(o, { description: a }), o;
}, Object.defineProperty(e, "description", {
  get() {
    return Gr.get(e)?.description;
  },
  configurable: !0
}), e.meta = (...a) => {
  if (a.length === 0)
    return Gr.get(e);
  const o = e.clone();
  return Gr.add(o, a[0]), o;
}, e.isOptional = () => e.safeParse(void 0).success, e.isNullable = () => e.safeParse(null).success, e)), nx = /* @__PURE__ */ F("_ZodString", (e, t) => {
  Gd.init(e, t), Ze.init(e, t);
  const a = e._zod.bag;
  e.format = a.format ?? null, e.minLength = a.minimum ?? null, e.maxLength = a.maximum ?? null, e.regex = (...o) => e.check(iot(...o)), e.includes = (...o) => e.check(cot(...o)), e.startsWith = (...o) => e.check(uot(...o)), e.endsWith = (...o) => e.check(dot(...o)), e.min = (...o) => e.check(os(...o)), e.max = (...o) => e.check(ax(...o)), e.length = (...o) => e.check(ox(...o)), e.nonempty = (...o) => e.check(os(1, ...o)), e.lowercase = (o) => e.check(sot(o)), e.uppercase = (o) => e.check(lot(o)), e.trim = () => e.check(hot()), e.normalize = (...o) => e.check(got(...o)), e.toLowerCase = () => e.check(mot()), e.toUpperCase = () => e.check(pot());
}), Bot = /* @__PURE__ */ F("ZodString", (e, t) => {
  Gd.init(e, t), nx.init(e, t), e.email = (a) => e.check(tx(rx, a)), e.url = (a) => e.check(Mat(Vot, a)), e.jwt = (a) => e.check(Qat(nnt, a)), e.emoji = (a) => e.check(Lat(Uot, a)), e.guid = (a) => e.check(Bp(Fp, a)), e.uuid = (a) => e.check(Nat(Kr, a)), e.uuidv4 = (a) => e.check(Rat(Kr, a)), e.uuidv6 = (a) => e.check(Iat(Kr, a)), e.uuidv7 = (a) => e.check(Tat(Kr, a)), e.nanoid = (a) => e.check(Wat(qot, a)), e.guid = (a) => e.check(Bp(Fp, a)), e.cuid = (a) => e.check(Bat(Hot, a)), e.cuid2 = (a) => e.check(Fat(Got, a)), e.ulid = (a) => e.check(Vat(Kot, a)), e.base64 = (a) => e.check(Zat(tnt, a)), e.base64url = (a) => e.check(Yat(ant, a)), e.xid = (a) => e.check(Uat(Jot, a)), e.ksuid = (a) => e.check(qat(Zot, a)), e.ipv4 = (a) => e.check(Hat(Yot, a)), e.ipv6 = (a) => e.check(Gat(Xot, a)), e.cidrv4 = (a) => e.check(Kat(Qot, a)), e.cidrv6 = (a) => e.check(Jat(ent, a)), e.e164 = (a) => e.check(Xat(ont, a)), e.datetime = (a) => e.check(wot(a)), e.date = (a) => e.check(xot(a)), e.time = (a) => e.check(Sot(a)), e.duration = (a) => e.check(Eot(a));
});
function lt(e) {
  return Dat(Bot, e);
}
const Le = /* @__PURE__ */ F("ZodStringFormat", (e, t) => {
  Te.init(e, t), nx.init(e, t);
}), rx = /* @__PURE__ */ F("ZodEmail", (e, t) => {
  Vtt.init(e, t), Le.init(e, t);
});
function Fot(e) {
  return tx(rx, e);
}
const Fp = /* @__PURE__ */ F("ZodGUID", (e, t) => {
  Btt.init(e, t), Le.init(e, t);
}), Kr = /* @__PURE__ */ F("ZodUUID", (e, t) => {
  Ftt.init(e, t), Le.init(e, t);
}), Vot = /* @__PURE__ */ F("ZodURL", (e, t) => {
  Utt.init(e, t), Le.init(e, t);
}), Uot = /* @__PURE__ */ F("ZodEmoji", (e, t) => {
  qtt.init(e, t), Le.init(e, t);
}), qot = /* @__PURE__ */ F("ZodNanoID", (e, t) => {
  Htt.init(e, t), Le.init(e, t);
}), Hot = /* @__PURE__ */ F("ZodCUID", (e, t) => {
  Gtt.init(e, t), Le.init(e, t);
}), Got = /* @__PURE__ */ F("ZodCUID2", (e, t) => {
  Ktt.init(e, t), Le.init(e, t);
}), Kot = /* @__PURE__ */ F("ZodULID", (e, t) => {
  Jtt.init(e, t), Le.init(e, t);
}), Jot = /* @__PURE__ */ F("ZodXID", (e, t) => {
  Ztt.init(e, t), Le.init(e, t);
}), Zot = /* @__PURE__ */ F("ZodKSUID", (e, t) => {
  Ytt.init(e, t), Le.init(e, t);
}), Yot = /* @__PURE__ */ F("ZodIPv4", (e, t) => {
  aat.init(e, t), Le.init(e, t);
}), Xot = /* @__PURE__ */ F("ZodIPv6", (e, t) => {
  oat.init(e, t), Le.init(e, t);
}), Qot = /* @__PURE__ */ F("ZodCIDRv4", (e, t) => {
  nat.init(e, t), Le.init(e, t);
}), ent = /* @__PURE__ */ F("ZodCIDRv6", (e, t) => {
  rat.init(e, t), Le.init(e, t);
}), tnt = /* @__PURE__ */ F("ZodBase64", (e, t) => {
  iat.init(e, t), Le.init(e, t);
}), ant = /* @__PURE__ */ F("ZodBase64URL", (e, t) => {
  lat.init(e, t), Le.init(e, t);
}), ont = /* @__PURE__ */ F("ZodE164", (e, t) => {
  cat.init(e, t), Le.init(e, t);
}), nnt = /* @__PURE__ */ F("ZodJWT", (e, t) => {
  dat.init(e, t), Le.init(e, t);
}), rnt = /* @__PURE__ */ F("ZodUnknown", (e, t) => {
  gat.init(e, t), Ze.init(e, t);
});
function Vp() {
  return not(rnt);
}
const int = /* @__PURE__ */ F("ZodNever", (e, t) => {
  hat.init(e, t), Ze.init(e, t);
});
function snt(e) {
  return rot(int, e);
}
const lnt = /* @__PURE__ */ F("ZodArray", (e, t) => {
  mat.init(e, t), Ze.init(e, t), e.element = t.element, e.min = (a, o) => e.check(os(a, o)), e.nonempty = (a) => e.check(os(1, a)), e.max = (a, o) => e.check(ax(a, o)), e.length = (a, o) => e.check(ox(a, o)), e.unwrap = () => e.element;
});
function cnt(e, t) {
  return fot(lnt, e, t);
}
const unt = /* @__PURE__ */ F("ZodObject", (e, t) => {
  fat.init(e, t), Ze.init(e, t), Re(e, "shape", () => t.shape), e.keyof = () => pnt(Object.keys(e._zod.def.shape)), e.catchall = (a) => e.clone({ ...e._zod.def, catchall: a }), e.passthrough = () => e.clone({ ...e._zod.def, catchall: Vp() }), e.loose = () => e.clone({ ...e._zod.def, catchall: Vp() }), e.strict = () => e.clone({ ...e._zod.def, catchall: snt() }), e.strip = () => e.clone({ ...e._zod.def, catchall: void 0 }), e.extend = (a) => Fet(e, a), e.safeExtend = (a) => Vet(e, a), e.merge = (a) => Uet(e, a), e.pick = (a) => Wet(e, a), e.omit = (a) => Bet(e, a), e.partial = (...a) => qet(ix, e, a[0]), e.required = (...a) => Het(sx, e, a[0]);
});
function ns(e, t) {
  const a = {
    type: "object",
    get shape() {
      return La(this, "shape", e ? Iet(e) : {}), this.shape;
    },
    ...re(t)
  };
  return new unt(a);
}
const dnt = /* @__PURE__ */ F("ZodUnion", (e, t) => {
  bat.init(e, t), Ze.init(e, t), e.options = t.options;
});
function gnt(e, t) {
  return new dnt({
    type: "union",
    options: e,
    ...re(t)
  });
}
const hnt = /* @__PURE__ */ F("ZodIntersection", (e, t) => {
  _at.init(e, t), Ze.init(e, t);
});
function mnt(e, t) {
  return new hnt({
    type: "intersection",
    left: e,
    right: t
  });
}
const ou = /* @__PURE__ */ F("ZodEnum", (e, t) => {
  vat.init(e, t), Ze.init(e, t), e.enum = t.entries, e.options = Object.values(t.entries);
  const a = new Set(Object.keys(t.entries));
  e.extract = (o, n) => {
    const r = {};
    for (const i of o)
      if (a.has(i))
        r[i] = t.entries[i];
      else
        throw new Error(`Key ${i} not found in enum`);
    return new ou({
      ...t,
      checks: [],
      ...re(n),
      entries: r
    });
  }, e.exclude = (o, n) => {
    const r = { ...t.entries };
    for (const i of o)
      if (a.has(i))
        delete r[i];
      else
        throw new Error(`Key ${i} not found in enum`);
    return new ou({
      ...t,
      checks: [],
      ...re(n),
      entries: r
    });
  };
});
function pnt(e, t) {
  const a = Array.isArray(e) ? Object.fromEntries(e.map((o) => [o, o])) : e;
  return new ou({
    type: "enum",
    entries: a,
    ...re(t)
  });
}
const fnt = /* @__PURE__ */ F("ZodLiteral", (e, t) => {
  yat.init(e, t), Ze.init(e, t), e.values = new Set(t.values), Object.defineProperty(e, "value", {
    get() {
      if (t.values.length > 1)
        throw new Error("This schema contains multiple valid literal values. Use `.values` instead.");
      return t.values[0];
    }
  });
});
function bnt(e, t) {
  return new fnt({
    type: "literal",
    values: Array.isArray(e) ? e : [e],
    ...re(t)
  });
}
const _nt = /* @__PURE__ */ F("ZodTransform", (e, t) => {
  wat.init(e, t), Ze.init(e, t), e._zod.parse = (a, o) => {
    if (o.direction === "backward")
      throw new Bk(e.constructor.name);
    a.addIssue = (r) => {
      if (typeof r == "string")
        a.issues.push(Kn(r, a.value, t));
      else {
        const i = r;
        i.fatal && (i.continue = !1), i.code ?? (i.code = "custom"), i.input ?? (i.input = a.value), i.inst ?? (i.inst = e), a.issues.push(Kn(i));
      }
    };
    const n = t.transform(a.value, a);
    return n instanceof Promise ? n.then((r) => (a.value = r, a)) : (a.value = n, a);
  };
});
function vnt(e) {
  return new _nt({
    type: "transform",
    transform: e
  });
}
const ix = /* @__PURE__ */ F("ZodOptional", (e, t) => {
  kat.init(e, t), Ze.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Up(e) {
  return new ix({
    type: "optional",
    innerType: e
  });
}
const ynt = /* @__PURE__ */ F("ZodNullable", (e, t) => {
  xat.init(e, t), Ze.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function qp(e) {
  return new ynt({
    type: "nullable",
    innerType: e
  });
}
const wnt = /* @__PURE__ */ F("ZodDefault", (e, t) => {
  $at.init(e, t), Ze.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeDefault = e.unwrap;
});
function knt(e, t) {
  return new wnt({
    type: "default",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : Uk(t);
    }
  });
}
const xnt = /* @__PURE__ */ F("ZodPrefault", (e, t) => {
  Sat.init(e, t), Ze.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function $nt(e, t) {
  return new xnt({
    type: "prefault",
    innerType: e,
    get defaultValue() {
      return typeof t == "function" ? t() : Uk(t);
    }
  });
}
const sx = /* @__PURE__ */ F("ZodNonOptional", (e, t) => {
  Cat.init(e, t), Ze.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Snt(e, t) {
  return new sx({
    type: "nonoptional",
    innerType: e,
    ...re(t)
  });
}
const Cnt = /* @__PURE__ */ F("ZodCatch", (e, t) => {
  Eat.init(e, t), Ze.init(e, t), e.unwrap = () => e._zod.def.innerType, e.removeCatch = e.unwrap;
});
function Ent(e, t) {
  return new Cnt({
    type: "catch",
    innerType: e,
    catchValue: typeof t == "function" ? t : () => t
  });
}
const znt = /* @__PURE__ */ F("ZodPipe", (e, t) => {
  zat.init(e, t), Ze.init(e, t), e.in = t.in, e.out = t.out;
});
function Hp(e, t) {
  return new znt({
    type: "pipe",
    in: e,
    out: t
    // ...util.normalizeParams(params),
  });
}
const jnt = /* @__PURE__ */ F("ZodReadonly", (e, t) => {
  jat.init(e, t), Ze.init(e, t), e.unwrap = () => e._zod.def.innerType;
});
function Ant(e) {
  return new jnt({
    type: "readonly",
    innerType: e
  });
}
const Ont = /* @__PURE__ */ F("ZodCustom", (e, t) => {
  Aat.init(e, t), Ze.init(e, t);
});
function Pnt(e, t = {}) {
  return bot(Ont, e, t);
}
function Dnt(e) {
  return _ot(e);
}
ns({
  email: Fot(),
  password: lt().min(8)
}).required();
ns({
  firstname: lt().min(1),
  lastname: lt().min(1),
  email: lt().email(),
  password: lt().min(8),
  sponsor: lt().optional(),
  cgus: bnt(!0)
});
function Nnt({ children: e, onLogout: t }) {
  return e ? Gp(e, {
    onClick: async () => {
      await OCe(), t && await t();
    }
  }) : null;
}
function lx({ config: e, children: t, onLogout: a }) {
  return cze(e.apiUrl), /* @__PURE__ */ v(zDe, { config: e, children: /* @__PURE__ */ v(Nnt, { onLogout: a, children: t }) });
}
function cx(e) {
  var t, a, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var n = e.length;
    for (t = 0; t < n; t++) e[t] && (a = cx(e[t])) && (o && (o += " "), o += a);
  } else for (a in e) e[a] && (o && (o += " "), o += a);
  return o;
}
function Rnt() {
  for (var e, t, a = 0, o = "", n = arguments.length; a < n; a++) (e = arguments[a]) && (t = cx(e)) && (o && (o += " "), o += t);
  return o;
}
const Int = [
  "accessible-bathroom",
  "accessible-bedroom",
  "ac",
  "ambassador_sidebar",
  "animals-card",
  "angle-left",
  "angle-left-rounded",
  "angle-right",
  "angle-right-rounded",
  "anywhere-in-the-world",
  "arrow-thin",
  "arrow-thin-right",
  "available-exchange-type",
  "average-reactivity",
  "baby-bed",
  "baby-gear",
  "baby-gear-old",
  "baby-sitter",
  "balcony-terrace",
  "bathroom",
  "bathtub",
  "bbq",
  "bedroom",
  "beds",
  "bicycle",
  "briefcase3",
  "button-power",
  "cancel",
  "calendar",
  "car",
  "cat-to-feed",
  "chat-lock",
  "check",
  "checkbox-fill",
  "children-welcome",
  "circle-close",
  "circle-help",
  "circle-left-arrow",
  "circle-right-arrow",
  "cities",
  "cleaning-person",
  "clock",
  "computer",
  "cook",
  "corona-virus",
  "countryside",
  "credit-card",
  "dashboard-saved-search",
  "dedicated-work-space",
  "disabled-access",
  "dishwasher",
  "docs",
  "dog-to-feed",
  "dollar",
  "doorman",
  "double-bed",
  "double-bed-up",
  "dryer",
  "easy-navigation",
  "electric-car",
  "electric-car-plug",
  "elevator",
  "error",
  "error-regular",
  "error-warning-fill",
  "excellent-reactivity",
  "eye",
  "eye-slash",
  "eye-slash-back",
  "facebook",
  "filter-picture",
  "fireplace",
  "flag",
  "flat",
  "folk",
  "freezer",
  "fridge",
  "garden",
  "gift",
  "gp",
  "great-reactivity",
  "guarantees",
  "guestpoint-exchange-type",
  "guestpoints",
  "guide",
  "gym",
  "header-help",
  "header-message-new",
  "header-message-read",
  "header-profile-home",
  "header-profile-profile",
  "header-profile-settings",
  "header-profile-they-love-my-home",
  "heart",
  "heart-fill",
  "heating-system",
  "high-speed-connection",
  "home-bin",
  "home-camera",
  "home-cinema",
  "home-exchange",
  "home-panel",
  "house",
  "ic-compass",
  "ic-flip-left",
  "ic-flip-right",
  "ic-location",
  "ic-move",
  "ic-shelter",
  "ic-transfer",
  "icon_facebook",
  "icon_gmail",
  "icon_messanger",
  "icon_outlook",
  "id",
  "information-circle",
  "information-circle-regular",
  "instagram",
  "internet",
  "isolated",
  "island",
  "jacuzzi",
  "key",
  "keys",
  "kids-playground",
  "kids-toys",
  "lakes",
  "lifebuoy",
  "linkedin",
  "location",
  "lock",
  "lock-credit-card",
  "low-consumption-machines",
  "marker-home",
  "marker-home-favorite",
  "marker-home-selected",
  "marker-home-selected-favorite",
  "marker-home-unavailable",
  "marker-home-unavailable-favorite",
  "low-reactivity",
  "map-1",
  "megaphone",
  "membership",
  "messenger",
  "microwave-oven",
  "minus",
  "moonplus",
  "more-filter",
  "motorboat",
  "motorcycle",
  "motor-scooter",
  "mountains",
  "my-family",
  "new-tab",
  "notification",
  "noun-loyalty-card",
  "number-eight",
  "number-five",
  "number-four",
  "number-nine",
  "number-one",
  "number-seven",
  "number-six",
  "number-three",
  "number-two",
  "ok",
  "oven",
  "parking-space",
  "pencil",
  "people",
  "pets-welcome",
  "phone",
  "piano",
  "ping-pong-table",
  "pin",
  "plants-to-water",
  "playground",
  "plus",
  "plus-sign",
  "pool-table",
  "preferred-destinations",
  "primary-home",
  "private-room",
  "public-transit-access",
  "rabbit",
  "raw",
  "reciprocal-exchange-type",
  "remove",
  "renewable-energy-provider",
  "river",
  "rooms",
  "sailboat",
  "satellite-cable",
  "sauna",
  "search",
  "search-location-pin",
  "seaside",
  "secondary-home",
  "secured-swimming-pool",
  "selective-waste-sorting",
  "shape-close",
  "share-fat",
  "simple-bed",
  "simple-bed-up",
  "size",
  "smart-tv",
  "smokers-welcome",
  "solar-panels",
  "sort-order",
  "sponsor-hand-icon",
  "star-black",
  "star-full",
  "step-free-entry",
  "sugesstion",
  "sun",
  "swimming-pool",
  "tennis-court",
  "tiktok",
  "triangle-warning",
  "tv",
  "tv-icon",
  "twitter",
  "types_of_exchanges",
  "unavailable",
  "up-arrow",
  "upload",
  "user",
  "vegetable-garden",
  "verification-check",
  "verification-check-regular",
  "video-game-console",
  "villages",
  "warning",
  "warning-regular",
  "washing-machine",
  "wide-angle",
  "wide-doors",
  "wifi",
  "youtube"
], Tnt = {
  "marker-home-favorite": 3,
  "marker-home": 2,
  "marker-home-selected-favorite": 3,
  "marker-home-selected": 2,
  "marker-home-unavailable-favorite": 3,
  "marker-home-unavailable": 2,
  icon_facebook: 2,
  icon_gmail: 5
}, Mnt = Int.map((e) => ({
  name: e,
  class: `icon-${e}`,
  paths: Tnt[e]
})), Lnt = {
  base: "",
  primary: "is-primary",
  secondary: "is-secondary",
  tertiary: "is-tertiary",
  success: "is-success-700",
  error: "is-error",
  "eco-green": "is-eco-green",
  inverted: "is-inverted",
  warning: "is-warning",
  neutral: "is-neutral",
  inherit: "is-inherit",
  dark: "is-dark"
}, Wnt = {
  small: "is-small",
  medium: "is-medium",
  large: "is-large",
  "2xl": "is-2xl",
  "3xl": "is-3xl",
  "4xl": "is-4xl",
  "5xl": "is-5xl",
  "6xl": "is-6xl",
  "7xl": "is-7xl",
  "8xl": "is-8xl",
  "9xl": "is-9xl",
  "10xl": "is-10xl"
};
function Bnt(e = 0) {
  const t = [];
  for (let a = 0; a < e; a++)
    t[a] = `path${a + 1}`;
  return t.map((a) => /* @__PURE__ */ v("span", { className: a }, a));
}
const Fnt = pt(
  ({ name: e, size: t = "medium", color: a = "base", className: o = "", ...n }, r) => {
    const i = Mnt.find((l) => l.name === e), s = Rnt("icon", `ds-${i?.class}`, Wnt[t], Lnt[a], o);
    return /* @__PURE__ */ v("i", { className: s, ...n, ref: r, children: Bnt(i?.paths) });
  }
);
Fnt.displayName = "Icon";
jt({
  locale: "en"
});
const Vnt = ns({
  firstName: lt({ error: Cn.t("auth:modal.finishCreatingAccount.firstName.error") }).min(1, Cn.t("auth:modal.finishCreatingAccount.firstName.error")),
  lastName: lt({ error: Cn.t("auth:modal.finishCreatingAccount.lastName.error") }).min(1, Cn.t("auth:modal.finishCreatingAccount.lastName.error")),
  referralCode: lt().optional(),
  phoneNumber: lt().optional(),
  howDoYouKnowHE: ns({
    firstLevel: lt().optional(),
    secondLevel: lt().optional(),
    openField: lt().optional()
  })
});
Vnt.extend({
  phoneNumber: lt().min(1, { error: Cn.t("auth:modal.finishCreatingAccount.phone_number.error") })
});
function ux() {
  const { t: e } = po("header");
  return /* @__PURE__ */ T($u, { children: [
    /* @__PURE__ */ v(Su, { children: /* @__PURE__ */ T(ue, { gap: "2", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "header-help" }),
      e("help")
    ] }) }),
    /* @__PURE__ */ T(Cu, { children: [
      /* @__PURE__ */ v(de, { href: e("links:faq"), children: e("faq") }),
      /* @__PURE__ */ v(Et, {}),
      /* @__PURE__ */ v(de, { href: e("links:guestpoints"), children: e("guestpoints") }),
      /* @__PURE__ */ v(Et, {}),
      /* @__PURE__ */ v(de, { href: e("links:about-calendar"), children: e("about-the-calendar") }),
      /* @__PURE__ */ v(Et, {}),
      /* @__PURE__ */ v(de, { href: e("links:guarantees"), children: e("guarantees") }),
      /* @__PURE__ */ v(Et, {}),
      /* @__PURE__ */ v(de, { href: e("links:contact-us"), children: e("contact") })
    ] })
  ] });
}
function Unt() {
  const { url: e } = je("/conversations"), { conversations: t, userInfos: a } = ro((n) => ({
    conversations: n.conversations,
    userInfos: n.userInfos
  })), { t: o } = po("header");
  return /* @__PURE__ */ T($u, { hideOn: "mobile", children: [
    /* @__PURE__ */ v(Su, { children: /* @__PURE__ */ T(ue, { gap: "2", alignItems: "center", children: [
      t && t?.notifications > 0 && /* @__PURE__ */ v(bu, { value: t?.notifications, onIcon: !0, children: /* @__PURE__ */ v(Se, { name: "header-message-new" }) }),
      o("messages")
    ] }) }),
    /* @__PURE__ */ T(Cu, { size: "medium", children: [
      t?.all?.length ? /* @__PURE__ */ v(de, { noPaddingRight: !0, noTopBottomPadding: !0, children: /* @__PURE__ */ v(qnt, { conversations: t }) }) : /* @__PURE__ */ v(de, { children: /* @__PURE__ */ T(ue, { justifyContent: "center", children: [
        /* @__PURE__ */ v(Je, { children: o("no-messages") }),
        /* @__PURE__ */ v(
          "img",
          {
            src: "https://d2kzpkef14nfxb.cloudfront.net/images/website/header/messages_empty.svg",
            alt: "no messages"
          }
        )
      ] }) }),
      /* @__PURE__ */ v(de, { noPaddingRight: !0, noTopBottomPadding: !0, children: /* @__PURE__ */ T(ue, { justifyContent: "space-between", isFullWidth: !0, alignItems: "center", children: [
        /* @__PURE__ */ T(Je, { size: "sm", children: [
          o("my-response-rate"),
          " ",
          /* @__PURE__ */ T(Je, { isSpan: !0, isBold: !0, size: "sm", children: [
            a?.response_rate,
            "%"
          ] })
        ] }),
        /* @__PURE__ */ v(nu, { color: "tertiary", size: "medium", href: e, children: o("view-inbox") })
      ] }) })
    ] })
  ] });
}
const qnt = ({ conversations: e }) => /* @__PURE__ */ v(
  RS,
  {
    isFullWidth: !0,
    size: "small",
    tabs: [
      {
        title: "All",
        content: /* @__PURE__ */ v(De, { children: e.all.map((t) => /* @__PURE__ */ v(Zl, { conversation: t }, t.id)) })
      },
      {
        title: `Unreplied (${e.stats.unreplied})`,
        content: /* @__PURE__ */ v(De, { children: e.unreplied.map((t) => /* @__PURE__ */ v(Zl, { conversation: t }, t.id)) })
      },
      {
        title: `Finalized (${e.stats.finalized})`,
        content: /* @__PURE__ */ v(De, { children: e.finalized.map((t) => /* @__PURE__ */ v(Zl, { conversation: t }, t.id)) })
      }
    ]
  }
), Zl = ({ conversation: e }) => {
  const { url: t } = je(`/conversations/${e.id}`);
  return /* @__PURE__ */ T("a", { href: t, children: [
    /* @__PURE__ */ T(ue, { gap: "4", alignItems: "center", noMargin: !0, children: [
      /* @__PURE__ */ v(
        "img",
        {
          src: e.interlocutor.profilePicture,
          style: { height: "40px", width: "40px", background: "blue", borderRadius: "9999px" },
          alt: "user"
        }
      ),
      /* @__PURE__ */ T(
        "div",
        {
          style: {
            overflow: "hidden",
            flex: "1 0 0"
          },
          children: [
            /* @__PURE__ */ v(
              "div",
              {
                style: {
                  fontWeight: "bold"
                },
                children: e.interlocutor.firstName
              }
            ),
            /* @__PURE__ */ v(Je, { ellipsis: !0, size: "sm", children: e.lastMessage.content })
          ]
        }
      ),
      /* @__PURE__ */ v("div", { children: px(e.lastMessage.createdAt) })
    ] }),
    /* @__PURE__ */ v($S, { space: "small" })
  ] });
};
function Hnt() {
  const { t: e } = po("header"), { userInfos: t, completionRate: a, userProfile: o, userMembership: n, apiUrl: r } = ro((m) => ({
    userInfos: m.userInfos,
    completionRate: m.userInfos?.profil.completionRate ?? 0,
    userProfile: m.userInfos?.notifications?.user?.details.userProfile,
    userMembership: m.userInfos?.notifications?.user?.details.membership,
    apiUrl: m.apiUrl
  })), { signout: i } = Ps((m) => ({
    signout: m.signout
  })), { url: s } = je(`/user/edit/${t?.profil.id}`), { url: l } = je("/homes/edit"), { url: c } = je("/homes/create"), { url: u } = je("/myexchanges"), { url: d } = je("/my-plan"), { url: h } = je("/user/favorite"), { url: p } = je("/user/they-love-my-home"), { url: f } = je(`/user/settings/${t?.profil.id}`);
  return /* @__PURE__ */ T(De, { children: [
    /* @__PURE__ */ v(de, { noPaddingRight: !0, href: s, children: /* @__PURE__ */ T(ue, { gap: "2", isFullWidth: !0, children: [
      /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "space-between", children: [
        /* @__PURE__ */ T(ue, { gap: "4", alignItems: "center", children: [
          /* @__PURE__ */ v(Se, { name: "header-profile-profile" }),
          e("my-profile")
        ] }),
        /* @__PURE__ */ T(ue, { alignItems: "center", gap: "2", children: [
          /* @__PURE__ */ T(Je, { size: "sm", children: [
            a,
            "%"
          ] }),
          /* @__PURE__ */ v(mg, { value: a, color: "tertiary", size: "small", ariaLabel: "User completion rate" })
        ] })
      ] }),
      /* @__PURE__ */ v(Je, { isBold: !0, size: "sm", color: "tertiary", children: o && e(`notification.user_profile.${o.status}`, {
        gp: o.gpReward
      }) })
    ] }) }),
    /* @__PURE__ */ v(Et, {}),
    t?.homes?.map((m) => /* @__PURE__ */ T("div", { children: [
      /* @__PURE__ */ v(de, { noPaddingRight: !0, href: `${l}/${m.id}`, children: /* @__PURE__ */ T(ue, { gap: "2", isFullWidth: !0, children: [
        /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "space-between", children: [
          /* @__PURE__ */ T(ue, { gap: "4", alignItems: "center", children: [
            /* @__PURE__ */ v(Se, { name: "header-profile-home" }),
            /* @__PURE__ */ v(Je, { size: "sm", children: "My Home" })
          ] }),
          /* @__PURE__ */ T(ue, { alignItems: "center", gap: "2", children: [
            /* @__PURE__ */ T(Je, { size: "sm", children: [
              m.completionRate,
              "%"
            ] }),
            /* @__PURE__ */ v(
              mg,
              {
                value: m.completionRate,
                color: "tertiary",
                size: "small",
                ariaLabel: "Home completion rate"
              }
            )
          ] })
        ] }),
        m.notifications?.status && /* @__PURE__ */ v(Je, { size: "sm", color: "tertiary", isBold: !0, children: e(`notification.home.${m.notifications.status}`, {
          gp: m.notifications.gpReward
        }) })
      ] }) }),
      /* @__PURE__ */ v(Et, {})
    ] }, m.id)),
    /* @__PURE__ */ v(de, { noPaddingRight: !0, href: c, children: /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "plus" }),
      e("add-home")
    ] }) }),
    /* @__PURE__ */ v(Et, {}),
    /* @__PURE__ */ v(de, { noPaddingRight: !0, href: u, children: /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "keys" }),
      e("my-exchanges")
    ] }) }),
    /* @__PURE__ */ v(Et, {}),
    /* @__PURE__ */ v(de, { noPaddingRight: !0, href: d, children: /* @__PURE__ */ T(ue, { gap: "2", children: [
      /* @__PURE__ */ v(ue, { isFullWidth: !0, justifyContent: "space-between", children: /* @__PURE__ */ v(ue, { isFullWidth: !0, justifyContent: "space-between", children: /* @__PURE__ */ T(ue, { gap: "4", alignItems: "center", children: [
        /* @__PURE__ */ v(Se, { name: "credit-card" }),
        e("my-membership")
      ] }) }) }),
      n && /* @__PURE__ */ v(Je, { size: "sm", color: "tertiary", isBold: !0, children: e(`notification.membership.${n.status}`, {
        gp: n.gpReward
      }) })
    ] }) }),
    /* @__PURE__ */ v(Et, {}),
    /* @__PURE__ */ v(de, { noPaddingRight: !0, href: h, children: /* @__PURE__ */ T(ue, { isFullWidth: !0, gap: "4", justifyContent: "start", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "heart" }),
      e("my-favorite-homes")
    ] }) }),
    /* @__PURE__ */ v(Et, {}),
    /* @__PURE__ */ v(de, { noPaddingRight: !0, href: p, children: /* @__PURE__ */ T(ue, { gap: "4", isFullWidth: !0, justifyContent: "start", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "header-profile-they-love-my-home" }),
      e("they-love-my-home")
    ] }) }),
    /* @__PURE__ */ v(Et, {}),
    /* @__PURE__ */ v(de, { noPaddingRight: !0, href: f, children: /* @__PURE__ */ T(ue, { gap: "4", isFullWidth: !0, justifyContent: "start", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "header-profile-settings" }),
      e("settings")
    ] }) }),
    /* @__PURE__ */ v(Et, {}),
    /* @__PURE__ */ v(lx, { config: { apiUrl: r }, onLogout: i, children: /* @__PURE__ */ v(de, { noPaddingRight: !0, children: /* @__PURE__ */ T(ue, { gap: "4", isFullWidth: !0, justifyContent: "start", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "button-power" }),
      e("logout")
    ] }) }) })
  ] });
}
function Gnt() {
  const { t: e } = po("header"), { userInfos: t, userProfile: a, userCompletionRate: o, userMemberShip: n } = ro((m) => ({
    userInfos: m.userInfos,
    userProfile: m.userInfos?.profil,
    userCompletionRate: m.userInfos?.profil.completionRate ?? 0,
    userMemberShip: m.userInfos?.notifications?.user?.details.membership
  })), { url: r } = je("/conversations"), { url: i } = je(`/user/edit/${t?.profil.id}`), { url: s } = je("/homes/edit"), { url: l } = je("/homes/create"), { url: c } = je("/myexchanges"), { url: u } = je("/my-plan"), { url: d } = je("/user/favorite"), { url: h } = je("/user/they-love-my-home"), { url: p } = je("/user/gpdetails"), { url: f } = je(`/user/settings/${t?.profil.id}`);
  return /* @__PURE__ */ T(De, { children: [
    /* @__PURE__ */ v(de, { largerPaddingBottom: !0, children: /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "start", alignItems: "center", children: [
      /* @__PURE__ */ v(Sb, { url: a?.profilePicture ?? "", alt: "avatar" }),
      /* @__PURE__ */ T("div", { children: [
        /* @__PURE__ */ T(Je, { isBold: !0, isSpan: !0, children: [
          a?.firstName,
          " ",
          t?.profil.lastName
        ] }),
        /* @__PURE__ */ T("div", { children: [
          /* @__PURE__ */ v(Je, { isBold: !0, isSpan: !0, color: "secondary", children: a?.totalGP }),
          " ",
          "GP"
        ] })
      ] })
    ] }) }),
    /* @__PURE__ */ v(de, { href: r, children: /* @__PURE__ */ v(ue, { isFullWidth: !0, justifyContent: "space-between", children: /* @__PURE__ */ T(ue, { gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "header-message-new" }),
      "Inbox"
    ] }) }) }),
    /* @__PURE__ */ v(de, { href: i, children: /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "space-between", children: [
      /* @__PURE__ */ T(ue, { gap: "4", alignItems: "center", children: [
        /* @__PURE__ */ v(Se, { name: "header-profile-profile" }),
        "My Profile"
      ] }),
      /* @__PURE__ */ T(Je, { color: o === 1 ? "primary" : "tertiary", children: [
        o,
        "%"
      ] })
    ] }) }),
    t?.homes?.map((m) => /* @__PURE__ */ v(de, { href: `${s}/${m.id}`, children: /* @__PURE__ */ T(ue, { gap: "0", isFullWidth: !0, children: [
      /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "space-between", children: [
        /* @__PURE__ */ T(ue, { gap: "4", alignItems: "center", children: [
          /* @__PURE__ */ v(Se, { name: "header-profile-home" }),
          "My Home"
        ] }),
        /* @__PURE__ */ T(Je, { color: m.completionRate === 1 ? "primary" : "tertiary", children: [
          m.completionRate,
          "%"
        ] })
      ] }),
      m.notifications?.status && /* @__PURE__ */ v(Je, { size: "sm", color: "tertiary", isBold: !0, children: e(`notification.home.${m.notifications.status}`, {
        gp: m.notifications.gpReward
      }) })
    ] }) }, m.id)),
    /* @__PURE__ */ v(de, { href: l, children: /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "plus" }),
      "Add a home"
    ] }) }),
    /* @__PURE__ */ v(de, { href: c, children: /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "keys" }),
      "My exchanges"
    ] }) }),
    /* @__PURE__ */ v(de, { href: u, children: /* @__PURE__ */ T(ue, { gap: "0", children: [
      /* @__PURE__ */ v(ue, { isFullWidth: !0, justifyContent: "space-between", children: /* @__PURE__ */ T(ue, { justifyContent: "start", gap: "4", alignItems: "center", children: [
        /* @__PURE__ */ v(Se, { name: "credit-card" }),
        "My membership"
      ] }) }),
      n && /* @__PURE__ */ v(Je, { size: "sm", color: "tertiary", isBold: !0, children: e(`notification.membership.${n.status}`, {
        gp: n.gpReward
      }) })
    ] }) }),
    /* @__PURE__ */ v(de, { href: d, children: /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "heart" }),
      "My favorite homes"
    ] }) }),
    /* @__PURE__ */ v(de, { href: h, children: /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "header-profile-they-love-my-home" }),
      "They love my home"
    ] }) }),
    /* @__PURE__ */ v(de, { href: f, children: /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "start", gap: "4", alignItems: "center", children: [
      /* @__PURE__ */ v(Se, { name: "header-profile-settings" }),
      "My settings"
    ] }) }),
    /* @__PURE__ */ v(de, { href: p, children: /* @__PURE__ */ v(Je, { isSpan: !0, color: "secondary", children: "Sponsor 10 friends and receive up to 2500 GP" }) })
  ] });
}
function Knt() {
  const { t: e } = po("header"), { url: t } = je("/user/gpdetails"), { url: a } = je("/"), { url: o } = je("/collection"), { userInfos: n, apiUrl: r } = ro((s) => ({
    userInfos: s.userInfos,
    apiUrl: s.apiUrl
  })), { signout: i } = Ps((s) => ({
    signout: s.signout
  }));
  return /* @__PURE__ */ T(kb, { notificationValue: n?.notifications?.user?.total, children: [
    /* @__PURE__ */ T(xb, { position: "end", children: [
      /* @__PURE__ */ v(Ko, { hideOn: "desktop", children: /* @__PURE__ */ v(Gnt, {}) }),
      /* @__PURE__ */ v(To, { hideOn: "desktop" }),
      /* @__PURE__ */ v(ux, {}),
      /* @__PURE__ */ v(To, {}),
      /* @__PURE__ */ v(Unt, {}),
      /* @__PURE__ */ v(To, { hideOn: "mobile" }),
      /* @__PURE__ */ v(de, { href: t, hideOn: "mobile", children: /* @__PURE__ */ T(ue, { gap: "1", children: [
        /* @__PURE__ */ v(Je, { isSpan: !0, isBold: !0, color: "secondary", children: n?.profil.totalGP }),
        /* @__PURE__ */ v(Je, { isSpan: !0, children: "GP" })
      ] }) }),
      /* @__PURE__ */ v(To, { hideOn: "mobile" }),
      /* @__PURE__ */ T($u, { hideOn: "mobile", children: [
        /* @__PURE__ */ v(Su, { children: /* @__PURE__ */ T(ue, { alignItems: "center", gap: "2", children: [
          /* @__PURE__ */ v(bu, { value: n?.notifications?.user?.total ?? 0, children: /* @__PURE__ */ v(Sb, { url: n?.profil.profilePicture ?? "", alt: "avatar" }) }),
          e("my-account")
        ] }) }),
        /* @__PURE__ */ v(Cu, { size: "small", children: /* @__PURE__ */ v(Hnt, {}) })
      ] }),
      /* @__PURE__ */ v(de, { hideOn: "desktop", href: o, children: "Home Exchange Collection" }),
      /* @__PURE__ */ v(de, { hideOn: "desktop", href: a, children: "English" }),
      /* @__PURE__ */ v(de, { hideOn: "desktop", href: a, children: "US dollars - $" })
    ] }),
    /* @__PURE__ */ v(lx, { config: { apiUrl: r }, onLogout: i, children: /* @__PURE__ */ v(de, { marginAutoTop: !0, hideOn: "desktop", children: /* @__PURE__ */ T(ue, { isFullWidth: !0, justifyContent: "start", children: [
      /* @__PURE__ */ v(Se, { name: "button-power" }),
      e("logout")
    ] }) }) })
  ] });
}
function Jnt() {
  const [e, t] = Pe(!1), [a, o] = Pe(!1), { url: n } = je("/#signup"), { url: r } = je("/#signin"), { url: i } = je("/"), { url: s } = je("/collection"), { apiUrl: l } = ro((p) => ({ apiUrl: p.apiUrl })), { currentWidth: c } = Bee(), { t: u } = po(["header", "links"]), { setIsSignedIn: d } = Ps((p) => ({
    setIsSignedIn: p.setIsSignedIn
  })), { setNavigationBarData: h } = ro((p) => ({
    setNavigationBarData: p.setNavigationBarData
  }));
  return Fee("navigation-bar:open-signup-modal", () => {
    o(!0);
  }), /* @__PURE__ */ v(kb, { children: /* @__PURE__ */ T(xb, { position: "end", children: [
    /* @__PURE__ */ v(de, { href: u("links:how-it-works"), children: c && c <= 1300 ? /* @__PURE__ */ v(Se, { name: "circle-help" }) : u("how-it-works") }),
    /* @__PURE__ */ v(de, { href: u("links:subscription-cost"), children: c && c <= 1300 ? /* @__PURE__ */ v(Se, { name: "dollar" }) : u("how-much-does-it-cost") }),
    /* @__PURE__ */ v(Ko, { hideOn: "desktop", children: /* @__PURE__ */ v(To, {}) }),
    /* @__PURE__ */ v(ux, {}),
    /* @__PURE__ */ v(Ko, { hideOn: "desktop", children: /* @__PURE__ */ v(To, {}) }),
    /* @__PURE__ */ v(de, { href: s, hideOn: "desktop", children: "Home Exchange Collection" }),
    /* @__PURE__ */ v(de, { href: i, hideOn: "desktop", children: "English" }),
    /* @__PURE__ */ v(de, { href: i, hideOn: "desktop", children: "US dollars - $" }),
    /* @__PURE__ */ T(De, { children: [
      /* @__PURE__ */ v(de, { href: r, isSecondOnMobile: !0, isButton: !0, children: u("sign-in") }),
      /* @__PURE__ */ v(de, { isFirstOnMobile: !0, largerPaddingBottom: !0, children: /* @__PURE__ */ v(nu, { href: n, size: "regular", color: "primary", children: u("sign-up-for-free") }) })
    ] })
  ] }) });
}
function Znt({ theme: e, locale: t }) {
  const { t: a } = po("header"), { apiUrl: o, assetsUrl: n } = ro((l) => ({ apiUrl: l.apiUrl, assetsUrl: l.assetsUrl })), { isSignedIn: r } = Ps((l) => ({ isSignedIn: l.isSignedIn })), { url: i } = je("/"), s = `${n}/navigation/he-logo${e === "collection" ? "-collection" : ""}.svg`;
  return /* @__PURE__ */ T(wb, { children: [
    /* @__PURE__ */ T($b, { children: [
      /* @__PURE__ */ v(de, { backgroundOnHover: !1, href: i, children: /* @__PURE__ */ v("img", { src: s, alt: `HomeExchange ${e} logo ` }) }),
      /* @__PURE__ */ v(de, { isFlexGrow: !0, children: /* @__PURE__ */ v(
        GD,
        {
          config: { apiUrl: o, locale: t },
          id: "navbar-search-bar",
          placeholder: a("common:autocomplete.placeholder"),
          buttonText: a("common:autocomplete.button"),
          hideButtonText: !0
        }
      ) })
    ] }),
    r ? /* @__PURE__ */ v(Knt, {}) : /* @__PURE__ */ v(Jnt, {})
  ] });
}
function wit({
  conversations: e,
  userInfos: t,
  theme: a,
  isSignedIn: o,
  locale: n = "en",
  apiUrl: r,
  assetsUrl: i
}) {
  return im.changeLanguage(n), fx(r), /* @__PURE__ */ v(Jee, { isSignedIn: o, children: /* @__PURE__ */ v(qee, { conversations: e, userInfos: t, apiUrl: r, assetsUrl: i, children: /* @__PURE__ */ v(Px, { i18n: im, children: /* @__PURE__ */ v(zb, { locale: n, children: /* @__PURE__ */ v(Znt, { theme: a, locale: n }) }) }) }) });
}
const Ynt = ({ logoIsLink: e, theme: t, assetsUrl: a }) => {
  const { url: o } = je("/"), n = `${a}/navigation/he-logo${t === "collection" ? "-collection" : ""}.svg`;
  return /* @__PURE__ */ v(wb, { isFixedTop: !0, children: /* @__PURE__ */ v($b, { children: /* @__PURE__ */ v(de, { href: e ? o : void 0, children: /* @__PURE__ */ v("img", { src: n, alt: `HomeExchange ${t} logo ` }) }) }) });
}, kit = ({ logoIsLink: e, locale: t, theme: a, assetsUrl: o }) => /* @__PURE__ */ v(zb, { locale: t || "en", children: /* @__PURE__ */ v(Ynt, { logoIsLink: e, theme: a, assetsUrl: o }) });
function xit({ locale: e }) {
  const [t, a] = Pe();
  return Ce(() => {
    bx(e).then(a);
  }, [e]), t && /* @__PURE__ */ v(
    E0,
    {
      text: t.communicationBanner.data.text,
      url: t.communicationBanner.data.link
    }
  );
}
export {
  xit as CommunicationBanner,
  Hnt as DesktopMenu,
  ux as HelpItem,
  kit as LiteHeader,
  Knt as LoggedInMenu,
  Jnt as LoggedOutMenu,
  Unt as MessagesItem,
  Gnt as MobileMenu,
  wit as NavigationBar,
  qee as NavigationBarProvider,
  qnt as TabContent,
  wy as UserContext,
  Jee as UserProvider,
  Uee as createNavigationBarStore,
  Kee as createUserStore,
  bx as getCommunicationBannerData,
  Cit as getNavigationBarData,
  Eit as heFetch,
  im as i18nConfig,
  fx as setNavigationBarFetchConfig,
  ro as useNavigationBarContext,
  Ps as useUserContext
};
